var _objectWithoutProperties = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _defineProperty = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/defineProperty.js");
var _get = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/get.js");
var _assertThisInitialized = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
var _construct2 = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/construct.js");
var _toArray = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/toArray.js");
var _toConsumableArray = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _classCallCheck = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/createClass.js");
var _inherits = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _wrapNativeSuper = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
var _slicedToArray = require("/home/keoadmin/agent/_work/66/s/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _excluded = ["data"],
  _excluded2 = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e743) { throw _e743; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e744) { didErr = true; err = _e744; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
require("core-js/modules/esnext.global-this.js");
require("core-js/modules/es.typed-array.set.js");
require("core-js/modules/es.typed-array.sort.js");
require("core-js/modules/es.math.hypot.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.regexp.flags.js");
require("core-js/modules/es.array.flat.js");
require("core-js/modules/es.array.unscopables.flat.js");
require("core-js/modules/es.array.flat-map.js");
require("core-js/modules/es.array.unscopables.flat-map.js");
require("core-js/modules/esnext.promise.all-settled.js");
/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.mapboxgl = factory());
})(this, function () {
  'use strict';

  /* eslint-disable */
  var shared, worker, mapboxgl;
  // define gets called three times: one for each chunk. we rely on the order
  // they're imported to know which is which
  function define(_, chunk) {
    if (!shared) {
      shared = chunk;
    } else if (!worker) {
      worker = chunk;
    } else {
      var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
      var sharedChunk = {};
      shared(sharedChunk);
      mapboxgl = chunk(sharedChunk);
      if (typeof window !== 'undefined' && window && window.URL && window.URL.createObjectURL) {
        mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], {
          type: 'text/javascript'
        }));
      }
    }
  }
  define(["exports"], function (t) {
    var e = "3.6.0";
    var r;
    var n = {
      API_URL: "https://api.mapbox.com",
      get API_URL_REGEX() {
        if (null == r) {
          var _t2 = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
          try {
            r = null != process.env.API_URL_REGEX ? new RegExp(process.env.API_URL_REGEX) : _t2;
          } catch (e) {
            r = _t2;
          }
        }
        return r;
      },
      get API_TILEJSON_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
      },
      get API_SPRITE_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
      },
      get API_FONTS_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
      },
      get API_STYLE_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
      },
      get API_CDN_URL_REGEX() {
        return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
      },
      get EVENTS_URL() {
        if (!n.API_URL) return null;
        try {
          var _t3 = new URL(n.API_URL);
          return "api.mapbox.cn" === _t3.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === _t3.hostname ? "https://events.mapbox.com/events/v2" : null;
        } catch (t) {
          return null;
        }
      },
      SESSION_PATH: "/map-sessions/v1",
      FEEDBACK_URL: "https://apps.mapbox.com/feedback",
      TILE_URL_VERSION: "v4",
      RASTER_URL_PREFIX: "raster/v1",
      RASTERARRAYS_URL_PREFIX: "rasterarrays/v1",
      REQUIRE_ACCESS_TOKEN: !0,
      ACCESS_TOKEN: null,
      DEFAULT_STYLE: "mapbox://styles/mapbox/standard",
      MAX_PARALLEL_IMAGE_REQUESTS: 16,
      DRACO_URL: "https://api.mapbox.com/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm",
      MESHOPT_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_base_v0.20.wasm",
      MESHOPT_SIMD_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_simd_v0.20.wasm",
      GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
      TILES3D_URL_PREFIX: "3dtiles/v1"
    };
    function i(t) {
      return n.API_URL_REGEX.test(t);
    }
    function s(t) {
      return 0 === t.indexOf("mapbox:");
    }
    function a(t) {
      return n.API_CDN_URL_REGEX.test(t);
    }
    function o(t) {
      return n.API_SPRITE_REGEX.test(t);
    }
    function l(t) {
      return n.API_STYLE_REGEX.test(t) && !o(t);
    }
    var u = {
        create: "create",
        load: "load",
        fullLoad: "fullLoad"
      },
      c = {
        mark: function mark(t) {
          performance.mark(t);
        },
        measure: function measure(t, e, r) {
          performance.measure(t, e, r);
        }
      };
    function h(t) {
      var e = t.name.split("?")[0];
      return a(e) && e.includes("mapbox-gl.js") ? "javascript" : a(e) && e.includes("mapbox-gl.css") ? "css" : function (t) {
        return n.API_FONTS_REGEX.test(t);
      }(e) ? "fontRange" : o(e) ? "sprite" : l(e) ? "style" : function (t) {
        return n.API_TILEJSON_REGEX.test(t);
      }(e) ? "tilejson" : "other";
    }
    function p(t) {
      return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
    }
    var f = {},
      d = {};
    Object.defineProperty(d, "__esModule", {
      value: !0
    }), d.setMatrixArrayType = function (t) {
      d.ARRAY_TYPE = y = t;
    }, d.toRadian = function (t) {
      return t * x;
    }, d.equals = function (t, e) {
      return Math.abs(t - e) <= m * Math.max(1, Math.abs(t), Math.abs(e));
    }, d.RANDOM = d.ARRAY_TYPE = d.EPSILON = void 0;
    var m = 1e-6;
    d.EPSILON = m;
    var y = "undefined" != typeof Float32Array ? Float32Array : Array;
    d.ARRAY_TYPE = y;
    var g = Math.random;
    d.RANDOM = g;
    var x = Math.PI / 180;
    Math.hypot || (Math.hypot = function () {
      for (var t = 0, e = arguments.length; e--;) t += arguments[e] * arguments[e];
      return Math.sqrt(t);
    });
    var b = {};
    function v(t) {
      return v = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, v(t);
    }
    Object.defineProperty(b, "__esModule", {
      value: !0
    }), b.create = function () {
      var t = new _.ARRAY_TYPE(4);
      return _.ARRAY_TYPE != Float32Array && (t[1] = 0, t[2] = 0), t[0] = 1, t[3] = 1, t;
    }, b.clone = function (t) {
      var e = new _.ARRAY_TYPE(4);
      return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e;
    }, b.copy = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t;
    }, b.identity = function (t) {
      return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t;
    }, b.fromValues = function (t, e, r, n) {
      var i = new _.ARRAY_TYPE(4);
      return i[0] = t, i[1] = e, i[2] = r, i[3] = n, i;
    }, b.set = function (t, e, r, n, i) {
      return t[0] = e, t[1] = r, t[2] = n, t[3] = i, t;
    }, b.transpose = function (t, e) {
      if (t === e) {
        var r = e[1];
        t[1] = e[2], t[2] = r;
      } else t[0] = e[0], t[1] = e[2], t[2] = e[1], t[3] = e[3];
      return t;
    }, b.invert = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = r * s - i * n;
      return a ? (t[0] = s * (a = 1 / a), t[1] = -n * a, t[2] = -i * a, t[3] = r * a, t) : null;
    }, b.adjoint = function (t, e) {
      var r = e[0];
      return t[0] = e[3], t[1] = -e[1], t[2] = -e[2], t[3] = r, t;
    }, b.determinant = function (t) {
      return t[0] * t[3] - t[2] * t[1];
    }, b.multiply = M, b.rotate = function (t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = Math.sin(r),
        l = Math.cos(r);
      return t[0] = n * l + s * o, t[1] = i * l + a * o, t[2] = n * -o + s * l, t[3] = i * -o + a * l, t;
    }, b.scale = function (t, e, r) {
      var n = e[1],
        i = e[2],
        s = e[3],
        a = r[0],
        o = r[1];
      return t[0] = e[0] * a, t[1] = n * a, t[2] = i * o, t[3] = s * o, t;
    }, b.fromRotation = function (t, e) {
      var r = Math.sin(e),
        n = Math.cos(e);
      return t[0] = n, t[1] = r, t[2] = -r, t[3] = n, t;
    }, b.fromScaling = function (t, e) {
      return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = e[1], t;
    }, b.str = function (t) {
      return "mat2(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ")";
    }, b.frob = function (t) {
      return Math.hypot(t[0], t[1], t[2], t[3]);
    }, b.LDU = function (t, e, r, n) {
      return t[2] = n[2] / n[0], r[0] = n[0], r[1] = n[1], r[3] = n[3] - t[2] * r[1], [t, e, r];
    }, b.add = function (t, e, r) {
      return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t[3] = e[3] + r[3], t;
    }, b.subtract = A, b.exactEquals = function (t, e) {
      return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3];
    }, b.equals = function (t, e) {
      var r = t[0],
        n = t[1],
        i = t[2],
        s = t[3],
        a = e[0],
        o = e[1],
        l = e[2],
        u = e[3];
      return Math.abs(r - a) <= _.EPSILON * Math.max(1, Math.abs(r), Math.abs(a)) && Math.abs(n - o) <= _.EPSILON * Math.max(1, Math.abs(n), Math.abs(o)) && Math.abs(i - l) <= _.EPSILON * Math.max(1, Math.abs(i), Math.abs(l)) && Math.abs(s - u) <= _.EPSILON * Math.max(1, Math.abs(s), Math.abs(u));
    }, b.multiplyScalar = function (t, e, r) {
      return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t;
    }, b.multiplyScalarAndAdd = function (t, e, r, n) {
      return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t[2] = e[2] + r[2] * n, t[3] = e[3] + r[3] * n, t;
    }, b.sub = b.mul = void 0;
    var _ = function (t, e) {
      if (t && t.__esModule) return t;
      if (null === t || "object" !== v(t) && "function" != typeof t) return {
        default: t
      };
      var r = w(void 0);
      if (r && r.has(t)) return r.get(t);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var s in t) if ("default" !== s && Object.prototype.hasOwnProperty.call(t, s)) {
        var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
        a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
      }
      return n.default = t, r && r.set(t, n), n;
    }(d);
    function w(t) {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap(),
        r = new WeakMap();
      return (w = function w(t) {
        return t ? r : e;
      })(t);
    }
    function M(t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = r[0],
        l = r[1],
        u = r[2],
        c = r[3];
      return t[0] = n * o + s * l, t[1] = i * o + a * l, t[2] = n * u + s * c, t[3] = i * u + a * c, t;
    }
    function A(t, e, r) {
      return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t[3] = e[3] - r[3], t;
    }
    b.mul = M, b.sub = A;
    var S = {};
    function I(t) {
      return I = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, I(t);
    }
    Object.defineProperty(S, "__esModule", {
      value: !0
    }), S.create = function () {
      var t = new T.ARRAY_TYPE(6);
      return T.ARRAY_TYPE != Float32Array && (t[1] = 0, t[2] = 0, t[4] = 0, t[5] = 0), t[0] = 1, t[3] = 1, t;
    }, S.clone = function (t) {
      var e = new T.ARRAY_TYPE(6);
      return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e;
    }, S.copy = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t;
    }, S.identity = function (t) {
      return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t[4] = 0, t[5] = 0, t;
    }, S.fromValues = function (t, e, r, n, i, s) {
      var a = new T.ARRAY_TYPE(6);
      return a[0] = t, a[1] = e, a[2] = r, a[3] = n, a[4] = i, a[5] = s, a;
    }, S.set = function (t, e, r, n, i, s, a) {
      return t[0] = e, t[1] = r, t[2] = n, t[3] = i, t[4] = s, t[5] = a, t;
    }, S.invert = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = e[4],
        o = e[5],
        l = r * s - n * i;
      return l ? (t[0] = s * (l = 1 / l), t[1] = -n * l, t[2] = -i * l, t[3] = r * l, t[4] = (i * o - s * a) * l, t[5] = (n * a - r * o) * l, t) : null;
    }, S.determinant = function (t) {
      return t[0] * t[3] - t[1] * t[2];
    }, S.multiply = P, S.rotate = function (t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = e[4],
        l = e[5],
        u = Math.sin(r),
        c = Math.cos(r);
      return t[0] = n * c + s * u, t[1] = i * c + a * u, t[2] = n * -u + s * c, t[3] = i * -u + a * c, t[4] = o, t[5] = l, t;
    }, S.scale = function (t, e, r) {
      var n = e[1],
        i = e[2],
        s = e[3],
        a = e[4],
        o = e[5],
        l = r[0],
        u = r[1];
      return t[0] = e[0] * l, t[1] = n * l, t[2] = i * u, t[3] = s * u, t[4] = a, t[5] = o, t;
    }, S.translate = function (t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = e[4],
        l = e[5],
        u = r[0],
        c = r[1];
      return t[0] = n, t[1] = i, t[2] = s, t[3] = a, t[4] = n * u + s * c + o, t[5] = i * u + a * c + l, t;
    }, S.fromRotation = function (t, e) {
      var r = Math.sin(e),
        n = Math.cos(e);
      return t[0] = n, t[1] = r, t[2] = -r, t[3] = n, t[4] = 0, t[5] = 0, t;
    }, S.fromScaling = function (t, e) {
      return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = e[1], t[4] = 0, t[5] = 0, t;
    }, S.fromTranslation = function (t, e) {
      return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t[4] = e[0], t[5] = e[1], t;
    }, S.str = function (t) {
      return "mat2d(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ", " + t[4] + ", " + t[5] + ")";
    }, S.frob = function (t) {
      return Math.hypot(t[0], t[1], t[2], t[3], t[4], t[5], 1);
    }, S.add = function (t, e, r) {
      return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t[3] = e[3] + r[3], t[4] = e[4] + r[4], t[5] = e[5] + r[5], t;
    }, S.subtract = z, S.multiplyScalar = function (t, e, r) {
      return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t[4] = e[4] * r, t[5] = e[5] * r, t;
    }, S.multiplyScalarAndAdd = function (t, e, r, n) {
      return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t[2] = e[2] + r[2] * n, t[3] = e[3] + r[3] * n, t[4] = e[4] + r[4] * n, t[5] = e[5] + r[5] * n, t;
    }, S.exactEquals = function (t, e) {
      return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3] && t[4] === e[4] && t[5] === e[5];
    }, S.equals = function (t, e) {
      var r = t[0],
        n = t[1],
        i = t[2],
        s = t[3],
        a = t[4],
        o = t[5],
        l = e[0],
        u = e[1],
        c = e[2],
        h = e[3],
        p = e[4],
        f = e[5];
      return Math.abs(r - l) <= T.EPSILON * Math.max(1, Math.abs(r), Math.abs(l)) && Math.abs(n - u) <= T.EPSILON * Math.max(1, Math.abs(n), Math.abs(u)) && Math.abs(i - c) <= T.EPSILON * Math.max(1, Math.abs(i), Math.abs(c)) && Math.abs(s - h) <= T.EPSILON * Math.max(1, Math.abs(s), Math.abs(h)) && Math.abs(a - p) <= T.EPSILON * Math.max(1, Math.abs(a), Math.abs(p)) && Math.abs(o - f) <= T.EPSILON * Math.max(1, Math.abs(o), Math.abs(f));
    }, S.sub = S.mul = void 0;
    var T = function (t, e) {
      if (t && t.__esModule) return t;
      if (null === t || "object" !== I(t) && "function" != typeof t) return {
        default: t
      };
      var r = k(void 0);
      if (r && r.has(t)) return r.get(t);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var s in t) if ("default" !== s && Object.prototype.hasOwnProperty.call(t, s)) {
        var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
        a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
      }
      return n.default = t, r && r.set(t, n), n;
    }(d);
    function k(t) {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap(),
        r = new WeakMap();
      return (k = function k(t) {
        return t ? r : e;
      })(t);
    }
    function P(t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = e[4],
        l = e[5],
        u = r[0],
        c = r[1],
        h = r[2],
        p = r[3],
        f = r[4],
        d = r[5];
      return t[0] = n * u + s * c, t[1] = i * u + a * c, t[2] = n * h + s * p, t[3] = i * h + a * p, t[4] = n * f + s * d + o, t[5] = i * f + a * d + l, t;
    }
    function z(t, e, r) {
      return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t[3] = e[3] - r[3], t[4] = e[4] - r[4], t[5] = e[5] - r[5], t;
    }
    S.mul = P, S.sub = z;
    var E = {};
    function B(t) {
      return B = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, B(t);
    }
    Object.defineProperty(E, "__esModule", {
      value: !0
    }), E.create = function () {
      var t = new D.ARRAY_TYPE(9);
      return D.ARRAY_TYPE != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[5] = 0, t[6] = 0, t[7] = 0), t[0] = 1, t[4] = 1, t[8] = 1, t;
    }, E.fromMat4 = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[4], t[4] = e[5], t[5] = e[6], t[6] = e[8], t[7] = e[9], t[8] = e[10], t;
    }, E.clone = function (t) {
      var e = new D.ARRAY_TYPE(9);
      return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e;
    }, E.copy = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t;
    }, E.fromValues = function (t, e, r, n, i, s, a, o, l) {
      var u = new D.ARRAY_TYPE(9);
      return u[0] = t, u[1] = e, u[2] = r, u[3] = n, u[4] = i, u[5] = s, u[6] = a, u[7] = o, u[8] = l, u;
    }, E.set = function (t, e, r, n, i, s, a, o, l, u) {
      return t[0] = e, t[1] = r, t[2] = n, t[3] = i, t[4] = s, t[5] = a, t[6] = o, t[7] = l, t[8] = u, t;
    }, E.identity = function (t) {
      return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 1, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t;
    }, E.transpose = function (t, e) {
      if (t === e) {
        var r = e[1],
          n = e[2],
          i = e[5];
        t[1] = e[3], t[2] = e[6], t[3] = r, t[5] = e[7], t[6] = n, t[7] = i;
      } else t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8];
      return t;
    }, E.invert = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = e[4],
        o = e[5],
        l = e[6],
        u = e[7],
        c = e[8],
        h = c * a - o * u,
        p = -c * s + o * l,
        f = u * s - a * l,
        d = r * h + n * p + i * f;
      return d ? (t[0] = h * (d = 1 / d), t[1] = (-c * n + i * u) * d, t[2] = (o * n - i * a) * d, t[3] = p * d, t[4] = (c * r - i * l) * d, t[5] = (-o * r + i * s) * d, t[6] = f * d, t[7] = (-u * r + n * l) * d, t[8] = (a * r - n * s) * d, t) : null;
    }, E.adjoint = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = e[4],
        o = e[5],
        l = e[6],
        u = e[7],
        c = e[8];
      return t[0] = a * c - o * u, t[1] = i * u - n * c, t[2] = n * o - i * a, t[3] = o * l - s * c, t[4] = r * c - i * l, t[5] = i * s - r * o, t[6] = s * u - a * l, t[7] = n * l - r * u, t[8] = r * a - n * s, t;
    }, E.determinant = function (t) {
      var e = t[3],
        r = t[4],
        n = t[5],
        i = t[6],
        s = t[7],
        a = t[8];
      return t[0] * (a * r - n * s) + t[1] * (-a * e + n * i) + t[2] * (s * e - r * i);
    }, E.multiply = C, E.translate = function (t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = e[4],
        l = e[5],
        u = e[6],
        c = e[7],
        h = e[8],
        p = r[0],
        f = r[1];
      return t[0] = n, t[1] = i, t[2] = s, t[3] = a, t[4] = o, t[5] = l, t[6] = p * n + f * a + u, t[7] = p * i + f * o + c, t[8] = p * s + f * l + h, t;
    }, E.rotate = function (t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = e[4],
        l = e[5],
        u = e[6],
        c = e[7],
        h = e[8],
        p = Math.sin(r),
        f = Math.cos(r);
      return t[0] = f * n + p * a, t[1] = f * i + p * o, t[2] = f * s + p * l, t[3] = f * a - p * n, t[4] = f * o - p * i, t[5] = f * l - p * s, t[6] = u, t[7] = c, t[8] = h, t;
    }, E.scale = function (t, e, r) {
      var n = r[0],
        i = r[1];
      return t[0] = n * e[0], t[1] = n * e[1], t[2] = n * e[2], t[3] = i * e[3], t[4] = i * e[4], t[5] = i * e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t;
    }, E.fromTranslation = function (t, e) {
      return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 1, t[5] = 0, t[6] = e[0], t[7] = e[1], t[8] = 1, t;
    }, E.fromRotation = function (t, e) {
      var r = Math.sin(e),
        n = Math.cos(e);
      return t[0] = n, t[1] = r, t[2] = 0, t[3] = -r, t[4] = n, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t;
    }, E.fromScaling = function (t, e) {
      return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = e[1], t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t;
    }, E.fromMat2d = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t[2] = 0, t[3] = e[2], t[4] = e[3], t[5] = 0, t[6] = e[4], t[7] = e[5], t[8] = 1, t;
    }, E.fromQuat = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = r + r,
        o = n + n,
        l = i + i,
        u = r * a,
        c = n * a,
        h = n * o,
        p = i * a,
        f = i * o,
        d = i * l,
        m = s * a,
        y = s * o,
        g = s * l;
      return t[0] = 1 - h - d, t[3] = c - g, t[6] = p + y, t[1] = c + g, t[4] = 1 - u - d, t[7] = f - m, t[2] = p - y, t[5] = f + m, t[8] = 1 - u - h, t;
    }, E.normalFromMat4 = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = e[4],
        o = e[5],
        l = e[6],
        u = e[7],
        c = e[8],
        h = e[9],
        p = e[10],
        f = e[11],
        d = e[12],
        m = e[13],
        y = e[14],
        g = e[15],
        x = r * o - n * a,
        b = r * l - i * a,
        v = r * u - s * a,
        _ = n * l - i * o,
        w = n * u - s * o,
        M = i * u - s * l,
        A = c * m - h * d,
        S = c * y - p * d,
        I = c * g - f * d,
        T = h * y - p * m,
        k = h * g - f * m,
        P = p * g - f * y,
        z = x * P - b * k + v * T + _ * I - w * S + M * A;
      return z ? (t[0] = (o * P - l * k + u * T) * (z = 1 / z), t[1] = (l * I - a * P - u * S) * z, t[2] = (a * k - o * I + u * A) * z, t[3] = (i * k - n * P - s * T) * z, t[4] = (r * P - i * I + s * S) * z, t[5] = (n * I - r * k - s * A) * z, t[6] = (m * M - y * w + g * _) * z, t[7] = (y * v - d * M - g * b) * z, t[8] = (d * w - m * v + g * x) * z, t) : null;
    }, E.projection = function (t, e, r) {
      return t[0] = 2 / e, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = -2 / r, t[5] = 0, t[6] = -1, t[7] = 1, t[8] = 1, t;
    }, E.str = function (t) {
      return "mat3(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ", " + t[4] + ", " + t[5] + ", " + t[6] + ", " + t[7] + ", " + t[8] + ")";
    }, E.frob = function (t) {
      return Math.hypot(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8]);
    }, E.add = function (t, e, r) {
      return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t[3] = e[3] + r[3], t[4] = e[4] + r[4], t[5] = e[5] + r[5], t[6] = e[6] + r[6], t[7] = e[7] + r[7], t[8] = e[8] + r[8], t;
    }, E.subtract = L, E.multiplyScalar = function (t, e, r) {
      return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t[4] = e[4] * r, t[5] = e[5] * r, t[6] = e[6] * r, t[7] = e[7] * r, t[8] = e[8] * r, t;
    }, E.multiplyScalarAndAdd = function (t, e, r, n) {
      return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t[2] = e[2] + r[2] * n, t[3] = e[3] + r[3] * n, t[4] = e[4] + r[4] * n, t[5] = e[5] + r[5] * n, t[6] = e[6] + r[6] * n, t[7] = e[7] + r[7] * n, t[8] = e[8] + r[8] * n, t;
    }, E.exactEquals = function (t, e) {
      return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3] && t[4] === e[4] && t[5] === e[5] && t[6] === e[6] && t[7] === e[7] && t[8] === e[8];
    }, E.equals = function (t, e) {
      var r = t[0],
        n = t[1],
        i = t[2],
        s = t[3],
        a = t[4],
        o = t[5],
        l = t[6],
        u = t[7],
        c = t[8],
        h = e[0],
        p = e[1],
        f = e[2],
        d = e[3],
        m = e[4],
        y = e[5],
        g = e[6],
        x = e[7],
        b = e[8];
      return Math.abs(r - h) <= D.EPSILON * Math.max(1, Math.abs(r), Math.abs(h)) && Math.abs(n - p) <= D.EPSILON * Math.max(1, Math.abs(n), Math.abs(p)) && Math.abs(i - f) <= D.EPSILON * Math.max(1, Math.abs(i), Math.abs(f)) && Math.abs(s - d) <= D.EPSILON * Math.max(1, Math.abs(s), Math.abs(d)) && Math.abs(a - m) <= D.EPSILON * Math.max(1, Math.abs(a), Math.abs(m)) && Math.abs(o - y) <= D.EPSILON * Math.max(1, Math.abs(o), Math.abs(y)) && Math.abs(l - g) <= D.EPSILON * Math.max(1, Math.abs(l), Math.abs(g)) && Math.abs(u - x) <= D.EPSILON * Math.max(1, Math.abs(u), Math.abs(x)) && Math.abs(c - b) <= D.EPSILON * Math.max(1, Math.abs(c), Math.abs(b));
    }, E.sub = E.mul = void 0;
    var D = function (t, e) {
      if (t && t.__esModule) return t;
      if (null === t || "object" !== B(t) && "function" != typeof t) return {
        default: t
      };
      var r = R(void 0);
      if (r && r.has(t)) return r.get(t);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var s in t) if ("default" !== s && Object.prototype.hasOwnProperty.call(t, s)) {
        var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
        a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
      }
      return n.default = t, r && r.set(t, n), n;
    }(d);
    function R(t) {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap(),
        r = new WeakMap();
      return (R = function R(t) {
        return t ? r : e;
      })(t);
    }
    function C(t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = e[4],
        l = e[5],
        u = e[6],
        c = e[7],
        h = e[8],
        p = r[0],
        f = r[1],
        d = r[2],
        m = r[3],
        y = r[4],
        g = r[5],
        x = r[6],
        b = r[7],
        v = r[8];
      return t[0] = p * n + f * a + d * u, t[1] = p * i + f * o + d * c, t[2] = p * s + f * l + d * h, t[3] = m * n + y * a + g * u, t[4] = m * i + y * o + g * c, t[5] = m * s + y * l + g * h, t[6] = x * n + b * a + v * u, t[7] = x * i + b * o + v * c, t[8] = x * s + b * l + v * h, t;
    }
    function L(t, e, r) {
      return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t[3] = e[3] - r[3], t[4] = e[4] - r[4], t[5] = e[5] - r[5], t[6] = e[6] - r[6], t[7] = e[7] - r[7], t[8] = e[8] - r[8], t;
    }
    E.mul = C, E.sub = L;
    var V = {};
    function F(t) {
      return F = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, F(t);
    }
    Object.defineProperty(V, "__esModule", {
      value: !0
    }), V.create = function () {
      var t = new O.ARRAY_TYPE(16);
      return O.ARRAY_TYPE != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0), t[0] = 1, t[5] = 1, t[10] = 1, t[15] = 1, t;
    }, V.clone = function (t) {
      var e = new O.ARRAY_TYPE(16);
      return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
    }, V.copy = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
    }, V.fromValues = function (t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m) {
      var y = new O.ARRAY_TYPE(16);
      return y[0] = t, y[1] = e, y[2] = r, y[3] = n, y[4] = i, y[5] = s, y[6] = a, y[7] = o, y[8] = l, y[9] = u, y[10] = c, y[11] = h, y[12] = p, y[13] = f, y[14] = d, y[15] = m, y;
    }, V.set = function (t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y) {
      return t[0] = e, t[1] = r, t[2] = n, t[3] = i, t[4] = s, t[5] = a, t[6] = o, t[7] = l, t[8] = u, t[9] = c, t[10] = h, t[11] = p, t[12] = f, t[13] = d, t[14] = m, t[15] = y, t;
    }, V.identity = j, V.transpose = function (t, e) {
      if (t === e) {
        var r = e[1],
          n = e[2],
          i = e[3],
          s = e[6],
          a = e[7],
          o = e[11];
        t[1] = e[4], t[2] = e[8], t[3] = e[12], t[4] = r, t[6] = e[9], t[7] = e[13], t[8] = n, t[9] = s, t[11] = e[14], t[12] = i, t[13] = a, t[14] = o;
      } else t[0] = e[0], t[1] = e[4], t[2] = e[8], t[3] = e[12], t[4] = e[1], t[5] = e[5], t[6] = e[9], t[7] = e[13], t[8] = e[2], t[9] = e[6], t[10] = e[10], t[11] = e[14], t[12] = e[3], t[13] = e[7], t[14] = e[11], t[15] = e[15];
      return t;
    }, V.invert = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = e[4],
        o = e[5],
        l = e[6],
        u = e[7],
        c = e[8],
        h = e[9],
        p = e[10],
        f = e[11],
        d = e[12],
        m = e[13],
        y = e[14],
        g = e[15],
        x = r * o - n * a,
        b = r * l - i * a,
        v = r * u - s * a,
        _ = n * l - i * o,
        w = n * u - s * o,
        M = i * u - s * l,
        A = c * m - h * d,
        S = c * y - p * d,
        I = c * g - f * d,
        T = h * y - p * m,
        k = h * g - f * m,
        P = p * g - f * y,
        z = x * P - b * k + v * T + _ * I - w * S + M * A;
      return z ? (t[0] = (o * P - l * k + u * T) * (z = 1 / z), t[1] = (i * k - n * P - s * T) * z, t[2] = (m * M - y * w + g * _) * z, t[3] = (p * w - h * M - f * _) * z, t[4] = (l * I - a * P - u * S) * z, t[5] = (r * P - i * I + s * S) * z, t[6] = (y * v - d * M - g * b) * z, t[7] = (c * M - p * v + f * b) * z, t[8] = (a * k - o * I + u * A) * z, t[9] = (n * I - r * k - s * A) * z, t[10] = (d * w - m * v + g * x) * z, t[11] = (h * v - c * w - f * x) * z, t[12] = (o * S - a * T - l * A) * z, t[13] = (r * T - n * S + i * A) * z, t[14] = (m * b - d * _ - y * x) * z, t[15] = (c * _ - h * b + p * x) * z, t) : null;
    }, V.adjoint = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = e[4],
        o = e[5],
        l = e[6],
        u = e[7],
        c = e[8],
        h = e[9],
        p = e[10],
        f = e[11],
        d = e[12],
        m = e[13],
        y = e[14],
        g = e[15];
      return t[0] = o * (p * g - f * y) - h * (l * g - u * y) + m * (l * f - u * p), t[1] = -(n * (p * g - f * y) - h * (i * g - s * y) + m * (i * f - s * p)), t[2] = n * (l * g - u * y) - o * (i * g - s * y) + m * (i * u - s * l), t[3] = -(n * (l * f - u * p) - o * (i * f - s * p) + h * (i * u - s * l)), t[4] = -(a * (p * g - f * y) - c * (l * g - u * y) + d * (l * f - u * p)), t[5] = r * (p * g - f * y) - c * (i * g - s * y) + d * (i * f - s * p), t[6] = -(r * (l * g - u * y) - a * (i * g - s * y) + d * (i * u - s * l)), t[7] = r * (l * f - u * p) - a * (i * f - s * p) + c * (i * u - s * l), t[8] = a * (h * g - f * m) - c * (o * g - u * m) + d * (o * f - u * h), t[9] = -(r * (h * g - f * m) - c * (n * g - s * m) + d * (n * f - s * h)), t[10] = r * (o * g - u * m) - a * (n * g - s * m) + d * (n * u - s * o), t[11] = -(r * (o * f - u * h) - a * (n * f - s * h) + c * (n * u - s * o)), t[12] = -(a * (h * y - p * m) - c * (o * y - l * m) + d * (o * p - l * h)), t[13] = r * (h * y - p * m) - c * (n * y - i * m) + d * (n * p - i * h), t[14] = -(r * (o * y - l * m) - a * (n * y - i * m) + d * (n * l - i * o)), t[15] = r * (o * p - l * h) - a * (n * p - i * h) + c * (n * l - i * o), t;
    }, V.determinant = function (t) {
      var e = t[0],
        r = t[1],
        n = t[2],
        i = t[3],
        s = t[4],
        a = t[5],
        o = t[6],
        l = t[7],
        u = t[8],
        c = t[9],
        h = t[10],
        p = t[11],
        f = t[12],
        d = t[13],
        m = t[14],
        y = t[15];
      return (e * a - r * s) * (h * y - p * m) - (e * o - n * s) * (c * y - p * d) + (e * l - i * s) * (c * m - h * d) + (r * o - n * a) * (u * y - p * f) - (r * l - i * a) * (u * m - h * f) + (n * l - i * o) * (u * d - c * f);
    }, V.multiply = N, V.translate = function (t, e, r) {
      var n,
        i,
        s,
        a,
        o,
        l,
        u,
        c,
        h,
        p,
        f,
        d,
        m = r[0],
        y = r[1],
        g = r[2];
      return e === t ? (t[12] = e[0] * m + e[4] * y + e[8] * g + e[12], t[13] = e[1] * m + e[5] * y + e[9] * g + e[13], t[14] = e[2] * m + e[6] * y + e[10] * g + e[14], t[15] = e[3] * m + e[7] * y + e[11] * g + e[15]) : (i = e[1], s = e[2], a = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], t[0] = n = e[0], t[1] = i, t[2] = s, t[3] = a, t[4] = o, t[5] = l, t[6] = u, t[7] = c, t[8] = h, t[9] = p, t[10] = f, t[11] = d, t[12] = n * m + o * y + h * g + e[12], t[13] = i * m + l * y + p * g + e[13], t[14] = s * m + u * y + f * g + e[14], t[15] = a * m + c * y + d * g + e[15]), t;
    }, V.scale = function (t, e, r) {
      var n = r[0],
        i = r[1],
        s = r[2];
      return t[0] = e[0] * n, t[1] = e[1] * n, t[2] = e[2] * n, t[3] = e[3] * n, t[4] = e[4] * i, t[5] = e[5] * i, t[6] = e[6] * i, t[7] = e[7] * i, t[8] = e[8] * s, t[9] = e[9] * s, t[10] = e[10] * s, t[11] = e[11] * s, t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
    }, V.rotate = function (t, e, r, n) {
      var i,
        s,
        a,
        o,
        l,
        u,
        c,
        h,
        p,
        f,
        d,
        m,
        y,
        g,
        x,
        b,
        v,
        _,
        w,
        M,
        A,
        S,
        I,
        T,
        k = n[0],
        P = n[1],
        z = n[2],
        E = Math.hypot(k, P, z);
      return E < O.EPSILON ? null : (k *= E = 1 / E, P *= E, z *= E, i = Math.sin(r), s = Math.cos(r), l = e[1], u = e[2], c = e[3], p = e[5], f = e[6], d = e[7], y = e[9], g = e[10], x = e[11], b = k * k * (a = 1 - s) + s, w = k * P * a - z * i, M = P * P * a + s, A = z * P * a + k * i, S = k * z * a + P * i, I = P * z * a - k * i, T = z * z * a + s, t[0] = (o = e[0]) * b + (h = e[4]) * (v = P * k * a + z * i) + (m = e[8]) * (_ = z * k * a - P * i), t[1] = l * b + p * v + y * _, t[2] = u * b + f * v + g * _, t[3] = c * b + d * v + x * _, t[4] = o * w + h * M + m * A, t[5] = l * w + p * M + y * A, t[6] = u * w + f * M + g * A, t[7] = c * w + d * M + x * A, t[8] = o * S + h * I + m * T, t[9] = l * S + p * I + y * T, t[10] = u * S + f * I + g * T, t[11] = c * S + d * I + x * T, e !== t && (t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t);
    }, V.rotateX = function (t, e, r) {
      var n = Math.sin(r),
        i = Math.cos(r),
        s = e[4],
        a = e[5],
        o = e[6],
        l = e[7],
        u = e[8],
        c = e[9],
        h = e[10],
        p = e[11];
      return e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[4] = s * i + u * n, t[5] = a * i + c * n, t[6] = o * i + h * n, t[7] = l * i + p * n, t[8] = u * i - s * n, t[9] = c * i - a * n, t[10] = h * i - o * n, t[11] = p * i - l * n, t;
    }, V.rotateY = function (t, e, r) {
      var n = Math.sin(r),
        i = Math.cos(r),
        s = e[0],
        a = e[1],
        o = e[2],
        l = e[3],
        u = e[8],
        c = e[9],
        h = e[10],
        p = e[11];
      return e !== t && (t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = s * i - u * n, t[1] = a * i - c * n, t[2] = o * i - h * n, t[3] = l * i - p * n, t[8] = s * n + u * i, t[9] = a * n + c * i, t[10] = o * n + h * i, t[11] = l * n + p * i, t;
    }, V.rotateZ = function (t, e, r) {
      var n = Math.sin(r),
        i = Math.cos(r),
        s = e[0],
        a = e[1],
        o = e[2],
        l = e[3],
        u = e[4],
        c = e[5],
        h = e[6],
        p = e[7];
      return e !== t && (t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = s * i + u * n, t[1] = a * i + c * n, t[2] = o * i + h * n, t[3] = l * i + p * n, t[4] = u * i - s * n, t[5] = c * i - a * n, t[6] = h * i - o * n, t[7] = p * i - l * n, t;
    }, V.fromTranslation = function (t, e) {
      return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = e[0], t[13] = e[1], t[14] = e[2], t[15] = 1, t;
    }, V.fromScaling = function (t, e) {
      return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = e[1], t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = e[2], t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
    }, V.fromRotation = function (t, e, r) {
      var n,
        i,
        s,
        a = r[0],
        o = r[1],
        l = r[2],
        u = Math.hypot(a, o, l);
      return u < O.EPSILON ? null : (a *= u = 1 / u, o *= u, l *= u, n = Math.sin(e), i = Math.cos(e), t[0] = a * a * (s = 1 - i) + i, t[1] = o * a * s + l * n, t[2] = l * a * s - o * n, t[3] = 0, t[4] = a * o * s - l * n, t[5] = o * o * s + i, t[6] = l * o * s + a * n, t[7] = 0, t[8] = a * l * s + o * n, t[9] = o * l * s - a * n, t[10] = l * l * s + i, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t);
    }, V.fromXRotation = function (t, e) {
      var r = Math.sin(e),
        n = Math.cos(e);
      return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = n, t[6] = r, t[7] = 0, t[8] = 0, t[9] = -r, t[10] = n, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
    }, V.fromYRotation = function (t, e) {
      var r = Math.sin(e),
        n = Math.cos(e);
      return t[0] = n, t[1] = 0, t[2] = -r, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = r, t[9] = 0, t[10] = n, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
    }, V.fromZRotation = function (t, e) {
      var r = Math.sin(e),
        n = Math.cos(e);
      return t[0] = n, t[1] = r, t[2] = 0, t[3] = 0, t[4] = -r, t[5] = n, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
    }, V.fromRotationTranslation = $, V.fromQuat2 = function (t, e) {
      var r = new O.ARRAY_TYPE(3),
        n = -e[0],
        i = -e[1],
        s = -e[2],
        a = e[3],
        o = e[4],
        l = e[5],
        u = e[6],
        c = e[7],
        h = n * n + i * i + s * s + a * a;
      return h > 0 ? (r[0] = 2 * (o * a + c * n + l * s - u * i) / h, r[1] = 2 * (l * a + c * i + u * n - o * s) / h, r[2] = 2 * (u * a + c * s + o * i - l * n) / h) : (r[0] = 2 * (o * a + c * n + l * s - u * i), r[1] = 2 * (l * a + c * i + u * n - o * s), r[2] = 2 * (u * a + c * s + o * i - l * n)), $(t, e, r), t;
    }, V.getTranslation = function (t, e) {
      return t[0] = e[12], t[1] = e[13], t[2] = e[14], t;
    }, V.getScaling = q, V.getRotation = function (t, e) {
      var r = new O.ARRAY_TYPE(3);
      q(r, e);
      var n = 1 / r[0],
        i = 1 / r[1],
        s = 1 / r[2],
        a = e[0] * n,
        o = e[1] * i,
        l = e[2] * s,
        u = e[4] * n,
        c = e[5] * i,
        h = e[6] * s,
        p = e[8] * n,
        f = e[9] * i,
        d = e[10] * s,
        m = a + c + d,
        y = 0;
      return m > 0 ? (y = 2 * Math.sqrt(m + 1), t[3] = .25 * y, t[0] = (h - f) / y, t[1] = (p - l) / y, t[2] = (o - u) / y) : a > c && a > d ? (y = 2 * Math.sqrt(1 + a - c - d), t[3] = (h - f) / y, t[0] = .25 * y, t[1] = (o + u) / y, t[2] = (p + l) / y) : c > d ? (y = 2 * Math.sqrt(1 + c - a - d), t[3] = (p - l) / y, t[0] = (o + u) / y, t[1] = .25 * y, t[2] = (h + f) / y) : (y = 2 * Math.sqrt(1 + d - a - c), t[3] = (o - u) / y, t[0] = (p + l) / y, t[1] = (h + f) / y, t[2] = .25 * y), t;
    }, V.fromRotationTranslationScale = function (t, e, r, n) {
      var i = e[0],
        s = e[1],
        a = e[2],
        o = e[3],
        l = i + i,
        u = s + s,
        c = a + a,
        h = i * l,
        p = i * u,
        f = i * c,
        d = s * u,
        m = s * c,
        y = a * c,
        g = o * l,
        x = o * u,
        b = o * c,
        v = n[0],
        _ = n[1],
        w = n[2];
      return t[0] = (1 - (d + y)) * v, t[1] = (p + b) * v, t[2] = (f - x) * v, t[3] = 0, t[4] = (p - b) * _, t[5] = (1 - (h + y)) * _, t[6] = (m + g) * _, t[7] = 0, t[8] = (f + x) * w, t[9] = (m - g) * w, t[10] = (1 - (h + d)) * w, t[11] = 0, t[12] = r[0], t[13] = r[1], t[14] = r[2], t[15] = 1, t;
    }, V.fromRotationTranslationScaleOrigin = function (t, e, r, n, i) {
      var s = e[0],
        a = e[1],
        o = e[2],
        l = e[3],
        u = s + s,
        c = a + a,
        h = o + o,
        p = s * u,
        f = s * c,
        d = s * h,
        m = a * c,
        y = a * h,
        g = o * h,
        x = l * u,
        b = l * c,
        v = l * h,
        _ = n[0],
        w = n[1],
        M = n[2],
        A = i[0],
        S = i[1],
        I = i[2],
        T = (1 - (m + g)) * _,
        k = (f + v) * _,
        P = (d - b) * _,
        z = (f - v) * w,
        E = (1 - (p + g)) * w,
        B = (y + x) * w,
        D = (d + b) * M,
        R = (y - x) * M,
        C = (1 - (p + m)) * M;
      return t[0] = T, t[1] = k, t[2] = P, t[3] = 0, t[4] = z, t[5] = E, t[6] = B, t[7] = 0, t[8] = D, t[9] = R, t[10] = C, t[11] = 0, t[12] = r[0] + A - (T * A + z * S + D * I), t[13] = r[1] + S - (k * A + E * S + R * I), t[14] = r[2] + I - (P * A + B * S + C * I), t[15] = 1, t;
    }, V.fromQuat = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = r + r,
        o = n + n,
        l = i + i,
        u = r * a,
        c = n * a,
        h = n * o,
        p = i * a,
        f = i * o,
        d = i * l,
        m = s * a,
        y = s * o,
        g = s * l;
      return t[0] = 1 - h - d, t[1] = c + g, t[2] = p - y, t[3] = 0, t[4] = c - g, t[5] = 1 - u - d, t[6] = f + m, t[7] = 0, t[8] = p + y, t[9] = f - m, t[10] = 1 - u - h, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
    }, V.frustum = function (t, e, r, n, i, s, a) {
      var o = 1 / (r - e),
        l = 1 / (i - n),
        u = 1 / (s - a);
      return t[0] = 2 * s * o, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 2 * s * l, t[6] = 0, t[7] = 0, t[8] = (r + e) * o, t[9] = (i + n) * l, t[10] = (a + s) * u, t[11] = -1, t[12] = 0, t[13] = 0, t[14] = a * s * 2 * u, t[15] = 0, t;
    }, V.perspectiveNO = G, V.perspectiveZO = function (t, e, r, n, i) {
      var s,
        a = 1 / Math.tan(e / 2);
      return t[0] = a / r, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = a, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = -1, t[12] = 0, t[13] = 0, t[15] = 0, null != i && i !== 1 / 0 ? (t[10] = i * (s = 1 / (n - i)), t[14] = i * n * s) : (t[10] = -1, t[14] = -n), t;
    }, V.perspectiveFromFieldOfView = function (t, e, r, n) {
      var i = Math.tan(e.upDegrees * Math.PI / 180),
        s = Math.tan(e.downDegrees * Math.PI / 180),
        a = Math.tan(e.leftDegrees * Math.PI / 180),
        o = Math.tan(e.rightDegrees * Math.PI / 180),
        l = 2 / (a + o),
        u = 2 / (i + s);
      return t[0] = l, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = u, t[6] = 0, t[7] = 0, t[8] = -(a - o) * l * .5, t[9] = (i - s) * u * .5, t[10] = n / (r - n), t[11] = -1, t[12] = 0, t[13] = 0, t[14] = n * r / (r - n), t[15] = 0, t;
    }, V.orthoNO = X, V.orthoZO = function (t, e, r, n, i, s, a) {
      var o = 1 / (e - r),
        l = 1 / (n - i),
        u = 1 / (s - a);
      return t[0] = -2 * o, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * l, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = u, t[11] = 0, t[12] = (e + r) * o, t[13] = (i + n) * l, t[14] = s * u, t[15] = 1, t;
    }, V.lookAt = function (t, e, r, n) {
      var i,
        s,
        a,
        o,
        l,
        u,
        c,
        h,
        p,
        f,
        d = e[0],
        m = e[1],
        y = e[2],
        g = n[0],
        x = n[1],
        b = n[2],
        v = r[0],
        _ = r[1],
        w = r[2];
      return Math.abs(d - v) < O.EPSILON && Math.abs(m - _) < O.EPSILON && Math.abs(y - w) < O.EPSILON ? j(t) : (c = d - v, h = m - _, p = y - w, i = x * (p *= f = 1 / Math.hypot(c, h, p)) - b * (h *= f), s = b * (c *= f) - g * p, a = g * h - x * c, (f = Math.hypot(i, s, a)) ? (i *= f = 1 / f, s *= f, a *= f) : (i = 0, s = 0, a = 0), o = h * a - p * s, l = p * i - c * a, u = c * s - h * i, (f = Math.hypot(o, l, u)) ? (o *= f = 1 / f, l *= f, u *= f) : (o = 0, l = 0, u = 0), t[0] = i, t[1] = o, t[2] = c, t[3] = 0, t[4] = s, t[5] = l, t[6] = h, t[7] = 0, t[8] = a, t[9] = u, t[10] = p, t[11] = 0, t[12] = -(i * d + s * m + a * y), t[13] = -(o * d + l * m + u * y), t[14] = -(c * d + h * m + p * y), t[15] = 1, t);
    }, V.targetTo = function (t, e, r, n) {
      var i = e[0],
        s = e[1],
        a = e[2],
        o = n[0],
        l = n[1],
        u = n[2],
        c = i - r[0],
        h = s - r[1],
        p = a - r[2],
        f = c * c + h * h + p * p;
      f > 0 && (c *= f = 1 / Math.sqrt(f), h *= f, p *= f);
      var d = l * p - u * h,
        m = u * c - o * p,
        y = o * h - l * c;
      return (f = d * d + m * m + y * y) > 0 && (d *= f = 1 / Math.sqrt(f), m *= f, y *= f), t[0] = d, t[1] = m, t[2] = y, t[3] = 0, t[4] = h * y - p * m, t[5] = p * d - c * y, t[6] = c * m - h * d, t[7] = 0, t[8] = c, t[9] = h, t[10] = p, t[11] = 0, t[12] = i, t[13] = s, t[14] = a, t[15] = 1, t;
    }, V.str = function (t) {
      return "mat4(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ", " + t[4] + ", " + t[5] + ", " + t[6] + ", " + t[7] + ", " + t[8] + ", " + t[9] + ", " + t[10] + ", " + t[11] + ", " + t[12] + ", " + t[13] + ", " + t[14] + ", " + t[15] + ")";
    }, V.frob = function (t) {
      return Math.hypot(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
    }, V.add = function (t, e, r) {
      return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t[3] = e[3] + r[3], t[4] = e[4] + r[4], t[5] = e[5] + r[5], t[6] = e[6] + r[6], t[7] = e[7] + r[7], t[8] = e[8] + r[8], t[9] = e[9] + r[9], t[10] = e[10] + r[10], t[11] = e[11] + r[11], t[12] = e[12] + r[12], t[13] = e[13] + r[13], t[14] = e[14] + r[14], t[15] = e[15] + r[15], t;
    }, V.subtract = Y, V.multiplyScalar = function (t, e, r) {
      return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t[4] = e[4] * r, t[5] = e[5] * r, t[6] = e[6] * r, t[7] = e[7] * r, t[8] = e[8] * r, t[9] = e[9] * r, t[10] = e[10] * r, t[11] = e[11] * r, t[12] = e[12] * r, t[13] = e[13] * r, t[14] = e[14] * r, t[15] = e[15] * r, t;
    }, V.multiplyScalarAndAdd = function (t, e, r, n) {
      return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t[2] = e[2] + r[2] * n, t[3] = e[3] + r[3] * n, t[4] = e[4] + r[4] * n, t[5] = e[5] + r[5] * n, t[6] = e[6] + r[6] * n, t[7] = e[7] + r[7] * n, t[8] = e[8] + r[8] * n, t[9] = e[9] + r[9] * n, t[10] = e[10] + r[10] * n, t[11] = e[11] + r[11] * n, t[12] = e[12] + r[12] * n, t[13] = e[13] + r[13] * n, t[14] = e[14] + r[14] * n, t[15] = e[15] + r[15] * n, t;
    }, V.exactEquals = function (t, e) {
      return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3] && t[4] === e[4] && t[5] === e[5] && t[6] === e[6] && t[7] === e[7] && t[8] === e[8] && t[9] === e[9] && t[10] === e[10] && t[11] === e[11] && t[12] === e[12] && t[13] === e[13] && t[14] === e[14] && t[15] === e[15];
    }, V.equals = function (t, e) {
      var r = t[0],
        n = t[1],
        i = t[2],
        s = t[3],
        a = t[4],
        o = t[5],
        l = t[6],
        u = t[7],
        c = t[8],
        h = t[9],
        p = t[10],
        f = t[11],
        d = t[12],
        m = t[13],
        y = t[14],
        g = t[15],
        x = e[0],
        b = e[1],
        v = e[2],
        _ = e[3],
        w = e[4],
        M = e[5],
        A = e[6],
        S = e[7],
        I = e[8],
        T = e[9],
        k = e[10],
        P = e[11],
        z = e[12],
        E = e[13],
        B = e[14],
        D = e[15];
      return Math.abs(r - x) <= O.EPSILON * Math.max(1, Math.abs(r), Math.abs(x)) && Math.abs(n - b) <= O.EPSILON * Math.max(1, Math.abs(n), Math.abs(b)) && Math.abs(i - v) <= O.EPSILON * Math.max(1, Math.abs(i), Math.abs(v)) && Math.abs(s - _) <= O.EPSILON * Math.max(1, Math.abs(s), Math.abs(_)) && Math.abs(a - w) <= O.EPSILON * Math.max(1, Math.abs(a), Math.abs(w)) && Math.abs(o - M) <= O.EPSILON * Math.max(1, Math.abs(o), Math.abs(M)) && Math.abs(l - A) <= O.EPSILON * Math.max(1, Math.abs(l), Math.abs(A)) && Math.abs(u - S) <= O.EPSILON * Math.max(1, Math.abs(u), Math.abs(S)) && Math.abs(c - I) <= O.EPSILON * Math.max(1, Math.abs(c), Math.abs(I)) && Math.abs(h - T) <= O.EPSILON * Math.max(1, Math.abs(h), Math.abs(T)) && Math.abs(p - k) <= O.EPSILON * Math.max(1, Math.abs(p), Math.abs(k)) && Math.abs(f - P) <= O.EPSILON * Math.max(1, Math.abs(f), Math.abs(P)) && Math.abs(d - z) <= O.EPSILON * Math.max(1, Math.abs(d), Math.abs(z)) && Math.abs(m - E) <= O.EPSILON * Math.max(1, Math.abs(m), Math.abs(E)) && Math.abs(y - B) <= O.EPSILON * Math.max(1, Math.abs(y), Math.abs(B)) && Math.abs(g - D) <= O.EPSILON * Math.max(1, Math.abs(g), Math.abs(D));
    }, V.sub = V.mul = V.ortho = V.perspective = void 0;
    var O = function (t, e) {
      if (t && t.__esModule) return t;
      if (null === t || "object" !== F(t) && "function" != typeof t) return {
        default: t
      };
      var r = U(void 0);
      if (r && r.has(t)) return r.get(t);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var s in t) if ("default" !== s && Object.prototype.hasOwnProperty.call(t, s)) {
        var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
        a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
      }
      return n.default = t, r && r.set(t, n), n;
    }(d);
    function U(t) {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap(),
        r = new WeakMap();
      return (U = function U(t) {
        return t ? r : e;
      })(t);
    }
    function j(t) {
      return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
    }
    function N(t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = e[4],
        l = e[5],
        u = e[6],
        c = e[7],
        h = e[8],
        p = e[9],
        f = e[10],
        d = e[11],
        m = e[12],
        y = e[13],
        g = e[14],
        x = e[15],
        b = r[0],
        v = r[1],
        _ = r[2],
        w = r[3];
      return t[0] = b * n + v * o + _ * h + w * m, t[1] = b * i + v * l + _ * p + w * y, t[2] = b * s + v * u + _ * f + w * g, t[3] = b * a + v * c + _ * d + w * x, t[4] = (b = r[4]) * n + (v = r[5]) * o + (_ = r[6]) * h + (w = r[7]) * m, t[5] = b * i + v * l + _ * p + w * y, t[6] = b * s + v * u + _ * f + w * g, t[7] = b * a + v * c + _ * d + w * x, t[8] = (b = r[8]) * n + (v = r[9]) * o + (_ = r[10]) * h + (w = r[11]) * m, t[9] = b * i + v * l + _ * p + w * y, t[10] = b * s + v * u + _ * f + w * g, t[11] = b * a + v * c + _ * d + w * x, t[12] = (b = r[12]) * n + (v = r[13]) * o + (_ = r[14]) * h + (w = r[15]) * m, t[13] = b * i + v * l + _ * p + w * y, t[14] = b * s + v * u + _ * f + w * g, t[15] = b * a + v * c + _ * d + w * x, t;
    }
    function $(t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = n + n,
        l = i + i,
        u = s + s,
        c = n * o,
        h = n * l,
        p = n * u,
        f = i * l,
        d = i * u,
        m = s * u,
        y = a * o,
        g = a * l,
        x = a * u;
      return t[0] = 1 - (f + m), t[1] = h + x, t[2] = p - g, t[3] = 0, t[4] = h - x, t[5] = 1 - (c + m), t[6] = d + y, t[7] = 0, t[8] = p + g, t[9] = d - y, t[10] = 1 - (c + f), t[11] = 0, t[12] = r[0], t[13] = r[1], t[14] = r[2], t[15] = 1, t;
    }
    function q(t, e) {
      var r = e[4],
        n = e[5],
        i = e[6],
        s = e[8],
        a = e[9],
        o = e[10];
      return t[0] = Math.hypot(e[0], e[1], e[2]), t[1] = Math.hypot(r, n, i), t[2] = Math.hypot(s, a, o), t;
    }
    function G(t, e, r, n, i) {
      var s,
        a = 1 / Math.tan(e / 2);
      return t[0] = a / r, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = a, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = -1, t[12] = 0, t[13] = 0, t[15] = 0, null != i && i !== 1 / 0 ? (t[10] = (i + n) * (s = 1 / (n - i)), t[14] = 2 * i * n * s) : (t[10] = -1, t[14] = -2 * n), t;
    }
    function X(t, e, r, n, i, s, a) {
      var o = 1 / (e - r),
        l = 1 / (n - i),
        u = 1 / (s - a);
      return t[0] = -2 * o, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * l, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 2 * u, t[11] = 0, t[12] = (e + r) * o, t[13] = (i + n) * l, t[14] = (a + s) * u, t[15] = 1, t;
    }
    function Y(t, e, r) {
      return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t[3] = e[3] - r[3], t[4] = e[4] - r[4], t[5] = e[5] - r[5], t[6] = e[6] - r[6], t[7] = e[7] - r[7], t[8] = e[8] - r[8], t[9] = e[9] - r[9], t[10] = e[10] - r[10], t[11] = e[11] - r[11], t[12] = e[12] - r[12], t[13] = e[13] - r[13], t[14] = e[14] - r[14], t[15] = e[15] - r[15], t;
    }
    V.perspective = G, V.ortho = X, V.mul = N, V.sub = Y;
    var Z = {},
      H = {};
    function K(t) {
      return K = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, K(t);
    }
    Object.defineProperty(H, "__esModule", {
      value: !0
    }), H.create = Q, H.clone = function (t) {
      var e = new W.ARRAY_TYPE(3);
      return e[0] = t[0], e[1] = t[1], e[2] = t[2], e;
    }, H.length = tt, H.fromValues = function (t, e, r) {
      var n = new W.ARRAY_TYPE(3);
      return n[0] = t, n[1] = e, n[2] = r, n;
    }, H.copy = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t[2] = e[2], t;
    }, H.set = function (t, e, r, n) {
      return t[0] = e, t[1] = r, t[2] = n, t;
    }, H.add = function (t, e, r) {
      return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t;
    }, H.subtract = et, H.multiply = rt, H.divide = nt, H.ceil = function (t, e) {
      return t[0] = Math.ceil(e[0]), t[1] = Math.ceil(e[1]), t[2] = Math.ceil(e[2]), t;
    }, H.floor = function (t, e) {
      return t[0] = Math.floor(e[0]), t[1] = Math.floor(e[1]), t[2] = Math.floor(e[2]), t;
    }, H.min = function (t, e, r) {
      return t[0] = Math.min(e[0], r[0]), t[1] = Math.min(e[1], r[1]), t[2] = Math.min(e[2], r[2]), t;
    }, H.max = function (t, e, r) {
      return t[0] = Math.max(e[0], r[0]), t[1] = Math.max(e[1], r[1]), t[2] = Math.max(e[2], r[2]), t;
    }, H.round = function (t, e) {
      return t[0] = Math.round(e[0]), t[1] = Math.round(e[1]), t[2] = Math.round(e[2]), t;
    }, H.scale = function (t, e, r) {
      return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t;
    }, H.scaleAndAdd = function (t, e, r, n) {
      return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t[2] = e[2] + r[2] * n, t;
    }, H.distance = it, H.squaredDistance = st, H.squaredLength = at, H.negate = function (t, e) {
      return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t;
    }, H.inverse = function (t, e) {
      return t[0] = 1 / e[0], t[1] = 1 / e[1], t[2] = 1 / e[2], t;
    }, H.normalize = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = r * r + n * n + i * i;
      return s > 0 && (s = 1 / Math.sqrt(s)), t[0] = e[0] * s, t[1] = e[1] * s, t[2] = e[2] * s, t;
    }, H.dot = ot, H.cross = function (t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = r[0],
        o = r[1],
        l = r[2];
      return t[0] = i * l - s * o, t[1] = s * a - n * l, t[2] = n * o - i * a, t;
    }, H.lerp = function (t, e, r, n) {
      var i = e[0],
        s = e[1],
        a = e[2];
      return t[0] = i + n * (r[0] - i), t[1] = s + n * (r[1] - s), t[2] = a + n * (r[2] - a), t;
    }, H.hermite = function (t, e, r, n, i, s) {
      var a = s * s,
        o = a * (2 * s - 3) + 1,
        l = a * (s - 2) + s,
        u = a * (s - 1),
        c = a * (3 - 2 * s);
      return t[0] = e[0] * o + r[0] * l + n[0] * u + i[0] * c, t[1] = e[1] * o + r[1] * l + n[1] * u + i[1] * c, t[2] = e[2] * o + r[2] * l + n[2] * u + i[2] * c, t;
    }, H.bezier = function (t, e, r, n, i, s) {
      var a = 1 - s,
        o = a * a,
        l = s * s,
        u = o * a,
        c = 3 * s * o,
        h = 3 * l * a,
        p = l * s;
      return t[0] = e[0] * u + r[0] * c + n[0] * h + i[0] * p, t[1] = e[1] * u + r[1] * c + n[1] * h + i[1] * p, t[2] = e[2] * u + r[2] * c + n[2] * h + i[2] * p, t;
    }, H.random = function (t, e) {
      e = e || 1;
      var r = 2 * W.RANDOM() * Math.PI,
        n = 2 * W.RANDOM() - 1,
        i = Math.sqrt(1 - n * n) * e;
      return t[0] = Math.cos(r) * i, t[1] = Math.sin(r) * i, t[2] = n * e, t;
    }, H.transformMat4 = function (t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = r[3] * n + r[7] * i + r[11] * s + r[15];
      return t[0] = (r[0] * n + r[4] * i + r[8] * s + r[12]) / (a = a || 1), t[1] = (r[1] * n + r[5] * i + r[9] * s + r[13]) / a, t[2] = (r[2] * n + r[6] * i + r[10] * s + r[14]) / a, t;
    }, H.transformMat3 = function (t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2];
      return t[0] = n * r[0] + i * r[3] + s * r[6], t[1] = n * r[1] + i * r[4] + s * r[7], t[2] = n * r[2] + i * r[5] + s * r[8], t;
    }, H.transformQuat = function (t, e, r) {
      var n = r[0],
        i = r[1],
        s = r[2],
        a = e[0],
        o = e[1],
        l = e[2],
        u = i * l - s * o,
        c = s * a - n * l,
        h = n * o - i * a,
        p = i * h - s * c,
        f = s * u - n * h,
        d = n * c - i * u,
        m = 2 * r[3];
      return c *= m, h *= m, f *= 2, d *= 2, t[0] = a + (u *= m) + (p *= 2), t[1] = o + c + f, t[2] = l + h + d, t;
    }, H.rotateX = function (t, e, r, n) {
      var i = [],
        s = [];
      return i[0] = e[0] - r[0], i[1] = e[1] - r[1], i[2] = e[2] - r[2], s[0] = i[0], s[1] = i[1] * Math.cos(n) - i[2] * Math.sin(n), s[2] = i[1] * Math.sin(n) + i[2] * Math.cos(n), t[0] = s[0] + r[0], t[1] = s[1] + r[1], t[2] = s[2] + r[2], t;
    }, H.rotateY = function (t, e, r, n) {
      var i = [],
        s = [];
      return i[0] = e[0] - r[0], i[1] = e[1] - r[1], i[2] = e[2] - r[2], s[0] = i[2] * Math.sin(n) + i[0] * Math.cos(n), s[1] = i[1], s[2] = i[2] * Math.cos(n) - i[0] * Math.sin(n), t[0] = s[0] + r[0], t[1] = s[1] + r[1], t[2] = s[2] + r[2], t;
    }, H.rotateZ = function (t, e, r, n) {
      var i = [],
        s = [];
      return i[0] = e[0] - r[0], i[1] = e[1] - r[1], i[2] = e[2] - r[2], s[0] = i[0] * Math.cos(n) - i[1] * Math.sin(n), s[1] = i[0] * Math.sin(n) + i[1] * Math.cos(n), s[2] = i[2], t[0] = s[0] + r[0], t[1] = s[1] + r[1], t[2] = s[2] + r[2], t;
    }, H.angle = function (t, e) {
      var r = t[0],
        n = t[1],
        i = t[2],
        s = e[0],
        a = e[1],
        o = e[2],
        l = Math.sqrt(r * r + n * n + i * i) * Math.sqrt(s * s + a * a + o * o),
        u = l && ot(t, e) / l;
      return Math.acos(Math.min(Math.max(u, -1), 1));
    }, H.zero = function (t) {
      return t[0] = 0, t[1] = 0, t[2] = 0, t;
    }, H.str = function (t) {
      return "vec3(" + t[0] + ", " + t[1] + ", " + t[2] + ")";
    }, H.exactEquals = function (t, e) {
      return t[0] === e[0] && t[1] === e[1] && t[2] === e[2];
    }, H.equals = function (t, e) {
      var r = t[0],
        n = t[1],
        i = t[2],
        s = e[0],
        a = e[1],
        o = e[2];
      return Math.abs(r - s) <= W.EPSILON * Math.max(1, Math.abs(r), Math.abs(s)) && Math.abs(n - a) <= W.EPSILON * Math.max(1, Math.abs(n), Math.abs(a)) && Math.abs(i - o) <= W.EPSILON * Math.max(1, Math.abs(i), Math.abs(o));
    }, H.forEach = H.sqrLen = H.len = H.sqrDist = H.dist = H.div = H.mul = H.sub = void 0;
    var W = function (t, e) {
      if (t && t.__esModule) return t;
      if (null === t || "object" !== K(t) && "function" != typeof t) return {
        default: t
      };
      var r = J(void 0);
      if (r && r.has(t)) return r.get(t);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var s in t) if ("default" !== s && Object.prototype.hasOwnProperty.call(t, s)) {
        var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
        a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
      }
      return n.default = t, r && r.set(t, n), n;
    }(d);
    function J(t) {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap(),
        r = new WeakMap();
      return (J = function J(t) {
        return t ? r : e;
      })(t);
    }
    function Q() {
      var t = new W.ARRAY_TYPE(3);
      return W.ARRAY_TYPE != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0), t;
    }
    function tt(t) {
      return Math.hypot(t[0], t[1], t[2]);
    }
    function et(t, e, r) {
      return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t;
    }
    function rt(t, e, r) {
      return t[0] = e[0] * r[0], t[1] = e[1] * r[1], t[2] = e[2] * r[2], t;
    }
    function nt(t, e, r) {
      return t[0] = e[0] / r[0], t[1] = e[1] / r[1], t[2] = e[2] / r[2], t;
    }
    function it(t, e) {
      return Math.hypot(e[0] - t[0], e[1] - t[1], e[2] - t[2]);
    }
    function st(t, e) {
      var r = e[0] - t[0],
        n = e[1] - t[1],
        i = e[2] - t[2];
      return r * r + n * n + i * i;
    }
    function at(t) {
      var e = t[0],
        r = t[1],
        n = t[2];
      return e * e + r * r + n * n;
    }
    function ot(t, e) {
      return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
    }
    H.sub = et, H.mul = rt, H.div = nt, H.dist = it, H.sqrDist = st, H.len = tt, H.sqrLen = at;
    var lt,
      ut = (lt = Q(), function (t, e, r, n, i, s) {
        var a, o;
        for (e || (e = 3), r || (r = 0), o = n ? Math.min(n * e + r, t.length) : t.length, a = r; a < o; a += e) lt[0] = t[a], lt[1] = t[a + 1], lt[2] = t[a + 2], i(lt, lt, s), t[a] = lt[0], t[a + 1] = lt[1], t[a + 2] = lt[2];
        return t;
      });
    H.forEach = ut;
    var ct = {};
    function ht(t) {
      return ht = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, ht(t);
    }
    Object.defineProperty(ct, "__esModule", {
      value: !0
    }), ct.create = dt, ct.clone = function (t) {
      var e = new pt.ARRAY_TYPE(4);
      return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e;
    }, ct.fromValues = function (t, e, r, n) {
      var i = new pt.ARRAY_TYPE(4);
      return i[0] = t, i[1] = e, i[2] = r, i[3] = n, i;
    }, ct.copy = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t;
    }, ct.set = function (t, e, r, n, i) {
      return t[0] = e, t[1] = r, t[2] = n, t[3] = i, t;
    }, ct.add = function (t, e, r) {
      return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t[3] = e[3] + r[3], t;
    }, ct.subtract = mt, ct.multiply = yt, ct.divide = gt, ct.ceil = function (t, e) {
      return t[0] = Math.ceil(e[0]), t[1] = Math.ceil(e[1]), t[2] = Math.ceil(e[2]), t[3] = Math.ceil(e[3]), t;
    }, ct.floor = function (t, e) {
      return t[0] = Math.floor(e[0]), t[1] = Math.floor(e[1]), t[2] = Math.floor(e[2]), t[3] = Math.floor(e[3]), t;
    }, ct.min = function (t, e, r) {
      return t[0] = Math.min(e[0], r[0]), t[1] = Math.min(e[1], r[1]), t[2] = Math.min(e[2], r[2]), t[3] = Math.min(e[3], r[3]), t;
    }, ct.max = function (t, e, r) {
      return t[0] = Math.max(e[0], r[0]), t[1] = Math.max(e[1], r[1]), t[2] = Math.max(e[2], r[2]), t[3] = Math.max(e[3], r[3]), t;
    }, ct.round = function (t, e) {
      return t[0] = Math.round(e[0]), t[1] = Math.round(e[1]), t[2] = Math.round(e[2]), t[3] = Math.round(e[3]), t;
    }, ct.scale = function (t, e, r) {
      return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t;
    }, ct.scaleAndAdd = function (t, e, r, n) {
      return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t[2] = e[2] + r[2] * n, t[3] = e[3] + r[3] * n, t;
    }, ct.distance = xt, ct.squaredDistance = bt, ct.length = vt, ct.squaredLength = _t, ct.negate = function (t, e) {
      return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t[3] = -e[3], t;
    }, ct.inverse = function (t, e) {
      return t[0] = 1 / e[0], t[1] = 1 / e[1], t[2] = 1 / e[2], t[3] = 1 / e[3], t;
    }, ct.normalize = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = r * r + n * n + i * i + s * s;
      return a > 0 && (a = 1 / Math.sqrt(a)), t[0] = r * a, t[1] = n * a, t[2] = i * a, t[3] = s * a, t;
    }, ct.dot = function (t, e) {
      return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3] * e[3];
    }, ct.cross = function (t, e, r, n) {
      var i = r[0] * n[1] - r[1] * n[0],
        s = r[0] * n[2] - r[2] * n[0],
        a = r[0] * n[3] - r[3] * n[0],
        o = r[1] * n[2] - r[2] * n[1],
        l = r[1] * n[3] - r[3] * n[1],
        u = r[2] * n[3] - r[3] * n[2],
        c = e[0],
        h = e[1],
        p = e[2],
        f = e[3];
      return t[0] = h * u - p * l + f * o, t[1] = -c * u + p * a - f * s, t[2] = c * l - h * a + f * i, t[3] = -c * o + h * s - p * i, t;
    }, ct.lerp = function (t, e, r, n) {
      var i = e[0],
        s = e[1],
        a = e[2],
        o = e[3];
      return t[0] = i + n * (r[0] - i), t[1] = s + n * (r[1] - s), t[2] = a + n * (r[2] - a), t[3] = o + n * (r[3] - o), t;
    }, ct.random = function (t, e) {
      var r, n, i, s, a, o;
      e = e || 1;
      do {
        a = (r = 2 * pt.RANDOM() - 1) * r + (n = 2 * pt.RANDOM() - 1) * n;
      } while (a >= 1);
      do {
        o = (i = 2 * pt.RANDOM() - 1) * i + (s = 2 * pt.RANDOM() - 1) * s;
      } while (o >= 1);
      var l = Math.sqrt((1 - a) / o);
      return t[0] = e * r, t[1] = e * n, t[2] = e * i * l, t[3] = e * s * l, t;
    }, ct.transformMat4 = function (t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3];
      return t[0] = r[0] * n + r[4] * i + r[8] * s + r[12] * a, t[1] = r[1] * n + r[5] * i + r[9] * s + r[13] * a, t[2] = r[2] * n + r[6] * i + r[10] * s + r[14] * a, t[3] = r[3] * n + r[7] * i + r[11] * s + r[15] * a, t;
    }, ct.transformQuat = function (t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = r[0],
        o = r[1],
        l = r[2],
        u = r[3],
        c = u * n + o * s - l * i,
        h = u * i + l * n - a * s,
        p = u * s + a * i - o * n,
        f = -a * n - o * i - l * s;
      return t[0] = c * u + f * -a + h * -l - p * -o, t[1] = h * u + f * -o + p * -a - c * -l, t[2] = p * u + f * -l + c * -o - h * -a, t[3] = e[3], t;
    }, ct.zero = function (t) {
      return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 0, t;
    }, ct.str = function (t) {
      return "vec4(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ")";
    }, ct.exactEquals = function (t, e) {
      return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3];
    }, ct.equals = function (t, e) {
      var r = t[0],
        n = t[1],
        i = t[2],
        s = t[3],
        a = e[0],
        o = e[1],
        l = e[2],
        u = e[3];
      return Math.abs(r - a) <= pt.EPSILON * Math.max(1, Math.abs(r), Math.abs(a)) && Math.abs(n - o) <= pt.EPSILON * Math.max(1, Math.abs(n), Math.abs(o)) && Math.abs(i - l) <= pt.EPSILON * Math.max(1, Math.abs(i), Math.abs(l)) && Math.abs(s - u) <= pt.EPSILON * Math.max(1, Math.abs(s), Math.abs(u));
    }, ct.forEach = ct.sqrLen = ct.len = ct.sqrDist = ct.dist = ct.div = ct.mul = ct.sub = void 0;
    var pt = function (t, e) {
      if (t && t.__esModule) return t;
      if (null === t || "object" !== ht(t) && "function" != typeof t) return {
        default: t
      };
      var r = ft(void 0);
      if (r && r.has(t)) return r.get(t);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var s in t) if ("default" !== s && Object.prototype.hasOwnProperty.call(t, s)) {
        var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
        a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
      }
      return n.default = t, r && r.set(t, n), n;
    }(d);
    function ft(t) {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap(),
        r = new WeakMap();
      return (ft = function ft(t) {
        return t ? r : e;
      })(t);
    }
    function dt() {
      var t = new pt.ARRAY_TYPE(4);
      return pt.ARRAY_TYPE != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 0), t;
    }
    function mt(t, e, r) {
      return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t[2] = e[2] - r[2], t[3] = e[3] - r[3], t;
    }
    function yt(t, e, r) {
      return t[0] = e[0] * r[0], t[1] = e[1] * r[1], t[2] = e[2] * r[2], t[3] = e[3] * r[3], t;
    }
    function gt(t, e, r) {
      return t[0] = e[0] / r[0], t[1] = e[1] / r[1], t[2] = e[2] / r[2], t[3] = e[3] / r[3], t;
    }
    function xt(t, e) {
      return Math.hypot(e[0] - t[0], e[1] - t[1], e[2] - t[2], e[3] - t[3]);
    }
    function bt(t, e) {
      var r = e[0] - t[0],
        n = e[1] - t[1],
        i = e[2] - t[2],
        s = e[3] - t[3];
      return r * r + n * n + i * i + s * s;
    }
    function vt(t) {
      return Math.hypot(t[0], t[1], t[2], t[3]);
    }
    function _t(t) {
      var e = t[0],
        r = t[1],
        n = t[2],
        i = t[3];
      return e * e + r * r + n * n + i * i;
    }
    ct.sub = mt, ct.mul = yt, ct.div = gt, ct.dist = xt, ct.sqrDist = bt, ct.len = vt, ct.sqrLen = _t;
    var wt = function () {
      var t = dt();
      return function (e, r, n, i, s, a) {
        var o, l;
        for (r || (r = 4), n || (n = 0), l = i ? Math.min(i * r + n, e.length) : e.length, o = n; o < l; o += r) t[0] = e[o], t[1] = e[o + 1], t[2] = e[o + 2], t[3] = e[o + 3], s(t, t, a), e[o] = t[0], e[o + 1] = t[1], e[o + 2] = t[2], e[o + 3] = t[3];
        return e;
      };
    }();
    function Mt(t) {
      return Mt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Mt(t);
    }
    ct.forEach = wt, Object.defineProperty(Z, "__esModule", {
      value: !0
    }), Z.create = zt, Z.identity = function (t) {
      return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 1, t;
    }, Z.setAxisAngle = Et, Z.getAxisAngle = function (t, e) {
      var r = 2 * Math.acos(e[3]),
        n = Math.sin(r / 2);
      return n > At.EPSILON ? (t[0] = e[0] / n, t[1] = e[1] / n, t[2] = e[2] / n) : (t[0] = 1, t[1] = 0, t[2] = 0), r;
    }, Z.getAngle = function (t, e) {
      var r = Ft(t, e);
      return Math.acos(2 * r * r - 1);
    }, Z.multiply = Bt, Z.rotateX = function (t, e, r) {
      r *= .5;
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = Math.sin(r),
        l = Math.cos(r);
      return t[0] = n * l + a * o, t[1] = i * l + s * o, t[2] = s * l - i * o, t[3] = a * l - n * o, t;
    }, Z.rotateY = function (t, e, r) {
      r *= .5;
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = Math.sin(r),
        l = Math.cos(r);
      return t[0] = n * l - s * o, t[1] = i * l + a * o, t[2] = s * l + n * o, t[3] = a * l - i * o, t;
    }, Z.rotateZ = function (t, e, r) {
      r *= .5;
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = Math.sin(r),
        l = Math.cos(r);
      return t[0] = n * l + i * o, t[1] = i * l - n * o, t[2] = s * l + a * o, t[3] = a * l - s * o, t;
    }, Z.calculateW = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2];
      return t[0] = r, t[1] = n, t[2] = i, t[3] = Math.sqrt(Math.abs(1 - r * r - n * n - i * i)), t;
    }, Z.exp = Dt, Z.ln = Rt, Z.pow = function (t, e, r) {
      return Rt(t, e), Vt(t, t, r), Dt(t, t), t;
    }, Z.slerp = Ct, Z.random = function (t) {
      var e = At.RANDOM(),
        r = At.RANDOM(),
        n = At.RANDOM(),
        i = Math.sqrt(1 - e),
        s = Math.sqrt(e);
      return t[0] = i * Math.sin(2 * Math.PI * r), t[1] = i * Math.cos(2 * Math.PI * r), t[2] = s * Math.sin(2 * Math.PI * n), t[3] = s * Math.cos(2 * Math.PI * n), t;
    }, Z.invert = function (t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = r * r + n * n + i * i + s * s,
        o = a ? 1 / a : 0;
      return t[0] = -r * o, t[1] = -n * o, t[2] = -i * o, t[3] = s * o, t;
    }, Z.conjugate = function (t, e) {
      return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t[3] = e[3], t;
    }, Z.fromMat3 = Lt, Z.fromEuler = function (t, e, r, n) {
      var i = .5 * Math.PI / 180;
      e *= i, r *= i, n *= i;
      var s = Math.sin(e),
        a = Math.cos(e),
        o = Math.sin(r),
        l = Math.cos(r),
        u = Math.sin(n),
        c = Math.cos(n);
      return t[0] = s * l * c - a * o * u, t[1] = a * o * c + s * l * u, t[2] = a * l * u - s * o * c, t[3] = a * l * c + s * o * u, t;
    }, Z.str = function (t) {
      return "quat(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ")";
    }, Z.setAxes = Z.sqlerp = Z.rotationTo = Z.equals = Z.exactEquals = Z.normalize = Z.sqrLen = Z.squaredLength = Z.len = Z.length = Z.lerp = Z.dot = Z.scale = Z.mul = Z.add = Z.set = Z.copy = Z.fromValues = Z.clone = void 0;
    var At = Pt(d),
      St = Pt(E),
      It = Pt(H),
      Tt = Pt(ct);
    function kt(t) {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap(),
        r = new WeakMap();
      return (kt = function kt(t) {
        return t ? r : e;
      })(t);
    }
    function Pt(t, e) {
      if (t && t.__esModule) return t;
      if (null === t || "object" !== Mt(t) && "function" != typeof t) return {
        default: t
      };
      var r = kt(e);
      if (r && r.has(t)) return r.get(t);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var s in t) if ("default" !== s && Object.prototype.hasOwnProperty.call(t, s)) {
        var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
        a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
      }
      return n.default = t, r && r.set(t, n), n;
    }
    function zt() {
      var t = new At.ARRAY_TYPE(4);
      return At.ARRAY_TYPE != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0), t[3] = 1, t;
    }
    function Et(t, e, r) {
      r *= .5;
      var n = Math.sin(r);
      return t[0] = n * e[0], t[1] = n * e[1], t[2] = n * e[2], t[3] = Math.cos(r), t;
    }
    function Bt(t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = r[0],
        l = r[1],
        u = r[2],
        c = r[3];
      return t[0] = n * c + a * o + i * u - s * l, t[1] = i * c + a * l + s * o - n * u, t[2] = s * c + a * u + n * l - i * o, t[3] = a * c - n * o - i * l - s * u, t;
    }
    function Dt(t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = Math.sqrt(r * r + n * n + i * i),
        o = Math.exp(s),
        l = a > 0 ? o * Math.sin(a) / a : 0;
      return t[0] = r * l, t[1] = n * l, t[2] = i * l, t[3] = o * Math.cos(a), t;
    }
    function Rt(t, e) {
      var r = e[0],
        n = e[1],
        i = e[2],
        s = e[3],
        a = Math.sqrt(r * r + n * n + i * i),
        o = a > 0 ? Math.atan2(a, s) / a : 0;
      return t[0] = r * o, t[1] = n * o, t[2] = i * o, t[3] = .5 * Math.log(r * r + n * n + i * i + s * s), t;
    }
    function Ct(t, e, r, n) {
      var i,
        s,
        a,
        o,
        l,
        u = e[0],
        c = e[1],
        h = e[2],
        p = e[3],
        f = r[0],
        d = r[1],
        m = r[2],
        y = r[3];
      return (s = u * f + c * d + h * m + p * y) < 0 && (s = -s, f = -f, d = -d, m = -m, y = -y), 1 - s > At.EPSILON ? (i = Math.acos(s), a = Math.sin(i), o = Math.sin((1 - n) * i) / a, l = Math.sin(n * i) / a) : (o = 1 - n, l = n), t[0] = o * u + l * f, t[1] = o * c + l * d, t[2] = o * h + l * m, t[3] = o * p + l * y, t;
    }
    function Lt(t, e) {
      var r,
        n = e[0] + e[4] + e[8];
      if (n > 0) r = Math.sqrt(n + 1), t[3] = .5 * r, t[0] = (e[5] - e[7]) * (r = .5 / r), t[1] = (e[6] - e[2]) * r, t[2] = (e[1] - e[3]) * r;else {
        var i = 0;
        e[4] > e[0] && (i = 1), e[8] > e[3 * i + i] && (i = 2);
        var s = (i + 1) % 3,
          a = (i + 2) % 3;
        r = Math.sqrt(e[3 * i + i] - e[3 * s + s] - e[3 * a + a] + 1), t[i] = .5 * r, t[3] = (e[3 * s + a] - e[3 * a + s]) * (r = .5 / r), t[s] = (e[3 * s + i] + e[3 * i + s]) * r, t[a] = (e[3 * a + i] + e[3 * i + a]) * r;
      }
      return t;
    }
    Z.clone = Tt.clone, Z.fromValues = Tt.fromValues, Z.copy = Tt.copy, Z.set = Tt.set, Z.add = Tt.add, Z.mul = Bt;
    var Vt = Tt.scale;
    Z.scale = Vt;
    var Ft = Tt.dot;
    Z.dot = Ft, Z.lerp = Tt.lerp;
    var Ot = Tt.length;
    Z.length = Ot, Z.len = Ot;
    var Ut = Tt.squaredLength;
    Z.squaredLength = Ut, Z.sqrLen = Ut;
    var jt = Tt.normalize;
    Z.normalize = jt, Z.exactEquals = Tt.exactEquals, Z.equals = Tt.equals;
    var Nt,
      $t,
      qt,
      Gt = (Nt = It.create(), $t = It.fromValues(1, 0, 0), qt = It.fromValues(0, 1, 0), function (t, e, r) {
        var n = It.dot(e, r);
        return n < -.999999 ? (It.cross(Nt, $t, e), It.len(Nt) < 1e-6 && It.cross(Nt, qt, e), It.normalize(Nt, Nt), Et(t, Nt, Math.PI), t) : n > .999999 ? (t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 1, t) : (It.cross(Nt, e, r), t[0] = Nt[0], t[1] = Nt[1], t[2] = Nt[2], t[3] = 1 + n, jt(t, t));
      });
    Z.rotationTo = Gt;
    var Xt,
      Yt,
      Zt = (Xt = zt(), Yt = zt(), function (t, e, r, n, i, s) {
        return Ct(Xt, e, i, s), Ct(Yt, r, n, s), Ct(t, Xt, Yt, 2 * s * (1 - s)), t;
      });
    Z.sqlerp = Zt;
    var Ht,
      Kt = (Ht = St.create(), function (t, e, r, n) {
        return Ht[0] = r[0], Ht[3] = r[1], Ht[6] = r[2], Ht[1] = n[0], Ht[4] = n[1], Ht[7] = n[2], Ht[2] = -e[0], Ht[5] = -e[1], Ht[8] = -e[2], jt(t, Lt(t, Ht));
      });
    Z.setAxes = Kt;
    var Wt = {};
    function Jt(t) {
      return Jt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Jt(t);
    }
    Object.defineProperty(Wt, "__esModule", {
      value: !0
    }), Wt.create = function () {
      var t = new Qt.ARRAY_TYPE(8);
      return Qt.ARRAY_TYPE != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0, t[4] = 0, t[5] = 0, t[6] = 0, t[7] = 0), t[3] = 1, t;
    }, Wt.clone = function (t) {
      var e = new Qt.ARRAY_TYPE(8);
      return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e;
    }, Wt.fromValues = function (t, e, r, n, i, s, a, o) {
      var l = new Qt.ARRAY_TYPE(8);
      return l[0] = t, l[1] = e, l[2] = r, l[3] = n, l[4] = i, l[5] = s, l[6] = a, l[7] = o, l;
    }, Wt.fromRotationTranslationValues = function (t, e, r, n, i, s, a) {
      var o = new Qt.ARRAY_TYPE(8);
      o[0] = t, o[1] = e, o[2] = r, o[3] = n;
      var l = .5 * i,
        u = .5 * s,
        c = .5 * a;
      return o[4] = l * n + u * r - c * e, o[5] = u * n + c * t - l * r, o[6] = c * n + l * e - u * t, o[7] = -l * t - u * e - c * r, o;
    }, Wt.fromRotationTranslation = ie, Wt.fromTranslation = function (t, e) {
      return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 1, t[4] = .5 * e[0], t[5] = .5 * e[1], t[6] = .5 * e[2], t[7] = 0, t;
    }, Wt.fromRotation = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = 0, t[5] = 0, t[6] = 0, t[7] = 0, t;
    }, Wt.fromMat4 = function (t, e) {
      var r = te.create();
      ee.getRotation(r, e);
      var n = new Qt.ARRAY_TYPE(3);
      return ee.getTranslation(n, e), ie(t, r, n), t;
    }, Wt.copy = se, Wt.identity = function (t) {
      return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 1, t[4] = 0, t[5] = 0, t[6] = 0, t[7] = 0, t;
    }, Wt.set = function (t, e, r, n, i, s, a, o, l) {
      return t[0] = e, t[1] = r, t[2] = n, t[3] = i, t[4] = s, t[5] = a, t[6] = o, t[7] = l, t;
    }, Wt.getDual = function (t, e) {
      return t[0] = e[4], t[1] = e[5], t[2] = e[6], t[3] = e[7], t;
    }, Wt.setDual = function (t, e) {
      return t[4] = e[0], t[5] = e[1], t[6] = e[2], t[7] = e[3], t;
    }, Wt.getTranslation = function (t, e) {
      var r = e[4],
        n = e[5],
        i = e[6],
        s = e[7],
        a = -e[0],
        o = -e[1],
        l = -e[2],
        u = e[3];
      return t[0] = 2 * (r * u + s * a + n * l - i * o), t[1] = 2 * (n * u + s * o + i * a - r * l), t[2] = 2 * (i * u + s * l + r * o - n * a), t;
    }, Wt.translate = function (t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = .5 * r[0],
        l = .5 * r[1],
        u = .5 * r[2],
        c = e[4],
        h = e[5],
        p = e[6],
        f = e[7];
      return t[0] = n, t[1] = i, t[2] = s, t[3] = a, t[4] = a * o + i * u - s * l + c, t[5] = a * l + s * o - n * u + h, t[6] = a * u + n * l - i * o + p, t[7] = -n * o - i * l - s * u + f, t;
    }, Wt.rotateX = function (t, e, r) {
      var n = -e[0],
        i = -e[1],
        s = -e[2],
        a = e[3],
        o = e[4],
        l = e[5],
        u = e[6],
        c = e[7],
        h = o * a + c * n + l * s - u * i,
        p = l * a + c * i + u * n - o * s,
        f = u * a + c * s + o * i - l * n,
        d = c * a - o * n - l * i - u * s;
      return te.rotateX(t, e, r), t[4] = h * (a = t[3]) + d * (n = t[0]) + p * (s = t[2]) - f * (i = t[1]), t[5] = p * a + d * i + f * n - h * s, t[6] = f * a + d * s + h * i - p * n, t[7] = d * a - h * n - p * i - f * s, t;
    }, Wt.rotateY = function (t, e, r) {
      var n = -e[0],
        i = -e[1],
        s = -e[2],
        a = e[3],
        o = e[4],
        l = e[5],
        u = e[6],
        c = e[7],
        h = o * a + c * n + l * s - u * i,
        p = l * a + c * i + u * n - o * s,
        f = u * a + c * s + o * i - l * n,
        d = c * a - o * n - l * i - u * s;
      return te.rotateY(t, e, r), t[4] = h * (a = t[3]) + d * (n = t[0]) + p * (s = t[2]) - f * (i = t[1]), t[5] = p * a + d * i + f * n - h * s, t[6] = f * a + d * s + h * i - p * n, t[7] = d * a - h * n - p * i - f * s, t;
    }, Wt.rotateZ = function (t, e, r) {
      var n = -e[0],
        i = -e[1],
        s = -e[2],
        a = e[3],
        o = e[4],
        l = e[5],
        u = e[6],
        c = e[7],
        h = o * a + c * n + l * s - u * i,
        p = l * a + c * i + u * n - o * s,
        f = u * a + c * s + o * i - l * n,
        d = c * a - o * n - l * i - u * s;
      return te.rotateZ(t, e, r), t[4] = h * (a = t[3]) + d * (n = t[0]) + p * (s = t[2]) - f * (i = t[1]), t[5] = p * a + d * i + f * n - h * s, t[6] = f * a + d * s + h * i - p * n, t[7] = d * a - h * n - p * i - f * s, t;
    }, Wt.rotateByQuatAppend = function (t, e, r) {
      var n = r[0],
        i = r[1],
        s = r[2],
        a = r[3],
        o = e[0],
        l = e[1],
        u = e[2],
        c = e[3];
      return t[0] = o * a + c * n + l * s - u * i, t[1] = l * a + c * i + u * n - o * s, t[2] = u * a + c * s + o * i - l * n, t[3] = c * a - o * n - l * i - u * s, t[4] = (o = e[4]) * a + (c = e[7]) * n + (l = e[5]) * s - (u = e[6]) * i, t[5] = l * a + c * i + u * n - o * s, t[6] = u * a + c * s + o * i - l * n, t[7] = c * a - o * n - l * i - u * s, t;
    }, Wt.rotateByQuatPrepend = function (t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = r[0],
        l = r[1],
        u = r[2],
        c = r[3];
      return t[0] = n * c + a * o + i * u - s * l, t[1] = i * c + a * l + s * o - n * u, t[2] = s * c + a * u + n * l - i * o, t[3] = a * c - n * o - i * l - s * u, t[4] = n * (c = r[7]) + a * (o = r[4]) + i * (u = r[6]) - s * (l = r[5]), t[5] = i * c + a * l + s * o - n * u, t[6] = s * c + a * u + n * l - i * o, t[7] = a * c - n * o - i * l - s * u, t;
    }, Wt.rotateAroundAxis = function (t, e, r, n) {
      if (Math.abs(n) < Qt.EPSILON) return se(t, e);
      var i = Math.hypot(r[0], r[1], r[2]);
      n *= .5;
      var s = Math.sin(n),
        a = s * r[0] / i,
        o = s * r[1] / i,
        l = s * r[2] / i,
        u = Math.cos(n),
        c = e[0],
        h = e[1],
        p = e[2],
        f = e[3];
      t[0] = c * u + f * a + h * l - p * o, t[1] = h * u + f * o + p * a - c * l, t[2] = p * u + f * l + c * o - h * a, t[3] = f * u - c * a - h * o - p * l;
      var d = e[4],
        m = e[5],
        y = e[6],
        g = e[7];
      return t[4] = d * u + g * a + m * l - y * o, t[5] = m * u + g * o + y * a - d * l, t[6] = y * u + g * l + d * o - m * a, t[7] = g * u - d * a - m * o - y * l, t;
    }, Wt.add = function (t, e, r) {
      return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t[2] = e[2] + r[2], t[3] = e[3] + r[3], t[4] = e[4] + r[4], t[5] = e[5] + r[5], t[6] = e[6] + r[6], t[7] = e[7] + r[7], t;
    }, Wt.multiply = ae, Wt.scale = function (t, e, r) {
      return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t[4] = e[4] * r, t[5] = e[5] * r, t[6] = e[6] * r, t[7] = e[7] * r, t;
    }, Wt.lerp = function (t, e, r, n) {
      var i = 1 - n;
      return oe(e, r) < 0 && (n = -n), t[0] = e[0] * i + r[0] * n, t[1] = e[1] * i + r[1] * n, t[2] = e[2] * i + r[2] * n, t[3] = e[3] * i + r[3] * n, t[4] = e[4] * i + r[4] * n, t[5] = e[5] * i + r[5] * n, t[6] = e[6] * i + r[6] * n, t[7] = e[7] * i + r[7] * n, t;
    }, Wt.invert = function (t, e) {
      var r = ue(e);
      return t[0] = -e[0] / r, t[1] = -e[1] / r, t[2] = -e[2] / r, t[3] = e[3] / r, t[4] = -e[4] / r, t[5] = -e[5] / r, t[6] = -e[6] / r, t[7] = e[7] / r, t;
    }, Wt.conjugate = function (t, e) {
      return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t[3] = e[3], t[4] = -e[4], t[5] = -e[5], t[6] = -e[6], t[7] = e[7], t;
    }, Wt.normalize = function (t, e) {
      var r = ue(e);
      if (r > 0) {
        r = Math.sqrt(r);
        var n = e[0] / r,
          i = e[1] / r,
          s = e[2] / r,
          a = e[3] / r,
          o = e[4],
          l = e[5],
          u = e[6],
          c = e[7],
          h = n * o + i * l + s * u + a * c;
        t[0] = n, t[1] = i, t[2] = s, t[3] = a, t[4] = (o - n * h) / r, t[5] = (l - i * h) / r, t[6] = (u - s * h) / r, t[7] = (c - a * h) / r;
      }
      return t;
    }, Wt.str = function (t) {
      return "quat2(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ", " + t[4] + ", " + t[5] + ", " + t[6] + ", " + t[7] + ")";
    }, Wt.exactEquals = function (t, e) {
      return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3] && t[4] === e[4] && t[5] === e[5] && t[6] === e[6] && t[7] === e[7];
    }, Wt.equals = function (t, e) {
      var r = t[0],
        n = t[1],
        i = t[2],
        s = t[3],
        a = t[4],
        o = t[5],
        l = t[6],
        u = t[7],
        c = e[0],
        h = e[1],
        p = e[2],
        f = e[3],
        d = e[4],
        m = e[5],
        y = e[6],
        g = e[7];
      return Math.abs(r - c) <= Qt.EPSILON * Math.max(1, Math.abs(r), Math.abs(c)) && Math.abs(n - h) <= Qt.EPSILON * Math.max(1, Math.abs(n), Math.abs(h)) && Math.abs(i - p) <= Qt.EPSILON * Math.max(1, Math.abs(i), Math.abs(p)) && Math.abs(s - f) <= Qt.EPSILON * Math.max(1, Math.abs(s), Math.abs(f)) && Math.abs(a - d) <= Qt.EPSILON * Math.max(1, Math.abs(a), Math.abs(d)) && Math.abs(o - m) <= Qt.EPSILON * Math.max(1, Math.abs(o), Math.abs(m)) && Math.abs(l - y) <= Qt.EPSILON * Math.max(1, Math.abs(l), Math.abs(y)) && Math.abs(u - g) <= Qt.EPSILON * Math.max(1, Math.abs(u), Math.abs(g));
    }, Wt.sqrLen = Wt.squaredLength = Wt.len = Wt.length = Wt.dot = Wt.mul = Wt.setReal = Wt.getReal = void 0;
    var Qt = ne(d),
      te = ne(Z),
      ee = ne(V);
    function re(t) {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap(),
        r = new WeakMap();
      return (re = function re(t) {
        return t ? r : e;
      })(t);
    }
    function ne(t, e) {
      if (t && t.__esModule) return t;
      if (null === t || "object" !== Jt(t) && "function" != typeof t) return {
        default: t
      };
      var r = re(e);
      if (r && r.has(t)) return r.get(t);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var s in t) if ("default" !== s && Object.prototype.hasOwnProperty.call(t, s)) {
        var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
        a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
      }
      return n.default = t, r && r.set(t, n), n;
    }
    function ie(t, e, r) {
      var n = .5 * r[0],
        i = .5 * r[1],
        s = .5 * r[2],
        a = e[0],
        o = e[1],
        l = e[2],
        u = e[3];
      return t[0] = a, t[1] = o, t[2] = l, t[3] = u, t[4] = n * u + i * l - s * o, t[5] = i * u + s * a - n * l, t[6] = s * u + n * o - i * a, t[7] = -n * a - i * o - s * l, t;
    }
    function se(t, e) {
      return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t;
    }
    function ae(t, e, r) {
      var n = e[0],
        i = e[1],
        s = e[2],
        a = e[3],
        o = r[4],
        l = r[5],
        u = r[6],
        c = r[7],
        h = e[4],
        p = e[5],
        f = e[6],
        d = e[7],
        m = r[0],
        y = r[1],
        g = r[2],
        x = r[3];
      return t[0] = n * x + a * m + i * g - s * y, t[1] = i * x + a * y + s * m - n * g, t[2] = s * x + a * g + n * y - i * m, t[3] = a * x - n * m - i * y - s * g, t[4] = n * c + a * o + i * u - s * l + h * x + d * m + p * g - f * y, t[5] = i * c + a * l + s * o - n * u + p * x + d * y + f * m - h * g, t[6] = s * c + a * u + n * l - i * o + f * x + d * g + h * y - p * m, t[7] = a * c - n * o - i * l - s * u + d * x - h * m - p * y - f * g, t;
    }
    Wt.getReal = te.copy, Wt.setReal = te.copy, Wt.mul = ae;
    var oe = te.dot;
    Wt.dot = oe;
    var le = te.length;
    Wt.length = le, Wt.len = le;
    var ue = te.squaredLength;
    Wt.squaredLength = ue, Wt.sqrLen = ue;
    var ce = {};
    function he(t) {
      return he = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, he(t);
    }
    Object.defineProperty(ce, "__esModule", {
      value: !0
    }), ce.create = de, ce.clone = function (t) {
      var e = new pe.ARRAY_TYPE(2);
      return e[0] = t[0], e[1] = t[1], e;
    }, ce.fromValues = function (t, e) {
      var r = new pe.ARRAY_TYPE(2);
      return r[0] = t, r[1] = e, r;
    }, ce.copy = function (t, e) {
      return t[0] = e[0], t[1] = e[1], t;
    }, ce.set = function (t, e, r) {
      return t[0] = e, t[1] = r, t;
    }, ce.add = function (t, e, r) {
      return t[0] = e[0] + r[0], t[1] = e[1] + r[1], t;
    }, ce.subtract = me, ce.multiply = ye, ce.divide = ge, ce.ceil = function (t, e) {
      return t[0] = Math.ceil(e[0]), t[1] = Math.ceil(e[1]), t;
    }, ce.floor = function (t, e) {
      return t[0] = Math.floor(e[0]), t[1] = Math.floor(e[1]), t;
    }, ce.min = function (t, e, r) {
      return t[0] = Math.min(e[0], r[0]), t[1] = Math.min(e[1], r[1]), t;
    }, ce.max = function (t, e, r) {
      return t[0] = Math.max(e[0], r[0]), t[1] = Math.max(e[1], r[1]), t;
    }, ce.round = function (t, e) {
      return t[0] = Math.round(e[0]), t[1] = Math.round(e[1]), t;
    }, ce.scale = function (t, e, r) {
      return t[0] = e[0] * r, t[1] = e[1] * r, t;
    }, ce.scaleAndAdd = function (t, e, r, n) {
      return t[0] = e[0] + r[0] * n, t[1] = e[1] + r[1] * n, t;
    }, ce.distance = xe, ce.squaredDistance = be, ce.length = ve, ce.squaredLength = _e, ce.negate = function (t, e) {
      return t[0] = -e[0], t[1] = -e[1], t;
    }, ce.inverse = function (t, e) {
      return t[0] = 1 / e[0], t[1] = 1 / e[1], t;
    }, ce.normalize = function (t, e) {
      var r = e[0],
        n = e[1],
        i = r * r + n * n;
      return i > 0 && (i = 1 / Math.sqrt(i)), t[0] = e[0] * i, t[1] = e[1] * i, t;
    }, ce.dot = function (t, e) {
      return t[0] * e[0] + t[1] * e[1];
    }, ce.cross = function (t, e, r) {
      var n = e[0] * r[1] - e[1] * r[0];
      return t[0] = t[1] = 0, t[2] = n, t;
    }, ce.lerp = function (t, e, r, n) {
      var i = e[0],
        s = e[1];
      return t[0] = i + n * (r[0] - i), t[1] = s + n * (r[1] - s), t;
    }, ce.random = function (t, e) {
      e = e || 1;
      var r = 2 * pe.RANDOM() * Math.PI;
      return t[0] = Math.cos(r) * e, t[1] = Math.sin(r) * e, t;
    }, ce.transformMat2 = function (t, e, r) {
      var n = e[0],
        i = e[1];
      return t[0] = r[0] * n + r[2] * i, t[1] = r[1] * n + r[3] * i, t;
    }, ce.transformMat2d = function (t, e, r) {
      var n = e[0],
        i = e[1];
      return t[0] = r[0] * n + r[2] * i + r[4], t[1] = r[1] * n + r[3] * i + r[5], t;
    }, ce.transformMat3 = function (t, e, r) {
      var n = e[0],
        i = e[1];
      return t[0] = r[0] * n + r[3] * i + r[6], t[1] = r[1] * n + r[4] * i + r[7], t;
    }, ce.transformMat4 = function (t, e, r) {
      var n = e[0],
        i = e[1];
      return t[0] = r[0] * n + r[4] * i + r[12], t[1] = r[1] * n + r[5] * i + r[13], t;
    }, ce.rotate = function (t, e, r, n) {
      var i = e[0] - r[0],
        s = e[1] - r[1],
        a = Math.sin(n),
        o = Math.cos(n);
      return t[0] = i * o - s * a + r[0], t[1] = i * a + s * o + r[1], t;
    }, ce.angle = function (t, e) {
      var r = t[0],
        n = t[1],
        i = e[0],
        s = e[1],
        a = Math.sqrt(r * r + n * n) * Math.sqrt(i * i + s * s);
      return Math.acos(Math.min(Math.max(a && (r * i + n * s) / a, -1), 1));
    }, ce.zero = function (t) {
      return t[0] = 0, t[1] = 0, t;
    }, ce.str = function (t) {
      return "vec2(" + t[0] + ", " + t[1] + ")";
    }, ce.exactEquals = function (t, e) {
      return t[0] === e[0] && t[1] === e[1];
    }, ce.equals = function (t, e) {
      var r = t[0],
        n = t[1],
        i = e[0],
        s = e[1];
      return Math.abs(r - i) <= pe.EPSILON * Math.max(1, Math.abs(r), Math.abs(i)) && Math.abs(n - s) <= pe.EPSILON * Math.max(1, Math.abs(n), Math.abs(s));
    }, ce.forEach = ce.sqrLen = ce.sqrDist = ce.dist = ce.div = ce.mul = ce.sub = ce.len = void 0;
    var pe = function (t, e) {
      if (t && t.__esModule) return t;
      if (null === t || "object" !== he(t) && "function" != typeof t) return {
        default: t
      };
      var r = fe(void 0);
      if (r && r.has(t)) return r.get(t);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var s in t) if ("default" !== s && Object.prototype.hasOwnProperty.call(t, s)) {
        var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
        a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
      }
      return n.default = t, r && r.set(t, n), n;
    }(d);
    function fe(t) {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap(),
        r = new WeakMap();
      return (fe = function fe(t) {
        return t ? r : e;
      })(t);
    }
    function de() {
      var t = new pe.ARRAY_TYPE(2);
      return pe.ARRAY_TYPE != Float32Array && (t[0] = 0, t[1] = 0), t;
    }
    function me(t, e, r) {
      return t[0] = e[0] - r[0], t[1] = e[1] - r[1], t;
    }
    function ye(t, e, r) {
      return t[0] = e[0] * r[0], t[1] = e[1] * r[1], t;
    }
    function ge(t, e, r) {
      return t[0] = e[0] / r[0], t[1] = e[1] / r[1], t;
    }
    function xe(t, e) {
      return Math.hypot(e[0] - t[0], e[1] - t[1]);
    }
    function be(t, e) {
      var r = e[0] - t[0],
        n = e[1] - t[1];
      return r * r + n * n;
    }
    function ve(t) {
      return Math.hypot(t[0], t[1]);
    }
    function _e(t) {
      var e = t[0],
        r = t[1];
      return e * e + r * r;
    }
    ce.len = ve, ce.sub = me, ce.mul = ye, ce.div = ge, ce.dist = xe, ce.sqrDist = be, ce.sqrLen = _e;
    var we = function () {
      var t = de();
      return function (e, r, n, i, s, a) {
        var o, l;
        for (r || (r = 2), n || (n = 0), l = i ? Math.min(i * r + n, e.length) : e.length, o = n; o < l; o += r) t[0] = e[o], t[1] = e[o + 1], s(t, t, a), e[o] = t[0], e[o + 1] = t[1];
        return e;
      };
    }();
    function Me(t) {
      return Me = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, Me(t);
    }
    ce.forEach = we, Object.defineProperty(f, "__esModule", {
      value: !0
    }), t.aB = f.vec4 = t.$ = f.vec3 = f.vec2 = f.quat2 = t.aw = f.quat = t.ae = f.mat4 = t.bE = f.mat3 = f.mat2d = t.aD = f.mat2 = f.glMatrix = void 0;
    var Ae = Ce(d);
    f.glMatrix = Ae;
    var Se = Ce(b);
    t.aD = f.mat2 = Se;
    var Ie = Ce(S);
    f.mat2d = Ie;
    var Te = Ce(E);
    t.bE = f.mat3 = Te;
    var ke = Ce(V);
    t.ae = f.mat4 = ke;
    var Pe = Ce(Z);
    t.aw = f.quat = Pe;
    var ze = Ce(Wt);
    f.quat2 = ze;
    var Ee = Ce(ce);
    f.vec2 = Ee;
    var Be = Ce(H);
    t.$ = f.vec3 = Be;
    var De = Ce(ct);
    function Re(t) {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap(),
        r = new WeakMap();
      return (Re = function Re(t) {
        return t ? r : e;
      })(t);
    }
    function Ce(t, e) {
      if (t && t.__esModule) return t;
      if (null === t || "object" !== Me(t) && "function" != typeof t) return {
        default: t
      };
      var r = Re(e);
      if (r && r.has(t)) return r.get(t);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var s in t) if ("default" !== s && Object.prototype.hasOwnProperty.call(t, s)) {
        var a = i ? Object.getOwnPropertyDescriptor(t, s) : null;
        a && (a.get || a.set) ? Object.defineProperty(n, s, a) : n[s] = t[s];
      }
      return n.default = t, r && r.set(t, n), n;
    }
    t.aB = f.vec4 = De;
    var Le = Ve;
    function Ve(t, e, r, n) {
      this.cx = 3 * t, this.bx = 3 * (r - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e, this.by = 3 * (n - e) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t, this.p1y = e, this.p2x = r, this.p2y = n;
    }
    Ve.prototype = {
      sampleCurveX: function sampleCurveX(t) {
        return ((this.ax * t + this.bx) * t + this.cx) * t;
      },
      sampleCurveY: function sampleCurveY(t) {
        return ((this.ay * t + this.by) * t + this.cy) * t;
      },
      sampleCurveDerivativeX: function sampleCurveDerivativeX(t) {
        return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
      },
      solveCurveX: function solveCurveX(t, e) {
        if (void 0 === e && (e = 1e-6), t < 0) return 0;
        if (t > 1) return 1;
        for (var r = t, n = 0; n < 8; n++) {
          var i = this.sampleCurveX(r) - t;
          if (Math.abs(i) < e) return r;
          var s = this.sampleCurveDerivativeX(r);
          if (Math.abs(s) < 1e-6) break;
          r -= i / s;
        }
        var a = 0,
          o = 1;
        for (r = t, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t) < e)); n++) t > i ? a = r : o = r, r = .5 * (o - a) + a;
        return r;
      },
      solve: function solve(t, e) {
        return this.sampleCurveY(this.solveCurveX(t, e));
      }
    };
    var Fe = p(Le),
      Oe = Ue;
    function Ue(t, e) {
      this.x = t, this.y = e;
    }
    Ue.prototype = {
      clone: function clone() {
        return new Ue(this.x, this.y);
      },
      add: function add(t) {
        return this.clone()._add(t);
      },
      sub: function sub(t) {
        return this.clone()._sub(t);
      },
      multByPoint: function multByPoint(t) {
        return this.clone()._multByPoint(t);
      },
      divByPoint: function divByPoint(t) {
        return this.clone()._divByPoint(t);
      },
      mult: function mult(t) {
        return this.clone()._mult(t);
      },
      div: function div(t) {
        return this.clone()._div(t);
      },
      rotate: function rotate(t) {
        return this.clone()._rotate(t);
      },
      rotateAround: function rotateAround(t, e) {
        return this.clone()._rotateAround(t, e);
      },
      matMult: function matMult(t) {
        return this.clone()._matMult(t);
      },
      unit: function unit() {
        return this.clone()._unit();
      },
      perp: function perp() {
        return this.clone()._perp();
      },
      round: function round() {
        return this.clone()._round();
      },
      mag: function mag() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      },
      equals: function equals(t) {
        return this.x === t.x && this.y === t.y;
      },
      dist: function dist(t) {
        return Math.sqrt(this.distSqr(t));
      },
      distSqr: function distSqr(t) {
        var e = t.x - this.x,
          r = t.y - this.y;
        return e * e + r * r;
      },
      angle: function angle() {
        return Math.atan2(this.y, this.x);
      },
      angleTo: function angleTo(t) {
        return Math.atan2(this.y - t.y, this.x - t.x);
      },
      angleWith: function angleWith(t) {
        return this.angleWithSep(t.x, t.y);
      },
      angleWithSep: function angleWithSep(t, e) {
        return Math.atan2(this.x * e - this.y * t, this.x * t + this.y * e);
      },
      _matMult: function _matMult(t) {
        var e = t[2] * this.x + t[3] * this.y;
        return this.x = t[0] * this.x + t[1] * this.y, this.y = e, this;
      },
      _add: function _add(t) {
        return this.x += t.x, this.y += t.y, this;
      },
      _sub: function _sub(t) {
        return this.x -= t.x, this.y -= t.y, this;
      },
      _mult: function _mult(t) {
        return this.x *= t, this.y *= t, this;
      },
      _div: function _div(t) {
        return this.x /= t, this.y /= t, this;
      },
      _multByPoint: function _multByPoint(t) {
        return this.x *= t.x, this.y *= t.y, this;
      },
      _divByPoint: function _divByPoint(t) {
        return this.x /= t.x, this.y /= t.y, this;
      },
      _unit: function _unit() {
        return this._div(this.mag()), this;
      },
      _perp: function _perp() {
        var t = this.y;
        return this.y = this.x, this.x = -t, this;
      },
      _rotate: function _rotate(t) {
        var e = Math.cos(t),
          r = Math.sin(t),
          n = r * this.x + e * this.y;
        return this.x = e * this.x - r * this.y, this.y = n, this;
      },
      _rotateAround: function _rotateAround(t, e) {
        var r = Math.cos(t),
          n = Math.sin(t),
          i = e.y + n * (this.x - e.x) + r * (this.y - e.y);
        return this.x = e.x + r * (this.x - e.x) - n * (this.y - e.y), this.y = i, this;
      },
      _round: function _round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
      }
    }, Ue.convert = function (t) {
      return t instanceof Ue ? t : Array.isArray(t) ? new Ue(t[0], t[1]) : t;
    };
    var je = p(Oe);
    function Ne(t, e) {
      if (Array.isArray(t)) {
        if (!Array.isArray(e) || t.length !== e.length) return !1;
        for (var _r2 = 0; _r2 < t.length; _r2++) if (!Ne(t[_r2], e[_r2])) return !1;
        return !0;
      }
      if ("object" == typeof t && null !== t && null !== e) {
        if ("object" != typeof e) return !1;
        if (Object.keys(t).length !== Object.keys(e).length) return !1;
        for (var _r3 in t) if (!Ne(t[_r3], e[_r3])) return !1;
        return !0;
      }
      return t === e;
    }
    var $e = Math.PI / 180,
      qe = 180 / Math.PI;
    function Ge(t) {
      return t * $e;
    }
    function Xe(t) {
      return t * qe;
    }
    var Ye = [[0, 0], [1, 0], [1, 1], [0, 1]];
    function Ze(t) {
      if (t <= 0) return 0;
      if (t >= 1) return 1;
      var e = t * t,
        r = e * t;
      return 4 * (t < .5 ? r : 3 * (t - e) + r - .75);
    }
    function He(t, e, r, n) {
      var i = new Fe(t, e, r, n);
      return function (t) {
        return i.solve(t);
      };
    }
    var Ke = He(.25, .1, .25, 1);
    function We(t, e, r) {
      return Math.min(r, Math.max(e, t));
    }
    function Je(t, e, r) {
      return (r = We((r - t) / (e - t), 0, 1)) * r * (3 - 2 * r);
    }
    function Qe(t, e, r) {
      var n = r - e,
        i = ((t - e) % n + n) % n + e;
      return i === e ? r : i;
    }
    function tr(t, e, r) {
      if (!t.length) return r(null, []);
      var n = t.length;
      var i = new Array(t.length);
      var s = null;
      t.forEach(function (t, a) {
        e(t, function (t, e) {
          t && (s = t), i[a] = e, 0 == --n && r(s, i);
        });
      });
    }
    function er(t) {
      var e = [];
      for (var _r4 in t) e.push(t[_r4]);
      return e;
    }
    function rr(t) {
      for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        e[_key - 1] = arguments[_key];
      }
      for (var _i2 = 0, _e2 = e; _i2 < _e2.length; _i2++) {
        var _r5 = _e2[_i2];
        for (var _e3 in _r5) t[_e3] = _r5[_e3];
      }
      return t;
    }
    var nr = 1;
    function ir() {
      return nr++;
    }
    function sr() {
      return function t(e) {
        return e ? (e ^ Math.random() * (16 >> e / 4)).toString(16) : ([1e7] + -[1e3] + -4e3 + -8e3 + -1e11).replace(/[018]/g, t);
      }();
    }
    function ar(t) {
      return t <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
    }
    function or(t) {
      return !!t && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t);
    }
    function lr(t, e) {
      t.forEach(function (t) {
        e[t] && (e[t] = e[t].bind(e));
      });
    }
    function ur(t, e) {
      return -1 !== t.indexOf(e, t.length - e.length);
    }
    function cr(t, e, r) {
      var n = {};
      for (var _r6 in t) n[_r6] = e.call(this, t[_r6], _r6, t);
      return n;
    }
    function hr(t, e, r) {
      var n = {};
      for (var _r7 in t) e.call(this, t[_r7], _r7, t) && (n[_r7] = t[_r7]);
      return n;
    }
    function pr(t) {
      return Array.isArray(t) ? t.map(pr) : "object" == typeof t && t ? cr(t, pr) : t;
    }
    var fr = {};
    function dr(t) {
      fr[t] || ("undefined" != typeof console && console.warn(t), fr[t] = !0);
    }
    function mr(t, e, r) {
      return (r.y - t.y) * (e.x - t.x) > (e.y - t.y) * (r.x - t.x);
    }
    function yr(t) {
      var e = 0;
      for (var _r8, _n2, _i3 = 0, _s2 = t.length, _a2 = _s2 - 1; _i3 < _s2; _a2 = _i3++) _r8 = t[_i3], _n2 = t[_a2], e += (_n2.x - _r8.x) * (_r8.y + _n2.y);
      return e;
    }
    function gr(_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
        t = _ref2[0],
        e = _ref2[1],
        r = _ref2[2];
      var n = Ge(e + 90),
        i = Ge(r);
      return {
        x: t * Math.cos(n) * Math.sin(i),
        y: t * Math.sin(n) * Math.sin(i),
        z: t * Math.cos(i),
        azimuthal: e,
        polar: r
      };
    }
    function xr() {
      return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
    }
    function br(t) {
      var e = {};
      if (t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, function (t, r, n, i) {
        var s = n || i;
        return e[r] = !s || s.toLowerCase(), "";
      }), e["max-age"]) {
        var _t4 = parseInt(e["max-age"], 10);
        isNaN(_t4) ? delete e["max-age"] : e["max-age"] = _t4;
      }
      return e;
    }
    var vr,
      _r,
      wr,
      Mr,
      Ar,
      Sr,
      Ir = null;
    function Tr(t) {
      try {
        var _e4 = self[t];
        return _e4.setItem("_mapbox_test_", 1), _e4.removeItem("_mapbox_test_"), !0;
      } catch (t) {
        return !1;
      }
    }
    function kr(t, e) {
      return [t[4 * e], t[4 * e + 1], t[4 * e + 2], t[4 * e + 3]];
    }
    function Pr(t, e, r, n) {
      for (; e < r;) {
        var _i4 = e + r >> 1;
        t[_i4] < n ? e = _i4 + 1 : r = _i4;
      }
      return e;
    }
    function zr(t, e, r, n) {
      for (; e < r;) {
        var _i5 = e + r >> 1;
        t[_i5] <= n ? e = _i5 + 1 : r = _i5;
      }
      return e;
    }
    function Er(t) {
      return t > 0 ? 1 / (1.001 - t) : 1 + t;
    }
    function Br(t) {
      return t > 0 ? 1 - 1 / (1.001 - t) : -t;
    }
    function Dr() {
      return null == vr && (vr = self.OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap), vr;
    }
    var Rr = {
      now: function now() {
        return void 0 !== Mr ? Mr : performance.now();
      },
      setNow: function setNow(t) {
        Mr = t;
      },
      restoreNow: function restoreNow() {
        Mr = void 0;
      },
      frame: function frame(t) {
        var e = requestAnimationFrame(t);
        return {
          cancel: function cancel() {
            return cancelAnimationFrame(e);
          }
        };
      },
      getImageData: function getImageData(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var r = t.width,
          n = t.height;
        Ar || (Ar = document.createElement("canvas"));
        var i = Ar.getContext("2d", {
          willReadFrequently: !0
        });
        if (!i) throw new Error("failed to create canvas 2d context");
        return (r > Ar.width || n > Ar.height) && (Ar.width = r, Ar.height = n), i.clearRect(-e, -e, r + 2 * e, n + 2 * e), i.drawImage(t, 0, 0, r, n), i.getImageData(-e, -e, r + 2 * e, n + 2 * e);
      },
      resolveURL: function resolveURL(t) {
        return _r || (_r = document.createElement("a")), _r.href = t, _r.href;
      },
      get devicePixelRatio() {
        return window.devicePixelRatio;
      },
      get prefersReducedMotion() {
        return !!window.matchMedia && (null == wr && (wr = window.matchMedia("(prefers-reduced-motion: reduce)")), wr.matches);
      },
      hasCanvasFingerprintNoise: function hasCanvasFingerprintNoise() {
        if (void 0 !== Sr) return Sr;
        if (!Dr()) return Sr = !1, !1;
        var t = new OffscreenCanvas(85, 1),
          e = t.getContext("2d", {
            willReadFrequently: !0
          });
        var r = 0;
        for (var _n3 = 0; _n3 < t.width; ++_n3) e.fillStyle = "rgba(".concat(r++, ",").concat(r++, ",").concat(r++, ", 255)"), e.fillRect(_n3, 0, 1, 1);
        var n = e.getImageData(0, 0, t.width, t.height);
        r = 0;
        for (var _t5 = 0; _t5 < n.data.length; ++_t5) if (_t5 % 4 != 3 && r++ !== n.data[_t5]) return Sr = !0, !0;
        return Sr = !1, !1;
      }
    };
    function Cr(t, e) {
      var r = t.indexOf("?");
      if (r < 0) return "".concat(t, "?").concat(new URLSearchParams(e).toString());
      var n = new URLSearchParams(t.slice(r));
      for (var _t6 in e) n.set(_t6, e[_t6]);
      return "".concat(t.slice(0, r), "?").concat(n.toString());
    }
    function Lr(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        persistentParams: []
      };
      var r = t.indexOf("?");
      if (r < 0) return t;
      var n = new URLSearchParams(),
        i = new URLSearchParams(t.slice(r));
      var _iterator = _createForOfIteratorHelper(e.persistentParams),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t7 = _step.value;
          var _e5 = i.get(_t7);
          _e5 && n.set(_t7, _e5);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var s = n.toString();
      return "".concat(t.slice(0, r)).concat(s.length > 0 ? "?".concat(s) : "");
    }
    var Vr = "mapbox-tiles";
    var Fr = 500,
      Or = 50;
    var Ur = ["language", "worldview", "jobid"];
    var jr, Nr;
    function $r() {
      try {
        return caches;
      } catch (t) {}
    }
    function qr() {
      var t = $r();
      t && !jr && (jr = t.open(Vr));
    }
    var Gr = 1 / 0;
    var Xr = {
      supported: !1,
      testSupport: function testSupport(t) {
        !Hr && Zr && (Kr ? Jr(t) : Yr = t);
      }
    };
    var Yr,
      Zr,
      Hr = !1,
      Kr = !1;
    var Wr = "undefined" != typeof self ? self : {};
    function Jr(t) {
      var e = t.createTexture();
      t.bindTexture(t.TEXTURE_2D, e);
      try {
        if (t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, Zr), t.isContextLost()) return;
        Xr.supported = !0;
      } catch (t) {}
      t.deleteTexture(e), Hr = !0;
    }
    Wr.document && (Zr = Wr.document.createElement("img"), Zr.onload = function () {
      Yr && Jr(Yr), Yr = null, Kr = !0;
    }, Zr.onerror = function () {
      Hr = !0, Yr = null;
    }, Zr.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
    var Qr = {
      Unknown: "Unknown",
      Style: "Style",
      Source: "Source",
      Tile: "Tile",
      Glyphs: "Glyphs",
      SpriteImage: "SpriteImage",
      SpriteJSON: "SpriteJSON",
      Image: "Image",
      Model: "Model"
    };
    "function" == typeof Object.freeze && Object.freeze(Qr);
    var tn = /*#__PURE__*/function (_Error) {
      _inherits(tn, _Error);
      var _super = _createSuper(tn);
      function tn(t, e, r) {
        var _this;
        _classCallCheck(this, tn);
        401 === e && i(r) && (t += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), _this = _super.call(this, t), _this.status = e, _this.url = r;
        return _this;
      }
      _createClass(tn, [{
        key: "toString",
        value: function toString() {
          return "".concat(this.name, ": ").concat(this.message, " (").concat(this.status, "): ").concat(this.url);
        }
      }]);
      return tn;
    }( /*#__PURE__*/_wrapNativeSuper(Error));
    var en = xr() ? function () {
      return self.worker && self.worker.referrer;
    } : function () {
      return ("blob:" === location.protocol ? parent : self).location.href;
    };
    var rn = function rn(t, e) {
        if (!(/^file:/.test(r = t.url) || /^file:/.test(en()) && !/^\w+:/.test(r))) {
          if (self.fetch && self.Request && self.AbortController && Request.prototype.hasOwnProperty("signal")) return function (t, e) {
            var r = new AbortController(),
              n = new Request(t.url, {
                method: t.method || "GET",
                body: t.body,
                credentials: t.credentials,
                headers: t.headers,
                referrer: en(),
                referrerPolicy: t.referrerPolicy,
                signal: r.signal
              });
            var s = !1,
              a = !1;
            var o = (l = n.url).indexOf("sku=") > 0 && i(l);
            var l;
            "json" === t.type && n.headers.set("Accept", "application/json");
            var u = function u(r, i, s) {
                if (a) return;
                if (r && "SecurityError" !== r.message && dr(r.toString()), i && s) return c(i);
                var l = Date.now();
                fetch(n).then(function (r) {
                  if (r.ok) {
                    var _t8 = o ? r.clone() : null;
                    return c(r, _t8, l);
                  }
                  return e(new tn(r.statusText, r.status, t.url));
                }).catch(function (r) {
                  "AbortError" !== r.name && e(new Error("".concat(r.message, " ").concat(t.url)));
                });
              },
              c = function c(r, i, o) {
                ("arrayBuffer" === t.type ? r.arrayBuffer() : "json" === t.type ? r.json() : r.text()).then(function (t) {
                  a || (i && o && function (t, e, r) {
                    if (qr(), !jr) return;
                    var n = br(e.headers.get("Cache-Control") || "");
                    if (n["no-store"]) return;
                    var i = {
                      status: e.status,
                      statusText: e.statusText,
                      headers: new Headers()
                    };
                    e.headers.forEach(function (t, e) {
                      return i.headers.set(e, t);
                    }), n["max-age"] && i.headers.set("Expires", new Date(r + 1e3 * n["max-age"]).toUTCString());
                    var s = i.headers.get("Expires");
                    if (!s) return;
                    if (new Date(s).getTime() - r < 42e4) return;
                    var a = Lr(t.url, {
                      persistentParams: Ur
                    });
                    if (206 === e.status) {
                      var _e6 = t.headers.get("Range");
                      if (!_e6) return;
                      i.status = 200, a = Cr(a, {
                        range: _e6
                      });
                    }
                    !function (t, e) {
                      if (void 0 === Nr) try {
                        new Response(new ReadableStream()), Nr = !0;
                      } catch (t) {
                        Nr = !1;
                      }
                      Nr ? e(t.body) : t.blob().then(e);
                    }(e, function (t) {
                      var r = new Response(200 !== (n = e.status) && 404 !== n && [101, 103, 204, 205, 304].includes(n) ? null : t, i);
                      var n;
                      qr(), jr && jr.then(function (t) {
                        return t.put(a, r);
                      }).catch(function (t) {
                        return dr(t.message);
                      });
                    });
                  }(n, i, o), s = !0, e(null, t, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                }).catch(function (t) {
                  a || e(new Error(t.message));
                });
              };
            return o ? function (t, e) {
              if (qr(), !jr) return e(null);
              jr.then(function (r) {
                var n = Lr(t.url, {
                  persistentParams: Ur
                });
                var i = t.headers.get("Range");
                i && (n = Cr(n, {
                  range: i
                })), r.match(n).then(function (t) {
                  var i = function (t) {
                    if (!t) return !1;
                    var e = new Date(t.headers.get("Expires") || 0),
                      r = br(t.headers.get("Cache-Control") || "");
                    return e > Date.now() && !r["no-cache"];
                  }(t);
                  r.delete(n), i && r.put(n, t.clone()), e(null, t, i);
                }).catch(e);
              }).catch(e);
            }(n, u) : u(null, null), {
              cancel: function cancel() {
                a = !0, s || r.abort();
              }
            };
          }(t, e);
          if (xr() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t, e, void 0, !0);
        }
        var r;
        return function (t, e) {
          var r = new XMLHttpRequest();
          r.open(t.method || "GET", t.url, !0), "arrayBuffer" === t.type && (r.responseType = "arraybuffer");
          for (var _e7 in t.headers) r.setRequestHeader(_e7, t.headers[_e7]);
          return "json" === t.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t.credentials, r.onerror = function () {
            e(new Error(r.statusText));
          }, r.onload = function () {
            if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
              var _n4 = r.response;
              if ("json" === t.type) try {
                _n4 = JSON.parse(r.response);
              } catch (t) {
                return e(t);
              }
              e(null, _n4, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
            } else e(new tn(r.statusText, r.status, t.url));
          }, r.send(t.body), {
            cancel: function cancel() {
              return r.abort();
            }
          };
        }(t, e);
      },
      nn = function nn(t, e) {
        return rn(rr(t, {
          type: "arrayBuffer"
        }), e);
      };
    function sn(t) {
      var e = document.createElement("a");
      return e.href = t, e.protocol === location.protocol && e.host === location.host;
    }
    var an = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
    var on, ln;
    on = [], ln = 0;
    var un = function un(t, e) {
        if (Xr.supported && (t.headers || (t.headers = {}), t.headers.accept = "image/webp,*/*"), ln >= n.MAX_PARALLEL_IMAGE_REQUESTS) {
          var _r9 = {
            requestParameters: t,
            callback: e,
            cancelled: !1,
            cancel: function cancel() {
              this.cancelled = !0;
            }
          };
          return on.push(_r9), _r9;
        }
        ln++;
        var r = !1;
        var i = function i() {
            if (!r) for (r = !0, ln--; on.length && ln < n.MAX_PARALLEL_IMAGE_REQUESTS;) {
              var _t9 = on.shift(),
                _e8 = _t9.requestParameters,
                _r10 = _t9.callback,
                _n5 = _t9.cancelled;
              _n5 || (_t9.cancel = un(_e8, _r10).cancel);
            }
          },
          s = nn(t, function (t, r, n, s) {
            i(), t ? e(t) : r && (self.createImageBitmap ? function (t, e) {
              var r = new Blob([new Uint8Array(t)], {
                type: "image/png"
              });
              createImageBitmap(r).then(function (t) {
                e(null, t);
              }).catch(function (t) {
                e(new Error("Could not load image because of ".concat(t.message, ". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.")));
              });
            }(r, function (t, r) {
              return e(t, r, n, s);
            }) : function (t, e) {
              var r = new Image();
              r.onload = function () {
                e(null, r), URL.revokeObjectURL(r.src), r.onload = null, requestAnimationFrame(function () {
                  r.src = an;
                });
              }, r.onerror = function () {
                return e(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
              };
              var n = new Blob([new Uint8Array(t)], {
                type: "image/png"
              });
              r.src = t.byteLength ? URL.createObjectURL(n) : an;
            }(r, function (t, r) {
              return e(t, r, n, s);
            }));
          });
        return {
          cancel: function cancel() {
            s.cancel(), i();
          }
        };
      },
      cn = "01",
      hn = "NO_ACCESS_TOKEN",
      pn = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
    function fn(t) {
      var e = t.match(pn);
      if (!e) throw new Error("Unable to parse URL object");
      return {
        protocol: e[1],
        authority: e[2],
        path: e[3] || "/",
        params: e[4] ? e[4].split("&") : []
      };
    }
    function dn(t) {
      var e = t.params.length ? "?".concat(t.params.join("&")) : "";
      return "".concat(t.protocol, "://").concat(t.authority).concat(t.path).concat(e);
    }
    var mn = "mapbox.eventData";
    function yn(t) {
      if (!t) return null;
      var e = t.split(".");
      if (!e || 3 !== e.length) return null;
      try {
        return JSON.parse(decodeURIComponent(atob(e[1]).split("").map(function (t) {
          return "%" + ("00" + t.charCodeAt(0).toString(16)).slice(-2);
        }).join("")));
      } catch (t) {
        return null;
      }
    }
    var gn = /*#__PURE__*/function () {
      function gn(t) {
        _classCallCheck(this, gn);
        this.type = t, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
      }
      _createClass(gn, [{
        key: "getStorageKey",
        value: function getStorageKey(t) {
          var e = yn(n.ACCESS_TOKEN);
          var r = "";
          return r = e && e.u ? btoa(encodeURIComponent(e.u).replace(/%([0-9A-F]{2})/g, function (t, e) {
            return String.fromCharCode(Number("0x" + e));
          })) : n.ACCESS_TOKEN || "", t ? "".concat(mn, ".").concat(t, ":").concat(r) : "".concat(mn, ":").concat(r);
        }
      }, {
        key: "fetchEventData",
        value: function fetchEventData() {
          var t = Tr("localStorage"),
            e = this.getStorageKey(),
            r = this.getStorageKey("uuid");
          if (t) try {
            var _t10 = localStorage.getItem(e);
            _t10 && (this.eventData = JSON.parse(_t10));
            var _n6 = localStorage.getItem(r);
            _n6 && (this.anonId = _n6);
          } catch (t) {
            dr("Unable to read from LocalStorage");
          }
        }
      }, {
        key: "saveEventData",
        value: function saveEventData() {
          var t = Tr("localStorage"),
            e = this.getStorageKey(),
            r = this.getStorageKey("uuid"),
            n = this.anonId;
          if (t && n) try {
            localStorage.setItem(r, n), Object.keys(this.eventData).length >= 1 && localStorage.setItem(e, JSON.stringify(this.eventData));
          } catch (t) {
            dr("Unable to write to LocalStorage");
          }
        }
      }, {
        key: "processRequests",
        value: function processRequests(t) {}
      }, {
        key: "postEvent",
        value: function postEvent(t, e, r, i) {
          var _this2 = this;
          if (!n.EVENTS_URL) return;
          var s = fn(n.EVENTS_URL);
          s.params.push("access_token=".concat(i || n.ACCESS_TOKEN || ""));
          var a = {
              event: this.type,
              created: new Date(t).toISOString()
            },
            o = e ? rr(a, e) : a,
            l = {
              url: dn(s),
              headers: {
                "Content-Type": "text/plain"
              },
              body: JSON.stringify([o])
            };
          this.pendingRequest = function (t, e) {
            return rn(rr(t, {
              method: "POST"
            }), e);
          }(l, function (t) {
            _this2.pendingRequest = null, r(t), _this2.saveEventData(), _this2.processRequests(i);
          });
        }
      }, {
        key: "queueRequest",
        value: function queueRequest(t, e) {
          this.queue.push(t), this.processRequests(e);
        }
      }]);
      return gn;
    }();
    var xn = new ( /*#__PURE__*/function (_gn) {
        _inherits(_class, _gn);
        var _super2 = _createSuper(_class);
        function _class(t) {
          var _this3;
          _classCallCheck(this, _class);
          _this3 = _super2.call(this, "appUserTurnstile"), _this3._customAccessToken = t;
          return _this3;
        }
        _createClass(_class, [{
          key: "postTurnstileEvent",
          value: function postTurnstileEvent(t, e) {
            n.EVENTS_URL && n.ACCESS_TOKEN && Array.isArray(t) && t.some(function (t) {
              return s(t) || i(t);
            }) && this.queueRequest(Date.now(), e);
          }
        }, {
          key: "processRequests",
          value: function processRequests(t) {
            var _this4 = this;
            if (this.pendingRequest || 0 === this.queue.length) return;
            this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
            var r = yn(n.ACCESS_TOKEN),
              i = r ? r.u : n.ACCESS_TOKEN;
            var s = i !== this.eventData.tokenU;
            or(this.anonId) || (this.anonId = sr(), s = !0);
            var a = this.queue.shift();
            if (this.eventData.lastSuccess) {
              var _t11 = new Date(this.eventData.lastSuccess),
                _e9 = new Date(a),
                _r11 = (a - this.eventData.lastSuccess) / 864e5;
              s = s || _r11 >= 1 || _r11 < -1 || _t11.getDate() !== _e9.getDate();
            } else s = !0;
            s ? this.postEvent(a, {
              sdkIdentifier: "mapbox-gl-js",
              sdkVersion: e,
              skuId: cn,
              "enabled.telemetry": !1,
              userId: this.anonId
            }, function (t) {
              t || (_this4.eventData.lastSuccess = a, _this4.eventData.tokenU = i);
            }, t) : this.processRequests();
          }
        }]);
        return _class;
      }(gn))(),
      bn = xn.postTurnstileEvent.bind(xn),
      vn = new ( /*#__PURE__*/function (_gn2) {
        _inherits(_class2, _gn2);
        var _super3 = _createSuper(_class2);
        function _class2() {
          var _this5;
          _classCallCheck(this, _class2);
          _this5 = _super3.call(this, "map.load"), _this5.success = {}, _this5.skuToken = "";
          return _this5;
        }
        _createClass(_class2, [{
          key: "postMapLoadEvent",
          value: function postMapLoadEvent(t, e, r, i) {
            this.skuToken = e, this.errorCb = i, n.EVENTS_URL && (r || n.ACCESS_TOKEN ? this.queueRequest({
              id: t,
              timestamp: Date.now()
            }, r) : this.errorCb(new Error(hn)));
          }
        }, {
          key: "processRequests",
          value: function processRequests(t) {
            var _this6 = this;
            if (this.pendingRequest || 0 === this.queue.length) return;
            var _this$queue$shift = this.queue.shift(),
              r = _this$queue$shift.id,
              n = _this$queue$shift.timestamp;
            r && this.success[r] || (this.anonId || this.fetchEventData(), or(this.anonId) || (this.anonId = sr()), this.postEvent(n, {
              sdkIdentifier: "mapbox-gl-js",
              sdkVersion: e,
              skuId: cn,
              skuToken: this.skuToken,
              userId: this.anonId
            }, function (t) {
              t ? _this6.errorCb(t) : r && (_this6.success[r] = !0);
            }, t));
          }
        }, {
          key: "remove",
          value: function remove() {
            this.errorCb = null;
          }
        }]);
        return _class2;
      }(gn))(),
      _n = vn.postMapLoadEvent.bind(vn),
      wn = new ( /*#__PURE__*/function (_gn3) {
        _inherits(_class3, _gn3);
        var _super4 = _createSuper(_class3);
        function _class3() {
          var _this7;
          _classCallCheck(this, _class3);
          _this7 = _super4.call(this, "style.load"), _this7.eventIdPerMapInstanceMap = new Map(), _this7.mapInstanceIdMap = new WeakMap();
          return _this7;
        }
        _createClass(_class3, [{
          key: "getMapInstanceId",
          value: function getMapInstanceId(t) {
            var e = this.mapInstanceIdMap.get(t);
            return e || (e = sr(), this.mapInstanceIdMap.set(t, e)), e;
          }
        }, {
          key: "getEventId",
          value: function getEventId(t) {
            var e = this.eventIdPerMapInstanceMap.get(t) || 0;
            return this.eventIdPerMapInstanceMap.set(t, e + 1), e;
          }
        }, {
          key: "postStyleLoadEvent",
          value: function postStyleLoadEvent(t, e) {
            var r = e.map,
              i = e.style,
              s = e.importedStyles;
            if (!n.EVENTS_URL || !t && !n.ACCESS_TOKEN) return;
            var a = this.getMapInstanceId(r),
              o = {
                mapInstanceId: a,
                eventId: this.getEventId(a),
                style: i
              };
            s.length && (o.importedStyles = s), this.queueRequest({
              timestamp: Date.now(),
              payload: o
            }, t);
          }
        }, {
          key: "processRequests",
          value: function processRequests(t) {
            if (this.pendingRequest || 0 === this.queue.length) return;
            var _this$queue$shift2 = this.queue.shift(),
              e = _this$queue$shift2.timestamp,
              r = _this$queue$shift2.payload;
            this.postEvent(e, r, function () {}, t);
          }
        }]);
        return _class3;
      }(gn))(),
      Mn = wn.postStyleLoadEvent.bind(wn),
      An = new ( /*#__PURE__*/function (_gn4) {
        _inherits(_class4, _gn4);
        var _super5 = _createSuper(_class4);
        function _class4() {
          _classCallCheck(this, _class4);
          return _super5.call(this, "gljs.performance");
        }
        _createClass(_class4, [{
          key: "postPerformanceEvent",
          value: function postPerformanceEvent(t, e) {
            n.EVENTS_URL && (t || n.ACCESS_TOKEN) && this.queueRequest({
              timestamp: Date.now(),
              performanceData: e
            }, t);
          }
        }, {
          key: "processRequests",
          value: function processRequests(t) {
            if (this.pendingRequest || 0 === this.queue.length) return;
            var _this$queue$shift3 = this.queue.shift(),
              r = _this$queue$shift3.timestamp,
              n = _this$queue$shift3.performanceData,
              i = function (t) {
                var r = performance.getEntriesByType("resource"),
                  n = performance.getEntriesByType("mark"),
                  i = function (t) {
                    var e = {};
                    if (t) for (var _r12 in t) if ("other" !== _r12) {
                      var _iterator2 = _createForOfIteratorHelper(t[_r12]),
                        _step2;
                      try {
                        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                          var _n7 = _step2.value;
                          var _t12 = "".concat(_r12, "ResolveRangeMin"),
                            _i6 = "".concat(_r12, "ResolveRangeMax"),
                            _s3 = "".concat(_r12, "RequestCount"),
                            _a3 = "".concat(_r12, "RequestCachedCount");
                          e[_t12] = Math.min(e[_t12] || 1 / 0, _n7.startTime), e[_i6] = Math.max(e[_i6] || -1 / 0, _n7.responseEnd);
                          var _o2 = function _o2(t) {
                            void 0 === e[t] && (e[t] = 0), ++e[t];
                          };
                          void 0 !== _n7.transferSize && 0 === _n7.transferSize && _o2(_a3), _o2(_s3);
                        }
                      } catch (err) {
                        _iterator2.e(err);
                      } finally {
                        _iterator2.f();
                      }
                    }
                    return e;
                  }(function (t, e) {
                    var r = {};
                    if (t) {
                      var _iterator3 = _createForOfIteratorHelper(t),
                        _step3;
                      try {
                        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                          var _n8 = _step3.value;
                          var _t13 = e(_n8);
                          void 0 === r[_t13] && (r[_t13] = []), r[_t13].push(_n8);
                        }
                      } catch (err) {
                        _iterator3.e(err);
                      } finally {
                        _iterator3.f();
                      }
                    }
                    return r;
                  }(r, h)),
                  s = window.devicePixelRatio,
                  a = navigator.connection || navigator.mozConnection || navigator.webkitConnection,
                  o = a ? a.effectiveType : void 0,
                  c = {
                    counters: [],
                    metadata: [],
                    attributes: []
                  },
                  p = function p(t, e, r) {
                    null != r && t.push({
                      name: e,
                      value: r.toString()
                    });
                  };
                for (var _t14 in i) p(c.counters, _t14, i[_t14]);
                if (t.interactionRange[0] !== 1 / 0 && t.interactionRange[1] !== -1 / 0 && (p(c.counters, "interactionRangeMin", t.interactionRange[0]), p(c.counters, "interactionRangeMax", t.interactionRange[1])), n) {
                  var _loop = function _loop() {
                    var t = _Object$keys[_i7];
                    var e = u[t],
                      r = n.find(function (t) {
                        return t.name === e;
                      });
                    r && p(c.counters, e, r.startTime);
                  };
                  for (var _i7 = 0, _Object$keys = Object.keys(u); _i7 < _Object$keys.length; _i7++) {
                    _loop();
                  }
                }
                return p(c.counters, "visibilityHidden", t.visibilityHidden), p(c.attributes, "style", function (t) {
                  if (t) {
                    var _iterator4 = _createForOfIteratorHelper(t),
                      _step4;
                    try {
                      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                        var _e10 = _step4.value;
                        var _t15 = _e10.name.split("?")[0];
                        if (l(_t15)) {
                          var _e11 = _t15.split("/").slice(-2);
                          if (2 === _e11.length) return "mapbox://styles/".concat(_e11[0], "/").concat(_e11[1]);
                        }
                      }
                    } catch (err) {
                      _iterator4.e(err);
                    } finally {
                      _iterator4.f();
                    }
                  }
                }(r)), p(c.attributes, "terrainEnabled", t.terrainEnabled ? "true" : "false"), p(c.attributes, "fogEnabled", t.fogEnabled ? "true" : "false"), p(c.attributes, "projection", t.projection), p(c.attributes, "zoom", t.zoom), p(c.metadata, "devicePixelRatio", s), p(c.metadata, "connectionEffectiveType", o), p(c.metadata, "navigatorUserAgent", navigator.userAgent), p(c.metadata, "screenWidth", window.screen.width), p(c.metadata, "screenHeight", window.screen.height), p(c.metadata, "windowWidth", window.innerWidth), p(c.metadata, "windowHeight", window.innerHeight), p(c.metadata, "mapWidth", t.width / s), p(c.metadata, "mapHeight", t.height / s), p(c.metadata, "webglRenderer", t.renderer), p(c.metadata, "webglVendor", t.vendor), p(c.metadata, "sdkVersion", e), p(c.metadata, "sdkIdentifier", "mapbox-gl-js"), c;
              }(n);
            var _iterator5 = _createForOfIteratorHelper(i.metadata),
              _step5;
            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var _t16 = _step5.value;
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
            var _iterator6 = _createForOfIteratorHelper(i.counters),
              _step6;
            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var _t17 = _step6.value;
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
            var _iterator7 = _createForOfIteratorHelper(i.attributes),
              _step7;
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var _t18 = _step7.value;
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
            this.postEvent(r, i, function () {}, t);
          }
        }]);
        return _class4;
      }(gn))(),
      Sn = An.postPerformanceEvent.bind(An),
      In = new ( /*#__PURE__*/function (_gn5) {
        _inherits(_class5, _gn5);
        var _super6 = _createSuper(_class5);
        function _class5() {
          var _this8;
          _classCallCheck(this, _class5);
          _this8 = _super6.call(this, "map.auth"), _this8.success = {}, _this8.skuToken = "";
          return _this8;
        }
        _createClass(_class5, [{
          key: "getSession",
          value: function getSession(t, e, r, i) {
            var _this9 = this;
            if (!n.API_URL || !n.SESSION_PATH) return;
            var s = fn(n.API_URL + n.SESSION_PATH);
            s.params.push("sku=".concat(e || "")), s.params.push("access_token=".concat(i || n.ACCESS_TOKEN || ""));
            var a = {
              url: dn(s),
              headers: {
                "Content-Type": "text/plain"
              }
            };
            this.pendingRequest = function (t, e) {
              return rn(rr(t, {
                method: "GET"
              }), e);
            }(a, function (t) {
              _this9.pendingRequest = null, r(t), _this9.saveEventData(), _this9.processRequests(i);
            });
          }
        }, {
          key: "getSessionAPI",
          value: function getSessionAPI(t, e, r, i) {
            this.skuToken = e, this.errorCb = i, n.SESSION_PATH && n.API_URL && (r || n.ACCESS_TOKEN ? this.queueRequest({
              id: t,
              timestamp: Date.now()
            }, r) : this.errorCb(new Error(hn)));
          }
        }, {
          key: "processRequests",
          value: function processRequests(t) {
            var _this10 = this;
            if (this.pendingRequest || 0 === this.queue.length) return;
            var _this$queue$shift4 = this.queue.shift(),
              e = _this$queue$shift4.id,
              r = _this$queue$shift4.timestamp;
            e && this.success[e] || this.getSession(r, this.skuToken, function (t) {
              t ? _this10.errorCb(t) : e && (_this10.success[e] = !0);
            }, t);
          }
        }, {
          key: "remove",
          value: function remove() {
            this.errorCb = null;
          }
        }]);
        return _class5;
      }(gn))(),
      Tn = In.getSessionAPI.bind(In),
      kn = new Set();
    var Pn = {
        exports: {}
      },
      zn = {
        exports: function exports(t, e) {
          var r, n, i, s, a, o, l, u;
          for (n = t.length - (r = 3 & t.length), i = e, a = 3432918353, o = 461845907, u = 0; u < n;) l = 255 & t.charCodeAt(u) | (255 & t.charCodeAt(++u)) << 8 | (255 & t.charCodeAt(++u)) << 16 | (255 & t.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (s = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s >>> 16) & 65535) << 16);
          switch (l = 0, r) {
            case 3:
              l ^= (255 & t.charCodeAt(u + 2)) << 16;
            case 2:
              l ^= (255 & t.charCodeAt(u + 1)) << 8;
            case 1:
              i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t.charCodeAt(u))) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
          }
          return i ^= t.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
        }
      },
      En = {
        exports: ({}, function (t, e) {
          for (var r, n = t.length, i = e ^ n, s = 0; n >= 4;) r = 1540483477 * (65535 & (r = 255 & t.charCodeAt(s) | (255 & t.charCodeAt(++s)) << 8 | (255 & t.charCodeAt(++s)) << 16 | (255 & t.charCodeAt(++s)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++s;
          switch (n) {
            case 3:
              i ^= (255 & t.charCodeAt(s + 2)) << 16;
            case 2:
              i ^= (255 & t.charCodeAt(s + 1)) << 8;
            case 1:
              i = 1540483477 * (65535 & (i ^= 255 & t.charCodeAt(s))) + ((1540483477 * (i >>> 16) & 65535) << 16);
          }
          return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
        })
      },
      Bn = zn.exports,
      Dn = En.exports;
    Pn.exports = Bn, Pn.exports.murmur3 = Bn, Pn.exports.murmur2 = Dn;
    var Rn = p(Pn.exports);
    var Cn = /*#__PURE__*/_createClass(function Cn(t) {
      _classCallCheck(this, Cn);
      rr(this, (arguments.length <= 1 ? undefined : arguments[1]) || {}), this.type = t;
    });
    var Ln = /*#__PURE__*/function (_Cn) {
      _inherits(Ln, _Cn);
      var _super7 = _createSuper(Ln);
      function Ln(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, Ln);
        return _super7.call(this, "error", rr({
          error: t
        }, e));
      }
      return _createClass(Ln);
    }(Cn);
    function Vn(t, e, r) {
      r[t] && -1 !== r[t].indexOf(e) || (r[t] = r[t] || [], r[t].push(e));
    }
    function Fn(t, e, r) {
      if (r && r[t]) {
        var _n9 = r[t].indexOf(e);
        -1 !== _n9 && r[t].splice(_n9, 1);
      }
    }
    var On = /*#__PURE__*/function () {
      function On() {
        _classCallCheck(this, On);
      }
      _createClass(On, [{
        key: "on",
        value: function on(t, e) {
          return this._listeners = this._listeners || {}, Vn(t, e, this._listeners), this;
        }
      }, {
        key: "off",
        value: function off(t, e) {
          return Fn(t, e, this._listeners), Fn(t, e, this._oneTimeListeners), this;
        }
      }, {
        key: "once",
        value: function once(t, e) {
          var _this11 = this;
          return e ? (this._oneTimeListeners = this._oneTimeListeners || {}, Vn(t, e, this._oneTimeListeners), this) : new Promise(function (e) {
            return _this11.once(t, e);
          });
        }
      }, {
        key: "fire",
        value: function fire(t, e) {
          var r = "string" == typeof t ? new Cn(t, e) : t,
            n = r.type;
          if (this.listens(n)) {
            r.target = this;
            var _t19 = this._listeners && this._listeners[n] ? this._listeners[n].slice() : [];
            var _iterator8 = _createForOfIteratorHelper(_t19),
              _step8;
            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _e13 = _step8.value;
                _e13.call(this, r);
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
            var _e12 = this._oneTimeListeners && this._oneTimeListeners[n] ? this._oneTimeListeners[n].slice() : [];
            var _iterator9 = _createForOfIteratorHelper(_e12),
              _step9;
            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var _t20 = _step9.value;
                Fn(n, _t20, this._oneTimeListeners), _t20.call(this, r);
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
            var _i8 = this._eventedParent;
            _i8 && (rr(r, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), _i8.fire(r));
          } else r instanceof Ln && console.error(r.error);
          return this;
        }
      }, {
        key: "listens",
        value: function listens(t) {
          return !!(this._listeners && this._listeners[t] && this._listeners[t].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t] && this._oneTimeListeners[t].length > 0 || this._eventedParent && this._eventedParent.listens(t));
        }
      }, {
        key: "setEventedParent",
        value: function setEventedParent(t, e) {
          return this._eventedParent = t, this._eventedParentData = e, this;
        }
      }]);
      return On;
    }();
    t.G = void 0;
    var Un = {
      transparent: [0, 0, 0, 0],
      aliceblue: [240, 248, 255, 1],
      antiquewhite: [250, 235, 215, 1],
      aqua: [0, 255, 255, 1],
      aquamarine: [127, 255, 212, 1],
      azure: [240, 255, 255, 1],
      beige: [245, 245, 220, 1],
      bisque: [255, 228, 196, 1],
      black: [0, 0, 0, 1],
      blanchedalmond: [255, 235, 205, 1],
      blue: [0, 0, 255, 1],
      blueviolet: [138, 43, 226, 1],
      brown: [165, 42, 42, 1],
      burlywood: [222, 184, 135, 1],
      cadetblue: [95, 158, 160, 1],
      chartreuse: [127, 255, 0, 1],
      chocolate: [210, 105, 30, 1],
      coral: [255, 127, 80, 1],
      cornflowerblue: [100, 149, 237, 1],
      cornsilk: [255, 248, 220, 1],
      crimson: [220, 20, 60, 1],
      cyan: [0, 255, 255, 1],
      darkblue: [0, 0, 139, 1],
      darkcyan: [0, 139, 139, 1],
      darkgoldenrod: [184, 134, 11, 1],
      darkgray: [169, 169, 169, 1],
      darkgreen: [0, 100, 0, 1],
      darkgrey: [169, 169, 169, 1],
      darkkhaki: [189, 183, 107, 1],
      darkmagenta: [139, 0, 139, 1],
      darkolivegreen: [85, 107, 47, 1],
      darkorange: [255, 140, 0, 1],
      darkorchid: [153, 50, 204, 1],
      darkred: [139, 0, 0, 1],
      darksalmon: [233, 150, 122, 1],
      darkseagreen: [143, 188, 143, 1],
      darkslateblue: [72, 61, 139, 1],
      darkslategray: [47, 79, 79, 1],
      darkslategrey: [47, 79, 79, 1],
      darkturquoise: [0, 206, 209, 1],
      darkviolet: [148, 0, 211, 1],
      deeppink: [255, 20, 147, 1],
      deepskyblue: [0, 191, 255, 1],
      dimgray: [105, 105, 105, 1],
      dimgrey: [105, 105, 105, 1],
      dodgerblue: [30, 144, 255, 1],
      firebrick: [178, 34, 34, 1],
      floralwhite: [255, 250, 240, 1],
      forestgreen: [34, 139, 34, 1],
      fuchsia: [255, 0, 255, 1],
      gainsboro: [220, 220, 220, 1],
      ghostwhite: [248, 248, 255, 1],
      gold: [255, 215, 0, 1],
      goldenrod: [218, 165, 32, 1],
      gray: [128, 128, 128, 1],
      green: [0, 128, 0, 1],
      greenyellow: [173, 255, 47, 1],
      grey: [128, 128, 128, 1],
      honeydew: [240, 255, 240, 1],
      hotpink: [255, 105, 180, 1],
      indianred: [205, 92, 92, 1],
      indigo: [75, 0, 130, 1],
      ivory: [255, 255, 240, 1],
      khaki: [240, 230, 140, 1],
      lavender: [230, 230, 250, 1],
      lavenderblush: [255, 240, 245, 1],
      lawngreen: [124, 252, 0, 1],
      lemonchiffon: [255, 250, 205, 1],
      lightblue: [173, 216, 230, 1],
      lightcoral: [240, 128, 128, 1],
      lightcyan: [224, 255, 255, 1],
      lightgoldenrodyellow: [250, 250, 210, 1],
      lightgray: [211, 211, 211, 1],
      lightgreen: [144, 238, 144, 1],
      lightgrey: [211, 211, 211, 1],
      lightpink: [255, 182, 193, 1],
      lightsalmon: [255, 160, 122, 1],
      lightseagreen: [32, 178, 170, 1],
      lightskyblue: [135, 206, 250, 1],
      lightslategray: [119, 136, 153, 1],
      lightslategrey: [119, 136, 153, 1],
      lightsteelblue: [176, 196, 222, 1],
      lightyellow: [255, 255, 224, 1],
      lime: [0, 255, 0, 1],
      limegreen: [50, 205, 50, 1],
      linen: [250, 240, 230, 1],
      magenta: [255, 0, 255, 1],
      maroon: [128, 0, 0, 1],
      mediumaquamarine: [102, 205, 170, 1],
      mediumblue: [0, 0, 205, 1],
      mediumorchid: [186, 85, 211, 1],
      mediumpurple: [147, 112, 219, 1],
      mediumseagreen: [60, 179, 113, 1],
      mediumslateblue: [123, 104, 238, 1],
      mediumspringgreen: [0, 250, 154, 1],
      mediumturquoise: [72, 209, 204, 1],
      mediumvioletred: [199, 21, 133, 1],
      midnightblue: [25, 25, 112, 1],
      mintcream: [245, 255, 250, 1],
      mistyrose: [255, 228, 225, 1],
      moccasin: [255, 228, 181, 1],
      navajowhite: [255, 222, 173, 1],
      navy: [0, 0, 128, 1],
      oldlace: [253, 245, 230, 1],
      olive: [128, 128, 0, 1],
      olivedrab: [107, 142, 35, 1],
      orange: [255, 165, 0, 1],
      orangered: [255, 69, 0, 1],
      orchid: [218, 112, 214, 1],
      palegoldenrod: [238, 232, 170, 1],
      palegreen: [152, 251, 152, 1],
      paleturquoise: [175, 238, 238, 1],
      palevioletred: [219, 112, 147, 1],
      papayawhip: [255, 239, 213, 1],
      peachpuff: [255, 218, 185, 1],
      peru: [205, 133, 63, 1],
      pink: [255, 192, 203, 1],
      plum: [221, 160, 221, 1],
      powderblue: [176, 224, 230, 1],
      purple: [128, 0, 128, 1],
      rebeccapurple: [102, 51, 153, 1],
      red: [255, 0, 0, 1],
      rosybrown: [188, 143, 143, 1],
      royalblue: [65, 105, 225, 1],
      saddlebrown: [139, 69, 19, 1],
      salmon: [250, 128, 114, 1],
      sandybrown: [244, 164, 96, 1],
      seagreen: [46, 139, 87, 1],
      seashell: [255, 245, 238, 1],
      sienna: [160, 82, 45, 1],
      silver: [192, 192, 192, 1],
      skyblue: [135, 206, 235, 1],
      slateblue: [106, 90, 205, 1],
      slategray: [112, 128, 144, 1],
      slategrey: [112, 128, 144, 1],
      snow: [255, 250, 250, 1],
      springgreen: [0, 255, 127, 1],
      steelblue: [70, 130, 180, 1],
      tan: [210, 180, 140, 1],
      teal: [0, 128, 128, 1],
      thistle: [216, 191, 216, 1],
      tomato: [255, 99, 71, 1],
      turquoise: [64, 224, 208, 1],
      violet: [238, 130, 238, 1],
      wheat: [245, 222, 179, 1],
      white: [255, 255, 255, 1],
      whitesmoke: [245, 245, 245, 1],
      yellow: [255, 255, 0, 1],
      yellowgreen: [154, 205, 50, 1]
    };
    function jn(t) {
      return (t = Math.round(t)) < 0 ? 0 : t > 255 ? 255 : t;
    }
    function Nn(t) {
      return jn("%" === t[t.length - 1] ? parseFloat(t) / 100 * 255 : parseInt(t));
    }
    function $n(t) {
      return (e = "%" === t[t.length - 1] ? parseFloat(t) / 100 : parseFloat(t)) < 0 ? 0 : e > 1 ? 1 : e;
      var e;
    }
    function qn(t, e, r) {
      return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? t + (e - t) * r * 6 : 2 * r < 1 ? e : 3 * r < 2 ? t + (e - t) * (2 / 3 - r) * 6 : t;
    }
    try {
      t.G = {}.parseCSSColor = function (t) {
        var e,
          r = t.replace(/ /g, "").toLowerCase();
        if (r in Un) return Un[r].slice();
        if ("#" === r[0]) return 4 === r.length ? (e = parseInt(r.substr(1), 16)) >= 0 && e <= 4095 ? [(3840 & e) >> 4 | (3840 & e) >> 8, 240 & e | (240 & e) >> 4, 15 & e | (15 & e) << 4, 1] : null : 7 === r.length && (e = parseInt(r.substr(1), 16)) >= 0 && e <= 16777215 ? [(16711680 & e) >> 16, (65280 & e) >> 8, 255 & e, 1] : null;
        var n = r.indexOf("("),
          i = r.indexOf(")");
        if (-1 !== n && i + 1 === r.length) {
          var s = r.substr(0, n),
            a = r.substr(n + 1, i - (n + 1)).split(","),
            o = 1;
          switch (s) {
            case "rgba":
              if (4 !== a.length) return null;
              o = $n(a.pop());
            case "rgb":
              return 3 !== a.length ? null : [Nn(a[0]), Nn(a[1]), Nn(a[2]), o];
            case "hsla":
              if (4 !== a.length) return null;
              o = $n(a.pop());
            case "hsl":
              if (3 !== a.length) return null;
              var l = (parseFloat(a[0]) % 360 + 360) % 360 / 360,
                u = $n(a[1]),
                c = $n(a[2]),
                h = c <= .5 ? c * (u + 1) : c + u - c * u,
                p = 2 * c - h;
              return [jn(255 * qn(p, h, l + 1 / 3)), jn(255 * qn(p, h, l)), jn(255 * qn(p, h, l - 1 / 3)), o];
            default:
              return null;
          }
        }
        return null;
      };
    } catch (t) {}
    var Gn = /*#__PURE__*/function () {
      function Gn(t, e, r) {
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        _classCallCheck(this, Gn);
        this.r = t, this.g = e, this.b = r, this.a = n;
      }
      _createClass(Gn, [{
        key: "toString",
        value: function toString() {
          var _ref3 = 0 === this.a ? [0, 0, 0, 0] : [255 * this.r / this.a, 255 * this.g / this.a, 255 * this.b / this.a, this.a],
            _ref4 = _slicedToArray(_ref3, 4),
            t = _ref4[0],
            e = _ref4[1],
            r = _ref4[2],
            n = _ref4[3];
          return "rgba(".concat(Math.round(t), ",").concat(Math.round(e), ",").concat(Math.round(r), ",").concat(n, ")");
        }
      }, {
        key: "toRenderColor",
        value: function toRenderColor(t) {
          var e = this.r,
            r = this.g,
            n = this.b,
            i = this.a;
          return new Xn(t, e, r, n, i);
        }
      }], [{
        key: "parse",
        value: function parse(e) {
          if (!e) return;
          if (e instanceof Gn) return e;
          if ("string" != typeof e) return;
          var r = t.G(e);
          return r ? new Gn(r[0] / 255 * r[3], r[1] / 255 * r[3], r[2] / 255 * r[3], r[3]) : void 0;
        }
      }]);
      return Gn;
    }();
    var Xn = /*#__PURE__*/function () {
      function Xn(t, e, r, n, i) {
        _classCallCheck(this, Xn);
        if (t) {
          var _s4 = t.image.height,
            _a4 = _s4 * _s4;
          e = 0 === i ? 0 : e / i * (_s4 - 1), r = 0 === i ? 0 : r / i * (_s4 - 1), n = 0 === i ? 0 : n / i * (_s4 - 1);
          var _o3 = Math.floor(e),
            _l2 = Math.floor(r),
            _u2 = Math.floor(n),
            _c2 = Math.ceil(e),
            _h2 = Math.ceil(r),
            _p2 = Math.ceil(n),
            _f2 = e - _o3,
            _d2 = r - _l2,
            _m2 = n - _u2,
            _y2 = t.image.data,
            _g2 = 4 * (_o3 + _l2 * _a4 + _u2 * _s4),
            _x2 = 4 * (_o3 + _l2 * _a4 + _p2 * _s4),
            _b2 = 4 * (_o3 + _h2 * _a4 + _u2 * _s4),
            _v2 = 4 * (_o3 + _h2 * _a4 + _p2 * _s4),
            _2 = 4 * (_c2 + _l2 * _a4 + _u2 * _s4),
            _w = 4 * (_c2 + _l2 * _a4 + _p2 * _s4),
            _M = 4 * (_c2 + _h2 * _a4 + _u2 * _s4),
            _A = 4 * (_c2 + _h2 * _a4 + _p2 * _s4);
          if (_g2 < 0 || _A >= _y2.length) throw new Error("out of range");
          this.r = Yn(Yn(Yn(_y2[_g2], _y2[_x2], _m2), Yn(_y2[_b2], _y2[_v2], _m2), _d2), Yn(Yn(_y2[_2], _y2[_w], _m2), Yn(_y2[_M], _y2[_A], _m2), _d2), _f2) / 255 * i, this.g = Yn(Yn(Yn(_y2[_g2 + 1], _y2[_x2 + 1], _m2), Yn(_y2[_b2 + 1], _y2[_v2 + 1], _m2), _d2), Yn(Yn(_y2[_2 + 1], _y2[_w + 1], _m2), Yn(_y2[_M + 1], _y2[_A + 1], _m2), _d2), _f2) / 255 * i, this.b = Yn(Yn(Yn(_y2[_g2 + 2], _y2[_x2 + 2], _m2), Yn(_y2[_b2 + 2], _y2[_v2 + 2], _m2), _d2), Yn(Yn(_y2[_2 + 2], _y2[_w + 2], _m2), Yn(_y2[_M + 2], _y2[_A + 2], _m2), _d2), _f2) / 255 * i, this.a = i;
        } else this.r = e, this.g = r, this.b = n, this.a = i;
      }
      _createClass(Xn, [{
        key: "toArray",
        value: function toArray() {
          var t = this.r,
            e = this.g,
            r = this.b,
            n = this.a;
          return 0 === n ? [0, 0, 0, 0] : [255 * t / n, 255 * e / n, 255 * r / n, n];
        }
      }, {
        key: "toArray01",
        value: function toArray01() {
          var t = this.r,
            e = this.g,
            r = this.b,
            n = this.a;
          return 0 === n ? [0, 0, 0, 0] : [t / n, e / n, r / n, n];
        }
      }, {
        key: "toArray01Scaled",
        value: function toArray01Scaled(t) {
          var e = this.r,
            r = this.g,
            n = this.b,
            i = this.a;
          return 0 === i ? [0, 0, 0] : [e / i * t, r / i * t, n / i * t];
        }
      }, {
        key: "toArray01PremultipliedAlpha",
        value: function toArray01PremultipliedAlpha() {
          var t = this.r,
            e = this.g,
            r = this.b,
            n = this.a;
          return [t, e, r, n];
        }
      }, {
        key: "toArray01Linear",
        value: function toArray01Linear() {
          var t = this.r,
            e = this.g,
            r = this.b,
            n = this.a;
          return 0 === n ? [0, 0, 0, 0] : [Math.pow(t / n, 2.2), Math.pow(e / n, 2.2), Math.pow(r / n, 2.2), n];
        }
      }]);
      return Xn;
    }();
    function Yn(t, e, r) {
      return t * (1 - r) + e * r;
    }
    function Zn(t, e, r) {
      return t.map(function (t, n) {
        return Yn(t, e[n], r);
      });
    }
    Gn.black = new Gn(0, 0, 0, 1), Gn.white = new Gn(1, 1, 1, 1), Gn.transparent = new Gn(0, 0, 0, 0), Gn.red = new Gn(1, 0, 0, 1), Gn.blue = new Gn(0, 0, 1, 1);
    var Hn = Object.freeze({
      __proto__: null,
      array: Zn,
      color: function color(t, e, r) {
        return new Gn(Yn(t.r, e.r, r), Yn(t.g, e.g, r), Yn(t.b, e.b, r), Yn(t.a, e.a, r));
      },
      number: Yn
    });
    function Kn(t) {
      for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        e[_key2 - 1] = arguments[_key2];
      }
      for (var _i9 = 0, _e14 = e; _i9 < _e14.length; _i9++) {
        var _r13 = _e14[_i9];
        for (var _e15 in _r13) t[_e15] = _r13[_e15];
      }
      return t;
    }
    var Wn = /*#__PURE__*/function (_Error2) {
      _inherits(Wn, _Error2);
      var _super8 = _createSuper(Wn);
      function Wn(t, e) {
        var _this12;
        _classCallCheck(this, Wn);
        _this12 = _super8.call(this, e), _this12.message = e, _this12.key = t;
        return _this12;
      }
      return _createClass(Wn);
    }( /*#__PURE__*/_wrapNativeSuper(Error));
    var Jn = /*#__PURE__*/function () {
      function Jn(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        _classCallCheck(this, Jn);
        this.parent = t, this.bindings = {};
        var _iterator10 = _createForOfIteratorHelper(e),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _step10$value = _slicedToArray(_step10.value, 2),
              _t21 = _step10$value[0],
              _r14 = _step10$value[1];
            this.bindings[_t21] = _r14;
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
      _createClass(Jn, [{
        key: "concat",
        value: function concat(t) {
          return new Jn(this, t);
        }
      }, {
        key: "get",
        value: function get(t) {
          if (this.bindings[t]) return this.bindings[t];
          if (this.parent) return this.parent.get(t);
          throw new Error("".concat(t, " not found in scope."));
        }
      }, {
        key: "has",
        value: function has(t) {
          return !!this.bindings[t] || !!this.parent && this.parent.has(t);
        }
      }]);
      return Jn;
    }();
    var Qn = {
        kind: "null"
      },
      ti = {
        kind: "number"
      },
      ei = {
        kind: "string"
      },
      ri = {
        kind: "boolean"
      },
      ni = {
        kind: "color"
      },
      ii = {
        kind: "object"
      },
      si = {
        kind: "value"
      },
      ai = {
        kind: "collator"
      },
      oi = {
        kind: "formatted"
      },
      li = {
        kind: "resolvedImage"
      };
    function ui(t, e) {
      return {
        kind: "array",
        itemType: t,
        N: e
      };
    }
    function ci(t) {
      if ("array" === t.kind) {
        var _e16 = ci(t.itemType);
        return "number" == typeof t.N ? "array<".concat(_e16, ", ").concat(t.N, ">") : "value" === t.itemType.kind ? "array" : "array<".concat(_e16, ">");
      }
      return t.kind;
    }
    var hi = [Qn, ti, ei, ri, ni, oi, ii, ui(si), li];
    function pi(t, e) {
      if ("error" === e.kind) return null;
      if ("array" === t.kind) {
        if ("array" === e.kind && (0 === e.N && "value" === e.itemType.kind || !pi(t.itemType, e.itemType)) && ("number" != typeof t.N || t.N === e.N)) return null;
      } else {
        if (t.kind === e.kind) return null;
        if ("value" === t.kind) for (var _i10 = 0, _hi = hi; _i10 < _hi.length; _i10++) {
          var _t22 = _hi[_i10];
          if (!pi(_t22, e)) return null;
        }
      }
      return "Expected ".concat(ci(t), " but found ").concat(ci(e), " instead.");
    }
    function fi(t, e) {
      return e.some(function (e) {
        return e.kind === t.kind;
      });
    }
    function di(t, e) {
      return e.some(function (e) {
        return "null" === e ? null === t : "array" === e ? Array.isArray(t) : "object" === e ? t && !Array.isArray(t) && "object" == typeof t : e === typeof t;
      });
    }
    var mi = /*#__PURE__*/function () {
      function mi(t, e, r) {
        _classCallCheck(this, mi);
        this.sensitivity = t ? e ? "variant" : "case" : e ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
          sensitivity: this.sensitivity,
          usage: "search"
        });
      }
      _createClass(mi, [{
        key: "compare",
        value: function compare(t, e) {
          return this.collator.compare(t, e);
        }
      }, {
        key: "resolvedLocale",
        value: function resolvedLocale() {
          return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
        }
      }]);
      return mi;
    }();
    var yi = /*#__PURE__*/_createClass(function yi(t, e, r, n, i) {
      _classCallCheck(this, yi);
      this.text = t.normalize ? t.normalize() : t, this.image = e, this.scale = r, this.fontStack = n, this.textColor = i;
    });
    var gi = /*#__PURE__*/function () {
      function gi(t) {
        _classCallCheck(this, gi);
        this.sections = t;
      }
      _createClass(gi, [{
        key: "isEmpty",
        value: function isEmpty() {
          return 0 === this.sections.length || !this.sections.some(function (t) {
            return 0 !== t.text.length || t.image && 0 !== t.image.namePrimary.length;
          });
        }
      }, {
        key: "toString",
        value: function toString() {
          return 0 === this.sections.length ? "" : this.sections.map(function (t) {
            return t.text;
          }).join("");
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = ["format"];
          var _iterator11 = _createForOfIteratorHelper(this.sections),
            _step11;
          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _e17 = _step11.value;
              if (_e17.image) {
                t.push(["image", _e17.image.namePrimary]);
                continue;
              }
              t.push(_e17.text);
              var _r15 = {};
              _e17.fontStack && (_r15["text-font"] = ["literal", _e17.fontStack.split(",")]), _e17.scale && (_r15["font-scale"] = _e17.scale), _e17.textColor && (_r15["text-color"] = ["rgba"].concat(_e17.textColor.toRenderColor(null).toArray())), t.push(_r15);
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
          return t;
        }
      }], [{
        key: "fromString",
        value: function fromString(t) {
          return new gi([new yi(t, null, null, null, null)]);
        }
      }, {
        key: "factory",
        value: function factory(t) {
          return t instanceof gi ? t : gi.fromString(t);
        }
      }]);
      return gi;
    }();
    var xi = /*#__PURE__*/function () {
      function xi(t) {
        _classCallCheck(this, xi);
        this.namePrimary = t.namePrimary, t.nameSecondary && (this.nameSecondary = t.nameSecondary), this.available = t.available;
      }
      _createClass(xi, [{
        key: "toString",
        value: function toString() {
          return this.nameSecondary ? "[".concat(this.namePrimary, ",").concat(this.nameSecondary, "]") : this.namePrimary;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return this.nameSecondary ? ["image", this.namePrimary, this.nameSecondary] : ["image", this.namePrimary];
        }
      }], [{
        key: "fromString",
        value: function fromString(t, e) {
          return t ? new xi({
            namePrimary: t,
            nameSecondary: e,
            available: !1
          }) : null;
        }
      }]);
      return xi;
    }();
    function bi(t, e, r, n) {
      return "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : "Invalid rgba value [".concat([t, e, r, n].join(", "), "]: 'a' must be between 0 and 1.") : "Invalid rgba value [".concat(("number" == typeof n ? [t, e, r, n] : [t, e, r]).join(", "), "]: 'r', 'g', and 'b' must be between 0 and 255.");
    }
    function vi(t) {
      if (null === t) return !0;
      if ("string" == typeof t) return !0;
      if ("boolean" == typeof t) return !0;
      if ("number" == typeof t) return !0;
      if (t instanceof Gn) return !0;
      if (t instanceof mi) return !0;
      if (t instanceof gi) return !0;
      if (t instanceof xi) return !0;
      if (Array.isArray(t)) {
        var _iterator12 = _createForOfIteratorHelper(t),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var _e18 = _step12.value;
            if (!vi(_e18)) return !1;
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
        return !0;
      }
      if ("object" == typeof t) {
        for (var _e19 in t) if (!vi(t[_e19])) return !1;
        return !0;
      }
      return !1;
    }
    function _i(t) {
      if (null === t) return Qn;
      if ("string" == typeof t) return ei;
      if ("boolean" == typeof t) return ri;
      if ("number" == typeof t) return ti;
      if (t instanceof Gn) return ni;
      if (t instanceof mi) return ai;
      if (t instanceof gi) return oi;
      if (t instanceof xi) return li;
      if (Array.isArray(t)) {
        var _e20 = t.length;
        var _r16;
        var _iterator13 = _createForOfIteratorHelper(t),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var _e21 = _step13.value;
            var _t23 = _i(_e21);
            if (_r16) {
              if (_r16 === _t23) continue;
              _r16 = si;
              break;
            }
            _r16 = _t23;
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
        return ui(_r16 || si, _e20);
      }
      return ii;
    }
    function wi(t) {
      var e = typeof t;
      return null === t ? "" : "string" === e || "number" === e || "boolean" === e ? String(t) : t instanceof Gn || t instanceof gi || t instanceof xi ? t.toString() : JSON.stringify(t);
    }
    var Mi = /*#__PURE__*/function () {
      function Mi(t, e) {
        _classCallCheck(this, Mi);
        this.type = t, this.value = e;
      }
      _createClass(Mi, [{
        key: "evaluate",
        value: function evaluate() {
          return this.value;
        }
      }, {
        key: "eachChild",
        value: function eachChild() {}
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !0;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return "array" === this.type.kind || "object" === this.type.kind ? ["literal", this.value] : this.value instanceof Gn ? ["rgba"].concat(this.value.toRenderColor(null).toArray()) : this.value instanceof gi ? this.value.serialize() : this.value;
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (2 !== t.length) return e.error("'literal' expression requires exactly one argument, but found ".concat(t.length - 1, " instead."));
          if (!vi(t[1])) return e.error("invalid value");
          var r = t[1];
          var n = _i(r);
          var i = e.expectedType;
          return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new Mi(n, r);
        }
      }]);
      return Mi;
    }();
    var Ai = /*#__PURE__*/function () {
      function Ai(t) {
        _classCallCheck(this, Ai);
        this.name = "ExpressionEvaluationError", this.message = t;
      }
      _createClass(Ai, [{
        key: "toJSON",
        value: function toJSON() {
          return this.message;
        }
      }]);
      return Ai;
    }();
    var Si = {
      string: ei,
      number: ti,
      boolean: ri,
      object: ii
    };
    var Ii = /*#__PURE__*/function () {
      function Ii(t, e) {
        _classCallCheck(this, Ii);
        this.type = t, this.args = e;
      }
      _createClass(Ii, [{
        key: "evaluate",
        value: function evaluate(t) {
          for (var _e22 = 0; _e22 < this.args.length; _e22++) {
            var _r17 = this.args[_e22].evaluate(t);
            if (!pi(this.type, _i(_r17))) return _r17;
            if (_e22 === this.args.length - 1) throw new Ai("The expression ".concat(JSON.stringify(this.args[_e22].serialize()), " evaluated to ").concat(ci(_i(_r17)), " but was expected to be of type ").concat(ci(this.type), "."));
          }
          return null;
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          this.args.forEach(t);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return this.args.every(function (t) {
            return t.outputDefined();
          });
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = this.type,
            e = [t.kind];
          if ("array" === t.kind) {
            var _r18 = t.itemType;
            if ("string" === _r18.kind || "number" === _r18.kind || "boolean" === _r18.kind) {
              e.push(_r18.kind);
              var _n10 = t.N;
              ("number" == typeof _n10 || this.args.length > 1) && e.push(_n10);
            }
          }
          return e.concat(this.args.map(function (t) {
            return t.serialize();
          }));
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (t.length < 2) return e.error("Expected at least one argument.");
          var r,
            n = 1;
          var i = t[0];
          if ("array" === i) {
            var _i11, _s5;
            if (t.length > 2) {
              var _r19 = t[1];
              if ("string" != typeof _r19 || !(_r19 in Si) || "object" === _r19) return e.error('The item type argument of "array" must be one of string, number, boolean', 1);
              _i11 = Si[_r19], n++;
            } else _i11 = si;
            if (t.length > 3) {
              if (null !== t[2] && ("number" != typeof t[2] || t[2] < 0 || t[2] !== Math.floor(t[2]))) return e.error('The length argument to "array" must be a positive integer literal', 2);
              _s5 = t[2], n++;
            }
            r = ui(_i11, _s5);
          } else r = Si[i];
          var s = [];
          for (; n < t.length; n++) {
            var _r20 = e.parse(t[n], n, si);
            if (!_r20) return null;
            s.push(_r20);
          }
          return new Ii(r, s);
        }
      }]);
      return Ii;
    }();
    var Ti = /*#__PURE__*/function () {
      function Ti(t) {
        _classCallCheck(this, Ti);
        this.type = oi, this.sections = t;
      }
      _createClass(Ti, [{
        key: "evaluate",
        value: function evaluate(t) {
          return new gi(this.sections.map(function (e) {
            var r = e.content.evaluate(t);
            return _i(r) === li ? new yi("", r, null, null, null) : new yi(wi(r), null, e.scale ? e.scale.evaluate(t) : null, e.font ? e.font.evaluate(t).join(",") : null, e.textColor ? e.textColor.evaluate(t) : null);
          }));
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          var _iterator14 = _createForOfIteratorHelper(this.sections),
            _step14;
          try {
            for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
              var _e23 = _step14.value;
              t(_e23.content), _e23.scale && t(_e23.scale), _e23.font && t(_e23.font), _e23.textColor && t(_e23.textColor);
            }
          } catch (err) {
            _iterator14.e(err);
          } finally {
            _iterator14.f();
          }
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = ["format"];
          var _iterator15 = _createForOfIteratorHelper(this.sections),
            _step15;
          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var _e24 = _step15.value;
              t.push(_e24.content.serialize());
              var _r21 = {};
              _e24.scale && (_r21["font-scale"] = _e24.scale.serialize()), _e24.font && (_r21["text-font"] = _e24.font.serialize()), _e24.textColor && (_r21["text-color"] = _e24.textColor.serialize()), t.push(_r21);
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }
          return t;
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (t.length < 2) return e.error("Expected at least one argument.");
          var r = t[1];
          if (!Array.isArray(r) && "object" == typeof r) return e.error("First argument must be an image or text section.");
          var n = [];
          var i = !1;
          for (var _r22 = 1; _r22 <= t.length - 1; ++_r22) {
            var _s6 = t[_r22];
            if (i && "object" == typeof _s6 && !Array.isArray(_s6)) {
              i = !1;
              var _t24 = null;
              if (_s6["font-scale"] && (_t24 = e.parse(_s6["font-scale"], 1, ti), !_t24)) return null;
              var _r23 = null;
              if (_s6["text-font"] && (_r23 = e.parse(_s6["text-font"], 1, ui(ei)), !_r23)) return null;
              var _a5 = null;
              if (_s6["text-color"] && (_a5 = e.parse(_s6["text-color"], 1, ni), !_a5)) return null;
              var _o4 = n[n.length - 1];
              _o4.scale = _t24, _o4.font = _r23, _o4.textColor = _a5;
            } else {
              var _s7 = e.parse(t[_r22], 1, si);
              if (!_s7) return null;
              var _a6 = _s7.type.kind;
              if ("string" !== _a6 && "value" !== _a6 && "null" !== _a6 && "resolvedImage" !== _a6) return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
              i = !0, n.push({
                content: _s7,
                scale: null,
                font: null,
                textColor: null
              });
            }
          }
          return new Ti(n);
        }
      }]);
      return Ti;
    }();
    var ki = /*#__PURE__*/function () {
      function ki(t, e) {
        _classCallCheck(this, ki);
        this.type = li, this.inputPrimary = t, this.inputSecondary = e;
      }
      _createClass(ki, [{
        key: "evaluate",
        value: function evaluate(t) {
          var e = xi.fromString(this.inputPrimary.evaluate(t), this.inputSecondary ? this.inputSecondary.evaluate(t) : void 0);
          return e && t.availableImages && (e.available = t.availableImages.indexOf(e.namePrimary) > -1, e.nameSecondary && e.available && t.availableImages && (e.available = t.availableImages.indexOf(e.nameSecondary) > -1)), e;
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          t(this.inputPrimary), this.inputSecondary && t(this.inputSecondary);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return this.inputSecondary ? ["image", this.inputPrimary.serialize(), this.inputSecondary.serialize()] : ["image", this.inputPrimary.serialize()];
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (t.length < 2) return e.error("Expected two or more arguments.");
          var r = e.parse(t[1], 1, ei);
          if (!r) return e.error("No image name provided.");
          if (2 === t.length) return new ki(r);
          var n = e.parse(t[2], 1, ei);
          return n ? new ki(r, n) : e.error("Secondary image variant is not a string.");
        }
      }]);
      return ki;
    }();
    function Pi(t) {
      return t instanceof Number ? "number" : t instanceof String ? "string" : t instanceof Boolean ? "boolean" : Array.isArray(t) ? "array" : null === t ? "null" : typeof t;
    }
    var zi = {
      "to-boolean": ri,
      "to-color": ni,
      "to-number": ti,
      "to-string": ei
    };
    var Ei = /*#__PURE__*/function () {
      function Ei(t, e) {
        _classCallCheck(this, Ei);
        this.type = t, this.args = e;
      }
      _createClass(Ei, [{
        key: "evaluate",
        value: function evaluate(t) {
          if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t));
          if ("color" === this.type.kind) {
            var _e25, _r24;
            var _iterator16 = _createForOfIteratorHelper(this.args),
              _step16;
            try {
              for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                var _n11 = _step16.value;
                if (_e25 = _n11.evaluate(t), _r24 = null, _e25 instanceof Gn) return _e25;
                if ("string" == typeof _e25) {
                  var _r25 = t.parseColor(_e25);
                  if (_r25) return _r25;
                } else if (Array.isArray(_e25) && (_r24 = _e25.length < 3 || _e25.length > 4 ? "Invalid rbga value ".concat(JSON.stringify(_e25), ": expected an array containing either three or four numeric values.") : bi(_e25[0], _e25[1], _e25[2], _e25[3]), !_r24)) return new Gn(_e25[0] / 255, _e25[1] / 255, _e25[2] / 255, _e25[3]);
              }
            } catch (err) {
              _iterator16.e(err);
            } finally {
              _iterator16.f();
            }
            throw new Ai(_r24 || "Could not parse color from value '".concat("string" == typeof _e25 ? _e25 : String(JSON.stringify(_e25)), "'"));
          }
          if ("number" === this.type.kind) {
            var _e26 = null;
            var _iterator17 = _createForOfIteratorHelper(this.args),
              _step17;
            try {
              for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                var _r26 = _step17.value;
                if (_e26 = _r26.evaluate(t), null === _e26) return 0;
                var _n12 = Number(_e26);
                if (!isNaN(_n12)) return _n12;
              }
            } catch (err) {
              _iterator17.e(err);
            } finally {
              _iterator17.f();
            }
            throw new Ai("Could not convert ".concat(JSON.stringify(_e26), " to number."));
          }
          return "formatted" === this.type.kind ? gi.fromString(wi(this.args[0].evaluate(t))) : "resolvedImage" === this.type.kind ? xi.fromString(wi(this.args[0].evaluate(t))) : "array" === this.type.kind ? this.args.map(function (e) {
            return e.evaluate(t);
          }) : wi(this.args[0].evaluate(t));
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          this.args.forEach(t);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return this.args.every(function (t) {
            return t.outputDefined();
          });
        }
      }, {
        key: "serialize",
        value: function serialize() {
          if ("formatted" === this.type.kind) return new Ti([{
            content: this.args[0],
            scale: null,
            font: null,
            textColor: null
          }]).serialize();
          if ("resolvedImage" === this.type.kind) return new ki(this.args[0]).serialize();
          var t = "array" === this.type.kind ? [] : ["to-".concat(this.type.kind)];
          return this.eachChild(function (e) {
            t.push(e.serialize());
          }), t;
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (t.length < 2) return e.error("Expected at least one argument.");
          var r = t[0],
            n = [];
          var i = Qn;
          if ("to-array" === r) {
            if (!Array.isArray(t[1])) return null;
            var _r27 = t[1].length;
            if (e.expectedType) {
              if ("array" !== e.expectedType.kind) return e.error("Expected ".concat(e.expectedType.kind, " but found array."));
              i = ui(e.expectedType.itemType, _r27);
            } else {
              if (!(_r27 > 0 && vi(t[1][0]))) return null;
              i = ui(_i(t[1][0]), _r27);
            }
            for (var _s8 = 0; _s8 < _r27; _s8++) {
              var _r28 = t[1][_s8];
              var _a7 = void 0;
              if ("array" === Pi(_r28)) _a7 = e.parse(_r28, void 0, i.itemType);else {
                var _t25 = Pi(_r28);
                if (_t25 !== i.itemType.kind) return e.error("Expected ".concat(i.itemType.kind, " but found ").concat(_t25, "."));
                _a7 = e.registry.literal.parse(["literal", void 0 === _r28 ? null : _r28], e);
              }
              if (!_a7) return null;
              n.push(_a7);
            }
          } else {
            if (("to-boolean" === r || "to-string" === r) && 2 !== t.length) return e.error("Expected one argument.");
            i = zi[r];
            for (var _r29 = 1; _r29 < t.length; _r29++) {
              var _i12 = e.parse(t[_r29], _r29, si);
              if (!_i12) return null;
              n.push(_i12);
            }
          }
          return new Ei(i, n);
        }
      }]);
      return Ei;
    }();
    var Bi = ["Unknown", "Point", "LineString", "Polygon"];
    var Di = /*#__PURE__*/function () {
      function Di(t, e) {
        _classCallCheck(this, Di);
        this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.scope = t, this.options = e;
      }
      _createClass(Di, [{
        key: "id",
        value: function id() {
          return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
        }
      }, {
        key: "geometryType",
        value: function geometryType() {
          return this.feature ? "number" == typeof this.feature.type ? Bi[this.feature.type] : this.feature.type : null;
        }
      }, {
        key: "geometry",
        value: function geometry() {
          return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
        }
      }, {
        key: "canonicalID",
        value: function canonicalID() {
          return this.canonical;
        }
      }, {
        key: "properties",
        value: function properties() {
          return this.feature && this.feature.properties || {};
        }
      }, {
        key: "measureLight",
        value: function measureLight(t) {
          return this.globals.brightness || 0;
        }
      }, {
        key: "distanceFromCenter",
        value: function distanceFromCenter() {
          if (this.featureTileCoord && this.featureDistanceData) {
            var _t26 = this.featureDistanceData.center,
              _e27 = this.featureDistanceData.scale,
              _this$featureTileCoor = this.featureTileCoord,
              _r30 = _this$featureTileCoor.x,
              _n13 = _this$featureTileCoor.y;
            return this.featureDistanceData.bearing[0] * (_r30 * _e27 - _t26[0]) + this.featureDistanceData.bearing[1] * (_n13 * _e27 - _t26[1]);
          }
          return 0;
        }
      }, {
        key: "parseColor",
        value: function parseColor(t) {
          var e = this._parseColorCache[t];
          return e || (e = this._parseColorCache[t] = Gn.parse(t)), e;
        }
      }, {
        key: "getConfig",
        value: function getConfig(t) {
          return this.options ? this.options.get(t) : null;
        }
      }]);
      return Di;
    }();
    var Ri = /*#__PURE__*/function () {
      function Ri(t, e, r, n, i) {
        _classCallCheck(this, Ri);
        this.name = t, this.type = e, this._evaluate = r, this.args = n, this._overloadIndex = i;
      }
      _createClass(Ri, [{
        key: "evaluate",
        value: function evaluate(t) {
          if (!this._evaluate) {
            var _t27 = Ri.definitions[this.name];
            this._evaluate = Array.isArray(_t27) ? _t27[2] : _t27.overloads[this._overloadIndex][1];
          }
          return this._evaluate(t, this.args);
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          this.args.forEach(t);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return [this.name].concat(this.args.map(function (t) {
            return t.serialize();
          }));
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          var _e$errors;
          var r = t[0],
            n = Ri.definitions[r];
          if (!n) return e.error("Unknown expression \"".concat(r, "\". If you wanted a literal array, use [\"literal\", [...]]."), 0);
          var i = Array.isArray(n) ? n[0] : n.type,
            s = Array.isArray(n) ? [[n[1], n[2]]] : n.overloads,
            a = [];
          var o = null,
            l = -1;
          var _iterator18 = _createForOfIteratorHelper(s),
            _step18;
          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var _step18$value = _slicedToArray(_step18.value, 2),
                _n15 = _step18$value[0],
                _u3 = _step18$value[1];
              if (Array.isArray(_n15) && _n15.length !== t.length - 1) continue;
              a.push(_n15), l++, o = new ta(e.registry, e.path, null, e.scope, void 0, e._scope, e.options);
              var _s9 = [];
              var _c3 = !1;
              for (var _e28 = 1; _e28 < t.length; _e28++) {
                var _r33 = t[_e28],
                  _i14 = Array.isArray(_n15) ? _n15[_e28 - 1] : _n15.type,
                  _a8 = o.parse(_r33, 1 + _s9.length, _i14);
                if (!_a8) {
                  _c3 = !0;
                  break;
                }
                _s9.push(_a8);
              }
              if (!_c3) if (Array.isArray(_n15) && _n15.length !== _s9.length) o.error("Expected ".concat(_n15.length, " arguments, but found ").concat(_s9.length, " instead."));else {
                for (var _t28 = 0; _t28 < _s9.length; _t28++) {
                  var _e29 = Array.isArray(_n15) ? _n15[_t28] : _n15.type,
                    _r34 = _s9[_t28];
                  o.concat(_t28 + 1).checkSubtype(_e29, _r34.type);
                }
                if (0 === o.errors.length) return new Ri(r, i, _u3, _s9, l);
              }
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }
          if (1 === a.length) (_e$errors = e.errors).push.apply(_e$errors, _toConsumableArray(o.errors));else {
            var _r31 = (a.length ? a : s.map(function (_ref5) {
                var _ref6 = _slicedToArray(_ref5, 1),
                  t = _ref6[0];
                return t;
              })).map(Ci).join(" | "),
              _n14 = [];
            for (var _r32 = 1; _r32 < t.length; _r32++) {
              var _i13 = e.parse(t[_r32], 1 + _n14.length);
              if (!_i13) return null;
              _n14.push(ci(_i13.type));
            }
            e.error("Expected arguments of type ".concat(_r31, ", but found (").concat(_n14.join(", "), ") instead."));
          }
          return null;
        }
      }, {
        key: "register",
        value: function register(t, e) {
          Ri.definitions = e;
          for (var _r35 in e) t[_r35] = Ri;
        }
      }]);
      return Ri;
    }();
    function Ci(t) {
      return Array.isArray(t) ? "(".concat(t.map(ci).join(", "), ")") : "(".concat(ci(t.type), "...)");
    }
    var Li = /*#__PURE__*/function () {
      function Li(t, e, r) {
        _classCallCheck(this, Li);
        this.type = ai, this.locale = r, this.caseSensitive = t, this.diacriticSensitive = e;
      }
      _createClass(Li, [{
        key: "evaluate",
        value: function evaluate(t) {
          return new mi(this.caseSensitive.evaluate(t), this.diacriticSensitive.evaluate(t), this.locale ? this.locale.evaluate(t) : null);
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          t(this.caseSensitive), t(this.diacriticSensitive), this.locale && t(this.locale);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = {};
          return t["case-sensitive"] = this.caseSensitive.serialize(), t["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t.locale = this.locale.serialize()), ["collator", t];
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (2 !== t.length) return e.error("Expected one argument.");
          var r = t[1];
          if ("object" != typeof r || Array.isArray(r)) return e.error("Collator options argument must be an object.");
          var n = e.parse(void 0 !== r["case-sensitive"] && r["case-sensitive"], 1, ri);
          if (!n) return null;
          var i = e.parse(void 0 !== r["diacritic-sensitive"] && r["diacritic-sensitive"], 1, ri);
          if (!i) return null;
          var s = null;
          return r.locale && (s = e.parse(r.locale, 1, ei), !s) ? null : new Li(n, i, s);
        }
      }]);
      return Li;
    }();
    function Vi(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : t.length - 1;
      var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Oi;
      for (; n > r;) {
        if (n - r > 600) {
          var _s10 = n - r + 1,
            _a9 = e - r + 1,
            _o5 = Math.log(_s10),
            _l3 = .5 * Math.exp(2 * _o5 / 3),
            _u4 = .5 * Math.sqrt(_o5 * _l3 * (_s10 - _l3) / _s10) * (_a9 - _s10 / 2 < 0 ? -1 : 1);
          Vi(t, e, Math.max(r, Math.floor(e - _a9 * _l3 / _s10 + _u4)), Math.min(n, Math.floor(e + (_s10 - _a9) * _l3 / _s10 + _u4)), i);
        }
        var _s11 = t[e];
        var _a10 = r,
          _o6 = n;
        for (Fi(t, r, e), i(t[n], _s11) > 0 && Fi(t, r, n); _a10 < _o6;) {
          for (Fi(t, _a10, _o6), _a10++, _o6--; i(t[_a10], _s11) < 0;) _a10++;
          for (; i(t[_o6], _s11) > 0;) _o6--;
        }
        0 === i(t[r], _s11) ? Fi(t, r, _o6) : (_o6++, Fi(t, _o6, n)), _o6 <= e && (r = _o6 + 1), e <= _o6 && (n = _o6 - 1);
      }
    }
    function Fi(t, e, r) {
      var n = t[e];
      t[e] = t[r], t[r] = n;
    }
    function Oi(t, e) {
      return t < e ? -1 : t > e ? 1 : 0;
    }
    function Ui(t) {
      var e = 0;
      for (var _r36, _n16, _i15 = 0, _s12 = t.length, _a11 = _s12 - 1; _i15 < _s12; _a11 = _i15++) _r36 = t[_i15], _n16 = t[_a11], e += (_n16.x - _r36.x) * (_r36.y + _n16.y);
      return e;
    }
    function ji(t, e) {
      t[0] = Math.min(t[0], e[0]), t[1] = Math.min(t[1], e[1]), t[2] = Math.max(t[2], e[0]), t[3] = Math.max(t[3], e[1]);
    }
    function Ni(t, e) {
      return !(t[0] <= e[0] || t[2] >= e[2] || t[1] <= e[1] || t[3] >= e[3]);
    }
    function $i(t, e, r) {
      var n = t[0] - e[0],
        i = t[1] - e[1],
        s = t[0] - r[0],
        a = t[1] - r[1];
      return n * a - s * i == 0 && n * s <= 0 && i * a <= 0;
    }
    function qi(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var n = !1;
      for (var _o7 = 0, _l4 = e.length; _o7 < _l4; _o7++) {
        var _l5 = e[_o7];
        for (var _e30 = 0, _o8 = _l5.length, _u5 = _o8 - 1; _e30 < _o8; _u5 = _e30++) {
          var _o9 = _l5[_u5],
            _c4 = _l5[_e30];
          if ($i(t, _o9, _c4)) return r;
          (s = _o9)[1] > (i = t)[1] != (a = _c4)[1] > i[1] && i[0] < (a[0] - s[0]) * (i[1] - s[1]) / (a[1] - s[1]) + s[0] && (n = !n);
        }
      }
      var i, s, a;
      return n;
    }
    function Gi(t, e, r, n) {
      var i = n[0] - r[0],
        s = n[1] - r[1],
        a = (t[0] - r[0]) * s - i * (t[1] - r[1]),
        o = (e[0] - r[0]) * s - i * (e[1] - r[1]);
      return a > 0 && o < 0 || a < 0 && o > 0;
    }
    function Xi(t, e, r, n) {
      return 0 != (i = [n[0] - r[0], n[1] - r[1]])[0] * (s = [e[0] - t[0], e[1] - t[1]])[1] - i[1] * s[0] && !(!Gi(t, e, r, n) || !Gi(r, n, t, e));
      var i, s;
    }
    var Yi = 8192;
    function Zi(t, e) {
      var r = (180 + t[0]) / 360,
        n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t[1] * Math.PI / 360))) / 360,
        i = Math.pow(2, e.z);
      return [Math.round(r * i * Yi), Math.round(n * i * Yi)];
    }
    function Hi(t, e) {
      for (var _r37 = 0; _r37 < e.length; _r37++) if (qi(t, e[_r37])) return !0;
      return !1;
    }
    function Ki(t, e, r) {
      var _iterator19 = _createForOfIteratorHelper(r),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var _n17 = _step19.value;
          for (var _r38 = 0, _i16 = _n17.length, _s13 = _i16 - 1; _r38 < _i16; _s13 = _r38++) if (Xi(t, e, _n17[_s13], _n17[_r38])) return !0;
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
      return !1;
    }
    function Wi(t, e) {
      for (var _r39 = 0; _r39 < t.length; ++_r39) if (!qi(t[_r39], e)) return !1;
      for (var _r40 = 0; _r40 < t.length - 1; ++_r40) if (Ki(t[_r40], t[_r40 + 1], e)) return !1;
      return !0;
    }
    function Ji(t, e) {
      for (var _r41 = 0; _r41 < e.length; _r41++) if (Wi(t, e[_r41])) return !0;
      return !1;
    }
    function Qi(t, e, r) {
      var n = [];
      for (var _i17 = 0; _i17 < t.length; _i17++) {
        var _s14 = [];
        for (var _n18 = 0; _n18 < t[_i17].length; _n18++) {
          var _a12 = Zi(t[_i17][_n18], r);
          ji(e, _a12), _s14.push(_a12);
        }
        n.push(_s14);
      }
      return n;
    }
    function ts(t, e, r) {
      var n = [];
      for (var _i18 = 0; _i18 < t.length; _i18++) {
        var _s15 = Qi(t[_i18], e, r);
        n.push(_s15);
      }
      return n;
    }
    function es(t, e, r, n) {
      if (t[0] < r[0] || t[0] > r[2]) {
        var _e31 = .5 * n;
        var _i19 = t[0] - r[0] > _e31 ? -n : r[0] - t[0] > _e31 ? n : 0;
        0 === _i19 && (_i19 = t[0] - r[2] > _e31 ? -n : r[2] - t[0] > _e31 ? n : 0), t[0] += _i19;
      }
      ji(e, t);
    }
    function rs(t, e, r, n) {
      var i = Math.pow(2, n.z) * Yi,
        s = [n.x * Yi, n.y * Yi],
        a = [];
      if (!t) return a;
      var _iterator20 = _createForOfIteratorHelper(t),
        _step20;
      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var _n19 = _step20.value;
          var _iterator21 = _createForOfIteratorHelper(_n19),
            _step21;
          try {
            for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
              var _t29 = _step21.value;
              var _n20 = [_t29.x + s[0], _t29.y + s[1]];
              es(_n20, e, r, i), a.push(_n20);
            }
          } catch (err) {
            _iterator21.e(err);
          } finally {
            _iterator21.f();
          }
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
      return a;
    }
    function ns(t, e, r, n) {
      var i = Math.pow(2, n.z) * Yi,
        s = [n.x * Yi, n.y * Yi],
        a = [];
      if (!t) return a;
      var _iterator22 = _createForOfIteratorHelper(t),
        _step22;
      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var _r42 = _step22.value;
          var _t31 = [];
          var _iterator25 = _createForOfIteratorHelper(_r42),
            _step25;
          try {
            for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
              var _n22 = _step25.value;
              var _r43 = [_n22.x + s[0], _n22.y + s[1]];
              ji(e, _r43), _t31.push(_r43);
            }
          } catch (err) {
            _iterator25.e(err);
          } finally {
            _iterator25.f();
          }
          a.push(_t31);
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
      if (e[2] - e[0] <= i / 2) {
        (o = e)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
        var _iterator23 = _createForOfIteratorHelper(a),
          _step23;
        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var _t30 = _step23.value;
            var _iterator24 = _createForOfIteratorHelper(_t30),
              _step24;
            try {
              for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                var _n21 = _step24.value;
                es(_n21, e, r, i);
              }
            } catch (err) {
              _iterator24.e(err);
            } finally {
              _iterator24.f();
            }
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
      }
      var o;
      return a;
    }
    var is = /*#__PURE__*/function () {
      function is(t, e) {
        _classCallCheck(this, is);
        this.type = ri, this.geojson = t, this.geometries = e;
      }
      _createClass(is, [{
        key: "evaluate",
        value: function evaluate(t) {
          if (null != t.geometry() && null != t.canonicalID()) {
            if ("Point" === t.geometryType()) return function (t, e) {
              var r = [1 / 0, 1 / 0, -1 / 0, -1 / 0],
                n = [1 / 0, 1 / 0, -1 / 0, -1 / 0],
                i = t.canonicalID();
              if (!i) return !1;
              if ("Polygon" === e.type) {
                var _s16 = Qi(e.coordinates, n, i),
                  _a13 = rs(t.geometry(), r, n, i);
                if (!Ni(r, n)) return !1;
                var _iterator26 = _createForOfIteratorHelper(_a13),
                  _step26;
                try {
                  for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                    var _t32 = _step26.value;
                    if (!qi(_t32, _s16)) return !1;
                  }
                } catch (err) {
                  _iterator26.e(err);
                } finally {
                  _iterator26.f();
                }
              }
              if ("MultiPolygon" === e.type) {
                var _s17 = ts(e.coordinates, n, i),
                  _a14 = rs(t.geometry(), r, n, i);
                if (!Ni(r, n)) return !1;
                var _iterator27 = _createForOfIteratorHelper(_a14),
                  _step27;
                try {
                  for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                    var _t33 = _step27.value;
                    if (!Hi(_t33, _s17)) return !1;
                  }
                } catch (err) {
                  _iterator27.e(err);
                } finally {
                  _iterator27.f();
                }
              }
              return !0;
            }(t, this.geometries);
            if ("LineString" === t.geometryType()) return function (t, e) {
              var r = [1 / 0, 1 / 0, -1 / 0, -1 / 0],
                n = [1 / 0, 1 / 0, -1 / 0, -1 / 0],
                i = t.canonicalID();
              if (!i) return !1;
              if ("Polygon" === e.type) {
                var _s18 = Qi(e.coordinates, n, i),
                  _a15 = ns(t.geometry(), r, n, i);
                if (!Ni(r, n)) return !1;
                var _iterator28 = _createForOfIteratorHelper(_a15),
                  _step28;
                try {
                  for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                    var _t34 = _step28.value;
                    if (!Wi(_t34, _s18)) return !1;
                  }
                } catch (err) {
                  _iterator28.e(err);
                } finally {
                  _iterator28.f();
                }
              }
              if ("MultiPolygon" === e.type) {
                var _s19 = ts(e.coordinates, n, i),
                  _a16 = ns(t.geometry(), r, n, i);
                if (!Ni(r, n)) return !1;
                var _iterator29 = _createForOfIteratorHelper(_a16),
                  _step29;
                try {
                  for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
                    var _t35 = _step29.value;
                    if (!Ji(_t35, _s19)) return !1;
                  }
                } catch (err) {
                  _iterator29.e(err);
                } finally {
                  _iterator29.f();
                }
              }
              return !0;
            }(t, this.geometries);
          }
          return !1;
        }
      }, {
        key: "eachChild",
        value: function eachChild() {}
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !0;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return ["within", this.geojson];
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (2 !== t.length) return e.error("'within' expression requires exactly one argument, but found ".concat(t.length - 1, " instead."));
          if (vi(t[1])) {
            var _e32 = t[1];
            if ("FeatureCollection" === _e32.type) for (var _t36 = 0; _t36 < _e32.features.length; ++_t36) {
              var _r44 = _e32.features[_t36].geometry.type;
              if ("Polygon" === _r44 || "MultiPolygon" === _r44) return new is(_e32, _e32.features[_t36].geometry);
            } else if ("Feature" === _e32.type) {
              var _t37 = _e32.geometry.type;
              if ("Polygon" === _t37 || "MultiPolygon" === _t37) return new is(_e32, _e32.geometry);
            } else if ("Polygon" === _e32.type || "MultiPolygon" === _e32.type) return new is(_e32, _e32);
          }
          return e.error("'within' expression requires valid geojson object that contains polygon geometry type.");
        }
      }]);
      return is;
    }();
    var ss = {
        kilometers: 1,
        miles: 1e3 / 1609.344,
        nauticalmiles: 1e3 / 1852,
        meters: 1e3,
        metres: 1e3,
        yards: 1e3 / .9144,
        feet: 1e3 / .3048,
        inches: 1e3 / .0254
      },
      as = 1 / 298.257223563,
      os = as * (2 - as),
      ls = Math.PI / 180;
    var us = /*#__PURE__*/function () {
      function us(t, e) {
        _classCallCheck(this, us);
        if (void 0 === t) throw new Error("No latitude given.");
        if (e && !ss[e]) throw new Error("Unknown unit ".concat(e, ". Use one of: ").concat(Object.keys(ss).join(", ")));
        var r = 6378.137 * ls * (e ? ss[e] : 1),
          n = Math.cos(t * ls),
          i = 1 / (1 - os * (1 - n * n)),
          s = Math.sqrt(i);
        this.kx = r * s * n, this.ky = r * s * i * (1 - os);
      }
      _createClass(us, [{
        key: "distance",
        value: function distance(t, e) {
          var r = ps(t[0] - e[0]) * this.kx,
            n = (t[1] - e[1]) * this.ky;
          return Math.sqrt(r * r + n * n);
        }
      }, {
        key: "bearing",
        value: function bearing(t, e) {
          var r = ps(e[0] - t[0]) * this.kx;
          return Math.atan2(r, (e[1] - t[1]) * this.ky) / ls;
        }
      }, {
        key: "destination",
        value: function destination(t, e, r) {
          var n = r * ls;
          return this.offset(t, Math.sin(n) * e, Math.cos(n) * e);
        }
      }, {
        key: "offset",
        value: function offset(t, e, r) {
          return [t[0] + e / this.kx, t[1] + r / this.ky];
        }
      }, {
        key: "lineDistance",
        value: function lineDistance(t) {
          var e = 0;
          for (var _r45 = 0; _r45 < t.length - 1; _r45++) e += this.distance(t[_r45], t[_r45 + 1]);
          return e;
        }
      }, {
        key: "area",
        value: function area(t) {
          var e = 0;
          for (var _r46 = 0; _r46 < t.length; _r46++) {
            var _n23 = t[_r46];
            for (var _t38 = 0, _i20 = _n23.length, _s20 = _i20 - 1; _t38 < _i20; _s20 = _t38++) e += ps(_n23[_t38][0] - _n23[_s20][0]) * (_n23[_t38][1] + _n23[_s20][1]) * (_r46 ? -1 : 1);
          }
          return Math.abs(e) / 2 * this.kx * this.ky;
        }
      }, {
        key: "along",
        value: function along(t, e) {
          var r = 0;
          if (e <= 0) return t[0];
          for (var _n24 = 0; _n24 < t.length - 1; _n24++) {
            var _i21 = t[_n24],
              _s21 = t[_n24 + 1],
              _a17 = this.distance(_i21, _s21);
            if (r += _a17, r > e) return hs(_i21, _s21, (e - (r - _a17)) / _a17);
          }
          return t[t.length - 1];
        }
      }, {
        key: "pointToSegmentDistance",
        value: function pointToSegmentDistance(t, e, r) {
          var _e33 = _slicedToArray(e, 2),
            n = _e33[0],
            i = _e33[1],
            s = ps(r[0] - n) * this.kx,
            a = (r[1] - i) * this.ky;
          if (0 !== s || 0 !== a) {
            var _e34 = (ps(t[0] - n) * this.kx * s + (t[1] - i) * this.ky * a) / (s * s + a * a);
            _e34 > 1 ? (n = r[0], i = r[1]) : _e34 > 0 && (n += s / this.kx * _e34, i += a / this.ky * _e34);
          }
          return s = ps(t[0] - n) * this.kx, a = (t[1] - i) * this.ky, Math.sqrt(s * s + a * a);
        }
      }, {
        key: "pointOnLine",
        value: function pointOnLine(t, e) {
          var r = 1 / 0,
            n = t[0][0],
            i = t[0][1],
            s = 0,
            a = 0;
          for (var _o10 = 0; _o10 < t.length - 1; _o10++) {
            var _l6 = t[_o10][0],
              _u6 = t[_o10][1],
              _c5 = ps(t[_o10 + 1][0] - _l6) * this.kx,
              _h3 = (t[_o10 + 1][1] - _u6) * this.ky,
              _p3 = 0;
            0 === _c5 && 0 === _h3 || (_p3 = (ps(e[0] - _l6) * this.kx * _c5 + (e[1] - _u6) * this.ky * _h3) / (_c5 * _c5 + _h3 * _h3), _p3 > 1 ? (_l6 = t[_o10 + 1][0], _u6 = t[_o10 + 1][1]) : _p3 > 0 && (_l6 += _c5 / this.kx * _p3, _u6 += _h3 / this.ky * _p3)), _c5 = ps(e[0] - _l6) * this.kx, _h3 = (e[1] - _u6) * this.ky;
            var _f3 = _c5 * _c5 + _h3 * _h3;
            _f3 < r && (r = _f3, n = _l6, i = _u6, s = _o10, a = _p3);
          }
          return {
            point: [n, i],
            index: s,
            t: Math.max(0, Math.min(1, a))
          };
        }
      }, {
        key: "lineSlice",
        value: function lineSlice(t, e, r) {
          var n = this.pointOnLine(r, t),
            i = this.pointOnLine(r, e);
          if (n.index > i.index || n.index === i.index && n.t > i.t) {
            var _t39 = n;
            n = i, i = _t39;
          }
          var s = [n.point],
            a = n.index + 1,
            o = i.index;
          !cs(r[a], s[0]) && a <= o && s.push(r[a]);
          for (var _t40 = a + 1; _t40 <= o; _t40++) s.push(r[_t40]);
          return cs(r[o], i.point) || s.push(i.point), s;
        }
      }, {
        key: "lineSliceAlong",
        value: function lineSliceAlong(t, e, r) {
          var n = 0;
          var i = [];
          for (var _s22 = 0; _s22 < r.length - 1; _s22++) {
            var _a18 = r[_s22],
              _o11 = r[_s22 + 1],
              _l7 = this.distance(_a18, _o11);
            if (n += _l7, n > t && 0 === i.length && i.push(hs(_a18, _o11, (t - (n - _l7)) / _l7)), n >= e) return i.push(hs(_a18, _o11, (e - (n - _l7)) / _l7)), i;
            n > t && i.push(_o11);
          }
          return i;
        }
      }, {
        key: "bufferPoint",
        value: function bufferPoint(t, e) {
          var r = e / this.ky,
            n = e / this.kx;
          return [t[0] - n, t[1] - r, t[0] + n, t[1] + r];
        }
      }, {
        key: "bufferBBox",
        value: function bufferBBox(t, e) {
          var r = e / this.ky,
            n = e / this.kx;
          return [t[0] - n, t[1] - r, t[2] + n, t[3] + r];
        }
      }, {
        key: "insideBBox",
        value: function insideBBox(t, e) {
          return ps(t[0] - e[0]) >= 0 && ps(t[0] - e[2]) <= 0 && t[1] >= e[1] && t[1] <= e[3];
        }
      }], [{
        key: "fromTile",
        value: function fromTile(t, e, r) {
          var n = Math.PI * (1 - 2 * (t + .5) / Math.pow(2, e)),
            i = Math.atan(.5 * (Math.exp(n) - Math.exp(-n))) / ls;
          return new us(i, r);
        }
      }, {
        key: "units",
        get: function get() {
          return ss;
        }
      }]);
      return us;
    }();
    function cs(t, e) {
      return t[0] === e[0] && t[1] === e[1];
    }
    function hs(t, e, r) {
      var n = ps(e[0] - t[0]);
      return [t[0] + n * r, t[1] + (e[1] - t[1]) * r];
    }
    function ps(t) {
      for (; t < -180;) t += 360;
      for (; t > 180;) t -= 360;
      return t;
    }
    var fs = /*#__PURE__*/function () {
      function fs() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (t, e) {
          return t < e ? -1 : t > e ? 1 : 0;
        };
        _classCallCheck(this, fs);
        if (this.data = t, this.length = this.data.length, this.compare = e, this.length > 0) for (var _t41 = (this.length >> 1) - 1; _t41 >= 0; _t41--) this._down(_t41);
      }
      _createClass(fs, [{
        key: "push",
        value: function push(t) {
          this.data.push(t), this._up(this.length++);
        }
      }, {
        key: "pop",
        value: function pop() {
          if (0 === this.length) return;
          var t = this.data[0],
            e = this.data.pop();
          return --this.length > 0 && (this.data[0] = e, this._down(0)), t;
        }
      }, {
        key: "peek",
        value: function peek() {
          return this.data[0];
        }
      }, {
        key: "_up",
        value: function _up(t) {
          var e = this.data,
            r = this.compare,
            n = e[t];
          for (; t > 0;) {
            var _i22 = t - 1 >> 1,
              _s23 = e[_i22];
            if (r(n, _s23) >= 0) break;
            e[t] = _s23, t = _i22;
          }
          e[t] = n;
        }
      }, {
        key: "_down",
        value: function _down(t) {
          var e = this.data,
            r = this.compare,
            n = this.length >> 1,
            i = e[t];
          for (; t < n;) {
            var _n25 = 1 + (t << 1);
            var _s24 = _n25 + 1;
            if (_s24 < this.length && r(e[_s24], e[_n25]) < 0 && (_n25 = _s24), r(e[_n25], i) >= 0) break;
            e[t] = e[_n25], t = _n25;
          }
          e[t] = i;
        }
      }]);
      return fs;
    }();
    var ds = 8192;
    function ms(t, e) {
      return e.dist - t.dist;
    }
    var ys = 100,
      gs = 50;
    function xs(t) {
      var e = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
      if (e.length !== t.length) return !1;
      for (var _r47 = 0; _r47 < e.length; _r47++) if (e[_r47] !== t[_r47]) return !1;
      return !0;
    }
    function bs(t) {
      return t[1] - t[0] + 1;
    }
    function vs(t, e) {
      var r = t[1] >= t[0] && t[1] < e;
      return r || console.warn("Distance Expression: Index is out of range"), r;
    }
    function _s(t, e) {
      if (t[0] > t[1]) return [null, null];
      var r = bs(t);
      if (e) {
        if (2 === r) return [t, null];
        var _e35 = Math.floor(r / 2);
        return [[t[0], t[0] + _e35], [t[0] + _e35, t[1]]];
      }
      {
        if (1 === r) return [t, null];
        var _e36 = Math.floor(r / 2) - 1;
        return [[t[0], t[0] + _e36], [t[0] + _e36 + 1, t[1]]];
      }
    }
    function ws(t, e) {
      var r = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
      if (!vs(e, t.length)) return r;
      for (var _n26 = e[0]; _n26 <= e[1]; ++_n26) ji(r, t[_n26]);
      return r;
    }
    function Ms(t) {
      var e = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
      for (var _r48 = 0; _r48 < t.length; ++_r48) for (var _n27 = 0; _n27 < t[_r48].length; ++_n27) ji(e, t[_r48][_n27]);
      return e;
    }
    function As(t, e, r) {
      if (xs(t) || xs(e)) return NaN;
      var n = 0,
        i = 0;
      return t[2] < e[0] && (n = e[0] - t[2]), t[0] > e[2] && (n = t[0] - e[2]), t[1] > e[3] && (i = t[1] - e[3]), t[3] < e[1] && (i = e[1] - t[3]), r.distance([0, 0], [n, i]);
    }
    function Ss(t) {
      return 360 * t - 180;
    }
    function Is(t) {
      return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t) * Math.PI / 180)) - 90;
    }
    function Ts(t, e) {
      var r = Math.pow(2, e.z),
        n = (t.y / ds + e.y) / r;
      return [Ss((t.x / ds + e.x) / r), Is(n)];
    }
    function ks(t, e) {
      var r = [];
      for (var _n28 = 0; _n28 < t.length; ++_n28) r.push(Ts(t[_n28], e));
      return r;
    }
    function Ps(t, e, r) {
      var n = r.pointOnLine(e, t).point;
      return r.distance(t, n);
    }
    function zs(t, e, r, n, i) {
      var s = r.slice(n[0], n[1] + 1);
      var a = 1 / 0;
      for (var _r49 = e[0]; _r49 <= e[1]; ++_r49) if (0 === (a = Math.min(a, Ps(t[_r49], s, i)))) return 0;
      return a;
    }
    function Es(t, e, r, n, i) {
      var s = Math.min(i.pointToSegmentDistance(t, r, n), i.pointToSegmentDistance(e, r, n)),
        a = Math.min(i.pointToSegmentDistance(r, t, e), i.pointToSegmentDistance(n, t, e));
      return Math.min(s, a);
    }
    function Bs(t, e, r, n, i) {
      if (!vs(e, t.length) || !vs(n, r.length)) return NaN;
      var s = 1 / 0;
      for (var _a19 = e[0]; _a19 < e[1]; ++_a19) for (var _e37 = n[0]; _e37 < n[1]; ++_e37) {
        if (Xi(t[_a19], t[_a19 + 1], r[_e37], r[_e37 + 1])) return 0;
        s = Math.min(s, Es(t[_a19], t[_a19 + 1], r[_e37], r[_e37 + 1], i));
      }
      return s;
    }
    function Ds(t, e, r, n, i) {
      if (!vs(e, t.length) || !vs(n, r.length)) return NaN;
      var s = 1 / 0;
      for (var _a20 = e[0]; _a20 <= e[1]; ++_a20) for (var _e38 = n[0]; _e38 <= n[1]; ++_e38) if (0 === (s = Math.min(s, i.distance(t[_a20], r[_e38])))) return s;
      return s;
    }
    function Rs(t, e, r) {
      if (qi(t, e, !0)) return 0;
      var n = 1 / 0;
      var _iterator30 = _createForOfIteratorHelper(e),
        _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var _i23 = _step30.value;
          var _e39 = _i23.length;
          if (_e39 < 2) return console.warn("Distance Expression: Invalid polygon!"), NaN;
          if (_i23[0] !== _i23[_e39 - 1] && 0 === (n = Math.min(n, r.pointToSegmentDistance(t, _i23[_e39 - 1], _i23[0])))) return n;
          if (0 === (n = Math.min(n, Ps(t, _i23, r)))) return n;
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
      return n;
    }
    function Cs(t, e, r, n) {
      if (!vs(e, t.length)) return NaN;
      for (var _n29 = e[0]; _n29 <= e[1]; ++_n29) if (qi(t[_n29], r, !0)) return 0;
      var i = 1 / 0;
      for (var _s25 = e[0]; _s25 < e[1]; ++_s25) {
        var _iterator31 = _createForOfIteratorHelper(r),
          _step31;
        try {
          for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
            var _e40 = _step31.value;
            for (var _r50 = 0, _a21 = _e40.length, _o12 = _a21 - 1; _r50 < _a21; _o12 = _r50++) {
              if (Xi(t[_s25], t[_s25 + 1], _e40[_o12], _e40[_r50])) return 0;
              i = Math.min(i, Es(t[_s25], t[_s25 + 1], _e40[_o12], _e40[_r50], n));
            }
          }
        } catch (err) {
          _iterator31.e(err);
        } finally {
          _iterator31.f();
        }
      }
      return i;
    }
    function Ls(t, e) {
      var _iterator32 = _createForOfIteratorHelper(t),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var _r51 = _step32.value;
          for (var _t42 = 0; _t42 <= _r51.length - 1; ++_t42) if (qi(_r51[_t42], e, !0)) return !0;
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
      return !1;
    }
    function Vs(t, e, r) {
      var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1 / 0;
      var i = Ms(t),
        s = Ms(e);
      if (n !== 1 / 0 && As(i, s, r) >= n) return n;
      if (Ni(i, s)) {
        if (Ls(t, e)) return 0;
      } else if (Ls(e, t)) return 0;
      var a = n;
      var _iterator33 = _createForOfIteratorHelper(t),
        _step33;
      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var _n30 = _step33.value;
          for (var _t43 = 0, _i24 = _n30.length, _s26 = _i24 - 1; _t43 < _i24; _s26 = _t43++) {
            var _iterator34 = _createForOfIteratorHelper(e),
              _step34;
            try {
              for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
                var _i25 = _step34.value;
                for (var _e41 = 0, _o13 = _i25.length, _l8 = _o13 - 1; _e41 < _o13; _l8 = _e41++) {
                  if (Xi(_n30[_s26], _n30[_t43], _i25[_l8], _i25[_e41])) return 0;
                  a = Math.min(a, Es(_n30[_s26], _n30[_t43], _i25[_l8], _i25[_e41], r));
                }
              }
            } catch (err) {
              _iterator34.e(err);
            } finally {
              _iterator34.f();
            }
          }
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
      return a;
    }
    function Fs(t, e, r, n, i, s, a) {
      if (null === s || null === a) return;
      var o = As(ws(n, s), ws(i, a), r);
      o < e && t.push({
        dist: o,
        range1: s,
        range2: a
      });
    }
    function Os(t, e, r, n) {
      var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1 / 0;
      var s = Math.min(n.distance(t[0], r[0][0]), i);
      if (0 === s) return s;
      var a = new fs([{
          dist: 0,
          range1: [0, t.length - 1],
          range2: [0, 0]
        }], ms),
        o = e ? gs : ys,
        l = Ms(r);
      for (; a.length;) {
        var _i26 = a.pop();
        if (_i26.dist >= s) continue;
        var _u7 = _i26.range1;
        if (bs(_u7) <= o) {
          if (!vs(_u7, t.length)) return NaN;
          if (e) {
            var _e42 = Cs(t, _u7, r, n);
            if (0 === (s = Math.min(s, _e42))) return s;
          } else for (var _e43 = _u7[0]; _e43 <= _u7[1]; ++_e43) {
            var _i27 = Rs(t[_e43], r, n);
            if (0 === (s = Math.min(s, _i27))) return s;
          }
        } else {
          var _r52 = _s(_u7, e);
          if (null !== _r52[0]) {
            var _e44 = As(ws(t, _r52[0]), l, n);
            _e44 < s && a.push({
              dist: _e44,
              range1: _r52[0],
              range2: [0, 0]
            });
          }
          if (null !== _r52[1]) {
            var _e45 = As(ws(t, _r52[1]), l, n);
            _e45 < s && a.push({
              dist: _e45,
              range1: _r52[1],
              range2: [0, 0]
            });
          }
        }
      }
      return s;
    }
    function Us(t, e, r, n, i) {
      var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1 / 0;
      var a = Math.min(s, i.distance(t[0], r[0]));
      if (0 === a) return a;
      var o = new fs([{
          dist: 0,
          range1: [0, t.length - 1],
          range2: [0, r.length - 1]
        }], ms),
        l = e ? gs : ys,
        u = n ? gs : ys;
      for (; o.length;) {
        var _s27 = o.pop();
        if (_s27.dist >= a) continue;
        var _c6 = _s27.range1,
          _h4 = _s27.range2;
        if (bs(_c6) <= l && bs(_h4) <= u) {
          if (!vs(_c6, t.length) || !vs(_h4, r.length)) return NaN;
          if (e && n ? a = Math.min(a, Bs(t, _c6, r, _h4, i)) : e || n ? e && !n ? a = Math.min(a, zs(r, _h4, t, _c6, i)) : !e && n && (a = Math.min(a, zs(t, _c6, r, _h4, i))) : a = Math.min(a, Ds(t, _c6, r, _h4, i)), 0 === a) return a;
        } else {
          var _s28 = _s(_c6, e),
            _l9 = _s(_h4, n);
          Fs(o, a, i, t, r, _s28[0], _l9[0]), Fs(o, a, i, t, r, _s28[0], _l9[1]), Fs(o, a, i, t, r, _s28[1], _l9[0]), Fs(o, a, i, t, r, _s28[1], _l9[1]);
        }
      }
      return a;
    }
    function js(t, e, r, n) {
      var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1 / 0;
      var s = i;
      var a = ws(t, [0, t.length - 1]);
      var _iterator35 = _createForOfIteratorHelper(r),
        _step35;
      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var _i28 = _step35.value;
          if (!(s !== 1 / 0 && As(a, ws(_i28, [0, _i28.length - 1]), n) >= s) && (s = Math.min(s, Us(t, e, _i28, !0, n, s)), 0 === s)) return s;
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
      return s;
    }
    function Ns(t, e, r, n) {
      var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1 / 0;
      var s = i;
      var a = ws(t, [0, t.length - 1]);
      var _iterator36 = _createForOfIteratorHelper(r),
        _step36;
      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var _i29 = _step36.value;
          if (s !== 1 / 0 && As(a, Ms(_i29), n) >= s) continue;
          var _r53 = Os(t, e, _i29, n, s);
          if (isNaN(_r53)) return _r53;
          if (0 === (s = Math.min(s, _r53))) return s;
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
      return s;
    }
    function $s(t) {
      return "Point" === t || "MultiPoint" === t || "LineString" === t || "MultiLineString" === t || "Polygon" === t || "MultiPolygon" === t;
    }
    var qs = /*#__PURE__*/function () {
      function qs(t, e) {
        _classCallCheck(this, qs);
        this.type = ti, this.geojson = t, this.geometries = e;
      }
      _createClass(qs, [{
        key: "evaluate",
        value: function evaluate(t) {
          var e = t.geometry(),
            r = t.canonicalID();
          if (null != e && null != r) {
            if ("Point" === t.geometryType()) return function (t, e, r) {
              var n = [];
              var _iterator37 = _createForOfIteratorHelper(t),
                _step37;
              try {
                for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
                  var _r54 = _step37.value;
                  var _iterator38 = _createForOfIteratorHelper(_r54),
                    _step38;
                  try {
                    for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
                      var _t44 = _step38.value;
                      n.push(Ts(_t44, e));
                    }
                  } catch (err) {
                    _iterator38.e(err);
                  } finally {
                    _iterator38.f();
                  }
                }
              } catch (err) {
                _iterator37.e(err);
              } finally {
                _iterator37.f();
              }
              var i = new us(n[0][1], "meters");
              return "Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type ? Us(n, !1, "Point" === r.type ? [r.coordinates] : r.coordinates, "LineString" === r.type, i) : "MultiLineString" === r.type ? js(n, !1, r.coordinates, i) : "Polygon" === r.type || "MultiPolygon" === r.type ? Ns(n, !1, "Polygon" === r.type ? [r.coordinates] : r.coordinates, i) : null;
            }(e, r, this.geometries);
            if ("LineString" === t.geometryType()) return function (t, e, r) {
              var n = [];
              var _iterator39 = _createForOfIteratorHelper(t),
                _step39;
              try {
                for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                  var _r55 = _step39.value;
                  var _t47 = [];
                  var _iterator40 = _createForOfIteratorHelper(_r55),
                    _step40;
                  try {
                    for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
                      var _n31 = _step40.value;
                      _t47.push(Ts(_n31, e));
                    }
                  } catch (err) {
                    _iterator40.e(err);
                  } finally {
                    _iterator40.f();
                  }
                  n.push(_t47);
                }
              } catch (err) {
                _iterator39.e(err);
              } finally {
                _iterator39.f();
              }
              var i = new us(n[0][0][1], "meters");
              if ("Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type) return js("Point" === r.type ? [r.coordinates] : r.coordinates, "LineString" === r.type, n, i);
              if ("MultiLineString" === r.type) {
                var _t45 = 1 / 0;
                for (var _e46 = 0; _e46 < r.coordinates.length; _e46++) {
                  var _s29 = js(r.coordinates[_e46], !0, n, i, _t45);
                  if (isNaN(_s29)) return _s29;
                  if (0 === (_t45 = Math.min(_t45, _s29))) return _t45;
                }
                return _t45;
              }
              if ("Polygon" === r.type || "MultiPolygon" === r.type) {
                var _t46 = 1 / 0;
                for (var _e47 = 0; _e47 < n.length; _e47++) {
                  var _s30 = Ns(n[_e47], !0, "Polygon" === r.type ? [r.coordinates] : r.coordinates, i, _t46);
                  if (isNaN(_s30)) return _s30;
                  if (0 === (_t46 = Math.min(_t46, _s30))) return _t46;
                }
                return _t46;
              }
              return null;
            }(e, r, this.geometries);
            if ("Polygon" === t.geometryType()) return function (t, e, r) {
              var n = [];
              var _iterator41 = _createForOfIteratorHelper(function (t, e) {
                  var r = t.length;
                  if (r <= 1) return [t];
                  var n = [];
                  var i, s;
                  for (var _e50 = 0; _e50 < r; _e50++) {
                    var _r56 = Ui(t[_e50]);
                    0 !== _r56 && (t[_e50].area = Math.abs(_r56), void 0 === s && (s = _r56 < 0), s === _r56 < 0 ? (i && n.push(i), i = [t[_e50]]) : i.push(t[_e50]));
                  }
                  return i && n.push(i), n;
                }(t)),
                _step41;
              try {
                for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
                  var _r57 = _step41.value;
                  var _t50 = [];
                  for (var _n32 = 0; _n32 < _r57.length; ++_n32) _t50.push(ks(_r57[_n32], e));
                  n.push(_t50);
                }
              } catch (err) {
                _iterator41.e(err);
              } finally {
                _iterator41.f();
              }
              var i = new us(n[0][0][0][1], "meters");
              if ("Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type) return Ns("Point" === r.type ? [r.coordinates] : r.coordinates, "LineString" === r.type, n, i);
              if ("MultiLineString" === r.type) {
                var _t48 = 1 / 0;
                for (var _e48 = 0; _e48 < r.coordinates.length; _e48++) {
                  var _s31 = Ns(r.coordinates[_e48], !0, n, i, _t48);
                  if (isNaN(_s31)) return _s31;
                  if (0 === (_t48 = Math.min(_t48, _s31))) return _t48;
                }
                return _t48;
              }
              return "Polygon" === r.type || "MultiPolygon" === r.type ? function (t, e, r) {
                var n = 1 / 0;
                var _iterator42 = _createForOfIteratorHelper(t),
                  _step42;
                try {
                  for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
                    var _i30 = _step42.value;
                    var _iterator43 = _createForOfIteratorHelper(e),
                      _step43;
                    try {
                      for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
                        var _t49 = _step43.value;
                        var _e49 = Vs(_i30, _t49, r, n);
                        if (isNaN(_e49)) return _e49;
                        if (0 === (n = Math.min(n, _e49))) return n;
                      }
                    } catch (err) {
                      _iterator43.e(err);
                    } finally {
                      _iterator43.f();
                    }
                  }
                } catch (err) {
                  _iterator42.e(err);
                } finally {
                  _iterator42.f();
                }
                return n;
              }("Polygon" === r.type ? [r.coordinates] : r.coordinates, n, i) : null;
            }(e, r, this.geometries);
            console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
          } else console.warn("Distance Expression: requirs valid feature and canonical information.");
          return null;
        }
      }, {
        key: "eachChild",
        value: function eachChild() {}
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !0;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return ["distance", this.geojson];
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (2 !== t.length) return e.error("'distance' expression requires either one argument, but found ' ".concat(t.length - 1, " instead."));
          if (vi(t[1])) {
            var _e51 = t[1];
            if ("FeatureCollection" === _e51.type) {
              for (var _t51 = 0; _t51 < _e51.features.length; ++_t51) if ($s(_e51.features[_t51].geometry.type)) return new qs(_e51, _e51.features[_t51].geometry);
            } else if ("Feature" === _e51.type) {
              if ($s(_e51.geometry.type)) return new qs(_e51, _e51.geometry);
            } else if ($s(_e51.type)) return new qs(_e51, _e51);
          }
          return e.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
        }
      }]);
      return qs;
    }();
    function Gs(t, e) {
      switch (t) {
        case "string":
          return wi(e);
        case "number":
          return +e;
        case "boolean":
          return !!e;
        case "color":
          return Gn.parse(e);
        case "formatted":
          return gi.fromString(wi(e));
        case "resolvedImage":
          return xi.fromString(wi(e));
      }
      return e;
    }
    function Xs(t, e, r, n) {
      return void 0 !== n && (t = n * Math.round(t / n)), void 0 !== e && t < e && (t = e), void 0 !== r && t > r && (t = r), t;
    }
    var Ys = /*#__PURE__*/function () {
      function Ys(t, e, r) {
        _classCallCheck(this, Ys);
        this.type = t, this.key = e, this.scope = r;
      }
      _createClass(Ys, [{
        key: "evaluate",
        value: function evaluate(t) {
          var e = [this.key, this.scope, t.scope].filter(Boolean).join(""),
            r = t.getConfig(e);
          if (!r) return null;
          var n = r.type,
            i = r.value,
            s = r.values,
            a = r.minValue,
            o = r.maxValue,
            l = r.stepValue,
            u = r.default.evaluate(t);
          var c = u;
          if (i) {
            var _e52 = t.scope;
            t.scope = (_e52 || "").split("").slice(1).join(""), c = i.evaluate(t), t.scope = _e52;
          }
          return n && (c = Gs(n, c)), void 0 === c || void 0 === a && void 0 === o && void 0 === l || ("number" == typeof c ? c = Xs(c, a, o, l) : Array.isArray(c) && (c = c.map(function (t) {
            return "number" == typeof t ? Xs(t, a, o, l) : t;
          }))), void 0 !== i && void 0 !== c && s && !s.includes(c) && (c = u, n && (c = Gs(n, c))), (n && n !== this.type || void 0 !== c && _i(c) !== this.type) && (c = Gs(this.type.kind, c)), c;
        }
      }, {
        key: "eachChild",
        value: function eachChild() {}
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = ["config", this.key];
          return this.scope && t.concat(this.key), t;
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          var r = e.expectedType;
          if (null == r && (r = si), t.length < 2 || t.length > 3) return e.error("Invalid number of arguments for 'config' expression.");
          var n = e.parse(t[1], 1);
          if (!(n instanceof Mi)) return e.error("Key name of 'config' expression must be a string literal.");
          if (t.length >= 3) {
            var _i31 = e.parse(t[2], 2);
            return _i31 instanceof Mi ? new Ys(r, wi(n.value), wi(_i31.value)) : e.error("Scope of 'config' expression must be a string literal.");
          }
          return new Ys(r, wi(n.value));
        }
      }]);
      return Ys;
    }();
    function Zs(t) {
      if (t instanceof Ri) {
        if ("get" === t.name && 1 === t.args.length) return !1;
        if ("feature-state" === t.name) return !1;
        if ("has" === t.name && 1 === t.args.length) return !1;
        if ("properties" === t.name || "geometry-type" === t.name || "id" === t.name) return !1;
        if (/^filter-/.test(t.name)) return !1;
      }
      if (t instanceof is) return !1;
      if (t instanceof qs) return !1;
      var e = !0;
      return t.eachChild(function (t) {
        e && !Zs(t) && (e = !1);
      }), e;
    }
    function Hs(t) {
      if (t instanceof Ri && "feature-state" === t.name) return !1;
      var e = !0;
      return t.eachChild(function (t) {
        e && !Hs(t) && (e = !1);
      }), e;
    }
    function Ks(t) {
      if (t instanceof Ys) return new Set([t.key]);
      var e = new Set();
      return t.eachChild(function (t) {
        e = new Set([].concat(_toConsumableArray(e), _toConsumableArray(Ks(t))));
      }), e;
    }
    function Ws(t, e) {
      if (t instanceof Ri && e.indexOf(t.name) >= 0) return !1;
      var r = !0;
      return t.eachChild(function (t) {
        r && !Ws(t, e) && (r = !1);
      }), r;
    }
    var Js = /*#__PURE__*/function () {
      function Js(t, e) {
        _classCallCheck(this, Js);
        this.type = e.type, this.name = t, this.boundExpression = e;
      }
      _createClass(Js, [{
        key: "evaluate",
        value: function evaluate(t) {
          return this.boundExpression.evaluate(t);
        }
      }, {
        key: "eachChild",
        value: function eachChild() {}
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return ["var", this.name];
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (2 !== t.length || "string" != typeof t[1]) return e.error("'var' expression requires exactly one string literal argument.");
          var r = t[1];
          return e.scope.has(r) ? new Js(r, e.scope.get(r)) : e.error("Unknown variable \"".concat(r, "\". Make sure \"").concat(r, "\" has been bound in an enclosing \"let\" expression before using it."), 1);
        }
      }]);
      return Js;
    }();
    var Qs = /*#__PURE__*/function () {
      function Qs(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var r = arguments.length > 2 ? arguments[2] : undefined;
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Jn();
        var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var s = arguments.length > 5 ? arguments[5] : undefined;
        var a = arguments.length > 6 ? arguments[6] : undefined;
        _classCallCheck(this, Qs);
        this.registry = t, this.path = e, this.key = e.map(function (t) {
          return "[".concat(t, "]");
        }).join(""), this.scope = n, this.errors = i, this.expectedType = r, this._scope = s, this.options = a;
      }
      _createClass(Qs, [{
        key: "parse",
        value: function parse(t, e, r, n) {
          var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
          return e || r ? this.concat(e, r, n)._parse(t, i) : this._parse(t, i);
        }
      }, {
        key: "_parse",
        value: function _parse(t, e) {
          function r(t, e, r) {
            return "assert" === r ? new Ii(e, [t]) : "coerce" === r ? new Ei(e, [t]) : t;
          }
          if (null !== t && "string" != typeof t && "boolean" != typeof t && "number" != typeof t || (t = ["literal", t]), Array.isArray(t)) {
            if (0 === t.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
            var _n33 = "string" == typeof t[0] ? this.registry[t[0]] : void 0;
            if (_n33) {
              var _i32 = _n33.parse(t, this);
              if (!_i32) return null;
              if (this.expectedType) {
                var _t52 = this.expectedType,
                  _n34 = _i32.type;
                if ("string" !== _t52.kind && "number" !== _t52.kind && "boolean" !== _t52.kind && "object" !== _t52.kind && "array" !== _t52.kind || "value" !== _n34.kind) {
                  if ("color" !== _t52.kind && "formatted" !== _t52.kind && "resolvedImage" !== _t52.kind || "value" !== _n34.kind && "string" !== _n34.kind) {
                    if (this.checkSubtype(_t52, _n34)) return null;
                  } else _i32 = r(_i32, _t52, e.typeAnnotation || "coerce");
                } else _i32 = r(_i32, _t52, e.typeAnnotation || "assert");
              }
              if (!(_i32 instanceof Mi) && "resolvedImage" !== _i32.type.kind && ea(_i32)) {
                var _t53 = new Di(this._scope, this.options);
                try {
                  _i32 = new Mi(_i32.type, _i32.evaluate(_t53));
                } catch (t) {
                  return this.error(t.message), null;
                }
              }
              return _i32;
            }
            return Ei.parse(["to-array", t], this);
          }
          return this.error(void 0 === t ? "'undefined' value invalid. Use null instead." : "object" == typeof t ? 'Bare objects invalid. Use ["literal", {...}] instead.' : "Expected an array, but found ".concat(typeof t, " instead."));
        }
      }, {
        key: "concat",
        value: function concat(t, e, r) {
          var n = "number" == typeof t ? this.path.concat(t) : this.path,
            i = r ? this.scope.concat(r) : this.scope;
          return new Qs(this.registry, n, e || null, i, this.errors, this._scope, this.options);
        }
      }, {
        key: "error",
        value: function error(t) {
          for (var _len3 = arguments.length, e = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            e[_key3 - 1] = arguments[_key3];
          }
          var r = "".concat(this.key).concat(e.map(function (t) {
            return "[".concat(t, "]");
          }).join(""));
          this.errors.push(new Wn(r, t));
        }
      }, {
        key: "checkSubtype",
        value: function checkSubtype(t, e) {
          var r = pi(t, e);
          return r && this.error(r), r;
        }
      }]);
      return Qs;
    }();
    var ta = Qs;
    function ea(t) {
      if (t instanceof Js) return ea(t.boundExpression);
      if (t instanceof Ri && "error" === t.name) return !1;
      if (t instanceof Li) return !1;
      if (t instanceof is) return !1;
      if (t instanceof qs) return !1;
      if (t instanceof Ys) return !1;
      var e = t instanceof Ei || t instanceof Ii;
      var r = !0;
      return t.eachChild(function (t) {
        r = e ? r && ea(t) : r && t instanceof Mi;
      }), !!r && Zs(t) && Ws(t, ["zoom", "heatmap-density", "line-progress", "raster-value", "sky-radial-progress", "accumulated", "is-supported-script", "pitch", "distance-from-center", "measure-light", "raster-particle-speed"]);
    }
    function ra(t, e) {
      var r = t.length - 1;
      var n,
        i,
        s = 0,
        a = r,
        o = 0;
      for (; s <= a;) if (o = Math.floor((s + a) / 2), n = t[o], i = t[o + 1], n <= e) {
        if (o === r || e < i) return o;
        s = o + 1;
      } else {
        if (!(n > e)) throw new Ai("Input is not a number.");
        a = o - 1;
      }
      return 0;
    }
    var na = /*#__PURE__*/function () {
      function na(t, e, r) {
        _classCallCheck(this, na);
        this.type = t, this.input = e, this.labels = [], this.outputs = [];
        var _iterator44 = _createForOfIteratorHelper(r),
          _step44;
        try {
          for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
            var _step44$value = _slicedToArray(_step44.value, 2),
              _t54 = _step44$value[0],
              _e53 = _step44$value[1];
            this.labels.push(_t54), this.outputs.push(_e53);
          }
        } catch (err) {
          _iterator44.e(err);
        } finally {
          _iterator44.f();
        }
      }
      _createClass(na, [{
        key: "evaluate",
        value: function evaluate(t) {
          var e = this.labels,
            r = this.outputs;
          if (1 === e.length) return r[0].evaluate(t);
          var n = this.input.evaluate(t);
          if (n <= e[0]) return r[0].evaluate(t);
          var i = e.length;
          return n >= e[i - 1] ? r[i - 1].evaluate(t) : r[ra(e, n)].evaluate(t);
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          t(this.input);
          var _iterator45 = _createForOfIteratorHelper(this.outputs),
            _step45;
          try {
            for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
              var _e54 = _step45.value;
              t(_e54);
            }
          } catch (err) {
            _iterator45.e(err);
          } finally {
            _iterator45.f();
          }
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return this.outputs.every(function (t) {
            return t.outputDefined();
          });
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = ["step", this.input.serialize()];
          for (var _e55 = 0; _e55 < this.labels.length; _e55++) _e55 > 0 && t.push(this.labels[_e55]), t.push(this.outputs[_e55].serialize());
          return t;
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (t.length - 1 < 4) return e.error("Expected at least 4 arguments, but found only ".concat(t.length - 1, "."));
          if ((t.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
          var r = e.parse(t[1], 1, ti);
          if (!r) return null;
          var n = [];
          var i = null;
          e.expectedType && "value" !== e.expectedType.kind && (i = e.expectedType);
          for (var _r58 = 1; _r58 < t.length; _r58 += 2) {
            var _s32 = 1 === _r58 ? -1 / 0 : t[_r58],
              _a22 = t[_r58 + 1],
              _o14 = _r58,
              _l10 = _r58 + 1;
            if ("number" != typeof _s32) return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', _o14);
            if (n.length && n[n.length - 1][0] >= _s32) return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', _o14);
            var _u8 = e.parse(_a22, _l10, i);
            if (!_u8) return null;
            i = i || _u8.type, n.push([_s32, _u8]);
          }
          return new na(i, r, n);
        }
      }]);
      return na;
    }();
    var ia = .95047,
      sa = 1.08883,
      aa = 4 / 29,
      oa = 6 / 29,
      la = 3 * oa * oa,
      ua = oa * oa * oa,
      ca = Math.PI / 180,
      ha = 180 / Math.PI;
    function pa(t) {
      return t > ua ? Math.pow(t, 1 / 3) : t / la + aa;
    }
    function fa(t) {
      return t > oa ? t * t * t : la * (t - aa);
    }
    function da(t) {
      return 255 * (t <= .0031308 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055);
    }
    function ma(t) {
      return (t /= 255) <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
    }
    function ya(t) {
      var e = ma(t.r),
        r = ma(t.g),
        n = ma(t.b),
        i = pa((.4124564 * e + .3575761 * r + .1804375 * n) / ia),
        s = pa((.2126729 * e + .7151522 * r + .072175 * n) / 1);
      return {
        l: 116 * s - 16,
        a: 500 * (i - s),
        b: 200 * (s - pa((.0193339 * e + .119192 * r + .9503041 * n) / sa)),
        alpha: t.a
      };
    }
    function ga(t) {
      var e = (t.l + 16) / 116,
        r = isNaN(t.a) ? e : e + t.a / 500,
        n = isNaN(t.b) ? e : e - t.b / 200;
      return e = 1 * fa(e), r = ia * fa(r), n = sa * fa(n), new Gn(da(3.2404542 * r - 1.5371385 * e - .4985314 * n), da(-.969266 * r + 1.8760108 * e + .041556 * n), da(.0556434 * r - .2040259 * e + 1.0572252 * n), t.alpha);
    }
    function xa(t, e, r) {
      var n = e - t;
      return t + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
    }
    var ba = {
        forward: ya,
        reverse: ga,
        interpolate: function interpolate(t, e, r) {
          return {
            l: Yn(t.l, e.l, r),
            a: Yn(t.a, e.a, r),
            b: Yn(t.b, e.b, r),
            alpha: Yn(t.alpha, e.alpha, r)
          };
        }
      },
      va = {
        forward: function forward(t) {
          var _ya = ya(t),
            e = _ya.l,
            r = _ya.a,
            n = _ya.b,
            i = Math.atan2(n, r) * ha;
          return {
            h: i < 0 ? i + 360 : i,
            c: Math.sqrt(r * r + n * n),
            l: e,
            alpha: t.a
          };
        },
        reverse: function reverse(t) {
          var e = t.h * ca,
            r = t.c;
          return ga({
            l: t.l,
            a: Math.cos(e) * r,
            b: Math.sin(e) * r,
            alpha: t.alpha
          });
        },
        interpolate: function interpolate(t, e, r) {
          return {
            h: xa(t.h, e.h, r),
            c: Yn(t.c, e.c, r),
            l: Yn(t.l, e.l, r),
            alpha: Yn(t.alpha, e.alpha, r)
          };
        }
      };
    var _a = Object.freeze({
      __proto__: null,
      hcl: va,
      lab: ba
    });
    var wa = /*#__PURE__*/function () {
      function wa(t, e, r, n, i) {
        _classCallCheck(this, wa);
        this.type = t, this.operator = e, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
        var _iterator46 = _createForOfIteratorHelper(i),
          _step46;
        try {
          for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
            var _step46$value = _slicedToArray(_step46.value, 2),
              _t55 = _step46$value[0],
              _e56 = _step46$value[1];
            this.labels.push(_t55), this.outputs.push(_e56);
          }
        } catch (err) {
          _iterator46.e(err);
        } finally {
          _iterator46.f();
        }
      }
      _createClass(wa, [{
        key: "evaluate",
        value: function evaluate(t) {
          var e = this.labels,
            r = this.outputs;
          if (1 === e.length) return r[0].evaluate(t);
          var n = this.input.evaluate(t);
          if (n <= e[0]) return r[0].evaluate(t);
          var i = e.length;
          if (n >= e[i - 1]) return r[i - 1].evaluate(t);
          var s = ra(e, n),
            a = wa.interpolationFactor(this.interpolation, n, e[s], e[s + 1]),
            o = r[s].evaluate(t),
            l = r[s + 1].evaluate(t);
          return "interpolate" === this.operator ? Hn[this.type.kind.toLowerCase()](o, l, a) : "interpolate-hcl" === this.operator ? va.reverse(va.interpolate(va.forward(o), va.forward(l), a)) : ba.reverse(ba.interpolate(ba.forward(o), ba.forward(l), a));
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          t(this.input);
          var _iterator47 = _createForOfIteratorHelper(this.outputs),
            _step47;
          try {
            for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
              var _e57 = _step47.value;
              t(_e57);
            }
          } catch (err) {
            _iterator47.e(err);
          } finally {
            _iterator47.f();
          }
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return this.outputs.every(function (t) {
            return t.outputDefined();
          });
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t;
          t = "linear" === this.interpolation.name ? ["linear"] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? ["linear"] : ["exponential", this.interpolation.base] : ["cubic-bezier"].concat(this.interpolation.controlPoints);
          var e = [this.operator, t, this.input.serialize()];
          for (var _t56 = 0; _t56 < this.labels.length; _t56++) e.push(this.labels[_t56], this.outputs[_t56].serialize());
          return e;
        }
      }], [{
        key: "interpolationFactor",
        value: function interpolationFactor(t, e, r, n) {
          var i = 0;
          if ("exponential" === t.name) i = Ma(e, t.base, r, n);else if ("linear" === t.name) i = Ma(e, 1, r, n);else if ("cubic-bezier" === t.name) {
            var _s33 = t.controlPoints;
            i = new Fe(_s33[0], _s33[1], _s33[2], _s33[3]).solve(Ma(e, 1, r, n));
          }
          return i;
        }
      }, {
        key: "parse",
        value: function parse(t, e) {
          var _t57 = _toArray(t),
            r = _t57[0],
            n = _t57[1],
            i = _t57[2],
            s = _t57.slice(3);
          if (!Array.isArray(n) || 0 === n.length) return e.error("Expected an interpolation type expression.", 1);
          if ("linear" === n[0]) n = {
            name: "linear"
          };else if ("exponential" === n[0]) {
            var _t58 = n[1];
            if ("number" != typeof _t58) return e.error("Exponential interpolation requires a numeric base.", 1, 1);
            n = {
              name: "exponential",
              base: _t58
            };
          } else {
            if ("cubic-bezier" !== n[0]) return e.error("Unknown interpolation type ".concat(String(n[0])), 1, 0);
            {
              var _t59 = n.slice(1);
              if (4 !== _t59.length || _t59.some(function (t) {
                return "number" != typeof t || t < 0 || t > 1;
              })) return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
              n = {
                name: "cubic-bezier",
                controlPoints: _t59
              };
            }
          }
          if (t.length - 1 < 4) return e.error("Expected at least 4 arguments, but found only ".concat(t.length - 1, "."));
          if ((t.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
          if (i = e.parse(i, 2, ti), !i) return null;
          var a = [];
          var o = null;
          "interpolate-hcl" === r || "interpolate-lab" === r ? o = ni : e.expectedType && "value" !== e.expectedType.kind && (o = e.expectedType);
          for (var _t60 = 0; _t60 < s.length; _t60 += 2) {
            var _r59 = s[_t60],
              _n35 = s[_t60 + 1],
              _i33 = _t60 + 3,
              _l11 = _t60 + 4;
            if ("number" != typeof _r59) return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', _i33);
            if (a.length && a[a.length - 1][0] >= _r59) return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', _i33);
            var _u9 = e.parse(_n35, _l11, o);
            if (!_u9) return null;
            o = o || _u9.type, a.push([_r59, _u9]);
          }
          return "number" === o.kind || "color" === o.kind || "array" === o.kind && "number" === o.itemType.kind && "number" == typeof o.N ? new wa(o, r, n, i, a) : e.error("Type ".concat(ci(o), " is not interpolatable."));
        }
      }]);
      return wa;
    }();
    function Ma(t, e, r, n) {
      var i = n - r,
        s = t - r;
      return 0 === i ? 0 : 1 === e ? s / i : (Math.pow(e, s) - 1) / (Math.pow(e, i) - 1);
    }
    var Aa = /*#__PURE__*/function () {
      function Aa(t, e) {
        _classCallCheck(this, Aa);
        this.type = t, this.args = e;
      }
      _createClass(Aa, [{
        key: "evaluate",
        value: function evaluate(t) {
          var e,
            r = null,
            n = 0;
          var _iterator48 = _createForOfIteratorHelper(this.args),
            _step48;
          try {
            for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
              var _i34 = _step48.value;
              if (n++, r = _i34.evaluate(t), r && r instanceof xi && !r.available && (e || (e = r), r = null, n === this.args.length)) return e;
              if (null !== r) break;
            }
          } catch (err) {
            _iterator48.e(err);
          } finally {
            _iterator48.f();
          }
          return r;
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          this.args.forEach(t);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return this.args.every(function (t) {
            return t.outputDefined();
          });
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = ["coalesce"];
          return this.eachChild(function (e) {
            t.push(e.serialize());
          }), t;
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (t.length < 2) return e.error("Expectected at least one argument.");
          var r = null;
          var n = e.expectedType;
          n && "value" !== n.kind && (r = n);
          var i = [];
          var _iterator49 = _createForOfIteratorHelper(t.slice(1)),
            _step49;
          try {
            for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
              var _n36 = _step49.value;
              var _t61 = e.parse(_n36, 1 + i.length, r, void 0, {
                typeAnnotation: "omit"
              });
              if (!_t61) return null;
              r = r || _t61.type, i.push(_t61);
            }
          } catch (err) {
            _iterator49.e(err);
          } finally {
            _iterator49.f();
          }
          var s = n && i.some(function (t) {
            return pi(n, t.type);
          });
          return new Aa(s ? si : r, i);
        }
      }]);
      return Aa;
    }();
    var Sa = /*#__PURE__*/function () {
      function Sa(t, e) {
        _classCallCheck(this, Sa);
        this.type = e.type, this.bindings = [].concat(t), this.result = e;
      }
      _createClass(Sa, [{
        key: "evaluate",
        value: function evaluate(t) {
          return this.result.evaluate(t);
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          var _iterator50 = _createForOfIteratorHelper(this.bindings),
            _step50;
          try {
            for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
              var _e58 = _step50.value;
              t(_e58[1]);
            }
          } catch (err) {
            _iterator50.e(err);
          } finally {
            _iterator50.f();
          }
          t(this.result);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return this.result.outputDefined();
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = ["let"];
          var _iterator51 = _createForOfIteratorHelper(this.bindings),
            _step51;
          try {
            for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
              var _step51$value = _slicedToArray(_step51.value, 2),
                _e59 = _step51$value[0],
                _r60 = _step51$value[1];
              t.push(_e59, _r60.serialize());
            }
          } catch (err) {
            _iterator51.e(err);
          } finally {
            _iterator51.f();
          }
          return t.push(this.result.serialize()), t;
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (t.length < 4) return e.error("Expected at least 3 arguments, but found ".concat(t.length - 1, " instead."));
          var r = [];
          for (var _n37 = 1; _n37 < t.length - 1; _n37 += 2) {
            var _i35 = t[_n37];
            if ("string" != typeof _i35) return e.error("Expected string, but found ".concat(typeof _i35, " instead."), _n37);
            if (/[^a-zA-Z0-9_]/.test(_i35)) return e.error("Variable names must contain only alphanumeric characters or '_'.", _n37);
            var _s34 = e.parse(t[_n37 + 1], _n37 + 1);
            if (!_s34) return null;
            r.push([_i35, _s34]);
          }
          var n = e.parse(t[t.length - 1], t.length - 1, e.expectedType, r);
          return n ? new Sa(r, n) : null;
        }
      }]);
      return Sa;
    }();
    var Ia = /*#__PURE__*/function () {
      function Ia(t, e, r) {
        _classCallCheck(this, Ia);
        this.type = t, this.index = e, this.input = r;
      }
      _createClass(Ia, [{
        key: "evaluate",
        value: function evaluate(t) {
          var e = this.index.evaluate(t),
            r = this.input.evaluate(t);
          if (e < 0) throw new Ai("Array index out of bounds: ".concat(e, " < 0."));
          if (e >= r.length) throw new Ai("Array index out of bounds: ".concat(e, " > ").concat(r.length - 1, "."));
          if (e !== Math.floor(e)) throw new Ai("Array index must be an integer, but found ".concat(e, " instead."));
          return r[e];
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          t(this.index), t(this.input);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return ["at", this.index.serialize(), this.input.serialize()];
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (3 !== t.length) return e.error("Expected 2 arguments, but found ".concat(t.length - 1, " instead."));
          var r = e.parse(t[1], 1, ti),
            n = e.parse(t[2], 2, ui(e.expectedType || si));
          return r && n ? new Ia(n.type.itemType, r, n) : null;
        }
      }]);
      return Ia;
    }();
    var Ta = /*#__PURE__*/function () {
      function Ta(t, e) {
        _classCallCheck(this, Ta);
        this.type = ri, this.needle = t, this.haystack = e;
      }
      _createClass(Ta, [{
        key: "evaluate",
        value: function evaluate(t) {
          var e = this.needle.evaluate(t),
            r = this.haystack.evaluate(t);
          if (null == r) return !1;
          if (!di(e, ["boolean", "string", "number", "null"])) throw new Ai("Expected first argument to be of type boolean, string, number or null, but found ".concat(ci(_i(e)), " instead."));
          if (!di(r, ["string", "array"])) throw new Ai("Expected second argument to be of type array or string, but found ".concat(ci(_i(r)), " instead."));
          return r.indexOf(e) >= 0;
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          t(this.needle), t(this.haystack);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !0;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return ["in", this.needle.serialize(), this.haystack.serialize()];
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (3 !== t.length) return e.error("Expected 2 arguments, but found ".concat(t.length - 1, " instead."));
          var r = e.parse(t[1], 1, si),
            n = e.parse(t[2], 2, si);
          return r && n ? fi(r.type, [ri, ei, ti, Qn, si]) ? new Ta(r, n) : e.error("Expected first argument to be of type boolean, string, number or null, but found ".concat(ci(r.type), " instead")) : null;
        }
      }]);
      return Ta;
    }();
    var ka = /*#__PURE__*/function () {
      function ka(t, e, r) {
        _classCallCheck(this, ka);
        this.type = ti, this.needle = t, this.haystack = e, this.fromIndex = r;
      }
      _createClass(ka, [{
        key: "evaluate",
        value: function evaluate(t) {
          var e = this.needle.evaluate(t),
            r = this.haystack.evaluate(t);
          if (!di(e, ["boolean", "string", "number", "null"])) throw new Ai("Expected first argument to be of type boolean, string, number or null, but found ".concat(ci(_i(e)), " instead."));
          if (!di(r, ["string", "array"])) throw new Ai("Expected second argument to be of type array or string, but found ".concat(ci(_i(r)), " instead."));
          if (this.fromIndex) {
            var _n38 = this.fromIndex.evaluate(t);
            return r.indexOf(e, _n38);
          }
          return r.indexOf(e);
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          t(this.needle), t(this.haystack), this.fromIndex && t(this.fromIndex);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          if (null != this.fromIndex && void 0 !== this.fromIndex) {
            var _t62 = this.fromIndex.serialize();
            return ["index-of", this.needle.serialize(), this.haystack.serialize(), _t62];
          }
          return ["index-of", this.needle.serialize(), this.haystack.serialize()];
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (t.length <= 2 || t.length >= 5) return e.error("Expected 3 or 4 arguments, but found ".concat(t.length - 1, " instead."));
          var r = e.parse(t[1], 1, si),
            n = e.parse(t[2], 2, si);
          if (!r || !n) return null;
          if (!fi(r.type, [ri, ei, ti, Qn, si])) return e.error("Expected first argument to be of type boolean, string, number or null, but found ".concat(ci(r.type), " instead"));
          if (4 === t.length) {
            var _i36 = e.parse(t[3], 3, ti);
            return _i36 ? new ka(r, n, _i36) : null;
          }
          return new ka(r, n);
        }
      }]);
      return ka;
    }();
    var Pa = /*#__PURE__*/function () {
      function Pa(t, e, r, n, i, s) {
        _classCallCheck(this, Pa);
        this.inputType = t, this.type = e, this.input = r, this.cases = n, this.outputs = i, this.otherwise = s;
      }
      _createClass(Pa, [{
        key: "evaluate",
        value: function evaluate(t) {
          var e = this.input.evaluate(t);
          return (_i(e) === this.inputType && this.outputs[this.cases[e]] || this.otherwise).evaluate(t);
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          t(this.input), this.outputs.forEach(t), t(this.otherwise);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return this.outputs.every(function (t) {
            return t.outputDefined();
          }) && this.otherwise.outputDefined();
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var _this13 = this;
          var t = ["match", this.input.serialize()],
            e = Object.keys(this.cases).sort(),
            r = [],
            n = {};
          var _iterator52 = _createForOfIteratorHelper(e),
            _step52;
          try {
            for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
              var _t63 = _step52.value;
              var _e61 = n[this.cases[_t63]];
              void 0 === _e61 ? (n[this.cases[_t63]] = r.length, r.push([this.cases[_t63], [_t63]])) : r[_e61][1].push(_t63);
            }
          } catch (err) {
            _iterator52.e(err);
          } finally {
            _iterator52.f();
          }
          var i = function i(t) {
            return "number" === _this13.inputType.kind ? Number(t) : t;
          };
          for (var _i37 = 0, _r61 = r; _i37 < _r61.length; _i37++) {
            var _r61$_i = _slicedToArray(_r61[_i37], 2),
              _e60 = _r61$_i[0],
              _n39 = _r61$_i[1];
            t.push(1 === _n39.length ? i(_n39[0]) : _n39.map(i)), t.push(this.outputs[_e60].serialize());
          }
          return t.push(this.otherwise.serialize()), t;
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (t.length < 5) return e.error("Expected at least 4 arguments, but found only ".concat(t.length - 1, "."));
          if (t.length % 2 != 1) return e.error("Expected an even number of arguments.");
          var r, n;
          e.expectedType && "value" !== e.expectedType.kind && (n = e.expectedType);
          var i = {},
            s = [];
          for (var _a23 = 2; _a23 < t.length - 1; _a23 += 2) {
            var _o15 = t[_a23];
            var _l12 = t[_a23 + 1];
            Array.isArray(_o15) || (_o15 = [_o15]);
            var _u10 = e.concat(_a23);
            if (0 === _o15.length) return _u10.error("Expected at least one branch label.");
            var _iterator53 = _createForOfIteratorHelper(_o15),
              _step53;
            try {
              for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
                var _t64 = _step53.value;
                if ("number" != typeof _t64 && "string" != typeof _t64) return _u10.error("Branch labels must be numbers or strings.");
                if ("number" == typeof _t64 && Math.abs(_t64) > Number.MAX_SAFE_INTEGER) return _u10.error("Branch labels must be integers no larger than ".concat(Number.MAX_SAFE_INTEGER, "."));
                if ("number" == typeof _t64 && Math.floor(_t64) !== _t64) return _u10.error("Numeric branch labels must be integer values.");
                if (r) {
                  if (_u10.checkSubtype(r, _i(_t64))) return null;
                } else r = _i(_t64);
                if (void 0 !== i[String(_t64)]) return _u10.error("Branch labels must be unique.");
                i[String(_t64)] = s.length;
              }
            } catch (err) {
              _iterator53.e(err);
            } finally {
              _iterator53.f();
            }
            var _c7 = e.parse(_l12, _a23, n);
            if (!_c7) return null;
            n = n || _c7.type, s.push(_c7);
          }
          var a = e.parse(t[1], 1, si);
          if (!a) return null;
          var o = e.parse(t[t.length - 1], t.length - 1, n);
          return o ? "value" !== a.type.kind && e.concat(1).checkSubtype(r, a.type) ? null : new Pa(r, n, a, i, s, o) : null;
        }
      }]);
      return Pa;
    }();
    var za = /*#__PURE__*/function () {
      function za(t, e, r) {
        _classCallCheck(this, za);
        this.type = t, this.branches = e, this.otherwise = r;
      }
      _createClass(za, [{
        key: "evaluate",
        value: function evaluate(t) {
          var _iterator54 = _createForOfIteratorHelper(this.branches),
            _step54;
          try {
            for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
              var _step54$value = _slicedToArray(_step54.value, 2),
                _e62 = _step54$value[0],
                _r62 = _step54$value[1];
              if (_e62.evaluate(t)) return _r62.evaluate(t);
            }
          } catch (err) {
            _iterator54.e(err);
          } finally {
            _iterator54.f();
          }
          return this.otherwise.evaluate(t);
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          var _iterator55 = _createForOfIteratorHelper(this.branches),
            _step55;
          try {
            for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
              var _step55$value = _slicedToArray(_step55.value, 2),
                _e63 = _step55$value[0],
                _r63 = _step55$value[1];
              t(_e63), t(_r63);
            }
          } catch (err) {
            _iterator55.e(err);
          } finally {
            _iterator55.f();
          }
          t(this.otherwise);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return this.branches.every(function (_ref7) {
            var _ref8 = _slicedToArray(_ref7, 2),
              t = _ref8[0],
              e = _ref8[1];
            return e.outputDefined();
          }) && this.otherwise.outputDefined();
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = ["case"];
          return this.eachChild(function (e) {
            t.push(e.serialize());
          }), t;
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (t.length < 4) return e.error("Expected at least 3 arguments, but found only ".concat(t.length - 1, "."));
          if (t.length % 2 != 0) return e.error("Expected an odd number of arguments.");
          var r;
          e.expectedType && "value" !== e.expectedType.kind && (r = e.expectedType);
          var n = [];
          for (var _i38 = 1; _i38 < t.length - 1; _i38 += 2) {
            var _s35 = e.parse(t[_i38], _i38, ri);
            if (!_s35) return null;
            var _a24 = e.parse(t[_i38 + 1], _i38 + 1, r);
            if (!_a24) return null;
            n.push([_s35, _a24]), r = r || _a24.type;
          }
          var i = e.parse(t[t.length - 1], t.length - 1, r);
          return i ? new za(r, n, i) : null;
        }
      }]);
      return za;
    }();
    var Ea = /*#__PURE__*/function () {
      function Ea(t, e, r, n) {
        _classCallCheck(this, Ea);
        this.type = t, this.input = e, this.beginIndex = r, this.endIndex = n;
      }
      _createClass(Ea, [{
        key: "evaluate",
        value: function evaluate(t) {
          var e = this.input.evaluate(t),
            r = this.beginIndex.evaluate(t);
          if (!di(e, ["string", "array"])) throw new Ai("Expected first argument to be of type array or string, but found ".concat(ci(_i(e)), " instead."));
          if (this.endIndex) {
            var _n40 = this.endIndex.evaluate(t);
            return e.slice(r, _n40);
          }
          return e.slice(r);
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          t(this.input), t(this.beginIndex), this.endIndex && t(this.endIndex);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          if (null != this.endIndex && void 0 !== this.endIndex) {
            var _t65 = this.endIndex.serialize();
            return ["slice", this.input.serialize(), this.beginIndex.serialize(), _t65];
          }
          return ["slice", this.input.serialize(), this.beginIndex.serialize()];
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (t.length <= 2 || t.length >= 5) return e.error("Expected 3 or 4 arguments, but found ".concat(t.length - 1, " instead."));
          var r = e.parse(t[1], 1, si),
            n = e.parse(t[2], 2, ti);
          if (!r || !n) return null;
          if (!fi(r.type, [ui(si), ei, si])) return e.error("Expected first argument to be of type array or string, but found ".concat(ci(r.type), " instead"));
          if (4 === t.length) {
            var _i39 = e.parse(t[3], 3, ti);
            return _i39 ? new Ea(r.type, r, n, _i39) : null;
          }
          return new Ea(r.type, r, n);
        }
      }]);
      return Ea;
    }();
    function Ba(t, e) {
      return "==" === t || "!=" === t ? "boolean" === e.kind || "string" === e.kind || "number" === e.kind || "null" === e.kind || "value" === e.kind : "string" === e.kind || "number" === e.kind || "value" === e.kind;
    }
    function Da(t, e, r, n) {
      return 0 === n.compare(e, r);
    }
    function Ra(t, e, r) {
      var n = "==" !== t && "!=" !== t;
      return /*#__PURE__*/function () {
        function i(t, e, r) {
          _classCallCheck(this, i);
          this.type = ri, this.lhs = t, this.rhs = e, this.collator = r, this.hasUntypedArgument = "value" === t.type.kind || "value" === e.type.kind;
        }
        _createClass(i, [{
          key: "evaluate",
          value: function evaluate(_i40) {
            var s = this.lhs.evaluate(_i40),
              a = this.rhs.evaluate(_i40);
            if (n && this.hasUntypedArgument) {
              var _e64 = _i(s),
                _r64 = _i(a);
              if (_e64.kind !== _r64.kind || "string" !== _e64.kind && "number" !== _e64.kind) throw new Ai("Expected arguments for \"".concat(t, "\" to be (string, string) or (number, number), but found (").concat(_e64.kind, ", ").concat(_r64.kind, ") instead."));
            }
            if (this.collator && !n && this.hasUntypedArgument) {
              var _t66 = _i(s),
                _r65 = _i(a);
              if ("string" !== _t66.kind || "string" !== _r65.kind) return e(_i40, s, a);
            }
            return this.collator ? r(_i40, s, a, this.collator.evaluate(_i40)) : e(_i40, s, a);
          }
        }, {
          key: "eachChild",
          value: function eachChild(t) {
            t(this.lhs), t(this.rhs), this.collator && t(this.collator);
          }
        }, {
          key: "outputDefined",
          value: function outputDefined() {
            return !0;
          }
        }, {
          key: "serialize",
          value: function serialize() {
            var e = [t];
            return this.eachChild(function (t) {
              e.push(t.serialize());
            }), e;
          }
        }], [{
          key: "parse",
          value: function parse(t, e) {
            if (3 !== t.length && 4 !== t.length) return e.error("Expected two or three arguments.");
            var r = t[0];
            var s = e.parse(t[1], 1, si);
            if (!s) return null;
            if (!Ba(r, s.type)) return e.concat(1).error("\"".concat(r, "\" comparisons are not supported for type '").concat(ci(s.type), "'."));
            var a = e.parse(t[2], 2, si);
            if (!a) return null;
            if (!Ba(r, a.type)) return e.concat(2).error("\"".concat(r, "\" comparisons are not supported for type '").concat(ci(a.type), "'."));
            if (s.type.kind !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e.error("Cannot compare types '".concat(ci(s.type), "' and '").concat(ci(a.type), "'."));
            n && ("value" === s.type.kind && "value" !== a.type.kind ? s = new Ii(a.type, [s]) : "value" !== s.type.kind && "value" === a.type.kind && (a = new Ii(s.type, [a])));
            var o = null;
            if (4 === t.length) {
              if ("string" !== s.type.kind && "string" !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e.error("Cannot use collator to compare non-string types.");
              if (o = e.parse(t[3], 3, ai), !o) return null;
            }
            return new i(s, a, o);
          }
        }]);
        return i;
      }();
    }
    var Ca = Ra("==", function (t, e, r) {
        return e === r;
      }, Da),
      La = Ra("!=", function (t, e, r) {
        return e !== r;
      }, function (t, e, r, n) {
        return !Da(0, e, r, n);
      }),
      Va = Ra("<", function (t, e, r) {
        return e < r;
      }, function (t, e, r, n) {
        return n.compare(e, r) < 0;
      }),
      Fa = Ra(">", function (t, e, r) {
        return e > r;
      }, function (t, e, r, n) {
        return n.compare(e, r) > 0;
      }),
      Oa = Ra("<=", function (t, e, r) {
        return e <= r;
      }, function (t, e, r, n) {
        return n.compare(e, r) <= 0;
      }),
      Ua = Ra(">=", function (t, e, r) {
        return e >= r;
      }, function (t, e, r, n) {
        return n.compare(e, r) >= 0;
      });
    var ja = /*#__PURE__*/function () {
      function ja(t, e, r, n, i, s) {
        _classCallCheck(this, ja);
        this.type = ei, this.number = t, this.locale = e, this.currency = r, this.unit = n, this.minFractionDigits = i, this.maxFractionDigits = s;
      }
      _createClass(ja, [{
        key: "evaluate",
        value: function evaluate(t) {
          return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t) : [], {
            style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
            currency: this.currency ? this.currency.evaluate(t) : void 0,
            unit: this.unit ? this.unit.evaluate(t) : void 0,
            minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t) : void 0,
            maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t) : void 0
          }).format(this.number.evaluate(t));
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          t(this.number), this.locale && t(this.locale), this.currency && t(this.currency), this.unit && t(this.unit), this.minFractionDigits && t(this.minFractionDigits), this.maxFractionDigits && t(this.maxFractionDigits);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = {};
          return this.locale && (t.locale = this.locale.serialize()), this.currency && (t.currency = this.currency.serialize()), this.unit && (t.unit = this.unit.serialize()), this.minFractionDigits && (t["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t["max-fraction-digits"] = this.maxFractionDigits.serialize()), ["number-format", this.number.serialize(), t];
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (3 !== t.length) return e.error("Expected two arguments.");
          var r = e.parse(t[1], 1, ti);
          if (!r) return null;
          var n = t[2];
          if ("object" != typeof n || Array.isArray(n)) return e.error("NumberFormat options argument must be an object.");
          var i = null;
          if (n.locale && (i = e.parse(n.locale, 1, ei), !i)) return null;
          var s = null;
          if (n.currency && (s = e.parse(n.currency, 1, ei), !s)) return null;
          var a = null;
          if (n.unit && (a = e.parse(n.unit, 1, ei), !a)) return null;
          var o = null;
          if (n["min-fraction-digits"] && (o = e.parse(n["min-fraction-digits"], 1, ti), !o)) return null;
          var l = null;
          return n["max-fraction-digits"] && (l = e.parse(n["max-fraction-digits"], 1, ti), !l) ? null : new ja(r, i, s, a, o, l);
        }
      }]);
      return ja;
    }();
    var Na = /*#__PURE__*/function () {
      function Na(t) {
        _classCallCheck(this, Na);
        this.type = ti, this.input = t;
      }
      _createClass(Na, [{
        key: "evaluate",
        value: function evaluate(t) {
          var e = this.input.evaluate(t);
          if ("string" == typeof e) return e.length;
          if (Array.isArray(e)) return e.length;
          throw new Ai("Expected value to be of type string or array, but found ".concat(ci(_i(e)), " instead."));
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          t(this.input);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = ["length"];
          return this.eachChild(function (e) {
            t.push(e.serialize());
          }), t;
        }
      }], [{
        key: "parse",
        value: function parse(t, e) {
          if (2 !== t.length) return e.error("Expected 1 argument, but found ".concat(t.length - 1, " instead."));
          var r = e.parse(t[1], 1);
          return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e.error("Expected argument of type string or array, but found ".concat(ci(r.type), " instead.")) : new Na(r) : null;
        }
      }]);
      return Na;
    }();
    function $a(t) {
      return function () {
        t = 1831565813 + (t |= 0) | 0;
        var e = Math.imul(t ^ t >>> 15, 1 | t);
        return e = e + Math.imul(e ^ e >>> 7, 61 | e) ^ e, ((e ^ e >>> 14) >>> 0) / 4294967296;
      };
    }
    var qa = {
      "==": Ca,
      "!=": La,
      ">": Fa,
      "<": Va,
      ">=": Ua,
      "<=": Oa,
      array: Ii,
      at: Ia,
      boolean: Ii,
      case: za,
      coalesce: Aa,
      collator: Li,
      format: Ti,
      image: ki,
      in: Ta,
      "index-of": ka,
      interpolate: wa,
      "interpolate-hcl": wa,
      "interpolate-lab": wa,
      length: Na,
      let: Sa,
      literal: Mi,
      match: Pa,
      number: Ii,
      "number-format": ja,
      object: Ii,
      slice: Ea,
      step: na,
      string: Ii,
      "to-boolean": Ei,
      "to-color": Ei,
      "to-number": Ei,
      "to-string": Ei,
      var: Js,
      within: is,
      distance: qs,
      config: Ys
    };
    function Ga(t, _ref9) {
      var _ref10 = _slicedToArray(_ref9, 4),
        e = _ref10[0],
        r = _ref10[1],
        n = _ref10[2],
        i = _ref10[3];
      e = e.evaluate(t), r = r.evaluate(t), n = n.evaluate(t);
      var s = i ? i.evaluate(t) : 1,
        a = bi(e, r, n, s);
      if (a) throw new Ai(a);
      return new Gn(e / 255 * s, r / 255 * s, n / 255 * s, s);
    }
    function Xa(t, _ref11) {
      var _ref12 = _slicedToArray(_ref11, 4),
        e = _ref12[0],
        r = _ref12[1],
        n = _ref12[2],
        i = _ref12[3];
      e = e.evaluate(t), r = r.evaluate(t), n = n.evaluate(t);
      var s = i ? i.evaluate(t) : 1,
        a = function (t, e, r, n) {
          return "number" == typeof t && t >= 0 && t <= 360 ? "number" == typeof e && e >= 0 && e <= 100 && "number" == typeof r && r >= 0 && r <= 100 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : "Invalid hsla value [".concat([t, e, r, n].join(", "), "]: 'a' must be between 0 and 1.") : "Invalid hsla value [".concat(("number" == typeof n ? [t, e, r, n] : [t, e, r]).join(", "), "]: 's', and 'l' must be between 0 and 100.") : "Invalid hsla value [".concat(("number" == typeof n ? [t, e, r, n] : [t, e, r]).join(", "), "]: 'h' must be between 0 and 360.");
        }(e, r, n, s);
      if (a) throw new Ai(a);
      var o = "hsla(".concat(e, ", ").concat(r, "%, ").concat(n, "%, ").concat(s, ")"),
        l = Gn.parse(o);
      if (!l) throw new Ai("Failed to parse HSLA color: ".concat(o));
      return l;
    }
    function Ya(t, e) {
      return t in e;
    }
    function Za(t, e) {
      var r = e[t];
      return void 0 === r ? null : r;
    }
    function Ha(t) {
      return {
        type: t
      };
    }
    function Ka(t) {
      return {
        result: "success",
        value: t
      };
    }
    function Wa(t) {
      return {
        result: "error",
        value: t
      };
    }
    function Ja(t, e) {
      return !!t && !!t.parameters && t.parameters.indexOf(e) > -1;
    }
    function Qa(t) {
      return "data-driven" === t["property-type"];
    }
    function to(t) {
      return Ja(t.expression, "measure-light");
    }
    function eo(t) {
      return Ja(t.expression, "zoom");
    }
    function ro(t) {
      return !!t.expression && t.expression.interpolated;
    }
    function no(t) {
      return "object" == typeof t && null !== t && !Array.isArray(t);
    }
    function io(t) {
      return t;
    }
    function so(t, e) {
      var r = "color" === e.type,
        n = t.stops && "object" == typeof t.stops[0][0],
        i = n || !(n || void 0 !== t.property),
        s = t.type || (ro(e) ? "exponential" : "interval");
      if (r && ((t = Kn({}, t)).stops && (t.stops = t.stops.map(function (t) {
        return [t[0], Gn.parse(t[1])];
      })), t.default = Gn.parse(t.default ? t.default : e.default)), t.colorSpace && "rgb" !== t.colorSpace && !_a[t.colorSpace]) throw new Error("Unknown color space: ".concat(t.colorSpace));
      var a, o, l;
      if ("exponential" === s) a = uo;else if ("interval" === s) a = lo;else if ("categorical" === s) {
        a = oo, o = Object.create(null);
        var _iterator56 = _createForOfIteratorHelper(t.stops),
          _step56;
        try {
          for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
            var _e65 = _step56.value;
            o[_e65[0]] = _e65[1];
          }
        } catch (err) {
          _iterator56.e(err);
        } finally {
          _iterator56.f();
        }
        l = typeof t.stops[0][0];
      } else {
        if ("identity" !== s) throw new Error("Unknown function type \"".concat(s, "\""));
        a = co;
      }
      if (n) {
        var _r66 = {},
          _n41 = [];
        for (var _e66 = 0; _e66 < t.stops.length; _e66++) {
          var _i41 = t.stops[_e66],
            _s36 = _i41[0].zoom;
          void 0 === _r66[_s36] && (_r66[_s36] = {
            zoom: _s36,
            type: t.type,
            property: t.property,
            default: t.default,
            stops: []
          }, _n41.push(_s36)), _r66[_s36].stops.push([_i41[0].value, _i41[1]]);
        }
        var _i42 = [];
        for (var _i43 = 0, _n42 = _n41; _i43 < _n42.length; _i43++) {
          var _t67 = _n42[_i43];
          _i42.push([_r66[_t67].zoom, so(_r66[_t67], e)]);
        }
        var _s37 = {
          name: "linear"
        };
        return {
          kind: "composite",
          interpolationType: _s37,
          interpolationFactor: wa.interpolationFactor.bind(void 0, _s37),
          zoomStops: _i42.map(function (t) {
            return t[0];
          }),
          evaluate: function evaluate(_ref13, n) {
            var r = _ref13.zoom;
            return uo({
              stops: _i42,
              base: t.base
            }, e, r).evaluate(r, n);
          }
        };
      }
      if (i) {
        var _r67 = "exponential" === s ? {
          name: "exponential",
          base: void 0 !== t.base ? t.base : 1
        } : null;
        return {
          kind: "camera",
          interpolationType: _r67,
          interpolationFactor: wa.interpolationFactor.bind(void 0, _r67),
          zoomStops: t.stops.map(function (t) {
            return t[0];
          }),
          evaluate: function evaluate(_ref14) {
            var r = _ref14.zoom;
            return a(t, e, r, o, l);
          }
        };
      }
      return {
        kind: "source",
        evaluate: function evaluate(r, n) {
          var i = n && n.properties ? n.properties[t.property] : void 0;
          return void 0 === i ? ao(t.default, e.default) : a(t, e, i, o, l);
        }
      };
    }
    function ao(t, e, r) {
      return void 0 !== t ? t : void 0 !== e ? e : void 0 !== r ? r : void 0;
    }
    function oo(t, e, r, n, i) {
      return ao(typeof r === i ? n[r] : void 0, t.default, e.default);
    }
    function lo(t, e, r) {
      if ("number" !== Pi(r)) return ao(t.default, e.default);
      var n = t.stops.length;
      if (1 === n) return t.stops[0][1];
      if (r <= t.stops[0][0]) return t.stops[0][1];
      if (r >= t.stops[n - 1][0]) return t.stops[n - 1][1];
      var i = ra(t.stops.map(function (t) {
        return t[0];
      }), r);
      return t.stops[i][1];
    }
    function uo(t, e, r) {
      var n = void 0 !== t.base ? t.base : 1;
      if ("number" !== Pi(r)) return ao(t.default, e.default);
      var i = t.stops.length;
      if (1 === i) return t.stops[0][1];
      if (r <= t.stops[0][0]) return t.stops[0][1];
      if (r >= t.stops[i - 1][0]) return t.stops[i - 1][1];
      var s = ra(t.stops.map(function (t) {
          return t[0];
        }), r),
        a = function (t, e, r, n) {
          var i = n - r,
            s = t - r;
          return 0 === i ? 0 : 1 === e ? s / i : (Math.pow(e, s) - 1) / (Math.pow(e, i) - 1);
        }(r, n, t.stops[s][0], t.stops[s + 1][0]),
        o = t.stops[s][1],
        l = t.stops[s + 1][1];
      var u = Hn[e.type] || io;
      if (t.colorSpace && "rgb" !== t.colorSpace) {
        var _e67 = _a[t.colorSpace];
        u = function u(t, r) {
          return _e67.reverse(_e67.interpolate(_e67.forward(t), _e67.forward(r), a));
        };
      }
      return "function" == typeof o.evaluate ? {
        evaluate: function evaluate() {
          for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            t[_key4] = arguments[_key4];
          }
          var e = o.evaluate.apply(void 0, t),
            r = l.evaluate.apply(void 0, t);
          if (void 0 !== e && void 0 !== r) return u(e, r, a);
        }
      } : u(o, l, a);
    }
    function co(t, e, r) {
      return "color" === e.type ? r = Gn.parse(r) : "formatted" === e.type ? r = gi.fromString(r.toString()) : "resolvedImage" === e.type ? r = xi.fromString(r.toString()) : Pi(r) === e.type || "enum" === e.type && e.values[r] || (r = void 0), ao(r, t.default, e.default);
    }
    Ri.register(qa, {
      error: [{
        kind: "error"
      }, [ei], function (t, _ref15) {
        var _ref16 = _slicedToArray(_ref15, 1),
          e = _ref16[0];
        throw new Ai(e.evaluate(t));
      }],
      typeof: [ei, [si], function (t, _ref17) {
        var _ref18 = _slicedToArray(_ref17, 1),
          e = _ref18[0];
        return ci(_i(e.evaluate(t)));
      }],
      "to-rgba": [ui(ti, 4), [ni], function (t, _ref19) {
        var _ref20 = _slicedToArray(_ref19, 1),
          e = _ref20[0];
        return e.evaluate(t).toRenderColor(null).toArray();
      }],
      rgb: [ni, [ti, ti, ti], Ga],
      rgba: [ni, [ti, ti, ti, ti], Ga],
      hsl: [ni, [ti, ti, ti], Xa],
      hsla: [ni, [ti, ti, ti, ti], Xa],
      has: {
        type: ri,
        overloads: [[[ei], function (t, _ref21) {
          var _ref22 = _slicedToArray(_ref21, 1),
            e = _ref22[0];
          return Ya(e.evaluate(t), t.properties());
        }], [[ei, ii], function (t, _ref23) {
          var _ref24 = _slicedToArray(_ref23, 2),
            e = _ref24[0],
            r = _ref24[1];
          return Ya(e.evaluate(t), r.evaluate(t));
        }]]
      },
      get: {
        type: si,
        overloads: [[[ei], function (t, _ref25) {
          var _ref26 = _slicedToArray(_ref25, 1),
            e = _ref26[0];
          return Za(e.evaluate(t), t.properties());
        }], [[ei, ii], function (t, _ref27) {
          var _ref28 = _slicedToArray(_ref27, 2),
            e = _ref28[0],
            r = _ref28[1];
          return Za(e.evaluate(t), r.evaluate(t));
        }]]
      },
      "feature-state": [si, [ei], function (t, _ref29) {
        var _ref30 = _slicedToArray(_ref29, 1),
          e = _ref30[0];
        return Za(e.evaluate(t), t.featureState || {});
      }],
      properties: [ii, [], function (t) {
        return t.properties();
      }],
      "geometry-type": [ei, [], function (t) {
        return t.geometryType();
      }],
      id: [si, [], function (t) {
        return t.id();
      }],
      zoom: [ti, [], function (t) {
        return t.globals.zoom;
      }],
      pitch: [ti, [], function (t) {
        return t.globals.pitch || 0;
      }],
      "distance-from-center": [ti, [], function (t) {
        return t.distanceFromCenter();
      }],
      "measure-light": [ti, [ei], function (t, _ref31) {
        var _ref32 = _slicedToArray(_ref31, 1),
          e = _ref32[0];
        return t.measureLight(e.evaluate(t));
      }],
      "heatmap-density": [ti, [], function (t) {
        return t.globals.heatmapDensity || 0;
      }],
      "line-progress": [ti, [], function (t) {
        return t.globals.lineProgress || 0;
      }],
      "raster-value": [ti, [], function (t) {
        return t.globals.rasterValue || 0;
      }],
      "raster-particle-speed": [ti, [], function (t) {
        return t.globals.rasterParticleSpeed || 0;
      }],
      "sky-radial-progress": [ti, [], function (t) {
        return t.globals.skyRadialProgress || 0;
      }],
      accumulated: [si, [], function (t) {
        return void 0 === t.globals.accumulated ? null : t.globals.accumulated;
      }],
      "+": [ti, Ha(ti), function (t, e) {
        var r = 0;
        var _iterator57 = _createForOfIteratorHelper(e),
          _step57;
        try {
          for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
            var _n43 = _step57.value;
            r += _n43.evaluate(t);
          }
        } catch (err) {
          _iterator57.e(err);
        } finally {
          _iterator57.f();
        }
        return r;
      }],
      "*": [ti, Ha(ti), function (t, e) {
        var r = 1;
        var _iterator58 = _createForOfIteratorHelper(e),
          _step58;
        try {
          for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
            var _n44 = _step58.value;
            r *= _n44.evaluate(t);
          }
        } catch (err) {
          _iterator58.e(err);
        } finally {
          _iterator58.f();
        }
        return r;
      }],
      "-": {
        type: ti,
        overloads: [[[ti, ti], function (t, _ref33) {
          var _ref34 = _slicedToArray(_ref33, 2),
            e = _ref34[0],
            r = _ref34[1];
          return e.evaluate(t) - r.evaluate(t);
        }], [[ti], function (t, _ref35) {
          var _ref36 = _slicedToArray(_ref35, 1),
            e = _ref36[0];
          return -e.evaluate(t);
        }]]
      },
      "/": [ti, [ti, ti], function (t, _ref37) {
        var _ref38 = _slicedToArray(_ref37, 2),
          e = _ref38[0],
          r = _ref38[1];
        return e.evaluate(t) / r.evaluate(t);
      }],
      "%": [ti, [ti, ti], function (t, _ref39) {
        var _ref40 = _slicedToArray(_ref39, 2),
          e = _ref40[0],
          r = _ref40[1];
        return e.evaluate(t) % r.evaluate(t);
      }],
      ln2: [ti, [], function () {
        return Math.LN2;
      }],
      pi: [ti, [], function () {
        return Math.PI;
      }],
      e: [ti, [], function () {
        return Math.E;
      }],
      "^": [ti, [ti, ti], function (t, _ref41) {
        var _ref42 = _slicedToArray(_ref41, 2),
          e = _ref42[0],
          r = _ref42[1];
        return Math.pow(e.evaluate(t), r.evaluate(t));
      }],
      sqrt: [ti, [ti], function (t, _ref43) {
        var _ref44 = _slicedToArray(_ref43, 1),
          e = _ref44[0];
        return Math.sqrt(e.evaluate(t));
      }],
      log10: [ti, [ti], function (t, _ref45) {
        var _ref46 = _slicedToArray(_ref45, 1),
          e = _ref46[0];
        return Math.log(e.evaluate(t)) / Math.LN10;
      }],
      ln: [ti, [ti], function (t, _ref47) {
        var _ref48 = _slicedToArray(_ref47, 1),
          e = _ref48[0];
        return Math.log(e.evaluate(t));
      }],
      log2: [ti, [ti], function (t, _ref49) {
        var _ref50 = _slicedToArray(_ref49, 1),
          e = _ref50[0];
        return Math.log(e.evaluate(t)) / Math.LN2;
      }],
      sin: [ti, [ti], function (t, _ref51) {
        var _ref52 = _slicedToArray(_ref51, 1),
          e = _ref52[0];
        return Math.sin(e.evaluate(t));
      }],
      cos: [ti, [ti], function (t, _ref53) {
        var _ref54 = _slicedToArray(_ref53, 1),
          e = _ref54[0];
        return Math.cos(e.evaluate(t));
      }],
      tan: [ti, [ti], function (t, _ref55) {
        var _ref56 = _slicedToArray(_ref55, 1),
          e = _ref56[0];
        return Math.tan(e.evaluate(t));
      }],
      asin: [ti, [ti], function (t, _ref57) {
        var _ref58 = _slicedToArray(_ref57, 1),
          e = _ref58[0];
        return Math.asin(e.evaluate(t));
      }],
      acos: [ti, [ti], function (t, _ref59) {
        var _ref60 = _slicedToArray(_ref59, 1),
          e = _ref60[0];
        return Math.acos(e.evaluate(t));
      }],
      atan: [ti, [ti], function (t, _ref61) {
        var _ref62 = _slicedToArray(_ref61, 1),
          e = _ref62[0];
        return Math.atan(e.evaluate(t));
      }],
      min: [ti, Ha(ti), function (t, e) {
        return Math.min.apply(Math, _toConsumableArray(e.map(function (e) {
          return e.evaluate(t);
        })));
      }],
      max: [ti, Ha(ti), function (t, e) {
        return Math.max.apply(Math, _toConsumableArray(e.map(function (e) {
          return e.evaluate(t);
        })));
      }],
      abs: [ti, [ti], function (t, _ref63) {
        var _ref64 = _slicedToArray(_ref63, 1),
          e = _ref64[0];
        return Math.abs(e.evaluate(t));
      }],
      round: [ti, [ti], function (t, _ref65) {
        var _ref66 = _slicedToArray(_ref65, 1),
          e = _ref66[0];
        var r = e.evaluate(t);
        return r < 0 ? -Math.round(-r) : Math.round(r);
      }],
      floor: [ti, [ti], function (t, _ref67) {
        var _ref68 = _slicedToArray(_ref67, 1),
          e = _ref68[0];
        return Math.floor(e.evaluate(t));
      }],
      ceil: [ti, [ti], function (t, _ref69) {
        var _ref70 = _slicedToArray(_ref69, 1),
          e = _ref70[0];
        return Math.ceil(e.evaluate(t));
      }],
      "filter-==": [ri, [ei, si], function (t, _ref71) {
        var _ref72 = _slicedToArray(_ref71, 2),
          e = _ref72[0],
          r = _ref72[1];
        return t.properties()[e.value] === r.value;
      }],
      "filter-id-==": [ri, [si], function (t, _ref73) {
        var _ref74 = _slicedToArray(_ref73, 1),
          e = _ref74[0];
        return t.id() === e.value;
      }],
      "filter-type-==": [ri, [ei], function (t, _ref75) {
        var _ref76 = _slicedToArray(_ref75, 1),
          e = _ref76[0];
        return t.geometryType() === e.value;
      }],
      "filter-<": [ri, [ei, si], function (t, _ref77) {
        var _ref78 = _slicedToArray(_ref77, 2),
          e = _ref78[0],
          r = _ref78[1];
        var n = t.properties()[e.value],
          i = r.value;
        return typeof n == typeof i && n < i;
      }],
      "filter-id-<": [ri, [si], function (t, _ref79) {
        var _ref80 = _slicedToArray(_ref79, 1),
          e = _ref80[0];
        var r = t.id(),
          n = e.value;
        return typeof r == typeof n && r < n;
      }],
      "filter->": [ri, [ei, si], function (t, _ref81) {
        var _ref82 = _slicedToArray(_ref81, 2),
          e = _ref82[0],
          r = _ref82[1];
        var n = t.properties()[e.value],
          i = r.value;
        return typeof n == typeof i && n > i;
      }],
      "filter-id->": [ri, [si], function (t, _ref83) {
        var _ref84 = _slicedToArray(_ref83, 1),
          e = _ref84[0];
        var r = t.id(),
          n = e.value;
        return typeof r == typeof n && r > n;
      }],
      "filter-<=": [ri, [ei, si], function (t, _ref85) {
        var _ref86 = _slicedToArray(_ref85, 2),
          e = _ref86[0],
          r = _ref86[1];
        var n = t.properties()[e.value],
          i = r.value;
        return typeof n == typeof i && n <= i;
      }],
      "filter-id-<=": [ri, [si], function (t, _ref87) {
        var _ref88 = _slicedToArray(_ref87, 1),
          e = _ref88[0];
        var r = t.id(),
          n = e.value;
        return typeof r == typeof n && r <= n;
      }],
      "filter->=": [ri, [ei, si], function (t, _ref89) {
        var _ref90 = _slicedToArray(_ref89, 2),
          e = _ref90[0],
          r = _ref90[1];
        var n = t.properties()[e.value],
          i = r.value;
        return typeof n == typeof i && n >= i;
      }],
      "filter-id->=": [ri, [si], function (t, _ref91) {
        var _ref92 = _slicedToArray(_ref91, 1),
          e = _ref92[0];
        var r = t.id(),
          n = e.value;
        return typeof r == typeof n && r >= n;
      }],
      "filter-has": [ri, [si], function (t, _ref93) {
        var _ref94 = _slicedToArray(_ref93, 1),
          e = _ref94[0];
        return e.value in t.properties();
      }],
      "filter-has-id": [ri, [], function (t) {
        return null !== t.id() && void 0 !== t.id();
      }],
      "filter-type-in": [ri, [ui(ei)], function (t, _ref95) {
        var _ref96 = _slicedToArray(_ref95, 1),
          e = _ref96[0];
        return e.value.indexOf(t.geometryType()) >= 0;
      }],
      "filter-id-in": [ri, [ui(si)], function (t, _ref97) {
        var _ref98 = _slicedToArray(_ref97, 1),
          e = _ref98[0];
        return e.value.indexOf(t.id()) >= 0;
      }],
      "filter-in-small": [ri, [ei, ui(si)], function (t, _ref99) {
        var _ref100 = _slicedToArray(_ref99, 2),
          e = _ref100[0],
          r = _ref100[1];
        return r.value.indexOf(t.properties()[e.value]) >= 0;
      }],
      "filter-in-large": [ri, [ei, ui(si)], function (t, _ref101) {
        var _ref102 = _slicedToArray(_ref101, 2),
          e = _ref102[0],
          r = _ref102[1];
        return function (t, e, r, n) {
          for (; r <= n;) {
            var _i44 = r + n >> 1;
            if (e[_i44] === t) return !0;
            e[_i44] > t ? n = _i44 - 1 : r = _i44 + 1;
          }
          return !1;
        }(t.properties()[e.value], r.value, 0, r.value.length - 1);
      }],
      all: {
        type: ri,
        overloads: [[[ri, ri], function (t, _ref103) {
          var _ref104 = _slicedToArray(_ref103, 2),
            e = _ref104[0],
            r = _ref104[1];
          return e.evaluate(t) && r.evaluate(t);
        }], [Ha(ri), function (t, e) {
          var _iterator59 = _createForOfIteratorHelper(e),
            _step59;
          try {
            for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
              var _r68 = _step59.value;
              if (!_r68.evaluate(t)) return !1;
            }
          } catch (err) {
            _iterator59.e(err);
          } finally {
            _iterator59.f();
          }
          return !0;
        }]]
      },
      any: {
        type: ri,
        overloads: [[[ri, ri], function (t, _ref105) {
          var _ref106 = _slicedToArray(_ref105, 2),
            e = _ref106[0],
            r = _ref106[1];
          return e.evaluate(t) || r.evaluate(t);
        }], [Ha(ri), function (t, e) {
          var _iterator60 = _createForOfIteratorHelper(e),
            _step60;
          try {
            for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
              var _r69 = _step60.value;
              if (_r69.evaluate(t)) return !0;
            }
          } catch (err) {
            _iterator60.e(err);
          } finally {
            _iterator60.f();
          }
          return !1;
        }]]
      },
      "!": [ri, [ri], function (t, _ref107) {
        var _ref108 = _slicedToArray(_ref107, 1),
          e = _ref108[0];
        return !e.evaluate(t);
      }],
      "is-supported-script": [ri, [ei], function (t, _ref109) {
        var _ref110 = _slicedToArray(_ref109, 1),
          e = _ref110[0];
        var r = t.globals && t.globals.isSupportedScript;
        return !r || r(e.evaluate(t));
      }],
      upcase: [ei, [ei], function (t, _ref111) {
        var _ref112 = _slicedToArray(_ref111, 1),
          e = _ref112[0];
        return e.evaluate(t).toUpperCase();
      }],
      downcase: [ei, [ei], function (t, _ref113) {
        var _ref114 = _slicedToArray(_ref113, 1),
          e = _ref114[0];
        return e.evaluate(t).toLowerCase();
      }],
      concat: [ei, Ha(si), function (t, e) {
        return e.map(function (e) {
          return wi(e.evaluate(t));
        }).join("");
      }],
      "resolved-locale": [ei, [ai], function (t, _ref115) {
        var _ref116 = _slicedToArray(_ref115, 1),
          e = _ref116[0];
        return e.evaluate(t).resolvedLocale();
      }],
      random: [ti, [ti, ti, si], function (t, e) {
        var _e$map = e.map(function (e) {
            return e.evaluate(t);
          }),
          _e$map2 = _slicedToArray(_e$map, 3),
          r = _e$map2[0],
          n = _e$map2[1],
          i = _e$map2[2];
        if (r > n) return r;
        if (r === n) return r;
        var s;
        if ("string" == typeof i) s = function (t) {
          var e = 0;
          if (0 === t.length) return e;
          for (var _r70 = 0; _r70 < t.length; _r70++) e = (e << 5) - e + t.charCodeAt(_r70), e |= 0;
          return e;
        }(i);else {
          if ("number" != typeof i) throw new Ai("Invalid seed input: ".concat(i));
          s = i;
        }
        return r + $a(s)() * (n - r);
      }]
    });
    var ho = /*#__PURE__*/function () {
      function ho(t, e, r, n) {
        _classCallCheck(this, ho);
        this.expression = t, this._warningHistory = {}, this._evaluator = new Di(r, n), this._defaultValue = e ? function (t) {
          return "color" === t.type && (no(t.default) || Array.isArray(t.default)) ? new Gn(0, 0, 0, 0) : "color" === t.type ? Gn.parse(t.default) || null : void 0 === t.default ? null : t.default;
        }(e) : null, this._enumValues = e && "enum" === e.type ? e.values : null;
      }
      _createClass(ho, [{
        key: "evaluateWithoutErrorHandling",
        value: function evaluateWithoutErrorHandling(t, e, r, n, i, s, a, o) {
          return this._evaluator.globals = t, this._evaluator.feature = e, this._evaluator.featureState = r, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = o || null, this.expression.evaluate(this._evaluator);
        }
      }, {
        key: "evaluate",
        value: function evaluate(t, e, r, n, i, s, a, o) {
          this._evaluator.globals = t, this._evaluator.feature = e || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s || null, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = o || null;
          try {
            var _t68 = this.expression.evaluate(this._evaluator);
            if (null == _t68 || "number" == typeof _t68 && _t68 != _t68) return this._defaultValue;
            if (this._enumValues && !(_t68 in this._enumValues)) throw new Ai("Expected value to be one of ".concat(Object.keys(this._enumValues).map(function (t) {
              return JSON.stringify(t);
            }).join(", "), ", but found ").concat(JSON.stringify(_t68), " instead."));
            return _t68;
          } catch (t) {
            return this._warningHistory[t.message] || (this._warningHistory[t.message] = !0, "undefined" != typeof console && console.warn("Failed to evaluate expression \"".concat(JSON.stringify(this.expression.serialize()), "\". ").concat(t.message))), this._defaultValue;
          }
        }
      }]);
      return ho;
    }();
    function po(t) {
      return Array.isArray(t) && t.length > 0 && "string" == typeof t[0] && t[0] in qa;
    }
    function fo(t, e, r, n) {
      var i = new ta(qa, [], e ? function (t) {
          var e = {
            color: ni,
            string: ei,
            number: ti,
            enum: ei,
            boolean: ri,
            formatted: oi,
            resolvedImage: li
          };
          return "array" === t.type ? ui(e[t.value] || si, t.length) : e[t.type];
        }(e) : void 0, void 0, void 0, r, n),
        s = i.parse(t, void 0, void 0, void 0, e && "string" === e.type ? {
          typeAnnotation: "coerce"
        } : void 0);
      return s ? Ka(new ho(s, e, r, n)) : Wa(i.errors);
    }
    var mo = /*#__PURE__*/function () {
      function mo(t, e, r) {
        _classCallCheck(this, mo);
        this.kind = t, this._styleExpression = e, this.isLightConstant = r, this.isStateDependent = "constant" !== t && !Hs(e.expression), this.configDependencies = Ks(e.expression);
      }
      _createClass(mo, [{
        key: "evaluateWithoutErrorHandling",
        value: function evaluateWithoutErrorHandling(t, e, r, n, i, s) {
          return this._styleExpression.evaluateWithoutErrorHandling(t, e, r, n, i, s);
        }
      }, {
        key: "evaluate",
        value: function evaluate(t, e, r, n, i, s) {
          return this._styleExpression.evaluate(t, e, r, n, i, s);
        }
      }]);
      return mo;
    }();
    var yo = /*#__PURE__*/function () {
      function yo(t, e, r, n, i) {
        _classCallCheck(this, yo);
        this.kind = t, this.zoomStops = r, this._styleExpression = e, this.isStateDependent = "camera" !== t && !Hs(e.expression), this.isLightConstant = i, this.configDependencies = Ks(e.expression), this.interpolationType = n;
      }
      _createClass(yo, [{
        key: "evaluateWithoutErrorHandling",
        value: function evaluateWithoutErrorHandling(t, e, r, n, i, s) {
          return this._styleExpression.evaluateWithoutErrorHandling(t, e, r, n, i, s);
        }
      }, {
        key: "evaluate",
        value: function evaluate(t, e, r, n, i, s) {
          return this._styleExpression.evaluate(t, e, r, n, i, s);
        }
      }, {
        key: "interpolationFactor",
        value: function interpolationFactor(t, e, r) {
          return this.interpolationType ? wa.interpolationFactor(this.interpolationType, t, e, r) : 0;
        }
      }]);
      return yo;
    }();
    function go(t, e, r, n) {
      if ("error" === (t = fo(t, e, r, n)).result) return t;
      var i = t.value.expression,
        s = Zs(i);
      if (!s && !Qa(e)) return Wa([new Wn("", "data expressions not supported")]);
      var a = Ws(i, ["zoom", "pitch", "distance-from-center"]);
      if (!a && !eo(e)) return Wa([new Wn("", "zoom expressions not supported")]);
      var o = Ws(i, ["measure-light"]);
      if (!o && !to(e)) return Wa([new Wn("", "measure-light expression not supported")]);
      var l = e.expression && e.expression.relaxZoomRestriction,
        u = bo(i);
      return u || a || l ? u instanceof Wn ? Wa([u]) : u instanceof wa && !ro(e) ? Wa([new Wn("", '"interpolate" expressions cannot be used with this property')]) : Ka(u ? new yo(s ? "camera" : "composite", t.value, u.labels, u instanceof wa ? u.interpolation : void 0, o) : new mo(s ? "constant" : "source", t.value, o)) : Wa([new Wn("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')]);
    }
    var xo = /*#__PURE__*/function () {
      function xo(t, e) {
        _classCallCheck(this, xo);
        this._parameters = t, this._specification = e, Kn(this, so(this._parameters, this._specification));
      }
      _createClass(xo, null, [{
        key: "deserialize",
        value: function deserialize(t) {
          return new xo(t._parameters, t._specification);
        }
      }, {
        key: "serialize",
        value: function serialize(t) {
          return {
            _parameters: t._parameters,
            _specification: t._specification
          };
        }
      }]);
      return xo;
    }();
    function bo(t) {
      var e = null;
      if (t instanceof Sa) e = bo(t.result);else if (t instanceof Aa) {
        var _iterator61 = _createForOfIteratorHelper(t.args),
          _step61;
        try {
          for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
            var _r71 = _step61.value;
            if (e = bo(_r71), e) break;
          }
        } catch (err) {
          _iterator61.e(err);
        } finally {
          _iterator61.f();
        }
      } else (t instanceof na || t instanceof wa) && t.input instanceof Ri && "zoom" === t.input.name && (e = t);
      return e instanceof Wn || t.eachChild(function (t) {
        var r = bo(t);
        r instanceof Wn ? e = r : e && r && e !== r && (e = new Wn("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
      }), e;
    }
    var vo = wo,
      _o = 3;
    function wo(t, e, r) {
      var n = this.cells = [];
      if (t instanceof ArrayBuffer) {
        this.arrayBuffer = t;
        var i = new Int32Array(this.arrayBuffer);
        t = i[0], this.d = (e = i[1]) + 2 * (r = i[2]);
        for (var s = 0; s < this.d * this.d; s++) {
          var a = i[_o + s],
            o = i[_o + s + 1];
          n.push(a === o ? null : i.subarray(a, o));
        }
        var l = i[_o + n.length + 1];
        this.keys = i.subarray(i[_o + n.length], l), this.bboxes = i.subarray(l), this.insert = this._insertReadonly;
      } else {
        this.d = e + 2 * r;
        for (var u = 0; u < this.d * this.d; u++) n.push([]);
        this.keys = [], this.bboxes = [];
      }
      this.n = e, this.extent = t, this.padding = r, this.scale = e / t, this.uid = 0;
      var c = r / e * t;
      this.min = -c, this.max = t + c;
    }
    wo.prototype.insert = function (t, e, r, n, i) {
      this._forEachCell(e, r, n, i, this._insertCell, this.uid++), this.keys.push(t), this.bboxes.push(e), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
    }, wo.prototype._insertReadonly = function () {
      throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
    }, wo.prototype._insertCell = function (t, e, r, n, i, s) {
      this.cells[i].push(s);
    }, wo.prototype.query = function (t, e, r, n, i) {
      var s = this.min,
        a = this.max;
      if (t <= s && e <= s && a <= r && a <= n && !i) return Array.prototype.slice.call(this.keys);
      var o = [];
      return this._forEachCell(t, e, r, n, this._queryCell, o, {}, i), o;
    }, wo.prototype._queryCell = function (t, e, r, n, i, s, a, o) {
      var l = this.cells[i];
      if (null !== l) for (var u = this.keys, c = this.bboxes, h = 0; h < l.length; h++) {
        var p = l[h];
        if (void 0 === a[p]) {
          var f = 4 * p;
          (o ? o(c[f + 0], c[f + 1], c[f + 2], c[f + 3]) : t <= c[f + 2] && e <= c[f + 3] && r >= c[f + 0] && n >= c[f + 1]) ? (a[p] = !0, s.push(u[p])) : a[p] = !1;
        }
      }
    }, wo.prototype._forEachCell = function (t, e, r, n, i, s, a, o) {
      for (var l = this._convertToCellCoord(t), u = this._convertToCellCoord(e), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n), p = l; p <= c; p++) for (var f = u; f <= h; f++) {
        var d = this.d * f + p;
        if ((!o || o(this._convertFromCellCoord(p), this._convertFromCellCoord(f), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(f + 1))) && i.call(this, t, e, r, n, d, s, a, o)) return;
      }
    }, wo.prototype._convertFromCellCoord = function (t) {
      return (t - this.padding) / this.scale;
    }, wo.prototype._convertToCellCoord = function (t) {
      return Math.max(0, Math.min(this.d - 1, Math.floor(t * this.scale) + this.padding));
    }, wo.prototype.toArrayBuffer = function () {
      if (this.arrayBuffer) return this.arrayBuffer;
      for (var t = this.cells, e = _o + this.cells.length + 1 + 1, r = 0, n = 0; n < this.cells.length; n++) r += this.cells[n].length;
      var i = new Int32Array(e + r + this.keys.length + this.bboxes.length);
      i[0] = this.extent, i[1] = this.n, i[2] = this.padding;
      for (var s = e, a = 0; a < t.length; a++) {
        var o = t[a];
        i[_o + a] = s, i.set(o, s), s += o.length;
      }
      return i[_o + t.length] = s, i.set(this.keys, s), i[_o + t.length + 1] = s += this.keys.length, i.set(this.bboxes, s), s += this.bboxes.length, i.buffer;
    };
    var Mo = p(vo);
    var Ao = {};
    function So(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      Object.defineProperty(t, "_classRegistryKey", {
        value: e,
        writable: !1
      }), Ao[e] = {
        klass: t,
        omit: r.omit || []
      };
    }
    So(Object, "Object"), Mo.serialize = function (t, e) {
      var r = t.toArrayBuffer();
      return e && e.add(r), {
        buffer: r
      };
    }, Mo.deserialize = function (t) {
      return new Mo(t.buffer);
    }, Object.defineProperty(Mo, "name", {
      value: "Grid"
    }), So(Mo, "Grid"), So(Gn, "Color"), So(Error, "Error"), So(gi, "Formatted"), So(yi, "FormattedSection"), So(tn, "AJAXError"), So(xi, "ResolvedImage"), So(xo, "StylePropertyFunction"), So(ho, "StyleExpression", {
      omit: ["_evaluator"]
    }), So(yo, "ZoomDependentExpression"), So(mo, "ZoomConstantExpression"), So(Ri, "CompoundExpression", {
      omit: ["_evaluate"]
    });
    for (var _t69 in qa) Ao[qa[_t69]._classRegistryKey] || So(qa[_t69], "Expression".concat(_t69));
    function Io(t) {
      return t && "undefined" != typeof ArrayBuffer && (t instanceof ArrayBuffer || t.constructor && "ArrayBuffer" === t.constructor.name);
    }
    function To(t) {
      return self.ImageBitmap && t instanceof ImageBitmap;
    }
    function ko(t, e) {
      if (null == t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || t instanceof Boolean || t instanceof Number || t instanceof String || t instanceof Date || t instanceof RegExp) return t;
      if (Io(t) || To(t)) return e && e.add(t), t;
      if (ArrayBuffer.isView(t)) {
        var _r72 = t;
        return e && e.add(_r72.buffer), _r72;
      }
      if (t instanceof ImageData) return e && e.add(t.data.buffer), t;
      if (Array.isArray(t)) {
        var _r73 = [];
        var _iterator62 = _createForOfIteratorHelper(t),
          _step62;
        try {
          for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
            var _n45 = _step62.value;
            _r73.push(ko(_n45, e));
          }
        } catch (err) {
          _iterator62.e(err);
        } finally {
          _iterator62.f();
        }
        return _r73;
      }
      if (t instanceof Map) {
        var _e68 = {
          $name: "Map"
        };
        var _iterator63 = _createForOfIteratorHelper(t.entries()),
          _step63;
        try {
          for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
            var _step63$value = _slicedToArray(_step63.value, 2),
              _r74 = _step63$value[0],
              _n46 = _step63$value[1];
            _e68[_r74] = ko(_n46);
          }
        } catch (err) {
          _iterator63.e(err);
        } finally {
          _iterator63.f();
        }
        return _e68;
      }
      if (t instanceof Set) {
        var _e69 = {
          $name: "Set"
        };
        var _r75 = 0;
        var _iterator64 = _createForOfIteratorHelper(t.values()),
          _step64;
        try {
          for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
            var _n47 = _step64.value;
            _e69[++_r75] = ko(_n47);
          }
        } catch (err) {
          _iterator64.e(err);
        } finally {
          _iterator64.f();
        }
        return _e69;
      }
      if ("object" == typeof t) {
        var _r76 = t.constructor,
          _n48 = _r76._classRegistryKey;
        if (!_n48) throw new Error("can't serialize object of unregistered class ".concat(_n48));
        var _i45 = _r76.serialize ? _r76.serialize(t, e) : {};
        if (!_r76.serialize) {
          for (var _r77 in t) t.hasOwnProperty(_r77) && (Ao[_n48].omit.indexOf(_r77) >= 0 || (_i45[_r77] = ko(t[_r77], e)));
          t instanceof Error && (_i45.message = t.message);
        }
        if (_i45.$name) throw new Error("$name property is reserved for worker serialization logic.");
        return "Object" !== _n48 && (_i45.$name = _n48), _i45;
      }
      throw new Error("can't serialize object of type " + typeof t);
    }
    function Po(t) {
      if (null == t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || t instanceof Boolean || t instanceof Number || t instanceof String || t instanceof Date || t instanceof RegExp || Io(t) || To(t) || ArrayBuffer.isView(t) || t instanceof ImageData) return t;
      if (Array.isArray(t)) return t.map(Po);
      if ("object" == typeof t) {
        var _e70 = t.$name || "Object";
        if ("Map" === _e70) {
          var _e71 = new Map();
          for (var _i46 = 0, _Object$keys2 = Object.keys(t); _i46 < _Object$keys2.length; _i46++) {
            var _r78 = _Object$keys2[_i46];
            "$name" !== _r78 && _e71.set(_r78, Po(t[_r78]));
          }
          return _e71;
        }
        if ("Set" === _e70) {
          var _e72 = new Set();
          for (var _i47 = 0, _Object$keys3 = Object.keys(t); _i47 < _Object$keys3.length; _i47++) {
            var _r79 = _Object$keys3[_i47];
            "$name" !== _r79 && _e72.add(Po(t[_r79]));
          }
          return _e72;
        }
        var _r80 = Ao[_e70].klass;
        if (!_r80) throw new Error("can't deserialize unregistered class ".concat(_e70));
        if (_r80.deserialize) return _r80.deserialize(t);
        var _n49 = Object.create(_r80.prototype);
        for (var _i48 = 0, _Object$keys4 = Object.keys(t); _i48 < _Object$keys4.length; _i48++) {
          var _e73 = _Object$keys4[_i48];
          "$name" !== _e73 && (_n49[_e73] = Po(t[_e73]));
        }
        return _n49;
      }
      throw new Error("can't deserialize object of type " + typeof t);
    }
    var zo = {
      "Latin-1 Supplement": function Latin1Supplement(t) {
        return t >= 128 && t <= 255;
      },
      Arabic: function Arabic(t) {
        return t >= 1536 && t <= 1791;
      },
      "Arabic Supplement": function ArabicSupplement(t) {
        return t >= 1872 && t <= 1919;
      },
      "Arabic Extended-A": function ArabicExtendedA(t) {
        return t >= 2208 && t <= 2303;
      },
      "Hangul Jamo": function HangulJamo(t) {
        return t >= 4352 && t <= 4607;
      },
      "Unified Canadian Aboriginal Syllabics": function UnifiedCanadianAboriginalSyllabics(t) {
        return t >= 5120 && t <= 5759;
      },
      Khmer: function Khmer(t) {
        return t >= 6016 && t <= 6143;
      },
      "Unified Canadian Aboriginal Syllabics Extended": function UnifiedCanadianAboriginalSyllabicsExtended(t) {
        return t >= 6320 && t <= 6399;
      },
      "General Punctuation": function GeneralPunctuation(t) {
        return t >= 8192 && t <= 8303;
      },
      "Letterlike Symbols": function LetterlikeSymbols(t) {
        return t >= 8448 && t <= 8527;
      },
      "Number Forms": function NumberForms(t) {
        return t >= 8528 && t <= 8591;
      },
      "Miscellaneous Technical": function MiscellaneousTechnical(t) {
        return t >= 8960 && t <= 9215;
      },
      "Control Pictures": function ControlPictures(t) {
        return t >= 9216 && t <= 9279;
      },
      "Optical Character Recognition": function OpticalCharacterRecognition(t) {
        return t >= 9280 && t <= 9311;
      },
      "Enclosed Alphanumerics": function EnclosedAlphanumerics(t) {
        return t >= 9312 && t <= 9471;
      },
      "Geometric Shapes": function GeometricShapes(t) {
        return t >= 9632 && t <= 9727;
      },
      "Miscellaneous Symbols": function MiscellaneousSymbols(t) {
        return t >= 9728 && t <= 9983;
      },
      "Miscellaneous Symbols and Arrows": function MiscellaneousSymbolsAndArrows(t) {
        return t >= 11008 && t <= 11263;
      },
      "CJK Radicals Supplement": function CJKRadicalsSupplement(t) {
        return t >= 11904 && t <= 12031;
      },
      "Kangxi Radicals": function KangxiRadicals(t) {
        return t >= 12032 && t <= 12255;
      },
      "Ideographic Description Characters": function IdeographicDescriptionCharacters(t) {
        return t >= 12272 && t <= 12287;
      },
      "CJK Symbols and Punctuation": function CJKSymbolsAndPunctuation(t) {
        return t >= 12288 && t <= 12351;
      },
      Hiragana: function Hiragana(t) {
        return t >= 12352 && t <= 12447;
      },
      Katakana: function Katakana(t) {
        return t >= 12448 && t <= 12543;
      },
      Bopomofo: function Bopomofo(t) {
        return t >= 12544 && t <= 12591;
      },
      "Hangul Compatibility Jamo": function HangulCompatibilityJamo(t) {
        return t >= 12592 && t <= 12687;
      },
      Kanbun: function Kanbun(t) {
        return t >= 12688 && t <= 12703;
      },
      "Bopomofo Extended": function BopomofoExtended(t) {
        return t >= 12704 && t <= 12735;
      },
      "CJK Strokes": function CJKStrokes(t) {
        return t >= 12736 && t <= 12783;
      },
      "Katakana Phonetic Extensions": function KatakanaPhoneticExtensions(t) {
        return t >= 12784 && t <= 12799;
      },
      "Enclosed CJK Letters and Months": function EnclosedCJKLettersAndMonths(t) {
        return t >= 12800 && t <= 13055;
      },
      "CJK Compatibility": function CJKCompatibility(t) {
        return t >= 13056 && t <= 13311;
      },
      "CJK Unified Ideographs Extension A": function CJKUnifiedIdeographsExtensionA(t) {
        return t >= 13312 && t <= 19903;
      },
      "Yijing Hexagram Symbols": function YijingHexagramSymbols(t) {
        return t >= 19904 && t <= 19967;
      },
      "CJK Unified Ideographs": function CJKUnifiedIdeographs(t) {
        return t >= 19968 && t <= 40959;
      },
      "Yi Syllables": function YiSyllables(t) {
        return t >= 40960 && t <= 42127;
      },
      "Yi Radicals": function YiRadicals(t) {
        return t >= 42128 && t <= 42191;
      },
      "Hangul Jamo Extended-A": function HangulJamoExtendedA(t) {
        return t >= 43360 && t <= 43391;
      },
      "Hangul Syllables": function HangulSyllables(t) {
        return t >= 44032 && t <= 55215;
      },
      "Hangul Jamo Extended-B": function HangulJamoExtendedB(t) {
        return t >= 55216 && t <= 55295;
      },
      "Private Use Area": function PrivateUseArea(t) {
        return t >= 57344 && t <= 63743;
      },
      "CJK Compatibility Ideographs": function CJKCompatibilityIdeographs(t) {
        return t >= 63744 && t <= 64255;
      },
      "Arabic Presentation Forms-A": function ArabicPresentationFormsA(t) {
        return t >= 64336 && t <= 65023;
      },
      "Vertical Forms": function VerticalForms(t) {
        return t >= 65040 && t <= 65055;
      },
      "CJK Compatibility Forms": function CJKCompatibilityForms(t) {
        return t >= 65072 && t <= 65103;
      },
      "Small Form Variants": function SmallFormVariants(t) {
        return t >= 65104 && t <= 65135;
      },
      "Arabic Presentation Forms-B": function ArabicPresentationFormsB(t) {
        return t >= 65136 && t <= 65279;
      },
      "Halfwidth and Fullwidth Forms": function HalfwidthAndFullwidthForms(t) {
        return t >= 65280 && t <= 65519;
      },
      "CJK Unified Ideographs Extension B": function CJKUnifiedIdeographsExtensionB(t) {
        return t >= 131072 && t <= 173791;
      }
    };
    function Eo(t) {
      var _iterator65 = _createForOfIteratorHelper(t),
        _step65;
      try {
        for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
          var _e74 = _step65.value;
          if (Ro(_e74.charCodeAt(0))) return !0;
        }
      } catch (err) {
        _iterator65.e(err);
      } finally {
        _iterator65.f();
      }
      return !1;
    }
    function Bo(t) {
      var _iterator66 = _createForOfIteratorHelper(t),
        _step66;
      try {
        for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
          var _e75 = _step66.value;
          if (!Do(_e75.charCodeAt(0))) return !1;
        }
      } catch (err) {
        _iterator66.e(err);
      } finally {
        _iterator66.f();
      }
      return !0;
    }
    function Do(t) {
      return !(zo.Arabic(t) || zo["Arabic Supplement"](t) || zo["Arabic Extended-A"](t) || zo["Arabic Presentation Forms-A"](t) || zo["Arabic Presentation Forms-B"](t));
    }
    function Ro(t) {
      return !(746 !== t && 747 !== t && (t < 4352 || !(zo["Bopomofo Extended"](t) || zo.Bopomofo(t) || zo["CJK Compatibility Forms"](t) && !(t >= 65097 && t <= 65103) || zo["CJK Compatibility Ideographs"](t) || zo["CJK Compatibility"](t) || zo["CJK Radicals Supplement"](t) || zo["CJK Strokes"](t) || !(!zo["CJK Symbols and Punctuation"](t) || t >= 12296 && t <= 12305 || t >= 12308 && t <= 12319 || 12336 === t) || zo["CJK Unified Ideographs Extension A"](t) || zo["CJK Unified Ideographs"](t) || zo["Enclosed CJK Letters and Months"](t) || zo["Hangul Compatibility Jamo"](t) || zo["Hangul Jamo Extended-A"](t) || zo["Hangul Jamo Extended-B"](t) || zo["Hangul Jamo"](t) || zo["Hangul Syllables"](t) || zo.Hiragana(t) || zo["Ideographic Description Characters"](t) || zo.Kanbun(t) || zo["Kangxi Radicals"](t) || zo["Katakana Phonetic Extensions"](t) || zo.Katakana(t) && 12540 !== t || !(!zo["Halfwidth and Fullwidth Forms"](t) || 65288 === t || 65289 === t || 65293 === t || t >= 65306 && t <= 65310 || 65339 === t || 65341 === t || 65343 === t || t >= 65371 && t <= 65503 || 65507 === t || t >= 65512 && t <= 65519) || !(!zo["Small Form Variants"](t) || t >= 65112 && t <= 65118 || t >= 65123 && t <= 65126) || zo["Unified Canadian Aboriginal Syllabics"](t) || zo["Unified Canadian Aboriginal Syllabics Extended"](t) || zo["Vertical Forms"](t) || zo["Yijing Hexagram Symbols"](t) || zo["Yi Syllables"](t) || zo["Yi Radicals"](t))));
    }
    function Co(t) {
      return !(Ro(t) || function (t) {
        return !!(zo["Latin-1 Supplement"](t) && (167 === t || 169 === t || 174 === t || 177 === t || 188 === t || 189 === t || 190 === t || 215 === t || 247 === t) || zo["General Punctuation"](t) && (8214 === t || 8224 === t || 8225 === t || 8240 === t || 8241 === t || 8251 === t || 8252 === t || 8258 === t || 8263 === t || 8264 === t || 8265 === t || 8273 === t) || zo["Letterlike Symbols"](t) || zo["Number Forms"](t) || zo["Miscellaneous Technical"](t) && (t >= 8960 && t <= 8967 || t >= 8972 && t <= 8991 || t >= 8996 && t <= 9e3 || 9003 === t || t >= 9085 && t <= 9114 || t >= 9150 && t <= 9165 || 9167 === t || t >= 9169 && t <= 9179 || t >= 9186 && t <= 9215) || zo["Control Pictures"](t) && 9251 !== t || zo["Optical Character Recognition"](t) || zo["Enclosed Alphanumerics"](t) || zo["Geometric Shapes"](t) || zo["Miscellaneous Symbols"](t) && !(t >= 9754 && t <= 9759) || zo["Miscellaneous Symbols and Arrows"](t) && (t >= 11026 && t <= 11055 || t >= 11088 && t <= 11097 || t >= 11192 && t <= 11243) || zo["CJK Symbols and Punctuation"](t) || zo.Katakana(t) || zo["Private Use Area"](t) || zo["CJK Compatibility Forms"](t) || zo["Small Form Variants"](t) || zo["Halfwidth and Fullwidth Forms"](t) || 8734 === t || 8756 === t || 8757 === t || t >= 9984 && t <= 10087 || t >= 10102 && t <= 10131 || 65532 === t || 65533 === t);
      }(t));
    }
    function Lo(t) {
      return t >= 1424 && t <= 2303 || zo["Arabic Presentation Forms-A"](t) || zo["Arabic Presentation Forms-B"](t);
    }
    function Vo(t, e) {
      return !(!e && Lo(t) || t >= 2304 && t <= 3583 || t >= 3840 && t <= 4255 || zo.Khmer(t));
    }
    function Fo(t) {
      var _iterator67 = _createForOfIteratorHelper(t),
        _step67;
      try {
        for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
          var _e76 = _step67.value;
          if (Lo(_e76.charCodeAt(0))) return !0;
        }
      } catch (err) {
        _iterator67.e(err);
      } finally {
        _iterator67.f();
      }
      return !1;
    }
    var Oo = "deferred",
      Uo = "loading",
      jo = "loaded";
    var No = null,
      $o = "unavailable",
      qo = null;
    var Go = function Go(t) {
      t && "string" == typeof t && t.indexOf("NetworkError") > -1 && ($o = "error"), No && No(t);
    };
    function Xo() {
      Yo.fire(new Cn("pluginStateChange", {
        pluginStatus: $o,
        pluginURL: qo
      }));
    }
    var Yo = new On(),
      Zo = function Zo() {
        return $o;
      },
      Ho = function Ho() {
        if ($o !== Oo || !qo) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
        $o = Uo, Xo(), qo && nn({
          url: qo
        }, function (t) {
          t ? Go(t) : ($o = jo, Xo());
        });
      },
      Ko = {
        applyArabicShaping: null,
        processBidirectionalText: null,
        processStyledBidirectionalText: null,
        isLoaded: function isLoaded() {
          return $o === jo || null != Ko.applyArabicShaping;
        },
        isLoading: function isLoading() {
          return $o === Uo;
        },
        setState: function setState(t) {
          $o = t.pluginStatus, qo = t.pluginURL;
        },
        isParsed: function isParsed() {
          return null != Ko.applyArabicShaping && null != Ko.processBidirectionalText && null != Ko.processStyledBidirectionalText;
        },
        getPluginURL: function getPluginURL() {
          return qo;
        }
      };
    var Wo = /*#__PURE__*/function () {
      function Wo(t, e) {
        _classCallCheck(this, Wo);
        this.zoom = t, e ? (this.now = e.now, this.fadeDuration = e.fadeDuration, this.transition = e.transition, this.pitch = e.pitch, this.brightness = e.brightness) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
      }
      _createClass(Wo, [{
        key: "isSupportedScript",
        value: function isSupportedScript(t) {
          return function (t, e) {
            var _iterator68 = _createForOfIteratorHelper(t),
              _step68;
            try {
              for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
                var _r81 = _step68.value;
                if (!Vo(_r81.charCodeAt(0), e)) return !1;
              }
            } catch (err) {
              _iterator68.e(err);
            } finally {
              _iterator68.f();
            }
            return !0;
          }(t, Ko.isLoaded());
        }
      }]);
      return Wo;
    }();
    var Jo = /*#__PURE__*/function () {
      function Jo(t, e, r, n) {
        _classCallCheck(this, Jo);
        this.property = t, this.value = e, this.expression = function (t, e, r, n) {
          if (no(t)) return new xo(t, e);
          if (po(t) || Array.isArray(t) && t.length > 0) {
            var _i49 = go(t, e, r, n);
            if ("error" === _i49.result) throw new Error(_i49.value.map(function (t) {
              return "".concat(t.key, ": ").concat(t.message);
            }).join(", "));
            return _i49.value;
          }
          {
            var _r82 = t;
            return "string" == typeof t && "color" === e.type && (_r82 = Gn.parse(t)), {
              kind: "constant",
              configDependencies: new Set(),
              evaluate: function evaluate() {
                return _r82;
              }
            };
          }
        }(void 0 === e ? t.specification.default : e, t.specification, r, n);
      }
      _createClass(Jo, [{
        key: "isDataDriven",
        value: function isDataDriven() {
          return "source" === this.expression.kind || "composite" === this.expression.kind;
        }
      }, {
        key: "possiblyEvaluate",
        value: function possiblyEvaluate(t, e, r) {
          return this.property.possiblyEvaluate(this, t, e, r);
        }
      }]);
      return Jo;
    }();
    var Qo = /*#__PURE__*/function () {
      function Qo(t, e, r) {
        _classCallCheck(this, Qo);
        this.property = t, this.value = new Jo(t, void 0, e, r);
      }
      _createClass(Qo, [{
        key: "transitioned",
        value: function transitioned(t, e) {
          return new el(this.property, this.value, e, rr({}, t.transition, this.transition), t.now);
        }
      }, {
        key: "untransitioned",
        value: function untransitioned() {
          return new el(this.property, this.value, null, {}, 0);
        }
      }]);
      return Qo;
    }();
    var tl = /*#__PURE__*/function () {
      function tl(t, e, r) {
        _classCallCheck(this, tl);
        this._properties = t, this._values = Object.create(t.defaultTransitionablePropertyValues), this._scope = e, this._options = r, this.configDependencies = new Set();
      }
      _createClass(tl, [{
        key: "getValue",
        value: function getValue(t) {
          return pr(this._values[t].value.value);
        }
      }, {
        key: "setValue",
        value: function setValue(t, e) {
          this._values.hasOwnProperty(t) || (this._values[t] = new Qo(this._values[t].property, this._scope, this._options)), this._values[t].value = new Jo(this._values[t].property, null === e ? void 0 : pr(e), this._scope, this._options), this._values[t].value.expression.configDependencies && (this.configDependencies = new Set([].concat(_toConsumableArray(this.configDependencies), _toConsumableArray(this._values[t].value.expression.configDependencies))));
        }
      }, {
        key: "setTransitionOrValue",
        value: function setTransitionOrValue(t, e) {
          e && (this._options = e);
          var r = this._properties.properties;
          if (t) for (var _e77 in t) {
            var _n50 = t[_e77];
            if (ur(_e77, "-transition")) {
              var _t70 = _e77.slice(0, -11);
              r[_t70] && this.setTransition(_t70, _n50);
            } else r.hasOwnProperty(_e77) && this.setValue(_e77, _n50);
          }
        }
      }, {
        key: "getTransition",
        value: function getTransition(t) {
          return pr(this._values[t].transition);
        }
      }, {
        key: "setTransition",
        value: function setTransition(t, e) {
          this._values.hasOwnProperty(t) || (this._values[t] = new Qo(this._values[t].property)), this._values[t].transition = pr(e) || void 0;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = {};
          for (var _i50 = 0, _Object$keys5 = Object.keys(this._values); _i50 < _Object$keys5.length; _i50++) {
            var _e78 = _Object$keys5[_i50];
            var _r83 = this.getValue(_e78);
            void 0 !== _r83 && (t[_e78] = _r83);
            var _n51 = this.getTransition(_e78);
            void 0 !== _n51 && (t["".concat(_e78, "-transition")] = _n51);
          }
          return t;
        }
      }, {
        key: "transitioned",
        value: function transitioned(t, e) {
          var r = new rl(this._properties);
          for (var _i51 = 0, _Object$keys6 = Object.keys(this._values); _i51 < _Object$keys6.length; _i51++) {
            var _n52 = _Object$keys6[_i51];
            r._values[_n52] = this._values[_n52].transitioned(t, e._values[_n52]);
          }
          return r;
        }
      }, {
        key: "untransitioned",
        value: function untransitioned() {
          var t = new rl(this._properties);
          for (var _i52 = 0, _Object$keys7 = Object.keys(this._values); _i52 < _Object$keys7.length; _i52++) {
            var _e79 = _Object$keys7[_i52];
            t._values[_e79] = this._values[_e79].untransitioned();
          }
          return t;
        }
      }]);
      return tl;
    }();
    var el = /*#__PURE__*/function () {
      function el(t, e, r, n, i) {
        _classCallCheck(this, el);
        var s = n.delay || 0,
          a = n.duration || 0;
        i = i || 0, this.property = t, this.value = e, this.begin = i + s, this.end = this.begin + a, t.specification.transition && (n.delay || n.duration) && (this.prior = r);
      }
      _createClass(el, [{
        key: "possiblyEvaluate",
        value: function possiblyEvaluate(t, e, r) {
          var n = t.now || 0,
            i = this.value.possiblyEvaluate(t, e, r),
            s = this.prior;
          if (s) {
            if (n > this.end) return this.prior = null, i;
            if (this.value.isDataDriven()) return this.prior = null, i;
            if (n < this.begin) return s.possiblyEvaluate(t, e, r);
            {
              var _a25 = (n - this.begin) / (this.end - this.begin);
              return this.property.interpolate(s.possiblyEvaluate(t, e, r), i, Ze(_a25));
            }
          }
          return i;
        }
      }]);
      return el;
    }();
    var rl = /*#__PURE__*/function () {
      function rl(t) {
        _classCallCheck(this, rl);
        this._properties = t, this._values = Object.create(t.defaultTransitioningPropertyValues);
      }
      _createClass(rl, [{
        key: "possiblyEvaluate",
        value: function possiblyEvaluate(t, e, r) {
          var n = new sl(this._properties);
          for (var _i53 = 0, _Object$keys8 = Object.keys(this._values); _i53 < _Object$keys8.length; _i53++) {
            var _i54 = _Object$keys8[_i53];
            n._values[_i54] = this._values[_i54].possiblyEvaluate(t, e, r);
          }
          return n;
        }
      }, {
        key: "hasTransition",
        value: function hasTransition() {
          for (var _i55 = 0, _Object$keys9 = Object.keys(this._values); _i55 < _Object$keys9.length; _i55++) {
            var _t71 = _Object$keys9[_i55];
            if (this._values[_t71].prior) return !0;
          }
          return !1;
        }
      }]);
      return rl;
    }();
    var nl = /*#__PURE__*/function () {
      function nl(t, e, r) {
        _classCallCheck(this, nl);
        this._properties = t, this._values = Object.create(t.defaultPropertyValues), this._scope = e, this._options = r, this.configDependencies = new Set();
      }
      _createClass(nl, [{
        key: "getValue",
        value: function getValue(t) {
          return pr(this._values[t].value);
        }
      }, {
        key: "setValue",
        value: function setValue(t, e) {
          this._values[t] = new Jo(this._values[t].property, null === e ? void 0 : pr(e), this._scope, this._options), this._values[t].expression.configDependencies && (this.configDependencies = new Set([].concat(_toConsumableArray(this.configDependencies), _toConsumableArray(this._values[t].expression.configDependencies))));
        }
      }, {
        key: "serialize",
        value: function serialize() {
          var t = {};
          for (var _i56 = 0, _Object$keys10 = Object.keys(this._values); _i56 < _Object$keys10.length; _i56++) {
            var _e80 = _Object$keys10[_i56];
            var _r84 = this.getValue(_e80);
            void 0 !== _r84 && (t[_e80] = _r84);
          }
          return t;
        }
      }, {
        key: "possiblyEvaluate",
        value: function possiblyEvaluate(t, e, r) {
          var n = new sl(this._properties);
          for (var _i57 = 0, _Object$keys11 = Object.keys(this._values); _i57 < _Object$keys11.length; _i57++) {
            var _i58 = _Object$keys11[_i57];
            n._values[_i58] = this._values[_i58].possiblyEvaluate(t, e, r);
          }
          return n;
        }
      }]);
      return nl;
    }();
    var il = /*#__PURE__*/function () {
      function il(t, e, r) {
        _classCallCheck(this, il);
        this.property = t, this.value = e, this.parameters = r;
      }
      _createClass(il, [{
        key: "isConstant",
        value: function isConstant() {
          return "constant" === this.value.kind;
        }
      }, {
        key: "constantOr",
        value: function constantOr(t) {
          return "constant" === this.value.kind ? this.value.value : t;
        }
      }, {
        key: "evaluate",
        value: function evaluate(t, e, r, n) {
          return this.property.evaluate(this.value, this.parameters, t, e, r, n);
        }
      }]);
      return il;
    }();
    var sl = /*#__PURE__*/function () {
      function sl(t) {
        _classCallCheck(this, sl);
        this._properties = t, this._values = Object.create(t.defaultPossiblyEvaluatedValues);
      }
      _createClass(sl, [{
        key: "get",
        value: function get(t) {
          return this._values[t];
        }
      }]);
      return sl;
    }();
    var al = /*#__PURE__*/function () {
      function al(t) {
        _classCallCheck(this, al);
        this.specification = t;
      }
      _createClass(al, [{
        key: "possiblyEvaluate",
        value: function possiblyEvaluate(t, e) {
          return t.expression.evaluate(e);
        }
      }, {
        key: "interpolate",
        value: function interpolate(t, e, r) {
          var n = Hn[this.specification.type];
          return n ? n(t, e, r) : t;
        }
      }]);
      return al;
    }();
    var ol = /*#__PURE__*/function () {
      function ol(t, e) {
        _classCallCheck(this, ol);
        this.specification = t, this.overrides = e;
      }
      _createClass(ol, [{
        key: "possiblyEvaluate",
        value: function possiblyEvaluate(t, e, r, n) {
          return new il(this, "constant" === t.expression.kind || "camera" === t.expression.kind ? {
            kind: "constant",
            value: t.expression.evaluate(e, null, {}, r, n)
          } : t.expression, e);
        }
      }, {
        key: "interpolate",
        value: function interpolate(t, e, r) {
          if ("constant" !== t.value.kind || "constant" !== e.value.kind) return t;
          if (void 0 === t.value.value || void 0 === e.value.value) return new il(this, {
            kind: "constant",
            value: void 0
          }, t.parameters);
          var n = Hn[this.specification.type];
          return n ? new il(this, {
            kind: "constant",
            value: n(t.value.value, e.value.value, r)
          }, t.parameters) : t;
        }
      }, {
        key: "evaluate",
        value: function evaluate(t, e, r, n, i, s) {
          return "constant" === t.kind ? t.value : t.evaluate(e, r, n, i, s);
        }
      }]);
      return ol;
    }();
    var ll = /*#__PURE__*/function () {
      function ll(t) {
        _classCallCheck(this, ll);
        this.specification = t;
      }
      _createClass(ll, [{
        key: "possiblyEvaluate",
        value: function possiblyEvaluate(t, e, r, n) {
          return !!t.expression.evaluate(e, null, {}, r, n);
        }
      }, {
        key: "interpolate",
        value: function interpolate() {
          return !1;
        }
      }]);
      return ll;
    }();
    var ul = /*#__PURE__*/_createClass(function ul(t) {
      _classCallCheck(this, ul);
      this.properties = t, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
      var e = new Wo(0, {});
      for (var _r85 in t) {
        var _n53 = t[_r85];
        _n53.specification.overridable && this.overridableProperties.push(_r85);
        var _i59 = this.defaultPropertyValues[_r85] = new Jo(_n53, void 0),
          _s38 = this.defaultTransitionablePropertyValues[_r85] = new Qo(_n53);
        this.defaultTransitioningPropertyValues[_r85] = _s38.untransitioned(), this.defaultPossiblyEvaluatedValues[_r85] = _i59.possiblyEvaluate(e);
      }
    });
    So(ol, "DataDrivenProperty"), So(al, "DataConstantProperty"), So(ll, "ColorRampProperty");
    var cl = JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"required":false,"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"camera":{"type":"camera"},"color-theme":{"type":"colorTheme"},"imports":{"type":"array","value":"import"},"schema":{"type":"schema"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"},"models":{"type":"models"}},"model":{"type":"string","required":true},"import":{"id":{"type":"string","required":true},"url":{"type":"string","required":true},"config":{"type":"config"},"data":{"type":"$root"}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"default":{"type":"*","property-type":"data-constant","expression":{},"required":true},"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"values":{"type":"array","value":"*"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"id":{"type":"string","required":true},"properties":{"type":"properties"},"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"cast-shadows":{"type":"boolean","default":false,"expression":{},"property-type":"data-constant"},"shadow-intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_ambient":{"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":1,"mapbox":1},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"experimental":true,"type":{"required":true,"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"},"dynamic":{"type":"boolean","default":false}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":1}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":1}},"url":{"required":false,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_model":{"type":{"required":true,"type":"enum","values":{"model":1,"batched-model":1}},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"raster-particle":{"experimental":true},"hillshade":{},"model":{"experimental":true},"background":{},"sky":{},"slot":{},"clip":{"experimental":true}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_clip","layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_raster-particle","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_model":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"model-id":{"type":"string","default":"","property-type":"data-driven","expression":{"parameters":["zoom","feature"]}}},"layout_clip":{"clip-layer-types":{"type":"array","value":"enum","values":{"model":1,"symbol":1},"default":[],"expression":{},"property-type":"data-constant","experimental":true},"clip-layer-scope":{"type":"array","value":"string","default":[],"expression":{},"property-type":"data-constant","experimental":true}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"fill-extrusion-edge-radius":{"type":"number","experimental":true,"private":true,"default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":1,"round":1,"square":1},"default":"butt","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":1,"round":1,"miter":1,"none":1},"default":"miter","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-z-offset":{"type":"number","experimental":true,"expression":{"parameters":["zoom","feature","line-progress"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":1,"line":1,"line-center":1},"default":"point","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":1,"viewport-y":1,"source":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{"type":"enum","values":{"none":1,"width":1,"height":1,"both":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":1,"left":1,"center":1,"right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":1,"uppercase":1,"lowercase":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster-particle":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":1,"exponential":1,"interval":1,"categorical":1},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":1,"lab":1,"hcl":1},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"high-color":{"type":"color","property-type":"data-constant","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"space-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"star-intensity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"camera":{"camera-projection":{"type":"enum","values":{"perspective":1,"orthographic":1},"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"default":"perspective","property-type":"data-constant"}},"colorTheme":{"data":{"type":"string","property-type":"data-constant","expression":{}}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-180,-90],"maximum":[180,90]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-90,-90],"maximum":[90,90]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_raster-particle","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-ambient-occlusion-intensity":{"property-type":"data-constant","type":"number","private":true,"default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"property-type":"data-constant","type":"number","private":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-wall-radius":{"property-type":"data-constant","type":"number","experimental":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-radius":{"property-type":"data-constant","type":"number","experimental":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-attenuation":{"property-type":"data-constant","type":"number","experimental":true,"default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-flood-light-color":{"property-type":"data-constant","type":"color","experimental":true,"default":"#ffffff","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-intensity":{"property-type":"data-constant","type":"number","experimental":true,"default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-wall-radius":{"property-type":"data-driven","type":"number","experimental":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-radius":{"property-type":"data-driven","type":"number","experimental":true,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-attenuation":{"property-type":"data-constant","type":"number","experimental":true,"default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-vertical-scale":{"property-type":"data-constant","type":"number","experimental":true,"default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-rounded-roof":{"property-type":"data-constant","type":"boolean","default":true,"experimental":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"fill-extrusion-line-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-line-alignment":{"type":"enum","values":{"inside":1,"outside":1,"center":1},"default":"center","property-type":"data-constant"}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-gradient":{"type":"color","expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"property-type":"constant"},"line-trim-fade-range":{"type":"array","value":"number","experimental":true,"length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-trim-color":{"type":"color","experimental":true,"default":"transparent","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-border-width":{"type":"number","private":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-border-color":{"type":"color","private":true,"default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true,"property-type":"data-constant"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-driven"},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-image-cross-fade":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"transition":true},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-color-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-value"]},"property-type":"color-ramp"},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color-range":{"type":"array","length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":1,"nearest":1},"default":"linear","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"raster-array-band":{"type":"string","required":false,"experimental":true,"property-type":"data-constant"},"raster-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_raster-particle":{"raster-particle-array-band":{"type":"string","required":false,"property-type":"data-constant"},"raster-particle-count":{"type":"number","default":512,"minimum":1,"property-type":"data-constant"},"raster-particle-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-particle-speed"]},"property-type":"color-ramp"},"raster-particle-max-speed":{"type":"number","default":1,"minimum":1,"property-type":"data-constant"},"raster-particle-speed-factor":{"type":"number","default":0.2,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-particle-fade-opacity-factor":{"type":"number","default":0.98,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-particle-reset-rate-factor":{"type":"number","default":0.8,"minimum":0,"maximum":1,"property-type":"data-constant"},"raster-particle-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_background":{"background-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":1,"atmosphere":1},"default":"atmosphere","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","value":"number","default":[0,0],"length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"model-rotation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-scale":{"type":"array","value":"number","length":3,"default":[1,1,1],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-translation":{"type":"array","value":"number","length":3,"default":[0,0,0],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-color":{"type":"color","default":"#ffffff","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":true},"model-color-mix-intensity":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-type":{"type":"enum","values":{"common-3d":1,"location-indicator":1},"default":"common-3d","property-type":"data-constant"},"model-cast-shadows":{"type":"boolean","default":true,"property-type":"data-constant"},"model-receive-shadows":{"type":"boolean","default":true,"property-type":"data-constant"},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant","transition":true},"model-emissive-strength":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state"]},"transition":true},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"model-front-cutoff":{"type":"array","private":true,"value":"number","property-type":"data-constant","expression":{"interpolated":true,"parameters":["zoom"]},"length":3,"default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1]}},"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"property-type":{"data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"string"}}}');
    function hl(t) {
      return t instanceof Number || t instanceof String || t instanceof Boolean ? t.valueOf() : t;
    }
    function pl(t) {
      if (Array.isArray(t)) return t.map(pl);
      if (t instanceof Object && !(t instanceof Number || t instanceof String || t instanceof Boolean)) {
        var _e81 = {};
        for (var _r86 in t) _e81[_r86] = pl(t[_r86]);
        return _e81;
      }
      return hl(t);
    }
    function fl(t) {
      if (!0 === t || !1 === t) return !0;
      if (!Array.isArray(t) || 0 === t.length) return !1;
      switch (t[0]) {
        case "has":
          return t.length >= 2 && "$id" !== t[1] && "$type" !== t[1];
        case "in":
          return t.length >= 3 && ("string" != typeof t[1] || Array.isArray(t[2]));
        case "!in":
        case "!has":
        case "none":
          return !1;
        case "==":
        case "!=":
        case ">":
        case ">=":
        case "<":
        case "<=":
          return 3 !== t.length || Array.isArray(t[1]) || Array.isArray(t[2]);
        case "any":
        case "all":
          var _iterator69 = _createForOfIteratorHelper(t.slice(1)),
            _step69;
          try {
            for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
              var _e82 = _step69.value;
              if (!fl(_e82) && "boolean" != typeof _e82) return !1;
            }
          } catch (err) {
            _iterator69.e(err);
          } finally {
            _iterator69.f();
          }
          return !0;
        default:
          return !0;
      }
    }
    function dl(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "fill";
      if (null == t) return {
        filter: function filter() {
          return !0;
        },
        needGeometry: !1,
        needFeature: !1
      };
      fl(t) || (t = _l(t));
      var r = t;
      var n = !0;
      try {
        n = function (t) {
          if (!gl(t)) return t;
          var e = pl(t);
          return yl(e), e = ml(e), e;
        }(r);
      } catch (t) {
        console.warn("Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n".concat(JSON.stringify(r, null, 2), "\n        "));
      }
      var i = cl["filter_".concat(e)],
        s = fo(n, i);
      var a = null;
      if ("error" === s.result) throw new Error(s.value.map(function (t) {
        return "".concat(t.key, ": ").concat(t.message);
      }).join(", "));
      a = function a(t, e, r) {
        return s.value.evaluate(t, e, {}, r);
      };
      var o = null,
        l = null;
      if (n !== r) {
        var _t72 = fo(r, i);
        if ("error" === _t72.result) throw new Error(_t72.value.map(function (t) {
          return "".concat(t.key, ": ").concat(t.message);
        }).join(", "));
        o = function o(e, r, n, i, s) {
          return _t72.value.evaluate(e, r, {}, n, void 0, void 0, i, s);
        }, l = !Zs(_t72.value.expression);
      }
      return {
        filter: a,
        dynamicFilter: o || void 0,
        needGeometry: vl(n),
        needFeature: !!l
      };
    }
    function ml(t) {
      if (!Array.isArray(t)) return t;
      var e = function (t) {
        if (xl.has(t[0])) for (var _e83 = 1; _e83 < t.length; _e83++) if (gl(t[_e83])) return !0;
        return t;
      }(t);
      return !0 === e ? e : e.map(function (t) {
        return ml(t);
      });
    }
    function yl(t) {
      var e = !1;
      var r = [];
      if ("case" === t[0]) {
        for (var _n54 = 1; _n54 < t.length - 1; _n54 += 2) e = e || gl(t[_n54]), r.push(t[_n54 + 1]);
        r.push(t[t.length - 1]);
      } else if ("match" === t[0]) {
        e = e || gl(t[1]);
        for (var _e84 = 2; _e84 < t.length - 1; _e84 += 2) r.push(t[_e84 + 1]);
        r.push(t[t.length - 1]);
      } else if ("step" === t[0]) {
        e = e || gl(t[1]);
        for (var _e85 = 1; _e85 < t.length - 1; _e85 += 2) r.push(t[_e85 + 1]);
      }
      e && (t.length = 0, t.push.apply(t, ["any"].concat(r)));
      for (var _e86 = 1; _e86 < t.length; _e86++) yl(t[_e86]);
    }
    function gl(t) {
      if (!Array.isArray(t)) return !1;
      if ("pitch" === (e = t[0]) || "distance-from-center" === e) return !0;
      var e;
      for (var _e87 = 1; _e87 < t.length; _e87++) if (gl(t[_e87])) return !0;
      return !1;
    }
    var xl = new Set(["in", "==", "!=", ">", ">=", "<", "<=", "to-boolean"]);
    function bl(t, e) {
      return t < e ? -1 : t > e ? 1 : 0;
    }
    function vl(t) {
      if (!Array.isArray(t)) return !1;
      if ("within" === t[0] || "distance" === t[0]) return !0;
      for (var _e88 = 1; _e88 < t.length; _e88++) if (vl(t[_e88])) return !0;
      return !1;
    }
    function _l(t) {
      if (!t) return !0;
      var e = t[0];
      return t.length <= 1 ? "any" !== e : "==" === e ? wl(t[1], t[2], "==") : "!=" === e ? Sl(wl(t[1], t[2], "==")) : "<" === e || ">" === e || "<=" === e || ">=" === e ? wl(t[1], t[2], e) : "any" === e ? (r = t.slice(1), ["any"].concat(r.map(_l))) : "all" === e ? ["all"].concat(t.slice(1).map(_l)) : "none" === e ? ["all"].concat(t.slice(1).map(_l).map(Sl)) : "in" === e ? Ml(t[1], t.slice(2)) : "!in" === e ? Sl(Ml(t[1], t.slice(2))) : "has" === e ? Al(t[1]) : "!has" !== e || Sl(Al(t[1]));
      var r;
    }
    function wl(t, e, r) {
      switch (t) {
        case "$type":
          return ["filter-type-".concat(r), e];
        case "$id":
          return ["filter-id-".concat(r), e];
        default:
          return ["filter-".concat(r), t, e];
      }
    }
    function Ml(t, e) {
      if (0 === e.length) return !1;
      switch (t) {
        case "$type":
          return ["filter-type-in", ["literal", e]];
        case "$id":
          return ["filter-id-in", ["literal", e]];
        default:
          return e.length > 200 && !e.some(function (t) {
            return typeof t != typeof e[0];
          }) ? ["filter-in-large", t, ["literal", e.sort(bl)]] : ["filter-in-small", t, ["literal", e]];
      }
    }
    function Al(t) {
      switch (t) {
        case "$type":
          return !0;
        case "$id":
          return ["filter-has-id"];
        default:
          return ["filter-has", t];
      }
    }
    function Sl(t) {
      return ["!", t];
    }
    var Il = "";
    function Tl(t, e) {
      return e ? "".concat(t).concat(Il).concat(e) : t;
    }
    var kl = "-transition",
      Pl = new Set(["fill", "line", "background", "hillshade", "raster"]);
    var zl = /*#__PURE__*/function (_On) {
      _inherits(zl, _On);
      var _super9 = _createSuper(zl);
      function zl(t, e, r, n, i) {
        var _this14;
        _classCallCheck(this, zl);
        if (_this14 = _super9.call(this), _this14.id = t.id, _this14.fqid = Tl(_this14.id, r), _this14.type = t.type, _this14.scope = r, _this14.lut = n, _this14.options = i, _this14._featureFilter = {
          filter: function filter() {
            return !0;
          },
          needGeometry: !1,
          needFeature: !1
        }, _this14._filterCompiled = !1, _this14.configDependencies = new Set(), "custom" !== t.type && (_this14.metadata = t.metadata, _this14.minzoom = t.minzoom, _this14.maxzoom = t.maxzoom, "background" !== t.type && "sky" !== t.type && "slot" !== t.type && (_this14.source = t.source, _this14.sourceLayer = t["source-layer"], _this14.filter = t.filter), t.slot && (_this14.slot = t.slot), e.layout && (_this14._unevaluatedLayout = new nl(e.layout, _this14.scope, i), _this14.configDependencies = new Set([].concat(_toConsumableArray(_this14.configDependencies), _toConsumableArray(_this14._unevaluatedLayout.configDependencies)))), e.paint)) {
          _this14._transitionablePaint = new tl(e.paint, _this14.scope, i);
          for (var _e89 in t.paint) _this14.setPaintProperty(_e89, t.paint[_e89]);
          for (var _e90 in t.layout) _this14.setLayoutProperty(_e90, t.layout[_e90]);
          _this14.configDependencies = new Set([].concat(_toConsumableArray(_this14.configDependencies), _toConsumableArray(_this14._transitionablePaint.configDependencies))), _this14._transitioningPaint = _this14._transitionablePaint.untransitioned(), _this14.paint = new sl(e.paint);
        }
        return _possibleConstructorReturn(_this14);
      }
      _createClass(zl, [{
        key: "onAdd",
        value: function onAdd(t) {}
      }, {
        key: "onRemove",
        value: function onRemove(t) {}
      }, {
        key: "isDraped",
        value: function isDraped(t) {
          return Pl.has(this.type);
        }
      }, {
        key: "getLayoutProperty",
        value: function getLayoutProperty(t) {
          return "visibility" === t ? this.visibility : this._unevaluatedLayout.getValue(t);
        }
      }, {
        key: "setLayoutProperty",
        value: function setLayoutProperty(t, e) {
          if ("custom" === this.type && "visibility" === t) return void (this.visibility = e);
          var r = this._unevaluatedLayout;
          r._properties.properties[t] && (r.setValue(t, e), this.configDependencies = new Set([].concat(_toConsumableArray(this.configDependencies), _toConsumableArray(r.configDependencies))), "visibility" === t && this.possiblyEvaluateVisibility());
        }
      }, {
        key: "possiblyEvaluateVisibility",
        value: function possiblyEvaluateVisibility() {
          this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({
            zoom: 0
          });
        }
      }, {
        key: "getPaintProperty",
        value: function getPaintProperty(t) {
          return ur(t, kl) ? this._transitionablePaint.getTransition(t.slice(0, -11)) : this._transitionablePaint.getValue(t);
        }
      }, {
        key: "setPaintProperty",
        value: function setPaintProperty(t, e) {
          var r = this._transitionablePaint,
            n = r._properties.properties;
          if (ur(t, kl)) {
            var _i60 = t.slice(0, -11);
            return n[_i60] && r.setTransition(_i60, e || void 0), !1;
          }
          if (!n[t]) return !1;
          var i = r._values[t],
            s = i.value.isDataDriven(),
            a = i.value;
          r.setValue(t, e), this.configDependencies = new Set([].concat(_toConsumableArray(this.configDependencies), _toConsumableArray(r.configDependencies))), this._handleSpecialPaintPropertyUpdate(t);
          var o = r._values[t].value,
            l = o.isDataDriven(),
            u = ur(t, "pattern") || "line-dasharray" === t;
          return l || s || u || this._handleOverridablePaintPropertyUpdate(t, a, o);
        }
      }, {
        key: "_handleSpecialPaintPropertyUpdate",
        value: function _handleSpecialPaintPropertyUpdate(t) {}
      }, {
        key: "getProgramIds",
        value: function getProgramIds() {
          return null;
        }
      }, {
        key: "getDefaultProgramParams",
        value: function getDefaultProgramParams(t, e, r) {
          return null;
        }
      }, {
        key: "_handleOverridablePaintPropertyUpdate",
        value: function _handleOverridablePaintPropertyUpdate(t, e, r) {
          return !1;
        }
      }, {
        key: "isHidden",
        value: function isHidden(t) {
          return !!(this.minzoom && t < this.minzoom) || !!(this.maxzoom && t >= this.maxzoom) || "none" === this.visibility;
        }
      }, {
        key: "updateTransitions",
        value: function updateTransitions(t) {
          this._transitioningPaint = this._transitionablePaint.transitioned(t, this._transitioningPaint);
        }
      }, {
        key: "hasTransition",
        value: function hasTransition() {
          return this._transitioningPaint.hasTransition();
        }
      }, {
        key: "recalculate",
        value: function recalculate(t, e) {
          this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t, void 0, e)), this.paint = this._transitioningPaint.possiblyEvaluate(t, void 0, e);
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return hr({
            id: this.id,
            type: this.type,
            slot: this.slot,
            source: this.source,
            "source-layer": this.sourceLayer,
            metadata: this.metadata,
            minzoom: this.minzoom,
            maxzoom: this.maxzoom,
            filter: this.filter,
            layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
            paint: this._transitionablePaint && this._transitionablePaint.serialize()
          }, function (t, e) {
            return !(void 0 === t || "layout" === e && !Object.keys(t).length || "paint" === e && !Object.keys(t).length);
          });
        }
      }, {
        key: "is3D",
        value: function is3D() {
          return !1;
        }
      }, {
        key: "isSky",
        value: function isSky() {
          return !1;
        }
      }, {
        key: "isTileClipped",
        value: function isTileClipped() {
          return !1;
        }
      }, {
        key: "hasOffscreenPass",
        value: function hasOffscreenPass() {
          return !1;
        }
      }, {
        key: "hasShadowPass",
        value: function hasShadowPass() {
          return !1;
        }
      }, {
        key: "canCastShadows",
        value: function canCastShadows() {
          return !1;
        }
      }, {
        key: "hasLightBeamPass",
        value: function hasLightBeamPass() {
          return !1;
        }
      }, {
        key: "cutoffRange",
        value: function cutoffRange() {
          return 0;
        }
      }, {
        key: "tileCoverLift",
        value: function tileCoverLift() {
          return 0;
        }
      }, {
        key: "resize",
        value: function resize() {}
      }, {
        key: "isStateDependent",
        value: function isStateDependent() {
          for (var _t73 in this.paint._values) {
            var _e91 = this.paint.get(_t73);
            if (_e91 instanceof il && Qa(_e91.property.specification) && ("source" === _e91.value.kind || "composite" === _e91.value.kind) && _e91.value.isStateDependent) return !0;
          }
          return !1;
        }
      }, {
        key: "compileFilter",
        value: function compileFilter() {
          this._filterCompiled || (this._featureFilter = dl(this.filter), this._filterCompiled = !0);
        }
      }, {
        key: "invalidateCompiledFilter",
        value: function invalidateCompiledFilter() {
          this._filterCompiled = !1;
        }
      }, {
        key: "dynamicFilter",
        value: function dynamicFilter() {
          return this._featureFilter.dynamicFilter;
        }
      }, {
        key: "dynamicFilterNeedsFeature",
        value: function dynamicFilterNeedsFeature() {
          return this._featureFilter.needFeature;
        }
      }, {
        key: "getLayerRenderingStats",
        value: function getLayerRenderingStats() {
          return this._stats;
        }
      }, {
        key: "resetLayerRenderingStats",
        value: function resetLayerRenderingStats(t) {
          this._stats && ("shadow" === t.renderPass ? this._stats.numRenderedVerticesInShadowPass = 0 : this._stats.numRenderedVerticesInTransparentPass = 0);
        }
      }, {
        key: "queryRadius",
        value: function queryRadius(t) {}
      }, {
        key: "queryIntersectsFeature",
        value: function queryIntersectsFeature(t, e, r, n, i, s, a, o, l) {}
      }, {
        key: "queryIntersectsMatchingFeature",
        value: function queryIntersectsMatchingFeature(t, e, r, n) {}
      }]);
      return zl;
    }(On);
    var El = {
      Int8: Int8Array,
      Uint8: Uint8Array,
      Int16: Int16Array,
      Uint16: Uint16Array,
      Int32: Int32Array,
      Uint32: Uint32Array,
      Float32: Float32Array
    };
    var Bl = /*#__PURE__*/_createClass(function Bl(t, e) {
      _classCallCheck(this, Bl);
      this._structArray = t, this._pos1 = e * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
    });
    var Dl = /*#__PURE__*/function () {
      function Dl() {
        _classCallCheck(this, Dl);
        this.isTransferred = !1, this.capacity = -1, this.resize(0);
      }
      _createClass(Dl, [{
        key: "_trim",
        value: function _trim() {
          this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
        }
      }, {
        key: "clear",
        value: function clear() {
          this.length = 0;
        }
      }, {
        key: "resize",
        value: function resize(t) {
          this.reserve(t), this.length = t;
        }
      }, {
        key: "reserve",
        value: function reserve(t) {
          if (t > this.capacity) {
            this.capacity = Math.max(t, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
            var _e92 = this.uint8;
            this._refreshViews(), _e92 && this.uint8.set(_e92);
          }
        }
      }, {
        key: "_refreshViews",
        value: function _refreshViews() {
          throw new Error("StructArray#_refreshViews() must be implemented by each concrete StructArray layout");
        }
      }, {
        key: "emplace",
        value: function emplace() {
          throw new Error("StructArray#emplace() must be implemented by each concrete StructArray layout");
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack() {
          throw new Error("StructArray#emplaceBack() must be implemented by each concrete StructArray layout");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
        }
      }], [{
        key: "serialize",
        value: function serialize(t, e) {
          return t._trim(), e && (t.isTransferred = !0, e.add(t.arrayBuffer)), {
            length: t.length,
            arrayBuffer: t.arrayBuffer
          };
        }
      }, {
        key: "deserialize",
        value: function deserialize(t) {
          var e = Object.create(this.prototype);
          return e.arrayBuffer = t.arrayBuffer, e.length = t.length, e.capacity = t.arrayBuffer.byteLength / e.bytesPerElement, e._refreshViews(), e;
        }
      }]);
      return Dl;
    }();
    function Rl(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var r = 0,
        n = 0;
      return {
        members: t.map(function (t) {
          var i = El[t.type].BYTES_PER_ELEMENT,
            s = r = Cl(r, Math.max(e, i)),
            a = t.components || 1;
          return n = Math.max(n, i), r += i * a, {
            name: t.name,
            type: t.type,
            components: a,
            offset: s
          };
        }),
        size: Cl(r, Math.max(n, e)),
        alignment: e
      };
    }
    function Cl(t, e) {
      return Math.ceil(t / e) * e;
    }
    var Ll = /*#__PURE__*/function (_Dl) {
      _inherits(Ll, _Dl);
      var _super10 = _createSuper(Ll);
      function Ll() {
        _classCallCheck(this, Ll);
        return _super10.apply(this, arguments);
      }
      _createClass(Ll, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e) {
          var r = this.length;
          return this.resize(r + 1), this.emplace(r, t, e);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r) {
          var n = 2 * t;
          return this.int16[n + 0] = e, this.int16[n + 1] = r, t;
        }
      }]);
      return Ll;
    }(Dl);
    Ll.prototype.bytesPerElement = 4, So(Ll, "StructArrayLayout2i4");
    var Vl = /*#__PURE__*/function (_Dl2) {
      _inherits(Vl, _Dl2);
      var _super11 = _createSuper(Vl);
      function Vl() {
        _classCallCheck(this, Vl);
        return _super11.apply(this, arguments);
      }
      _createClass(Vl, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r) {
          var n = this.length;
          return this.resize(n + 1), this.emplace(n, t, e, r);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n) {
          var i = 3 * t;
          return this.int16[i + 0] = e, this.int16[i + 1] = r, this.int16[i + 2] = n, t;
        }
      }]);
      return Vl;
    }(Dl);
    Vl.prototype.bytesPerElement = 6, So(Vl, "StructArrayLayout3i6");
    var Fl = /*#__PURE__*/function (_Dl3) {
      _inherits(Fl, _Dl3);
      var _super12 = _createSuper(Fl);
      function Fl() {
        _classCallCheck(this, Fl);
        return _super12.apply(this, arguments);
      }
      _createClass(Fl, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n) {
          var i = this.length;
          return this.resize(i + 1), this.emplace(i, t, e, r, n);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i) {
          var s = 4 * t;
          return this.int16[s + 0] = e, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, t;
        }
      }]);
      return Fl;
    }(Dl);
    Fl.prototype.bytesPerElement = 8, So(Fl, "StructArrayLayout4i8");
    var Ol = /*#__PURE__*/function (_Dl4) {
      _inherits(Ol, _Dl4);
      var _super13 = _createSuper(Ol);
      function Ol() {
        _classCallCheck(this, Ol);
        return _super13.apply(this, arguments);
      }
      _createClass(Ol, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i) {
          var s = this.length;
          return this.resize(s + 1), this.emplace(s, t, e, r, n, i);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s) {
          var a = 5 * t;
          return this.int16[a + 0] = e, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, this.int16[a + 4] = s, t;
        }
      }]);
      return Ol;
    }(Dl);
    Ol.prototype.bytesPerElement = 10, So(Ol, "StructArrayLayout5i10");
    var Ul = /*#__PURE__*/function (_Dl5) {
      _inherits(Ul, _Dl5);
      var _super14 = _createSuper(Ul);
      function Ul() {
        _classCallCheck(this, Ul);
        return _super14.apply(this, arguments);
      }
      _createClass(Ul, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i, s, a) {
          var o = this.length;
          return this.resize(o + 1), this.emplace(o, t, e, r, n, i, s, a);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s, a, o) {
          var l = 6 * t,
            u = 12 * t,
            c = 3 * t;
          return this.int16[l + 0] = e, this.int16[l + 1] = r, this.uint8[u + 4] = n, this.uint8[u + 5] = i, this.uint8[u + 6] = s, this.uint8[u + 7] = a, this.float32[c + 2] = o, t;
        }
      }]);
      return Ul;
    }(Dl);
    Ul.prototype.bytesPerElement = 12, So(Ul, "StructArrayLayout2i4ub1f12");
    var jl = /*#__PURE__*/function (_Dl6) {
      _inherits(jl, _Dl6);
      var _super15 = _createSuper(jl);
      function jl() {
        _classCallCheck(this, jl);
        return _super15.apply(this, arguments);
      }
      _createClass(jl, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n) {
          var i = this.length;
          return this.resize(i + 1), this.emplace(i, t, e, r, n);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i) {
          var s = 4 * t;
          return this.float32[s + 0] = e, this.float32[s + 1] = r, this.float32[s + 2] = n, this.float32[s + 3] = i, t;
        }
      }]);
      return jl;
    }(Dl);
    jl.prototype.bytesPerElement = 16, So(jl, "StructArrayLayout4f16");
    var Nl = /*#__PURE__*/function (_Dl7) {
      _inherits(Nl, _Dl7);
      var _super16 = _createSuper(Nl);
      function Nl() {
        _classCallCheck(this, Nl);
        return _super16.apply(this, arguments);
      }
      _createClass(Nl, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r) {
          var n = this.length;
          return this.resize(n + 1), this.emplace(n, t, e, r);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n) {
          var i = 3 * t;
          return this.float32[i + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t;
        }
      }]);
      return Nl;
    }(Dl);
    Nl.prototype.bytesPerElement = 12, So(Nl, "StructArrayLayout3f12");
    var $l = /*#__PURE__*/function (_Dl8) {
      _inherits($l, _Dl8);
      var _super17 = _createSuper($l);
      function $l() {
        _classCallCheck(this, $l);
        return _super17.apply(this, arguments);
      }
      _createClass($l, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i) {
          var s = this.length;
          return this.resize(s + 1), this.emplace(s, t, e, r, n, i);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s) {
          var a = 6 * t,
            o = 3 * t;
          return this.uint16[a + 0] = e, this.uint16[a + 1] = r, this.uint16[a + 2] = n, this.uint16[a + 3] = i, this.float32[o + 2] = s, t;
        }
      }]);
      return $l;
    }(Dl);
    $l.prototype.bytesPerElement = 12, So($l, "StructArrayLayout4ui1f12");
    var ql = /*#__PURE__*/function (_Dl9) {
      _inherits(ql, _Dl9);
      var _super18 = _createSuper(ql);
      function ql() {
        _classCallCheck(this, ql);
        return _super18.apply(this, arguments);
      }
      _createClass(ql, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n) {
          var i = this.length;
          return this.resize(i + 1), this.emplace(i, t, e, r, n);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i) {
          var s = 4 * t;
          return this.uint16[s + 0] = e, this.uint16[s + 1] = r, this.uint16[s + 2] = n, this.uint16[s + 3] = i, t;
        }
      }]);
      return ql;
    }(Dl);
    ql.prototype.bytesPerElement = 8, So(ql, "StructArrayLayout4ui8");
    var Gl = /*#__PURE__*/function (_Dl10) {
      _inherits(Gl, _Dl10);
      var _super19 = _createSuper(Gl);
      function Gl() {
        _classCallCheck(this, Gl);
        return _super19.apply(this, arguments);
      }
      _createClass(Gl, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i, s) {
          var a = this.length;
          return this.resize(a + 1), this.emplace(a, t, e, r, n, i, s);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s, a) {
          var o = 6 * t;
          return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, this.int16[o + 5] = a, t;
        }
      }]);
      return Gl;
    }(Dl);
    Gl.prototype.bytesPerElement = 12, So(Gl, "StructArrayLayout6i12");
    var Xl = /*#__PURE__*/function (_Dl11) {
      _inherits(Xl, _Dl11);
      var _super20 = _createSuper(Xl);
      function Xl() {
        _classCallCheck(this, Xl);
        return _super20.apply(this, arguments);
      }
      _createClass(Xl, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i, s, a, o, l, u, c, h) {
          var p = this.length;
          return this.resize(p + 1), this.emplace(p, t, e, r, n, i, s, a, o, l, u, c, h);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s, a, o, l, u, c, h, p) {
          var f = 12 * t;
          return this.int16[f + 0] = e, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = s, this.uint16[f + 5] = a, this.uint16[f + 6] = o, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t;
        }
      }]);
      return Xl;
    }(Dl);
    Xl.prototype.bytesPerElement = 24, So(Xl, "StructArrayLayout4i4ui4i24");
    var Yl = /*#__PURE__*/function (_Dl12) {
      _inherits(Yl, _Dl12);
      var _super21 = _createSuper(Yl);
      function Yl() {
        _classCallCheck(this, Yl);
        return _super21.apply(this, arguments);
      }
      _createClass(Yl, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i, s) {
          var a = this.length;
          return this.resize(a + 1), this.emplace(a, t, e, r, n, i, s);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s, a) {
          var o = 10 * t,
            l = 5 * t;
          return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.float32[l + 2] = i, this.float32[l + 3] = s, this.float32[l + 4] = a, t;
        }
      }]);
      return Yl;
    }(Dl);
    Yl.prototype.bytesPerElement = 20, So(Yl, "StructArrayLayout3i3f20");
    var Zl = /*#__PURE__*/function (_Dl13) {
      _inherits(Zl, _Dl13);
      var _super22 = _createSuper(Zl);
      function Zl() {
        _classCallCheck(this, Zl);
        return _super22.apply(this, arguments);
      }
      _createClass(Zl, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t) {
          var e = this.length;
          return this.resize(e + 1), this.emplace(e, t);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e) {
          return this.uint32[1 * t + 0] = e, t;
        }
      }]);
      return Zl;
    }(Dl);
    Zl.prototype.bytesPerElement = 4, So(Zl, "StructArrayLayout1ul4");
    var Hl = /*#__PURE__*/function (_Dl14) {
      _inherits(Hl, _Dl14);
      var _super23 = _createSuper(Hl);
      function Hl() {
        _classCallCheck(this, Hl);
        return _super23.apply(this, arguments);
      }
      _createClass(Hl, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e) {
          var r = this.length;
          return this.resize(r + 1), this.emplace(r, t, e);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r) {
          var n = 2 * t;
          return this.uint16[n + 0] = e, this.uint16[n + 1] = r, t;
        }
      }]);
      return Hl;
    }(Dl);
    Hl.prototype.bytesPerElement = 4, So(Hl, "StructArrayLayout2ui4");
    var Kl = /*#__PURE__*/function (_Dl15) {
      _inherits(Kl, _Dl15);
      var _super24 = _createSuper(Kl);
      function Kl() {
        _classCallCheck(this, Kl);
        return _super24.apply(this, arguments);
      }
      _createClass(Kl, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i, s, a, o, l, u, c, h, p) {
          var f = this.length;
          return this.resize(f + 1), this.emplace(f, t, e, r, n, i, s, a, o, l, u, c, h, p);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s, a, o, l, u, c, h, p, f) {
          var d = 20 * t,
            m = 10 * t;
          return this.int16[d + 0] = e, this.int16[d + 1] = r, this.int16[d + 2] = n, this.int16[d + 3] = i, this.int16[d + 4] = s, this.float32[m + 3] = a, this.float32[m + 4] = o, this.float32[m + 5] = l, this.float32[m + 6] = u, this.int16[d + 14] = c, this.uint32[m + 8] = h, this.uint16[d + 18] = p, this.uint16[d + 19] = f, t;
        }
      }]);
      return Kl;
    }(Dl);
    Kl.prototype.bytesPerElement = 40, So(Kl, "StructArrayLayout5i4f1i1ul2ui40");
    var Wl = /*#__PURE__*/function (_Dl16) {
      _inherits(Wl, _Dl16);
      var _super25 = _createSuper(Wl);
      function Wl() {
        _classCallCheck(this, Wl);
        return _super25.apply(this, arguments);
      }
      _createClass(Wl, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i, s, a) {
          var o = this.length;
          return this.resize(o + 1), this.emplace(o, t, e, r, n, i, s, a);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s, a, o) {
          var l = 8 * t;
          return this.int16[l + 0] = e, this.int16[l + 1] = r, this.int16[l + 2] = n, this.int16[l + 4] = i, this.int16[l + 5] = s, this.int16[l + 6] = a, this.int16[l + 7] = o, t;
        }
      }]);
      return Wl;
    }(Dl);
    Wl.prototype.bytesPerElement = 16, So(Wl, "StructArrayLayout3i2i2i16");
    var Jl = /*#__PURE__*/function (_Dl17) {
      _inherits(Jl, _Dl17);
      var _super26 = _createSuper(Jl);
      function Jl() {
        _classCallCheck(this, Jl);
        return _super26.apply(this, arguments);
      }
      _createClass(Jl, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i) {
          var s = this.length;
          return this.resize(s + 1), this.emplace(s, t, e, r, n, i);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s) {
          var a = 4 * t,
            o = 8 * t;
          return this.float32[a + 0] = e, this.float32[a + 1] = r, this.float32[a + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = s, t;
        }
      }]);
      return Jl;
    }(Dl);
    Jl.prototype.bytesPerElement = 16, So(Jl, "StructArrayLayout2f1f2i16");
    var Ql = /*#__PURE__*/function (_Dl18) {
      _inherits(Ql, _Dl18);
      var _super27 = _createSuper(Ql);
      function Ql() {
        _classCallCheck(this, Ql);
        return _super27.apply(this, arguments);
      }
      _createClass(Ql, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n) {
          var i = this.length;
          return this.resize(i + 1), this.emplace(i, t, e, r, n);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i) {
          var s = 12 * t,
            a = 3 * t;
          return this.uint8[s + 0] = e, this.uint8[s + 1] = r, this.float32[a + 1] = n, this.float32[a + 2] = i, t;
        }
      }]);
      return Ql;
    }(Dl);
    Ql.prototype.bytesPerElement = 12, So(Ql, "StructArrayLayout2ub2f12");
    var tu = /*#__PURE__*/function (_Dl19) {
      _inherits(tu, _Dl19);
      var _super28 = _createSuper(tu);
      function tu() {
        _classCallCheck(this, tu);
        return _super28.apply(this, arguments);
      }
      _createClass(tu, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r) {
          var n = this.length;
          return this.resize(n + 1), this.emplace(n, t, e, r);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n) {
          var i = 3 * t;
          return this.uint16[i + 0] = e, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t;
        }
      }]);
      return tu;
    }(Dl);
    tu.prototype.bytesPerElement = 6, So(tu, "StructArrayLayout3ui6");
    var eu = /*#__PURE__*/function (_Dl20) {
      _inherits(eu, _Dl20);
      var _super29 = _createSuper(eu);
      function eu() {
        _classCallCheck(this, eu);
        return _super29.apply(this, arguments);
      }
      _createClass(eu, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v) {
          var _ = this.length;
          return this.resize(_ + 1), this.emplace(_, t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v, _) {
          var w = 30 * t,
            M = 15 * t,
            A = 60 * t;
          return this.int16[w + 0] = e, this.int16[w + 1] = r, this.int16[w + 2] = n, this.float32[M + 2] = i, this.float32[M + 3] = s, this.uint16[w + 8] = a, this.uint16[w + 9] = o, this.uint32[M + 5] = l, this.uint32[M + 6] = u, this.uint32[M + 7] = c, this.uint16[w + 16] = h, this.uint16[w + 17] = p, this.uint16[w + 18] = f, this.float32[M + 10] = d, this.float32[M + 11] = m, this.uint8[A + 48] = y, this.uint8[A + 49] = g, this.uint8[A + 50] = x, this.uint32[M + 13] = b, this.int16[w + 28] = v, this.uint8[A + 58] = _, t;
        }
      }]);
      return eu;
    }(Dl);
    eu.prototype.bytesPerElement = 60, So(eu, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
    var ru = /*#__PURE__*/function (_Dl21) {
      _inherits(ru, _Dl21);
      var _super30 = _createSuper(ru);
      function ru() {
        _classCallCheck(this, ru);
        return _super30.apply(this, arguments);
      }
      _createClass(ru, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v, _, w, M, A, S, I, T, k, P, z, E) {
          var B = this.length;
          return this.resize(B + 1), this.emplace(B, t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v, _, w, M, A, S, I, T, k, P, z, E);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v, _, w, M, A, S, I, T, k, P, z, E, B) {
          var D = 20 * t,
            R = 40 * t,
            C = 80 * t;
          return this.float32[D + 0] = e, this.float32[D + 1] = r, this.int16[R + 4] = n, this.int16[R + 5] = i, this.int16[R + 6] = s, this.int16[R + 7] = a, this.int16[R + 8] = o, this.int16[R + 9] = l, this.int16[R + 10] = u, this.int16[R + 11] = c, this.int16[R + 12] = h, this.uint16[R + 13] = p, this.uint16[R + 14] = f, this.uint16[R + 15] = d, this.uint16[R + 16] = m, this.uint16[R + 17] = y, this.uint16[R + 18] = g, this.uint16[R + 19] = x, this.uint16[R + 20] = b, this.uint16[R + 21] = v, this.uint16[R + 22] = _, this.uint16[R + 23] = w, this.uint16[R + 24] = M, this.uint16[R + 25] = A, this.uint16[R + 26] = S, this.uint16[R + 27] = I, this.uint32[D + 14] = T, this.float32[D + 15] = k, this.float32[D + 16] = P, this.float32[D + 17] = z, this.float32[D + 18] = E, this.uint8[C + 76] = B, t;
        }
      }]);
      return ru;
    }(Dl);
    ru.prototype.bytesPerElement = 80, So(ru, "StructArrayLayout2f9i15ui1ul4f1ub80");
    var nu = /*#__PURE__*/function (_Dl22) {
      _inherits(nu, _Dl22);
      var _super31 = _createSuper(nu);
      function nu() {
        _classCallCheck(this, nu);
        return _super31.apply(this, arguments);
      }
      _createClass(nu, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t) {
          var e = this.length;
          return this.resize(e + 1), this.emplace(e, t);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e) {
          return this.float32[1 * t + 0] = e, t;
        }
      }]);
      return nu;
    }(Dl);
    nu.prototype.bytesPerElement = 4, So(nu, "StructArrayLayout1f4");
    var iu = /*#__PURE__*/function (_Dl23) {
      _inherits(iu, _Dl23);
      var _super32 = _createSuper(iu);
      function iu() {
        _classCallCheck(this, iu);
        return _super32.apply(this, arguments);
      }
      _createClass(iu, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i) {
          var s = this.length;
          return this.resize(s + 1), this.emplace(s, t, e, r, n, i);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s) {
          var a = 5 * t;
          return this.float32[a + 0] = e, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, this.float32[a + 4] = s, t;
        }
      }]);
      return iu;
    }(Dl);
    iu.prototype.bytesPerElement = 20, So(iu, "StructArrayLayout5f20");
    var su = /*#__PURE__*/function (_Dl24) {
      _inherits(su, _Dl24);
      var _super33 = _createSuper(su);
      function su() {
        _classCallCheck(this, su);
        return _super33.apply(this, arguments);
      }
      _createClass(su, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i, s, a) {
          var o = this.length;
          return this.resize(o + 1), this.emplace(o, t, e, r, n, i, s, a);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s, a, o) {
          var l = 7 * t;
          return this.float32[l + 0] = e, this.float32[l + 1] = r, this.float32[l + 2] = n, this.float32[l + 3] = i, this.float32[l + 4] = s, this.float32[l + 5] = a, this.float32[l + 6] = o, t;
        }
      }]);
      return su;
    }(Dl);
    su.prototype.bytesPerElement = 28, So(su, "StructArrayLayout7f28");
    var au = /*#__PURE__*/function (_Dl25) {
      _inherits(au, _Dl25);
      var _super34 = _createSuper(au);
      function au() {
        _classCallCheck(this, au);
        return _super34.apply(this, arguments);
      }
      _createClass(au, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n) {
          var i = this.length;
          return this.resize(i + 1), this.emplace(i, t, e, r, n);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i) {
          var s = 6 * t;
          return this.uint32[3 * t + 0] = e, this.uint16[s + 2] = r, this.uint16[s + 3] = n, this.uint16[s + 4] = i, t;
        }
      }]);
      return au;
    }(Dl);
    au.prototype.bytesPerElement = 12, So(au, "StructArrayLayout1ul3ui12");
    var ou = /*#__PURE__*/function (_Dl26) {
      _inherits(ou, _Dl26);
      var _super35 = _createSuper(ou);
      function ou() {
        _classCallCheck(this, ou);
        return _super35.apply(this, arguments);
      }
      _createClass(ou, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t) {
          var e = this.length;
          return this.resize(e + 1), this.emplace(e, t);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e) {
          return this.uint16[1 * t + 0] = e, t;
        }
      }]);
      return ou;
    }(Dl);
    ou.prototype.bytesPerElement = 2, So(ou, "StructArrayLayout1ui2");
    var lu = /*#__PURE__*/function (_Dl27) {
      _inherits(lu, _Dl27);
      var _super36 = _createSuper(lu);
      function lu() {
        _classCallCheck(this, lu);
        return _super36.apply(this, arguments);
      }
      _createClass(lu, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e) {
          var r = this.length;
          return this.resize(r + 1), this.emplace(r, t, e);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r) {
          var n = 2 * t;
          return this.float32[n + 0] = e, this.float32[n + 1] = r, t;
        }
      }]);
      return lu;
    }(Dl);
    lu.prototype.bytesPerElement = 8, So(lu, "StructArrayLayout2f8");
    var uu = /*#__PURE__*/function (_Dl28) {
      _inherits(uu, _Dl28);
      var _super37 = _createSuper(uu);
      function uu() {
        _classCallCheck(this, uu);
        return _super37.apply(this, arguments);
      }
      _createClass(uu, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m) {
          var y = this.length;
          return this.resize(y + 1), this.emplace(y, t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y) {
          var g = 16 * t;
          return this.float32[g + 0] = e, this.float32[g + 1] = r, this.float32[g + 2] = n, this.float32[g + 3] = i, this.float32[g + 4] = s, this.float32[g + 5] = a, this.float32[g + 6] = o, this.float32[g + 7] = l, this.float32[g + 8] = u, this.float32[g + 9] = c, this.float32[g + 10] = h, this.float32[g + 11] = p, this.float32[g + 12] = f, this.float32[g + 13] = d, this.float32[g + 14] = m, this.float32[g + 15] = y, t;
        }
      }]);
      return uu;
    }(Dl);
    uu.prototype.bytesPerElement = 64, So(uu, "StructArrayLayout16f64");
    var cu = /*#__PURE__*/function (_Dl29) {
      _inherits(cu, _Dl29);
      var _super38 = _createSuper(cu);
      function cu() {
        _classCallCheck(this, cu);
        return _super38.apply(this, arguments);
      }
      _createClass(cu, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t, e, r, n, i, s, a) {
          var o = this.length;
          return this.resize(o + 1), this.emplace(o, t, e, r, n, i, s, a);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e, r, n, i, s, a, o) {
          var l = 10 * t,
            u = 5 * t;
          return this.uint16[l + 0] = e, this.uint16[l + 1] = r, this.uint16[l + 2] = n, this.uint16[l + 3] = i, this.float32[u + 2] = s, this.float32[u + 3] = a, this.float32[u + 4] = o, t;
        }
      }]);
      return cu;
    }(Dl);
    cu.prototype.bytesPerElement = 20, So(cu, "StructArrayLayout4ui3f20");
    var hu = /*#__PURE__*/function (_Dl30) {
      _inherits(hu, _Dl30);
      var _super39 = _createSuper(hu);
      function hu() {
        _classCallCheck(this, hu);
        return _super39.apply(this, arguments);
      }
      _createClass(hu, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t) {
          var e = this.length;
          return this.resize(e + 1), this.emplace(e, t);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e) {
          return this.int16[1 * t + 0] = e, t;
        }
      }]);
      return hu;
    }(Dl);
    hu.prototype.bytesPerElement = 2, So(hu, "StructArrayLayout1i2");
    var pu = /*#__PURE__*/function (_Dl31) {
      _inherits(pu, _Dl31);
      var _super40 = _createSuper(pu);
      function pu() {
        _classCallCheck(this, pu);
        return _super40.apply(this, arguments);
      }
      _createClass(pu, [{
        key: "_refreshViews",
        value: function _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer);
        }
      }, {
        key: "emplaceBack",
        value: function emplaceBack(t) {
          var e = this.length;
          return this.resize(e + 1), this.emplace(e, t);
        }
      }, {
        key: "emplace",
        value: function emplace(t, e) {
          return this.uint8[1 * t + 0] = e, t;
        }
      }]);
      return pu;
    }(Dl);
    pu.prototype.bytesPerElement = 1, So(pu, "StructArrayLayout1ub1");
    var fu = /*#__PURE__*/function (_Bl) {
      _inherits(fu, _Bl);
      var _super41 = _createSuper(fu);
      function fu() {
        _classCallCheck(this, fu);
        return _super41.apply(this, arguments);
      }
      _createClass(fu, [{
        key: "projectedAnchorX",
        get: function get() {
          return this._structArray.int16[this._pos2 + 0];
        }
      }, {
        key: "projectedAnchorY",
        get: function get() {
          return this._structArray.int16[this._pos2 + 1];
        }
      }, {
        key: "projectedAnchorZ",
        get: function get() {
          return this._structArray.int16[this._pos2 + 2];
        }
      }, {
        key: "tileAnchorX",
        get: function get() {
          return this._structArray.int16[this._pos2 + 3];
        }
      }, {
        key: "tileAnchorY",
        get: function get() {
          return this._structArray.int16[this._pos2 + 4];
        }
      }, {
        key: "x1",
        get: function get() {
          return this._structArray.float32[this._pos4 + 3];
        }
      }, {
        key: "y1",
        get: function get() {
          return this._structArray.float32[this._pos4 + 4];
        }
      }, {
        key: "x2",
        get: function get() {
          return this._structArray.float32[this._pos4 + 5];
        }
      }, {
        key: "y2",
        get: function get() {
          return this._structArray.float32[this._pos4 + 6];
        }
      }, {
        key: "padding",
        get: function get() {
          return this._structArray.int16[this._pos2 + 14];
        }
      }, {
        key: "featureIndex",
        get: function get() {
          return this._structArray.uint32[this._pos4 + 8];
        }
      }, {
        key: "sourceLayerIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 18];
        }
      }, {
        key: "bucketIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 19];
        }
      }]);
      return fu;
    }(Bl);
    fu.prototype.size = 40;
    var du = /*#__PURE__*/function (_Kl) {
      _inherits(du, _Kl);
      var _super42 = _createSuper(du);
      function du() {
        _classCallCheck(this, du);
        return _super42.apply(this, arguments);
      }
      _createClass(du, [{
        key: "get",
        value: function get(t) {
          return new fu(this, t);
        }
      }]);
      return du;
    }(Kl);
    So(du, "CollisionBoxArray");
    var mu = /*#__PURE__*/function (_Bl2) {
      _inherits(mu, _Bl2);
      var _super43 = _createSuper(mu);
      function mu() {
        _classCallCheck(this, mu);
        return _super43.apply(this, arguments);
      }
      _createClass(mu, [{
        key: "projectedAnchorX",
        get: function get() {
          return this._structArray.int16[this._pos2 + 0];
        }
      }, {
        key: "projectedAnchorY",
        get: function get() {
          return this._structArray.int16[this._pos2 + 1];
        }
      }, {
        key: "projectedAnchorZ",
        get: function get() {
          return this._structArray.int16[this._pos2 + 2];
        }
      }, {
        key: "tileAnchorX",
        get: function get() {
          return this._structArray.float32[this._pos4 + 2];
        }
      }, {
        key: "tileAnchorY",
        get: function get() {
          return this._structArray.float32[this._pos4 + 3];
        }
      }, {
        key: "glyphStartIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 8];
        }
      }, {
        key: "numGlyphs",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 9];
        }
      }, {
        key: "vertexStartIndex",
        get: function get() {
          return this._structArray.uint32[this._pos4 + 5];
        }
      }, {
        key: "lineStartIndex",
        get: function get() {
          return this._structArray.uint32[this._pos4 + 6];
        }
      }, {
        key: "lineLength",
        get: function get() {
          return this._structArray.uint32[this._pos4 + 7];
        }
      }, {
        key: "segment",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 16];
        }
      }, {
        key: "lowerSize",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 17];
        }
      }, {
        key: "upperSize",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 18];
        }
      }, {
        key: "lineOffsetX",
        get: function get() {
          return this._structArray.float32[this._pos4 + 10];
        }
      }, {
        key: "lineOffsetY",
        get: function get() {
          return this._structArray.float32[this._pos4 + 11];
        }
      }, {
        key: "writingMode",
        get: function get() {
          return this._structArray.uint8[this._pos1 + 48];
        }
      }, {
        key: "placedOrientation",
        get: function get() {
          return this._structArray.uint8[this._pos1 + 49];
        },
        set: function set(t) {
          this._structArray.uint8[this._pos1 + 49] = t;
        }
      }, {
        key: "hidden",
        get: function get() {
          return this._structArray.uint8[this._pos1 + 50];
        },
        set: function set(t) {
          this._structArray.uint8[this._pos1 + 50] = t;
        }
      }, {
        key: "crossTileID",
        get: function get() {
          return this._structArray.uint32[this._pos4 + 13];
        },
        set: function set(t) {
          this._structArray.uint32[this._pos4 + 13] = t;
        }
      }, {
        key: "associatedIconIndex",
        get: function get() {
          return this._structArray.int16[this._pos2 + 28];
        }
      }, {
        key: "flipState",
        get: function get() {
          return this._structArray.uint8[this._pos1 + 58];
        },
        set: function set(t) {
          this._structArray.uint8[this._pos1 + 58] = t;
        }
      }]);
      return mu;
    }(Bl);
    mu.prototype.size = 60;
    var yu = /*#__PURE__*/function (_eu) {
      _inherits(yu, _eu);
      var _super44 = _createSuper(yu);
      function yu() {
        _classCallCheck(this, yu);
        return _super44.apply(this, arguments);
      }
      _createClass(yu, [{
        key: "get",
        value: function get(t) {
          return new mu(this, t);
        }
      }]);
      return yu;
    }(eu);
    So(yu, "PlacedSymbolArray");
    var gu = /*#__PURE__*/function (_Bl3) {
      _inherits(gu, _Bl3);
      var _super45 = _createSuper(gu);
      function gu() {
        _classCallCheck(this, gu);
        return _super45.apply(this, arguments);
      }
      _createClass(gu, [{
        key: "tileAnchorX",
        get: function get() {
          return this._structArray.float32[this._pos4 + 0];
        }
      }, {
        key: "tileAnchorY",
        get: function get() {
          return this._structArray.float32[this._pos4 + 1];
        }
      }, {
        key: "projectedAnchorX",
        get: function get() {
          return this._structArray.int16[this._pos2 + 4];
        }
      }, {
        key: "projectedAnchorY",
        get: function get() {
          return this._structArray.int16[this._pos2 + 5];
        }
      }, {
        key: "projectedAnchorZ",
        get: function get() {
          return this._structArray.int16[this._pos2 + 6];
        }
      }, {
        key: "rightJustifiedTextSymbolIndex",
        get: function get() {
          return this._structArray.int16[this._pos2 + 7];
        }
      }, {
        key: "centerJustifiedTextSymbolIndex",
        get: function get() {
          return this._structArray.int16[this._pos2 + 8];
        }
      }, {
        key: "leftJustifiedTextSymbolIndex",
        get: function get() {
          return this._structArray.int16[this._pos2 + 9];
        }
      }, {
        key: "verticalPlacedTextSymbolIndex",
        get: function get() {
          return this._structArray.int16[this._pos2 + 10];
        }
      }, {
        key: "placedIconSymbolIndex",
        get: function get() {
          return this._structArray.int16[this._pos2 + 11];
        }
      }, {
        key: "verticalPlacedIconSymbolIndex",
        get: function get() {
          return this._structArray.int16[this._pos2 + 12];
        }
      }, {
        key: "key",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 13];
        }
      }, {
        key: "textBoxStartIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 14];
        }
      }, {
        key: "textBoxEndIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 15];
        }
      }, {
        key: "verticalTextBoxStartIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 16];
        }
      }, {
        key: "verticalTextBoxEndIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 17];
        }
      }, {
        key: "iconBoxStartIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 18];
        }
      }, {
        key: "iconBoxEndIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 19];
        }
      }, {
        key: "verticalIconBoxStartIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 20];
        }
      }, {
        key: "verticalIconBoxEndIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 21];
        }
      }, {
        key: "featureIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 22];
        }
      }, {
        key: "numHorizontalGlyphVertices",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 23];
        }
      }, {
        key: "numVerticalGlyphVertices",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 24];
        }
      }, {
        key: "numIconVertices",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 25];
        }
      }, {
        key: "numVerticalIconVertices",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 26];
        }
      }, {
        key: "useRuntimeCollisionCircles",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 27];
        }
      }, {
        key: "crossTileID",
        get: function get() {
          return this._structArray.uint32[this._pos4 + 14];
        },
        set: function set(t) {
          this._structArray.uint32[this._pos4 + 14] = t;
        }
      }, {
        key: "textOffset0",
        get: function get() {
          return this._structArray.float32[this._pos4 + 15];
        }
      }, {
        key: "textOffset1",
        get: function get() {
          return this._structArray.float32[this._pos4 + 16];
        }
      }, {
        key: "collisionCircleDiameter",
        get: function get() {
          return this._structArray.float32[this._pos4 + 17];
        }
      }, {
        key: "zOffset",
        get: function get() {
          return this._structArray.float32[this._pos4 + 18];
        },
        set: function set(t) {
          this._structArray.float32[this._pos4 + 18] = t;
        }
      }, {
        key: "hasIconTextFit",
        get: function get() {
          return this._structArray.uint8[this._pos1 + 76];
        }
      }]);
      return gu;
    }(Bl);
    gu.prototype.size = 80;
    var xu = /*#__PURE__*/function (_ru) {
      _inherits(xu, _ru);
      var _super46 = _createSuper(xu);
      function xu() {
        _classCallCheck(this, xu);
        return _super46.apply(this, arguments);
      }
      _createClass(xu, [{
        key: "get",
        value: function get(t) {
          return new gu(this, t);
        }
      }]);
      return xu;
    }(ru);
    So(xu, "SymbolInstanceArray");
    var bu = /*#__PURE__*/function (_nu) {
      _inherits(bu, _nu);
      var _super47 = _createSuper(bu);
      function bu() {
        _classCallCheck(this, bu);
        return _super47.apply(this, arguments);
      }
      _createClass(bu, [{
        key: "getoffsetX",
        value: function getoffsetX(t) {
          return this.float32[1 * t + 0];
        }
      }]);
      return bu;
    }(nu);
    So(bu, "GlyphOffsetArray");
    var vu = /*#__PURE__*/function (_Ll) {
      _inherits(vu, _Ll);
      var _super48 = _createSuper(vu);
      function vu() {
        _classCallCheck(this, vu);
        return _super48.apply(this, arguments);
      }
      _createClass(vu, [{
        key: "getx",
        value: function getx(t) {
          return this.int16[2 * t + 0];
        }
      }, {
        key: "gety",
        value: function gety(t) {
          return this.int16[2 * t + 1];
        }
      }]);
      return vu;
    }(Ll);
    So(vu, "SymbolLineVertexArray");
    var _u = /*#__PURE__*/function (_Bl4) {
      _inherits(_u, _Bl4);
      var _super49 = _createSuper(_u);
      function _u() {
        _classCallCheck(this, _u);
        return _super49.apply(this, arguments);
      }
      _createClass(_u, [{
        key: "featureIndex",
        get: function get() {
          return this._structArray.uint32[this._pos4 + 0];
        }
      }, {
        key: "sourceLayerIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 2];
        }
      }, {
        key: "bucketIndex",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 3];
        }
      }, {
        key: "layoutVertexArrayOffset",
        get: function get() {
          return this._structArray.uint16[this._pos2 + 4];
        }
      }]);
      return _u;
    }(Bl);
    _u.prototype.size = 12;
    var wu = /*#__PURE__*/function (_au) {
      _inherits(wu, _au);
      var _super50 = _createSuper(wu);
      function wu() {
        _classCallCheck(this, wu);
        return _super50.apply(this, arguments);
      }
      _createClass(wu, [{
        key: "get",
        value: function get(t) {
          return new _u(this, t);
        }
      }]);
      return wu;
    }(au);
    So(wu, "FeatureIndexArray");
    var Mu = /*#__PURE__*/function (_Hl) {
      _inherits(Mu, _Hl);
      var _super51 = _createSuper(Mu);
      function Mu() {
        _classCallCheck(this, Mu);
        return _super51.apply(this, arguments);
      }
      _createClass(Mu, [{
        key: "geta_centroid_pos0",
        value: function geta_centroid_pos0(t) {
          return this.uint16[2 * t + 0];
        }
      }, {
        key: "geta_centroid_pos1",
        value: function geta_centroid_pos1(t) {
          return this.uint16[2 * t + 1];
        }
      }]);
      return Mu;
    }(Hl);
    So(Mu, "FillExtrusionCentroidArray");
    var Au = /*#__PURE__*/function (_Bl5) {
      _inherits(Au, _Bl5);
      var _super52 = _createSuper(Au);
      function Au() {
        _classCallCheck(this, Au);
        return _super52.apply(this, arguments);
      }
      _createClass(Au, [{
        key: "a_join_normal_inside_polygon0",
        get: function get() {
          return this._structArray.int16[this._pos2 + 0];
        }
      }, {
        key: "a_join_normal_inside_polygon1",
        get: function get() {
          return this._structArray.int16[this._pos2 + 1];
        }
      }, {
        key: "a_join_normal_inside_polygon2",
        get: function get() {
          return this._structArray.int16[this._pos2 + 2];
        }
      }, {
        key: "a_join_normal_inside_polygon3",
        get: function get() {
          return this._structArray.int16[this._pos2 + 3];
        }
      }]);
      return Au;
    }(Bl);
    Au.prototype.size = 8;
    var Su = /*#__PURE__*/function (_Fl) {
      _inherits(Su, _Fl);
      var _super53 = _createSuper(Su);
      function Su() {
        _classCallCheck(this, Su);
        return _super53.apply(this, arguments);
      }
      _createClass(Su, [{
        key: "get",
        value: function get(t) {
          return new Au(this, t);
        }
      }]);
      return Su;
    }(Fl);
    So(Su, "FillExtrusionWallArray");
    var Iu = Rl([{
        name: "a_pos",
        components: 2,
        type: "Int16"
      }], 4),
      Tu = Rl([{
        name: "a_pos_3",
        components: 3,
        type: "Int16"
      }, {
        name: "a_pos_normal_3",
        components: 3,
        type: "Int16"
      }]);
    var ku = /*#__PURE__*/function () {
      function ku() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _classCallCheck(this, ku);
        this.segments = t;
      }
      _createClass(ku, [{
        key: "_prepareSegment",
        value: function _prepareSegment(t, e, r, n) {
          var i = this.segments[this.segments.length - 1];
          return t > ku.MAX_VERTEX_ARRAY_LENGTH && dr("Max vertices per segment is ".concat(ku.MAX_VERTEX_ARRAY_LENGTH, ": bucket requested ").concat(t)), (!i || i.vertexLength + t > ku.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
            vertexOffset: e,
            primitiveOffset: r,
            vertexLength: 0,
            primitiveLength: 0
          }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
        }
      }, {
        key: "prepareSegment",
        value: function prepareSegment(t, e, r, n) {
          return this._prepareSegment(t, e.length, r.length, n);
        }
      }, {
        key: "get",
        value: function get() {
          return this.segments;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iterator70 = _createForOfIteratorHelper(this.segments),
            _step70;
          try {
            for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
              var _t74 = _step70.value;
              for (var _e93 in _t74.vaos) _t74.vaos[_e93].destroy();
            }
          } catch (err) {
            _iterator70.e(err);
          } finally {
            _iterator70.f();
          }
        }
      }], [{
        key: "simpleSegment",
        value: function simpleSegment(t, e, r, n) {
          return new ku([{
            vertexOffset: t,
            primitiveOffset: e,
            vertexLength: r,
            primitiveLength: n,
            vaos: {},
            sortKey: 0
          }]);
        }
      }]);
      return ku;
    }();
    function Pu(t, e) {
      return 256 * (t = We(Math.floor(t), 0, 255)) + We(Math.floor(e), 0, 255);
    }
    ku.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, So(ku, "SegmentVector");
    var zu = Rl([{
        name: "a_pattern",
        components: 4,
        type: "Uint16"
      }, {
        name: "a_pixel_ratio",
        components: 1,
        type: "Float32"
      }]),
      Eu = Rl([{
        name: "a_dash",
        components: 4,
        type: "Uint16"
      }]);
    var Bu = /*#__PURE__*/function () {
      function Bu() {
        _classCallCheck(this, Bu);
        this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = !1;
      }
      _createClass(Bu, [{
        key: "add",
        value: function add(t, e, r, n) {
          this.ids.push(Du(t)), this.positions.push(e, r, n);
        }
      }, {
        key: "eachPosition",
        value: function eachPosition(t, e) {
          var r = Du(t);
          var n = 0,
            i = this.ids.length - 1;
          for (; n < i;) {
            var _t75 = n + i >> 1;
            this.ids[_t75] >= r ? i = _t75 : n = _t75 + 1;
          }
          for (; this.ids[n] === r;) e(this.positions[3 * n], this.positions[3 * n + 1], this.positions[3 * n + 2]), n++;
        }
      }], [{
        key: "serialize",
        value: function serialize(t, e) {
          var r = new Float64Array(t.ids),
            n = new Uint32Array(t.positions);
          return Ru(r, n, 0, r.length - 1), e && (e.add(r.buffer), e.add(n.buffer)), {
            ids: r,
            positions: n
          };
        }
      }, {
        key: "deserialize",
        value: function deserialize(t) {
          var e = new Bu();
          var r;
          e.ids = t.ids, e.positions = t.positions;
          var _iterator71 = _createForOfIteratorHelper(e.ids),
            _step71;
          try {
            for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
              var _t76 = _step71.value;
              _t76 !== r && e.uniqueIds.push(_t76), r = _t76;
            }
          } catch (err) {
            _iterator71.e(err);
          } finally {
            _iterator71.f();
          }
          return e.indexed = !0, e;
        }
      }]);
      return Bu;
    }();
    function Du(t) {
      var e = +t;
      return !isNaN(e) && Number.MIN_SAFE_INTEGER <= e && e <= Number.MAX_SAFE_INTEGER ? e : Rn(String(t));
    }
    function Ru(t, e, r, n) {
      for (; r < n;) {
        var _i61 = t[r + n >> 1];
        var _s39 = r - 1,
          _a26 = n + 1;
        for (;;) {
          do {
            _s39++;
          } while (t[_s39] < _i61);
          do {
            _a26--;
          } while (t[_a26] > _i61);
          if (_s39 >= _a26) break;
          Cu(t, _s39, _a26), Cu(e, 3 * _s39, 3 * _a26), Cu(e, 3 * _s39 + 1, 3 * _a26 + 1), Cu(e, 3 * _s39 + 2, 3 * _a26 + 2);
        }
        _a26 - r < n - _a26 ? (Ru(t, e, r, _a26), r = _a26 + 1) : (Ru(t, e, _a26 + 1, n), n = _a26);
      }
    }
    function Cu(t, e, r) {
      var n = t[e];
      t[e] = t[r], t[r] = n;
    }
    So(Bu, "FeaturePositionMap");
    var Lu = /*#__PURE__*/function () {
      function Lu(t) {
        _classCallCheck(this, Lu);
        this.gl = t.gl, this.initialized = !1;
      }
      _createClass(Lu, [{
        key: "fetchUniformLocation",
        value: function fetchUniformLocation(t, e) {
          return this.location || this.initialized || (this.location = this.gl.getUniformLocation(t, e), this.initialized = !0), !!this.location;
        }
      }, {
        key: "set",
        value: function set(t, e, r) {
          throw new Error("Uniform#set() must be implemented by each concrete Uniform");
        }
      }]);
      return Lu;
    }();
    var Vu = /*#__PURE__*/function (_Lu) {
      _inherits(Vu, _Lu);
      var _super54 = _createSuper(Vu);
      function Vu(t) {
        var _this15;
        _classCallCheck(this, Vu);
        _this15 = _super54.call(this, t), _this15.current = 0;
        return _this15;
      }
      _createClass(Vu, [{
        key: "set",
        value: function set(t, e, r) {
          this.fetchUniformLocation(t, e) && this.current !== r && (this.current = r, this.gl.uniform1i(this.location, r));
        }
      }]);
      return Vu;
    }(Lu);
    var Fu = /*#__PURE__*/function (_Lu2) {
      _inherits(Fu, _Lu2);
      var _super55 = _createSuper(Fu);
      function Fu(t) {
        var _this16;
        _classCallCheck(this, Fu);
        _this16 = _super55.call(this, t), _this16.current = 0;
        return _this16;
      }
      _createClass(Fu, [{
        key: "set",
        value: function set(t, e, r) {
          this.fetchUniformLocation(t, e) && this.current !== r && (this.current = r, this.gl.uniform1f(this.location, r));
        }
      }]);
      return Fu;
    }(Lu);
    var Ou = /*#__PURE__*/function (_Lu3) {
      _inherits(Ou, _Lu3);
      var _super56 = _createSuper(Ou);
      function Ou(t) {
        var _this17;
        _classCallCheck(this, Ou);
        _this17 = _super56.call(this, t), _this17.current = [0, 0];
        return _this17;
      }
      _createClass(Ou, [{
        key: "set",
        value: function set(t, e, r) {
          this.fetchUniformLocation(t, e) && (r[0] === this.current[0] && r[1] === this.current[1] || (this.current = r, this.gl.uniform2f(this.location, r[0], r[1])));
        }
      }]);
      return Ou;
    }(Lu);
    var Uu = /*#__PURE__*/function (_Lu4) {
      _inherits(Uu, _Lu4);
      var _super57 = _createSuper(Uu);
      function Uu(t) {
        var _this18;
        _classCallCheck(this, Uu);
        _this18 = _super57.call(this, t), _this18.current = [0, 0, 0];
        return _this18;
      }
      _createClass(Uu, [{
        key: "set",
        value: function set(t, e, r) {
          this.fetchUniformLocation(t, e) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] || (this.current = r, this.gl.uniform3f(this.location, r[0], r[1], r[2])));
        }
      }]);
      return Uu;
    }(Lu);
    var ju = /*#__PURE__*/function (_Lu5) {
      _inherits(ju, _Lu5);
      var _super58 = _createSuper(ju);
      function ju(t) {
        var _this19;
        _classCallCheck(this, ju);
        _this19 = _super58.call(this, t), _this19.current = [0, 0, 0, 0];
        return _this19;
      }
      _createClass(ju, [{
        key: "set",
        value: function set(t, e, r) {
          this.fetchUniformLocation(t, e) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] && r[3] === this.current[3] || (this.current = r, this.gl.uniform4f(this.location, r[0], r[1], r[2], r[3])));
        }
      }]);
      return ju;
    }(Lu);
    var Nu = /*#__PURE__*/function (_Lu6) {
      _inherits(Nu, _Lu6);
      var _super59 = _createSuper(Nu);
      function Nu(t) {
        var _this20;
        _classCallCheck(this, Nu);
        _this20 = _super59.call(this, t), _this20.current = Gn.transparent.toRenderColor(null);
        return _this20;
      }
      _createClass(Nu, [{
        key: "set",
        value: function set(t, e, r) {
          this.fetchUniformLocation(t, e) && (r.r === this.current.r && r.g === this.current.g && r.b === this.current.b && r.a === this.current.a || (this.current = r, this.gl.uniform4f(this.location, r.r, r.g, r.b, r.a)));
        }
      }]);
      return Nu;
    }(Lu);
    var $u = new Float32Array(16);
    var qu = /*#__PURE__*/function (_Lu7) {
      _inherits(qu, _Lu7);
      var _super60 = _createSuper(qu);
      function qu(t) {
        var _this21;
        _classCallCheck(this, qu);
        _this21 = _super60.call(this, t), _this21.current = $u;
        return _this21;
      }
      _createClass(qu, [{
        key: "set",
        value: function set(t, e, r) {
          if (this.fetchUniformLocation(t, e)) {
            if (r[12] !== this.current[12] || r[0] !== this.current[0]) return this.current = r, void this.gl.uniformMatrix4fv(this.location, !1, r);
            for (var _t77 = 1; _t77 < 16; _t77++) if (r[_t77] !== this.current[_t77]) {
              this.current = r, this.gl.uniformMatrix4fv(this.location, !1, r);
              break;
            }
          }
        }
      }]);
      return qu;
    }(Lu);
    var Gu = new Float32Array(9),
      Xu = new Float32Array(4);
    var Yu = /*#__PURE__*/function (_Lu8) {
      _inherits(Yu, _Lu8);
      var _super61 = _createSuper(Yu);
      function Yu(t) {
        var _this22;
        _classCallCheck(this, Yu);
        _this22 = _super61.call(this, t), _this22.current = Xu;
        return _this22;
      }
      _createClass(Yu, [{
        key: "set",
        value: function set(t, e, r) {
          if (this.fetchUniformLocation(t, e)) for (var _t78 = 0; _t78 < 4; _t78++) if (r[_t78] !== this.current[_t78]) {
            this.current = r, this.gl.uniformMatrix2fv(this.location, !1, r);
            break;
          }
        }
      }]);
      return Yu;
    }(Lu);
    function Zu(t) {
      return [Pu(255 * t.r, 255 * t.g), Pu(255 * t.b, 255 * t.a)];
    }
    var Hu = /*#__PURE__*/function () {
      function Hu(t, e, r, n) {
        _classCallCheck(this, Hu);
        this.value = t, this.uniformNames = e.map(function (t) {
          return "u_".concat(t);
        }), this.type = r, this.context = n;
      }
      _createClass(Hu, [{
        key: "setUniform",
        value: function setUniform(t, e, r, n, i) {
          var s = n.constantOr(this.value);
          e.set(t, i, s instanceof Gn ? s.toRenderColor(this.context.lut) : s);
        }
      }, {
        key: "getBinding",
        value: function getBinding(t, e) {
          return "color" === this.type ? new Nu(t) : new Fu(t);
        }
      }]);
      return Hu;
    }();
    var Ku = /*#__PURE__*/function () {
      function Ku(t, e) {
        _classCallCheck(this, Ku);
        this.uniformNames = e.map(function (t) {
          return "u_".concat(t);
        }), this.pattern = null, this.pixelRatio = 1;
      }
      _createClass(Ku, [{
        key: "setConstantPatternPositions",
        value: function setConstantPatternPositions(t) {
          this.pixelRatio = t.pixelRatio || 1, this.pattern = t.tl.concat(t.br);
        }
      }, {
        key: "setUniform",
        value: function setUniform(t, e, r, n, i) {
          var s = "u_pattern" === i || "u_dash" === i ? this.pattern : "u_pixel_ratio" === i ? this.pixelRatio : null;
          s && e.set(t, i, s);
        }
      }, {
        key: "getBinding",
        value: function getBinding(t, e) {
          return "u_pattern" === e || "u_dash" === e ? new ju(t) : new Fu(t);
        }
      }]);
      return Ku;
    }();
    var Wu = /*#__PURE__*/function () {
      function Wu(t, e, r, n) {
        _classCallCheck(this, Wu);
        this.expression = t, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e.map(function (t) {
          return {
            name: "a_".concat(t),
            type: "Float32",
            components: "color" === r ? 2 : 1,
            offset: 0
          };
        }), this.paintVertexArray = new n();
      }
      _createClass(Wu, [{
        key: "populatePaintArray",
        value: function populatePaintArray(t, e, r, n, i, s, a) {
          var o = this.paintVertexArray.length,
            l = this.expression.evaluate(new Wo(0, {
              brightness: s
            }), e, {}, i, n, a);
          this.paintVertexArray.resize(t), this._setPaintValue(o, t, l, this.context);
        }
      }, {
        key: "updatePaintArray",
        value: function updatePaintArray(t, e, r, n, i, s, a) {
          var o = this.expression.evaluate({
            zoom: 0,
            brightness: a
          }, r, n, void 0, i);
          this._setPaintValue(t, e, o, this.context);
        }
      }, {
        key: "_setPaintValue",
        value: function _setPaintValue(t, e, r, n) {
          if ("color" === this.type) {
            var _i62 = Zu(r.toRenderColor(n.lut));
            for (var _r87 = t; _r87 < e; _r87++) this.paintVertexArray.emplace(_r87, _i62[0], _i62[1]);
          } else {
            for (var _n55 = t; _n55 < e; _n55++) this.paintVertexArray.emplace(_n55, r);
            this.maxValue = Math.max(this.maxValue, Math.abs(r));
          }
        }
      }, {
        key: "upload",
        value: function upload(t) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
      }]);
      return Wu;
    }();
    var Ju = /*#__PURE__*/function () {
      function Ju(t, e, r, n, i, s) {
        _classCallCheck(this, Ju);
        this.expression = t, this.uniformNames = e.map(function (t) {
          return "u_".concat(t, "_t");
        }), this.type = r, this.useIntegerZoom = n, this.context = i, this.maxValue = 0, this.paintVertexAttributes = e.map(function (t) {
          return {
            name: "a_".concat(t),
            type: "Float32",
            components: "color" === r ? 4 : 2,
            offset: 0
          };
        }), this.paintVertexArray = new s();
      }
      _createClass(Ju, [{
        key: "populatePaintArray",
        value: function populatePaintArray(t, e, r, n, i, s, a) {
          var o = this.expression.evaluate(new Wo(this.context.zoom, {
              brightness: s
            }), e, {}, i, n, a),
            l = this.expression.evaluate(new Wo(this.context.zoom + 1, {
              brightness: s
            }), e, {}, i, n, a),
            u = this.paintVertexArray.length;
          this.paintVertexArray.resize(t), this._setPaintValue(u, t, o, l, this.context);
        }
      }, {
        key: "updatePaintArray",
        value: function updatePaintArray(t, e, r, n, i, s, a) {
          var o = this.expression.evaluate({
              zoom: this.context.zoom,
              brightness: a
            }, r, n, void 0, i),
            l = this.expression.evaluate({
              zoom: this.context.zoom + 1,
              brightness: a
            }, r, n, void 0, i);
          this._setPaintValue(t, e, o, l, this.context);
        }
      }, {
        key: "_setPaintValue",
        value: function _setPaintValue(t, e, r, n, i) {
          if ("color" === this.type) {
            var _n56 = Zu(r.toRenderColor(i.lut)),
              _s40 = Zu(r.toRenderColor(i.lut));
            for (var _r88 = t; _r88 < e; _r88++) this.paintVertexArray.emplace(_r88, _n56[0], _n56[1], _s40[0], _s40[1]);
          } else {
            for (var _i63 = t; _i63 < e; _i63++) this.paintVertexArray.emplace(_i63, r, n);
            this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
          }
        }
      }, {
        key: "upload",
        value: function upload(t) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
      }, {
        key: "setUniform",
        value: function setUniform(t, e, r, n, i) {
          var s = this.useIntegerZoom ? Math.floor(r.zoom) : r.zoom,
            a = We(this.expression.interpolationFactor(s, this.context.zoom, this.context.zoom + 1), 0, 1);
          e.set(t, i, a);
        }
      }, {
        key: "getBinding",
        value: function getBinding(t, e) {
          return new Fu(t);
        }
      }]);
      return Ju;
    }();
    var Qu = /*#__PURE__*/function () {
      function Qu(t, e, r, n, i) {
        _classCallCheck(this, Qu);
        this.expression = t, this.layerId = i, this.paintVertexAttributes = ("array" === r ? Eu : zu).members;
        for (var _t79 = 0; _t79 < e.length; ++_t79);
        this.paintVertexArray = new n();
      }
      _createClass(Qu, [{
        key: "populatePaintArray",
        value: function populatePaintArray(t, e, r, n) {
          var i = this.paintVertexArray.length;
          this.paintVertexArray.resize(t), this._setPaintValues(i, t, e.patterns && e.patterns[this.layerId], r);
        }
      }, {
        key: "updatePaintArray",
        value: function updatePaintArray(t, e, r, n, i, s, a) {
          this._setPaintValues(t, e, r.patterns && r.patterns[this.layerId], s);
        }
      }, {
        key: "_setPaintValues",
        value: function _setPaintValues(t, e, r, n) {
          if (!n || !r) return;
          var i = n[r];
          if (!i) return;
          var s = i.tl,
            a = i.br,
            o = i.pixelRatio;
          for (var _r89 = t; _r89 < e; _r89++) this.paintVertexArray.emplace(_r89, s[0], s[1], a[0], a[1], o);
        }
      }, {
        key: "upload",
        value: function upload(t) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
      }]);
      return Qu;
    }();
    var tc = /*#__PURE__*/function () {
      function tc(t, e) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
          return !0;
        };
        _classCallCheck(this, tc);
        this.binders = {}, this._buffers = [], this.context = e;
        var n = [];
        for (var _i64 in t.paint._values) {
          var _s41 = t.paint.get(_i64);
          if (!r(_i64)) continue;
          if (!(_s41 instanceof il && Qa(_s41.property.specification))) continue;
          var _a27 = nc(_i64, t.type),
            _o16 = _s41.value,
            _l13 = _s41.property.specification.type,
            _u11 = !!_s41.property.useIntegerZoom,
            _c8 = "line-dasharray" === _i64 || _i64.endsWith("pattern"),
            _h5 = "line-dasharray" === _i64 && "constant" !== t.layout.get("line-cap").value.kind;
          if ("constant" !== _o16.kind || _h5) {
            if ("source" === _o16.kind || _h5 || _c8) {
              var _e94 = ac(_i64, _l13, "source");
              this.binders[_i64] = _c8 ? new Qu(_o16, _a27, _l13, _e94, t.id) : new Wu(_o16, _a27, _l13, _e94), n.push("/a_".concat(_i64));
            } else {
              var _t80 = ac(_i64, _l13, "composite");
              this.binders[_i64] = new Ju(_o16, _a27, _l13, _u11, e, _t80), n.push("/z_".concat(_i64));
            }
          } else this.binders[_i64] = _c8 ? new Ku(_o16.value, _a27) : new Hu(_o16.value, _a27, _l13, e), n.push("/u_".concat(_i64));
        }
        this.cacheKey = n.sort().join("");
      }
      _createClass(tc, [{
        key: "getMaxValue",
        value: function getMaxValue(t) {
          var e = this.binders[t];
          return e instanceof Wu || e instanceof Ju ? e.maxValue : 0;
        }
      }, {
        key: "populatePaintArrays",
        value: function populatePaintArrays(t, e, r, n, i, s, a) {
          for (var _o17 in this.binders) {
            var _l14 = this.binders[_o17];
            _l14.context = this.context, (_l14 instanceof Wu || _l14 instanceof Ju || _l14 instanceof Qu) && _l14.populatePaintArray(t, e, r, n, i, s, a);
          }
        }
      }, {
        key: "setConstantPatternPositions",
        value: function setConstantPatternPositions(t) {
          for (var _e95 in this.binders) {
            var _r90 = this.binders[_e95];
            _r90 instanceof Ku && _r90.setConstantPatternPositions(t);
          }
        }
      }, {
        key: "updatePaintArrays",
        value: function updatePaintArrays(t, e, r, n, i, s, a, o) {
          var _this23 = this;
          var l = !1;
          var u = Object.keys(t),
            c = 0 !== u.length,
            h = c ? u : e.uniqueIds;
          this.context.lut = i.lut;
          var _loop2 = function _loop2() {
            var p = _this23.binders[_u12];
            if (p.context = _this23.context, (p instanceof Wu || p instanceof Ju || p instanceof Qu) && (!0 === p.expression.isStateDependent || !1 === p.expression.isLightConstant)) {
              var _f4 = i.paint.get(_u12);
              p.expression = _f4.value;
              var _iterator72 = _createForOfIteratorHelper(h),
                _step72;
              try {
                var _loop4 = function _loop4() {
                  var r = _step72.value;
                  var i = t[r.toString()];
                  e.eachPosition(r, function (t, e, r) {
                    var l = n.feature(t);
                    p.updatePaintArray(e, r, l, i, s, a, o);
                  });
                };
                for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
                  _loop4();
                }
              } catch (err) {
                _iterator72.e(err);
              } finally {
                _iterator72.f();
              }
              if (!c) {
                var _iterator73 = _createForOfIteratorHelper(r.uniqueIds),
                  _step73;
                try {
                  var _loop3 = function _loop3() {
                    var e = _step73.value;
                    var i = t[e.toString()];
                    r.eachPosition(e, function (t, e, r) {
                      var l = n.feature(t);
                      p.updatePaintArray(e, r, l, i, s, a, o);
                    });
                  };
                  for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
                    _loop3();
                  }
                } catch (err) {
                  _iterator73.e(err);
                } finally {
                  _iterator73.f();
                }
              }
              l = !0;
            }
          };
          for (var _u12 in this.binders) {
            _loop2();
          }
          return l;
        }
      }, {
        key: "defines",
        value: function defines() {
          var t = [];
          for (var _e96 in this.binders) {
            var _r91 = this.binders[_e96];
            (_r91 instanceof Hu || _r91 instanceof Ku) && t.push.apply(t, _toConsumableArray(_r91.uniformNames.map(function (t) {
              return "#define HAS_UNIFORM_".concat(t);
            })));
          }
          return t;
        }
      }, {
        key: "getBinderAttributes",
        value: function getBinderAttributes() {
          var t = [];
          for (var _e97 in this.binders) {
            var _r92 = this.binders[_e97];
            if (_r92 instanceof Wu || _r92 instanceof Ju || _r92 instanceof Qu) for (var _e98 = 0; _e98 < _r92.paintVertexAttributes.length; _e98++) t.push(_r92.paintVertexAttributes[_e98].name);
          }
          return t;
        }
      }, {
        key: "getBinderUniforms",
        value: function getBinderUniforms() {
          var t = [];
          for (var _e99 in this.binders) {
            var _r93 = this.binders[_e99];
            if (_r93 instanceof Hu || _r93 instanceof Ku || _r93 instanceof Ju) {
              var _iterator74 = _createForOfIteratorHelper(_r93.uniformNames),
                _step74;
              try {
                for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
                  var _e100 = _step74.value;
                  t.push(_e100);
                }
              } catch (err) {
                _iterator74.e(err);
              } finally {
                _iterator74.f();
              }
            }
          }
          return t;
        }
      }, {
        key: "getPaintVertexBuffers",
        value: function getPaintVertexBuffers() {
          return this._buffers;
        }
      }, {
        key: "getUniforms",
        value: function getUniforms(t) {
          var e = [];
          for (var _r94 in this.binders) {
            var _n57 = this.binders[_r94];
            if (_n57 instanceof Hu || _n57 instanceof Ku || _n57 instanceof Ju) {
              var _iterator75 = _createForOfIteratorHelper(_n57.uniformNames),
                _step75;
              try {
                for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
                  var _i65 = _step75.value;
                  e.push({
                    name: _i65,
                    property: _r94,
                    binding: _n57.getBinding(t, _i65)
                  });
                }
              } catch (err) {
                _iterator75.e(err);
              } finally {
                _iterator75.f();
              }
            }
          }
          return e;
        }
      }, {
        key: "setUniforms",
        value: function setUniforms(t, e, r, n, i) {
          var _iterator76 = _createForOfIteratorHelper(r),
            _step76;
          try {
            for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
              var _step76$value = _step76.value,
                _e101 = _step76$value.name,
                _s42 = _step76$value.property,
                _a28 = _step76$value.binding;
              this.binders[_s42].setUniform(t, _a28, i, n.get(_s42), _e101);
            }
          } catch (err) {
            _iterator76.e(err);
          } finally {
            _iterator76.f();
          }
        }
      }, {
        key: "updatePaintBuffers",
        value: function updatePaintBuffers() {
          this._buffers = [];
          for (var _t81 in this.binders) {
            var _e102 = this.binders[_t81];
            (_e102 instanceof Wu || _e102 instanceof Ju || _e102 instanceof Qu) && _e102.paintVertexBuffer && this._buffers.push(_e102.paintVertexBuffer);
          }
        }
      }, {
        key: "upload",
        value: function upload(t) {
          for (var _e103 in this.binders) {
            var _r95 = this.binders[_e103];
            (_r95 instanceof Wu || _r95 instanceof Ju || _r95 instanceof Qu) && _r95.upload(t);
          }
          this.updatePaintBuffers();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          for (var _t82 in this.binders) {
            var _e104 = this.binders[_t82];
            (_e104 instanceof Wu || _e104 instanceof Ju || _e104 instanceof Qu) && _e104.destroy();
          }
        }
      }]);
      return tc;
    }();
    var ec = /*#__PURE__*/function () {
      function ec(t, e) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
          return !0;
        };
        _classCallCheck(this, ec);
        this.programConfigurations = {};
        var _iterator77 = _createForOfIteratorHelper(t),
          _step77;
        try {
          for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
            var _n58 = _step77.value;
            this.programConfigurations[_n58.id] = new tc(_n58, e, r);
          }
        } catch (err) {
          _iterator77.e(err);
        } finally {
          _iterator77.f();
        }
        this.needsUpload = !1, this._featureMap = new Bu(), this._featureMapWithoutIds = new Bu(), this._bufferOffset = 0, this._idlessCounter = 0;
      }
      _createClass(ec, [{
        key: "populatePaintArrays",
        value: function populatePaintArrays(t, e, r, n, i, s, a, o) {
          for (var _r96 in this.programConfigurations) this.programConfigurations[_r96].populatePaintArrays(t, e, n, i, s, a, o);
          void 0 !== e.id ? this._featureMap.add(e.id, r, this._bufferOffset, t) : (this._featureMapWithoutIds.add(this._idlessCounter, r, this._bufferOffset, t), this._idlessCounter += 1), this._bufferOffset = t, this.needsUpload = !0;
        }
      }, {
        key: "updatePaintArrays",
        value: function updatePaintArrays(t, e, r, n, i, s) {
          var _iterator78 = _createForOfIteratorHelper(r),
            _step78;
          try {
            for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
              var _a29 = _step78.value;
              this.needsUpload = this.programConfigurations[_a29.id].updatePaintArrays(t, this._featureMap, this._featureMapWithoutIds, e, _a29, n, i, s || 0) || this.needsUpload;
            }
          } catch (err) {
            _iterator78.e(err);
          } finally {
            _iterator78.f();
          }
        }
      }, {
        key: "get",
        value: function get(t) {
          return this.programConfigurations[t];
        }
      }, {
        key: "upload",
        value: function upload(t) {
          if (this.needsUpload) {
            for (var _e105 in this.programConfigurations) this.programConfigurations[_e105].upload(t);
            this.needsUpload = !1;
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          for (var _t83 in this.programConfigurations) this.programConfigurations[_t83].destroy();
        }
      }]);
      return ec;
    }();
    var rc = {
      "text-opacity": ["opacity"],
      "icon-opacity": ["opacity"],
      "text-occlusion-opacity": ["occlusion_opacity"],
      "icon-occlusion-opacity": ["occlusion_opacity"],
      "text-color": ["fill_color"],
      "icon-color": ["fill_color"],
      "text-emissive-strength": ["emissive_strength"],
      "icon-emissive-strength": ["emissive_strength"],
      "text-halo-color": ["halo_color"],
      "icon-halo-color": ["halo_color"],
      "text-halo-blur": ["halo_blur"],
      "icon-halo-blur": ["halo_blur"],
      "text-halo-width": ["halo_width"],
      "icon-halo-width": ["halo_width"],
      "line-gap-width": ["gapwidth"],
      "line-pattern": ["pattern", "pixel_ratio"],
      "fill-pattern": ["pattern", "pixel_ratio"],
      "fill-extrusion-pattern": ["pattern", "pixel_ratio"],
      "line-dasharray": ["dash"]
    };
    function nc(t, e) {
      return rc[t] || [t.replace("".concat(e, "-"), "").replace(/-/g, "_")];
    }
    var ic = {
        "line-pattern": {
          source: $l,
          composite: $l
        },
        "fill-pattern": {
          source: $l,
          composite: $l
        },
        "fill-extrusion-pattern": {
          source: $l,
          composite: $l
        },
        "line-dasharray": {
          source: ql,
          composite: ql
        }
      },
      sc = {
        color: {
          source: lu,
          composite: jl
        },
        number: {
          source: nu,
          composite: lu
        }
      };
    function ac(t, e, r) {
      var n = ic[t];
      return n && n[r] || sc[e][r];
    }
    So(Hu, "ConstantBinder"), So(Ku, "PatternConstantBinder"), So(Wu, "SourceExpressionBinder"), So(Qu, "PatternCompositeBinder"), So(Ju, "CompositeExpressionBinder"), So(tc, "ProgramConfiguration", {
      omit: ["_buffers"]
    }), So(ec, "ProgramConfigurationSet");
    var oc = ds / Math.PI / 2,
      lc = 5,
      uc = 6,
      cc = 16383,
      hc = 64,
      pc = [hc, 32, 16],
      fc = -oc,
      dc = oc;
    function mc(t, e, r) {
      var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : oc;
      return r = Ge(r), [t * Math.sin(r) * n, -e * n, t * Math.cos(r) * n];
    }
    function yc(t, e, r) {
      return mc(Math.cos(Ge(t)), Math.sin(Ge(t)), e, r);
    }
    var gc = 6371008.8,
      xc = 2 * Math.PI * gc;
    var bc = /*#__PURE__*/function () {
      function bc(t, e) {
        _classCallCheck(this, bc);
        if (isNaN(t) || isNaN(e)) throw new Error("Invalid LngLat object: (".concat(t, ", ").concat(e, ")"));
        if (this.lng = +t, this.lat = +e, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
      }
      _createClass(bc, [{
        key: "wrap",
        value: function wrap() {
          return new bc(Qe(this.lng, -180, 180), this.lat);
        }
      }, {
        key: "toArray",
        value: function toArray() {
          return [this.lng, this.lat];
        }
      }, {
        key: "toString",
        value: function toString() {
          return "LngLat(".concat(this.lng, ", ").concat(this.lat, ")");
        }
      }, {
        key: "distanceTo",
        value: function distanceTo(t) {
          var e = Math.PI / 180,
            r = this.lat * e,
            n = t.lat * e,
            i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t.lng - this.lng) * e);
          return gc * Math.acos(Math.min(i, 1));
        }
      }, {
        key: "toBounds",
        value: function toBounds() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          var e = 360 * t / 40075017,
            r = e / Math.cos(Math.PI / 180 * this.lat);
          return new vc({
            lng: this.lng - r,
            lat: this.lat - e
          }, {
            lng: this.lng + r,
            lat: this.lat + e
          });
        }
      }, {
        key: "toEcef",
        value: function toEcef(t) {
          return yc(this.lat, this.lng, oc + t * oc / gc);
        }
      }], [{
        key: "convert",
        value: function convert(t) {
          if (t instanceof bc) return t;
          if (Array.isArray(t) && (2 === t.length || 3 === t.length)) return new bc(Number(t[0]), Number(t[1]));
          if (!Array.isArray(t) && "object" == typeof t && null !== t) return new bc(Number("lng" in t ? t.lng : t.lon), Number(t.lat));
          throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
        }
      }]);
      return bc;
    }();
    var vc = /*#__PURE__*/function () {
      function vc(t, e) {
        _classCallCheck(this, vc);
        if (t) if (e) this.setSouthWest(t).setNorthEast(e);else if (4 === t.length) {
          var _e106 = t;
          this.setSouthWest([_e106[0], _e106[1]]).setNorthEast([_e106[2], _e106[3]]);
        } else {
          var _e107 = t;
          this.setSouthWest(_e107[0]).setNorthEast(_e107[1]);
        }
      }
      _createClass(vc, [{
        key: "setNorthEast",
        value: function setNorthEast(t) {
          return this._ne = t instanceof bc ? new bc(t.lng, t.lat) : bc.convert(t), this;
        }
      }, {
        key: "setSouthWest",
        value: function setSouthWest(t) {
          return this._sw = t instanceof bc ? new bc(t.lng, t.lat) : bc.convert(t), this;
        }
      }, {
        key: "extend",
        value: function extend(t) {
          var e = this._sw,
            r = this._ne;
          var n, i;
          if (t instanceof bc) n = t, i = t;else {
            if (!(t instanceof vc)) return Array.isArray(t) ? 4 === t.length || t.every(Array.isArray) ? this.extend(vc.convert(t)) : this.extend(bc.convert(t)) : "object" == typeof t && null !== t && t.hasOwnProperty("lat") && (t.hasOwnProperty("lon") || t.hasOwnProperty("lng")) ? this.extend(bc.convert(t)) : this;
            if (n = t._sw, i = t._ne, !n || !i) return this;
          }
          return e || r ? (e.lng = Math.min(n.lng, e.lng), e.lat = Math.min(n.lat, e.lat), r.lng = Math.max(i.lng, r.lng), r.lat = Math.max(i.lat, r.lat)) : (this._sw = new bc(n.lng, n.lat), this._ne = new bc(i.lng, i.lat)), this;
        }
      }, {
        key: "getCenter",
        value: function getCenter() {
          return new bc((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
        }
      }, {
        key: "getSouthWest",
        value: function getSouthWest() {
          return this._sw;
        }
      }, {
        key: "getNorthEast",
        value: function getNorthEast() {
          return this._ne;
        }
      }, {
        key: "getNorthWest",
        value: function getNorthWest() {
          return new bc(this.getWest(), this.getNorth());
        }
      }, {
        key: "getSouthEast",
        value: function getSouthEast() {
          return new bc(this.getEast(), this.getSouth());
        }
      }, {
        key: "getWest",
        value: function getWest() {
          return this._sw.lng;
        }
      }, {
        key: "getSouth",
        value: function getSouth() {
          return this._sw.lat;
        }
      }, {
        key: "getEast",
        value: function getEast() {
          return this._ne.lng;
        }
      }, {
        key: "getNorth",
        value: function getNorth() {
          return this._ne.lat;
        }
      }, {
        key: "toArray",
        value: function toArray() {
          return [this._sw.toArray(), this._ne.toArray()];
        }
      }, {
        key: "toString",
        value: function toString() {
          return "LngLatBounds(".concat(this._sw.toString(), ", ").concat(this._ne.toString(), ")");
        }
      }, {
        key: "isEmpty",
        value: function isEmpty() {
          return !(this._sw && this._ne);
        }
      }, {
        key: "contains",
        value: function contains(t) {
          var _bc$convert = bc.convert(t),
            e = _bc$convert.lng,
            r = _bc$convert.lat;
          var n = this._sw.lng <= e && e <= this._ne.lng;
          return this._sw.lng > this._ne.lng && (n = this._sw.lng >= e && e >= this._ne.lng), this._sw.lat <= r && r <= this._ne.lat && n;
        }
      }], [{
        key: "convert",
        value: function convert(t) {
          return !t || t instanceof vc ? t : new vc(t);
        }
      }]);
      return vc;
    }();
    var _c = {};
    !function (t, e) {
      !function (t) {
        function e(t, e, n) {
          var i = r(256 * t, 256 * (e = Math.pow(2, n) - e - 1), n),
            s = r(256 * (t + 1), 256 * (e + 1), n);
          return i[0] + "," + i[1] + "," + s[0] + "," + s[1];
        }
        function r(t, e, r) {
          var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
          return [t * n - 2 * Math.PI * 6378137 / 2, e * n - 2 * Math.PI * 6378137 / 2];
        }
        t.getURL = function (t, r, n, i, s, a) {
          return a = a || {}, t + "?" + ["bbox=" + e(n, i, s), "format=" + (a.format || "image/png"), "service=" + (a.service || "WMS"), "version=" + (a.version || "1.1.1"), "request=" + (a.request || "GetMap"), "srs=" + (a.srs || "EPSG:3857"), "width=" + (a.width || 256), "height=" + (a.height || 256), "layers=" + r].join("&");
        }, t.getTileBBox = e, t.getMercCoords = r, Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }(e);
    }(0, _c);
    var wc = _c;
    var Mc = /*#__PURE__*/function () {
      function Mc(t, e, r) {
        _classCallCheck(this, Mc);
        this.z = t, this.x = e, this.y = r, this.key = Ic(0, t, t, e, r);
      }
      _createClass(Mc, [{
        key: "equals",
        value: function equals(t) {
          return this.z === t.z && this.x === t.x && this.y === t.y;
        }
      }, {
        key: "url",
        value: function url(t, e) {
          var r = wc.getTileBBox(this.x, this.y, this.z),
            n = function (t, e, r) {
              var n,
                i = "";
              for (var _s43 = t; _s43 > 0; _s43--) n = 1 << _s43 - 1, i += (e & n ? 1 : 0) + (r & n ? 2 : 0);
              return i;
            }(this.z, this.x, this.y);
          return t[(this.x + this.y) % t.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === e ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n).replace("{bbox-epsg-3857}", r);
        }
      }, {
        key: "toString",
        value: function toString() {
          return "".concat(this.z, "/").concat(this.x, "/").concat(this.y);
        }
      }]);
      return Mc;
    }();
    var Ac = /*#__PURE__*/_createClass(function Ac(t, e) {
      _classCallCheck(this, Ac);
      this.wrap = t, this.canonical = e, this.key = Ic(t, e.z, e.z, e.x, e.y);
    });
    var Sc = /*#__PURE__*/function () {
      function Sc(t, e, r, n, i) {
        _classCallCheck(this, Sc);
        this.overscaledZ = t, this.wrap = e, this.canonical = new Mc(r, +n, +i), this.key = 0 === e && t === r ? this.canonical.key : Ic(e, t, r, n, i);
      }
      _createClass(Sc, [{
        key: "equals",
        value: function equals(t) {
          return this.overscaledZ === t.overscaledZ && this.wrap === t.wrap && this.canonical.equals(t.canonical);
        }
      }, {
        key: "scaledTo",
        value: function scaledTo(t) {
          var e = this.canonical.z - t;
          return t > this.canonical.z ? new Sc(t, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Sc(t, this.wrap, t, this.canonical.x >> e, this.canonical.y >> e);
        }
      }, {
        key: "calculateScaledKey",
        value: function calculateScaledKey(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          if (this.overscaledZ === t && e) return this.key;
          if (t > this.canonical.z) return Ic(this.wrap * +e, t, this.canonical.z, this.canonical.x, this.canonical.y);
          {
            var _r97 = this.canonical.z - t;
            return Ic(this.wrap * +e, t, t, this.canonical.x >> _r97, this.canonical.y >> _r97);
          }
        }
      }, {
        key: "isChildOf",
        value: function isChildOf(t) {
          if (t.wrap !== this.wrap) return !1;
          var e = this.canonical.z - t.canonical.z;
          return 0 === t.overscaledZ || t.overscaledZ < this.overscaledZ && t.canonical.z < this.canonical.z && t.canonical.x === this.canonical.x >> e && t.canonical.y === this.canonical.y >> e;
        }
      }, {
        key: "children",
        value: function children(t) {
          if (this.overscaledZ >= t) return [new Sc(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)];
          var e = this.canonical.z + 1,
            r = 2 * this.canonical.x,
            n = 2 * this.canonical.y;
          return [new Sc(e, this.wrap, e, r, n), new Sc(e, this.wrap, e, r + 1, n), new Sc(e, this.wrap, e, r, n + 1), new Sc(e, this.wrap, e, r + 1, n + 1)];
        }
      }, {
        key: "isLessThan",
        value: function isLessThan(t) {
          return this.wrap < t.wrap || !(this.wrap > t.wrap) && (this.overscaledZ < t.overscaledZ || !(this.overscaledZ > t.overscaledZ) && (this.canonical.x < t.canonical.x || !(this.canonical.x > t.canonical.x) && this.canonical.y < t.canonical.y));
        }
      }, {
        key: "wrapped",
        value: function wrapped() {
          return new Sc(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
        }
      }, {
        key: "unwrapTo",
        value: function unwrapTo(t) {
          return new Sc(this.overscaledZ, t, this.canonical.z, this.canonical.x, this.canonical.y);
        }
      }, {
        key: "overscaleFactor",
        value: function overscaleFactor() {
          return Math.pow(2, this.overscaledZ - this.canonical.z);
        }
      }, {
        key: "toUnwrapped",
        value: function toUnwrapped() {
          return new Ac(this.wrap, this.canonical);
        }
      }, {
        key: "toString",
        value: function toString() {
          return "".concat(this.overscaledZ, "/").concat(this.canonical.x, "/").concat(this.canonical.y);
        }
      }]);
      return Sc;
    }();
    function Ic(t, e, r, n, i) {
      var s = 1 << Math.min(r, 22);
      var a = s * (i % s) + n % s;
      return t && r < 22 && (a += s * s * ((t < 0 ? -2 * t - 1 : 2 * t) % (1 << 2 * (22 - r)))), 16 * (32 * a + r) + (e - r);
    }
    var Tc = [function (t) {
      var e = t.canonical.x - 1,
        r = t.wrap;
      return e < 0 && (e = (1 << t.canonical.z) - 1, r--), new Sc(t.overscaledZ, r, t.canonical.z, e, t.canonical.y);
    }, function (t) {
      var e = t.canonical.x + 1,
        r = t.wrap;
      return e === 1 << t.canonical.z && (e = 0, r++), new Sc(t.overscaledZ, r, t.canonical.z, e, t.canonical.y);
    }, function (t) {
      return new Sc(t.overscaledZ, t.wrap, t.canonical.z, t.canonical.x, (0 === t.canonical.y ? 1 << t.canonical.z : t.canonical.y) - 1);
    }, function (t) {
      return new Sc(t.overscaledZ, t.wrap, t.canonical.z, t.canonical.x, t.canonical.y === (1 << t.canonical.z) - 1 ? 0 : t.canonical.y + 1);
    }];
    So(Mc, "CanonicalTileID"), So(Sc, "OverscaledTileID", {
      omit: ["projMatrix", "expandedProjMatrix"]
    });
    var kc = 0,
      Pc = 25.5;
    function zc(t) {
      return xc * Math.cos(t * Math.PI / 180);
    }
    function Ec(t) {
      return (180 + t) / 360;
    }
    function Bc(t) {
      return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t * Math.PI / 360))) / 360;
    }
    function Dc(t, e) {
      return t / zc(e);
    }
    function Rc(t) {
      return 360 * t - 180;
    }
    function Cc(t) {
      return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t) * Math.PI / 180)) - 90;
    }
    function Lc(t, e) {
      return t * zc(Cc(e));
    }
    var Vc = 85.051129;
    function Fc(t) {
      return Math.cos(Ge(We(t, -Vc, Vc)));
    }
    function Oc(t, e) {
      var r = We(e, kc, Pc),
        n = Math.pow(2, r);
      return Fc(t) * xc / (512 * n);
    }
    function Uc(t) {
      return 1 / Math.cos(t * Math.PI / 180);
    }
    function jc(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var r = Math.exp(Math.PI * (1 - (t.y + e / ds) / (1 << t.z) * 2));
      return 80150034 * r / (r * r + 1) / ds / (1 << t.z);
    }
    var Nc = /*#__PURE__*/function () {
      function Nc(t, e) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        _classCallCheck(this, Nc);
        this.x = +t, this.y = +e, this.z = +r;
      }
      _createClass(Nc, [{
        key: "toLngLat",
        value: function toLngLat() {
          return new bc(Rc(this.x), Cc(this.y));
        }
      }, {
        key: "toAltitude",
        value: function toAltitude() {
          return Lc(this.z, this.y);
        }
      }, {
        key: "meterInMercatorCoordinateUnits",
        value: function meterInMercatorCoordinateUnits() {
          return 1 / xc * Uc(Cc(this.y));
        }
      }], [{
        key: "fromLngLat",
        value: function fromLngLat(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var r = bc.convert(t);
          return new Nc(Ec(r.lng), Bc(r.lat), Dc(e, r.lat));
        }
      }]);
      return Nc;
    }();
    function $c(t, e, r, n, i, s, a, o, l) {
      var u = (e + n) / 2,
        c = (r + i) / 2,
        h = new je(u, c);
      o(h), function (t, e, r, n, i, s) {
        var a = r - i,
          o = n - s;
        return Math.abs((n - e) * a - (r - t) * o) / Math.hypot(a, o);
      }(h.x, h.y, s.x, s.y, a.x, a.y) >= l ? ($c(t, e, r, u, c, s, h, o, l), $c(t, u, c, n, i, h, a, o, l)) : t.push(a);
    }
    function qc(t, e, r) {
      var n = t[0],
        i = n.x,
        s = n.y;
      e(n);
      var a = [n];
      for (var _o18 = 1; _o18 < t.length; _o18++) {
        var _l15 = t[_o18],
          _u13 = _l15.x,
          _c9 = _l15.y;
        e(_l15), $c(a, i, s, _u13, _c9, n, _l15, e, r), i = _u13, s = _c9, n = _l15;
      }
      return a;
    }
    function Gc(t, e, r, n) {
      if (n(e, r)) {
        var _i66 = e.add(r)._mult(.5);
        Gc(t, e, _i66, n), Gc(t, _i66, r, n);
      } else t.push(r);
    }
    function Xc(t, e) {
      var r = t[0];
      var n = [r];
      for (var _i67 = 1; _i67 < t.length; _i67++) {
        var _s44 = t[_i67];
        Gc(n, r, _s44, e), r = _s44;
      }
      return n;
    }
    var Yc = Math.pow(2, 14) - 1,
      Zc = -Yc - 1;
    function Hc(t, e) {
      var r = Math.round(t.x * e),
        n = Math.round(t.y * e);
      return t.x = We(r, Zc, Yc), t.y = We(n, Zc, Yc), (r < t.x || r > t.x + 1 || n < t.y || n > t.y + 1) && dr("Geometry exceeds allowed extent, reduce your vector tile buffer size"), t;
    }
    function Kc(t, e, r) {
      var n = t.loadGeometry(),
        i = t.extent,
        s = ds / i;
      if (e && r && r.projection.isReprojectedInTileSpace) {
        var _s45 = 1 << e.z,
          _a30 = r.scale,
          _o19 = r.x,
          _l16 = r.y,
          _u14 = r.projection,
          _c10 = function _c10(t) {
            var r = Rc((e.x + t.x / i) / _s45),
              n = Cc((e.y + t.y / i) / _s45),
              c = _u14.project(r, n);
            t.x = (c.x * _a30 - _o19) * i, t.y = (c.y * _a30 - _l16) * i;
          };
        for (var _e108 = 0; _e108 < n.length; _e108++) if (1 !== t.type) n[_e108] = qc(n[_e108], _c10, 1);else {
          var _t84 = [];
          var _iterator79 = _createForOfIteratorHelper(n[_e108]),
            _step79;
          try {
            for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
              var _r98 = _step79.value;
              _r98.x < 0 || _r98.x >= i || _r98.y < 0 || _r98.y >= i || (_c10(_r98), _t84.push(_r98));
            }
          } catch (err) {
            _iterator79.e(err);
          } finally {
            _iterator79.f();
          }
          n[_e108] = _t84;
        }
      }
      var _iterator80 = _createForOfIteratorHelper(n),
        _step80;
      try {
        for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
          var _t85 = _step80.value;
          var _iterator81 = _createForOfIteratorHelper(_t85),
            _step81;
          try {
            for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
              var _e109 = _step81.value;
              Hc(_e109, s);
            }
          } catch (err) {
            _iterator81.e(err);
          } finally {
            _iterator81.f();
          }
        }
      } catch (err) {
        _iterator80.e(err);
      } finally {
        _iterator80.f();
      }
      return n;
    }
    function Wc(t, e) {
      return {
        type: t.type,
        id: t.id,
        properties: t.properties,
        geometry: e ? Kc(t) : []
      };
    }
    function Jc(t, e, r, n, i) {
      t.emplaceBack(2 * e + (n + 1) / 2, 2 * r + (i + 1) / 2);
    }
    function Qc(t, e, r) {
      var n = 16384;
      t.emplaceBack(e.x, e.y, e.z, r[0] * n, r[1] * n, r[2] * n);
    }
    var th = /*#__PURE__*/function () {
      function th(t) {
        _classCallCheck(this, th);
        this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function (t) {
          return t.fqid;
        }), this.index = t.index, this.hasPattern = !1, this.projection = t.projection, this.layoutVertexArray = new Ll(), this.indexArray = new tu(), this.segments = new ku(), this.programConfigurations = new ec(t.layers, {
          zoom: t.zoom,
          lut: t.lut
        }), this.stateDependentLayerIds = this.layers.filter(function (t) {
          return t.isStateDependent();
        }).map(function (t) {
          return t.id;
        });
      }
      _createClass(th, [{
        key: "updateFootprints",
        value: function updateFootprints(t, e) {}
      }, {
        key: "populate",
        value: function populate(t, e, r, n) {
          var i = this.layers[0],
            s = [];
          var a = null;
          "circle" === i.type && (a = i.layout.get("circle-sort-key"));
          var _iterator82 = _createForOfIteratorHelper(t),
            _step82;
          try {
            for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
              var _step82$value = _step82.value,
                _e110 = _step82$value.feature,
                _i70 = _step82$value.id,
                _o20 = _step82$value.index,
                _l18 = _step82$value.sourceLayerIndex;
              var _t86 = this.layers[0]._featureFilter.needGeometry,
                _u15 = Wc(_e110, _t86);
              if (!this.layers[0]._featureFilter.filter(new Wo(this.zoom), _u15, r)) continue;
              var _c11 = a ? a.evaluate(_u15, {}, r) : void 0,
                _h6 = {
                  id: _i70,
                  properties: _e110.properties,
                  type: _e110.type,
                  sourceLayerIndex: _l18,
                  index: _o20,
                  geometry: _t86 ? _u15.geometry : Kc(_e110, r, n),
                  patterns: {},
                  sortKey: _c11
                };
              s.push(_h6);
            }
          } catch (err) {
            _iterator82.e(err);
          } finally {
            _iterator82.f();
          }
          a && s.sort(function (t, e) {
            return t.sortKey - e.sortKey;
          });
          var o = null;
          "globe" === n.projection.name && (this.globeExtVertexArray = new Gl(), o = n.projection);
          for (var _i68 = 0, _s46 = s; _i68 < _s46.length; _i68++) {
            var _n59 = _s46[_i68];
            var _i69 = _n59.geometry,
              _s47 = _n59.index,
              _a31 = _n59.sourceLayerIndex,
              _l17 = t[_s47].feature;
            this.addFeature(_n59, _i69, _s47, e.availableImages, r, o, e.brightness), e.featureIndex.insert(_l17, _i69, _s47, _a31, this.index);
          }
        }
      }, {
        key: "update",
        value: function update(t, e, r, n, i) {
          var s = 0 !== Object.keys(t).length;
          s && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(t, e, s ? this.stateDependentLayers : this.layers, r, n, i);
        }
      }, {
        key: "isEmpty",
        value: function isEmpty() {
          return 0 === this.layoutVertexArray.length;
        }
      }, {
        key: "uploadPending",
        value: function uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
      }, {
        key: "upload",
        value: function upload(t) {
          this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Iu.members), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = t.createVertexBuffer(this.globeExtVertexArray, Tu.members))), this.programConfigurations.upload(t), this.uploaded = !0;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy());
        }
      }, {
        key: "addFeature",
        value: function addFeature(t, e, r, n, i, s, a) {
          var _iterator83 = _createForOfIteratorHelper(e),
            _step83;
          try {
            for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
              var _r99 = _step83.value;
              var _iterator84 = _createForOfIteratorHelper(_r99),
                _step84;
              try {
                for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
                  var _e111 = _step84.value;
                  var _r100 = _e111.x,
                    _n60 = _e111.y;
                  if (_r100 < 0 || _r100 >= ds || _n60 < 0 || _n60 >= ds) continue;
                  if (s) {
                    var _t87 = s.projectTilePoint(_r100, _n60, i),
                      _e112 = s.upVector(i, _r100, _n60),
                      _a32 = this.globeExtVertexArray;
                    Qc(_a32, _t87, _e112), Qc(_a32, _t87, _e112), Qc(_a32, _t87, _e112), Qc(_a32, _t87, _e112);
                  }
                  var _a33 = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t.sortKey),
                    _o21 = _a33.vertexLength;
                  Jc(this.layoutVertexArray, _r100, _n60, -1, -1), Jc(this.layoutVertexArray, _r100, _n60, 1, -1), Jc(this.layoutVertexArray, _r100, _n60, 1, 1), Jc(this.layoutVertexArray, _r100, _n60, -1, 1), this.indexArray.emplaceBack(_o21, _o21 + 1, _o21 + 2), this.indexArray.emplaceBack(_o21, _o21 + 2, _o21 + 3), _a33.vertexLength += 4, _a33.primitiveLength += 2;
                }
              } catch (err) {
                _iterator84.e(err);
              } finally {
                _iterator84.f();
              }
            }
          } catch (err) {
            _iterator83.e(err);
          } finally {
            _iterator83.f();
          }
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, {}, n, i, a);
        }
      }]);
      return th;
    }();
    function eh(t, e) {
      for (var _r101 = 0; _r101 < t.length; _r101++) if (ch(e, t[_r101])) return !0;
      for (var _r102 = 0; _r102 < e.length; _r102++) if (ch(t, e[_r102])) return !0;
      return !!sh(t, e);
    }
    function rh(t, e, r) {
      return !!ch(t, e) || !!oh(e, t, r);
    }
    function nh(t, e) {
      if (1 === t.length) return uh(e, t[0]);
      for (var _r103 = 0; _r103 < e.length; _r103++) {
        var _n61 = e[_r103];
        for (var _e113 = 0; _e113 < _n61.length; _e113++) if (ch(t, _n61[_e113])) return !0;
      }
      for (var _r104 = 0; _r104 < t.length; _r104++) if (uh(e, t[_r104])) return !0;
      for (var _r105 = 0; _r105 < e.length; _r105++) if (sh(t, e[_r105])) return !0;
      return !1;
    }
    function ih(t, e, r) {
      if (t.length > 1) {
        if (sh(t, e)) return !0;
        for (var _n62 = 0; _n62 < e.length; _n62++) if (oh(e[_n62], t, r)) return !0;
      }
      for (var _n63 = 0; _n63 < t.length; _n63++) if (oh(t[_n63], e, r)) return !0;
      return !1;
    }
    function sh(t, e) {
      if (0 === t.length || 0 === e.length) return !1;
      for (var _r106 = 0; _r106 < t.length - 1; _r106++) {
        var _n64 = t[_r106],
          _i71 = t[_r106 + 1];
        for (var _t88 = 0; _t88 < e.length - 1; _t88++) if (ah(_n64, _i71, e[_t88], e[_t88 + 1])) return !0;
      }
      return !1;
    }
    function ah(t, e, r, n) {
      return mr(t, r, n) !== mr(e, r, n) && mr(t, e, r) !== mr(t, e, n);
    }
    function oh(t, e, r) {
      var n = r * r;
      if (1 === e.length) return t.distSqr(e[0]) < n;
      for (var _r107 = 1; _r107 < e.length; _r107++) if (lh(t, e[_r107 - 1], e[_r107]) < n) return !0;
      return !1;
    }
    function lh(t, e, r) {
      var n = e.distSqr(r);
      if (0 === n) return t.distSqr(e);
      var i = ((t.x - e.x) * (r.x - e.x) + (t.y - e.y) * (r.y - e.y)) / n;
      return t.distSqr(i < 0 ? e : i > 1 ? r : r.sub(e)._mult(i)._add(e));
    }
    function uh(t, e) {
      var r,
        n,
        i,
        s = !1;
      for (var _a34 = 0; _a34 < t.length; _a34++) {
        r = t[_a34];
        for (var _t89 = 0, _a35 = r.length - 1; _t89 < r.length; _a35 = _t89++) n = r[_t89], i = r[_a35], n.y > e.y != i.y > e.y && e.x < (i.x - n.x) * (e.y - n.y) / (i.y - n.y) + n.x && (s = !s);
      }
      return s;
    }
    function ch(t, e) {
      var r = !1;
      for (var _n65 = 0, _i72 = t.length - 1; _n65 < t.length; _i72 = _n65++) {
        var _s48 = t[_n65],
          _a36 = t[_i72];
        _s48.y > e.y != _a36.y > e.y && e.x < (_a36.x - _s48.x) * (e.y - _s48.y) / (_a36.y - _s48.y) + _s48.x && (r = !r);
      }
      return r;
    }
    function hh(t, e, r, n, i) {
      var _iterator85 = _createForOfIteratorHelper(t),
        _step85;
      try {
        for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
          var _s49 = _step85.value;
          if (e <= _s49.x && r <= _s49.y && n >= _s49.x && i >= _s49.y) return !0;
        }
      } catch (err) {
        _iterator85.e(err);
      } finally {
        _iterator85.f();
      }
      var s = [new je(e, r), new je(e, i), new je(n, i), new je(n, r)];
      if (t.length > 2) {
        var _iterator86 = _createForOfIteratorHelper(s),
          _step86;
        try {
          for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
            var _e114 = _step86.value;
            if (ch(t, _e114)) return !0;
          }
        } catch (err) {
          _iterator86.e(err);
        } finally {
          _iterator86.f();
        }
      }
      for (var _e115 = 0; _e115 < t.length - 1; _e115++) if (ph(t[_e115], t[_e115 + 1], s)) return !0;
      return !1;
    }
    function ph(t, e, r) {
      var n = r[0],
        i = r[2];
      if (t.x < n.x && e.x < n.x || t.x > i.x && e.x > i.x || t.y < n.y && e.y < n.y || t.y > i.y && e.y > i.y) return !1;
      var s = mr(t, e, r[0]);
      return s !== mr(t, e, r[1]) || s !== mr(t, e, r[2]) || s !== mr(t, e, r[3]);
    }
    function fh(t, e, r, n, i, s) {
      var a = e.y - t.y,
        o = t.x - e.x;
      if (s = s || 0) {
        var _t90 = a * a + o * o;
        if (0 === _t90) return !0;
        var _e116 = Math.sqrt(_t90);
        a /= _e116, o /= _e116;
      }
      return !((r.x - t.x) * a + (r.y - t.y) * o - s < 0 || (n.x - t.x) * a + (n.y - t.y) * o - s < 0 || (i.x - t.x) * a + (i.y - t.y) * o - s < 0);
    }
    function dh(t, e, r, n, i, s, a) {
      return !(fh(t, e, n, i, s, a) || fh(e, r, n, i, s, a) || fh(r, t, n, i, s, a) || fh(n, i, t, e, r, a) || fh(i, s, t, e, r, a) || fh(s, n, t, e, r, a));
    }
    function mh(t, e, r) {
      var n = e.paint.get(t).value;
      return "constant" === n.kind ? n.value : r.programConfigurations.get(e.id).getMaxValue(t);
    }
    function yh(t) {
      return Math.sqrt(t[0] * t[0] + t[1] * t[1]);
    }
    function gh(t, e, r, n, i) {
      if (!e[0] && !e[1]) return t;
      var s = je.convert(e)._mult(i);
      "viewport" === r && s._rotate(-n);
      var a = [];
      for (var _e117 = 0; _e117 < t.length; _e117++) a.push(t[_e117].sub(s));
      return a;
    }
    function xh(t, e, r, n) {
      var i = je.convert(t)._mult(n);
      return "viewport" === e && i._rotate(-r), i;
    }
    var bh, vh;
    So(th, "CircleBucket", {
      omit: ["layers"]
    });
    var _h = /*#__PURE__*/function () {
      function _h(t, e) {
        _classCallCheck(this, _h);
        this.pos = t, this.dir = e;
      }
      _createClass(_h, [{
        key: "intersectsPlane",
        value: function intersectsPlane(e, r, n) {
          var i = t.$.dot(r, this.dir);
          if (Math.abs(i) < 1e-6) return !1;
          var s = ((e[0] - this.pos[0]) * r[0] + (e[1] - this.pos[1]) * r[1] + (e[2] - this.pos[2]) * r[2]) / i;
          return n[0] = this.pos[0] + this.dir[0] * s, n[1] = this.pos[1] + this.dir[1] * s, n[2] = this.pos[2] + this.dir[2] * s, !0;
        }
      }, {
        key: "closestPointOnSphere",
        value: function closestPointOnSphere(e, r, n) {
          if (t.$.equals(this.pos, e) || 0 === r) return n[0] = n[1] = n[2] = 0, !1;
          var _this$dir = _slicedToArray(this.dir, 3),
            i = _this$dir[0],
            s = _this$dir[1],
            a = _this$dir[2],
            o = this.pos[0] - e[0],
            l = this.pos[1] - e[1],
            u = this.pos[2] - e[2],
            c = i * i + s * s + a * a,
            h = 2 * (o * i + l * s + u * a),
            p = h * h - 4 * c * (o * o + l * l + u * u - r * r);
          if (p < 0) {
            var _t91 = Math.max(-h / 2, 0),
              _e118 = o + i * _t91,
              _c12 = l + s * _t91,
              _p4 = u + a * _t91,
              _f5 = Math.hypot(_e118, _c12, _p4);
            return n[0] = _e118 * r / _f5, n[1] = _c12 * r / _f5, n[2] = _p4 * r / _f5, !1;
          }
          {
            var _t92 = (-h - Math.sqrt(p)) / (2 * c);
            if (_t92 < 0) {
              var _t93 = Math.hypot(o, l, u);
              return n[0] = o * r / _t93, n[1] = l * r / _t93, n[2] = u * r / _t93, !1;
            }
            return n[0] = o + i * _t92, n[1] = l + s * _t92, n[2] = u + a * _t92, !0;
          }
        }
      }]);
      return _h;
    }();
    var wh = /*#__PURE__*/function () {
      function wh(t, e, r, n, i) {
        _classCallCheck(this, wh);
        this.TL = t, this.TR = e, this.BR = r, this.BL = n, this.horizon = i;
      }
      _createClass(wh, null, [{
        key: "fromInvProjectionMatrix",
        value: function fromInvProjectionMatrix(e, r, n) {
          var i = [-1, 1, 1],
            s = [1, 1, 1],
            a = [1, -1, 1],
            o = [-1, -1, 1],
            l = t.$.transformMat4(i, i, e),
            u = t.$.transformMat4(s, s, e),
            c = t.$.transformMat4(a, a, e),
            h = t.$.transformMat4(o, o, e);
          return new wh(l, u, c, h, r / n);
        }
      }]);
      return wh;
    }();
    function Mh(e, r, n) {
      var i = 1 / 0,
        s = -1 / 0;
      var a = [];
      var _iterator87 = _createForOfIteratorHelper(e),
        _step87;
      try {
        for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
          var _o22 = _step87.value;
          t.$.sub(a, _o22, r);
          var _e119 = t.$.dot(a, n);
          i = Math.min(i, _e119), s = Math.max(s, _e119);
        }
      } catch (err) {
        _iterator87.e(err);
      } finally {
        _iterator87.f();
      }
      return [i, s];
    }
    function Ah(e, r) {
      var n = !0;
      for (var _i73 = 0; _i73 < e.planes.length; _i73++) {
        var _s50 = e.planes[_i73];
        var _a37 = 0;
        for (var _e120 = 0; _e120 < r.length; _e120++) _a37 += t.$.dot(_s50, r[_e120]) + _s50[3] >= 0;
        if (0 === _a37) return 0;
        _a37 !== r.length && (n = !1);
      }
      return n ? 2 : 1;
    }
    function Sh(t, e) {
      var _iterator88 = _createForOfIteratorHelper(t.projections),
        _step88;
      try {
        for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
          var _r108 = _step88.value;
          var _n66 = Mh(e, t.points[0], _r108.axis);
          if (_r108.projection[1] < _n66[0] || _r108.projection[0] > _n66[1]) return 0;
        }
      } catch (err) {
        _iterator88.e(err);
      } finally {
        _iterator88.f();
      }
      return 1;
    }
    function Ih(e, r) {
      var n = 0;
      var i = [0, 0, 0, 0];
      for (var _s51 = 0; _s51 < e.length; _s51++) i[0] = e[_s51][0], i[1] = e[_s51][1], i[2] = e[_s51][2], i[3] = 1, t.aB.dot(i, r) >= 0 && n++;
      return n;
    }
    var Th = /*#__PURE__*/function () {
      function Th(e, r) {
        _classCallCheck(this, Th);
        this.points = e || new Array(8).fill([0, 0, 0]), this.planes = r || new Array(6).fill([0, 0, 0, 0]), this.bounds = kh.fromPoints(this.points), this.projections = [], this.frustumEdges = [t.$.sub([], this.points[2], this.points[3]), t.$.sub([], this.points[0], this.points[3]), t.$.sub([], this.points[4], this.points[0]), t.$.sub([], this.points[5], this.points[1]), t.$.sub([], this.points[6], this.points[2]), t.$.sub([], this.points[7], this.points[3])];
        var _iterator89 = _createForOfIteratorHelper(this.frustumEdges),
          _step89;
        try {
          for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
            var _t94 = _step89.value;
            var _e121 = [0, -_t94[2], _t94[1]],
              _r109 = [_t94[2], 0, -_t94[0]];
            this.projections.push({
              axis: _e121,
              projection: Mh(this.points, this.points[0], _e121)
            }), this.projections.push({
              axis: _r109,
              projection: Mh(this.points, this.points[0], _r109)
            });
          }
        } catch (err) {
          _iterator89.e(err);
        } finally {
          _iterator89.f();
        }
      }
      _createClass(Th, [{
        key: "intersectsPrecise",
        value: function intersectsPrecise(e, r, n) {
          for (var _t95 = 0; _t95 < r.length; _t95++) if (!Ih(e, r[_t95])) return 0;
          for (var _t96 = 0; _t96 < this.planes.length; _t96++) if (!Ih(e, this.planes[_t96])) return 0;
          var _iterator90 = _createForOfIteratorHelper(n),
            _step90;
          try {
            for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
              var _r110 = _step90.value;
              var _iterator91 = _createForOfIteratorHelper(this.frustumEdges),
                _step91;
              try {
                for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
                  var _n67 = _step91.value;
                  var _i74 = t.$.cross([], _r110, _n67),
                    _s52 = t.$.length(_i74);
                  if (0 === _s52) continue;
                  t.$.scale(_i74, _i74, 1 / _s52);
                  var _a38 = Mh(this.points, this.points[0], _i74),
                    _o23 = Mh(e, this.points[0], _i74);
                  if (_a38[0] > _o23[1] || _o23[0] > _a38[1]) return 0;
                }
              } catch (err) {
                _iterator91.e(err);
              } finally {
                _iterator91.f();
              }
            }
          } catch (err) {
            _iterator90.e(err);
          } finally {
            _iterator90.f();
          }
          return 1;
        }
      }, {
        key: "containsPoint",
        value: function containsPoint(e) {
          var _iterator92 = _createForOfIteratorHelper(this.planes),
            _step92;
          try {
            for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
              var _r111 = _step92.value;
              var _n68 = _r111[3];
              if (t.$.dot([_r111[0], _r111[1], _r111[2]], e) + _n68 < 0) return !1;
            }
          } catch (err) {
            _iterator92.e(err);
          } finally {
            _iterator92.f();
          }
          return !0;
        }
      }], [{
        key: "fromInvProjectionMatrix",
        value: function fromInvProjectionMatrix(e, r, n, i) {
          var s = Math.pow(2, n),
            a = [[-1, 1, -1, 1], [1, 1, -1, 1], [1, -1, -1, 1], [-1, -1, -1, 1], [-1, 1, 1, 1], [1, 1, 1, 1], [1, -1, 1, 1], [-1, -1, 1, 1]].map(function (n) {
              var a = t.aB.transformMat4([], n, e),
                o = 1 / a[3] / r * s;
              return t.aB.mul(a, a, [o, o, i ? 1 / a[3] : o, o]);
            }),
            o = [[0, 1, 2], [6, 5, 4], [0, 3, 7], [2, 1, 5], [3, 2, 6], [0, 4, 5]].map(function (e) {
              var r = t.$.sub([], a[e[0]], a[e[1]]),
                n = t.$.sub([], a[e[2]], a[e[1]]),
                i = t.$.normalize([], t.$.cross([], r, n)),
                s = -t.$.dot(i, a[e[1]]);
              return i.concat(s);
            }),
            l = [];
          for (var _t97 = 0; _t97 < a.length; _t97++) l.push([a[_t97][0], a[_t97][1], a[_t97][2]]);
          return new Th(l, o);
        }
      }]);
      return Th;
    }();
    var kh = /*#__PURE__*/function () {
      function kh(e, r) {
        _classCallCheck(this, kh);
        this.min = e, this.max = r, this.center = t.$.scale([], t.$.add([], this.min, this.max), .5);
      }
      _createClass(kh, [{
        key: "quadrant",
        value: function quadrant(e) {
          var r = [e % 2 == 0, e < 2],
            n = t.$.clone(this.min),
            i = t.$.clone(this.max);
          for (var _t98 = 0; _t98 < r.length; _t98++) n[_t98] = r[_t98] ? this.min[_t98] : this.center[_t98], i[_t98] = r[_t98] ? this.center[_t98] : this.max[_t98];
          return i[2] = this.max[2], new kh(n, i);
        }
      }, {
        key: "distanceX",
        value: function distanceX(t) {
          return Math.max(Math.min(this.max[0], t[0]), this.min[0]) - t[0];
        }
      }, {
        key: "distanceY",
        value: function distanceY(t) {
          return Math.max(Math.min(this.max[1], t[1]), this.min[1]) - t[1];
        }
      }, {
        key: "distanceZ",
        value: function distanceZ(t) {
          return Math.max(Math.min(this.max[2], t[2]), this.min[2]) - t[2];
        }
      }, {
        key: "getCorners",
        value: function getCorners() {
          var t = this.min,
            e = this.max;
          return [[t[0], t[1], t[2]], [e[0], t[1], t[2]], [e[0], e[1], t[2]], [t[0], e[1], t[2]], [t[0], t[1], e[2]], [e[0], t[1], e[2]], [e[0], e[1], e[2]], [t[0], e[1], e[2]]];
        }
      }, {
        key: "intersects",
        value: function intersects(t) {
          return this.intersectsAabb(t.bounds) ? Ah(t, this.getCorners()) : 0;
        }
      }, {
        key: "intersectsFlat",
        value: function intersectsFlat(t) {
          return this.intersectsAabb(t.bounds) ? Ah(t, [[this.min[0], this.min[1], 0], [this.max[0], this.min[1], 0], [this.max[0], this.max[1], 0], [this.min[0], this.max[1], 0]]) : 0;
        }
      }, {
        key: "intersectsPrecise",
        value: function intersectsPrecise(t, e) {
          return e || this.intersects(t) ? Sh(t, this.getCorners()) : 0;
        }
      }, {
        key: "intersectsPreciseFlat",
        value: function intersectsPreciseFlat(t, e) {
          return e || this.intersectsFlat(t) ? Sh(t, [[this.min[0], this.min[1], 0], [this.max[0], this.min[1], 0], [this.max[0], this.max[1], 0], [this.min[0], this.max[1], 0]]) : 0;
        }
      }, {
        key: "intersectsAabb",
        value: function intersectsAabb(t) {
          for (var _e122 = 0; _e122 < 3; ++_e122) if (this.min[_e122] > t.max[_e122] || t.min[_e122] > this.max[_e122]) return !1;
          return !0;
        }
      }, {
        key: "intersectsAabbXY",
        value: function intersectsAabbXY(t) {
          return !(this.min[0] > t.max[0] || t.min[0] > this.max[0] || this.min[1] > t.max[1] || t.min[1] > this.max[1]);
        }
      }, {
        key: "encapsulate",
        value: function encapsulate(t) {
          for (var _e123 = 0; _e123 < 3; _e123++) this.min[_e123] = Math.min(this.min[_e123], t.min[_e123]), this.max[_e123] = Math.max(this.max[_e123], t.max[_e123]);
        }
      }, {
        key: "encapsulatePoint",
        value: function encapsulatePoint(t) {
          for (var _e124 = 0; _e124 < 3; _e124++) this.min[_e124] = Math.min(this.min[_e124], t[_e124]), this.max[_e124] = Math.max(this.max[_e124], t[_e124]);
        }
      }, {
        key: "closestPoint",
        value: function closestPoint(t) {
          return [Math.max(Math.min(this.max[0], t[0]), this.min[0]), Math.max(Math.min(this.max[1], t[1]), this.min[1]), Math.max(Math.min(this.max[2], t[2]), this.min[2])];
        }
      }], [{
        key: "fromPoints",
        value: function fromPoints(e) {
          var r = [1 / 0, 1 / 0, 1 / 0],
            n = [-1 / 0, -1 / 0, -1 / 0];
          var _iterator93 = _createForOfIteratorHelper(e),
            _step93;
          try {
            for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
              var _i75 = _step93.value;
              t.$.min(r, r, _i75), t.$.max(n, n, _i75);
            }
          } catch (err) {
            _iterator93.e(err);
          } finally {
            _iterator93.f();
          }
          return new kh(r, n);
        }
      }, {
        key: "fromTileIdAndHeight",
        value: function fromTileIdAndHeight(t, e, r) {
          var n = 1 << t.canonical.z,
            i = t.canonical.x,
            s = t.canonical.y;
          return new kh([i / n, s / n, e], [(i + 1) / n, (s + 1) / n, r]);
        }
      }, {
        key: "applyTransform",
        value: function applyTransform(e, r) {
          var n = e.getCorners();
          for (var _e125 = 0; _e125 < n.length; ++_e125) t.$.transformMat4(n[_e125], n[_e125], r);
          return kh.fromPoints(n);
        }
      }, {
        key: "applyTransformFast",
        value: function applyTransformFast(t, e) {
          var r = [e[12], e[13], e[14]],
            n = [].concat(r);
          for (var _i76 = 0; _i76 < 3; _i76++) for (var _s53 = 0; _s53 < 3; _s53++) {
            var _a39 = e[4 * _s53 + _i76],
              _o24 = _a39 * t.min[_s53],
              _l19 = _a39 * t.max[_s53];
            r[_i76] += Math.min(_o24, _l19), n[_i76] += Math.max(_o24, _l19);
          }
          return new kh(r, n);
        }
      }, {
        key: "projectAabbCorners",
        value: function projectAabbCorners(e, r) {
          var n = e.getCorners();
          for (var _e126 = 0; _e126 < n.length; ++_e126) t.$.transformMat4(n[_e126], n[_e126], r);
          return n;
        }
      }]);
      return kh;
    }();
    So(kh, "Aabb");
    var Ph = Rl([{
        type: "Float32",
        name: "a_globe_pos",
        components: 3
      }, {
        type: "Float32",
        name: "a_uv",
        components: 2
      }]),
      zh = Ph.members,
      Eh = Rl([{
        name: "a_pos_3",
        components: 3,
        type: "Int16"
      }]);
    var Bh = Rl([{
      name: "a_pos",
      type: "Int16",
      components: 2
    }]);
    function Dh(t) {
      return t * oc / gc;
    }
    var Rh = [new kh([fc, fc, fc], [dc, dc, dc]), new kh([fc, fc, fc], [0, 0, dc]), new kh([0, fc, fc], [dc, 0, dc]), new kh([fc, 0, fc], [0, dc, dc]), new kh([0, 0, fc], [dc, dc, dc])];
    function Ch(e, r, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
      var s = t.$.scale([], e._camera.position, e.worldSize),
        a = [r, n, 1, 1];
      t.aB.transformMat4(a, a, e.pixelMatrixInverse), t.aB.scale(a, a, 1 / a[3]);
      var o = t.$.sub([], a, s),
        l = t.$.normalize([], o),
        u = e.globeMatrix,
        c = [u[12], u[13], u[14]],
        h = t.$.sub([], c, s),
        p = t.$.length(h),
        f = t.$.normalize([], h),
        d = e.worldSize / (2 * Math.PI),
        m = t.$.dot(f, l),
        y = Math.asin(d / p);
      if (y < Math.acos(m)) {
        if (!i) return null;
        var _e127 = [],
          _r112 = [];
        t.$.scale(_e127, l, p / m), t.$.normalize(_r112, t.$.sub(_r112, _e127, h)), t.$.normalize(l, t.$.add(l, h, t.$.scale(l, _r112, Math.tan(y) * p)));
      }
      var g = [];
      new _h(s, l).closestPointOnSphere(c, d, g);
      var x = t.$.normalize([], kr(u, 0)),
        b = t.$.normalize([], kr(u, 1)),
        v = t.$.normalize([], kr(u, 2)),
        _ = t.$.dot(x, g),
        w = t.$.dot(b, g),
        M = t.$.dot(v, g),
        A = Xe(Math.asin(-w / d));
      var S = Xe(Math.atan2(_, M));
      S = e.center.lng + function (t, e) {
        var r = (e - t + 180) % 360 - 180;
        return r < -180 ? r + 360 : r;
      }(e.center.lng, S);
      var I = Ec(S),
        T = We(Bc(A), 0, 1);
      return new Nc(I, T);
    }
    var Lh = /*#__PURE__*/_createClass(function Lh(e, r, n) {
      _classCallCheck(this, Lh);
      this.a = t.$.sub([], e, n), this.b = t.$.sub([], r, n), this.center = n;
      var i = t.$.normalize([], this.a),
        s = t.$.normalize([], this.b);
      this.angle = Math.acos(t.$.dot(i, s));
    });
    function Vh(t, e) {
      if (0 === t.angle) return null;
      var r;
      return r = 0 === t.a[e] ? 1 / t.angle * .5 * Math.PI : 1 / t.angle * Math.atan(t.b[e] / t.a[e] / Math.sin(t.angle) - 1 / Math.tan(t.angle)), r < 0 || r > 1 ? null : function (t, e, r, n) {
        var i = Math.sin(r);
        return t * (Math.sin((1 - n) * r) / i) + e * (Math.sin(n * r) / i);
      }(t.a[e], t.b[e], t.angle, We(r, 0, 1)) + t.center[e];
    }
    function Fh(t) {
      if (t.z <= 1) return Rh[t.z + 2 * t.y + t.x];
      var e = qh($h(t));
      return kh.fromPoints(e);
    }
    function Oh(e, r, n) {
      return t.$.scale(e, e, 1 - n), t.$.scaleAndAdd(e, e, r, n);
    }
    function Uh(e, r) {
      var n = Qh(r.zoom);
      if (0 === n) return Fh(e);
      var i = $h(e),
        s = qh(i),
        a = Ec(i.getWest()) * r.worldSize,
        o = Ec(i.getEast()) * r.worldSize,
        l = Bc(i.getNorth()) * r.worldSize,
        u = Bc(i.getSouth()) * r.worldSize,
        c = [a, l, 0],
        h = [o, l, 0],
        p = [a, u, 0],
        f = [o, u, 0],
        d = t.ae.invert([], r.globeMatrix);
      return t.$.transformMat4(c, c, d), t.$.transformMat4(h, h, d), t.$.transformMat4(p, p, d), t.$.transformMat4(f, f, d), s[0] = Oh(s[0], p, n), s[1] = Oh(s[1], f, n), s[2] = Oh(s[2], h, n), s[3] = Oh(s[3], c, n), kh.fromPoints(s);
    }
    function jh(e, r, n) {
      var _iterator94 = _createForOfIteratorHelper(e),
        _step94;
      try {
        for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
          var _i77 = _step94.value;
          t.$.transformMat4(_i77, _i77, r), t.$.scale(_i77, _i77, n);
        }
      } catch (err) {
        _iterator94.e(err);
      } finally {
        _iterator94.f();
      }
    }
    function Nh(e, r, n, i) {
      var s = r / e.worldSize,
        a = e.globeMatrix;
      if (n.z <= 1) {
        var _t99 = Fh(n).getCorners();
        return jh(_t99, a, s), kh.fromPoints(_t99);
      }
      var o = $h(n, i),
        l = qh(o, oc + Dh(e._tileCoverLift));
      jh(l, a, s);
      var u = Number.MAX_VALUE,
        c = [-u, -u, -u],
        h = [u, u, u];
      if (o.contains(e.center)) {
        var _iterator95 = _createForOfIteratorHelper(l),
          _step95;
        try {
          for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
            var _e128 = _step95.value;
            t.$.min(h, h, _e128), t.$.max(c, c, _e128);
          }
        } catch (err) {
          _iterator95.e(err);
        } finally {
          _iterator95.f();
        }
        c[2] = 0;
        var _r113 = e.point,
          _n69 = [_r113.x * s, _r113.y * s, 0];
        return t.$.min(h, h, _n69), t.$.max(c, c, _n69), new kh(h, c);
      }
      if (e._tileCoverLift > 0) {
        var _iterator96 = _createForOfIteratorHelper(l),
          _step96;
        try {
          for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
            var _e129 = _step96.value;
            t.$.min(h, h, _e129), t.$.max(c, c, _e129);
          }
        } catch (err) {
          _iterator96.e(err);
        } finally {
          _iterator96.f();
        }
        return new kh(h, c);
      }
      var p = [a[12] * s, a[13] * s, a[14] * s],
        f = o.getCenter(),
        d = We(e.center.lat, -Vc, Vc),
        m = We(f.lat, -Vc, Vc),
        y = Ec(e.center.lng),
        g = Bc(d);
      var x = y - Ec(f.lng);
      var b = g - Bc(m);
      x > .5 ? x -= 1 : x < -.5 && (x += 1);
      var v = 0;
      if (Math.abs(x) > Math.abs(b)) v = x >= 0 ? 1 : 3;else {
        v = b >= 0 ? 0 : 2;
        var _e130 = [a[4] * s, a[5] * s, a[6] * s],
          _r114 = -Math.sin(Ge(b >= 0 ? o.getSouth() : o.getNorth())) * oc;
        t.$.scaleAndAdd(p, p, _e130, _r114);
      }
      var _ = l[v],
        w = l[(v + 1) % 4],
        M = new Lh(_, w, p),
        A = [Vh(M, 0) || _[0], Vh(M, 1) || _[1], Vh(M, 2) || _[2]],
        S = Qh(e.zoom);
      if (S > 0) {
        var _i78 = function (_ref117, n, i, s, a) {
          var t = _ref117.x,
            e = _ref117.y,
            r = _ref117.z;
          var o = 1 / (1 << r);
          var l = t * o,
            u = l + o,
            c = e * o,
            h = c + o,
            p = 0;
          var f = (l + u) / 2 - s;
          return f > .5 ? p = -1 : f < -.5 && (p = 1), l = ((l + p) * n - (s *= n)) * i + s, u = ((u + p) * n - s) * i + s, c = (c * n - (a *= n)) * i + a, h = (h * n - a) * i + a, [[l, h, 0], [u, h, 0], [u, c, 0], [l, c, 0]];
        }(n, r, e._pixelsPerMercatorPixel, y, g);
        for (var _t100 = 0; _t100 < l.length; _t100++) Oh(l[_t100], _i78[_t100], S);
        var _s54 = t.$.add([], _i78[v], _i78[(v + 1) % 4]);
        t.$.scale(_s54, _s54, .5), Oh(A, _s54, S);
      }
      var _iterator97 = _createForOfIteratorHelper(l),
        _step97;
      try {
        for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
          var _e131 = _step97.value;
          t.$.min(h, h, _e131), t.$.max(c, c, _e131);
        }
      } catch (err) {
        _iterator97.e(err);
      } finally {
        _iterator97.f();
      }
      return h[2] = Math.min(_[2], w[2]), t.$.min(h, h, A), t.$.max(c, c, A), new kh(h, c);
    }
    function $h(_ref118) {
      var t = _ref118.x,
        e = _ref118.y,
        r = _ref118.z;
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = 1 / (1 << r),
        s = new bc(Rc(t * i), e === (1 << r) - 1 && n ? -90 : Cc((e + 1) * i)),
        a = new bc(Rc((t + 1) * i), 0 === e && n ? 90 : Cc(e * i));
      return new vc(s, a);
    }
    function qh(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : oc;
      var r = Ge(t.getNorth()),
        n = Ge(t.getSouth()),
        i = Math.cos(r),
        s = Math.cos(n),
        a = Math.sin(r),
        o = Math.sin(n),
        l = t.getWest(),
        u = t.getEast();
      return [mc(s, o, l, e), mc(s, o, u, e), mc(i, a, u, e), mc(i, a, l, e)];
    }
    function Gh(t, e, r, n) {
      var i = 1 << r.z,
        s = (t / ds + r.x) / i;
      return yc(Cc((e / ds + r.y) / i), Rc(s), n);
    }
    function Xh(_ref119) {
      var t = _ref119.min,
        e = _ref119.max;
      return cc / Math.max(e[0] - t[0], e[1] - t[1], e[2] - t[2]);
    }
    var Yh = new Float64Array(16);
    function Zh(e) {
      var r = Xh(e),
        n = t.ae.fromScaling(Yh, [r, r, r]);
      return t.ae.translate(n, n, t.$.negate([], e.min));
    }
    function Hh(e) {
      var r = t.ae.fromTranslation(Yh, e.min),
        n = 1 / Xh(e);
      return t.ae.scale(r, r, [n, n, n]);
    }
    function Kh(t) {
      var e = ds / (2 * Math.PI);
      return t / (2 * Math.PI) / e;
    }
    function Wh(t, e) {
      return ds / (512 * Math.pow(2, t)) * Xh(Fh(e));
    }
    function Jh(e, r, n, i, s) {
      var a = Kh(n),
        o = [e, r, -n / (2 * Math.PI)],
        l = t.ae.identity(new Float64Array(16));
      return t.ae.translate(l, l, o), t.ae.scale(l, l, [a, a, a]), t.ae.rotateX(l, l, Ge(-s)), t.ae.rotateY(l, l, Ge(-i)), l;
    }
    function Qh(t) {
      return Je(lc, uc, t);
    }
    function tp(e, r) {
      var n = yc(r.lat, r.lng),
        i = function (e) {
          var r = yc(e._center.lat, e._center.lng),
            n = t.$.fromValues(0, 1, 0);
          var i = t.$.cross([], n, r);
          var s = t.ae.fromRotation([], -e.angle, r);
          i = t.$.transformMat4(i, i, s), t.ae.fromRotation(s, -e._pitch, i);
          var a = t.$.normalize([], r);
          return t.$.scale(a, a, Dh(e.cameraToCenterDistance / e.pixelsPerMeter)), t.$.transformMat4(a, a, s), t.$.add([], r, a);
        }(e),
        s = t.$.subtract([], i, n);
      return t.$.angle(s, n);
    }
    function ep(t, e) {
      return tp(t, e) > Math.PI / 2 * 1.01;
    }
    var rp = Ge(85),
      np = Math.cos(rp),
      ip = Math.sin(rp),
      sp = t.ae.create(),
      ap = function ap(t) {
        var e = [];
        return "map" === t.paint.get("circle-pitch-alignment") && e.push("PITCH_WITH_MAP"), "map" === t.paint.get("circle-pitch-scale") && e.push("SCALE_WITH_MAP"), e;
      };
    function op(e, r, n, i, s, a, o, l, u) {
      if (a && e.queryGeometry.isAboveHorizon) return !1;
      a && (u *= e.pixelToTileUnitsFactor);
      var c = e.tileID.canonical,
        h = n.projection.upVectorScale(c, n.center.lat, n.worldSize).metersToTile;
      var _iterator98 = _createForOfIteratorHelper(r),
        _step98;
      try {
        for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
          var _p5 = _step98.value;
          var _iterator99 = _createForOfIteratorHelper(_p5),
            _step99;
          try {
            var _loop5 = function _loop5() {
                var r = _step99.value;
                var p = r.add(l),
                  f = s && n.elevation ? n.elevation.exaggeration() * s.getElevationAt(p.x, p.y, !0) : 0,
                  d = n.projection.projectTilePoint(p.x, p.y, c);
                if (f > 0) {
                  var _t101 = n.projection.upVector(c, p.x, p.y);
                  d.x += _t101[0] * h * f, d.y += _t101[1] * h * f, d.z += _t101[2] * h * f;
                }
                var m = a ? p : lp(d.x, d.y, d.z, i),
                  y = a ? e.tilespaceRays.map(function (t) {
                    return hp(t, f);
                  }) : e.queryGeometry.screenGeometry,
                  g = t.aB.transformMat4([], [d.x, d.y, d.z, 1], i);
                if (!o && a ? u *= g[3] / n.cameraToCenterDistance : o && !a && (u *= n.cameraToCenterDistance / g[3]), a) {
                  var _t102 = Cc((r.y / ds + c.y) / (1 << c.z));
                  u /= n.projection.pixelsPerMeter(_t102, 1) / Dc(1, _t102);
                }
                if (rh(y, m, u)) return {
                  v: !0
                };
              },
              _ret;
            for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
              _ret = _loop5();
              if (_ret) return _ret.v;
            }
          } catch (err) {
            _iterator99.e(err);
          } finally {
            _iterator99.f();
          }
        }
      } catch (err) {
        _iterator98.e(err);
      } finally {
        _iterator98.f();
      }
      return !1;
    }
    function lp(e, r, n, i) {
      var s = t.aB.transformMat4([], [e, r, n, 1], i);
      return new je(s[0] / s[3], s[1] / s[3]);
    }
    var up = t.$.fromValues(0, 0, 0),
      cp = t.$.fromValues(0, 0, 1);
    function hp(e, r) {
      var n = t.$.create();
      return up[2] = r, e.intersectsPlane(up, cp, n), new je(n[0], n[1]);
    }
    var pp = /*#__PURE__*/function (_th) {
      _inherits(pp, _th);
      var _super62 = _createSuper(pp);
      function pp() {
        _classCallCheck(this, pp);
        return _super62.apply(this, arguments);
      }
      return _createClass(pp);
    }(th);
    function fp(t, _ref120, n, i) {
      var e = _ref120.width,
        r = _ref120.height;
      if (i) {
        if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);else if (i.length !== e * r * n) throw new RangeError("mismatched image size");
      } else i = new Uint8Array(e * r * n);
      return t.width = e, t.height = r, t.data = i, t;
    }
    function dp(t, e, r) {
      var n = e.width,
        i = e.height;
      n === t.width && i === t.height || (mp(t, e, {
        x: 0,
        y: 0
      }, {
        x: 0,
        y: 0
      }, {
        width: Math.min(t.width, n),
        height: Math.min(t.height, i)
      }, r, null), t.width = n, t.height = i, t.data = e.data);
    }
    function mp(t, e, r, n, i, s, a, o) {
      if (0 === i.width || 0 === i.height) return e;
      if (i.width > t.width || i.height > t.height || r.x > t.width - i.width || r.y > t.height - i.height) throw new RangeError("out of range source coordinates for image copy");
      if (i.width > e.width || i.height > e.height || n.x > e.width - i.width || n.y > e.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
      var l = t.data,
        u = e.data,
        c = 4 === s && o;
      for (var _o25 = 0; _o25 < i.height; _o25++) {
        var _h7 = ((r.y + _o25) * t.width + r.x) * s,
          _p6 = ((n.y + _o25) * e.width + n.x) * s;
        if (c) for (var _t103 = 0; _t103 < i.width; _t103++) {
          var _e132 = _h7 + _t103 * s + 3,
            _r115 = _p6 + _t103 * s;
          u[_r115 + 0] = 255, u[_r115 + 1] = 255, u[_r115 + 2] = 255, u[_r115 + 3] = l[_e132];
        } else if (a) for (var _t104 = 0; _t104 < i.width; _t104++) {
          var _e133 = _h7 + _t104 * s,
            _r116 = _p6 + _t104 * s,
            _n70 = l[_e133 + 3],
            _i79 = new Gn(l[_e133 + 0] / 255 * _n70, l[_e133 + 1] / 255 * _n70, l[_e133 + 2] / 255 * _n70, _n70).toRenderColor(a).toArray();
          u[_r116 + 0] = _i79[0], u[_r116 + 1] = _i79[1], u[_r116 + 2] = _i79[2], u[_r116 + 3] = _i79[3];
        } else for (var _t105 = 0; _t105 < i.width * s; _t105++) u[_p6 + _t105] = l[_h7 + _t105];
      }
      return e;
    }
    So(pp, "HeatmapBucket", {
      omit: ["layers"]
    });
    var yp = /*#__PURE__*/function () {
      function yp(t, e) {
        _classCallCheck(this, yp);
        fp(this, t, 1, e);
      }
      _createClass(yp, [{
        key: "resize",
        value: function resize(t) {
          dp(this, new yp(t), 1);
        }
      }, {
        key: "clone",
        value: function clone() {
          return new yp({
            width: this.width,
            height: this.height
          }, new Uint8Array(this.data));
        }
      }], [{
        key: "copy",
        value: function copy(t, e, r, n, i) {
          mp(t, e, r, n, i, 1, null);
        }
      }]);
      return yp;
    }();
    var gp = /*#__PURE__*/function () {
      function gp(t, e) {
        _classCallCheck(this, gp);
        fp(this, t, 4, e);
      }
      _createClass(gp, [{
        key: "resize",
        value: function resize(t) {
          dp(this, new gp(t), 4);
        }
      }, {
        key: "replace",
        value: function replace(t, e) {
          e ? this.data.set(t) : this.data = t instanceof Uint8ClampedArray ? new Uint8Array(t.buffer) : t;
        }
      }, {
        key: "clone",
        value: function clone() {
          return new gp({
            width: this.width,
            height: this.height
          }, new Uint8Array(this.data));
        }
      }], [{
        key: "copy",
        value: function copy(t, e, r, n, i, s, a) {
          mp(t, e, r, n, i, 4, s, a);
        }
      }]);
      return gp;
    }();
    var xp = /*#__PURE__*/_createClass(function xp(t, e) {
      _classCallCheck(this, xp);
      this.width = t.width, this.height = t.height, this.data = e instanceof Uint8Array ? new Float32Array(e.buffer) : e;
    });
    var bp, vp, _p, wp;
    function Mp(t) {
      var e = {},
        r = t.resolution || 256,
        n = t.clips ? t.clips.length : 1,
        i = t.image || new gp({
          width: r,
          height: n
        }),
        s = function s(r, n, _s55) {
          e[t.evaluationKey] = _s55;
          var a = t.expression.evaluate(e);
          a && (i.data[r + n + 0] = Math.floor(255 * a.r / a.a), i.data[r + n + 1] = Math.floor(255 * a.g / a.a), i.data[r + n + 2] = Math.floor(255 * a.b / a.a), i.data[r + n + 3] = Math.floor(255 * a.a));
        };
      if (t.clips) for (var _e134 = 0, _i80 = 0; _e134 < n; ++_e134, _i80 += 4 * r) for (var _n71 = 0, _a40 = 0; _n71 < r; _n71++, _a40 += 4) {
        var _o26 = _n71 / (r - 1),
          _t$clips$_e = t.clips[_e134],
          _l20 = _t$clips$_e.start,
          _u16 = _t$clips$_e.end;
        s(_i80, _a40, _l20 * (1 - _o26) + _u16 * _o26);
      } else for (var _t106 = 0, _e135 = 0; _t106 < r; _t106++, _e135 += 4) s(0, _e135, _t106 / (r - 1));
      return i;
    }
    So(yp, "AlphaImage"), So(gp, "RGBAImage");
    var Ap = Rl([{
        name: "a_pos",
        components: 2,
        type: "Int16"
      }], 4),
      Sp = Ap.members;
    function Ip(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
      var n = e && e.length,
        i = n ? e[0] * r : t.length;
      var s = Tp(t, 0, i, r, !0);
      var a = [];
      if (!s || s.next === s.prev) return a;
      var o, l, u;
      if (n && (s = function (t, e, r, n) {
        var i = [];
        for (var _r117 = 0, _s56 = e.length; _r117 < _s56; _r117++) {
          var _a41 = Tp(t, e[_r117] * n, _r117 < _s56 - 1 ? e[_r117 + 1] * n : t.length, n, !1);
          _a41 === _a41.next && (_a41.steiner = !0), i.push(Fp(_a41));
        }
        i.sort(Rp);
        for (var _t107 = 0; _t107 < i.length; _t107++) r = Cp(i[_t107], r);
        return r;
      }(t, e, s, r)), t.length > 80 * r) {
        o = 1 / 0, l = 1 / 0;
        var _e136 = -1 / 0,
          _n72 = -1 / 0;
        for (var _s57 = r; _s57 < i; _s57 += r) {
          var _r118 = t[_s57],
            _i81 = t[_s57 + 1];
          _r118 < o && (o = _r118), _i81 < l && (l = _i81), _r118 > _e136 && (_e136 = _r118), _i81 > _n72 && (_n72 = _i81);
        }
        u = Math.max(_e136 - o, _n72 - l), u = 0 !== u ? 32767 / u : 0;
      }
      return Pp(s, a, r, o, l, u, 0), a;
    }
    function Tp(t, e, r, n, i) {
      var s;
      if (i === function (t, e, r, n) {
        var i = 0;
        for (var _s58 = e, _a42 = r - n; _s58 < r; _s58 += n) i += (t[_a42] - t[_s58]) * (t[_s58 + 1] + t[_a42 + 1]), _a42 = _s58;
        return i;
      }(t, e, r, n) > 0) for (var _i82 = e; _i82 < r; _i82 += n) s = Zp(_i82 / n | 0, t[_i82], t[_i82 + 1], s);else for (var _i83 = r - n; _i83 >= e; _i83 -= n) s = Zp(_i83 / n | 0, t[_i83], t[_i83 + 1], s);
      return s && Np(s, s.next) && (Hp(s), s = s.next), s;
    }
    function kp(t, e) {
      if (!t) return t;
      e || (e = t);
      var r,
        n = t;
      do {
        if (r = !1, n.steiner || !Np(n, n.next) && 0 !== jp(n.prev, n, n.next)) n = n.next;else {
          if (Hp(n), n = e = n.prev, n === n.next) break;
          r = !0;
        }
      } while (r || n !== e);
      return e;
    }
    function Pp(t, e, r, n, i, s, a) {
      if (!t) return;
      !a && s && function (t, e, r, n) {
        var i = t;
        do {
          0 === i.z && (i.z = Vp(i.x, i.y, e, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
        } while (i !== t);
        i.prevZ.nextZ = null, i.prevZ = null, function (t) {
          var e,
            r = 1;
          do {
            var _n73 = void 0,
              _i84 = t;
            t = null;
            var _s59 = null;
            for (e = 0; _i84;) {
              e++;
              var _a43 = _i84,
                _o27 = 0;
              for (var _t108 = 0; _t108 < r && (_o27++, _a43 = _a43.nextZ, _a43); _t108++);
              var _l21 = r;
              for (; _o27 > 0 || _l21 > 0 && _a43;) 0 !== _o27 && (0 === _l21 || !_a43 || _i84.z <= _a43.z) ? (_n73 = _i84, _i84 = _i84.nextZ, _o27--) : (_n73 = _a43, _a43 = _a43.nextZ, _l21--), _s59 ? _s59.nextZ = _n73 : t = _n73, _n73.prevZ = _s59, _s59 = _n73;
              _i84 = _a43;
            }
            _s59.nextZ = null, r *= 2;
          } while (e > 1);
        }(i);
      }(t, n, i, s);
      var o = t;
      for (; t.prev !== t.next;) {
        var _l22 = t.prev,
          _u17 = t.next;
        if (s ? Ep(t, n, i, s) : zp(t)) e.push(_l22.i, t.i, _u17.i), Hp(t), t = _u17.next, o = _u17.next;else if ((t = _u17) === o) {
          a ? 1 === a ? Pp(t = Bp(kp(t), e), e, r, n, i, s, 2) : 2 === a && Dp(t, e, r, n, i, s) : Pp(kp(t), e, r, n, i, s, 1);
          break;
        }
      }
    }
    function zp(t) {
      var e = t.prev,
        r = t,
        n = t.next;
      if (jp(e, r, n) >= 0) return !1;
      var i = e.x,
        s = r.x,
        a = n.x,
        o = e.y,
        l = r.y,
        u = n.y,
        c = i < s ? i < a ? i : a : s < a ? s : a,
        h = o < l ? o < u ? o : u : l < u ? l : u,
        p = i > s ? i > a ? i : a : s > a ? s : a,
        f = o > l ? o > u ? o : u : l > u ? l : u;
      var d = n.next;
      for (; d !== e;) {
        if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && Op(i, o, s, l, a, u, d.x, d.y) && jp(d.prev, d, d.next) >= 0) return !1;
        d = d.next;
      }
      return !0;
    }
    function Ep(t, e, r, n) {
      var i = t.prev,
        s = t,
        a = t.next;
      if (jp(i, s, a) >= 0) return !1;
      var o = i.x,
        l = s.x,
        u = a.x,
        c = i.y,
        h = s.y,
        p = a.y,
        f = o < l ? o < u ? o : u : l < u ? l : u,
        d = c < h ? c < p ? c : p : h < p ? h : p,
        m = o > l ? o > u ? o : u : l > u ? l : u,
        y = c > h ? c > p ? c : p : h > p ? h : p,
        g = Vp(f, d, e, r, n),
        x = Vp(m, y, e, r, n);
      var b = t.prevZ,
        v = t.nextZ;
      for (; b && b.z >= g && v && v.z <= x;) {
        if (b.x >= f && b.x <= m && b.y >= d && b.y <= y && b !== i && b !== a && Op(o, c, l, h, u, p, b.x, b.y) && jp(b.prev, b, b.next) >= 0) return !1;
        if (b = b.prevZ, v.x >= f && v.x <= m && v.y >= d && v.y <= y && v !== i && v !== a && Op(o, c, l, h, u, p, v.x, v.y) && jp(v.prev, v, v.next) >= 0) return !1;
        v = v.nextZ;
      }
      for (; b && b.z >= g;) {
        if (b.x >= f && b.x <= m && b.y >= d && b.y <= y && b !== i && b !== a && Op(o, c, l, h, u, p, b.x, b.y) && jp(b.prev, b, b.next) >= 0) return !1;
        b = b.prevZ;
      }
      for (; v && v.z <= x;) {
        if (v.x >= f && v.x <= m && v.y >= d && v.y <= y && v !== i && v !== a && Op(o, c, l, h, u, p, v.x, v.y) && jp(v.prev, v, v.next) >= 0) return !1;
        v = v.nextZ;
      }
      return !0;
    }
    function Bp(t, e) {
      var r = t;
      do {
        var _n74 = r.prev,
          _i85 = r.next.next;
        !Np(_n74, _i85) && $p(_n74, r, r.next, _i85) && Xp(_n74, _i85) && Xp(_i85, _n74) && (e.push(_n74.i, r.i, _i85.i), Hp(r), Hp(r.next), r = t = _i85), r = r.next;
      } while (r !== t);
      return kp(r);
    }
    function Dp(t, e, r, n, i, s) {
      var a = t;
      do {
        var _t109 = a.next.next;
        for (; _t109 !== a.prev;) {
          if (a.i !== _t109.i && Up(a, _t109)) {
            var _o28 = Yp(a, _t109);
            return a = kp(a, a.next), _o28 = kp(_o28, _o28.next), Pp(a, e, r, n, i, s, 0), void Pp(_o28, e, r, n, i, s, 0);
          }
          _t109 = _t109.next;
        }
        a = a.next;
      } while (a !== t);
    }
    function Rp(t, e) {
      return t.x - e.x;
    }
    function Cp(t, e) {
      var r = function (t, e) {
        var r = e;
        var n = t.x,
          i = t.y;
        var s,
          a = -1 / 0;
        do {
          if (i <= r.y && i >= r.next.y && r.next.y !== r.y) {
            var _t110 = r.x + (i - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
            if (_t110 <= n && _t110 > a && (a = _t110, s = r.x < r.next.x ? r : r.next, _t110 === n)) return s;
          }
          r = r.next;
        } while (r !== e);
        if (!s) return null;
        var o = s,
          l = s.x,
          u = s.y;
        var c = 1 / 0;
        r = s;
        do {
          if (n >= r.x && r.x >= l && n !== r.x && Op(i < u ? n : a, i, l, u, i < u ? a : n, i, r.x, r.y)) {
            var _e137 = Math.abs(i - r.y) / (n - r.x);
            Xp(r, t) && (_e137 < c || _e137 === c && (r.x > s.x || r.x === s.x && Lp(s, r))) && (s = r, c = _e137);
          }
          r = r.next;
        } while (r !== o);
        return s;
      }(t, e);
      if (!r) return e;
      var n = Yp(r, t);
      return kp(n, n.next), kp(r, r.next);
    }
    function Lp(t, e) {
      return jp(t.prev, t, e.prev) < 0 && jp(e.next, t, t.next) < 0;
    }
    function Vp(t, e, r, n, i) {
      return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - r) * i | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
    }
    function Fp(t) {
      var e = t,
        r = t;
      do {
        (e.x < r.x || e.x === r.x && e.y < r.y) && (r = e), e = e.next;
      } while (e !== t);
      return r;
    }
    function Op(t, e, r, n, i, s, a, o) {
      return (i - a) * (e - o) >= (t - a) * (s - o) && (t - a) * (n - o) >= (r - a) * (e - o) && (r - a) * (s - o) >= (i - a) * (n - o);
    }
    function Up(t, e) {
      return t.next.i !== e.i && t.prev.i !== e.i && !function (t, e) {
        var r = t;
        do {
          if (r.i !== t.i && r.next.i !== t.i && r.i !== e.i && r.next.i !== e.i && $p(r, r.next, t, e)) return !0;
          r = r.next;
        } while (r !== t);
        return !1;
      }(t, e) && (Xp(t, e) && Xp(e, t) && function (t, e) {
        var r = t,
          n = !1;
        var i = (t.x + e.x) / 2,
          s = (t.y + e.y) / 2;
        do {
          r.y > s != r.next.y > s && r.next.y !== r.y && i < (r.next.x - r.x) * (s - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
        } while (r !== t);
        return n;
      }(t, e) && (jp(t.prev, t, e.prev) || jp(t, e.prev, e)) || Np(t, e) && jp(t.prev, t, t.next) > 0 && jp(e.prev, e, e.next) > 0);
    }
    function jp(t, e, r) {
      return (e.y - t.y) * (r.x - e.x) - (e.x - t.x) * (r.y - e.y);
    }
    function Np(t, e) {
      return t.x === e.x && t.y === e.y;
    }
    function $p(t, e, r, n) {
      var i = Gp(jp(t, e, r)),
        s = Gp(jp(t, e, n)),
        a = Gp(jp(r, n, t)),
        o = Gp(jp(r, n, e));
      return i !== s && a !== o || !(0 !== i || !qp(t, r, e)) || !(0 !== s || !qp(t, n, e)) || !(0 !== a || !qp(r, t, n)) || !(0 !== o || !qp(r, e, n));
    }
    function qp(t, e, r) {
      return e.x <= Math.max(t.x, r.x) && e.x >= Math.min(t.x, r.x) && e.y <= Math.max(t.y, r.y) && e.y >= Math.min(t.y, r.y);
    }
    function Gp(t) {
      return t > 0 ? 1 : t < 0 ? -1 : 0;
    }
    function Xp(t, e) {
      return jp(t.prev, t, t.next) < 0 ? jp(t, e, t.next) >= 0 && jp(t, t.prev, e) >= 0 : jp(t, e, t.prev) < 0 || jp(t, t.next, e) < 0;
    }
    function Yp(t, e) {
      var r = Kp(t.i, t.x, t.y),
        n = Kp(e.i, e.x, e.y),
        i = t.next,
        s = e.prev;
      return t.next = e, e.prev = t, r.next = i, i.prev = r, n.next = r, r.prev = n, s.next = n, n.prev = s, n;
    }
    function Zp(t, e, r, n) {
      var i = Kp(t, e, r);
      return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
    }
    function Hp(t) {
      t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
    }
    function Kp(t, e, r) {
      return {
        i: t,
        x: e,
        y: r,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: !1
      };
    }
    function Wp(t, e) {
      var r = t.length;
      if (r <= 1) return [t];
      var n = [];
      var i, s;
      for (var _e138 = 0; _e138 < r; _e138++) {
        var _r119 = yr(t[_e138]);
        0 !== _r119 && (t[_e138].area = Math.abs(_r119), void 0 === s && (s = _r119 < 0), s === _r119 < 0 ? (i && n.push(i), i = [t[_e138]]) : i.push(t[_e138]));
      }
      if (i && n.push(i), e > 1) for (var _t111 = 0; _t111 < n.length; _t111++) n[_t111].length <= e || (Vi(n[_t111], e, 1, n[_t111].length - 1, Jp), n[_t111] = n[_t111].slice(0, e));
      return n;
    }
    function Jp(t, e) {
      return e.area - t.area;
    }
    function Qp(t, e, r) {
      var n = r.patternDependencies;
      var i = !1;
      var _iterator100 = _createForOfIteratorHelper(e),
        _step100;
      try {
        for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
          var _r120 = _step100.value;
          var _e139 = _r120.paint.get("".concat(t, "-pattern"));
          _e139.isConstant() || (i = !0);
          var _s60 = _e139.constantOr(null);
          _s60 && (i = !0, n[_s60] = !0);
        }
      } catch (err) {
        _iterator100.e(err);
      } finally {
        _iterator100.f();
      }
      return i;
    }
    function tf(t, e, r, n, i) {
      var s = i.patternDependencies;
      var _iterator101 = _createForOfIteratorHelper(e),
        _step101;
      try {
        for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
          var _a44 = _step101.value;
          var _e140 = _a44.paint.get("".concat(t, "-pattern")).value;
          if ("constant" !== _e140.kind) {
            var _t112 = _e140.evaluate({
              zoom: n
            }, r, {}, i.availableImages);
            _t112 = _t112 && _t112.name ? _t112.name : _t112, s[_t112] = !0, r.patterns[_a44.id] = _t112;
          }
        }
      } catch (err) {
        _iterator101.e(err);
      } finally {
        _iterator101.f();
      }
      return r;
    }
    var ef = /*#__PURE__*/function () {
      function ef(t) {
        _classCallCheck(this, ef);
        this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function (t) {
          return t.fqid;
        }), this.index = t.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new Ll(), this.indexArray = new tu(), this.indexArray2 = new Hl(), this.programConfigurations = new ec(t.layers, {
          zoom: t.zoom,
          lut: t.lut
        }), this.segments = new ku(), this.segments2 = new ku(), this.stateDependentLayerIds = this.layers.filter(function (t) {
          return t.isStateDependent();
        }).map(function (t) {
          return t.id;
        }), this.projection = t.projection;
      }
      _createClass(ef, [{
        key: "updateFootprints",
        value: function updateFootprints(t, e) {}
      }, {
        key: "populate",
        value: function populate(t, e, r, n) {
          this.hasPattern = Qp("fill", this.layers, e);
          var i = this.layers[0].layout.get("fill-sort-key"),
            s = [];
          var _iterator102 = _createForOfIteratorHelper(t),
            _step102;
          try {
            for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
              var _step102$value = _step102.value,
                _a46 = _step102$value.feature,
                _o29 = _step102$value.id,
                _l23 = _step102$value.index,
                _u18 = _step102$value.sourceLayerIndex;
              var _t114 = this.layers[0]._featureFilter.needGeometry,
                _c13 = Wc(_a46, _t114);
              if (!this.layers[0]._featureFilter.filter(new Wo(this.zoom), _c13, r)) continue;
              var _h8 = i ? i.evaluate(_c13, {}, r, e.availableImages) : void 0,
                _p7 = {
                  id: _o29,
                  properties: _a46.properties,
                  type: _a46.type,
                  sourceLayerIndex: _u18,
                  index: _l23,
                  geometry: _t114 ? _c13.geometry : Kc(_a46, r, n),
                  patterns: {},
                  sortKey: _h8
                };
              s.push(_p7);
            }
          } catch (err) {
            _iterator102.e(err);
          } finally {
            _iterator102.f();
          }
          i && s.sort(function (t, e) {
            return t.sortKey - e.sortKey;
          });
          for (var _i86 = 0, _s61 = s; _i86 < _s61.length; _i86++) {
            var _n75 = _s61[_i86];
            var _i87 = _n75.geometry,
              _s62 = _n75.index,
              _a45 = _n75.sourceLayerIndex;
            if (this.hasPattern) {
              var _t113 = tf("fill", this.layers, _n75, this.zoom, e);
              this.patternFeatures.push(_t113);
            } else this.addFeature(_n75, _i87, _s62, r, {}, e.availableImages, e.brightness);
            e.featureIndex.insert(t[_s62].feature, _i87, _s62, _a45, this.index);
          }
        }
      }, {
        key: "update",
        value: function update(t, e, r, n, i) {
          var s = 0 !== Object.keys(t).length;
          s && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(t, e, s ? this.stateDependentLayers : this.layers, r, n, i);
        }
      }, {
        key: "addFeatures",
        value: function addFeatures(t, e, r, n, i, s) {
          var _iterator103 = _createForOfIteratorHelper(this.patternFeatures),
            _step103;
          try {
            for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
              var _t115 = _step103.value;
              this.addFeature(_t115, _t115.geometry, _t115.index, e, r, n, s);
            }
          } catch (err) {
            _iterator103.e(err);
          } finally {
            _iterator103.f();
          }
        }
      }, {
        key: "isEmpty",
        value: function isEmpty() {
          return 0 === this.layoutVertexArray.length;
        }
      }, {
        key: "uploadPending",
        value: function uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
      }, {
        key: "upload",
        value: function upload(t) {
          this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Sp), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.indexBuffer2 = t.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t), this.uploaded = !0;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
        }
      }, {
        key: "addFeature",
        value: function addFeature(t, e, r, n, i) {
          var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
          var a = arguments.length > 6 ? arguments[6] : undefined;
          var _iterator104 = _createForOfIteratorHelper(Wp(e, 500)),
            _step104;
          try {
            for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
              var _t116 = _step104.value;
              var _e141 = 0;
              var _iterator105 = _createForOfIteratorHelper(_t116),
                _step105;
              try {
                for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
                  var _r122 = _step105.value;
                  _e141 += _r122.length;
                }
              } catch (err) {
                _iterator105.e(err);
              } finally {
                _iterator105.f();
              }
              var _r121 = this.segments.prepareSegment(_e141, this.layoutVertexArray, this.indexArray),
                _n76 = _r121.vertexLength,
                _i88 = [],
                _s63 = [];
              var _iterator106 = _createForOfIteratorHelper(_t116),
                _step106;
              try {
                for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
                  var _e142 = _step106.value;
                  if (0 === _e142.length) continue;
                  _e142 !== _t116[0] && _s63.push(_i88.length / 2);
                  var _r123 = this.segments2.prepareSegment(_e142.length, this.layoutVertexArray, this.indexArray2),
                    _n77 = _r123.vertexLength;
                  this.layoutVertexArray.emplaceBack(_e142[0].x, _e142[0].y), this.indexArray2.emplaceBack(_n77 + _e142.length - 1, _n77), _i88.push(_e142[0].x), _i88.push(_e142[0].y);
                  for (var _t118 = 1; _t118 < _e142.length; _t118++) this.layoutVertexArray.emplaceBack(_e142[_t118].x, _e142[_t118].y), this.indexArray2.emplaceBack(_n77 + _t118 - 1, _n77 + _t118), _i88.push(_e142[_t118].x), _i88.push(_e142[_t118].y);
                  _r123.vertexLength += _e142.length, _r123.primitiveLength += _e142.length;
                }
              } catch (err) {
                _iterator106.e(err);
              } finally {
                _iterator106.f();
              }
              var _a47 = Ip(_i88, _s63);
              for (var _t117 = 0; _t117 < _a47.length; _t117 += 3) this.indexArray.emplaceBack(_n76 + _a47[_t117], _n76 + _a47[_t117 + 1], _n76 + _a47[_t117 + 2]);
              _r121.vertexLength += _e141, _r121.primitiveLength += _a47.length / 3;
            }
          } catch (err) {
            _iterator104.e(err);
          } finally {
            _iterator104.f();
          }
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, s, n, a);
        }
      }]);
      return ef;
    }();
    var rf, nf, sf, af;
    So(ef, "FillBucket", {
      omit: ["layers", "patternFeatures"]
    });
    var of = /*#__PURE__*/function () {
      function of(t, e, r, n) {
        _classCallCheck(this, of);
        if (this.triangleCount = e.length / 3, this.min = new je(0, 0), this.max = new je(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], 0 === this.triangleCount || 0 === t.length) return;
        var _ref121 = [t[0].clone(), t[0].clone()],
          i = _ref121[0],
          s = _ref121[1];
        for (var _e143 = 1; _e143 < t.length; ++_e143) {
          var _r124 = t[_e143];
          i.x = Math.min(i.x, _r124.x), i.y = Math.min(i.y, _r124.y), s.x = Math.max(s.x, _r124.x), s.y = Math.max(s.y, _r124.y);
        }
        if (n) {
          var _t119 = Math.ceil(Math.max(s.x - i.x, s.y - i.y) / n);
          r = Math.max(r, _t119);
        }
        if (0 === r) return;
        this.min = i, this.max = s;
        var a = this.max.sub(this.min);
        a.x = Math.max(a.x, 1), a.y = Math.max(a.y, 1);
        var o = Math.max(a.x, a.y) / r;
        this.cellsX = Math.max(1, Math.ceil(a.x / o)), this.cellsY = Math.max(1, Math.ceil(a.y / o)), this.xScale = 1 / o, this.yScale = 1 / o;
        var l = [];
        for (var _r125 = 0; _r125 < this.triangleCount; _r125++) {
          var _n78 = t[e[3 * _r125 + 0]].sub(this.min),
            _i89 = t[e[3 * _r125 + 1]].sub(this.min),
            _s64 = t[e[3 * _r125 + 2]].sub(this.min),
            _a48 = lf(Math.floor(Math.min(_n78.x, _i89.x, _s64.x)), this.xScale, this.cellsX),
            _u19 = lf(Math.floor(Math.max(_n78.x, _i89.x, _s64.x)), this.xScale, this.cellsX),
            _c14 = lf(Math.floor(Math.min(_n78.y, _i89.y, _s64.y)), this.yScale, this.cellsY),
            _h9 = lf(Math.floor(Math.max(_n78.y, _i89.y, _s64.y)), this.yScale, this.cellsY),
            _p8 = new je(0, 0),
            _f6 = new je(0, 0),
            _d3 = new je(0, 0),
            _m3 = new je(0, 0);
          for (var _t120 = _c14; _t120 <= _h9; ++_t120) {
            _p8.y = _f6.y = _t120 * o, _d3.y = _m3.y = (_t120 + 1) * o;
            for (var _e144 = _a48; _e144 <= _u19; ++_e144) _p8.x = _d3.x = _e144 * o, _f6.x = _m3.x = (_e144 + 1) * o, (dh(_n78, _i89, _s64, _p8, _f6, _m3) || dh(_n78, _i89, _s64, _p8, _m3, _d3)) && l.push({
              cellIdx: _t120 * this.cellsX + _e144,
              triIdx: _r125
            });
          }
        }
        if (0 === l.length) return;
        l.sort(function (t, e) {
          return t.cellIdx - e.cellIdx || t.triIdx - e.triIdx;
        });
        var u = 0;
        for (; u < l.length;) {
          var _t121 = l[u].cellIdx,
            _e145 = {
              start: this.payload.length,
              len: 0
            };
          for (; u < l.length && l[u].cellIdx === _t121;) ++_e145.len, this.payload.push(l[u++].triIdx);
          this.cells[_t121] = _e145;
        }
      }
      _createClass(of, [{
        key: "_lazyInitLookup",
        value: function _lazyInitLookup() {
          this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8))), this.lookup.fill(0);
        }
      }, {
        key: "queryPoint",
        value: function queryPoint(t, e) {
          if (0 === this.triangleCount || 0 === this.cells.length) return;
          if (t.x > this.max.x || this.min.x > t.x || t.y > this.max.y || this.min.y > t.y) return;
          var r = lf(t.x - this.min.x, this.xScale, this.cellsX),
            n = lf(t.y - this.min.y, this.yScale, this.cellsY),
            i = this.cells[n * this.cellsX + r];
          if (i) {
            this._lazyInitLookup();
            for (var _t122 = 0; _t122 < i.len; _t122++) {
              var _r126 = this.payload[i.start + _t122],
                _n79 = Math.floor(_r126 / 8),
                _s65 = 1 << _r126 % 8;
              if (!(this.lookup[_n79] & _s65) && (this.lookup[_n79] |= _s65, e.push(_r126), e.length === this.triangleCount)) return;
            }
          }
        }
      }, {
        key: "query",
        value: function query(t, e, r) {
          if (0 === this.triangleCount || 0 === this.cells.length) return;
          if (t.x > this.max.x || this.min.x > e.x) return;
          if (t.y > this.max.y || this.min.y > e.y) return;
          this._lazyInitLookup();
          var n = lf(t.x - this.min.x, this.xScale, this.cellsX),
            i = lf(e.x - this.min.x, this.xScale, this.cellsX),
            s = lf(t.y - this.min.y, this.yScale, this.cellsY),
            a = lf(e.y - this.min.y, this.yScale, this.cellsY);
          for (var _t123 = s; _t123 <= a; _t123++) for (var _e146 = n; _e146 <= i; _e146++) {
            var _n80 = this.cells[_t123 * this.cellsX + _e146];
            if (_n80) for (var _t124 = 0; _t124 < _n80.len; _t124++) {
              var _e147 = this.payload[_n80.start + _t124],
                _i90 = Math.floor(_e147 / 8),
                _s66 = 1 << _e147 % 8;
              if (!(this.lookup[_i90] & _s66) && (this.lookup[_i90] |= _s66, r.push(_e147), r.length === this.triangleCount)) return;
            }
          }
        }
      }]);
      return of;
    }();
    function lf(t, e, r) {
      return Math.max(0, Math.min(r - 1, Math.floor(t * e)));
    }
    So(of, "TriangleGridIndex");
    var uf = /*#__PURE__*/function () {
      function uf(t) {
        _classCallCheck(this, uf);
        this.zoom = t.zoom, this.layers = t.layers, this.layerIds = this.layers.map(function (t) {
          return t.fqid;
        }), this.index = t.index, this.hasPattern = !1, this.stateDependentLayerIds = this.layers.filter(function (t) {
          return t.isStateDependent();
        }).map(function (t) {
          return t.id;
        }), this.footprints = [];
      }
      _createClass(uf, [{
        key: "updateFootprints",
        value: function updateFootprints(t, e) {
          var _iterator107 = _createForOfIteratorHelper(this.footprints),
            _step107;
          try {
            for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
              var _r127 = _step107.value;
              e.push({
                footprint: _r127,
                id: t
              });
            }
          } catch (err) {
            _iterator107.e(err);
          } finally {
            _iterator107.f();
          }
        }
      }, {
        key: "populate",
        value: function populate(t, e, r, n) {
          var i = [];
          var _iterator108 = _createForOfIteratorHelper(t),
            _step108;
          try {
            for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
              var _step108$value = _step108.value,
                _e148 = _step108$value.feature,
                _s68 = _step108$value.id,
                _a50 = _step108$value.index,
                _o30 = _step108$value.sourceLayerIndex;
              var _t125 = this.layers[0]._featureFilter.needGeometry,
                _l24 = Wc(_e148, _t125);
              if (!this.layers[0]._featureFilter.filter(new Wo(this.zoom), _l24, r)) continue;
              var _u20 = {
                id: _s68,
                properties: _e148.properties,
                type: _e148.type,
                sourceLayerIndex: _o30,
                index: _a50,
                geometry: _t125 ? _l24.geometry : Kc(_e148, r, n),
                patterns: {}
              };
              i.push(_u20);
            }
          } catch (err) {
            _iterator108.e(err);
          } finally {
            _iterator108.f();
          }
          for (var _i92 = 0, _i91 = i; _i92 < _i91.length; _i92++) {
            var _n81 = _i91[_i92];
            var _i93 = _n81.geometry,
              _s67 = _n81.index,
              _a49 = _n81.sourceLayerIndex;
            this.addFeature(_n81, _i93, _s67, r, {}, e.availableImages, e.brightness), e.featureIndex.insert(t[_s67].feature, _i93, _s67, _a49, this.index);
          }
        }
      }, {
        key: "isEmpty",
        value: function isEmpty() {
          return 0 === this.footprints.length;
        }
      }, {
        key: "uploadPending",
        value: function uploadPending() {
          return !1;
        }
      }, {
        key: "upload",
        value: function upload(t) {}
      }, {
        key: "update",
        value: function update(t, e, r, n, i) {}
      }, {
        key: "destroy",
        value: function destroy() {}
      }, {
        key: "addFeature",
        value: function addFeature(t, e, r, n, i) {
          var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
          var a = arguments.length > 6 ? arguments[6] : undefined;
          var _iterator109 = _createForOfIteratorHelper(Wp(e, 2)),
            _step109;
          try {
            for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
              var _t126 = _step109.value;
              var _e149 = [],
                _r128 = [],
                _n82 = [],
                _i94 = new je(1 / 0, 1 / 0),
                _s69 = new je(-1 / 0, -1 / 0);
              var _iterator110 = _createForOfIteratorHelper(_t126),
                _step110;
              try {
                for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
                  var _a52 = _step110.value;
                  if (0 !== _a52.length) {
                    _a52 !== _t126[0] && _n82.push(_r128.length / 2);
                    for (var _t127 = 0; _t127 < _a52.length; _t127++) _r128.push(_a52[_t127].x), _r128.push(_a52[_t127].y), _e149.push(_a52[_t127]), _i94.x = Math.min(_i94.x, _a52[_t127].x), _i94.y = Math.min(_i94.y, _a52[_t127].y), _s69.x = Math.max(_s69.x, _a52[_t127].x), _s69.y = Math.max(_s69.y, _a52[_t127].y);
                  }
                }
              } catch (err) {
                _iterator110.e(err);
              } finally {
                _iterator110.f();
              }
              var _a51 = Ip(_r128, _n82),
                _o31 = new of(_e149, _a51, 8, 256);
              this.footprints.push({
                vertices: _e149,
                indices: _a51,
                grid: _o31,
                min: _i94,
                max: _s69
              });
            }
          } catch (err) {
            _iterator109.e(err);
          } finally {
            _iterator109.f();
          }
        }
      }]);
      return uf;
    }();
    So(uf, "ClipBucket", {
      omit: ["layers"]
    });
    var cf = Rl([{
        name: "a_pos_normal_ed",
        components: 4,
        type: "Int16"
      }]),
      hf = Rl([{
        name: "a_pos_end",
        components: 4,
        type: "Int16"
      }, {
        name: "a_angular_offset_factor",
        components: 1,
        type: "Int16"
      }]),
      pf = Rl([{
        name: "a_centroid_pos",
        components: 2,
        type: "Uint16"
      }]),
      ff = Rl([{
        name: "a_join_normal_inside_polygon",
        components: 4,
        type: "Int16"
      }]),
      df = Rl([{
        name: "a_hidden_by_landmark",
        components: 1,
        type: "Uint8"
      }]),
      mf = Rl([{
        name: "a_pos_3",
        components: 3,
        type: "Int16"
      }, {
        name: "a_pos_normal_3",
        components: 3,
        type: "Int16"
      }]),
      yf = cf.members;
    var gf = {},
      xf = Oe,
      bf = vf;
    function vf(t, e, r, n, i) {
      this.properties = {}, this.extent = r, this.type = 0, this._pbf = t, this._geometry = -1, this._keys = n, this._values = i, t.readFields(_f, this, e);
    }
    function _f(t, e, r) {
      1 == t ? e.id = r.readVarint() : 2 == t ? function (t, e) {
        for (var r = t.readVarint() + t.pos; t.pos < r;) {
          var n = e._keys[t.readVarint()],
            i = e._values[t.readVarint()];
          e.properties[n] = i;
        }
      }(r, e) : 3 == t ? e.type = r.readVarint() : 4 == t && (e._geometry = r.pos);
    }
    function wf(t) {
      for (var e, r, n = 0, i = 0, s = t.length, a = s - 1; i < s; a = i++) n += ((r = t[a]).x - (e = t[i]).x) * (e.y + r.y);
      return n;
    }
    vf.types = ["Unknown", "Point", "LineString", "Polygon"], vf.prototype.loadGeometry = function () {
      var t = this._pbf;
      t.pos = this._geometry;
      for (var e, r = t.readVarint() + t.pos, n = 1, i = 0, s = 0, a = 0, o = []; t.pos < r;) {
        if (i <= 0) {
          var l = t.readVarint();
          n = 7 & l, i = l >> 3;
        }
        if (i--, 1 === n || 2 === n) s += t.readSVarint(), a += t.readSVarint(), 1 === n && (e && o.push(e), e = []), e.push(new xf(s, a));else {
          if (7 !== n) throw new Error("unknown command " + n);
          e && e.push(e[0].clone());
        }
      }
      return e && o.push(e), o;
    }, vf.prototype.bbox = function () {
      var t = this._pbf;
      t.pos = this._geometry;
      for (var e = t.readVarint() + t.pos, r = 1, n = 0, i = 0, s = 0, a = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0; t.pos < e;) {
        if (n <= 0) {
          var c = t.readVarint();
          r = 7 & c, n = c >> 3;
        }
        if (n--, 1 === r || 2 === r) (i += t.readSVarint()) < a && (a = i), i > o && (o = i), (s += t.readSVarint()) < l && (l = s), s > u && (u = s);else if (7 !== r) throw new Error("unknown command " + r);
      }
      return [a, l, o, u];
    }, vf.prototype.toGeoJSON = function (t, e, r) {
      var n,
        i,
        s = this.extent * Math.pow(2, r),
        a = this.extent * t,
        o = this.extent * e,
        l = this.loadGeometry(),
        u = vf.types[this.type];
      function c(t) {
        for (var e = 0; e < t.length; e++) {
          var r = t[e];
          t[e] = [360 * (r.x + a) / s - 180, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + o) / s) * Math.PI / 180)) - 90];
        }
      }
      switch (this.type) {
        case 1:
          var h = [];
          for (n = 0; n < l.length; n++) h[n] = l[n][0];
          c(l = h);
          break;
        case 2:
          for (n = 0; n < l.length; n++) c(l[n]);
          break;
        case 3:
          for (l = function (t) {
            var e = t.length;
            if (e <= 1) return [t];
            for (var r, n, i = [], s = 0; s < e; s++) {
              var a = wf(t[s]);
              0 !== a && (void 0 === n && (n = a < 0), n === a < 0 ? (r && i.push(r), r = [t[s]]) : r.push(t[s]));
            }
            return r && i.push(r), i;
          }(l), n = 0; n < l.length; n++) for (i = 0; i < l[n].length; i++) c(l[n][i]);
      }
      1 === l.length ? l = l[0] : u = "Multi" + u;
      var p = {
        type: "Feature",
        geometry: {
          type: u,
          coordinates: l
        },
        properties: this.properties
      };
      return "id" in this && (p.id = this.id), p;
    };
    var Mf = bf,
      Af = Sf;
    function Sf(t, e) {
      this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t, this._keys = [], this._values = [], this._features = [], t.readFields(If, this, e), this.length = this._features.length;
    }
    function If(t, e, r) {
      15 === t ? e.version = r.readVarint() : 1 === t ? e.name = r.readString() : 5 === t ? e.extent = r.readVarint() : 2 === t ? e._features.push(r.pos) : 3 === t ? e._keys.push(r.readString()) : 4 === t && e._values.push(function (t) {
        for (var e = null, r = t.readVarint() + t.pos; t.pos < r;) {
          var n = t.readVarint() >> 3;
          e = 1 === n ? t.readString() : 2 === n ? t.readFloat() : 3 === n ? t.readDouble() : 4 === n ? t.readVarint64() : 5 === n ? t.readVarint() : 6 === n ? t.readSVarint() : 7 === n ? t.readBoolean() : null;
        }
        return e;
      }(r));
    }
    Sf.prototype.feature = function (t) {
      if (t < 0 || t >= this._features.length) throw new Error("feature index out of bounds");
      this._pbf.pos = this._features[t];
      var e = this._pbf.readVarint() + this._pbf.pos;
      return new Mf(this._pbf, e, this.extent, this._keys, this._values);
    };
    var Tf = Af;
    function kf(t, e, r) {
      if (3 === t) {
        var n = new Tf(r, r.readVarint() + r.pos);
        n.length && (e[n.name] = n);
      }
    }
    var Pf = gf.VectorTile = function (t, e) {
        this.layers = t.readFields(kf, {}, e);
      },
      zf = gf.VectorTileFeature = bf;
    gf.VectorTileLayer = Af;
    var Ef = /*#__PURE__*/function (_je) {
      _inherits(Ef, _je);
      var _super63 = _createSuper(Ef);
      function Ef(t, e, r) {
        var _this24;
        _classCallCheck(this, Ef);
        _this24 = _super63.call(this, t, e), _this24.z = r;
        return _this24;
      }
      return _createClass(Ef);
    }(je);
    var Bf = /*#__PURE__*/function (_Ef) {
      _inherits(Bf, _Ef);
      var _super64 = _createSuper(Bf);
      function Bf(t, e, r, n) {
        var _this25;
        _classCallCheck(this, Bf);
        _this25 = _super64.call(this, t, e, r), _this25.w = n;
        return _this25;
      }
      return _createClass(Bf);
    }(Ef);
    function Df(t, e, r, n) {
      var i = [],
        s = 0 === n ? function (t, e, r, n, i, s) {
          t.push(new je(s, r + (s - e) / (n - e) * (i - r)));
        } : function (t, e, r, n, i, s) {
          t.push(new je(e + (s - r) / (i - r) * (n - e), s));
        };
      var _iterator111 = _createForOfIteratorHelper(t),
        _step111;
      try {
        for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
          var _a53 = _step111.value;
          var _t128 = [];
          var _iterator112 = _createForOfIteratorHelper(_a53),
            _step112;
          try {
            for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
              var _i95 = _step112.value;
              if (_i95.length <= 2) continue;
              var _a54 = [];
              for (var _t129 = 0; _t129 < _i95.length - 1; _t129++) {
                var _o32 = _i95[_t129].x,
                  _l25 = _i95[_t129].y,
                  _u21 = _i95[_t129 + 1].x,
                  _c15 = _i95[_t129 + 1].y,
                  _h10 = 0 === n ? _o32 : _l25,
                  _p9 = 0 === n ? _u21 : _c15;
                _h10 < e ? _p9 > e && s(_a54, _o32, _l25, _u21, _c15, e) : _h10 > r ? _p9 < r && s(_a54, _o32, _l25, _u21, _c15, r) : _a54.push(_i95[_t129]), _p9 < e && _h10 >= e && s(_a54, _o32, _l25, _u21, _c15, e), _p9 > r && _h10 <= r && s(_a54, _o32, _l25, _u21, _c15, r);
              }
              var _o33 = _i95[_i95.length - 1];
              var _l26 = 0 === n ? _o33.x : _o33.y;
              _l26 >= e && _l26 <= r && _a54.push(_o33), _a54.length && (_o33 = _a54[_a54.length - 1], _a54[0].x === _o33.x && _a54[0].y === _o33.y || _a54.push(_a54[0]), _t128.push(_a54));
            }
          } catch (err) {
            _iterator112.e(err);
          } finally {
            _iterator112.f();
          }
          _t128.length && i.push(_t128);
        }
      } catch (err) {
        _iterator111.e(err);
      } finally {
        _iterator111.f();
      }
      return i;
    }
    function Rf(t, e, r, n) {
      var i = "x" === r ? "y" : "x",
        s = (n - t[r]) / (e[r] - t[r]);
      t[i] = t[i] + (e[i] - t[i]) * s, t[r] = n, t.hasOwnProperty("z") && (t.z = Yn(t.z, e.z, s)), t.hasOwnProperty("w") && (t.w = Yn(t.w, e.w, s));
    }
    function Cf(t, e, r, n) {
      var i = r,
        s = n;
      for (var _i96 = 0, _arr = ["x", "y"]; _i96 < _arr.length; _i96++) {
        var _r129 = _arr[_i96];
        var _n83 = t,
          _a55 = e;
        _n83[_r129] >= _a55[_r129] && (_n83 = e, _a55 = t), _n83[_r129] < i && _a55[_r129] > i && Rf(_n83, _a55, _r129, i), _n83[_r129] < s && _a55[_r129] > s && Rf(_a55, _n83, _r129, s);
      }
    }
    var Lf = Number.MAX_SAFE_INTEGER;
    function Vf(t, e, r, n) {
      return t.order < e || t.order === Lf || !(t.clipMask & r) || function (t, e) {
        return 0 !== e.length && void 0 === e.find(function (e) {
          return e === t;
        });
      }(n, t.clipScope);
    }
    function Ff(t, e) {
      return t.x - e.x || t.y - e.y;
    }
    function Of(t, e) {
      return 0 === Ff(t.min, e.min) && 0 === Ff(t.max, e.max);
    }
    function Uf(t, e) {
      return !(t.min.x > e.max.x || t.max.x < e.min.x || t.min.y > e.max.y || t.max.y < e.min.y);
    }
    function jf(t, e) {
      if (t.length !== e.length) return !1;
      for (var _r130 = 0; _r130 < t.length; _r130++) if (t[_r130].sourceId !== e[_r130].sourceId || !Of(t[_r130], e[_r130]) || t[_r130].order !== e[_r130].order || t[_r130].clipMask !== e[_r130].clipMask || !Ne(t[_r130].clipScope, e[_r130].clipScope)) return !1;
      return !0;
    }
    function Nf(t, e, r) {
      var n = 1 / ds,
        i = 1 / (1 << r.canonical.z),
        s = (e.x * n + r.canonical.x) * i + r.wrap,
        a = (e.y * n + r.canonical.y) * i;
      return {
        min: new je((t.x * n + r.canonical.x) * i + r.wrap, (t.y * n + r.canonical.y) * i),
        max: new je(s, a)
      };
    }
    function $f(t, e, r) {
      var n = 1 << r.canonical.z,
        i = ((e.x - r.wrap) * n - r.canonical.x) * ds,
        s = (e.y * n - r.canonical.y) * ds;
      return {
        min: new je(((t.x - r.wrap) * n - r.canonical.x) * ds, (t.y * n - r.canonical.y) * ds),
        max: new je(i, s)
      };
    }
    function qf(t, e, r, n, i, s, a) {
      var o = t.indices,
        l = t.vertices,
        u = [];
      for (var _c16 = n; _c16 < n + i; _c16 += 3) {
        var _n84 = e[r[_c16 + 0] + s],
          _i97 = e[r[_c16 + 1] + s],
          _h11 = e[r[_c16 + 2] + s],
          _p10 = Math.min(_n84.x, _i97.x, _h11.x),
          _f7 = Math.max(_n84.x, _i97.x, _h11.x),
          _d4 = Math.min(_n84.y, _i97.y, _h11.y),
          _m4 = Math.max(_n84.y, _i97.y, _h11.y);
        u.length = 0, t.grid.query(new je(_p10, _d4), new je(_f7, _m4), u);
        for (var _t130 = 0; _t130 < u.length; _t130++) {
          var _e150 = u[_t130];
          if (dh(l[o[3 * _e150 + 0]], l[o[3 * _e150 + 1]], l[o[3 * _e150 + 2]], _n84, _i97, _h11, a)) return !0;
        }
      }
      return !1;
    }
    function Gf(t, e, r, n) {
      if (!t || !r) return !1;
      var i = t.vertices;
      if (!e.canonical.equals(n.canonical) || e.wrap !== n.wrap) {
        if (r.vertices.length < t.vertices.length) return Gf(r, n, t, e);
        var _s70 = e.canonical,
          _a56 = n.canonical,
          _o34 = Math.pow(2, _a56.z - _s70.z);
        i = t.vertices.map(function (t) {
          return new je((t.x + _s70.x * ds) * _o34 - _a56.x * ds, (t.y + _s70.y * ds) * _o34 - _a56.y * ds);
        });
      }
      return qf(r, i, t.indices, 0, t.indices.length, 0, 0);
    }
    function Xf(t, e, r, n) {
      var i = Math.pow(2, n.z - r.z);
      return new je((t + r.x * ds) * i - n.x * ds, (e + r.y * ds) * i - n.y * ds);
    }
    function Yf(t, e) {
      var r = [];
      e.footprint.grid.queryPoint(t, r);
      var n = e.footprint.indices,
        i = e.footprint.vertices;
      for (var _e151 = 0; _e151 < r.length; _e151++) {
        var _s71 = r[_e151];
        if (ch([i[n[3 * _s71 + 0]], i[n[3 * _s71 + 1]], i[n[3 * _s71 + 2]]], t)) return !0;
      }
      return !1;
    }
    var Zf = /*#__PURE__*/function () {
      function Zf(t) {
        _classCallCheck(this, Zf);
        this.size = t, this.minimums = [], this.maximums = [], this.leaves = [];
      }
      _createClass(Zf, [{
        key: "getElevation",
        value: function getElevation(t, e) {
          var r = this.toIdx(t, e);
          return {
            min: this.minimums[r],
            max: this.maximums[r]
          };
        }
      }, {
        key: "isLeaf",
        value: function isLeaf(t, e) {
          return this.leaves[this.toIdx(t, e)];
        }
      }, {
        key: "toIdx",
        value: function toIdx(t, e) {
          return e * this.size + t;
        }
      }]);
      return Zf;
    }();
    function Hf(t, e, r, n) {
      var i = 0,
        s = Number.MAX_VALUE;
      for (var _a57 = 0; _a57 < 3; _a57++) if (Math.abs(n[_a57]) < 1e-15) {
        if (r[_a57] < t[_a57] || r[_a57] > e[_a57]) return null;
      } else {
        var _o35 = 1 / n[_a57];
        var _l27 = (t[_a57] - r[_a57]) * _o35,
          _u22 = (e[_a57] - r[_a57]) * _o35;
        if (_l27 > _u22) {
          var _t131 = _l27;
          _l27 = _u22, _u22 = _t131;
        }
        if (_l27 > i && (i = _l27), _u22 < s && (s = _u22), i > s) return null;
      }
      return i;
    }
    function Kf(t, e, r, n, i, s, a, o, l, u, c) {
      var h = n - t,
        p = i - e,
        f = s - r,
        d = a - t,
        m = o - e,
        y = l - r,
        g = c[1] * y - c[2] * m,
        x = c[2] * d - c[0] * y,
        b = c[0] * m - c[1] * d,
        v = h * g + p * x + f * b;
      if (Math.abs(v) < 1e-15) return null;
      var _ = 1 / v,
        w = u[0] - t,
        M = u[1] - e,
        A = u[2] - r,
        S = (w * g + M * x + A * b) * _;
      if (S < 0 || S > 1) return null;
      var I = M * f - A * p,
        T = A * h - w * f,
        k = w * p - M * h,
        P = (c[0] * I + c[1] * T + c[2] * k) * _;
      return P < 0 || S + P > 1 ? null : (d * I + m * T + y * k) * _;
    }
    function Wf(t, e, r) {
      return (t - e) / (r - e);
    }
    function Jf(t, e, r, n, i, s, a, o, l) {
      var u = 1 << r,
        c = s - n,
        h = a - i,
        p = (t + 1) / u * c + n,
        f = (e + 0) / u * h + i,
        d = (e + 1) / u * h + i;
      o[0] = (t + 0) / u * c + n, o[1] = f, l[0] = p, l[1] = d;
    }
    var Qf = /*#__PURE__*/function () {
      function Qf(t) {
        _classCallCheck(this, Qf);
        if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = t, this._siblingOffset = [[0, 0], [1, 0], [0, 1], [1, 1]], !this.dem) return;
        var e = function (t) {
            var e = Math.ceil(Math.log2(t.dim / 8)),
              r = [];
            var n = Math.ceil(Math.pow(2, e));
            var i = 1 / n,
              s = function s(t, e, r, n, i) {
                var s = n ? 1 : 0,
                  a = (t + 1) * r - s,
                  o = e * r,
                  l = (e + 1) * r - s;
                i[0] = t * r, i[1] = o, i[2] = a, i[3] = l;
              };
            var a = new Zf(n);
            var o = [];
            for (var _e152 = 0; _e152 < n * n; _e152++) {
              s(_e152 % n, Math.floor(_e152 / n), i, !1, o);
              var _r131 = ed(o[0], o[1], t),
                _l28 = ed(o[2], o[1], t),
                _u23 = ed(o[2], o[3], t),
                _c17 = ed(o[0], o[3], t);
              a.minimums.push(Math.min(_r131, _l28, _u23, _c17)), a.maximums.push(Math.max(_r131, _l28, _u23, _c17)), a.leaves.push(1);
            }
            for (r.push(a), n /= 2; n >= 1; n /= 2) {
              var _t132 = r[r.length - 1];
              a = new Zf(n);
              for (var _e153 = 0; _e153 < n * n; _e153++) {
                s(_e153 % n, Math.floor(_e153 / n), 2, !0, o);
                var _r132 = _t132.getElevation(o[0], o[1]),
                  _i98 = _t132.getElevation(o[2], o[1]),
                  _l29 = _t132.getElevation(o[2], o[3]),
                  _u24 = _t132.getElevation(o[0], o[3]),
                  _c18 = _t132.isLeaf(o[0], o[1]),
                  _h12 = _t132.isLeaf(o[2], o[1]),
                  _p11 = _t132.isLeaf(o[2], o[3]),
                  _f8 = _t132.isLeaf(o[0], o[3]),
                  _d5 = Math.min(_r132.min, _i98.min, _l29.min, _u24.min),
                  _m5 = Math.max(_r132.max, _i98.max, _l29.max, _u24.max),
                  _y3 = _c18 && _h12 && _p11 && _f8;
                a.maximums.push(_m5), a.minimums.push(_d5), a.leaves.push(_m5 - _d5 <= 5 && _y3 ? 1 : 0);
              }
              r.push(a);
            }
            return r;
          }(this.dem),
          r = e.length - 1,
          n = e[r];
        this._addNode(n.minimums[0], n.maximums[0], n.leaves[0]), this._construct(e, 0, 0, r, 0);
      }
      _createClass(Qf, [{
        key: "raycastRoot",
        value: function raycastRoot(t, e, r, n, i, s) {
          var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1;
          return Hf([t, e, -100], [r, n, this.maximums[0] * a], i, s);
        }
      }, {
        key: "raycast",
        value: function raycast(e, r, n, i, s, a) {
          var o = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1;
          if (!this.nodeCount) return null;
          var l = this.raycastRoot(e, r, n, i, s, a, o);
          if (null == l) return null;
          var u = [],
            c = [],
            h = [],
            p = [],
            f = [{
              idx: 0,
              t: l,
              nodex: 0,
              nodey: 0,
              depth: 0
            }];
          for (; f.length > 0;) {
            var _f$pop = f.pop(),
              _l30 = _f$pop.idx,
              _d6 = _f$pop.t,
              _m6 = _f$pop.nodex,
              _y4 = _f$pop.nodey,
              _g3 = _f$pop.depth;
            if (this.leaves[_l30]) {
              Jf(_m6, _y4, _g3, e, r, n, i, h, p);
              var _l31 = 1 << _g3,
                _u25 = (_m6 + 0) / _l31,
                _c19 = (_m6 + 1) / _l31,
                _f9 = (_y4 + 0) / _l31,
                _x3 = (_y4 + 1) / _l31,
                _b3 = ed(_u25, _f9, this.dem) * o,
                _v3 = ed(_c19, _f9, this.dem) * o,
                _3 = ed(_c19, _x3, this.dem) * o,
                _w2 = ed(_u25, _x3, this.dem) * o,
                _M2 = Kf(h[0], h[1], _b3, p[0], h[1], _v3, p[0], p[1], _3, s, a),
                _A2 = Kf(p[0], p[1], _3, h[0], p[1], _w2, h[0], h[1], _b3, s, a),
                _S = Math.min(null !== _M2 ? _M2 : Number.MAX_VALUE, null !== _A2 ? _A2 : Number.MAX_VALUE);
              if (_S !== Number.MAX_VALUE) return _S;
              {
                var _e154 = t.$.scaleAndAdd([], s, a, _d6);
                if (td(_b3, _v3, _w2, _3, Wf(_e154[0], h[0], p[0]), Wf(_e154[1], h[1], p[1])) >= _e154[2]) return _d6;
              }
              continue;
            }
            var _x4 = 0;
            for (var _t133 = 0; _t133 < this._siblingOffset.length; _t133++) {
              Jf((_m6 << 1) + this._siblingOffset[_t133][0], (_y4 << 1) + this._siblingOffset[_t133][1], _g3 + 1, e, r, n, i, h, p), h[2] = -100, p[2] = this.maximums[this.childOffsets[_l30] + _t133] * o;
              var _f10 = Hf(h, p, s, a);
              if (null != _f10) {
                var _e155 = _f10;
                u[_t133] = _e155;
                var _r133 = !1;
                for (var _n85 = 0; _n85 < _x4 && !_r133; _n85++) _e155 >= u[c[_n85]] && (c.splice(_n85, 0, _t133), _r133 = !0);
                _r133 || (c[_x4] = _t133), _x4++;
              }
            }
            for (var _t134 = 0; _t134 < _x4; _t134++) {
              var _e156 = c[_t134];
              f.push({
                idx: this.childOffsets[_l30] + _e156,
                t: u[_e156],
                nodex: (_m6 << 1) + this._siblingOffset[_e156][0],
                nodey: (_y4 << 1) + this._siblingOffset[_e156][1],
                depth: _g3 + 1
              });
            }
          }
          return null;
        }
      }, {
        key: "_addNode",
        value: function _addNode(t, e, r) {
          return this.minimums.push(t), this.maximums.push(e), this.leaves.push(r), this.childOffsets.push(0), this.nodeCount++;
        }
      }, {
        key: "_construct",
        value: function _construct(t, e, r, n, i) {
          if (1 === t[n].isLeaf(e, r)) return;
          this.childOffsets[i] || (this.childOffsets[i] = this.nodeCount);
          var s = n - 1,
            a = t[s];
          var o = 0,
            l = 0;
          for (var _t135 = 0; _t135 < this._siblingOffset.length; _t135++) {
            var _n86 = 2 * e + this._siblingOffset[_t135][0],
              _i99 = 2 * r + this._siblingOffset[_t135][1],
              _s72 = a.getElevation(_n86, _i99),
              _u26 = a.isLeaf(_n86, _i99),
              _c20 = this._addNode(_s72.min, _s72.max, _u26);
            _u26 && (o |= 1 << _t135), l || (l = _c20);
          }
          for (var _n87 = 0; _n87 < this._siblingOffset.length; _n87++) o & 1 << _n87 || this._construct(t, 2 * e + this._siblingOffset[_n87][0], 2 * r + this._siblingOffset[_n87][1], s, l + _n87);
        }
      }]);
      return Qf;
    }();
    function td(t, e, r, n, i, s) {
      return Yn(Yn(t, r, s), Yn(e, n, s), i);
    }
    function ed(t, e, r) {
      var n = r.dim,
        i = We(t * n - .5, 0, n - 1),
        s = We(e * n - .5, 0, n - 1),
        a = Math.floor(i),
        o = Math.floor(s),
        l = Math.min(a + 1, n - 1),
        u = Math.min(o + 1, n - 1);
      return td(r.get(a, o), r.get(l, o), r.get(a, u), r.get(l, u), i - a, s - o);
    }
    var rd = {
      mapbox: [6553.6, 25.6, .1, 1e4],
      terrarium: [256, 1, 1 / 256, 32768]
    };
    function nd(t, e, r) {
      return (256 * t * 256 + 256 * e + r) / 10 - 1e4;
    }
    function id(t, e, r) {
      return 256 * t + e + r / 256 - 32768;
    }
    var sd = /*#__PURE__*/function () {
      function sd(t, e, r) {
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
        _classCallCheck(this, sd);
        if (this.uid = t, e.height !== e.width) throw new RangeError("DEM tiles must be square");
        if (r && "mapbox" !== r && "terrarium" !== r) return dr("\"".concat(r, "\" is not a valid encoding type. Valid types include \"mapbox\" and \"terrarium\"."));
        this.stride = e.height;
        var i = this.dim = e.height - 2,
          s = new Uint32Array(e.data.buffer);
        if (this.pixels = new Uint8Array(e.data.buffer), this.floatView = new Float32Array(e.data.buffer), this.borderReady = n, this._modifiedForSources = {}, !n) {
          for (var _t136 = 0; _t136 < i; _t136++) s[this._idx(-1, _t136)] = s[this._idx(0, _t136)], s[this._idx(i, _t136)] = s[this._idx(i - 1, _t136)], s[this._idx(_t136, -1)] = s[this._idx(_t136, 0)], s[this._idx(_t136, i)] = s[this._idx(_t136, i - 1)];
          s[this._idx(-1, -1)] = s[this._idx(0, 0)], s[this._idx(i, -1)] = s[this._idx(i - 1, 0)], s[this._idx(-1, i)] = s[this._idx(0, i - 1)], s[this._idx(i, i)] = s[this._idx(i - 1, i - 1)];
        }
        var a = "terrarium" === r ? id : nd;
        for (var _t137 = 0; _t137 < s.length; ++_t137) {
          var _e157 = 4 * _t137;
          this.floatView[_t137] = a(this.pixels[_e157], this.pixels[_e157 + 1], this.pixels[_e157 + 2]);
        }
        this._timestamp = Rr.now();
      }
      _createClass(sd, [{
        key: "tree",
        get: function get() {
          return this._tree || this._buildQuadTree(), this._tree;
        }
      }, {
        key: "_buildQuadTree",
        value: function _buildQuadTree() {
          this._tree = new Qf(this);
        }
      }, {
        key: "get",
        value: function get(t, e) {
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          r && (t = We(t, -1, this.dim), e = We(e, -1, this.dim));
          var n = this._idx(t, e);
          return this.floatView[n];
        }
      }, {
        key: "set",
        value: function set(t, e, r) {
          var n = this._idx(t, e),
            i = this.floatView[n];
          return this.floatView[n] = r, r - i;
        }
      }, {
        key: "_idx",
        value: function _idx(t, e) {
          if (t < -1 || t >= this.dim + 1 || e < -1 || e >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
          return (e + 1) * this.stride + (t + 1);
        }
      }, {
        key: "getPixels",
        value: function getPixels() {
          return new xp({
            width: this.stride,
            height: this.stride
          }, this.pixels);
        }
      }, {
        key: "backfillBorder",
        value: function backfillBorder(t, e, r) {
          if (this.dim !== t.dim) throw new Error("dem dimension mismatch");
          var n = e * this.dim,
            i = e * this.dim + this.dim,
            s = r * this.dim,
            a = r * this.dim + this.dim;
          switch (e) {
            case -1:
              n = i - 1;
              break;
            case 1:
              i = n + 1;
          }
          switch (r) {
            case -1:
              s = a - 1;
              break;
            case 1:
              a = s + 1;
          }
          var o = -e * this.dim,
            l = -r * this.dim;
          for (var _e158 = s; _e158 < a; _e158++) for (var _r134 = n; _r134 < i; _r134++) {
            var _n88 = 4 * this._idx(_r134, _e158),
              _i100 = 4 * this._idx(_r134 + o, _e158 + l);
            this.pixels[_n88 + 0] = t.pixels[_i100 + 0], this.pixels[_n88 + 1] = t.pixels[_i100 + 1], this.pixels[_n88 + 2] = t.pixels[_i100 + 2], this.pixels[_n88 + 3] = t.pixels[_i100 + 3];
          }
        }
      }, {
        key: "onDeserialize",
        value: function onDeserialize() {
          this._tree && (this._tree.dem = this);
        }
      }], [{
        key: "getUnpackVector",
        value: function getUnpackVector(t) {
          return rd[t];
        }
      }, {
        key: "pack",
        value: function pack(t, e) {
          var r = [0, 0, 0, 0],
            n = sd.getUnpackVector(e);
          var i = Math.floor((t + n[3]) / n[2]);
          return r[2] = i % 256, i = Math.floor(i / 256), r[1] = i % 256, i = Math.floor(i / 256), r[0] = i, r;
        }
      }]);
      return sd;
    }();
    So(sd, "DEMData"), So(Qf, "DemMinMaxQuadTree", {
      omit: ["dem"]
    });
    var ad = /*#__PURE__*/function () {
      function ad(t, e, r) {
        _classCallCheck(this, ad);
        this._demTile = t, this._dem = this._demTile.dem, this._scale = e, this._offset = r;
      }
      _createClass(ad, [{
        key: "tileCoordToPixel",
        value: function tileCoordToPixel(t, e) {
          var r = e * this._scale + this._offset[1],
            n = Math.floor(t * this._scale + this._offset[0]),
            i = Math.floor(r);
          return new je(n, i);
        }
      }, {
        key: "getElevationAt",
        value: function getElevationAt(t, e, r, n) {
          var i = t * this._scale + this._offset[0],
            s = e * this._scale + this._offset[1],
            a = Math.floor(i),
            o = Math.floor(s),
            l = this._dem;
          return n = !!n, r ? Yn(Yn(l.get(a, o, n), l.get(a, o + 1, n), s - o), Yn(l.get(a + 1, o, n), l.get(a + 1, o + 1, n), s - o), i - a) : l.get(a, o, n);
        }
      }, {
        key: "getElevationAtPixel",
        value: function getElevationAtPixel(t, e, r) {
          return this._dem.get(t, e, !!r);
        }
      }, {
        key: "getMeterToDEM",
        value: function getMeterToDEM(t) {
          return (1 << this._demTile.tileID.canonical.z) * Dc(1, t) * this._dem.stride;
        }
      }], [{
        key: "create",
        value: function create(t, e, r) {
          var n = r || t.findDEMTileFor(e);
          if (!n || !n.dem) return;
          var i = n.dem,
            s = n.tileID,
            a = 1 << e.canonical.z - s.canonical.z;
          return new ad(n, i.dim / ds / a, [(e.canonical.x / a - s.canonical.x) * i.dim, (e.canonical.y / a - s.canonical.y) * i.dim]);
        }
      }]);
      return ad;
    }();
    var od = {
        None: 0,
        Model: 1,
        Symbol: 2,
        FillExtrusion: 4,
        All: 7
      },
      ld = zf.types,
      ud = ["fill-extrusion-base", "fill-extrusion-height", "fill-extrusion-color", "fill-extrusion-pattern", "fill-extrusion-flood-light-wall-radius", "fill-extrusion-line-width", "fill-extrusion-line-alignment"],
      cd = ["fill-extrusion-flood-light-ground-radius"],
      hd = Math.pow(2, 13),
      pd = Math.pow(2, 15) - 1,
      fd = new je(0, 1),
      dd = 2147483648;
    function md(t, e, r, n, i, s, a, o) {
      t.emplaceBack((e << 1) + a, (r << 1) + s, (Math.floor(n * hd) << 1) + i, Math.round(o));
    }
    function yd(t, e, r, n) {
      t.emplaceBack(e.x * ds, e.y * ds, r ? 0 : 1, n ? 1 : 0);
    }
    function gd(t, e, r, n, i, s) {
      t.emplaceBack(e.x, e.y, (r.x << 1) + n, (r.y << 1) + i, s);
    }
    function xd(t, e, r) {
      var n = 16384;
      t.emplaceBack(e.x, e.y, e.z, r[0] * n, r[1] * n, r[2] * n);
    }
    var bd = /*#__PURE__*/_createClass(function bd() {
      _classCallCheck(this, bd);
      this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
    });
    var vd = /*#__PURE__*/function () {
      function vd() {
        _classCallCheck(this, vd);
        this.centroidXY = new je(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new je(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new je(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0;
      }
      _createClass(vd, [{
        key: "span",
        value: function span() {
          return new je(this.max.x - this.min.x, this.max.y - this.min.y);
        }
      }]);
      return vd;
    }();
    var _d = /*#__PURE__*/function () {
      function _d() {
        _classCallCheck(this, _d);
        this.acc = new je(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
      }
      _createClass(_d, [{
        key: "startRing",
        value: function startRing(t, e) {
          t.min.x === Number.MAX_VALUE && (t.min.x = t.max.x = e.x, t.min.y = t.max.y = e.y);
        }
      }, {
        key: "appendEdge",
        value: function appendEdge(t, e, r) {
          this.accCount++, this.acc._add(e);
          var n = !!this.borders;
          e.x < t.min.x ? (t.min.x = e.x, n = !0) : e.x > t.max.x && (t.max.x = e.x, n = !0), e.y < t.min.y ? (t.min.y = e.y, n = !0) : e.y > t.max.y && (t.max.y = e.y, n = !0), ((0 === e.x || e.x === ds) && e.x === r.x) != ((0 === e.y || e.y === ds) && e.y === r.y) && this.processBorderOverlap(e, r), n && this.checkBorderIntersection(e, r);
        }
      }, {
        key: "checkBorderIntersection",
        value: function checkBorderIntersection(t, e) {
          e.x < 0 != t.x < 0 && this.addBorderIntersection(0, Yn(e.y, t.y, (0 - e.x) / (t.x - e.x))), e.x > ds != t.x > ds && this.addBorderIntersection(1, Yn(e.y, t.y, (ds - e.x) / (t.x - e.x))), e.y < 0 != t.y < 0 && this.addBorderIntersection(2, Yn(e.x, t.x, (0 - e.y) / (t.y - e.y))), e.y > ds != t.y > ds && this.addBorderIntersection(3, Yn(e.x, t.x, (ds - e.y) / (t.y - e.y)));
        }
      }, {
        key: "addBorderIntersection",
        value: function addBorderIntersection(t, e) {
          this.borders || (this.borders = [[Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE]]);
          var r = this.borders[t];
          e < r[0] && (r[0] = e), e > r[1] && (r[1] = e);
        }
      }, {
        key: "processBorderOverlap",
        value: function processBorderOverlap(t, e) {
          if (t.x === e.x) {
            if (t.y === e.y) return;
            var _r135 = 0 === t.x ? 0 : 1;
            this.addBorderIntersection(_r135, e.y), this.addBorderIntersection(_r135, t.y);
          } else {
            var _r136 = 0 === t.y ? 2 : 3;
            this.addBorderIntersection(_r136, e.x), this.addBorderIntersection(_r136, t.x);
          }
        }
      }, {
        key: "centroid",
        value: function centroid() {
          return 0 === this.accCount ? new je(0, 0) : new je(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
        }
      }, {
        key: "intersectsCount",
        value: function intersectsCount() {
          return this.borders ? this.borders.reduce(function (t, e) {
            return t + +(e[0] !== Number.MAX_VALUE);
          }, 0) : 0;
        }
      }]);
      return _d;
    }();
    function wd(t, e) {
      var r = t.add(e)._unit(),
        n = We(t.x * r.x + t.y * r.y, -1, 1);
      var i, s, a;
      return i = Math.acos(n), Math.min(4, Math.max(-4, Math.tan(i))) / 4 * pd * ((s = t).x * (a = e).y - s.y * a.x < 0 ? -1 : 1);
    }
    var Md = [function (t) {
      return t.x < 0;
    }, function (t) {
      return t.x > ds;
    }, function (t) {
      return t.y < 0;
    }, function (t) {
      return t.y > ds;
    }];
    function Ad(t, e, r, n) {
      var i = [4];
      if (0 === n) return i;
      r._mult(n);
      var s = t.sub(r),
        a = e.sub(r),
        o = [t, e, s, a];
      for (var _t138 = 0; _t138 < 4; _t138++) {
        var _iterator113 = _createForOfIteratorHelper(o),
          _step113;
        try {
          for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
            var _e159 = _step113.value;
            if (Md[_t138](_e159)) {
              i.push(_t138);
              break;
            }
          }
        } catch (err) {
          _iterator113.e(err);
        } finally {
          _iterator113.f();
        }
      }
      return i;
    }
    var Sd = /*#__PURE__*/function () {
      function Sd(t) {
        _classCallCheck(this, Sd);
        this.vertexArray = new Ol(), this.indexArray = new tu(), this.programConfigurations = new ec(t.layers, {
          zoom: t.zoom,
          lut: t.lut
        }, function (t) {
          return cd.includes(t);
        }), this._segments = new ku(), this.hiddenByLandmarkVertexArray = new pu(), this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [0, 0, 0, 0, 0], this.regionSegments = {}, this.regionSegments[4] = new ku();
      }
      _createClass(Sd, [{
        key: "getDefaultSegment",
        value: function getDefaultSegment() {
          return this.regionSegments[4];
        }
      }, {
        key: "hasData",
        value: function hasData() {
          return 0 !== this.vertexArray.length;
        }
      }, {
        key: "addData",
        value: function addData(t, e, r) {
          var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          var i = t.length;
          if (i > 2) {
            var _s73 = Math.max(0, this._segments.get().length - 1);
            var _a58 = this._segments._prepareSegment(4 * i, this.vertexArray.length, 2 * this._segmentToGroundQuads[_s73].length);
            var _o36;
            _s73 !== this._segments.get().length - 1 && (_s73++, this._segmentToGroundQuads[_s73] = [], this._segmentToRegionTriCounts[_s73] = [0, 0, 0, 0, 0]);
            {
              var _e160 = t[0],
                _r137 = t[1];
              _o36 = wd(_e160.sub(t[i - 1])._perp()._unit(), _r137.sub(_e160)._perp()._unit());
            }
            for (var _l32 = 0; _l32 < i; _l32++) {
              var _u27 = _l32 === i - 1 ? 0 : _l32 + 1,
                _c21 = t[_l32],
                _h13 = t[_u27],
                _p12 = t[_u27 === i - 1 ? 0 : _u27 + 1],
                _f11 = _h13.sub(_c21)._perp()._unit(),
                _d7 = wd(_f11, _p12.sub(_h13)._perp()._unit()),
                _m7 = _o36,
                _y5 = _d7;
              if (zd(_c21, _h13, e) || n && Ed(_c21, e) && Ed(_h13, e)) {
                _o36 = _d7;
                continue;
              }
              var _g4 = _a58.vertexLength;
              gd(this.vertexArray, _c21, _h13, 1, 1, _m7), gd(this.vertexArray, _c21, _h13, 1, 0, _m7), gd(this.vertexArray, _c21, _h13, 0, 1, _y5), gd(this.vertexArray, _c21, _h13, 0, 0, _y5), _a58.vertexLength += 4;
              var _x5 = Ad(_c21, _h13, _f11, r);
              var _iterator114 = _createForOfIteratorHelper(_x5),
                _step114;
              try {
                for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
                  var _t139 = _step114.value;
                  this._segmentToGroundQuads[_s73].push({
                    id: _g4,
                    region: _t139
                  }), this._segmentToRegionTriCounts[_s73][_t139] += 2, _a58.primitiveLength += 2;
                }
              } catch (err) {
                _iterator114.e(err);
              } finally {
                _iterator114.f();
              }
              _o36 = _d7;
            }
          }
        }
      }, {
        key: "prepareBorderSegments",
        value: function prepareBorderSegments() {
          if (!this.hasData()) return;
          var t = this._segments.get(),
            e = t.length;
          for (var _t140 = 0; _t140 < e; _t140++) this._segmentToGroundQuads[_t140].sort(function (t, e) {
            return t.region - e.region;
          });
          for (var _r138 = 0; _r138 < e; _r138++) {
            var _e161 = this._segmentToGroundQuads[_r138],
              _n89 = t[_r138],
              _i101 = this._segmentToRegionTriCounts[_r138];
            _i101.reduce(function (t, e) {
              return t + e;
            }, 0);
            var _s74 = 0;
            for (var _t141 = 0; _t141 <= 4; _t141++) {
              var _e162 = _i101[_t141];
              if (0 !== _e162) {
                var _r139 = this.regionSegments[_t141];
                _r139 || (_r139 = this.regionSegments[_t141] = new ku());
                var _i102 = {
                  vertexOffset: _n89.vertexOffset,
                  primitiveOffset: _n89.primitiveOffset + _s74,
                  vertexLength: _n89.vertexLength,
                  primitiveLength: _e162
                };
                _r139.get().push(_i102);
              }
              _s74 += _e162;
            }
            for (var _t142 = 0; _t142 < _e161.length; _t142++) {
              var _r140 = _e161[_t142].id;
              this.indexArray.emplaceBack(_r140, _r140 + 1, _r140 + 3), this.indexArray.emplaceBack(_r140, _r140 + 3, _r140 + 2);
            }
          }
          this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
        }
      }, {
        key: "addPaintPropertiesData",
        value: function addPaintPropertiesData(t, e, r, n, i, s) {
          this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, t, e, r, n, i, s);
        }
      }, {
        key: "upload",
        value: function upload(t) {
          this.hasData() && (this.vertexBuffer = t.createVertexBuffer(this.vertexArray, hf.members), this.indexBuffer = t.createIndexBuffer(this.indexArray));
        }
      }, {
        key: "uploadPaintProperties",
        value: function uploadPaintProperties(t) {
          this.hasData() && this.programConfigurations.upload(t);
        }
      }, {
        key: "update",
        value: function update(t, e, r, n, i, s) {
          this.hasData() && this.programConfigurations.updatePaintArrays(t, e, r, n, i, s);
        }
      }, {
        key: "updateHiddenByLandmark",
        value: function updateHiddenByLandmark(t) {
          if (!this.hasData()) return;
          var e = t.groundVertexCount + t.groundVertexArrayOffset;
          if (0 === t.groundVertexCount) return;
          var r = t.flags & dd ? 1 : 0;
          for (var _n90 = t.groundVertexArrayOffset; _n90 < e; ++_n90) this.hiddenByLandmarkVertexArray.emplace(_n90, r);
          this._needsHiddenByLandmarkUpdate = !0;
        }
      }, {
        key: "uploadHiddenByLandmark",
        value: function uploadHiddenByLandmark(t) {
          this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = t.createVertexBuffer(this.hiddenByLandmarkVertexArray, df.members, !0) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = !1);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          if (this.vertexBuffer) {
            this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
            for (var _t143 = 0; _t143 <= 4; _t143++) {
              var _e163 = this.regionSegments[_t143];
              _e163 && _e163.destroy();
            }
          }
        }
      }]);
      return Sd;
    }();
    var Id = /*#__PURE__*/function () {
      function Id(t) {
        _classCallCheck(this, Id);
        this.zoom = t.zoom, this.canonical = t.canonical, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function (t) {
          return t.fqid;
        }), this.index = t.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = t.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = [], this.footprintIndices = new tu(), this.footprintVertices = new Ll(), this.footprintSegments = [], this.layoutVertexArray = new Fl(), this.centroidVertexArray = new Mu(), this.wallVertexArray = new Su(), this.indexArray = new tu(), this.programConfigurations = new ec(t.layers, {
          zoom: t.zoom,
          lut: t.lut
        }, function (t) {
          return ud.includes(t);
        }), this.segments = new ku(), this.stateDependentLayerIds = this.layers.filter(function (t) {
          return t.isStateDependent();
        }).map(function (t) {
          return t.id;
        }), this.groundEffect = new Sd(t), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [];
      }
      _createClass(Id, [{
        key: "updateFootprints",
        value: function updateFootprints(t, e) {}
      }, {
        key: "populate",
        value: function populate(t, e, r, n) {
          this.features = [], this.hasPattern = Qp("fill-extrusion", this.layers, e), this.featuresOnBorder = [], this.borderFeatureIndices = [[], [], [], []], this.borderDoneWithNeighborZ = [-1, -1, -1, -1], this.tileToMeter = jc(r), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter, this.wallMode = 0 !== this.layers[0].paint.get("fill-extrusion-line-width").constantOr(1);
          var _iterator115 = _createForOfIteratorHelper(t),
            _step115;
          try {
            for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
              var _step115$value = _step115.value,
                _i103 = _step115$value.feature,
                _s75 = _step115$value.id,
                _a59 = _step115$value.index,
                _o37 = _step115$value.sourceLayerIndex;
              var _t144 = this.layers[0]._featureFilter.needGeometry,
                _l33 = Wc(_i103, _t144);
              if (!this.layers[0]._featureFilter.filter(new Wo(this.zoom), _l33, r)) continue;
              var _u28 = {
                  id: _s75,
                  sourceLayerIndex: _o37,
                  index: _a59,
                  geometry: _t144 ? _l33.geometry : Kc(_i103, r, n),
                  properties: _i103.properties,
                  type: _i103.type,
                  patterns: {}
                },
                _c22 = this.layoutVertexArray.length;
              if (this.hasPattern) this.features.push(tf("fill-extrusion", this.layers, _u28, this.zoom, e));else if (this.wallMode) {
                var _iterator116 = _createForOfIteratorHelper(_u28.geometry),
                  _step116;
                try {
                  for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
                    var _t145 = _step116.value;
                    this.addFeature(_u28, [_t145], _a59, r, {}, e.availableImages, n, e.brightness);
                  }
                } catch (err) {
                  _iterator116.e(err);
                } finally {
                  _iterator116.f();
                }
              } else this.addFeature(_u28, _u28.geometry, _a59, r, {}, e.availableImages, n, e.brightness);
              e.featureIndex.insert(_i103, _u28.geometry, _a59, _o37, this.index, _c22);
            }
          } catch (err) {
            _iterator115.e(err);
          } finally {
            _iterator115.f();
          }
          this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
        }
      }, {
        key: "addFeatures",
        value: function addFeatures(t, e, r, n, i, s) {
          var _iterator117 = _createForOfIteratorHelper(this.features),
            _step117;
          try {
            for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
              var _t146 = _step117.value;
              var _a60 = _t146.geometry;
              if (this.wallMode) {
                var _iterator118 = _createForOfIteratorHelper(_a60),
                  _step118;
                try {
                  for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
                    var _o38 = _step118.value;
                    this.addFeature(_t146, [_o38], _t146.index, e, r, n, i, s);
                  }
                } catch (err) {
                  _iterator118.e(err);
                } finally {
                  _iterator118.f();
                }
              } else this.addFeature(_t146, _a60, _t146.index, e, r, n, i, s);
            }
          } catch (err) {
            _iterator117.e(err);
          } finally {
            _iterator117.f();
          }
          this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
        }
      }, {
        key: "update",
        value: function update(t, e, r, n, i) {
          var s = 0 !== Object.keys(t).length;
          if (s && !this.stateDependentLayers.length) return;
          var a = s ? this.stateDependentLayers : this.layers;
          this.programConfigurations.updatePaintArrays(t, e, a, r, n, i), this.groundEffect.update(t, e, a, r, n, i);
        }
      }, {
        key: "isEmpty",
        value: function isEmpty() {
          return 0 === this.layoutVertexArray.length;
        }
      }, {
        key: "uploadPending",
        value: function uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
        }
      }, {
        key: "upload",
        value: function upload(t) {
          this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, yf), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.wallVertexBuffer = t.createVertexBuffer(this.wallVertexArray, ff.members), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = t.createVertexBuffer(this.layoutVertexExtArray, mf.members, !0)), this.groundEffect.upload(t)), this.groundEffect.uploadPaintProperties(t), this.programConfigurations.upload(t), this.uploaded = !0;
        }
      }, {
        key: "uploadCentroid",
        value: function uploadCentroid(t) {
          this.groundEffect.uploadHiddenByLandmark(t), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = t.createVertexBuffer(this.centroidVertexArray, pf.members, !0) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = !1);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }
      }, {
        key: "addFeature",
        value: function addFeature(t, e, r, n, i, s, a, o) {
          var l = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(t, {}) / this.tileToMeter,
            u = [new je(0, 0), new je(ds, ds)],
            c = a.projection,
            h = "globe" === c.name,
            p = this.wallMode || "Polygon" === ld[t.type],
            f = new _d();
          f.centroidDataIndex = this.centroidData.length;
          var d = new vd(),
            m = this.layers[0].paint.get("fill-extrusion-base").evaluate(t, {}, n) <= 0,
            y = this.layers[0].paint.get("fill-extrusion-height").evaluate(t, {}, n);
          var g;
          if (d.height = y, d.vertexArrayOffset = this.layoutVertexArray.length, d.groundVertexArrayOffset = this.groundEffect.vertexArray.length, h && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new Gl()), this.wallMode) {
            if (h) return void dr("Non zero fill-extrusion-line-width is not yet supported on globe.");
            if (1 !== e.length) return;
            g = function (t) {
              var e = t[0].x === t[t.length - 1].x && t[0].y === t[t.length - 1].y,
                r = function (t) {
                  var e = 0;
                  var r = t.length;
                  for (var _n91 = 0; _n91 < r; _n91++) e += (t[(_n91 + 1) % r].x - t[_n91].x) * (t[(_n91 + 1) % r].y + t[_n91].y);
                  return e >= 0;
                }(t);
              r || (t = t.reverse());
              var n = {
                  isPolygon: e,
                  geometry: [],
                  joinNormals: []
                },
                i = [],
                s = [],
                a = [];
              var o = t.length;
              if (o < (e ? 3 : 2)) return n;
              for (; o >= 2 && t[o - 1].equals(t[o - 2]);) o--;
              var l,
                u,
                c,
                h,
                p,
                f = 0;
              for (; f < o - 1 && t[f].equals(t[f + 1]);) f++;
              e && (l = t[o - 2], p = t[f].sub(l)._unit()._perp());
              for (var _r141 = f; _r141 < o; _r141++) {
                if (c = _r141 === o - 1 ? e ? t[f + 1] : void 0 : t[_r141 + 1], c && t[_r141].equals(c)) continue;
                p && (h = p), l && (u = l), l = t[_r141], p = c ? c.sub(l)._unit()._perp() : h, h = h || p;
                var _n92 = h.add(p);
                0 === _n92.x && 0 === _n92.y || _n92._unit();
                var _d8 = _n92.x * p.x + _n92.y * p.y,
                  _m8 = 0 !== _d8 ? 1 / _d8 : 1 / 0,
                  _y6 = h.x * p.y - h.y * p.x > 0;
                var _g5 = "miter";
                "miter" === _g5 && _m8 > 2 && (_g5 = "bevel");
                var _x6 = function _x6(t, e, r, n) {
                  var o = new je(t.x, t.y),
                    l = new je(t.x, t.y);
                  o.x -= e.x * n, o.y -= e.y * n, l.x -= e.x * Math.max(r, 1), l.y -= e.y * Math.max(r, 1), a.push(e), i.push(o), s.push(l);
                };
                if ("miter" === _g5) _n92._mult(_m8), _x6(l, _n92, 1, 0);else {
                  var _t147 = -Math.sqrt(_m8 * _m8 - 1),
                    _e164 = _y6 ? _t147 : 0,
                    _r142 = _y6 ? 0 : _t147;
                  u && _x6(l, h, _e164, _r142), c && _x6(l, p, _e164, _r142);
                }
              }
              return n.geometry = [].concat(i, _toConsumableArray(s.reverse()), [i[0]]), n.joinNormals = [].concat(a, _toConsumableArray(a.reverse()), [a[a.length - 1]]), n;
            }(e[0]), e = [g.geometry];
          }
          var x = function x(t, e) {
              return t < (e.length - 1) / 2 || t === e.length - 1;
            },
            b = this.wallMode ? [e] : Wp(e, 500);
          for (var _t148 = b.length - 1; _t148 >= 0; _t148--) {
            var _e165 = b[_t148];
            (0 === _e165.length || (v = _e165[0]).every(function (t) {
              return t.x <= 0;
            }) || v.every(function (t) {
              return t.x >= ds;
            }) || v.every(function (t) {
              return t.y <= 0;
            }) || v.every(function (t) {
              return t.y >= ds;
            })) && b.splice(_t148, 1);
          }
          var v;
          var _;
          if (h) _ = Cd(b, u, n);else {
            _ = [];
            var _iterator119 = _createForOfIteratorHelper(b),
              _step119;
            try {
              for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
                var _t149 = _step119.value;
                _.push({
                  polygon: _t149,
                  bounds: u
                });
              }
            } catch (err) {
              _iterator119.e(err);
            } finally {
              _iterator119.f();
            }
          }
          var w = p ? this.edgeRadius : 0,
            M = w > 0 && this.zoom < 17,
            A = function A(t, e) {
              if (0 === t.length) return !1;
              var r = t[t.length - 1];
              return e.x === r.x && e.y === r.y;
            };
          var _iterator120 = _createForOfIteratorHelper(_),
            _step120;
          try {
            for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
              var _step120$value = _step120.value,
                _t151 = _step120$value.polygon,
                _e167 = _step120$value.bounds;
              var _r143 = 0,
                _i104 = 0;
              var _iterator121 = _createForOfIteratorHelper(_t151),
                _step121;
              try {
                for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
                  var _e175 = _step121.value;
                  p && !_e175[0].equals(_e175[_e175.length - 1]) && _e175.push(_e175[0]), _i104 += p ? _e175.length - 1 : _e175.length;
                }
              } catch (err) {
                _iterator121.e(err);
              } finally {
                _iterator121.f();
              }
              var _s76 = this.segments.prepareSegment((p ? 5 : 4) * _i104, this.layoutVertexArray, this.indexArray);
              d.footprintSegIdx < 0 && (d.footprintSegIdx = this.footprintSegments.length), d.polygonSegIdx < 0 && (d.polygonSegIdx = this.polygonSegments.length);
              var _a61 = {
                  triangleArrayOffset: this.indexArray.length,
                  triangleCount: 0,
                  triangleSegIdx: this.segments.segments.length - 1
                },
                _o39 = new bd();
              if (_o39.vertexOffset = this.footprintVertices.length, _o39.indexOffset = 3 * this.footprintIndices.length, _o39.ringIndices = [], p) {
                var _i105 = [],
                  _a62 = [];
                _r143 = _s76.vertexLength;
                for (var _r144 = 0; _r144 < _t151.length; _r144++) {
                  var _u29 = _t151[_r144];
                  _u29.length && 0 !== _r144 && _a62.push(_i105.length / 2);
                  var _p13 = [];
                  var _f12 = void 0,
                    _d9 = void 0;
                  _f12 = _u29[1].sub(_u29[0])._perp()._unit(), _o39.ringIndices.push(_u29.length - 1);
                  for (var _t152 = 1; _t152 < _u29.length; _t152++) {
                    var _e168 = _u29[_t152],
                      _r145 = _u29[_t152 === _u29.length - 1 ? 1 : _t152 + 1],
                      _a63 = _e168.clone();
                    if (w) {
                      _d9 = _r145.sub(_e168)._perp()._unit();
                      var _t153 = _f12.add(_d9)._unit(),
                        _n93 = w * Math.min(4, 1 / (_f12.x * _t153.x + _f12.y * _t153.y));
                      _a63.x += _n93 * _t153.x, _a63.y += _n93 * _t153.y, _a63.x = Math.round(_a63.x), _a63.y = Math.round(_a63.y), _f12 = _d9;
                    }
                    if (!m || 0 !== w && !M || A(_p13, _a63) || _p13.push(_a63), md(this.layoutVertexArray, _a63.x, _a63.y, 0, 0, 1, 1, 0), this.wallMode) {
                      var _e169 = x(_t152, _u29);
                      yd(this.wallVertexArray, g.joinNormals[_t152], _e169, g.isPolygon);
                    }
                    _s76.vertexLength++, this.footprintVertices.emplaceBack(_e168.x, _e168.y), _i105.push(_e168.x, _e168.y), h && xd(this.layoutVertexExtArray, c.projectTilePoint(_a63.x, _a63.y, n), c.upVector(n, _a63.x, _a63.y));
                  }
                  m && (0 === w || M) && (0 !== _p13.length && A(_p13, _p13[0]) && _p13.pop(), this.groundEffect.addData(_p13, _e167, l));
                }
                var _u30 = Ip(_i105, _a62);
                for (var _t154 = 0; _t154 < _u30.length; _t154 += 3) this.footprintIndices.emplaceBack(_o39.vertexOffset + _u30[_t154 + 0], _o39.vertexOffset + _u30[_t154 + 1], _o39.vertexOffset + _u30[_t154 + 2]), this.indexArray.emplaceBack(_r143 + _u30[_t154], _r143 + _u30[_t154 + 2], _r143 + _u30[_t154 + 1]), _s76.primitiveLength++;
                _o39.indexCount += _u30.length, _o39.vertexCount += this.footprintVertices.length - _o39.vertexOffset;
              }
              for (var _i106 = 0; _i106 < _t151.length; _i106++) {
                var _a64 = _t151[_i106];
                f.startRing(d, _a64[0]);
                var _o40 = _a64.length > 4 && Bd(_a64[_a64.length - 2], _a64[0], _a64[1]),
                  _u31 = w ? kd(_a64[_a64.length - 2], _a64[0], _a64[1], w) : 0;
                var _y7 = [];
                var _b4 = void 0,
                  _v4 = void 0,
                  _4 = void 0;
                _v4 = _a64[1].sub(_a64[0])._perp()._unit();
                var _M3 = !0;
                for (var _t155 = 1, _i107 = 0; _t155 < _a64.length; _t155++) {
                  var _l34 = _a64[_t155 - 1],
                    _p14 = _a64[_t155];
                  var _S2 = _a64[_t155 === _a64.length - 1 ? 1 : _t155 + 1];
                  if (f.appendEdge(d, _p14, _l34), zd(_p14, _l34, _e167)) {
                    w && (_v4 = _S2.sub(_p14)._perp()._unit(), _M3 = !_M3);
                    continue;
                  }
                  var _I = _p14.sub(_l34)._perp(),
                    _T = _I.x / (Math.abs(_I.x) + Math.abs(_I.y)),
                    _k = _I.y > 0 ? 1 : 0,
                    _P = _l34.dist(_p14);
                  if (_i107 + _P > 32768 && (_i107 = 0), w) {
                    _4 = _S2.sub(_p14)._perp()._unit();
                    var _t156 = Pd(_l34, _p14, _S2, Td(_v4, _4), w);
                    isNaN(_t156) && (_t156 = 0);
                    var _e170 = _p14.sub(_l34)._unit();
                    _l34 = _l34.add(_e170.mult(_u31))._round(), _p14 = _p14.add(_e170.mult(-_t156))._round(), _u31 = _t156, _v4 = _4, m && this.zoom >= 17 && (A(_y7, _l34) || _y7.push(_l34), A(_y7, _p14) || _y7.push(_p14));
                  }
                  var _z = _s76.vertexLength,
                    _E = _a64.length > 4 && Bd(_l34, _p14, _S2);
                  var _B = Dd(_i107, _o40, _M3);
                  if (md(this.layoutVertexArray, _l34.x, _l34.y, _T, _k, 0, 0, _B), md(this.layoutVertexArray, _l34.x, _l34.y, _T, _k, 0, 1, _B), this.wallMode) {
                    var _e171 = x(_t155 - 1, _a64),
                      _r146 = g.joinNormals[_t155 - 1];
                    yd(this.wallVertexArray, _r146, !_e171, g.isPolygon), yd(this.wallVertexArray, _r146, !_e171, g.isPolygon);
                  }
                  if (_i107 += _P, _B = Dd(_i107, _E, !_M3), _o40 = _E, md(this.layoutVertexArray, _p14.x, _p14.y, _T, _k, 0, 0, _B), md(this.layoutVertexArray, _p14.x, _p14.y, _T, _k, 0, 1, _B), this.wallMode) {
                    var _e172 = x(_t155, _a64),
                      _r147 = g.joinNormals[_t155];
                    yd(this.wallVertexArray, _r147, !_e172, g.isPolygon), yd(this.wallVertexArray, _r147, !_e172, g.isPolygon);
                  }
                  if (_s76.vertexLength += 4, this.indexArray.emplaceBack(_z + 0, _z + 1, _z + 2), this.indexArray.emplaceBack(_z + 1, _z + 3, _z + 2), _s76.primitiveLength += 2, w) {
                    var _n94 = _r143 + (1 === _t155 ? _a64.length - 2 : _t155 - 2),
                      _i108 = 1 === _t155 ? _r143 : _n94 + 1;
                    if (this.indexArray.emplaceBack(_z + 1, _n94, _z + 3), this.indexArray.emplaceBack(_n94, _i108, _z + 3), _s76.primitiveLength += 2, void 0 === _b4 && (_b4 = _z), !zd(_S2, _a64[_t155], _e167)) {
                      var _e173 = _t155 === _a64.length - 1 ? _b4 : _s76.vertexLength;
                      this.indexArray.emplaceBack(_z + 2, _z + 3, _e173), this.indexArray.emplaceBack(_z + 3, _e173 + 1, _e173), this.indexArray.emplaceBack(_z + 3, _i108, _e173 + 1), _s76.primitiveLength += 3;
                    }
                    _M3 = !_M3;
                  }
                  if (h) {
                    var _t157 = this.layoutVertexExtArray,
                      _e174 = c.projectTilePoint(_l34.x, _l34.y, n),
                      _r148 = c.projectTilePoint(_p14.x, _p14.y, n),
                      _i109 = c.upVector(n, _l34.x, _l34.y),
                      _s77 = c.upVector(n, _p14.x, _p14.y);
                    xd(_t157, _e174, _i109), xd(_t157, _e174, _i109), xd(_t157, _r148, _s77), xd(_t157, _r148, _s77);
                  }
                }
                p && (_r143 += _a64.length - 1), m && w && this.zoom >= 17 && (0 !== _y7.length && A(_y7, _y7[0]) && _y7.pop(), this.groundEffect.addData(_y7, _e167, l, w > 0));
              }
              this.footprintSegments.push(_o39), _a61.triangleCount = this.indexArray.length - _a61.triangleArrayOffset, this.polygonSegments.push(_a61), ++d.footprintSegLen, ++d.polygonSegLen;
            }
          } catch (err) {
            _iterator120.e(err);
          } finally {
            _iterator120.f();
          }
          if (d.vertexCount = this.layoutVertexArray.length - d.vertexArrayOffset, d.groundVertexCount = this.groundEffect.vertexArray.length - d.groundVertexArrayOffset, 0 !== d.vertexCount) {
            if (d.centroidXY = f.borders ? fd : this.encodeCentroid(f, d), this.centroidData.push(d), f.borders) {
              this.featuresOnBorder.push(f);
              var _t150 = this.featuresOnBorder.length - 1;
              for (var _e166 = 0; _e166 < f.borders.length; _e166++) f.borders[_e166][0] !== Number.MAX_VALUE && this.borderFeatureIndices[_e166].push(_t150);
            }
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, s, n, o), this.groundEffect.addPaintPropertiesData(t, r, i, s, n, o), this.maxHeight = Math.max(this.maxHeight, y);
          }
        }
      }, {
        key: "sortBorders",
        value: function sortBorders() {
          var _this26 = this;
          var _loop6 = function _loop6(_t158) {
            _this26.borderFeatureIndices[_t158].sort(function (e, r) {
              return _this26.featuresOnBorder[e].borders[_t158][0] - _this26.featuresOnBorder[r].borders[_t158][0];
            });
          };
          for (var _t158 = 0; _t158 < this.borderFeatureIndices.length; _t158++) {
            _loop6(_t158);
          }
        }
      }, {
        key: "splitToSubtiles",
        value: function splitToSubtiles() {
          var t = [];
          for (var _e176 = 0; _e176 < this.centroidData.length; _e176++) {
            var _r149 = this.centroidData[_e176],
              _n95 = +(_r149.min.y + _r149.max.y > ds),
              _i110 = 2 * _n95 + (+(_r149.min.x + _r149.max.x > ds) ^ _n95);
            for (var _n96 = 0; _n96 < _r149.polygonSegLen; _n96++) {
              var _s78 = _r149.polygonSegIdx + _n96;
              t.push({
                centroidIdx: _e176,
                subtile: _i110,
                polygonSegmentIdx: _s78,
                triangleSegmentIdx: this.polygonSegments[_s78].triangleSegIdx
              });
            }
          }
          var e = new tu();
          t.sort(function (t, e) {
            return t.triangleSegmentIdx === e.triangleSegmentIdx ? t.subtile - e.subtile : t.triangleSegmentIdx - e.triangleSegmentIdx;
          });
          var r = 0,
            n = 0,
            i = 0;
          for (var _i111 = 0, _t159 = t; _i111 < _t159.length; _i111++) {
            var _e177 = _t159[_i111];
            if (_e177.triangleSegmentIdx !== r) break;
            i++;
          }
          var s = t.length;
          for (; n !== t.length;) {
            r = t[n].triangleSegmentIdx;
            var _a65 = 0,
              _o41 = n,
              _l35 = n;
            for (var _e178 = _o41; _e178 < i && t[_e178].subtile === _a65; _e178++) _l35++;
            for (; _o41 !== i;) {
              var _n97 = t[_o41];
              _a65 = _n97.subtile;
              var _s79 = this.centroidData[_n97.centroidIdx].min.clone(),
                _u32 = this.centroidData[_n97.centroidIdx].max.clone(),
                _c23 = {
                  vertexOffset: this.segments.segments[r].vertexOffset,
                  primitiveOffset: e.length,
                  vertexLength: this.segments.segments[r].vertexLength,
                  primitiveLength: 0,
                  sortKey: void 0,
                  vaos: {}
                };
              for (var _r150 = _o41; _r150 < _l35; _r150++) {
                var _n98 = t[_r150],
                  _i112 = this.polygonSegments[_n98.polygonSegmentIdx],
                  _a66 = this.centroidData[_n98.centroidIdx].min,
                  _o42 = this.centroidData[_n98.centroidIdx].max,
                  _l36 = this.indexArray.uint16;
                for (var _t160 = _i112.triangleArrayOffset; _t160 < _i112.triangleArrayOffset + _i112.triangleCount; _t160++) e.emplaceBack(_l36[3 * _t160], _l36[3 * _t160 + 1], _l36[3 * _t160 + 2]);
                _c23.primitiveLength += _i112.triangleCount, _s79.x = Math.min(_s79.x, _a66.x), _s79.y = Math.min(_s79.y, _a66.y), _u32.x = Math.max(_u32.x, _o42.x), _u32.y = Math.max(_u32.y, _o42.y);
              }
              _c23.primitiveLength > 0 && this.triangleSubSegments.push({
                segment: _c23,
                min: _s79,
                max: _u32
              }), _o41 = _l35;
              for (var _e179 = _o41; _e179 < i && t[_e179].subtile === t[_o41].subtile; _e179++) _l35++;
            }
            n = i;
            for (var _e180 = n; _e180 < s && t[_e180].triangleSegmentIdx === t[n].triangleSegmentIdx; _e180++) i++;
          }
          e._trim(), this.indexArray = e;
        }
      }, {
        key: "getVisibleSegments",
        value: function getVisibleSegments(t, e, r) {
          var n = new ku();
          if (this.wallMode) {
            var _iterator122 = _createForOfIteratorHelper(this.triangleSubSegments),
              _step122;
            try {
              for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
                var _t161 = _step122.value;
                n.segments.push(_t161.segment);
              }
            } catch (err) {
              _iterator122.e(err);
            } finally {
              _iterator122.f();
            }
            return n;
          }
          var i = 0,
            s = 0;
          var a = 1 << t.canonical.z;
          if (e) {
            var _r151 = e.getMinMaxForTile(t);
            _r151 && (i = _r151.min, s = _r151.max);
          }
          s += this.maxHeight;
          var o = t.toUnwrapped();
          var l;
          var u = [o.canonical.x / a + o.wrap, o.canonical.y / a],
            c = [(o.canonical.x + 1) / a + o.wrap, (o.canonical.y + 1) / a],
            h = function h(t, e, r) {
              return [t[0] * (1 - r[0]) + e[0] * r[0], t[1] * (1 - r[1]) + e[1] * r[1]];
            },
            p = [],
            f = [];
          var _iterator123 = _createForOfIteratorHelper(this.triangleSubSegments),
            _step123;
          try {
            for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
              var _t162 = _step123.value;
              p[0] = _t162.min.x / ds, p[1] = _t162.min.y / ds, f[0] = _t162.max.x / ds, f[1] = _t162.max.y / ds;
              var _e181 = h(u, c, p),
                _a67 = h(u, c, f);
              if (0 === new kh([_e181[0], _e181[1], i], [_a67[0], _a67[1], s]).intersectsPrecise(r)) {
                l && (n.segments.push(l), l = void 0);
                continue;
              }
              var _o43 = _t162.segment;
              l && l.vertexOffset !== _o43.vertexOffset && (n.segments.push(l), l = void 0), l ? (l.vertexLength += _o43.vertexLength, l.primitiveLength += _o43.primitiveLength) : l = {
                vertexOffset: _o43.vertexOffset,
                primitiveLength: _o43.primitiveLength,
                vertexLength: _o43.vertexLength,
                primitiveOffset: _o43.primitiveOffset,
                sortKey: void 0,
                vaos: {}
              };
            }
          } catch (err) {
            _iterator123.e(err);
          } finally {
            _iterator123.f();
          }
          return l && n.segments.push(l), n;
        }
      }, {
        key: "encodeCentroid",
        value: function encodeCentroid(t, e) {
          var r = t.centroid(),
            n = e.span(),
            i = Math.min(7, Math.round(n.x * this.tileToMeter / 10)),
            s = Math.min(7, Math.round(n.y * this.tileToMeter / 10));
          return new je(We(r.x, 1, ds - 1) << 3 | i, We(r.y, 1, ds - 1) << 3 | s);
        }
      }, {
        key: "encodeBorderCentroid",
        value: function encodeBorderCentroid(t) {
          if (!t.borders) return new je(0, 0);
          var e = t.borders,
            r = Number.MAX_VALUE;
          if (e[0][0] !== r || e[1][0] !== r) {
            var _t163 = e[0][0] !== r ? 0 : 1;
            return new je(6 | (e[0][0] !== r ? 0 : 65528), (e[_t163][0] + e[_t163][1]) / 2 << 3 | 6);
          }
          {
            var _t164 = e[2][0] !== r ? 2 : 3;
            return new je((e[_t164][0] + e[_t164][1]) / 2 << 3 | 6, 6 | (e[2][0] !== r ? 0 : 65528));
          }
        }
      }, {
        key: "showCentroid",
        value: function showCentroid(t) {
          var e = this.centroidData[t.centroidDataIndex];
          e.flags &= dd, e.centroidXY.x = 0, e.centroidXY.y = 0, this.writeCentroidToBuffer(e);
        }
      }, {
        key: "writeCentroidToBuffer",
        value: function writeCentroidToBuffer(t) {
          this.groundEffect.updateHiddenByLandmark(t);
          var e = t.vertexArrayOffset,
            r = t.vertexCount + t.vertexArrayOffset,
            n = t.flags & dd ? fd : t.centroidXY,
            i = this.centroidVertexArray.geta_centroid_pos0(e);
          if (this.centroidVertexArray.geta_centroid_pos1(e) !== n.y || i !== n.x) {
            for (var _t165 = e; _t165 < r; ++_t165) this.centroidVertexArray.emplace(_t165, n.x, n.y);
            this.needsCentroidUpdate = !0;
          }
        }
      }, {
        key: "createCentroidsBuffer",
        value: function createCentroidsBuffer() {
          this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
          var _iterator124 = _createForOfIteratorHelper(this.centroidData),
            _step124;
          try {
            for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
              var _t166 = _step124.value;
              this.writeCentroidToBuffer(_t166);
            }
          } catch (err) {
            _iterator124.e(err);
          } finally {
            _iterator124.f();
          }
        }
      }, {
        key: "updateReplacement",
        value: function updateReplacement(t, e, r) {
          if (e.updateTime === this.replacementUpdateTime) return;
          this.replacementUpdateTime = e.updateTime;
          var n = e.getReplacementRegionsForTile(t.toUnwrapped());
          if (jf(this.activeReplacements, n)) return;
          if (this.activeReplacements = n, 0 === this.centroidVertexArray.length) this.createCentroidsBuffer();else {
            var _iterator125 = _createForOfIteratorHelper(this.centroidData),
              _step125;
            try {
              for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
                var _t167 = _step125.value;
                _t167.flags &= 2147483647;
              }
            } catch (err) {
              _iterator125.e(err);
            } finally {
              _iterator125.f();
            }
          }
          var i = [];
          var _iterator126 = _createForOfIteratorHelper(this.activeReplacements),
            _step126;
          try {
            for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
              var _e182 = _step126.value;
              if (_e182.order < r) continue;
              var _n99 = Math.pow(2, _e182.footprintTileId.canonical.z - t.canonical.z);
              var _iterator128 = _createForOfIteratorHelper(this.centroidData),
                _step128;
              try {
                for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
                  var _r152 = _step128.value;
                  if (!(_r152.flags & dd || _e182.min.x > _r152.max.x || _r152.min.x > _e182.max.x || _e182.min.y > _r152.max.y || _r152.min.y > _e182.max.y)) for (var _s80 = 0; _s80 < _r152.footprintSegLen; _s80++) {
                    var _a68 = this.footprintSegments[_r152.footprintSegIdx + _s80];
                    if (i.length = 0, Ld(this.footprintVertices, _a68.vertexOffset, _a68.vertexCount, _e182.footprintTileId.canonical, t.canonical, i), qf(_e182.footprint, i, this.footprintIndices.uint16, _a68.indexOffset, _a68.indexCount, -_a68.vertexOffset, -_n99)) {
                      _r152.flags |= dd;
                      break;
                    }
                  }
                }
              } catch (err) {
                _iterator128.e(err);
              } finally {
                _iterator128.f();
              }
            }
          } catch (err) {
            _iterator126.e(err);
          } finally {
            _iterator126.f();
          }
          var _iterator127 = _createForOfIteratorHelper(this.centroidData),
            _step127;
          try {
            for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
              var _t168 = _step127.value;
              this.writeCentroidToBuffer(_t168);
            }
          } catch (err) {
            _iterator127.e(err);
          } finally {
            _iterator127.f();
          }
          this.borderDoneWithNeighborZ = [-1, -1, -1, -1];
        }
      }, {
        key: "footprintContainsPoint",
        value: function footprintContainsPoint(t, e, r) {
          var n = !1;
          for (var _i113 = 0; _i113 < r.footprintSegLen; _i113++) {
            var _s81 = this.footprintSegments[r.footprintSegIdx + _i113];
            var _a69 = 0;
            var _iterator129 = _createForOfIteratorHelper(_s81.ringIndices),
              _step129;
            try {
              for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
                var _r153 = _step129.value;
                for (var _i114 = _a69, _o44 = _r153 + _a69 - 1; _i114 < _r153 + _a69; _o44 = _i114++) {
                  var _r154 = this.footprintVertices.int16[2 * (_i114 + _s81.vertexOffset) + 0],
                    _a70 = this.footprintVertices.int16[2 * (_i114 + _s81.vertexOffset) + 1],
                    _l37 = this.footprintVertices.int16[2 * (_o44 + _s81.vertexOffset) + 1];
                  _a70 > e != _l37 > e && t < (this.footprintVertices.int16[2 * (_o44 + _s81.vertexOffset) + 0] - _r154) * (e - _a70) / (_l37 - _a70) + _r154 && (n = !n);
                }
                _a69 = _r153;
              }
            } catch (err) {
              _iterator129.e(err);
            } finally {
              _iterator129.f();
            }
          }
          return n;
        }
      }, {
        key: "getHeightAtTileCoord",
        value: function getHeightAtTileCoord(t, e) {
          var r = Number.NEGATIVE_INFINITY,
            n = !0;
          var i = 4 * (t + ds) * ds + (e + ds);
          if (this.partLookup.hasOwnProperty(i)) {
            var _t169 = this.partLookup[i];
            return _t169 ? {
              height: _t169.height,
              hidden: !!(_t169.flags & dd)
            } : void 0;
          }
          var _iterator130 = _createForOfIteratorHelper(this.centroidData),
            _step130;
          try {
            for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
              var _s82 = _step130.value;
              t > _s82.max.x || _s82.min.x > t || e > _s82.max.y || _s82.min.y > e || this.footprintContainsPoint(t, e, _s82) && _s82 && _s82.height > r && (r = _s82.height, this.partLookup[i] = _s82, n = !!(_s82.flags & dd));
            }
          } catch (err) {
            _iterator130.e(err);
          } finally {
            _iterator130.f();
          }
          if (r !== Number.NEGATIVE_INFINITY) return {
            height: r,
            hidden: n
          };
          this.partLookup[i] = void 0;
        }
      }]);
      return Id;
    }();
    function Td(t, e) {
      var r = t.add(e)._unit();
      return t.x * r.x + t.y * r.y;
    }
    function kd(t, e, r, n) {
      var i = e.sub(t)._perp()._unit(),
        s = r.sub(e)._perp()._unit();
      return Pd(t, e, r, Td(i, s), n);
    }
    function Pd(t, e, r, n, i) {
      var s = Math.sqrt(1 - n * n);
      return Math.min(t.dist(e) / 3, e.dist(r) / 3, i * s / n);
    }
    function zd(t, e, r) {
      return t.x < r[0].x && e.x < r[0].x || t.x > r[1].x && e.x > r[1].x || t.y < r[0].y && e.y < r[0].y || t.y > r[1].y && e.y > r[1].y;
    }
    function Ed(t, e) {
      return t.x < e[0].x || t.x > e[1].x || t.y < e[0].y || t.y > e[1].y;
    }
    function Bd(t, e, r) {
      if (t.x < 0 || t.x >= ds || e.x < 0 || e.x >= ds || r.x < 0 || r.x >= ds) return !1;
      var n = r.sub(e),
        i = n.perp(),
        s = t.sub(e);
      return (n.x * s.x + n.y * s.y) / Math.sqrt((n.x * n.x + n.y * n.y) * (s.x * s.x + s.y * s.y)) > -.866 && i.x * s.x + i.y * s.y < 0;
    }
    function Dd(t, e, r) {
      var n = e ? 2 | t : -3 & t;
      return r ? 1 | n : -2 & n;
    }
    function Rd() {
      var t = Math.PI / 32,
        e = Math.tan(t),
        r = gc;
      return r * Math.sqrt(1 + 2 * e * e) - r;
    }
    function Cd(t, e, r) {
      var n = 1 << r.z,
        i = Rc(r.x / n),
        s = Rc((r.x + 1) / n),
        a = Cc(r.y / n),
        o = Cc((r.y + 1) / n);
      return function (t, e, r, n) {
        var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var s = arguments.length > 5 ? arguments[5] : undefined;
        var a = [];
        if (!t.length || !r || !n) return a;
        var o = function o(t, e) {
            var _iterator131 = _createForOfIteratorHelper(t),
              _step131;
            try {
              for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
                var _r155 = _step131.value;
                a.push({
                  polygon: _r155,
                  bounds: e
                });
              }
            } catch (err) {
              _iterator131.e(err);
            } finally {
              _iterator131.f();
            }
          },
          l = Math.ceil(Math.log2(r)),
          u = Math.ceil(Math.log2(n)),
          c = l - u,
          h = [];
        for (var _t170 = 0; _t170 < Math.abs(c); _t170++) h.push(c > 0 ? 0 : 1);
        for (var _t171 = 0; _t171 < Math.min(l, u); _t171++) h.push(0), h.push(1);
        var p = t;
        if (p = Df(p, e[0].y - i, e[1].y + i, 1), p = Df(p, e[0].x - i, e[1].x + i, 0), !p.length) return a;
        var f = [];
        for (h.length ? f.push({
          polygons: p,
          bounds: e,
          depth: 0
        }) : o(p, e); f.length;) {
          var _t172 = f.pop(),
            _e183 = _t172.depth,
            _r156 = h[_e183],
            _n100 = _t172.bounds[0],
            _a71 = _t172.bounds[1],
            _l38 = 0 === _r156 ? _n100.x : _n100.y,
            _u33 = 0 === _r156 ? _a71.x : _a71.y,
            _c24 = s ? s(_r156, _l38, _u33) : .5 * (_l38 + _u33),
            _p15 = Df(_t172.polygons, _l38 - i, _c24 + i, _r156),
            _d10 = Df(_t172.polygons, _c24 - i, _u33 + i, _r156);
          if (_p15.length) {
            var _t173 = [_n100, new je(0 === _r156 ? _c24 : _a71.x, 1 === _r156 ? _c24 : _a71.y)];
            h.length > _e183 + 1 ? f.push({
              polygons: _p15,
              bounds: _t173,
              depth: _e183 + 1
            }) : o(_p15, _t173);
          }
          if (_d10.length) {
            var _t174 = [new je(0 === _r156 ? _c24 : _n100.x, 1 === _r156 ? _c24 : _n100.y), _a71];
            h.length > _e183 + 1 ? f.push({
              polygons: _d10,
              bounds: _t174,
              depth: _e183 + 1
            }) : o(_d10, _t174);
          }
        }
        return a;
      }(t, e, Math.ceil((s - i) / 11.25), Math.ceil((a - o) / 11.25), 1, function (t, e, i) {
        if (0 === t) return .5 * (e + i);
        {
          var _t175 = Cc((r.y + e / ds) / n);
          return (Bc(.5 * (Cc((r.y + i / ds) / n) + _t175)) * n - r.y) * ds;
        }
      });
    }
    function Ld(t, e, r, n, i, s) {
      var a = Math.pow(2, n.z - i.z);
      for (var _o45 = 0; _o45 < r; _o45++) {
        var _r157 = t.int16[2 * (_o45 + e) + 0],
          _l39 = t.int16[2 * (_o45 + e) + 1];
        _r157 = (_r157 + i.x * ds) * a - n.x * ds, _l39 = (_l39 + i.y * ds) * a - n.y * ds, s.push(new je(_r157, _l39));
      }
    }
    var Vd, Fd;
    function Od(t, e) {
      return t.x * e.x + t.y * e.y;
    }
    function Ud(t, e) {
      if (1 === t.length) {
        var _r158 = 0;
        var _n101 = e[_r158++];
        var _i115;
        for (; !_i115 || _n101.equals(_i115);) if (_i115 = e[_r158++], !_i115) return 1 / 0;
        for (; _r158 < e.length; _r158++) {
          var _s83 = e[_r158],
            _a72 = t[0],
            _o46 = _i115.sub(_n101),
            _l40 = _s83.sub(_n101),
            _u34 = _a72.sub(_n101),
            _c25 = Od(_o46, _o46),
            _h14 = Od(_o46, _l40),
            _p16 = Od(_l40, _l40),
            _f13 = Od(_u34, _o46),
            _d11 = Od(_u34, _l40),
            _m9 = _c25 * _p16 - _h14 * _h14,
            _y8 = (_p16 * _f13 - _h14 * _d11) / _m9,
            _g6 = (_c25 * _d11 - _h14 * _f13) / _m9,
            _x7 = _n101.z * (1 - _y8 - _g6) + _i115.z * _y8 + _s83.z * _g6;
          if (isFinite(_x7)) return _x7;
        }
        return 1 / 0;
      }
      {
        var _t176 = 1 / 0;
        var _iterator132 = _createForOfIteratorHelper(e),
          _step132;
        try {
          for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
            var _r159 = _step132.value;
            _t176 = Math.min(_t176, _r159.z);
          }
        } catch (err) {
          _iterator132.e(err);
        } finally {
          _iterator132.f();
        }
        return _t176;
      }
    }
    function jd(t, e, r, n, i, s, a, o) {
      var l = a * i.getElevationAt(t, e, !0, !0),
        u = 0 !== s[0],
        c = u ? 0 === s[1] ? a * (s[0] / 7 - 450) : a * function (t, e, r) {
          var n = Math.floor(e[0] / 8),
            i = Math.floor(e[1] / 8),
            s = 10 * (e[0] - 8 * n),
            a = 10 * (e[1] - 8 * i),
            o = t.getElevationAt(n, i, !0, !0),
            l = t.getMeterToDEM(r),
            u = Math.floor(.5 * (s * l - 1)),
            c = Math.floor(.5 * (a * l - 1)),
            h = t.tileCoordToPixel(n, i),
            p = 2 * u + 1,
            f = 2 * c + 1,
            d = function (t, e, r, n, i) {
              return [t.getElevationAtPixel(e, r, !0), t.getElevationAtPixel(e + i, r, !0), t.getElevationAtPixel(e, r + i, !0), t.getElevationAtPixel(e + n, r + i, !0)];
            }(t, h.x - u, h.y - c, p, f),
            m = Math.abs(d[0] - d[1]),
            y = Math.abs(d[2] - d[3]),
            g = Math.abs(d[0] - d[2]) + Math.abs(d[1] - d[3]),
            x = Math.min(.25, .5 * l * (m + y) / p),
            b = Math.min(.25, .5 * l * g / f);
          return o + Math.max(x * s, b * a);
        }(i, s, o) : l;
      return {
        base: l + (0 === r) ? -1 : r,
        top: u ? Math.max(c + n, l + r + 2) : l + n
      };
    }
    So(Id, "FillExtrusionBucket", {
      omit: ["layers", "features"]
    }), So(vd, "PartData"), So(bd, "FootprintSegment"), So(_d, "BorderCentroidData"), So(Sd, "GroundEffect");
    var Nd = Rl([{
        name: "a_pos_normal",
        components: 2,
        type: "Int16"
      }, {
        name: "a_data",
        components: 4,
        type: "Uint8"
      }, {
        name: "a_linesofar",
        components: 1,
        type: "Float32"
      }], 4),
      $d = Nd.members,
      qd = Rl([{
        name: "a_packed",
        components: 4,
        type: "Float32"
      }]),
      Gd = qd.members,
      Xd = Rl([{
        name: "a_pattern_data",
        components: 3,
        type: "Float32"
      }]),
      Yd = Xd.members,
      Zd = Rl([{
        name: "a_pos_offset",
        components: 4,
        type: "Int16"
      }, {
        name: "a_tex_size",
        components: 4,
        type: "Uint16"
      }, {
        name: "a_pixeloffset",
        components: 4,
        type: "Int16"
      }], 4),
      Hd = Rl([{
        name: "a_globe_anchor",
        components: 3,
        type: "Int16"
      }, {
        name: "a_globe_normal",
        components: 3,
        type: "Float32"
      }], 4),
      Kd = Rl([{
        name: "a_projected_pos",
        components: 4,
        type: "Float32"
      }], 4);
    Rl([{
      name: "a_fade_opacity",
      components: 1,
      type: "Uint32"
    }], 4);
    var Wd = Rl([{
        name: "a_z_offset",
        components: 1,
        type: "Float32"
      }], 4),
      Jd = Rl([{
        name: "a_texb",
        components: 2,
        type: "Uint16"
      }]),
      Qd = Rl([{
        name: "a_placed",
        components: 2,
        type: "Uint8"
      }, {
        name: "a_shift",
        components: 2,
        type: "Float32"
      }]),
      tm = Rl([{
        name: "a_size_scale",
        components: 1,
        type: "Float32"
      }, {
        name: "a_padding",
        components: 2,
        type: "Float32"
      }, {
        name: "a_z_offset",
        components: 1,
        type: "Float32"
      }]);
    Rl([{
      type: "Int16",
      name: "projectedAnchorX"
    }, {
      type: "Int16",
      name: "projectedAnchorY"
    }, {
      type: "Int16",
      name: "projectedAnchorZ"
    }, {
      type: "Int16",
      name: "tileAnchorX"
    }, {
      type: "Int16",
      name: "tileAnchorY"
    }, {
      type: "Float32",
      name: "x1"
    }, {
      type: "Float32",
      name: "y1"
    }, {
      type: "Float32",
      name: "x2"
    }, {
      type: "Float32",
      name: "y2"
    }, {
      type: "Int16",
      name: "padding"
    }, {
      type: "Uint32",
      name: "featureIndex"
    }, {
      type: "Uint16",
      name: "sourceLayerIndex"
    }, {
      type: "Uint16",
      name: "bucketIndex"
    }]);
    var em = Rl([{
        name: "a_pos",
        components: 3,
        type: "Int16"
      }, {
        name: "a_anchor_pos",
        components: 2,
        type: "Int16"
      }, {
        name: "a_extrude",
        components: 2,
        type: "Int16"
      }], 4),
      rm = Rl([{
        name: "a_pos_2f",
        components: 2,
        type: "Float32"
      }, {
        name: "a_radius",
        components: 1,
        type: "Float32"
      }, {
        name: "a_flags",
        components: 2,
        type: "Int16"
      }], 4);
    Rl([{
      name: "triangle",
      components: 3,
      type: "Uint16"
    }]), Rl([{
      type: "Int16",
      name: "projectedAnchorX"
    }, {
      type: "Int16",
      name: "projectedAnchorY"
    }, {
      type: "Int16",
      name: "projectedAnchorZ"
    }, {
      type: "Float32",
      name: "tileAnchorX"
    }, {
      type: "Float32",
      name: "tileAnchorY"
    }, {
      type: "Uint16",
      name: "glyphStartIndex"
    }, {
      type: "Uint16",
      name: "numGlyphs"
    }, {
      type: "Uint32",
      name: "vertexStartIndex"
    }, {
      type: "Uint32",
      name: "lineStartIndex"
    }, {
      type: "Uint32",
      name: "lineLength"
    }, {
      type: "Uint16",
      name: "segment"
    }, {
      type: "Uint16",
      name: "lowerSize"
    }, {
      type: "Uint16",
      name: "upperSize"
    }, {
      type: "Float32",
      name: "lineOffsetX"
    }, {
      type: "Float32",
      name: "lineOffsetY"
    }, {
      type: "Uint8",
      name: "writingMode"
    }, {
      type: "Uint8",
      name: "placedOrientation"
    }, {
      type: "Uint8",
      name: "hidden"
    }, {
      type: "Uint32",
      name: "crossTileID"
    }, {
      type: "Int16",
      name: "associatedIconIndex"
    }, {
      type: "Uint8",
      name: "flipState"
    }]), Rl([{
      type: "Float32",
      name: "tileAnchorX"
    }, {
      type: "Float32",
      name: "tileAnchorY"
    }, {
      type: "Int16",
      name: "projectedAnchorX"
    }, {
      type: "Int16",
      name: "projectedAnchorY"
    }, {
      type: "Int16",
      name: "projectedAnchorZ"
    }, {
      type: "Int16",
      name: "rightJustifiedTextSymbolIndex"
    }, {
      type: "Int16",
      name: "centerJustifiedTextSymbolIndex"
    }, {
      type: "Int16",
      name: "leftJustifiedTextSymbolIndex"
    }, {
      type: "Int16",
      name: "verticalPlacedTextSymbolIndex"
    }, {
      type: "Int16",
      name: "placedIconSymbolIndex"
    }, {
      type: "Int16",
      name: "verticalPlacedIconSymbolIndex"
    }, {
      type: "Uint16",
      name: "key"
    }, {
      type: "Uint16",
      name: "textBoxStartIndex"
    }, {
      type: "Uint16",
      name: "textBoxEndIndex"
    }, {
      type: "Uint16",
      name: "verticalTextBoxStartIndex"
    }, {
      type: "Uint16",
      name: "verticalTextBoxEndIndex"
    }, {
      type: "Uint16",
      name: "iconBoxStartIndex"
    }, {
      type: "Uint16",
      name: "iconBoxEndIndex"
    }, {
      type: "Uint16",
      name: "verticalIconBoxStartIndex"
    }, {
      type: "Uint16",
      name: "verticalIconBoxEndIndex"
    }, {
      type: "Uint16",
      name: "featureIndex"
    }, {
      type: "Uint16",
      name: "numHorizontalGlyphVertices"
    }, {
      type: "Uint16",
      name: "numVerticalGlyphVertices"
    }, {
      type: "Uint16",
      name: "numIconVertices"
    }, {
      type: "Uint16",
      name: "numVerticalIconVertices"
    }, {
      type: "Uint16",
      name: "useRuntimeCollisionCircles"
    }, {
      type: "Uint32",
      name: "crossTileID"
    }, {
      type: "Float32",
      components: 2,
      name: "textOffset"
    }, {
      type: "Float32",
      name: "collisionCircleDiameter"
    }, {
      type: "Float32",
      name: "zOffset"
    }, {
      type: "Uint8",
      name: "hasIconTextFit"
    }]), Rl([{
      type: "Float32",
      name: "offsetX"
    }]), Rl([{
      type: "Int16",
      name: "x"
    }, {
      type: "Int16",
      name: "y"
    }]);
    var nm = /*#__PURE__*/function () {
      function nm(t, e) {
        _classCallCheck(this, nm);
        this.width = t, this.height = e, this.nextRow = 0, this.image = new yp({
          width: t,
          height: e
        }), this.positions = {}, this.uploaded = !1;
      }
      _createClass(nm, [{
        key: "getDash",
        value: function getDash(t, e) {
          var r = this.getKey(t, e);
          return this.positions[r];
        }
      }, {
        key: "trim",
        value: function trim() {
          var t = this.width,
            e = this.height = ar(this.nextRow);
          this.image.resize({
            width: t,
            height: e
          });
        }
      }, {
        key: "getKey",
        value: function getKey(t, e) {
          return t.join(",") + e;
        }
      }, {
        key: "getDashRanges",
        value: function getDashRanges(t, e, r) {
          var n = [];
          var i = t.length % 2 == 1 ? -t[t.length - 1] * r : 0,
            s = t[0] * r,
            a = !0;
          n.push({
            left: i,
            right: s,
            isDash: a,
            zeroLength: 0 === t[0]
          });
          var o = t[0];
          for (var _e184 = 1; _e184 < t.length; _e184++) {
            a = !a;
            var _l41 = t[_e184];
            i = o * r, o += _l41, s = o * r, n.push({
              left: i,
              right: s,
              isDash: a,
              zeroLength: 0 === _l41
            });
          }
          return n;
        }
      }, {
        key: "addRoundDash",
        value: function addRoundDash(t, e, r) {
          var n = e / 2;
          for (var _e185 = -r; _e185 <= r; _e185++) {
            var _i116 = this.width * (this.nextRow + r + _e185);
            var _s84 = 0,
              _a73 = t[_s84];
            for (var _o47 = 0; _o47 < this.width; _o47++) {
              _o47 / _a73.right > 1 && (_a73 = t[++_s84]);
              var _l42 = Math.abs(_o47 - _a73.left),
                _u35 = Math.abs(_o47 - _a73.right),
                _c26 = Math.min(_l42, _u35);
              var _h15 = void 0;
              var _p17 = _e185 / r * (n + 1);
              if (_a73.isDash) {
                var _t177 = n - Math.abs(_p17);
                _h15 = Math.sqrt(_c26 * _c26 + _t177 * _t177);
              } else _h15 = n - Math.sqrt(_c26 * _c26 + _p17 * _p17);
              this.image.data[_i116 + _o47] = Math.max(0, Math.min(255, _h15 + 128));
            }
          }
        }
      }, {
        key: "addRegularDash",
        value: function addRegularDash(t, e) {
          for (var _e186 = t.length - 1; _e186 >= 0; --_e186) {
            var _r160 = t[_e186],
              _n102 = t[_e186 + 1];
            _r160.zeroLength ? t.splice(_e186, 1) : _n102 && _n102.isDash === _r160.isDash && (_n102.left = _r160.left, t.splice(_e186, 1));
          }
          var r = t[0],
            n = t[t.length - 1];
          r.isDash === n.isDash && (r.left = n.left - this.width, n.right = r.right + this.width);
          var i = this.width * this.nextRow;
          var s = 0,
            a = t[s];
          for (var _r161 = 0; _r161 < this.width; _r161++) {
            _r161 / a.right > 1 && (a = t[++s]);
            var _n103 = Math.abs(_r161 - a.left),
              _o48 = Math.abs(_r161 - a.right),
              _l43 = Math.min(_n103, _o48);
            this.image.data[i + _r161] = Math.max(0, Math.min(255, (a.isDash ? _l43 : -_l43) + e + 128));
          }
        }
      }, {
        key: "addDash",
        value: function addDash(t, e) {
          var r = this.getKey(t, e);
          if (this.positions[r]) return this.positions[r];
          var n = "round" === e,
            i = n ? 7 : 0,
            s = 2 * i + 1;
          if (this.nextRow + s > this.height) return dr("LineAtlas out of space"), null;
          0 === t.length && t.push(1);
          var a = 0;
          for (var _e187 = 0; _e187 < t.length; _e187++) t[_e187] < 0 && (dr("Negative value is found in line dasharray, replacing values with 0"), t[_e187] = 0), a += t[_e187];
          if (0 !== a) {
            var _r162 = this.width / a,
              _s85 = this.getDashRanges(t, this.width, _r162);
            n ? this.addRoundDash(_s85, _r162, i) : this.addRegularDash(_s85, "square" === e ? .5 * _r162 : 0);
          }
          var o = this.nextRow + i;
          this.nextRow += s;
          var l = {
            tl: [o, i],
            br: [a, 0]
          };
          return this.positions[r] = l, l;
        }
      }]);
      return nm;
    }();
    So(nm, "LineAtlas");
    var im = zf.types,
      sm = Math.cos(Math.PI / 180 * 37.5),
      am = Math.cos(Math.PI / 180 * 5);
    var om = /*#__PURE__*/function () {
      function om(t) {
        var _this27 = this;
        _classCallCheck(this, om);
        this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function (t) {
          return t.fqid;
        }), this.index = t.index, this.projection = t.projection, this.hasPattern = !1, this.hasZOffset = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach(function (t) {
          _this27.gradients[t.id] = {};
        }), this.layoutVertexArray = new Ul(), this.layoutVertexArray2 = new jl(), this.patternVertexArray = new Nl(), this.indexArray = new tu(), this.programConfigurations = new ec(t.layers, {
          zoom: t.zoom,
          lut: t.lut
        }), this.segments = new ku(), this.maxLineLength = 0, this.zOffsetVertexArray = new nu(), this.stateDependentLayerIds = this.layers.filter(function (t) {
          return t.isStateDependent();
        }).map(function (t) {
          return t.id;
        }), this.tessellationStep = t.tessellationStep ? t.tessellationStep : ds / 64;
      }
      _createClass(om, [{
        key: "updateFootprints",
        value: function updateFootprints(t, e) {}
      }, {
        key: "populate",
        value: function populate(t, e, r, n) {
          this.hasPattern = Qp("line", this.layers, e);
          var i = this.layers[0].layout.get("line-sort-key"),
            s = this.layers[0].layout.get("line-z-offset");
          this.hasZOffset = !s.isConstant() || !!s.constantOr(0);
          var a = [];
          var _iterator133 = _createForOfIteratorHelper(t),
            _step133;
          try {
            for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
              var _step133$value = _step133.value,
                _e188 = _step133$value.feature,
                _s87 = _step133$value.id,
                _o49 = _step133$value.index,
                _l44 = _step133$value.sourceLayerIndex;
              var _t179 = this.layers[0]._featureFilter.needGeometry,
                _u36 = Wc(_e188, _t179);
              if (!this.layers[0]._featureFilter.filter(new Wo(this.zoom), _u36, r)) continue;
              var _c27 = i ? i.evaluate(_u36, {}, r) : void 0,
                _h16 = {
                  id: _s87,
                  properties: _e188.properties,
                  type: _e188.type,
                  sourceLayerIndex: _l44,
                  index: _o49,
                  geometry: _t179 ? _u36.geometry : Kc(_e188, r, n),
                  patterns: {},
                  sortKey: _c27
                };
              a.push(_h16);
            }
          } catch (err) {
            _iterator133.e(err);
          } finally {
            _iterator133.f();
          }
          i && a.sort(function (t, e) {
            return t.sortKey - e.sortKey;
          });
          var o = e.lineAtlas,
            l = e.featureIndex,
            u = this.addConstantDashes(o);
          for (var _i117 = 0, _a74 = a; _i117 < _a74.length; _i117++) {
            var _n104 = _a74[_i117];
            var _i118 = _n104.geometry,
              _s86 = _n104.index,
              _a75 = _n104.sourceLayerIndex;
            if (u && this.addFeatureDashes(_n104, o), this.hasPattern) {
              var _t178 = tf("line", this.layers, _n104, this.zoom, e);
              this.patternFeatures.push(_t178);
            } else this.addFeature(_n104, _i118, _s86, r, o.positions, e.availableImages, e.brightness);
            l.insert(t[_s86].feature, _i118, _s86, _a75, this.index);
          }
        }
      }, {
        key: "addConstantDashes",
        value: function addConstantDashes(t) {
          var e = !1;
          var _iterator134 = _createForOfIteratorHelper(this.layers),
            _step134;
          try {
            for (_iterator134.s(); !(_step134 = _iterator134.n()).done;) {
              var _r163 = _step134.value;
              var _n105 = _r163.paint.get("line-dasharray").value,
                _i119 = _r163.layout.get("line-cap").value;
              if ("constant" !== _n105.kind || "constant" !== _i119.kind) e = !0;else {
                var _e189 = _i119.value,
                  _r164 = _n105.value;
                if (!_r164) continue;
                t.addDash(_r164, _e189);
              }
            }
          } catch (err) {
            _iterator134.e(err);
          } finally {
            _iterator134.f();
          }
          return e;
        }
      }, {
        key: "addFeatureDashes",
        value: function addFeatureDashes(t, e) {
          var r = this.zoom;
          var _iterator135 = _createForOfIteratorHelper(this.layers),
            _step135;
          try {
            for (_iterator135.s(); !(_step135 = _iterator135.n()).done;) {
              var _n106 = _step135.value;
              var _i120 = _n106.paint.get("line-dasharray").value,
                _s88 = _n106.layout.get("line-cap").value;
              if ("constant" === _i120.kind && "constant" === _s88.kind) continue;
              var _a76 = void 0,
                _o50 = void 0;
              if ("constant" === _i120.kind) {
                if (_a76 = _i120.value, !_a76) continue;
              } else _a76 = _i120.evaluate({
                zoom: r
              }, t);
              _o50 = "constant" === _s88.kind ? _s88.value : _s88.evaluate({
                zoom: r
              }, t), e.addDash(_a76, _o50), t.patterns[_n106.id] = e.getKey(_a76, _o50);
            }
          } catch (err) {
            _iterator135.e(err);
          } finally {
            _iterator135.f();
          }
        }
      }, {
        key: "update",
        value: function update(t, e, r, n, i) {
          var s = 0 !== Object.keys(t).length;
          s && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(t, e, s ? this.stateDependentLayers : this.layers, r, n, i);
        }
      }, {
        key: "addFeatures",
        value: function addFeatures(t, e, r, n, i, s) {
          var _iterator136 = _createForOfIteratorHelper(this.patternFeatures),
            _step136;
          try {
            for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
              var _t180 = _step136.value;
              this.addFeature(_t180, _t180.geometry, _t180.index, e, r, n, s);
            }
          } catch (err) {
            _iterator136.e(err);
          } finally {
            _iterator136.f();
          }
        }
      }, {
        key: "isEmpty",
        value: function isEmpty() {
          return 0 === this.layoutVertexArray.length;
        }
      }, {
        key: "uploadPending",
        value: function uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
      }, {
        key: "upload",
        value: function upload(t) {
          this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t.createVertexBuffer(this.layoutVertexArray2, Gd)), 0 !== this.patternVertexArray.length && (this.patternVertexBuffer = t.createVertexBuffer(this.patternVertexArray, Yd)), !this.zOffsetVertexBuffer && this.zOffsetVertexArray.length > 0 && (this.zOffsetVertexBuffer = t.createVertexBuffer(this.zOffsetVertexArray, Wd.members, !0)), this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, $d), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.layoutVertexBuffer && (this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }
      }, {
        key: "lineFeatureClips",
        value: function lineFeatureClips(t) {
          if (t.properties && t.properties.hasOwnProperty("mapbox_clip_start") && t.properties.hasOwnProperty("mapbox_clip_end")) return {
            start: +t.properties.mapbox_clip_start,
            end: +t.properties.mapbox_clip_end
          };
        }
      }, {
        key: "addFeature",
        value: function addFeature(t, e, r, n, i, s, a) {
          var o = this.layers[0].layout,
            l = o.get("line-join").evaluate(t, {}),
            u = o.get("line-cap").evaluate(t, {}),
            c = o.get("line-miter-limit"),
            h = o.get("line-round-limit");
          this.lineClips = this.lineFeatureClips(t);
          var _iterator137 = _createForOfIteratorHelper(e),
            _step137;
          try {
            for (_iterator137.s(); !(_step137 = _iterator137.n()).done;) {
              var _r165 = _step137.value;
              this.addLine(_r165, t, n, l, u, c, h);
            }
          } catch (err) {
            _iterator137.e(err);
          } finally {
            _iterator137.f();
          }
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, i, s, n, a);
        }
      }, {
        key: "addLine",
        value: function addLine(t, e, r, n, i, s, a) {
          this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineSoFar = 0, this.currentVertex = void 0;
          var o = {
              zoom: this.zoom,
              lineProgress: void 0
            },
            l = this.layers[0].layout,
            u = "none" === n;
          if (this.patternJoinNone = this.hasPattern && u, this.segmentStart = 0, this.segmentStartf32 = 0, this.segmentPoints = [], this.lineClips) {
            this.lineClipsArray.push(this.lineClips);
            for (var _e190 = 0; _e190 < t.length - 1; _e190++) this.totalDistance += t[_e190].dist(t[_e190 + 1]);
            this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
          }
          var c = "Polygon" === im[e.type];
          var h = t.length;
          for (; h >= 2 && t[h - 1].equals(t[h - 2]);) h--;
          var p = 0;
          for (; p < h - 1 && t[p].equals(t[p + 1]);) p++;
          if (h < (c ? 3 : 2)) return;
          "bevel" === n && (s = 1.05);
          var f = this.overscaling <= 16 ? 15 * ds / (512 * this.overscaling) : 0,
            d = this.segments.prepareSegment(10 * h, this.layoutVertexArray, this.indexArray);
          var m, y, g, x, b, v;
          this.e1 = this.e2 = -1, c && (m = t[h - 2], b = t[p].sub(m)._unit()._perp());
          for (var _r166 = p; _r166 < h; _r166++) {
            if (g = _r166 === h - 1 ? c ? t[p + 1] : void 0 : t[_r166 + 1], g && t[_r166].equals(g)) continue;
            if (b && (x = b), m && (y = m), m = t[_r166], this.hasZOffset) {
              var _t181 = l.get("line-z-offset").value;
              if ("constant" === _t181.kind) v = _t181.value;else {
                if (this.lineClips) {
                  var _t182 = this.totalDistance / (this.lineClips.end - this.lineClips.start);
                  o.lineProgress = (_t182 * this.lineClips.start + this.distance + (y ? y.dist(m) : 0)) / _t182;
                } else dr("line-z-offset evaluation for ".concat(this.layerIds[0], " requires enabling 'lineMetrics' for the source.")), o.lineProgress = 0;
                v = _t181.evaluate(o, e);
              }
              v = v || 0;
            }
            b = g ? g.sub(m)._unit()._perp() : x, x = x || b;
            var _5 = y && g;
            var _w3 = _5 ? n : c || u ? "butt" : i;
            var _M4 = x.x * b.x + x.y * b.y;
            if (u) {
              var _t183 = function _t183(t) {
                if (t.patternJoinNone) {
                  var _e191 = t.segmentPoints.length / 2,
                    _r167 = t.lineSoFar - t.segmentStart;
                  for (var _n107 = 0; _n107 < _e191; ++_n107) {
                    var _e192 = t.segmentPoints[2 * _n107 + 1],
                      _i121 = Math.round(t.segmentPoints[2 * _n107]) + .5 + .25 * _e192;
                    t.patternVertexArray.emplaceBack(_i121, _r167, t.segmentStart), t.patternVertexArray.emplaceBack(_i121, _r167, t.segmentStart);
                  }
                  t.segmentPoints.length = 0;
                }
                t.e1 = t.e2 = -1;
              };
              if (_5 && _M4 < am) {
                this.updateDistance(y, m), this.addCurrentVertex(m, x, 1, 1, d, v), _t183(this), this.addCurrentVertex(m, b, -1, -1, d, v);
                continue;
              }
              if (y) {
                if (!g) {
                  this.updateDistance(y, m), this.addCurrentVertex(m, x, 1, 1, d, v), _t183(this);
                  continue;
                }
                _w3 = "miter";
              }
            }
            var _A3 = x.add(b);
            0 === _A3.x && 0 === _A3.y || _A3._unit();
            var _S3 = _A3.x * b.x + _A3.y * b.y,
              _I2 = 0 !== _S3 ? 1 / _S3 : 1 / 0,
              _T2 = 2 * Math.sqrt(2 - 2 * _S3),
              _k2 = _S3 < sm && y && g,
              _P2 = x.x * b.y - x.y * b.x > 0;
            if (_k2 && _r166 > p) {
              var _t184 = m.dist(y);
              if (_t184 > 2 * f) {
                var _e193 = m.sub(m.sub(y)._mult(f / _t184)._round());
                this.updateDistance(y, _e193), this.addCurrentVertex(_e193, x, 0, 0, d, v), y = _e193;
              }
            }
            if (_5 && "round" === _w3 && (_I2 < a ? _w3 = "miter" : _I2 <= 2 && (_w3 = "fakeround")), "miter" === _w3 && _I2 > s && (_w3 = "bevel"), "bevel" === _w3 && (_I2 > 2 && (_w3 = "flipbevel"), _I2 < s && (_w3 = "miter")), y && this.updateDistance(y, m), "miter" === _w3) _A3._mult(_I2), this.addCurrentVertex(m, _A3, 0, 0, d, v);else if ("flipbevel" === _w3) {
              if (_I2 > 100) _A3 = b.mult(-1);else {
                var _t185 = _I2 * x.add(b).mag() / x.sub(b).mag();
                _A3._perp()._mult(_t185 * (_P2 ? -1 : 1));
              }
              this.addCurrentVertex(m, _A3, 0, 0, d, v), this.addCurrentVertex(m, _A3.mult(-1), 0, 0, d, v);
            } else if ("bevel" === _w3 || "fakeround" === _w3) {
              var _t186 = -Math.sqrt(_I2 * _I2 - 1),
                _e194 = _P2 ? _t186 : 0,
                _r168 = _P2 ? 0 : _t186;
              if (y && this.addCurrentVertex(m, x, _e194, _r168, d, v), "fakeround" === _w3) {
                var _t187 = Math.round(180 * _T2 / Math.PI / 20);
                for (var _e195 = 1; _e195 < _t187; _e195++) {
                  var _r169 = _e195 / _t187;
                  if (.5 !== _r169) {
                    var _t188 = _r169 - .5;
                    _r169 += _r169 * _t188 * (_r169 - 1) * ((1.0904 + _M4 * (_M4 * (3.55645 - 1.43519 * _M4) - 3.2452)) * _t188 * _t188 + (.848013 + _M4 * (.215638 * _M4 - 1.06021)));
                  }
                  var _n108 = b.sub(x)._mult(_r169)._add(x)._unit()._mult(_P2 ? -1 : 1);
                  this.addHalfVertex(m, _n108.x, _n108.y, !1, _P2, 0, d, v);
                }
              }
              g && this.addCurrentVertex(m, b, -_e194, -_r168, d, v);
            } else "butt" === _w3 ? this.addCurrentVertex(m, _A3, 0, 0, d, v) : "square" === _w3 ? (y || this.addCurrentVertex(m, _A3, -1, -1, d, v), this.addCurrentVertex(m, _A3, 0, 0, d, v), y && this.addCurrentVertex(m, _A3, 1, 1, d, v)) : "round" === _w3 && (y && (this.addCurrentVertex(m, x, 0, 0, d, v), this.addCurrentVertex(m, x, 1, 1, d, v, !0)), g && (this.addCurrentVertex(m, b, -1, -1, d, v, !0), this.addCurrentVertex(m, b, 0, 0, d, v)));
            if (_k2 && _r166 < h - 1) {
              var _t189 = m.dist(g);
              if (_t189 > 2 * f) {
                var _e196 = m.add(g.sub(m)._mult(f / _t189)._round());
                this.updateDistance(m, _e196), this.addCurrentVertex(_e196, b, 0, 0, d, v), m = _e196;
              }
            }
          }
        }
      }, {
        key: "addVerticesTo",
        value: function addVerticesTo(t, e, r, n, i, s, a, o, l, u) {
          var c = (e.w - t.w) / this.tessellationStep | 0;
          if (c > 1) {
            this.lineSoFar = t.w;
            var _h17 = (e.x - t.x) / c,
              _p18 = (e.y - t.y) / c,
              _f14 = (e.z - t.z) / c,
              _d12 = (e.w - t.w) / c;
            for (var _e197 = 1; _e197 < c; ++_e197) t.x += _h17, t.y += _p18, t.z += _f14, this.lineSoFar += _d12, this.addHalfVertex(t, r, n, u, !1, a, l, t.z), this.addHalfVertex(t, i, s, u, !0, -o, l, t.z);
          }
          this.lineSoFar = e.w, this.addHalfVertex(e, r, n, u, !1, a, l, e.z), this.addHalfVertex(e, i, s, u, !0, -o, l, e.z);
        }
      }, {
        key: "addCurrentVertex",
        value: function addCurrentVertex(t, e, r, n, i, s) {
          var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
          var o = e.x + e.y * r,
            l = e.y - e.x * r,
            u = e.y * n - e.x,
            c = -e.y - e.x * n;
          if (null != s) {
            var _e198 = -10,
              _h18 = ds + 10,
              _p19 = s,
              _f15 = new Bf(t.x, t.y, _p19, this.lineSoFar),
              _d13 = lm(t, _e198, _h18),
              _m10 = this.lineSoFar;
            if (this.currentVertex) {
              if (_d13) {
                var _s89 = this.currentVertexIsOutside,
                  _f16 = this.currentVertex,
                  _d14 = new Bf(t.x, t.y, _p19, this.lineSoFar);
                Cf(_f16, _d14, _e198, _h18), lm(_d14, _e198, _h18) || (_s89 && (this.e1 = this.e2 = -1, this.lineSoFar = _f16.w, this.addHalfVertex(_f16, o, l, a, !1, r, i, _f16.z), this.addHalfVertex(_f16, u, c, a, !0, -n, i, _f16.z)), this.addVerticesTo(_f16, _d14, o, l, u, c, r, n, i, a));
              } else {
                var _t190 = this.currentVertex;
                this.currentVertexIsOutside && (Cf(_t190, _f15, _e198, _h18), this.e1 = this.e2 = -1, this.lineSoFar = _t190.w, this.addHalfVertex(_t190, o, l, a, !1, r, i, _t190.z), this.addHalfVertex(_t190, u, c, a, !0, -n, i, _t190.z)), this.addVerticesTo(_t190, _f15, o, l, u, c, r, n, i, a);
              }
            } else _d13 || (this.addHalfVertex(t, o, l, a, !1, r, i, s), this.addHalfVertex(t, u, c, a, !0, -n, i, s));
            this.currentVertex = _f15, this.currentVertexIsOutside = _d13, this.lineSoFar = _m10;
          } else this.addHalfVertex(t, o, l, a, !1, r, i, s), this.addHalfVertex(t, u, c, a, !0, -n, i, s);
        }
      }, {
        key: "addHalfVertex",
        value: function addHalfVertex(_ref122, r, n, i, s, a, o, l) {
          var t = _ref122.x,
            e = _ref122.y;
          this.patternJoinNone && (0 === this.segmentPoints.length && (this.segmentStart = this.lineSoFar, this.segmentStartf32 = Math.fround(this.lineSoFar)), s || this.segmentPoints.push(this.lineSoFar - this.segmentStart, a)), this.layoutVertexArray.emplaceBack((t << 1) + (i ? 1 : 0), (e << 1) + (s ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1), 0, this.lineSoFar - this.segmentStartf32), this.lineClips && this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, this.lineClips.start, this.lineClips.end);
          var u = o.vertexLength++;
          this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), s ? this.e2 = u : this.e1 = u, null != l && this.zOffsetVertexArray.emplaceBack(l);
        }
      }, {
        key: "updateScaledDistance",
        value: function updateScaledDistance() {
          if (this.lineClips) {
            var _t191 = this.totalDistance / (this.lineClips.end - this.lineClips.start);
            this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = _t191 * this.lineClips.start + this.distance;
          } else this.lineSoFar = this.distance;
        }
      }, {
        key: "updateDistance",
        value: function updateDistance(t, e) {
          this.distance += t.dist(e), this.updateScaledDistance();
        }
      }]);
      return om;
    }();
    function lm(t, e, r) {
      return t.x < e || t.x > r || t.y < e || t.y > r;
    }
    var um, cm;
    function hm(t, e, r) {
      return e * (ds / (t.tileSize * Math.pow(2, r - t.tileID.overscaledZ)));
    }
    function pm(t, e) {
      return 1 / hm(t, 1, e.tileZoom);
    }
    function fm(t, e, r, n) {
      return t.translatePosMatrix(n || e.tileID.projMatrix, e, r.paint.get("line-translate"), r.paint.get("line-translate-anchor"));
    }
    So(om, "LineBucket", {
      omit: ["layers", "patternFeatures", "currentVertex", "currentVertexIsOutside"]
    });
    var dm = function dm(t) {
      var e = [];
      mm(t) && e.push("RENDER_LINE_DASH"), t.paint.get("line-gradient") && e.push("RENDER_LINE_GRADIENT");
      var r = t.paint.get("line-trim-offset");
      0 === r[0] && 0 === r[1] || e.push("RENDER_LINE_TRIM_OFFSET"), 0 !== t.paint.get("line-border-width").constantOr(1) && e.push("RENDER_LINE_BORDER");
      var n = "none" === t.layout.get("line-join").constantOr("miter"),
        i = !!t.paint.get("line-pattern").constantOr(1);
      return n && i && e.push("LINE_JOIN_NONE"), e;
    };
    function mm(t) {
      var e = t.paint.get("line-dasharray").value;
      return e.value || "constant" !== e.kind;
    }
    var ym = /*#__PURE__*/function () {
      function ym(t) {
        _classCallCheck(this, ym);
        this._stringToNumber = {}, this._numberToString = [];
        for (var _e199 = 0; _e199 < t.length; _e199++) {
          var _r170 = t[_e199];
          this._stringToNumber[_r170] = _e199, this._numberToString[_e199] = _r170;
        }
      }
      _createClass(ym, [{
        key: "encode",
        value: function encode(t) {
          return this._stringToNumber[t];
        }
      }, {
        key: "decode",
        value: function decode(t) {
          return this._numberToString[t];
        }
      }]);
      return ym;
    }();
    var gm = {
        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
        read: function read(t, e, r, n, i) {
          var s,
            a,
            o = 8 * i - n - 1,
            l = (1 << o) - 1,
            u = l >> 1,
            c = -7,
            h = r ? i - 1 : 0,
            p = r ? -1 : 1,
            f = t[e + h];
          for (h += p, s = f & (1 << -c) - 1, f >>= -c, c += o; c > 0; s = 256 * s + t[e + h], h += p, c -= 8);
          for (a = s & (1 << -c) - 1, s >>= -c, c += n; c > 0; a = 256 * a + t[e + h], h += p, c -= 8);
          if (0 === s) s = 1 - u;else {
            if (s === l) return a ? NaN : 1 / 0 * (f ? -1 : 1);
            a += Math.pow(2, n), s -= u;
          }
          return (f ? -1 : 1) * a * Math.pow(2, s - n);
        },
        write: function write(t, e, r, n, i, s) {
          var a,
            o,
            l,
            u = 8 * s - i - 1,
            c = (1 << u) - 1,
            h = c >> 1,
            p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
            f = n ? 0 : s - 1,
            d = n ? 1 : -1,
            m = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
          for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), (e += a + h >= 1 ? p / l : p * Math.pow(2, 1 - h)) * l >= 2 && (a++, l /= 2), a + h >= c ? (o = 0, a = c) : a + h >= 1 ? (o = (e * l - 1) * Math.pow(2, i), a += h) : (o = e * Math.pow(2, h - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + f] = 255 & o, f += d, o /= 256, i -= 8);
          for (a = a << i | o, u += i; u > 0; t[r + f] = 255 & a, f += d, a /= 256, u -= 8);
          t[r + f - d] |= 128 * m;
        }
      },
      xm = vm,
      bm = gm;
    function vm(t) {
      this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t) ? t : new Uint8Array(t || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
    }
    vm.Varint = 0, vm.Fixed64 = 1, vm.Bytes = 2, vm.Fixed32 = 5;
    var _m = 4294967296,
      wm = 1 / _m,
      Mm = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
    function Am(t) {
      return t.type === vm.Bytes ? t.readVarint() + t.pos : t.pos + 1;
    }
    function Sm(t, e, r) {
      return r ? 4294967296 * e + (t >>> 0) : 4294967296 * (e >>> 0) + (t >>> 0);
    }
    function Im(t, e, r) {
      var n = e <= 16383 ? 1 : e <= 2097151 ? 2 : e <= 268435455 ? 3 : Math.floor(Math.log(e) / (7 * Math.LN2));
      r.realloc(n);
      for (var i = r.pos - 1; i >= t; i--) r.buf[i + n] = r.buf[i];
    }
    function Tm(t, e) {
      for (var r = 0; r < t.length; r++) e.writeVarint(t[r]);
    }
    function km(t, e) {
      for (var r = 0; r < t.length; r++) e.writeSVarint(t[r]);
    }
    function Pm(t, e) {
      for (var r = 0; r < t.length; r++) e.writeFloat(t[r]);
    }
    function zm(t, e) {
      for (var r = 0; r < t.length; r++) e.writeDouble(t[r]);
    }
    function Em(t, e) {
      for (var r = 0; r < t.length; r++) e.writeBoolean(t[r]);
    }
    function Bm(t, e) {
      for (var r = 0; r < t.length; r++) e.writeFixed32(t[r]);
    }
    function Dm(t, e) {
      for (var r = 0; r < t.length; r++) e.writeSFixed32(t[r]);
    }
    function Rm(t, e) {
      for (var r = 0; r < t.length; r++) e.writeFixed64(t[r]);
    }
    function Cm(t, e) {
      for (var r = 0; r < t.length; r++) e.writeSFixed64(t[r]);
    }
    function Lm(t, e) {
      return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + 16777216 * t[e + 3];
    }
    function Vm(t, e, r) {
      t[r] = e, t[r + 1] = e >>> 8, t[r + 2] = e >>> 16, t[r + 3] = e >>> 24;
    }
    function Fm(t, e) {
      return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + (t[e + 3] << 24);
    }
    vm.prototype = {
      destroy: function destroy() {
        this.buf = null;
      },
      readFields: function readFields(t, e, r) {
        for (r = r || this.length; this.pos < r;) {
          var n = this.readVarint(),
            i = n >> 3,
            s = this.pos;
          this.type = 7 & n, t(i, e, this), this.pos === s && this.skip(n);
        }
        return e;
      },
      readMessage: function readMessage(t, e) {
        return this.readFields(t, e, this.readVarint() + this.pos);
      },
      readFixed32: function readFixed32() {
        var t = Lm(this.buf, this.pos);
        return this.pos += 4, t;
      },
      readSFixed32: function readSFixed32() {
        var t = Fm(this.buf, this.pos);
        return this.pos += 4, t;
      },
      readFixed64: function readFixed64() {
        var t = Lm(this.buf, this.pos) + Lm(this.buf, this.pos + 4) * _m;
        return this.pos += 8, t;
      },
      readSFixed64: function readSFixed64() {
        var t = Lm(this.buf, this.pos) + Fm(this.buf, this.pos + 4) * _m;
        return this.pos += 8, t;
      },
      readFloat: function readFloat() {
        var t = bm.read(this.buf, this.pos, !0, 23, 4);
        return this.pos += 4, t;
      },
      readDouble: function readDouble() {
        var t = bm.read(this.buf, this.pos, !0, 52, 8);
        return this.pos += 8, t;
      },
      readVarint: function readVarint(t) {
        var e,
          r,
          n = this.buf;
        return e = 127 & (r = n[this.pos++]), r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e : function (t, e, r) {
          var n,
            i,
            s = r.buf;
          if (n = (112 & (i = s[r.pos++])) >> 4, i < 128) return Sm(t, n, e);
          if (n |= (127 & (i = s[r.pos++])) << 3, i < 128) return Sm(t, n, e);
          if (n |= (127 & (i = s[r.pos++])) << 10, i < 128) return Sm(t, n, e);
          if (n |= (127 & (i = s[r.pos++])) << 17, i < 128) return Sm(t, n, e);
          if (n |= (127 & (i = s[r.pos++])) << 24, i < 128) return Sm(t, n, e);
          if (n |= (1 & (i = s[r.pos++])) << 31, i < 128) return Sm(t, n, e);
          throw new Error("Expected varint not more than 10 bytes");
        }(e |= (15 & (r = n[this.pos])) << 28, t, this))));
      },
      readVarint64: function readVarint64() {
        return this.readVarint(!0);
      },
      readSVarint: function readSVarint() {
        var t = this.readVarint();
        return t % 2 == 1 ? (t + 1) / -2 : t / 2;
      },
      readBoolean: function readBoolean() {
        return Boolean(this.readVarint());
      },
      readString: function readString() {
        var t = this.readVarint() + this.pos,
          e = this.pos;
        return this.pos = t, t - e >= 12 && Mm ? function (t, e, r) {
          return Mm.decode(t.subarray(e, r));
        }(this.buf, e, t) : function (t, e, r) {
          for (var n = "", i = e; i < r;) {
            var s,
              a,
              o,
              l = t[i],
              u = null,
              c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
            if (i + c > r) break;
            1 === c ? l < 128 && (u = l) : 2 === c ? 128 == (192 & (s = t[i + 1])) && (u = (31 & l) << 6 | 63 & s) <= 127 && (u = null) : 3 === c ? (a = t[i + 2], 128 == (192 & (s = t[i + 1])) && 128 == (192 & a) && ((u = (15 & l) << 12 | (63 & s) << 6 | 63 & a) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === c && (a = t[i + 2], o = t[i + 3], 128 == (192 & (s = t[i + 1])) && 128 == (192 & a) && 128 == (192 & o) && ((u = (15 & l) << 18 | (63 & s) << 12 | (63 & a) << 6 | 63 & o) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, c = 1) : u > 65535 && (u -= 65536, n += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n += String.fromCharCode(u), i += c;
          }
          return n;
        }(this.buf, e, t);
      },
      readBytes: function readBytes() {
        var t = this.readVarint() + this.pos,
          e = this.buf.subarray(this.pos, t);
        return this.pos = t, e;
      },
      readPackedVarint: function readPackedVarint(t, e) {
        if (this.type !== vm.Bytes) return t.push(this.readVarint(e));
        var r = Am(this);
        for (t = t || []; this.pos < r;) t.push(this.readVarint(e));
        return t;
      },
      readPackedSVarint: function readPackedSVarint(t) {
        if (this.type !== vm.Bytes) return t.push(this.readSVarint());
        var e = Am(this);
        for (t = t || []; this.pos < e;) t.push(this.readSVarint());
        return t;
      },
      readPackedBoolean: function readPackedBoolean(t) {
        if (this.type !== vm.Bytes) return t.push(this.readBoolean());
        var e = Am(this);
        for (t = t || []; this.pos < e;) t.push(this.readBoolean());
        return t;
      },
      readPackedFloat: function readPackedFloat(t) {
        if (this.type !== vm.Bytes) return t.push(this.readFloat());
        var e = Am(this);
        for (t = t || []; this.pos < e;) t.push(this.readFloat());
        return t;
      },
      readPackedDouble: function readPackedDouble(t) {
        if (this.type !== vm.Bytes) return t.push(this.readDouble());
        var e = Am(this);
        for (t = t || []; this.pos < e;) t.push(this.readDouble());
        return t;
      },
      readPackedFixed32: function readPackedFixed32(t) {
        if (this.type !== vm.Bytes) return t.push(this.readFixed32());
        var e = Am(this);
        for (t = t || []; this.pos < e;) t.push(this.readFixed32());
        return t;
      },
      readPackedSFixed32: function readPackedSFixed32(t) {
        if (this.type !== vm.Bytes) return t.push(this.readSFixed32());
        var e = Am(this);
        for (t = t || []; this.pos < e;) t.push(this.readSFixed32());
        return t;
      },
      readPackedFixed64: function readPackedFixed64(t) {
        if (this.type !== vm.Bytes) return t.push(this.readFixed64());
        var e = Am(this);
        for (t = t || []; this.pos < e;) t.push(this.readFixed64());
        return t;
      },
      readPackedSFixed64: function readPackedSFixed64(t) {
        if (this.type !== vm.Bytes) return t.push(this.readSFixed64());
        var e = Am(this);
        for (t = t || []; this.pos < e;) t.push(this.readSFixed64());
        return t;
      },
      skip: function skip(t) {
        var e = 7 & t;
        if (e === vm.Varint) for (; this.buf[this.pos++] > 127;);else if (e === vm.Bytes) this.pos = this.readVarint() + this.pos;else if (e === vm.Fixed32) this.pos += 4;else {
          if (e !== vm.Fixed64) throw new Error("Unimplemented type: " + e);
          this.pos += 8;
        }
      },
      writeTag: function writeTag(t, e) {
        this.writeVarint(t << 3 | e);
      },
      realloc: function realloc(t) {
        for (var e = this.length || 16; e < this.pos + t;) e *= 2;
        if (e !== this.length) {
          var r = new Uint8Array(e);
          r.set(this.buf), this.buf = r, this.length = e;
        }
      },
      finish: function finish() {
        return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
      },
      writeFixed32: function writeFixed32(t) {
        this.realloc(4), Vm(this.buf, t, this.pos), this.pos += 4;
      },
      writeSFixed32: function writeSFixed32(t) {
        this.realloc(4), Vm(this.buf, t, this.pos), this.pos += 4;
      },
      writeFixed64: function writeFixed64(t) {
        this.realloc(8), Vm(this.buf, -1 & t, this.pos), Vm(this.buf, Math.floor(t * wm), this.pos + 4), this.pos += 8;
      },
      writeSFixed64: function writeSFixed64(t) {
        this.realloc(8), Vm(this.buf, -1 & t, this.pos), Vm(this.buf, Math.floor(t * wm), this.pos + 4), this.pos += 8;
      },
      writeVarint: function writeVarint(t) {
        (t = +t || 0) > 268435455 || t < 0 ? function (t, e) {
          var r, n;
          if (t >= 0 ? (r = t % 4294967296 | 0, n = t / 4294967296 | 0) : (n = ~(-t / 4294967296), 4294967295 ^ (r = ~(-t % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t >= 0x10000000000000000 || t < -0x10000000000000000) throw new Error("Given varint doesn't fit into 10 bytes");
          e.realloc(10), function (t, e, r) {
            r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, r.buf[r.pos] = 127 & (t >>>= 7);
          }(r, 0, e), function (t, e) {
            var r = (7 & t) << 4;
            e.buf[e.pos++] |= r | ((t >>>= 3) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = 127 & t)))));
          }(n, e);
        }(t, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = t >>> 7 & 127))));
      },
      writeSVarint: function writeSVarint(t) {
        this.writeVarint(t < 0 ? 2 * -t - 1 : 2 * t);
      },
      writeBoolean: function writeBoolean(t) {
        this.writeVarint(Boolean(t));
      },
      writeString: function writeString(t) {
        t = String(t), this.realloc(4 * t.length), this.pos++;
        var e = this.pos;
        this.pos = function (t, e, r) {
          for (var n, i, s = 0; s < e.length; s++) {
            if ((n = e.charCodeAt(s)) > 55295 && n < 57344) {
              if (!i) {
                n > 56319 || s + 1 === e.length ? (t[r++] = 239, t[r++] = 191, t[r++] = 189) : i = n;
                continue;
              }
              if (n < 56320) {
                t[r++] = 239, t[r++] = 191, t[r++] = 189, i = n;
                continue;
              }
              n = i - 55296 << 10 | n - 56320 | 65536, i = null;
            } else i && (t[r++] = 239, t[r++] = 191, t[r++] = 189, i = null);
            n < 128 ? t[r++] = n : (n < 2048 ? t[r++] = n >> 6 | 192 : (n < 65536 ? t[r++] = n >> 12 | 224 : (t[r++] = n >> 18 | 240, t[r++] = n >> 12 & 63 | 128), t[r++] = n >> 6 & 63 | 128), t[r++] = 63 & n | 128);
          }
          return r;
        }(this.buf, t, this.pos);
        var r = this.pos - e;
        r >= 128 && Im(e, r, this), this.pos = e - 1, this.writeVarint(r), this.pos += r;
      },
      writeFloat: function writeFloat(t) {
        this.realloc(4), bm.write(this.buf, t, this.pos, !0, 23, 4), this.pos += 4;
      },
      writeDouble: function writeDouble(t) {
        this.realloc(8), bm.write(this.buf, t, this.pos, !0, 52, 8), this.pos += 8;
      },
      writeBytes: function writeBytes(t) {
        var e = t.length;
        this.writeVarint(e), this.realloc(e);
        for (var r = 0; r < e; r++) this.buf[this.pos++] = t[r];
      },
      writeRawMessage: function writeRawMessage(t, e) {
        this.pos++;
        var r = this.pos;
        t(e, this);
        var n = this.pos - r;
        n >= 128 && Im(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
      },
      writeMessage: function writeMessage(t, e, r) {
        this.writeTag(t, vm.Bytes), this.writeRawMessage(e, r);
      },
      writePackedVarint: function writePackedVarint(t, e) {
        e.length && this.writeMessage(t, Tm, e);
      },
      writePackedSVarint: function writePackedSVarint(t, e) {
        e.length && this.writeMessage(t, km, e);
      },
      writePackedBoolean: function writePackedBoolean(t, e) {
        e.length && this.writeMessage(t, Em, e);
      },
      writePackedFloat: function writePackedFloat(t, e) {
        e.length && this.writeMessage(t, Pm, e);
      },
      writePackedDouble: function writePackedDouble(t, e) {
        e.length && this.writeMessage(t, zm, e);
      },
      writePackedFixed32: function writePackedFixed32(t, e) {
        e.length && this.writeMessage(t, Bm, e);
      },
      writePackedSFixed32: function writePackedSFixed32(t, e) {
        e.length && this.writeMessage(t, Dm, e);
      },
      writePackedFixed64: function writePackedFixed64(t, e) {
        e.length && this.writeMessage(t, Rm, e);
      },
      writePackedSFixed64: function writePackedSFixed64(t, e) {
        e.length && this.writeMessage(t, Cm, e);
      },
      writeBytesField: function writeBytesField(t, e) {
        this.writeTag(t, vm.Bytes), this.writeBytes(e);
      },
      writeFixed32Field: function writeFixed32Field(t, e) {
        this.writeTag(t, vm.Fixed32), this.writeFixed32(e);
      },
      writeSFixed32Field: function writeSFixed32Field(t, e) {
        this.writeTag(t, vm.Fixed32), this.writeSFixed32(e);
      },
      writeFixed64Field: function writeFixed64Field(t, e) {
        this.writeTag(t, vm.Fixed64), this.writeFixed64(e);
      },
      writeSFixed64Field: function writeSFixed64Field(t, e) {
        this.writeTag(t, vm.Fixed64), this.writeSFixed64(e);
      },
      writeVarintField: function writeVarintField(t, e) {
        this.writeTag(t, vm.Varint), this.writeVarint(e);
      },
      writeSVarintField: function writeSVarintField(t, e) {
        this.writeTag(t, vm.Varint), this.writeSVarint(e);
      },
      writeStringField: function writeStringField(t, e) {
        this.writeTag(t, vm.Bytes), this.writeString(e);
      },
      writeFloatField: function writeFloatField(t, e) {
        this.writeTag(t, vm.Fixed32), this.writeFloat(e);
      },
      writeDoubleField: function writeDoubleField(t, e) {
        this.writeTag(t, vm.Fixed64), this.writeDouble(e);
      },
      writeBooleanField: function writeBooleanField(t, e) {
        this.writeVarintField(t, Boolean(e));
      }
    };
    var Om = p(xm);
    var Um = ["id", "tile", "layer", "source", "sourceLayer", "state"];
    var jm = /*#__PURE__*/function () {
      function jm(t, e, r, n, i) {
        _classCallCheck(this, jm);
        this.type = "Feature", this._vectorTileFeature = t, this._z = e, this._x = r, this._y = n, this.properties = t.properties, this.id = i;
      }
      _createClass(jm, [{
        key: "geometry",
        get: function get() {
          return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
        },
        set: function set(t) {
          this._geometry = t;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = {
            type: "Feature",
            state: void 0,
            geometry: this.geometry,
            properties: this.properties
          };
          for (var _i122 = 0, _Um = Um; _i122 < _Um.length; _i122++) {
            var _e200 = _Um[_i122];
            void 0 !== this[_e200] && (t[_e200] = this[_e200]);
          }
          return t;
        }
      }]);
      return jm;
    }();
    var Nm = /*#__PURE__*/function () {
      function Nm() {
        _classCallCheck(this, Nm);
        this.state = {}, this.stateChanges = {}, this.deletedStates = {};
      }
      _createClass(Nm, [{
        key: "updateState",
        value: function updateState(t, e, r) {
          var n = String(e);
          if (this.stateChanges[t] = this.stateChanges[t] || {}, this.stateChanges[t][n] = this.stateChanges[t][n] || {}, rr(this.stateChanges[t][n], r), null === this.deletedStates[t]) {
            this.deletedStates[t] = {};
            for (var _e201 in this.state[t]) _e201 !== n && (this.deletedStates[t][_e201] = null);
          } else if (this.deletedStates[t] && null === this.deletedStates[t][n]) {
            this.deletedStates[t][n] = {};
            for (var _e202 in this.state[t][n]) r[_e202] || (this.deletedStates[t][n][_e202] = null);
          } else for (var _e203 in r) this.deletedStates[t] && this.deletedStates[t][n] && null === this.deletedStates[t][n][_e203] && delete this.deletedStates[t][n][_e203];
        }
      }, {
        key: "removeFeatureState",
        value: function removeFeatureState(t, e, r) {
          if (null === this.deletedStates[t]) return;
          var n = String(e);
          if (this.deletedStates[t] = this.deletedStates[t] || {}, r && void 0 !== e) null !== this.deletedStates[t][n] && (this.deletedStates[t][n] = this.deletedStates[t][n] || {}, this.deletedStates[t][n][r] = null);else if (void 0 !== e) {
            if (this.stateChanges[t] && this.stateChanges[t][n]) for (r in this.deletedStates[t][n] = {}, this.stateChanges[t][n]) this.deletedStates[t][n][r] = null;else this.deletedStates[t][n] = null;
          } else this.deletedStates[t] = null;
        }
      }, {
        key: "getState",
        value: function getState(t, e) {
          var r = String(e),
            n = rr({}, (this.state[t] || {})[r], (this.stateChanges[t] || {})[r]);
          if (null === this.deletedStates[t]) return {};
          if (this.deletedStates[t]) {
            var _r171 = this.deletedStates[t][e];
            if (null === _r171) return {};
            for (var _t192 in _r171) delete n[_t192];
          }
          return n;
        }
      }, {
        key: "initializeTileState",
        value: function initializeTileState(t, e) {
          t.setFeatureState(this.state, e);
        }
      }, {
        key: "coalesceChanges",
        value: function coalesceChanges(t, e) {
          var r = {};
          for (var _t193 in this.stateChanges) {
            this.state[_t193] = this.state[_t193] || {};
            var _e204 = {};
            for (var _r172 in this.stateChanges[_t193]) this.state[_t193][_r172] || (this.state[_t193][_r172] = {}), rr(this.state[_t193][_r172], this.stateChanges[_t193][_r172]), _e204[_r172] = this.state[_t193][_r172];
            r[_t193] = _e204;
          }
          for (var _t194 in this.deletedStates) {
            this.state[_t194] = this.state[_t194] || {};
            var _e205 = {};
            if (null === this.deletedStates[_t194]) for (var _r173 in this.state[_t194]) _e205[_r173] = {}, this.state[_t194][_r173] = {};else for (var _r174 in this.deletedStates[_t194]) {
              if (null === this.deletedStates[_t194][_r174]) this.state[_t194][_r174] = {};else if (this.state[_t194][_r174]) for (var _i123 = 0, _Object$keys12 = Object.keys(this.deletedStates[_t194][_r174]); _i123 < _Object$keys12.length; _i123++) {
                var _e206 = _Object$keys12[_i123];
                delete this.state[_t194][_r174][_e206];
              }
              _e205[_r174] = this.state[_t194][_r174];
            }
            r[_t194] = r[_t194] || {}, rr(r[_t194], _e205);
          }
          if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(r).length) for (var _n109 in t) t[_n109].setFeatureState(r, e);
        }
      }]);
      return Nm;
    }();
    var $m = /*#__PURE__*/function () {
      function $m(t, e) {
        _classCallCheck(this, $m);
        this.tileID = t, this.x = t.canonical.x, this.y = t.canonical.y, this.z = t.canonical.z, this.grid = new Mo(ds, 16, 0), this.featureIndexArray = new wu(), this.promoteId = e, this.is3DTile = !1;
      }
      _createClass($m, [{
        key: "insert",
        value: function insert(t, e, r, n, i) {
          var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
          var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
          var o = this.featureIndexArray.length;
          this.featureIndexArray.emplaceBack(r, n, i, s);
          var l = this.grid;
          for (var _t195 = 0; _t195 < e.length; _t195++) {
            var _r175 = e[_t195],
              _n110 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
            for (var _t196 = 0; _t196 < _r175.length; _t196++) {
              var _e207 = _r175[_t196];
              _n110[0] = Math.min(_n110[0], _e207.x), _n110[1] = Math.min(_n110[1], _e207.y), _n110[2] = Math.max(_n110[2], _e207.x), _n110[3] = Math.max(_n110[3], _e207.y);
            }
            0 !== a && (_n110[0] -= a, _n110[1] -= a, _n110[2] += a, _n110[3] += a), _n110[0] < ds && _n110[1] < ds && _n110[2] >= 0 && _n110[3] >= 0 && l.insert(o, _n110[0], _n110[1], _n110[2], _n110[3]);
          }
        }
      }, {
        key: "loadVTLayers",
        value: function loadVTLayers() {
          if (!this.vtLayers) {
            this.vtLayers = new Pf(new Om(this.rawTileData)).layers, this.sourceLayerCoder = new ym(this.vtLayers ? Object.keys(this.vtLayers).sort() : ["_geojsonTileLayer"]), this.vtFeatures = {};
            for (var _t197 in this.vtLayers) this.vtFeatures[_t197] = [];
          }
          return this.vtLayers;
        }
      }, {
        key: "query",
        value: function query(t, e, r, n) {
          var _this28 = this;
          this.loadVTLayers();
          var i = t.params || {},
            s = dl(i.filter),
            a = t.tileResult,
            o = t.transform,
            l = a.bufferedTilespaceBounds,
            u = this.grid.query(l.min.x, l.min.y, l.max.x, l.max.y, function (t, e, r, n) {
              return hh(a.bufferedTilespaceGeometry, t, e, r, n);
            });
          u.sort(Gm);
          var c = null;
          o.elevation && u.length > 0 && (c = ad.create(o.elevation, this.tileID));
          var h = {};
          var p;
          var _loop7 = function _loop7() {
              var f = u[_l45];
              if (f === p) return 0; // continue
              p = f;
              var d = _this28.featureIndexArray.get(f);
              var m = null;
              if (_this28.is3DTile) {
                var _t198 = _this28.bucketLayerIDs[0][0],
                  _r176 = e[_t198];
                if ("model" !== _r176.type) return 0; // continue
                var _r176$queryIntersects = _r176.queryIntersectsMatchingFeature(a, d.featureIndex, s, o),
                  _n111 = _r176$queryIntersects.queryFeature,
                  _i124 = _r176$queryIntersects.intersectionZ;
                _n111 && _this28.appendToResult(h, _t198, d.featureIndex, _n111, _i124);
              } else _this28.loadMatchingFeature(h, d, s, i.layers, i.availableImages, e, r, n, function (e, r, n) {
                var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                return m || (m = Kc(e, _this28.tileID.canonical, t.tileTransform)), r.queryIntersectsFeature(a, e, n, m, _this28.z, t.transform, t.pixelPosMatrix, c, i);
              });
            },
            _ret2;
          for (var _l45 = 0; _l45 < u.length; _l45++) {
            _ret2 = _loop7();
            if (_ret2 === 0) continue;
          }
          return h;
        }
      }, {
        key: "loadMatchingFeature",
        value: function loadMatchingFeature(t, e, r, n, i, s, a, o, l) {
          var u = e.featureIndex,
            c = e.bucketIndex,
            h = e.sourceLayerIndex,
            p = e.layoutVertexArrayOffset,
            f = this.bucketLayerIDs[c];
          if (n && !function (t, e) {
            for (var _r177 = 0; _r177 < t.length; _r177++) if (e.indexOf(t[_r177]) >= 0) return !0;
            return !1;
          }(n, f)) return;
          var d = this.sourceLayerCoder.decode(h),
            m = this.vtLayers[d].feature(u);
          if (r.needGeometry) {
            var _t199 = Wc(m, !0);
            if (!r.filter(new Wo(this.tileID.overscaledZ), _t199, this.tileID.canonical)) return;
          } else if (!r.filter(new Wo(this.tileID.overscaledZ), m)) return;
          var y = this.getId(m, d);
          for (var _e208 = 0; _e208 < f.length; _e208++) {
            var _r178 = f[_e208];
            if (n && n.indexOf(_r178) < 0) continue;
            var _c28 = s[_r178];
            if (!_c28) continue;
            var _h19 = {};
            void 0 !== y && o && (_h19 = o.getState(_c28.sourceLayer || "_geojsonTileLayer", y));
            var _d15 = !l || l(m, _c28, _h19, p);
            if (!_d15) continue;
            var _g7 = new jm(m, this.z, this.x, this.y, y),
              _x8 = rr({}, a[_r178]);
            _x8.paint = qm(_x8.paint, _c28.paint, m, _h19, i), _x8.layout = qm(_x8.layout, _c28.layout, m, _h19, i), _g7.layer = _x8, this.appendToResult(t, _r178, u, _g7, _d15);
          }
        }
      }, {
        key: "appendToResult",
        value: function appendToResult(t, e, r, n, i) {
          var s = t[e];
          void 0 === s && (s = t[e] = []), s.push({
            featureIndex: r,
            feature: n,
            intersectionZ: i
          });
        }
      }, {
        key: "lookupSymbolFeatures",
        value: function lookupSymbolFeatures(t, e, r, n, i, s, a, o) {
          var l = {};
          this.loadVTLayers();
          var u = dl(i);
          var _iterator138 = _createForOfIteratorHelper(t),
            _step138;
          try {
            for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
              var _i125 = _step138.value;
              this.loadMatchingFeature(l, {
                bucketIndex: r,
                sourceLayerIndex: n,
                featureIndex: _i125,
                layoutVertexArrayOffset: 0
              }, u, s, a, o, e);
            }
          } catch (err) {
            _iterator138.e(err);
          } finally {
            _iterator138.f();
          }
          return l;
        }
      }, {
        key: "loadFeature",
        value: function loadFeature(t) {
          var e = t.featureIndex,
            r = t.sourceLayerIndex;
          this.loadVTLayers();
          var n = this.sourceLayerCoder.decode(r),
            i = this.vtFeatures[n];
          if (i[e]) return i[e];
          var s = this.vtLayers[n].feature(e);
          return i[e] = s, s;
        }
      }, {
        key: "hasLayer",
        value: function hasLayer(t) {
          var _iterator139 = _createForOfIteratorHelper(this.bucketLayerIDs),
            _step139;
          try {
            for (_iterator139.s(); !(_step139 = _iterator139.n()).done;) {
              var _e209 = _step139.value;
              var _iterator140 = _createForOfIteratorHelper(_e209),
                _step140;
              try {
                for (_iterator140.s(); !(_step140 = _iterator140.n()).done;) {
                  var _r179 = _step140.value;
                  if (t === _r179) return !0;
                }
              } catch (err) {
                _iterator140.e(err);
              } finally {
                _iterator140.f();
              }
            }
          } catch (err) {
            _iterator139.e(err);
          } finally {
            _iterator139.f();
          }
          return !1;
        }
      }, {
        key: "getId",
        value: function getId(t, e) {
          var r = t.id;
          if (this.promoteId) {
            var _n112 = "string" == typeof this.promoteId ? this.promoteId : this.promoteId[e];
            null != _n112 && (r = t.properties[_n112]), "boolean" == typeof r && (r = Number(r));
          }
          return r;
        }
      }]);
      return $m;
    }();
    function qm(t, e, r, n, i) {
      return cr(t, function (t, s) {
        var a = e instanceof sl ? e.get(s) : null;
        return a && a.evaluate ? a.evaluate(r, n, i) : a;
      });
    }
    function Gm(t, e) {
      return e - t;
    }
    So($m, "FeatureIndex", {
      omit: ["rawTileData", "sourceLayerCoder"]
    });
    var Xm = 24;
    var Ym = 128;
    function Zm(t, e) {
      var r = e.expression;
      if ("constant" === r.kind) return {
        kind: "constant",
        layoutSize: r.evaluate(new Wo(t + 1))
      };
      if ("source" === r.kind) return {
        kind: "source"
      };
      {
        var _e210 = r.zoomStops,
          _n113 = r.interpolationType;
        var _i126 = 0;
        for (; _i126 < _e210.length && _e210[_i126] <= t;) _i126++;
        _i126 = Math.max(0, _i126 - 1);
        var _s90 = _i126;
        for (; _s90 < _e210.length && _e210[_s90] < t + 1;) _s90++;
        _s90 = Math.min(_e210.length - 1, _s90);
        var _a77 = _e210[_i126],
          _o51 = _e210[_s90];
        return "composite" === r.kind ? {
          kind: "composite",
          minZoom: _a77,
          maxZoom: _o51,
          interpolationType: _n113
        } : {
          kind: "camera",
          minZoom: _a77,
          maxZoom: _o51,
          minSize: r.evaluate(new Wo(_a77)),
          maxSize: r.evaluate(new Wo(_o51)),
          interpolationType: _n113
        };
      }
    }
    function Hm(t, _ref123, _ref124) {
      var e = _ref123.uSize,
        r = _ref123.uSizeT;
      var n = _ref124.lowerSize,
        i = _ref124.upperSize;
      return "source" === t.kind ? n / Ym : "composite" === t.kind ? Yn(n / Ym, i / Ym, r) : e;
    }
    function Km(t, e) {
      var r = 0,
        n = 0;
      if ("constant" === t.kind) n = t.layoutSize;else if ("source" !== t.kind) {
        var _i127 = t.interpolationType,
          _s91 = t.minZoom,
          _a78 = t.maxZoom,
          _o52 = _i127 ? We(wa.interpolationFactor(_i127, e, _s91, _a78), 0, 1) : 0;
        "camera" === t.kind ? n = Yn(t.minSize, t.maxSize, _o52) : r = _o52;
      }
      return {
        uSizeT: r,
        uSize: n
      };
    }
    var Wm = Object.freeze({
      __proto__: null,
      SIZE_PACK_FACTOR: Ym,
      evaluateSizeForFeature: Hm,
      evaluateSizeForZoom: Km,
      getSizeData: Zm
    });
    function Jm(t, e, r) {
      return t.sections.forEach(function (t) {
        t.text = function (t, e, r) {
          var n = e.layout.get("text-transform").evaluate(r, {});
          return "uppercase" === n ? t = t.toLocaleUpperCase() : "lowercase" === n && (t = t.toLocaleLowerCase()), Ko.applyArabicShaping && (t = Ko.applyArabicShaping(t)), t;
        }(t.text, e, r);
      }), t;
    }
    var Qm = {
      "!": "︕",
      "#": "＃",
      $: "＄",
      "%": "％",
      "&": "＆",
      "(": "︵",
      ")": "︶",
      "*": "＊",
      "+": "＋",
      ",": "︐",
      "-": "︲",
      ".": "・",
      "/": "／",
      ":": "︓",
      ";": "︔",
      "<": "︿",
      "=": "＝",
      ">": "﹀",
      "?": "︖",
      "@": "＠",
      "[": "﹇",
      "\\": "＼",
      "]": "﹈",
      "^": "＾",
      _: "︳",
      "`": "｀",
      "{": "︷",
      "|": "―",
      "}": "︸",
      "~": "～",
      "¢": "￠",
      "£": "￡",
      "¥": "￥",
      "¦": "￤",
      "¬": "￢",
      "¯": "￣",
      "–": "︲",
      "—": "︱",
      "‘": "﹃",
      "’": "﹄",
      "“": "﹁",
      "”": "﹂",
      "…": "︙",
      "‧": "・",
      "₩": "￦",
      "、": "︑",
      "。": "︒",
      "〈": "︿",
      "〉": "﹀",
      "《": "︽",
      "》": "︾",
      "「": "﹁",
      "」": "﹂",
      "『": "﹃",
      "』": "﹄",
      "【": "︻",
      "】": "︼",
      "〔": "︹",
      "〕": "︺",
      "〖": "︗",
      "〗": "︘",
      "！": "︕",
      "（": "︵",
      "）": "︶",
      "，": "︐",
      "－": "︲",
      "．": "・",
      "：": "︓",
      "；": "︔",
      "＜": "︿",
      "＞": "﹀",
      "？": "︖",
      "［": "﹇",
      "］": "﹈",
      "＿": "︳",
      "｛": "︷",
      "｜": "―",
      "｝": "︸",
      "｟": "︵",
      "｠": "︶",
      "｡": "︒",
      "｢": "﹁",
      "｣": "﹂",
      "←": "↑",
      "→": "↓"
    };
    function ty(t) {
      return "︶" === t || "﹈" === t || "︸" === t || "﹄" === t || "﹂" === t || "︾" === t || "︼" === t || "︺" === t || "︘" === t || "﹀" === t || "︐" === t || "︓" === t || "︔" === t || "｀" === t || "￣" === t || "︑" === t || "︒" === t;
    }
    function ey(t) {
      return "︵" === t || "﹇" === t || "︷" === t || "﹃" === t || "﹁" === t || "︽" === t || "︻" === t || "︹" === t || "︗" === t || "︿" === t;
    }
    var ry = 3;
    function ny(t, e, r) {
      e.glyphs = [], 1 === t && r.readMessage(iy, e);
    }
    function iy(t, e, r) {
      if (3 === t) {
        var _r$readMessage = r.readMessage(sy, {}),
          _t200 = _r$readMessage.id,
          _n114 = _r$readMessage.bitmap,
          _i128 = _r$readMessage.width,
          _s92 = _r$readMessage.height,
          _a79 = _r$readMessage.left,
          _o53 = _r$readMessage.top,
          _l46 = _r$readMessage.advance;
        e.glyphs.push({
          id: _t200,
          bitmap: new yp({
            width: _i128 + 2 * ry,
            height: _s92 + 2 * ry
          }, _n114),
          metrics: {
            width: _i128,
            height: _s92,
            left: _a79,
            top: _o53,
            advance: _l46
          }
        });
      } else 4 === t ? e.ascender = r.readSVarint() : 5 === t && (e.descender = r.readSVarint());
    }
    function sy(t, e, r) {
      1 === t ? e.id = r.readVarint() : 2 === t ? e.bitmap = r.readBytes() : 3 === t ? e.width = r.readVarint() : 4 === t ? e.height = r.readVarint() : 5 === t ? e.left = r.readSVarint() : 6 === t ? e.top = r.readSVarint() : 7 === t && (e.advance = r.readVarint());
    }
    var ay = ry,
      oy = {
        horizontal: 1,
        vertical: 2,
        horizontalOnly: 3
      };
    var ly = /*#__PURE__*/function () {
      function ly() {
        _classCallCheck(this, ly);
        this.scale = 1, this.fontStack = "", this.imageName = null;
      }
      _createClass(ly, null, [{
        key: "forText",
        value: function forText(t, e) {
          var r = new ly();
          return r.scale = t || 1, r.fontStack = e, r;
        }
      }, {
        key: "forImage",
        value: function forImage(t) {
          var e = new ly();
          return e.imageName = t, e;
        }
      }]);
      return ly;
    }();
    var uy = /*#__PURE__*/function () {
      function uy() {
        _classCallCheck(this, uy);
        this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
      }
      _createClass(uy, [{
        key: "length",
        value: function length() {
          return this.text.length;
        }
      }, {
        key: "getSection",
        value: function getSection(t) {
          return this.sections[this.sectionIndex[t]];
        }
      }, {
        key: "getSections",
        value: function getSections() {
          return this.sections;
        }
      }, {
        key: "getSectionIndex",
        value: function getSectionIndex(t) {
          return this.sectionIndex[t];
        }
      }, {
        key: "getCodePoint",
        value: function getCodePoint(t) {
          return this.text.codePointAt(t);
        }
      }, {
        key: "verticalizePunctuation",
        value: function verticalizePunctuation(t) {
          this.text = function (t, e) {
            var r = "";
            for (var _n115 = 0; _n115 < t.length; _n115++) {
              var _i129 = t.charCodeAt(_n115 + 1) || null,
                _s93 = t.charCodeAt(_n115 - 1) || null;
              r += !e && (_i129 && Co(_i129) && !Qm[t[_n115 + 1]] || _s93 && Co(_s93) && !Qm[t[_n115 - 1]]) || !Qm[t[_n115]] ? t[_n115] : Qm[t[_n115]];
            }
            return r;
          }(this.text, t);
        }
      }, {
        key: "trim",
        value: function trim() {
          var t = 0;
          for (var _e211 = 0; _e211 < this.text.length && hy[this.text.charCodeAt(_e211)]; _e211++) t++;
          var e = this.text.length;
          for (var _r180 = this.text.length - 1; _r180 >= 0 && _r180 >= t && hy[this.text.charCodeAt(_r180)]; _r180--) e--;
          this.text = this.text.substring(t, e), this.sectionIndex = this.sectionIndex.slice(t, e);
        }
      }, {
        key: "substring",
        value: function substring(t, e) {
          var r = new uy();
          return r.text = this.text.substring(t, e), r.sectionIndex = this.sectionIndex.slice(t, e), r.sections = this.sections, r;
        }
      }, {
        key: "toString",
        value: function toString() {
          return this.text;
        }
      }, {
        key: "getMaxScale",
        value: function getMaxScale() {
          var _this29 = this;
          return this.sectionIndex.reduce(function (t, e) {
            return Math.max(t, _this29.sections[e].scale);
          }, 0);
        }
      }, {
        key: "addTextSection",
        value: function addTextSection(t, e) {
          this.text += t.text, this.sections.push(ly.forText(t.scale, t.fontStack || e));
          var r = this.sections.length - 1;
          for (var _e212 = 0; _e212 < t.text.length; ++_e212) this.sectionIndex.push(r);
        }
      }, {
        key: "addImageSection",
        value: function addImageSection(t) {
          var e = t.image ? t.image.namePrimary : "";
          if (0 === e.length) return void dr("Can't add FormattedSection with an empty image.");
          var r = this.getNextImageSectionCharCode();
          r ? (this.text += String.fromCodePoint(r), this.sections.push(ly.forImage(e)), this.sectionIndex.push(this.sections.length - 1)) : dr("Reached maximum number of images 6401");
        }
      }, {
        key: "getNextImageSectionCharCode",
        value: function getNextImageSectionCharCode() {
          return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
        }
      }], [{
        key: "fromFeature",
        value: function fromFeature(t, e) {
          var r = new uy();
          for (var _n116 = 0; _n116 < t.sections.length; _n116++) {
            var _i130 = t.sections[_n116];
            _i130.image ? r.addImageSection(_i130) : r.addTextSection(_i130, e);
          }
          return r;
        }
      }]);
      return uy;
    }();
    function cy(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d) {
      var m = uy.fromFeature(t, i);
      h === oy.vertical && m.verticalizePunctuation(p);
      var y = [];
      var g = function (t, e, r, n, i, s) {
          if (!t) return [];
          var a = [],
            o = function (t, e, r, n, i, s) {
              var a = 0;
              for (var _r181 = 0; _r181 < t.length(); _r181++) {
                var _o54 = t.getSection(_r181);
                a += fy(t.getCodePoint(_r181), _o54, n, i, e, s);
              }
              return a / Math.max(1, Math.ceil(a / r));
            }(t, e, r, n, i, s),
            l = t.text.indexOf("​") >= 0;
          var u = 0;
          for (var _r182 = 0; _r182 < t.length(); _r182++) {
            var _h20 = t.getSection(_r182),
              _p20 = t.getCodePoint(_r182);
            if (hy[_p20] || (u += fy(_p20, _h20, n, i, e, s)), _r182 < t.length() - 1) {
              var _e213 = !((c = _p20) < 11904 || !(zo["Bopomofo Extended"](c) || zo.Bopomofo(c) || zo["CJK Compatibility Forms"](c) || zo["CJK Compatibility Ideographs"](c) || zo["CJK Compatibility"](c) || zo["CJK Radicals Supplement"](c) || zo["CJK Strokes"](c) || zo["CJK Symbols and Punctuation"](c) || zo["CJK Unified Ideographs Extension A"](c) || zo["CJK Unified Ideographs"](c) || zo["Enclosed CJK Letters and Months"](c) || zo["Halfwidth and Fullwidth Forms"](c) || zo.Hiragana(c) || zo["Ideographic Description Characters"](c) || zo["Kangxi Radicals"](c) || zo["Katakana Phonetic Extensions"](c) || zo.Katakana(c) || zo["Vertical Forms"](c) || zo["Yi Radicals"](c) || zo["Yi Syllables"](c)));
              (py[_p20] || _e213 || _h20.imageName) && a.push(yy(_r182 + 1, u, o, a, my(_p20, t.getCodePoint(_r182 + 1), _e213 && l), !1));
            }
          }
          var c;
          return gy(yy(t.length(), u, o, a, 0, !0));
        }(m, u, s, e, n, f),
        x = Ko.processBidirectionalText,
        b = Ko.processStyledBidirectionalText;
      if (x && 1 === m.sections.length) {
        var _t201 = x(m.toString(), g);
        var _iterator141 = _createForOfIteratorHelper(_t201),
          _step141;
        try {
          for (_iterator141.s(); !(_step141 = _iterator141.n()).done;) {
            var _e214 = _step141.value;
            var _t202 = new uy();
            _t202.text = _e214, _t202.sections = m.sections;
            for (var _r183 = 0; _r183 < _e214.length; _r183++) _t202.sectionIndex.push(0);
            y.push(_t202);
          }
        } catch (err) {
          _iterator141.e(err);
        } finally {
          _iterator141.f();
        }
      } else if (b) {
        var _t203 = b(m.text, m.sectionIndex, g);
        var _iterator142 = _createForOfIteratorHelper(_t203),
          _step142;
        try {
          for (_iterator142.s(); !(_step142 = _iterator142.n()).done;) {
            var _e215 = _step142.value;
            var _t204 = new uy();
            _t204.text = _e215[0], _t204.sectionIndex = _e215[1], _t204.sections = m.sections, y.push(_t204);
          }
        } catch (err) {
          _iterator142.e(err);
        } finally {
          _iterator142.f();
        }
      } else y = function (t, e) {
        var r = [],
          n = t.text;
        var i = 0;
        var _iterator143 = _createForOfIteratorHelper(e),
          _step143;
        try {
          for (_iterator143.s(); !(_step143 = _iterator143.n()).done;) {
            var _n117 = _step143.value;
            r.push(t.substring(i, _n117)), i = _n117;
          }
        } catch (err) {
          _iterator143.e(err);
        } finally {
          _iterator143.f();
        }
        return i < n.length && r.push(t.substring(i, n.length)), r;
      }(m, g);
      var v = [],
        _ = {
          positionedLines: v,
          text: m.toString(),
          top: c[1],
          bottom: c[1],
          left: c[0],
          right: c[0],
          writingMode: h,
          iconsInText: !1,
          verticalizable: !1,
          hasBaseline: !1
        };
      return function (t, e, r, n, i, s, a, o, l, u, c, h) {
        var p = 0,
          f = 0,
          d = 0;
        var m = "right" === o ? 1 : "left" === o ? 0 : .5;
        var y = !1;
        var _iterator144 = _createForOfIteratorHelper(i),
          _step144;
        try {
          for (_iterator144.s(); !(_step144 = _iterator144.n()).done;) {
            var _t206 = _step144.value;
            var _r184 = _t206.getSections();
            var _iterator148 = _createForOfIteratorHelper(_r184),
              _step148;
            try {
              for (_iterator148.s(); !(_step148 = _iterator148.n()).done;) {
                var _t207 = _step148.value;
                if (_t207.imageName) continue;
                var _r185 = e[_t207.fontStack];
                if (_r185 && (y = void 0 !== _r185.ascender && void 0 !== _r185.descender, !y)) break;
              }
            } catch (err) {
              _iterator148.e(err);
            } finally {
              _iterator148.f();
            }
            if (!y) break;
          }
        } catch (err) {
          _iterator144.e(err);
        } finally {
          _iterator144.f();
        }
        var g = 0;
        var _iterator145 = _createForOfIteratorHelper(i),
          _step145;
        try {
          for (_iterator145.s(); !(_step145 = _iterator145.n()).done;) {
            var _a80 = _step145.value;
            _a80.trim();
            var _i131 = _a80.getMaxScale(),
              _o55 = (_i131 - 1) * Xm,
              _b5 = {
                positionedGlyphs: [],
                lineOffset: 0
              };
            t.positionedLines[g] = _b5;
            var _v5 = _b5.positionedGlyphs;
            var _6 = 0;
            if (!_a80.length()) {
              f += s, ++g;
              continue;
            }
            var _w4 = 0,
              _M5 = 0;
            for (var _s94 = 0; _s94 < _a80.length(); _s94++) {
              var _o56 = _a80.getSection(_s94),
                _d16 = _a80.getSectionIndex(_s94),
                _m11 = _a80.getCodePoint(_s94);
              var _g8 = _o56.scale,
                _b6 = null,
                _A4 = null,
                _S4 = null,
                _I3 = Xm,
                _T3 = 0;
              var _k3 = !(l === oy.horizontal || !c && !Ro(_m11) || c && (hy[_m11] || (x = _m11, zo.Arabic(x) || zo["Arabic Supplement"](x) || zo["Arabic Extended-A"](x) || zo["Arabic Presentation Forms-A"](x) || zo["Arabic Presentation Forms-B"](x))));
              if (_o56.imageName) {
                var _e217 = n[_o56.imageName];
                if (!_e217) continue;
                _S4 = _o56.imageName, t.iconsInText = t.iconsInText || !0, _A4 = _e217.paddedRect;
                var _r186 = _e217.displaySize;
                _g8 = _g8 * Xm / h, _b6 = {
                  width: _r186[0],
                  height: _r186[1],
                  left: 0,
                  top: -ay,
                  advance: _k3 ? _r186[1] : _r186[0],
                  localGlyph: !1
                }, _T3 = y ? -_b6.height * _g8 : _i131 * Xm - 17 - _r186[1] * _g8, _I3 = _b6.advance;
                var _s95 = (_k3 ? _r186[0] : _r186[1]) * _g8 - Xm * _i131;
                _s95 > 0 && _s95 > _6 && (_6 = _s95);
              } else {
                var _t208 = r[_o56.fontStack];
                if (!_t208) continue;
                _t208[_m11] && (_A4 = _t208[_m11]);
                var _n118 = e[_o56.fontStack];
                if (!_n118) continue;
                var _s96 = _n118.glyphs[_m11];
                if (!_s96) continue;
                if (_b6 = _s96.metrics, _I3 = 8203 !== _m11 ? Xm : 0, y) {
                  var _t209 = void 0 !== _n118.ascender ? Math.abs(_n118.ascender) : 0,
                    _e218 = void 0 !== _n118.descender ? Math.abs(_n118.descender) : 0,
                    _r187 = (_t209 + _e218) * _g8;
                  _w4 < _r187 && (_w4 = _r187, _M5 = (_t209 - _e218) / 2 * _g8), _T3 = -_t209 * _g8;
                } else _T3 = (_i131 - _g8) * Xm - 17;
              }
              _k3 ? (t.verticalizable = !0, _v5.push({
                glyph: _m11,
                imageName: _S4,
                x: p,
                y: f + _T3,
                vertical: _k3,
                scale: _g8,
                localGlyph: _b6.localGlyph,
                fontStack: _o56.fontStack,
                sectionIndex: _d16,
                metrics: _b6,
                rect: _A4
              }), p += _I3 * _g8 + u) : (_v5.push({
                glyph: _m11,
                imageName: _S4,
                x: p,
                y: f + _T3,
                vertical: _k3,
                scale: _g8,
                localGlyph: _b6.localGlyph,
                fontStack: _o56.fontStack,
                sectionIndex: _d16,
                metrics: _b6,
                rect: _A4
              }), p += _b6.advance * _g8 + u);
            }
            0 !== _v5.length && (d = Math.max(p - u, d), y ? by(_v5, m, _6, _M5, s * _i131 / 2) : by(_v5, m, _6, 0, s / 2)), p = 0;
            var _A5 = s * _i131 + _6;
            _b5.lineOffset = Math.max(_6, _o55), f += _A5, ++g;
          }
        } catch (err) {
          _iterator145.e(err);
        } finally {
          _iterator145.f();
        }
        var x;
        var b = f,
          _xy = xy(a),
          v = _xy.horizontalAlign,
          _ = _xy.verticalAlign;
        (function (t, e, r, n, i, s) {
          var a = (e - r) * i,
            o = -s * n;
          var _iterator146 = _createForOfIteratorHelper(t),
            _step146;
          try {
            for (_iterator146.s(); !(_step146 = _iterator146.n()).done;) {
              var _e216 = _step146.value;
              var _iterator147 = _createForOfIteratorHelper(_e216.positionedGlyphs),
                _step147;
              try {
                for (_iterator147.s(); !(_step147 = _iterator147.n()).done;) {
                  var _t205 = _step147.value;
                  _t205.x += a, _t205.y += o;
                }
              } catch (err) {
                _iterator147.e(err);
              } finally {
                _iterator147.f();
              }
            }
          } catch (err) {
            _iterator146.e(err);
          } finally {
            _iterator146.f();
          }
        })(t.positionedLines, m, v, _, d, b), t.top += -_ * b, t.bottom = t.top + b, t.left += -v * d, t.right = t.left + d, t.hasBaseline = y;
      }(_, e, r, n, y, a, o, l, h, u, p, d), !function (t) {
        var _iterator149 = _createForOfIteratorHelper(t),
          _step149;
        try {
          for (_iterator149.s(); !(_step149 = _iterator149.n()).done;) {
            var _e219 = _step149.value;
            if (0 !== _e219.positionedGlyphs.length) return !1;
          }
        } catch (err) {
          _iterator149.e(err);
        } finally {
          _iterator149.f();
        }
        return !0;
      }(v) && _;
    }
    var hy = {
        9: !0,
        10: !0,
        11: !0,
        12: !0,
        13: !0,
        32: !0
      },
      py = {
        10: !0,
        32: !0,
        38: !0,
        40: !0,
        41: !0,
        43: !0,
        45: !0,
        47: !0,
        173: !0,
        183: !0,
        8203: !0,
        8208: !0,
        8211: !0,
        8231: !0
      };
    function fy(t, e, r, n, i, s) {
      if (e.imageName) {
        var _t210 = n[e.imageName];
        return _t210 ? _t210.displaySize[0] * e.scale * Xm / s + i : 0;
      }
      {
        var _n119 = r[e.fontStack],
          _s97 = _n119 && _n119.glyphs[t];
        return _s97 ? _s97.metrics.advance * e.scale + i : 0;
      }
    }
    function dy(t, e, r, n) {
      var i = Math.pow(t - e, 2);
      return n ? t < e ? i / 2 : 2 * i : i + Math.abs(r) * r;
    }
    function my(t, e, r) {
      var n = 0;
      return 10 === t && (n -= 1e4), r && (n += 150), 40 !== t && 65288 !== t || (n += 50), 41 !== e && 65289 !== e || (n += 50), n;
    }
    function yy(t, e, r, n, i, s) {
      var a = null,
        o = dy(e, r, i, s);
      var _iterator150 = _createForOfIteratorHelper(n),
        _step150;
      try {
        for (_iterator150.s(); !(_step150 = _iterator150.n()).done;) {
          var _t211 = _step150.value;
          var _n120 = dy(e - _t211.x, r, i, s) + _t211.badness;
          _n120 <= o && (a = _t211, o = _n120);
        }
      } catch (err) {
        _iterator150.e(err);
      } finally {
        _iterator150.f();
      }
      return {
        index: t,
        x: e,
        priorBreak: a,
        badness: o
      };
    }
    function gy(t) {
      return t ? gy(t.priorBreak).concat(t.index) : [];
    }
    function xy(t) {
      var e = .5,
        r = .5;
      switch (t) {
        case "right":
        case "top-right":
        case "bottom-right":
          e = 1;
          break;
        case "left":
        case "top-left":
        case "bottom-left":
          e = 0;
      }
      switch (t) {
        case "bottom":
        case "bottom-right":
        case "bottom-left":
          r = 1;
          break;
        case "top":
        case "top-right":
        case "top-left":
          r = 0;
      }
      return {
        horizontalAlign: e,
        verticalAlign: r
      };
    }
    function by(t, e, r, n, i) {
      if (!(e || r || n || i)) return;
      var s = t.length - 1,
        a = t[s],
        o = (a.x + a.metrics.advance * a.scale) * e;
      for (var _e220 = 0; _e220 <= s; _e220++) t[_e220].x -= o, t[_e220].y += r + n + i;
    }
    function vy(t, e, r, n) {
      var _xy2 = xy(n),
        i = _xy2.horizontalAlign,
        s = _xy2.verticalAlign,
        a = r[0] - t.displaySize[0] * i,
        o = r[1] - t.displaySize[1] * s;
      return {
        imagePrimary: t,
        imageSecondary: e,
        top: o,
        bottom: o + t.displaySize[1],
        left: a,
        right: a + t.displaySize[0]
      };
    }
    function _y(t, e, r, n, i, s) {
      var a = t.imagePrimary;
      var o;
      if (a.content) {
        var _t212 = a.content,
          _e221 = a.pixelRatio || 1;
        o = [_t212[0] / _e221, _t212[1] / _e221, a.displaySize[0] - _t212[2] / _e221, a.displaySize[1] - _t212[3] / _e221];
      }
      var l = e.left * s,
        u = e.right * s;
      var c, h, p, f;
      "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - a.displaySize[0]) / 2, h = f + a.displaySize[0]);
      var d = e.top * s,
        m = e.bottom * s;
      return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + m + n[2]) : (c = i[1] + (d + m - a.displaySize[1]) / 2, p = c + a.displaySize[1]), {
        imagePrimary: a,
        imageSecondary: void 0,
        top: c,
        right: h,
        bottom: p,
        left: f,
        collisionPadding: o
      };
    }
    var wy = /*#__PURE__*/function (_je2) {
      _inherits(wy, _je2);
      var _super65 = _createSuper(wy);
      function wy(t, e, r, n, i) {
        var _this30;
        _classCallCheck(this, wy);
        _this30 = _super65.call(this, t, e), _this30.angle = n, _this30.z = r, void 0 !== i && (_this30.segment = i);
        return _this30;
      }
      _createClass(wy, [{
        key: "clone",
        value: function clone() {
          return new wy(this.x, this.y, this.z, this.angle, this.segment);
        }
      }]);
      return wy;
    }(je);
    function My(t, e, r, n, i) {
      if (void 0 === e.segment) return !0;
      var s = e,
        a = e.segment + 1,
        o = 0;
      for (; o > -r / 2;) {
        if (a--, a < 0) return !1;
        o -= t[a].dist(s), s = t[a];
      }
      o += t[a].dist(t[a + 1]), a++;
      var l = [];
      var u = 0;
      for (; o < r / 2;) {
        var _e222 = t[a],
          _r188 = t[a + 1];
        if (!_r188) return !1;
        var _s98 = t[a - 1].angleTo(_e222) - _e222.angleTo(_r188);
        for (_s98 = Math.abs((_s98 + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
          distance: o,
          angleDelta: _s98
        }), u += _s98; o - l[0].distance > n;) u -= l.shift().angleDelta;
        if (u > i) return !1;
        a++, o += _e222.dist(_r188);
      }
      return !0;
    }
    function Ay(t) {
      var e = 0;
      for (var _r189 = 0; _r189 < t.length - 1; _r189++) e += t[_r189].dist(t[_r189 + 1]);
      return e;
    }
    function Sy(t, e, r) {
      return t ? .6 * e * r : 0;
    }
    function Iy(t, e) {
      return Math.max(t ? t.right - t.left : 0, e ? e.right - e.left : 0);
    }
    function Ty(t, e, r, n, i, s) {
      var a = Sy(r, i, s),
        o = Iy(r, n) * s;
      var l = 0;
      var u = Ay(t) / 2;
      for (var _r190 = 0; _r190 < t.length - 1; _r190++) {
        var _n121 = t[_r190],
          _i132 = t[_r190 + 1],
          _s99 = _n121.dist(_i132);
        if (l + _s99 > u) {
          var _c29 = (u - l) / _s99,
            _h21 = Yn(_n121.x, _i132.x, _c29),
            _p21 = Yn(_n121.y, _i132.y, _c29),
            _f17 = new wy(_h21, _p21, 0, _i132.angleTo(_n121), _r190);
          return !a || My(t, _f17, o, a, e) ? _f17 : void 0;
        }
        l += _s99;
      }
    }
    function ky(t, e, r, n, i, s, a, o, l) {
      var u = Sy(n, s, a),
        c = Iy(n, i),
        h = c * a,
        p = 0 === t[0].x || t[0].x === l || 0 === t[0].y || t[0].y === l;
      return e - h < e / 4 && (e = h + e / 4), Py(t, p ? e / 2 * o % e : (c / 2 + 2 * s) * a * o % e, e, u, r, h, p, !1, l);
    }
    function Py(t, e, r, n, i, s, a, o, l) {
      var u = s / 2,
        c = Ay(t);
      var h = 0,
        p = e - r,
        f = [];
      for (var _e223 = 0; _e223 < t.length - 1; _e223++) {
        var _a81 = t[_e223],
          _o57 = t[_e223 + 1],
          _d17 = _a81.dist(_o57),
          _m12 = _o57.angleTo(_a81);
        for (; p + r < h + _d17;) {
          p += r;
          var _y9 = (p - h) / _d17,
            _g9 = Yn(_a81.x, _o57.x, _y9),
            _x9 = Yn(_a81.y, _o57.y, _y9);
          if (_g9 >= 0 && _g9 < l && _x9 >= 0 && _x9 < l && p - u >= 0 && p + u <= c) {
            var _r191 = new wy(_g9, _x9, 0, _m12, _e223);
            n && !My(t, _r191, s, n, i) || f.push(_r191);
          }
        }
        h += _d17;
      }
      return o || f.length || a || (f = Py(t, h / 2, r, n, i, s, a, !0, l)), f;
    }
    function zy(t, e, r, n, i) {
      var s = [];
      for (var _a82 = 0; _a82 < t.length; _a82++) {
        var _o58 = t[_a82];
        var _l47 = void 0;
        for (var _t213 = 0; _t213 < _o58.length - 1; _t213++) {
          var _a83 = _o58[_t213],
            _u37 = _o58[_t213 + 1];
          _a83.x < e && _u37.x < e || (_a83.x < e ? _a83 = new je(e, _a83.y + (e - _a83.x) / (_u37.x - _a83.x) * (_u37.y - _a83.y))._round() : _u37.x < e && (_u37 = new je(e, _a83.y + (e - _a83.x) / (_u37.x - _a83.x) * (_u37.y - _a83.y))._round()), _a83.y < r && _u37.y < r || (_a83.y < r ? _a83 = new je(_a83.x + (r - _a83.y) / (_u37.y - _a83.y) * (_u37.x - _a83.x), r)._round() : _u37.y < r && (_u37 = new je(_a83.x + (r - _a83.y) / (_u37.y - _a83.y) * (_u37.x - _a83.x), r)._round()), _a83.x >= n && _u37.x >= n || (_a83.x >= n ? _a83 = new je(n, _a83.y + (n - _a83.x) / (_u37.x - _a83.x) * (_u37.y - _a83.y))._round() : _u37.x >= n && (_u37 = new je(n, _a83.y + (n - _a83.x) / (_u37.x - _a83.x) * (_u37.y - _a83.y))._round()), _a83.y >= i && _u37.y >= i || (_a83.y >= i ? _a83 = new je(_a83.x + (i - _a83.y) / (_u37.y - _a83.y) * (_u37.x - _a83.x), i)._round() : _u37.y >= i && (_u37 = new je(_a83.x + (i - _a83.y) / (_u37.y - _a83.y) * (_u37.x - _a83.x), i)._round()), _l47 && _a83.equals(_l47[_l47.length - 1]) || (_l47 = [_a83], s.push(_l47)), _l47.push(_u37)))));
        }
      }
      return s;
    }
    function Ey(t) {
      var e = 0,
        r = 0;
      var _iterator151 = _createForOfIteratorHelper(t),
        _step151;
      try {
        for (_iterator151.s(); !(_step151 = _iterator151.n()).done;) {
          var _n122 = _step151.value;
          e += _n122.w * _n122.h, r = Math.max(r, _n122.w);
        }
      } catch (err) {
        _iterator151.e(err);
      } finally {
        _iterator151.f();
      }
      t.sort(function (t, e) {
        return e.h - t.h;
      });
      var n = [{
        x: 0,
        y: 0,
        w: Math.max(Math.ceil(Math.sqrt(e / .95)), r),
        h: 1 / 0
      }];
      var i = 0,
        s = 0;
      var _iterator152 = _createForOfIteratorHelper(t),
        _step152;
      try {
        for (_iterator152.s(); !(_step152 = _iterator152.n()).done;) {
          var _e224 = _step152.value;
          for (var _t214 = n.length - 1; _t214 >= 0; _t214--) {
            var _r192 = n[_t214];
            if (!(_e224.w > _r192.w || _e224.h > _r192.h)) {
              if (_e224.x = _r192.x, _e224.y = _r192.y, s = Math.max(s, _e224.y + _e224.h), i = Math.max(i, _e224.x + _e224.w), _e224.w === _r192.w && _e224.h === _r192.h) {
                var _e225 = n.pop();
                _t214 < n.length && (n[_t214] = _e225);
              } else _e224.h === _r192.h ? (_r192.x += _e224.w, _r192.w -= _e224.w) : _e224.w === _r192.w ? (_r192.y += _e224.h, _r192.h -= _e224.h) : (n.push({
                x: _r192.x + _e224.w,
                y: _r192.y,
                w: _r192.w - _e224.w,
                h: _e224.h
              }), _r192.y += _e224.h, _r192.h -= _e224.h);
              break;
            }
          }
        }
      } catch (err) {
        _iterator152.e(err);
      } finally {
        _iterator152.f();
      }
      return {
        w: i,
        h: s,
        fill: e / (i * s) || 0
      };
    }
    So(wy, "Anchor");
    var By = 1;
    var Dy = /*#__PURE__*/function () {
      function Dy(t, _ref125) {
        var e = _ref125.pixelRatio,
          r = _ref125.version,
          n = _ref125.stretchX,
          i = _ref125.stretchY,
          s = _ref125.content;
        _classCallCheck(this, Dy);
        this.paddedRect = t, this.pixelRatio = e, this.stretchX = n, this.stretchY = i, this.content = s, this.version = r;
      }
      _createClass(Dy, [{
        key: "tl",
        get: function get() {
          return [this.paddedRect.x + By, this.paddedRect.y + By];
        }
      }, {
        key: "br",
        get: function get() {
          return [this.paddedRect.x + this.paddedRect.w - By, this.paddedRect.y + this.paddedRect.h - By];
        }
      }, {
        key: "displaySize",
        get: function get() {
          return [(this.paddedRect.w - 2 * By) / this.pixelRatio, (this.paddedRect.h - 2 * By) / this.pixelRatio];
        }
      }]);
      return Dy;
    }();
    var Ry = /*#__PURE__*/function () {
      function Ry(t, e, r) {
        _classCallCheck(this, Ry);
        var n = {},
          i = {};
        this.haveRenderCallbacks = [];
        var s = [];
        this.addImages(t, n, s), this.addImages(e, i, s);
        var _Ey = Ey(s),
          a = _Ey.w,
          o = _Ey.h,
          l = new gp({
            width: a || 1,
            height: o || 1
          });
        for (var _e226 in t) {
          var _i133 = t[_e226],
            _s100 = n[_e226].paddedRect;
          gp.copy(_i133.data, l, {
            x: 0,
            y: 0
          }, {
            x: _s100.x + By,
            y: _s100.y + By
          }, _i133.data, r, _i133.sdf);
        }
        for (var _t215 in e) {
          var _n123 = e[_t215],
            _s101 = i[_t215].paddedRect,
            _a84 = _s101.x + By,
            _o59 = _s101.y + By,
            _u38 = _n123.data.width,
            _c30 = _n123.data.height;
          gp.copy(_n123.data, l, {
            x: 0,
            y: 0
          }, {
            x: _a84,
            y: _o59
          }, _n123.data, r), gp.copy(_n123.data, l, {
            x: 0,
            y: _c30 - 1
          }, {
            x: _a84,
            y: _o59 - 1
          }, {
            width: _u38,
            height: 1
          }, r), gp.copy(_n123.data, l, {
            x: 0,
            y: 0
          }, {
            x: _a84,
            y: _o59 + _c30
          }, {
            width: _u38,
            height: 1
          }, r), gp.copy(_n123.data, l, {
            x: _u38 - 1,
            y: 0
          }, {
            x: _a84 - 1,
            y: _o59
          }, {
            width: 1,
            height: _c30
          }, r), gp.copy(_n123.data, l, {
            x: 0,
            y: 0
          }, {
            x: _a84 + _u38,
            y: _o59
          }, {
            width: 1,
            height: _c30
          }, r);
        }
        this.image = l, this.iconPositions = n, this.patternPositions = i;
      }
      _createClass(Ry, [{
        key: "addImages",
        value: function addImages(t, e, r) {
          for (var _n124 in t) {
            var _i134 = t[_n124],
              _s102 = {
                x: 0,
                y: 0,
                w: _i134.data.width + 2 * By,
                h: _i134.data.height + 2 * By
              };
            r.push(_s102), e[_n124] = new Dy(_s102, _i134), _i134.hasRenderCallback && this.haveRenderCallbacks.push(_n124);
          }
        }
      }, {
        key: "patchUpdatedImages",
        value: function patchUpdatedImages(t, e, r) {
          this.haveRenderCallbacks = this.haveRenderCallbacks.filter(function (e) {
            return t.hasImage(e, r);
          }), t.dispatchRenderCallbacks(this.haveRenderCallbacks, r);
          for (var _n125 in t.getUpdatedImages(r)) this.patchUpdatedImage(this.iconPositions[_n125], t.getImage(_n125, r), e), this.patchUpdatedImage(this.patternPositions[_n125], t.getImage(_n125, r), e);
        }
      }, {
        key: "patchUpdatedImage",
        value: function patchUpdatedImage(t, e, r) {
          if (!t || !e) return;
          if (t.version === e.version) return;
          t.version = e.version;
          var _t$tl = _slicedToArray(t.tl, 2),
            n = _t$tl[0],
            i = _t$tl[1],
            s = !!Object.keys(this.patternPositions).length;
          r.update(e.data, {
            useMipmap: s
          }, {
            x: n,
            y: i
          });
        }
      }]);
      return Ry;
    }();
    So(Dy, "ImagePosition"), So(Ry, "ImageAtlas");
    var Cy = 1e20;
    function Ly(t, e, r, n, i, s, a, o, l) {
      for (var _u39 = e; _u39 < e + n; _u39++) Vy(t, r * s + _u39, s, i, a, o, l);
      for (var _u40 = r; _u40 < r + i; _u40++) Vy(t, _u40 * s + e, 1, n, a, o, l);
    }
    function Vy(t, e, r, n, i, s, a) {
      s[0] = 0, a[0] = -Cy, a[1] = Cy, i[0] = t[e];
      for (var _o60 = 1, _l48 = 0, _u41 = 0; _o60 < n; _o60++) {
        i[_o60] = t[e + _o60 * r];
        var _n126 = _o60 * _o60;
        do {
          var _t216 = s[_l48];
          _u41 = (i[_o60] - i[_t216] + _n126 - _t216 * _t216) / (_o60 - _t216) / 2;
        } while (_u41 <= a[_l48] && --_l48 > -1);
        _l48++, s[_l48] = _o60, a[_l48] = _u41, a[_l48 + 1] = Cy;
      }
      for (var _o61 = 0, _l49 = 0; _o61 < n; _o61++) {
        for (; a[_l49 + 1] < _o61;) _l49++;
        var _n127 = s[_l49],
          _u42 = _o61 - _n127;
        t[e + _o61 * r] = i[_n127] + _u42 * _u42;
      }
    }
    var Fy = 2,
      Oy = {
        none: 0,
        ideographs: 1,
        all: 2
      };
    var Uy = /*#__PURE__*/function () {
      function Uy(t, e, r) {
        _classCallCheck(this, Uy);
        this.requestManager = t, this.localGlyphMode = e, this.localFontFamily = r, this.urls = {}, this.entries = {}, this.localGlyphs = {
          200: {},
          400: {},
          500: {},
          900: {}
        };
      }
      _createClass(Uy, [{
        key: "setURL",
        value: function setURL(t, e) {
          this.urls[e] = t;
        }
      }, {
        key: "getGlyphs",
        value: function getGlyphs(t, e, r) {
          var _this31 = this;
          var i = [],
            s = this.urls[e] || n.GLYPHS_URL;
          for (var _e227 in t) {
            var _iterator153 = _createForOfIteratorHelper(t[_e227]),
              _step153;
            try {
              for (_iterator153.s(); !(_step153 = _iterator153.n()).done;) {
                var _r193 = _step153.value;
                i.push({
                  stack: _e227,
                  id: _r193
                });
              }
            } catch (err) {
              _iterator153.e(err);
            } finally {
              _iterator153.f();
            }
          }
          tr(i, function (_ref126, r) {
            var t = _ref126.stack,
              e = _ref126.id;
            var n = _this31.entries[t];
            n || (n = _this31.entries[t] = {
              glyphs: {},
              requests: {},
              ranges: {},
              ascender: void 0,
              descender: void 0
            });
            var i = n.glyphs[e];
            if (void 0 !== i) return void r(null, {
              stack: t,
              id: e,
              glyph: i
            });
            if (i = _this31._tinySDF(n, t, e), i) return n.glyphs[e] = i, void r(null, {
              stack: t,
              id: e,
              glyph: i
            });
            var a = Math.floor(e / 256);
            if (256 * a > 65535) return void r(new Error("glyphs > 65535 not supported"));
            if (n.ranges[a]) return void r(null, {
              stack: t,
              id: e,
              glyph: i
            });
            var o = n.requests[a];
            o || (o = n.requests[a] = [], Uy.loadGlyphRange(t, a, s, _this31.requestManager, function (t, e) {
              if (e) {
                n.ascender = e.ascender, n.descender = e.descender;
                for (var _t217 in e.glyphs) _this31._doesCharSupportLocalGlyph(+_t217) || (n.glyphs[+_t217] = e.glyphs[+_t217]);
                n.ranges[a] = !0;
              }
              var _iterator154 = _createForOfIteratorHelper(o),
                _step154;
              try {
                for (_iterator154.s(); !(_step154 = _iterator154.n()).done;) {
                  var _r194 = _step154.value;
                  _r194(t, e);
                }
              } catch (err) {
                _iterator154.e(err);
              } finally {
                _iterator154.f();
              }
              delete n.requests[a];
            })), o.push(function (n, i) {
              n ? r(n) : i && r(null, {
                stack: t,
                id: e,
                glyph: i.glyphs[e] || null
              });
            });
          }, function (t, e) {
            if (t) r(t);else if (e) {
              var _t218 = {};
              var _iterator155 = _createForOfIteratorHelper(e),
                _step155;
              try {
                for (_iterator155.s(); !(_step155 = _iterator155.n()).done;) {
                  var _step155$value = _step155.value,
                    _r195 = _step155$value.stack,
                    _n128 = _step155$value.id,
                    _i135 = _step155$value.glyph;
                  void 0 === _t218[_r195] && (_t218[_r195] = {}), void 0 === _t218[_r195].glyphs && (_t218[_r195].glyphs = {}), _t218[_r195].glyphs[_n128] = _i135 && {
                    id: _i135.id,
                    bitmap: _i135.bitmap.clone(),
                    metrics: _i135.metrics
                  }, _t218[_r195].ascender = _this31.entries[_r195].ascender, _t218[_r195].descender = _this31.entries[_r195].descender;
                }
              } catch (err) {
                _iterator155.e(err);
              } finally {
                _iterator155.f();
              }
              r(null, _t218);
            }
          });
        }
      }, {
        key: "_doesCharSupportLocalGlyph",
        value: function _doesCharSupportLocalGlyph(t) {
          return this.localGlyphMode !== Oy.none && (this.localGlyphMode === Oy.all ? !!this.localFontFamily : !!this.localFontFamily && (zo["CJK Unified Ideographs"](t) || zo["Hangul Syllables"](t) || zo.Hiragana(t) || zo.Katakana(t) || zo["CJK Symbols and Punctuation"](t) || zo["CJK Unified Ideographs Extension A"](t) || zo["CJK Unified Ideographs Extension B"](t)));
        }
      }, {
        key: "_tinySDF",
        value: function _tinySDF(t, e, r) {
          var n = this.localFontFamily;
          if (!n || !this._doesCharSupportLocalGlyph(r)) return;
          var i = t.tinySDF;
          if (!i) {
            var _r196 = "400";
            /bold/i.test(e) ? _r196 = "900" : /medium/i.test(e) ? _r196 = "500" : /light/i.test(e) && (_r196 = "200"), i = t.tinySDF = new Uy.TinySDF({
              fontFamily: n,
              fontWeight: _r196,
              fontSize: 24 * Fy,
              buffer: 3 * Fy,
              radius: 8 * Fy
            }), i.fontWeight = _r196;
          }
          if (this.localGlyphs[i.fontWeight][r]) return this.localGlyphs[i.fontWeight][r];
          var s = String.fromCodePoint(r),
            _i$draw = i.draw(s),
            a = _i$draw.data,
            o = _i$draw.width,
            l = _i$draw.height,
            u = _i$draw.glyphWidth,
            c = _i$draw.glyphHeight,
            h = _i$draw.glyphLeft,
            p = _i$draw.glyphTop,
            f = _i$draw.glyphAdvance;
          return this.localGlyphs[i.fontWeight][r] = {
            id: r,
            bitmap: new yp({
              width: o,
              height: l
            }, a),
            metrics: {
              width: u / Fy,
              height: c / Fy,
              left: h / Fy,
              top: p / Fy - 27,
              advance: f / Fy,
              localGlyph: !0
            }
          };
        }
      }]);
      return Uy;
    }();
    Uy.loadGlyphRange = function (t, e, r, n, i) {
      var s = 256 * e,
        a = s + 255,
        o = n.transformRequest(n.normalizeGlyphsURL(r).replace("{fontstack}", t).replace("{range}", "".concat(s, "-").concat(a)), Qr.Glyphs);
      nn(o, function (t, e) {
        if (t) i(t);else if (e) {
          var _t219 = {},
            _r197 = function (t) {
              return new Om(t).readFields(ny, {});
            }(e);
          var _iterator156 = _createForOfIteratorHelper(_r197.glyphs),
            _step156;
          try {
            for (_iterator156.s(); !(_step156 = _iterator156.n()).done;) {
              var _e228 = _step156.value;
              _t219[_e228.id] = _e228;
            }
          } catch (err) {
            _iterator156.e(err);
          } finally {
            _iterator156.f();
          }
          i(null, {
            glyphs: _t219,
            ascender: _r197.ascender,
            descender: _r197.descender
          });
        }
      });
    }, Uy.TinySDF = /*#__PURE__*/function () {
      function _class6() {
        var _ref127 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref127$fontSize = _ref127.fontSize,
          t = _ref127$fontSize === void 0 ? 24 : _ref127$fontSize,
          _ref127$buffer = _ref127.buffer,
          e = _ref127$buffer === void 0 ? 3 : _ref127$buffer,
          _ref127$radius = _ref127.radius,
          r = _ref127$radius === void 0 ? 8 : _ref127$radius,
          _ref127$cutoff = _ref127.cutoff,
          n = _ref127$cutoff === void 0 ? .25 : _ref127$cutoff,
          _ref127$fontFamily = _ref127.fontFamily,
          i = _ref127$fontFamily === void 0 ? "sans-serif" : _ref127$fontFamily,
          _ref127$fontWeight = _ref127.fontWeight,
          s = _ref127$fontWeight === void 0 ? "normal" : _ref127$fontWeight,
          _ref127$fontStyle = _ref127.fontStyle,
          a = _ref127$fontStyle === void 0 ? "normal" : _ref127$fontStyle;
        _classCallCheck(this, _class6);
        this.buffer = e, this.cutoff = n, this.radius = r;
        var o = this.size = t + 4 * e,
          l = this._createCanvas(o),
          u = this.ctx = l.getContext("2d", {
            willReadFrequently: !0
          });
        u.font = "".concat(a, " ").concat(s, " ").concat(t, "px ").concat(i), u.textBaseline = "alphabetic", u.textAlign = "left", u.fillStyle = "black", this.gridOuter = new Float64Array(o * o), this.gridInner = new Float64Array(o * o), this.f = new Float64Array(o), this.z = new Float64Array(o + 1), this.v = new Uint16Array(o);
      }
      _createClass(_class6, [{
        key: "_createCanvas",
        value: function _createCanvas(t) {
          var e = document.createElement("canvas");
          return e.width = e.height = t, e;
        }
      }, {
        key: "draw",
        value: function draw(t) {
          var _this$ctx$measureText = this.ctx.measureText(t),
            e = _this$ctx$measureText.width,
            r = _this$ctx$measureText.actualBoundingBoxAscent,
            n = _this$ctx$measureText.actualBoundingBoxDescent,
            i = _this$ctx$measureText.actualBoundingBoxLeft,
            s = _this$ctx$measureText.actualBoundingBoxRight,
            a = Math.ceil(r),
            o = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(s - i))),
            l = Math.min(this.size - this.buffer, a + Math.ceil(n)),
            u = o + 2 * this.buffer,
            c = l + 2 * this.buffer,
            h = Math.max(u * c, 0),
            p = new Uint8ClampedArray(h),
            f = {
              data: p,
              width: u,
              height: c,
              glyphWidth: o,
              glyphHeight: l,
              glyphTop: a,
              glyphLeft: 0,
              glyphAdvance: e
            };
          if (0 === o || 0 === l) return f;
          var d = this.ctx,
            m = this.buffer,
            y = this.gridInner,
            g = this.gridOuter;
          d.clearRect(m, m, o, l), d.fillText(t, m, m + a);
          var x = d.getImageData(m, m, o, l);
          g.fill(Cy, 0, h), y.fill(0, 0, h);
          for (var _t220 = 0; _t220 < l; _t220++) for (var _e229 = 0; _e229 < o; _e229++) {
            var _r198 = x.data[4 * (_t220 * o + _e229) + 3] / 255;
            if (0 === _r198) continue;
            var _n129 = (_t220 + m) * u + _e229 + m;
            if (1 === _r198) g[_n129] = 0, y[_n129] = Cy;else {
              var _t221 = .5 - _r198;
              g[_n129] = _t221 > 0 ? _t221 * _t221 : 0, y[_n129] = _t221 < 0 ? _t221 * _t221 : 0;
            }
          }
          Ly(g, 0, 0, u, c, u, this.f, this.v, this.z), Ly(y, m, m, o, l, u, this.f, this.v, this.z);
          for (var _t222 = 0; _t222 < h; _t222++) {
            var _e230 = Math.sqrt(g[_t222]) - Math.sqrt(y[_t222]);
            p[_t222] = Math.round(255 - 255 * (_e230 / this.radius + this.cutoff));
          }
          return f;
        }
      }]);
      return _class6;
    }();
    var jy = By;
    function Ny(t, e, r, n) {
      var i = [],
        s = t.imagePrimary,
        a = s.pixelRatio,
        o = s.paddedRect.w - 2 * jy,
        l = s.paddedRect.h - 2 * jy,
        u = t.right - t.left,
        c = t.bottom - t.top,
        h = s.stretchX || [[0, o]],
        p = s.stretchY || [[0, l]],
        f = function f(t, e) {
          return t + e[1] - e[0];
        },
        d = h.reduce(f, 0),
        m = p.reduce(f, 0),
        y = o - d,
        g = l - m;
      var x = 0,
        b = d,
        v = 0,
        _ = m,
        w = 0,
        M = y,
        A = 0,
        S = g;
      if (s.content && n) {
        var _t223 = s.content;
        x = $y(h, 0, _t223[0]), v = $y(p, 0, _t223[1]), b = $y(h, _t223[0], _t223[2]), _ = $y(p, _t223[1], _t223[3]), w = _t223[0] - x, A = _t223[1] - v, M = _t223[2] - _t223[0] - b, S = _t223[3] - _t223[1] - _;
      }
      var I = function I(n, i, o, l) {
        var h = Gy(n.stretch - x, b, u, t.left),
          p = Xy(n.fixed - w, M, n.stretch, d),
          f = Gy(i.stretch - v, _, c, t.top),
          y = Xy(i.fixed - A, S, i.stretch, m),
          g = Gy(o.stretch - x, b, u, t.left),
          I = Xy(o.fixed - w, M, o.stretch, d),
          T = Gy(l.stretch - v, _, c, t.top),
          k = Xy(l.fixed - A, S, l.stretch, m),
          P = new je(h, f),
          z = new je(g, f),
          E = new je(g, T),
          B = new je(h, T),
          D = new je(p / a, y / a),
          R = new je(I / a, k / a),
          C = e * Math.PI / 180;
        if (C) {
          var _t224 = Math.sin(C),
            _e231 = Math.cos(C),
            _r199 = [_e231, -_t224, _t224, _e231];
          P._matMult(_r199), z._matMult(_r199), B._matMult(_r199), E._matMult(_r199);
        }
        var L = n.stretch + n.fixed,
          V = o.stretch + o.fixed,
          F = i.stretch + i.fixed,
          O = l.stretch + l.fixed,
          U = t.imageSecondary;
        return {
          tl: P,
          tr: z,
          bl: B,
          br: E,
          texPrimary: {
            x: s.paddedRect.x + jy + L,
            y: s.paddedRect.y + jy + F,
            w: V - L,
            h: O - F
          },
          texSecondary: U ? {
            x: U.paddedRect.x + jy + L,
            y: U.paddedRect.y + jy + F,
            w: V - L,
            h: O - F
          } : void 0,
          writingMode: void 0,
          glyphOffset: [0, 0],
          sectionIndex: 0,
          pixelOffsetTL: D,
          pixelOffsetBR: R,
          minFontScaleX: M / a / u,
          minFontScaleY: S / a / c,
          isSDF: r
        };
      };
      if (n && (s.stretchX || s.stretchY)) {
        var _t225 = qy(h, y, d),
          _e232 = qy(p, g, m);
        for (var _r200 = 0; _r200 < _t225.length - 1; _r200++) {
          var _n130 = _t225[_r200],
            _s103 = _t225[_r200 + 1];
          for (var _t226 = 0; _t226 < _e232.length - 1; _t226++) i.push(I(_n130, _e232[_t226], _s103, _e232[_t226 + 1]));
        }
      } else i.push(I({
        fixed: 0,
        stretch: -1
      }, {
        fixed: 0,
        stretch: -1
      }, {
        fixed: 0,
        stretch: o + 1
      }, {
        fixed: 0,
        stretch: l + 1
      }));
      return i;
    }
    function $y(t, e, r) {
      var n = 0;
      var _iterator157 = _createForOfIteratorHelper(t),
        _step157;
      try {
        for (_iterator157.s(); !(_step157 = _iterator157.n()).done;) {
          var _i136 = _step157.value;
          n += Math.max(e, Math.min(r, _i136[1])) - Math.max(e, Math.min(r, _i136[0]));
        }
      } catch (err) {
        _iterator157.e(err);
      } finally {
        _iterator157.f();
      }
      return n;
    }
    function qy(t, e, r) {
      var n = [{
        fixed: -jy,
        stretch: 0
      }];
      var _iterator158 = _createForOfIteratorHelper(t),
        _step158;
      try {
        for (_iterator158.s(); !(_step158 = _iterator158.n()).done;) {
          var _step158$value = _slicedToArray(_step158.value, 2),
            _e233 = _step158$value[0],
            _r201 = _step158$value[1];
          var _t227 = n[n.length - 1];
          n.push({
            fixed: _e233 - _t227.stretch,
            stretch: _t227.stretch
          }), n.push({
            fixed: _e233 - _t227.stretch,
            stretch: _t227.stretch + (_r201 - _e233)
          });
        }
      } catch (err) {
        _iterator158.e(err);
      } finally {
        _iterator158.f();
      }
      return n.push({
        fixed: e + jy,
        stretch: r
      }), n;
    }
    function Gy(t, e, r, n) {
      return t / e * r + n;
    }
    function Xy(t, e, r, n) {
      return t - e * r / n;
    }
    function Yy(t, e, r, n) {
      var i = e + t.positionedLines[n].lineOffset;
      return 0 === n ? r + i / 2 : r + (i + (e + t.positionedLines[n - 1].lineOffset)) / 2;
    }
    function Zy(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var n = 1 / 0,
        i = 1 / 0,
        s = -1 / 0,
        a = -1 / 0;
      var o = t[0];
      for (var _t228 = 0; _t228 < o.length; _t228++) {
        var _e234 = o[_t228];
        (!_t228 || _e234.x < n) && (n = _e234.x), (!_t228 || _e234.y < i) && (i = _e234.y), (!_t228 || _e234.x > s) && (s = _e234.x), (!_t228 || _e234.y > a) && (a = _e234.y);
      }
      var l = Math.min(s - n, a - i);
      var u = l / 2;
      var c = new fs([], Hy);
      if (0 === l) return new je(n, i);
      for (var _e235 = n; _e235 < s; _e235 += l) for (var _r202 = i; _r202 < a; _r202 += l) c.push(new Ky(_e235 + u, _r202 + u, u, t));
      var h = function (t) {
          var e = 0,
            r = 0,
            n = 0;
          var i = t[0];
          for (var _t229 = 0, _s104 = i.length, _a85 = _s104 - 1; _t229 < _s104; _a85 = _t229++) {
            var _s105 = i[_t229],
              _o62 = i[_a85],
              _l50 = _s105.x * _o62.y - _o62.x * _s105.y;
            r += (_s105.x + _o62.x) * _l50, n += (_s105.y + _o62.y) * _l50, e += 3 * _l50;
          }
          return new Ky(r / e, n / e, 0, t);
        }(t),
        p = c.length;
      for (; c.length;) {
        var _n131 = c.pop();
        (_n131.d > h.d || !h.d) && (h = _n131, r && console.log("found best %d after %d probes", Math.round(1e4 * _n131.d) / 1e4, p)), _n131.max - h.d <= e || (u = _n131.h / 2, c.push(new Ky(_n131.p.x - u, _n131.p.y - u, u, t)), c.push(new Ky(_n131.p.x + u, _n131.p.y - u, u, t)), c.push(new Ky(_n131.p.x - u, _n131.p.y + u, u, t)), c.push(new Ky(_n131.p.x + u, _n131.p.y + u, u, t)), p += 4);
      }
      return r && (console.log("num probes: ".concat(p)), console.log("best distance: ".concat(h.d))), h.p;
    }
    function Hy(t, e) {
      return e.max - t.max;
    }
    var Ky = /*#__PURE__*/_createClass(function Ky(t, e, r, n) {
      _classCallCheck(this, Ky);
      this.p = new je(t, e), this.h = r, this.d = function (t, e) {
        var r = !1,
          n = 1 / 0;
        for (var _i137 = 0; _i137 < e.length; _i137++) {
          var _s106 = e[_i137];
          for (var _e236 = 0, _i138 = _s106.length, _a86 = _i138 - 1; _e236 < _i138; _a86 = _e236++) {
            var _i139 = _s106[_e236],
              _o63 = _s106[_a86];
            _i139.y > t.y != _o63.y > t.y && t.x < (_o63.x - _i139.x) * (t.y - _i139.y) / (_o63.y - _i139.y) + _i139.x && (r = !r), n = Math.min(n, lh(t, _i139, _o63));
          }
        }
        return (r ? 1 : -1) * Math.sqrt(n);
      }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
    });
    var Wy = Number.POSITIVE_INFINITY,
      Jy = Math.sqrt(2);
    function Qy(t, _ref128) {
      var _ref129 = _slicedToArray(_ref128, 2),
        e = _ref129[0],
        r = _ref129[1];
      var n = 0,
        i = 0;
      if (r === Wy) {
        e < 0 && (e = 0);
        var _r203 = e / Jy;
        switch (t) {
          case "top-right":
          case "top-left":
            i = _r203 - 7;
            break;
          case "bottom-right":
          case "bottom-left":
            i = 7 - _r203;
            break;
          case "bottom":
            i = 7 - e;
            break;
          case "top":
            i = e - 7;
        }
        switch (t) {
          case "top-right":
          case "bottom-right":
            n = -_r203;
            break;
          case "top-left":
          case "bottom-left":
            n = _r203;
            break;
          case "left":
            n = e;
            break;
          case "right":
            n = -e;
        }
      } else {
        switch (e = Math.abs(e), r = Math.abs(r), t) {
          case "top-right":
          case "top-left":
          case "top":
            i = r - 7;
            break;
          case "bottom-right":
          case "bottom-left":
          case "bottom":
            i = 7 - r;
        }
        switch (t) {
          case "top-right":
          case "bottom-right":
          case "right":
            n = -e;
            break;
          case "top-left":
          case "bottom-left":
          case "left":
            n = e;
        }
      }
      return [n, i];
    }
    function tg(t) {
      switch (t) {
        case "right":
        case "top-right":
        case "bottom-right":
          return "right";
        case "left":
        case "top-left":
        case "bottom-left":
          return "left";
      }
      return "center";
    }
    function eg(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d) {
      var m = s.textMaxSize.evaluate(e, {}, h);
      void 0 === m && (m = a);
      var y = t.layers[0].layout,
        g = y.get("icon-offset").evaluate(e, {}, h),
        x = sg(r.horizontal) || r.vertical,
        b = "globe" === p.name,
        v = Xm,
        _ = a / v,
        w = t.tilePixelRatio * m / v,
        M = (E = t.overscaling, t.zoom > 18 && E > 2 && (E >>= 1), Math.max(ds / (512 * E), 1) * y.get("symbol-spacing")),
        A = y.get("text-padding") * t.tilePixelRatio,
        S = y.get("icon-padding") * t.tilePixelRatio,
        I = Ge(y.get("text-max-angle")),
        T = "map" === y.get("text-rotation-alignment") && "point" !== y.get("symbol-placement"),
        k = "map" === y.get("icon-rotation-alignment") && "point" !== y.get("symbol-placement"),
        P = y.get("symbol-placement"),
        z = M / 2;
      var E;
      var B = y.get("icon-text-fit").evaluate(e, {}, h),
        D = y.get("icon-text-fit-padding").evaluate(e, {}, h),
        R = "none" !== B;
      var C;
      !1 === t.hasAnyIconTextFit && R && (t.hasAnyIconTextFit = !0), n && R && (t.allowVerticalPlacement && r.vertical && (C = _y(n, r.vertical, B, D, g, _)), x && (n = _y(n, x, B, D, g, _)));
      var L = function L(a, o, m) {
        if (o.x < 0 || o.x >= ds || o.y < 0 || o.y >= ds) return;
        var y = null;
        if (b) {
          var _p$projectTilePoint = p.projectTilePoint(o.x, o.y, m),
            _t230 = _p$projectTilePoint.x,
            _e237 = _p$projectTilePoint.y,
            _r204 = _p$projectTilePoint.z;
          y = {
            anchor: new wy(_t230, _e237, _r204, 0, void 0),
            up: p.upVector(m, o.x, o.y)
          };
        }
        !function (t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g, x, b, v, _, w, M, A, S, I, _l$layout$get$evaluat, _l$layout$get$evaluat2) {
          var T = t.addToLineVertexArray(e, n);
          var k,
            P,
            z,
            E,
            B,
            D,
            R,
            C = 0,
            L = 0,
            V = 0,
            F = 0,
            O = -1,
            U = -1;
          var j = {};
          var N = Rn("");
          var $ = r ? r.anchor : e,
            q = "none" !== l.layout.get("icon-text-fit").evaluate(v, {}, A);
          var G = 0,
            X = 0;
          if (void 0 === l._unevaluatedLayout.getValue("text-radial-offset") ? (_l$layout$get$evaluat = l.layout.get("text-offset").evaluate(v, {}, A).map(function (t) {
            return t * Xm;
          }), _l$layout$get$evaluat2 = _slicedToArray(_l$layout$get$evaluat, 2), G = _l$layout$get$evaluat2[0], X = _l$layout$get$evaluat2[1], _l$layout$get$evaluat) : (G = l.layout.get("text-radial-offset").evaluate(v, {}, A) * Xm, X = Wy), t.allowVerticalPlacement && i.vertical) {
            var _t231 = i.vertical;
            if (d) D = og(_t231), o && (R = og(o));else {
              var _r205 = l.layout.get("text-rotate").evaluate(v, {}, A) + 90;
              z = ag(u, $, e, c, h, p, _t231, f, _r205, m), o && (E = ag(u, $, e, c, h, p, o, g, _r205));
            }
          }
          if (s) {
            var _n132 = l.layout.get("icon-rotate").evaluate(v, {}, A),
              _i140 = Ny(s, _n132, w, q),
              _a87 = o ? Ny(o, _n132, w, q) : void 0;
            P = ag(u, $, e, c, h, p, s, g, _n132), C = 4 * _i140.length;
            var _f18 = t.iconSizeData;
            var _d18 = null;
            "source" === _f18.kind ? (_d18 = [Ym * l.layout.get("icon-size").evaluate(v, {}, A)], _d18[0] > ng && dr("".concat(t.layerIds[0], ": Value for \"icon-size\" is >= ").concat(rg, ". Reduce your \"icon-size\"."))) : "composite" === _f18.kind && (_d18 = [Ym * _.compositeIconSizes[0].evaluate(v, {}, A), Ym * _.compositeIconSizes[1].evaluate(v, {}, A)], (_d18[0] > ng || _d18[1] > ng) && dr("".concat(t.layerIds[0], ": Value for \"icon-size\" is >= ").concat(rg, ". Reduce your \"icon-size\"."))), t.addSymbols(t.icon, _i140, _d18, b, x, v, !1, r, e, T.lineStartIndex, T.lineLength, -1, M, A, S, I), O = t.icon.placedSymbolArray.length - 1, _a87 && (L = 4 * _a87.length, t.addSymbols(t.icon, _a87, _d18, b, x, v, oy.vertical, r, e, T.lineStartIndex, T.lineLength, -1, M, A, S, I), U = t.icon.placedSymbolArray.length - 1);
          }
          for (var _n133 in i.horizontal) {
            var _s107 = i.horizontal[_n133];
            k || (N = Rn(_s107.text), d ? B = og(_s107) : k = ag(u, $, e, c, h, p, _s107, f, l.layout.get("text-rotate").evaluate(v, {}, A), m));
            var _o64 = 1 === _s107.positionedLines.length;
            if (V += ig(t, r, e, _s107, a, l, d, v, m, T, i.vertical ? oy.horizontal : oy.horizontalOnly, _o64 ? Object.keys(i.horizontal) : [_n133], j, O, _, M, A, S), _o64) break;
          }
          i.vertical && (F += ig(t, r, e, i.vertical, a, l, d, v, m, T, oy.vertical, ["vertical"], j, U, _, M, A, S));
          var Y = -1;
          var Z = function Z(t, e) {
            return t ? Math.max(t, e) : e;
          };
          Y = Z(B, Y), Y = Z(D, Y), Y = Z(R, Y);
          var H = Y > -1 ? 1 : 0;
          t.glyphOffsetArray.length >= 65535 && dr("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== v.sortKey && t.addToSortKeyRanges(t.symbolInstances.length, v.sortKey), t.symbolInstances.emplaceBack(e.x, e.y, $.x, $.y, $.z, j.right >= 0 ? j.right : -1, j.center >= 0 ? j.center : -1, j.left >= 0 ? j.left : -1, j.vertical >= 0 ? j.vertical : -1, O, U, N, void 0 !== k ? k : t.collisionBoxArray.length, void 0 !== k ? k + 1 : t.collisionBoxArray.length, void 0 !== z ? z : t.collisionBoxArray.length, void 0 !== z ? z + 1 : t.collisionBoxArray.length, void 0 !== P ? P : t.collisionBoxArray.length, void 0 !== P ? P + 1 : t.collisionBoxArray.length, E || t.collisionBoxArray.length, E ? E + 1 : t.collisionBoxArray.length, c, V, F, C, L, H, 0, G, X, Y, 0, q ? 1 : 0);
        }(t, o, y, a, r, n, i, C, t.layers[0], t.collisionBoxArray, e.index, e.sourceLayerIndex, t.index, A, T, l, 0, S, k, g, e, s, u, c, h, f, d);
      };
      if ("line" === P) {
        var _iterator159 = _createForOfIteratorHelper(zy(e.geometry, 0, 0, ds, ds)),
          _step159;
        try {
          for (_iterator159.s(); !(_step159 = _iterator159.n()).done;) {
            var _i141 = _step159.value;
            var _e238 = ky(_i141, M, I, r.vertical || x, n, v, w, t.overscaling, ds);
            var _iterator160 = _createForOfIteratorHelper(_e238),
              _step160;
            try {
              for (_iterator160.s(); !(_step160 = _iterator160.n()).done;) {
                var _r206 = _step160.value;
                x && lg(t, x.text, z, _r206) || L(_i141, _r206, h);
              }
            } catch (err) {
              _iterator160.e(err);
            } finally {
              _iterator160.f();
            }
          }
        } catch (err) {
          _iterator159.e(err);
        } finally {
          _iterator159.f();
        }
      } else if ("line-center" === P) {
        var _iterator161 = _createForOfIteratorHelper(e.geometry),
          _step161;
        try {
          for (_iterator161.s(); !(_step161 = _iterator161.n()).done;) {
            var _t232 = _step161.value;
            if (_t232.length > 1) {
              var _e239 = Ty(_t232, I, r.vertical || x, n, v, w);
              _e239 && L(_t232, _e239, h);
            }
          }
        } catch (err) {
          _iterator161.e(err);
        } finally {
          _iterator161.f();
        }
      } else if ("Polygon" === e.type) {
        var _iterator162 = _createForOfIteratorHelper(Wp(e.geometry, 0)),
          _step162;
        try {
          for (_iterator162.s(); !(_step162 = _iterator162.n()).done;) {
            var _t233 = _step162.value;
            var _e240 = Zy(_t233, 16);
            L(_t233[0], new wy(_e240.x, _e240.y, 0, 0, void 0), h);
          }
        } catch (err) {
          _iterator162.e(err);
        } finally {
          _iterator162.f();
        }
      } else if ("LineString" === e.type) {
        var _iterator163 = _createForOfIteratorHelper(e.geometry),
          _step163;
        try {
          for (_iterator163.s(); !(_step163 = _iterator163.n()).done;) {
            var _t234 = _step163.value;
            L(_t234, new wy(_t234[0].x, _t234[0].y, 0, 0, void 0), h);
          }
        } catch (err) {
          _iterator163.e(err);
        } finally {
          _iterator163.f();
        }
      } else if ("Point" === e.type) {
        var _iterator164 = _createForOfIteratorHelper(e.geometry),
          _step164;
        try {
          for (_iterator164.s(); !(_step164 = _iterator164.n()).done;) {
            var _t235 = _step164.value;
            var _iterator165 = _createForOfIteratorHelper(_t235),
              _step165;
            try {
              for (_iterator165.s(); !(_step165 = _iterator165.n()).done;) {
                var _e241 = _step165.value;
                L([_e241], new wy(_e241.x, _e241.y, 0, 0, void 0), h);
              }
            } catch (err) {
              _iterator165.e(err);
            } finally {
              _iterator165.f();
            }
          }
        } catch (err) {
          _iterator164.e(err);
        } finally {
          _iterator164.f();
        }
      }
    }
    var rg = 255,
      ng = rg * Ym;
    function ig(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m, y, g) {
      var x = function (t, e, r, n, i, s, a, o) {
          var l = [];
          if (0 === e.positionedLines.length) return l;
          var u = n.layout.get("text-rotate").evaluate(s, {}) * Math.PI / 180,
            c = function (t) {
              var e = t[0],
                r = t[1],
                n = e * r;
              return n > 0 ? [e, -r] : n < 0 ? [-e, r] : 0 === e ? [r, e] : [r, -e];
            }(r);
          var h = Math.abs(e.top - e.bottom);
          var _iterator166 = _createForOfIteratorHelper(e.positionedLines),
            _step166;
          try {
            for (_iterator166.s(); !(_step166 = _iterator166.n()).done;) {
              var _t239 = _step166.value;
              h -= _t239.lineOffset;
            }
          } catch (err) {
            _iterator166.e(err);
          } finally {
            _iterator166.f();
          }
          var p = e.positionedLines.length,
            f = h / p;
          var d = e.top - r[1];
          for (var _t236 = 0; _t236 < p; ++_t236) {
            var _n134 = e.positionedLines[_t236];
            d = Yy(e, f, d, _t236);
            var _iterator167 = _createForOfIteratorHelper(_n134.positionedGlyphs),
              _step167;
            try {
              for (_iterator167.s(); !(_step167 = _iterator167.n()).done;) {
                var _t237 = _step167.value;
                if (!_t237.rect) continue;
                var _n135 = _t237.rect || {};
                var _s108 = ay + 1,
                  _h22 = !0,
                  _p22 = 1,
                  _f19 = 0;
                if (_t237.imageName) {
                  var _e242 = a[_t237.imageName];
                  if (!_e242) continue;
                  if (_e242.sdf) {
                    dr("SDF images are not supported in formatted text and will be ignored.");
                    continue;
                  }
                  _h22 = !1, _p22 = _e242.pixelRatio, _s108 = By / _p22;
                }
                var _m13 = (i || o) && _t237.vertical,
                  _y10 = _t237.metrics.advance * _t237.scale / 2,
                  _g10 = _t237.metrics,
                  _x10 = _t237.rect;
                if (null === _x10) continue;
                o && e.verticalizable && (_f19 = _t237.imageName ? _y10 - _t237.metrics.width * _t237.scale / 2 : 0);
                var _b7 = i ? [_t237.x + _y10, _t237.y] : [0, 0];
                var _v6 = [0, 0],
                  _7 = [0, 0],
                  _w5 = !1;
                i || (_m13 ? (_7 = [_t237.x + _y10 + c[0], _t237.y + c[1] - _f19], _w5 = !0) : _v6 = [_t237.x + _y10 + r[0], _t237.y + r[1] - _f19]);
                var _M6 = _x10.w * _t237.scale / (_p22 * (_t237.localGlyph ? Fy : 1)),
                  _A6 = _x10.h * _t237.scale / (_p22 * (_t237.localGlyph ? Fy : 1));
                var _S5 = void 0,
                  _I4 = void 0,
                  _T4 = void 0,
                  _k4 = void 0;
                if (_m13) {
                  var _e243 = _t237.y - d,
                    _r207 = new je(-_y10, _y10 - _e243),
                    _n136 = -Math.PI / 2,
                    _i142 = _construct2(je, _toConsumableArray(_7));
                  _S5 = new je(-_y10 + _v6[0], _v6[1]), _S5._rotateAround(_n136, _r207)._add(_i142), _S5.x += -_e243 + _y10, _S5.y -= (_g10.left - _s108) * _t237.scale;
                  var _a88 = _t237.imageName ? _g10.advance * _t237.scale : Xm * _t237.scale,
                    _o65 = String.fromCodePoint(_t237.glyph);
                  ty(_o65) ? _S5.x += (1 - _s108) * _t237.scale : ey(_o65) ? _S5.x += _a88 - _g10.height * _t237.scale + (-_s108 - 1) * _t237.scale : _S5.x += _t237.imageName || _g10.width + 2 * _s108 === _x10.w && _g10.height + 2 * _s108 === _x10.h ? (_a88 - _A6) / 2 : (_a88 - (_g10.height + 2 * _s108) * _t237.scale) / 2, _I4 = new je(_S5.x, _S5.y - _M6), _T4 = new je(_S5.x + _A6, _S5.y), _k4 = new je(_S5.x + _A6, _S5.y - _M6);
                } else {
                  var _e244 = (_g10.left - _s108) * _t237.scale - _y10 + _v6[0],
                    _r208 = (-_g10.top - _s108) * _t237.scale + _v6[1],
                    _n137 = _e244 + _M6,
                    _i143 = _r208 + _A6;
                  _S5 = new je(_e244, _r208), _I4 = new je(_n137, _r208), _T4 = new je(_e244, _i143), _k4 = new je(_n137, _i143);
                }
                if (u) {
                  var _t238 = void 0;
                  _t238 = i ? new je(0, 0) : _w5 ? new je(c[0], c[1]) : new je(r[0], r[1]), _S5._rotateAround(u, _t238), _I4._rotateAround(u, _t238), _T4._rotateAround(u, _t238), _k4._rotateAround(u, _t238);
                }
                var _P3 = new je(0, 0),
                  _z2 = new je(0, 0);
                l.push({
                  tl: _S5,
                  tr: _I4,
                  bl: _T4,
                  br: _k4,
                  texPrimary: _n135,
                  texSecondary: void 0,
                  writingMode: e.writingMode,
                  glyphOffset: _b7,
                  sectionIndex: _t237.sectionIndex,
                  isSDF: _h22,
                  pixelOffsetTL: _P3,
                  pixelOffsetBR: _z2,
                  minFontScaleX: 0,
                  minFontScaleY: 0
                });
              }
            } catch (err) {
              _iterator167.e(err);
            } finally {
              _iterator167.f();
            }
          }
          return l;
        }(0, n, l, s, a, o, i, t.allowVerticalPlacement),
        b = t.textSizeData;
      var v = null;
      "source" === b.kind ? (v = [Ym * s.layout.get("text-size").evaluate(o, {}, y)], v[0] > ng && dr("".concat(t.layerIds[0], ": Value for \"text-size\" is >= ").concat(rg, ". Reduce your \"text-size\"."))) : "composite" === b.kind && (v = [Ym * d.compositeTextSizes[0].evaluate(o, {}, y), Ym * d.compositeTextSizes[1].evaluate(o, {}, y)], (v[0] > ng || v[1] > ng) && dr("".concat(t.layerIds[0], ": Value for \"text-size\" is >= ").concat(rg, ". Reduce your \"text-size\"."))), t.addSymbols(t.text, x, v, l, a, o, c, e, r, u.lineStartIndex, u.lineLength, f, m, y, g, !1);
      var _iterator168 = _createForOfIteratorHelper(h),
        _step168;
      try {
        for (_iterator168.s(); !(_step168 = _iterator168.n()).done;) {
          var _e245 = _step168.value;
          p[_e245] = t.text.placedSymbolArray.length - 1;
        }
      } catch (err) {
        _iterator168.e(err);
      } finally {
        _iterator168.f();
      }
      return 4 * x.length;
    }
    function sg(t) {
      for (var _e246 in t) return t[_e246];
      return null;
    }
    function ag(t, e, r, n, i, s, a, o, l, u) {
      var c = a.top,
        h = a.bottom,
        p = a.left,
        f = a.right;
      var d = a.collisionPadding;
      if (d && (p -= d[0], c -= d[1], f += d[2], h += d[3]), l) {
        var _t240 = new je(p, c),
          _e247 = new je(f, c),
          _r209 = new je(p, h),
          _n138 = new je(f, h),
          _i144 = Ge(l);
        var _s109 = new je(0, 0);
        u && (_s109 = new je(u[0], u[1])), _t240._rotateAround(_i144, _s109), _e247._rotateAround(_i144, _s109), _r209._rotateAround(_i144, _s109), _n138._rotateAround(_i144, _s109), p = Math.min(_t240.x, _e247.x, _r209.x, _n138.x), f = Math.max(_t240.x, _e247.x, _r209.x, _n138.x), c = Math.min(_t240.y, _e247.y, _r209.y, _n138.y), h = Math.max(_t240.y, _e247.y, _r209.y, _n138.y);
      }
      return t.emplaceBack(e.x, e.y, e.z, r.x, r.y, p, c, f, h, o, n, i, s), t.length - 1;
    }
    function og(t) {
      t.collisionPadding && (t.top -= t.collisionPadding[1], t.bottom += t.collisionPadding[3]);
      var e = t.bottom - t.top;
      return e > 0 ? Math.max(10, e) : null;
    }
    function lg(t, e, r, n) {
      var i = t.compareText;
      if (e in i) {
        var _t241 = i[e];
        for (var _e248 = _t241.length - 1; _e248 >= 0; _e248--) if (n.dist(_t241[_e248]) < r) return !0;
      } else i[e] = [];
      return i[e].push(n), !1;
    }
    function ug(t, e) {
      var r = t.fovAboveCenter,
        n = t.elevation ? t.elevation.getMinElevationBelowMSL() * e : 0,
        i = (t._camera.position[2] * t.worldSize - n) / Math.cos(t._pitch),
        s = Math.sin(r) * i / Math.sin(Math.max(Math.PI / 2 - t._pitch - r, .01)),
        a = Math.sin(t._pitch) * s + i;
      return Math.min(1.01 * a, i * (1 / t._horizonShift));
    }
    function cg(t, e) {
      if (!e.isReprojectedInTileSpace) return {
        scale: 1 << t.z,
        x: t.x,
        y: t.y,
        x2: t.x + 1,
        y2: t.y + 1,
        projection: e
      };
      var r = Math.pow(2, -t.z),
        n = t.x * r,
        i = (t.x + 1) * r,
        s = t.y * r,
        a = (t.y + 1) * r,
        o = Rc(n),
        l = Rc(i),
        u = Cc(s),
        c = Cc(a),
        h = e.project(o, u),
        p = e.project(l, u),
        f = e.project(l, c),
        d = e.project(o, c);
      var m = Math.min(h.x, p.x, f.x, d.x),
        y = Math.min(h.y, p.y, f.y, d.y),
        g = Math.max(h.x, p.x, f.x, d.x),
        x = Math.max(h.y, p.y, f.y, d.y);
      var b = r / 16;
      function v(t, r, n, i, s, a) {
        var o = (n + s) / 2,
          l = (i + a) / 2,
          u = e.project(Rc(o), Cc(l)),
          c = Math.max(0, m - u.x, y - u.y, u.x - g, u.y - x);
        m = Math.min(m, u.x), g = Math.max(g, u.x), y = Math.min(y, u.y), x = Math.max(x, u.y), c > b && (v(t, u, n, i, o, l), v(u, r, o, l, s, a));
      }
      v(h, p, n, s, i, s), v(p, f, i, s, i, a), v(f, d, i, a, n, a), v(d, h, n, a, n, s), m -= b, y -= b, g += b, x += b;
      var _ = 1 / Math.max(g - m, x - y);
      return {
        scale: _,
        x: m * _,
        y: y * _,
        x2: g * _,
        y2: x * _,
        projection: e
      };
    }
    function hg(t, _ref130) {
      var e = _ref130.x,
        r = _ref130.y;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return new je(((e - n) * t.scale - t.x) * ds, (r * t.scale - t.y) * ds);
    }
    var pg = t.ae.identity(new Float32Array(16));
    var fg = /*#__PURE__*/function () {
      function fg(t) {
        _classCallCheck(this, fg);
        this.spec = t, this.name = t.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = ["custom"], this.center = [0, 0], this.range = [3.5, 7];
      }
      _createClass(fg, [{
        key: "project",
        value: function project(t, e) {
          return {
            x: 0,
            y: 0,
            z: 0
          };
        }
      }, {
        key: "unproject",
        value: function unproject(t, e) {
          return new bc(0, 0);
        }
      }, {
        key: "projectTilePoint",
        value: function projectTilePoint(t, e, r) {
          return {
            x: t,
            y: e,
            z: 0
          };
        }
      }, {
        key: "locationPoint",
        value: function locationPoint(t, e) {
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
          return t._coordinatePoint(t.locationCoordinate(e), r);
        }
      }, {
        key: "pixelsPerMeter",
        value: function pixelsPerMeter(t, e) {
          return Dc(1, t) * e;
        }
      }, {
        key: "pixelSpaceConversion",
        value: function pixelSpaceConversion(t, e, r) {
          return 1;
        }
      }, {
        key: "farthestPixelDistance",
        value: function farthestPixelDistance(t) {
          return ug(t, t.pixelsPerMeter);
        }
      }, {
        key: "pointCoordinate",
        value: function pointCoordinate(t, e, r, n) {
          var i = t.horizonLineFromTop(!1),
            s = new je(e, Math.max(i, r));
          return t.rayIntersectionCoordinate(t.pointRayIntersection(s, n));
        }
      }, {
        key: "pointCoordinate3D",
        value: function pointCoordinate3D(t, e, r) {
          var n = new je(e, r);
          if (t.elevation) return t.elevation.pointCoordinate(n);
          {
            var _e249 = this.pointCoordinate(t, n.x, n.y, 0);
            return [_e249.x, _e249.y, _e249.z];
          }
        }
      }, {
        key: "isPointAboveHorizon",
        value: function isPointAboveHorizon(t, e) {
          if (t.elevation && t.elevation.visibleDemTiles.length) return !this.pointCoordinate3D(t, e.x, e.y);
          var r = t.horizonLineFromTop();
          return e.y < r;
        }
      }, {
        key: "createInversionMatrix",
        value: function createInversionMatrix(t, e) {
          return pg;
        }
      }, {
        key: "createTileMatrix",
        value: function createTileMatrix(e, r, n) {
          var i, s, a;
          var o = n.canonical,
            l = t.ae.identity(new Float64Array(16));
          if (this.isReprojectedInTileSpace) {
            var _u43 = cg(o, this);
            i = 1, s = _u43.x + n.wrap * _u43.scale, a = _u43.y, t.ae.scale(l, l, [i / _u43.scale, i / _u43.scale, e.pixelsPerMeter / r]);
          } else i = r / e.zoomScale(o.z), s = (o.x + Math.pow(2, o.z) * n.wrap) * i, a = o.y * i;
          return t.ae.translate(l, l, [s, a, 0]), t.ae.scale(l, l, [i / ds, i / ds, 1]), l;
        }
      }, {
        key: "upVector",
        value: function upVector(t, e, r) {
          return [0, 0, 1];
        }
      }, {
        key: "upVectorScale",
        value: function upVectorScale(t, e, r) {
          return {
            metersToTile: 1
          };
        }
      }]);
      return fg;
    }();
    var dg = /*#__PURE__*/function (_fg) {
      _inherits(dg, _fg);
      var _super66 = _createSuper(dg);
      function dg(t) {
        var _this32;
        _classCallCheck(this, dg);
        _this32 = _super66.call(this, t), _this32.range = [4, 7], _this32.center = t.center || [-96, 37.5];
        var _this32$parallels = _this32.parallels = t.parallels || [29.5, 45.5],
          _this32$parallels2 = _slicedToArray(_this32$parallels, 2),
          e = _this32$parallels2[0],
          r = _this32$parallels2[1],
          n = Math.sin(Ge(e));
        _this32.n = (n + Math.sin(Ge(r))) / 2, _this32.c = 1 + n * (2 * _this32.n - n), _this32.r0 = Math.sqrt(_this32.c) / _this32.n;
        return _this32;
      }
      _createClass(dg, [{
        key: "project",
        value: function project(t, e) {
          var r = this.n,
            n = this.c,
            i = this.r0,
            s = Ge(t - this.center[0]),
            a = Ge(e),
            o = Math.sqrt(n - 2 * r * Math.sin(a)) / r;
          return {
            x: o * Math.sin(s * r),
            y: o * Math.cos(s * r) - i,
            z: 0
          };
        }
      }, {
        key: "unproject",
        value: function unproject(t, e) {
          var r = this.n,
            n = this.c,
            i = this.r0,
            s = i + e;
          var a = Math.atan2(t, Math.abs(s)) * Math.sign(s);
          s * r < 0 && (a -= Math.PI * Math.sign(t) * Math.sign(s));
          var o = Ge(this.center[0]) * r;
          a = Qe(a, -Math.PI - o, Math.PI - o);
          var l = We(Xe(a / r) + this.center[0], -180, 180),
            u = Math.asin(We((n - (t * t + s * s) * r * r) / (2 * r), -1, 1)),
            c = We(Xe(u), -Vc, Vc);
          return new bc(l, c);
        }
      }]);
      return dg;
    }(fg);
    var mg = 1.340264,
      yg = -.081106,
      gg = 893e-6,
      xg = .003796,
      bg = Math.sqrt(3) / 2;
    var vg = /*#__PURE__*/function (_fg2) {
      _inherits(vg, _fg2);
      var _super67 = _createSuper(vg);
      function vg() {
        _classCallCheck(this, vg);
        return _super67.apply(this, arguments);
      }
      _createClass(vg, [{
        key: "project",
        value: function project(t, e) {
          e = e / 180 * Math.PI, t = t / 180 * Math.PI;
          var r = Math.asin(bg * Math.sin(e)),
            n = r * r,
            i = n * n * n;
          return {
            x: .5 * (t * Math.cos(r) / (bg * (mg + 3 * yg * n + i * (7 * gg + 9 * xg * n))) / Math.PI + .5),
            y: 1 - .5 * (r * (mg + yg * n + i * (gg + xg * n)) / Math.PI + 1),
            z: 0
          };
        }
      }, {
        key: "unproject",
        value: function unproject(t, e) {
          t = (2 * t - .5) * Math.PI;
          var r = e = (2 * (1 - e) - 1) * Math.PI,
            n = r * r,
            i = n * n * n;
          for (var _t242, _s110, _a89, _o66 = 0; _o66 < 12 && (_s110 = r * (mg + yg * n + i * (gg + xg * n)) - e, _a89 = mg + 3 * yg * n + i * (7 * gg + 9 * xg * n), _t242 = _s110 / _a89, r = We(r - _t242, -Math.PI / 3, Math.PI / 3), n = r * r, i = n * n * n, !(Math.abs(_t242) < 1e-12)); ++_o66);
          var s = bg * t * (mg + 3 * yg * n + i * (7 * gg + 9 * xg * n)) / Math.cos(r),
            a = Math.asin(Math.sin(r) / bg),
            o = We(180 * s / Math.PI, -180, 180),
            l = We(180 * a / Math.PI, -Vc, Vc);
          return new bc(o, l);
        }
      }]);
      return vg;
    }(fg);
    var _g = /*#__PURE__*/function (_fg3) {
      _inherits(_g, _fg3);
      var _super68 = _createSuper(_g);
      function _g(t) {
        var _this33;
        _classCallCheck(this, _g);
        _this33 = _super68.call(this, t), _this33.wrap = !0, _this33.supportsWorldCopies = !0;
        return _this33;
      }
      _createClass(_g, [{
        key: "project",
        value: function project(t, e) {
          return {
            x: .5 + t / 360,
            y: .5 - e / 360,
            z: 0
          };
        }
      }, {
        key: "unproject",
        value: function unproject(t, e) {
          var r = 360 * (t - .5),
            n = We(360 * (.5 - e), -Vc, Vc);
          return new bc(r, n);
        }
      }]);
      return _g;
    }(fg);
    var wg = Math.PI / 2;
    function Mg(t) {
      return Math.tan((wg + t) / 2);
    }
    var Ag = /*#__PURE__*/function (_fg4) {
      _inherits(Ag, _fg4);
      var _super69 = _createSuper(Ag);
      function Ag(t) {
        var _this34;
        _classCallCheck(this, Ag);
        _this34 = _super69.call(this, t), _this34.center = t.center || [0, 30];
        var _this34$parallels = _this34.parallels = t.parallels || [30, 30],
          _this34$parallels2 = _slicedToArray(_this34$parallels, 2),
          e = _this34$parallels2[0],
          r = _this34$parallels2[1];
        var n = Ge(e),
          i = Ge(r);
        _this34.southernCenter = n + i < 0, _this34.southernCenter && (n = -n, i = -i);
        var s = Math.cos(n),
          a = Mg(n);
        _this34.n = n === i ? Math.sin(n) : Math.log(s / Math.cos(i)) / Math.log(Mg(i) / a), _this34.f = s * Math.pow(Mg(n), _this34.n) / _this34.n;
        return _this34;
      }
      _createClass(Ag, [{
        key: "project",
        value: function project(t, e) {
          e = Ge(e), this.southernCenter && (e = -e), t = Ge(t - this.center[0]);
          var r = 1e-6,
            n = this.n,
            i = this.f;
          i > 0 ? e < -wg + r && (e = -wg + r) : e > wg - r && (e = wg - r);
          var s = i / Math.pow(Mg(e), n);
          var a = s * Math.sin(n * t),
            o = i - s * Math.cos(n * t);
          return a = .5 * (a / Math.PI + .5), o = .5 * (o / Math.PI + .5), {
            x: a,
            y: this.southernCenter ? o : 1 - o,
            z: 0
          };
        }
      }, {
        key: "unproject",
        value: function unproject(t, e) {
          t = (2 * t - .5) * Math.PI, this.southernCenter && (e = 1 - e), e = (2 * (1 - e) - .5) * Math.PI;
          var r = this.n,
            n = this.f,
            i = n - e,
            s = Math.sign(i),
            a = Math.sign(r) * Math.sqrt(t * t + i * i);
          var o = Math.atan2(t, Math.abs(i)) * s;
          i * r < 0 && (o -= Math.PI * Math.sign(t) * s);
          var l = We(Xe(o / r) + this.center[0], -180, 180),
            u = We(Xe(2 * Math.atan(Math.pow(n / a, 1 / r)) - wg), -Vc, Vc);
          return new bc(l, this.southernCenter ? -u : u);
        }
      }]);
      return Ag;
    }(fg);
    var Sg = /*#__PURE__*/function (_fg5) {
      _inherits(Sg, _fg5);
      var _super70 = _createSuper(Sg);
      function Sg(t) {
        var _this35;
        _classCallCheck(this, Sg);
        _this35 = _super70.call(this, t), _this35.wrap = !0, _this35.supportsWorldCopies = !0, _this35.supportsTerrain = !0, _this35.supportsFog = !0, _this35.supportsFreeCamera = !0, _this35.isReprojectedInTileSpace = !1, _this35.unsupportedLayers = [], _this35.range = null;
        return _this35;
      }
      _createClass(Sg, [{
        key: "project",
        value: function project(t, e) {
          return {
            x: Ec(t),
            y: Bc(e),
            z: 0
          };
        }
      }, {
        key: "unproject",
        value: function unproject(t, e) {
          var r = Rc(t),
            n = Cc(e);
          return new bc(r, n);
        }
      }]);
      return Sg;
    }(fg);
    var Ig = Ge(Vc);
    var Tg = /*#__PURE__*/function (_fg6) {
      _inherits(Tg, _fg6);
      var _super71 = _createSuper(Tg);
      function Tg() {
        _classCallCheck(this, Tg);
        return _super71.apply(this, arguments);
      }
      _createClass(Tg, [{
        key: "project",
        value: function project(t, e) {
          var r = (e = Ge(e)) * e,
            n = r * r;
          return {
            x: .5 * ((t = Ge(t)) * (.8707 - .131979 * r + n * (n * (.003971 * r - .001529 * n) - .013791)) / Math.PI + .5),
            y: 1 - .5 * (e * (1.007226 + r * (.015085 + n * (.028874 * r - .044475 - .005916 * n))) / Math.PI + 1),
            z: 0
          };
        }
      }, {
        key: "unproject",
        value: function unproject(t, e) {
          t = (2 * t - .5) * Math.PI;
          var r = e = (2 * (1 - e) - 1) * Math.PI,
            n = 25,
            i = 0,
            s = r * r;
          do {
            s = r * r;
            var _t243 = s * s;
            i = (r * (1.007226 + s * (.015085 + _t243 * (.028874 * s - .044475 - .005916 * _t243))) - e) / (1.007226 + s * (.045255 + _t243 * (.259866 * s - .311325 - .005916 * 11 * _t243))), r = We(r - i, -Ig, Ig);
          } while (Math.abs(i) > 1e-6 && --n > 0);
          s = r * r;
          var a = We(Xe(t / (.8707 + s * (s * (s * s * s * (.003971 - .001529 * s) - .013791) - .131979))), -180, 180),
            o = Xe(r);
          return new bc(a, o);
        }
      }]);
      return Tg;
    }(fg);
    var kg = Ge(Vc);
    var Pg = /*#__PURE__*/function (_fg7) {
      _inherits(Pg, _fg7);
      var _super72 = _createSuper(Pg);
      function Pg() {
        _classCallCheck(this, Pg);
        return _super72.apply(this, arguments);
      }
      _createClass(Pg, [{
        key: "project",
        value: function project(t, e) {
          e = Ge(e), t = Ge(t);
          var r = Math.cos(e),
            n = 2 / Math.PI,
            i = Math.acos(r * Math.cos(t / 2)),
            s = Math.sin(i) / i,
            a = .5 * (t * n + 2 * r * Math.sin(t / 2) / s) || 0,
            o = .5 * (e + Math.sin(e) / s) || 0;
          return {
            x: .5 * (a / Math.PI + .5),
            y: 1 - .5 * (o / Math.PI + 1),
            z: 0
          };
        }
      }, {
        key: "unproject",
        value: function unproject(t, e) {
          var r = t = (2 * t - .5) * Math.PI,
            n = e = (2 * (1 - e) - 1) * Math.PI,
            i = 25;
          var s = 1e-6;
          var a = 0,
            o = 0;
          do {
            var _i145 = Math.cos(n),
              _s111 = Math.sin(n),
              _l51 = 2 * _s111 * _i145,
              _u44 = _s111 * _s111,
              _c31 = _i145 * _i145,
              _h23 = Math.cos(r / 2),
              _p23 = Math.sin(r / 2),
              _f20 = 2 * _h23 * _p23,
              _d19 = _p23 * _p23,
              _m14 = 1 - _c31 * _h23 * _h23,
              _y11 = _m14 ? 1 / _m14 : 0,
              _g11 = _m14 ? Math.acos(_i145 * _h23) * Math.sqrt(1 / _m14) : 0,
              _x11 = .5 * (2 * _g11 * _i145 * _p23 + 2 * r / Math.PI) - t,
              _b8 = .5 * (_g11 * _s111 + n) - e,
              _v7 = .5 * _y11 * (_c31 * _d19 + _g11 * _i145 * _h23 * _u44) + 1 / Math.PI,
              _8 = _y11 * (_f20 * _l51 / 4 - _g11 * _s111 * _p23),
              _w6 = .125 * _y11 * (_l51 * _p23 - _g11 * _s111 * _c31 * _f20),
              _M7 = .5 * _y11 * (_u44 * _h23 + _g11 * _d19 * _i145) + .5,
              _A7 = _8 * _w6 - _M7 * _v7;
            a = (_b8 * _8 - _x11 * _M7) / _A7, o = (_x11 * _w6 - _b8 * _v7) / _A7, r = We(r - a, -Math.PI, Math.PI), n = We(n - o, -kg, kg);
          } while ((Math.abs(a) > s || Math.abs(o) > s) && --i > 0);
          return new bc(Xe(r), Xe(n));
        }
      }]);
      return Pg;
    }(fg);
    var zg = /*#__PURE__*/function (_fg8) {
      _inherits(zg, _fg8);
      var _super73 = _createSuper(zg);
      function zg(t) {
        var _this36;
        _classCallCheck(this, zg);
        _this36 = _super73.call(this, t), _this36.center = t.center || [0, 0], _this36.parallels = t.parallels || [0, 0], _this36.cosPhi = Math.max(.01, Math.cos(Ge(_this36.parallels[0]))), _this36.scale = 1 / (2 * Math.max(Math.PI * _this36.cosPhi, 1 / _this36.cosPhi)), _this36.wrap = !0, _this36.supportsWorldCopies = !0;
        return _this36;
      }
      _createClass(zg, [{
        key: "project",
        value: function project(t, e) {
          var r = this.scale,
            n = this.cosPhi;
          return {
            x: Ge(t) * n * r + .5,
            y: -Math.sin(Ge(e)) / n * r + .5,
            z: 0
          };
        }
      }, {
        key: "unproject",
        value: function unproject(t, e) {
          var r = this.scale,
            n = this.cosPhi,
            i = -(e - .5) / r,
            s = We(Xe((t - .5) / r) / n, -180, 180),
            a = Math.asin(We(i * n, -1, 1)),
            o = We(Xe(a), -Vc, Vc);
          return new bc(s, o);
        }
      }]);
      return zg;
    }(fg);
    var Eg = /*#__PURE__*/function (_Sg) {
      _inherits(Eg, _Sg);
      var _super74 = _createSuper(Eg);
      function Eg(t) {
        var _this37;
        _classCallCheck(this, Eg);
        _this37 = _super74.call(this, t), _this37.requiresDraping = !0, _this37.supportsWorldCopies = !1, _this37.supportsFog = !0, _this37.zAxisUnit = "pixels", _this37.unsupportedLayers = ["debug"], _this37.range = [3, 5];
        return _this37;
      }
      _createClass(Eg, [{
        key: "projectTilePoint",
        value: function projectTilePoint(e, r, n) {
          var i = Gh(e, r, n),
            s = Zh(Fh(n));
          return t.$.transformMat4(i, i, s), {
            x: i[0],
            y: i[1],
            z: i[2]
          };
        }
      }, {
        key: "locationPoint",
        value: function locationPoint(e, r) {
          var n = yc(r.lat, r.lng),
            i = t.$.normalize([], n),
            s = e.elevation ? e.elevation.getAtPointOrZero(e.locationCoordinate(r), e._centerAltitude) : e._centerAltitude,
            a = Dc(1, 0) * ds * s;
          t.$.scaleAndAdd(n, n, i, a);
          var o = t.ae.identity(new Float64Array(16));
          return t.ae.multiply(o, e.pixelMatrix, e.globeMatrix), t.$.transformMat4(n, n, o), new je(n[0], n[1]);
        }
      }, {
        key: "pixelsPerMeter",
        value: function pixelsPerMeter(t, e) {
          return Dc(1, 0) * e;
        }
      }, {
        key: "pixelSpaceConversion",
        value: function pixelSpaceConversion(t, e, r) {
          var n = Dc(1, t) * e,
            i = Yn(Dc(1, 45) * e, n, r);
          return this.pixelsPerMeter(t, e) / i;
        }
      }, {
        key: "createTileMatrix",
        value: function createTileMatrix(e, r, n) {
          var i = Hh(Fh(n.canonical));
          return t.ae.multiply(new Float64Array(16), e.globeMatrix, i);
        }
      }, {
        key: "createInversionMatrix",
        value: function createInversionMatrix(e, r) {
          var n = e.center,
            i = Zh(Fh(r));
          return t.ae.rotateY(i, i, Ge(n.lng)), t.ae.rotateX(i, i, Ge(n.lat)), t.ae.scale(i, i, [e._pixelsPerMercatorPixel, e._pixelsPerMercatorPixel, 1]), Float32Array.from(i);
        }
      }, {
        key: "pointCoordinate",
        value: function pointCoordinate(t, e, r, n) {
          return Ch(t, e, r, !0) || new Nc(0, 0);
        }
      }, {
        key: "pointCoordinate3D",
        value: function pointCoordinate3D(t, e, r) {
          var n = this.pointCoordinate(t, e, r, 0);
          return [n.x, n.y, n.z];
        }
      }, {
        key: "isPointAboveHorizon",
        value: function isPointAboveHorizon(t, e) {
          return !Ch(t, e.x, e.y, !1);
        }
      }, {
        key: "farthestPixelDistance",
        value: function farthestPixelDistance(e) {
          var r = function (e, r) {
              var n = e.cameraToCenterDistance,
                i = e._centerAltitude * r,
                s = e._camera,
                a = e._camera.forward(),
                o = t.$.add([], t.$.scale([], a, -n), [0, 0, i]),
                l = e.worldSize / (2 * Math.PI),
                u = [0, 0, -l],
                c = e.width / e.height,
                h = Math.tan(e.fovAboveCenter),
                p = t.$.scale([], s.up(), h),
                f = t.$.scale([], s.right(), h * c),
                d = t.$.normalize([], t.$.add([], t.$.add([], a, p), f)),
                m = [];
              var y;
              if (new _h(o, d).closestPointOnSphere(u, l, m)) {
                var _r210 = t.$.add([], m, u),
                  _n139 = t.$.sub([], _r210, o);
                y = Math.cos(e.fovAboveCenter) * t.$.length(_n139);
              } else {
                var _e250 = t.$.sub([], o, u),
                  _r211 = t.$.sub([], u, o);
                t.$.normalize(_r211, _r211);
                var _n140 = t.$.length(_e250) - l;
                y = Math.sqrt(_n140 * (_n140 + 2 * l));
                var _i146 = Math.acos(y / (l + _n140)) - Math.acos(t.$.dot(a, _r211));
                y *= Math.cos(_i146);
              }
              return 1.01 * y;
            }(e, this.pixelsPerMeter(e.center.lat, e.worldSize)),
            n = Qh(e.zoom);
          if (n > 0) {
            var _t244 = ug(e, Dc(1, e.center.lat) * e.worldSize),
              _i147 = e.worldSize / (2 * Math.PI),
              _s112 = Math.max(e.width, e.height) / e.worldSize * Math.PI;
            return Yn(r, _t244 + _i147 * (1 - Math.cos(_s112)), Math.pow(n, 10));
          }
          return r;
        }
      }, {
        key: "upVector",
        value: function upVector(t, e, r) {
          return Gh(e, r, t, 1);
        }
      }, {
        key: "upVectorScale",
        value: function upVectorScale(t) {
          return {
            metersToTile: Dh(Xh(Fh(t)))
          };
        }
      }]);
      return Eg;
    }(Sg);
    function Bg(t) {
      var e = t.parallels,
        r = !!e && Math.abs(e[0] + e[1]) < .01;
      switch (t.name) {
        case "mercator":
          return new Sg(t);
        case "equirectangular":
          return new _g(t);
        case "naturalEarth":
          return new Tg(t);
        case "equalEarth":
          return new vg(t);
        case "winkelTripel":
          return new Pg(t);
        case "albers":
          return r ? new zg(t) : new dg(t);
        case "lambertConformalConic":
          return r ? new zg(t) : new Ag(t);
        case "globe":
          return new Eg(t);
      }
      throw new Error("Invalid projection name: ".concat(t.name));
    }
    var Dg = zf.types,
      Rg = [{
        name: "a_fade_opacity",
        components: 1,
        type: "Uint8",
        offset: 0
      }];
    function Cg(t, e, r, n, i, s, a, o, l, u, c, h, p) {
      var f = o ? Math.min(ng, Math.round(o[0])) : 0,
        d = o ? Math.min(ng, Math.round(o[1])) : 0;
      t.emplaceBack(e, r, Math.round(32 * n), Math.round(32 * i), s, a, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
    }
    function Lg(t, e, r) {
      t.emplaceBack(e, r);
    }
    function Vg(t, e, r, n, i, s, a) {
      t.emplaceBack(e, r, n, i, s, a);
    }
    function Fg(t, e, r, n, i) {
      t.emplaceBack(e, r, n, i), t.emplaceBack(e, r, n, i), t.emplaceBack(e, r, n, i), t.emplaceBack(e, r, n, i);
    }
    function Og(t) {
      var _iterator169 = _createForOfIteratorHelper(t.sections),
        _step169;
      try {
        for (_iterator169.s(); !(_step169 = _iterator169.n()).done;) {
          var _e251 = _step169.value;
          if (Fo(_e251.text)) return !0;
        }
      } catch (err) {
        _iterator169.e(err);
      } finally {
        _iterator169.f();
      }
      return !1;
    }
    var Ug = /*#__PURE__*/function () {
      function Ug(t) {
        _classCallCheck(this, Ug);
        this.layoutVertexArray = new Xl(), this.indexArray = new tu(), this.programConfigurations = t, this.segments = new ku(), this.dynamicLayoutVertexArray = new jl(), this.opacityVertexArray = new Zl(), this.placedSymbolArray = new yu(), this.iconTransitioningVertexArray = new Hl(), this.globeExtVertexArray = new Yl(), this.zOffsetVertexArray = new nu();
      }
      _createClass(Ug, [{
        key: "isEmpty",
        value: function isEmpty() {
          return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
        }
      }, {
        key: "upload",
        value: function upload(t, e, r, n, i) {
          this.isEmpty() || (r && (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Zd.members), this.indexBuffer = t.createIndexBuffer(this.indexArray, e), this.dynamicLayoutVertexBuffer = t.createVertexBuffer(this.dynamicLayoutVertexArray, Kd.members, !0), this.opacityVertexBuffer = t.createVertexBuffer(this.opacityVertexArray, Rg, !0), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = t.createVertexBuffer(this.iconTransitioningVertexArray, Jd.members, !0)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = t.createVertexBuffer(this.globeExtVertexArray, Hd.members, !0)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || i) && (this.zOffsetVertexBuffer = t.createVertexBuffer(this.zOffsetVertexArray, Wd.members, !0)), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy());
        }
      }]);
      return Ug;
    }();
    So(Ug, "SymbolBuffers");
    var jg = /*#__PURE__*/function () {
      function jg(t, e, r) {
        _classCallCheck(this, jg);
        this.layoutVertexArray = new t(), this.layoutAttributes = e, this.indexArray = new r(), this.segments = new ku(), this.collisionVertexArray = new Ql(), this.collisionVertexArrayExt = new jl();
      }
      _createClass(jg, [{
        key: "upload",
        value: function upload(t) {
          this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t.createVertexBuffer(this.collisionVertexArray, Qd.members, !0), this.collisionVertexBufferExt = t.createVertexBuffer(this.collisionVertexArrayExt, tm.members, !0);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
        }
      }]);
      return jg;
    }();
    So(jg, "CollisionBuffers");
    var Ng = /*#__PURE__*/function () {
      function Ng(e) {
        _classCallCheck(this, Ng);
        this.collisionBoxArray = e.collisionBoxArray, this.zoom = e.zoom, this.lut = e.lut, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map(function (t) {
          return t.fqid;
        }), this.index = e.index, this.pixelRatio = e.pixelRatio, this.sourceLayerIndex = e.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.hasAnyIconTextFit = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = t.ae.identity([]), this.placementViewportMatrix = t.ae.identity([]);
        var r = this.layers[0]._unevaluatedLayout._values;
        this.textSizeData = Zm(this.zoom, r["text-size"]), this.iconSizeData = Zm(this.zoom, r["icon-size"]);
        var n = this.layers[0].layout,
          i = n.get("symbol-sort-key"),
          s = n.get("symbol-z-order");
        this.canOverlap = n.get("text-allow-overlap") || n.get("icon-allow-overlap") || n.get("text-ignore-placement") || n.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== s && void 0 !== i.constantOr(1), this.sortFeaturesByY = ("viewport-y" === s || "auto" === s && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = n.get("text-writing-mode").map(function (t) {
          return oy[t];
        }), this.stateDependentLayerIds = this.layers.filter(function (t) {
          return t.isStateDependent();
        }).map(function (t) {
          return t.id;
        }), this.sourceID = e.sourceID, this.projection = e.projection, this.hasAnyZOffset = !1, this.zOffsetSortDirty = !1, this.zOffsetBuffersNeedUpload = n.get("symbol-z-elevate"), this.activeReplacements = [], this.replacementUpdateTime = 0;
      }
      _createClass(Ng, [{
        key: "createArrays",
        value: function createArrays() {
          this.text = new Ug(new ec(this.layers, {
            zoom: this.zoom,
            lut: this.lut
          }, function (t) {
            return /^text/.test(t);
          })), this.icon = new Ug(new ec(this.layers, {
            zoom: this.zoom,
            lut: this.lut
          }, function (t) {
            return /^icon/.test(t);
          })), this.glyphOffsetArray = new bu(), this.lineVertexArray = new vu(), this.symbolInstances = new xu();
        }
      }, {
        key: "calculateGlyphDependencies",
        value: function calculateGlyphDependencies(t, e, r, n, i) {
          for (var _r212 = 0; _r212 < t.length; _r212++) {
            var _s113 = t.codePointAt(_r212);
            if (void 0 === _s113) break;
            if (e[_s113] = !0, n && i && _s113 <= 65535) {
              var _n141 = Qm[t.charAt(_r212)];
              _n141 && (e[_n141.charCodeAt(0)] = !0);
            }
          }
        }
      }, {
        key: "updateFootprints",
        value: function updateFootprints(t, e) {}
      }, {
        key: "updateReplacement",
        value: function updateReplacement(t, e) {
          if (e.updateTime === this.replacementUpdateTime) return !1;
          this.replacementUpdateTime = e.updateTime;
          var r = e.getReplacementRegionsForTile(t.toUnwrapped(), !0);
          return !jf(this.activeReplacements, r) && (this.activeReplacements = r, !0);
        }
      }, {
        key: "populate",
        value: function populate(e, r, n, i) {
          var _this38 = this;
          var s = this.layers[0],
            a = s.layout,
            o = "globe" === this.projection.name,
            l = a.get("text-font"),
            u = a.get("text-field"),
            c = a.get("icon-image"),
            h = ("constant" !== u.value.kind || u.value.value instanceof gi && !u.value.value.isEmpty() || u.value.value.toString().length > 0) && ("constant" !== l.value.kind || l.value.value.length > 0),
            p = "constant" !== c.value.kind || !!c.value.value || Object.keys(c.parameters).length > 0,
            f = a.get("symbol-sort-key");
          if (this.features = [], !h && !p) return;
          var d = r.iconDependencies,
            m = r.glyphDependencies,
            y = r.availableImages,
            g = new Wo(this.zoom);
          var _iterator170 = _createForOfIteratorHelper(e),
            _step170;
          try {
            var _loop8 = function _loop8() {
                var _step170$value = _step170.value,
                  r = _step170$value.feature,
                  u = _step170$value.id,
                  c = _step170$value.index,
                  x = _step170$value.sourceLayerIndex;
                var e = s._featureFilter.needGeometry,
                  b = Wc(r, e);
                if (!s._featureFilter.filter(g, b, n)) return 0; // continue
                if (e || (b.geometry = Kc(r, n, i)), o && 1 !== r.type && n.z <= 5) {
                  var _e252 = b.geometry,
                    _r213 = .98078528056,
                    _i149 = function _i149(e, i) {
                      var s = Gh(e.x, e.y, n, 1),
                        a = Gh(i.x, i.y, n, 1);
                      return t.$.dot(s, a) < _r213;
                    };
                  for (var _t246 = 0; _t246 < _e252.length; _t246++) _e252[_t246] = Xc(_e252[_t246], _i149);
                }
                var v, _;
                if (h) {
                  var _t247 = s.getValueAndResolveTokens("text-field", b, n, y),
                    _e253 = gi.factory(_t247);
                  Og(_e253) && (_this38.hasRTLText = !0), (!_this38.hasRTLText || "unavailable" === Zo() || _this38.hasRTLText && Ko.isParsed()) && (v = Jm(_e253, s, b));
                }
                if (p) {
                  var _t248 = s.getValueAndResolveTokens("icon-image", b, n, y);
                  _ = _t248 instanceof xi ? _t248 : xi.fromString(_t248);
                }
                if (!v && !_) return 0; // continue
                var w = _this38.sortFeaturesByKey ? f.evaluate(b, {}, n) : void 0;
                if (_this38.features.push({
                  id: u,
                  text: v,
                  icon: _,
                  index: c,
                  sourceLayerIndex: x,
                  geometry: b.geometry,
                  properties: r.properties,
                  type: Dg[r.type],
                  sortKey: w
                }), _ && (d[_.namePrimary] = !0, _.nameSecondary && (d[_.nameSecondary] = !0)), v) {
                  var _t249 = l.evaluate(b, {}, n).join(","),
                    _e254 = "map" === a.get("text-rotation-alignment") && "point" !== a.get("symbol-placement");
                  _this38.allowVerticalPlacement = _this38.writingModes && _this38.writingModes.indexOf(oy.vertical) >= 0;
                  var _iterator171 = _createForOfIteratorHelper(v.sections),
                    _step171;
                  try {
                    for (_iterator171.s(); !(_step171 = _iterator171.n()).done;) {
                      var _r214 = _step171.value;
                      if (_r214.image) d[_r214.image.namePrimary] = !0;else {
                        var _n142 = Eo(v.toString()),
                          _i150 = _r214.fontStack || _t249,
                          _s114 = m[_i150] = m[_i150] || {};
                        _this38.calculateGlyphDependencies(_r214.text, _s114, _e254, _this38.allowVerticalPlacement, _n142);
                      }
                    }
                  } catch (err) {
                    _iterator171.e(err);
                  } finally {
                    _iterator171.f();
                  }
                }
              },
              _ret3;
            for (_iterator170.s(); !(_step170 = _iterator170.n()).done;) {
              _ret3 = _loop8();
              if (_ret3 === 0) continue;
            }
          } catch (err) {
            _iterator170.e(err);
          } finally {
            _iterator170.f();
          }
          "line" === a.get("symbol-placement") && (this.features = function (t) {
            var e = {},
              r = {},
              n = [];
            var i = 0;
            function s(e) {
              n.push(t[e]), i++;
            }
            function a(t, e, i) {
              var s = r[t];
              return delete r[t], r[e] = s, n[s].geometry[0].pop(), n[s].geometry[0] = n[s].geometry[0].concat(i[0]), s;
            }
            function o(t, r, i) {
              var s = e[r];
              return delete e[r], e[t] = s, n[s].geometry[0].shift(), n[s].geometry[0] = i[0].concat(n[s].geometry[0]), s;
            }
            function l(t, e, r) {
              var n = r ? e[0][e[0].length - 1] : e[0][0];
              return "".concat(t, ":").concat(n.x, ":").concat(n.y);
            }
            for (var _u45 = 0; _u45 < t.length; _u45++) {
              var _c32 = t[_u45],
                _h24 = _c32.geometry,
                _p24 = _c32.text ? _c32.text.toString() : null;
              if (!_p24) {
                s(_u45);
                continue;
              }
              var _f21 = l(_p24, _h24),
                _d20 = l(_p24, _h24, !0);
              if (_f21 in r && _d20 in e && r[_f21] !== e[_d20]) {
                var _t245 = o(_f21, _d20, _h24),
                  _i148 = a(_f21, _d20, n[_t245].geometry);
                delete e[_f21], delete r[_d20], r[l(_p24, n[_i148].geometry, !0)] = _i148, n[_t245].geometry = null;
              } else _f21 in r ? a(_f21, _d20, _h24) : _d20 in e ? o(_f21, _d20, _h24) : (s(_u45), e[_f21] = i - 1, r[_d20] = i - 1);
            }
            return n.filter(function (t) {
              return t.geometry;
            });
          }(this.features)), this.sortFeaturesByKey && this.features.sort(function (t, e) {
            return t.sortKey - e.sortKey;
          });
        }
      }, {
        key: "update",
        value: function update(t, e, r, n, i) {
          var s = 0 !== Object.keys(t).length;
          if (s && !this.stateDependentLayers.length) return;
          var a = s ? this.stateDependentLayers : this.layers;
          this.text.programConfigurations.updatePaintArrays(t, e, a, r, n, i), this.icon.programConfigurations.updatePaintArrays(t, e, a, r, n, i);
        }
      }, {
        key: "updateZOffset",
        value: function updateZOffset() {
          var t = function t(_t250, e, n) {
              r += e, r > _t250.length && _t250.resize(r);
              for (var _i151 = -e; _i151 < 0; _i151++) _t250.emplace(_i151 + r, n);
            },
            e = function e(t, _e255, r) {
              n += _e255, n > t.length && t.resize(n);
              for (var _i152 = -_e255; _i152 < 0; _i152++) t.emplace(_i152 + n, r);
            };
          if (!this.zOffsetBuffersNeedUpload) return;
          this.zOffsetBuffersNeedUpload = !1;
          var r = 0,
            n = 0;
          for (var _r215 = 0; _r215 < this.symbolInstances.length; _r215++) {
            var _n143 = this.symbolInstances.get(_r215),
              _i153 = _n143.numHorizontalGlyphVertices,
              _s115 = _n143.numVerticalGlyphVertices,
              _a90 = _n143.numIconVertices,
              _o67 = _n143.zOffset,
              _l52 = _a90 > 0;
            if ((_i153 > 0 || _s115 > 0) && (t(this.text.zOffsetVertexArray, _i153, _o67), t(this.text.zOffsetVertexArray, _s115, _o67)), _l52) {
              var _t251 = _n143.placedIconSymbolIndex,
                _r216 = _n143.verticalPlacedIconSymbolIndex;
              _t251 >= 0 && e(this.icon.zOffsetVertexArray, _a90, _o67), _r216 >= 0 && e(this.icon.zOffsetVertexArray, _n143.numVerticalIconVertices, _o67);
            }
          }
          this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
        }
      }, {
        key: "isEmpty",
        value: function isEmpty() {
          return 0 === this.symbolInstances.length && !this.hasRTLText;
        }
      }, {
        key: "uploadPending",
        value: function uploadPending() {
          return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
        }
      }, {
        key: "upload",
        value: function upload(t) {
          !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t), this.iconCollisionBox.upload(t)), this.text.upload(t, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.icon.upload(t, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.uploaded = !0;
        }
      }, {
        key: "destroyDebugData",
        value: function destroyDebugData() {
          this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
        }
      }, {
        key: "getProjection",
        value: function getProjection() {
          return this.projectionInstance || (this.projectionInstance = Bg(this.projection)), this.projectionInstance;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
        }
      }, {
        key: "addToLineVertexArray",
        value: function addToLineVertexArray(t, e) {
          var r = this.lineVertexArray.length;
          if (void 0 !== t.segment) {
            var _iterator172 = _createForOfIteratorHelper(e),
              _step172;
            try {
              for (_iterator172.s(); !(_step172 = _iterator172.n()).done;) {
                var _step172$value = _step172.value,
                  _t252 = _step172$value.x,
                  _r217 = _step172$value.y;
                this.lineVertexArray.emplaceBack(_t252, _r217);
              }
            } catch (err) {
              _iterator172.e(err);
            } finally {
              _iterator172.f();
            }
          }
          return {
            lineStartIndex: r,
            lineLength: this.lineVertexArray.length - r
          };
        }
      }, {
        key: "addSymbols",
        value: function addSymbols(t, e, r, n, i, s, a, o, l, u, c, h, p, f, d, m) {
          var y = t.indexArray,
            g = t.layoutVertexArray,
            x = t.globeExtVertexArray,
            b = t.segments.prepareSegment(4 * e.length, g, y, this.canOverlap ? s.sortKey : void 0),
            v = this.glyphOffsetArray.length,
            _ = b.vertexLength,
            w = this.allowVerticalPlacement && a === oy.vertical ? Math.PI / 2 : 0,
            M = s.text && s.text.sections;
          for (var _n144 = 0; _n144 < e.length; _n144++) {
            var _e$_n = e[_n144],
              _i154 = _e$_n.tl,
              _a91 = _e$_n.tr,
              _u46 = _e$_n.bl,
              _c33 = _e$_n.br,
              _h25 = _e$_n.texPrimary,
              _v8 = _e$_n.texSecondary,
              _9 = _e$_n.pixelOffsetTL,
              _A8 = _e$_n.pixelOffsetBR,
              _S6 = _e$_n.minFontScaleX,
              _I5 = _e$_n.minFontScaleY,
              _T5 = _e$_n.glyphOffset,
              _k5 = _e$_n.isSDF,
              _P4 = _e$_n.sectionIndex,
              _z3 = b.vertexLength,
              _E2 = _T5[1];
            if (Cg(g, l.x, l.y, _i154.x, _E2 + _i154.y, _h25.x, _h25.y, r, _k5, _9.x, _9.y, _S6, _I5), Cg(g, l.x, l.y, _a91.x, _E2 + _a91.y, _h25.x + _h25.w, _h25.y, r, _k5, _A8.x, _9.y, _S6, _I5), Cg(g, l.x, l.y, _u46.x, _E2 + _u46.y, _h25.x, _h25.y + _h25.h, r, _k5, _9.x, _A8.y, _S6, _I5), Cg(g, l.x, l.y, _c33.x, _E2 + _c33.y, _h25.x + _h25.w, _h25.y + _h25.h, r, _k5, _A8.x, _A8.y, _S6, _I5), o) {
              var _o$anchor = o.anchor,
                _e256 = _o$anchor.x,
                _r218 = _o$anchor.y,
                _n145 = _o$anchor.z,
                _o$up = _slicedToArray(o.up, 3),
                _i155 = _o$up[0],
                _s116 = _o$up[1],
                _a92 = _o$up[2];
              Vg(x, _e256, _r218, _n145, _i155, _s116, _a92), Vg(x, _e256, _r218, _n145, _i155, _s116, _a92), Vg(x, _e256, _r218, _n145, _i155, _s116, _a92), Vg(x, _e256, _r218, _n145, _i155, _s116, _a92), Fg(t.dynamicLayoutVertexArray, _e256, _r218, _n145, w);
            } else Fg(t.dynamicLayoutVertexArray, l.x, l.y, l.z, w);
            if (m) {
              var _e257 = _v8 || _h25;
              Lg(t.iconTransitioningVertexArray, _e257.x, _e257.y), Lg(t.iconTransitioningVertexArray, _e257.x + _e257.w, _e257.y), Lg(t.iconTransitioningVertexArray, _e257.x, _e257.y + _e257.h), Lg(t.iconTransitioningVertexArray, _e257.x + _e257.w, _e257.y + _e257.h);
            }
            y.emplaceBack(_z3, _z3 + 1, _z3 + 2), y.emplaceBack(_z3 + 1, _z3 + 2, _z3 + 3), b.vertexLength += 4, b.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(_T5[0]), _n144 !== e.length - 1 && _P4 === e[_n144 + 1].sectionIndex || t.programConfigurations.populatePaintArrays(g.length, s, s.index, {}, p, f, d, M && M[_P4]);
          }
          var A = o ? o.anchor : l;
          t.placedSymbolArray.emplaceBack(A.x, A.y, A.z, l.x, l.y, v, this.glyphOffsetArray.length - v, _, u, c, l.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], a, 0, !1, 0, h, 0);
        }
      }, {
        key: "_commitLayoutVertex",
        value: function _commitLayoutVertex(t, e, r, n, i, s, a) {
          t.emplaceBack(e, r, n, i, s, Math.round(a.x), Math.round(a.y));
        }
      }, {
        key: "_addCollisionDebugVertices",
        value: function _addCollisionDebugVertices(t, e, r, n, i, s, a) {
          var o = r.segments.prepareSegment(4, r.layoutVertexArray, r.indexArray),
            l = o.vertexLength,
            u = a.tileAnchorX,
            c = a.tileAnchorY;
          for (var _t253 = 0; _t253 < 4; _t253++) r.collisionVertexArray.emplaceBack(0, 0, 0, 0);
          this._commitDebugCollisionVertexUpdate(r.collisionVertexArrayExt, e, t.padding, a.zOffset), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new je(t.x1, t.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new je(t.x2, t.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new je(t.x2, t.y2)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new je(t.x1, t.y2)), o.vertexLength += 4;
          var h = r.indexArray;
          h.emplaceBack(l, l + 1), h.emplaceBack(l + 1, l + 2), h.emplaceBack(l + 2, l + 3), h.emplaceBack(l + 3, l), o.primitiveLength += 4;
        }
      }, {
        key: "_addTextDebugCollisionBoxes",
        value: function _addTextDebugCollisionBoxes(t, e, r, n, i, s) {
          for (var _a93 = n; _a93 < i; _a93++) {
            var _n146 = r.get(_a93),
              _i156 = this.getSymbolInstanceTextSize(t, s, e, _a93);
            this._addCollisionDebugVertices(_n146, _i156, this.textCollisionBox, _n146.projectedAnchorX, _n146.projectedAnchorY, _n146.projectedAnchorZ, s);
          }
        }
      }, {
        key: "_addIconDebugCollisionBoxes",
        value: function _addIconDebugCollisionBoxes(t, e, r, n, i, s) {
          for (var _a94 = n; _a94 < i; _a94++) {
            var _n147 = r.get(_a94),
              _i157 = this.getSymbolInstanceIconSize(t, e, s.placedIconSymbolIndex);
            this._addCollisionDebugVertices(_n147, _i157, this.iconCollisionBox, _n147.projectedAnchorX, _n147.projectedAnchorY, _n147.projectedAnchorZ, s);
          }
        }
      }, {
        key: "generateCollisionDebugBuffers",
        value: function generateCollisionDebugBuffers(t, e) {
          this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new jg(Wl, em.members, Hl), this.iconCollisionBox = new jg(Wl, em.members, Hl);
          var r = Km(this.iconSizeData, t),
            n = Km(this.textSizeData, t);
          for (var _i158 = 0; _i158 < this.symbolInstances.length; _i158++) {
            var _s117 = this.symbolInstances.get(_i158);
            this._addTextDebugCollisionBoxes(n, t, e, _s117.textBoxStartIndex, _s117.textBoxEndIndex, _s117), this._addTextDebugCollisionBoxes(n, t, e, _s117.verticalTextBoxStartIndex, _s117.verticalTextBoxEndIndex, _s117), this._addIconDebugCollisionBoxes(r, t, e, _s117.iconBoxStartIndex, _s117.iconBoxEndIndex, _s117), this._addIconDebugCollisionBoxes(r, t, e, _s117.verticalIconBoxStartIndex, _s117.verticalIconBoxEndIndex, _s117);
          }
        }
      }, {
        key: "getSymbolInstanceTextSize",
        value: function getSymbolInstanceTextSize(t, e, r, n) {
          var i = this.text.placedSymbolArray.get(e.rightJustifiedTextSymbolIndex >= 0 ? e.rightJustifiedTextSymbolIndex : e.centerJustifiedTextSymbolIndex >= 0 ? e.centerJustifiedTextSymbolIndex : e.leftJustifiedTextSymbolIndex >= 0 ? e.leftJustifiedTextSymbolIndex : e.verticalPlacedTextSymbolIndex >= 0 ? e.verticalPlacedTextSymbolIndex : n),
            s = Hm(this.textSizeData, t, i) / Xm;
          return this.tilePixelRatio * s;
        }
      }, {
        key: "getSymbolInstanceIconSize",
        value: function getSymbolInstanceIconSize(t, e, r) {
          var n = this.icon.placedSymbolArray.get(r),
            i = Hm(this.iconSizeData, t, n);
          return this.tilePixelRatio * i;
        }
      }, {
        key: "_commitDebugCollisionVertexUpdate",
        value: function _commitDebugCollisionVertexUpdate(t, e, r, n) {
          t.emplaceBack(e, -r, -r, n), t.emplaceBack(e, r, -r, n), t.emplaceBack(e, r, r, n), t.emplaceBack(e, -r, r, n);
        }
      }, {
        key: "_updateTextDebugCollisionBoxes",
        value: function _updateTextDebugCollisionBoxes(t, e, r, n, i, s) {
          for (var _a95 = n; _a95 < i; _a95++) {
            var _n148 = r.get(_a95),
              _i159 = this.getSymbolInstanceTextSize(t, s, e, _a95);
            this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, _i159, _n148.padding, s.zOffset);
          }
        }
      }, {
        key: "_updateIconDebugCollisionBoxes",
        value: function _updateIconDebugCollisionBoxes(t, e, r, n, i, s) {
          for (var _a96 = n; _a96 < i; _a96++) {
            var _n149 = r.get(_a96),
              _i160 = this.getSymbolInstanceIconSize(t, e, s.placedIconSymbolIndex);
            this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, _i160, _n149.padding, s.zOffset);
          }
        }
      }, {
        key: "updateCollisionDebugBuffers",
        value: function updateCollisionDebugBuffers(t, e) {
          if (!this.hasDebugData()) return;
          this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
          var r = Km(this.iconSizeData, t),
            n = Km(this.textSizeData, t);
          for (var _i161 = 0; _i161 < this.symbolInstances.length; _i161++) {
            var _s118 = this.symbolInstances.get(_i161);
            this._updateTextDebugCollisionBoxes(n, t, e, _s118.textBoxStartIndex, _s118.textBoxEndIndex, _s118), this._updateTextDebugCollisionBoxes(n, t, e, _s118.verticalTextBoxStartIndex, _s118.verticalTextBoxEndIndex, _s118), this._updateIconDebugCollisionBoxes(r, t, e, _s118.iconBoxStartIndex, _s118.iconBoxEndIndex, _s118), this._updateIconDebugCollisionBoxes(r, t, e, _s118.verticalIconBoxStartIndex, _s118.verticalIconBoxEndIndex, _s118);
          }
          this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
        }
      }, {
        key: "_deserializeCollisionBoxesForSymbol",
        value: function _deserializeCollisionBoxesForSymbol(t, e, r, n, i, s, a, o, l) {
          var u = {};
          if (e < r) {
            var _t$get = t.get(e),
              _r219 = _t$get.x1,
              _n150 = _t$get.y1,
              _i162 = _t$get.x2,
              _s119 = _t$get.y2,
              _a97 = _t$get.padding,
              _o68 = _t$get.projectedAnchorX,
              _l53 = _t$get.projectedAnchorY,
              _c34 = _t$get.projectedAnchorZ,
              _h26 = _t$get.tileAnchorX,
              _p25 = _t$get.tileAnchorY,
              _f22 = _t$get.featureIndex;
            u.textBox = {
              x1: _r219,
              y1: _n150,
              x2: _i162,
              y2: _s119,
              padding: _a97,
              projectedAnchorX: _o68,
              projectedAnchorY: _l53,
              projectedAnchorZ: _c34,
              tileAnchorX: _h26,
              tileAnchorY: _p25
            }, u.textFeatureIndex = _f22;
          }
          if (n < i) {
            var _t$get2 = t.get(n),
              _e258 = _t$get2.x1,
              _r220 = _t$get2.y1,
              _i163 = _t$get2.x2,
              _s120 = _t$get2.y2,
              _a98 = _t$get2.padding,
              _o69 = _t$get2.projectedAnchorX,
              _l54 = _t$get2.projectedAnchorY,
              _c35 = _t$get2.projectedAnchorZ,
              _h27 = _t$get2.tileAnchorX,
              _p26 = _t$get2.tileAnchorY,
              _f23 = _t$get2.featureIndex;
            u.verticalTextBox = {
              x1: _e258,
              y1: _r220,
              x2: _i163,
              y2: _s120,
              padding: _a98,
              projectedAnchorX: _o69,
              projectedAnchorY: _l54,
              projectedAnchorZ: _c35,
              tileAnchorX: _h27,
              tileAnchorY: _p26
            }, u.verticalTextFeatureIndex = _f23;
          }
          if (s < a) {
            var _t$get3 = t.get(s),
              _e259 = _t$get3.x1,
              _r221 = _t$get3.y1,
              _n151 = _t$get3.x2,
              _i164 = _t$get3.y2,
              _a99 = _t$get3.padding,
              _o70 = _t$get3.projectedAnchorX,
              _l55 = _t$get3.projectedAnchorY,
              _c36 = _t$get3.projectedAnchorZ,
              _h28 = _t$get3.tileAnchorX,
              _p27 = _t$get3.tileAnchorY,
              _f24 = _t$get3.featureIndex;
            u.iconBox = {
              x1: _e259,
              y1: _r221,
              x2: _n151,
              y2: _i164,
              padding: _a99,
              projectedAnchorX: _o70,
              projectedAnchorY: _l55,
              projectedAnchorZ: _c36,
              tileAnchorX: _h28,
              tileAnchorY: _p27
            }, u.iconFeatureIndex = _f24;
          }
          if (o < l) {
            var _t$get4 = t.get(o),
              _e260 = _t$get4.x1,
              _r222 = _t$get4.y1,
              _n152 = _t$get4.x2,
              _i165 = _t$get4.y2,
              _s121 = _t$get4.padding,
              _a100 = _t$get4.projectedAnchorX,
              _l56 = _t$get4.projectedAnchorY,
              _c37 = _t$get4.projectedAnchorZ,
              _h29 = _t$get4.tileAnchorX,
              _p28 = _t$get4.tileAnchorY,
              _f25 = _t$get4.featureIndex;
            u.verticalIconBox = {
              x1: _e260,
              y1: _r222,
              x2: _n152,
              y2: _i165,
              padding: _s121,
              projectedAnchorX: _a100,
              projectedAnchorY: _l56,
              projectedAnchorZ: _c37,
              tileAnchorX: _h29,
              tileAnchorY: _p28
            }, u.verticalIconFeatureIndex = _f25;
          }
          return u;
        }
      }, {
        key: "deserializeCollisionBoxes",
        value: function deserializeCollisionBoxes(t) {
          this.collisionArrays = [];
          for (var _e261 = 0; _e261 < this.symbolInstances.length; _e261++) {
            var _r223 = this.symbolInstances.get(_e261);
            this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t, _r223.textBoxStartIndex, _r223.textBoxEndIndex, _r223.verticalTextBoxStartIndex, _r223.verticalTextBoxEndIndex, _r223.iconBoxStartIndex, _r223.iconBoxEndIndex, _r223.verticalIconBoxStartIndex, _r223.verticalIconBoxEndIndex));
          }
        }
      }, {
        key: "hasTextData",
        value: function hasTextData() {
          return this.text.segments.get().length > 0;
        }
      }, {
        key: "hasIconData",
        value: function hasIconData() {
          return this.icon.segments.get().length > 0;
        }
      }, {
        key: "hasDebugData",
        value: function hasDebugData() {
          return this.textCollisionBox && this.iconCollisionBox;
        }
      }, {
        key: "hasTextCollisionBoxData",
        value: function hasTextCollisionBoxData() {
          return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
        }
      }, {
        key: "hasIconCollisionBoxData",
        value: function hasIconCollisionBoxData() {
          return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
        }
      }, {
        key: "hasIconTextFit",
        value: function hasIconTextFit() {
          return this.hasAnyIconTextFit;
        }
      }, {
        key: "addIndicesForPlacedSymbol",
        value: function addIndicesForPlacedSymbol(t, e) {
          var r = t.placedSymbolArray.get(e),
            n = r.vertexStartIndex + 4 * r.numGlyphs;
          for (var _e262 = r.vertexStartIndex; _e262 < n; _e262 += 4) t.indexArray.emplaceBack(_e262, _e262 + 1, _e262 + 2), t.indexArray.emplaceBack(_e262 + 1, _e262 + 2, _e262 + 3);
        }
      }, {
        key: "getSortedSymbolIndexes",
        value: function getSortedSymbolIndexes(t) {
          if (this.sortedAngle === t && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
          var e = Math.sin(t),
            r = Math.cos(t),
            n = [],
            i = [],
            s = [];
          for (var _t254 = 0; _t254 < this.symbolInstances.length; ++_t254) {
            s.push(_t254);
            var _a101 = this.symbolInstances.get(_t254);
            n.push(0 | Math.round(e * _a101.tileAnchorX + r * _a101.tileAnchorY)), i.push(_a101.featureIndex);
          }
          return s.sort(function (t, e) {
            return n[t] - n[e] || i[e] - i[t];
          }), s;
        }
      }, {
        key: "getSortedIndexesByZOffset",
        value: function getSortedIndexesByZOffset() {
          var _this39 = this;
          if (!this.zOffsetSortDirty) return this.symbolInstanceIndexesSortedZOffset;
          if (!this.symbolInstanceIndexesSortedZOffset) {
            this.symbolInstanceIndexesSortedZOffset = [];
            for (var _t255 = 0; _t255 < this.symbolInstances.length; ++_t255) this.symbolInstanceIndexesSortedZOffset.push(_t255);
          }
          return this.zOffsetSortDirty = !1, this.symbolInstanceIndexesSortedZOffset.sort(function (t, e) {
            return _this39.symbolInstances.get(e).zOffset - _this39.symbolInstances.get(t).zOffset;
          });
        }
      }, {
        key: "addToSortKeyRanges",
        value: function addToSortKeyRanges(t, e) {
          var r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
          r && r.sortKey === e ? r.symbolInstanceEnd = t + 1 : this.sortKeyRanges.push({
            sortKey: e,
            symbolInstanceStart: t,
            symbolInstanceEnd: t + 1
          });
        }
      }, {
        key: "sortFeatures",
        value: function sortFeatures(t) {
          if (this.sortFeaturesByY && this.sortedAngle !== t && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
            this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t), this.sortedAngle = t, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
            var _iterator173 = _createForOfIteratorHelper(this.symbolInstanceIndexes),
              _step173;
            try {
              for (_iterator173.s(); !(_step173 = _iterator173.n()).done;) {
                var _t256 = _step173.value;
                var _e263 = this.symbolInstances.get(_t256);
                this.featureSortOrder.push(_e263.featureIndex);
                var _r224 = _e263.rightJustifiedTextSymbolIndex,
                  _n153 = _e263.centerJustifiedTextSymbolIndex,
                  _i166 = _e263.leftJustifiedTextSymbolIndex,
                  _s122 = _e263.verticalPlacedTextSymbolIndex,
                  _a102 = _e263.placedIconSymbolIndex,
                  _o71 = _e263.verticalPlacedIconSymbolIndex;
                _r224 >= 0 && this.addIndicesForPlacedSymbol(this.text, _r224), _n153 >= 0 && _n153 !== _r224 && this.addIndicesForPlacedSymbol(this.text, _n153), _i166 >= 0 && _i166 !== _n153 && _i166 !== _r224 && this.addIndicesForPlacedSymbol(this.text, _i166), _s122 >= 0 && this.addIndicesForPlacedSymbol(this.text, _s122), _a102 >= 0 && this.addIndicesForPlacedSymbol(this.icon, _a102), _o71 >= 0 && this.addIndicesForPlacedSymbol(this.icon, _o71);
              }
            } catch (err) {
              _iterator173.e(err);
            } finally {
              _iterator173.f();
            }
            this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
          }
        }
      }]);
      return Ng;
    }();
    So(Ng, "SymbolBucket", {
      omit: ["layers", "collisionBoxArray", "features", "compareText"]
    }), Ng.addDynamicAttributes = Fg;
    var $g = /*#__PURE__*/function () {
      function $g(t, e, r, n) {
        _classCallCheck(this, $g);
        this.context = t, this.format = r, this.texture = t.gl.createTexture(), this.update(e, n);
      }
      _createClass($g, [{
        key: "update",
        value: function update(t, e, r) {
          var n = t.width,
            i = t.height,
            s = this.context,
            a = s.gl;
          if (a.bindTexture(a.TEXTURE_2D, this.texture), s.pixelStoreUnpackFlipY.set(!1), s.pixelStoreUnpack.set(1), s.pixelStoreUnpackPremultiplyAlpha.set(this.format === a.RGBA && (!e || !1 !== e.premultiply)), this.useMipmap = Boolean(e && e.useMipmap), r || this.size && this.size[0] === n && this.size[1] === i) {
            var _ref131 = r || {
                x: 0,
                y: 0
              },
              _e264 = _ref131.x,
              _s123 = _ref131.y;
            if (t instanceof HTMLImageElement || t instanceof HTMLCanvasElement || t instanceof HTMLVideoElement || t instanceof ImageData || ImageBitmap && t instanceof ImageBitmap) a.texSubImage2D(a.TEXTURE_2D, 0, _e264, _s123, a.RGBA, a.UNSIGNED_BYTE, t);else {
              var _r225 = this.format,
                _o72 = a.UNSIGNED_BYTE;
              this.format === a.R32F && (_r225 = a.RED, _o72 = a.FLOAT), a.texSubImage2D(a.TEXTURE_2D, 0, _e264, _s123, n, i, _r225, _o72, t.data);
            }
          } else if (this.size = [n, i], t instanceof HTMLImageElement || t instanceof HTMLCanvasElement || t instanceof HTMLVideoElement || t instanceof ImageData || ImageBitmap && t instanceof ImageBitmap) {
            var _e265 = this.format;
            this.format === a.R8 && (_e265 = a.RED), a.texImage2D(a.TEXTURE_2D, 0, this.format, _e265, a.UNSIGNED_BYTE, t);
          } else {
            var _e266 = this.format,
              _r226 = this.format,
              _s124 = a.UNSIGNED_BYTE,
              _o73 = !1;
            this.format === a.DEPTH_COMPONENT && (_e266 = a.DEPTH_COMPONENT16, _s124 = a.UNSIGNED_SHORT), this.format === a.DEPTH_STENCIL && (_e266 = a.DEPTH24_STENCIL8, _s124 = a.UNSIGNED_INT_24_8, _o73 = !0), this.format === a.R8 && (_r226 = a.RED), this.format === a.R32F && (_s124 = a.FLOAT, _r226 = a.RED), !this.useMipmap && _o73 ? a.texStorage2D(a.TEXTURE_2D, 1, _e266, n, i) : a.texImage2D(a.TEXTURE_2D, 0, _e266, n, i, 0, _r226, _s124, t.data);
          }
          this.useMipmap && a.generateMipmap(a.TEXTURE_2D);
        }
      }, {
        key: "bind",
        value: function bind(t, e) {
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          var n = this.context,
            i = n.gl;
          i.bindTexture(i.TEXTURE_2D, this.texture), t !== this.minFilter && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, t), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, this.useMipmap && !r ? t === i.NEAREST ? i.NEAREST_MIPMAP_NEAREST : i.LINEAR_MIPMAP_LINEAR : t), this.minFilter = t), e !== this.wrapS && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, e), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, e), this.wrapS = e);
        }
      }, {
        key: "bindExtraParam",
        value: function bindExtraParam(t, e, r, n) {
          var i = this.context,
            s = i.gl;
          s.bindTexture(s.TEXTURE_2D, this.texture), e !== this.magFilter && (s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, e), this.magFilter = e), t !== this.minFilter && (s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, this.useMipmap ? t === s.NEAREST ? s.NEAREST_MIPMAP_NEAREST : s.LINEAR_MIPMAP_LINEAR : t), this.minFilter = t), r !== this.wrapS && (s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, r), this.wrapS = r), n !== this.wrapT && (s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, n), this.wrapT = n);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = this.context.gl;
          t.deleteTexture(this.texture), this.texture = null;
        }
      }]);
      return $g;
    }();
    var qg = /*#__PURE__*/function () {
      function qg(t, e) {
        _classCallCheck(this, qg);
        this.context = t, this.texture = e;
      }
      _createClass(qg, [{
        key: "bind",
        value: function bind(t, e) {
          var r = this.context,
            n = r.gl;
          n.bindTexture(n.TEXTURE_2D, this.texture), t !== this.minFilter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, t), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, t), this.minFilter = t), e !== this.wrapS && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, e), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, e), this.wrapS = e);
        }
      }]);
      return qg;
    }();
    var Gg = 32,
      Xg = 33,
      Yg = new Uint16Array(8184);
    for (var _t257 = 0; _t257 < 2046; _t257++) {
      var _e267 = _t257 + 2,
        _r227 = 0,
        _n154 = 0,
        _i167 = 0,
        _s125 = 0,
        _a103 = 0,
        _o74 = 0;
      for (1 & _e267 ? _i167 = _s125 = _a103 = Gg : _r227 = _n154 = _o74 = Gg; (_e267 >>= 1) > 1;) {
        var _t258 = _r227 + _i167 >> 1,
          _l57 = _n154 + _s125 >> 1;
        1 & _e267 ? (_i167 = _r227, _s125 = _n154, _r227 = _a103, _n154 = _o74) : (_r227 = _i167, _n154 = _s125, _i167 = _a103, _s125 = _o74), _a103 = _t258, _o74 = _l57;
      }
      var _l58 = 4 * _t257;
      Yg[_l58 + 0] = _r227, Yg[_l58 + 1] = _n154, Yg[_l58 + 2] = _i167, Yg[_l58 + 3] = _s125;
    }
    var Zg = new Uint16Array(2178),
      Hg = new Uint8Array(1089),
      Kg = new Uint16Array(1089);
    function Wg(t) {
      return 0 === t ? -.03125 : 32 === t ? .03125 : 0;
    }
    var Jg = Rl([{
      name: "a_pos",
      type: "Int16",
      components: 2
    }, {
      name: "a_texture_pos",
      type: "Int16",
      components: 2
    }]);
    var Qg = /*#__PURE__*/function () {
      function Qg(t, e, r, n) {
        _classCallCheck(this, Qg);
        this.id = Qg.uniqueIdxCounter, Qg.uniqueIdxCounter++, this.context = t;
        var i = t.gl;
        this.buffer = i.createBuffer(), this.dynamicDraw = Boolean(r), this.context.unbindVAO(), t.bindElementBuffer.set(this.buffer), i.bufferData(i.ELEMENT_ARRAY_BUFFER, e.arrayBuffer, this.dynamicDraw ? i.DYNAMIC_DRAW : i.STATIC_DRAW), this.dynamicDraw || n || e.destroy();
      }
      _createClass(Qg, [{
        key: "bind",
        value: function bind() {
          this.context.bindElementBuffer.set(this.buffer);
        }
      }, {
        key: "updateData",
        value: function updateData(t) {
          this.id = Qg.uniqueIdxCounter, Qg.uniqueIdxCounter++;
          var e = this.context.gl;
          this.context.unbindVAO(), this.bind(), e.bufferSubData(e.ELEMENT_ARRAY_BUFFER, 0, t.arrayBuffer);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        }
      }]);
      return Qg;
    }();
    Qg.uniqueIdxCounter = 0;
    var tx = /*#__PURE__*/_createClass(function tx(t, e, r) {
      _classCallCheck(this, tx);
      this.func = t, this.mask = e, this.range = r;
    });
    tx.ReadOnly = !1, tx.ReadWrite = !0, tx.disabled = new tx(519, tx.ReadOnly, [0, 1]);
    var ex = 7680;
    var rx = /*#__PURE__*/_createClass(function rx(t, e, r, n, i, s) {
      _classCallCheck(this, rx);
      this.test = t, this.ref = e, this.mask = r, this.fail = n, this.depthFail = i, this.pass = s;
    });
    rx.disabled = new rx({
      func: 519,
      mask: 0
    }, 0, 0, ex, ex, ex);
    var nx = 771;
    var ix = /*#__PURE__*/_createClass(function ix(t, e, r, n) {
      _classCallCheck(this, ix);
      this.blendFunction = t, this.blendColor = e, this.mask = r, this.blendEquation = n;
    });
    ix.Replace = [1, 0, 1, 0], ix.disabled = new ix(ix.Replace, Gn.transparent, [!1, !1, !1, !1]), ix.unblended = new ix(ix.Replace, Gn.transparent, [!0, !0, !0, !0]), ix.alphaBlended = new ix([1, nx, 1, nx], Gn.transparent, [!0, !0, !0, !0]), ix.alphaBlendedNonPremultiplied = new ix([770, nx, 770, nx], Gn.transparent, [!0, !0, !0, !0]), ix.multiply = new ix([774, 0, 774, 0], Gn.transparent, [!0, !0, !0, !0]);
    var sx = 1029,
      ax = 2305;
    var ox = /*#__PURE__*/_createClass(function ox(t, e, r) {
      _classCallCheck(this, ox);
      this.enable = t, this.mode = e, this.frontFace = r;
    });
    ox.disabled = new ox(!1, sx, ax), ox.backCCW = new ox(!0, sx, ax), ox.backCW = new ox(!0, sx, 2304), ox.frontCW = new ox(!0, 1028, 2304), ox.frontCCW = new ox(!0, 1028, ax);
    var lx = Rl([{
      name: "a_index",
      type: "Int16",
      components: 1
    }]);
    var ux = function () {
      return {
        type: 2,
        extent: ds,
        loadGeometry: function loadGeometry() {
          return [[new je(0, 0), new je(ds + 1, 0), new je(ds + 1, ds + 1), new je(0, ds + 1), new je(0, 0)]];
        }
      };
    }();
    var cx = /*#__PURE__*/function () {
      function cx(t, e, r, n, i) {
        _classCallCheck(this, cx);
        this.tileID = t, this.uid = ir(), this.uses = 0, this.tileSize = e, this.tileZoom = r, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.isRaster = i, n && n.style && (this._lastUpdatedBrightness = n.style.getBrightness()), this.expiredRequestCount = 0, this.state = "loading", n && n.transform && (this.projection = n.transform.projection);
      }
      _createClass(cx, [{
        key: "registerFadeDuration",
        value: function registerFadeDuration(t) {
          var e = t + this.timeAdded;
          e < Rr.now() || this.fadeEndTime && e < this.fadeEndTime || (this.fadeEndTime = e);
        }
      }, {
        key: "wasRequested",
        value: function wasRequested() {
          return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
        }
      }, {
        key: "tileTransform",
        get: function get() {
          return this._tileTransform || (this._tileTransform = cg(this.tileID.canonical, this.projection)), this._tileTransform;
        }
      }, {
        key: "loadVectorData",
        value: function loadVectorData(t, e, r) {
          if (this.unloadVectorData(), this.state = "loaded", t) {
            t.featureIndex && (this.latestFeatureIndex = t.featureIndex, t.rawTileData ? (this.latestRawTileData = t.rawTileData, this.latestFeatureIndex.rawTileData = t.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t.collisionBoxArray, this.buckets = function (t, e) {
              var r = {};
              if (!e) return r;
              var _iterator174 = _createForOfIteratorHelper(t),
                _step174;
              try {
                var _loop9 = function _loop9() {
                  var n = _step174.value;
                  var t = n.layerIds.map(function (t) {
                    return e.getLayer(t);
                  }).filter(Boolean);
                  if (0 !== t.length) {
                    n.layers = t, n.stateDependentLayerIds && (n.stateDependentLayers = n.stateDependentLayerIds.map(function (e) {
                      return t.filter(function (t) {
                        return t.id === e;
                      })[0];
                    }));
                    var _iterator175 = _createForOfIteratorHelper(t),
                      _step175;
                    try {
                      for (_iterator175.s(); !(_step175 = _iterator175.n()).done;) {
                        var _e268 = _step175.value;
                        r[_e268.fqid] = n;
                      }
                    } catch (err) {
                      _iterator175.e(err);
                    } finally {
                      _iterator175.f();
                    }
                  }
                };
                for (_iterator174.s(); !(_step174 = _iterator174.n()).done;) {
                  _loop9();
                }
              } catch (err) {
                _iterator174.e(err);
              } finally {
                _iterator174.f();
              }
              return r;
            }(t.buckets, e.style), this.hasSymbolBuckets = !1;
            for (var _t259 in this.buckets) {
              var _e269 = this.buckets[_t259];
              if (_e269 instanceof Ng) {
                if (this.hasSymbolBuckets = !0, !r) break;
                _e269.justReloaded = !0;
              }
            }
            if (this.hasRTLText = !1, this.hasSymbolBuckets) for (var _t260 in this.buckets) {
              var _e270 = this.buckets[_t260];
              if (_e270 instanceof Ng && _e270.hasRTLText) {
                this.hasRTLText = !0, Ko.isLoading() || Ko.isLoaded() || "deferred" !== Zo() || Ho();
                break;
              }
            }
            this.queryPadding = 0;
            for (var _t261 in this.buckets) {
              var _r228 = this.buckets[_t261],
                _n155 = e.style.getOwnLayer(_t261);
              if (!_n155) continue;
              var _i168 = _n155.queryRadius(_r228);
              this.queryPadding = Math.max(this.queryPadding, _i168);
            }
            t.imageAtlas && (this.imageAtlas = t.imageAtlas), t.glyphAtlasImage && (this.glyphAtlasImage = t.glyphAtlasImage), t.lineAtlas && (this.lineAtlas = t.lineAtlas), this._lastUpdatedBrightness = t.brightness;
          } else this.collisionBoxArray = new du();
        }
      }, {
        key: "unloadVectorData",
        value: function unloadVectorData() {
          if (this.hasData()) {
            for (var _t262 in this.buckets) this.buckets[_t262].destroy();
            this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
          }
        }
      }, {
        key: "getBucket",
        value: function getBucket(t) {
          return this.buckets[t.fqid];
        }
      }, {
        key: "upload",
        value: function upload(t) {
          for (var _e271 in this.buckets) {
            var _r229 = this.buckets[_e271];
            _r229.uploadPending() && _r229.upload(t);
          }
          var e = t.gl,
            r = this.imageAtlas;
          if (r && !r.uploaded) {
            var _n156 = !!Object.keys(r.patternPositions).length;
            this.imageAtlasTexture = new $g(t, r.image, e.RGBA, {
              useMipmap: _n156
            }), this.imageAtlas.uploaded = !0;
          }
          this.glyphAtlasImage && (this.glyphAtlasTexture = new $g(t, this.glyphAtlasImage, e.R8), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new $g(t, this.lineAtlas.image, e.R8), this.lineAtlas.uploaded = !0);
        }
      }, {
        key: "prepare",
        value: function prepare(t, e, r) {
          if (this.imageAtlas && this.imageAtlasTexture && this.imageAtlas.patchUpdatedImages(t, this.imageAtlasTexture, r), !e || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) return;
          var n = e.style.getBrightness();
          (this._lastUpdatedBrightness || n) && (this._lastUpdatedBrightness && n && Math.abs(this._lastUpdatedBrightness - n) < .001 || (this._lastUpdatedBrightness = n, this.updateBuckets(void 0, e)));
        }
      }, {
        key: "queryRenderedFeatures",
        value: function queryRenderedFeatures(t, e, r, n, i, s, a, o) {
          return this.latestFeatureIndex && (this.latestFeatureIndex.rawTileData || this.latestFeatureIndex.is3DTile) ? this.latestFeatureIndex.query({
            tileResult: n,
            pixelPosMatrix: a,
            transform: s,
            params: i,
            tileTransform: this.tileTransform
          }, t, e, r) : {};
        }
      }, {
        key: "querySourceFeatures",
        value: function querySourceFeatures(t, e) {
          var r = this.latestFeatureIndex;
          if (!r || !r.rawTileData) return;
          var n = r.loadVTLayers(),
            i = e ? e.sourceLayer : "",
            s = n._geojsonTileLayer || n[i];
          if (!s) return;
          var a = dl(e && e.filter),
            _this$tileID$canonica = this.tileID.canonical,
            o = _this$tileID$canonica.z,
            l = _this$tileID$canonica.x,
            u = _this$tileID$canonica.y,
            c = {
              z: o,
              x: l,
              y: u
            };
          for (var _e272 = 0; _e272 < s.length; _e272++) {
            var _n157 = s.feature(_e272);
            if (a.needGeometry) {
              var _t263 = Wc(_n157, !0);
              if (!a.filter(new Wo(this.tileID.overscaledZ), _t263, this.tileID.canonical)) continue;
            } else if (!a.filter(new Wo(this.tileID.overscaledZ), _n157)) continue;
            var _h30 = r.getId(_n157, i),
              _p29 = new jm(_n157, o, l, u, _h30);
            _p29.tile = c, t.push(_p29);
          }
        }
      }, {
        key: "hasData",
        value: function hasData() {
          return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
        }
      }, {
        key: "patternsLoaded",
        value: function patternsLoaded() {
          return !!this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
        }
      }, {
        key: "setExpiryData",
        value: function setExpiryData(t) {
          var e = this.expirationTime;
          if (t.cacheControl) {
            var _e273 = br(t.cacheControl);
            _e273["max-age"] && (this.expirationTime = Date.now() + 1e3 * _e273["max-age"]);
          } else t.expires && (this.expirationTime = new Date(t.expires).getTime());
          if (this.expirationTime) {
            var _t264 = Date.now();
            var _r230 = !1;
            if (this.expirationTime > _t264) _r230 = !1;else if (e) {
              if (this.expirationTime < e) _r230 = !0;else {
                var _n158 = this.expirationTime - e;
                _n158 ? this.expirationTime = _t264 + Math.max(_n158, 3e4) : _r230 = !0;
              }
            } else _r230 = !0;
            _r230 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
          }
        }
      }, {
        key: "getExpiryTimeout",
        value: function getExpiryTimeout() {
          if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - new Date().getTime(), Math.pow(2, 31) - 1);
        }
      }, {
        key: "setFeatureState",
        value: function setFeatureState(t, e) {
          this.latestFeatureIndex && this.latestFeatureIndex.rawTileData && 0 !== Object.keys(t).length && e && this.updateBuckets(t, e);
        }
      }, {
        key: "updateBuckets",
        value: function updateBuckets(t, e) {
          if (!this.latestFeatureIndex) return;
          var r = this.latestFeatureIndex.loadVTLayers(),
            n = e.style.listImages(),
            i = e.style.getBrightness();
          for (var _s126 in this.buckets) {
            if (!e.style.hasLayer(_s126)) continue;
            var _a104 = this.buckets[_s126],
              _o75 = _a104.layers[0].sourceLayer || "_geojsonTileLayer",
              _l59 = r[_o75];
            var _u47 = {};
            if (t && (_u47 = t[_o75], !_l59 || !_u47 || 0 === Object.keys(_u47).length)) continue;
            if (_a104.update(_u47, _l59, n, this.imageAtlas && this.imageAtlas.patternPositions || {}, i), _a104 instanceof om || _a104 instanceof ef) {
              var _t265 = e.style.getOwnSourceCache(_a104.layers[0].source);
              e._terrain && e._terrain.enabled && _t265 && _a104.programConfigurations.needsUpload && e._terrain._clearRenderCacheForTile(_t265.id, this.tileID);
            }
            var _c38 = e && e.style && e.style.getOwnLayer(_s126);
            _c38 && (this.queryPadding = Math.max(this.queryPadding, _c38.queryRadius(_a104)));
          }
        }
      }, {
        key: "holdingForFade",
        value: function holdingForFade() {
          return void 0 !== this.symbolFadeHoldUntil;
        }
      }, {
        key: "symbolFadeFinished",
        value: function symbolFadeFinished() {
          return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < Rr.now();
        }
      }, {
        key: "clearFadeHold",
        value: function clearFadeHold() {
          this.symbolFadeHoldUntil = void 0;
        }
      }, {
        key: "setHoldDuration",
        value: function setHoldDuration(t) {
          this.symbolFadeHoldUntil = Rr.now() + t;
        }
      }, {
        key: "setTexture",
        value: function setTexture(t, e) {
          var r = e.context,
            n = r.gl;
          this.texture = this.texture || e.getTileTexture(t.width), this.texture && this.texture instanceof $g ? this.texture.update(t, {
            useMipmap: !0
          }) : (this.texture = new $g(r, t, n.RGBA, {
            useMipmap: !0
          }), this.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE));
        }
      }, {
        key: "setDependencies",
        value: function setDependencies(t, e) {
          var r = {};
          var _iterator176 = _createForOfIteratorHelper(e),
            _step176;
          try {
            for (_iterator176.s(); !(_step176 = _iterator176.n()).done;) {
              var _t266 = _step176.value;
              r[_t266] = !0;
            }
          } catch (err) {
            _iterator176.e(err);
          } finally {
            _iterator176.f();
          }
          this.dependencies[t] = r;
        }
      }, {
        key: "hasDependency",
        value: function hasDependency(t, e) {
          var _iterator177 = _createForOfIteratorHelper(t),
            _step177;
          try {
            for (_iterator177.s(); !(_step177 = _iterator177.n()).done;) {
              var _r231 = _step177.value;
              var _t267 = this.dependencies[_r231];
              if (_t267) {
                var _iterator178 = _createForOfIteratorHelper(e),
                  _step178;
                try {
                  for (_iterator178.s(); !(_step178 = _iterator178.n()).done;) {
                    var _r232 = _step178.value;
                    if (_t267[_r232]) return !0;
                  }
                } catch (err) {
                  _iterator178.e(err);
                } finally {
                  _iterator178.f();
                }
              }
            }
          } catch (err) {
            _iterator177.e(err);
          } finally {
            _iterator177.f();
          }
          return !1;
        }
      }, {
        key: "clearQueryDebugViz",
        value: function clearQueryDebugViz() {}
      }, {
        key: "_makeDebugTileBoundsBuffers",
        value: function _makeDebugTileBoundsBuffers(t, e) {
          if (!e || "mercator" === e.name || this._tileDebugBuffer) return;
          var r = Kc(ux, this.tileID.canonical, this.tileTransform)[0],
            n = new Ll(),
            i = new ou();
          for (var _t268 = 0; _t268 < r.length; _t268++) {
            var _r$_t = r[_t268],
              _e274 = _r$_t.x,
              _s127 = _r$_t.y;
            n.emplaceBack(_e274, _s127), i.emplaceBack(_t268);
          }
          i.emplaceBack(0), this._tileDebugIndexBuffer = t.createIndexBuffer(i), this._tileDebugBuffer = t.createVertexBuffer(n, Bh.members), this._tileDebugSegments = ku.simpleSegment(0, 0, n.length, i.length);
        }
      }, {
        key: "_makeTileBoundsBuffers",
        value: function _makeTileBoundsBuffers(t, e) {
          if (this._tileBoundsBuffer || !e || "mercator" === e.name) return;
          var r = Kc(ux, this.tileID.canonical, this.tileTransform)[0];
          var n, i;
          if (this.isRaster) {
            var _t269 = function (t, e) {
              var r = cg(t, e),
                n = Math.pow(2, t.z);
              for (var _i169 = 0; _i169 < Xg; _i169++) for (var _s128 = 0; _s128 < Xg; _s128++) {
                var _a105 = Rc((t.x + (_s128 + Wg(_s128)) / Gg) / n),
                  _o76 = Cc((t.y + (_i169 + Wg(_i169)) / Gg) / n),
                  _l60 = e.project(_a105, _o76),
                  _u48 = _i169 * Xg + _s128;
                Zg[2 * _u48 + 0] = Math.round((_l60.x * r.scale - r.x) * ds), Zg[2 * _u48 + 1] = Math.round((_l60.y * r.scale - r.y) * ds);
              }
              Hg.fill(0), Kg.fill(0);
              for (var _t270 = 2045; _t270 >= 0; _t270--) {
                var _e275 = 4 * _t270,
                  _r233 = Yg[_e275 + 0],
                  _n159 = Yg[_e275 + 1],
                  _i170 = Yg[_e275 + 2],
                  _s129 = Yg[_e275 + 3],
                  _a106 = _r233 + _i170 >> 1,
                  _o77 = _n159 + _s129 >> 1,
                  _l61 = _a106 + _o77 - _n159,
                  _u49 = _o77 + _r233 - _a106,
                  _c39 = _n159 * Xg + _r233,
                  _h31 = _s129 * Xg + _i170,
                  _p30 = _o77 * Xg + _a106,
                  _f26 = Math.hypot((Zg[2 * _c39 + 0] + Zg[2 * _h31 + 0]) / 2 - Zg[2 * _p30 + 0], (Zg[2 * _c39 + 1] + Zg[2 * _h31 + 1]) / 2 - Zg[2 * _p30 + 1]) >= 16;
                Hg[_p30] = Hg[_p30] || (_f26 ? 1 : 0), _t270 < 1022 && (Hg[_p30] = Hg[_p30] || Hg[(_n159 + _u49 >> 1) * Xg + (_r233 + _l61 >> 1)] || Hg[(_s129 + _u49 >> 1) * Xg + (_i170 + _l61 >> 1)]);
              }
              var i = new Fl(),
                s = new tu();
              var a = 0;
              function o(t, e) {
                var r = e * Xg + t;
                return 0 === Kg[r] && (i.emplaceBack(Zg[2 * r + 0], Zg[2 * r + 1], t * ds / Gg, e * ds / Gg), Kg[r] = ++a), Kg[r] - 1;
              }
              function l(t, e, r, n, i, a) {
                var u = t + r >> 1,
                  c = e + n >> 1;
                if (Math.abs(t - i) + Math.abs(e - a) > 1 && Hg[c * Xg + u]) l(i, a, t, e, u, c), l(r, n, i, a, u, c);else {
                  var _l62 = o(t, e),
                    _u50 = o(r, n),
                    _c40 = o(i, a);
                  s.emplaceBack(_l62, _u50, _c40);
                }
              }
              return l(0, 0, Gg, Gg, Gg, 0), l(Gg, Gg, 0, 0, 0, Gg), {
                vertices: i,
                indices: s
              };
            }(this.tileID.canonical, e);
            n = _t269.vertices, i = _t269.indices;
          } else {
            n = new Fl(), i = new tu();
            var _iterator179 = _createForOfIteratorHelper(r),
              _step179;
            try {
              for (_iterator179.s(); !(_step179 = _iterator179.n()).done;) {
                var _step179$value = _step179.value,
                  _t272 = _step179$value.x,
                  _e277 = _step179$value.y;
                n.emplaceBack(_t272, _e277, 0, 0);
              }
            } catch (err) {
              _iterator179.e(err);
            } finally {
              _iterator179.f();
            }
            var _t271 = Ip(n.int16, void 0, 4);
            for (var _e276 = 0; _e276 < _t271.length; _e276 += 3) i.emplaceBack(_t271[_e276], _t271[_e276 + 1], _t271[_e276 + 2]);
          }
          this._tileBoundsBuffer = t.createVertexBuffer(n, Jg.members), this._tileBoundsIndexBuffer = t.createIndexBuffer(i), this._tileBoundsSegments = ku.simpleSegment(0, 0, n.length, i.length);
        }
      }, {
        key: "_makeGlobeTileDebugBuffers",
        value: function _makeGlobeTileDebugBuffers(e, r) {
          var n = r.projection;
          if (!n || "globe" !== n.name || r.freezeTileCoverage) return;
          var i = this.tileID.canonical,
            s = Zh(Uh(i, r)),
            a = Qh(r.zoom);
          var o;
          a > 0 && (o = t.ae.invert(new Float64Array(16), r.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(e, i, r, s, o, a), this._makeGlobeTileDebugTextBuffer(e, i, r, s, o, a);
        }
      }, {
        key: "_globePoint",
        value: function _globePoint(e, r, n, i, s, a, o) {
          var l = Gh(e, r, n);
          if (a) {
            var _s130 = 1 << n.z,
              _u51 = Ec(i.center.lng),
              _c41 = Bc(i.center.lat),
              _h32 = (n.x + .5) / _s130 - _u51;
            var _p31 = 0;
            _h32 > .5 ? _p31 = -1 : _h32 < -.5 && (_p31 = 1);
            var _f27 = (e / ds + n.x) / _s130 + _p31,
              _d21 = (r / ds + n.y) / _s130;
            _f27 = (_f27 - _u51) * i._pixelsPerMercatorPixel + _u51, _d21 = (_d21 - _c41) * i._pixelsPerMercatorPixel + _c41;
            var _m15 = [_f27 * i.worldSize, _d21 * i.worldSize, 0];
            t.$.transformMat4(_m15, _m15, a), l = Oh(l, _m15, o);
          }
          return t.$.transformMat4(l, l, s);
        }
      }, {
        key: "_makeGlobeTileDebugBorderBuffer",
        value: function _makeGlobeTileDebugBorderBuffer(t, e, r, n, i, s) {
          var _this40 = this;
          var a = new Ll(),
            o = new ou(),
            l = new Vl(),
            u = function u(t, _u52, c, h, p) {
              var f = (c - t) / (p - 1),
                d = (h - _u52) / (p - 1),
                m = a.length;
              for (var _c42 = 0; _c42 < p; _c42++) {
                var _h33 = t + _c42 * f,
                  _p32 = _u52 + _c42 * d;
                a.emplaceBack(_h33, _p32);
                var _y12 = _this40._globePoint(_h33, _p32, e, r, n, i, s);
                l.emplaceBack(_y12[0], _y12[1], _y12[2]), o.emplaceBack(m + _c42);
              }
            },
            c = ds;
          u(0, 0, c, 0, 16), u(c, 0, c, c, 16), u(c, c, 0, c, 16), u(0, c, 0, 0, 16), this._tileDebugIndexBuffer = t.createIndexBuffer(o), this._tileDebugBuffer = t.createVertexBuffer(a, Bh.members), this._globeTileDebugBorderBuffer = t.createVertexBuffer(l, Eh.members), this._tileDebugSegments = ku.simpleSegment(0, 0, a.length, o.length);
        }
      }, {
        key: "_makeGlobeTileDebugTextBuffer",
        value: function _makeGlobeTileDebugTextBuffer(t, e, r, n, i, s) {
          var a = ds / 4,
            o = new Ll(),
            l = new tu(),
            u = new Vl(),
            c = 25;
          l.reserve(32), o.reserve(c), u.reserve(c);
          var h = function h(t, e) {
            return c * t + e;
          };
          for (var _t273 = 0; _t273 < c; _t273++) {
            var _l63 = _t273 * a;
            for (var _t274 = 0; _t274 < c; _t274++) {
              var _c43 = _t274 * a;
              o.emplaceBack(_c43, _l63);
              var _h34 = this._globePoint(_c43, _l63, e, r, n, i, s);
              u.emplaceBack(_h34[0], _h34[1], _h34[2]);
            }
          }
          for (var _t275 = 0; _t275 < 4; _t275++) for (var _e278 = 0; _e278 < 4; _e278++) {
            var _r234 = h(_t275, _e278),
              _n160 = h(_t275, _e278 + 1),
              _i171 = h(_t275 + 1, _e278),
              _s131 = h(_t275 + 1, _e278 + 1);
            l.emplaceBack(_r234, _n160, _i171), l.emplaceBack(_i171, _n160, _s131);
          }
          this._tileDebugTextIndexBuffer = t.createIndexBuffer(l), this._tileDebugTextBuffer = t.createVertexBuffer(o, Bh.members), this._globeTileDebugTextBuffer = t.createVertexBuffer(u, Eh.members), this._tileDebugTextSegments = ku.simpleSegment(0, 0, c, 32);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          for (var _t276 in this.buckets) this.buckets[_t276].destroy();
          this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture.destroy(), delete this.imageAtlasTexture), this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), !t && this.texture && this.texture instanceof $g && (this.texture.destroy(), delete this.texture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.rasterParticleState && (this.rasterParticleState.destroy(), delete this.rasterParticleState), this.latestFeatureIndex = null, this.state = "unloaded";
        }
      }]);
      return cx;
    }();
    function hx(t, e, r) {
      1 === t ? e.header_length = r.readFixed32() : 2 === t ? e.x = r.readVarint() : 3 === t ? e.y = r.readVarint() : 4 === t ? e.z = r.readVarint() : 5 === t && e.layers.push(function (t, e) {
        return t.readFields(yx, {
          version: 0,
          name: "",
          units: "",
          tilesize: 0,
          buffer: 0,
          pixel_format: 0,
          data_index: []
        }, e);
      }(r, r.readVarint() + r.pos));
    }
    function px(t, e, r) {
      1 === t ? (e.delta_filter = function (t, e) {
        return t.readFields(fx, {
          block_size: 0
        }, e);
      }(r, r.readVarint() + r.pos), e.filter = "delta_filter") : 2 === t ? (r.readVarint(), e.filter = "zigzag_filter") : 3 === t ? (r.readVarint(), e.filter = "bitshuffle_filter") : 4 === t && (r.readVarint(), e.filter = "byteshuffle_filter");
    }
    function fx(t, e, r) {
      1 === t && (e.block_size = r.readVarint());
    }
    function dx(t, e, r) {
      1 === t ? (r.readVarint(), e.codec = "gzip_data") : 2 === t ? (r.readVarint(), e.codec = "jpeg_image") : 3 === t ? (r.readVarint(), e.codec = "webp_image") : 4 === t && (r.readVarint(), e.codec = "png_image");
    }
    function mx(t, e, r) {
      1 === t ? e.first_byte = r.readFixed64() : 2 === t ? e.last_byte = r.readFixed64() : 3 === t ? e.filters.push(function (t, e) {
        return t.readFields(px, {}, e);
      }(r, r.readVarint() + r.pos)) : 4 === t ? e.codec = function (t, e) {
        return t.readFields(dx, {}, e);
      }(r, r.readVarint() + r.pos) : 5 === t ? e.deprecated_offset = r.readFloat() : 6 === t ? e.deprecated_scale = r.readFloat() : 7 === t ? e.bands.push(r.readString()) : 8 === t ? e.offset = r.readDouble() : 9 === t && (e.scale = r.readDouble());
    }
    function yx(t, e, r) {
      1 === t ? e.version = r.readVarint() : 2 === t ? e.name = r.readString() : 3 === t ? e.units = r.readString() : 4 === t ? e.tilesize = r.readVarint() : 5 === t ? e.buffer = r.readVarint() : 6 === t ? e.pixel_format = r.readVarint() : 7 === t && e.data_index.push(function (t, e) {
        return t.readFields(mx, {
          first_byte: 0,
          last_byte: 0,
          filters: [],
          codec: null,
          offset: 0,
          scale: 0,
          deprecated_offset: 0,
          deprecated_scale: 0,
          bands: []
        }, e);
      }(r, r.readVarint() + r.pos));
    }
    function gx(t, e, r) {
      if (2 === t) !function (t, e, r) {
        t.readFields(xx, r, e);
      }(r, r.readVarint() + r.pos, e);else if (3 === t) throw new Error("Not implemented");
    }
    function xx(t, e, r) {
      if (1 === t) {
        var _t277 = 0;
        var _n161 = r.readVarint() + r.pos;
        for (; r.pos < _n161;) e[_t277++] = r.readVarint();
      }
    }
    var bx = /*#__PURE__*/function () {
      function bx(t) {
        _classCallCheck(this, bx);
        this.capacity = t, this.cache = new Map();
      }
      _createClass(bx, [{
        key: "get",
        value: function get(t) {
          if (!this.cache.has(t)) return;
          var e = this.cache.get(t);
          return this.cache.delete(t), this.cache.set(t, e), e;
        }
      }, {
        key: "put",
        value: function put(t, e) {
          this.cache.has(t) ? this.cache.delete(t) : this.cache.size === this.capacity && this.cache.delete(this.cache.keys().next().value), this.cache.set(t, e);
        }
      }]);
      return bx;
    }();
    function vx(t, e) {
      if (4 !== e.length) throw new Error("Expected data of dimension 4 but got ".concat(e.length, "."));
      var r = e[3];
      for (var _n162 = 2; _n162 >= 1; _n162--) {
        var _i172 = 1 === _n162 ? 1 : 0,
          _s132 = 2 === _n162 ? 1 : 0;
        for (var _n163 = 0; _n163 < e[0]; _n163++) {
          var _a107 = e[1] * _n163;
          for (var _n164 = _i172; _n164 < e[1]; _n164++) {
            var _i173 = e[2] * (_n164 + _a107);
            for (var _n165 = _s132; _n165 < e[2]; _n165++) {
              var _s133 = e[3] * (_n165 + _i173);
              for (var _n166 = 0; _n166 < e[3]; _n166++) {
                var _e279 = _s133 + _n166;
                t[_e279] += t[_e279 - r];
              }
            }
          }
        }
        r *= e[_n162];
      }
      return t;
    }
    function _x(t) {
      for (var _e280 = 0, _r235 = t.length; _e280 < _r235; _e280++) t[_e280] = t[_e280] >>> 1 ^ -(1 & t[_e280]);
      return t;
    }
    function wx(t, e) {
      switch (e) {
        case "uint32":
          return t;
        case "uint16":
          for (var _e281 = 0; _e281 < t.length; _e281 += 2) {
            var _r236 = t[_e281],
              _n167 = t[_e281 + 1];
            t[_e281] = (240 & _r236) >> 4 | (61440 & _r236) >> 8 | (240 & _n167) << 4 | 61440 & _n167, t[_e281 + 1] = 15 & _r236 | (3840 & _r236) >> 4 | (15 & _n167) << 8 | (3840 & _n167) << 4;
          }
          return t;
        case "uint8":
          for (var _e282 = 0; _e282 < t.length; _e282 += 4) {
            var _r237 = t[_e282],
              _n168 = t[_e282 + 1],
              _i174 = t[_e282 + 2],
              _s134 = t[_e282 + 3];
            t[_e282 + 0] = (192 & _r237) >> 6 | (192 & _n168) >> 4 | (192 & _i174) >> 2 | 192 & _s134, t[_e282 + 1] = (48 & _r237) >> 4 | (48 & _n168) >> 2 | 48 & _i174 | (48 & _s134) << 2, t[_e282 + 2] = (12 & _r237) >> 2 | 12 & _n168 | (12 & _i174) << 2 | (12 & _s134) << 4, t[_e282 + 3] = 3 & _r237 | (3 & _n168) << 2 | (3 & _i174) << 4 | (3 & _s134) << 6;
          }
          return t;
        default:
          throw new Error("Invalid pixel format, \"".concat(e, "\""));
      }
    }
    var Mx = Uint8Array,
      Ax = Uint16Array,
      Sx = Int32Array,
      Ix = new Mx([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]),
      Tx = new Mx([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]),
      kx = new Mx([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
      Px = function Px(t, e) {
        for (var r = new Ax(31), n = 0; n < 31; ++n) r[n] = e += 1 << t[n - 1];
        var i = new Sx(r[30]);
        for (n = 1; n < 30; ++n) for (var s = r[n]; s < r[n + 1]; ++s) i[s] = s - r[n] << 5 | n;
        return {
          b: r,
          r: i
        };
      },
      zx = Px(Ix, 2),
      Ex = zx.b,
      Bx = zx.r;
    Ex[28] = 258, Bx[258] = 28;
    for (var Dx = Px(Tx, 0).b, Rx = new Ax(32768), Cx = 0; Cx < 32768; ++Cx) {
      var Lx = (43690 & Cx) >> 1 | (21845 & Cx) << 1;
      Rx[Cx] = ((65280 & (Lx = (61680 & (Lx = (52428 & Lx) >> 2 | (13107 & Lx) << 2)) >> 4 | (3855 & Lx) << 4)) >> 8 | (255 & Lx) << 8) >> 1;
    }
    var Vx = function Vx(t, e, r) {
        for (var n = t.length, i = 0, s = new Ax(e); i < n; ++i) t[i] && ++s[t[i] - 1];
        var a,
          o = new Ax(e);
        for (i = 1; i < e; ++i) o[i] = o[i - 1] + s[i - 1] << 1;
        a = new Ax(1 << e);
        var l = 15 - e;
        for (i = 0; i < n; ++i) if (t[i]) for (var u = i << 4 | t[i], c = e - t[i], h = o[t[i] - 1]++ << c, p = h | (1 << c) - 1; h <= p; ++h) a[Rx[h] >> l] = u;
        return a;
      },
      Fx = new Mx(288);
    for (Cx = 0; Cx < 144; ++Cx) Fx[Cx] = 8;
    for (Cx = 144; Cx < 256; ++Cx) Fx[Cx] = 9;
    for (Cx = 256; Cx < 280; ++Cx) Fx[Cx] = 7;
    for (Cx = 280; Cx < 288; ++Cx) Fx[Cx] = 8;
    var Ox = new Mx(32);
    for (Cx = 0; Cx < 32; ++Cx) Ox[Cx] = 5;
    var Ux = Vx(Fx, 9),
      jx = Vx(Ox, 5),
      Nx = function Nx(t) {
        for (var e = t[0], r = 1; r < t.length; ++r) t[r] > e && (e = t[r]);
        return e;
      },
      $x = function $x(t, e, r) {
        var n = e / 8 | 0;
        return (t[n] | t[n + 1] << 8) >> (7 & e) & r;
      },
      qx = function qx(t, e) {
        var r = e / 8 | 0;
        return (t[r] | t[r + 1] << 8 | t[r + 2] << 16) >> (7 & e);
      },
      Gx = ["unexpected EOF", "invalid block type", "invalid length/literal", "invalid distance", "stream finished", "no stream handler",, "no callback", "invalid UTF-8 data", "extra field too long", "date not in range 1980-2099", "filename too long", "stream finishing", "invalid zip data"],
      Xx = function Xx(t, e, r) {
        var n = new Error(e || Gx[t]);
        if (n.code = t, Error.captureStackTrace && Error.captureStackTrace(n, Xx), !r) throw n;
        return n;
      },
      Yx = new Mx(0),
      Zx = "undefined" != typeof TextDecoder && new TextDecoder();
    try {
      Zx.decode(Yx, {
        stream: !0
      });
    } catch (t) {}
    var Hx = {
      gzip_data: "gzip"
    };
    var Kx = /*#__PURE__*/function (_Error3) {
      _inherits(Kx, _Error3);
      var _super75 = _createSuper(Kx);
      function Kx(t) {
        var _this41;
        _classCallCheck(this, Kx);
        _this41 = _super75.call(this, t), _this41.name = "MRTError";
        return _this41;
      }
      return _createClass(Kx);
    }( /*#__PURE__*/_wrapNativeSuper(Error));
    var Wx = {
        0: "uint32",
        1: "uint32",
        2: "uint16",
        3: "uint8"
      },
      Jx = {
        uint32: 1,
        uint16: 2,
        uint8: 4
      },
      Qx = {
        uint32: Uint32Array,
        uint16: Uint16Array,
        uint8: Uint8Array
      };
    var tb, eb;
    var rb = /*#__PURE__*/function () {
      function rb() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
        _classCallCheck(this, rb);
        this.x = NaN, this.y = NaN, this.z = NaN, this.layers = {}, this._cacheSize = t;
      }
      _createClass(rb, [{
        key: "getLayer",
        value: function getLayer(t) {
          var e = this.layers[t];
          if (!e) throw new Kx("Layer '".concat(t, "' not found"));
          return e;
        }
      }, {
        key: "getHeaderLength",
        value: function getHeaderLength(t) {
          var e = new Uint8Array(t),
            r = new DataView(t);
          if (13 !== e[0]) throw new Kx("File is not a valid MRT.");
          return r.getUint32(1, !0);
        }
      }, {
        key: "parseHeader",
        value: function parseHeader(t) {
          var e = new Uint8Array(t),
            r = this.getHeaderLength(t);
          if (e.length < r) throw new Kx("Expected header with length >= ".concat(r, " but got buffer of length ").concat(e.length));
          var n = function (t, e) {
            return t.readFields(hx, {
              header_length: 0,
              x: 0,
              y: 0,
              z: 0,
              layers: []
            }, void 0);
          }(new tb(e.subarray(0, r)));
          if (!isNaN(this.x) && (this.x !== n.x || this.y !== n.y || this.z !== n.z)) throw new Kx("Invalid attempt to parse header ".concat(n.z, "/").concat(n.x, "/").concat(n.y, " for tile ").concat(this.z, "/").concat(this.x, "/").concat(this.y));
          this.x = n.x, this.y = n.y, this.z = n.z;
          var _iterator180 = _createForOfIteratorHelper(n.layers),
            _step180;
          try {
            for (_iterator180.s(); !(_step180 = _iterator180.n()).done;) {
              var _t278 = _step180.value;
              this.layers[_t278.name] = new nb(_t278, {
                cacheSize: this._cacheSize
              });
            }
          } catch (err) {
            _iterator180.e(err);
          } finally {
            _iterator180.f();
          }
          return this;
        }
      }, {
        key: "createDecodingTask",
        value: function createDecodingTask(t) {
          var _this42 = this;
          var e = [],
            r = this.getLayer(t.layerName);
          var _iterator181 = _createForOfIteratorHelper(t.blockIndices),
            _step181;
          try {
            for (_iterator181.s(); !(_step181 = _iterator181.n()).done;) {
              var _n169 = _step181.value;
              var _i175 = r.dataIndex[_n169],
                _s135 = _i175.first_byte - t.firstByte,
                _a108 = _i175.last_byte - t.firstByte;
              if (r._blocksInProgress.has(_n169)) continue;
              var _o78 = {
                layerName: r.name,
                firstByte: _s135,
                lastByte: _a108,
                pixelFormat: r.pixelFormat,
                blockIndex: _n169,
                blockShape: [_i175.bands.length].concat(r.bandShape),
                buffer: r.buffer,
                codec: _i175.codec.codec,
                filters: _i175.filters.map(function (t) {
                  return t.filter;
                })
              };
              r._blocksInProgress.add(_n169), e.push(_o78);
            }
          } catch (err) {
            _iterator181.e(err);
          } finally {
            _iterator181.f();
          }
          return new ib(e, function () {
            e.forEach(function (t) {
              return r._blocksInProgress.delete(t.blockIndex);
            });
          }, function (t, n) {
            if (e.forEach(function (t) {
              return r._blocksInProgress.delete(t.blockIndex);
            }), t) throw t;
            n.forEach(function (t) {
              _this42.getLayer(t.layerName).processDecodedData(t);
            });
          });
        }
      }]);
      return rb;
    }();
    var nb = /*#__PURE__*/function () {
      function nb(_ref132, o) {
        var t = _ref132.version,
          e = _ref132.name,
          r = _ref132.units,
          n = _ref132.tilesize,
          i = _ref132.pixel_format,
          s = _ref132.buffer,
          a = _ref132.data_index;
        _classCallCheck(this, nb);
        if (this.version = t, 1 !== this.version) throw new Kx("Cannot parse raster layer encoded with MRT version ".concat(t));
        this.name = e, this.units = r, this.tileSize = n, this.buffer = s, this.pixelFormat = Wx[i], this.dataIndex = a, this.bandShape = [n + 2 * s, n + 2 * s, Jx[this.pixelFormat]], this._decodedBlocks = new bx(o ? o.cacheSize : 5), this._blocksInProgress = new Set();
      }
      _createClass(nb, [{
        key: "dimension",
        get: function get() {
          return Jx[this.pixelFormat];
        }
      }, {
        key: "cacheSize",
        get: function get() {
          return this._decodedBlocks.capacity;
        }
      }, {
        key: "getBandList",
        value: function getBandList() {
          return this.dataIndex.map(function (_ref133) {
            var t = _ref133.bands;
            return t;
          }).flat();
        }
      }, {
        key: "processDecodedData",
        value: function processDecodedData(t) {
          var e = t.blockIndex.toString();
          this._decodedBlocks.get(e) || this._decodedBlocks.put(e, t.data);
        }
      }, {
        key: "getBlockForBand",
        value: function getBlockForBand(t) {
          var e = 0;
          switch (typeof t) {
            case "string":
              var _iterator182 = _createForOfIteratorHelper(this.dataIndex.entries()),
                _step182;
              try {
                for (_iterator182.s(); !(_step182 = _iterator182.n()).done;) {
                  var _step182$value = _slicedToArray(_step182.value, 2),
                    _r238 = _step182$value[0],
                    _n170 = _step182$value[1];
                  var _iterator183 = _createForOfIteratorHelper(_n170.bands.entries()),
                    _step183;
                  try {
                    for (_iterator183.s(); !(_step183 = _iterator183.n()).done;) {
                      var _step183$value = _slicedToArray(_step183.value, 2),
                        _i176 = _step183$value[0],
                        _s136 = _step183$value[1];
                      if (_s136 === t) return {
                        bandIndex: e + _i176,
                        blockIndex: _r238,
                        blockBandIndex: _i176
                      };
                    }
                  } catch (err) {
                    _iterator183.e(err);
                  } finally {
                    _iterator183.f();
                  }
                  e += _n170.bands.length;
                }
              } catch (err) {
                _iterator182.e(err);
              } finally {
                _iterator182.f();
              }
              break;
            case "number":
              var _iterator184 = _createForOfIteratorHelper(this.dataIndex.entries()),
                _step184;
              try {
                for (_iterator184.s(); !(_step184 = _iterator184.n()).done;) {
                  var _step184$value = _slicedToArray(_step184.value, 2),
                    _r239 = _step184$value[0],
                    _n171 = _step184$value[1];
                  if (t >= e && t < e + _n171.bands.length) return {
                    bandIndex: t,
                    blockIndex: _r239,
                    blockBandIndex: t - e
                  };
                  e += _n171.bands.length;
                }
              } catch (err) {
                _iterator184.e(err);
              } finally {
                _iterator184.f();
              }
              break;
            default:
              throw new Kx("Invalid band `".concat(JSON.stringify(t), "`. Expected string or integer."));
          }
          throw new Kx("Band not found: ".concat(JSON.stringify(t)));
        }
      }, {
        key: "getDataRange",
        value: function getDataRange(t) {
          var e = 1 / 0,
            r = -1 / 0;
          var n = [],
            i = new Set();
          var _iterator185 = _createForOfIteratorHelper(t),
            _step185;
          try {
            for (_iterator185.s(); !(_step185 = _iterator185.n()).done;) {
              var _s137 = _step185.value;
              var _this$getBlockForBand = this.getBlockForBand(_s137),
                _t279 = _this$getBlockForBand.blockIndex;
              if (_t279 < 0) throw new Kx("Invalid band: ".concat(JSON.stringify(_s137)));
              var _a109 = this.dataIndex[_t279];
              n.includes(_t279) || n.push(_t279), i.add(_t279), e = Math.min(e, _a109.first_byte), r = Math.max(r, _a109.last_byte);
            }
          } catch (err) {
            _iterator185.e(err);
          } finally {
            _iterator185.f();
          }
          if (i.size > this.cacheSize) throw new Kx("Number of blocks to decode (".concat(i.size, ") exceeds cache size (").concat(this.cacheSize, ")."));
          return {
            layerName: this.name,
            firstByte: e,
            lastByte: r,
            blockIndices: n
          };
        }
      }, {
        key: "hasBand",
        value: function hasBand(t) {
          var _this$getBlockForBand2 = this.getBlockForBand(t),
            e = _this$getBlockForBand2.blockIndex;
          return e >= 0;
        }
      }, {
        key: "hasDataForBand",
        value: function hasDataForBand(t) {
          var _this$getBlockForBand3 = this.getBlockForBand(t),
            e = _this$getBlockForBand3.blockIndex;
          return e >= 0 && !!this._decodedBlocks.get(e.toString());
        }
      }, {
        key: "getBandView",
        value: function getBandView(t) {
          var _this$getBlockForBand4 = this.getBlockForBand(t),
            e = _this$getBlockForBand4.blockIndex,
            r = _this$getBlockForBand4.blockBandIndex,
            n = this._decodedBlocks.get(e.toString());
          if (!n) throw new Kx("Data for band ".concat(JSON.stringify(t), " of layer \"").concat(this.name, "\" not decoded."));
          var i = this.dataIndex[e],
            s = this.bandShape.reduce(function (t, e) {
              return t * e;
            }, 1),
            a = r * s,
            o = n.subarray(a, a + s);
          return {
            data: o,
            bytes: new Uint8Array(o.buffer).subarray(o.byteOffset, o.byteOffset + o.byteLength),
            tileSize: this.tileSize,
            buffer: this.buffer,
            pixelFormat: this.pixelFormat,
            dimension: this.dimension,
            offset: 0 !== i.offset ? i.offset : i.deprecated_offset,
            scale: 0 !== i.scale ? i.scale : i.deprecated_scale
          };
        }
      }]);
      return nb;
    }();
    rb.setPbf = function (t) {
      tb = t;
    };
    var ib = /*#__PURE__*/function () {
      function ib(t, e, r) {
        _classCallCheck(this, ib);
        this.tasks = t, this._onCancel = e, this._onComplete = r, this._finalized = !1;
      }
      _createClass(ib, [{
        key: "cancel",
        value: function cancel() {
          this._finalized || (this._onCancel(), this._finalized = !0);
        }
      }, {
        key: "complete",
        value: function complete(t, e) {
          this._finalized || (this._onComplete(t, e), this._finalized = !0);
        }
      }]);
      return ib;
    }();
    rb.performDecoding = function (t, e) {
      var r = new Uint8Array(t);
      return Promise.all(e.tasks.map(function (t) {
        var e = t.layerName,
          n = t.firstByte,
          i = t.lastByte,
          s = t.pixelFormat,
          a = t.blockShape,
          o = t.blockIndex,
          l = t.filters,
          u = t.codec,
          c = r.subarray(n, i + 1),
          h = new Uint32Array(a[0] * a[1] * a[2]);
        var p;
        if ("gzip_data" !== u) throw new Kx("Unhandled codec: ".concat(u));
        return p = function (t, e) {
          if (!globalThis.DecompressionStream && "gzip_data" === e) return Promise.resolve(((s = function (t) {
            31 == t[0] && 139 == t[1] && 8 == t[2] || Xx(6, "invalid gzip data");
            var e = t[3],
              r = 10;
            4 & e && (r += 2 + (t[10] | t[11] << 8));
            for (var n = (e >> 3 & 1) + (e >> 4 & 1); n > 0; n -= !t[r++]);
            return r + (2 & e);
          }(i = t)) + 8 > i.length && Xx(6, "invalid gzip data"), function (t, e, r, n) {
            var i = t.length;
            if (!i || e.f && !e.l) return r || new Mx(0);
            var s = !r,
              a = s || 2 != e.i,
              o = e.i;
            s && (r = new Mx(3 * i));
            var l,
              u,
              c = function c(t) {
                var e = r.length;
                if (t > e) {
                  var n = new Mx(Math.max(2 * e, t));
                  n.set(r), r = n;
                }
              },
              h = e.f || 0,
              p = e.p || 0,
              f = e.b || 0,
              d = e.l,
              m = e.d,
              y = e.m,
              g = e.n,
              x = 8 * i;
            do {
              if (!d) {
                h = $x(t, p, 1);
                var b = $x(t, p + 1, 3);
                if (p += 3, !b) {
                  var v = t[(E = 4 + ((p + 7) / 8 | 0)) - 4] | t[E - 3] << 8,
                    _ = E + v;
                  if (_ > i) {
                    o && Xx(0);
                    break;
                  }
                  a && c(f + v), r.set(t.subarray(E, _), f), e.b = f += v, e.p = p = 8 * _, e.f = h;
                  continue;
                }
                if (1 == b) d = Ux, m = jx, y = 9, g = 5;else if (2 == b) {
                  var w = $x(t, p, 31) + 257,
                    M = $x(t, p + 10, 15) + 4,
                    A = w + $x(t, p + 5, 31) + 1;
                  p += 14;
                  for (var S = new Mx(A), I = new Mx(19), T = 0; T < M; ++T) I[kx[T]] = $x(t, p + 3 * T, 7);
                  p += 3 * M;
                  var k = Nx(I),
                    P = (1 << k) - 1,
                    z = Vx(I, k);
                  for (T = 0; T < A;) {
                    var E,
                      B = z[$x(t, p, P)];
                    if (p += 15 & B, (E = B >> 4) < 16) S[T++] = E;else {
                      var D = 0,
                        R = 0;
                      for (16 == E ? (R = 3 + $x(t, p, 3), p += 2, D = S[T - 1]) : 17 == E ? (R = 3 + $x(t, p, 7), p += 3) : 18 == E && (R = 11 + $x(t, p, 127), p += 7); R--;) S[T++] = D;
                    }
                  }
                  var C = S.subarray(0, w),
                    L = S.subarray(w);
                  y = Nx(C), g = Nx(L), d = Vx(C, y), m = Vx(L, g);
                } else Xx(1);
                if (p > x) {
                  o && Xx(0);
                  break;
                }
              }
              a && c(f + 131072);
              for (var V = (1 << y) - 1, F = (1 << g) - 1, O = p;; O = p) {
                var U = (D = d[qx(t, p) & V]) >> 4;
                if ((p += 15 & D) > x) {
                  o && Xx(0);
                  break;
                }
                if (D || Xx(2), U < 256) r[f++] = U;else {
                  if (256 == U) {
                    O = p, d = null;
                    break;
                  }
                  var j = U - 254;
                  U > 264 && (j = $x(t, p, (1 << (q = Ix[T = U - 257])) - 1) + Ex[T], p += q);
                  var N = m[qx(t, p) & F],
                    $ = N >> 4;
                  if (N || Xx(3), p += 15 & N, L = Dx[$], $ > 3) {
                    var q = Tx[$];
                    L += qx(t, p) & (1 << q) - 1, p += q;
                  }
                  if (p > x) {
                    o && Xx(0);
                    break;
                  }
                  a && c(f + 131072);
                  var G = f + j;
                  if (f < L) {
                    var X = 0 - L,
                      Y = Math.min(L, G);
                    for (X + f < 0 && Xx(3); f < Y; ++f) r[f] = (void 0)[X + f];
                  }
                  for (; f < G; ++f) r[f] = r[f - L];
                }
              }
              e.l = d, e.p = O, e.b = f, e.f = h, d && (h = 1, e.m = y, e.d = m, e.n = g);
            } while (!h);
            return f != r.length && s ? (l = r, (null == (u = f) || u > l.length) && (u = l.length), new Mx(l.subarray(0, u))) : r.subarray(0, f);
          }(i.subarray(s, -8), {
            i: 2
          }, new Mx(((r = i)[(n = r.length) - 4] | r[n - 3] << 8 | r[n - 2] << 16 | r[n - 1] << 24) >>> 0))));
          var r, n, i, s;
          var a = Hx[e];
          if (!a) throw new Error("Unhandled codec: ".concat(e));
          var o = new globalThis.DecompressionStream(a);
          return new Response(new Blob([t]).stream().pipeThrough(o)).arrayBuffer().then(function (t) {
            return new Uint8Array(t);
          });
        }(c, u).then(function (t) {
          return function (t, e) {
            t.readFields(gx, e);
          }(new tb(t), h), new (0, Qx[s])(h.buffer);
        }), p.then(function (t) {
          for (var _e283 = l.length - 1; _e283 >= 0; _e283--) switch (l[_e283]) {
            case "delta_filter":
              vx(t, a);
              break;
            case "zigzag_filter":
              _x(t);
              break;
            case "bitshuffle_filter":
              wx(t, s);
              break;
            default:
              throw new Kx("Unhandled filter \"".concat(l[_e283], "\""));
          }
          return {
            layerName: e,
            blockIndex: o,
            data: t
          };
        }).catch(function (t) {
          throw t;
        });
      }));
    }, rb.setPbf(Om);
    var sb = /*#__PURE__*/function (_cx) {
      _inherits(sb, _cx);
      var _super76 = _createSuper(sb);
      function sb(t, e, r, n, i) {
        var _this43;
        _classCallCheck(this, sb);
        _this43 = _super76.call(this, t, e, r, n, i), _this43._workQueue = [], _this43._fetchQueue = [], _this43._isHeaderLoaded = !1;
        return _this43;
      }
      _createClass(sb, [{
        key: "setTexture",
        value: function setTexture(t, e) {
          var r = e.context,
            n = r.gl;
          this.texture = this.texture || e.getTileTexture(t.width), this.texture && this.texture instanceof $g ? this.texture.update(t, {
            useMipmap: !1,
            premultiply: !1
          }) : this.texture = new $g(r, t, n.RGBA, {
            useMipmap: !1,
            premultiply: !1
          });
        }
      }, {
        key: "flushQueues",
        value: function flushQueues() {
          for (; this._workQueue.length;) this._workQueue.pop()();
          for (; this._fetchQueue.length;) this._fetchQueue.pop()();
        }
      }, {
        key: "fetchHeader",
        value: function fetchHeader() {
          var _this44 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16384;
          var e = arguments.length > 1 ? arguments[1] : undefined;
          var r = this._mrt = new rb(30),
            n = Object.assign({}, this.requestParams, {
              headers: {
                Range: "bytes=0-" + (t - 1)
              }
            });
          return this.entireBuffer = null, this.request = nn(n, function (n, i, s, a) {
            if (n) e(n);else try {
              var _n172 = r.getHeaderLength(i);
              if (_n172 > t) return void (_this44.request = _this44.fetchHeader(_n172, e));
              r.parseHeader(i), _this44._isHeaderLoaded = !0;
              var _o79 = 0;
              for (var _i177 = 0, _Object$values = Object.values(r.layers); _i177 < _Object$values.length; _i177++) {
                var _t280 = _Object$values[_i177];
                _o79 = Math.max(_o79, _t280.dataIndex[_t280.dataIndex.length - 1].last_byte);
              }
              i.byteLength >= _o79 && (_this44.entireBuffer = i), e(null, _this44.entireBuffer || i, s, a);
            } catch (t) {
              e(t);
            }
          }), this.request;
        }
      }, {
        key: "fetchBand",
        value: function fetchBand(t, e, r) {
          var _this45 = this;
          var n = this._mrt;
          if (!this._isHeaderLoaded || !n) return void r(new Error("Tile header is not ready"));
          var i = this.actor;
          if (!i) return void r(new Error("Can't fetch tile band without an actor"));
          var s;
          var a = function a(n, i) {
              s.complete(n, i), n ? r(n) : (_this45.updateTextureDescriptor(t, e), r(null, _this45.textureDescriptor && _this45.textureDescriptor.img));
            },
            o = function o(t, e) {
              if (t) return r(t);
              var n = i.send("decodeRasterArray", {
                buffer: e,
                task: s
              }, a, void 0, !0);
              _this45._workQueue.push(function () {
                n && n.cancel(), s.cancel();
              });
            },
            l = n.getLayer(t);
          if (!l) return void r(new Error("Unknown sourceLayer \"".concat(t, "\"")));
          if (l.hasDataForBand(e)) return this.updateTextureDescriptor(t, e), void r(null, this.textureDescriptor ? this.textureDescriptor.img : null);
          var u = l.getDataRange([e]);
          if (s = n.createDecodingTask(u), !s || s.tasks.length) {
            if (this.flushQueues(), this.entireBuffer) o(null, this.entireBuffer.slice(u.firstByte, u.lastByte + 1));else {
              var _t281 = Object.assign({}, this.requestParams, {
                  headers: {
                    Range: "bytes=".concat(u.firstByte, "-").concat(u.lastByte)
                  }
                }),
                _e284 = nn(_t281, o);
              this._fetchQueue.push(function () {
                _e284.cancel(), s.cancel();
              });
            }
          } else r(null);
        }
      }, {
        key: "updateNeeded",
        value: function updateNeeded(t, e) {
          return (!this.textureDescriptor || this.textureDescriptor.band !== e || this.textureDescriptor.layer !== t) && "errored" !== this.state;
        }
      }, {
        key: "updateTextureDescriptor",
        value: function updateTextureDescriptor(t, e) {
          if (!this._mrt) return;
          var r = this._mrt.getLayer(t);
          if (!r || !r.hasBand(e) || !r.hasDataForBand(e)) return;
          var _r$getBandView = r.getBandView(e),
            n = _r$getBandView.bytes,
            i = _r$getBandView.tileSize,
            s = _r$getBandView.buffer,
            a = _r$getBandView.offset,
            o = _r$getBandView.scale,
            l = i + 2 * s,
            u = {
              data: n,
              width: l,
              height: l
            },
            c = this.texture;
          c && c instanceof $g && c.update(u, {
            useMipmap: !1,
            premultiply: !1
          }), this.textureDescriptor = {
            layer: t,
            band: e,
            img: u,
            buffer: s,
            offset: a,
            tileSize: i,
            format: r.pixelFormat,
            mix: [o, 256 * o, 65536 * o, 16777216 * o]
          };
        }
      }]);
      return sb;
    }(cx);
    var ab = /*#__PURE__*/function () {
      function ab(t, e) {
        _classCallCheck(this, ab);
        this.max = t, this.onRemove = e, this.reset();
      }
      _createClass(ab, [{
        key: "reset",
        value: function reset() {
          for (var _t282 in this.data) {
            var _iterator186 = _createForOfIteratorHelper(this.data[_t282]),
              _step186;
            try {
              for (_iterator186.s(); !(_step186 = _iterator186.n()).done;) {
                var _e285 = _step186.value;
                _e285.timeout && clearTimeout(_e285.timeout), this.onRemove(_e285.value);
              }
            } catch (err) {
              _iterator186.e(err);
            } finally {
              _iterator186.f();
            }
          }
          return this.data = {}, this.order = [], this;
        }
      }, {
        key: "add",
        value: function add(t, e, r) {
          var _this46 = this;
          var n = t.wrapped().key;
          void 0 === this.data[n] && (this.data[n] = []);
          var i = {
            value: e,
            timeout: void 0
          };
          if (void 0 !== r && (i.timeout = setTimeout(function () {
            _this46.remove(t, i);
          }, r)), this.data[n].push(i), this.order.push(n), this.order.length > this.max) {
            var _t283 = this._getAndRemoveByKey(this.order[0]);
            _t283 && this.onRemove(_t283);
          }
          return this;
        }
      }, {
        key: "has",
        value: function has(t) {
          return t.wrapped().key in this.data;
        }
      }, {
        key: "getAndRemove",
        value: function getAndRemove(t) {
          return this.has(t) ? this._getAndRemoveByKey(t.wrapped().key) : null;
        }
      }, {
        key: "_getAndRemoveByKey",
        value: function _getAndRemoveByKey(t) {
          var e = this.data[t].shift();
          return e.timeout && clearTimeout(e.timeout), 0 === this.data[t].length && delete this.data[t], this.order.splice(this.order.indexOf(t), 1), e.value;
        }
      }, {
        key: "getByKey",
        value: function getByKey(t) {
          var e = this.data[t];
          return e ? e[0].value : null;
        }
      }, {
        key: "get",
        value: function get(t) {
          return this.has(t) ? this.data[t.wrapped().key][0].value : null;
        }
      }, {
        key: "remove",
        value: function remove(t, e) {
          if (!this.has(t)) return this;
          var r = t.wrapped().key,
            n = void 0 === e ? 0 : this.data[r].indexOf(e),
            i = this.data[r][n];
          return this.data[r].splice(n, 1), i.timeout && clearTimeout(i.timeout), 0 === this.data[r].length && delete this.data[r], this.onRemove(i.value), this.order.splice(this.order.indexOf(r), 1), this;
        }
      }, {
        key: "setMaxSize",
        value: function setMaxSize(t) {
          for (this.max = t; this.order.length > this.max;) {
            var _t284 = this._getAndRemoveByKey(this.order[0]);
            _t284 && this.onRemove(_t284);
          }
          return this;
        }
      }, {
        key: "filter",
        value: function filter(t) {
          var e = [];
          for (var _r240 in this.data) {
            var _iterator187 = _createForOfIteratorHelper(this.data[_r240]),
              _step187;
            try {
              for (_iterator187.s(); !(_step187 = _iterator187.n()).done;) {
                var _n173 = _step187.value;
                t(_n173.value) || e.push(_n173);
              }
            } catch (err) {
              _iterator187.e(err);
            } finally {
              _iterator187.f();
            }
          }
          for (var _i178 = 0, _e286 = e; _i178 < _e286.length; _i178++) {
            var _t285 = _e286[_i178];
            this.remove(_t285.value.tileID, _t285);
          }
        }
      }]);
      return ab;
    }();
    var ob = /*#__PURE__*/function (_On2) {
      _inherits(ob, _On2);
      var _super77 = _createSuper(ob);
      function ob(t, e, r) {
        var _this47;
        _classCallCheck(this, ob);
        _this47 = _super77.call(this), _this47.id = t, _this47._onlySymbols = r, e.on("data", function (t) {
          "source" === t.dataType && "metadata" === t.sourceDataType && (_this47._sourceLoaded = !0), _this47._sourceLoaded && !_this47._paused && "source" === t.dataType && "content" === t.sourceDataType && (_this47.reload(), _this47.transform && _this47.update(_this47.transform));
        }), e.on("error", function () {
          _this47._sourceErrored = !0;
        }), _this47._source = e, _this47._tiles = {}, _this47._cache = new ab(0, _this47._unloadTile.bind(_assertThisInitialized(_this47))), _this47._timers = {}, _this47._cacheTimers = {}, _this47._minTileCacheSize = e.minTileCacheSize, _this47._maxTileCacheSize = e.maxTileCacheSize, _this47._loadedParentTiles = {}, _this47.castsShadows = !1, _this47.tileCoverLift = 0, _this47._coveredTiles = {}, _this47._shadowCasterTiles = {}, _this47._state = new Nm(), _this47._isRaster = "raster" === _this47._source.type || "raster-dem" === _this47._source.type || "raster-array" === _this47._source.type || "custom" === _this47._source.type && "raster" === _this47._source._dataType;
        return _this47;
      }
      _createClass(ob, [{
        key: "onAdd",
        value: function onAdd(t) {
          this.map = t, this._minTileCacheSize = void 0 === this._minTileCacheSize && t ? t._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && t ? t._maxTileCacheSize : this._maxTileCacheSize;
        }
      }, {
        key: "loaded",
        value: function loaded() {
          if (this._sourceErrored) return !0;
          if (!this._sourceLoaded) return !1;
          if (!this._source.loaded()) return !1;
          for (var _t286 in this._tiles) {
            var _e287 = this._tiles[_t286];
            if ("loaded" !== _e287.state && "errored" !== _e287.state) return !1;
          }
          return !0;
        }
      }, {
        key: "getSource",
        value: function getSource() {
          return this._source;
        }
      }, {
        key: "pause",
        value: function pause() {
          this._paused = !0;
        }
      }, {
        key: "resume",
        value: function resume() {
          if (!this._paused) return;
          var t = this._shouldReloadOnResume;
          this._paused = !1, this._shouldReloadOnResume = !1, t && this.reload(), this.transform && this.update(this.transform);
        }
      }, {
        key: "_loadTile",
        value: function _loadTile(t, e) {
          return t.isSymbolTile = this._onlySymbols, t.isExtraShadowCaster = this._shadowCasterTiles[t.tileID.key], this._source.loadTile(t, e);
        }
      }, {
        key: "_unloadTile",
        value: function _unloadTile(t) {
          if (this._source.unloadTile) return this._source.unloadTile(t);
        }
      }, {
        key: "_abortTile",
        value: function _abortTile(t) {
          if (this._source.abortTile) return this._source.abortTile(t);
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return this._source.serialize();
        }
      }, {
        key: "prepare",
        value: function prepare(t) {
          this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
          for (var _e288 in this._tiles) {
            var _r241 = this._tiles[_e288];
            _r241.upload(t), _r241.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
          }
        }
      }, {
        key: "getIds",
        value: function getIds() {
          return er(this._tiles).map(function (t) {
            return t.tileID;
          }).sort(lb).map(function (t) {
            return t.key;
          });
        }
      }, {
        key: "getRenderableIds",
        value: function getRenderableIds(t, e) {
          var _this48 = this;
          var r = [];
          for (var _n174 in this._tiles) this._isIdRenderable(+_n174, t, e) && r.push(this._tiles[_n174]);
          return t ? r.sort(function (t, e) {
            var r = t.tileID,
              n = e.tileID,
              i = new je(r.canonical.x, r.canonical.y)._rotate(_this48.transform.angle),
              s = new je(n.canonical.x, n.canonical.y)._rotate(_this48.transform.angle);
            return r.overscaledZ - n.overscaledZ || s.y - i.y || s.x - i.x;
          }).map(function (t) {
            return t.tileID.key;
          }) : r.map(function (t) {
            return t.tileID;
          }).sort(lb).map(function (t) {
            return t.key;
          });
        }
      }, {
        key: "hasRenderableParent",
        value: function hasRenderableParent(t) {
          var e = this.findLoadedParent(t, 0);
          return !!e && this._isIdRenderable(e.tileID.key);
        }
      }, {
        key: "_isIdRenderable",
        value: function _isIdRenderable(t, e, r) {
          return this._tiles[t] && this._tiles[t].hasData() && !this._coveredTiles[t] && (e || !this._tiles[t].holdingForFade()) && (r || !this._shadowCasterTiles[t]);
        }
      }, {
        key: "reload",
        value: function reload() {
          if (this._paused) this._shouldReloadOnResume = !0;else {
            this._cache.reset();
            for (var _t287 in this._tiles) "errored" !== this._tiles[_t287].state && this._reloadTile(+_t287, "reloading");
          }
        }
      }, {
        key: "_reloadTile",
        value: function _reloadTile(t, e) {
          var r = this._tiles[t];
          r && ("loading" !== r.state && (r.state = e), this._loadTile(r, this._tileLoaded.bind(this, r, t, e)));
        }
      }, {
        key: "_tileLoaded",
        value: function _tileLoaded(t, e, r, n) {
          if (n) {
            if (t.state = "errored", 404 !== n.status) this._source.fire(new Ln(n, {
              tile: t
            }));else {
              if (this._source.fire(new Cn("data", {
                dataType: "source",
                sourceDataType: "error",
                sourceId: this._source.id,
                tile: t
              })), !(t.tileID.key in this._loadedParentTiles)) return;
              if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                var _t288 = this.map.painter.terrain;
                this.update(this.transform, _t288.getScaledDemTileSize(), !0), _t288.resetTileLookupCache(this.id);
              } else this.update(this.transform);
            }
          } else t.timeAdded = Rr.now(), "expired" === r && (t.refreshedUponExpiration = !0), this._setTileReloadTimer(e, t), "raster-dem" === this._source.type && t.dem && this._backfillDEM(t), this._state.initializeTileState(t, this.map ? this.map.painter : null), this._source.fire(new Cn("data", {
            dataType: "source",
            tile: t,
            coord: t.tileID,
            sourceCacheId: this.id
          }));
        }
      }, {
        key: "_backfillDEM",
        value: function _backfillDEM(t) {
          var e = this.getRenderableIds();
          for (var _n175 = 0; _n175 < e.length; _n175++) {
            var _i179 = e[_n175];
            if (t.neighboringTiles && t.neighboringTiles[_i179]) {
              var _e289 = this.getTileByID(_i179);
              r(t, _e289), r(_e289, t);
            }
          }
          function r(t, e) {
            if (!t.dem || t.dem.borderReady) return;
            t.needsHillshadePrepare = !0, t.needsDEMTextureUpload = !0;
            var r = e.tileID.canonical.x - t.tileID.canonical.x;
            var n = e.tileID.canonical.y - t.tileID.canonical.y,
              i = Math.pow(2, t.tileID.canonical.z),
              s = e.tileID.key;
            0 === r && 0 === n || Math.abs(n) > 1 || (Math.abs(r) > 1 && (1 === Math.abs(r + i) ? r += i : 1 === Math.abs(r - i) && (r -= i)), e.dem && t.dem && (t.dem.backfillBorder(e.dem, r, n), t.neighboringTiles && t.neighboringTiles[s] && (t.neighboringTiles[s].backfilled = !0)));
          }
        }
      }, {
        key: "getTile",
        value: function getTile(t) {
          return this.getTileByID(t.key);
        }
      }, {
        key: "getTileByID",
        value: function getTileByID(t) {
          return this._tiles[t];
        }
      }, {
        key: "_retainLoadedChildren",
        value: function _retainLoadedChildren(t, e, r, n) {
          for (var _i180 in this._tiles) {
            var _s138 = this._tiles[_i180];
            if (n[_i180] || !_s138.hasData() || _s138.tileID.overscaledZ <= e || _s138.tileID.overscaledZ > r) continue;
            var _a110 = _s138.tileID;
            for (; _s138 && _s138.tileID.overscaledZ > e + 1;) {
              var _t289 = _s138.tileID.scaledTo(_s138.tileID.overscaledZ - 1);
              _s138 = this._tiles[_t289.key], _s138 && _s138.hasData() && (_a110 = _t289);
            }
            var _o80 = _a110;
            for (; _o80.overscaledZ > e;) if (_o80 = _o80.scaledTo(_o80.overscaledZ - 1), t[_o80.key]) {
              n[_a110.key] = _a110;
              break;
            }
          }
        }
      }, {
        key: "findLoadedParent",
        value: function findLoadedParent(t, e) {
          if (t.key in this._loadedParentTiles) {
            var _r242 = this._loadedParentTiles[t.key];
            return _r242 && _r242.tileID.overscaledZ >= e ? _r242 : null;
          }
          for (var _r243 = t.overscaledZ - 1; _r243 >= e; _r243--) {
            var _e290 = t.scaledTo(_r243),
              _n176 = this._getLoadedTile(_e290);
            if (_n176) return _n176;
          }
        }
      }, {
        key: "_getLoadedTile",
        value: function _getLoadedTile(t) {
          var e = this._tiles[t.key];
          return e && e.hasData() ? e : this._cache.getByKey(this._source.reparseOverscaled ? t.wrapped().key : t.canonical.key);
        }
      }, {
        key: "updateCacheSize",
        value: function updateCacheSize(t, e) {
          e = e || this._source.tileSize;
          var r = Math.ceil(t.width / e) + 1,
            n = Math.ceil(t.height / e) + 1,
            i = Math.floor(r * n * 5),
            s = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, i) : i,
            a = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, s) : s;
          this._cache.setMaxSize(a);
        }
      }, {
        key: "handleWrapJump",
        value: function handleWrapJump(t) {
          var e = Math.round((t - (void 0 === this._prevLng ? t : this._prevLng)) / 360);
          if (this._prevLng = t, e) {
            var _t290 = {};
            for (var _r244 in this._tiles) {
              var _n177 = this._tiles[_r244];
              _n177.tileID = _n177.tileID.unwrapTo(_n177.tileID.wrap + e), _t290[_n177.tileID.key] = _n177;
            }
            this._tiles = _t290;
            for (var _t291 in this._timers) clearTimeout(this._timers[_t291]), delete this._timers[_t291];
            for (var _t292 in this._tiles) this._setTileReloadTimer(+_t292, this._tiles[_t292]);
          }
        }
      }, {
        key: "update",
        value: function update(t, e, r, n) {
          if (this.transform = t, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
          if (this.usedForTerrain && !r) return;
          this.updateCacheSize(t, e), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {};
          var i = "batched-model" === this._source.type;
          var s;
          if (this.used || this.usedForTerrain) {
            if (this._source.tileID) s = t.getVisibleUnwrappedCoordinates(this._source.tileID).map(function (t) {
              return new Sc(t.canonical.z, t.wrap, t.canonical.z, t.canonical.x, t.canonical.y);
            });else if (0 !== this.tileCoverLift) {
              var _n178 = t.clone();
              _n178.tileCoverLift = this.tileCoverLift, s = _n178.coveringTiles({
                tileSize: e || this._source.tileSize,
                minzoom: this._source.minzoom,
                maxzoom: this._source.maxzoom,
                roundZoom: this._source.roundZoom && !r,
                reparseOverscaled: this._source.reparseOverscaled,
                isTerrainDEM: this.usedForTerrain,
                calculateQuadrantVisibility: i
              }), this._source.minzoom <= 1 && "globe" === t.projection.name && (s.push(new Sc(1, 0, 1, 0, 0)), s.push(new Sc(1, 0, 1, 1, 0)), s.push(new Sc(1, 0, 1, 0, 1)), s.push(new Sc(1, 0, 1, 1, 1)));
            } else if (s = t.coveringTiles({
              tileSize: e || this._source.tileSize,
              minzoom: this._source.minzoom,
              maxzoom: this._source.maxzoom,
              roundZoom: this._source.roundZoom && !r,
              reparseOverscaled: this._source.reparseOverscaled,
              isTerrainDEM: this.usedForTerrain,
              calculateQuadrantVisibility: i
            }), this._source.hasTile) {
              var _t293 = this._source.hasTile.bind(this._source);
              s = s.filter(function (e) {
                return _t293(e);
              });
            }
          } else s = [];
          if (s.length > 0 && this.castsShadows && n && "globe" !== this.transform.projection.name && !this.usedForTerrain && !ub(this._source.type)) {
            var _a111 = t.coveringZoomLevel({
                tileSize: e || this._source.tileSize,
                roundZoom: this._source.roundZoom && !r
              }),
              _o81 = Math.min(_a111, this._source.maxzoom);
            if (i) {
              var _e291 = t.extendTileCover(s, _o81);
              var _iterator188 = _createForOfIteratorHelper(_e291),
                _step188;
              try {
                for (_iterator188.s(); !(_step188 = _iterator188.n()).done;) {
                  var _t294 = _step188.value;
                  s.push(_t294);
                }
              } catch (err) {
                _iterator188.e(err);
              } finally {
                _iterator188.f();
              }
            } else {
              var _e292 = t.extendTileCover(s, _o81, n);
              var _iterator189 = _createForOfIteratorHelper(_e292),
                _step189;
              try {
                for (_iterator189.s(); !(_step189 = _iterator189.n()).done;) {
                  var _t295 = _step189.value;
                  this._shadowCasterTiles[_t295.key] = !0, s.push(_t295);
                }
              } catch (err) {
                _iterator189.e(err);
              } finally {
                _iterator189.f();
              }
            }
          }
          var a = this._updateRetainedTiles(s);
          if (ub(this._source.type) && 0 !== s.length) {
            var _t296 = {},
              _e293 = {},
              _r245 = Object.keys(a);
            for (var _i181 = 0, _r246 = _r245; _i181 < _r246.length; _i181++) {
              var _n179 = _r246[_i181];
              var _r247 = a[_n179],
                _i182 = this._tiles[_n179];
              if (!_i182 || _i182.fadeEndTime && _i182.fadeEndTime <= Rr.now()) continue;
              var _s139 = this.findLoadedParent(_r247, Math.max(_r247.overscaledZ - ob.maxOverzooming, this._source.minzoom));
              _s139 && (this._addTile(_s139.tileID), _t296[_s139.tileID.key] = _s139.tileID), _e293[_n179] = _r247;
            }
            var _n180 = s[s.length - 1].overscaledZ;
            for (var _t297 in this._tiles) {
              var _r248 = this._tiles[_t297];
              if (a[_t297] || !_r248.hasData()) continue;
              var _i183 = _r248.tileID;
              for (; _i183.overscaledZ > _n180;) {
                _i183 = _i183.scaledTo(_i183.overscaledZ - 1);
                var _n181 = this._tiles[_i183.key];
                if (_n181 && _n181.hasData() && _e293[_i183.key]) {
                  a[_t297] = _r248.tileID;
                  break;
                }
              }
            }
            for (var _e294 in _t296) a[_e294] || (this._coveredTiles[_e294] = !0, a[_e294] = _t296[_e294]);
          }
          for (var _t298 in a) this._tiles[_t298].clearFadeHold();
          var o = function (t, e) {
            var r = [];
            for (var _n182 in t) _n182 in e || r.push(_n182);
            return r;
          }(this._tiles, a);
          var _iterator190 = _createForOfIteratorHelper(o),
            _step190;
          try {
            for (_iterator190.s(); !(_step190 = _iterator190.n()).done;) {
              var _t299 = _step190.value;
              var _e295 = this._tiles[_t299];
              _e295.hasSymbolBuckets && !_e295.holdingForFade() ? _e295.setHoldDuration(this.map._fadeDuration) : _e295.hasSymbolBuckets && !_e295.symbolFadeFinished() || this._removeTile(+_t299);
            }
          } catch (err) {
            _iterator190.e(err);
          } finally {
            _iterator190.f();
          }
          this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
        }
      }, {
        key: "releaseSymbolFadeTiles",
        value: function releaseSymbolFadeTiles() {
          for (var _t300 in this._tiles) this._tiles[_t300].holdingForFade() && this._removeTile(+_t300);
        }
      }, {
        key: "_updateRetainedTiles",
        value: function _updateRetainedTiles(t) {
          var e = {};
          if (0 === t.length) return e;
          var r = {},
            n = t.reduce(function (t, e) {
              return Math.min(t, e.overscaledZ);
            }, 1 / 0),
            i = t[0].overscaledZ,
            s = Math.max(i - ob.maxOverzooming, this._source.minzoom),
            a = Math.max(i + ob.maxUnderzooming, this._source.minzoom),
            o = {};
          var _iterator191 = _createForOfIteratorHelper(t),
            _step191;
          try {
            for (_iterator191.s(); !(_step191 = _iterator191.n()).done;) {
              var _r249 = _step191.value;
              var _t301 = this._addTile(_r249);
              e[_r249.key] = _r249, _t301.hasData() || n < this._source.maxzoom && (o[_r249.key] = _r249);
            }
          } catch (err) {
            _iterator191.e(err);
          } finally {
            _iterator191.f();
          }
          this._retainLoadedChildren(o, n, a, e);
          var _iterator192 = _createForOfIteratorHelper(t),
            _step192;
          try {
            for (_iterator192.s(); !(_step192 = _iterator192.n()).done;) {
              var _n183 = _step192.value;
              var _t302 = this._tiles[_n183.key];
              if (_t302.hasData()) continue;
              if (_n183.canonical.z >= this._source.maxzoom) {
                var _t303 = _n183.children(this._source.maxzoom)[0],
                  _r250 = this.getTile(_t303);
                if (_r250 && _r250.hasData()) {
                  e[_t303.key] = _t303;
                  continue;
                }
              } else {
                var _t304 = _n183.children(this._source.maxzoom);
                if (e[_t304[0].key] && e[_t304[1].key] && e[_t304[2].key] && e[_t304[3].key]) continue;
              }
              var _i184 = _t302.wasRequested();
              for (var _a112 = _n183.overscaledZ - 1; _a112 >= s; --_a112) {
                var _s140 = _n183.scaledTo(_a112);
                if (r[_s140.key]) break;
                if (r[_s140.key] = !0, _t302 = this.getTile(_s140), !_t302 && _i184 && (_t302 = this._addTile(_s140)), _t302 && (e[_s140.key] = _s140, _i184 = _t302.wasRequested(), _t302.hasData())) break;
              }
            }
          } catch (err) {
            _iterator192.e(err);
          } finally {
            _iterator192.f();
          }
          return e;
        }
      }, {
        key: "_updateLoadedParentTileCache",
        value: function _updateLoadedParentTileCache() {
          this._loadedParentTiles = {};
          for (var _t305 in this._tiles) {
            var _e296 = [];
            var _r251 = void 0,
              _n184 = this._tiles[_t305].tileID;
            for (; _n184.overscaledZ > 0;) {
              if (_n184.key in this._loadedParentTiles) {
                _r251 = this._loadedParentTiles[_n184.key];
                break;
              }
              _e296.push(_n184.key);
              var _t306 = _n184.scaledTo(_n184.overscaledZ - 1);
              if (_r251 = this._getLoadedTile(_t306), _r251) break;
              _n184 = _t306;
            }
            for (var _i185 = 0, _e297 = _e296; _i185 < _e297.length; _i185++) {
              var _t307 = _e297[_i185];
              this._loadedParentTiles[_t307] = _r251;
            }
          }
        }
      }, {
        key: "_addTile",
        value: function _addTile(t) {
          var e = this._tiles[t.key];
          if (e) return !0 !== e.isExtraShadowCaster || !!this._shadowCasterTiles[t.key] || this._reloadTile(t.key, "reloading"), e;
          e = this._cache.getAndRemove(t), e && (this._setTileReloadTimer(t.key, e), e.tileID = t, this._state.initializeTileState(e, this.map ? this.map.painter : null), this._cacheTimers[t.key] && (clearTimeout(this._cacheTimers[t.key]), delete this._cacheTimers[t.key], this._setTileReloadTimer(t.key, e)));
          var r = Boolean(e);
          if (!r) {
            var _r252 = this.map ? this.map.painter : null,
              _n185 = this._source.tileSize * t.overscaleFactor();
            e = "raster-array" === this._source.type ? new sb(t, _n185, this.transform.tileZoom, _r252, this._isRaster) : new cx(t, _n185, this.transform.tileZoom, _r252, this._isRaster), this._loadTile(e, this._tileLoaded.bind(this, e, t.key, e.state));
          }
          return e ? (e.uses++, this._tiles[t.key] = e, r || this._source.fire(new Cn("dataloading", {
            tile: e,
            coord: e.tileID,
            dataType: "source"
          })), e) : null;
        }
      }, {
        key: "_setTileReloadTimer",
        value: function _setTileReloadTimer(t, e) {
          var _this49 = this;
          t in this._timers && (clearTimeout(this._timers[t]), delete this._timers[t]);
          var r = e.getExpiryTimeout();
          r && (this._timers[t] = setTimeout(function () {
            _this49._reloadTile(t, "expired"), delete _this49._timers[t];
          }, r));
        }
      }, {
        key: "_removeTile",
        value: function _removeTile(t) {
          var e = this._tiles[t];
          e && (e.uses--, delete this._tiles[t], this._timers[t] && (clearTimeout(this._timers[t]), delete this._timers[t]), e.uses > 0 || (e.hasData() && "reloading" !== e.state || "empty" === e.state ? this._cache.add(e.tileID, e, e.getExpiryTimeout()) : (e.aborted = !0, this._abortTile(e), this._unloadTile(e))));
        }
      }, {
        key: "clearTiles",
        value: function clearTiles() {
          this._shouldReloadOnResume = !1, this._paused = !1;
          for (var _t308 in this._tiles) this._removeTile(+_t308);
          this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
        }
      }, {
        key: "tilesIn",
        value: function tilesIn(t, e, r) {
          var n = [],
            i = this.transform;
          if (!i) return n;
          var s = "globe" === i.projection.name,
            a = Ec(i.center.lng);
          for (var _o82 in this._tiles) {
            var _l64 = this._tiles[_o82];
            if (r && _l64.clearQueryDebugViz(), _l64.holdingForFade()) continue;
            var _u53 = void 0;
            if (s) {
              var _t309 = _l64.tileID.canonical;
              if (0 === _t309.z) {
                var _e298 = [Math.abs(We.apply(void 0, [a].concat(_toConsumableArray(cb(_t309, -1)))) - a), Math.abs(We.apply(void 0, [a].concat(_toConsumableArray(cb(_t309, 1)))) - a)];
                _u53 = [0, 2 * _e298.indexOf(Math.min.apply(Math, _e298)) - 1];
              } else {
                var _e299 = [Math.abs(We.apply(void 0, [a].concat(_toConsumableArray(cb(_t309, -1)))) - a), Math.abs(We.apply(void 0, [a].concat(_toConsumableArray(cb(_t309, 0)))) - a), Math.abs(We.apply(void 0, [a].concat(_toConsumableArray(cb(_t309, 1)))) - a)];
                _u53 = [_e299.indexOf(Math.min.apply(Math, _e299)) - 1];
              }
            } else _u53 = [0];
            var _iterator193 = _createForOfIteratorHelper(_u53),
              _step193;
            try {
              for (_iterator193.s(); !(_step193 = _iterator193.n()).done;) {
                var _r253 = _step193.value;
                var _s141 = t.containsTile(_l64, i, e, _r253);
                _s141 && n.push(_s141);
              }
            } catch (err) {
              _iterator193.e(err);
            } finally {
              _iterator193.f();
            }
          }
          return n;
        }
      }, {
        key: "getShadowCasterCoordinates",
        value: function getShadowCasterCoordinates() {
          return this._getRenderableCoordinates(!1, !0);
        }
      }, {
        key: "getVisibleCoordinates",
        value: function getVisibleCoordinates(t) {
          return this._getRenderableCoordinates(t);
        }
      }, {
        key: "_getRenderableCoordinates",
        value: function _getRenderableCoordinates(t, e) {
          var _this50 = this;
          var r = this.getRenderableIds(t, e).map(function (t) {
              return _this50._tiles[t].tileID;
            }),
            n = "globe" === this.transform.projection.name;
          var _iterator194 = _createForOfIteratorHelper(r),
            _step194;
          try {
            for (_iterator194.s(); !(_step194 = _iterator194.n()).done;) {
              var _t310 = _step194.value;
              _t310.projMatrix = this.transform.calculateProjMatrix(_t310.toUnwrapped()), _t310.expandedProjMatrix = n ? this.transform.calculateProjMatrix(_t310.toUnwrapped(), !1, !0) : _t310.projMatrix;
            }
          } catch (err) {
            _iterator194.e(err);
          } finally {
            _iterator194.f();
          }
          return r;
        }
      }, {
        key: "sortCoordinatesByDistance",
        value: function sortCoordinatesByDistance(t) {
          var e = t.slice(),
            r = this.transform._camera.position,
            n = this.transform._camera.forward(),
            i = {};
          var _iterator195 = _createForOfIteratorHelper(e),
            _step195;
          try {
            for (_iterator195.s(); !(_step195 = _iterator195.n()).done;) {
              var _t311 = _step195.value;
              var _e300 = 1 / (1 << _t311.canonical.z);
              i[_t311.key] = ((_t311.canonical.x + .5) * _e300 + _t311.wrap - r[0]) * n[0] + ((_t311.canonical.y + .5) * _e300 - r[1]) * n[1] - r[2] * n[2];
            }
          } catch (err) {
            _iterator195.e(err);
          } finally {
            _iterator195.f();
          }
          return e.sort(function (t, e) {
            return i[t.key] - i[e.key];
          }), e;
        }
      }, {
        key: "hasTransition",
        value: function hasTransition() {
          if (this._source.hasTransition()) return !0;
          if (ub(this._source.type)) for (var _t312 in this._tiles) {
            var _e301 = this._tiles[_t312];
            if (void 0 !== _e301.fadeEndTime && _e301.fadeEndTime >= Rr.now()) return !0;
          }
          return !1;
        }
      }, {
        key: "setFeatureState",
        value: function setFeatureState(t, e, r) {
          this._state.updateState(t = t || "_geojsonTileLayer", e, r);
        }
      }, {
        key: "removeFeatureState",
        value: function removeFeatureState(t, e, r) {
          this._state.removeFeatureState(t = t || "_geojsonTileLayer", e, r);
        }
      }, {
        key: "getFeatureState",
        value: function getFeatureState(t, e) {
          return this._state.getState(t = t || "_geojsonTileLayer", e);
        }
      }, {
        key: "setDependencies",
        value: function setDependencies(t, e, r) {
          var n = this._tiles[t];
          n && n.setDependencies(e, r);
        }
      }, {
        key: "reloadTilesForDependencies",
        value: function reloadTilesForDependencies(t, e) {
          for (var _r254 in this._tiles) this._tiles[_r254].hasDependency(t, e) && this._reloadTile(+_r254, "reloading");
          this._cache.filter(function (r) {
            return !r.hasDependency(t, e);
          });
        }
      }, {
        key: "_preloadTiles",
        value: function _preloadTiles(t, e) {
          var _this51 = this;
          if (!this._sourceLoaded) {
            var _r255 = function _r255() {
              _this51._sourceLoaded && (_this51._source.off("data", _r255), _this51._preloadTiles(t, e));
            };
            return void this._source.on("data", _r255);
          }
          var r = new Map(),
            n = Array.isArray(t) ? t : [t],
            i = this.map.painter.terrain,
            s = this.usedForTerrain && i ? i.getScaledDemTileSize() : this._source.tileSize;
          var _iterator196 = _createForOfIteratorHelper(n),
            _step196;
          try {
            for (_iterator196.s(); !(_step196 = _iterator196.n()).done;) {
              var _t313 = _step196.value;
              var _e302 = _t313.coveringTiles({
                tileSize: s,
                minzoom: this._source.minzoom,
                maxzoom: this._source.maxzoom,
                roundZoom: this._source.roundZoom && !this.usedForTerrain,
                reparseOverscaled: this._source.reparseOverscaled,
                isTerrainDEM: this.usedForTerrain
              });
              var _iterator197 = _createForOfIteratorHelper(_e302),
                _step197;
              try {
                for (_iterator197.s(); !(_step197 = _iterator197.n()).done;) {
                  var _t314 = _step197.value;
                  r.set(_t314.key, _t314);
                }
              } catch (err) {
                _iterator197.e(err);
              } finally {
                _iterator197.f();
              }
              this.usedForTerrain && _t313.updateElevation(!1);
            }
          } catch (err) {
            _iterator196.e(err);
          } finally {
            _iterator196.f();
          }
          tr(Array.from(r.values()), function (t, e) {
            var r = new cx(t, _this51._source.tileSize * t.overscaleFactor(), _this51.transform.tileZoom, _this51.map.painter, _this51._isRaster);
            _this51._loadTile(r, function (t) {
              "raster-dem" === _this51._source.type && r.dem && _this51._backfillDEM(r), e(t, r);
            });
          }, e);
        }
      }]);
      return ob;
    }(On);
    function lb(t, e) {
      var r = Math.abs(2 * t.wrap) - +(t.wrap < 0),
        n = Math.abs(2 * e.wrap) - +(e.wrap < 0);
      return t.overscaledZ - e.overscaledZ || n - r || e.canonical.y - t.canonical.y || e.canonical.x - t.canonical.x;
    }
    function ub(t) {
      return "raster" === t || "image" === t || "video" === t || "custom" === t;
    }
    function cb(t, e) {
      var r = 1 << t.z;
      return [t.x / r + e, (t.x + 1) / r + e];
    }
    ob.maxOverzooming = 10, ob.maxUnderzooming = 3;
    var hb = function hb() {
      return eb || (eb = {
        layout: um || (um = new ul({
          "line-cap": new ol(cl.layout_line["line-cap"]),
          "line-join": new ol(cl.layout_line["line-join"]),
          "line-miter-limit": new al(cl.layout_line["line-miter-limit"]),
          "line-round-limit": new al(cl.layout_line["line-round-limit"]),
          "line-sort-key": new ol(cl.layout_line["line-sort-key"]),
          "line-z-offset": new ol(cl.layout_line["line-z-offset"]),
          visibility: new al(cl.layout_line.visibility)
        })),
        paint: cm || (cm = new ul({
          "line-opacity": new ol(cl.paint_line["line-opacity"]),
          "line-color": new ol(cl.paint_line["line-color"]),
          "line-translate": new al(cl.paint_line["line-translate"]),
          "line-translate-anchor": new al(cl.paint_line["line-translate-anchor"]),
          "line-width": new ol(cl.paint_line["line-width"]),
          "line-gap-width": new ol(cl.paint_line["line-gap-width"]),
          "line-offset": new ol(cl.paint_line["line-offset"]),
          "line-blur": new ol(cl.paint_line["line-blur"]),
          "line-dasharray": new ol(cl.paint_line["line-dasharray"]),
          "line-pattern": new ol(cl.paint_line["line-pattern"]),
          "line-gradient": new ll(cl.paint_line["line-gradient"]),
          "line-trim-offset": new al(cl.paint_line["line-trim-offset"]),
          "line-trim-fade-range": new al(cl.paint_line["line-trim-fade-range"]),
          "line-trim-color": new al(cl.paint_line["line-trim-color"]),
          "line-emissive-strength": new al(cl.paint_line["line-emissive-strength"]),
          "line-border-width": new ol(cl.paint_line["line-border-width"]),
          "line-border-color": new ol(cl.paint_line["line-border-color"]),
          "line-occlusion-opacity": new al(cl.paint_line["line-occlusion-opacity"])
        }))
      }, eb);
    };
    var pb = /*#__PURE__*/function (_ol) {
      _inherits(pb, _ol);
      var _super78 = _createSuper(pb);
      function pb() {
        _classCallCheck(this, pb);
        return _super78.apply(this, arguments);
      }
      _createClass(pb, [{
        key: "possiblyEvaluate",
        value: function possiblyEvaluate(t, e) {
          return e = new Wo(Math.floor(e.zoom), {
            now: e.now,
            fadeDuration: e.fadeDuration,
            transition: e.transition
          }), _get(_getPrototypeOf(pb.prototype), "possiblyEvaluate", this).call(this, t, e);
        }
      }, {
        key: "evaluate",
        value: function evaluate(t, e, r, n) {
          return e = rr({}, e, {
            zoom: Math.floor(e.zoom)
          }), _get(_getPrototypeOf(pb.prototype), "evaluate", this).call(this, t, e, r, n);
        }
      }]);
      return pb;
    }(ol);
    var fb, db, mb, yb;
    function gb(t, e) {
      return e > 0 ? e + 2 * t : t;
    }
    var xb = /*#__PURE__*/function () {
      function xb(t) {
        _classCallCheck(this, xb);
        this.type = t.property.overrides ? t.property.overrides.runtimeType : Qn, this.defaultValue = t;
      }
      _createClass(xb, [{
        key: "evaluate",
        value: function evaluate(t) {
          if (t.formattedSection) {
            var _e303 = this.defaultValue.property.overrides;
            if (_e303 && _e303.hasOverride(t.formattedSection)) return _e303.getOverride(t.formattedSection);
          }
          return t.feature && t.featureState ? this.defaultValue.evaluate(t.feature, t.featureState) : this.defaultValue.property.specification.default;
        }
      }, {
        key: "eachChild",
        value: function eachChild(t) {
          this.defaultValue.isConstant() || t(this.defaultValue.value._styleExpression.expression);
        }
      }, {
        key: "outputDefined",
        value: function outputDefined() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return null;
        }
      }]);
      return xb;
    }();
    So(xb, "FormatSectionOverride", {
      omit: ["defaultValue"]
    });
    var bb = function bb() {
      return yb || (yb = {
        layout: db || (db = new ul({
          "symbol-placement": new al(cl.layout_symbol["symbol-placement"]),
          "symbol-spacing": new al(cl.layout_symbol["symbol-spacing"]),
          "symbol-avoid-edges": new al(cl.layout_symbol["symbol-avoid-edges"]),
          "symbol-sort-key": new ol(cl.layout_symbol["symbol-sort-key"]),
          "symbol-z-order": new al(cl.layout_symbol["symbol-z-order"]),
          "symbol-z-elevate": new al(cl.layout_symbol["symbol-z-elevate"]),
          "icon-allow-overlap": new al(cl.layout_symbol["icon-allow-overlap"]),
          "icon-ignore-placement": new al(cl.layout_symbol["icon-ignore-placement"]),
          "icon-optional": new al(cl.layout_symbol["icon-optional"]),
          "icon-rotation-alignment": new al(cl.layout_symbol["icon-rotation-alignment"]),
          "icon-size": new ol(cl.layout_symbol["icon-size"]),
          "icon-text-fit": new ol(cl.layout_symbol["icon-text-fit"]),
          "icon-text-fit-padding": new ol(cl.layout_symbol["icon-text-fit-padding"]),
          "icon-image": new ol(cl.layout_symbol["icon-image"]),
          "icon-rotate": new ol(cl.layout_symbol["icon-rotate"]),
          "icon-padding": new al(cl.layout_symbol["icon-padding"]),
          "icon-keep-upright": new al(cl.layout_symbol["icon-keep-upright"]),
          "icon-offset": new ol(cl.layout_symbol["icon-offset"]),
          "icon-anchor": new ol(cl.layout_symbol["icon-anchor"]),
          "icon-pitch-alignment": new al(cl.layout_symbol["icon-pitch-alignment"]),
          "text-pitch-alignment": new al(cl.layout_symbol["text-pitch-alignment"]),
          "text-rotation-alignment": new al(cl.layout_symbol["text-rotation-alignment"]),
          "text-field": new ol(cl.layout_symbol["text-field"]),
          "text-font": new ol(cl.layout_symbol["text-font"]),
          "text-size": new ol(cl.layout_symbol["text-size"]),
          "text-max-width": new ol(cl.layout_symbol["text-max-width"]),
          "text-line-height": new ol(cl.layout_symbol["text-line-height"]),
          "text-letter-spacing": new ol(cl.layout_symbol["text-letter-spacing"]),
          "text-justify": new ol(cl.layout_symbol["text-justify"]),
          "text-radial-offset": new ol(cl.layout_symbol["text-radial-offset"]),
          "text-variable-anchor": new al(cl.layout_symbol["text-variable-anchor"]),
          "text-anchor": new ol(cl.layout_symbol["text-anchor"]),
          "text-max-angle": new al(cl.layout_symbol["text-max-angle"]),
          "text-writing-mode": new al(cl.layout_symbol["text-writing-mode"]),
          "text-rotate": new ol(cl.layout_symbol["text-rotate"]),
          "text-padding": new al(cl.layout_symbol["text-padding"]),
          "text-keep-upright": new al(cl.layout_symbol["text-keep-upright"]),
          "text-transform": new ol(cl.layout_symbol["text-transform"]),
          "text-offset": new ol(cl.layout_symbol["text-offset"]),
          "text-allow-overlap": new al(cl.layout_symbol["text-allow-overlap"]),
          "text-ignore-placement": new al(cl.layout_symbol["text-ignore-placement"]),
          "text-optional": new al(cl.layout_symbol["text-optional"]),
          visibility: new al(cl.layout_symbol.visibility)
        })),
        paint: mb || (mb = new ul({
          "icon-opacity": new ol(cl.paint_symbol["icon-opacity"]),
          "icon-occlusion-opacity": new ol(cl.paint_symbol["icon-occlusion-opacity"]),
          "icon-emissive-strength": new ol(cl.paint_symbol["icon-emissive-strength"]),
          "text-emissive-strength": new ol(cl.paint_symbol["text-emissive-strength"]),
          "icon-color": new ol(cl.paint_symbol["icon-color"]),
          "icon-halo-color": new ol(cl.paint_symbol["icon-halo-color"]),
          "icon-halo-width": new ol(cl.paint_symbol["icon-halo-width"]),
          "icon-halo-blur": new ol(cl.paint_symbol["icon-halo-blur"]),
          "icon-translate": new al(cl.paint_symbol["icon-translate"]),
          "icon-translate-anchor": new al(cl.paint_symbol["icon-translate-anchor"]),
          "icon-image-cross-fade": new ol(cl.paint_symbol["icon-image-cross-fade"]),
          "text-opacity": new ol(cl.paint_symbol["text-opacity"]),
          "text-occlusion-opacity": new ol(cl.paint_symbol["text-occlusion-opacity"]),
          "text-color": new ol(cl.paint_symbol["text-color"], {
            runtimeType: ni,
            getOverride: function getOverride(t) {
              return t.textColor;
            },
            hasOverride: function hasOverride(t) {
              return !!t.textColor;
            }
          }),
          "text-halo-color": new ol(cl.paint_symbol["text-halo-color"]),
          "text-halo-width": new ol(cl.paint_symbol["text-halo-width"]),
          "text-halo-blur": new ol(cl.paint_symbol["text-halo-blur"]),
          "text-translate": new al(cl.paint_symbol["text-translate"]),
          "text-translate-anchor": new al(cl.paint_symbol["text-translate-anchor"]),
          "icon-color-saturation": new al(cl.paint_symbol["icon-color-saturation"]),
          "icon-color-contrast": new al(cl.paint_symbol["icon-color-contrast"]),
          "icon-color-brightness-min": new al(cl.paint_symbol["icon-color-brightness-min"]),
          "icon-color-brightness-max": new al(cl.paint_symbol["icon-color-brightness-max"])
        }))
      }, yb);
    };
    var vb = /*#__PURE__*/function (_zl) {
      _inherits(vb, _zl);
      var _super79 = _createSuper(vb);
      function vb(e, r, n, i) {
        var _this52;
        _classCallCheck(this, vb);
        _this52 = _super79.call(this, e, bb(), r, n, i), _this52._colorAdjustmentMatrix = t.ae.identity([]), _this52.hasInitialOcclusionOpacityProperties = void 0 !== e.paint && ("icon-occlusion-opacity" in e.paint || "text-occlusion-opacity" in e.paint);
        return _this52;
      }
      _createClass(vb, [{
        key: "recalculate",
        value: function recalculate(t, e) {
          _get(_getPrototypeOf(vb.prototype), "recalculate", this).call(this, t, e), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
          var r = this.layout.get("text-writing-mode");
          if (r) {
            var _t315 = [];
            var _iterator198 = _createForOfIteratorHelper(r),
              _step198;
            try {
              for (_iterator198.s(); !(_step198 = _iterator198.n()).done;) {
                var _e304 = _step198.value;
                _t315.indexOf(_e304) < 0 && _t315.push(_e304);
              }
            } catch (err) {
              _iterator198.e(err);
            } finally {
              _iterator198.f();
            }
            this.layout._values["text-writing-mode"] = _t315;
          } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? ["horizontal"] : ["horizontal", "vertical"];
          this._setPaintOverrides();
        }
      }, {
        key: "getColorAdjustmentMatrix",
        value: function getColorAdjustmentMatrix(e, r, n, i) {
          return this._saturation === e && this._contrast === r && this._brightnessMin === n && this._brightnessMax === i || (this._colorAdjustmentMatrix = function (e, r, n, i) {
            e = Br(e), r = Er(r);
            var s = t.ae.create(),
              a = e / 3,
              o = 1 - 2 * a,
              l = [o, a, a, 0, a, o, a, 0, a, a, o, 0, 0, 0, 0, 1],
              u = .5 - .5 * r,
              c = i - n;
            return t.ae.multiply(s, [c, 0, 0, 0, 0, c, 0, 0, 0, 0, c, 0, n, n, n, 1], [r, 0, 0, 0, 0, r, 0, 0, 0, 0, r, 0, u, u, u, 1]), t.ae.multiply(s, s, l), s;
          }(e, r, n, i), this._saturation = e, this._contrast = r, this._brightnessMin = n, this._brightnessMax = i), this._colorAdjustmentMatrix;
        }
      }, {
        key: "getValueAndResolveTokens",
        value: function getValueAndResolveTokens(t, e, r, n) {
          var i = this.layout.get(t).evaluate(e, {}, r, n),
            s = this._unevaluatedLayout._values[t];
          return s.isDataDriven() || po(s.value) || !i ? i : function (t, e) {
            return e.replace(/{([^{}]+)}/g, function (e, r) {
              return r in t ? String(t[r]) : "";
            });
          }(e.properties, i);
        }
      }, {
        key: "createBucket",
        value: function createBucket(t) {
          return new Ng(t);
        }
      }, {
        key: "queryRadius",
        value: function queryRadius() {
          return 0;
        }
      }, {
        key: "queryIntersectsFeature",
        value: function queryIntersectsFeature() {
          return !1;
        }
      }, {
        key: "_setPaintOverrides",
        value: function _setPaintOverrides() {
          var _iterator199 = _createForOfIteratorHelper(bb().paint.overridableProperties),
            _step199;
          try {
            for (_iterator199.s(); !(_step199 = _iterator199.n()).done;) {
              var _t316 = _step199.value;
              if (!vb.hasPaintOverride(this.layout, _t316)) continue;
              var _e305 = this.paint.get(_t316),
                _r256 = new xb(_e305),
                _n186 = new ho(_r256, _e305.property.specification, this.scope, this.options);
              var _i186 = null;
              _i186 = "constant" === _e305.value.kind || "source" === _e305.value.kind ? new mo("source", _n186) : new yo("composite", _n186, _e305.value.zoomStops, _e305.value._interpolationType), this.paint._values[_t316] = new il(_e305.property, _i186, _e305.parameters);
            }
          } catch (err) {
            _iterator199.e(err);
          } finally {
            _iterator199.f();
          }
        }
      }, {
        key: "_handleOverridablePaintPropertyUpdate",
        value: function _handleOverridablePaintPropertyUpdate(t, e, r) {
          return !(!this.layout || e.isDataDriven() || r.isDataDriven()) && vb.hasPaintOverride(this.layout, t);
        }
      }, {
        key: "getProgramIds",
        value: function getProgramIds() {
          var t = 0 !== this.paint.get("icon-opacity").constantOr(1),
            e = 0 !== this.paint.get("text-opacity").constantOr(1),
            r = [];
          return t && r.push("symbolIcon"), e && r.push("symbolSDF"), r;
        }
      }, {
        key: "getDefaultProgramParams",
        value: function getDefaultProgramParams(t, e, r) {
          return {
            config: new tc(this, {
              zoom: e,
              lut: r
            }),
            overrideFog: !1
          };
        }
      }], [{
        key: "hasPaintOverride",
        value: function hasPaintOverride(t, e) {
          var r = t.get("text-field"),
            n = bb().paint.properties[e];
          var i = !1;
          var s = function s(t) {
            var _iterator200 = _createForOfIteratorHelper(t),
              _step200;
            try {
              for (_iterator200.s(); !(_step200 = _iterator200.n()).done;) {
                var _e306 = _step200.value;
                if (n.overrides && n.overrides.hasOverride(_e306)) return void (i = !0);
              }
            } catch (err) {
              _iterator200.e(err);
            } finally {
              _iterator200.f();
            }
          };
          if ("constant" === r.value.kind && r.value.value instanceof gi) s(r.value.value.sections);else if ("source" === r.value.kind) {
            var _t317 = function _t317(e) {
                i || (e instanceof Mi && _i(e.value) === oi ? s(e.value.sections) : e instanceof Ti ? s(e.sections) : e.eachChild(_t317));
              },
              _e307 = r.value;
            _e307._styleExpression && _t317(_e307._styleExpression.expression);
          }
          return i;
        }
      }]);
      return vb;
    }(zl);
    var _b, wb, Mb, Ab;
    function Sb(e, r, n, i, s, a, o, l) {
      var u = [e, r, 1, n, i, 1, s, a, 1],
        c = [o, l, 1],
        h = t.bE.adjoint([], u),
        _t$$$transformMat = t.$.transformMat3(c, c, h),
        _t$$$transformMat2 = _slicedToArray(_t$$$transformMat, 3),
        p = _t$$$transformMat2[0],
        f = _t$$$transformMat2[1],
        d = _t$$$transformMat2[2];
      return t.bE.multiply(u, u, [p, 0, 0, 0, f, 0, 0, 0, d]);
    }
    function Ib(e, r, n, i, s, a, o, l) {
      var u = function (e, r, n, i, s, a, o, l) {
        var u = Sb(0, 0, 1, 0, 1, 1, 0, 1),
          c = Sb(e, r, n, i, s, a, o, l),
          h = t.bE.adjoint([], u);
        return t.bE.multiply(c, c, h);
      }(e, r, n, i, s, a, o, l);
      return [u[2] / u[8] / ds, u[5] / u[8] / ds];
    }
    function Tb(t) {
      return [t[0], Math.min(Math.max(t[1], -Vc), Vc)];
    }
    var kb = /*#__PURE__*/function (_On3) {
      _inherits(kb, _On3);
      var _super80 = _createSuper(kb);
      function kb(t, e, r, n) {
        var _this53;
        _classCallCheck(this, kb);
        _this53 = _super80.call(this), _this53.id = t, _this53.dispatcher = r, _this53.coordinates = e.coordinates, _this53.type = "image", _this53.minzoom = 0, _this53.maxzoom = 22, _this53.tileSize = 512, _this53.tiles = {}, _this53._loaded = !1, _this53.onNorthPole = !1, _this53.onSouthPole = !1, _this53.setEventedParent(n), _this53.options = e, _this53._dirty = !1;
        return _this53;
      }
      _createClass(kb, [{
        key: "load",
        value: function load(t, e) {
          var _this54 = this;
          if (this._loaded = e || !1, this.fire(new Cn("dataloading", {
            dataType: "source"
          })), this.url = this.options.url, !this.url) return t && (this.coordinates = t), this._loaded = !0, void this._finishLoading();
          this._imageRequest = un(this.map._requestManager.transformRequest(this.url, Qr.Image), function (e, r) {
            _this54._imageRequest = null, _this54._loaded = !0, e ? _this54.fire(new Ln(e)) : r && (_this54.image = r instanceof HTMLImageElement ? Rr.getImageData(r) : r, _this54._dirty = !0, _this54.width = _this54.image.width, _this54.height = _this54.image.height, t && (_this54.coordinates = t), _this54._finishLoading());
          });
        }
      }, {
        key: "loaded",
        value: function loaded() {
          return this._loaded;
        }
      }, {
        key: "updateImage",
        value: function updateImage(t) {
          return t.url ? (this._imageRequest && t.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = t.url, this.load(t.coordinates, this._loaded), this) : this;
        }
      }, {
        key: "setTexture",
        value: function setTexture(t) {
          if (!(t.handle instanceof WebGLTexture)) throw new Error("The provided handle is not a WebGLTexture instance");
          return this.texture = new qg(this.map.painter.context, t.handle), this.width = t.dimensions[0], this.height = t.dimensions[1], this._dirty = !1, this._loaded = !0, this._finishLoading(), this;
        }
      }, {
        key: "_finishLoading",
        value: function _finishLoading() {
          this.map && (this.setCoordinates(this.coordinates), this.fire(new Cn("data", {
            dataType: "source",
            sourceDataType: "metadata"
          })));
        }
      }, {
        key: "onAdd",
        value: function onAdd(t) {
          this.map = t, this.load();
        }
      }, {
        key: "onRemove",
        value: function onRemove(t) {
          this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), !this.texture || this.texture instanceof qg || this.texture.destroy(), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy());
        }
      }, {
        key: "setCoordinates",
        value: function setCoordinates(t) {
          if (this.coordinates = t, this._boundsArray = void 0, this._unsupportedCoords = !1, !t.length) return this;
          this.onNorthPole = !1, this.onSouthPole = !1;
          var e = t[0][1],
            r = t[0][1];
          var _iterator201 = _createForOfIteratorHelper(t),
            _step201;
          try {
            for (_iterator201.s(); !(_step201 = _iterator201.n()).done;) {
              var _n187 = _step201.value;
              _n187[1] > r && (r = _n187[1]), _n187[1] < e && (e = _n187[1]);
            }
          } catch (err) {
            _iterator201.e(err);
          } finally {
            _iterator201.f();
          }
          var n = (r + e) / 2;
          if (n > Vc ? this.onNorthPole = !0 : n < -Vc && (this.onSouthPole = !0), !this.onNorthPole && !this.onSouthPole) {
            var _e308 = t.map(Nc.fromLngLat);
            this.tileID = function (t) {
              var e = 1 / 0,
                r = 1 / 0,
                n = -1 / 0,
                i = -1 / 0;
              var _iterator202 = _createForOfIteratorHelper(t),
                _step202;
              try {
                for (_iterator202.s(); !(_step202 = _iterator202.n()).done;) {
                  var _s142 = _step202.value;
                  e = Math.min(e, _s142.x), r = Math.min(r, _s142.y), n = Math.max(n, _s142.x), i = Math.max(i, _s142.y);
                }
              } catch (err) {
                _iterator202.e(err);
              } finally {
                _iterator202.f();
              }
              var s = Math.max(n - e, i - r),
                a = Math.max(0, Math.floor(-Math.log(s) / Math.LN2)),
                o = Math.pow(2, a);
              var l = Math.floor((e + n) / 2 * o);
              return l > 1 && (l -= 1), new Mc(a, l, Math.floor((r + i) / 2 * o));
            }(_e308), this.minzoom = this.maxzoom = this.tileID.z;
          }
          return this.fire(new Cn("data", {
            dataType: "source",
            sourceDataType: "content"
          })), this;
        }
      }, {
        key: "_clear",
        value: function _clear() {
          this._boundsArray = void 0, this._unsupportedCoords = !1;
        }
      }, {
        key: "_prepareData",
        value: function _prepareData(e) {
          var _this55 = this;
          for (var _t318 in this.tiles) {
            var _e309 = this.tiles[_t318];
            "loaded" !== _e309.state && (_e309.state = "loaded", _e309.texture = this.texture);
          }
          if (this._boundsArray || this.onNorthPole || this.onSouthPole || this._unsupportedCoords) return;
          var r = cg(new Mc(0, 0, 0), this.map.transform.projection),
            n = [r.projection.project(this.coordinates[0][0], this.coordinates[0][1]), r.projection.project(this.coordinates[1][0], this.coordinates[1][1]), r.projection.project(this.coordinates[2][0], this.coordinates[2][1]), r.projection.project(this.coordinates[3][0], this.coordinates[3][1])];
          if (!function (t) {
            var e = t[1].x - t[0].x,
              r = t[1].y - t[0].y,
              n = t[2].x - t[1].x,
              i = t[2].y - t[1].y,
              s = t[3].x - t[2].x,
              a = t[3].y - t[2].y,
              o = t[0].x - t[3].x,
              l = t[0].y - t[3].y,
              u = e * i - n * r,
              c = n * a - s * i,
              h = s * l - o * a,
              p = o * r - e * l;
            return u > 0 && c > 0 && h > 0 && p > 0 || u < 0 && c < 0 && h < 0 && p < 0;
          }(n)) return console.warn("Image source coordinates are defining non-convex area in the Mercator projection"), void (this._unsupportedCoords = !0);
          var i = cg(this.tileID, this.map.transform.projection),
            _this$coordinates$map = this.coordinates.map(function (t) {
              var e = i.projection.project(t[0], t[1]);
              return hg(i, e)._round();
            }),
            _this$coordinates$map2 = _slicedToArray(_this$coordinates$map, 4),
            s = _this$coordinates$map2[0],
            a = _this$coordinates$map2[1],
            o = _this$coordinates$map2[2],
            l = _this$coordinates$map2[3];
          this.perspectiveTransform = Ib(s.x, s.y, a.x, a.y, o.x, o.y, l.x, l.y);
          var u = this._boundsArray = new Fl();
          u.emplaceBack(s.x, s.y, 0, 0), u.emplaceBack(a.x, a.y, ds, 0), u.emplaceBack(l.x, l.y, 0, ds), u.emplaceBack(o.x, o.y, ds, ds), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy()), this.boundsBuffer = e.createVertexBuffer(u, Jg.members), this.boundsSegments = ku.simpleSegment(0, 0, 4, 2);
          var c = [],
            h = function (t) {
              return [Tb(t[0]), Tb(t[1]), Tb(t[2]), Tb(t[3])];
            }(this.coordinates),
            _ref134 = function (t) {
              var e = t[0][0],
                r = e,
                n = t[0][1],
                i = n;
              for (var _s143 = 1; _s143 < t.length; _s143++) t[_s143][0] < e ? e = t[_s143][0] : t[_s143][0] > r && (r = t[_s143][0]), t[_s143][1] < n ? n = t[_s143][1] : t[_s143][1] > i && (i = t[_s143][1]);
              return [e, n, r - e, i - n];
            }(h),
            _ref135 = _slicedToArray(_ref134, 4),
            p = _ref135[0],
            f = _ref135[1],
            d = _ref135[2],
            m = _ref135[3];
          {
            var _i187 = new Fl(),
              _ref136 = function (t) {
                var e = t[0].x,
                  r = e,
                  n = t[0].y,
                  i = n;
                for (var _s145 = 1; _s145 < t.length; _s145++) t[_s145].x < e ? e = t[_s145].x : t[_s145].x > r && (r = t[_s145].x), t[_s145].y < n ? n = t[_s145].y : t[_s145].y > i && (i = t[_s145].y);
                return [e, n, r - e, i - n];
              }(n),
              _ref137 = _slicedToArray(_ref136, 4),
              _s144 = _ref137[0],
              _a113 = _ref137[1],
              _o83 = _ref137[2],
              _l65 = _ref137[3],
              _u54 = function _u54(t) {
                return [(t.x - _s144) / _o83, (t.y - _a113) / _l65];
              },
              _n$map = n.map(_u54),
              _n$map2 = _slicedToArray(_n$map, 4),
              _h35 = _n$map2[0],
              _y13 = _n$map2[1],
              _g12 = _n$map2[2],
              _x12 = _n$map2[3],
              _b9 = function (e, r, n, i, s, a, o, l) {
                var u = Sb(0, 0, 1, 0, 1, 1, 0, 1),
                  c = Sb(e, r, n, i, s, a, o, l),
                  h = t.bE.adjoint([], c);
                return t.bE.multiply(u, u, h);
              }(_h35[0], _h35[1], _y13[0], _y13[1], _g12[0], _g12[1], _x12[0], _x12[1]);
            this.elevatedGlobePerspectiveTransform = Ib(_h35[0], _h35[1], _y13[0], _y13[1], _g12[0], _g12[1], _x12[0], _x12[1]);
            var _v9 = function _v9(e, r) {
                c.push(e.lng);
                var n = Math.round((e.lng - p) / d * ds),
                  s = Math.round((e.lat - f) / m * ds),
                  a = _u54(r),
                  o = t.$.transformMat3([], [a[0], a[1], 1], _b9),
                  l = Math.round(o[0] / o[2] * ds),
                  h = Math.round(o[1] / o[2] * ds);
                _i187.emplaceBack(n, s, l, h);
              },
              _10 = n[3].x - n[0].x,
              _w7 = n[3].y - n[0].y,
              _M8 = n[2].x - n[1].x,
              _A9 = n[2].y - n[1].y;
            for (var _t319 = 0; _t319 < 65; _t319++) {
              var _e310 = _t319 / 64,
                _i188 = [n[0].x + _e310 * _10, n[0].y + _e310 * _w7],
                _s146 = [n[1].x + _e310 * _M8, n[1].y + _e310 * _A9],
                _a114 = _s146[0] - _i188[0],
                _o84 = _s146[1] - _i188[1];
              for (var _t320 = 0; _t320 < 65; _t320++) {
                var _e311 = _t320 / 64,
                  _n188 = {
                    x: _i188[0] + _a114 * _e311,
                    y: _i188[1] + _o84 * _e311,
                    z: 0
                  };
                _v9(r.projection.unproject(_n188.x, _n188.y), _n188);
              }
            }
            this.elevatedGlobeVertexBuffer = e.createVertexBuffer(_i187, Jg.members);
          }
          {
            var _ref138, _ref139;
            this.maxLongitudeTriangleSize = 0;
            var _t321 = [],
              _r257 = new tu();
            var _n189 = function _n189(e, n, i) {
              _r257.emplaceBack(e, n, i);
              var s = c[e],
                a = c[n],
                o = c[i],
                l = Math.min(Math.min(s, a), o),
                u = Math.max(Math.max(s, a), o) - l;
              u > _this55.maxLongitudeTriangleSize && (_this55.maxLongitudeTriangleSize = u), _t321.push(l + u / 2);
            };
            for (var _t322 = 0; _t322 < 64; _t322++) for (var _e312 = 0; _e312 < 64; _e312++) {
              var _r258 = 65 * _t322 + _e312,
                _i189 = _r258 + 1,
                _s147 = _r258 + 65,
                _a115 = _s147 + 1;
              _n189(_r258, _s147, _i189), _n189(_i189, _s147, _a115);
            }
            (_ref138 = function (t, e) {
              var r = Array.from({
                length: t.length
              }, function (t, e) {
                return e;
              });
              r.sort(function (e, r) {
                return t[e] - t[r];
              });
              var n = [],
                i = new tu();
              for (var _s148 = 0; _s148 < r.length; _s148++) {
                var _a116 = r[_s148];
                n.push(t[_a116]);
                var _o85 = 3 * _a116,
                  _l66 = _o85 + 1;
                i.emplaceBack(e.uint16[_o85], e.uint16[_l66], e.uint16[_l66 + 1]);
              }
              return [n, i];
            }(_t321, _r257), _ref139 = _slicedToArray(_ref138, 2), _t321 = _ref139[0], _r257 = _ref139[1]), this.elevatedGlobeTrianglesCenterLongitudes = _t321, this.elevatedGlobeIndexBuffer = e.createIndexBuffer(_r257);
          }
          this.elevatedGlobeSegments = ku.simpleSegment(0, 0, 4225, 8192), this.elevatedGlobeGridMatrix = new Float32Array([0, d / ds, 0, m / ds, 0, 0, f, p, 0]);
        }
      }, {
        key: "prepare",
        value: function prepare() {
          var t = 0 !== Object.keys(this.tiles).length;
          if (this.tileID && !t) return;
          var e = this.map.painter.context,
            r = e.gl;
          !this._dirty || this.texture instanceof qg || (this.texture ? this.texture.update(this.image) : (this.texture = new $g(e, this.image, r.RGBA), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE)), this._dirty = !1), t && this._prepareData(e);
        }
      }, {
        key: "loadTile",
        value: function loadTile(t, e) {
          this.tileID && this.tileID.equals(t.tileID.canonical) ? (this.tiles[String(t.tileID.wrap)] = t, t.buckets = {}, e(null)) : (t.state = "errored", e(null));
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return {
            type: "image",
            url: this.options.url,
            coordinates: this.coordinates
          };
        }
      }, {
        key: "hasTransition",
        value: function hasTransition() {
          return !1;
        }
      }, {
        key: "getSegmentsForLongitude",
        value: function getSegmentsForLongitude(t) {
          var e = this.elevatedGlobeSegments;
          if (!this.elevatedGlobeTrianglesCenterLongitudes || !e) return null;
          var r = this.elevatedGlobeTrianglesCenterLongitudes;
          var n = (i = t + 180) + 360 * Math.round((r[0] - i) / 360);
          var i;
          var s = new ku(),
            a = function a(t, r) {
              s.segments.push({
                vertexOffset: 0,
                primitiveOffset: t,
                vertexLength: e.segments[0].vertexLength,
                primitiveLength: r,
                sortKey: void 0,
                vaos: {}
              });
            },
            o = .51 * this.maxLongitudeTriangleSize;
          if (Math.abs(r[0] - n) <= o) {
            var _t323 = zr(r, 0, r.length, n + o);
            return _t323 === r.length || a(_t323, Pr(r, _t323 + 1, r.length, n + 360 - o) - _t323), s;
          }
          n < r[0] && (n += 360);
          var l = Pr(r, 0, r.length, n - o);
          if (l === r.length) return a(0, r.length), s;
          a(0, l - 0);
          var u = zr(r, l + 1, r.length, n + o);
          return u !== r.length && a(u, r.length - u), s;
        }
      }]);
      return kb;
    }(On);
    var Pb = (Math.pow(256, 2) - 1) / 16907520;
    var zb = /*#__PURE__*/function (_zl2) {
      _inherits(zb, _zl2);
      var _super81 = _createSuper(zb);
      function zb(t, e, r, n) {
        var _this56;
        _classCallCheck(this, zb);
        _this56 = _super81.call(this, t, {
          layout: Mb || (Mb = new ul({
            visibility: new al(cl.layout_raster.visibility)
          })),
          paint: Ab || (Ab = new ul({
            "raster-opacity": new al(cl.paint_raster["raster-opacity"]),
            "raster-color": new ll(cl.paint_raster["raster-color"]),
            "raster-color-mix": new al(cl.paint_raster["raster-color-mix"]),
            "raster-color-range": new al(cl.paint_raster["raster-color-range"]),
            "raster-hue-rotate": new al(cl.paint_raster["raster-hue-rotate"]),
            "raster-brightness-min": new al(cl.paint_raster["raster-brightness-min"]),
            "raster-brightness-max": new al(cl.paint_raster["raster-brightness-max"]),
            "raster-saturation": new al(cl.paint_raster["raster-saturation"]),
            "raster-contrast": new al(cl.paint_raster["raster-contrast"]),
            "raster-resampling": new al(cl.paint_raster["raster-resampling"]),
            "raster-fade-duration": new al(cl.paint_raster["raster-fade-duration"]),
            "raster-emissive-strength": new al(cl.paint_raster["raster-emissive-strength"]),
            "raster-array-band": new al(cl.paint_raster["raster-array-band"]),
            "raster-elevation": new al(cl.paint_raster["raster-elevation"])
          }))
        }, e, r, n), _this56.updateColorRamp(), _this56._curRampRange = [NaN, NaN];
        return _this56;
      }
      _createClass(zb, [{
        key: "getProgramIds",
        value: function getProgramIds() {
          return ["raster"];
        }
      }, {
        key: "hasColorMap",
        value: function hasColorMap() {
          return !!this._transitionablePaint._values["raster-color"].value.value;
        }
      }, {
        key: "tileCoverLift",
        value: function tileCoverLift() {
          return this.paint.get("raster-elevation");
        }
      }, {
        key: "isDraped",
        value: function isDraped(t) {
          return !(t && t._source instanceof kb && (t._source.onNorthPole || t._source.onSouthPole)) && 0 === this.paint.get("raster-elevation");
        }
      }, {
        key: "_handleSpecialPaintPropertyUpdate",
        value: function _handleSpecialPaintPropertyUpdate(t) {
          "raster-color" !== t && "raster-color-range" !== t || (this._curRampRange = [NaN, NaN], this.updateColorRamp());
        }
      }, {
        key: "updateColorRamp",
        value: function updateColorRamp(t) {
          if (!this.hasColorMap()) return;
          if (!this._curRampRange) return;
          var e = this._transitionablePaint._values["raster-color"].value.expression,
            _ref140 = t || this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({
              zoom: 0
            }) || [NaN, NaN],
            _ref141 = _slicedToArray(_ref140, 2),
            r = _ref141[0],
            n = _ref141[1];
          isNaN(r) && isNaN(n) || r === this._curRampRange[0] && n === this._curRampRange[1] || (this.colorRamp = Mp({
            expression: e,
            evaluationKey: "rasterValue",
            image: this.colorRamp,
            clips: [{
              start: r,
              end: n
            }],
            resolution: 256
          }), this.colorRampTexture = null, this._curRampRange = [r, n]);
        }
      }]);
      return zb;
    }(zl);
    var Eb, Bb, Db, Rb, Cb;
    var Lb = /*#__PURE__*/function (_zl3) {
      _inherits(Lb, _zl3);
      var _super82 = _createSuper(Lb);
      function Lb(t, e, r, n) {
        var _this57;
        _classCallCheck(this, Lb);
        _this57 = _super82.call(this, t, {
          layout: Eb || (Eb = new ul({
            visibility: new al(cl["layout_raster-particle"].visibility)
          })),
          paint: Bb || (Bb = new ul({
            "raster-particle-array-band": new al(cl["paint_raster-particle"]["raster-particle-array-band"]),
            "raster-particle-count": new al(cl["paint_raster-particle"]["raster-particle-count"]),
            "raster-particle-color": new ll(cl["paint_raster-particle"]["raster-particle-color"]),
            "raster-particle-max-speed": new al(cl["paint_raster-particle"]["raster-particle-max-speed"]),
            "raster-particle-speed-factor": new al(cl["paint_raster-particle"]["raster-particle-speed-factor"]),
            "raster-particle-fade-opacity-factor": new al(cl["paint_raster-particle"]["raster-particle-fade-opacity-factor"]),
            "raster-particle-reset-rate-factor": new al(cl["paint_raster-particle"]["raster-particle-reset-rate-factor"]),
            "raster-particle-elevation": new al(cl["paint_raster-particle"]["raster-particle-elevation"])
          }))
        }, e, r, n), _this57._updateColorRamp(), _this57.lastInvalidatedAt = Rr.now();
        return _this57;
      }
      _createClass(Lb, [{
        key: "onRemove",
        value: function onRemove(t) {
          this.colorRampTexture && this.colorRampTexture.destroy(), this.tileFramebuffer && this.tileFramebuffer.destroy(), this.particleFramebuffer && this.particleFramebuffer.destroy();
        }
      }, {
        key: "hasColorMap",
        value: function hasColorMap() {
          return !!this._transitionablePaint._values["raster-particle-color"].value.value;
        }
      }, {
        key: "getProgramIds",
        value: function getProgramIds() {
          return ["rasterParticle"];
        }
      }, {
        key: "hasOffscreenPass",
        value: function hasOffscreenPass() {
          return "none" !== this.visibility;
        }
      }, {
        key: "isDraped",
        value: function isDraped(t) {
          return !1;
        }
      }, {
        key: "_handleSpecialPaintPropertyUpdate",
        value: function _handleSpecialPaintPropertyUpdate(t) {
          "raster-particle-color" !== t && "raster-particle-max-speed" !== t || (this._updateColorRamp(), this._invalidateAnimationState()), "raster-particle-count" === t && this._invalidateAnimationState();
        }
      }, {
        key: "_updateColorRamp",
        value: function _updateColorRamp() {
          if (!this.hasColorMap()) return;
          var t = this._transitionablePaint._values["raster-particle-color"].value.expression,
            e = this._transitionablePaint._values["raster-particle-max-speed"].value.expression.evaluate({
              zoom: 0
            });
          this.colorRamp = Mp({
            expression: t,
            evaluationKey: "rasterParticleSpeed",
            image: this.colorRamp,
            clips: [{
              start: 0,
              end: e
            }],
            resolution: 256
          }), this.colorRampTexture = null;
        }
      }, {
        key: "_invalidateAnimationState",
        value: function _invalidateAnimationState() {
          this.lastInvalidatedAt = Rr.now();
        }
      }, {
        key: "tileCoverLift",
        value: function tileCoverLift() {
          return this.paint.get("raster-particle-elevation");
        }
      }]);
      return Lb;
    }(zl);
    var Vb = /*#__PURE__*/function (_zl4) {
      _inherits(Vb, _zl4);
      var _super83 = _createSuper(Vb);
      function Vb(t, e) {
        var _this58;
        _classCallCheck(this, Vb);
        _this58 = _super83.call(this, t, {}, e, null), _this58.implementation = t, t.slot && (_this58.slot = t.slot);
        return _this58;
      }
      _createClass(Vb, [{
        key: "is3D",
        value: function is3D() {
          return "3d" === this.implementation.renderingMode;
        }
      }, {
        key: "hasOffscreenPass",
        value: function hasOffscreenPass() {
          return void 0 !== this.implementation.prerender;
        }
      }, {
        key: "isDraped",
        value: function isDraped(t) {
          return void 0 !== this.implementation.renderToTile;
        }
      }, {
        key: "shouldRedrape",
        value: function shouldRedrape() {
          return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
        }
      }, {
        key: "recalculate",
        value: function recalculate() {}
      }, {
        key: "updateTransitions",
        value: function updateTransitions() {}
      }, {
        key: "hasTransition",
        value: function hasTransition() {
          return !1;
        }
      }, {
        key: "serialize",
        value: function serialize() {}
      }, {
        key: "onAdd",
        value: function onAdd(t) {
          this.implementation.onAdd && this.implementation.onAdd(t, t.painter.context.gl);
        }
      }, {
        key: "onRemove",
        value: function onRemove(t) {
          this.implementation.onRemove && this.implementation.onRemove(t, t.painter.context.gl);
        }
      }]);
      return Vb;
    }(zl);
    function Fb(e, r, n) {
      var i = [0, 0, 1],
        s = t.aw.identity([]);
      return t.aw.rotateY(s, s, n ? -Ge(e) + Math.PI : Ge(e)), t.aw.rotateX(s, s, -Ge(r)), t.$.transformQuat(i, i, s), t.$.normalize(i, i);
    }
    function Ob(e, r) {
      var n = jb(e.projection, e.zoom, e.width, e.height),
        i = function (e, r, n, i, s) {
          var a = new bc(n.lng - 180 * Nb, n.lat),
            o = new bc(n.lng + 180 * Nb, n.lat),
            l = e.project(a.lng, a.lat),
            u = e.project(o.lng, o.lat),
            c = -Math.atan2(u.y - l.y, u.x - l.x),
            h = Nc.fromLngLat(n);
          h.y = We(h.y, -1 + Nb, 1 - Nb);
          var p = h.toLngLat(),
            f = e.project(p.lng, p.lat),
            d = Nc.fromLngLat(p);
          d.x += Nb;
          var m = d.toLngLat(),
            y = e.project(m.lng, m.lat),
            g = qb(y.x - f.x, y.y - f.y, c),
            x = Nc.fromLngLat(p);
          x.y += Nb;
          var b = x.toLngLat(),
            v = e.project(b.lng, b.lat),
            _ = qb(v.x - f.x, v.y - f.y, c),
            w = Math.abs(g.x) / Math.abs(_.y),
            M = t.ae.identity([]);
          t.ae.rotateZ(M, M, -c * (1 - (s ? 0 : i)));
          var A = t.ae.identity([]);
          return t.ae.scale(A, A, [1, 1 - (1 - w) * i, 1]), A[4] = -_.x / _.y * i, t.ae.rotateZ(A, A, c), t.ae.multiply(A, M, A), A;
        }(e.projection, 0, e.center, n, r),
        s = Ub(e);
      return t.ae.scale(i, i, [s, s, 1]), i;
    }
    function Ub(t) {
      var e = t.projection,
        r = jb(t.projection, t.zoom, t.width, t.height),
        n = $b(e, t.center),
        i = $b(e, bc.convert(e.center));
      return Math.pow(2, n * r + (1 - r) * i);
    }
    function jb(t, e, r, n) {
      var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1 / 0;
      var s = t.range;
      if (!s) return 0;
      var a = Math.min(i, Math.max(r, n)),
        o = Math.log(a / 1024) / Math.LN2;
      return Je(s[0] + o, s[1] + o, e);
    }
    var Nb = 1 / 4e4;
    function $b(t, e) {
      var r = We(e.lat, -Vc, Vc),
        n = new bc(e.lng - 180 * Nb, r),
        i = new bc(e.lng + 180 * Nb, r),
        s = t.project(n.lng, r),
        a = t.project(i.lng, r),
        o = Nc.fromLngLat(n),
        l = Nc.fromLngLat(i),
        u = a.x - s.x,
        c = a.y - s.y,
        h = l.x - o.x,
        p = l.y - o.y,
        f = Math.sqrt((h * h + p * p) / (u * u + c * c));
      return Math.log(f) / Math.LN2;
    }
    function qb(t, e, r) {
      var n = Math.cos(r),
        i = Math.sin(r);
      return {
        x: t * n - e * i,
        y: t * i + e * n
      };
    }
    function Gb(e, r, n) {
      t.ae.identity(e), t.ae.rotateZ(e, e, Ge(r[2])), t.ae.rotateX(e, e, Ge(r[0])), t.ae.rotateY(e, e, Ge(r[1])), t.ae.scale(e, e, n), t.ae.multiply(e, e, [1, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
    }
    function Xb(e, r, n, i, s, a, o, l) {
      var u = [n[0] - r[0], n[1] - r[1], 0],
        c = [i[0] - r[0], i[1] - r[1], 0];
      if (t.$.length(u) < 1e-12 || t.$.length(c) < 1e-12) return t.aw.identity(e);
      var h = t.$.cross([], u, c);
      t.$.normalize(h, h), t.$.subtract(c, i, r), u[2] = (a - s) * l, c[2] = (o - s) * l;
      var p = u;
      return t.$.cross(p, u, c), t.$.normalize(p, p), t.aw.rotationTo(e, h, p);
    }
    function Yb(e, r) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var i = Qh(r.zoom),
        s = function (e, r, n) {
          var i = r.worldSize,
            s = [e[12], e[13], e[14]],
            a = Cc(s[1] / i),
            o = Rc(s[0] / i),
            l = t.ae.identity([]),
            u = Dc(1, a) * i,
            c = Dc(1, 0) * i * Oc(a, r.zoom),
            h = 1 / Kh(i);
          var p = c * h;
          if (n) {
            var _t324 = jb(r.projection, r.zoom, r.width, r.height, 1024);
            p = h * r.projection.pixelSpaceConversion(r.center.lat, i, _t324);
          }
          var f = yc(a, o);
          t.$.add(f, f, t.$.scale([], t.$.normalize([], f), u * p * s[2]));
          var d = function (e) {
            var r = [e[0], e[1], e[2]];
            var n = [0, 1, 0];
            var i = t.$.cross([], n, r);
            return t.$.cross(n, r, i), 0 === t.$.squaredLength(n) && (n = [0, 1, 0], t.$.cross(i, r, n)), t.$.normalize(i, i), t.$.normalize(n, n), t.$.normalize(r, r), [i[0], i[1], i[2], 0, n[0], n[1], n[2], 0, r[0], r[1], r[2], 0, e[0], e[1], e[2], 1];
          }(f);
          t.ae.scale(l, l, [p, p, p * u]), t.ae.translate(l, l, [-s[0], -s[1], -s[2]]);
          var m = t.ae.multiply([], r.globeMatrix, d);
          return t.ae.multiply(m, m, l), t.ae.multiply(m, m, e), m;
        }(e, r, n);
      if (i > 0) {
        var _n190 = function (e, r) {
          var n = r.worldSize,
            i = Dc(1, 0) * n * Oc(r.center.lat, r.zoom) / Kh(n),
            s = Dc(1, r.center.lat) * n,
            a = t.ae.identity([]);
          return t.ae.rotateY(a, a, Ge(r.center.lng)), t.ae.rotateX(a, a, Ge(r.center.lat)), t.ae.translate(a, a, [0, 0, oc]), t.ae.scale(a, a, [i, i, i * s]), t.ae.translate(a, a, [r.point.x - .5 * n, r.point.y - .5 * n, 0]), t.ae.multiply(a, a, e), t.ae.multiply(a, r.globeMatrix, a);
        }(e, r);
        return function (e, r, n) {
          var i = function i(e, r, n) {
              var i = t.$.length(e),
                s = t.$.length(r),
                a = Oh(e, r, n);
              return t.$.scale(a, a, 1 / t.$.length(a) * Yn(i, s, n));
            },
            s = i([e[0], e[1], e[2]], [r[0], r[1], r[2]], n),
            a = i([e[4], e[5], e[6]], [r[4], r[5], r[6]], n),
            o = i([e[8], e[9], e[10]], [r[8], r[9], r[10]], n),
            l = Oh([e[12], e[13], e[14]], [r[12], r[13], r[14]], n);
          return [s[0], s[1], s[2], 0, a[0], a[1], a[2], 0, o[0], o[1], o[2], 0, l[0], l[1], l[2], 1];
        }(s, _n190, i);
      }
      return s;
    }
    function Zb(t, e, r, n) {
      var i = kh.projectAabbCorners(n, r);
      var s = Number.MAX_VALUE,
        a = -1;
      for (var _t325 = 0; _t325 < i.length; ++_t325) {
        var _r259 = i[_t325];
        _r259[0] = (.5 * _r259[0] + .5) * e.width, _r259[1] = (.5 - .5 * _r259[1]) * e.height, _r259[2] < s && (a = _t325, s = _r259[2]);
      }
      var o = function o(t) {
        return new je(i[t][0], i[t][1]);
      };
      var l;
      switch (a) {
        case 0:
        case 6:
          l = [o(1), o(5), o(4), o(7), o(3), o(2), o(1)];
          break;
        case 1:
        case 7:
          l = [o(0), o(4), o(5), o(6), o(2), o(3), o(0)];
          break;
        case 3:
        case 5:
          l = [o(1), o(0), o(4), o(7), o(6), o(2), o(1)];
          break;
        default:
          l = [o(1), o(5), o(6), o(7), o(3), o(0), o(1)];
      }
      if (eh(t, l)) return s;
    }
    var Hb = Rl([{
        name: "a_pos_3f",
        components: 3,
        type: "Float32"
      }]),
      Kb = Rl([{
        name: "a_color_3f",
        components: 3,
        type: "Float32"
      }]),
      Wb = Rl([{
        name: "a_color_4f",
        components: 4,
        type: "Float32"
      }]),
      Jb = Rl([{
        name: "a_uv_2f",
        components: 2,
        type: "Float32"
      }]),
      Qb = Rl([{
        name: "a_normal_3f",
        components: 3,
        type: "Float32"
      }]),
      tv = Rl([{
        name: "a_normal_matrix0",
        components: 4,
        type: "Float32"
      }, {
        name: "a_normal_matrix1",
        components: 4,
        type: "Float32"
      }, {
        name: "a_normal_matrix2",
        components: 4,
        type: "Float32"
      }, {
        name: "a_normal_matrix3",
        components: 4,
        type: "Float32"
      }]),
      ev = Rl([{
        name: "a_pbr",
        components: 4,
        type: "Uint16"
      }, {
        name: "a_heightBasedEmissiveStrength",
        components: 3,
        type: "Float32"
      }]);
    var rv = /*#__PURE__*/_createClass(function rv(t, e, r, n) {
      _classCallCheck(this, rv);
      this.message = (t ? "".concat(t, ": ") : "") + r, n && (this.identifier = n), null != e && e.__line__ && (this.line = e.__line__);
    });
    function nv(t, e) {
      var r = -1 === t.indexOf("://");
      try {
        return new URL(t, r && e ? "http://example.com" : void 0), !0;
      } catch (t) {
        return !1;
      }
    }
    var iv = /*#__PURE__*/_createClass(function iv(t, e) {
      _classCallCheck(this, iv);
      this.feature = t, this.instancedDataOffset = e, this.instancedDataCount = 0, this.rotation = [0, 0, 0], this.scale = [1, 1, 1], this.translation = [0, 0, 0];
    });
    var sv = /*#__PURE__*/_createClass(function sv() {
      _classCallCheck(this, sv);
      this.instancedDataArray = new uu(), this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
    });
    var av = /*#__PURE__*/function () {
      function av(t) {
        _classCallCheck(this, av);
        this.zoom = t.zoom, this.canonical = t.canonical, this.layers = t.layers, this.layerIds = this.layers.map(function (t) {
          return t.fqid;
        }), this.projection = t.projection, this.index = t.index, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter(function (t) {
          return t.isStateDependent();
        }).map(function (t) {
          return t.id;
        }), this.hasPattern = !1, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = {
          id: null,
          timestamp: 0
        }, this.modelUris = [], this.modelsRequested = !1, this.activeReplacements = [], this.replacementUpdateTime = 0;
      }
      _createClass(av, [{
        key: "updateFootprints",
        value: function updateFootprints(t, e) {}
      }, {
        key: "populate",
        value: function populate(t, e, r, n) {
          this.tileToMeter = jc(r);
          var i = this.layers[0]._featureFilter.needGeometry;
          this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
          var _iterator203 = _createForOfIteratorHelper(t),
            _step203;
          try {
            for (_iterator203.s(); !(_step203 = _iterator203.n()).done;) {
              var _step203$value = _step203.value,
                _s149 = _step203$value.feature,
                _a117 = _step203$value.id,
                _o86 = _step203$value.index,
                _l67 = _step203$value.sourceLayerIndex;
              var _t326 = null != _a117 ? _a117 : _s149.properties && _s149.properties.hasOwnProperty("id") ? _s149.properties.id : void 0,
                _u55 = Wc(_s149, i);
              if (!this.layers[0]._featureFilter.filter(new Wo(this.zoom), _u55, r)) continue;
              var _c44 = {
                  id: _t326,
                  sourceLayerIndex: _l67,
                  index: _o86,
                  geometry: i ? _u55.geometry : Kc(_s149, r, n),
                  properties: _s149.properties,
                  type: _s149.type,
                  patterns: {}
                },
                _h36 = this.addFeature(_c44, _c44.geometry, _u55);
              _h36 && e.featureIndex.insert(_s149, _c44.geometry, _o86, _l67, this.index, this.instancesPerModel[_h36].instancedDataArray.length, ds / 32);
            }
          } catch (err) {
            _iterator203.e(err);
          } finally {
            _iterator203.f();
          }
          this.lookup = null;
        }
      }, {
        key: "update",
        value: function update(t, e, r, n) {
          for (var _e313 in this.instancesPerModel) {
            var _r260 = this.instancesPerModel[_e313];
            for (var _e314 in t) _r260.idToFeaturesIndex.hasOwnProperty(_e314) && (this.evaluate(_r260.features[_r260.idToFeaturesIndex[_e314]], t[_e314], _r260, !0), this.uploaded = !1);
          }
          this.maxHeight = 0;
        }
      }, {
        key: "updateZoomBasedPaintProperties",
        value: function updateZoomBasedPaintProperties() {
          if (!this.hasZoomDependentProperties) return !1;
          var e = !1;
          for (var _r261 in this.instancesPerModel) {
            var _n191 = this.instancesPerModel[_r261];
            var _iterator204 = _createForOfIteratorHelper(_n191.features),
              _step204;
            try {
              for (_iterator204.s(); !(_step204 = _iterator204.n()).done;) {
                var _r262 = _step204.value;
                var _i190 = this.layers[0],
                  _s150 = _r262.feature,
                  _a118 = this.canonical,
                  _o87 = _i190.paint.get("model-rotation").evaluate(_s150, {}, _a118),
                  _l68 = _i190.paint.get("model-scale").evaluate(_s150, {}, _a118),
                  _u56 = _i190.paint.get("model-translation").evaluate(_s150, {}, _a118);
                t.$.exactEquals(_r262.rotation, _o87) && t.$.exactEquals(_r262.scale, _l68) && t.$.exactEquals(_r262.translation, _u56) || (this.evaluate(_r262, _r262.featureStates, _n191, !0), e = !0);
              }
            } catch (err) {
              _iterator204.e(err);
            } finally {
              _iterator204.f();
            }
          }
          return e;
        }
      }, {
        key: "updateReplacement",
        value: function updateReplacement(t, e, r, n) {
          if (e.updateTime === this.replacementUpdateTime) return !1;
          this.replacementUpdateTime = e.updateTime;
          var i = e.getReplacementRegionsForTile(t.toUnwrapped(), !0);
          if (jf(this.activeReplacements, i)) return !1;
          this.activeReplacements = i;
          var s = !1;
          for (var _e315 in this.instancesPerModel) {
            var _i191 = this.instancesPerModel[_e315],
              _a119 = _i191.instancedDataArray;
            var _iterator205 = _createForOfIteratorHelper(_i191.features),
              _step205;
            try {
              for (_iterator205.s(); !(_step205 = _iterator205.n()).done;) {
                var _e316 = _step205.value;
                var _i192 = _e316.instancedDataOffset,
                  _o88 = _e316.instancedDataCount;
                for (var _e317 = 0; _e317 < _o88; _e317++) {
                  var _o89 = 16 * (_e317 + _i192);
                  var _l69 = _a119.float32[_o89 + 0];
                  _l69 = _l69 > ds ? _l69 - ds : _l69;
                  var _u57 = Math.floor(_l69),
                    _c45 = _a119.float32[_o89 + 1];
                  var _h37 = !1;
                  var _iterator206 = _createForOfIteratorHelper(this.activeReplacements),
                    _step206;
                  try {
                    for (_iterator206.s(); !(_step206 = _iterator206.n()).done;) {
                      var _e318 = _step206.value;
                      if (!Vf(_e318, r, od.Model, n) && !(_e318.min.x > _u57 || _u57 > _e318.max.x || _e318.min.y > _c45 || _c45 > _e318.max.y) && (_h37 = Yf(Xf(_u57, _c45, t.canonical, _e318.footprintTileId.canonical), _e318), _h37)) break;
                    }
                  } catch (err) {
                    _iterator206.e(err);
                  } finally {
                    _iterator206.f();
                  }
                  _a119.float32[_o89] = _h37 ? _l69 + ds : _l69, s = s || _h37;
                }
              }
            } catch (err) {
              _iterator205.e(err);
            } finally {
              _iterator205.f();
            }
          }
          return s;
        }
      }, {
        key: "isEmpty",
        value: function isEmpty() {
          for (var _t327 in this.instancesPerModel) if (0 !== this.instancesPerModel[_t327].instancedDataArray.length) return !1;
          return !0;
        }
      }, {
        key: "uploadPending",
        value: function uploadPending() {
          return !this.uploaded;
        }
      }, {
        key: "upload",
        value: function upload(t) {
          if (!this.uploaded) for (var _e319 in this.instancesPerModel) {
            var _r263 = this.instancesPerModel[_e319];
            _r263.instancedDataArray.length < 0 || 0 === _r263.instancedDataArray.length || (_r263.instancedDataBuffer ? _r263.instancedDataBuffer.updateData(_r263.instancedDataArray) : _r263.instancedDataBuffer = t.createVertexBuffer(_r263.instancedDataArray, tv.members, !0, void 0, this.instanceCount));
          }
          this.uploaded = !0;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          for (var _t328 in this.instancesPerModel) {
            var _e320 = this.instancesPerModel[_t328];
            0 !== _e320.instancedDataArray.length && _e320.instancedDataBuffer && _e320.instancedDataBuffer.destroy();
          }
          var t = this.layers[0].modelManager;
          if (t && this.modelUris) {
            var _iterator207 = _createForOfIteratorHelper(this.modelUris),
              _step207;
            try {
              for (_iterator207.s(); !(_step207 = _iterator207.n()).done;) {
                var _e321 = _step207.value;
                t.removeModel(_e321, "");
              }
            } catch (err) {
              _iterator207.e(err);
            } finally {
              _iterator207.f();
            }
          }
        }
      }, {
        key: "addFeature",
        value: function addFeature(t, e, r) {
          var n = this.layers[0],
            i = n.layout.get("model-id").evaluate(r, {}, this.canonical);
          if (!i) return dr("modelId is not evaluated for layer ".concat(n.id, " and it is not going to get rendered.")), i;
          nv(i, !1) && (this.modelUris.includes(i) || this.modelUris.push(i)), this.instancesPerModel[i] || (this.instancesPerModel[i] = new sv());
          var s = this.instancesPerModel[i],
            a = s.instancedDataArray,
            o = new iv(r, a.length);
          var _iterator208 = _createForOfIteratorHelper(e),
            _step208;
          try {
            for (_iterator208.s(); !(_step208 = _iterator208.n()).done;) {
              var _t329 = _step208.value;
              var _iterator209 = _createForOfIteratorHelper(_t329),
                _step209;
              try {
                for (_iterator209.s(); !(_step209 = _iterator209.n()).done;) {
                  var _e322 = _step209.value;
                  if (_e322.x < 0 || _e322.x >= ds || _e322.y < 0 || _e322.y >= ds) continue;
                  var _t330 = (this.lookupDim - 1) / ds,
                    _r264 = this.lookupDim * (_e322.y * _t330 | 0) + _e322.x * _t330 | 0;
                  if (this.lookup) {
                    if (0 !== this.lookup[_r264]) continue;
                    this.lookup[_r264] = 1;
                  }
                  this.instanceCount++;
                  var _n192 = a.length;
                  a.resize(_n192 + 1), s.instancesEvaluatedElevation.push(0), a.float32[16 * _n192] = _e322.x, a.float32[16 * _n192 + 1] = _e322.y;
                }
              } catch (err) {
                _iterator209.e(err);
              } finally {
                _iterator209.f();
              }
            }
          } catch (err) {
            _iterator208.e(err);
          } finally {
            _iterator208.f();
          }
          return o.instancedDataCount = s.instancedDataArray.length - o.instancedDataOffset, o.instancedDataCount > 0 && (t.id && (s.idToFeaturesIndex[t.id] = s.features.length), s.features.push(o), this.evaluate(o, {}, s, !1)), i;
        }
      }, {
        key: "getModelUris",
        value: function getModelUris() {
          return this.modelUris;
        }
      }, {
        key: "evaluate",
        value: function evaluate(t, e, r, n) {
          var i = this.layers[0],
            s = t.feature,
            a = this.canonical,
            o = t.rotation = i.paint.get("model-rotation").evaluate(s, e, a),
            l = t.scale = i.paint.get("model-scale").evaluate(s, e, a),
            u = t.translation = i.paint.get("model-translation").evaluate(s, e, a),
            c = i.paint.get("model-color").evaluate(s, e, a);
          c.a = i.paint.get("model-color-mix-intensity").evaluate(s, e, a);
          var h = [];
          this.maxVerticalOffset < u[2] && (this.maxVerticalOffset = u[2]), this.maxScale = Math.max(Math.max(this.maxScale, l[0]), Math.max(l[1], l[2])), Gb(h, o, l);
          var p = Math.round(100 * c.a) + c.b / 1.05;
          for (var _e323 = 0; _e323 < t.instancedDataCount; ++_e323) {
            var _i193 = t.instancedDataOffset + _e323,
              _s151 = 16 * _i193,
              _o90 = r.instancedDataArray.float32;
            var _l70 = 0;
            n && (_l70 = _o90[_s151 + 6] - r.instancesEvaluatedElevation[_i193]);
            var _f28 = 0 | _o90[_s151 + 1];
            _o90[_s151] = (0 | _o90[_s151]) + c.r / 1.05, _o90[_s151 + 1] = _f28 + c.g / 1.05, _o90[_s151 + 2] = p, _o90[_s151 + 3] = 1 / (a.z > 10 ? this.tileToMeter : jc(a, _f28)), _o90[_s151 + 4] = u[0], _o90[_s151 + 5] = u[1], _o90[_s151 + 6] = u[2] + _l70, _o90[_s151 + 7] = h[0], _o90[_s151 + 8] = h[1], _o90[_s151 + 9] = h[2], _o90[_s151 + 10] = h[4], _o90[_s151 + 11] = h[5], _o90[_s151 + 12] = h[6], _o90[_s151 + 13] = h[8], _o90[_s151 + 14] = h[9], _o90[_s151 + 15] = h[10], r.instancesEvaluatedElevation[_i193] = u[2];
          }
        }
      }]);
      return av;
    }();
    var ov, lv;
    So(av, "ModelBucket", {
      omit: ["layers"]
    }), So(sv, "PerModelAttributes"), So(iv, "ModelFeature");
    var uv = 64,
      cv = {
        CoordinateSpaceTile: 1,
        CoordinateSpaceYUp: 2,
        HasMapboxMeshFeatures: 4,
        HasMeshoptCompression: 8
      };
    function hv(e, r, n, i, s, a, o, l, u) {
      var c = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : !1;
      var h = n.zoom,
        p = n.project(i),
        f = Oc(i.lat, h),
        d = 1 / f;
      t.ae.identity(e), t.ae.translate(e, e, [p.x + o[0] * d, p.y + o[1] * d, o[2]]);
      var m = 1,
        y = 1;
      var g = n.worldSize;
      if (c) {
        if ("mercator" === n.projection.name) {
          var _e324 = 0;
          n.elevation && (_e324 = n.elevation.getAtPointOrZero(new Nc(p.x / g, p.y / g), 0));
          var _r265 = t.aB.transformMat4([], [p.x, p.y, _e324, 1], n.projMatrix)[3] / n.cameraToCenterDistance;
          m = _r265, y = _r265 * Oc(n.center.lat, h);
        } else if ("globe" === n.projection.name) {
          var _r266 = Yb(e, n),
            _s152 = t.ae.multiply([], n.projMatrix, _r266),
            _a120 = [0, 0, 0, 1];
          t.aB.transformMat4(_a120, _a120, _s152);
          var _o91 = _a120[3] / n.cameraToCenterDistance,
            _l71 = Qh(h),
            _u58 = n.projection.pixelsPerMeter(i.lat, g) * Oc(i.lat, h),
            _c46 = n.projection.pixelsPerMeter(n.center.lat, g) * Oc(n.center.lat, h);
          m = _o91 / Yn(_u58, Fc(n.center.lat), _l71), y = _o91 * f / _u58, m *= _c46, y *= _c46;
        }
      } else m = d;
      t.ae.scale(e, e, [m, m, y]);
      var x = _toConsumableArray(e),
        b = r.orientation,
        v = [];
      if (Gb(v, [b[0] + s[0], b[1] + s[1], b[2] + s[2]], a), t.ae.multiply(e, x, v), l && n.elevation) {
        var _s153 = 0;
        var _a121 = [];
        if (u && n.elevation) {
          _s153 = function (e, r, n, i, s) {
            var a = r.elevation;
            if (!a) return 0;
            var o = kh.projectAabbCorners(n, i),
              l = Dc(1, s.lat) * r.worldSize,
              u = function (e, r) {
                var n = [0, 0, 1],
                  i = [{
                    corners: [0, 1, 3, 2],
                    dotProductWithUp: 0
                  }, {
                    corners: [1, 5, 2, 6],
                    dotProductWithUp: 0
                  }, {
                    corners: [0, 4, 1, 5],
                    dotProductWithUp: 0
                  }, {
                    corners: [2, 6, 3, 7],
                    dotProductWithUp: 0
                  }, {
                    corners: [4, 7, 5, 6],
                    dotProductWithUp: 0
                  }, {
                    corners: [0, 3, 4, 7],
                    dotProductWithUp: 0
                  }];
                for (var _i195 = 0, _i194 = i; _i195 < _i194.length; _i195++) {
                  var _s154 = _i194[_i195];
                  var _i196 = e[_s154.corners[0]],
                    _a122 = e[_s154.corners[1]],
                    _o92 = e[_s154.corners[2]],
                    _l72 = [_a122[0] - _i196[0], _a122[1] - _i196[1], r * (_a122[2] - _i196[2])],
                    _u59 = t.$.cross(_l72, _l72, [_o92[0] - _i196[0], _o92[1] - _i196[1], r * (_o92[2] - _i196[2])]);
                  t.$.normalize(_u59, _u59), _s154.dotProductWithUp = t.$.dot(_u59, n);
                }
                return i.sort(function (t, e) {
                  return t.dotProductWithUp - e.dotProductWithUp;
                }), i[0].corners;
              }(o, l),
              c = o[u[0]],
              h = o[u[1]],
              p = o[u[2]],
              f = o[u[3]],
              d = a.getAtPointOrZero(new Nc(c[0] / r.worldSize, c[1] / r.worldSize), 0),
              m = a.getAtPointOrZero(new Nc(h[0] / r.worldSize, h[1] / r.worldSize), 0),
              y = a.getAtPointOrZero(new Nc(p[0] / r.worldSize, p[1] / r.worldSize), 0),
              g = a.getAtPointOrZero(new Nc(f[0] / r.worldSize, f[1] / r.worldSize), 0),
              x = (d + g) / 2,
              b = (m + y) / 2;
            return x > b ? m < y ? Xb(e, h, f, c, m, g, d, l) : Xb(e, p, c, f, y, d, g, l) : d < g ? Xb(e, c, h, p, d, m, y, l) : Xb(e, f, p, h, g, y, m, l), Math.max(x, b);
          }(_a121, n, r.aabb, e, i);
          var _o93 = t.ae.fromQuat([], _a121),
            _l73 = t.ae.multiply([], _o93, v);
          t.ae.multiply(e, x, _l73);
        } else _s153 = n.elevation.getAtPointOrZero(new Nc(p.x / g, p.y / g), 0);
        0 !== _s153 && (e[14] += _s153);
      }
    }
    function pv(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      t.uploaded || (t.gfxTexture = new $g(e, t.image, r ? e.gl.R8 : e.gl.RGBA, {
        useMipmap: t.sampler.minFilter >= e.gl.NEAREST_MIPMAP_NEAREST
      }), t.uploaded = !0, t.image = null);
    }
    function fv(t, e, r) {
      t.indexBuffer = e.createIndexBuffer(t.indexArray, !1, !0), t.vertexBuffer = e.createVertexBuffer(t.vertexArray, Hb.members, !1, !0), t.normalArray && (t.normalBuffer = e.createVertexBuffer(t.normalArray, Qb.members, !1, !0)), t.texcoordArray && (t.texcoordBuffer = e.createVertexBuffer(t.texcoordArray, Jb.members, !1, !0)), t.colorArray && (t.colorBuffer = e.createVertexBuffer(t.colorArray, (12 === t.colorArray.bytesPerElement ? Kb : Wb).members, !1, !0)), t.featureArray && (t.pbrBuffer = e.createVertexBuffer(t.featureArray, ev.members, !0)), t.segments = ku.simpleSegment(0, 0, t.vertexArray.length, t.indexArray.length);
      var n = t.material;
      n.pbrMetallicRoughness.baseColorTexture && pv(n.pbrMetallicRoughness.baseColorTexture, e), n.pbrMetallicRoughness.metallicRoughnessTexture && pv(n.pbrMetallicRoughness.metallicRoughnessTexture, e), n.normalTexture && pv(n.normalTexture, e), n.occlusionTexture && pv(n.occlusionTexture, e, r), n.emissionTexture && pv(n.emissionTexture, e);
    }
    function dv(t, e, r) {
      if (t.meshes) {
        var _iterator210 = _createForOfIteratorHelper(t.meshes),
          _step210;
        try {
          for (_iterator210.s(); !(_step210 = _iterator210.n()).done;) {
            var _n193 = _step210.value;
            fv(_n193, e, r);
          }
        } catch (err) {
          _iterator210.e(err);
        } finally {
          _iterator210.f();
        }
      }
      if (t.children) {
        var _iterator211 = _createForOfIteratorHelper(t.children),
          _step211;
        try {
          for (_iterator211.s(); !(_step211 = _iterator211.n()).done;) {
            var _n194 = _step211.value;
            dv(_n194, e, r);
          }
        } catch (err) {
          _iterator211.e(err);
        } finally {
          _iterator211.f();
        }
      }
    }
    function mv(t) {
      if (t.meshes) {
        var _iterator212 = _createForOfIteratorHelper(t.meshes),
          _step212;
        try {
          for (_iterator212.s(); !(_step212 = _iterator212.n()).done;) {
            var _e325 = _step212.value;
            _e325.indexArray.destroy(), _e325.vertexArray.destroy(), _e325.colorArray && _e325.colorArray.destroy(), _e325.normalArray && _e325.normalArray.destroy(), _e325.texcoordArray && _e325.texcoordArray.destroy(), _e325.featureArray && _e325.featureArray.destroy();
          }
        } catch (err) {
          _iterator212.e(err);
        } finally {
          _iterator212.f();
        }
      }
      if (t.children) {
        var _iterator213 = _createForOfIteratorHelper(t.children),
          _step213;
        try {
          for (_iterator213.s(); !(_step213 = _iterator213.n()).done;) {
            var _e326 = _step213.value;
            mv(_e326);
          }
        } catch (err) {
          _iterator213.e(err);
        } finally {
          _iterator213.f();
        }
      }
    }
    function yv(t) {
      if (t.meshes) {
        var _iterator214 = _createForOfIteratorHelper(t.meshes),
          _step214;
        try {
          for (_iterator214.s(); !(_step214 = _iterator214.n()).done;) {
            var _r267 = _step214.value;
            _r267.vertexBuffer && (_r267.vertexBuffer.destroy(), _r267.indexBuffer.destroy(), _r267.normalBuffer && _r267.normalBuffer.destroy(), _r267.texcoordBuffer && _r267.texcoordBuffer.destroy(), _r267.colorBuffer && _r267.colorBuffer.destroy(), _r267.pbrBuffer && _r267.pbrBuffer.destroy(), _r267.segments.destroy(), _r267.material && ((e = _r267.material).pbrMetallicRoughness.baseColorTexture && e.pbrMetallicRoughness.baseColorTexture.gfxTexture && e.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), e.pbrMetallicRoughness.metallicRoughnessTexture && e.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && e.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), e.normalTexture && e.normalTexture.gfxTexture && e.normalTexture.gfxTexture.destroy(), e.emissionTexture && e.emissionTexture.gfxTexture && e.emissionTexture.gfxTexture.destroy(), e.occlusionTexture && e.occlusionTexture.gfxTexture && e.occlusionTexture.gfxTexture.destroy()));
          }
        } catch (err) {
          _iterator214.e(err);
        } finally {
          _iterator214.f();
        }
      }
      var e;
      if (t.children) {
        var _iterator215 = _createForOfIteratorHelper(t.children),
          _step215;
        try {
          for (_iterator215.s(); !(_step215 = _iterator215.n()).done;) {
            var _e327 = _step215.value;
            yv(_e327);
          }
        } catch (err) {
          _iterator215.e(err);
        } finally {
          _iterator215.f();
        }
      }
    }
    var gv = /*#__PURE__*/function () {
      function gv(t) {
        var _this59 = this;
        _classCallCheck(this, gv);
        this._callback = t, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel(), this._channel.port2.onmessage = function () {
          _this59._triggered = !1, _this59._callback();
        });
      }
      _createClass(gv, [{
        key: "trigger",
        value: function trigger() {
          var _this60 = this;
          this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(function () {
            _this60._triggered = !1, _this60._callback();
          }, 0));
        }
      }, {
        key: "remove",
        value: function remove() {
          this._channel = void 0, this._callback = function () {};
        }
      }]);
      return gv;
    }();
    var xv = /*#__PURE__*/function () {
      function xv() {
        _classCallCheck(this, xv);
        this.tasks = {}, this.taskQueue = [], lr(["process"], this), this.invoker = new gv(this.process), this.nextId = 0;
      }
      _createClass(xv, [{
        key: "add",
        value: function add(t, e) {
          var _this61 = this;
          var r = this.nextId++,
            n = function (_ref142) {
              var t = _ref142.type,
                e = _ref142.isSymbolTile,
                r = _ref142.zoom;
              return r = r || 0, "message" === t ? 0 : "maybePrepare" !== t || e ? "parseTile" !== t || e ? "parseTile" === t && e ? 300 - r : "maybePrepare" === t && e ? 400 - r : 500 : 200 - r : 100 - r;
            }(e);
          if (0 === n) {
            try {
              t();
            } finally {}
            return null;
          }
          return this.tasks[r] = {
            fn: t,
            metadata: e,
            priority: n,
            id: r
          }, this.taskQueue.push(r), this.invoker.trigger(), {
            cancel: function cancel() {
              delete _this61.tasks[r];
            }
          };
        }
      }, {
        key: "process",
        value: function process() {
          var _this62 = this;
          try {
            if (this.taskQueue = this.taskQueue.filter(function (t) {
              return !!_this62.tasks[t];
            }), !this.taskQueue.length) return;
            var _t331 = this.pick();
            if (null === _t331) return;
            var _e328 = this.tasks[_t331];
            if (delete this.tasks[_t331], this.taskQueue.length && this.invoker.trigger(), !_e328) return;
            _e328.fn();
          } finally {}
        }
      }, {
        key: "pick",
        value: function pick() {
          var t = null,
            e = 1 / 0;
          for (var _r268 = 0; _r268 < this.taskQueue.length; _r268++) {
            var _n195 = this.tasks[this.taskQueue[_r268]];
            _n195.priority < e && (e = _n195.priority, t = _r268);
          }
          if (null === t) return null;
          var r = this.taskQueue[t];
          return this.taskQueue.splice(t, 1), r;
        }
      }, {
        key: "remove",
        value: function remove() {
          this.invoker.remove();
        }
      }]);
      return xv;
    }();
    var bv = /*#__PURE__*/function () {
      function bv(t, e, r) {
        _classCallCheck(this, bv);
        this.target = t, this.parent = e, this.mapId = r, this.callbacks = {}, this.cancelCallbacks = {}, lr(["receive"], this), this.target.addEventListener("message", this.receive, !1), this.scheduler = new xv();
      }
      _createClass(bv, [{
        key: "send",
        value: function send(t, e, r, n) {
          var _this63 = this;
          var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
          var s = arguments.length > 5 ? arguments[5] : undefined;
          var a = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
          r && (r.metadata = s, this.callbacks[a] = r);
          var o = new Set();
          return this.target.postMessage({
            id: a,
            type: t,
            hasCallback: !!r,
            targetMapId: n,
            mustQueue: i,
            sourceMapId: this.mapId,
            data: ko(e, o)
          }, o), {
            cancel: function cancel() {
              r && delete _this63.callbacks[a], _this63.target.postMessage({
                id: a,
                type: "<cancel>",
                targetMapId: n,
                sourceMapId: _this63.mapId
              });
            }
          };
        }
      }, {
        key: "receive",
        value: function receive(t) {
          var _this64 = this;
          var e = t.data,
            r = e.id;
          if (r && (!e.targetMapId || this.mapId === e.targetMapId)) if ("<cancel>" === e.type) {
            var _t332 = this.cancelCallbacks[r];
            delete this.cancelCallbacks[r], _t332 && _t332.cancel();
          } else if (e.mustQueue || xr()) {
            var _t333 = this.callbacks[r],
              _n196 = this.scheduler.add(function () {
                return _this64.processTask(r, e);
              }, _t333 && _t333.metadata || {
                type: "message"
              });
            _n196 && (this.cancelCallbacks[r] = _n196);
          } else this.processTask(r, e);
        }
      }, {
        key: "processTask",
        value: function processTask(t, e) {
          var _this65 = this;
          if (delete this.cancelCallbacks[t], "<response>" === e.type) {
            var _r269 = this.callbacks[t];
            delete this.callbacks[t], _r269 && (e.error ? _r269(Po(e.error)) : _r269(null, Po(e.data)));
          } else {
            var _r270 = new Set(),
              _n197 = e.hasCallback ? function (e, n) {
                _this65.target.postMessage({
                  id: t,
                  type: "<response>",
                  sourceMapId: _this65.mapId,
                  error: e ? ko(e) : null,
                  data: ko(n, _r270)
                }, _r270);
              } : function (t) {},
              _i197 = Po(e.data);
            if (this.parent[e.type]) this.parent[e.type](e.sourceMapId, _i197, _n197);else if (this.parent.getWorkerSource) {
              var _t334 = e.type.split(".");
              this.parent.getWorkerSource(e.sourceMapId, _t334[0], _i197.source, _i197.scope)[_t334[1]](_i197, _n197);
            } else _n197(new Error("Could not find function ".concat(e.type)));
          }
        }
      }, {
        key: "remove",
        value: function remove() {
          this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
        }
      }]);
      return bv;
    }();
    var vv = /*#__PURE__*/function () {
      function vv(t, e) {
        var _this66 = this;
        _classCallCheck(this, vv);
        this.workerPool = t, this.actors = [], this.currentActor = 0, this.id = ir();
        var r = this.workerPool.acquire(this.id);
        for (var _t335 = 0; _t335 < r.length; _t335++) {
          var _n198 = new vv.Actor(r[_t335], e, this.id);
          _n198.name = "Worker ".concat(_t335), this.actors.push(_n198);
        }
        this.ready = !1, this.broadcast("checkIfReady", null, function () {
          _this66.ready = !0;
        });
      }
      _createClass(vv, [{
        key: "broadcast",
        value: function broadcast(t, e, r) {
          tr(this.actors, function (r, n) {
            r.send(t, e, n);
          }, r = r || function () {});
        }
      }, {
        key: "getActor",
        value: function getActor() {
          return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
        }
      }, {
        key: "remove",
        value: function remove() {
          this.actors.forEach(function (t) {
            t.remove();
          }), this.actors = [], this.workerPool.release(this.id);
        }
      }]);
      return vv;
    }();
    vv.Actor = bv;
    var _v = {
      workerUrl: "",
      workerClass: null,
      workerParams: void 0
    };
    function wv() {
      return null != _v.workerClass ? new _v.workerClass() : new self.Worker(_v.workerUrl, _v.workerParams);
    }
    var Mv = "mapboxgl_preloaded_worker_pool";
    var Av = /*#__PURE__*/function () {
      function Av() {
        _classCallCheck(this, Av);
        this.active = {};
      }
      _createClass(Av, [{
        key: "acquire",
        value: function acquire(t) {
          if (!this.workers) for (this.workers = []; this.workers.length < Av.workerCount;) this.workers.push(new wv());
          return this.active[t] = !0, this.workers.slice();
        }
      }, {
        key: "release",
        value: function release(t) {
          delete this.active[t], this.workers && 0 === this.numActive() && (this.workers.forEach(function (t) {
            t.terminate();
          }), this.workers = null);
        }
      }, {
        key: "isPreloaded",
        value: function isPreloaded() {
          return !!this.active[Mv];
        }
      }, {
        key: "numActive",
        value: function numActive() {
          return Object.keys(this.active).length;
        }
      }]);
      return Av;
    }();
    var Sv;
    function Iv() {
      return Sv || (Sv = new Av()), Sv;
    }
    Av.workerCount = 2;
    var Tv,
      kv,
      Pv,
      zv,
      Ev,
      Bv = null;
    function Dv() {
      return xr() && self.worker && self.worker.dracoUrl ? self.worker.dracoUrl : kv || n.DRACO_URL;
    }
    function Rv() {
      if (xr() && self.worker && self.worker.meshoptUrl) return self.worker.meshoptUrl;
      if (zv) return zv;
      var t = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 3, 2, 0, 0, 5, 3, 1, 0, 1, 12, 1, 0, 10, 22, 2, 12, 0, 65, 0, 65, 0, 65, 0, 252, 10, 0, 0, 11, 7, 0, 65, 0, 253, 15, 26, 11]);
      if ("object" != typeof WebAssembly) throw new Error("WebAssembly not supported, cannot instantiate meshoptimizer");
      return zv = WebAssembly.validate(t) ? n.MESHOPT_SIMD_URL : n.MESHOPT_URL, zv;
    }
    var Cv = {
        5120: Int8Array,
        5121: Uint8Array,
        5122: Int16Array,
        5123: Uint16Array,
        5125: Uint32Array,
        5126: Float32Array
      },
      Lv = {
        5120: "DT_INT8",
        5121: "DT_UINT8",
        5122: "DT_INT16",
        5123: "DT_UINT16",
        5125: "DT_UINT32",
        5126: "DT_FLOAT32"
      },
      Vv = {
        SCALAR: 1,
        VEC2: 2,
        VEC3: 3,
        VEC4: 4,
        MAT2: 4,
        MAT3: 9,
        MAT4: 16
      };
    function Fv(t, e, r) {
      var n = r.json.bufferViews.length,
        i = r.buffers.length;
      e.bufferView = n, r.json.bufferViews[n] = {
        buffer: i,
        byteLength: t.byteLength
      }, r.buffers[i] = t;
    }
    var Ov = "KHR_draco_mesh_compression";
    function Uv(t, e) {
      var r = t.extensions && t.extensions[Ov];
      if (!r) return;
      var n = new Pv.Decoder(),
        i = Yv(e, r.bufferView),
        s = new Pv.Mesh();
      if (!n.DecodeArrayToMesh(i, i.byteLength, s)) throw new Error("Failed to decode Draco mesh");
      var a = e.json.accessors[t.indices],
        o = Cv[a.componentType],
        l = a.count * o.BYTES_PER_ELEMENT,
        u = Pv._malloc(l);
      o === Uint16Array ? n.GetTrianglesUInt16Array(s, l, u) : n.GetTrianglesUInt32Array(s, l, u), Fv(Pv.memory.buffer.slice(u, u + l), a, e), Pv._free(u);
      for (var _i198 = 0, _Object$keys13 = Object.keys(r.attributes); _i198 < _Object$keys13.length; _i198++) {
        var _i199 = _Object$keys13[_i198];
        var _a123 = n.GetAttributeByUniqueId(s, r.attributes[_i199]),
          _o94 = e.json.accessors[t.attributes[_i199]],
          _l74 = Lv[_o94.componentType],
          _u60 = _o94.count * Vv[_o94.type] * Cv[_o94.componentType].BYTES_PER_ELEMENT,
          _c47 = Pv._malloc(_u60);
        n.GetAttributeDataArrayForAllPoints(s, _a123, Pv[_l74], _u60, _c47), Fv(Pv.memory.buffer.slice(_c47, _c47 + _u60), _o94, e), Pv._free(_c47);
      }
      n.destroy(), s.destroy(), delete t.extensions[Ov];
    }
    var jv = "EXT_meshopt_compression";
    function Nv(t, e) {
      if (!t.extensions || !t.extensions[jv]) return;
      var r = t.extensions[jv],
        n = new Uint8Array(e.buffers[r.buffer], r.byteOffset || 0, r.byteLength || 0),
        i = new Uint8Array(r.count * r.byteStride);
      Ev.decodeGltfBuffer(i, r.count, r.byteStride, n, r.mode, r.filter), t.buffer = e.buffers.length, t.byteOffset = 0, e.buffers[t.buffer] = i.buffer, delete t.extensions[jv];
    }
    var $v = 1179937895,
      qv = new TextDecoder("utf8");
    function Gv(t, e) {
      return new URL(t, e).href;
    }
    function Xv(t, e, r, n) {
      return fetch(Gv(t.uri, n)).then(function (t) {
        return t.arrayBuffer();
      }).then(function (t) {
        e.buffers[r] = t;
      });
    }
    function Yv(t, e) {
      var r = t.json.bufferViews[e];
      return new Uint8Array(t.buffers[r.buffer], r.byteOffset || 0, r.byteLength);
    }
    function Zv(t, e, r, n) {
      if (t.uri) {
        var _i200 = Gv(t.uri, n);
        return fetch(_i200).then(function (t) {
          return t.blob();
        }).then(function (t) {
          return createImageBitmap(t);
        }).then(function (t) {
          e.images[r] = t;
        });
      }
      if (void 0 !== t.bufferView) {
        var _n199 = Yv(e, t.bufferView),
          _i201 = new Blob([_n199], {
            type: t.mimeType
          });
        return createImageBitmap(_i201).then(function (t) {
          e.images[r] = t;
        });
      }
    }
    function Hv(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var r = arguments.length > 2 ? arguments[2] : undefined;
      var n = {
        json: null,
        images: [],
        buffers: []
      };
      if (new Uint32Array(t, e, 1)[0] === $v) {
        var _r271 = new Uint32Array(t, e);
        var _i202 = 2;
        var _s155 = (_r271[_i202++] >> 2) - 3,
          _a124 = _r271[_i202++] >> 2;
        if (_i202++, n.json = JSON.parse(qv.decode(_r271.subarray(_i202, _i202 + _a124))), _i202 += _a124, _i202 < _s155) {
          var _s156 = _r271[_i202++];
          _i202++;
          var _a125 = e + (_i202 << 2);
          n.buffers[0] = t.slice(_a125, _a125 + _s156);
        }
      } else n.json = JSON.parse(qv.decode(new Uint8Array(t, e)));
      var _n$json = n.json,
        i = _n$json.buffers,
        s = _n$json.images,
        a = _n$json.meshes,
        o = _n$json.extensionsUsed,
        l = _n$json.bufferViews;
      var u = Promise.resolve();
      if (i) {
        var _t336 = [];
        for (var _e329 = 0; _e329 < i.length; _e329++) {
          var _s157 = i[_e329];
          _s157.uri ? _t336.push(Xv(_s157, n, _e329, r)) : n.buffers[_e329] || (n.buffers[_e329] = null);
        }
        u = Promise.all(_t336);
      }
      return u.then(function () {
        var t = [],
          e = o && o.includes(Ov),
          i = o && o.includes(jv);
        if (e && t.push(function () {
          if (!Pv) return Tv || (Tv = function (t) {
            var e,
              r = null;
            function n() {
              e = new Uint8Array(r.buffer);
            }
            function i() {
              throw new Error("Unexpected Draco error.");
            }
            var s = {
              a: {
                a: i,
                d: function d(t, r, n) {
                  return e.copyWithin(t, r, r + n);
                },
                c: function c(t) {
                  var i = e.length,
                    s = Math.max(t >>> 0, Math.ceil(1.2 * i)),
                    a = Math.ceil((s - i) / 65536);
                  try {
                    return r.grow(a), n(), !0;
                  } catch (t) {
                    return !1;
                  }
                },
                b: i
              }
            };
            return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(t, s) : t.then(function (t) {
              return t.arrayBuffer();
            }).then(function (t) {
              return WebAssembly.instantiate(t, s);
            })).then(function (t) {
              var _t$instance$exports = t.instance.exports,
                i = _t$instance$exports.Rb,
                s = _t$instance$exports.Qb,
                a = _t$instance$exports.P,
                o = _t$instance$exports.T,
                l = _t$instance$exports.X,
                u = _t$instance$exports.Ja,
                c = _t$instance$exports.La,
                h = _t$instance$exports.Qa,
                p = _t$instance$exports.Va,
                f = _t$instance$exports.Wa,
                d = _t$instance$exports.eb,
                m = _t$instance$exports.jb,
                y = _t$instance$exports.f,
                g = _t$instance$exports.e,
                x = _t$instance$exports.yb,
                b = _t$instance$exports.zb,
                v = _t$instance$exports.Ab,
                _ = _t$instance$exports.Bb,
                w = _t$instance$exports.Db,
                M = _t$instance$exports.Gb;
              r = g;
              var A = function () {
                var t = 0,
                  r = 0,
                  n = 0,
                  a = 0;
                return function (o) {
                  n && (i(a), i(t), r += n, n = t = 0), t || (r += 128, t = s(r));
                  var l = o.length + 7 & -8;
                  var u = t;
                  l >= r && (n = l, u = a = s(l));
                  for (var _t337 = 0; _t337 < o.length; _t337++) e[u + _t337] = o[_t337];
                  return u;
                };
              }();
              return n(), y(), {
                memory: g,
                _free: i,
                _malloc: s,
                Mesh: /*#__PURE__*/function () {
                  function Mesh() {
                    _classCallCheck(this, Mesh);
                    this.ptr = a();
                  }
                  _createClass(Mesh, [{
                    key: "destroy",
                    value: function destroy() {
                      o(this.ptr);
                    }
                  }]);
                  return Mesh;
                }(),
                Decoder: /*#__PURE__*/function () {
                  function Decoder() {
                    _classCallCheck(this, Decoder);
                    this.ptr = u();
                  }
                  _createClass(Decoder, [{
                    key: "destroy",
                    value: function destroy() {
                      m(this.ptr);
                    }
                  }, {
                    key: "DecodeArrayToMesh",
                    value: function DecodeArrayToMesh(t, e, r) {
                      var n = A(t),
                        i = c(this.ptr, n, e, r.ptr);
                      return !!l(i);
                    }
                  }, {
                    key: "GetAttributeByUniqueId",
                    value: function GetAttributeByUniqueId(t, e) {
                      return {
                        ptr: h(this.ptr, t.ptr, e)
                      };
                    }
                  }, {
                    key: "GetTrianglesUInt16Array",
                    value: function GetTrianglesUInt16Array(t, e, r) {
                      p(this.ptr, t.ptr, e, r);
                    }
                  }, {
                    key: "GetTrianglesUInt32Array",
                    value: function GetTrianglesUInt32Array(t, e, r) {
                      f(this.ptr, t.ptr, e, r);
                    }
                  }, {
                    key: "GetAttributeDataArrayForAllPoints",
                    value: function GetAttributeDataArrayForAllPoints(t, e, r, n, i) {
                      d(this.ptr, t.ptr, e.ptr, r, n, i);
                    }
                  }]);
                  return Decoder;
                }(),
                DT_INT8: x(),
                DT_UINT8: b(),
                DT_INT16: v(),
                DT_UINT16: _(),
                DT_UINT32: w(),
                DT_FLOAT32: M()
              };
            });
          }(fetch(Dv())), Tv.then(function (t) {
            Pv = t, Tv = void 0;
          }));
        }()), i && t.push(function () {
          if (Ev) return;
          var t = function (t) {
            var e;
            var r = WebAssembly.instantiateStreaming(t, {}).then(function (t) {
                e = t.instance, e.exports.__wasm_call_ctors();
              }),
              n = {
                NONE: "",
                OCTAHEDRAL: "meshopt_decodeFilterOct",
                QUATERNION: "meshopt_decodeFilterQuat",
                EXPONENTIAL: "meshopt_decodeFilterExp"
              },
              i = {
                ATTRIBUTES: "meshopt_decodeVertexBuffer",
                TRIANGLES: "meshopt_decodeIndexBuffer",
                INDICES: "meshopt_decodeIndexSequence"
              };
            return {
              ready: r,
              supported: !0,
              decodeGltfBuffer: function decodeGltfBuffer(t, r, s, a, o, l) {
                !function (t, e, r, n, i, s, a) {
                  var o = t.exports.sbrk,
                    l = n + 3 & -4,
                    u = o(l * i),
                    c = o(s.length),
                    h = new Uint8Array(t.exports.memory.buffer);
                  h.set(s, c);
                  var p = e(u, n, i, c, s.length);
                  if (0 === p && a && a(u, l, i), r.set(h.subarray(u, u + n * i)), o(u - o(0)), 0 !== p) throw new Error("Malformed buffer data: ".concat(p));
                }(e, e.exports[i[o]], t, r, s, a, e.exports[n[l]]);
              }
            };
          }(fetch(Rv()));
          return t.ready.then(function () {
            Ev = t;
          });
        }()), s) for (var _e330 = 0; _e330 < s.length; _e330++) t.push(Zv(s[_e330], n, _e330, r));
        return (t.length ? Promise.all(t) : Promise.resolve()).then(function () {
          if (e && a) {
            var _iterator216 = _createForOfIteratorHelper(a),
              _step216;
            try {
              for (_iterator216.s(); !(_step216 = _iterator216.n()).done;) {
                var _t338 = _step216.value.primitives;
                var _iterator217 = _createForOfIteratorHelper(_t338),
                  _step217;
                try {
                  for (_iterator217.s(); !(_step217 = _iterator217.n()).done;) {
                    var _e331 = _step217.value;
                    Uv(_e331, n);
                  }
                } catch (err) {
                  _iterator217.e(err);
                } finally {
                  _iterator217.f();
                }
              }
            } catch (err) {
              _iterator216.e(err);
            } finally {
              _iterator216.f();
            }
          }
          if (i && a && l) {
            var _iterator218 = _createForOfIteratorHelper(l),
              _step218;
            try {
              for (_iterator218.s(); !(_step218 = _iterator218.n()).done;) {
                var _t339 = _step218.value;
                Nv(_t339, n);
              }
            } catch (err) {
              _iterator218.e(err);
            } finally {
              _iterator218.f();
            }
          }
          return n;
        });
      });
    }
    function Kv(t, e) {
      var r = t.json.bufferViews[e.bufferView],
        n = Cv[e.componentType];
      return new n(t.buffers[r.buffer], (e.byteOffset || 0) + (r.byteOffset || 0), e.count * (r.byteStride && r.byteStride !== Vv[e.type] * n.BYTES_PER_ELEMENT ? r.byteStride / n.BYTES_PER_ELEMENT : Vv[e.type]));
    }
    function Wv(t, e, r, n) {
      var i = Cv[e.componentType],
        s = function (t) {
          switch (t) {
            case Int8Array:
              return 1 / 127;
            case Uint8Array:
              return 1 / 255;
            case Int16Array:
              return 1 / 32767;
            case Uint16Array:
              return 1 / 65535;
            default:
              return 1;
          }
        }(i),
        a = t.json.bufferViews[e.bufferView],
        o = a.byteStride ? a.byteStride / i.BYTES_PER_ELEMENT : Vv[e.type],
        l = r.float32,
        u = l.length / r.capacity;
      for (var _t340 = 0, _r272 = 0; _t340 < e.count * o; _t340 += o, _r272 += u) for (var _e332 = 0; _e332 < u; _e332++) l[_r272 + _e332] = n[_t340 + _e332] * s;
      r._trim();
    }
    function Jv(t, e, r) {
      var n = t.indices,
        i = t.attributes,
        s = {};
      s.indexArray = new tu();
      var a = e.json.accessors[n],
        o = a.count / 3;
      s.indexArray.reserve(o);
      var l = Kv(e, a);
      for (var _t341 = 0; _t341 < o; _t341++) s.indexArray.emplaceBack(l[3 * _t341], l[3 * _t341 + 1], l[3 * _t341 + 2]);
      s.indexArray._trim(), s.vertexArray = new Nl();
      var u = e.json.accessors[i.POSITION];
      s.vertexArray.reserve(u.count);
      var c = Kv(e, u);
      for (var _t342 = 0; _t342 < u.count; _t342++) s.vertexArray.emplaceBack(c[3 * _t342], c[3 * _t342 + 1], c[3 * _t342 + 2]);
      if (s.vertexArray._trim(), s.aabb = new kh(u.min, u.max), s.centroid = function (t, e) {
        var r = [0, 0, 0],
          n = t.length;
        if (n > 0) {
          for (var _i203 = 0; _i203 < n; _i203++) {
            var _n200 = 3 * t[_i203];
            r[0] += e[_n200], r[1] += e[_n200 + 1], r[2] += e[_n200 + 2];
          }
          r[0] /= n, r[1] /= n, r[2] /= n;
        }
        return r;
      }(l, c), void 0 !== i.COLOR_0) {
        var _t343 = e.json.accessors[i.COLOR_0],
          _r273 = Vv[_t343.type],
          _n201 = Kv(e, _t343);
        s.colorArray = 3 === _r273 ? new Nl() : new jl(), s.colorArray.resize(_t343.count), Wv(e, _t343, s.colorArray, _n201);
      }
      if (void 0 !== i.NORMAL) {
        s.normalArray = new Nl();
        var _t344 = e.json.accessors[i.NORMAL];
        s.normalArray.resize(_t344.count);
        var _r274 = Kv(e, _t344);
        Wv(e, _t344, s.normalArray, _r274);
      }
      if (void 0 !== i.TEXCOORD_0 && r.length > 0) {
        s.texcoordArray = new lu();
        var _t345 = e.json.accessors[i.TEXCOORD_0];
        s.texcoordArray.resize(_t345.count);
        var _r275 = Kv(e, _t345);
        Wv(e, _t345, s.texcoordArray, _r275);
      }
      if (void 0 !== i._FEATURE_ID_RGBA4444) {
        var _t346 = e.json.accessors[i._FEATURE_ID_RGBA4444];
        e.json.extensionsUsed && e.json.extensionsUsed.includes("EXT_meshopt_compression") && (s.featureData = Kv(e, _t346));
      }
      void 0 !== i._FEATURE_RGBA4444 && (s.featureData = new Uint32Array(Kv(e, e.json.accessors[i._FEATURE_RGBA4444]).buffer));
      var h = t.material;
      return s.material = function (t, e) {
        var _t$emissiveFactor = t.emissiveFactor,
          r = _t$emissiveFactor === void 0 ? [0, 0, 0] : _t$emissiveFactor,
          _t$alphaMode = t.alphaMode,
          n = _t$alphaMode === void 0 ? "OPAQUE" : _t$alphaMode,
          _t$alphaCutoff = t.alphaCutoff,
          i = _t$alphaCutoff === void 0 ? .5 : _t$alphaCutoff,
          s = t.normalTexture,
          a = t.occlusionTexture,
          o = t.emissiveTexture,
          l = t.doubleSided,
          _ref143 = t.pbrMetallicRoughness || {},
          _ref143$baseColorFact = _ref143.baseColorFactor,
          u = _ref143$baseColorFact === void 0 ? [1, 1, 1, 1] : _ref143$baseColorFact,
          _ref143$metallicFacto = _ref143.metallicFactor,
          c = _ref143$metallicFacto === void 0 ? 1 : _ref143$metallicFacto,
          _ref143$roughnessFact = _ref143.roughnessFactor,
          h = _ref143$roughnessFact === void 0 ? 1 : _ref143$roughnessFact,
          p = _ref143.baseColorTexture,
          f = _ref143.metallicRoughnessTexture,
          d = a ? e[a.index] : void 0;
        if (a && a.extensions && a.extensions.KHR_texture_transform && d) {
          var _t347 = a.extensions.KHR_texture_transform;
          d.offsetScale = [_t347.offset[0], _t347.offset[1], _t347.scale[0], _t347.scale[1]];
        }
        return {
          pbrMetallicRoughness: {
            baseColorFactor: _construct2(Gn, _toConsumableArray(u)),
            metallicFactor: c,
            roughnessFactor: h,
            baseColorTexture: p ? e[p.index] : void 0,
            metallicRoughnessTexture: f ? e[f.index] : void 0
          },
          doubleSided: l,
          emissiveFactor: r,
          alphaMode: n,
          alphaCutoff: i,
          normalTexture: s ? e[s.index] : void 0,
          occlusionTexture: d,
          emissionTexture: o ? e[o.index] : void 0,
          defined: void 0 === t.defined
        };
      }(void 0 !== h ? e.json.materials[h] : {
        defined: !1
      }, r), s;
    }
    function Qv(e, r, n) {
      var i = e.matrix,
        s = e.rotation,
        a = e.translation,
        o = e.scale,
        l = e.mesh,
        u = e.extras,
        c = e.children,
        h = {};
      if (h.matrix = i || t.ae.fromRotationTranslationScale([], s || [0, 0, 0, 1], a || [0, 0, 0], o || [1, 1, 1]), void 0 !== l) {
        h.meshes = n[l];
        var _t348 = h.anchor = [0, 0];
        var _iterator219 = _createForOfIteratorHelper(h.meshes),
          _step219;
        try {
          for (_iterator219.s(); !(_step219 = _iterator219.n()).done;) {
            var _e333 = _step219.value;
            var _e333$aabb = _e333.aabb,
              _r276 = _e333$aabb.min,
              _n202 = _e333$aabb.max;
            _t348[0] += _r276[0] + _n202[0], _t348[1] += _r276[1] + _n202[1];
          }
        } catch (err) {
          _iterator219.e(err);
        } finally {
          _iterator219.f();
        }
        _t348[0] = Math.floor(_t348[0] / h.meshes.length / 2), _t348[1] = Math.floor(_t348[1] / h.meshes.length / 2);
      }
      if (u && (u.id && (h.id = u.id), u.lights && (h.lights = function (t) {
        if (!t.length) return [];
        var e = function (t) {
            var e = atob(t),
              r = new Uint8Array(e.length);
            for (var _t349 = 0; _t349 < e.length; _t349++) r[_t349] = e.codePointAt(_t349);
            return r;
          }(t),
          r = [],
          n = e.length / 24,
          i = new Uint16Array(e.buffer),
          s = new Float32Array(e.buffer);
        for (var _t350 = 0; _t350 < n; _t350++) {
          var _e334 = i[2 * _t350 * 6] / 30,
            _n203 = i[2 * _t350 * 6 + 1] / 30,
            _a126 = i[2 * _t350 * 6 + 10] / 100,
            _o95 = s[6 * _t350 + 1],
            _l75 = s[6 * _t350 + 2],
            _u61 = s[6 * _t350 + 3],
            _c48 = s[6 * _t350 + 4],
            _h38 = _u61 - _o95,
            _p33 = _c48 - _l75,
            _f29 = Math.hypot(_h38, _p33);
          r.push({
            pos: [_o95 + .5 * _h38, _l75 + .5 * _p33, _n203],
            normal: [_p33 / _f29, -_h38 / _f29, 0],
            width: _f29,
            height: _e334,
            depth: _a126,
            points: [_o95, _l75, _u61, _c48]
          });
        }
        return r;
      }(u.lights))), c) {
        var _t351 = [];
        var _iterator220 = _createForOfIteratorHelper(c),
          _step220;
        try {
          for (_iterator220.s(); !(_step220 = _iterator220.n()).done;) {
            var _e335 = _step220.value;
            _t351.push(Qv(r.json.nodes[_e335], r, n));
          }
        } catch (err) {
          _iterator220.e(err);
        } finally {
          _iterator220.f();
        }
        h.children = _t351;
      }
      return h;
    }
    function t_(t) {
      if (0 === t.vertices.length || 0 === t.indices.length) return null;
      var e = new of(t.vertices, t.indices, 8, 256),
        _ref144 = [e.min.clone(), e.max.clone()],
        r = _ref144[0],
        n = _ref144[1];
      return {
        vertices: t.vertices,
        indices: t.indices,
        grid: e,
        min: r,
        max: n
      };
    }
    function e_(t) {
      if (!t.extras || !t.extras.ground) return null;
      var e = t.extras.ground;
      if (!e || !Array.isArray(e) || 0 === e.length) return null;
      var r = e[0];
      if (!r || !Array.isArray(r) || 0 === r.length) return null;
      var n = [];
      var _iterator221 = _createForOfIteratorHelper(r),
        _step221;
      try {
        for (_iterator221.s(); !(_step221 = _iterator221.n()).done;) {
          var _t353 = _step221.value;
          if (!Array.isArray(_t353) || 2 !== _t353.length) continue;
          var _e337 = _t353[0],
            _r278 = _t353[1];
          "number" == typeof _e337 && "number" == typeof _r278 && n.push(new je(_e337, _r278));
        }
      } catch (err) {
        _iterator221.e(err);
      } finally {
        _iterator221.f();
      }
      if (n.length < 3) return null;
      n.length > 1 && n[n.length - 1].equals(n[0]) && n.pop();
      var i = 0;
      for (var _t352 = 0; _t352 < n.length; _t352++) {
        var _e336 = n[_t352],
          _r277 = n[(_t352 + 1) % n.length],
          _s158 = n[(_t352 + 2) % n.length];
        i += (_e336.x - _r277.x) * (_s158.y - _r277.y) - (_s158.x - _r277.x) * (_e336.y - _r277.y);
      }
      i > 0 && n.reverse();
      var s = Ip(n.flatMap(function (t) {
        return [t.x, t.y];
      }), []);
      return 0 === s.length ? null : {
        vertices: n,
        indices: s
      };
    }
    function r_(e, r) {
      var n = [],
        i = [];
      var s = 0;
      var a = [];
      var _iterator222 = _createForOfIteratorHelper(e),
        _step222;
      try {
        for (_iterator222.s(); !(_step222 = _iterator222.n()).done;) {
          var _o96 = _step222.value;
          s = n.length;
          var _e339 = _o96.vertexArray.float32,
            _l76 = _o96.indexArray.uint16;
          for (var _i204 = 0; _i204 < _o96.vertexArray.length; _i204++) a[0] = _e339[3 * _i204 + 0], a[1] = _e339[3 * _i204 + 1], a[2] = _e339[3 * _i204 + 2], t.$.transformMat4(a, a, r), n.push(new je(a[0], a[1]));
          for (var _t355 = 0; _t355 < 3 * _o96.indexArray.length; _t355++) i.push(_l76[_t355] + s);
        }
      } catch (err) {
        _iterator222.e(err);
      } finally {
        _iterator222.f();
      }
      if (i.length % 3 != 0) return null;
      for (var _t354 = 0; _t354 < i.length; _t354 += 3) {
        var _ref145;
        var _e338 = n[i[_t354 + 0]],
          _r279 = n[i[_t354 + 1]],
          _s159 = n[i[_t354 + 2]];
        (_e338.x - _r279.x) * (_s159.y - _r279.y) - (_s159.x - _r279.x) * (_e338.y - _r279.y) > 0 && (_ref145 = [i[_t354 + 2], i[_t354 + 1]], i[_t354 + 1] = _ref145[0], i[_t354 + 2] = _ref145[1], _ref145);
      }
      return {
        vertices: n,
        indices: i
      };
    }
    function n_(t) {
      var e = function (t, e) {
          var r = [],
            n = WebGL2RenderingContext;
          if (t.json.textures) {
            var _iterator223 = _createForOfIteratorHelper(t.json.textures),
              _step223;
            try {
              for (_iterator223.s(); !(_step223 = _iterator223.n()).done;) {
                var _i205 = _step223.value;
                var _s160 = {
                  magFilter: n.LINEAR,
                  minFilter: n.NEAREST,
                  wrapS: n.REPEAT,
                  wrapT: n.REPEAT
                };
                void 0 !== _i205.sampler && Object.assign(_s160, t.json.samplers[_i205.sampler]), r.push({
                  image: e[_i205.source],
                  sampler: _s160,
                  uploaded: !1
                });
              }
            } catch (err) {
              _iterator223.e(err);
            } finally {
              _iterator223.f();
            }
          }
          return r;
        }(t, t.images),
        r = function (t, e) {
          var r = [];
          var _iterator224 = _createForOfIteratorHelper(t.json.meshes),
            _step224;
          try {
            for (_iterator224.s(); !(_step224 = _iterator224.n()).done;) {
              var _n204 = _step224.value;
              var _i206 = [];
              var _iterator225 = _createForOfIteratorHelper(_n204.primitives),
                _step225;
              try {
                for (_iterator225.s(); !(_step225 = _iterator225.n()).done;) {
                  var _r280 = _step225.value;
                  _i206.push(Jv(_r280, t, e));
                }
              } catch (err) {
                _iterator225.e(err);
              } finally {
                _iterator225.f();
              }
              r.push(_i206);
            }
          } catch (err) {
            _iterator224.e(err);
          } finally {
            _iterator224.f();
          }
          return r;
        }(t, e),
        _t$json = t.json,
        n = _t$json.scenes,
        i = _t$json.scene,
        s = _t$json.nodes,
        a = n ? n[i || 0].nodes : s,
        o = [];
      var _iterator226 = _createForOfIteratorHelper(a),
        _step226;
      try {
        for (_iterator226.s(); !(_step226 = _iterator226.n()).done;) {
          var _e341 = _step226.value;
          o.push(Qv(s[_e341], t, r));
        }
      } catch (err) {
        _iterator226.e(err);
      } finally {
        _iterator226.f();
      }
      return function (t, e, r) {
        var n = {},
          i = new Set();
        for (var _s161 = 0; _s161 < t.length; _s161++) {
          var _t356 = r[e[_s161]];
          if (!_t356.extras) continue;
          var _a127 = _t356.extras["mapbox:footprint:version"],
            _o97 = _t356.extras["mapbox:footprint:id"];
          (_a127 || _o97) && i.add(_s161), "1.0.0" === _a127 && _o97 && (n[_o97] = _s161);
        }
        for (var _s162 = 0; _s162 < t.length; _s162++) {
          if (i.has(_s162)) continue;
          var _a128 = t[_s162],
            _o98 = r[e[_s162]];
          if (!_o98.extras) continue;
          var _l77 = null;
          _a128.id in n && (_l77 = r_(t[n[_a128.id]].meshes, _a128.matrix)), _l77 || (_l77 = e_(_o98)), _l77 && (_a128.footprint = t_(_l77));
        }
        if (i.size > 0) {
          var _e340 = Array.from(i.values()).sort(function (t, e) {
            return t - e;
          });
          for (var _r281 = _e340.length - 1; _r281 >= 0; _r281--) t.splice(_e340[_r281], 1);
        }
      }(o, a, t.json.nodes), o;
    }
    function i_(t) {
      t.heightmap = new Float32Array(4096), t.heightmap.fill(-1);
      var e = t.vertexArray.float32,
        r = t.aabb.min[0] - 1,
        n = t.aabb.min[1] - 1,
        i = uv / (t.aabb.max[0] - r + 2),
        s = uv / (t.aabb.max[1] - n + 2);
      for (var _a129 = 0; _a129 < e.length; _a129 += 3) {
        var _o99 = e[_a129 + 2],
          _l78 = (e[_a129 + 0] - r) * i | 0,
          _u62 = (e[_a129 + 1] - n) * s | 0;
        _o99 > t.heightmap[_u62 * uv + _l78] && (t.heightmap[_u62 * uv + _l78] = _o99);
      }
    }
    function s_(e, r) {
      var n = {};
      n.indexArray = new tu(), n.indexArray.reserve(4 * e.length), n.vertexArray = new Nl(), n.vertexArray.reserve(10 * e.length), n.colorArray = new jl(), n.vertexArray.reserve(10 * e.length);
      var i = 0;
      var _iterator227 = _createForOfIteratorHelper(e),
        _step227;
      try {
        for (_iterator227.s(); !(_step227 = _iterator227.n()).done;) {
          var _s163 = _step227.value;
          var _e342 = Math.min(10, Math.max(4, 1.3 * _s163.height)) * r,
            _a130 = [-_s163.normal[1], _s163.normal[0], 0],
            _o100 = Math.min(.29, .1 * _s163.width / _s163.depth),
            _l79 = _s163.width - 2 * _s163.depth * r * (_o100 + .01),
            _u63 = t.$.scaleAndAdd([], _s163.pos, _a130, _l79 / 2),
            _c49 = t.$.scaleAndAdd([], _s163.pos, _a130, -_l79 / 2),
            _h39 = [_u63[0], _u63[1], _u63[2] + _s163.height],
            _p34 = [_c49[0], _c49[1], _c49[2] + _s163.height],
            _f30 = t.$.scaleAndAdd([], _s163.normal, _a130, _o100);
          t.$.scale(_f30, _f30, _e342);
          var _d22 = t.$.scaleAndAdd([], _s163.normal, _a130, -_o100);
          t.$.scale(_d22, _d22, _e342), t.$.add(_f30, _u63, _f30), t.$.add(_d22, _c49, _d22), _u63[2] += .1, _c49[2] += .1, n.vertexArray.emplaceBack(_f30[0], _f30[1], _f30[2]), n.vertexArray.emplaceBack(_d22[0], _d22[1], _d22[2]), n.vertexArray.emplaceBack(_u63[0], _u63[1], _u63[2]), n.vertexArray.emplaceBack(_c49[0], _c49[1], _c49[2]), n.vertexArray.emplaceBack(_h39[0], _h39[1], _h39[2]), n.vertexArray.emplaceBack(_p34[0], _p34[1], _p34[2]), n.vertexArray.emplaceBack(_u63[0], _u63[1], _u63[2]), n.vertexArray.emplaceBack(_c49[0], _c49[1], _c49[2]), n.vertexArray.emplaceBack(_f30[0], _f30[1], _f30[2]), n.vertexArray.emplaceBack(_d22[0], _d22[1], _d22[2]);
          var _m16 = _l79 / _e342 / 2;
          n.colorArray.emplaceBack(-_m16 - _o100, -1, _m16, .8), n.colorArray.emplaceBack(_m16 + _o100, -1, _m16, .8), n.colorArray.emplaceBack(-_m16, 0, _m16, 1.3), n.colorArray.emplaceBack(_m16, 0, _m16, 1.3), n.colorArray.emplaceBack(_m16 + _o100, -.8, _m16, .7), n.colorArray.emplaceBack(_m16 + _o100, -.8, _m16, .7), n.colorArray.emplaceBack(0, 0, _m16, 1.3), n.colorArray.emplaceBack(0, 0, _m16, 1.3), n.colorArray.emplaceBack(_m16 + _o100, -1.2, _m16, .8), n.colorArray.emplaceBack(_m16 + _o100, -1.2, _m16, .8), n.indexArray.emplaceBack(6 + i, 4 + i, 8 + i), n.indexArray.emplaceBack(7 + i, 9 + i, 5 + i), n.indexArray.emplaceBack(0 + i, 1 + i, 2 + i), n.indexArray.emplaceBack(1 + i, 3 + i, 2 + i), i += 10;
        }
      } catch (err) {
        _iterator227.e(err);
      } finally {
        _iterator227.f();
      }
      var s = {
          defined: !0,
          emissiveFactor: [0, 0, 0]
        },
        a = {};
      return a.baseColorFactor = Gn.white, s.pbrMetallicRoughness = a, n.material = s, n.aabb = new kh([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), n;
    }
    var a_ = new Float32Array(262144),
      o_ = new Uint8Array(262144);
    function l_(t) {
      var e = 0;
      if (t.meshes) {
        var _iterator228 = _createForOfIteratorHelper(t.meshes),
          _step228;
        try {
          for (_iterator228.s(); !(_step228 = _iterator228.n()).done;) {
            var _r282 = _step228.value;
            e = Math.max(e, _r282.aabb.max[2]);
          }
        } catch (err) {
          _iterator228.e(err);
        } finally {
          _iterator228.f();
        }
      }
      if (t.children) {
        var _iterator229 = _createForOfIteratorHelper(t.children),
          _step229;
        try {
          for (_iterator229.s(); !(_step229 = _iterator229.n()).done;) {
            var _r283 = _step229.value;
            e = Math.max(e, l_(_r283));
          }
        } catch (err) {
          _iterator229.e(err);
        } finally {
          _iterator229.f();
        }
      }
      return e;
    }
    function u_(t, e, r) {
      if (t.meshes) {
        var _iterator230 = _createForOfIteratorHelper(t.meshes),
          _step230;
        try {
          for (_iterator230.s(); !(_step230 = _iterator230.n()).done;) {
            var _n205 = _step230.value;
            _n205.aabb.min[0] !== 1 / 0 && r.insert(e, _n205.aabb.min[0], _n205.aabb.min[1], _n205.aabb.max[0], _n205.aabb.max[1]);
          }
        } catch (err) {
          _iterator230.e(err);
        } finally {
          _iterator230.f();
        }
      }
      if (t.children) {
        var _iterator231 = _createForOfIteratorHelper(t.children),
          _step231;
        try {
          for (_iterator231.s(); !(_step231 = _iterator231.n()).done;) {
            var _n206 = _step231.value;
            u_(_n206, e, r);
          }
        } catch (err) {
          _iterator231.e(err);
        } finally {
          _iterator231.f();
        }
      }
    }
    var c_ = ["", "wall", "door", "roof", "window", "lamp", "logo"];
    var h_ = /*#__PURE__*/function () {
      function h_(t) {
        _classCallCheck(this, h_);
        this.node = t, this.evaluatedRMEA = [[1, 0, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1], [.4, 1, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1]], this.hiddenByReplacement = !1, this.evaluatedScale = [1, 1, 1], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.feature = {
          type: "Point",
          id: t.id,
          geometry: [],
          properties: {
            height: l_(t)
          }
        }, this.aabb = this._getLocalBounds();
      }
      _createClass(h_, [{
        key: "_getLocalBounds",
        value: function _getLocalBounds() {
          if (!this.node.meshes) return new kh([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]);
          if (!this.aabb) {
            var _t357 = 0;
            var _e343 = new kh([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]);
            var _iterator232 = _createForOfIteratorHelper(this.node.meshes),
              _step232;
            try {
              for (_iterator232.s(); !(_step232 = _iterator232.n()).done;) {
                var _r284 = _step232.value;
                this.node.lightMeshIndex !== _t357 && (_r284.transformedAabb = kh.applyTransformFast(_r284.aabb, this.node.matrix), _e343.encapsulate(_r284.transformedAabb)), _t357++;
              }
            } catch (err) {
              _iterator232.e(err);
            } finally {
              _iterator232.f();
            }
            this.aabb = _e343;
          }
          return this.aabb;
        }
      }]);
      return h_;
    }();
    var p_ = /*#__PURE__*/function () {
      function p_(t, e, r, n, i, s) {
        _classCallCheck(this, p_);
        this.id = e, this.modelTraits |= cv.CoordinateSpaceTile, this.uploaded = !1, this.hasPattern = !1, r && (this.modelTraits |= cv.HasMapboxMeshFeatures), n && (this.modelTraits |= cv.HasMeshoptCompression), this.zoom = -1, this.terrainExaggeration = 1, this.projection = {
          name: "mercator"
        }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = i, this.dirty = !0, this.needsUpload = !1, this.nodesInfo = [];
        var _iterator233 = _createForOfIteratorHelper(t),
          _step233;
        try {
          for (_iterator233.s(); !(_step233 = _iterator233.n()).done;) {
            var _e344 = _step233.value;
            this.nodesInfo.push(new h_(_e344)), u_(_e344, s.featureIndexArray.length, s.grid), s.featureIndexArray.emplaceBack(this.nodesInfo.length - 1, 0, s.bucketLayerIDs.length - 1, 0);
          }
        } catch (err) {
          _iterator233.e(err);
        } finally {
          _iterator233.f();
        }
      }
      _createClass(p_, [{
        key: "updateFootprints",
        value: function updateFootprints(t, e) {
          var _iterator234 = _createForOfIteratorHelper(this.getNodesInfo()),
            _step234;
          try {
            for (_iterator234.s(); !(_step234 = _iterator234.n()).done;) {
              var _r285 = _step234.value;
              var _n207 = _r285.node;
              _n207.footprint && e.push({
                footprint: _n207.footprint,
                id: t
              });
            }
          } catch (err) {
            _iterator234.e(err);
          } finally {
            _iterator234.f();
          }
        }
      }, {
        key: "update",
        value: function update() {
          console.log("Update 3D model bucket");
        }
      }, {
        key: "populate",
        value: function populate() {
          console.log("populate 3D model bucket");
        }
      }, {
        key: "uploadPending",
        value: function uploadPending() {
          return !this.uploaded || this.needsUpload;
        }
      }, {
        key: "upload",
        value: function upload(t) {
          if (!this.needsUpload) return;
          var e = this.getNodesInfo();
          var _iterator235 = _createForOfIteratorHelper(e),
            _step235;
          try {
            for (_iterator235.s(); !(_step235 = _iterator235.n()).done;) {
              var _r286 = _step235.value;
              var _e345 = _r286.node;
              this.uploaded ? this.updatePbrBuffer(_e345) : dv(_e345, t, !0);
            }
          } catch (err) {
            _iterator235.e(err);
          } finally {
            _iterator235.f();
          }
          var _iterator236 = _createForOfIteratorHelper(e),
            _step236;
          try {
            for (_iterator236.s(); !(_step236 = _iterator236.n()).done;) {
              var _t358 = _step236.value;
              mv(_t358.node);
            }
          } catch (err) {
            _iterator236.e(err);
          } finally {
            _iterator236.f();
          }
          this.uploaded = !0, this.needsUpload = !1;
        }
      }, {
        key: "updatePbrBuffer",
        value: function updatePbrBuffer(t) {
          var e = !1;
          if (!t.meshes) return e;
          var _iterator237 = _createForOfIteratorHelper(t.meshes),
            _step237;
          try {
            for (_iterator237.s(); !(_step237 = _iterator237.n()).done;) {
              var _r287 = _step237.value;
              _r287.pbrBuffer && (_r287.pbrBuffer.updateData(_r287.featureArray), e = !0);
            }
          } catch (err) {
            _iterator237.e(err);
          } finally {
            _iterator237.f();
          }
          return e;
        }
      }, {
        key: "needsReEvaluation",
        value: function needsReEvaluation(t, e, r) {
          var n = t.transform.projectionOptions,
            i = t.style.getBrightness(),
            s = this.brightness !== i;
          return !!(!this.uploaded || this.dirty || n.name !== this.projection.name || f_(r.paint.get("model-color").value, s) || f_(r.paint.get("model-color-mix-intensity").value, s) || f_(r.paint.get("model-roughness").value, s) || f_(r.paint.get("model-emissive-strength").value, s) || f_(r.paint.get("model-height-based-emissive-strength-multiplier").value, s)) && (this.projection = n, this.brightness = i, !0);
        }
      }, {
        key: "evaluateScale",
        value: function evaluateScale(t, e) {
          if (t.transform.zoom === this.zoom) return;
          this.zoom = t.transform.zoom;
          var r = this.getNodesInfo(),
            n = this.id.canonical;
          var _iterator238 = _createForOfIteratorHelper(r),
            _step238;
          try {
            for (_iterator238.s(); !(_step238 = _iterator238.n()).done;) {
              var _t359 = _step238.value;
              var _r288 = _t359.feature;
              _t359.evaluatedScale = e.paint.get("model-scale").evaluate(_r288, {}, n);
            }
          } catch (err) {
            _iterator238.e(err);
          } finally {
            _iterator238.f();
          }
        }
      }, {
        key: "evaluate",
        value: function evaluate(t) {
          var e = this.getNodesInfo();
          var _iterator239 = _createForOfIteratorHelper(e),
            _step239;
          try {
            for (_iterator239.s(); !(_step239 = _iterator239.n()).done;) {
              var _r289 = _step239.value;
              if (!_r289.node.meshes) continue;
              var _e346 = _r289.feature,
                _n208 = _r289.node.meshes && _r289.node.meshes[0].featureData,
                _i207 = _r289.evaluatedColor[2],
                _s164 = _r289.evaluatedRMEA[2],
                _a131 = this.id.canonical;
              if (_r289.hasTranslucentParts = !1, _n208) {
                for (var _n209 = 0; _n209 < c_.length; _n209++) {
                  var _i208 = c_[_n209];
                  _i208.length && (_e346.properties.part = _i208);
                  var _s165 = t.paint.get("model-color").evaluate(_e346, {}, _a131).toRenderColor(null),
                    _o101 = t.paint.get("model-color-mix-intensity").evaluate(_e346, {}, _a131);
                  _r289.evaluatedColor[_n209] = [_s165.r, _s165.g, _s165.b, _o101], _r289.evaluatedRMEA[_n209][0] = t.paint.get("model-roughness").evaluate(_e346, {}, _a131), _r289.evaluatedRMEA[_n209][2] = t.paint.get("model-emissive-strength").evaluate(_e346, {}, _a131), _r289.evaluatedRMEA[_n209][3] = _s165.a, _r289.emissionHeightBasedParams[_n209] = t.paint.get("model-height-based-emissive-strength-multiplier").evaluate(_e346, {}, _a131), !_r289.hasTranslucentParts && _s165.a < 1 && (_r289.hasTranslucentParts = !0);
                }
                delete _e346.properties.part, m_(_r289, _i207 !== _r289.evaluatedColor[2] || _s164 !== _r289.evaluatedRMEA[2], this.modelTraits);
              } else _r289.evaluatedRMEA[0][2] = t.paint.get("model-emissive-strength").evaluate(_e346, {}, _a131);
              _r289.evaluatedScale = t.paint.get("model-scale").evaluate(_e346, {}, _a131), this.updatePbrBuffer(_r289.node) || (this.needsUpload = !0);
            }
          } catch (err) {
            _iterator239.e(err);
          } finally {
            _iterator239.f();
          }
          this.dirty = !1;
        }
      }, {
        key: "elevationUpdate",
        value: function elevationUpdate(t, e, r, n) {
          var i = t.findDEMTileFor(r);
          if (i && (i.tileID.canonical !== this.terrainTile || e !== this.terrainExaggeration)) {
            if (i.dem && i.tileID.overscaledZ !== this.elevationReadFromZ) {
              this.elevationReadFromZ = i.tileID.overscaledZ;
              var _e347 = ad.create(t, r, i);
              if (!_e347) return;
              this.modelTraits & cv.HasMapboxMeshFeatures && this.updateDEM(t, _e347, r, n);
              var _iterator240 = _createForOfIteratorHelper(this.getNodesInfo()),
                _step240;
              try {
                for (_iterator240.s(); !(_step240 = _iterator240.n()).done;) {
                  var _t360 = _step240.value;
                  var _r290 = _t360.node;
                  if (!_r290.footprint || !_r290.footprint.vertices || !_r290.footprint.vertices.length) continue;
                  var _n210 = _r290.footprint.vertices;
                  var _i209 = _e347.getElevationAt(_n210[0].x, _n210[0].y, !0, !0);
                  for (var _t361 = 1; _t361 < _n210.length; _t361++) _i209 = Math.min(_i209, _e347.getElevationAt(_n210[_t361].x, _n210[_t361].y, !0, !0));
                  _r290.elevation = _i209;
                }
              } catch (err) {
                _iterator240.e(err);
              } finally {
                _iterator240.f();
              }
            }
            this.terrainTile = i.tileID.canonical, this.terrainExaggeration = e;
          }
        }
      }, {
        key: "updateDEM",
        value: function updateDEM(t, e, r, n) {
          var i = e._dem._modifiedForSources[n];
          if (void 0 === i && (e._dem._modifiedForSources[n] = [], i = e._dem._modifiedForSources[n]), i.includes(r.canonical)) return;
          var s = e._dem.dim;
          i.push(r.canonical);
          var a = !1;
          var _iterator241 = _createForOfIteratorHelper(this.getNodesInfo()),
            _step241;
          try {
            for (_iterator241.s(); !(_step241 = _iterator241.n()).done;) {
              var _t362 = _step241.value;
              var _r291 = _t362.node;
              if (!_r291.footprint || !_r291.footprint.grid) continue;
              var _n211 = _r291.footprint.grid,
                _i210 = e.tileCoordToPixel(_n211.min.x, _n211.min.y),
                _o102 = e.tileCoordToPixel(_n211.max.x, _n211.max.y),
                _l80 = Math.min(Math.min(s - _o102.y, _i210.x), Math.min(_i210.y, s - _o102.x));
              if (_l80 < 0) continue;
              var _u64 = We(_l80, 2, 5);
              var _c50 = Math.max(0, _i210.x - _u64),
                _h40 = Math.max(0, _i210.y - _u64),
                _p35 = Math.min(_o102.x + _u64, s - 1),
                _f31 = Math.min(_o102.y + _u64, s - 1);
              for (var _t363 = _h40; _t363 <= _f31; ++_t363) for (var _e348 = _c50; _e348 <= _p35; ++_e348) o_[_t363 * s + _e348] = 255;
              var _d23 = 0,
                _m17 = 0;
              for (var _t364 = 0; _t364 < _n211.cellsY; ++_t364) for (var _r292 = 0; _r292 < _n211.cellsX; ++_r292) {
                if (!_n211.cells[_t364 * _n211.cellsX + _r292]) continue;
                var _i211 = e.tileCoordToPixel(_n211.min.x + _r292 / _n211.xScale, _n211.min.y + _t364 / _n211.yScale),
                  _a132 = e.tileCoordToPixel(_n211.min.x + (_r292 + 1) / _n211.xScale, _n211.min.y + (_t364 + 1) / _n211.yScale);
                for (var _t365 = _i211.y; _t365 <= Math.min(_a132.y + 1, s - 1); ++_t365) for (var _r293 = _i211.x; _r293 <= Math.min(_a132.x + 1, s - 1); ++_r293) 255 === o_[_t365 * s + _r293] && (o_[_t365 * s + _r293] = 0, _d23 += e.getElevationAtPixel(_r293, _t365), _m17++);
              }
              var _y14 = _d23 / _m17;
              _c50 = Math.max(1, _i210.x - _u64), _h40 = Math.max(1, _i210.y - _u64), _p35 = Math.min(_o102.x + _u64, s - 2), _f31 = Math.min(_o102.y + _u64, s - 2), a = !0;
              for (var _t366 = _h40; _t366 <= _f31; ++_t366) for (var _r294 = _c50; _r294 <= _p35; ++_r294) 0 === o_[_t366 * s + _r294] && (a_[_t366 * s + _r294] = e._dem.set(_r294, _t366, _y14));
              for (var _t367 = 1; _t367 < _u64; ++_t367) {
                _c50 = Math.max(1, _i210.x - _t367), _h40 = Math.max(1, _i210.y - _t367), _p35 = Math.min(_o102.x + _t367, s - 2), _f31 = Math.min(_o102.y + _t367, s - 2);
                for (var _r295 = _h40; _r295 <= _f31; ++_r295) for (var _n212 = _c50; _n212 <= _p35; ++_n212) {
                  var _i212 = _r295 * s + _n212;
                  if (255 === o_[_i212]) {
                    var _a133 = 0,
                      _o103 = 0,
                      _l81 = -1,
                      _c51 = -1;
                    for (var _e349 = -1; _e349 <= 1; ++_e349) for (var _i213 = -1; _i213 <= 1; ++_i213) {
                      var _u65 = (_r295 + _e349) * s + _n212 + _i213;
                      if (o_[_u65] >= _t367) continue;
                      var _h41 = a_[_u65],
                        _p36 = Math.abs(_h41);
                      _p36 > _o103 && (_a133 = _h41, _o103 = _p36, _l81 = _i213, _c51 = _e349);
                    }
                    if (_o103 > .1) {
                      var _s166 = 1 - (_t367 + .5 * Math.abs(_l81 * _c51)) / _u64;
                      var _o104 = e._dem.get(_n212, _r295) + _a133 * _s166;
                      var _h42 = e._dem.get(_n212 + _l81, _r295 + _c51),
                        _p37 = e._dem.get(_n212 - _l81, _r295 - _c51, !0);
                      (_o104 - _h42) * (_o104 - _p37) > 0 && (_o104 = (_h42 + _p37) / 2), a_[_i212] = e._dem.set(_n212, _r295, _o104), o_[_i212] = _t367;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _iterator241.e(err);
          } finally {
            _iterator241.f();
          }
          a && (e._demTile.needsDEMTextureUpload = !0, e._dem._timestamp = Rr.now());
        }
      }, {
        key: "getNodesInfo",
        value: function getNodesInfo() {
          return this.nodesInfo;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = this.getNodesInfo();
          var _iterator242 = _createForOfIteratorHelper(t),
            _step242;
          try {
            for (_iterator242.s(); !(_step242 = _iterator242.n()).done;) {
              var _e350 = _step242.value;
              mv(_e350.node), yv(_e350.node);
            }
          } catch (err) {
            _iterator242.e(err);
          } finally {
            _iterator242.f();
          }
        }
      }, {
        key: "isEmpty",
        value: function isEmpty() {
          return !this.nodesInfo.length;
        }
      }, {
        key: "updateReplacement",
        value: function updateReplacement(t, e) {
          if (e.updateTime === this.replacementUpdateTime) return;
          this.replacementUpdateTime = e.updateTime;
          var r = e.getReplacementRegionsForTile(t.toUnwrapped()),
            n = this.getNodesInfo();
          var _loop10 = function _loop10() {
            var e = n[_t368].node;
            n[_t368].hiddenByReplacement = !!e.footprint && !r.find(function (t) {
              return t.footprint === e.footprint;
            });
          };
          for (var _t368 = 0; _t368 < this.nodesInfo.length; _t368++) {
            _loop10();
          }
        }
      }, {
        key: "getHeightAtTileCoord",
        value: function getHeightAtTileCoord(e, r) {
          var n = this.getNodesInfo(),
            i = [],
            s = [0, 0, 0],
            a = t.ae.identity([]);
          for (var _o105 = 0; _o105 < this.nodesInfo.length; _o105++) {
            var _l82 = n[_o105],
              _u66 = _l82.node.meshes[0],
              _c52 = _u66.transformedAabb;
            if (e < _c52.min[0] || r < _c52.min[1] || e > _c52.max[0] || r > _c52.max[1]) continue;
            if (!0 === _l82.node.hidden) return {
              height: 0,
              maxHeight: _l82.feature.properties.height,
              hidden: !1,
              verticalScale: _l82.evaluatedScale[2]
            };
            t.ae.invert(a, _l82.node.matrix), s[0] = e, s[1] = r, t.$.transformMat4(s, s, a);
            var _h43 = (s[0] - _u66.aabb.min[0]) / (_u66.aabb.max[0] - _u66.aabb.min[0]) * uv | 0,
              _p38 = Math.min(63, (s[1] - _u66.aabb.min[1]) / (_u66.aabb.max[1] - _u66.aabb.min[1]) * uv | 0) * uv + Math.min(63, _h43),
              _f32 = _u66.heightmap[_p38];
            if (!(_f32 < 0 && _l82.node.footprint)) {
              if (_l82.hiddenByReplacement) return;
              return {
                height: _f32,
                maxHeight: _l82.feature.properties.height,
                hidden: !1,
                verticalScale: _l82.evaluatedScale[2]
              };
            }
            if (_l82.node.footprint.grid.query(new je(e, r), new je(e, r), i), i.length > 0) return {
              height: void 0,
              maxHeight: _l82.feature.properties.height,
              hidden: _l82.hiddenByReplacement,
              verticalScale: _l82.evaluatedScale[2]
            };
          }
        }
      }]);
      return p_;
    }();
    function f_(t, e) {
      return !t.isLightConstant && e;
    }
    function d_(t, e, r, n, i, s, a, o) {
      var l = (61440 & e | (61440 & e) >> 4) >> 8,
        u = (3840 & e | (3840 & e) >> 4) >> 4,
        c = 240 & e | (240 & e) >> 4;
      r[3] > 0 && (l = Yn(l, 255 * r[0], r[3]), u = Yn(u, 255 * r[1], r[3]), c = Yn(c, 255 * r[2], r[3]));
      var h = l << 8 | u,
        p = c << 8 | Math.floor(255 * n[3]),
        f = function (t) {
          var e = We(t, 0, 2);
          return Math.min(Math.round(.5 * e * 255), 255);
        }(n[2]) << 8 | 15 * n[0] << 4 | 15 * n[1],
        d = We(i[0], 0, 1),
        m = We(i[1], 0, 1),
        y = We(i[2], 0, 1),
        g = We(i[3], 0, 1);
      var x, b, v, _;
      if (d !== m && a !== s && m !== d) {
        var _t369 = a - s;
        b = 1 / (_t369 * (m - d)), v = -(s + _t369 * d) / (_t369 * (m - d));
        var _e351 = We(i[4], -1, 1);
        _ = Math.pow(10, _e351), x = 255 * y << 8 | 255 * g;
      } else x = 65535, b = 0, v = 1, _ = 1;
      if (t.emplaceBack(h, p, f, x, b, v, _), o) {
        var _t370 = o.length;
        o.clear();
        for (var _e352 = 0; _e352 < _t370; _e352++) o.emplaceBack(h, p, f, x, b, v, _);
      }
    }
    function m_(t, e, r) {
      var n = t.node;
      var i = 0;
      var s = r & cv.HasMeshoptCompression;
      var _iterator243 = _createForOfIteratorHelper(n.meshes),
        _step243;
      try {
        for (_iterator243.s(); !(_step243 = _iterator243.n()).done;) {
          var _r296 = _step243.value;
          if (n.lights && n.lightMeshIndex === i) continue;
          if (!_r296.featureData) continue;
          _r296.featureArray = new cu(), _r296.featureArray.reserve(_r296.featureData.length);
          var _a134 = e;
          var _iterator244 = _createForOfIteratorHelper(_r296.featureData),
            _step244;
          try {
            for (_iterator244.s(); !(_step244 = _iterator244.n()).done;) {
              var _e353 = _step244.value;
              var _i214 = s ? 65535 & _e353 : _e353 >> 16 & 65535,
                _o106 = s ? _e353 >> 16 & 65535 : 65535 & _e353,
                _l83 = (15 & _o106) < 8 ? 15 & _o106 : 0,
                _u67 = t.evaluatedRMEA[_l83],
                _c53 = t.evaluatedColor[_l83],
                _h44 = t.emissionHeightBasedParams[_l83];
              var _p39 = void 0;
              if (_a134 && 2 === _l83 && n.lights && (_p39 = new cu(), _p39.resize(10 * n.lights.length)), d_(_r296.featureArray, _i214, _c53, _u67, _h44, _r296.aabb.min[2], _r296.aabb.max[2], _p39), _p39 && _a134) {
                _a134 = !1;
                var _t371 = n.meshes[n.lightMeshIndex];
                _t371.featureArray = _p39, _t371.featureArray._trim();
              }
            }
          } catch (err) {
            _iterator244.e(err);
          } finally {
            _iterator244.f();
          }
          _r296.featureArray._trim(), i++;
        }
      } catch (err) {
        _iterator243.e(err);
      } finally {
        _iterator243.f();
      }
    }
    function y_(t, e, r, n) {
      var i = 1 << t.z;
      e.lat = Cc((n / ds + t.y) / i), e.lng = Rc((r / ds + t.x) / i);
    }
    So(p_, "Tiled3dModelBucket", {
      omit: ["layers"]
    }), So(h_, "Tiled3dModelFeature");
    var g_ = {
      circle: /*#__PURE__*/function (_zl5) {
        _inherits(circle, _zl5);
        var _super84 = _createSuper(circle);
        function circle(t, e, r, n) {
          _classCallCheck(this, circle);
          return _super84.call(this, t, {
            layout: bh || (bh = new ul({
              "circle-sort-key": new ol(cl.layout_circle["circle-sort-key"]),
              visibility: new al(cl.layout_circle.visibility)
            })),
            paint: vh || (vh = new ul({
              "circle-radius": new ol(cl.paint_circle["circle-radius"]),
              "circle-color": new ol(cl.paint_circle["circle-color"]),
              "circle-blur": new ol(cl.paint_circle["circle-blur"]),
              "circle-opacity": new ol(cl.paint_circle["circle-opacity"]),
              "circle-translate": new al(cl.paint_circle["circle-translate"]),
              "circle-translate-anchor": new al(cl.paint_circle["circle-translate-anchor"]),
              "circle-pitch-scale": new al(cl.paint_circle["circle-pitch-scale"]),
              "circle-pitch-alignment": new al(cl.paint_circle["circle-pitch-alignment"]),
              "circle-stroke-width": new ol(cl.paint_circle["circle-stroke-width"]),
              "circle-stroke-color": new ol(cl.paint_circle["circle-stroke-color"]),
              "circle-stroke-opacity": new ol(cl.paint_circle["circle-stroke-opacity"]),
              "circle-emissive-strength": new al(cl.paint_circle["circle-emissive-strength"])
            }))
          }, e, r, n);
        }
        _createClass(circle, [{
          key: "createBucket",
          value: function createBucket(t) {
            return new th(t);
          }
        }, {
          key: "queryRadius",
          value: function queryRadius(t) {
            var e = t;
            return mh("circle-radius", this, e) + mh("circle-stroke-width", this, e) + yh(this.paint.get("circle-translate"));
          }
        }, {
          key: "queryIntersectsFeature",
          value: function queryIntersectsFeature(t, e, r, n, i, s, a, o) {
            var l = xh(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), s.angle, t.pixelToTileUnitsFactor),
              u = this.paint.get("circle-radius").evaluate(e, r) + this.paint.get("circle-stroke-width").evaluate(e, r);
            return op(t, n, s, a, o, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l, u);
          }
        }, {
          key: "getProgramIds",
          value: function getProgramIds() {
            return ["circle"];
          }
        }, {
          key: "getDefaultProgramParams",
          value: function getDefaultProgramParams(t, e, r) {
            var n = ap(this);
            return {
              config: new tc(this, {
                zoom: e,
                lut: r
              }),
              defines: n,
              overrideFog: !1
            };
          }
        }]);
        return circle;
      }(zl),
      heatmap: /*#__PURE__*/function (_zl6) {
        _inherits(heatmap, _zl6);
        var _super85 = _createSuper(heatmap);
        function heatmap(t, e, r, n) {
          var _this67;
          _classCallCheck(this, heatmap);
          _this67 = _super85.call(this, t, {
            layout: bp || (bp = new ul({
              visibility: new al(cl.layout_heatmap.visibility)
            })),
            paint: vp || (vp = new ul({
              "heatmap-radius": new ol(cl.paint_heatmap["heatmap-radius"]),
              "heatmap-weight": new ol(cl.paint_heatmap["heatmap-weight"]),
              "heatmap-intensity": new al(cl.paint_heatmap["heatmap-intensity"]),
              "heatmap-color": new ll(cl.paint_heatmap["heatmap-color"]),
              "heatmap-opacity": new al(cl.paint_heatmap["heatmap-opacity"])
            }))
          }, e, r, n), _this67._updateColorRamp();
          return _this67;
        }
        _createClass(heatmap, [{
          key: "createBucket",
          value: function createBucket(t) {
            return new pp(t);
          }
        }, {
          key: "_handleSpecialPaintPropertyUpdate",
          value: function _handleSpecialPaintPropertyUpdate(t) {
            "heatmap-color" === t && this._updateColorRamp();
          }
        }, {
          key: "_updateColorRamp",
          value: function _updateColorRamp() {
            this.colorRamp = Mp({
              expression: this._transitionablePaint._values["heatmap-color"].value.expression,
              evaluationKey: "heatmapDensity",
              image: this.colorRamp
            }), this.colorRampTexture = null;
          }
        }, {
          key: "resize",
          value: function resize() {
            this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
          }
        }, {
          key: "queryRadius",
          value: function queryRadius(t) {
            return mh("heatmap-radius", this, t);
          }
        }, {
          key: "queryIntersectsFeature",
          value: function queryIntersectsFeature(t, e, r, n, i, s, a, o) {
            var l = this.paint.get("heatmap-radius").evaluate(e, r);
            return op(t, n, s, a, o, !0, !0, new je(0, 0), l);
          }
        }, {
          key: "hasOffscreenPass",
          value: function hasOffscreenPass() {
            return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
          }
        }, {
          key: "getProgramIds",
          value: function getProgramIds() {
            return ["heatmap", "heatmapTexture"];
          }
        }, {
          key: "getDefaultProgramParams",
          value: function getDefaultProgramParams(t, e, r) {
            return "heatmap" === t ? {
              config: new tc(this, {
                zoom: e,
                lut: r
              }),
              overrideFog: !1
            } : {};
          }
        }]);
        return heatmap;
      }(zl),
      hillshade: /*#__PURE__*/function (_zl7) {
        _inherits(hillshade, _zl7);
        var _super86 = _createSuper(hillshade);
        function hillshade(t, e, r, n) {
          _classCallCheck(this, hillshade);
          return _super86.call(this, t, {
            layout: _p || (_p = new ul({
              visibility: new al(cl.layout_hillshade.visibility)
            })),
            paint: wp || (wp = new ul({
              "hillshade-illumination-direction": new al(cl.paint_hillshade["hillshade-illumination-direction"]),
              "hillshade-illumination-anchor": new al(cl.paint_hillshade["hillshade-illumination-anchor"]),
              "hillshade-exaggeration": new al(cl.paint_hillshade["hillshade-exaggeration"]),
              "hillshade-shadow-color": new al(cl.paint_hillshade["hillshade-shadow-color"]),
              "hillshade-highlight-color": new al(cl.paint_hillshade["hillshade-highlight-color"]),
              "hillshade-accent-color": new al(cl.paint_hillshade["hillshade-accent-color"]),
              "hillshade-emissive-strength": new al(cl.paint_hillshade["hillshade-emissive-strength"])
            }))
          }, e, r, n);
        }
        _createClass(hillshade, [{
          key: "hasOffscreenPass",
          value: function hasOffscreenPass() {
            return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
          }
        }, {
          key: "getProgramIds",
          value: function getProgramIds() {
            return ["hillshade", "hillshadePrepare"];
          }
        }, {
          key: "getDefaultProgramParams",
          value: function getDefaultProgramParams(t, e, r) {
            return {
              overrideFog: !1
            };
          }
        }]);
        return hillshade;
      }(zl),
      fill: /*#__PURE__*/function (_zl8) {
        _inherits(fill, _zl8);
        var _super87 = _createSuper(fill);
        function fill(t, e, r, n) {
          _classCallCheck(this, fill);
          return _super87.call(this, t, {
            layout: rf || (rf = new ul({
              "fill-sort-key": new ol(cl.layout_fill["fill-sort-key"]),
              visibility: new al(cl.layout_fill.visibility)
            })),
            paint: nf || (nf = new ul({
              "fill-antialias": new al(cl.paint_fill["fill-antialias"]),
              "fill-opacity": new ol(cl.paint_fill["fill-opacity"]),
              "fill-color": new ol(cl.paint_fill["fill-color"]),
              "fill-outline-color": new ol(cl.paint_fill["fill-outline-color"]),
              "fill-translate": new al(cl.paint_fill["fill-translate"]),
              "fill-translate-anchor": new al(cl.paint_fill["fill-translate-anchor"]),
              "fill-pattern": new ol(cl.paint_fill["fill-pattern"]),
              "fill-emissive-strength": new al(cl.paint_fill["fill-emissive-strength"])
            }))
          }, e, r, n);
        }
        _createClass(fill, [{
          key: "getProgramIds",
          value: function getProgramIds() {
            var t = this.paint.get("fill-pattern"),
              e = t && t.constantOr(1),
              r = [e ? "fillPattern" : "fill"];
            return this.paint.get("fill-antialias") && r.push(e && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), r;
          }
        }, {
          key: "getDefaultProgramParams",
          value: function getDefaultProgramParams(t, e, r) {
            return {
              config: new tc(this, {
                zoom: e,
                lut: r
              }),
              overrideFog: !1
            };
          }
        }, {
          key: "recalculate",
          value: function recalculate(t, e) {
            _get(_getPrototypeOf(fill.prototype), "recalculate", this).call(this, t, e);
            var r = this.paint._values["fill-outline-color"];
            "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
          }
        }, {
          key: "createBucket",
          value: function createBucket(t) {
            return new ef(t);
          }
        }, {
          key: "queryRadius",
          value: function queryRadius() {
            return yh(this.paint.get("fill-translate"));
          }
        }, {
          key: "queryIntersectsFeature",
          value: function queryIntersectsFeature(t, e, r, n, i, s) {
            return !t.queryGeometry.isAboveHorizon && nh(gh(t.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), s.angle, t.pixelToTileUnitsFactor), n);
          }
        }, {
          key: "isTileClipped",
          value: function isTileClipped() {
            return !0;
          }
        }]);
        return fill;
      }(zl),
      "fill-extrusion": /*#__PURE__*/function (_zl9) {
        _inherits(fillExtrusion, _zl9);
        var _super88 = _createSuper(fillExtrusion);
        function fillExtrusion(t, e, r, n) {
          var _this68;
          _classCallCheck(this, fillExtrusion);
          _this68 = _super88.call(this, t, {
            layout: Vd || (Vd = new ul({
              visibility: new al(cl["layout_fill-extrusion"].visibility),
              "fill-extrusion-edge-radius": new al(cl["layout_fill-extrusion"]["fill-extrusion-edge-radius"])
            })),
            paint: Fd || (Fd = new ul({
              "fill-extrusion-opacity": new al(cl["paint_fill-extrusion"]["fill-extrusion-opacity"]),
              "fill-extrusion-color": new ol(cl["paint_fill-extrusion"]["fill-extrusion-color"]),
              "fill-extrusion-translate": new al(cl["paint_fill-extrusion"]["fill-extrusion-translate"]),
              "fill-extrusion-translate-anchor": new al(cl["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
              "fill-extrusion-pattern": new ol(cl["paint_fill-extrusion"]["fill-extrusion-pattern"]),
              "fill-extrusion-height": new ol(cl["paint_fill-extrusion"]["fill-extrusion-height"]),
              "fill-extrusion-base": new ol(cl["paint_fill-extrusion"]["fill-extrusion-base"]),
              "fill-extrusion-vertical-gradient": new al(cl["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
              "fill-extrusion-ambient-occlusion-intensity": new al(cl["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),
              "fill-extrusion-ambient-occlusion-radius": new al(cl["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]),
              "fill-extrusion-ambient-occlusion-wall-radius": new al(cl["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]),
              "fill-extrusion-ambient-occlusion-ground-radius": new al(cl["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]),
              "fill-extrusion-ambient-occlusion-ground-attenuation": new al(cl["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]),
              "fill-extrusion-flood-light-color": new al(cl["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]),
              "fill-extrusion-flood-light-intensity": new al(cl["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]),
              "fill-extrusion-flood-light-wall-radius": new ol(cl["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]),
              "fill-extrusion-flood-light-ground-radius": new ol(cl["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]),
              "fill-extrusion-flood-light-ground-attenuation": new al(cl["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]),
              "fill-extrusion-vertical-scale": new al(cl["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]),
              "fill-extrusion-rounded-roof": new al(cl["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]),
              "fill-extrusion-cutoff-fade-range": new al(cl["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]),
              "fill-extrusion-emissive-strength": new al(cl["paint_fill-extrusion"]["fill-extrusion-emissive-strength"]),
              "fill-extrusion-line-width": new ol(cl["paint_fill-extrusion"]["fill-extrusion-line-width"]),
              "fill-extrusion-line-alignment": new al(cl["paint_fill-extrusion"]["fill-extrusion-line-alignment"])
            }))
          }, e, r, n), _this68._stats = {
            numRenderedVerticesInShadowPass: 0,
            numRenderedVerticesInTransparentPass: 0
          };
          return _this68;
        }
        _createClass(fillExtrusion, [{
          key: "createBucket",
          value: function createBucket(t) {
            return new Id(t);
          }
        }, {
          key: "queryRadius",
          value: function queryRadius() {
            return yh(this.paint.get("fill-extrusion-translate"));
          }
        }, {
          key: "is3D",
          value: function is3D() {
            return !0;
          }
        }, {
          key: "hasShadowPass",
          value: function hasShadowPass() {
            return !0;
          }
        }, {
          key: "cutoffRange",
          value: function cutoffRange() {
            return this.paint.get("fill-extrusion-cutoff-fade-range");
          }
        }, {
          key: "canCastShadows",
          value: function canCastShadows() {
            return !0;
          }
        }, {
          key: "getProgramIds",
          value: function getProgramIds() {
            return [this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"];
          }
        }, {
          key: "queryIntersectsFeature",
          value: function queryIntersectsFeature(e, r, n, i, s, a, o, l, u) {
            var c = xh(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), a.angle, e.pixelToTileUnitsFactor),
              h = this.paint.get("fill-extrusion-height").evaluate(r, n),
              p = this.paint.get("fill-extrusion-base").evaluate(r, n),
              f = [0, 0],
              d = l && a.elevation,
              m = a.elevation ? a.elevation.exaggeration() : 1,
              y = e.tile.getBucket(this);
            if (d && y instanceof Id) {
              var _t372 = y.centroidVertexArray,
                _e354 = u + 1;
              _e354 < _t372.length && (f[0] = _t372.geta_centroid_pos0(_e354), f[1] = _t372.geta_centroid_pos1(_e354));
            }
            if (0 === f[0] && 1 === f[1]) return !1;
            "globe" === a.projection.name && (i = Cd([i], [new je(0, 0), new je(ds, ds)], e.tileID.canonical).map(function (t) {
              return t.polygon;
            }).flat());
            var g = d ? l : null,
              _ref146 = function (e, r, n, i, s, a, o, l, u, c, h) {
                return "globe" === e.projection.name ? function (e, r, n, i, s, a, o, l, u, c, h) {
                  var p = [],
                    f = [],
                    d = e.projection.upVectorScale(h, e.center.lat, e.worldSize).metersToTile,
                    m = [0, 0, 0, 1],
                    y = [0, 0, 0, 1],
                    g = function g(t, e, r, n) {
                      t[0] = e, t[1] = r, t[2] = n, t[3] = 1;
                    },
                    x = Rd();
                  n > 0 && (n += x), i += x;
                  var _iterator245 = _createForOfIteratorHelper(r),
                    _step245;
                  try {
                    for (_iterator245.s(); !(_step245 = _iterator245.n()).done;) {
                      var _x13 = _step245.value;
                      var _r297 = [],
                        _b10 = [];
                      var _iterator246 = _createForOfIteratorHelper(_x13),
                        _step246;
                      try {
                        for (_iterator246.s(); !(_step246 = _iterator246.n()).done;) {
                          var _p40 = _step246.value;
                          var _f33 = _p40.x + s.x,
                            _x14 = _p40.y + s.y,
                            _v10 = e.projection.projectTilePoint(_f33, _x14, h),
                            _11 = e.projection.upVector(h, _p40.x, _p40.y);
                          var _w8 = n,
                            _M9 = i;
                          if (o) {
                            var _t373 = jd(_f33, _x14, n, i, o, l, u, c);
                            _w8 += _t373.base, _M9 += _t373.top;
                          }
                          0 !== n ? g(m, _v10.x + _11[0] * d * _w8, _v10.y + _11[1] * d * _w8, _v10.z + _11[2] * d * _w8) : g(m, _v10.x, _v10.y, _v10.z), g(y, _v10.x + _11[0] * d * _M9, _v10.y + _11[1] * d * _M9, _v10.z + _11[2] * d * _M9), t.$.transformMat4(m, m, a), t.$.transformMat4(y, y, a), _r297.push(new Ef(m[0], m[1], m[2])), _b10.push(new Ef(y[0], y[1], y[2]));
                        }
                      } catch (err) {
                        _iterator246.e(err);
                      } finally {
                        _iterator246.f();
                      }
                      p.push(_r297), f.push(_b10);
                    }
                  } catch (err) {
                    _iterator245.e(err);
                  } finally {
                    _iterator245.f();
                  }
                  return [p, f];
                }(e, r, n, i, s, a, o, l, u, c, h) : o ? function (e, r, n, i, s, a, o, l, u) {
                  var c = [],
                    h = [],
                    p = [0, 0, 0, 1];
                  var _iterator247 = _createForOfIteratorHelper(e),
                    _step247;
                  try {
                    for (_iterator247.s(); !(_step247 = _iterator247.n()).done;) {
                      var _f34 = _step247.value;
                      var _e355 = [],
                        _d24 = [];
                      var _iterator248 = _createForOfIteratorHelper(_f34),
                        _step248;
                      try {
                        for (_iterator248.s(); !(_step248 = _iterator248.n()).done;) {
                          var _c54 = _step248.value;
                          var _h45 = _c54.x + i.x,
                            _f35 = _c54.y + i.y,
                            _m18 = jd(_h45, _f35, r, n, a, o, l, u);
                          p[0] = _h45, p[1] = _f35, p[2] = _m18.base, p[3] = 1, t.aB.transformMat4(p, p, s), p[3] = Math.max(p[3], 1e-5);
                          var _y15 = new Ef(p[0] / p[3], p[1] / p[3], p[2] / p[3]);
                          p[0] = _h45, p[1] = _f35, p[2] = _m18.top, p[3] = 1, t.aB.transformMat4(p, p, s), p[3] = Math.max(p[3], 1e-5);
                          var _g13 = new Ef(p[0] / p[3], p[1] / p[3], p[2] / p[3]);
                          _e355.push(_y15), _d24.push(_g13);
                        }
                      } catch (err) {
                        _iterator248.e(err);
                      } finally {
                        _iterator248.f();
                      }
                      c.push(_e355), h.push(_d24);
                    }
                  } catch (err) {
                    _iterator247.e(err);
                  } finally {
                    _iterator247.f();
                  }
                  return [c, h];
                }(r, n, i, s, a, o, l, u, c) : function (t, e, r, n, i) {
                  var s = [],
                    a = [],
                    o = i[8] * e,
                    l = i[9] * e,
                    u = i[10] * e,
                    c = i[11] * e,
                    h = i[8] * r,
                    p = i[9] * r,
                    f = i[10] * r,
                    d = i[11] * r;
                  var _iterator249 = _createForOfIteratorHelper(t),
                    _step249;
                  try {
                    for (_iterator249.s(); !(_step249 = _iterator249.n()).done;) {
                      var _e356 = _step249.value;
                      var _t374 = [],
                        _r298 = [];
                      var _iterator250 = _createForOfIteratorHelper(_e356),
                        _step250;
                      try {
                        for (_iterator250.s(); !(_step250 = _iterator250.n()).done;) {
                          var _s167 = _step250.value;
                          var _e357 = _s167.x + n.x,
                            _a135 = _s167.y + n.y,
                            _m19 = i[0] * _e357 + i[4] * _a135 + i[12],
                            _y16 = i[1] * _e357 + i[5] * _a135 + i[13],
                            _g14 = i[2] * _e357 + i[6] * _a135 + i[14],
                            _x15 = i[3] * _e357 + i[7] * _a135 + i[15],
                            _b11 = _m19 + o,
                            _v11 = _y16 + l,
                            _12 = _g14 + u,
                            _w9 = Math.max(_x15 + c, 1e-5),
                            _M10 = _m19 + h,
                            _A10 = _y16 + p,
                            _S7 = _g14 + f,
                            _I6 = Math.max(_x15 + d, 1e-5);
                          _t374.push(new Ef(_b11 / _w9, _v11 / _w9, _12 / _w9)), _r298.push(new Ef(_M10 / _I6, _A10 / _I6, _S7 / _I6));
                        }
                      } catch (err) {
                        _iterator250.e(err);
                      } finally {
                        _iterator250.f();
                      }
                      s.push(_t374), a.push(_r298);
                    }
                  } catch (err) {
                    _iterator249.e(err);
                  } finally {
                    _iterator249.f();
                  }
                  return [s, a];
                }(r, n, i, s, a);
              }(a, i, p, h, c, o, g, f, m, a.center.lat, e.tileID.canonical),
              _ref147 = _slicedToArray(_ref146, 2),
              x = _ref147[0],
              b = _ref147[1],
              v = e.queryGeometry;
            return function (t, e, r) {
              var n = 1 / 0;
              nh(r, e) && (n = Ud(r, e[0]));
              for (var _i215 = 0; _i215 < e.length; _i215++) {
                var _s168 = e[_i215],
                  _a136 = t[_i215];
                for (var _t375 = 0; _t375 < _s168.length - 1; _t375++) {
                  var _e358 = _s168[_t375],
                    _i216 = [_e358, _s168[_t375 + 1], _a136[_t375 + 1], _a136[_t375], _e358];
                  eh(r, _i216) && (n = Math.min(n, Ud(r, _i216)));
                }
              }
              return n !== 1 / 0 && n;
            }(x, b, v.isPointQuery() ? v.screenBounds : v.screenGeometry);
          }
        }]);
        return fillExtrusion;
      }(zl),
      line: /*#__PURE__*/function (_zl10) {
        _inherits(line, _zl10);
        var _super89 = _createSuper(line);
        function line(t, e, r, n) {
          var _this69;
          _classCallCheck(this, line);
          var i = hb();
          _this69 = _super89.call(this, t, i, e, r, n), i.layout && (_this69.layout = new sl(i.layout)), _this69.gradientVersion = 0;
          return _this69;
        }
        _createClass(line, [{
          key: "_handleSpecialPaintPropertyUpdate",
          value: function _handleSpecialPaintPropertyUpdate(t) {
            if ("line-gradient" === t) {
              var _t376 = this._transitionablePaint._values["line-gradient"].value.expression;
              this.stepInterpolant = _t376._styleExpression && _t376._styleExpression.expression instanceof na, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
            }
          }
        }, {
          key: "gradientExpression",
          value: function gradientExpression() {
            return this._transitionablePaint._values["line-gradient"].value.expression;
          }
        }, {
          key: "widthExpression",
          value: function widthExpression() {
            return this._transitionablePaint._values["line-width"].value.expression;
          }
        }, {
          key: "recalculate",
          value: function recalculate(t, e) {
            _get(_getPrototypeOf(line.prototype), "recalculate", this).call(this, t, e), this.paint._values["line-floorwidth"] = function () {
              if (fb) return fb;
              var t = hb();
              return fb = new pb(t.paint.properties["line-width"].specification), fb.useIntegerZoom = !0, fb;
            }().possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t);
          }
        }, {
          key: "createBucket",
          value: function createBucket(t) {
            return new om(t);
          }
        }, {
          key: "getProgramIds",
          value: function getProgramIds() {
            return [this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"];
          }
        }, {
          key: "getDefaultProgramParams",
          value: function getDefaultProgramParams(t, e, r) {
            var n = dm(this);
            return {
              config: new tc(this, {
                zoom: e,
                lut: r
              }),
              defines: n,
              overrideFog: !1
            };
          }
        }, {
          key: "queryRadius",
          value: function queryRadius(t) {
            var e = t,
              r = gb(mh("line-width", this, e), mh("line-gap-width", this, e)),
              n = mh("line-offset", this, e);
            return r / 2 + Math.abs(n) + yh(this.paint.get("line-translate"));
          }
        }, {
          key: "queryIntersectsFeature",
          value: function queryIntersectsFeature(t, e, r, n, i, s) {
            if (t.queryGeometry.isAboveHorizon) return !1;
            var a = gh(t.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), s.angle, t.pixelToTileUnitsFactor),
              o = t.pixelToTileUnitsFactor / 2 * gb(this.paint.get("line-width").evaluate(e, r), this.paint.get("line-gap-width").evaluate(e, r)),
              l = this.paint.get("line-offset").evaluate(e, r);
            return l && (n = function (t, e) {
              var r = [],
                n = new je(0, 0);
              for (var _i217 = 0; _i217 < t.length; _i217++) {
                var _s169 = t[_i217],
                  _a137 = [];
                for (var _t377 = 0; _t377 < _s169.length; _t377++) {
                  var _r299 = _s169[_t377],
                    _i218 = _s169[_t377 + 1],
                    _o107 = 0 === _t377 ? n : _r299.sub(_s169[_t377 - 1])._unit()._perp(),
                    _l84 = _t377 === _s169.length - 1 ? n : _i218.sub(_r299)._unit()._perp(),
                    _u68 = _o107._add(_l84)._unit();
                  _u68._mult(1 / (_u68.x * _l84.x + _u68.y * _l84.y)), _a137.push(_u68._mult(e)._add(_r299));
                }
                r.push(_a137);
              }
              return r;
            }(n, l * t.pixelToTileUnitsFactor)), function (t, e, r) {
              for (var _n213 = 0; _n213 < e.length; _n213++) {
                var _i219 = e[_n213];
                if (t.length >= 3) for (var _e359 = 0; _e359 < _i219.length; _e359++) if (ch(t, _i219[_e359])) return !0;
                if (ih(t, _i219, r)) return !0;
              }
              return !1;
            }(a, n, o);
          }
        }, {
          key: "isTileClipped",
          value: function isTileClipped() {
            return !0;
          }
        }, {
          key: "isDraped",
          value: function isDraped(t) {
            var e = this.layout.get("line-z-offset");
            return e.isConstant() && !e.constantOr(0);
          }
        }]);
        return line;
      }(zl),
      symbol: vb,
      background: /*#__PURE__*/function (_zl11) {
        _inherits(background, _zl11);
        var _super90 = _createSuper(background);
        function background(t, e, r, n) {
          _classCallCheck(this, background);
          return _super90.call(this, t, {
            layout: _b || (_b = new ul({
              visibility: new al(cl.layout_background.visibility)
            })),
            paint: wb || (wb = new ul({
              "background-color": new al(cl.paint_background["background-color"]),
              "background-pattern": new al(cl.paint_background["background-pattern"]),
              "background-opacity": new al(cl.paint_background["background-opacity"]),
              "background-emissive-strength": new al(cl.paint_background["background-emissive-strength"])
            }))
          }, e, r, n);
        }
        _createClass(background, [{
          key: "getProgramIds",
          value: function getProgramIds() {
            return [this.paint.get("background-pattern") ? "backgroundPattern" : "background"];
          }
        }, {
          key: "getDefaultProgramParams",
          value: function getDefaultProgramParams(t, e, r) {
            return {
              overrideFog: !1
            };
          }
        }]);
        return background;
      }(zl),
      raster: zb,
      "raster-particle": Lb,
      sky: /*#__PURE__*/function (_zl12) {
        _inherits(sky, _zl12);
        var _super91 = _createSuper(sky);
        function sky(t, e, r, n) {
          var _this70;
          _classCallCheck(this, sky);
          _this70 = _super91.call(this, t, {
            layout: Db || (Db = new ul({
              visibility: new al(cl.layout_sky.visibility)
            })),
            paint: Rb || (Rb = new ul({
              "sky-type": new al(cl.paint_sky["sky-type"]),
              "sky-atmosphere-sun": new al(cl.paint_sky["sky-atmosphere-sun"]),
              "sky-atmosphere-sun-intensity": new al(cl.paint_sky["sky-atmosphere-sun-intensity"]),
              "sky-gradient-center": new al(cl.paint_sky["sky-gradient-center"]),
              "sky-gradient-radius": new al(cl.paint_sky["sky-gradient-radius"]),
              "sky-gradient": new ll(cl.paint_sky["sky-gradient"]),
              "sky-atmosphere-halo-color": new al(cl.paint_sky["sky-atmosphere-halo-color"]),
              "sky-atmosphere-color": new al(cl.paint_sky["sky-atmosphere-color"]),
              "sky-opacity": new al(cl.paint_sky["sky-opacity"])
            }))
          }, e, r, n), _this70._updateColorRamp();
          return _this70;
        }
        _createClass(sky, [{
          key: "_handleSpecialPaintPropertyUpdate",
          value: function _handleSpecialPaintPropertyUpdate(t) {
            "sky-gradient" === t ? this._updateColorRamp() : "sky-atmosphere-sun" !== t && "sky-atmosphere-halo-color" !== t && "sky-atmosphere-color" !== t && "sky-atmosphere-sun-intensity" !== t || (this._skyboxInvalidated = !0);
          }
        }, {
          key: "_updateColorRamp",
          value: function _updateColorRamp() {
            this.colorRamp = Mp({
              expression: this._transitionablePaint._values["sky-gradient"].value.expression,
              evaluationKey: "skyRadialProgress"
            }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
          }
        }, {
          key: "needsSkyboxCapture",
          value: function needsSkyboxCapture(t) {
            if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return !0;
            if (!this.paint.get("sky-atmosphere-sun")) {
              var _e360 = t.style.light.properties.get("position");
              return this._lightPosition.azimuthal !== _e360.azimuthal || this._lightPosition.polar !== _e360.polar;
            }
            return !1;
          }
        }, {
          key: "getCenter",
          value: function getCenter(t, e) {
            if ("atmosphere" === this.paint.get("sky-type")) {
              var _r300 = this.paint.get("sky-atmosphere-sun"),
                _n214 = !_r300,
                _i220 = t.style.light,
                _s170 = _i220.properties.get("position");
              return _n214 && "viewport" === _i220.properties.get("anchor") && dr("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), _n214 ? Fb(_s170.azimuthal, 90 - _s170.polar, e) : Fb(_r300[0], 90 - _r300[1], e);
            }
            var r = this.paint.get("sky-gradient-center");
            return Fb(r[0], 90 - r[1], e);
          }
        }, {
          key: "isSky",
          value: function isSky() {
            return !0;
          }
        }, {
          key: "markSkyboxValid",
          value: function markSkyboxValid(t) {
            this._skyboxInvalidated = !1, this._lightPosition = t.style.light.properties.get("position");
          }
        }, {
          key: "hasOffscreenPass",
          value: function hasOffscreenPass() {
            return !0;
          }
        }, {
          key: "getProgramIds",
          value: function getProgramIds() {
            var t = this.paint.get("sky-type");
            return "atmosphere" === t ? ["skyboxCapture", "skybox"] : "gradient" === t ? ["skyboxGradient"] : null;
          }
        }]);
        return sky;
      }(zl),
      slot: /*#__PURE__*/function (_zl13) {
        _inherits(slot, _zl13);
        var _super92 = _createSuper(slot);
        function slot(t, e, r, n) {
          _classCallCheck(this, slot);
          return _super92.call(this, t, {
            paint: Cb || (Cb = new ul({}))
          }, e, null);
        }
        return _createClass(slot);
      }(zl),
      model: /*#__PURE__*/function (_zl14) {
        _inherits(model, _zl14);
        var _super93 = _createSuper(model);
        function model(t, e, r, n) {
          var _this71;
          _classCallCheck(this, model);
          _this71 = _super93.call(this, t, {
            layout: ov || (ov = new ul({
              visibility: new al(cl.layout_model.visibility),
              "model-id": new ol(cl.layout_model["model-id"])
            })),
            paint: lv || (lv = new ul({
              "model-opacity": new al(cl.paint_model["model-opacity"]),
              "model-rotation": new ol(cl.paint_model["model-rotation"]),
              "model-scale": new ol(cl.paint_model["model-scale"]),
              "model-translation": new ol(cl.paint_model["model-translation"]),
              "model-color": new ol(cl.paint_model["model-color"]),
              "model-color-mix-intensity": new ol(cl.paint_model["model-color-mix-intensity"]),
              "model-type": new al(cl.paint_model["model-type"]),
              "model-cast-shadows": new al(cl.paint_model["model-cast-shadows"]),
              "model-receive-shadows": new al(cl.paint_model["model-receive-shadows"]),
              "model-ambient-occlusion-intensity": new al(cl.paint_model["model-ambient-occlusion-intensity"]),
              "model-emissive-strength": new ol(cl.paint_model["model-emissive-strength"]),
              "model-roughness": new ol(cl.paint_model["model-roughness"]),
              "model-height-based-emissive-strength-multiplier": new ol(cl.paint_model["model-height-based-emissive-strength-multiplier"]),
              "model-cutoff-fade-range": new al(cl.paint_model["model-cutoff-fade-range"]),
              "model-front-cutoff": new al(cl.paint_model["model-front-cutoff"])
            }))
          }, e, r, n), _this71._stats = {
            numRenderedVerticesInShadowPass: 0,
            numRenderedVerticesInTransparentPass: 0
          };
          return _this71;
        }
        _createClass(model, [{
          key: "createBucket",
          value: function createBucket(t) {
            return new av(t);
          }
        }, {
          key: "getProgramIds",
          value: function getProgramIds() {
            return ["model"];
          }
        }, {
          key: "is3D",
          value: function is3D() {
            return !0;
          }
        }, {
          key: "hasShadowPass",
          value: function hasShadowPass() {
            return !0;
          }
        }, {
          key: "canCastShadows",
          value: function canCastShadows() {
            return !0;
          }
        }, {
          key: "hasLightBeamPass",
          value: function hasLightBeamPass() {
            return !0;
          }
        }, {
          key: "cutoffRange",
          value: function cutoffRange() {
            return this.paint.get("model-cutoff-fade-range");
          }
        }, {
          key: "queryRadius",
          value: function queryRadius(t) {
            return t instanceof p_ ? ds - 1 : 0;
          }
        }, {
          key: "queryIntersectsFeature",
          value: function queryIntersectsFeature(e, r, n, i, s, a) {
            if (!this.modelManager) return !1;
            var o = this.modelManager,
              l = e.tile.getBucket(this);
            if (!(l && l instanceof av)) return !1;
            var u = l;
            for (var _n215 in u.instancesPerModel) {
              var _i221 = u.instancesPerModel[_n215],
                _s171 = void 0 !== r.id ? r.id : r.properties && r.properties.hasOwnProperty("id") ? r.properties.id : void 0;
              if (_i221.idToFeaturesIndex.hasOwnProperty(_s171)) {
                var _r301 = _i221.features[_i221.idToFeaturesIndex[_s171]],
                  _l85 = o.getModel(_n215, this.scope);
                if (!_l85) return !1;
                var _c55 = t.ae.create();
                var _h46 = new bc(0, 0),
                  _p41 = u.canonical;
                var _f36 = Number.MAX_VALUE;
                for (var _n216 = 0; _n216 < _r301.instancedDataCount; ++_n216) {
                  var _s172 = 16 * (_r301.instancedDataOffset + _n216),
                    _o108 = _i221.instancedDataArray.float32,
                    _u69 = [_o108[_s172 + 4], _o108[_s172 + 5], _o108[_s172 + 6]];
                  y_(_p41, _h46, _o108[_s172], 0 | _o108[_s172 + 1]), hv(_c55, _l85, a, _h46, _r301.rotation, _r301.scale, _u69, !1, !1, !1), "globe" === a.projection.name && (_c55 = Yb(_c55, a));
                  var _d25 = t.ae.multiply([], a.projMatrix, _c55),
                    _m20 = e.queryGeometry,
                    _y17 = Zb(_m20.isPointQuery() ? _m20.screenBounds : _m20.screenGeometry, a, _d25, _l85.aabb);
                  null != _y17 && (_f36 = Math.min(_y17, _f36));
                }
                return _f36 !== Number.MAX_VALUE && _f36;
              }
            }
            return !1;
          }
        }, {
          key: "_handleOverridablePaintPropertyUpdate",
          value: function _handleOverridablePaintPropertyUpdate(t, e, r) {
            return !(!this.layout || e.isDataDriven() || r.isDataDriven() || "model-color" !== t && "model-color-mix-intensity" !== t && "model-rotation" !== t && "model-scale" !== t && "model-translation" !== t && "model-emissive-strength" !== t);
          }
        }, {
          key: "_isPropertyZoomDependent",
          value: function _isPropertyZoomDependent(t) {
            var e = this._transitionablePaint._values[t];
            return null != e && null != e.value && null != e.value.expression && e.value.expression instanceof yo;
          }
        }, {
          key: "isZoomDependent",
          value: function isZoomDependent() {
            return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
          }
        }, {
          key: "queryIntersectsMatchingFeature",
          value: function queryIntersectsMatchingFeature(e, r, n, i) {
            var s = e.tile,
              a = s.getBucket(this);
            var o = null,
              l = Number.MAX_VALUE;
            if (!(a && a instanceof p_)) return {
              queryFeature: o,
              intersectionZ: l
            };
            var u = a.getNodesInfo()[r];
            if (u.hiddenByReplacement || !u.node.meshes || !n.filter(new Wo(s.tileID.overscaledZ), u.feature, s.tileID.canonical)) return {
              queryFeature: o,
              intersectionZ: l
            };
            var c = u.node,
              h = i.calculatePosMatrix(s.tileID.toUnwrapped(), i.worldSize),
              p = u.evaluatedScale;
            var f = 0;
            i.elevation && c.elevation && (f = c.elevation * i.elevation.exaggeration()), t.ae.translate(h, h, [(c.anchor ? c.anchor[0] : 0) * (p[0] - 1), (c.anchor ? c.anchor[1] : 0) * (p[1] - 1), f]), t.ae.scale(h, h, p), t.ae.multiply(h, h, c.matrix);
            var d = e.queryGeometry,
              m = d.isPointQuery() ? d.screenBounds : d.screenGeometry,
              y = function y(e) {
                var r = t.ae.multiply([], h, e.matrix),
                  n = t.ae.multiply(r, i.expandedFarZProjMatrix, r);
                for (var _t378 = 0; _t378 < e.meshes.length; ++_t378) {
                  var _r302 = e.meshes[_t378];
                  if (_t378 === e.lightMeshIndex) continue;
                  var _s173 = Zb(m, i, n, _r302.aabb);
                  null != _s173 && (l = Math.min(_s173, l));
                }
                if (e.children) {
                  var _iterator251 = _createForOfIteratorHelper(e.children),
                    _step251;
                  try {
                    for (_iterator251.s(); !(_step251 = _iterator251.n()).done;) {
                      var _t379 = _step251.value;
                      y(_t379);
                    }
                  } catch (err) {
                    _iterator251.e(err);
                  } finally {
                    _iterator251.f();
                  }
                }
              };
            if (y(c), l === Number.MAX_VALUE) return {
              queryFeature: o,
              intersectionZ: l
            };
            var g = new bc(0, 0);
            return y_(s.tileID.canonical, g, u.node.anchor[0], u.node.anchor[1]), o = {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [g.lng, g.lat]
              },
              properties: u.feature.properties,
              id: u.feature.id,
              state: {},
              layer: this.serialize()
            }, {
              queryFeature: o,
              intersectionZ: l
            };
          }
        }]);
        return model;
      }(zl),
      clip: /*#__PURE__*/function (_zl15) {
        _inherits(clip, _zl15);
        var _super94 = _createSuper(clip);
        function clip(t, e, r, n) {
          _classCallCheck(this, clip);
          return _super94.call(this, t, {
            layout: sf || (sf = new ul({
              "clip-layer-types": new al(cl.layout_clip["clip-layer-types"]),
              "clip-layer-scope": new al(cl.layout_clip["clip-layer-scope"])
            })),
            paint: af || (af = new ul({}))
          }, e, r, n);
        }
        _createClass(clip, [{
          key: "recalculate",
          value: function recalculate(t, e) {
            _get(_getPrototypeOf(clip.prototype), "recalculate", this).call(this, t, e);
          }
        }, {
          key: "createBucket",
          value: function createBucket(t) {
            return new uf(t);
          }
        }, {
          key: "isTileClipped",
          value: function isTileClipped() {
            return !0;
          }
        }, {
          key: "is3D",
          value: function is3D() {
            return !0;
          }
        }]);
        return clip;
      }(zl)
    };
    So(ib, "MRTDecodingBatch", {
      omit: ["_onCancel", "_onComplete"]
    });
    var x_ = [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
    var b_ = /*#__PURE__*/function () {
      function b_(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Float64Array;
        var n = arguments.length > 3 ? arguments[3] : undefined;
        _classCallCheck(this, b_);
        if (isNaN(t) || t < 0) throw new Error("Unpexpected numItems value: ".concat(t, "."));
        this.numItems = +t, this.nodeSize = Math.min(Math.max(+e, 2), 65535), this.ArrayType = r, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
        var i = x_.indexOf(this.ArrayType),
          s = 2 * t * this.ArrayType.BYTES_PER_ELEMENT,
          a = t * this.IndexArrayType.BYTES_PER_ELEMENT,
          o = (8 - a % 8) % 8;
        if (i < 0) throw new Error("Unexpected typed array class: ".concat(r, "."));
        n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + a + o, 2 * t), this._pos = 2 * t, this._finished = !0) : (this.data = new ArrayBuffer(8 + s + a + o), this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + a + o, 2 * t), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([219, 16 + i]), new Uint16Array(this.data, 2, 1)[0] = e, new Uint32Array(this.data, 4, 1)[0] = t);
      }
      _createClass(b_, [{
        key: "add",
        value: function add(t, e) {
          var r = this._pos >> 1;
          return this.ids[r] = r, this.coords[this._pos++] = t, this.coords[this._pos++] = e, r;
        }
      }, {
        key: "finish",
        value: function finish() {
          var t = this._pos >> 1;
          if (t !== this.numItems) throw new Error("Added ".concat(t, " items when expected ").concat(this.numItems, "."));
          return v_(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
        }
      }, {
        key: "range",
        value: function range(t, e, r, n) {
          if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
          var i = this.ids,
            s = this.coords,
            a = this.nodeSize,
            o = [0, i.length - 1, 0],
            l = [];
          for (; o.length;) {
            var _u70 = o.pop() || 0,
              _c56 = o.pop() || 0,
              _h47 = o.pop() || 0;
            if (_c56 - _h47 <= a) {
              for (var _a138 = _h47; _a138 <= _c56; _a138++) {
                var _o109 = s[2 * _a138],
                  _u71 = s[2 * _a138 + 1];
                _o109 >= t && _o109 <= r && _u71 >= e && _u71 <= n && l.push(i[_a138]);
              }
              continue;
            }
            var _p42 = _h47 + _c56 >> 1,
              _f37 = s[2 * _p42],
              _d26 = s[2 * _p42 + 1];
            _f37 >= t && _f37 <= r && _d26 >= e && _d26 <= n && l.push(i[_p42]), (0 === _u70 ? t <= _f37 : e <= _d26) && (o.push(_h47), o.push(_p42 - 1), o.push(1 - _u70)), (0 === _u70 ? r >= _f37 : n >= _d26) && (o.push(_p42 + 1), o.push(_c56), o.push(1 - _u70));
          }
          return l;
        }
      }, {
        key: "within",
        value: function within(t, e, r) {
          if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
          var n = this.ids,
            i = this.coords,
            s = this.nodeSize,
            a = [0, n.length - 1, 0],
            o = [],
            l = r * r;
          for (; a.length;) {
            var _u72 = a.pop() || 0,
              _c57 = a.pop() || 0,
              _h48 = a.pop() || 0;
            if (_c57 - _h48 <= s) {
              for (var _r303 = _h48; _r303 <= _c57; _r303++) A_(i[2 * _r303], i[2 * _r303 + 1], t, e) <= l && o.push(n[_r303]);
              continue;
            }
            var _p43 = _h48 + _c57 >> 1,
              _f38 = i[2 * _p43],
              _d27 = i[2 * _p43 + 1];
            A_(_f38, _d27, t, e) <= l && o.push(n[_p43]), (0 === _u72 ? t - r <= _f38 : e - r <= _d27) && (a.push(_h48), a.push(_p43 - 1), a.push(1 - _u72)), (0 === _u72 ? t + r >= _f38 : e + r >= _d27) && (a.push(_p43 + 1), a.push(_c57), a.push(1 - _u72));
          }
          return o;
        }
      }], [{
        key: "from",
        value: function from(t) {
          if (!(t instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
          var _Uint8Array = new Uint8Array(t, 0, 2),
            _Uint8Array2 = _slicedToArray(_Uint8Array, 2),
            e = _Uint8Array2[0],
            r = _Uint8Array2[1];
          if (219 !== e) throw new Error("Data does not appear to be in a KDBush format.");
          var n = r >> 4;
          if (1 !== n) throw new Error("Got v".concat(n, " data when expected v1."));
          var i = x_[15 & r];
          if (!i) throw new Error("Unrecognized array type.");
          var _Uint16Array = new Uint16Array(t, 2, 1),
            _Uint16Array2 = _slicedToArray(_Uint16Array, 1),
            s = _Uint16Array2[0],
            _Uint32Array = new Uint32Array(t, 4, 1),
            _Uint32Array2 = _slicedToArray(_Uint32Array, 1),
            a = _Uint32Array2[0];
          return new b_(a, s, i, t);
        }
      }]);
      return b_;
    }();
    function v_(t, e, r, n, i, s) {
      if (i - n <= r) return;
      var a = n + i >> 1;
      __(t, e, a, n, i, s), v_(t, e, r, n, a - 1, 1 - s), v_(t, e, r, a + 1, i, 1 - s);
    }
    function __(t, e, r, n, i, s) {
      for (; i > n;) {
        if (i - n > 600) {
          var _a139 = i - n + 1,
            _o110 = r - n + 1,
            _l86 = Math.log(_a139),
            _u73 = .5 * Math.exp(2 * _l86 / 3),
            _c58 = .5 * Math.sqrt(_l86 * _u73 * (_a139 - _u73) / _a139) * (_o110 - _a139 / 2 < 0 ? -1 : 1);
          __(t, e, r, Math.max(n, Math.floor(r - _o110 * _u73 / _a139 + _c58)), Math.min(i, Math.floor(r + (_a139 - _o110) * _u73 / _a139 + _c58)), s);
        }
        var _a140 = e[2 * r + s];
        var _o111 = n,
          _l87 = i;
        for (w_(t, e, n, r), e[2 * i + s] > _a140 && w_(t, e, n, i); _o111 < _l87;) {
          for (w_(t, e, _o111, _l87), _o111++, _l87--; e[2 * _o111 + s] < _a140;) _o111++;
          for (; e[2 * _l87 + s] > _a140;) _l87--;
        }
        e[2 * n + s] === _a140 ? w_(t, e, n, _l87) : (_l87++, w_(t, e, _l87, i)), _l87 <= r && (n = _l87 + 1), r <= _l87 && (i = _l87 - 1);
      }
    }
    function w_(t, e, r, n) {
      M_(t, r, n), M_(e, 2 * r, 2 * n), M_(e, 2 * r + 1, 2 * n + 1);
    }
    function M_(t, e, r) {
      var n = t[e];
      t[e] = t[r], t[r] = n;
    }
    function A_(t, e, r, n) {
      var i = t - r,
        s = e - n;
      return i * i + s * s;
    }
    t.A = Hs, t.B = Ws, t.C = Gn, t.D = Zs, t.E = On, t.F = Ri, t.H = fl, t.I = Qg, t.J = no, t.K = to, t.L = function (t) {
      var e = t.value;
      var r = [];
      if (!e) return r;
      var n = Pi(e);
      return "string" !== n ? (r = r.concat([new rv(t.key, e, "string expected, \"".concat(n, "\" found"))]), r) : (nv(e, !0) || (r = r.concat([new rv(t.key, e, "invalid url \"".concat(e, "\""))])), r);
    }, t.M = /*#__PURE__*/function () {
      function _class7(t, e, r, n) {
        _classCallCheck(this, _class7);
        this.id = t, this.position = null != e ? new bc(e[0], e[1]) : new bc(0, 0), this.orientation = null != r ? r : [0, 0, 0], this.nodes = n, this.uploaded = !1, this.aabb = new kh([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), this.matrix = [];
      }
      _createClass(_class7, [{
        key: "_applyTransformations",
        value: function _applyTransformations(e, r) {
          if (t.ae.multiply(e.matrix, r, e.matrix), e.meshes) {
            var _iterator252 = _createForOfIteratorHelper(e.meshes),
              _step252;
            try {
              for (_iterator252.s(); !(_step252 = _iterator252.n()).done;) {
                var _t380 = _step252.value;
                var _r304 = kh.applyTransformFast(_t380.aabb, e.matrix);
                this.aabb.encapsulate(_r304);
              }
            } catch (err) {
              _iterator252.e(err);
            } finally {
              _iterator252.f();
            }
          }
          if (e.children) {
            var _iterator253 = _createForOfIteratorHelper(e.children),
              _step253;
            try {
              for (_iterator253.s(); !(_step253 = _iterator253.n()).done;) {
                var _t381 = _step253.value;
                this._applyTransformations(_t381, e.matrix);
              }
            } catch (err) {
              _iterator253.e(err);
            } finally {
              _iterator253.f();
            }
          }
        }
      }, {
        key: "computeBoundsAndApplyParent",
        value: function computeBoundsAndApplyParent() {
          var e = t.ae.identity([]);
          var _iterator254 = _createForOfIteratorHelper(this.nodes),
            _step254;
          try {
            for (_iterator254.s(); !(_step254 = _iterator254.n()).done;) {
              var _t382 = _step254.value;
              this._applyTransformations(_t382, e);
            }
          } catch (err) {
            _iterator254.e(err);
          } finally {
            _iterator254.f();
          }
        }
      }, {
        key: "computeModelMatrix",
        value: function computeModelMatrix(t, e, r, n, i, s) {
          var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
          hv(this.matrix, this, t.transform, this.position, e, r, n, i, s, a);
        }
      }, {
        key: "upload",
        value: function upload(t) {
          if (!this.uploaded) {
            var _iterator255 = _createForOfIteratorHelper(this.nodes),
              _step255;
            try {
              for (_iterator255.s(); !(_step255 = _iterator255.n()).done;) {
                var _e361 = _step255.value;
                dv(_e361, t);
              }
            } catch (err) {
              _iterator255.e(err);
            } finally {
              _iterator255.f();
            }
            var _iterator256 = _createForOfIteratorHelper(this.nodes),
              _step256;
            try {
              for (_iterator256.s(); !(_step256 = _iterator256.n()).done;) {
                var _t383 = _step256.value;
                mv(_t383);
              }
            } catch (err) {
              _iterator256.e(err);
            } finally {
              _iterator256.f();
            }
            this.uploaded = !0;
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iterator257 = _createForOfIteratorHelper(this.nodes),
            _step257;
          try {
            for (_iterator257.s(); !(_step257 = _iterator257.n()).done;) {
              var _t384 = _step257.value;
              yv(_t384);
            }
          } catch (err) {
            _iterator257.e(err);
          } finally {
            _iterator257.f();
          }
        }
      }]);
      return _class7;
    }(), t.N = cl, t.O = tl, t.P = je, t.Q = rr, t.R = Qr, t.S = hu, t.T = $g, t.U = ul, t.V = rv, t.W = al, t.X = /*#__PURE__*/function () {
      function _class8(t) {
        _classCallCheck(this, _class8);
        this.specification = t;
      }
      _createClass(_class8, [{
        key: "possiblyEvaluate",
        value: function possiblyEvaluate(t, e) {
          return gr(t.expression.evaluate(e));
        }
      }, {
        key: "interpolate",
        value: function interpolate(t, e, r) {
          return {
            x: Yn(t.x, e.x, r),
            y: Yn(t.y, e.y, r),
            z: Yn(t.z, e.z, r),
            azimuthal: Yn(t.azimuthal, e.azimuthal, r),
            polar: Yn(t.polar, e.polar, r)
          };
        }
      }]);
      return _class8;
    }(), t.Y = Wo, t.Z = yo, t._ = Nc, t.a = ix, t.a$ = wh, t.a0 = Je, t.a1 = sl, t.a2 = Qh, t.a3 = Yn, t.a4 = ds, t.a5 = Zn, t.a6 = /*#__PURE__*/function () {
      function _class9(t) {
        _classCallCheck(this, _class9);
        this.specification = t;
      }
      _createClass(_class9, [{
        key: "possiblyEvaluate",
        value: function possiblyEvaluate(t, e) {
          return function (_ref148) {
            var _ref149 = _slicedToArray(_ref148, 2),
              t = _ref149[0],
              e = _ref149[1];
            var r = gr([1, t, e]);
            return {
              x: r.x,
              y: r.y,
              z: r.z
            };
          }(t.expression.evaluate(e));
        }
      }, {
        key: "interpolate",
        value: function interpolate(t, e, r) {
          return {
            x: Yn(t.x, e.x, r),
            y: Yn(t.y, e.y, r),
            z: Yn(t.z, e.z, r)
          };
        }
      }]);
      return _class9;
    }(), t.a7 = qu, t.a8 = Vu, t.a9 = Ou, t.aA = function (t, e, r) {
      t[4 * e + 0] = r[0], t[4 * e + 1] = r[1], t[4 * e + 2] = r[2], t[4 * e + 3] = r[3];
    }, t.aC = function (e, r) {
      var _e$point = e.point,
        n = _e$point.x,
        i = _e$point.y,
        s = Jh(n, i, e.worldSize / e._pixelsPerMercatorPixel, 0, 0);
      return t.ae.multiply(s, s, Hh(Fh(r)));
    }, t.aE = Km, t.aF = oy, t.aG = Hm, t.aH = function (t, e, r, n, i) {
      var s = 5 * e + 2;
      t.float32[s + 0] = r, t.float32[s + 1] = n, t.float32[s + 2] = i;
    }, t.aI = Fg, t.aJ = bc, t.aK = Bg, t.aL = Ac, t.aM = Th, t.aN = Ub, t.aO = Mc, t.aP = Nh, t.aQ = Sc, t.aR = function (t, e, r, n, i, s, a, o, l) {
      if ("globe" === l.name) return Nh(t, e, new Mc(r, n, i), !1);
      var u = cg({
        z: r,
        x: n,
        y: i
      }, l);
      return new kh([(s + u.x / u.scale) * e, e * (u.y / u.scale), a], [(s + u.x2 / u.scale) * e, e * (u.y2 / u.scale), o]);
    }, t.aS = function (t, e, r) {
      var n = 0;
      for (var _r305 = 0; _r305 < 2; ++_r305) {
        var _i222 = 0;
        t[_r305] > _i222 && (n += (t[_r305] - _i222) * (t[_r305] - _i222)), e[_r305] < _i222 && (n += (_i222 - e[_r305]) * (_i222 - e[_r305]));
      }
      return n;
    }, t.aT = Vc, t.aU = _h, t.aV = uc, t.aW = function (e) {
      var r = t.ae.identity(new Float64Array(16));
      t.ae.multiply(r, e.pixelMatrix, e.globeMatrix);
      var n = [0, fc, 0],
        i = [0, dc, 0];
      return t.$.transformMat4(n, n, r), t.$.transformMat4(i, i, r), [n[0] > 0 && n[0] <= e.width && n[1] > 0 && n[1] <= e.height && !ep(e, new bc(e.center.lat, 90)), i[0] > 0 && i[0] <= e.width && i[1] > 0 && i[1] <= e.height && !ep(e, new bc(e.center.lat, -90))];
    }, t.aX = function (e, r) {
      var n = e.tileTransform.scale,
        i = n * ds / (e.tileSize * Math.pow(2, r.zoom - e.tileID.overscaledZ + e.tileID.canonical.z));
      return t.aD.scale(new Float32Array(4), r.inverseAdjustmentMatrix, [i, i]);
    }, t.aY = jb, t.aZ = Ob, t.a_ = function (e) {
      var r = Ob(e, !0);
      return t.aD.invert([], [r[0], r[1], r[4], r[5]]);
    }, t.aa = Nu, t.ab = Fu, t.ac = Ge, t.ad = function (t, e, r) {
      var n = Math.sqrt(t * t + e * e + r * r),
        i = n > 0 ? Math.acos(r / n) * qe : 0;
      var s = 0 !== t || 0 !== e ? Math.atan2(-e, -t) * qe + 90 : 0;
      return s < 0 && (s += 360), [n, s, i];
    }, t.af = tx, t.ag = ox, t.ah = rx, t.ai = function (t, e) {
      var r = {};
      for (var _n217 = 0; _n217 < e.length; _n217++) {
        var _i223 = e[_n217];
        _i223 in t && (r[_i223] = t[_i223]);
      }
      return r;
    }, t.aj = vc, t.ak = Ec, t.al = Bc, t.am = Tl, t.an = function (t) {
      Gr++, Gr > Or && (t.getActor().send("enforceCacheSizeLimit", Fr), Gr = 0);
    }, t.ao = bn, t.ap = /*#__PURE__*/function () {
      function _class10(t) {
        _classCallCheck(this, _class10);
        this.entries = {}, this.scheduler = t;
      }
      _createClass(_class10, [{
        key: "request",
        value: function request(t, e, r, n) {
          var _this72 = this;
          var i = this.entries[t] = this.entries[t] || {
            callbacks: []
          };
          if (i.result) {
            var _i$result = _slicedToArray(i.result, 2),
              _t385 = _i$result[0],
              _r306 = _i$result[1];
            return this.scheduler ? this.scheduler.add(function () {
              n(_t385, _r306);
            }, e) : n(_t385, _r306), function () {};
          }
          return i.callbacks.push(n), i.cancel || (i.cancel = r(function (r, n) {
            i.result = [r, n];
            var _iterator258 = _createForOfIteratorHelper(i.callbacks),
              _step258;
            try {
              var _loop11 = function _loop11() {
                var t = _step258.value;
                _this72.scheduler ? _this72.scheduler.add(function () {
                  t(r, n);
                }, e) : t(r, n);
              };
              for (_iterator258.s(); !(_step258 = _iterator258.n()).done;) {
                _loop11();
              }
            } catch (err) {
              _iterator258.e(err);
            } finally {
              _iterator258.f();
            }
            setTimeout(function () {
              return delete _this72.entries[t];
            }, 3e3);
          })), function () {
            i.result || (i.callbacks = i.callbacks.filter(function (t) {
              return t !== n;
            }), i.callbacks.length || (i.cancel(), delete _this72.entries[t]));
          };
        }
      }]);
      return _class10;
    }(), t.aq = function (t, e, r) {
      var n = JSON.stringify(t.request);
      return t.data && (this.deduped.entries[n] = {
        result: [null, t.data]
      }), this.deduped.request(n, {
        type: "parseTile",
        isSymbolTile: t.isSymbolTile,
        zoom: t.tileZoom
      }, function (e) {
        var n = nn(t.request, function (t, n, i, s) {
          t ? e(t) : n && e(null, {
            vectorTile: r ? void 0 : new Pf(new Om(n)),
            rawData: n,
            cacheControl: i,
            expires: s
          });
        });
        return function () {
          n.cancel(), e();
        };
      }, e);
    }, t.ar = Uu, t.as = /*#__PURE__*/function (_Lu9) {
      _inherits(_class11, _Lu9);
      var _super95 = _createSuper(_class11);
      function _class11(t) {
        var _this73;
        _classCallCheck(this, _class11);
        _this73 = _super95.call(this, t), _this73.current = Gu;
        return _this73;
      }
      _createClass(_class11, [{
        key: "set",
        value: function set(t, e, r) {
          if (this.fetchUniformLocation(t, e)) for (var _t386 = 0; _t386 < 9; _t386++) if (r[_t386] !== this.current[_t386]) {
            this.current = r, this.gl.uniformMatrix3fv(this.location, !1, r);
            break;
          }
        }
      }]);
      return _class11;
    }(Lu), t.at = ju, t.au = We, t.av = Qe, t.ax = kr, t.ay = Dc, t.az = Cc, t.b = ku, t.b$ = Tc, t.b0 = function (t) {
      var _t$point = t.point,
        e = _t$point.x,
        r = _t$point.y,
        _t$_center = t._center,
        n = _t$_center.lng,
        i = _t$_center.lat;
      return Jh(e, r, t.worldSize, n, i);
    }, t.b1 = Xe, t.b2 = Ic, t.b3 = lc, t.b4 = function (t) {
      var e = Math.round((t + 45 + 360) % 360 / 90) % 4;
      return Ye[e];
    }, t.b5 = 45, t.b6 = zc, t.b7 = jc, t.b8 = kh, t.b9 = gr, t.bA = cx, t.bB = xp, t.bC = function (t, e) {
      return [Math.pow(t[0], 2.2) * e, Math.pow(t[1], 2.2) * e, Math.pow(t[2], 2.2) * e];
    }, t.bD = hm, t.bF = Wh, t.bG = Br, t.bH = Er, t.bI = 256, t.bJ = function (e, r) {
      var n = [0, 0, 0],
        i = Zh(Fh(r.canonical));
      return t.$.transformMat4(n, n, i), t.$.transformMat4(n, n, e), n;
    }, t.bK = function (t) {
      return {
        u_camera_to_center_distance: new Fu(t),
        u_extrude_scale: new Yu(t),
        u_device_pixel_ratio: new Fu(t),
        u_matrix: new qu(t),
        u_inv_rot_matrix: new qu(t),
        u_merc_center: new Ou(t),
        u_tile_id: new Uu(t),
        u_zoom_transition: new Fu(t),
        u_up_dir: new Uu(t),
        u_emissive_strength: new Fu(t)
      };
    }, t.bL = function (t) {
      return {
        u_matrix: new qu(t),
        u_pixels_to_tile_units: new Yu(t),
        u_device_pixel_ratio: new Fu(t),
        u_units_to_pixels: new Ou(t),
        u_dash_image: new Vu(t),
        u_gradient_image: new Vu(t),
        u_image_height: new Fu(t),
        u_texsize: new Ou(t),
        u_tile_units_to_pixels: new Fu(t),
        u_alpha_discard_threshold: new Fu(t),
        u_trim_offset: new Ou(t),
        u_trim_fade_range: new Ou(t),
        u_trim_color: new ju(t),
        u_emissive_strength: new Fu(t)
      };
    }, t.bM = function (t) {
      return {
        u_matrix: new qu(t),
        u_texsize: new Ou(t),
        u_pixels_to_tile_units: new Yu(t),
        u_device_pixel_ratio: new Fu(t),
        u_image: new Vu(t),
        u_units_to_pixels: new Ou(t),
        u_tile_units_to_pixels: new Fu(t),
        u_alpha_discard_threshold: new Fu(t),
        u_trim_offset: new Ou(t)
      };
    }, t.bN = Jl, t.bO = rm, t.bP = Xm, t.bQ = Wm, t.bR = Qy, t.bS = xy, t.bT = ap, t.bU = function (t, e, r, n, i, s) {
      var a = t.transform,
        o = "globe" === a.projection.name;
      var l;
      if ("map" === s.paint.get("circle-pitch-alignment")) {
        if (o) {
          var _t387 = Wh(a.zoom, e.canonical) * a._pixelsPerMercatorPixel;
          l = Float32Array.from([_t387, 0, 0, _t387]);
        } else l = a.calculatePixelsToTileUnitsMatrix(r);
      } else l = new Float32Array([a.pixelsToGLUnits[0], 0, 0, a.pixelsToGLUnits[1]]);
      var u = {
        u_camera_to_center_distance: t.transform.getCameraToCenterDistance(a.projection),
        u_matrix: t.translatePosMatrix(e.projMatrix, r, s.paint.get("circle-translate"), s.paint.get("circle-translate-anchor")),
        u_device_pixel_ratio: Rr.devicePixelRatio,
        u_extrude_scale: l,
        u_inv_rot_matrix: sp,
        u_merc_center: [0, 0],
        u_tile_id: [0, 0, 0],
        u_zoom_transition: 0,
        u_up_dir: [0, 0, 0],
        u_emissive_strength: s.paint.get("circle-emissive-strength")
      };
      if (o) {
        u.u_inv_rot_matrix = n, u.u_merc_center = i, u.u_tile_id = [e.canonical.x, e.canonical.y, 1 << e.canonical.z], u.u_zoom_transition = Qh(a.zoom);
        var _t388 = i[0] * ds,
          _r307 = i[1] * ds;
        u.u_up_dir = a.projection.upVector(new Mc(0, 0, 0), _t388, _r307);
      }
      return u;
    }, t.bV = dm, t.bW = function (t, e, r, n, i, s) {
      var a = t.transform;
      return {
        u_matrix: fm(t, e, r, n),
        u_texsize: e.imageAtlasTexture ? e.imageAtlasTexture.size : [0, 0],
        u_pixels_to_tile_units: a.calculatePixelsToTileUnitsMatrix(e),
        u_device_pixel_ratio: i,
        u_image: 0,
        u_tile_units_to_pixels: pm(e, a),
        u_units_to_pixels: [1 / a.pixelsToGLUnits[0], 1 / a.pixelsToGLUnits[1]],
        u_alpha_discard_threshold: 0,
        u_trim_offset: s
      };
    }, t.bX = function (t, e, r, n, i, s, a) {
      var o = t.transform,
        l = o.calculatePixelsToTileUnitsMatrix(e);
      return {
        u_matrix: fm(t, e, r, n),
        u_pixels_to_tile_units: l,
        u_device_pixel_ratio: s,
        u_units_to_pixels: [1 / o.pixelsToGLUnits[0], 1 / o.pixelsToGLUnits[1]],
        u_dash_image: 0,
        u_gradient_image: 1,
        u_image_height: i,
        u_texsize: mm(r) && e.lineAtlasTexture ? e.lineAtlasTexture.size : [0, 0],
        u_tile_units_to_pixels: pm(e, t.transform),
        u_alpha_discard_threshold: 0,
        u_trim_offset: a,
        u_trim_fade_range: r.paint.get("line-trim-fade-range"),
        u_trim_color: r.paint.get("line-trim-color").toRenderColor(r.lut).toArray01(),
        u_emissive_strength: r.paint.get("line-emissive-strength")
      };
    }, t.bY = ar, t.bZ = Mp, t.b_ = Rd, t.ba = function (t) {
      return [Math.pow(t[0], 1 / 2.2), Math.pow(t[1], 1 / 2.2), Math.pow(t[2], 1 / 2.2)];
    }, t.bb = Ze, t.bc = function (t, e, r) {
      var n = Qh(r.zoom),
        i = t.style.map._antialias,
        s = e.options.extStandardDerivativesForceOff || t.terrain && t.terrain.exaggeration() > 0;
      return 0 === n && !i && !s;
    }, t.bd = function (e) {
      var r = e.pixelsPerMeter,
        n = r / Dc(1, e.center.lat),
        i = t.ae.identity(new Float64Array(16));
      return t.ae.translate(i, i, [e.point.x, e.point.y, 0]), t.ae.scale(i, i, [n, n, r]), Float32Array.from(i);
    }, t.be = $h, t.bf = function (t) {
      var e = Vc - 5;
      t = We(t, -e, e) / e * 90;
      var r = Math.pow(Math.abs(Math.sin(Ge(t))), 3);
      return Math.round(r * (pc.length - 1));
    }, t.bg = function (e, r, n, i) {
      var s = r.getNorth(),
        a = r.getSouth(),
        o = r.getWest(),
        l = r.getEast(),
        u = 1 << e.z,
        c = l - o,
        h = s - a,
        p = c / hc,
        f = -h / pc[n],
        d = [0, p, 0, f, 0, 0, s, o, 0];
      if (e.z > 0) {
        var _e362 = 180 / i;
        t.bE.multiply(d, d, [_e362 / c + 1, 0, 0, 0, _e362 / h + 1, 0, -.5 * _e362 / p, .5 * _e362 / f, 1]);
      }
      return d[2] = u, d[5] = e.x, d[8] = e.y, d;
    }, t.bh = Zh, t.bi = Fh, t.bj = function (e, r, n) {
      var i = t.ae.identity(new Float64Array(16)),
        s = (r / (1 << e) - .5) * Math.PI * 2;
      return t.ae.rotateY(i, n.globeMatrix, s), Float32Array.from(i);
    }, t.bk = Dr, t.bl = function (t) {
      return t <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(t) / Math.LN2));
    }, t.bm = zb, t.bn = Lb, t.bo = kb, t.bp = function (t, e) {
      var r = document.createElement("video");
      r.muted = !0, r.onloadstart = function () {
        e(null, r);
      };
      for (var _e363 = 0; _e363 < t.length; _e363++) {
        var _n218 = document.createElement("source");
        sn(t[_e363]) || (r.crossOrigin = "Anonymous"), _n218.src = t[_e363], r.appendChild(_n218);
      }
      return {
        cancel: function cancel() {}
      };
    }, t.bq = qg, t.br = lr, t.bs = /*#__PURE__*/function () {
      function _class12() {
        _classCallCheck(this, _class12);
      }
      _createClass(_class12, [{
        key: "isDataAvailableAtPoint",
        value: function isDataAvailableAtPoint(t) {
          var e = this._source();
          if (this.isUsingMockSource() || !e || t.y < 0 || t.y > 1) return !1;
          var r = e.getSource().maxzoom,
            n = 1 << r,
            i = Math.floor(t.x),
            s = Math.floor((t.x - i) * n),
            a = Math.floor(t.y * n),
            o = this.findDEMTileFor(new Sc(r, i, r, s, a));
          return !(!o || !o.dem);
        }
      }, {
        key: "getAtPointOrZero",
        value: function getAtPointOrZero(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return this.getAtPoint(t, e) || 0;
        }
      }, {
        key: "getAtPoint",
        value: function getAtPoint(t, e) {
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
          if (this.isUsingMockSource()) return null;
          null == e && (e = null);
          var n = this._source();
          if (!n) return e;
          if (t.y < 0 || t.y > 1) return e;
          var i = n.getSource().maxzoom,
            s = 1 << i,
            a = Math.floor(t.x),
            o = t.x - a,
            l = new Sc(i, a, i, Math.floor(o * s), Math.floor(t.y * s)),
            u = this.findDEMTileFor(l);
          if (!u || !u.dem) return e;
          var c = u.dem,
            h = 1 << u.tileID.canonical.z,
            p = (o * h - u.tileID.canonical.x) * c.dim,
            f = (t.y * h - u.tileID.canonical.y) * c.dim,
            d = Math.floor(p),
            m = Math.floor(f);
          return (r ? this.exaggeration() : 1) * Yn(Yn(c.get(d, m), c.get(d, m + 1), f - m), Yn(c.get(d + 1, m), c.get(d + 1, m + 1), f - m), p - d);
        }
      }, {
        key: "getAtTileOffset",
        value: function getAtTileOffset(t, e, r) {
          var n = 1 << t.canonical.z;
          return this.getAtPointOrZero(new Nc(t.wrap + (t.canonical.x + e / ds) / n, (t.canonical.y + r / ds) / n));
        }
      }, {
        key: "getAtTileOffsetFunc",
        value: function getAtTileOffsetFunc(e, r, n, i) {
          var _this74 = this;
          return function (s) {
            var a = _this74.getAtTileOffset(e, s.x, s.y),
              o = i.upVector(e.canonical, s.x, s.y),
              l = i.upVectorScale(e.canonical, r, n).metersToTile;
            return t.$.scale(o, o, a * l), o;
          };
        }
      }, {
        key: "getForTilePoints",
        value: function getForTilePoints(t, e, r, n) {
          var _this75 = this;
          if (this.isUsingMockSource()) return !1;
          var i = ad.create(this, t, n);
          return !!i && (e.forEach(function (t) {
            t[2] = _this75.exaggeration() * i.getElevationAt(t[0], t[1], r);
          }), !0);
        }
      }, {
        key: "getMinMaxForTile",
        value: function getMinMaxForTile(t) {
          if (this.isUsingMockSource()) return null;
          var e = this.findDEMTileFor(t);
          if (!e || !e.dem) return null;
          var r = e.dem.tree,
            n = e.tileID,
            i = 1 << t.canonical.z - n.canonical.z;
          var s = t.canonical.x / i - n.canonical.x,
            a = t.canonical.y / i - n.canonical.y,
            o = 0;
          for (var _e364 = 0; _e364 < t.canonical.z - n.canonical.z && !r.leaves[o]; _e364++) {
            s *= 2, a *= 2;
            var _t389 = 2 * Math.floor(a) + Math.floor(s);
            o = r.childOffsets[o] + _t389, s %= 1, a %= 1;
          }
          return {
            min: this.exaggeration() * r.minimums[o],
            max: this.exaggeration() * r.maximums[o]
          };
        }
      }, {
        key: "getMinElevationBelowMSL",
        value: function getMinElevationBelowMSL() {
          throw new Error("Pure virtual method called.");
        }
      }, {
        key: "raycast",
        value: function raycast(t, e, r) {
          throw new Error("Pure virtual method called.");
        }
      }, {
        key: "pointCoordinate",
        value: function pointCoordinate(t) {
          throw new Error("Pure virtual method called.");
        }
      }, {
        key: "_source",
        value: function _source() {
          throw new Error("Pure virtual method called.");
        }
      }, {
        key: "isUsingMockSource",
        value: function isUsingMockSource() {
          throw new Error("Pure virtual method called.");
        }
      }, {
        key: "exaggeration",
        value: function exaggeration() {
          throw new Error("Pure virtual method called.");
        }
      }, {
        key: "findDEMTileFor",
        value: function findDEMTileFor(t) {
          throw new Error("Pure virtual method called.");
        }
      }, {
        key: "visibleDemTiles",
        get: function get() {
          throw new Error("Getter must be implemented in subclass.");
        }
      }, {
        key: "getMinMaxForVisibleTiles",
        value: function getMinMaxForVisibleTiles() {
          var t = this.visibleDemTiles;
          if (0 === t.length) return null;
          var e = !1,
            r = Number.MAX_VALUE,
            n = Number.MIN_VALUE;
          var _iterator259 = _createForOfIteratorHelper(t),
            _step259;
          try {
            for (_iterator259.s(); !(_step259 = _iterator259.n()).done;) {
              var _i224 = _step259.value;
              var _t390 = this.getMinMaxForTile(_i224.tileID);
              _t390 && (r = Math.min(r, _t390.min), n = Math.max(n, _t390.max), e = !0);
            }
          } catch (err) {
            _iterator259.e(err);
          } finally {
            _iterator259.f();
          }
          return e ? {
            min: r,
            max: n
          } : null;
        }
      }]);
      return _class12;
    }(), t.bt = Bh, t.bu = Dh, t.bv = Ll, t.bw = tu, t.bx = ob, t.by = vv, t.bz = Iv, t.c = n_, t.c$ = function (t, e, r, n) {
      return "custom" === t.type ? new Vb(t, e) : new g_[t.type](t, e, r, n);
    }, t.c0 = Id, t.c1 = dd, t.c2 = 450, t.c3 = 7, t.c4 = Pb, t.c5 = sb, t.c6 = 256, t.c7 = Uh, t.c8 = Hh, t.c9 = Rl, t.cA = hh, t.cB = function (e, r) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return t.$.fromValues(((r.x - n) * e.scale - e.x) * ds, (r.y * e.scale - e.y) * ds, Lc(r.z, r.y));
    }, t.cC = function (t) {
      var e = 1 / 0,
        r = 1 / 0,
        n = -1 / 0,
        i = -1 / 0;
      var _iterator260 = _createForOfIteratorHelper(t),
        _step260;
      try {
        for (_iterator260.s(); !(_step260 = _iterator260.n()).done;) {
          var _s174 = _step260.value;
          e = Math.min(e, _s174.x), r = Math.min(r, _s174.y), n = Math.max(n, _s174.x), i = Math.max(i, _s174.y);
        }
      } catch (err) {
        _iterator260.e(err);
      } finally {
        _iterator260.f();
      }
      return {
        min: new je(e, r),
        max: new je(n, i)
      };
    }, t.cD = ch, t.cE = qc, t.cF = oc, t.cG = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"], t.cH = zy, t.cI = eh, t.cJ = Vf, t.cK = Xf, t.cL = Yf, t.cM = tg, t.cN = b_, t.cO = function (t) {
      return t({
        pluginStatus: $o,
        pluginURL: qo
      }), Yo.on("pluginStateChange", t), t;
    }, t.cP = Uy, t.cQ = Oy, t.cR = en, t.cS = Go, t.cT = s, t.cU = Lr, t.cV = Rn, t.cW = pr, t.cX = function (t) {
      var e = t.indexOf(Il);
      return e >= 0 ? t.slice(0, e) : t;
    }, t.cY = function (t) {
      return t.indexOf(Il) >= 0;
    }, t.cZ = function (t) {
      var e = t.indexOf(Il);
      return e >= 0 ? t.slice(e + 1) : "";
    }, t.c_ = function (t) {
      var e = [],
        r = t.id;
      return void 0 === r && e.push({
        message: "layers.".concat(r, ": missing required property \"id\"")
      }), void 0 === t.render && e.push({
        message: "layers.".concat(r, ": missing required method \"render\"")
      }), t.renderingMode && "2d" !== t.renderingMode && "3d" !== t.renderingMode && e.push({
        message: "layers.".concat(r, ": property \"renderingMode\" must be either \"2d\" or \"3d\"")
      }), e;
    }, t.ca = Nl, t.cb = iu, t.cc = 1, t.cd = nx, t.ce = 0, t.cf = su, t.cg = function (t, e, r, n, i) {
      return We((t - e) / (r - e) * (i - n) + n, n, i);
    }, t.ch = $a, t.ci = Oc, t.cj = /*#__PURE__*/function () {
      function _class13(t, e, r, n) {
        _classCallCheck(this, _class13);
        this.context = t, this.format = n, this.size = r, this.texture = t.gl.createTexture();
        var _this$size = _slicedToArray(this.size, 3),
          i = _this$size[0],
          s = _this$size[1],
          a = _this$size[2],
          o = t.gl;
        o.bindTexture(o.TEXTURE_3D, this.texture), t.pixelStoreUnpackFlipY.set(!1), t.pixelStoreUnpack.set(1), t.pixelStoreUnpackPremultiplyAlpha.set(!1);
        var l = this.format,
          u = o.UNSIGNED_BYTE;
        this.format === o.DEPTH_COMPONENT && (l = o.DEPTH_COMPONENT16, u = o.UNSIGNED_SHORT), this.format === o.R8 && (n = o.RED), this.format === o.R32F && (u = o.FLOAT, n = o.RED), o.texImage3D(o.TEXTURE_3D, 0, l, i, s, a, 0, n, u, e.data);
      }
      _createClass(_class13, [{
        key: "bind",
        value: function bind(t, e) {
          var r = this.context,
            n = r.gl;
          n.bindTexture(n.TEXTURE_3D, this.texture), t !== this.minFilter && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MAG_FILTER, t), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MIN_FILTER, t), this.minFilter = t), e !== this.wrapS && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_S, e), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_T, e), this.wrapS = e);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = this.context.gl;
          t.deleteTexture(this.texture), this.texture = null;
        }
      }]);
      return _class13;
    }(), t.ck = Yb, t.cl = [1, 1, 1], t.cm = ad, t.cn = cv, t.co = Hl, t.cp = /*#__PURE__*/function () {
      function _class14() {
        _classCallCheck(this, _class14);
        this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [], this._globalClipBounds = {
          min: new je(1 / 0, 1 / 0),
          max: new je(-1 / 0, -1 / 0)
        };
      }
      _createClass(_class14, [{
        key: "clear",
        value: function clear() {
          this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
        }
      }, {
        key: "updateTime",
        get: function get() {
          return this._updateTime;
        }
      }, {
        key: "getReplacementRegionsForTile",
        value: function getReplacementRegionsForTile(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var r = Nf(new je(0, 0), new je(ds, ds), t),
            n = [];
          if (e && !Uf(r, this._globalClipBounds)) return n;
          var _iterator261 = _createForOfIteratorHelper(this._activeRegions),
            _step261;
          try {
            for (_iterator261.s(); !(_step261 = _iterator261.n()).done;) {
              var _e365 = _step261.value;
              if (_e365.hiddenByOverlap) continue;
              if (!Uf(r, _e365)) continue;
              var _i225 = $f(_e365.min, _e365.max, t);
              n.push({
                min: _i225.min,
                max: _i225.max,
                sourceId: this._sourceIds[_e365.priority],
                footprint: _e365.footprint,
                footprintTileId: _e365.tileId,
                order: _e365.order,
                clipMask: _e365.clipMask,
                clipScope: _e365.clipScope
              });
            }
          } catch (err) {
            _iterator261.e(err);
          } finally {
            _iterator261.f();
          }
          return n;
        }
      }, {
        key: "setSources",
        value: function setSources(t) {
          this._setSources(t.map(function (t) {
            return {
              getSourceId: function getSourceId() {
                return t.cache.id;
              },
              getFootprints: function getFootprints() {
                var e = [];
                var _iterator262 = _createForOfIteratorHelper(t.cache.getVisibleCoordinates()),
                  _step262;
                try {
                  for (_iterator262.s(); !(_step262 = _iterator262.n()).done;) {
                    var _r308 = _step262.value;
                    var _n219 = t.cache.getTile(_r308).buckets[t.layer];
                    _n219 && _n219.updateFootprints(_r308.toUnwrapped(), e);
                  }
                } catch (err) {
                  _iterator262.e(err);
                } finally {
                  _iterator262.f();
                }
                return e;
              },
              getOrder: function getOrder() {
                return t.order;
              },
              getClipMask: function getClipMask() {
                return t.clipMask;
              },
              getClipScope: function getClipScope() {
                return t.clipScope;
              }
            };
          }));
        }
      }, {
        key: "_addSource",
        value: function _addSource(t) {
          var e = t.getFootprints();
          if (0 === e.length) return;
          var r = t.getOrder(),
            n = t.getClipMask(),
            i = t.getClipScope();
          var _iterator263 = _createForOfIteratorHelper(e),
            _step263;
          try {
            for (_iterator263.s(); !(_step263 = _iterator263.n()).done;) {
              var _t391 = _step263.value;
              if (!_t391.footprint) continue;
              var _e366 = Nf(_t391.footprint.min, _t391.footprint.max, _t391.id);
              this._activeRegions.push({
                min: _e366.min,
                max: _e366.max,
                hiddenByOverlap: !1,
                priority: this._sourceIds.length,
                tileId: _t391.id,
                footprint: _t391.footprint,
                order: r,
                clipMask: n,
                clipScope: i
              });
            }
          } catch (err) {
            _iterator263.e(err);
          } finally {
            _iterator263.f();
          }
          this._sourceIds.push(t.getSourceId());
        }
      }, {
        key: "_computeReplacement",
        value: function _computeReplacement() {
          var _this76 = this;
          this._activeRegions.sort(function (t, e) {
            return t.priority - e.priority || Ff(t.min, e.min) || Ff(t.max, e.max) || t.order - e.order || t.clipMask - e.clipMask || function (t, e) {
              var r = function r(t, e) {
                return t + e;
              };
              return t.length - e.length || t.reduce(r, "").localeCompare(e.reduce(r, ""));
            }(t.clipScope, e.clipScope);
          });
          var t = this._activeRegions.length !== this._prevRegions.length;
          if (!t) {
            var _e367 = 0;
            for (; !t && _e367 !== this._activeRegions.length;) {
              var _r309 = this._activeRegions[_e367],
                _n220 = this._prevRegions[_e367];
              t = _r309.priority !== _n220.priority || !Of(_r309, _n220) || _r309.order !== _n220.order || _r309.clipMask !== _n220.clipMask || !Ne(_r309.clipScope, _n220.clipScope), ++_e367;
            }
          }
          if (t) {
            ++this._updateTime;
            var _iterator264 = _createForOfIteratorHelper(this._activeRegions),
              _step264;
            try {
              for (_iterator264.s(); !(_step264 = _iterator264.n()).done;) {
                var _t394 = _step264.value;
                _t394.order !== Lf && (this._globalClipBounds.min.x = Math.min(this._globalClipBounds.min.x, _t394.min.x), this._globalClipBounds.min.y = Math.min(this._globalClipBounds.min.y, _t394.min.y), this._globalClipBounds.max.x = Math.max(this._globalClipBounds.max.x, _t394.max.x), this._globalClipBounds.max.y = Math.max(this._globalClipBounds.max.y, _t394.max.y));
              }
            } catch (err) {
              _iterator264.e(err);
            } finally {
              _iterator264.f();
            }
            var _t392 = function _t392(t) {
              var e = _this76._activeRegions;
              if (t >= e.length) return t;
              var r = e[t].priority;
              for (; t < e.length && e[t].priority === r;) ++t;
              return t;
            };
            if (this._sourceIds.length > 1) {
              var _e368 = 0,
                _r310 = _t392(_e368);
              for (; _e368 !== _r310;) {
                var _n221 = _e368;
                var _i226 = _e368;
                for (; _n221 !== _r310;) {
                  var _t393 = this._activeRegions[_n221];
                  _t393.hiddenByOverlap = !1;
                  for (var _e369 = 0; _e369 < _i226; _e369++) {
                    var _r311 = this._activeRegions[_e369];
                    if (!_r311.hiddenByOverlap && _t393.order === Lf && Uf(_t393, _r311) && (_t393.hiddenByOverlap = Gf(_t393.footprint, _t393.tileId, _r311.footprint, _r311.tileId), _t393.hiddenByOverlap)) break;
                  }
                  ++_n221;
                }
                _e368 = _r310, _r310 = _t392(_e368);
              }
            }
          }
        }
      }, {
        key: "_setSources",
        value: function _setSources(t) {
          var _ref150;
          (_ref150 = [this._activeRegions, []], this._prevRegions = _ref150[0], this._activeRegions = _ref150[1]), this._sourceIds = [];
          for (var _e370 = t.length - 1; _e370 >= 0; _e370--) this._addSource(t[_e370]);
          this._computeReplacement();
        }
      }]);
      return _class14;
    }(), t.cq = Fl, t.cr = Jg, t.cs = ou, t.ct = /*#__PURE__*/function () {
      function _class15(t) {
        _classCallCheck(this, _class15);
        this._createGrid(t), this._createPoles(t);
      }
      _createClass(_class15, [{
        key: "destroy",
        value: function destroy() {
          this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
          var _iterator265 = _createForOfIteratorHelper(this._poleSegments),
            _step265;
          try {
            for (_iterator265.s(); !(_step265 = _iterator265.n()).done;) {
              var _t395 = _step265.value;
              _t395.destroy();
            }
          } catch (err) {
            _iterator265.e(err);
          } finally {
            _iterator265.f();
          }
          var _iterator266 = _createForOfIteratorHelper(this._gridSegments),
            _step266;
          try {
            for (_iterator266.s(); !(_step266 = _iterator266.n()).done;) {
              var _t396 = _step266.value;
              _t396.withSkirts.destroy(), _t396.withoutSkirts.destroy();
            }
          } catch (err) {
            _iterator266.e(err);
          } finally {
            _iterator266.f();
          }
        }
      }, {
        key: "_fillGridMeshWithLods",
        value: function _fillGridMeshWithLods(t, e) {
          var r = new Ll(),
            n = new tu(),
            i = [],
            s = t + 1 + 2,
            a = e[0] + 1,
            o = e[0] + 1 + (1 + e.length),
            l = function l(t, e, r) {
              var n = t === s - 1 ? t - 2 : 0 === t ? t : t - 1;
              return n += r ? 24575 : 0, [n, e];
            };
          for (var _t397 = 0; _t397 < s; ++_t397) r.emplaceBack.apply(r, _toConsumableArray(l(_t397, 0, !0)));
          for (var _t398 = 0; _t398 < a; ++_t398) for (var _e371 = 0; _e371 < s; ++_e371) r.emplaceBack.apply(r, _toConsumableArray(l(_e371, _t398, (0 === _e371 || _e371 === s - 1) && !0)));
          for (var _t399 = 0; _t399 < e.length; ++_t399) {
            var _n222 = e[_t399];
            for (var _t400 = 0; _t400 < s; ++_t400) r.emplaceBack.apply(r, _toConsumableArray(l(_t400, _n222, !0)));
          }
          for (var _t401 = 0; _t401 < e.length; ++_t401) {
            var _a141 = n.length,
              _l88 = e[_t401] + 1 + 2,
              _u74 = new tu();
            for (var _r312 = 0; _r312 < _l88 - 1; _r312++) {
              var _i227 = _r312 === _l88 - 2,
                _a142 = _i227 ? s * (o - e.length + _t401 - _r312) : s;
              for (var _t402 = 0; _t402 < s - 1; _t402++) {
                var _e372 = _r312 * s + _t402;
                0 === _r312 || _i227 || 0 === _t402 || _t402 === s - 2 ? (_u74.emplaceBack(_e372 + 1, _e372, _e372 + _a142), _u74.emplaceBack(_e372 + _a142, _e372 + _a142 + 1, _e372 + 1)) : (n.emplaceBack(_e372 + 1, _e372, _e372 + _a142), n.emplaceBack(_e372 + _a142, _e372 + _a142 + 1, _e372 + 1));
              }
            }
            var _c59 = ku.simpleSegment(0, _a141, r.length, n.length - _a141);
            for (var _t403 = 0; _t403 < _u74.uint16.length; _t403 += 3) n.emplaceBack(_u74.uint16[_t403], _u74.uint16[_t403 + 1], _u74.uint16[_t403 + 2]);
            var _h49 = ku.simpleSegment(0, _a141, r.length, n.length - _a141);
            i.push({
              withoutSkirts: _c59,
              withSkirts: _h49
            });
          }
          return {
            vertices: r,
            indices: n,
            segments: i
          };
        }
      }, {
        key: "_createGrid",
        value: function _createGrid(t) {
          var e = this._fillGridMeshWithLods(hc, pc);
          this._gridSegments = e.segments, this._gridBuffer = t.createVertexBuffer(e.vertices, Bh.members), this._gridIndexBuffer = t.createIndexBuffer(e.indices, !0);
        }
      }, {
        key: "_createPoles",
        value: function _createPoles(t) {
          var e = new tu();
          for (var _t404 = 0; _t404 <= hc; _t404++) e.emplaceBack(0, _t404 + 1, _t404 + 2);
          this._poleIndexBuffer = t.createIndexBuffer(e, !0);
          var r = new iu(),
            n = new iu(),
            i = new iu(),
            s = new iu();
          this._poleSegments = [];
          for (var _t405 = 0, _e373 = 0; _t405 < lc; _t405++) {
            var _a143 = 360 / (1 << _t405);
            r.emplaceBack(0, -oc, 0, .5, 0), n.emplaceBack(0, -oc, 0, .5, 1), i.emplaceBack(0, -oc, 0, .5, .5), s.emplaceBack(0, -oc, 0, .5, .5);
            for (var _t406 = 0; _t406 <= hc; _t406++) {
              var _e374 = _t406 / hc,
                _o112 = 0;
              var _l89 = Yn(0, _a143, _e374),
                _mc = mc(np, ip, _l89, oc),
                _mc2 = _slicedToArray(_mc, 3),
                _u75 = _mc2[0],
                _c60 = _mc2[1],
                _h50 = _mc2[2];
              r.emplaceBack(_u75, _c60, _h50, _e374, _o112), n.emplaceBack(_u75, _c60, _h50, _e374, 1 - _o112);
              var _p44 = Ge(_l89);
              _e374 = .5 + .5 * Math.sin(_p44), _o112 = .5 + .5 * Math.cos(_p44), i.emplaceBack(_u75, _c60, _h50, _e374, _o112), s.emplaceBack(_u75, _c60, _h50, _e374, 1 - _o112);
            }
            this._poleSegments.push(ku.simpleSegment(_e373, 0, 66, 64)), _e373 += 66;
          }
          this._poleNorthVertexBuffer = t.createVertexBuffer(r, zh, !1), this._poleSouthVertexBuffer = t.createVertexBuffer(n, zh, !1), this._texturedPoleNorthVertexBuffer = t.createVertexBuffer(i, zh, !1), this._texturedPoleSouthVertexBuffer = t.createVertexBuffer(s, zh, !1);
        }
      }, {
        key: "getGridBuffers",
        value: function getGridBuffers(t, e) {
          return [this._gridBuffer, this._gridIndexBuffer, e ? this._gridSegments[t].withSkirts : this._gridSegments[t].withoutSkirts];
        }
      }, {
        key: "getPoleBuffers",
        value: function getPoleBuffers(t, e) {
          return [e ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer, e ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer, this._poleIndexBuffer, this._poleSegments[t]];
        }
      }]);
      return _class15;
    }(), t.cu = function (t) {
      return kn.has(t);
    }, t.cv = Lf, t.cw = od, t.cx = function (t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
      var i = new je(r, r),
        s = t.sub(i),
        a = e.add(i),
        o = [s, new je(a.x, s.y), a, new je(s.x, a.y)];
      return n && o.push(s.clone()), o;
    }, t.cy = function (t, e) {
      var r = [];
      for (var _n223 = 0; _n223 < t.length; _n223++) {
        var _i228 = Qe(_n223 - 1, -1, t.length - 1),
          _s175 = Qe(_n223 + 1, -1, t.length - 1),
          _a144 = t[_n223],
          _o113 = t[_s175],
          _l90 = t[_i228].sub(_a144).unit(),
          _u76 = _o113.sub(_a144).unit(),
          _c61 = _u76.angleWithSep(_l90.x, _l90.y),
          _h51 = _l90.add(_u76).unit().mult(-1 * e / Math.sin(_c61 / 2));
        r.push(_a144.add(_h51));
      }
      return r;
    }, t.cz = hg, t.d = Ne, t.d$ = rb, t.d0 = hr, t.d1 = Yo, t.d2 = rn, t.d3 = He, t.d4 = function () {
      return !!document.fullscreenElement || !!document.webkitFullscreenElement;
    }, t.d5 = Ke, t.d6 = Uc, t.d7 = yc, t.d8 = function (_ref151) {
      var _ref152 = _slicedToArray(_ref151, 3),
        t = _ref152[0],
        e = _ref152[1],
        r = _ref152[2];
      var n = Math.hypot(t, e, r),
        i = Math.atan2(t, r),
        s = .5 * Math.PI - Math.acos(-e / n);
      return new bc(Xe(i), Xe(s));
    }, t.d9 = Rc, t.dA = function () {
      Iv().acquire(Mv);
    }, t.dB = function () {
      var t = Sv;
      t && (t.isPreloaded() && 1 === t.numActive() ? (t.release(Mv), Sv = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
    }, t.dC = Av, t.dD = function (t) {
      var e = $r();
      if (!e) return;
      var r = e.delete(Vr);
      t && r.catch(t).then(function () {
        return t();
      });
    }, t.dE = _v, t.dF = Dv, t.dG = function (t) {
      kv = Rr.resolveURL(t), Bv || (Bv = new vv(Iv(), new On())), Bv.broadcast("setDracoUrl", kv);
    }, t.dH = Rv, t.dI = function (t) {
      zv = Rr.resolveURL(t), Bv || (Bv = new vv(Iv(), new On())), Bv.broadcast("setMeshoptUrl", zv);
    }, t.dJ = er, t.dK = So, t.dL = yp, t.dM = Fy, t.dN = cg, t.dO = du, t.dP = ym, t.dQ = $m, t.dR = nm, t.dS = cr, t.dT = Ry, t.dU = Ng, t.dV = function (t, e, r, n, i, s, a, o, l, u, c) {
      t.createArrays(), t.tilePixelRatio = ds / (512 * t.overscaling), t.compareText = {}, t.iconsNeedLinear = !1;
      var h = t.layers[0].layout,
        p = t.layers[0]._unevaluatedLayout._values,
        f = {};
      if ("composite" === t.textSizeData.kind) {
        var _t$textSizeData = t.textSizeData,
          _e375 = _t$textSizeData.minZoom,
          _r313 = _t$textSizeData.maxZoom;
        f.compositeTextSizes = [p["text-size"].possiblyEvaluate(new Wo(_e375), o), p["text-size"].possiblyEvaluate(new Wo(_r313), o)];
      }
      if ("composite" === t.iconSizeData.kind) {
        var _t$iconSizeData = t.iconSizeData,
          _e376 = _t$iconSizeData.minZoom,
          _r314 = _t$iconSizeData.maxZoom;
        f.compositeIconSizes = [p["icon-size"].possiblyEvaluate(new Wo(_e376), o), p["icon-size"].possiblyEvaluate(new Wo(_r314), o)];
      }
      f.layoutTextSize = p["text-size"].possiblyEvaluate(new Wo(l + 1), o), f.layoutIconSize = p["icon-size"].possiblyEvaluate(new Wo(l + 1), o), f.textMaxSize = p["text-size"].possiblyEvaluate(new Wo(18), o);
      var d = "map" === h.get("text-rotation-alignment") && "point" !== h.get("symbol-placement"),
        m = h.get("text-size");
      var y = !1;
      var _iterator267 = _createForOfIteratorHelper(t.features),
        _step267;
      try {
        for (_iterator267.s(); !(_step267 = _iterator267.n()).done;) {
          var _e377 = _step267.value;
          if (_e377.icon && _e377.icon.nameSecondary) {
            y = !0;
            break;
          }
        }
      } catch (err) {
        _iterator267.e(err);
      } finally {
        _iterator267.f();
      }
      var _iterator268 = _createForOfIteratorHelper(t.features),
        _step268;
      try {
        var _loop12 = function _loop12() {
          var s = _step268.value;
          var l = h.get("text-font").evaluate(s, {}, o).join(","),
            p = m.evaluate(s, {}, o),
            g = f.layoutTextSize.evaluate(s, {}, o),
            x = (f.layoutIconSize.evaluate(s, {}, o), {
              horizontal: {},
              vertical: void 0
            }),
            b = s.text;
          var v,
            _ = [0, 0];
          if (b) {
            var _n224 = b.toString(),
              _a145 = h.get("text-letter-spacing").evaluate(s, {}, o) * Xm,
              _u77 = h.get("text-line-height").evaluate(s, {}, o) * Xm,
              _c62 = Bo(_n224) ? _a145 : 0,
              _f39 = h.get("text-anchor").evaluate(s, {}, o),
              _m21 = h.get("text-variable-anchor");
            if (!_m21) {
              var _t407 = h.get("text-radial-offset").evaluate(s, {}, o);
              _ = _t407 ? Qy(_f39, [_t407 * Xm, Wy]) : h.get("text-offset").evaluate(s, {}, o).map(function (t) {
                return t * Xm;
              });
            }
            var _y18 = d ? "center" : h.get("text-justify").evaluate(s, {}, o);
            var _v12 = "point" === h.get("symbol-placement"),
              _w10 = _v12 ? h.get("text-max-width").evaluate(s, {}, o) * Xm : 1 / 0,
              _M11 = function _M11(s) {
                t.allowVerticalPlacement && Eo(_n224) && (x.vertical = cy(b, e, r, i, l, _w10, _u77, _f39, s, _c62, _, oy.vertical, !0, g, p));
              };
            if (!d && _m21) {
              var _t408 = "auto" === _y18 ? _m21.map(function (t) {
                return tg(t);
              }) : [_y18];
              var _n225 = !1;
              for (var _s176 = 0; _s176 < _t408.length; _s176++) {
                var _a146 = _t408[_s176];
                if (!x.horizontal[_a146]) if (_n225) x.horizontal[_a146] = x.horizontal[0];else {
                  var _t409 = cy(b, e, r, i, l, _w10, _u77, "center", _a146, _c62, _, oy.horizontal, !1, g, p);
                  _t409 && (x.horizontal[_a146] = _t409, _n225 = 1 === _t409.positionedLines.length);
                }
              }
              _M11("left");
            } else {
              if ("auto" === _y18 && (_y18 = tg(_f39)), _v12 || h.get("text-writing-mode").indexOf("horizontal") >= 0 || !Eo(_n224)) {
                var _t410 = cy(b, e, r, i, l, _w10, _u77, _f39, _y18, _c62, _, oy.horizontal, !1, g, p);
                _t410 && (x.horizontal[_y18] = _t410);
              }
              _M11(_v12 ? "left" : _y18);
            }
          }
          var w = !1;
          if (s.icon && s.icon.namePrimary) {
            var _e378 = n[s.icon.namePrimary];
            _e378 && (v = vy(i[s.icon.namePrimary], s.icon.nameSecondary ? i[s.icon.nameSecondary] : void 0, h.get("icon-offset").evaluate(s, {}, o), h.get("icon-anchor").evaluate(s, {}, o)), w = _e378.sdf, void 0 === t.sdfIcons ? t.sdfIcons = _e378.sdf : t.sdfIcons !== _e378.sdf && dr("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (_e378.pixelRatio !== t.pixelRatio || 0 !== h.get("icon-rotate").constantOr(1)) && (t.iconsNeedLinear = !0));
          }
          var M = sg(x.horizontal) || x.vertical;
          t.iconsInText || (t.iconsInText = !!M && M.iconsInText), (M || v) && eg(t, s, x, v, n, f, g, 0, _, w, a, o, u, c, y);
        };
        for (_iterator268.s(); !(_step268 = _iterator268.n()).done;) {
          _loop12();
        }
      } catch (err) {
        _iterator268.e(err);
      } finally {
        _iterator268.f();
      }
      s && t.generateCollisionDebugBuffers(l, t.collisionBoxArray);
    }, t.dW = om, t.dX = ef, t.dY = Pf, t.dZ = Om, t.d_ = sd, t.da = gc, t.db = n, t.dc = ep, t.dd = tp, t.de = function (e) {
      var r = [0, 0, 0],
        n = t.ae.identity(new Float64Array(16));
      return t.ae.multiply(n, e.pixelMatrix, e.globeMatrix), t.$.transformMat4(r, r, n), new je(r[0], r[1]);
    }, t.df = c, t.dg = u, t.dh = function (t) {
      var e = t.navigator ? t.navigator.userAgent : null;
      return !!function (t) {
        if (null == Ir) {
          var _e379 = t.navigator ? t.navigator.userAgent : null;
          Ir = !!t.safari || !(!_e379 || !(/\b(iPad|iPhone|iPod)\b/.test(_e379) || _e379.match("Safari") && !_e379.match("Chrome")));
        }
        return Ir;
      }(t) && e && (e.match("Version/15.4") || e.match("Version/15.5") || e.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/));
    }, t.di = ir, t.dj = /*#__PURE__*/function () {
      function _class16(t, e, r) {
        _classCallCheck(this, _class16);
        this._transformRequestFn = t, this._customAccessToken = e, this._silenceAuthErrors = !!r, this._createSkuToken();
      }
      _createClass(_class16, [{
        key: "_createSkuToken",
        value: function _createSkuToken() {
          var t = function () {
            var t = "";
            for (var _e380 = 0; _e380 < 10; _e380++) t += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
            return {
              token: ["1", cn, t].join(""),
              tokenExpiresAt: Date.now() + 432e5
            };
          }();
          this._skuToken = t.token, this._skuTokenExpiresAt = t.tokenExpiresAt;
        }
      }, {
        key: "_isSkuTokenExpired",
        value: function _isSkuTokenExpired() {
          return Date.now() > this._skuTokenExpiresAt;
        }
      }, {
        key: "transformRequest",
        value: function transformRequest(t, e) {
          return this._transformRequestFn && this._transformRequestFn(t, e) || {
            url: t
          };
        }
      }, {
        key: "normalizeStyleURL",
        value: function normalizeStyleURL(t, r) {
          if (!s(t)) return t;
          var n = fn(t);
          return n.params.push("sdk=js-".concat(e)), n.path = "/styles/v1".concat(n.path), this._makeAPIURL(n, this._customAccessToken || r);
        }
      }, {
        key: "normalizeGlyphsURL",
        value: function normalizeGlyphsURL(t, e) {
          if (!s(t)) return t;
          var r = fn(t);
          return r.path = "/fonts/v1".concat(r.path), this._makeAPIURL(r, this._customAccessToken || e);
        }
      }, {
        key: "normalizeModelURL",
        value: function normalizeModelURL(t, e) {
          if (!s(t)) return t;
          var r = fn(t);
          return r.path = "/models/v1".concat(r.path), this._makeAPIURL(r, this._customAccessToken || e);
        }
      }, {
        key: "normalizeSourceURL",
        value: function normalizeSourceURL(t, e, r, n) {
          if (!s(t)) return t;
          var i = fn(t);
          return i.path = "/v4/".concat(i.authority, ".json"), i.params.push("secure"), r && i.params.push("language=".concat(r)), n && i.params.push("worldview=".concat(n)), this._makeAPIURL(i, this._customAccessToken || e);
        }
      }, {
        key: "normalizeSpriteURL",
        value: function normalizeSpriteURL(t, e, r, n) {
          var i = fn(t);
          return s(t) ? (i.path = "/styles/v1".concat(i.path, "/sprite").concat(e).concat(r), this._makeAPIURL(i, this._customAccessToken || n)) : (i.path += "".concat(e).concat(r), dn(i));
        }
      }, {
        key: "normalizeTileURL",
        value: function normalizeTileURL(t, e, r) {
          if (this._isSkuTokenExpired() && this._createSkuToken(), t && !s(t)) return t;
          var i = fn(t);
          i.path = i.path.replace(/(\.(png|jpg)\d*)(?=$)/, "".concat(e || r && "raster" !== i.authority && 512 === r ? "@2x" : "").concat(Xr.supported ? ".webp" : "$1")), "raster" === i.authority ? i.path = "/".concat(n.RASTER_URL_PREFIX).concat(i.path) : "rasterarrays" === i.authority ? i.path = "/".concat(n.RASTERARRAYS_URL_PREFIX).concat(i.path) : "3dtiles" === i.authority ? i.path = "/".concat(n.TILES3D_URL_PREFIX).concat(i.path) : (i.path = i.path.replace(/^.+\/v4\//, "/"), i.path = "/".concat(n.TILE_URL_VERSION).concat(i.path));
          var a = this._customAccessToken || function (t) {
            var _iterator269 = _createForOfIteratorHelper(t),
              _step269;
            try {
              for (_iterator269.s(); !(_step269 = _iterator269.n()).done;) {
                var _e381 = _step269.value;
                var _t411 = _e381.match(/^access_token=(.*)$/);
                if (_t411) return _t411[1];
              }
            } catch (err) {
              _iterator269.e(err);
            } finally {
              _iterator269.f();
            }
            return null;
          }(i.params) || n.ACCESS_TOKEN;
          return n.REQUIRE_ACCESS_TOKEN && a && this._skuToken && i.params.push("sku=".concat(this._skuToken)), this._makeAPIURL(i, a);
        }
      }, {
        key: "canonicalizeTileURL",
        value: function canonicalizeTileURL(t, e) {
          var r = fn(t);
          if (!r.path.match(/^(\/v4\/|\/(raster|rasterarrays)\/v1\/)/) || !r.path.match(/\.[\w]+$/)) return t;
          var i = "mapbox://";
          r.path.match(/^\/raster\/v1\//) ? i += "raster/".concat(r.path.replace("/".concat(n.RASTER_URL_PREFIX, "/"), "")) : r.path.match(/^\/rasterarrays\/v1\//) ? i += "rasterarrays/".concat(r.path.replace("/".concat(n.RASTERARRAYS_URL_PREFIX, "/"), "")) : i += "tiles/".concat(r.path.replace("/".concat(n.TILE_URL_VERSION, "/"), ""));
          var s = r.params;
          return e && (s = s.filter(function (t) {
            return !t.match(/^access_token=/);
          })), s.length && (i += "?".concat(s.join("&"))), i;
        }
      }, {
        key: "canonicalizeTileset",
        value: function canonicalizeTileset(t, e) {
          var r = !!e && s(e),
            n = [];
          var _iterator270 = _createForOfIteratorHelper(t.tiles || []),
            _step270;
          try {
            for (_iterator270.s(); !(_step270 = _iterator270.n()).done;) {
              var _e382 = _step270.value;
              i(_e382) ? n.push(this.canonicalizeTileURL(_e382, r)) : n.push(_e382);
            }
          } catch (err) {
            _iterator270.e(err);
          } finally {
            _iterator270.f();
          }
          return n;
        }
      }, {
        key: "_makeAPIURL",
        value: function _makeAPIURL(t, e) {
          var r = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes",
            i = fn(n.API_URL);
          if (t.protocol = i.protocol, t.authority = i.authority, "http" === t.protocol) {
            var _e383 = t.params.indexOf("secure");
            _e383 >= 0 && t.params.splice(_e383, 1);
          }
          if ("/" !== i.path && (t.path = "".concat(i.path).concat(t.path)), !n.REQUIRE_ACCESS_TOKEN) return dn(t);
          if (e = e || n.ACCESS_TOKEN, !this._silenceAuthErrors) {
            if (!e) throw new Error("An API access token is required to use Mapbox GL. ".concat(r));
            if ("s" === e[0]) throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ".concat(r));
          }
          return t.params = t.params.filter(function (t) {
            return -1 === t.indexOf("access_token");
          }), t.params.push("access_token=".concat(e || "")), dn(t);
        }
      }]);
      return _class16;
    }(), t.dk = function (t, e) {
      e ? kn.add(t) : kn.delete(t);
    }, t.dl = Xr, t.dm = Sn, t.dn = Tn, t.dp = hn, t.dq = _n, t.dr = Mn, t.ds = function (t) {
      kn.delete(t);
    }, t.dt = In, t.du = vn, t.dv = tr, t.dw = e, t.dx = function (t, e) {
      Fr = t, Or = e;
    }, t.dy = function (t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      if ($o === Oo || $o === Uo || $o === jo) throw new Error("setRTLTextPlugin cannot be called multiple times.");
      qo = Rr.resolveURL(t), $o = Oo, No = e, Xo(), r || Ho();
    }, t.dz = Zo, t.e = Rr, t.e0 = zf, t.e1 = gf, t.e2 = Oe, t.e3 = xm, t.e4 = p, t.e5 = nn, t.e6 = function (t) {
      var e = 0;
      if (new Uint32Array(t, 0, 1)[0] !== $v) {
        var _r316 = new Uint32Array(t, 0, 7),
          _r315 = _slicedToArray(_r316, 6),
          _n226 = _r315[2],
          _i229 = _r315[3],
          _s177 = _r315[4],
          _a147 = _r315[5];
        e = _r316.byteLength + _i229 + _s177 + _a147 + _s177, (_n226 !== t.byteLength || e >= t.byteLength) && dr("Invalid b3dm header information.");
      }
      return Hv(t, e);
    }, t.e7 = function (t, e) {
      var r = n_(t);
      var _iterator271 = _createForOfIteratorHelper(r),
        _step271;
      try {
        for (_iterator271.s(); !(_step271 = _iterator271.n()).done;) {
          var _t412 = _step271.value;
          var _iterator272 = _createForOfIteratorHelper(_t412.meshes),
            _step272;
          try {
            for (_iterator272.s(); !(_step272 = _iterator272.n()).done;) {
              var _e384 = _step272.value;
              i_(_e384);
            }
          } catch (err) {
            _iterator272.e(err);
          } finally {
            _iterator272.f();
          }
          _t412.lights && (_t412.lightMeshIndex = _t412.meshes.length, _t412.meshes.push(s_(_t412.lights, e)));
        }
      } catch (err) {
        _iterator271.e(err);
      } finally {
        _iterator271.f();
      }
      return r;
    }, t.e8 = p_, t.e9 = bv, t.ea = Ko, t.eb = function (t) {
      qr(), jr && jr.then(function (e) {
        e.keys().then(function (r) {
          for (var _n227 = 0; _n227 < r.length - t; _n227++) e.delete(r[_n227]);
        });
      });
    }, t.f = Ln, t.g = Cn, t.h = function (t, e) {
      return rn(rr(t, {
        type: "json"
      }), e);
    }, t.i = un, t.j = gp, t.k = Ey, t.l = function (t) {
      return fetch(t).then(function (t) {
        return t.arrayBuffer();
      }).then(function (e) {
        return Hv(e, 0, t);
      });
    }, t.m = Dy, t.n = /*#__PURE__*/function (_rv) {
      _inherits(_class17, _rv);
      var _super96 = _createSuper(_class17);
      function _class17() {
        _classCallCheck(this, _class17);
        return _super96.apply(this, arguments);
      }
      return _createClass(_class17);
    }(rv), t.o = Pi, t.p = lx, t.q = Kn, t.r = Qa, t.s = ro, t.t = eo, t.u = hl, t.v = po, t.w = dr, t.x = pl, t.y = go, t.z = fo;
  });
  define(["./shared"], function (e) {
    function t(e) {
      var t = e ? e.url.toString() : void 0;
      return t ? performance.getEntriesByName(t) : [];
    }
    function s(e) {
      if ("number" == typeof e || "boolean" == typeof e || "string" == typeof e || null == e) return JSON.stringify(e);
      if (Array.isArray(e)) {
        var _t413 = "[";
        var _iterator273 = _createForOfIteratorHelper(e),
          _step273;
        try {
          for (_iterator273.s(); !(_step273 = _iterator273.n()).done;) {
            var _o114 = _step273.value;
            _t413 += "".concat(s(_o114), ",");
          }
        } catch (err) {
          _iterator273.e(err);
        } finally {
          _iterator273.f();
        }
        return "".concat(_t413, "]");
      }
      var t = "{";
      var _iterator274 = _createForOfIteratorHelper(Object.keys(e).sort()),
        _step274;
      try {
        for (_iterator274.s(); !(_step274 = _iterator274.n()).done;) {
          var _o115 = _step274.value;
          t += "".concat(_o115, ":").concat(s(e[_o115]), ",");
        }
      } catch (err) {
        _iterator274.e(err);
      } finally {
        _iterator274.f();
      }
      return "".concat(t, "}");
    }
    function o(t) {
      var o = "";
      var _iterator275 = _createForOfIteratorHelper(e.cG),
        _step275;
      try {
        for (_iterator275.s(); !(_step275 = _iterator275.n()).done;) {
          var _i230 = _step275.value;
          o += "/".concat(s(t[_i230]));
        }
      } catch (err) {
        _iterator275.e(err);
      } finally {
        _iterator275.f();
      }
      return o;
    }
    var i = /*#__PURE__*/function () {
      function i(e) {
        _classCallCheck(this, i);
        this.keyCache = {}, this._layers = {}, this._layerConfigs = {}, e && this.replace(e);
      }
      _createClass(i, [{
        key: "replace",
        value: function replace(e, t) {
          this._layerConfigs = {}, this._layers = {}, this.update(e, [], t);
        }
      }, {
        key: "update",
        value: function update(t, s, _i231) {
          var _this77 = this;
          this._options = _i231;
          var _iterator276 = _createForOfIteratorHelper(t),
            _step276;
          try {
            for (_iterator276.s(); !(_step276 = _iterator276.n()).done;) {
              var _s178 = _step276.value;
              this._layerConfigs[_s178.id] = _s178, (this._layers[_s178.id] = e.c$(_s178, this.scope, null, this._options)).compileFilter(), this.keyCache[_s178.id] && delete this.keyCache[_s178.id];
            }
          } catch (err) {
            _iterator276.e(err);
          } finally {
            _iterator276.f();
          }
          var _iterator277 = _createForOfIteratorHelper(s),
            _step277;
          try {
            for (_iterator277.s(); !(_step277 = _iterator277.n()).done;) {
              var _e386 = _step277.value;
              delete this.keyCache[_e386], delete this._layerConfigs[_e386], delete this._layers[_e386];
            }
          } catch (err) {
            _iterator277.e(err);
          } finally {
            _iterator277.f();
          }
          this.familiesBySource = {};
          var n = function (e, t) {
            var s = {};
            for (var _i233 = 0; _i233 < e.length; _i233++) {
              var _n228 = t && t[e[_i233].id] || o(e[_i233]);
              t && (t[e[_i233].id] = _n228);
              var _r317 = s[_n228];
              _r317 || (_r317 = s[_n228] = []), _r317.push(e[_i233]);
            }
            var i = [];
            for (var _e385 in s) i.push(s[_e385]);
            return i;
          }(e.dJ(this._layerConfigs), this.keyCache);
          var _iterator278 = _createForOfIteratorHelper(n),
            _step278;
          try {
            for (_iterator278.s(); !(_step278 = _iterator278.n()).done;) {
              var _e387 = _step278.value;
              var _t414 = _e387.map(function (e) {
                  return _this77._layers[e.id];
                }),
                _s179 = _t414[0];
              if ("none" === _s179.visibility) continue;
              var _o116 = _s179.source || "";
              var _i232 = this.familiesBySource[_o116];
              _i232 || (_i232 = this.familiesBySource[_o116] = {});
              var _n229 = _s179.sourceLayer || "_geojsonTileLayer";
              var _r318 = _i232[_n229];
              _r318 || (_r318 = _i232[_n229] = []), _r318.push(_t414);
            }
          } catch (err) {
            _iterator278.e(err);
          } finally {
            _iterator278.f();
          }
        }
      }]);
      return i;
    }();
    var n = 1 * e.dM;
    var r = /*#__PURE__*/_createClass(function r(t) {
      _classCallCheck(this, r);
      var s = {},
        o = [];
      for (var _e388 in t) {
        var _i234 = t[_e388],
          _r320 = s[_e388] = {};
        for (var _e389 in _i234.glyphs) {
          var _t415 = _i234.glyphs[+_e389];
          if (!_t415 || 0 === _t415.bitmap.width || 0 === _t415.bitmap.height) continue;
          var _s180 = _t415.metrics.localGlyph ? n : 1,
            _a148 = {
              x: 0,
              y: 0,
              w: _t415.bitmap.width + 2 * _s180,
              h: _t415.bitmap.height + 2 * _s180
            };
          o.push(_a148), _r320[_e389] = _a148;
        }
      }
      var _e$k = e.k(o),
        i = _e$k.w,
        _r319 = _e$k.h,
        a = new e.dL({
          width: i || 1,
          height: _r319 || 1
        });
      for (var _o117 in t) {
        var _i235 = t[_o117];
        for (var _t416 in _i235.glyphs) {
          var _r321 = _i235.glyphs[+_t416];
          if (!_r321 || 0 === _r321.bitmap.width || 0 === _r321.bitmap.height) continue;
          var _l91 = s[_o117][_t416],
            _c63 = _r321.metrics.localGlyph ? n : 1;
          e.dL.copy(_r321.bitmap, a, {
            x: 0,
            y: 0
          }, {
            x: _l91.x + _c63,
            y: _l91.y + _c63
          }, _r321.bitmap);
        }
      }
      this.image = a, this.positions = s;
    });
    e.dK(r, "GlyphAtlas");
    var a = /*#__PURE__*/function () {
      function a(t) {
        _classCallCheck(this, a);
        this.tileID = new e.aQ(t.tileID.overscaledZ, t.tileID.wrap, t.tileID.canonical.z, t.tileID.canonical.x, t.tileID.canonical.y), this.tileZoom = t.tileZoom, this.uid = t.uid, this.zoom = t.zoom, this.lut = t.lut, this.canonical = t.tileID.canonical, this.pixelRatio = t.pixelRatio, this.tileSize = t.tileSize, this.source = t.source, this.scope = t.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t.showCollisionBoxes, this.collectResourceTiming = !!t.collectResourceTiming, this.promoteId = t.promoteId, this.isSymbolTile = t.isSymbolTile, this.tileTransform = e.dN(t.tileID.canonical, t.projection), this.projection = t.projection, this.brightness = t.brightness, this.extraShadowCaster = !!t.extraShadowCaster, this.tessellationStep = t.tessellationStep;
      }
      _createClass(a, [{
        key: "parse",
        value: function parse(t, s, o, i, n) {
          var _this78 = this;
          this.status = "parsing", this.data = t, this.collisionBoxArray = new e.dO();
          var _a149 = new e.dP(Object.keys(t.layers).sort()),
            c = new e.dQ(this.tileID, this.promoteId);
          c.bucketLayerIDs = [];
          var h = {},
            u = new e.dR(256, 256),
            d = {
              featureIndex: c,
              iconDependencies: {},
              patternDependencies: {},
              glyphDependencies: {},
              lineAtlas: u,
              availableImages: o,
              brightness: this.brightness
            },
            f = s.familiesBySource[this.source];
          for (var _s181 in f) {
            var _i236 = t.layers[_s181];
            if (!_i236) continue;
            var _n230 = !1,
              _r322 = !1,
              _u78 = !1;
            var _iterator279 = _createForOfIteratorHelper(f[_s181]),
              _step279;
            try {
              for (_iterator279.s(); !(_step279 = _iterator279.n()).done;) {
                var _e391 = _step279.value;
                "symbol" === _e391[0].type ? _n230 = !0 : _r322 = !0, _e391[0].is3D() && "model" !== _e391[0].type && (_u78 = !0);
              }
            } catch (err) {
              _iterator279.e(err);
            } finally {
              _iterator279.f();
            }
            if (this.extraShadowCaster && !_u78) continue;
            if (!0 === this.isSymbolTile && !_n230) continue;
            if (!1 === this.isSymbolTile && !_r322) continue;
            1 === _i236.version && e.w("Vector tile source \"".concat(this.source, "\" layer \"").concat(_s181, "\" does not use vector tile spec v2 and therefore may have some rendering errors."));
            var _p45 = _a149.encode(_s181),
              _g15 = [];
            for (var _e390 = 0; _e390 < _i236.length; _e390++) {
              var _t417 = _i236.feature(_e390),
                _o118 = c.getId(_t417, _s181);
              _g15.push({
                feature: _t417,
                id: _o118,
                index: _e390,
                sourceLayerIndex: _p45
              });
            }
            var _iterator280 = _createForOfIteratorHelper(f[_s181]),
              _step280;
            try {
              for (_iterator280.s(); !(_step280 = _iterator280.n()).done;) {
                var _e392 = _step280.value;
                var _t418 = _e392[0];
                (!this.extraShadowCaster || _t418.is3D() && "model" !== _t418.type) && (void 0 !== this.isSymbolTile && "symbol" === _t418.type !== this.isSymbolTile || _t418.minzoom && this.zoom < Math.floor(_t418.minzoom) || _t418.maxzoom && this.zoom >= _t418.maxzoom || "none" !== _t418.visibility && (l(_e392, this.zoom, d.brightness, o), (h[_t418.id] = _t418.createBucket({
                  index: c.bucketLayerIDs.length,
                  layers: _e392,
                  zoom: this.zoom,
                  lut: this.lut,
                  canonical: this.canonical,
                  pixelRatio: this.pixelRatio,
                  overscaling: this.overscaling,
                  collisionBoxArray: this.collisionBoxArray,
                  sourceLayerIndex: _p45,
                  sourceID: this.source,
                  projection: this.projection.spec,
                  tessellationStep: this.tessellationStep
                })).populate(_g15, d, this.tileID.canonical, this.tileTransform), c.bucketLayerIDs.push(_e392.map(function (e) {
                  return e.id;
                }))));
              }
            } catch (err) {
              _iterator280.e(err);
            } finally {
              _iterator280.f();
            }
          }
          var p, g, m, y;
          u.trim();
          var x = {
              type: "maybePrepare",
              isSymbolTile: this.isSymbolTile,
              zoom: this.zoom
            },
            w = function w() {
              if (p) return _this78.status = "done", n(p);
              if (_this78.extraShadowCaster) _this78.status = "done", n(null, {
                buckets: e.dJ(h).filter(function (e) {
                  return !e.isEmpty();
                }),
                featureIndex: c,
                collisionBoxArray: null,
                glyphAtlasImage: null,
                lineAtlas: null,
                imageAtlas: null,
                brightness: d.brightness,
                glyphMap: null,
                iconMap: null,
                glyphPositions: null
              });else if (g && m && y) {
                var _t419 = new r(g),
                  _s182 = new e.dT(m, y, _this78.lut);
                for (var _i237 in h) {
                  var _n231 = h[_i237];
                  _n231 instanceof e.dU ? (l(_n231.layers, _this78.zoom, d.brightness, o), e.dV(_n231, g, _t419.positions, m, _s182.iconPositions, _this78.showCollisionBoxes, o, _this78.tileID.canonical, _this78.tileZoom, _this78.projection, _this78.brightness)) : _n231.hasPattern && (_n231 instanceof e.dW || _n231 instanceof e.dX || _n231 instanceof e.c0) && (l(_n231.layers, _this78.zoom, d.brightness, o), _n231.addFeatures(d, _this78.tileID.canonical, _s182.patternPositions, o, _this78.tileTransform, _this78.brightness));
                }
                _this78.status = "done", n(null, {
                  buckets: e.dJ(h).filter(function (e) {
                    return !e.isEmpty();
                  }),
                  featureIndex: c,
                  collisionBoxArray: _this78.collisionBoxArray,
                  glyphAtlasImage: _t419.image,
                  lineAtlas: u,
                  imageAtlas: _s182,
                  brightness: d.brightness
                });
              }
            };
          if (!this.extraShadowCaster) {
            var _t420 = e.dS(d.glyphDependencies, function (e) {
              return Object.keys(e).map(Number);
            });
            Object.keys(_t420).length ? i.send("getGlyphs", {
              uid: this.uid,
              stacks: _t420,
              scope: this.scope
            }, function (e, t) {
              p || (p = e, g = t, w());
            }, void 0, !1, x) : g = {};
            var _s183 = Object.keys(d.iconDependencies);
            _s183.length ? i.send("getImages", {
              icons: _s183,
              source: this.source,
              scope: this.scope,
              tileID: this.tileID,
              type: "icons"
            }, function (e, t) {
              p || (p = e, m = t, w());
            }, void 0, !1, x) : m = {};
            var _o119 = Object.keys(d.patternDependencies);
            _o119.length ? i.send("getImages", {
              icons: _o119,
              source: this.source,
              scope: this.scope,
              tileID: this.tileID,
              type: "patterns"
            }, function (e, t) {
              p || (p = e, y = t, w());
            }, void 0, !1, x) : y = {};
          }
          w();
        }
      }]);
      return a;
    }();
    function l(t, s, o, i) {
      var n = new e.Y(s, {
        brightness: o
      });
      var _iterator281 = _createForOfIteratorHelper(t),
        _step281;
      try {
        for (_iterator281.s(); !(_step281 = _iterator281.n()).done;) {
          var _e393 = _step281.value;
          _e393.recalculate(n, i);
        }
      } catch (err) {
        _iterator281.e(err);
      } finally {
        _iterator281.f();
      }
    }
    var c = /*#__PURE__*/function (_e$E) {
      _inherits(c, _e$E);
      var _super97 = _createSuper(c);
      function c(t, s, o, i, n, r) {
        var _this79;
        _classCallCheck(this, c);
        _this79 = _super97.call(this), _this79.actor = t, _this79.layerIndex = s, _this79.availableImages = o, _this79.loadVectorData = n || e.aq, _this79.loading = {}, _this79.loaded = {}, _this79.deduped = new e.ap(t.scheduler), _this79.isSpriteLoaded = i, _this79.scheduler = t.scheduler, _this79.brightness = r;
        return _this79;
      }
      _createClass(c, [{
        key: "loadTile",
        value: function loadTile(s, o) {
          var _this80 = this;
          var i = s.uid,
            n = s && s.request,
            r = n && n.collectResourceTiming,
            l = this.loading[i] = new a(s);
          l.abort = this.loadVectorData(s, function (a, _c64) {
            var h = !_this80.loading[i];
            if (delete _this80.loading[i], h || a || !_c64) return l.status = "done", h || (_this80.loaded[i] = l), o(a);
            var u = _c64.rawData,
              d = {};
            _c64.expires && (d.expires = _c64.expires), _c64.cacheControl && (d.cacheControl = _c64.cacheControl), l.vectorTile = _c64.vectorTile || new e.dY(new e.dZ(u));
            var f = function f() {
              l.parse(l.vectorTile, _this80.layerIndex, _this80.availableImages, _this80.actor, function (s, i) {
                if (s || !i) return o(s);
                var a = {};
                if (r) {
                  var _e394 = t(n);
                  _e394.length > 0 && (a.resourceTiming = JSON.parse(JSON.stringify(_e394)));
                }
                o(null, e.Q({
                  rawTileData: u.slice(0)
                }, i, d, a));
              });
            };
            _this80.isSpriteLoaded ? f() : _this80.once("isSpriteLoaded", function () {
              _this80.scheduler ? _this80.scheduler.add(f, {
                type: "parseTile",
                isSymbolTile: s.isSymbolTile,
                zoom: s.tileZoom
              }) : f();
            }), _this80.loaded = _this80.loaded || {}, _this80.loaded[i] = l;
          });
        }
      }, {
        key: "reloadTile",
        value: function reloadTile(t, s) {
          var _this81 = this;
          var o = this.loaded,
            i = t.uid;
          if (o && o[i]) {
            var _n232 = o[i];
            _n232.showCollisionBoxes = t.showCollisionBoxes, _n232.projection = t.projection, _n232.brightness = t.brightness, _n232.tileTransform = e.dN(t.tileID.canonical, t.projection), _n232.extraShadowCaster = t.extraShadowCaster, _n232.lut = t.lut;
            var _r323 = function _r323(e, t) {
              var o = _n232.reloadCallback;
              o && (delete _n232.reloadCallback, _n232.parse(_n232.vectorTile, _this81.layerIndex, _this81.availableImages, _this81.actor, o)), s(e, t);
            };
            "parsing" === _n232.status ? _n232.reloadCallback = _r323 : "done" === _n232.status && (_n232.vectorTile ? _n232.parse(_n232.vectorTile, this.layerIndex, this.availableImages, this.actor, _r323) : _r323());
          } else s(null, void 0);
        }
      }, {
        key: "abortTile",
        value: function abortTile(e, t) {
          var s = e.uid,
            o = this.loading[s];
          o && (o.abort && o.abort(), delete this.loading[s]), t();
        }
      }, {
        key: "removeTile",
        value: function removeTile(e, t) {
          var s = this.loaded,
            o = e.uid;
          s && s[o] && delete s[o], t();
        }
      }]);
      return c;
    }(e.E);
    var h = /*#__PURE__*/function () {
      function h() {
        _classCallCheck(this, h);
      }
      _createClass(h, [{
        key: "loadTile",
        value: function loadTile(t, s) {
          var o = t.uid,
            i = t.encoding,
            n = t.rawImageData,
            r = t.padding,
            a = ImageBitmap && n instanceof ImageBitmap ? this.getImageData(n, r) : n;
          s(null, new e.d_(o, a, i, r < 1));
        }
      }, {
        key: "getImageData",
        value: function getImageData(e, t) {
          this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e.width, e.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", {
            willReadFrequently: !0
          })), this.offscreenCanvas.width = e.width, this.offscreenCanvas.height = e.height, this.offscreenCanvasContext.drawImage(e, 0, 0, e.width, e.height);
          var s = this.offscreenCanvasContext.getImageData(-t, -t, e.width + 2 * t, e.height + 2 * t);
          return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), s;
        }
      }]);
      return h;
    }();
    e.d$.setPbf(e.dZ);
    var u = /*#__PURE__*/function () {
      function u() {
        _classCallCheck(this, u);
      }
      _createClass(u, [{
        key: "decodeRasterArray",
        value: function decodeRasterArray(_ref153, o) {
          var t = _ref153.task,
            s = _ref153.buffer;
          e.d$.performDecoding(s, t).then(function (e) {
            o(null, e);
          }, function (e) {
            o(e);
          });
        }
      }]);
      return u;
    }();
    var d = e.e0.prototype.toGeoJSON;
    var f = /*#__PURE__*/function () {
        function f(t) {
          _classCallCheck(this, f);
          this._feature = t, this.extent = e.a4, this.type = t.type, this.properties = t.tags, "id" in t && !isNaN(t.id) && (this.id = parseInt(t.id, 10));
        }
        _createClass(f, [{
          key: "loadGeometry",
          value: function loadGeometry() {
            if (1 === this._feature.type) {
              var _t421 = [];
              var _iterator282 = _createForOfIteratorHelper(this._feature.geometry),
                _step282;
              try {
                for (_iterator282.s(); !(_step282 = _iterator282.n()).done;) {
                  var _s184 = _step282.value;
                  _t421.push([new e.P(_s184[0], _s184[1])]);
                }
              } catch (err) {
                _iterator282.e(err);
              } finally {
                _iterator282.f();
              }
              return _t421;
            }
            {
              var _t422 = [];
              var _iterator283 = _createForOfIteratorHelper(this._feature.geometry),
                _step283;
              try {
                for (_iterator283.s(); !(_step283 = _iterator283.n()).done;) {
                  var _s185 = _step283.value;
                  var _o120 = [];
                  var _iterator284 = _createForOfIteratorHelper(_s185),
                    _step284;
                  try {
                    for (_iterator284.s(); !(_step284 = _iterator284.n()).done;) {
                      var _t423 = _step284.value;
                      _o120.push(new e.P(_t423[0], _t423[1]));
                    }
                  } catch (err) {
                    _iterator284.e(err);
                  } finally {
                    _iterator284.f();
                  }
                  _t422.push(_o120);
                }
              } catch (err) {
                _iterator283.e(err);
              } finally {
                _iterator283.f();
              }
              return _t422;
            }
          }
        }, {
          key: "toGeoJSON",
          value: function toGeoJSON(e, t, s) {
            return d.call(this, e, t, s);
          }
        }]);
        return f;
      }(),
      p = /*#__PURE__*/function () {
        function p(t) {
          _classCallCheck(this, p);
          this.layers = {
            _geojsonTileLayer: this
          }, this.name = "_geojsonTileLayer", this.extent = e.a4, this.length = t.length, this._features = t;
        }
        _createClass(p, [{
          key: "feature",
          value: function feature(e) {
            return new f(this._features[e]);
          }
        }]);
        return p;
      }();
    var g = 64 / 4096,
      m = 128;
    var y = /*#__PURE__*/function () {
      function y() {
        _classCallCheck(this, y);
        this.features = new Map();
      }
      _createClass(y, [{
        key: "clear",
        value: function clear() {
          this.features.clear();
        }
      }, {
        key: "load",
        value: function load() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var t = arguments.length > 1 ? arguments[1] : undefined;
          var _iterator285 = _createForOfIteratorHelper(e),
            _step285;
          try {
            for (_iterator285.s(); !(_step285 = _iterator285.n()).done;) {
              var _s186 = _step285.value;
              var _e395 = _s186.id;
              if (null == _e395) continue;
              var _o121 = this.features.get(_e395);
              _o121 && this.updateCache(_o121, t), _s186.geometry ? (_o121 = w(_s186), this.updateCache(_o121, t), this.features.set(_e395, _o121)) : this.features.delete(_e395), this.updateCache(_o121, t);
            }
          } catch (err) {
            _iterator285.e(err);
          } finally {
            _iterator285.f();
          }
        }
      }, {
        key: "updateCache",
        value: function updateCache(e, t) {
          for (var _i238 = 0, _Object$values2 = Object.values(t); _i238 < _Object$values2.length; _i238++) {
            var _Object$values2$_i = _Object$values2[_i238],
              _s187 = _Object$values2$_i.canonical,
              _o122 = _Object$values2$_i.uid;
            var _i239 = _s187.z,
              _n233 = _s187.x,
              _r324 = _s187.y;
            x(e, Math.pow(2, _i239), _n233, _r324) && delete t[_o122];
          }
        }
      }, {
        key: "getTile",
        value: function getTile(e, t, s) {
          var o = Math.pow(2, e),
            i = [];
          var _iterator286 = _createForOfIteratorHelper(this.features.values()),
            _step286;
          try {
            for (_iterator286.s(); !(_step286 = _iterator286.n()).done;) {
              var _e396 = _step286.value;
              x(_e396, o, t, s) && i.push(I(_e396, o, t, s));
            }
          } catch (err) {
            _iterator286.e(err);
          } finally {
            _iterator286.f();
          }
          return {
            features: i
          };
        }
      }, {
        key: "getFeatures",
        value: function getFeatures() {
          return _toConsumableArray(this.features.values());
        }
      }]);
      return y;
    }();
    function x(_ref154, i, n, r) {
      var e = _ref154.minX,
        t = _ref154.minY,
        s = _ref154.maxX,
        o = _ref154.maxY;
      return e < (n + 1 + g) / i && t < (r + 1 + g) / i && s > (n - g) / i && o > (r - g) / i;
    }
    function w(e) {
      var t = e.id,
        s = e.geometry,
        o = e.properties;
      if (!s) return;
      if ("GeometryCollection" === s.type) throw new Error("GeometryCollection not supported in dynamic mode.");
      var i = s.type,
        n = s.coordinates,
        r = {
          id: t,
          type: 1,
          geometry: [],
          tags: o,
          minX: 1 / 0,
          minY: 1 / 0,
          maxX: -1 / 0,
          maxY: -1 / 0
        },
        a = r.geometry;
      if ("Point" === i) S(n, a, r);else if ("MultiPoint" === i) {
        var _iterator287 = _createForOfIteratorHelper(n),
          _step287;
        try {
          for (_iterator287.s(); !(_step287 = _iterator287.n()).done;) {
            var _e397 = _step287.value;
            S(_e397, a, r);
          }
        } catch (err) {
          _iterator287.e(err);
        } finally {
          _iterator287.f();
        }
      } else if ("LineString" === i) r.type = 2, b(n, a, r);else if ("MultiLineString" === i) r.type = 2, v(n, a, r);else if ("Polygon" === i) r.type = 3, v(n, a, r, !0);else {
        if ("MultiPolygon" !== i) throw new Error("Input data is not a valid GeoJSON object.");
        r.type = 3;
        var _iterator288 = _createForOfIteratorHelper(n),
          _step288;
        try {
          for (_iterator288.s(); !(_step288 = _iterator288.n()).done;) {
            var _e398 = _step288.value;
            v(_e398, a, r, !0);
          }
        } catch (err) {
          _iterator288.e(err);
        } finally {
          _iterator288.f();
        }
      }
      return r;
    }
    function S(_ref155, o, i) {
      var _ref156 = _slicedToArray(_ref155, 2),
        t = _ref156[0],
        s = _ref156[1];
      var n = e.ak(t);
      var r = e.al(s);
      r = r < 0 ? 0 : r > 1 ? 1 : r, o.push(n, r), i.minX = Math.min(i.minX, n), i.minY = Math.min(i.minY, r), i.maxX = Math.max(i.maxX, n), i.maxY = Math.max(i.maxY, r);
    }
    function b(e, t, s) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
      var n = [];
      var _iterator289 = _createForOfIteratorHelper(e),
        _step289;
      try {
        for (_iterator289.s(); !(_step289 = _iterator289.n()).done;) {
          var _t426 = _step289.value;
          S(_t426, n, s);
        }
      } catch (err) {
        _iterator289.e(err);
      } finally {
        _iterator289.f();
      }
      t.push(n), o && function (e, t) {
        var s = 0;
        for (var _t424 = 0, _o123 = e.length, _i240 = _o123 - 2; _t424 < _o123; _i240 = _t424, _t424 += 2) s += (e[_t424] - e[_i240]) * (e[_t424 + 1] + e[_i240 + 1]);
        if (s > 0 === t) for (var _t425 = 0, _s188 = e.length; _t425 < _s188 / 2; _t425 += 2) {
          var _o124 = e[_t425],
            _i241 = e[_t425 + 1];
          e[_t425] = e[_s188 - 2 - _t425], e[_t425 + 1] = e[_s188 - 1 - _t425], e[_s188 - 2 - _t425] = _o124, e[_s188 - 1 - _t425] = _i241;
        }
      }(n, i);
    }
    function v(e, t, s) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      for (var _i242 = 0; _i242 < e.length; _i242++) b(e[_i242], t, s, o, 0 === _i242);
    }
    function I(t, s, o, i) {
      var n = t.id,
        r = t.type,
        a = t.geometry,
        l = t.tags,
        c = [];
      if (1 === r) !function (t, s, o, i, n) {
        for (var _r325 = 0; _r325 < t.length; _r325 += 2) {
          var _a150 = Math.round(e.a4 * (t[_r325 + 0] * s - o)),
            _l92 = Math.round(e.a4 * (t[_r325 + 1] * s - i));
          n.push([_a150, _l92]);
        }
      }(a, s, o, i, c);else {
        var _iterator290 = _createForOfIteratorHelper(a),
          _step290;
        try {
          for (_iterator290.s(); !(_step290 = _iterator290.n()).done;) {
            var _e399 = _step290.value;
            M(_e399, s, o, i, c);
          }
        } catch (err) {
          _iterator290.e(err);
        } finally {
          _iterator290.f();
        }
      }
      return {
        id: n,
        type: r,
        geometry: c,
        tags: l
      };
    }
    function M(t, s, o, i, n) {
      var r = -m,
        a = e.a4 + m;
      var l;
      for (var _c65 = 0; _c65 < t.length - 2; _c65 += 2) {
        var _h52 = Math.round(e.a4 * (t[_c65 + 0] * s - o)),
          _u79 = Math.round(e.a4 * (t[_c65 + 1] * s - i)),
          _d28 = Math.round(e.a4 * (t[_c65 + 2] * s - o)),
          _f40 = Math.round(e.a4 * (t[_c65 + 3] * s - i));
        var _p46 = _d28 - _h52,
          _g16 = _f40 - _u79;
        _h52 < r && _d28 < r || (_h52 < r ? (_u79 += Math.round(_g16 * ((r - _h52) / _p46)), _h52 = r) : _d28 < r && (_f40 = _u79 + Math.round(_g16 * ((r - _h52) / _p46)), _d28 = r), _u79 < r && _f40 < r || (_u79 < r ? (_h52 += Math.round(_p46 * ((r - _u79) / _g16)), _u79 = r) : _f40 < r && (_d28 = _h52 + Math.round(_p46 * ((r - _u79) / _g16)), _f40 = r), _h52 >= a && _d28 >= a || (_h52 >= a ? (_u79 += Math.round(_g16 * ((a - _h52) / _p46)), _h52 = a) : _d28 >= a && (_f40 = _u79 + Math.round(_g16 * ((a - _h52) / _p46)), _d28 = a), _u79 >= a && _f40 >= a || (_u79 >= a ? (_h52 += Math.round(_p46 * ((a - _u79) / _g16)), _u79 = a) : _f40 >= a && (_d28 = _h52 + Math.round(_p46 * ((a - _u79) / _g16)), _f40 = a), l && _h52 === l[l.length - 1][0] && _u79 === l[l.length - 1][1] || (l = [[_h52, _u79]], n.push(l)), l.push([_d28, _f40])))));
      }
    }
    var k = {
        exports: {}
      },
      T = e.e2,
      P = e.e1.VectorTileFeature,
      C = _;
    function _(e, t) {
      this.options = t || {}, this.features = e, this.length = e.length;
    }
    function L(e, t) {
      this.id = "number" == typeof e.id ? e.id : void 0, this.type = e.type, this.rawGeometry = 1 === e.type ? [e.geometry] : e.geometry, this.properties = e.tags, this.extent = t || 4096;
    }
    _.prototype.feature = function (e) {
      return new L(this.features[e], this.options.extent);
    }, L.prototype.loadGeometry = function () {
      var e = this.rawGeometry;
      this.geometry = [];
      for (var t = 0; t < e.length; t++) {
        for (var s = e[t], o = [], i = 0; i < s.length; i++) o.push(new T(s[i][0], s[i][1]));
        this.geometry.push(o);
      }
      return this.geometry;
    }, L.prototype.bbox = function () {
      this.geometry || this.loadGeometry();
      for (var e = this.geometry, t = 1 / 0, s = -1 / 0, o = 1 / 0, i = -1 / 0, n = 0; n < e.length; n++) for (var r = e[n], a = 0; a < r.length; a++) {
        var l = r[a];
        t = Math.min(t, l.x), s = Math.max(s, l.x), o = Math.min(o, l.y), i = Math.max(i, l.y);
      }
      return [t, o, s, i];
    }, L.prototype.toGeoJSON = P.prototype.toGeoJSON;
    var D = e.e3,
      j = C;
    function O(e) {
      var t = new D();
      return function (e, t) {
        for (var s in e.layers) t.writeMessage(3, z, e.layers[s]);
      }(e, t), t.finish();
    }
    function z(e, t) {
      var s;
      t.writeVarintField(15, e.version || 1), t.writeStringField(1, e.name || ""), t.writeVarintField(5, e.extent || 4096);
      var o = {
        keys: [],
        values: [],
        keycache: {},
        valuecache: {}
      };
      for (s = 0; s < e.length; s++) o.feature = e.feature(s), t.writeMessage(2, Z, o);
      var i = o.keys;
      for (s = 0; s < i.length; s++) t.writeStringField(3, i[s]);
      var n = o.values;
      for (s = 0; s < n.length; s++) t.writeMessage(4, F, n[s]);
    }
    function Z(e, t) {
      var s = e.feature;
      void 0 !== s.id && t.writeVarintField(1, s.id), t.writeMessage(2, A, e), t.writeVarintField(3, s.type), t.writeMessage(4, Y, s);
    }
    function A(e, t) {
      var s = e.feature,
        o = e.keys,
        i = e.values,
        n = e.keycache,
        r = e.valuecache;
      for (var a in s.properties) {
        var l = s.properties[a],
          c = n[a];
        if (null !== l) {
          void 0 === c && (o.push(a), n[a] = c = o.length - 1), t.writeVarint(c);
          var h = typeof l;
          "string" !== h && "boolean" !== h && "number" !== h && (l = JSON.stringify(l));
          var u = h + ":" + l,
            d = r[u];
          void 0 === d && (i.push(l), r[u] = d = i.length - 1), t.writeVarint(d);
        }
      }
    }
    function E(e, t) {
      return (t << 3) + (7 & e);
    }
    function N(e) {
      return e << 1 ^ e >> 31;
    }
    function Y(e, t) {
      for (var s = e.loadGeometry(), o = e.type, i = 0, n = 0, r = s.length, a = 0; a < r; a++) {
        var l = s[a],
          c = 1;
        1 === o && (c = l.length), t.writeVarint(E(1, c));
        for (var h = 3 === o ? l.length - 1 : l.length, u = 0; u < h; u++) {
          1 === u && 1 !== o && t.writeVarint(E(2, h - 1));
          var d = l[u].x - i,
            f = l[u].y - n;
          t.writeVarint(N(d)), t.writeVarint(N(f)), i += d, n += f;
        }
        3 === o && t.writeVarint(E(7, 1));
      }
    }
    function F(e, t) {
      var s = typeof e;
      "string" === s ? t.writeStringField(1, e) : "boolean" === s ? t.writeBooleanField(7, e) : "number" === s && (e % 1 != 0 ? t.writeDoubleField(3, e) : e < 0 ? t.writeSVarintField(6, e) : t.writeVarintField(5, e));
    }
    k.exports = O, k.exports.fromVectorTileJs = O, k.exports.fromGeojsonVt = function (e, t) {
      t = t || {};
      var s = {};
      for (var o in e) s[o] = new j(e[o].features, t), s[o].name = o, s[o].version = t.version, s[o].extent = t.extent;
      return O({
        layers: s
      });
    }, k.exports.GeoJSONWrapper = j;
    var X = e.e4(k.exports);
    var J = {
        minZoom: 0,
        maxZoom: 16,
        minPoints: 2,
        radius: 40,
        extent: 512,
        nodeSize: 64,
        log: !1,
        generateId: !1,
        reduce: null,
        map: function map(e) {
          return e;
        }
      },
      G = Math.fround || (W = new Float32Array(1), function (e) {
        return W[0] = +e, W[0];
      });
    var W;
    var B = 3,
      R = 5,
      V = 6;
    var $ = /*#__PURE__*/function () {
      function $(e) {
        _classCallCheck(this, $);
        this.options = Object.assign(Object.create(J), e), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
      }
      _createClass($, [{
        key: "load",
        value: function load(e) {
          var _this$options = this.options,
            t = _this$options.log,
            s = _this$options.minZoom,
            o = _this$options.maxZoom;
          t && console.time("total time");
          var i = "prepare ".concat(e.length, " points");
          t && console.time(i), this.points = e;
          var n = [];
          for (var _t427 = 0; _t427 < e.length; _t427++) {
            var _s189 = e[_t427];
            if (!_s189.geometry) continue;
            var _s189$geometry$coordi = _slicedToArray(_s189.geometry.coordinates, 2),
              _o125 = _s189$geometry$coordi[0],
              _i243 = _s189$geometry$coordi[1],
              _r326 = G(Q(_o125)),
              _a151 = G(K(_i243));
            n.push(_r326, _a151, 1 / 0, _t427, -1, 1), this.options.reduce && n.push(0);
          }
          var r = this.trees[o + 1] = this._createTree(n);
          t && console.timeEnd(i);
          for (var _e400 = o; _e400 >= s; _e400--) {
            var _s190 = +Date.now();
            r = this.trees[_e400] = this._createTree(this._cluster(r, _e400)), t && console.log("z%d: %d clusters in %dms", _e400, r.numItems, +Date.now() - _s190);
          }
          return t && console.timeEnd("total time"), this;
        }
      }, {
        key: "getClusters",
        value: function getClusters(e, t) {
          var s = ((e[0] + 180) % 360 + 360) % 360 - 180;
          var o = Math.max(-90, Math.min(90, e[1]));
          var i = 180 === e[2] ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180;
          var n = Math.max(-90, Math.min(90, e[3]));
          if (e[2] - e[0] >= 360) s = -180, i = 180;else if (s > i) {
            var _e401 = this.getClusters([s, o, 180, n], t),
              _r327 = this.getClusters([-180, o, i, n], t);
            return _e401.concat(_r327);
          }
          var r = this.trees[this._limitZoom(t)],
            a = r.range(Q(s), K(n), Q(i), K(o)),
            l = r.data,
            c = [];
          var _iterator291 = _createForOfIteratorHelper(a),
            _step291;
          try {
            for (_iterator291.s(); !(_step291 = _iterator291.n()).done;) {
              var _e402 = _step291.value;
              var _t428 = this.stride * _e402;
              c.push(l[_t428 + R] > 1 ? q(l, _t428, this.clusterProps) : this.points[l[_t428 + B]]);
            }
          } catch (err) {
            _iterator291.e(err);
          } finally {
            _iterator291.f();
          }
          return c;
        }
      }, {
        key: "getChildren",
        value: function getChildren(e) {
          var t = this._getOriginId(e),
            s = this._getOriginZoom(e),
            o = "No cluster with the specified id.",
            i = this.trees[s];
          if (!i) throw new Error(o);
          var n = i.data;
          if (t * this.stride >= n.length) throw new Error(o);
          var r = this.options.radius / (this.options.extent * Math.pow(2, s - 1)),
            a = i.within(n[t * this.stride], n[t * this.stride + 1], r),
            l = [];
          var _iterator292 = _createForOfIteratorHelper(a),
            _step292;
          try {
            for (_iterator292.s(); !(_step292 = _iterator292.n()).done;) {
              var _t429 = _step292.value;
              var _s191 = _t429 * this.stride;
              n[_s191 + 4] === e && l.push(n[_s191 + R] > 1 ? q(n, _s191, this.clusterProps) : this.points[n[_s191 + B]]);
            }
          } catch (err) {
            _iterator292.e(err);
          } finally {
            _iterator292.f();
          }
          if (0 === l.length) throw new Error(o);
          return l;
        }
      }, {
        key: "getLeaves",
        value: function getLeaves(e, t, s) {
          var o = [];
          return this._appendLeaves(o, e, t = t || 10, s = s || 0, 0), o;
        }
      }, {
        key: "getTile",
        value: function getTile(e, t, s) {
          var o = this.trees[this._limitZoom(e)],
            i = Math.pow(2, e),
            _this$options2 = this.options,
            n = _this$options2.extent,
            r = _this$options2.radius,
            a = r / n,
            l = (s - a) / i,
            c = (s + 1 + a) / i,
            h = {
              features: []
            };
          return this._addTileFeatures(o.range((t - a) / i, l, (t + 1 + a) / i, c), o.data, t, s, i, h), 0 === t && this._addTileFeatures(o.range(1 - a / i, l, 1, c), o.data, i, s, i, h), t === i - 1 && this._addTileFeatures(o.range(0, l, a / i, c), o.data, -1, s, i, h), h.features.length ? h : null;
        }
      }, {
        key: "getClusterExpansionZoom",
        value: function getClusterExpansionZoom(e) {
          var t = this._getOriginZoom(e) - 1;
          for (; t <= this.options.maxZoom;) {
            var _s192 = this.getChildren(e);
            if (t++, 1 !== _s192.length) break;
            e = _s192[0].properties.cluster_id;
          }
          return t;
        }
      }, {
        key: "_appendLeaves",
        value: function _appendLeaves(e, t, s, o, i) {
          var n = this.getChildren(t);
          var _iterator293 = _createForOfIteratorHelper(n),
            _step293;
          try {
            for (_iterator293.s(); !(_step293 = _iterator293.n()).done;) {
              var _t430 = _step293.value;
              var _n234 = _t430.properties;
              if (_n234 && _n234.cluster ? i + _n234.point_count <= o ? i += _n234.point_count : i = this._appendLeaves(e, _n234.cluster_id, s, o, i) : i < o ? i++ : e.push(_t430), e.length === s) break;
            }
          } catch (err) {
            _iterator293.e(err);
          } finally {
            _iterator293.f();
          }
          return i;
        }
      }, {
        key: "_createTree",
        value: function _createTree(t) {
          var s = new e.cN(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
          for (var _e403 = 0; _e403 < t.length; _e403 += this.stride) s.add(t[_e403], t[_e403 + 1]);
          return s.finish(), s.data = t, s;
        }
      }, {
        key: "_addTileFeatures",
        value: function _addTileFeatures(e, t, s, o, i, n) {
          var _iterator294 = _createForOfIteratorHelper(e),
            _step294;
          try {
            for (_iterator294.s(); !(_step294 = _iterator294.n()).done;) {
              var _r328 = _step294.value;
              var _e404 = _r328 * this.stride,
                _a152 = t[_e404 + R] > 1;
              var _l93 = void 0,
                _c66 = void 0,
                _h53 = void 0;
              if (_a152) _l93 = U(t, _e404, this.clusterProps), _c66 = t[_e404], _h53 = t[_e404 + 1];else {
                var _s193 = this.points[t[_e404 + B]];
                _l93 = _s193.properties;
                var _s193$geometry$coordi = _slicedToArray(_s193.geometry.coordinates, 2),
                  _o126 = _s193$geometry$coordi[0],
                  _i244 = _s193$geometry$coordi[1];
                _c66 = Q(_o126), _h53 = K(_i244);
              }
              var _u80 = {
                type: 1,
                geometry: [[Math.round(this.options.extent * (_c66 * i - s)), Math.round(this.options.extent * (_h53 * i - o))]],
                tags: _l93
              };
              var _d29 = void 0;
              _d29 = _a152 || this.options.generateId ? t[_e404 + B] : this.points[t[_e404 + B]].id, void 0 !== _d29 && (_u80.id = _d29), n.features.push(_u80);
            }
          } catch (err) {
            _iterator294.e(err);
          } finally {
            _iterator294.f();
          }
        }
      }, {
        key: "_limitZoom",
        value: function _limitZoom(e) {
          return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
        }
      }, {
        key: "_cluster",
        value: function _cluster(e, t) {
          var _this$options3 = this.options,
            s = _this$options3.radius,
            o = _this$options3.extent,
            i = _this$options3.reduce,
            n = _this$options3.minPoints,
            r = s / (o * Math.pow(2, t)),
            a = e.data,
            l = [],
            c = this.stride;
          for (var _s194 = 0; _s194 < a.length; _s194 += c) {
            if (a[_s194 + 2] <= t) continue;
            a[_s194 + 2] = t;
            var _o127 = a[_s194],
              _h54 = a[_s194 + 1],
              _u81 = e.within(a[_s194], a[_s194 + 1], r),
              _d30 = a[_s194 + R];
            var _f41 = _d30;
            var _iterator295 = _createForOfIteratorHelper(_u81),
              _step295;
            try {
              for (_iterator295.s(); !(_step295 = _iterator295.n()).done;) {
                var _e409 = _step295.value;
                var _s196 = _e409 * c;
                a[_s196 + 2] > t && (_f41 += a[_s196 + R]);
              }
            } catch (err) {
              _iterator295.e(err);
            } finally {
              _iterator295.f();
            }
            if (_f41 > _d30 && _f41 >= n) {
              var _e405 = void 0,
                _n235 = _o127 * _d30,
                _r329 = _h54 * _d30,
                _p47 = -1;
              var _g17 = (_s194 / c << 5) + (t + 1) + this.points.length;
              var _iterator296 = _createForOfIteratorHelper(_u81),
                _step296;
              try {
                for (_iterator296.s(); !(_step296 = _iterator296.n()).done;) {
                  var _o128 = _step296.value;
                  var _l94 = _o128 * c;
                  if (a[_l94 + 2] <= t) continue;
                  a[_l94 + 2] = t;
                  var _h55 = a[_l94 + R];
                  _n235 += a[_l94] * _h55, _r329 += a[_l94 + 1] * _h55, a[_l94 + 4] = _g17, i && (_e405 || (_e405 = this._map(a, _s194, !0), _p47 = this.clusterProps.length, this.clusterProps.push(_e405)), i(_e405, this._map(a, _l94)));
                }
              } catch (err) {
                _iterator296.e(err);
              } finally {
                _iterator296.f();
              }
              a[_s194 + 4] = _g17, l.push(_n235 / _f41, _r329 / _f41, 1 / 0, _g17, -1, _f41), i && l.push(_p47);
            } else {
              for (var _e406 = 0; _e406 < c; _e406++) l.push(a[_s194 + _e406]);
              if (_f41 > 1) {
                var _iterator297 = _createForOfIteratorHelper(_u81),
                  _step297;
                try {
                  for (_iterator297.s(); !(_step297 = _iterator297.n()).done;) {
                    var _e407 = _step297.value;
                    var _s195 = _e407 * c;
                    if (!(a[_s195 + 2] <= t)) {
                      a[_s195 + 2] = t;
                      for (var _e408 = 0; _e408 < c; _e408++) l.push(a[_s195 + _e408]);
                    }
                  }
                } catch (err) {
                  _iterator297.e(err);
                } finally {
                  _iterator297.f();
                }
              }
            }
          }
          return l;
        }
      }, {
        key: "_getOriginId",
        value: function _getOriginId(e) {
          return e - this.points.length >> 5;
        }
      }, {
        key: "_getOriginZoom",
        value: function _getOriginZoom(e) {
          return (e - this.points.length) % 32;
        }
      }, {
        key: "_map",
        value: function _map(e, t, s) {
          if (e[t + R] > 1) {
            var _o129 = this.clusterProps[e[t + V]];
            return s ? Object.assign({}, _o129) : _o129;
          }
          var o = this.points[e[t + B]].properties,
            i = this.options.map(o);
          return s && i === o ? Object.assign({}, i) : i;
        }
      }]);
      return $;
    }();
    function q(e, t, s) {
      return {
        type: "Feature",
        id: e[t + B],
        properties: U(e, t, s),
        geometry: {
          type: "Point",
          coordinates: [(o = e[t], 360 * (o - .5)), H(e[t + 1])]
        }
      };
      var o;
    }
    function U(e, t, s) {
      var o = e[t + R],
        i = o >= 1e4 ? "".concat(Math.round(o / 1e3), "k") : o >= 1e3 ? Math.round(o / 100) / 10 + "k" : o,
        n = e[t + V],
        r = -1 === n ? {} : Object.assign({}, s[n]);
      return Object.assign(r, {
        cluster: !0,
        cluster_id: e[t + B],
        point_count: o,
        point_count_abbreviated: i
      });
    }
    function Q(e) {
      return e / 360 + .5;
    }
    function K(e) {
      var t = Math.sin(e * Math.PI / 180),
        s = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
      return s < 0 ? 0 : s > 1 ? 1 : s;
    }
    function H(e) {
      var t = (180 - 360 * e) * Math.PI / 180;
      return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
    }
    function ee(e, t, s, o) {
      var i = o;
      var n = t + (s - t >> 1);
      var r,
        a = s - t;
      var l = e[t],
        c = e[t + 1],
        h = e[s],
        u = e[s + 1];
      for (var _o130 = t + 3; _o130 < s; _o130 += 3) {
        var _t431 = te(e[_o130], e[_o130 + 1], l, c, h, u);
        if (_t431 > i) r = _o130, i = _t431;else if (_t431 === i) {
          var _e410 = Math.abs(_o130 - n);
          _e410 < a && (r = _o130, a = _e410);
        }
      }
      i > o && (r - t > 3 && ee(e, t, r, o), e[r + 2] = i, s - r > 3 && ee(e, r, s, o));
    }
    function te(e, t, s, o, i, n) {
      var r = i - s,
        a = n - o;
      if (0 !== r || 0 !== a) {
        var _l95 = ((e - s) * r + (t - o) * a) / (r * r + a * a);
        _l95 > 1 ? (s = i, o = n) : _l95 > 0 && (s += r * _l95, o += a * _l95);
      }
      return r = e - s, a = t - o, r * r + a * a;
    }
    function se(e, t, s, o) {
      var i = {
        id: e !== null && e !== void 0 ? e : null,
        type: t,
        geometry: s,
        tags: o,
        minX: 1 / 0,
        minY: 1 / 0,
        maxX: -1 / 0,
        maxY: -1 / 0
      };
      if ("Point" === t || "MultiPoint" === t || "LineString" === t) oe(i, s);else if ("Polygon" === t) oe(i, s[0]);else if ("MultiLineString" === t) {
        var _iterator298 = _createForOfIteratorHelper(s),
          _step298;
        try {
          for (_iterator298.s(); !(_step298 = _iterator298.n()).done;) {
            var _e411 = _step298.value;
            oe(i, _e411);
          }
        } catch (err) {
          _iterator298.e(err);
        } finally {
          _iterator298.f();
        }
      } else if ("MultiPolygon" === t) {
        var _iterator299 = _createForOfIteratorHelper(s),
          _step299;
        try {
          for (_iterator299.s(); !(_step299 = _iterator299.n()).done;) {
            var _e412 = _step299.value;
            oe(i, _e412[0]);
          }
        } catch (err) {
          _iterator299.e(err);
        } finally {
          _iterator299.f();
        }
      }
      return i;
    }
    function oe(e, t) {
      for (var _s197 = 0; _s197 < t.length; _s197 += 3) e.minX = Math.min(e.minX, t[_s197]), e.minY = Math.min(e.minY, t[_s197 + 1]), e.maxX = Math.max(e.maxX, t[_s197]), e.maxY = Math.max(e.maxY, t[_s197 + 1]);
    }
    function ie(e, t, s, o) {
      if (!t.geometry) return;
      var i = t.geometry.coordinates;
      if (i && 0 === i.length) return;
      var n = t.geometry.type,
        r = Math.pow(s.tolerance / ((1 << s.maxZoom) * s.extent), 2);
      var a = [],
        l = t.id;
      if (s.promoteId ? l = t.properties[s.promoteId] : s.generateId && (l = o || 0), "Point" === n) ne(i, a);else if ("MultiPoint" === n) {
        var _iterator300 = _createForOfIteratorHelper(i),
          _step300;
        try {
          for (_iterator300.s(); !(_step300 = _iterator300.n()).done;) {
            var _e413 = _step300.value;
            ne(_e413, a);
          }
        } catch (err) {
          _iterator300.e(err);
        } finally {
          _iterator300.f();
        }
      } else if ("LineString" === n) re(i, a, r, !1);else if ("MultiLineString" === n) {
        if (s.lineMetrics) {
          var _iterator301 = _createForOfIteratorHelper(i),
            _step301;
          try {
            for (_iterator301.s(); !(_step301 = _iterator301.n()).done;) {
              var _s198 = _step301.value;
              a = [], re(_s198, a, r, !1), e.push(se(l, "LineString", a, t.properties));
            }
          } catch (err) {
            _iterator301.e(err);
          } finally {
            _iterator301.f();
          }
          return;
        }
        ae(i, a, r, !1);
      } else if ("Polygon" === n) ae(i, a, r, !0);else {
        if ("MultiPolygon" !== n) {
          if ("GeometryCollection" === n) {
            var _iterator302 = _createForOfIteratorHelper(t.geometry.geometries),
              _step302;
            try {
              for (_iterator302.s(); !(_step302 = _iterator302.n()).done;) {
                var _i245 = _step302.value;
                ie(e, {
                  id: l,
                  geometry: _i245,
                  properties: t.properties
                }, s, o);
              }
            } catch (err) {
              _iterator302.e(err);
            } finally {
              _iterator302.f();
            }
            return;
          }
          throw new Error("Input data is not a valid GeoJSON object.");
        }
        var _iterator303 = _createForOfIteratorHelper(i),
          _step303;
        try {
          for (_iterator303.s(); !(_step303 = _iterator303.n()).done;) {
            var _e414 = _step303.value;
            var _t432 = [];
            ae(_e414, _t432, r, !0), a.push(_t432);
          }
        } catch (err) {
          _iterator303.e(err);
        } finally {
          _iterator303.f();
        }
      }
      e.push(se(l, n, a, t.properties));
    }
    function ne(e, t) {
      t.push(le(e[0]), ce(e[1]), 0);
    }
    function re(e, t, s, o) {
      var i,
        n,
        r = 0;
      for (var _s199 = 0; _s199 < e.length; _s199++) {
        var _a153 = le(e[_s199][0]),
          _l96 = ce(e[_s199][1]);
        t.push(_a153, _l96, 0), _s199 > 0 && (r += o ? (i * _l96 - _a153 * n) / 2 : Math.sqrt(Math.pow(_a153 - i, 2) + Math.pow(_l96 - n, 2))), i = _a153, n = _l96;
      }
      var a = t.length - 3;
      t[2] = 1, ee(t, 0, a, s), t[a + 2] = 1, t.size = Math.abs(r), t.start = 0, t.end = t.size;
    }
    function ae(e, t, s, o) {
      for (var _i246 = 0; _i246 < e.length; _i246++) {
        var _n236 = [];
        re(e[_i246], _n236, s, o), t.push(_n236);
      }
    }
    function le(e) {
      return e / 360 + .5;
    }
    function ce(e) {
      var t = Math.sin(e * Math.PI / 180),
        s = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
      return s < 0 ? 0 : s > 1 ? 1 : s;
    }
    function he(e, t, s, o, i, n, r, a) {
      if (o /= t, n >= (s /= t) && r < o) return e;
      if (r < s || n >= o) return null;
      var l = [];
      var _iterator304 = _createForOfIteratorHelper(e),
        _step304;
      try {
        for (_iterator304.s(); !(_step304 = _iterator304.n()).done;) {
          var _t433 = _step304.value;
          var _e415 = _t433.geometry;
          var _n237 = _t433.type;
          var _r330 = 0 === i ? _t433.minX : _t433.minY,
            _c67 = 0 === i ? _t433.maxX : _t433.maxY;
          if (_r330 >= s && _c67 < o) {
            l.push(_t433);
            continue;
          }
          if (_c67 < s || _r330 >= o) continue;
          var _h56 = [];
          if ("Point" === _n237 || "MultiPoint" === _n237) ue(_e415, _h56, s, o, i);else if ("LineString" === _n237) de(_e415, _h56, s, o, i, !1, a.lineMetrics);else if ("MultiLineString" === _n237) pe(_e415, _h56, s, o, i, !1);else if ("Polygon" === _n237) pe(_e415, _h56, s, o, i, !0);else if ("MultiPolygon" === _n237) {
            var _iterator305 = _createForOfIteratorHelper(_e415),
              _step305;
            try {
              for (_iterator305.s(); !(_step305 = _iterator305.n()).done;) {
                var _t434 = _step305.value;
                var _e416 = [];
                pe(_t434, _e416, s, o, i, !0), _e416.length && _h56.push(_e416);
              }
            } catch (err) {
              _iterator305.e(err);
            } finally {
              _iterator305.f();
            }
          }
          if (_h56.length) {
            if (a.lineMetrics && "LineString" === _n237) {
              var _iterator306 = _createForOfIteratorHelper(_h56),
                _step306;
              try {
                for (_iterator306.s(); !(_step306 = _iterator306.n()).done;) {
                  var _e417 = _step306.value;
                  l.push(se(_t433.id, _n237, _e417, _t433.tags));
                }
              } catch (err) {
                _iterator306.e(err);
              } finally {
                _iterator306.f();
              }
              continue;
            }
            "LineString" !== _n237 && "MultiLineString" !== _n237 || (1 === _h56.length ? (_n237 = "LineString", _h56 = _h56[0]) : _n237 = "MultiLineString"), "Point" !== _n237 && "MultiPoint" !== _n237 || (_n237 = 3 === _h56.length ? "Point" : "MultiPoint"), l.push(se(_t433.id, _n237, _h56, _t433.tags));
          }
        }
      } catch (err) {
        _iterator304.e(err);
      } finally {
        _iterator304.f();
      }
      return l.length ? l : null;
    }
    function ue(e, t, s, o, i) {
      for (var _n238 = 0; _n238 < e.length; _n238 += 3) {
        var _r331 = e[_n238 + i];
        _r331 >= s && _r331 <= o && ge(t, e[_n238], e[_n238 + 1], e[_n238 + 2]);
      }
    }
    function de(e, t, s, o, i, n, r) {
      var a = fe(e);
      var l = 0 === i ? me : ye;
      var c,
        h,
        u = e.start;
      for (var _d31 = 0; _d31 < e.length - 3; _d31 += 3) {
        var _f42 = e[_d31],
          _p48 = e[_d31 + 1],
          _g18 = e[_d31 + 2],
          _m22 = e[_d31 + 3],
          _y19 = e[_d31 + 4],
          _x16 = 0 === i ? _f42 : _p48,
          _w11 = 0 === i ? _m22 : _y19;
        var _S8 = !1;
        r && (c = Math.sqrt(Math.pow(_f42 - _m22, 2) + Math.pow(_p48 - _y19, 2))), _x16 < s ? _w11 > s && (h = l(a, _f42, _p48, _m22, _y19, s), r && (a.start = u + c * h)) : _x16 > o ? _w11 < o && (h = l(a, _f42, _p48, _m22, _y19, o), r && (a.start = u + c * h)) : ge(a, _f42, _p48, _g18), _w11 < s && _x16 >= s && (h = l(a, _f42, _p48, _m22, _y19, s), _S8 = !0), _w11 > o && _x16 <= o && (h = l(a, _f42, _p48, _m22, _y19, o), _S8 = !0), !n && _S8 && (r && (a.end = u + c * h), t.push(a), a = fe(e)), r && (u += c);
      }
      var d = e.length - 3;
      var f = e[d],
        p = e[d + 1],
        g = 0 === i ? f : p;
      g >= s && g <= o && ge(a, f, p, e[d + 2]), d = a.length - 3, n && d >= 3 && (a[d] !== a[0] || a[d + 1] !== a[1]) && ge(a, a[0], a[1], a[2]), a.length && t.push(a);
    }
    function fe(e) {
      var t = [];
      return t.size = e.size, t.start = e.start, t.end = e.end, t;
    }
    function pe(e, t, s, o, i, n) {
      var _iterator307 = _createForOfIteratorHelper(e),
        _step307;
      try {
        for (_iterator307.s(); !(_step307 = _iterator307.n()).done;) {
          var _r332 = _step307.value;
          de(_r332, t, s, o, i, n, !1);
        }
      } catch (err) {
        _iterator307.e(err);
      } finally {
        _iterator307.f();
      }
    }
    function ge(e, t, s, o) {
      e.push(t, s, o);
    }
    function me(e, t, s, o, i, n) {
      var r = (n - t) / (o - t);
      return ge(e, n, s + (i - s) * r, 1), r;
    }
    function ye(e, t, s, o, i, n) {
      var r = (n - s) / (i - s);
      return ge(e, t + (o - t) * r, n, 1), r;
    }
    function xe(e, t) {
      var s = [];
      for (var _o131 = 0; _o131 < e.length; _o131++) {
        var _i247 = e[_o131],
          _n239 = _i247.type;
        var _r333 = void 0;
        if ("Point" === _n239 || "MultiPoint" === _n239 || "LineString" === _n239) _r333 = we(_i247.geometry, t);else if ("MultiLineString" === _n239 || "Polygon" === _n239) {
          _r333 = [];
          var _iterator308 = _createForOfIteratorHelper(_i247.geometry),
            _step308;
          try {
            for (_iterator308.s(); !(_step308 = _iterator308.n()).done;) {
              var _e418 = _step308.value;
              _r333.push(we(_e418, t));
            }
          } catch (err) {
            _iterator308.e(err);
          } finally {
            _iterator308.f();
          }
        } else if ("MultiPolygon" === _n239) {
          _r333 = [];
          var _iterator309 = _createForOfIteratorHelper(_i247.geometry),
            _step309;
          try {
            for (_iterator309.s(); !(_step309 = _iterator309.n()).done;) {
              var _e419 = _step309.value;
              var _s200 = [];
              var _iterator310 = _createForOfIteratorHelper(_e419),
                _step310;
              try {
                for (_iterator310.s(); !(_step310 = _iterator310.n()).done;) {
                  var _o132 = _step310.value;
                  _s200.push(we(_o132, t));
                }
              } catch (err) {
                _iterator310.e(err);
              } finally {
                _iterator310.f();
              }
              _r333.push(_s200);
            }
          } catch (err) {
            _iterator309.e(err);
          } finally {
            _iterator309.f();
          }
        }
        s.push(se(_i247.id, _n239, _r333, _i247.tags));
      }
      return s;
    }
    function we(e, t) {
      var s = [];
      s.size = e.size, void 0 !== e.start && (s.start = e.start, s.end = e.end);
      for (var _o133 = 0; _o133 < e.length; _o133 += 3) s.push(e[_o133] + t, e[_o133 + 1], e[_o133 + 2]);
      return s;
    }
    function Se(e, t) {
      if (e.transformed) return e;
      var s = 1 << e.z,
        o = e.x,
        i = e.y;
      var _iterator311 = _createForOfIteratorHelper(e.features),
        _step311;
      try {
        for (_iterator311.s(); !(_step311 = _iterator311.n()).done;) {
          var _n240 = _step311.value;
          var _e420 = _n240.geometry,
            _r334 = _n240.type;
          if (_n240.geometry = [], 1 === _r334) for (var _r335 = 0; _r335 < _e420.length; _r335 += 2) _n240.geometry.push(be(_e420[_r335], _e420[_r335 + 1], t, s, o, i));else for (var _r336 = 0; _r336 < _e420.length; _r336++) {
            var _a154 = [];
            for (var _n241 = 0; _n241 < _e420[_r336].length; _n241 += 2) _a154.push(be(_e420[_r336][_n241], _e420[_r336][_n241 + 1], t, s, o, i));
            _n240.geometry.push(_a154);
          }
        }
      } catch (err) {
        _iterator311.e(err);
      } finally {
        _iterator311.f();
      }
      return e.transformed = !0, e;
    }
    function be(e, t, s, o, i, n) {
      return [Math.round(s * (e * o - i)), Math.round(s * (t * o - n))];
    }
    function ve(e, t, s, o, i) {
      var n = t === i.maxZoom ? 0 : i.tolerance / ((1 << t) * i.extent),
        r = {
          features: [],
          numPoints: 0,
          numSimplified: 0,
          numFeatures: e.length,
          source: null,
          x: s,
          y: o,
          z: t,
          transformed: !1,
          minX: 2,
          minY: 1,
          maxX: -1,
          maxY: 0
        };
      var _iterator312 = _createForOfIteratorHelper(e),
        _step312;
      try {
        for (_iterator312.s(); !(_step312 = _iterator312.n()).done;) {
          var _t435 = _step312.value;
          Ie(r, _t435, n, i);
        }
      } catch (err) {
        _iterator312.e(err);
      } finally {
        _iterator312.f();
      }
      return r;
    }
    function Ie(e, t, s, o) {
      var i = t.geometry,
        n = t.type,
        r = [];
      if (e.minX = Math.min(e.minX, t.minX), e.minY = Math.min(e.minY, t.minY), e.maxX = Math.max(e.maxX, t.maxX), e.maxY = Math.max(e.maxY, t.maxY), "Point" === n || "MultiPoint" === n) for (var _t436 = 0; _t436 < i.length; _t436 += 3) r.push(i[_t436], i[_t436 + 1]), e.numPoints++, e.numSimplified++;else if ("LineString" === n) Me(r, i, e, s, !1, !1);else if ("MultiLineString" === n || "Polygon" === n) for (var _t437 = 0; _t437 < i.length; _t437++) Me(r, i[_t437], e, s, "Polygon" === n, 0 === _t437);else if ("MultiPolygon" === n) for (var _t438 = 0; _t438 < i.length; _t438++) {
        var _o134 = i[_t438];
        for (var _t439 = 0; _t439 < _o134.length; _t439++) Me(r, _o134[_t439], e, s, !0, 0 === _t439);
      }
      if (r.length) {
        var _s201 = t.tags || null;
        if ("LineString" === n && o.lineMetrics) {
          _s201 = {};
          for (var _e421 in t.tags) _s201[_e421] = t.tags[_e421];
          _s201.mapbox_clip_start = i.start / i.size, _s201.mapbox_clip_end = i.end / i.size;
        }
        var _a155 = {
          geometry: r,
          type: "Polygon" === n || "MultiPolygon" === n ? 3 : "LineString" === n || "MultiLineString" === n ? 2 : 1,
          tags: _s201
        };
        null !== t.id && (_a155.id = t.id), e.features.push(_a155);
      }
    }
    function Me(e, t, s, o, i, n) {
      var r = o * o;
      if (o > 0 && t.size < (i ? r : o)) return void (s.numPoints += t.length / 3);
      var a = [];
      for (var _e422 = 0; _e422 < t.length; _e422 += 3) (0 === o || t[_e422 + 2] > r) && (s.numSimplified++, a.push(t[_e422], t[_e422 + 1])), s.numPoints++;
      i && function (e, t) {
        var s = 0;
        for (var _t440 = 0, _o135 = e.length, _i248 = _o135 - 2; _t440 < _o135; _i248 = _t440, _t440 += 2) s += (e[_t440] - e[_i248]) * (e[_t440 + 1] + e[_i248 + 1]);
        if (s > 0 === t) for (var _t441 = 0, _s202 = e.length; _t441 < _s202 / 2; _t441 += 2) {
          var _o136 = e[_t441],
            _i249 = e[_t441 + 1];
          e[_t441] = e[_s202 - 2 - _t441], e[_t441 + 1] = e[_s202 - 1 - _t441], e[_s202 - 2 - _t441] = _o136, e[_s202 - 1 - _t441] = _i249;
        }
      }(a, n), e.push(a);
    }
    var ke = {
      maxZoom: 14,
      indexMaxZoom: 5,
      indexMaxPoints: 1e5,
      tolerance: 3,
      extent: 4096,
      buffer: 64,
      lineMetrics: !1,
      promoteId: null,
      generateId: !1,
      debug: 0
    };
    var Te = /*#__PURE__*/function () {
      function Te(e, t) {
        _classCallCheck(this, Te);
        var s = (t = this.options = function (e, t) {
          for (var _s203 in t) e[_s203] = t[_s203];
          return e;
        }(Object.create(ke), t)).debug;
        if (s && console.time("preprocess data"), t.maxZoom < 0 || t.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
        if (t.promoteId && t.generateId) throw new Error("promoteId and generateId cannot be used together.");
        var o = function (e, t) {
          var s = [];
          if ("FeatureCollection" === e.type) for (var _o137 = 0; _o137 < e.features.length; _o137++) ie(s, e.features[_o137], t, _o137);else ie(s, "Feature" === e.type ? e : {
            geometry: e
          }, t);
          return s;
        }(e, t);
        this.tiles = {}, this.tileCoords = [], s && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t.indexMaxZoom, t.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), o = function (e, t) {
          var s = t.buffer / t.extent;
          var o = e;
          var i = he(e, 1, -1 - s, s, 0, -1, 2, t),
            n = he(e, 1, 1 - s, 2 + s, 0, -1, 2, t);
          return (i || n) && (o = he(e, 1, -s, 1 + s, 0, -1, 2, t) || [], i && (o = xe(i, 1).concat(o)), n && (o = o.concat(xe(n, -1)))), o;
        }(o, t), o.length && this.splitTile(o, 0, 0, 0), s && (o.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
      }
      _createClass(Te, [{
        key: "splitTile",
        value: function splitTile(e, t, s, o, i, n, r) {
          var a = [e, t, s, o],
            l = this.options,
            c = l.debug;
          for (; a.length;) {
            o = a.pop(), s = a.pop(), t = a.pop(), e = a.pop();
            var _h57 = 1 << t,
              _u82 = Pe(t, s, o);
            var _d32 = this.tiles[_u82];
            if (!_d32 && (c > 1 && console.time("creation"), _d32 = this.tiles[_u82] = ve(e, t, s, o, l), this.tileCoords.push({
              z: t,
              x: s,
              y: o
            }), c)) {
              c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t, s, o, _d32.numFeatures, _d32.numPoints, _d32.numSimplified), console.timeEnd("creation"));
              var _e423 = "z".concat(t);
              this.stats[_e423] = (this.stats[_e423] || 0) + 1, this.total++;
            }
            if (_d32.source = e, null == i) {
              if (t === l.indexMaxZoom || _d32.numPoints <= l.indexMaxPoints) continue;
            } else {
              if (t === l.maxZoom || t === i) continue;
              if (null != i) {
                var _e424 = i - t;
                if (s !== n >> _e424 || o !== r >> _e424) continue;
              }
            }
            if (_d32.source = null, 0 === e.length) continue;
            c > 1 && console.time("clipping");
            var _f43 = .5 * l.buffer / l.extent,
              _p49 = .5 - _f43,
              _g19 = .5 + _f43,
              _m23 = 1 + _f43;
            var _y20 = null,
              _x17 = null,
              _w12 = null,
              _S9 = null,
              _b12 = he(e, _h57, s - _f43, s + _g19, 0, _d32.minX, _d32.maxX, l),
              _v13 = he(e, _h57, s + _p49, s + _m23, 0, _d32.minX, _d32.maxX, l);
            e = null, _b12 && (_y20 = he(_b12, _h57, o - _f43, o + _g19, 1, _d32.minY, _d32.maxY, l), _x17 = he(_b12, _h57, o + _p49, o + _m23, 1, _d32.minY, _d32.maxY, l), _b12 = null), _v13 && (_w12 = he(_v13, _h57, o - _f43, o + _g19, 1, _d32.minY, _d32.maxY, l), _S9 = he(_v13, _h57, o + _p49, o + _m23, 1, _d32.minY, _d32.maxY, l), _v13 = null), c > 1 && console.timeEnd("clipping"), a.push(_y20 || [], t + 1, 2 * s, 2 * o), a.push(_x17 || [], t + 1, 2 * s, 2 * o + 1), a.push(_w12 || [], t + 1, 2 * s + 1, 2 * o), a.push(_S9 || [], t + 1, 2 * s + 1, 2 * o + 1);
          }
        }
      }, {
        key: "getTile",
        value: function getTile(e, t, s) {
          e = +e, t = +t, s = +s;
          var o = this.options,
            i = o.extent,
            n = o.debug;
          if (e < 0 || e > 24) return null;
          var r = 1 << e,
            a = Pe(e, t = t + r & r - 1, s);
          if (this.tiles[a]) return Se(this.tiles[a], i);
          n > 1 && console.log("drilling down to z%d-%d-%d", e, t, s);
          var l,
            c = e,
            h = t,
            u = s;
          for (; !l && c > 0;) c--, h >>= 1, u >>= 1, l = this.tiles[Pe(c, h, u)];
          return l && l.source ? (n > 1 && (console.log("found parent tile z%d-%d-%d", c, h, u), console.time("drilling down")), this.splitTile(l.source, c, h, u, e, t, s), n > 1 && console.timeEnd("drilling down"), this.tiles[a] ? Se(this.tiles[a], i) : null) : null;
        }
      }]);
      return Te;
    }();
    function Pe(e, t, s) {
      return 32 * ((1 << e) * s + t) + e;
    }
    function Ce(e, t) {
      var s = e.tileID.canonical;
      if (!this._geoJSONIndex) return t(null, null);
      var o = this._geoJSONIndex.getTile(s.z, s.x, s.y);
      if (!o) return t(null, null);
      var i = new p(o.features);
      var n = X(i);
      0 === n.byteOffset && n.byteLength === n.buffer.byteLength || (n = new Uint8Array(n)), t(null, {
        vectorTile: i,
        rawData: n.buffer
      });
    }
    var _e = /*#__PURE__*/function (_c68) {
      _inherits(_e, _c68);
      var _super98 = _createSuper(_e);
      function _e(e, t, s, o, i, n) {
        var _this82;
        _classCallCheck(this, _e);
        _this82 = _super98.call(this, e, t, s, o, Ce, n), i && (_this82.loadGeoJSON = i), _this82._dynamicIndex = new y();
        return _this82;
      }
      _createClass(_e, [{
        key: "loadData",
        value: function loadData(s, o) {
          var _this83 = this;
          var i = s && s.request,
            n = i && i.collectResourceTiming;
          this.loadGeoJSON(s, function (r, a) {
            if (r || !a) return o(r);
            if ("object" != typeof a) return o(new Error("Input data given to '".concat(s.source, "' is not a valid GeoJSON object.")));
            {
              try {
                if (s.filter) {
                  var _t442 = e.z(s.filter, {
                    type: "boolean",
                    "property-type": "data-driven",
                    overridable: !1,
                    transition: !1
                  });
                  if ("error" === _t442.result) throw new Error(_t442.value.map(function (e) {
                    return "".concat(e.key, ": ").concat(e.message);
                  }).join(", "));
                  a.features = a.features.filter(function (e) {
                    return _t442.value.evaluate({
                      zoom: 0
                    }, e);
                  });
                }
                s.dynamic ? ("Feature" === a.type && (a = {
                  type: "FeatureCollection",
                  features: [a]
                }), s.append || (_this83._dynamicIndex.clear(), _this83.loaded = {}), _this83._dynamicIndex.load(a.features, _this83.loaded), s.cluster && (a.features = _this83._dynamicIndex.getFeatures())) : _this83.loaded = {}, _this83._geoJSONIndex = s.cluster ? new $(function (_ref157) {
                  var t = _ref157.superclusterOptions,
                    s = _ref157.clusterProperties;
                  if (!s || !t) return t;
                  var o = {},
                    i = {},
                    n = {
                      accumulated: null,
                      zoom: 0
                    },
                    r = {
                      properties: null
                    },
                    a = Object.keys(s);
                  for (var _i250 = 0, _a156 = a; _i250 < _a156.length; _i250++) {
                    var _t443 = _a156[_i250];
                    var _s$_t = _slicedToArray(s[_t443], 2),
                      _n242 = _s$_t[0],
                      _r337 = _s$_t[1],
                      _a157 = e.z(_r337),
                      _l97 = e.z("string" == typeof _n242 ? [_n242, ["accumulated"], ["get", _t443]] : _n242);
                    o[_t443] = _a157.value, i[_t443] = _l97.value;
                  }
                  return t.map = function (e) {
                    r.properties = e;
                    var t = {};
                    for (var _i251 = 0, _a158 = a; _i251 < _a158.length; _i251++) {
                      var _e425 = _a158[_i251];
                      t[_e425] = o[_e425].evaluate(n, r);
                    }
                    return t;
                  }, t.reduce = function (e, t) {
                    r.properties = t;
                    for (var _i252 = 0, _a159 = a; _i252 < _a159.length; _i252++) {
                      var _t444 = _a159[_i252];
                      n.accumulated = e[_t444], e[_t444] = i[_t444].evaluate(n, r);
                    }
                  }, t;
                }(s)).load(a.features) : s.dynamic ? _this83._dynamicIndex : function (e, t) {
                  return new Te(e, t);
                }(a, s.geojsonVtOptions);
              } catch (e) {
                return o(e);
              }
              var _r338 = {};
              if (n) {
                var _e426 = t(i);
                _e426 && (_r338.resourceTiming = {}, _r338.resourceTiming[s.source] = JSON.parse(JSON.stringify(_e426)));
              }
              o(null, _r338);
            }
          });
        }
      }, {
        key: "reloadTile",
        value: function reloadTile(e, t) {
          var s = this.loaded;
          return s && s[e.uid] ? e.partial ? t(null, void 0) : _get(_getPrototypeOf(_e.prototype), "reloadTile", this).call(this, e, t) : this.loadTile(e, t);
        }
      }, {
        key: "loadGeoJSON",
        value: function loadGeoJSON(t, s) {
          if (t.request) e.h(t.request, s);else {
            if ("string" != typeof t.data) return s(new Error("Input data given to '".concat(t.source, "' is not a valid GeoJSON object.")));
            try {
              return s(null, JSON.parse(t.data));
            } catch (e) {
              return s(new Error("Input data given to '".concat(t.source, "' is not a valid GeoJSON object.")));
            }
          }
        }
      }, {
        key: "getClusterExpansionZoom",
        value: function getClusterExpansionZoom(e, t) {
          try {
            t(null, this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));
          } catch (e) {
            t(e);
          }
        }
      }, {
        key: "getClusterChildren",
        value: function getClusterChildren(e, t) {
          try {
            t(null, this._geoJSONIndex.getChildren(e.clusterId));
          } catch (e) {
            t(e);
          }
        }
      }, {
        key: "getClusterLeaves",
        value: function getClusterLeaves(e, t) {
          try {
            t(null, this._geoJSONIndex.getLeaves(e.clusterId, e.limit, e.offset));
          } catch (e) {
            t(e);
          }
        }
      }]);
      return _e;
    }(c);
    var Le = /*#__PURE__*/function () {
      function Le(t, s) {
        _classCallCheck(this, Le);
        this.tileID = new e.aQ(t.tileID.overscaledZ, t.tileID.wrap, t.tileID.canonical.z, t.tileID.canonical.x, t.tileID.canonical.y), this.tileZoom = t.tileZoom, this.uid = t.uid, this.zoom = t.zoom, this.canonical = t.tileID.canonical, this.pixelRatio = t.pixelRatio, this.tileSize = t.tileSize, this.source = t.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = t.projection, this.brightness = s;
      }
      _createClass(Le, [{
        key: "parse",
        value: function parse(t, s, o, i) {
          var _this84 = this;
          this.status = "parsing";
          var n = new e.aQ(o.tileID.overscaledZ, o.tileID.wrap, o.tileID.canonical.z, o.tileID.canonical.x, o.tileID.canonical.y),
            r = {},
            a = s.familiesBySource[o.source],
            l = new e.dQ(n, o.promoteId);
          return l.bucketLayerIDs = [], l.is3DTile = !0, e.e6(t).then(function (t) {
            if (!t) return i(new Error("Could not parse tile"));
            var s = e.e7(t, 1 / e.b7(o.tileID.canonical)),
              c = t.json.extensionsUsed && t.json.extensionsUsed.includes("MAPBOX_mesh_features") || t.json.asset.extras && t.json.asset.extras.MAPBOX_mesh_features,
              h = t.json.extensionsUsed && t.json.extensionsUsed.includes("EXT_meshopt_compression"),
              u = new e.Y(_this84.zoom, {
                brightness: _this84.brightness
              });
            for (var _t445 in a) {
              var _iterator313 = _createForOfIteratorHelper(a[_t445]),
                _step313;
              try {
                for (_iterator313.s(); !(_step313 = _iterator313.n()).done;) {
                  var _o138 = _step313.value;
                  var _t446 = _o138[0];
                  l.bucketLayerIDs.push(_o138.map(function (e) {
                    return e.id;
                  })), _t446.recalculate(u, []);
                  var _i253 = new e.e8(s, n, c, h, _this84.brightness, l);
                  c || (_i253.needsUpload = !0), r[_t446.fqid] = _i253, _i253.evaluate(_t446);
                }
              } catch (err) {
                _iterator313.e(err);
              } finally {
                _iterator313.f();
              }
            }
            _this84.status = "done", i(null, {
              buckets: r,
              featureIndex: l
            });
          }).catch(function (e) {
            return i(new Error(e.message));
          });
        }
      }]);
      return Le;
    }();
    var De = /*#__PURE__*/function () {
      function De(e, t, s, o, i, n) {
        _classCallCheck(this, De);
        this.actor = e, this.layerIndex = t, this.brightness = n, this.loading = {}, this.loaded = {};
      }
      _createClass(De, [{
        key: "loadTile",
        value: function loadTile(t, s) {
          var _this85 = this;
          var o = t.uid,
            i = this.loading[o] = new Le(t, this.brightness);
          e.e5(t.request, function (e, n) {
            var r = !_this85.loading[o];
            return delete _this85.loading[o], r || e ? (i.status = "done", r || (_this85.loaded[o] = i), s(e)) : n && 0 !== n.byteLength ? void i.parse(n, _this85.layerIndex, t, function (e, t) {
              i.status = "done", _this85.loaded = _this85.loaded || {}, _this85.loaded[o] = i, e || !t ? s(e) : s(null, t);
            }) : (i.status = "done", _this85.loaded[o] = i, s());
          });
        }
      }, {
        key: "reloadTile",
        value: function reloadTile(e, t) {
          var _this86 = this;
          var s = this.loaded,
            o = e.uid;
          if (s && s[o]) {
            var _i254 = s[o];
            _i254.projection = e.projection, _i254.brightness = e.brightness;
            var _n243 = function _n243(s, o) {
              _i254.reloadCallback && (delete _i254.reloadCallback, _this86.loadTile(e, t)), t(s, o);
            };
            "parsing" === _i254.status ? _i254.reloadCallback = _n243 : "done" === _i254.status && this.loadTile(e, t);
          }
        }
      }, {
        key: "abortTile",
        value: function abortTile(e, t) {
          var s = e.uid;
          this.loading[s] && delete this.loading[s], t();
        }
      }, {
        key: "removeTile",
        value: function removeTile(e, t) {
          var s = this.loaded,
            o = e.uid;
          s && s[o] && delete s[o], t();
        }
      }]);
      return De;
    }();
    var je = /*#__PURE__*/function () {
      function je(t) {
        var _this87 = this;
        _classCallCheck(this, je);
        this.self = t, this.actor = new e.e9(t, this), this.layerIndexes = {}, this.availableImages = {}, this.isSpriteLoaded = {}, this.projections = {}, this.defaultProjection = e.aK({
          name: "mercator"
        }), this.workerSourceTypes = {
          vector: c,
          geojson: _e,
          "batched-model": De
        }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = function (e, t) {
          if (_this87.workerSourceTypes[e]) throw new Error("Worker source with name \"".concat(e, "\" already registered."));
          _this87.workerSourceTypes[e] = t;
        }, this.self.registerRTLTextPlugin = function (t) {
          if (e.ea.isParsed()) throw new Error("RTL text plugin already registered.");
          e.ea.applyArabicShaping = t.applyArabicShaping, e.ea.processBidirectionalText = t.processBidirectionalText, e.ea.processStyledBidirectionalText = t.processStyledBidirectionalText;
        };
      }
      _createClass(je, [{
        key: "clearCaches",
        value: function clearCaches(e, t, s) {
          delete this.layerIndexes[e], delete this.availableImages[e], delete this.workerSources[e], delete this.demWorkerSources[e], delete this.rasterArrayWorkerSource, s();
        }
      }, {
        key: "checkIfReady",
        value: function checkIfReady(e, t, s) {
          s();
        }
      }, {
        key: "setReferrer",
        value: function setReferrer(e, t) {
          this.referrer = t;
        }
      }, {
        key: "spriteLoaded",
        value: function spriteLoaded(t, _ref158) {
          var s = _ref158.scope,
            o = _ref158.isLoaded;
          if (this.isSpriteLoaded[t] || (this.isSpriteLoaded[t] = {}), this.isSpriteLoaded[t][s] = o, this.workerSources[t] && this.workerSources[t][s]) for (var _i255 in this.workerSources[t][s]) {
            var _n244 = this.workerSources[t][s][_i255];
            for (var _t447 in _n244) {
              var _s204 = _n244[_t447];
              _s204 instanceof c && (_s204.isSpriteLoaded = o, _s204.fire(new e.g("isSpriteLoaded")));
            }
          }
        }
      }, {
        key: "setImages",
        value: function setImages(e, _ref159, o) {
          var t = _ref159.scope,
            s = _ref159.images;
          if (this.availableImages[e] || (this.availableImages[e] = {}), this.availableImages[e][t] = s, this.workerSources[e] && this.workerSources[e][t]) {
            for (var _o139 in this.workerSources[e][t]) {
              var _i256 = this.workerSources[e][t][_o139];
              for (var _e427 in _i256) _i256[_e427].availableImages = s;
            }
            o();
          } else o();
        }
      }, {
        key: "setProjection",
        value: function setProjection(t, s) {
          this.projections[t] = e.aK(s);
        }
      }, {
        key: "setBrightness",
        value: function setBrightness(e, t, s) {
          this.brightness = t, s();
        }
      }, {
        key: "setLayers",
        value: function setLayers(e, t, s) {
          this.getLayerIndex(e, t.scope).replace(t.layers, t.options), s();
        }
      }, {
        key: "updateLayers",
        value: function updateLayers(e, t, s) {
          this.getLayerIndex(e, t.scope).update(t.layers, t.removedIds, t.options), s();
        }
      }, {
        key: "loadTile",
        value: function loadTile(e, t, s) {
          t.projection = this.projections[e] || this.defaultProjection, this.getWorkerSource(e, t.type, t.source, t.scope).loadTile(t, s);
        }
      }, {
        key: "loadDEMTile",
        value: function loadDEMTile(e, t, s) {
          this.getDEMWorkerSource(e, t.source, t.scope).loadTile(t, s);
        }
      }, {
        key: "decodeRasterArray",
        value: function decodeRasterArray(e, t, s) {
          this.getRasterArrayWorkerSource().decodeRasterArray(t, s);
        }
      }, {
        key: "reloadTile",
        value: function reloadTile(e, t, s) {
          t.projection = this.projections[e] || this.defaultProjection, this.getWorkerSource(e, t.type, t.source, t.scope).reloadTile(t, s);
        }
      }, {
        key: "abortTile",
        value: function abortTile(e, t, s) {
          this.getWorkerSource(e, t.type, t.source, t.scope).abortTile(t, s);
        }
      }, {
        key: "removeTile",
        value: function removeTile(e, t, s) {
          this.getWorkerSource(e, t.type, t.source, t.scope).removeTile(t, s);
        }
      }, {
        key: "removeSource",
        value: function removeSource(e, t, s) {
          if (!(this.workerSources[e] && this.workerSources[e][t.scope] && this.workerSources[e][t.scope][t.type] && this.workerSources[e][t.scope][t.type][t.source])) return;
          var o = this.workerSources[e][t.scope][t.type][t.source];
          delete this.workerSources[e][t.scope][t.type][t.source], void 0 !== o.removeSource ? o.removeSource(t, s) : s();
        }
      }, {
        key: "loadWorkerSource",
        value: function loadWorkerSource(e, t, s) {
          try {
            this.self.importScripts(t.url), s();
          } catch (e) {
            s(e.toString());
          }
        }
      }, {
        key: "syncRTLPluginState",
        value: function syncRTLPluginState(t, s, o) {
          try {
            e.ea.setState(s);
            var _t448 = e.ea.getPluginURL();
            if (e.ea.isLoaded() && !e.ea.isParsed() && null != _t448) {
              this.self.importScripts(_t448);
              var _s205 = e.ea.isParsed();
              o(_s205 ? void 0 : new Error("RTL Text Plugin failed to import scripts from ".concat(_t448)), _s205);
            }
          } catch (e) {
            o(e.toString());
          }
        }
      }, {
        key: "setDracoUrl",
        value: function setDracoUrl(e, t) {
          this.dracoUrl = t;
        }
      }, {
        key: "getAvailableImages",
        value: function getAvailableImages(e, t) {
          this.availableImages[e] || (this.availableImages[e] = {});
          var s = this.availableImages[e][t];
          return s || (s = []), s;
        }
      }, {
        key: "getLayerIndex",
        value: function getLayerIndex(e, t) {
          this.layerIndexes[e] || (this.layerIndexes[e] = {});
          var s = this.layerIndexes[e][t];
          return s || (s = this.layerIndexes[e][t] = new i(), s.scope = t), s;
        }
      }, {
        key: "getWorkerSource",
        value: function getWorkerSource(e, t, s, o) {
          var _this88 = this;
          return this.workerSources[e] || (this.workerSources[e] = {}), this.workerSources[e][o] || (this.workerSources[e][o] = {}), this.workerSources[e][o][t] || (this.workerSources[e][o][t] = {}), this.isSpriteLoaded[e] || (this.isSpriteLoaded[e] = {}), this.workerSources[e][o][t][s] || (this.workerSources[e][o][t][s] = new this.workerSourceTypes[t]({
            send: function send(t, s, o, i, n, r) {
              _this88.actor.send(t, s, o, e, n, r);
            },
            scheduler: this.actor.scheduler
          }, this.getLayerIndex(e, o), this.getAvailableImages(e, o), this.isSpriteLoaded[e][o], void 0, this.brightness)), this.workerSources[e][o][t][s];
        }
      }, {
        key: "getDEMWorkerSource",
        value: function getDEMWorkerSource(e, t, s) {
          return this.demWorkerSources[e] || (this.demWorkerSources[e] = {}), this.demWorkerSources[e][s] || (this.demWorkerSources[e][s] = {}), this.demWorkerSources[e][s][t] || (this.demWorkerSources[e][s][t] = new h()), this.demWorkerSources[e][s][t];
        }
      }, {
        key: "getRasterArrayWorkerSource",
        value: function getRasterArrayWorkerSource() {
          return this.rasterArrayWorkerSource || (this.rasterArrayWorkerSource = new u()), this.rasterArrayWorkerSource;
        }
      }, {
        key: "enforceCacheSizeLimit",
        value: function enforceCacheSizeLimit(t, s) {
          e.eb(s);
        }
      }, {
        key: "getWorkerPerformanceMetrics",
        value: function getWorkerPerformanceMetrics(e, t, s) {
          s(void 0, void 0);
        }
      }]);
      return je;
    }();
    return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new je(self)), je;
  });
  define(["./shared"], function (e) {
    var t = i;
    function i(e) {
      return !function (e) {
        return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : function () {
          if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
          var e,
            t,
            i = new Blob([""], {
              type: "text/javascript"
            }),
            o = URL.createObjectURL(i);
          try {
            t = new Worker(o), e = !0;
          } catch (t) {
            e = !1;
          }
          return t && t.terminate(), URL.revokeObjectURL(o), e;
        }() ? function () {
          var e = document.createElement("canvas");
          e.width = e.height = 1;
          var t = e.getContext("2d");
          if (!t) return !1;
          var i = t.getImageData(0, 0, 1, 1);
          return i && i.width === e.width;
        }() ? (void 0 === o[t = e && e.failIfMajorPerformanceCaveat] && (o[t] = function (e) {
          var t,
            o = function (e) {
              var t = document.createElement("canvas"),
                o = Object.create(i.webGLContextAttributes);
              return o.failIfMajorPerformanceCaveat = e, t.getContext("webgl2", o);
            }(e);
          if (!o) return !1;
          try {
            t = o.createShader(o.VERTEX_SHADER);
          } catch (e) {
            return !1;
          }
          return !(!t || o.isContextLost()) && (o.shaderSource(t, "void main() {}"), o.compileShader(t), !0 === o.getShaderParameter(t, o.COMPILE_STATUS));
        }(t)), o[t] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL2 support") : "insufficient Canvas/getImageData support" : "insufficient worker support";
        var t;
      }(e);
    }
    var o = {};
    function r(e, t, i) {
      var o = document.createElement(e);
      return null != t && (o.className = t), i && i.appendChild(o), o;
    }
    function a(e, t, i) {
      var o = document.createElementNS("http://www.w3.org/2000/svg", e);
      for (var _i257 = 0, _Object$keys14 = Object.keys(t); _i257 < _Object$keys14.length; _i257++) {
        var _e428 = _Object$keys14[_i257];
        o.setAttributeNS(null, _e428, String(t[_e428]));
      }
      return i && i.appendChild(o), o;
    }
    i.webGLContextAttributes = {
      antialias: !1,
      alpha: !0,
      stencil: !0,
      depth: !0
    };
    var n = "undefined" != typeof document ? document.documentElement && document.documentElement.style : null,
      s = n && void 0 !== n.userSelect ? "userSelect" : "WebkitUserSelect";
    var l;
    function c() {
      n && s && (l = n[s], n[s] = "none");
    }
    function h() {
      n && s && (n[s] = l);
    }
    function _(e) {
      e.preventDefault(), e.stopPropagation(), window.removeEventListener("click", _, !0);
    }
    function u() {
      window.addEventListener("click", _, !0), window.setTimeout(function () {
        window.removeEventListener("click", _, !0);
      }, 0);
    }
    function d(e, t) {
      var i = e.getBoundingClientRect();
      return m(e, i, t);
    }
    function p(e, t) {
      var i = e.getBoundingClientRect(),
        o = [];
      for (var _r339 = 0; _r339 < t.length; _r339++) o.push(m(e, i, t[_r339]));
      return o;
    }
    function f(e) {
      return void 0 !== window.InstallTrigger && 2 === e.button && e.ctrlKey && window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : e.button;
    }
    function m(t, i, o) {
      var r = t.offsetWidth === i.width ? 1 : t.offsetWidth / i.width;
      return new e.P((o.clientX - i.left) * r, (o.clientY - i.top) * r);
    }
    var g = /*#__PURE__*/function () {
      function g() {
        _classCallCheck(this, g);
        this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps = new Set(), this._updatedImages = new Set();
      }
      _createClass(g, [{
        key: "isDirty",
        value: function isDirty() {
          return this._changed;
        }
      }, {
        key: "setDirty",
        value: function setDirty() {
          this._changed = !0;
        }
      }, {
        key: "getUpdatedSourceCaches",
        value: function getUpdatedSourceCaches() {
          return this._updatedSourceCaches;
        }
      }, {
        key: "updateSourceCache",
        value: function updateSourceCache(e, t) {
          this._updatedSourceCaches[e] = t, this.setDirty();
        }
      }, {
        key: "discardSourceCacheUpdate",
        value: function discardSourceCacheUpdate(e) {
          delete this._updatedSourceCaches[e];
        }
      }, {
        key: "updateLayer",
        value: function updateLayer(e) {
          var t = e.scope;
          this._updatedLayers[t] = this._updatedLayers[t] || new Set(), this._updatedLayers[t].add(e.id), this.setDirty();
        }
      }, {
        key: "removeLayer",
        value: function removeLayer(e) {
          var t = e.scope;
          this._removedLayers[t] = this._removedLayers[t] || {}, this._updatedLayers[t] = this._updatedLayers[t] || new Set(), this._removedLayers[t][e.id] = e, this._updatedLayers[t].delete(e.id), this._updatedPaintProps.delete(e.fqid), this.setDirty();
        }
      }, {
        key: "getRemovedLayer",
        value: function getRemovedLayer(e) {
          return this._removedLayers[e.scope] ? this._removedLayers[e.scope][e.id] : null;
        }
      }, {
        key: "discardLayerRemoval",
        value: function discardLayerRemoval(e) {
          this._removedLayers[e.scope] && delete this._removedLayers[e.scope][e.id];
        }
      }, {
        key: "getLayerUpdatesByScope",
        value: function getLayerUpdatesByScope() {
          var e = {};
          for (var _t449 in this._updatedLayers) e[_t449] = e[_t449] || {}, e[_t449].updatedIds = Array.from(this._updatedLayers[_t449].values());
          for (var _t450 in this._removedLayers) e[_t450] = e[_t450] || {}, e[_t450].removedIds = Object.keys(this._removedLayers[_t450]);
          return e;
        }
      }, {
        key: "getUpdatedPaintProperties",
        value: function getUpdatedPaintProperties() {
          return this._updatedPaintProps;
        }
      }, {
        key: "updatePaintProperties",
        value: function updatePaintProperties(e) {
          this._updatedPaintProps.add(e.fqid), this.setDirty();
        }
      }, {
        key: "getUpdatedImages",
        value: function getUpdatedImages() {
          return Array.from(this._updatedImages.values());
        }
      }, {
        key: "updateImage",
        value: function updateImage(e) {
          this._updatedImages.add(e), this.setDirty();
        }
      }, {
        key: "resetUpdatedImages",
        value: function resetUpdatedImages() {
          this._updatedImages.clear();
        }
      }, {
        key: "reset",
        value: function reset() {
          this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps.clear(), this._updatedImages.clear();
        }
      }]);
      return g;
    }();
    var v = {
      Int8: "BYTE",
      Uint8: "UNSIGNED_BYTE",
      Int16: "SHORT",
      Uint16: "UNSIGNED_SHORT",
      Int32: "INT",
      Uint32: "UNSIGNED_INT",
      Float32: "FLOAT"
    };
    var x = /*#__PURE__*/function () {
      function x(e, t, i, o, r, a) {
        _classCallCheck(this, x);
        this.length = t.length, this.attributes = i, this.itemSize = t.bytesPerElement, this.dynamicDraw = o, this.instanceCount = a, this.context = e;
        var n = e.gl;
        this.buffer = n.createBuffer(), e.bindVertexBuffer.set(this.buffer), n.bufferData(n.ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW), this.dynamicDraw || r || t.destroy();
      }
      _createClass(x, [{
        key: "bind",
        value: function bind() {
          this.context.bindVertexBuffer.set(this.buffer);
        }
      }, {
        key: "updateData",
        value: function updateData(e) {
          var t = this.context.gl;
          this.bind(), t.bufferSubData(t.ARRAY_BUFFER, 0, e.arrayBuffer);
        }
      }, {
        key: "enableAttributes",
        value: function enableAttributes(e, t) {
          for (var _i258 = 0; _i258 < this.attributes.length; _i258++) {
            var _o140 = t.attributes[this.attributes[_i258].name];
            void 0 !== _o140 && e.enableVertexAttribArray(_o140);
          }
        }
      }, {
        key: "setVertexAttribPointers",
        value: function setVertexAttribPointers(e, t, i) {
          for (var _o141 = 0; _o141 < this.attributes.length; _o141++) {
            var _r340 = this.attributes[_o141],
              _a160 = t.attributes[_r340.name];
            void 0 !== _a160 && e.vertexAttribPointer(_a160, _r340.components, e[v[_r340.type]], !1, this.itemSize, _r340.offset + this.itemSize * (i || 0));
          }
        }
      }, {
        key: "setVertexAttribDivisor",
        value: function setVertexAttribDivisor(e, t, i) {
          for (var _o142 = 0; _o142 < this.attributes.length; _o142++) {
            var _r341 = t.attributes[this.attributes[_o142].name];
            void 0 !== _r341 && this.instanceCount && this.instanceCount > 0 && e.vertexAttribDivisor(_r341, i);
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        }
      }]);
      return x;
    }();
    var y = /*#__PURE__*/function () {
      function y(e) {
        _classCallCheck(this, y);
        this.gl = e.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
      }
      _createClass(y, [{
        key: "get",
        value: function get() {
          return this.current;
        }
      }, {
        key: "set",
        value: function set(e) {}
      }, {
        key: "getDefault",
        value: function getDefault() {
          return this.default;
        }
      }, {
        key: "setDefault",
        value: function setDefault() {
          this.set(this.default);
        }
      }]);
      return y;
    }();
    var b = /*#__PURE__*/function (_y21) {
      _inherits(b, _y21);
      var _super99 = _createSuper(b);
      function b() {
        _classCallCheck(this, b);
        return _super99.apply(this, arguments);
      }
      _createClass(b, [{
        key: "getDefault",
        value: function getDefault() {
          return e.C.transparent;
        }
      }, {
        key: "set",
        value: function set(e) {
          var t = this.current;
          (e.r !== t.r || e.g !== t.g || e.b !== t.b || e.a !== t.a || this.dirty) && (this.gl.clearColor(e.r, e.g, e.b, e.a), this.current = e, this.dirty = !1);
        }
      }]);
      return b;
    }(y);
    var w = /*#__PURE__*/function (_y22) {
      _inherits(w, _y22);
      var _super100 = _createSuper(w);
      function w() {
        _classCallCheck(this, w);
        return _super100.apply(this, arguments);
      }
      _createClass(w, [{
        key: "getDefault",
        value: function getDefault() {
          return 1;
        }
      }, {
        key: "set",
        value: function set(e) {
          (e !== this.current || this.dirty) && (this.gl.clearDepth(e), this.current = e, this.dirty = !1);
        }
      }]);
      return w;
    }(y);
    var T = /*#__PURE__*/function (_y23) {
      _inherits(T, _y23);
      var _super101 = _createSuper(T);
      function T() {
        _classCallCheck(this, T);
        return _super101.apply(this, arguments);
      }
      _createClass(T, [{
        key: "getDefault",
        value: function getDefault() {
          return 0;
        }
      }, {
        key: "set",
        value: function set(e) {
          (e !== this.current || this.dirty) && (this.gl.clearStencil(e), this.current = e, this.dirty = !1);
        }
      }]);
      return T;
    }(y);
    var E = /*#__PURE__*/function (_y24) {
      _inherits(E, _y24);
      var _super102 = _createSuper(E);
      function E() {
        _classCallCheck(this, E);
        return _super102.apply(this, arguments);
      }
      _createClass(E, [{
        key: "getDefault",
        value: function getDefault() {
          return [!0, !0, !0, !0];
        }
      }, {
        key: "set",
        value: function set(e) {
          var t = this.current;
          (e[0] !== t[0] || e[1] !== t[1] || e[2] !== t[2] || e[3] !== t[3] || this.dirty) && (this.gl.colorMask(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
        }
      }]);
      return E;
    }(y);
    var C = /*#__PURE__*/function (_y25) {
      _inherits(C, _y25);
      var _super103 = _createSuper(C);
      function C() {
        _classCallCheck(this, C);
        return _super103.apply(this, arguments);
      }
      _createClass(C, [{
        key: "getDefault",
        value: function getDefault() {
          return !0;
        }
      }, {
        key: "set",
        value: function set(e) {
          (e !== this.current || this.dirty) && (this.gl.depthMask(e), this.current = e, this.dirty = !1);
        }
      }]);
      return C;
    }(y);
    var S = /*#__PURE__*/function (_y26) {
      _inherits(S, _y26);
      var _super104 = _createSuper(S);
      function S() {
        _classCallCheck(this, S);
        return _super104.apply(this, arguments);
      }
      _createClass(S, [{
        key: "getDefault",
        value: function getDefault() {
          return 255;
        }
      }, {
        key: "set",
        value: function set(e) {
          (e !== this.current || this.dirty) && (this.gl.stencilMask(e), this.current = e, this.dirty = !1);
        }
      }]);
      return S;
    }(y);
    var I = /*#__PURE__*/function (_y27) {
      _inherits(I, _y27);
      var _super105 = _createSuper(I);
      function I() {
        _classCallCheck(this, I);
        return _super105.apply(this, arguments);
      }
      _createClass(I, [{
        key: "getDefault",
        value: function getDefault() {
          return {
            func: this.gl.ALWAYS,
            ref: 0,
            mask: 255
          };
        }
      }, {
        key: "set",
        value: function set(e) {
          var t = this.current;
          (e.func !== t.func || e.ref !== t.ref || e.mask !== t.mask || this.dirty) && (this.gl.stencilFunc(e.func, e.ref, e.mask), this.current = e, this.dirty = !1);
        }
      }]);
      return I;
    }(y);
    var L = /*#__PURE__*/function (_y28) {
      _inherits(L, _y28);
      var _super106 = _createSuper(L);
      function L() {
        _classCallCheck(this, L);
        return _super106.apply(this, arguments);
      }
      _createClass(L, [{
        key: "getDefault",
        value: function getDefault() {
          var e = this.gl;
          return [e.KEEP, e.KEEP, e.KEEP];
        }
      }, {
        key: "set",
        value: function set(e) {
          var t = this.current;
          (e[0] !== t[0] || e[1] !== t[1] || e[2] !== t[2] || this.dirty) && (this.gl.stencilOp(e[0], e[1], e[2]), this.current = e, this.dirty = !1);
        }
      }]);
      return L;
    }(y);
    var P = /*#__PURE__*/function (_y29) {
      _inherits(P, _y29);
      var _super107 = _createSuper(P);
      function P() {
        _classCallCheck(this, P);
        return _super107.apply(this, arguments);
      }
      _createClass(P, [{
        key: "getDefault",
        value: function getDefault() {
          return !1;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          var t = this.gl;
          e ? t.enable(t.STENCIL_TEST) : t.disable(t.STENCIL_TEST), this.current = e, this.dirty = !1;
        }
      }]);
      return P;
    }(y);
    var R = /*#__PURE__*/function (_y30) {
      _inherits(R, _y30);
      var _super108 = _createSuper(R);
      function R() {
        _classCallCheck(this, R);
        return _super108.apply(this, arguments);
      }
      _createClass(R, [{
        key: "getDefault",
        value: function getDefault() {
          return [0, 1];
        }
      }, {
        key: "set",
        value: function set(e) {
          var t = this.current;
          (e[0] !== t[0] || e[1] !== t[1] || this.dirty) && (this.gl.depthRange(e[0], e[1]), this.current = e, this.dirty = !1);
        }
      }]);
      return R;
    }(y);
    var D = /*#__PURE__*/function (_y31) {
      _inherits(D, _y31);
      var _super109 = _createSuper(D);
      function D() {
        _classCallCheck(this, D);
        return _super109.apply(this, arguments);
      }
      _createClass(D, [{
        key: "getDefault",
        value: function getDefault() {
          return !1;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          var t = this.gl;
          e ? t.enable(t.DEPTH_TEST) : t.disable(t.DEPTH_TEST), this.current = e, this.dirty = !1;
        }
      }]);
      return D;
    }(y);
    var A = /*#__PURE__*/function (_y32) {
      _inherits(A, _y32);
      var _super110 = _createSuper(A);
      function A() {
        _classCallCheck(this, A);
        return _super110.apply(this, arguments);
      }
      _createClass(A, [{
        key: "getDefault",
        value: function getDefault() {
          return this.gl.LESS;
        }
      }, {
        key: "set",
        value: function set(e) {
          (e !== this.current || this.dirty) && (this.gl.depthFunc(e), this.current = e, this.dirty = !1);
        }
      }]);
      return A;
    }(y);
    var M = /*#__PURE__*/function (_y33) {
      _inherits(M, _y33);
      var _super111 = _createSuper(M);
      function M() {
        _classCallCheck(this, M);
        return _super111.apply(this, arguments);
      }
      _createClass(M, [{
        key: "getDefault",
        value: function getDefault() {
          return !1;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          var t = this.gl;
          e ? t.enable(t.BLEND) : t.disable(t.BLEND), this.current = e, this.dirty = !1;
        }
      }]);
      return M;
    }(y);
    var z = /*#__PURE__*/function (_y34) {
      _inherits(z, _y34);
      var _super112 = _createSuper(z);
      function z() {
        _classCallCheck(this, z);
        return _super112.apply(this, arguments);
      }
      _createClass(z, [{
        key: "getDefault",
        value: function getDefault() {
          var e = this.gl;
          return [e.ONE, e.ZERO, e.ONE, e.ZERO];
        }
      }, {
        key: "set",
        value: function set(e) {
          var t = this.current;
          (e[0] !== t[0] || e[1] !== t[1] || e[2] !== t[2] || e[3] !== t[3] || this.dirty) && (this.gl.blendFuncSeparate(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
        }
      }]);
      return z;
    }(y);
    var O = /*#__PURE__*/function (_y35) {
      _inherits(O, _y35);
      var _super113 = _createSuper(O);
      function O() {
        _classCallCheck(this, O);
        return _super113.apply(this, arguments);
      }
      _createClass(O, [{
        key: "getDefault",
        value: function getDefault() {
          return e.C.transparent;
        }
      }, {
        key: "set",
        value: function set(e) {
          var t = this.current;
          (e.r !== t.r || e.g !== t.g || e.b !== t.b || e.a !== t.a || this.dirty) && (this.gl.blendColor(e.r, e.g, e.b, e.a), this.current = e, this.dirty = !1);
        }
      }]);
      return O;
    }(y);
    var F = /*#__PURE__*/function (_y36) {
      _inherits(F, _y36);
      var _super114 = _createSuper(F);
      function F() {
        _classCallCheck(this, F);
        return _super114.apply(this, arguments);
      }
      _createClass(F, [{
        key: "getDefault",
        value: function getDefault() {
          return this.gl.FUNC_ADD;
        }
      }, {
        key: "set",
        value: function set(e) {
          (e !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e, e), this.current = e, this.dirty = !1);
        }
      }]);
      return F;
    }(y);
    var B = /*#__PURE__*/function (_y37) {
      _inherits(B, _y37);
      var _super115 = _createSuper(B);
      function B() {
        _classCallCheck(this, B);
        return _super115.apply(this, arguments);
      }
      _createClass(B, [{
        key: "getDefault",
        value: function getDefault() {
          return !1;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          var t = this.gl;
          e ? t.enable(t.CULL_FACE) : t.disable(t.CULL_FACE), this.current = e, this.dirty = !1;
        }
      }]);
      return B;
    }(y);
    var k = /*#__PURE__*/function (_y38) {
      _inherits(k, _y38);
      var _super116 = _createSuper(k);
      function k() {
        _classCallCheck(this, k);
        return _super116.apply(this, arguments);
      }
      _createClass(k, [{
        key: "getDefault",
        value: function getDefault() {
          return this.gl.BACK;
        }
      }, {
        key: "set",
        value: function set(e) {
          (e !== this.current || this.dirty) && (this.gl.cullFace(e), this.current = e, this.dirty = !1);
        }
      }]);
      return k;
    }(y);
    var N = /*#__PURE__*/function (_y39) {
      _inherits(N, _y39);
      var _super117 = _createSuper(N);
      function N() {
        _classCallCheck(this, N);
        return _super117.apply(this, arguments);
      }
      _createClass(N, [{
        key: "getDefault",
        value: function getDefault() {
          return this.gl.CCW;
        }
      }, {
        key: "set",
        value: function set(e) {
          (e !== this.current || this.dirty) && (this.gl.frontFace(e), this.current = e, this.dirty = !1);
        }
      }]);
      return N;
    }(y);
    var U = /*#__PURE__*/function (_y40) {
      _inherits(U, _y40);
      var _super118 = _createSuper(U);
      function U() {
        _classCallCheck(this, U);
        return _super118.apply(this, arguments);
      }
      _createClass(U, [{
        key: "getDefault",
        value: function getDefault() {
          return null;
        }
      }, {
        key: "set",
        value: function set(e) {
          (e !== this.current || this.dirty) && (this.gl.useProgram(e), this.current = e, this.dirty = !1);
        }
      }]);
      return U;
    }(y);
    var G = /*#__PURE__*/function (_y41) {
      _inherits(G, _y41);
      var _super119 = _createSuper(G);
      function G() {
        _classCallCheck(this, G);
        return _super119.apply(this, arguments);
      }
      _createClass(G, [{
        key: "getDefault",
        value: function getDefault() {
          return this.gl.TEXTURE0;
        }
      }, {
        key: "set",
        value: function set(e) {
          (e !== this.current || this.dirty) && (this.gl.activeTexture(e), this.current = e, this.dirty = !1);
        }
      }]);
      return G;
    }(y);
    var j = /*#__PURE__*/function (_y42) {
      _inherits(j, _y42);
      var _super120 = _createSuper(j);
      function j() {
        _classCallCheck(this, j);
        return _super120.apply(this, arguments);
      }
      _createClass(j, [{
        key: "getDefault",
        value: function getDefault() {
          var e = this.gl;
          return [0, 0, e.drawingBufferWidth, e.drawingBufferHeight];
        }
      }, {
        key: "set",
        value: function set(e) {
          var t = this.current;
          (e[0] !== t[0] || e[1] !== t[1] || e[2] !== t[2] || e[3] !== t[3] || this.dirty) && (this.gl.viewport(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
        }
      }]);
      return j;
    }(y);
    var V = /*#__PURE__*/function (_y43) {
      _inherits(V, _y43);
      var _super121 = _createSuper(V);
      function V() {
        _classCallCheck(this, V);
        return _super121.apply(this, arguments);
      }
      _createClass(V, [{
        key: "getDefault",
        value: function getDefault() {
          return null;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          var t = this.gl;
          t.bindFramebuffer(t.FRAMEBUFFER, e), this.current = e, this.dirty = !1;
        }
      }]);
      return V;
    }(y);
    var $ = /*#__PURE__*/function (_y44) {
      _inherits($, _y44);
      var _super122 = _createSuper($);
      function $() {
        _classCallCheck(this, $);
        return _super122.apply(this, arguments);
      }
      _createClass($, [{
        key: "getDefault",
        value: function getDefault() {
          return null;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          var t = this.gl;
          t.bindRenderbuffer(t.RENDERBUFFER, e), this.current = e, this.dirty = !1;
        }
      }]);
      return $;
    }(y);
    var Z = /*#__PURE__*/function (_y45) {
      _inherits(Z, _y45);
      var _super123 = _createSuper(Z);
      function Z() {
        _classCallCheck(this, Z);
        return _super123.apply(this, arguments);
      }
      _createClass(Z, [{
        key: "getDefault",
        value: function getDefault() {
          return null;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          var t = this.gl;
          t.bindTexture(t.TEXTURE_2D, e), this.current = e, this.dirty = !1;
        }
      }]);
      return Z;
    }(y);
    var W = /*#__PURE__*/function (_y46) {
      _inherits(W, _y46);
      var _super124 = _createSuper(W);
      function W() {
        _classCallCheck(this, W);
        return _super124.apply(this, arguments);
      }
      _createClass(W, [{
        key: "getDefault",
        value: function getDefault() {
          return null;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          var t = this.gl;
          t.bindBuffer(t.ARRAY_BUFFER, e), this.current = e, this.dirty = !1;
        }
      }]);
      return W;
    }(y);
    var H = /*#__PURE__*/function (_y47) {
      _inherits(H, _y47);
      var _super125 = _createSuper(H);
      function H() {
        _classCallCheck(this, H);
        return _super125.apply(this, arguments);
      }
      _createClass(H, [{
        key: "getDefault",
        value: function getDefault() {
          return null;
        }
      }, {
        key: "set",
        value: function set(e) {
          var t = this.gl;
          t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e), this.current = e, this.dirty = !1;
        }
      }]);
      return H;
    }(y);
    var q = /*#__PURE__*/function (_y48) {
      _inherits(q, _y48);
      var _super126 = _createSuper(q);
      function q() {
        _classCallCheck(this, q);
        return _super126.apply(this, arguments);
      }
      _createClass(q, [{
        key: "getDefault",
        value: function getDefault() {
          return null;
        }
      }, {
        key: "set",
        value: function set(e) {
          this.gl && (e !== this.current || this.dirty) && (this.gl.bindVertexArray(e), this.current = e, this.dirty = !1);
        }
      }]);
      return q;
    }(y);
    var X = /*#__PURE__*/function (_y49) {
      _inherits(X, _y49);
      var _super127 = _createSuper(X);
      function X() {
        _classCallCheck(this, X);
        return _super127.apply(this, arguments);
      }
      _createClass(X, [{
        key: "getDefault",
        value: function getDefault() {
          return 4;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          var t = this.gl;
          t.pixelStorei(t.UNPACK_ALIGNMENT, e), this.current = e, this.dirty = !1;
        }
      }]);
      return X;
    }(y);
    var Q = /*#__PURE__*/function (_y50) {
      _inherits(Q, _y50);
      var _super128 = _createSuper(Q);
      function Q() {
        _classCallCheck(this, Q);
        return _super128.apply(this, arguments);
      }
      _createClass(Q, [{
        key: "getDefault",
        value: function getDefault() {
          return !1;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          var t = this.gl;
          t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e), this.current = e, this.dirty = !1;
        }
      }]);
      return Q;
    }(y);
    var Y = /*#__PURE__*/function (_y51) {
      _inherits(Y, _y51);
      var _super129 = _createSuper(Y);
      function Y() {
        _classCallCheck(this, Y);
        return _super129.apply(this, arguments);
      }
      _createClass(Y, [{
        key: "getDefault",
        value: function getDefault() {
          return !1;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          var t = this.gl;
          t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, e), this.current = e, this.dirty = !1;
        }
      }]);
      return Y;
    }(y);
    var J = /*#__PURE__*/function (_y52) {
      _inherits(J, _y52);
      var _super130 = _createSuper(J);
      function J(e, t) {
        var _this89;
        _classCallCheck(this, J);
        _this89 = _super130.call(this, e), _this89.context = e, _this89.parent = t;
        return _this89;
      }
      _createClass(J, [{
        key: "getDefault",
        value: function getDefault() {
          return null;
        }
      }]);
      return J;
    }(y);
    var K = /*#__PURE__*/function (_J) {
      _inherits(K, _J);
      var _super131 = _createSuper(K);
      function K() {
        _classCallCheck(this, K);
        return _super131.apply(this, arguments);
      }
      _createClass(K, [{
        key: "setDirty",
        value: function setDirty() {
          this.dirty = !0;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          this.context.bindFramebuffer.set(this.parent);
          var t = this.gl;
          t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e, 0), this.current = e, this.dirty = !1;
        }
      }]);
      return K;
    }(J);
    var ee = /*#__PURE__*/function (_J2) {
      _inherits(ee, _J2);
      var _super132 = _createSuper(ee);
      function ee() {
        _classCallCheck(this, ee);
        return _super132.apply(this, arguments);
      }
      _createClass(ee, [{
        key: "attachment",
        value: function attachment() {
          return this.gl.DEPTH_ATTACHMENT;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          this.context.bindFramebuffer.set(this.parent);
          var t = this.gl;
          t.framebufferRenderbuffer(t.FRAMEBUFFER, this.attachment(), t.RENDERBUFFER, e), this.current = e, this.dirty = !1;
        }
      }]);
      return ee;
    }(J);
    var te = /*#__PURE__*/function (_J3) {
      _inherits(te, _J3);
      var _super133 = _createSuper(te);
      function te() {
        _classCallCheck(this, te);
        return _super133.apply(this, arguments);
      }
      _createClass(te, [{
        key: "attachment",
        value: function attachment() {
          return this.gl.DEPTH_ATTACHMENT;
        }
      }, {
        key: "set",
        value: function set(e) {
          if (e === this.current && !this.dirty) return;
          this.context.bindFramebuffer.set(this.parent);
          var t = this.gl;
          t.framebufferTexture2D(t.FRAMEBUFFER, this.attachment(), t.TEXTURE_2D, e, 0), this.current = e, this.dirty = !1;
        }
      }]);
      return te;
    }(J);
    var ie = /*#__PURE__*/function (_ee) {
      _inherits(ie, _ee);
      var _super134 = _createSuper(ie);
      function ie() {
        _classCallCheck(this, ie);
        return _super134.apply(this, arguments);
      }
      _createClass(ie, [{
        key: "attachment",
        value: function attachment() {
          return this.gl.DEPTH_STENCIL_ATTACHMENT;
        }
      }]);
      return ie;
    }(ee);
    var oe = /*#__PURE__*/function () {
      function oe(e, t, i, o, r) {
        _classCallCheck(this, oe);
        this.context = e, this.width = t, this.height = i;
        var a = this.framebuffer = e.gl.createFramebuffer();
        o && (this.colorAttachment = new K(e, a)), r && (this.depthAttachmentType = r, this.depthAttachment = "renderbuffer" === r ? new ee(e, a) : new te(e, a));
      }
      _createClass(oe, [{
        key: "destroy",
        value: function destroy() {
          var e = this.context.gl;
          if (this.colorAttachment) {
            var _t451 = this.colorAttachment.get();
            _t451 && e.deleteTexture(_t451);
          }
          if (this.depthAttachment && this.depthAttachmentType) if ("renderbuffer" === this.depthAttachmentType) {
            var _t452 = this.depthAttachment.get();
            _t452 && e.deleteRenderbuffer(_t452);
          } else {
            var _t453 = this.depthAttachment.get();
            _t453 && e.deleteTexture(_t453);
          }
          e.deleteFramebuffer(this.framebuffer);
        }
      }]);
      return oe;
    }();
    var re = /*#__PURE__*/function () {
      function re(e, t) {
        _classCallCheck(this, re);
        this.gl = e, this.clearColor = new b(this), this.clearDepth = new w(this), this.clearStencil = new T(this), this.colorMask = new E(this), this.depthMask = new C(this), this.stencilMask = new S(this), this.stencilFunc = new I(this), this.stencilOp = new L(this), this.stencilTest = new P(this), this.depthRange = new R(this), this.depthTest = new D(this), this.depthFunc = new A(this), this.blend = new M(this), this.blendFunc = new z(this), this.blendColor = new O(this), this.blendEquation = new F(this), this.cullFace = new B(this), this.cullFaceSide = new k(this), this.frontFace = new N(this), this.program = new U(this), this.activeTexture = new G(this), this.viewport = new j(this), this.bindFramebuffer = new V(this), this.bindRenderbuffer = new $(this), this.bindTexture = new Z(this), this.bindVertexBuffer = new W(this), this.bindElementBuffer = new H(this), this.bindVertexArrayOES = new q(this), this.pixelStoreUnpack = new X(this), this.pixelStoreUnpackPremultiplyAlpha = new Q(this), this.pixelStoreUnpackFlipY = new Y(this), this.options = t ? _objectSpread({}, t) : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e.getExtension("EXT_texture_filter_anisotropic") || e.getExtension("MOZ_EXT_texture_filter_anisotropic") || e.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e.getExtension("EXT_color_buffer_half_float"), this.extTimerQuery = e.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e.getParameter(e.MAX_TEXTURE_SIZE), this.maxPointSize = e.getParameter(e.ALIASED_POINT_SIZE_RANGE)[1];
      }
      _createClass(re, [{
        key: "setDefault",
        value: function setDefault() {
          this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
        }
      }, {
        key: "setDirty",
        value: function setDirty() {
          this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArrayOES.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
        }
      }, {
        key: "createIndexBuffer",
        value: function createIndexBuffer(t, i, o) {
          return new e.I(this, t, i, o);
        }
      }, {
        key: "createVertexBuffer",
        value: function createVertexBuffer(e, t, i, o, r) {
          return new x(this, e, t, i, o, r);
        }
      }, {
        key: "createRenderbuffer",
        value: function createRenderbuffer(e, t, i) {
          var o = this.gl,
            r = o.createRenderbuffer();
          return this.bindRenderbuffer.set(r), o.renderbufferStorage(o.RENDERBUFFER, e, t, i), this.bindRenderbuffer.set(null), r;
        }
      }, {
        key: "createFramebuffer",
        value: function createFramebuffer(e, t, i, o) {
          return new oe(this, e, t, i, o);
        }
      }, {
        key: "clear",
        value: function clear(_ref160) {
          var e = _ref160.color,
            t = _ref160.depth,
            i = _ref160.stencil,
            o = _ref160.colorMask;
          var r = this.gl;
          var a = 0;
          e && (a |= r.COLOR_BUFFER_BIT, this.clearColor.set(e), this.colorMask.set(o || [!0, !0, !0, !0])), void 0 !== t && (a |= r.DEPTH_BUFFER_BIT, this.depthRange.set([0, 1]), this.clearDepth.set(t), this.depthMask.set(!0)), void 0 !== i && (a |= r.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), r.clear(a);
        }
      }, {
        key: "setCullFace",
        value: function setCullFace(e) {
          !1 === e.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e.mode), this.frontFace.set(e.frontFace));
        }
      }, {
        key: "setDepthMode",
        value: function setDepthMode(e) {
          e.func !== this.gl.ALWAYS || e.mask ? (this.depthTest.set(!0), this.depthFunc.set(e.func), this.depthMask.set(e.mask), this.depthRange.set(e.range)) : this.depthTest.set(!1);
        }
      }, {
        key: "setStencilMode",
        value: function setStencilMode(e) {
          e.test.func !== this.gl.ALWAYS || e.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e.mask), this.stencilOp.set([e.fail, e.depthFail, e.pass]), this.stencilFunc.set({
            func: e.test.func,
            ref: e.ref,
            mask: e.test.mask
          })) : this.stencilTest.set(!1);
        }
      }, {
        key: "setColorMode",
        value: function setColorMode(t) {
          e.d(t.blendFunction, e.a.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(t.blendFunction), this.blendColor.set(t.blendColor), t.blendEquation ? this.blendEquation.set(t.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(t.mask);
        }
      }, {
        key: "unbindVAO",
        value: function unbindVAO() {
          this.bindVertexArrayOES.set(null);
        }
      }]);
      return re;
    }();
    var ae = /*#__PURE__*/function () {
      function ae(t, i, o, r) {
        _classCallCheck(this, ae);
        var a = {
            width: o[0],
            height: o[1],
            data: null
          },
          n = t.gl;
        this.targetColorTexture = new e.T(t, a, n.RGBA, {
          useMipmap: !1
        }), this.backgroundColorTexture = new e.T(t, a, n.RGBA, {
          useMipmap: !1
        }), this.context = t, this.updateParticleTexture(i, r), this.lastInvalidatedAt = 0;
      }
      _createClass(ae, [{
        key: "updateParticleTexture",
        value: function updateParticleTexture(t, i) {
          if (this.particleTextureDimension === i.width) return;
          (this.particleTexture0 || this.particleTexture1 || this.particleIndexBuffer || this.particleSegment) && (this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleIndexBuffer.destroy(), this.particleSegment.destroy());
          var o = this.context.gl,
            r = i.width * i.height;
          this.particleTexture0 = new e.T(this.context, i, o.RGBA, {
            premultiply: !1,
            useMipmap: !1
          }), this.particleTexture1 = new e.T(this.context, i, o.RGBA, {
            premultiply: !1,
            useMipmap: !1
          });
          var a = new e.S();
          a.reserve(r);
          for (var _e429 = 0; _e429 < r; _e429++) a.emplaceBack(_e429);
          this.particleIndexBuffer = this.context.createVertexBuffer(a, e.p.members, !0), this.particleSegment = e.b.simpleSegment(0, 0, this.particleIndexBuffer.length, 0), this.particleTextureDimension = i.width;
        }
      }, {
        key: "update",
        value: function update(t) {
          return !(this.lastInvalidatedAt < t && (this.lastInvalidatedAt = e.e.now(), 1));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.targetColorTexture.destroy(), this.backgroundColorTexture.destroy(), this.particleIndexBuffer.destroy(), this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleSegment.destroy();
        }
      }]);
      return ae;
    }();
    var ne = /*#__PURE__*/function (_e$E2) {
      _inherits(ne, _e$E2);
      var _super135 = _createSuper(ne);
      function ne(e) {
        var _this90;
        _classCallCheck(this, ne);
        _this90 = _super135.call(this), _this90.requestManager = e, _this90.models = {
          "": {}
        }, _this90.numModelsLoading = {};
        return _this90;
      }
      _createClass(ne, [{
        key: "loadModel",
        value: function loadModel(t, i) {
          var _this91 = this;
          return e.l(this.requestManager.transformRequest(i, e.R.Model).url).then(function (i) {
            if (!i) return;
            var o = e.c(i),
              r = new e.M(t, void 0, void 0, o);
            return r.computeBoundsAndApplyParent(), r;
          }).catch(function (o) {
            if (o && 404 === o.status) return null;
            _this91.fire(new e.f(new Error("Could not load model ".concat(t, " from ").concat(i, ": ").concat(o.message))));
          });
        }
      }, {
        key: "load",
        value: function load(t, i) {
          var _this92 = this;
          this.models[i] || (this.models[i] = {});
          var o = Object.keys(t);
          this.numModelsLoading[i] = (this.numModelsLoading[i] || 0) + o.length;
          var r = [];
          for (var _i259 = 0, _o143 = o; _i259 < _o143.length; _i259++) {
            var _e430 = _o143[_i259];
            r.push(this.loadModel(_e430, t[_e430]));
          }
          Promise.allSettled(r).then(function (t) {
            for (var _e431 = 0; _e431 < t.length; _e431++) {
              var _t$_e = t[_e431],
                _r342 = _t$_e.status,
                _a161 = _t$_e.value;
              "fulfilled" === _r342 && _a161 && (_this92.models[i][o[_e431]] = {
                model: _a161,
                numReferences: 1
              });
            }
            _this92.numModelsLoading[i] -= o.length, _this92.fire(new e.g("data", {
              dataType: "style"
            }));
          }).catch(function (t) {
            _this92.fire(new e.f(new Error("Could not load models: ".concat(t.message))));
          });
        }
      }, {
        key: "isLoaded",
        value: function isLoaded() {
          for (var _e432 in this.numModelsLoading) if (this.numModelsLoading[_e432] > 0) return !1;
          return !0;
        }
      }, {
        key: "hasModel",
        value: function hasModel(e, t) {
          return !!this.getModel(e, t);
        }
      }, {
        key: "getModel",
        value: function getModel(e, t) {
          return this.models[t] || (this.models[t] = {}), this.models[t][e] ? this.models[t][e].model : void 0;
        }
      }, {
        key: "addModel",
        value: function addModel(e, t, i) {
          this.models[i] || (this.models[i] = {}), this.hasModel(e, i) && this.models[i][e].numReferences++, this.load(_defineProperty({}, e, this.requestManager.normalizeModelURL(t)), i);
        }
      }, {
        key: "addModels",
        value: function addModels(e, t) {
          this.models[t] || (this.models[t] = {});
          var i = {};
          for (var _o144 in e) this.models[t][_o144] = {}, i[_o144] = this.requestManager.normalizeModelURL(e[_o144]);
          this.load(i, t);
        }
      }, {
        key: "addModelsFromBucket",
        value: function addModelsFromBucket(e, t) {
          this.models[t] || (this.models[t] = {});
          var i = {};
          var _iterator314 = _createForOfIteratorHelper(e),
            _step314;
          try {
            for (_iterator314.s(); !(_step314 = _iterator314.n()).done;) {
              var _o145 = _step314.value;
              this.hasModel(_o145, t) ? this.models[t][_o145].numReferences++ : i[_o145] = this.requestManager.normalizeModelURL(_o145);
            }
          } catch (err) {
            _iterator314.e(err);
          } finally {
            _iterator314.f();
          }
          this.load(i, t);
        }
      }, {
        key: "removeModel",
        value: function removeModel(e, t) {
          if (this.models[t] && this.models[t][e] && (this.models[t][e].numReferences--, 0 === this.models[t][e].numReferences)) {
            var _i260 = this.models[t][e].model;
            delete this.models[t][e], _i260.destroy();
          }
        }
      }, {
        key: "listModels",
        value: function listModels(e) {
          return this.models[e] || (this.models[e] = {}), Object.keys(this.models[e]);
        }
      }, {
        key: "upload",
        value: function upload(e, t) {
          this.models[t] || (this.models[t] = {});
          for (var _i261 in this.models[t]) this.models[t][_i261].model && this.models[t][_i261].model.upload(e.context);
        }
      }]);
      return ne;
    }(e.E);
    function se(e) {
      var t = e.userImage;
      return !!(t && t.render && t.render()) && (e.data.replace(new Uint8Array(t.data.buffer)), !0);
    }
    var le = /*#__PURE__*/function (_e$E3) {
      _inherits(le, _e$E3);
      var _super136 = _createSuper(le);
      function le() {
        var _this93;
        _classCallCheck(this, le);
        _this93 = _super136.call(this), _this93.images = {}, _this93.updatedImages = {}, _this93.callbackDispatchedThisFrame = {}, _this93.loaded = {}, _this93.requestors = [], _this93.patterns = {}, _this93.atlasImage = {}, _this93.atlasTexture = {}, _this93.dirty = !0;
        return _this93;
      }
      _createClass(le, [{
        key: "createScope",
        value: function createScope(t) {
          this.images[t] = {}, this.loaded[t] = !1, this.updatedImages[t] = {}, this.patterns[t] = {}, this.callbackDispatchedThisFrame[t] = {}, this.atlasImage[t] = new e.j({
            width: 1,
            height: 1
          });
        }
      }, {
        key: "isLoaded",
        value: function isLoaded() {
          for (var _e433 in this.loaded) if (!this.loaded[_e433]) return !1;
          return !0;
        }
      }, {
        key: "setLoaded",
        value: function setLoaded(e, t) {
          if (this.loaded[t] !== e && (this.loaded[t] = e, e)) {
            var _iterator315 = _createForOfIteratorHelper(this.requestors),
              _step315;
            try {
              for (_iterator315.s(); !(_step315 = _iterator315.n()).done;) {
                var _step315$value = _step315.value,
                  _e434 = _step315$value.ids,
                  _i262 = _step315$value.callback;
                this._notify(_e434, t, _i262);
              }
            } catch (err) {
              _iterator315.e(err);
            } finally {
              _iterator315.f();
            }
            this.requestors = [];
          }
        }
      }, {
        key: "hasImage",
        value: function hasImage(e, t) {
          return !!this.getImage(e, t);
        }
      }, {
        key: "getImage",
        value: function getImage(e, t) {
          return this.images[t][e];
        }
      }, {
        key: "addImage",
        value: function addImage(e, t, i) {
          this._validate(e, i) && (this.images[t][e] = i);
        }
      }, {
        key: "_validate",
        value: function _validate(t, i) {
          var o = !0;
          return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new e.f(new Error("Image \"".concat(t, "\" has invalid \"stretchX\" value")))), o = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new e.f(new Error("Image \"".concat(t, "\" has invalid \"stretchY\" value")))), o = !1), this._validateContent(i.content, i) || (this.fire(new e.f(new Error("Image \"".concat(t, "\" has invalid \"content\" value")))), o = !1), o;
        }
      }, {
        key: "_validateStretch",
        value: function _validateStretch(e, t) {
          if (!e) return !0;
          var i = 0;
          var _iterator316 = _createForOfIteratorHelper(e),
            _step316;
          try {
            for (_iterator316.s(); !(_step316 = _iterator316.n()).done;) {
              var _o146 = _step316.value;
              if (_o146[0] < i || _o146[1] < _o146[0] || t < _o146[1]) return !1;
              i = _o146[1];
            }
          } catch (err) {
            _iterator316.e(err);
          } finally {
            _iterator316.f();
          }
          return !0;
        }
      }, {
        key: "_validateContent",
        value: function _validateContent(e, t) {
          return !(e && (4 !== e.length || e[0] < 0 || t.data.width < e[0] || e[1] < 0 || t.data.height < e[1] || e[2] < 0 || t.data.width < e[2] || e[3] < 0 || t.data.height < e[3] || e[2] < e[0] || e[3] < e[1]));
        }
      }, {
        key: "updateImage",
        value: function updateImage(e, t, i) {
          i.version = this.images[t][e].version + 1, this.images[t][e] = i, this.updatedImages[t][e] = !0;
        }
      }, {
        key: "removeImage",
        value: function removeImage(e, t) {
          var i = this.images[t][e];
          delete this.images[t][e], delete this.patterns[t][e], i.userImage && i.userImage.onRemove && i.userImage.onRemove();
        }
      }, {
        key: "listImages",
        value: function listImages(e) {
          return Object.keys(this.images[e]);
        }
      }, {
        key: "getImages",
        value: function getImages(e, t, i) {
          var o = !0;
          var r = !!this.loaded[t];
          if (!r) {
            var _iterator317 = _createForOfIteratorHelper(e),
              _step317;
            try {
              for (_iterator317.s(); !(_step317 = _iterator317.n()).done;) {
                var _i263 = _step317.value;
                this.images[t][_i263] || (o = !1);
              }
            } catch (err) {
              _iterator317.e(err);
            } finally {
              _iterator317.f();
            }
          }
          r || o ? this._notify(e, t, i) : this.requestors.push({
            ids: e,
            scope: t,
            callback: i
          });
        }
      }, {
        key: "getUpdatedImages",
        value: function getUpdatedImages(e) {
          return this.updatedImages[e];
        }
      }, {
        key: "_notify",
        value: function _notify(t, i, o) {
          var r = {};
          var _iterator318 = _createForOfIteratorHelper(t),
            _step318;
          try {
            for (_iterator318.s(); !(_step318 = _iterator318.n()).done;) {
              var _o147 = _step318.value;
              this.images[i][_o147] || this.fire(new e.g("styleimagemissing", {
                id: _o147
              }));
              var _t454 = this.images[i][_o147];
              _t454 ? r[_o147] = {
                data: _t454.data.clone(),
                pixelRatio: _t454.pixelRatio,
                sdf: _t454.sdf,
                version: _t454.version,
                stretchX: _t454.stretchX,
                stretchY: _t454.stretchY,
                content: _t454.content,
                hasRenderCallback: Boolean(_t454.userImage && _t454.userImage.render)
              } : e.w("Image \"".concat(_o147, "\" could not be loaded. Please make sure you have added the image with map.addImage() or a \"sprite\" property in your style. You can provide missing images by listening for the \"styleimagemissing\" map event."));
            }
          } catch (err) {
            _iterator318.e(err);
          } finally {
            _iterator318.f();
          }
          o(null, r);
        }
      }, {
        key: "getPixelSize",
        value: function getPixelSize(e) {
          var _this$atlasImage$e = this.atlasImage[e],
            t = _this$atlasImage$e.width,
            i = _this$atlasImage$e.height;
          return {
            width: t,
            height: i
          };
        }
      }, {
        key: "getPattern",
        value: function getPattern(t, i, o) {
          var r = this.patterns[i][t],
            a = this.getImage(t, i);
          if (!a) return null;
          if (r && r.position.version === a.version) return r.position;
          if (r) r.position.version = a.version;else {
            var _o148 = {
                w: a.data.width + 2,
                h: a.data.height + 2,
                x: 0,
                y: 0
              },
              _r343 = new e.m(_o148, a);
            this.patterns[i][t] = {
              bin: _o148,
              position: _r343
            };
          }
          return this._updatePatternAtlas(i, o), this.patterns[i][t].position;
        }
      }, {
        key: "bind",
        value: function bind(t, i) {
          var o = t.gl;
          var r = this.atlasTexture[i];
          r ? this.dirty && (r.update(this.atlasImage[i]), this.dirty = !1) : (r = new e.T(t, this.atlasImage[i], o.RGBA), this.atlasTexture[i] = r), r.bind(o.LINEAR, o.CLAMP_TO_EDGE);
        }
      }, {
        key: "_updatePatternAtlas",
        value: function _updatePatternAtlas(t, i) {
          var o = [];
          for (var _e435 in this.patterns[t]) o.push(this.patterns[t][_e435].bin);
          var _e$k2 = e.k(o),
            r = _e$k2.w,
            a = _e$k2.h,
            n = this.atlasImage[t];
          n.resize({
            width: r || 1,
            height: a || 1
          });
          for (var _o149 in this.patterns[t]) {
            var _r344 = this.patterns[t][_o149].bin,
              _a162 = _r344.x + 1,
              _s206 = _r344.y + 1,
              _l98 = this.images[t][_o149].data,
              _c69 = _l98.width,
              _h58 = _l98.height;
            e.j.copy(_l98, n, {
              x: 0,
              y: 0
            }, {
              x: _a162,
              y: _s206
            }, {
              width: _c69,
              height: _h58
            }, i), e.j.copy(_l98, n, {
              x: 0,
              y: _h58 - 1
            }, {
              x: _a162,
              y: _s206 - 1
            }, {
              width: _c69,
              height: 1
            }, i), e.j.copy(_l98, n, {
              x: 0,
              y: 0
            }, {
              x: _a162,
              y: _s206 + _h58
            }, {
              width: _c69,
              height: 1
            }, i), e.j.copy(_l98, n, {
              x: _c69 - 1,
              y: 0
            }, {
              x: _a162 - 1,
              y: _s206
            }, {
              width: 1,
              height: _h58
            }, i), e.j.copy(_l98, n, {
              x: 0,
              y: 0
            }, {
              x: _a162 + _c69,
              y: _s206
            }, {
              width: 1,
              height: _h58
            }, i);
          }
          this.dirty = !0;
        }
      }, {
        key: "beginFrame",
        value: function beginFrame() {
          for (var _e436 in this.images) this.callbackDispatchedThisFrame[_e436] = {};
        }
      }, {
        key: "dispatchRenderCallbacks",
        value: function dispatchRenderCallbacks(e, t) {
          var _iterator319 = _createForOfIteratorHelper(e),
            _step319;
          try {
            for (_iterator319.s(); !(_step319 = _iterator319.n()).done;) {
              var _i264 = _step319.value;
              if (this.callbackDispatchedThisFrame[t][_i264]) continue;
              this.callbackDispatchedThisFrame[t][_i264] = !0;
              var _e437 = this.images[t][_i264];
              se(_e437) && this.updateImage(_i264, t, _e437);
            }
          } catch (err) {
            _iterator319.e(err);
          } finally {
            _iterator319.f();
          }
        }
      }]);
      return le;
    }(e.E);
    function ce(t) {
      var i = t.key,
        o = t.value,
        r = t.valueSpec || {},
        a = t.objectElementValidators || {},
        n = t.style,
        s = t.styleSpec;
      var l = [];
      var c = e.o(o);
      if ("object" !== c) return [new e.V(i, o, "object expected, ".concat(c, " found"))];
      for (var _t455 in o) {
        var _c70 = _t455.split(".")[0];
        var _h59 = void 0;
        a[_c70] ? _h59 = a[_c70] : r[_c70] ? _h59 = De : a["*"] ? _h59 = a["*"] : r["*"] && (_h59 = De), _h59 ? l = l.concat(_h59({
          key: (i ? "".concat(i, ".") : i) + _t455,
          value: o[_t455],
          valueSpec: r[_c70] || r["*"],
          style: n,
          styleSpec: s,
          object: o,
          objectKey: _t455
        }, o)) : l.push(new e.n(i, o[_t455], "unknown property \"".concat(_t455, "\"")));
      }
      for (var _t456 in r) a[_t456] || r[_t456].required && void 0 === r[_t456].default && void 0 === o[_t456] && l.push(new e.V(i, o, "missing required property \"".concat(_t456, "\"")));
      return l;
    }
    function he(t) {
      var i = t.value,
        o = t.valueSpec,
        r = t.style,
        a = t.styleSpec,
        n = t.key,
        s = t.arrayElementValidator || De;
      if ("array" !== e.o(i)) return [new e.V(n, i, "array expected, ".concat(e.o(i), " found"))];
      if (o.length && i.length !== o.length) return [new e.V(n, i, "array length ".concat(o.length, " expected, length ").concat(i.length, " found"))];
      if (o["min-length"] && i.length < o["min-length"]) return [new e.V(n, i, "array length at least ".concat(o["min-length"], " expected, length ").concat(i.length, " found"))];
      var l = {
        type: o.value,
        values: o.values,
        minimum: o.minimum,
        maximum: o.maximum,
        function: void 0
      };
      a.$version < 7 && (l.function = o.function), "object" === e.o(o.value) && (l = o.value);
      var c = [];
      for (var _e438 = 0; _e438 < i.length; _e438++) c = c.concat(s({
        array: i,
        arrayIndex: _e438,
        value: i[_e438],
        valueSpec: l,
        style: r,
        styleSpec: a,
        key: "".concat(n, "[").concat(_e438, "]")
      }, !0));
      return c;
    }
    function _e(t) {
      var i = t.key,
        o = t.value,
        r = t.valueSpec;
      var a = e.o(o);
      if ("number" === a && o != o && (a = "NaN"), "number" !== a) return [new e.V(i, o, "number expected, ".concat(a, " found"))];
      if ("minimum" in r) {
        var _a163 = r.minimum;
        if ("array" === e.o(r.minimum) && (_a163 = r.minimum[t.arrayIndex]), o < _a163) return [new e.V(i, o, "".concat(o, " is less than the minimum value ").concat(_a163))];
      }
      if ("maximum" in r) {
        var _a164 = r.maximum;
        if ("array" === e.o(r.maximum) && (_a164 = r.maximum[t.arrayIndex]), o > _a164) return [new e.V(i, o, "".concat(o, " is greater than the maximum value ").concat(_a164))];
      }
      return [];
    }
    function ue(t) {
      var i = t.valueSpec,
        o = e.u(t.value.type);
      var r,
        a,
        n,
        s = {};
      var l = "categorical" !== o && void 0 === t.value.property,
        c = !l,
        h = "array" === e.o(t.value.stops) && "array" === e.o(t.value.stops[0]) && "object" === e.o(t.value.stops[0][0]),
        _ = ce({
          key: t.key,
          value: t.value,
          valueSpec: t.styleSpec.function,
          style: t.style,
          styleSpec: t.styleSpec,
          objectElementValidators: {
            stops: function stops(t) {
              if ("identity" === o) return [new e.V(t.key, t.value, 'identity function may not have a "stops" property')];
              var i = [];
              var r = t.value;
              return i = i.concat(he({
                key: t.key,
                value: r,
                valueSpec: t.valueSpec,
                style: t.style,
                styleSpec: t.styleSpec,
                arrayElementValidator: u
              })), "array" === e.o(r) && 0 === r.length && i.push(new e.V(t.key, r, "array must have at least one stop")), i;
            },
            default: function _default(e) {
              return De({
                key: e.key,
                value: e.value,
                valueSpec: i,
                style: e.style,
                styleSpec: e.styleSpec
              });
            }
          }
        });
      return "identity" === o && l && _.push(new e.V(t.key, t.value, 'missing required property "property"')), "identity" === o || t.value.stops || _.push(new e.V(t.key, t.value, 'missing required property "stops"')), "exponential" === o && t.valueSpec.expression && !e.s(t.valueSpec) && _.push(new e.V(t.key, t.value, "exponential functions not supported")), t.styleSpec.$version >= 8 && (c && !e.r(t.valueSpec) ? _.push(new e.V(t.key, t.value, "property functions not supported")) : l && !e.t(t.valueSpec) && _.push(new e.V(t.key, t.value, "zoom functions not supported"))), "categorical" !== o && !h || void 0 !== t.value.property || _.push(new e.V(t.key, t.value, '"property" property is required')), _;
      function u(t) {
        var o = [];
        var r = t.value,
          l = t.key;
        if ("array" !== e.o(r)) return [new e.V(l, r, "array expected, ".concat(e.o(r), " found"))];
        if (2 !== r.length) return [new e.V(l, r, "array length 2 expected, length ".concat(r.length, " found"))];
        if (h) {
          if ("object" !== e.o(r[0])) return [new e.V(l, r, "object expected, ".concat(e.o(r[0]), " found"))];
          if (void 0 === r[0].zoom) return [new e.V(l, r, "object stop key must have zoom")];
          if (void 0 === r[0].value) return [new e.V(l, r, "object stop key must have value")];
          var _i265 = e.u(r[0].zoom);
          if ("number" != typeof _i265) return [new e.V(l, r[0].zoom, "stop zoom values must be numbers")];
          if (n && n > _i265) return [new e.V(l, r[0].zoom, "stop zoom values must appear in ascending order")];
          _i265 !== n && (n = _i265, a = void 0, s = {}), o = o.concat(ce({
            key: "".concat(l, "[0]"),
            value: r[0],
            valueSpec: {
              zoom: {}
            },
            style: t.style,
            styleSpec: t.styleSpec,
            objectElementValidators: {
              zoom: _e,
              value: d
            }
          }));
        } else o = o.concat(d({
          key: "".concat(l, "[0]"),
          value: r[0],
          valueSpec: {},
          style: t.style,
          styleSpec: t.styleSpec
        }, r));
        return e.v(e.x(r[1])) ? o.concat([new e.V("".concat(l, "[1]"), r[1], "expressions are not allowed in function stops.")]) : o.concat(De({
          key: "".concat(l, "[1]"),
          value: r[1],
          valueSpec: i,
          style: t.style,
          styleSpec: t.styleSpec
        }));
      }
      function d(t, n) {
        var l = e.o(t.value),
          c = e.u(t.value),
          h = null !== t.value ? t.value : n;
        if (r) {
          if (l !== r) return [new e.V(t.key, h, "".concat(l, " stop domain type must match previous stop domain type ").concat(r))];
        } else r = l;
        if ("number" !== l && "string" !== l && "boolean" !== l && "number" != typeof c && "string" != typeof c && "boolean" != typeof c) return [new e.V(t.key, h, "stop domain value must be a number, string, or boolean")];
        if ("number" !== l && "categorical" !== o) {
          var _r345 = "number expected, ".concat(l, " found");
          return e.r(i) && void 0 === o && (_r345 += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [new e.V(t.key, h, _r345)];
        }
        return "categorical" !== o || "number" !== l || "number" == typeof c && isFinite(c) && Math.floor(c) === c ? "categorical" !== o && "number" === l && "number" == typeof c && "number" == typeof a && void 0 !== a && c < a ? [new e.V(t.key, h, "stop domain values must appear in ascending order")] : (a = c, "categorical" === o && c in s ? [new e.V(t.key, h, "stop domain values must be unique")] : (s[c] = !0, [])) : [new e.V(t.key, h, "integer expected, found ".concat(String(c)))];
      }
    }
    function de(t) {
      var i = ("property" === t.expressionContext ? e.y : e.z)(e.x(t.value), t.valueSpec);
      if ("error" === i.result) return i.value.map(function (i) {
        return new e.V("".concat(t.key).concat(i.key), t.value, i.message);
      });
      var o = i.value.expression || i.value._styleExpression.expression;
      if ("property" === t.expressionContext && "text-font" === t.propertyKey && !o.outputDefined()) return [new e.V(t.key, t.value, "Invalid data expression for \"".concat(t.propertyKey, "\". Output values must be contained as literals within the expression."))];
      if ("property" === t.expressionContext && "layout" === t.propertyType && !e.A(o)) return [new e.V(t.key, t.value, '"feature-state" data expressions are not supported with layout properties.')];
      if ("filter" === t.expressionContext) return pe(o, t);
      if (t.expressionContext && 0 === t.expressionContext.indexOf("cluster")) {
        if (!e.B(o, ["zoom", "feature-state"])) return [new e.V(t.key, t.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
        if ("cluster-initial" === t.expressionContext && !e.D(o)) return [new e.V(t.key, t.value, "Feature data expressions are not supported with initial expression part of cluster properties.")];
      }
      return [];
    }
    function pe(t, i) {
      var o = new Set(["zoom", "feature-state", "pitch", "distance-from-center"]);
      if (i.valueSpec && i.valueSpec.expression) {
        var _iterator320 = _createForOfIteratorHelper(i.valueSpec.expression.parameters),
          _step320;
        try {
          for (_iterator320.s(); !(_step320 = _iterator320.n()).done;) {
            var _e439 = _step320.value;
            o.delete(_e439);
          }
        } catch (err) {
          _iterator320.e(err);
        } finally {
          _iterator320.f();
        }
      }
      if (0 === o.size) return [];
      var r = [];
      return t instanceof e.F && o.has(t.name) ? [new e.V(i.key, i.value, "[\"".concat(t.name, "\"] expression is not supported in a filter for a ").concat(i.object.type, " layer with id: ").concat(i.object.id))] : (t.eachChild(function (e) {
        r.push.apply(r, _toConsumableArray(pe(e, i)));
      }), r);
    }
    function fe(t) {
      var i = t.key,
        o = t.value,
        r = t.valueSpec,
        a = [];
      return Array.isArray(r.values) ? -1 === r.values.indexOf(e.u(o)) && a.push(new e.V(i, o, "expected one of [".concat(r.values.join(", "), "], ").concat(JSON.stringify(o), " found"))) : -1 === Object.keys(r.values).indexOf(e.u(o)) && a.push(new e.V(i, o, "expected one of [".concat(Object.keys(r.values).join(", "), "], ").concat(JSON.stringify(o), " found"))), a;
    }
    function me(t) {
      return e.H(e.x(t.value)) ? de(e.q({}, t, {
        expressionContext: "filter",
        valueSpec: t.styleSpec["filter_".concat(t.layerType || "fill")]
      })) : ge(t);
    }
    function ge(t) {
      var i = t.value,
        o = t.key;
      if ("array" !== e.o(i)) return [new e.V(o, i, "array expected, ".concat(e.o(i), " found"))];
      var r = t.styleSpec;
      var a,
        n = [];
      if (i.length < 1) return [new e.V(o, i, "filter array must have at least 1 element")];
      switch (n = n.concat(fe({
        key: "".concat(o, "[0]"),
        value: i[0],
        valueSpec: r.filter_operator,
        style: t.style,
        styleSpec: t.styleSpec
      })), e.u(i[0])) {
        case "<":
        case "<=":
        case ">":
        case ">=":
          i.length >= 2 && "$type" === e.u(i[1]) && n.push(new e.V(o, i, "\"$type\" cannot be use with operator \"".concat(i[0], "\"")));
        case "==":
        case "!=":
          3 !== i.length && n.push(new e.V(o, i, "filter array for operator \"".concat(i[0], "\" must have 3 elements")));
        case "in":
        case "!in":
          i.length >= 2 && (a = e.o(i[1]), "string" !== a && n.push(new e.V("".concat(o, "[1]"), i[1], "string expected, ".concat(a, " found"))));
          for (var _s207 = 2; _s207 < i.length; _s207++) a = e.o(i[_s207]), "$type" === e.u(i[1]) ? n = n.concat(fe({
            key: "".concat(o, "[").concat(_s207, "]"),
            value: i[_s207],
            valueSpec: r.geometry_type,
            style: t.style,
            styleSpec: t.styleSpec
          })) : "string" !== a && "number" !== a && "boolean" !== a && n.push(new e.V("".concat(o, "[").concat(_s207, "]"), i[_s207], "string, number, or boolean expected, ".concat(a, " found")));
          break;
        case "any":
        case "all":
        case "none":
          for (var _e440 = 1; _e440 < i.length; _e440++) n = n.concat(ge({
            key: "".concat(o, "[").concat(_e440, "]"),
            value: i[_e440],
            style: t.style,
            styleSpec: t.styleSpec
          }));
          break;
        case "has":
        case "!has":
          a = e.o(i[1]), 2 !== i.length ? n.push(new e.V(o, i, "filter array for \"".concat(i[0], "\" operator must have 2 elements"))) : "string" !== a && n.push(new e.V("".concat(o, "[1]"), i[1], "string expected, ".concat(a, " found")));
      }
      return n;
    }
    function ve(t, i) {
      var o = t.key,
        r = t.style,
        a = t.layer,
        n = t.styleSpec,
        s = t.value,
        l = t.objectKey,
        c = n["".concat(i, "_").concat(t.layerType)];
      if (!c) return [];
      var h = l.match(/^(.*)-transition$/);
      if ("paint" === i && h && c[h[1]] && c[h[1]].transition) return De({
        key: o,
        value: s,
        valueSpec: n.transition,
        style: r,
        styleSpec: n
      });
      var _ = t.valueSpec || c[l];
      if (!_) return [new e.n(o, s, "unknown property \"".concat(l, "\""))];
      var u;
      if ("string" === e.o(s) && e.r(_) && !_.tokens && (u = /^{([^}]+)}$/.exec(s))) {
        var _t457 = "`{ \"type\": \"identity\", \"property\": ".concat(u ? JSON.stringify(u[1]) : '"_"', " }`");
        return [new e.V(o, s, "\"".concat(l, "\" does not support interpolation syntax\nUse an identity property function instead: ").concat(_t457, "."))];
      }
      var d = [];
      if ("symbol" === t.layerType) "text-field" !== l || !r || r.glyphs || r.imports || d.push(new e.V(o, s, 'use of "text-field" requires a style "glyphs" property')), "text-font" === l && e.J(e.x(s)) && "identity" === e.u(s.type) && d.push(new e.V(o, s, '"text-font" does not support identity functions'));else if ("model" === t.layerType && "paint" === i && a && a.layout && a.layout.hasOwnProperty("model-id") && e.r(_) && (e.K(_) || e.t(_))) {
        var _t458 = e.y(e.x(s), _),
          _i266 = _t458.value.expression || _t458.value._styleExpression.expression;
        _i266 && !e.B(_i266, ["measure-light"]) && ("model-emissive-strength" === l && e.D(_i266) && e.A(_i266) || d.push(new e.V(o, s, "".concat(l, " does not support measure-light expressions when the model layer source is vector tile or GeoJSON."))));
      }
      return d.concat(De({
        key: t.key,
        value: s,
        valueSpec: _,
        style: r,
        styleSpec: n,
        expressionContext: "property",
        propertyType: i,
        propertyKey: l
      }));
    }
    function xe(e) {
      return ve(e, "paint");
    }
    function ye(e) {
      return ve(e, "layout");
    }
    function be(t) {
      var i = [];
      var o = t.value,
        r = t.key,
        a = t.style,
        n = t.styleSpec;
      o.type || o.ref || i.push(new e.V(r, o, 'either "type" or "ref" is required'));
      var s = e.u(o.type);
      var l = e.u(o.ref);
      if (o.id) {
        var _n245 = e.u(o.id);
        for (var _s208 = 0; _s208 < t.arrayIndex; _s208++) {
          var _t459 = a.layers[_s208];
          e.u(_t459.id) === _n245 && i.push(new e.V(r, o.id, "duplicate layer id \"".concat(o.id, "\", previously used at line ").concat(_t459.id.__line__)));
        }
      }
      if ("ref" in o) {
        var _t460;
        ["type", "source", "source-layer", "filter", "layout"].forEach(function (t) {
          t in o && i.push(new e.V(r, o[t], "\"".concat(t, "\" is prohibited for ref layers")));
        }), a.layers.forEach(function (i) {
          e.u(i.id) === l && (_t460 = i);
        }), _t460 ? _t460.ref ? i.push(new e.V(r, o.ref, "ref cannot reference another ref layer")) : s = e.u(_t460.type) : "string" == typeof l && i.push(new e.V(r, o.ref, "ref layer \"".concat(l, "\" not found")));
      } else if ("background" !== s && "sky" !== s && "slot" !== s) if (o.source) {
        var _t461 = a.sources && a.sources[o.source],
          _n246 = _t461 && e.u(_t461.type);
        _t461 ? "vector" === _n246 && "raster" === s ? i.push(new e.V(r, o.source, "layer \"".concat(o.id, "\" requires a raster source"))) : "raster" === _n246 && "raster" !== s ? i.push(new e.V(r, o.source, "layer \"".concat(o.id, "\" requires a vector source"))) : "vector" !== _n246 || o["source-layer"] ? "raster-dem" === _n246 && "hillshade" !== s ? i.push(new e.V(r, o.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "raster-array" !== _n246 || ["raster", "raster-particle"].includes(s) ? "line" !== s || !o.paint || !o.paint["line-gradient"] && !o.paint["line-trim-offset"] || "geojson" === _n246 && _t461.lineMetrics ? "raster-particle" === s && "raster-array" !== _n246 && i.push(new e.V(r, o.source, "layer \"".concat(o.id, "\" requires a 'raster-array' source."))) : i.push(new e.V(r, o, "layer \"".concat(o.id, "\" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled."))) : i.push(new e.V(r, o.source, "raster-array source can only be used with layer type 'raster'.")) : i.push(new e.V(r, o, "layer \"".concat(o.id, "\" must specify a \"source-layer\""))) : i.push(new e.V(r, o.source, "source \"".concat(o.source, "\" not found")));
      } else i.push(new e.V(r, o, 'missing required property "source"'));
      return i = i.concat(ce({
        key: r,
        value: o,
        valueSpec: n.layer,
        style: t.style,
        styleSpec: t.styleSpec,
        objectElementValidators: {
          "*": function _() {
            return [];
          },
          type: function type() {
            return De({
              key: "".concat(r, ".type"),
              value: o.type,
              valueSpec: n.layer.type,
              style: t.style,
              styleSpec: t.styleSpec,
              object: o,
              objectKey: "type"
            });
          },
          filter: function filter(t) {
            return me(e.q({
              layerType: s
            }, t));
          },
          layout: function layout(t) {
            return ce({
              layer: o,
              key: t.key,
              value: t.value,
              valueSpec: {},
              style: t.style,
              styleSpec: t.styleSpec,
              objectElementValidators: {
                "*": function _(t) {
                  return ye(e.q({
                    layerType: s
                  }, t));
                }
              }
            });
          },
          paint: function paint(t) {
            return ce({
              layer: o,
              key: t.key,
              value: t.value,
              valueSpec: {},
              style: t.style,
              styleSpec: t.styleSpec,
              objectElementValidators: {
                "*": function _(t) {
                  return xe(e.q({
                    layerType: s,
                    layer: o
                  }, t));
                }
              }
            });
          }
        }
      })), i;
    }
    function we(t) {
      var i = t.value,
        o = t.key,
        r = e.o(i);
      return "string" !== r ? [new e.V(o, i, "string expected, ".concat(r, " found"))] : [];
    }
    var Te = {
      promoteId: function promoteId(_ref161) {
        var t = _ref161.key,
          i = _ref161.value;
        if ("string" === e.o(i)) return we({
          key: t,
          value: i
        });
        {
          var _e441 = [];
          for (var _o150 in i) _e441.push.apply(_e441, _toConsumableArray(we({
            key: "".concat(t, ".").concat(_o150),
            value: i[_o150]
          })));
          return _e441;
        }
      }
    };
    function Ee(t) {
      var i = t.value,
        o = t.key,
        r = t.styleSpec,
        a = t.style;
      if (!i.type) return [new e.V(o, i, '"type" is required')];
      var n = e.u(i.type);
      var s = [];
      switch (["vector", "raster", "raster-dem", "raster-array"].includes(n) && (i.url || i.tiles || s.push(new e.n(o, i, 'Either "url" or "tiles" is required.'))), n) {
        case "vector":
        case "raster":
        case "raster-dem":
        case "raster-array":
          return s = s.concat(ce({
            key: o,
            value: i,
            valueSpec: r["source_".concat(n.replace("-", "_"))],
            style: t.style,
            styleSpec: r,
            objectElementValidators: Te
          })), s;
        case "geojson":
          if (s = ce({
            key: o,
            value: i,
            valueSpec: r.source_geojson,
            style: a,
            styleSpec: r,
            objectElementValidators: Te
          }), i.cluster) for (var _e442 in i.clusterProperties) {
            var _s209, _s210;
            var _i$clusterProperties$ = _slicedToArray(i.clusterProperties[_e442], 2),
              _t462 = _i$clusterProperties$[0],
              _r346 = _i$clusterProperties$[1],
              _a165 = "string" == typeof _t462 ? [_t462, ["accumulated"], ["get", _e442]] : _t462;
            (_s209 = s).push.apply(_s209, _toConsumableArray(de({
              key: "".concat(o, ".").concat(_e442, ".map"),
              value: _r346,
              expressionContext: "cluster-map"
            }))), (_s210 = s).push.apply(_s210, _toConsumableArray(de({
              key: "".concat(o, ".").concat(_e442, ".reduce"),
              value: _a165,
              expressionContext: "cluster-reduce"
            })));
          }
          return s;
        case "video":
          return ce({
            key: o,
            value: i,
            valueSpec: r.source_video,
            style: a,
            styleSpec: r
          });
        case "image":
          return ce({
            key: o,
            value: i,
            valueSpec: r.source_image,
            style: a,
            styleSpec: r
          });
        case "canvas":
          return [new e.V(o, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")];
        default:
          return fe({
            key: "".concat(o, ".type"),
            value: i.type,
            valueSpec: {
              values: Ce(r)
            },
            style: a,
            styleSpec: r
          });
      }
    }
    function Ce(e) {
      return e.source.reduce(function (t, i) {
        var o = e[i];
        return "enum" === o.type.type && (t = t.concat(Object.keys(o.type.values))), t;
      }, []);
    }
    function Se(t) {
      var i = t.value,
        o = t.styleSpec,
        r = o.light,
        a = t.style;
      var n = [];
      var s = e.o(i);
      if (void 0 === i) return n;
      if ("object" !== s) return n = n.concat([new e.V("light", i, "object expected, ".concat(s, " found"))]), n;
      for (var _t463 in i) {
        var _s211 = _t463.match(/^(.*)-transition$/);
        n = n.concat(_s211 && r[_s211[1]] && r[_s211[1]].transition ? De({
          key: _t463,
          value: i[_t463],
          valueSpec: o.transition,
          style: a,
          styleSpec: o
        }) : r[_t463] ? De({
          key: _t463,
          value: i[_t463],
          valueSpec: r[_t463],
          style: a,
          styleSpec: o
        }) : [new e.V(_t463, i[_t463], "unknown property \"".concat(_t463, "\""))]);
      }
      return n;
    }
    function Ie(t) {
      var i = t.value;
      var o = [];
      if (!i) return o;
      var r = e.o(i);
      if ("object" !== r) return o = o.concat([new e.V("light-3d", i, "object expected, ".concat(r, " found"))]), o;
      var a = t.styleSpec,
        n = a["light-3d"],
        s = t.key,
        l = t.style,
        c = t.style.lights;
      for (var _i267 = 0, _arr2 = ["type", "id"]; _i267 < _arr2.length; _i267++) {
        var _t464 = _arr2[_i267];
        if (!(_t464 in i)) return o = o.concat([new e.V("light-3d", i, "missing property ".concat(_t464, " on light"))]), o;
      }
      if (i.type && c) for (var _r347 = 0; _r347 < t.arrayIndex; _r347++) {
        var _t465 = e.u(i.type),
          _a166 = c[_r347];
        e.u(_a166.type) === _t465 && o.push(new e.V(s, i.id, "duplicate light type \"".concat(i.type, "\", previously defined at line ").concat(_a166.id.__line__)));
      }
      var h = "properties_light_".concat(i.type);
      if (!(h in a)) return o = o.concat([new e.V("light-3d", i, "Invalid light type ".concat(i.type))]), o;
      var _ = a[h];
      for (var _r348 in i) if ("properties" === _r348) {
        var _n247 = i[_r348],
          _s212 = e.o(_n247);
        if ("object" !== _s212) return o = o.concat([new e.V("properties", _n247, "object expected, ".concat(_s212, " found"))]), o;
        for (var _i268 in _n247) o = o.concat(_[_i268] ? De({
          key: _i268,
          value: _n247[_i268],
          valueSpec: _[_i268],
          style: l,
          styleSpec: a
        }) : [new e.n(t.key, _n247[_i268], "unknown property \"".concat(_i268, "\""))]);
      } else {
        var _t466 = _r348.match(/^(.*)-transition$/);
        o = o.concat(_t466 && n[_t466[1]] && n[_t466[1]].transition ? De({
          key: _r348,
          value: i[_r348],
          valueSpec: a.transition,
          style: l,
          styleSpec: a
        }) : n[_r348] ? De({
          key: _r348,
          value: i[_r348],
          valueSpec: n[_r348],
          style: l,
          styleSpec: a
        }) : [new e.n(_r348, i[_r348], "unknown property \"".concat(_r348, "\""))]);
      }
      return o;
    }
    function Le(t) {
      var i = t.value,
        o = t.key,
        r = t.style,
        a = t.styleSpec,
        n = a.terrain;
      var s = [];
      var l = e.o(i);
      if (void 0 === i) return s;
      if ("null" === l) return s;
      if ("object" !== l) return s = s.concat([new e.V("terrain", i, "object expected, ".concat(l, " found"))]), s;
      for (var _t467 in i) {
        var _o151 = _t467.match(/^(.*)-transition$/);
        s = s.concat(_o151 && n[_o151[1]] && n[_o151[1]].transition ? De({
          key: _t467,
          value: i[_t467],
          valueSpec: a.transition,
          style: r,
          styleSpec: a
        }) : n[_t467] ? De({
          key: _t467,
          value: i[_t467],
          valueSpec: n[_t467],
          style: r,
          styleSpec: a
        }) : [new e.n(_t467, i[_t467], "unknown property \"".concat(_t467, "\""))]);
      }
      if (i.source) {
        var _t468 = r.sources && r.sources[i.source],
          _a167 = _t468 && e.u(_t468.type);
        _t468 ? "raster-dem" !== _a167 && s.push(new e.V(o, i.source, "terrain cannot be used with a source of type ".concat(String(_a167), ", it only be used with a \"raster-dem\" source type"))) : s.push(new e.V(o, i.source, "source \"".concat(i.source, "\" not found")));
      } else s.push(new e.V(o, i, 'terrain is missing required property "source"'));
      return s;
    }
    function Pe(t) {
      var i = t.value,
        o = t.style,
        r = t.styleSpec,
        a = r.fog;
      var n = [];
      var s = e.o(i);
      if (void 0 === i) return n;
      if ("object" !== s) return n = n.concat([new e.V("fog", i, "object expected, ".concat(s, " found"))]), n;
      for (var _t469 in i) {
        var _s213 = _t469.match(/^(.*)-transition$/);
        n = n.concat(_s213 && a[_s213[1]] && a[_s213[1]].transition ? De({
          key: _t469,
          value: i[_t469],
          valueSpec: r.transition,
          style: o,
          styleSpec: r
        }) : a[_t469] ? De({
          key: _t469,
          value: i[_t469],
          valueSpec: a[_t469],
          style: o,
          styleSpec: r
        }) : [new e.n(_t469, i[_t469], "unknown property \"".concat(_t469, "\""))]);
      }
      return n;
    }
    var Re = {
      "*": function _() {
        return [];
      },
      array: he,
      boolean: function boolean(t) {
        var i = t.value,
          o = t.key,
          r = e.o(i);
        return "boolean" !== r ? [new e.V(o, i, "boolean expected, ".concat(r, " found"))] : [];
      },
      number: _e,
      color: function color(t) {
        var i = t.key,
          o = t.value,
          r = e.o(o);
        return "string" !== r ? [new e.V(i, o, "color expected, ".concat(r, " found"))] : null === e.G(o) ? [new e.V(i, o, "color expected, \"".concat(o, "\" found"))] : [];
      },
      enum: fe,
      filter: me,
      function: ue,
      layer: be,
      object: ce,
      source: Ee,
      model: e.L,
      light: Se,
      "light-3d": Ie,
      terrain: Le,
      fog: Pe,
      string: we,
      formatted: function formatted(e) {
        return 0 === we(e).length ? [] : de(e);
      },
      resolvedImage: function resolvedImage(e) {
        return 0 === we(e).length ? [] : de(e);
      },
      projection: function projection(t) {
        var i = t.value,
          o = t.styleSpec,
          r = o.projection,
          a = t.style;
        var n = [];
        var s = e.o(i);
        if ("object" === s) for (var _e443 in i) n = n.concat(De({
          key: _e443,
          value: i[_e443],
          valueSpec: r[_e443],
          style: a,
          styleSpec: o
        }));else "string" !== s && (n = n.concat([new e.V("projection", i, "object or string expected, ".concat(s, " found"))]));
        return n;
      },
      import: function _import(t) {
        var i = t.value,
          o = t.styleSpec,
          r = i.data,
          a = _objectWithoutProperties(i, _excluded);
        Object.defineProperty(a, "__line__", {
          value: i.__line__,
          enumerable: !1
        });
        var n = ce(e.q({}, t, {
          value: a,
          valueSpec: o.import
        }));
        return "" === e.u(a.id) && n.push(new e.V("".concat(t.key, ".id"), a, "import id can't be an empty string")), r && (n = n.concat(Me(r, o, {
          key: "".concat(t.key, ".data")
        }))), n;
      }
    };
    function De(t) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var o = t.value,
        r = t.valueSpec,
        a = t.styleSpec;
      if (r.expression && e.J(e.u(o))) return ue(t);
      if (r.expression && e.v(e.x(o))) return de(t);
      if (r.type && Re[r.type]) {
        var _o152 = Re[r.type](t);
        return !0 === i && _o152.length > 0 && "array" === e.o(t.value) ? de(t) : _o152;
      }
      return ce(e.q({}, t, {
        valueSpec: r.type ? a[r.type] : r
      }));
    }
    function Ae(t) {
      var i = t.value,
        o = t.key,
        r = we(t);
      return r.length || (-1 === i.indexOf("{fontstack}") && r.push(new e.V(o, i, '"glyphs" url must include a "{fontstack}" token')), -1 === i.indexOf("{range}") && r.push(new e.V(o, i, '"glyphs" url must include a "{range}" token'))), r;
    }
    function Me(t) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e.N;
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return De({
        key: o.key || "",
        value: t,
        valueSpec: i.$root,
        styleSpec: i,
        style: t,
        objectElementValidators: {
          glyphs: Ae,
          "*": function _() {
            return [];
          }
        }
      });
    }
    function ze(t) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e.N;
      return Ze(Me(t, i));
    }
    var Oe = function Oe(e) {
        return Ze(Ee(e));
      },
      Fe = function Fe(e) {
        return Ze(Se(e));
      },
      Be = function Be(e) {
        return Ze(Ie(e));
      },
      ke = function ke(e) {
        return Ze(Le(e));
      },
      Ne = function Ne(e) {
        return Ze(Pe(e));
      },
      Ue = function Ue(e) {
        return Ze(be(e));
      },
      Ge = function Ge(e) {
        return Ze(me(e));
      },
      je = function je(e) {
        return Ze(xe(e));
      },
      Ve = function Ve(e) {
        return Ze(ye(e));
      },
      $e = function $e(t) {
        return Ze(e.L(t));
      };
    function Ze(e) {
      return e.slice().sort(function (e, t) {
        return e.line && t.line ? e.line - t.line : 0;
      });
    }
    function We(t, i) {
      var o = !1;
      if (i && i.length) {
        var _iterator321 = _createForOfIteratorHelper(i),
          _step321;
        try {
          for (_iterator321.s(); !(_step321 = _iterator321.n()).done;) {
            var _r349 = _step321.value;
            _r349 instanceof e.n ? e.w(_r349.message) : (t.fire(new e.f(new Error(_r349.message))), o = !0);
          }
        } catch (err) {
          _iterator321.e(err);
        } finally {
          _iterator321.f();
        }
      }
      return o;
    }
    var He;
    var qe = /*#__PURE__*/function (_e$E4) {
      _inherits(qe, _e$E4);
      var _super137 = _createSuper(qe);
      function qe(t) {
        var _this94;
        var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "flat";
        _classCallCheck(this, qe);
        _this94 = _super137.call(this), _this94._transitionable = new e.O(He || (He = new e.U({
          anchor: new e.W(e.N.light.anchor),
          position: new e.X(e.N.light.position),
          color: new e.W(e.N.light.color),
          intensity: new e.W(e.N.light.intensity)
        }))), _this94.setLight(t, i), _this94._transitioning = _this94._transitionable.untransitioned();
        return _this94;
      }
      _createClass(qe, [{
        key: "getLight",
        value: function getLight() {
          return this._transitionable.serialize();
        }
      }, {
        key: "setLight",
        value: function setLight(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          this._validate(Fe, e, i) || (this._transitionable.setTransitionOrValue(e), this.id = t);
        }
      }, {
        key: "updateTransitions",
        value: function updateTransitions(e) {
          this._transitioning = this._transitionable.transitioned(e, this._transitioning);
        }
      }, {
        key: "hasTransition",
        value: function hasTransition() {
          return this._transitioning.hasTransition();
        }
      }, {
        key: "recalculate",
        value: function recalculate(e) {
          this.properties = this._transitioning.possiblyEvaluate(e);
        }
      }, {
        key: "_validate",
        value: function _validate(t, i, o) {
          return (!o || !1 !== o.validate) && We(this, t.call(ze, e.Q({
            value: i,
            style: {
              glyphs: !0,
              sprite: !0
            },
            styleSpec: e.N
          })));
        }
      }]);
      return qe;
    }(e.E);
    var Xe = new e.U({
      source: new e.W(e.N.terrain.source),
      exaggeration: new e.W(e.N.terrain.exaggeration)
    });
    var Qe = /*#__PURE__*/function (_e$E5) {
      _inherits(Qe, _e$E5);
      var _super138 = _createSuper(Qe);
      function Qe(t, i, o, r) {
        var _this95;
        _classCallCheck(this, Qe);
        _this95 = _super138.call(this), _this95.scope = o, _this95._transitionable = new e.O(Xe, o, r), _this95._transitionable.setTransitionOrValue(t, r), _this95._transitioning = _this95._transitionable.untransitioned(), _this95.drapeRenderMode = i;
        return _this95;
      }
      _createClass(Qe, [{
        key: "get",
        value: function get() {
          return this._transitionable.serialize();
        }
      }, {
        key: "set",
        value: function set(e, t) {
          this._transitionable.setTransitionOrValue(e, t);
        }
      }, {
        key: "updateTransitions",
        value: function updateTransitions(e) {
          this._transitioning = this._transitionable.transitioned(e, this._transitioning);
        }
      }, {
        key: "hasTransition",
        value: function hasTransition() {
          return this._transitioning.hasTransition();
        }
      }, {
        key: "recalculate",
        value: function recalculate(e) {
          this.properties = this._transitioning.possiblyEvaluate(e);
        }
      }, {
        key: "getExaggeration",
        value: function getExaggeration(t) {
          return this._transitioning.possiblyEvaluate(new e.Y(t)).get("exaggeration");
        }
      }, {
        key: "isZoomDependent",
        value: function isZoomDependent() {
          var t = this._transitionable._values.exaggeration;
          return null != t && null != t.value && null != t.value.expression && t.value.expression instanceof e.Z;
        }
      }]);
      return Qe;
    }(e.E);
    var Ye = 45,
      Je = 65,
      Ke = .05;
    function et(t, i, o, r) {
      var a = e.a0(Ye, Je, o),
        _tt = tt(t, r),
        _tt2 = _slicedToArray(_tt, 2),
        n = _tt2[0],
        s = _tt2[1];
      var l = 1 - Math.min(1, Math.exp((i - n) / (s - n) * -6));
      return l *= l * l, l = Math.min(1, 1.00747 * l), l * a * t.alpha;
    }
    function tt(e, t) {
      var i = .5 / Math.tan(.5 * t);
      return [e.range[0] + i, e.range[1] + i];
    }
    function it(t, i, o, r, a) {
      var n = e.$.transformMat4([], [i, o, r], a.mercatorFogMatrix);
      return et(t, e.$.length(n), a.pitch, a._fov);
    }
    function ot(t, i, o, r, a, n, s) {
      var l = [[o, r, 0], [a, r, 0], [a, n, 0], [o, n, 0]];
      var c = Number.MAX_VALUE,
        h = -Number.MAX_VALUE;
      for (var _i269 = 0, _l99 = l; _i269 < _l99.length; _i269++) {
        var _t470 = _l99[_i269];
        var _o153 = e.$.transformMat4([], _t470, i),
          _r350 = e.$.length(_o153);
        c = Math.min(c, _r350), h = Math.max(h, _r350);
      }
      return [et(t, c, s.pitch, s._fov), et(t, h, s.pitch, s._fov)];
    }
    var rt = new e.U({
      range: new e.W(e.N.fog.range),
      color: new e.W(e.N.fog.color),
      "high-color": new e.W(e.N.fog["high-color"]),
      "space-color": new e.W(e.N.fog["space-color"]),
      "horizon-blend": new e.W(e.N.fog["horizon-blend"]),
      "star-intensity": new e.W(e.N.fog["star-intensity"]),
      "vertical-range": new e.W(e.N.fog["vertical-range"])
    });
    var at = /*#__PURE__*/function (_e$E6) {
      _inherits(at, _e$E6);
      var _super139 = _createSuper(at);
      function at(t, i, o, r) {
        var _this96;
        _classCallCheck(this, at);
        _this96 = _super139.call(this), _this96._transitionable = new e.O(rt, o, new Map(r)), _this96.set(t, r), _this96._transitioning = _this96._transitionable.untransitioned(), _this96._transform = i, _this96.properties = new e.a1(rt), _this96.scope = o;
        return _this96;
      }
      _createClass(at, [{
        key: "state",
        get: function get() {
          var t = this._transform,
            i = "globe" === t.projection.name,
            o = e.a2(t.zoom),
            r = this.properties.get("range"),
            a = [.5, 3];
          return {
            range: i ? [e.a3(a[0], r[0], o), e.a3(a[1], r[1], o)] : r,
            horizonBlend: this.properties.get("horizon-blend"),
            alpha: this.properties.get("color").a
          };
        }
      }, {
        key: "get",
        value: function get() {
          return this._transitionable.serialize();
        }
      }, {
        key: "set",
        value: function set(t, i) {
          var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (this._validate(Ne, t, o)) return;
          var r = e.Q({}, t);
          for (var _i270 = 0, _Object$keys15 = Object.keys(e.N.fog); _i270 < _Object$keys15.length; _i270++) {
            var _t471 = _Object$keys15[_i270];
            void 0 === r[_t471] && (r[_t471] = e.N.fog[_t471].default);
          }
          this._options = r, this._transitionable.setTransitionOrValue(this._options, i);
        }
      }, {
        key: "getOpacity",
        value: function getOpacity(t) {
          if (!this._transform.projection.supportsFog) return 0;
          var i = this.properties && this.properties.get("color") || 1;
          return ("globe" === this._transform.projection.name ? 1 : e.a0(Ye, Je, t)) * i.a;
        }
      }, {
        key: "getOpacityAtLatLng",
        value: function getOpacityAtLatLng(t, i) {
          return this._transform.projection.supportsFog ? function (t, i, o) {
            var r = e._.fromLngLat(i),
              a = o.elevation ? o.elevation.getAtPointOrZero(r) : 0;
            return it(t, r.x, r.y, a, o);
          }(this.state, t, i) : 0;
        }
      }, {
        key: "getOpacityForTile",
        value: function getOpacityForTile(t) {
          if (!this._transform.projection.supportsFog) return [1, 1];
          var i = this._transform.calculateFogTileMatrix(t.toUnwrapped());
          return ot(this.state, i, 0, 0, e.a4, e.a4, this._transform);
        }
      }, {
        key: "getOpacityForBounds",
        value: function getOpacityForBounds(e, t, i, o, r) {
          return this._transform.projection.supportsFog ? ot(this.state, e, t, i, o, r, this._transform) : [1, 1];
        }
      }, {
        key: "getFovAdjustedRange",
        value: function getFovAdjustedRange(e) {
          return this._transform.projection.supportsFog ? tt(this.state, e) : [0, 1];
        }
      }, {
        key: "isVisibleOnFrustum",
        value: function isVisibleOnFrustum(t) {
          if (!this._transform.projection.supportsFog) return !1;
          var i = [4, 5, 6, 7];
          for (var _i272 = 0, _i271 = i; _i272 < _i271.length; _i272++) {
            var _o154 = _i271[_i272];
            var _i273 = t.points[_o154];
            var _r351 = void 0;
            if (_i273[2] >= 0) _r351 = _i273;else {
              var _a168 = t.points[_o154 - 4];
              _r351 = e.a5(_a168, _i273, _a168[2] / (_a168[2] - _i273[2]));
            }
            if (it(this.state, _r351[0], _r351[1], 0, this._transform) >= Ke) return !0;
          }
          return !1;
        }
      }, {
        key: "updateConfig",
        value: function updateConfig(e) {
          this._transitionable.setTransitionOrValue(this._options, new Map(e));
        }
      }, {
        key: "updateTransitions",
        value: function updateTransitions(e) {
          this._transitioning = this._transitionable.transitioned(e, this._transitioning);
        }
      }, {
        key: "hasTransition",
        value: function hasTransition() {
          return this._transitioning.hasTransition();
        }
      }, {
        key: "recalculate",
        value: function recalculate(e) {
          this.properties = this._transitioning.possiblyEvaluate(e);
        }
      }, {
        key: "_validate",
        value: function _validate(t, i, o) {
          return (!o || !1 !== o.validate) && We(this, t.call(ze, e.Q({
            value: i,
            style: {
              glyphs: !0,
              sprite: !0
            },
            styleSpec: e.N
          })));
        }
      }]);
      return at;
    }(e.E);
    var nt = /*#__PURE__*/function (_e$E7) {
      _inherits(nt, _e$E7);
      var _super140 = _createSuper(nt);
      function nt(t, i, o, r) {
        var _this97;
        _classCallCheck(this, nt);
        _this97 = _super140.call(this), _this97.scope = o, _this97._options = t, _this97.properties = new e.a1(i), _this97._transitionable = new e.O(i, o, new Map(r)), _this97._transitionable.setTransitionOrValue(t.properties), _this97._transitioning = _this97._transitionable.untransitioned();
        return _this97;
      }
      _createClass(nt, [{
        key: "updateConfig",
        value: function updateConfig(e) {
          this._transitionable.setTransitionOrValue(this._options.properties, new Map(e));
        }
      }, {
        key: "updateTransitions",
        value: function updateTransitions(e) {
          this._transitioning = this._transitionable.transitioned(e, this._transitioning);
        }
      }, {
        key: "hasTransition",
        value: function hasTransition() {
          return this._transitioning.hasTransition();
        }
      }, {
        key: "recalculate",
        value: function recalculate(e) {
          this.properties = this._transitioning.possiblyEvaluate(e);
        }
      }, {
        key: "get",
        value: function get() {
          return this._options.properties = this._transitionable.serialize(), this._options;
        }
      }, {
        key: "set",
        value: function set(e, t) {
          this._options = e, this._transitionable.setTransitionOrValue(e.properties, t);
        }
      }, {
        key: "shadowsEnabled",
        value: function shadowsEnabled() {
          return !!this.properties && !0 === this.properties.get("cast-shadows");
        }
      }]);
      return nt;
    }(e.E);
    var st, lt;
    var ct = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif",
      ht = "\nout vec4 glFragColor;highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}\n#ifdef INDICATOR_CUTOUT\nuniform vec2 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;\n#endif\nvec4 applyCutout(vec4 color) {\n#ifdef INDICATOR_CUTOUT\nfloat holeMinOpacity=u_indicator_cutout_params.x;float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);\n#else\nreturn color;\n#endif\n}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif\nvec4 textureLodCustom(sampler2D image,vec2 pos,vec2 lod_coord) {vec2 size=vec2(textureSize(image,0));vec2 dx=dFdx(lod_coord.xy*size);vec2 dy=dFdy(lod_coord.xy*size);float delta_max_sqr=max(dot(dx,dx),dot(dy,dy));float lod=0.5*log2(delta_max_sqr);return textureLod(image,pos,lod);}vec4 applyLUT(highp sampler3D lut,vec4 col) {vec3 size=vec3(textureSize(lut,0));vec3 uvw=(col.rbg*float(size-1.0)+0.5)/size;return vec4(texture(lut,uvw).rgb,col.a);}vec3 applyLUT(highp sampler3D lut,vec3 col) {return applyLUT(lut,vec4(col,1.0)).rgb;}",
      _t = "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)\n{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}",
      ut = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}",
      dt = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nvec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }\n#endif\n#ifdef DEPTH_OCCLUSION\nuniform highp sampler2D u_depth;uniform highp vec2 u_depth_size_inv;uniform highp vec2 u_depth_range_unpack;uniform highp float u_occluder_half_size;uniform highp float u_occlusion_depth_offset;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}vec4 unpack_depth4(vec4 depth) {return depth*u_depth_range_unpack.x+vec4(u_depth_range_unpack.y);}\n#else\nhighp float unpack_depth_rgba(vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;\n#ifdef DEPTH_D24\nfloat depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5).r);\n#else\nfloat depth=unpack_depth_rgba(texture(u_depth,(coord.xy+1.0)*0.5));\n#endif\nreturn coord.z+u_occlusion_depth_offset > depth;}highp vec4 getCornerDepths(vec2 coord) {highp vec3 df=vec3(u_occluder_half_size*u_depth_size_inv,0.0);highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef DEPTH_D24\nhighp vec4 depth=vec4(\ntexture(u_depth,uv-df.xz).r,texture(u_depth,uv+df.xz).r,texture(u_depth,uv-df.zy).r,texture(u_depth,uv+df.zy).r\n);depth=unpack_depth4(depth);\n#else\nhighp vec4 depth=vec4(\nunpack_depth_rgba(texture(u_depth,uv-df.xz)),unpack_depth_rgba(texture(u_depth,uv+df.xz)),unpack_depth_rgba(texture(u_depth,uv-df.zy)),unpack_depth_rgba(texture(u_depth,uv+df.zy))\n);\n#endif\nreturn depth;}highp float occlusionFadeMultiSample(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec2 uv=0.5*coord.xy+0.5;int NX=3;int NY=4;highp vec2 df=u_occluder_half_size*u_depth_size_inv;highp vec2 oneStep=2.0*u_occluder_half_size*u_depth_size_inv/vec2(NX-1,NY-1);highp float res=0.0;for (int y=0; y < NY;++y) {for (int x=0; x < NX;++x) {\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)));\n#endif\nres+=1.0-clamp(300.0*(coord.z+u_occlusion_depth_offset-depth),0.0,1.0);}}res=clamp(2.0*res/float(NX*NY)-0.5,0.0,1.0);return res;}highp float occlusionFade(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec4 depth=getCornerDepths(coord.xy);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z+u_occlusion_depth_offset)-depth),0.0,1.0));}\n#else\nbool isOccluded(vec4 frag) { return false; }highp float occlusionFade(vec4 frag) { return 1.0; }highp float occlusionFadeMultiSample(vec4 frag) { return 1.0; }\n#endif//DEPTH_OCCLUSION",
      pt = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif",
      ft = "highp vec3 hash(highp vec2 p) {highp vec3 p3=fract(p.xyx*vec3(443.8975,397.2973,491.1871));p3+=dot(p3,p3.yxz+19.19);return fract((p3.xxy+p3.yzz)*p3.zyx);}vec3 dither(vec3 color,highp vec2 seed) {vec3 rnd=hash(seed)+hash(seed+0.59374)-0.5;return color+rnd/255.0;}\n#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {\n#ifdef FOG_DITHERING\nvec2 dither_seed=gl_FragCoord.xy+u_fog_temporal_offset;return dither(color,dither_seed);\n#else\nreturn color;\n#endif\n}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif",
      mt = "#ifdef RASTER_ARRAY\nuniform sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);ivec4 _raTexLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}vec2 _raTexLinearMix(highp vec2 fxy,highp vec4 colorMix,highp float colorOffset,highp vec4 t00,highp vec4 t10,highp vec4 t01,highp vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image0,c.yz,0),texelFetch(u_image0,c.xz,0),texelFetch(u_image0,c.yw,0),texelFetch(u_image0,c.xw,0)\n);}vec2 raTexture2D_image1_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image1,c.yz,0),texelFetch(u_image1,c.xz,0),texelFetch(u_image1,c.yw,0),texelFetch(u_image1,c.xw,0)\n);}vec2 raTexture2D_image0_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image0,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image1,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif",
      gt = "#ifdef RASTER_ARRAY\nuniform sampler2D u_velocity;uniform mediump vec2 u_velocity_res;uniform mediump float u_max_speed;const vec4 NO_DATA=vec4(1);const vec2 INVALID_VELOCITY=vec2(-1);uniform highp vec2 u_uv_offset;uniform highp float u_data_offset;uniform highp vec2 u_data_scale;ivec4 rasterArrayLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}highp vec2 lookup_velocity(highp vec2 uv) {uv=u_uv_offset.x+u_uv_offset.y*uv;highp vec2 fxy;ivec4 c=rasterArrayLinearCoord(uv,u_velocity_res,fxy);highp vec4 tl=texelFetch(u_velocity,c.yz,0);highp vec4 tr=texelFetch(u_velocity,c.xz,0);highp vec4 bl=texelFetch(u_velocity,c.yw,0);highp vec4 br=texelFetch(u_velocity,c.xw,0);if (tl==NO_DATA) {return INVALID_VELOCITY;}if (tr==NO_DATA) {return INVALID_VELOCITY;}if (bl==NO_DATA) {return INVALID_VELOCITY;}if (br==NO_DATA) {return INVALID_VELOCITY;}highp vec4 t=mix(mix(bl,br,fxy.x),mix(tl,tr,fxy.x),fxy.y);highp vec2 velocity=u_data_offset+vec2(dot(t.rg,u_data_scale),dot(t.ba,u_data_scale));velocity.y=-velocity.y;velocity/=max(u_max_speed,length(velocity));return velocity;}\n#endif\nuniform highp float u_particle_pos_scale;uniform highp vec2 u_particle_pos_offset;highp vec4 pack_pos_to_rgba(highp vec2 p) {highp vec2 v=(p+u_particle_pos_offset)/u_particle_pos_scale;highp vec4 r=vec4(v.x,fract(v.x*255.0),v.y,fract(v.y*255.0));return vec4(r.x-r.y/255.0,r.y,r.z-r.w/255.0,r.w);}highp vec2 unpack_pos_from_rgba(highp vec4 v) {v=floor(v*255.0+0.5)/255.0;highp vec2 p=vec2(v.x+(v.y/255.0),v.z+(v.w/255.0));return u_particle_pos_scale*p-u_particle_pos_offset;}",
      vt = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {vec3 transformed_normal=vec3(-normal.xy,normal.z);float NDotL=dot(normalize(transformed_normal),u_shadow_direction);float dotScale=min(1.0-NDotL,1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif//RENDER_SHADOWS",
      xt = "#ifdef RENDER_SHADOWS\n#ifdef DEPTH_TEXTURE\nuniform highp sampler2D u_shadowmap_0;uniform highp sampler2D u_shadowmap_1;\n#else\nuniform sampler2D u_shadowmap_0;uniform sampler2D u_shadowmap_1;\n#endif\nuniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;highp float shadow_sample_1(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_1,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_1,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}highp float shadow_sample_0(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_0,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_0,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}float shadow_occlusion_1(highp vec4 pos,highp float bias) {highp vec2 uv=pos.xy;return shadow_sample_1(uv,pos.z-bias);}float shadow_occlusion_0(highp vec4 pos,highp float bias) {highp float compare0=pos.z-bias;\n#ifdef NATIVE\nhighp vec2 uv=pos.xy;highp vec4 samples=textureGather(u_shadowmap_0,uv,0);lowp vec4 stepSamples=step(samples,vec4(compare0));\n#else\nhighp vec2 uv00=pos.xy-vec2(0.5*u_shadow_texel_size);highp vec2 uv10=uv00+vec2(u_shadow_texel_size,0.0);highp vec2 uv01=uv00+vec2(0.0,u_shadow_texel_size);highp vec2 uv11=uv01+vec2(u_shadow_texel_size,0.0);lowp vec4 stepSamples=vec4(\nshadow_sample_0(uv01,compare0),shadow_sample_0(uv11,compare0),shadow_sample_0(uv10,compare0),shadow_sample_0(uv00,compare0)\n);\n#endif\nvec2 f=fract(pos.xy*u_shadow_map_resolution-vec2(0.5));lowp vec2 lerpx=mix(stepSamples.wx,stepSamples.zy,f.xx);return mix(lerpx.x,lerpx.y,f.y);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {\n#ifdef SHADOWS_SINGLE_CASCADE\nlight_view_pos0.xyz=light_view_pos0.xyz/light_view_pos0.w*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);\n#else\nlight_view_pos0.xyz/=light_view_pos0.w;light_view_pos1.xyz/=light_view_pos1.w;vec4 uv=vec4(light_view_pos0.xy,light_view_pos1.xy);vec4 abs_bounds=abs(uv);if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {light_view_pos0.xyz=light_view_pos0.xyz*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}light_view_pos1.xyz=light_view_pos1.xyz*0.5+0.5;float occlusion1=shadow_occlusion_1(light_view_pos1,bias);return mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth));\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_opacity(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,float shadow_opacity) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias)*shadow_opacity;return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
    var yt = [];
    St(ct, yt), St(_t, yt), St(ht, yt);
    var bt = {
        "_prelude_fog.vertex.glsl": pt,
        "_prelude_terrain.vertex.glsl": dt,
        "_prelude_shadow.vertex.glsl": vt,
        "_prelude_fog.fragment.glsl": ft,
        "_prelude_shadow.fragment.glsl": xt,
        "_prelude_lighting.glsl": "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif//LIGHTING_3D_MODE",
        "_prelude_raster_array.glsl": mt,
        "_prelude_raster_particle.glsl": gt
      },
      wt = {};
    It("", dt), It(ft, pt), It(xt, vt), It(mt, ""), It(gt, "");
    var Tt = It(ht, _t),
      Et = ct;
    var Ct = {
      background: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec4 u_color;uniform float u_opacity;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;uniform float u_emissive_strength;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
      backgroundPattern: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in vec2 v_pos;void main() {vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=textureLodCustom(u_image,pos,v_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
      circle: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float blur_positive=blur < 0.0 ? 0.0 : 1.0;lowp float antialiasblur=v_data.z;float extrude_length=length(extrude)+antialiasblur*(1.0-blur_positive);float antialiased_blur=-max(abs(blur),antialiasblur);float opacity_t=smoothstep((1.0-blur_positive)*antialiased_blur,blur_positive*antialiased_blur,extrude_length-1.0)-smoothstep(0.0,antialiasblur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'),
      clippingMask: It("void main() {glFragColor=vec4(1.0);}", "in vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
      heatmap: It('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
      heatmapTexture: It("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"),
      collisionBox: It("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin vec3 a_pos;in vec2 a_anchor_pos;in vec2 a_extrude;in vec2 a_placed;in vec2 a_shift;in float a_size_scale;in vec2 a_padding;in float a_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;out float v_placed;out float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*(a_z_offset+elevation(a_anchor_pos)),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}'),
      collisionCircle: It("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
      debug: It("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}'),
      fill: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
      fillOutline: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;out highp vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
      fillOutlinePattern: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_emissive_strength;in highp vec2 v_pos;in highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;out highp vec2 v_pos;out highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);v_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
      fillPattern: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;in vec2 v_pos;uniform float u_emissive_strength;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
      fillExtrusion: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in vec4 v_flat;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\nuniform lowp float u_opacity;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nuniform float u_emissive_strength;in float v_height;void main() {\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor;\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\ncolor.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,u_emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;uniform float u_alignment;uniform float u_width_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec4 a_join_normal_inside_polygon;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nuniform highp float u_vertical_scale;out vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\n#pragma mapbox: define highp float line_width\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\n#pragma mapbox: initialize highp float line_width\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);float attr_height=height;height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;float c_ele=0.0;vec3 pos;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat cutoff=1.0;vec3 scaled_pos=pos;\n#ifdef RENDER_CUTOFF\nvec3 centroid_random=vec3(centroid_pos.xy,centroid_pos.x+centroid_pos.y+1.0);vec3 ground_pos=centroid_pos.x==0.0 ? pos.xyz : (centroid_random/8.0);vec4 ground=u_matrix*vec4(ground_pos.xy,ele,1.0);cutoff=cutoff_opacity(u_cutoff_params,ground.z);if (centroid_pos.y !=0.0 && centroid_pos.x !=0.0) {vec3 g=floor(ground_pos);vec3 mod_=centroid_random-g*8.0;float seed=min(1.0,0.1*(min(3.5,max(mod_.x+mod_.y,0.2*attr_height))*0.35+mod_.z));if (cutoff < 0.8-seed) {cutoff=0.0;}}float cutoff_scale=cutoff;v_cutoff_opacity=cutoff;scaled_pos.z=mix(c_ele,h,cutoff_scale);\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (cutoff==0.0 && centroid_pos.x !=0.0));\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside_polygon.xy/EXTENT);float isPolygon=a_join_normal_inside_polygon.w;float sideAlignment=abs(isPolygon*u_alignment);scaled_pos.xy+=(1.0-a_join_normal_inside_polygon.z)*mix(wall_offset*0.5,wall_offset*mix(1.0,0.0,max(u_alignment,0.0)),sideAlignment);scaled_pos.xy-=a_join_normal_inside_polygon.z*mix(wall_offset*0.5,wall_offset*mix(0.0,1.0,max(u_alignment,0.0)),sideAlignment);\n#endif\ngl_Position=mix(u_matrix*vec4(scaled_pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);v_flat=vec4(linearProduct(color.rgb,vec3(calculate_NdotL(normal))),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
      fillExtrusionDepth: It("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_alignment;uniform float u_width_scale;uniform float u_vertical_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec4 a_join_normal_inside_polygon;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp float line_width\nout highp float v_depth;void main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp float line_width\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;float ele=elevation(pos_nx.xy);float c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;float h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base);pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside_polygon.xy/EXTENT);float isPolygon=a_join_normal_inside_polygon.w;float sideAlignment=abs(isPolygon*u_alignment);pos.xy+=(1.0-a_join_normal_inside_polygon.z)*mix(wall_offset*0.5,wall_offset*mix(1.0,0.0,max(u_alignment,0.0)),sideAlignment);pos.xy-=a_join_normal_inside_polygon.z*mix(wall_offset*0.5,wall_offset*mix(0.0,1.0,max(u_alignment,0.0)),sideAlignment);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);v_depth=gl_Position.z/gl_Position.w;}'),
      fillExtrusionPattern: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\nin vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_alignment;uniform float u_width_scale;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec4 a_join_normal_inside_polygon;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nout vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\n#pragma mapbox: define highp float line_width\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\n#pragma mapbox: initialize highp float line_width\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside_polygon.xy/EXTENT);float isPolygon=a_join_normal_inside_polygon.w;float sideAlignment=abs(isPolygon*u_alignment);p.xy+=(1.0-a_join_normal_inside_polygon.z)*mix(wall_offset*0.5,wall_offset*mix(1.0,0.0,max(u_alignment,0.0)),sideAlignment);p.xy-=a_join_normal_inside_polygon.z*mix(wall_offset*0.5,wall_offset*mix(0.0,1.0,max(u_alignment,0.0)),sideAlignment);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif \n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'),
      groundShadow: It('#include "_prelude_shadow.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\n#ifdef INDICATOR_CUTOUT\nshadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0)).r);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in vec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);v_fog_opacity=fog(v_fog_pos);\n#endif\n}'),
      fillExtrusionGroundEffect: It("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;\n#endif\nHANDLE_WIREFRAME_DEBUG;\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp vec4 a_pos_end;in highp float a_angular_offset_factor;in highp float a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec2 p=a_pos_end.xy;vec2 q=floor(a_pos_end.zw*0.5);vec2 start_bottom=a_pos_end.zw-q*2.0;float fl_ground_radius=flood_light_ground_radius;fl_ground_radius=abs(flood_light_ground_radius);float direction=flood_light_ground_radius < 0.0 ?-1.0 : 1.0;float flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=a_angular_offset_factor/NORM*TANGENT_CUTOFF;float angular_offset=direction*angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(1.0,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=direction*perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=a_hidden_by_landmark;\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'),
      hillshadePrepare: It("precision highp float;uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
      hillshade: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
      line: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform lowp float u_device_pixel_ratio;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;in vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture(u_dash_image,v_tex).r;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;alpha*=linearstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trim_alpha=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);out_color=mix(out_color,u_trim_color,transition_factor);trim_alpha=out_color.a;}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef RENDER_LINE_BORDER\nfloat edgeBlur=(border_width+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2.t-edgeBlur),v_width2.s-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);if (border_color.a==0.0) {float Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}} else {out_color.rgb=mix(border_color.rgb*border_color.a*trim_alpha,out_color.rgb,smoothAlpha);}}\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*opacity);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED)\nin float a_z_offset;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nin highp vec4 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nin float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);\n#if defined(ELEVATED)\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 halfCellProgress=normal.yx*32.0;float ele0=elevation(pos);float ele_line=max(ele0,max(elevation(pos+halfCellProgress),elevation(pos-halfCellProgress)));float ele1=elevation(pos+offsetTile);float ele2=elevation(pos-offsetTile);float ele_max=max(ele_line,0.5*(ele1+ele2));float ele=ele_max-ele0+ele1+a_z_offset ;gl_Position=u_matrix*vec4(pos+offsetTile,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*0.1*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);\n#else\ngl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nfloat a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec4(a_uv_x,a_split_index*texel_height-half_texel_height,a_clip_start,a_clip_end);\n#else\nv_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/floorwidth,(-normal.y*height+dash.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
      linePattern: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform highp float u_device_pixel_ratio;uniform highp float u_alpha_discard_threshold;uniform highp vec2 u_texsize;uniform highp float u_tile_units_to_pixels;uniform highp vec2 u_trim_offset;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in highp float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec4 v_uv;\n#endif\n#ifdef LINE_JOIN_NONE\nin vec2 v_pattern_data;\n#endif\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;float pattern_size=display_size.x/u_tile_units_to_pixels;float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);highp float pattern_x=v_linesofar/pattern_size*aspect;float x=mod(pattern_x,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));vec2 lod_pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(pattern_x,y));vec4 color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {if (line_progress <=trim_end && line_progress >=trim_start) {color=vec4(0,0,0,0);}}\n#endif\n#ifdef LINE_JOIN_NONE\nfloat pattern_len=pattern_size/aspect;float segment_phase=pattern_len-mod(v_linesofar-v_pattern_data.x+pattern_len,pattern_len);float visible_start=segment_phase-step(pattern_len*0.5,segment_phase)*pattern_len;float visible_end=floor((v_pattern_data.y-segment_phase)/pattern_len)*pattern_len+segment_phase;visible_end+=step(pattern_len*0.5,v_pattern_data.y-visible_end)*pattern_len;if (v_pattern_data.x < visible_start || v_pattern_data.x >=visible_end) {color=vec4(0.0);}\n#endif\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_ground(color);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity);if (u_alpha_discard_threshold !=0.0) {if (color.a < u_alpha_discard_threshold) {discard;}}\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED)\nin float a_z_offset;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec4 a_packed;\n#endif\nin highp float a_linesofar;\n#ifdef LINE_JOIN_NONE\nin highp vec3 a_pattern_data;out vec2 v_pattern_data;\n#endif\nuniform mat4 u_matrix;uniform float u_tile_units_to_pixels;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out highp float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nout highp vec4 v_uv;\n#endif\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define mediump float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float floorwidth\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define mediump float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize mediump float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize mediump float pixel_ratio\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);vec2 dist=outset*a_extrude*scale;float u=0.5*a_direction;float t=1.0-abs(u);vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);\n#if defined(ELEVATED)\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 halfCellProgress=normal.yx*32.0;float ele0=elevation(pos);float ele_line=max(ele0,max(elevation(pos+halfCellProgress),elevation(pos-halfCellProgress)));float ele1=elevation(pos+offsetTile);float ele2=elevation(pos-offsetTile);float ele_max=max(ele_line,0.5*(ele1+ele2));float ele=ele_max-ele0+ele1+a_z_offset ;gl_Position=u_matrix*vec4(pos+offsetTile,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*0.1*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);\n#else\ngl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nfloat a_uv_x=a_packed[0];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];v_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;\n#ifdef LINE_JOIN_NONE\nv_width=floorwidth+ANTIALIASING;mediump float pixels_to_tile_units=1.0/u_tile_units_to_pixels;mediump float pixel_ratio_inverse=1.0/pixel_ratio;mediump float aspect=v_width/((pattern.w-pattern.y)*pixel_ratio_inverse);highp float subt_multiple=(pattern.z-pattern.x)*pixel_ratio_inverse*pixels_to_tile_units*aspect*32.0;highp float subt=floor(a_pattern_data.z/subt_multiple)*subt_multiple;float offset_sign=(fract(a_pattern_data.x)-0.5)*4.0;float line_progress_offset=offset_sign*v_width*0.5*pixels_to_tile_units;v_linesofar=(a_pattern_data.z-subt)+a_linesofar+line_progress_offset;v_pattern_data=vec2(a_pattern_data.x+line_progress_offset,a_pattern_data.y);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
      raster: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;uniform highp float u_zoom_transition;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nin float v_split_fade;\n#endif\nuniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;\n#ifdef GLOBE_POLES\ncolor.a*=1.0-smoothstep(0.0,0.05,u_zoom_transition);\n#endif\nvec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef PROJECTION_GLOBE_VIEW\nglFragColor*=mix(1.0,1.0-smoothstep(0.0,0.05,u_zoom_transition),smoothstep(0.8,0.9,v_split_fade));\n#endif\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;in vec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nout float v_split_fade;\n#endif\nvoid main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos   ,1.0);uv=a_uv;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\nfloat w=1.0+dot(a_texture_pos,u_perspective_transform);uv=a_texture_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);    \nv_split_fade=0.0;if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;float opposite_merc_center=mod(u_merc_center.x+0.5,1.0);float dist_from_poles=(abs(mercatorY-0.5)*2.0);float range=0.1;v_split_fade=abs(opposite_merc_center-mercatorX);v_split_fade=clamp(1.0-v_split_fade,0.0,1.0);v_split_fade=max(smoothstep(1.0-range,1.0,dist_from_poles),max(smoothstep(1.0-range,1.0,v_split_fade),smoothstep(1.0-range,1.0,1.0-v_split_fade)));}float tiles=u_grid_matrix[0][2];if (tiles > 0.0) {float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvY=mercatorY*tiles-idy;float uvX=mercatorX*tiles-idx;uv=vec2(uvX,uvY);}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\ngl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef RENDER_CUTOFF\nv_depth=gl_Position.z;\n#endif\n}'),
      rasterParticle: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;uniform sampler2D u_image0;uniform sampler2D u_image1;void main() {vec4 color0,color1,color;color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 out_color=color.rgb;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),0.0).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\nin vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {float w=1.0;vec2 uv;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvX=mercatorX*tiles-idx;float uvY=mercatorY*tiles-idy;uv=vec2(uvX,uvY);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nuv=a_texture_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}'),
      rasterParticleDraw: It("uniform sampler2D u_color_ramp;in float v_particle_speed;void main() {glFragColor=texture(u_color_ramp,vec2(v_particle_speed,0.5));}", '#include "_prelude_raster_particle.glsl"\nin float a_index;uniform sampler2D u_particle_texture;uniform float u_particle_texture_side_len;uniform vec2 u_tile_offset;out float v_particle_speed;void main() {ivec2 pixel_coord=ivec2(\nmod(a_index,u_particle_texture_side_len),a_index/u_particle_texture_side_len);vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);vec2 pos=unpack_pos_from_rgba(pixel)+u_tile_offset;vec2 tex_coord=fract(pos);vec2 velocity=lookup_velocity(tex_coord);if (velocity==INVALID_VELOCITY) {gl_Position=AWAY;v_particle_speed=0.0;} else {gl_Position=vec4(2.0*pos-1.0,0,1);v_particle_speed=length(velocity);}gl_PointSize=1.0;}'),
      rasterParticleTexture: It("uniform sampler2D u_texture;uniform float u_opacity;in vec2 v_tex_pos;void main() {vec4 color=texture(u_texture,v_tex_pos);glFragColor=vec4(floor(255.0*color*u_opacity)/255.0);}", "in vec2 a_pos;out vec2 v_tex_pos;void main() {vec2 uv=0.5*a_pos+vec2(0.5);v_tex_pos=uv;gl_Position=vec4(a_pos,0.0,1.0);}"),
      rasterParticleUpdate: It('#include "_prelude_raster_particle.glsl"\nuniform sampler2D u_particle_texture;uniform mediump float u_particle_texture_side_len;uniform mediump float u_speed_factor;uniform highp float u_reset_rate;uniform highp float u_rand_seed;in highp vec2 v_tex_coord;vec2 linearstep(vec2 edge0,vec2 edge1,vec2 x) {return  clamp((x-edge0)/(edge1-edge0),vec2(0),vec2(1));}const highp vec3 rand_constants=vec3(12.9898,78.233,4375.85453);highp float rand(const highp vec2 co) {highp float t=dot(rand_constants.xy,co);return fract(sin(t)*(rand_constants.z+t));}void main() {ivec2 pixel_coord=ivec2(v_tex_coord*u_particle_texture_side_len);highp vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);highp vec2 pos=unpack_pos_from_rgba(pixel);highp vec2 velocity=lookup_velocity(clamp(pos,0.0,1.0));highp vec2 dp=velocity==INVALID_VELOCITY ? vec2(0) : velocity*u_speed_factor;pos=pos+dp;highp vec2 seed=(pos+v_tex_coord)*u_rand_seed;highp vec2 random_pos=vec2(rand(seed+1.3),rand(seed+2.1));highp vec2 persist_rate=pow(\nlinearstep(vec2(-u_particle_pos_offset),vec2(0),pos)*linearstep(vec2(1.0+u_particle_pos_offset),vec2(1),pos),vec2(4)\n);highp vec2 per_frame_persist=pow(persist_rate,abs(dp)/u_particle_pos_offset);highp float drop_rate=1.0-per_frame_persist.x*per_frame_persist.y;drop_rate=any(greaterThanEqual(abs(pos-0.5),vec2(0.5+u_particle_pos_offset))) ? 1.0 : drop_rate;highp float drop=step(1.0-drop_rate-u_reset_rate,rand(seed));highp vec2 next_pos=mix(pos,random_pos,drop);glFragColor=pack_pos_to_rgba(next_pos);}', "in vec2 a_pos;out vec2 v_tex_coord;void main() {v_tex_coord=0.5*(a_pos+vec2(1.0));gl_Position=vec4(a_pos,0.0,1.0);}"),
      symbolIcon: It('#include "_prelude_lighting.glsl"\nuniform sampler2D u_texture;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\nin float v_fade_opacity;in vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\n#ifdef COLOR_ADJUSTMENT\nuniform mat4 u_color_adj_mat;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float emissive_strength\nlowp float alpha=opacity*v_fade_opacity;vec4 out_color;\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b);\n#else\nout_color=texture(u_texture,v_tex_a);\n#endif\n#ifdef COLOR_ADJUSTMENT\nout_color=u_color_adj_mat*out_color;\n#endif\nout_color*=alpha;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\n#ifdef Z_OFFSET\nin float a_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin vec2 a_texb;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform vec3 u_up_vector;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=a_globe_anchor+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetProjected_point=u_matrix*vec4(a_globe_anchor+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetProjected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetProjected_point.xy/offsetProjected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=globe_occlusion_fade;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float out_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change))*projection_transition_fade;float alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nv_tex_a=a_tex/u_texsize;\n#ifdef ICON_TRANSITION\nv_tex_b=a_texb/u_texsize;\n#endif\nv_fade_opacity=out_fade_opacity;\n#ifdef DEPTH_OCCLUSION\nfloat depthOcclusion=occlusionFadeMultiSample(projected_point);float depthOcclusionMultplier=mix(occlusion_opacity,1.0,depthOcclusion);v_fade_opacity*=depthOcclusionMultplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);v_fade_opacity*=occludedFadeMultiplier;\n#endif\n}'),
      symbolSDF: It('#include "_prelude_lighting.glsl"\n#define SDF_PX 8.0\nuniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_halo;in float v_draw_halo;in vec2 v_data0;in vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);vec4 out_color=color*(alpha*opacity*fade_opacity);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout float v_draw_halo;out vec2 v_data0;out vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=a_globe_anchor+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=globe_occlusion_fade;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float out_fade_opacity=interpolated_fade_opacity*projection_transition_fade;\n#ifdef DEPTH_OCCLUSION\nfloat depthOcclusion=occlusionFadeMultiSample(projected_point);float depthOcclusionMultplier=mix(occlusion_opacity,1.0,depthOcclusion);out_fade_opacity*=depthOcclusionMultplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nfloat gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,out_fade_opacity);}'),
      symbolTextAndIcon: It('#include "_prelude_lighting.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_halo;in float v_draw_halo;in vec4 v_data0;in vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);vec4 out_color=color*(alpha*opacity*fade_opacity);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\n#ifdef Z_OFFSET\nin float a_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout float v_draw_halo;out vec4 v_data0;out vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offset_projected_point=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projected_point.xy/projected_point.w;vec2 b=offset_projected_point.xy/offset_projected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*font_scale);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=globe_occlusion_fade;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nfloat out_fade_opacity=interpolated_fade_opacity*projection_transition_fade;\n#ifdef DEPTH_OCCLUSION\nfloat depthOcclusion=occlusionFadeMultiSample(projected_point);float depthOcclusionMultplier=mix(occlusion_opacity,1.0,depthOcclusion);out_fade_opacity*=depthOcclusionMultplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+ xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nfloat gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,out_fade_opacity,is_sdf);}'),
      terrainRaster: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;in vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nvec3 unlit_base=image_color.rgb*(1.0-image_color.a);vec3 emissive_base=image_color.rgb*image_color.a;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor.rgb=mix(color.rgb,image_color.rgb,image_color.a);color.a=1.0;\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in vec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);\n#endif\n}'),
      terrainDepth: It("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;out float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'),
      skybox: It('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color.rgb=dither(sky_color.rgb,gl_FragCoord.xy+u_temporal_offset);sky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', ut),
      skyboxGradient: It('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;color.rgb=dither(color.rgb,gl_FragCoord.xy+u_temporal_offset);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', ut),
      skyboxCapture: It("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),
      globeRaster: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;uniform float u_far_z_cutoff;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nvec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);vec3 dir=normalize(ray_dir);vec3 closest_point=dot(u_globe_pos,dir)*dir;float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nraster=apply_lighting_with_emission_ground(raster,raster.a);color=vec4(raster.rgb*antialias,antialias);\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor=apply_lighting_with_emission_ground(color,color.a);color.a=1.0;\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=1.0-step(u_far_z_cutoff,1.0/gl_FragCoord.w);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}'),
      globeAtmosphere: It('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\n#ifdef NATIVE\nglFragColor=vec4(1,1,1,1);\n#else\nglFragColor=vec4(0,0,0,1);\n#endif\nreturn;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;\n#ifndef NATIVE\nc=dither(c,gl_FragCoord.xy+u_temporal_offset);\n#endif\nglFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"),
      model: It('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_opacity;uniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;uniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nuniform vec4 u_occlusionTextureTransform;\n#endif\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_pbr\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nin highp float v_depth;uniform highp sampler2D u_depthTexture;uniform vec2 u_inv_depth_size;uniform vec2 u_depth_range_unpack;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return  depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}\n#else\nhighp float unpack_depth_rgba(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded() {vec2 coord=gl_FragCoord.xy*u_inv_depth_size;\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depthTexture,coord).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depthTexture,coord));\n#endif\nreturn v_depth > depth+0.0005;}\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\nif(texColor.w > 0.0) {texColor.rgb/=texColor.w;}texColor.w=1.0;\n#endif\nif(u_baseTextureIsAlpha) {if (texColor.r < 0.5) {discard;}} else {texColor.rgb=sRGBToLinear(texColor.rgb);albedo*=texColor;}\n#endif\nvec4 color=vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\nreturn color;}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;highp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_3f\nn=normalize(normal_3f);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));n=normalize(cross(fdx,fdy))*-1.0;\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_pbr\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f) \nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nif (isOccluded()) {discard;}\n#endif\nvec3 lightDir=u_lightpos;vec3 lightColor=u_lightcolor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 baseColor=getBaseColor().rgb;vec3 diffuse=getDiffuseShadedColor(baseColor,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(mix(diffuse,baseColor,u_emissive_strength),1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nvec2 uv=uv_2f.xy*u_occlusionTextureTransform.zw+u_occlusionTextureTransform.xy;\n#else\nvec2 uv=uv_2f;\n#endif\nao=(texture(u_occlusionTexture,uv).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nfloat emissiveFactorLength=max(length(u_emissiveFactor.rgb),0.001);emissive.rgb=sRGBToLinear(applyLUT(u_lutTexture,linearTosRGB(emissive.rgb/emissiveFactorLength).rbg))*emissiveFactorLength;\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_pbr\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);vec3 color_mix=v_color_mix.rgb;\n#ifdef APPLY_LUT_ON_GPU\ncolor_mix=applyLUT(u_lutTexture,color_mix);\n#endif\ncolor=mix(color,color_mix,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nfinalColor=applyCutout(finalColor);\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp vec4 pbr\n#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength\nuniform mat4 u_matrix;uniform mat4 u_node_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nout highp float v_depth;\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp vec4 pbr\n#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float hidden=float(pos_a.x > EXTENT);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=mix(u_matrix*pos,AWAY,hidden);pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_pbr\nvec4 albedo_c=decode_color(pbr.xy);vec2 e_r_m=unpack_float(pbr.z);vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(pbr.w)/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);\n#else\nnormal_3f=vec3(normal_matrix*vec4(normal_3f,0));\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shadow_pos=u_node_matrix*vec4(local_pos,1.0);\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normal_3f);shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*shadow_pos;v_pos_light_view_1=u_light_matrix_1*shadow_pos;v_depth_shadows=gl_Position.w;\n#endif\n}'),
      modelDepth: It("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float hidden=float(pos_a.x > EXTENT);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=mix(u_matrix*pos,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\nv_depth=gl_Position.z/gl_Position.w;}"),
      stars: It("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_fade_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_fade_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}"),
      occlusion: It("uniform vec4 u_color;void main() {glFragColor=u_color;}", '#include "_prelude_terrain.vertex.glsl"\nin highp vec2 a_offset_xy;uniform highp vec3 u_anchorPos;uniform mat4 u_matrix;uniform vec2 u_screenSizePx;uniform vec2 u_occluderSizePx;void main() {vec3 world_pos=u_anchorPos;\n#ifdef TERRAIN\nfloat e=elevation(world_pos.xy);world_pos.z+=e;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1.0);projected_point.xy+=projected_point.w*a_offset_xy*0.5*u_occluderSizePx/u_screenSizePx;gl_Position=projected_point;}')
    };
    function St(e, t) {
      var i = e.replace(/\s*\/\/[^\n]*\n/g, "\n").split("\n");
      var _iterator322 = _createForOfIteratorHelper(i),
        _step322;
      try {
        for (_iterator322.s(); !(_step322 = _iterator322.n()).done;) {
          var _e444 = _step322.value;
          if (_e444 = _e444.trim(), "#" === _e444[0] && _e444.includes("if") && !_e444.includes("endif")) {
            _e444 = _e444.replace("#", "").replace(/ifdef|ifndef|elif|if/g, "").replace(/!|defined|\(|\)|\|\||&&/g, "").replace(/\s+/g, " ").trim();
            var _i274 = _e444.split(" ");
            var _iterator323 = _createForOfIteratorHelper(_i274),
              _step323;
            try {
              for (_iterator323.s(); !(_step323 = _iterator323.n()).done;) {
                var _e445 = _step323.value;
                t.includes(_e445) || t.push(_e445);
              }
            } catch (err) {
              _iterator323.e(err);
            } finally {
              _iterator323.f();
            }
          }
        }
      } catch (err) {
        _iterator322.e(err);
      } finally {
        _iterator322.f();
      }
    }
    function It(e, t) {
      var i = /#include\s+"([^"]+)"/g,
        o = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g;
      var r = t.match(/(attribute(\S*)|(^\s*|;)in) (highp |mediump |lowp )?([\w]+) ([\w]+)/gm);
      r && (r = r.map(function (e) {
        var t = e.split(" ");
        return t[t.length - 1];
      }), r = _toConsumableArray(new Set(r)));
      var a = {},
        n = [],
        s = [];
      if (e = e.replace(i, function (e, t) {
        return s.push(t), "";
      }), (t = t.replace(i, function (e, t) {
        return n.push(t), "";
      })).includes("flat out")) return void console.error('The usage of "flat" qualifier is disallowed, see: https://bugs.webkit.org/show_bug.cgi?id=268071');
      var l = [].concat(yt);
      St(e, l), St(t, l);
      for (var _i275 = 0, _arr3 = [].concat(n, s); _i275 < _arr3.length; _i275++) {
        var _e446 = _arr3[_i275];
        bt[_e446] || console.error("Undefined include: ".concat(_e446)), wt[_e446] || (wt[_e446] = [], St(bt[_e446], wt[_e446])), l = [].concat(_toConsumableArray(l), _toConsumableArray(wt[_e446]));
      }
      return {
        fragmentSource: e = e.replace(o, function (e, t, i, o, r) {
          return a[r] = !0, "define" === t ? "\n#ifndef HAS_UNIFORM_u_".concat(r, "\nin ").concat(i, " ").concat(o, " ").concat(r, ";\n#else\nuniform ").concat(i, " ").concat(o, " u_").concat(r, ";\n#endif\n") : "initialize" === t ? "\n#ifdef HAS_UNIFORM_u_".concat(r, "\n    ").concat(i, " ").concat(o, " ").concat(r, " = u_").concat(r, ";\n#endif\n") : "define-attribute" === t ? "\n#ifdef HAS_ATTRIBUTE_a_".concat(r, "\n    in ").concat(i, " ").concat(o, " ").concat(r, ";\n#endif\n") : "initialize-attribute" === t ? "" : void 0;
        }),
        vertexSource: t = t.replace(o, function (e, t, i, o, r) {
          var n = "float" === o ? "vec2" : o,
            s = r.match(/color/) ? "color" : n;
          return "define-attribute-vertex-shader-only" === t ? "\n#ifdef HAS_ATTRIBUTE_a_".concat(r, "\nin ").concat(i, " ").concat(o, " a_").concat(r, ";\n#endif\n") : a[r] ? "define" === t ? "\n#ifndef HAS_UNIFORM_u_".concat(r, "\nuniform lowp float u_").concat(r, "_t;\nin ").concat(i, " ").concat(n, " a_").concat(r, ";\nout ").concat(i, " ").concat(o, " ").concat(r, ";\n#else\nuniform ").concat(i, " ").concat(o, " u_").concat(r, ";\n#endif\n") : "initialize" === t ? "vec4" === s ? "\n#ifndef HAS_UNIFORM_u_".concat(r, "\n    ").concat(r, " = a_").concat(r, ";\n#else\n    ").concat(i, " ").concat(o, " ").concat(r, " = u_").concat(r, ";\n#endif\n") : "\n#ifndef HAS_UNIFORM_u_".concat(r, "\n    ").concat(r, " = unpack_mix_").concat(s, "(a_").concat(r, ", u_").concat(r, "_t);\n#else\n    ").concat(i, " ").concat(o, " ").concat(r, " = u_").concat(r, ";\n#endif\n") : "define-attribute" === t ? "\n#ifdef HAS_ATTRIBUTE_a_".concat(r, "\n    in ").concat(i, " ").concat(o, " a_").concat(r, ";\n    out ").concat(i, " ").concat(o, " ").concat(r, ";\n#endif\n") : "initialize-attribute" === t ? "\n#ifdef HAS_ATTRIBUTE_a_".concat(r, "\n    ").concat(r, " = a_").concat(r, ";\n#endif\n") : void 0 : "define" === t ? "\n#ifndef HAS_UNIFORM_u_".concat(r, "\nuniform lowp float u_").concat(r, "_t;\nin ").concat(i, " ").concat(n, " a_").concat(r, ";\n#else\nuniform ").concat(i, " ").concat(o, " u_").concat(r, ";\n#endif\n") : "define-instanced" === t ? "mat4" === s ? "\n#ifdef INSTANCED_ARRAYS\nin vec4 a_".concat(r, "0;\nin vec4 a_").concat(r, "1;\nin vec4 a_").concat(r, "2;\nin vec4 a_").concat(r, "3;\n#else\nuniform ").concat(i, " ").concat(o, " u_").concat(r, ";\n#endif\n") : "\n#ifdef INSTANCED_ARRAYS\nin ".concat(i, " ").concat(n, " a_").concat(r, ";\n#else\nuniform ").concat(i, " ").concat(o, " u_").concat(r, ";\n#endif\n") : "initialize-attribute-custom" === t ? "\n#ifdef HAS_ATTRIBUTE_a_".concat(r, "\n    ").concat(i, " ").concat(o, " ").concat(r, " = a_").concat(r, ";\n#endif\n") : "vec4" === s ? "\n#ifndef HAS_UNIFORM_u_".concat(r, "\n    ").concat(i, " ").concat(o, " ").concat(r, " = a_").concat(r, ";\n#else\n    ").concat(i, " ").concat(o, " ").concat(r, " = u_").concat(r, ";\n#endif\n") : "\n#ifndef HAS_UNIFORM_u_".concat(r, "\n    ").concat(i, " ").concat(o, " ").concat(r, " = unpack_mix_").concat(s, "(a_").concat(r, ", u_").concat(r, "_t);\n#else\n    ").concat(i, " ").concat(o, " ").concat(r, " = u_").concat(r, ";\n#endif\n");
        }),
        staticAttributes: r,
        usedDefines: l,
        vertexIncludes: n,
        fragmentIncludes: s
      };
    }
    var Lt = /*#__PURE__*/function () {
      function Lt() {
        _classCallCheck(this, Lt);
        this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
      }
      _createClass(Lt, [{
        key: "bind",
        value: function bind(e, t, i, o, r, a, n, s) {
          this.context = e;
          var l = this.boundPaintVertexBuffers.length !== o.length;
          for (var _e447 = 0; !l && _e447 < o.length; _e447++) this.boundPaintVertexBuffers[_e447] !== o[_e447] && (l = !0);
          var c = this.boundDynamicVertexBuffers.length !== n.length;
          for (var _e448 = 0; !c && _e448 < n.length; _e448++) this.boundDynamicVertexBuffers[_e448] !== n[_e448] && (c = !0);
          if (!this.vao || this.boundProgram !== t || this.boundLayoutVertexBuffer !== i || l || c || this.boundIndexBuffer !== r || this.boundVertexOffset !== a) this.freshBind(t, i, o, r, a, n, s);else {
            e.bindVertexArrayOES.set(this.vao);
            var _iterator324 = _createForOfIteratorHelper(n),
              _step324;
            try {
              for (_iterator324.s(); !(_step324 = _iterator324.n()).done;) {
                var _i276 = _step324.value;
                _i276 && (_i276.bind(), s && _i276.instanceCount && _i276.setVertexAttribDivisor(e.gl, t, s));
              }
            } catch (err) {
              _iterator324.e(err);
            } finally {
              _iterator324.f();
            }
            r && r.dynamicDraw && r.bind();
          }
        }
      }, {
        key: "freshBind",
        value: function freshBind(e, t, i, o, r, a, n) {
          var s = e.numAttributes,
            l = this.context,
            c = l.gl;
          this.vao && this.destroy(), this.vao = l.gl.createVertexArray(), l.bindVertexArrayOES.set(this.vao), this.boundProgram = e, this.boundLayoutVertexBuffer = t, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = o, this.boundVertexOffset = r, this.boundDynamicVertexBuffers = a, t.enableAttributes(c, e), t.bind(), t.setVertexAttribPointers(c, e, r);
          var _iterator325 = _createForOfIteratorHelper(i),
            _step325;
          try {
            for (_iterator325.s(); !(_step325 = _iterator325.n()).done;) {
              var _t472 = _step325.value;
              _t472.enableAttributes(c, e), _t472.bind(), _t472.setVertexAttribPointers(c, e, r);
            }
          } catch (err) {
            _iterator325.e(err);
          } finally {
            _iterator325.f();
          }
          var _iterator326 = _createForOfIteratorHelper(a),
            _step326;
          try {
            for (_iterator326.s(); !(_step326 = _iterator326.n()).done;) {
              var _t473 = _step326.value;
              _t473 && (_t473.enableAttributes(c, e), _t473.bind(), _t473.setVertexAttribPointers(c, e, r), n && _t473.instanceCount && _t473.setVertexAttribDivisor(c, e, n));
            }
          } catch (err) {
            _iterator326.e(err);
          } finally {
            _iterator326.f();
          }
          o && o.bind(), l.currentNumAttributes = s;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
        }
      }]);
      return Lt;
    }();
    function Pt(t, i) {
      var o = Math.pow(2, i.canonical.z),
        r = i.canonical.y;
      return [new e._(0, r / o).toLngLat().lat, new e._(0, (r + 1) / o).toLngLat().lat];
    }
    function Rt(t, i, o, r, a, n, s) {
      var l = t.context,
        c = l.gl,
        h = o.hillshadeFBO;
      if (!h) return;
      t.prepareDrawTile();
      var _ = t.isTileAffectedByFog(i),
        u = t.getOrCreateProgram("hillshade", {
          overrideFog: _
        });
      l.activeTexture.set(c.TEXTURE0), c.bindTexture(c.TEXTURE_2D, h.colorAttachment.get());
      var d = function (t, i, o, r) {
        var a = o.paint.get("hillshade-shadow-color"),
          n = o.paint.get("hillshade-highlight-color"),
          s = o.paint.get("hillshade-accent-color"),
          l = o.paint.get("hillshade-emissive-strength");
        var c = e.ac(o.paint.get("hillshade-illumination-direction"));
        if ("viewport" === o.paint.get("hillshade-illumination-anchor")) c -= t.transform.angle;else if (t.style && t.style.enable3dLights() && t.style.directionalLight) {
          var _i277 = t.style.directionalLight.properties.get("direction"),
            _o155 = e.ad(_i277.x, _i277.y, _i277.z);
          c = e.ac(_o155[1]);
        }
        var h = !t.options.moving;
        return {
          u_matrix: r || t.transform.calculateProjMatrix(i.tileID.toUnwrapped(), h),
          u_image: 0,
          u_latrange: Pt(0, i.tileID),
          u_light: [o.paint.get("hillshade-exaggeration"), c],
          u_shadow: a.toRenderColor(o.lut),
          u_highlight: n.toRenderColor(o.lut),
          u_emissive_strength: l,
          u_accent: s.toRenderColor(o.lut)
        };
      }(t, o, r, t.terrain ? i.projMatrix : null);
      t.uploadCommonUniforms(l, u, i.toUnwrapped());
      var _t$getTileBoundsBuffe = t.getTileBoundsBuffers(o),
        p = _t$getTileBoundsBuffe.tileBoundsBuffer,
        f = _t$getTileBoundsBuffe.tileBoundsIndexBuffer,
        m = _t$getTileBoundsBuffe.tileBoundsSegments;
      u.draw(t, c.TRIANGLES, a, n, s, e.ag.disabled, d, r.id, p, f, m);
    }
    function Dt(t, i, o) {
      if (!i.needsDEMTextureUpload) return;
      var r = t.context,
        a = r.gl;
      r.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || t.getTileTexture(o.stride);
      var n = o.getPixels();
      i.demTexture ? i.demTexture.update(n, {
        premultiply: !1
      }) : i.demTexture = new e.T(r, n, a.R32F, {
        premultiply: !1
      }), i.needsDEMTextureUpload = !1;
    }
    function At(t, i, o) {
      var r = t.context,
        a = r.gl;
      if (!i.dem) return;
      var n = i.dem;
      if (r.activeTexture.set(a.TEXTURE1), Dt(t, i, n), !i.demTexture) return;
      i.demTexture.bind(a.NEAREST, a.CLAMP_TO_EDGE);
      var s = n.dim;
      r.activeTexture.set(a.TEXTURE0);
      var l = i.hillshadeFBO;
      if (!l) {
        var _t474 = new e.T(r, {
          width: s,
          height: s,
          data: null
        }, a.RGBA);
        _t474.bind(a.LINEAR, a.CLAMP_TO_EDGE), l = i.hillshadeFBO = r.createFramebuffer(s, s, !0, "renderbuffer"), l.colorAttachment.set(_t474.texture);
      }
      r.bindFramebuffer.set(l.framebuffer), r.viewport.set([0, 0, s, s]);
      var _t$getMercatorTileBou = t.getMercatorTileBoundsBuffers(),
        c = _t$getMercatorTileBou.tileBoundsBuffer,
        h = _t$getMercatorTileBou.tileBoundsIndexBuffer,
        _ = _t$getMercatorTileBou.tileBoundsSegments,
        u = [];
      t.linearFloatFilteringSupported() && u.push("TERRAIN_DEM_FLOAT_FORMAT"), t.getOrCreateProgram("hillshadePrepare", {
        defines: u
      }).draw(t, a.TRIANGLES, e.af.disabled, e.ah.disabled, e.a.unblended, e.ag.disabled, function (t, i) {
        var o = i.stride,
          r = e.ae.create();
        return e.ae.ortho(r, 0, e.a4, -e.a4, 0, 0, 1), e.ae.translate(r, r, [0, -e.a4, 0]), {
          u_matrix: r,
          u_image: 1,
          u_dimension: [o, o],
          u_zoom: t.overscaledZ
        };
      }(i.tileID, n), o.id, c, h, _), i.needsHillshadePrepare = !1;
    }
    function Mt(t, i, o, r, a) {
      var n = function n(o, r) {
          if (o) return a(o);
          if (r) {
            if (t.url && r.tiles && t.tiles && delete t.tiles, r.variants) {
              if (!Array.isArray(r.variants)) return a(new Error("variants must be an array"));
              var _iterator327 = _createForOfIteratorHelper(r.variants),
                _step327;
              try {
                for (_iterator327.s(); !(_step327 = _iterator327.n()).done;) {
                  var _t475 = _step327.value;
                  if (null == _t475 || "object" != typeof _t475 || _t475.constructor !== Object) return a(new Error("variant must be an object"));
                  if (!Array.isArray(_t475.capabilities)) return a(new Error("capabilities must be an array"));
                  if (1 === _t475.capabilities.length && "meshopt" === _t475.capabilities[0]) {
                    r = e.Q(r, _t475);
                    break;
                  }
                }
              } catch (err) {
                _iterator327.e(err);
              } finally {
                _iterator327.f();
              }
            }
            var _o156 = e.ai(e.Q(r, t), ["tilejson", "tiles", "minzoom", "maxzoom", "attribution", "mapbox_logo", "bounds", "scheme", "tileSize", "encoding"]);
            r.vector_layers && (_o156.vectorLayers = r.vector_layers, _o156.vectorLayerIds = _o156.vectorLayers.map(function (e) {
              return e.id;
            })), r.raster_layers && (_o156.rasterLayers = r.raster_layers, _o156.rasterLayerIds = _o156.rasterLayers.map(function (e) {
              return e.id;
            })), _o156.tiles = i.canonicalizeTileset(_o156, t.url), a(null, _o156);
          }
        },
        s = function (e, t, i) {
          if (!e) return null;
          if (!t && !i) return e;
          i = i || e.worldview_default;
          var o = Object.values(e.language || {});
          if (0 === o.length) return null;
          var r = Object.values(e.worldview || {});
          if (0 === r.length) return null;
          var a = o.every(function (e) {
              return e === t;
            }),
            n = r.every(function (e) {
              return e === i;
            });
          return a && n ? e : t in (e.language_options || {}) || i in (e.worldview_options || {}) ? null : e.language_options && e.worldview_options ? e : null;
        }(t.data, o, r);
      return s ? e.e.frame(function () {
        return n(null, s);
      }) : t.url ? e.h(i.transformRequest(i.normalizeSourceURL(t.url, null, o, r), e.R.Source), n) : e.e.frame(function () {
        var e = t.data,
          i = _objectWithoutProperties(t, _excluded2);
        n(null, i);
      });
    }
    var zt = /*#__PURE__*/function () {
      function zt(t, i, o) {
        _classCallCheck(this, zt);
        this.bounds = e.aj.convert(this.validateBounds(t)), this.minzoom = i || 0, this.maxzoom = o || 24;
      }
      _createClass(zt, [{
        key: "validateBounds",
        value: function validateBounds(e) {
          return Array.isArray(e) && 4 === e.length ? [Math.max(-180, e[0]), Math.max(-90, e[1]), Math.min(180, e[2]), Math.min(90, e[3])] : [-180, -90, 180, 90];
        }
      }, {
        key: "contains",
        value: function contains(t) {
          var i = Math.pow(2, t.z),
            o = Math.floor(e.ak(this.bounds.getWest()) * i),
            r = Math.floor(e.al(this.bounds.getNorth()) * i),
            a = Math.ceil(e.ak(this.bounds.getEast()) * i),
            n = Math.ceil(e.al(this.bounds.getSouth()) * i);
          return t.x >= o && t.x < a && t.y >= r && t.y < n;
        }
      }]);
      return zt;
    }();
    var Ot = /*#__PURE__*/function (_e$E8) {
      _inherits(Ot, _e$E8);
      var _super141 = _createSuper(Ot);
      function Ot(t, i, o, r) {
        var _this98;
        _classCallCheck(this, Ot);
        _this98 = _super141.call(this), _this98.id = t, _this98.dispatcher = o, _this98.setEventedParent(r), _this98.type = "raster", _this98.minzoom = 0, _this98.maxzoom = 22, _this98.roundZoom = !0, _this98.scheme = "xyz", _this98.tileSize = 512, _this98._loaded = !1, _this98._options = e.Q({
          type: "raster"
        }, i), e.Q(_assertThisInitialized(_this98), e.ai(i, ["url", "scheme", "tileSize"]));
        return _this98;
      }
      _createClass(Ot, [{
        key: "load",
        value: function load(t) {
          var _this99 = this;
          this._loaded = !1, this.fire(new e.g("dataloading", {
            dataType: "source"
          })), this._tileJSONRequest = Mt(this._options, this.map._requestManager, null, null, function (i, o) {
            _this99._tileJSONRequest = null, _this99._loaded = !0, i ? _this99.fire(new e.f(i)) : o && (e.Q(_this99, o), o.bounds && (_this99.tileBounds = new zt(o.bounds, _this99.minzoom, _this99.maxzoom)), e.ao(o.tiles), _this99.fire(new e.g("data", {
              dataType: "source",
              sourceDataType: "metadata"
            })), _this99.fire(new e.g("data", {
              dataType: "source",
              sourceDataType: "content"
            }))), t && t(i);
          });
        }
      }, {
        key: "loaded",
        value: function loaded() {
          return this._loaded;
        }
      }, {
        key: "onAdd",
        value: function onAdd(e) {
          this.map = e, this.load();
        }
      }, {
        key: "reload",
        value: function reload() {
          var _this100 = this;
          this.cancelTileJSONRequest();
          var t = e.am(this.id, this.scope);
          this.load(function () {
            return _this100.map.style.clearSource(t);
          });
        }
      }, {
        key: "setTiles",
        value: function setTiles(e) {
          return this._options.tiles = e, this.reload(), this;
        }
      }, {
        key: "setUrl",
        value: function setUrl(e) {
          return this.url = e, this._options.url = e, this.reload(), this;
        }
      }, {
        key: "onRemove",
        value: function onRemove(e) {
          this.cancelTileJSONRequest();
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return e.Q({}, this._options);
        }
      }, {
        key: "hasTile",
        value: function hasTile(e) {
          return !this.tileBounds || this.tileBounds.contains(e.canonical);
        }
      }, {
        key: "loadTile",
        value: function loadTile(t, i) {
          var _this101 = this;
          var o = e.e.devicePixelRatio >= 2,
            r = this.map._requestManager.normalizeTileURL(t.tileID.canonical.url(this.tiles, this.scheme), o, this.tileSize);
          t.request = e.i(this.map._requestManager.transformRequest(r, e.R.Tile), function (o, r, a, n) {
            return delete t.request, t.aborted ? (t.state = "unloaded", i(null)) : o ? (t.state = "errored", i(o)) : r ? (_this101.map._refreshExpiredTiles && t.setExpiryData({
              cacheControl: a,
              expires: n
            }), t.setTexture(r, _this101.map.painter), t.state = "loaded", e.an(_this101.dispatcher), void i(null)) : i(null);
          });
        }
      }, {
        key: "abortTile",
        value: function abortTile(e, t) {
          e.request && (e.request.cancel(), delete e.request), t && t();
        }
      }, {
        key: "unloadTile",
        value: function unloadTile(t, i) {
          t.texture && t.texture instanceof e.T ? (t.destroy(!0), t.texture && t.texture instanceof e.T && this.map.painter.saveTileTexture(t.texture)) : t.destroy(), i && i();
        }
      }, {
        key: "hasTransition",
        value: function hasTransition() {
          return !1;
        }
      }, {
        key: "cancelTileJSONRequest",
        value: function cancelTileJSONRequest() {
          this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
        }
      }]);
      return Ot;
    }(e.E);
    var Ft = /*#__PURE__*/function (_e$E9) {
      _inherits(Ft, _e$E9);
      var _super142 = _createSuper(Ft);
      function Ft(t, i, o, r) {
        var _this102;
        _classCallCheck(this, Ft);
        if (_this102 = _super142.call(this), _this102.id = t, _this102.dispatcher = o, _this102.type = "vector", _this102.minzoom = 0, _this102.maxzoom = 22, _this102.scheme = "xyz", _this102.tileSize = 512, _this102.reparseOverscaled = !0, _this102.isTileClipped = !0, _this102._loaded = !1, e.Q(_assertThisInitialized(_this102), e.ai(i, ["url", "scheme", "tileSize", "promoteId"])), _this102._options = e.Q({
          type: "vector"
        }, i), _this102._collectResourceTiming = !!i.collectResourceTiming, 512 !== _this102.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
        _this102.setEventedParent(r), _this102._tileWorkers = {}, _this102._deduped = new e.ap();
        return _possibleConstructorReturn(_this102);
      }
      _createClass(Ft, [{
        key: "load",
        value: function load(t) {
          var _this103 = this;
          this._loaded = !1, this.fire(new e.g("dataloading", {
            dataType: "source"
          }));
          var i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language,
            o = this.map._worldview;
          this._tileJSONRequest = Mt(this._options, this.map._requestManager, i, o, function (r, a) {
            _this103._tileJSONRequest = null, _this103._loaded = !0, r ? (i && console.warn("Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ".concat(i)), o && 2 !== o.length && console.warn("Requested worldview strings must be a valid ISO alpha-2 code. Found: ".concat(o)), _this103.fire(new e.f(r))) : a && (e.Q(_this103, a), a.bounds && (_this103.tileBounds = new zt(a.bounds, _this103.minzoom, _this103.maxzoom)), e.ao(a.tiles, _this103.map._requestManager._customAccessToken), _this103.fire(new e.g("data", {
              dataType: "source",
              sourceDataType: "metadata"
            })), _this103.fire(new e.g("data", {
              dataType: "source",
              sourceDataType: "content"
            }))), t && t(r);
          });
        }
      }, {
        key: "loaded",
        value: function loaded() {
          return this._loaded;
        }
      }, {
        key: "hasTile",
        value: function hasTile(e) {
          return !this.tileBounds || this.tileBounds.contains(e.canonical);
        }
      }, {
        key: "onAdd",
        value: function onAdd(e) {
          this.map = e, this.load();
        }
      }, {
        key: "reload",
        value: function reload() {
          var _this104 = this;
          this.cancelTileJSONRequest();
          var t = e.am(this.id, this.scope);
          this.load(function () {
            return _this104.map.style.clearSource(t);
          });
        }
      }, {
        key: "setTiles",
        value: function setTiles(e) {
          return this._options.tiles = e, this.reload(), this;
        }
      }, {
        key: "setUrl",
        value: function setUrl(e) {
          return this.url = e, this._options.url = e, this.reload(), this;
        }
      }, {
        key: "onRemove",
        value: function onRemove(e) {
          this.cancelTileJSONRequest();
        }
      }, {
        key: "serialize",
        value: function serialize() {
          return e.Q({}, this._options);
        }
      }, {
        key: "loadTile",
        value: function loadTile(t, i) {
          var _this105 = this;
          var o = this.map._requestManager.normalizeTileURL(t.tileID.canonical.url(this.tiles, this.scheme)),
            r = this.map._requestManager.transformRequest(o, e.R.Tile),
            a = this.map.style ? this.map.style.getLut(this.scope) : null,
            n = {
              request: r,
              data: void 0,
              uid: t.uid,
              tileID: t.tileID,
              tileZoom: t.tileZoom,
              zoom: t.tileID.overscaledZ,
              lut: a ? {
                image: a.image.clone()
              } : null,
              tileSize: this.tileSize * t.tileID.overscaleFactor(),
              type: this.type,
              source: this.id,
              scope: this.scope,
              pixelRatio: e.e.devicePixelRatio,
              showCollisionBoxes: this.map.showCollisionBoxes,
              promoteId: this.promoteId,
              isSymbolTile: t.isSymbolTile,
              brightness: this.map.style && this.map.style.getBrightness() || 0,
              extraShadowCaster: t.isExtraShadowCaster,
              tessellationStep: this.map._tessellationStep
            };
          if (n.request.collectResourceTiming = this._collectResourceTiming, t.actor && "expired" !== t.state) "loading" === t.state ? t.reloadCallback = i : t.request = t.actor.send("reloadTile", n, s.bind(this));else if (t.actor = this._tileWorkers[o] = this._tileWorkers[o] || this.dispatcher.getActor(), this.dispatcher.ready) t.request = t.actor.send("loadTile", n, s.bind(this), void 0, !0);else {
            var _i278 = e.aq.call({
              deduped: this._deduped
            }, n, function (e, i) {
              e || !i ? s.call(_this105, e) : (n.data = {
                cacheControl: i.cacheControl,
                expires: i.expires,
                rawData: i.rawData.slice(0)
              }, t.actor && t.actor.send("loadTile", n, s.bind(_this105), void 0, !0));
            }, !0);
            t.request = {
              cancel: _i278
            };
          }
          function s(o, r) {
            return delete t.request, t.aborted ? i(null) : o && 404 !== o.status ? i(o) : (r && r.resourceTiming && (t.resourceTiming = r.resourceTiming), this.map._refreshExpiredTiles && r && t.setExpiryData(r), t.loadVectorData(r, this.map.painter), e.an(this.dispatcher), i(null), void (t.reloadCallback && (this.loadTile(t, t.reloadCallback), t.reloadCallback = null)));
          }
        }
      }, {
        key: "abortTile",
        value: function abortTile(e) {
          e.request && (e.request.cancel(), delete e.request), e.actor && e.actor.send("abortTile", {
            uid: e.uid,
            type: this.type,
            source: this.id,
            scope: this.scope
          });
        }
      }, {
        key: "unloadTile",
        value: function unloadTile(e, t) {
          e.actor && e.actor.send("removeTile", {
            uid: e.uid,
            type: this.type,
            source: this.id,
            scope: this.scope
          }), e.destroy();
        }
      }, {
        key: "hasTransition",
        value: function hasTransition() {
          return !1;
        }
      }, {
        key: "afterUpdate",
        value: function afterUpdate() {
          this._tileWorkers = {};
        }
      }, {
        key: "cancelTileJSONRequest",
        value: function cancelTileJSONRequest() {
          this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
        }
      }]);
      return Ft;
    }(e.E);
    var Bt = function Bt(e, t, i) {
        return {
          u_matrix: e,
          u_image0: 0,
          u_skirt_height: t,
          u_ground_shadow_factor: i
        };
      },
      kt = function kt(e, t, i, o, r, a, n, s, l, c, h, _, u, d, p, f) {
        return {
          u_proj_matrix: Float32Array.from(e),
          u_globe_matrix: t,
          u_normalize_matrix: Float32Array.from(o),
          u_merc_matrix: i,
          u_zoom_transition: r,
          u_merc_center: a,
          u_image0: 0,
          u_frustum_tl: n,
          u_frustum_tr: s,
          u_frustum_br: l,
          u_frustum_bl: c,
          u_globe_pos: h,
          u_globe_radius: _,
          u_viewport: u,
          u_grid_matrix: f ? Float32Array.from(f) : new Float32Array(9),
          u_skirt_height: d,
          u_far_z_cutoff: p
        };
      };
    var Nt = /*#__PURE__*/function () {
      function Nt() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        _classCallCheck(this, Nt);
        if (isNaN(e) || e < 0 || isNaN(t) || t < 0 || isNaN(i) || i < 0 || isNaN(o) || o < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
        this.top = e, this.bottom = t, this.left = i, this.right = o;
      }
      _createClass(Nt, [{
        key: "interpolate",
        value: function interpolate(t, i, o) {
          return null != i.top && null != t.top && (this.top = e.a3(t.top, i.top, o)), null != i.bottom && null != t.bottom && (this.bottom = e.a3(t.bottom, i.bottom, o)), null != i.left && null != t.left && (this.left = e.a3(t.left, i.left, o)), null != i.right && null != t.right && (this.right = e.a3(t.right, i.right, o)), this;
        }
      }, {
        key: "getCenter",
        value: function getCenter(t, i) {
          var o = e.au((this.left + t - this.right) / 2, 0, t),
            r = e.au((this.top + i - this.bottom) / 2, 0, i);
          return new e.P(o, r);
        }
      }, {
        key: "equals",
        value: function equals(e) {
          return this.top === e.top && this.bottom === e.bottom && this.left === e.left && this.right === e.right;
        }
      }, {
        key: "clone",
        value: function clone() {
          return new Nt(this.top, this.bottom, this.left, this.right);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            top: this.top,
            bottom: this.bottom,
            left: this.left,
            right: this.right
          };
        }
      }]);
      return Nt;
    }();
    function Ut(t, i) {
      var o = e.ax(t, 3);
      e.ae.fromQuat(t, i), e.aA(t, 3, o);
    }
    function Gt(t, i) {
      var o = e.aw.identity([]);
      return e.aw.rotateZ(o, o, -i), e.aw.rotateX(o, o, -t), o;
    }
    function jt(t, i) {
      var o = [t[0], t[1], 0],
        r = [i[0], i[1], 0];
      if (e.$.length(o) >= 1e-15) {
        var _t476 = e.$.normalize([], o);
        e.$.scale(r, _t476, e.$.dot(r, _t476)), i[0] = r[0], i[1] = r[1];
      }
      var a = e.$.cross([], i, t);
      if (e.$.len(a) < 1e-15) return null;
      var n = Math.atan2(-a[1], a[0]);
      return Gt(Math.atan2(Math.sqrt(t[0] * t[0] + t[1] * t[1]), -t[2]), n);
    }
    var Vt = /*#__PURE__*/function () {
      function Vt(e, t) {
        _classCallCheck(this, Vt);
        this.position = e, this.orientation = t;
      }
      _createClass(Vt, [{
        key: "position",
        get: function get() {
          return this._position;
        },
        set: function set(t) {
          if (t) {
            var _i279 = t instanceof e._ ? t : new e._(t[0], t[1], t[2]);
            this._renderWorldCopies && (_i279.x = e.av(_i279.x, 0, 1)), this._position = _i279;
          } else this._position = null;
        }
      }, {
        key: "lookAtPoint",
        value: function lookAtPoint(t, i) {
          if (this.orientation = null, !this.position) return;
          var o = this.position,
            r = this._elevation ? this._elevation.getAtPointOrZero(e._.fromLngLat(t)) : 0,
            a = e._.fromLngLat(t, r),
            n = [a.x - o.x, a.y - o.y, a.z - o.z];
          i || (i = [0, 0, 1]), i[2] = Math.abs(i[2]), this.orientation = jt(n, i);
        }
      }, {
        key: "setPitchBearing",
        value: function setPitchBearing(t, i) {
          this.orientation = Gt(e.ac(t), e.ac(-i));
        }
      }]);
      return Vt;
    }();
    var $t = /*#__PURE__*/function () {
      function $t(t, i) {
        _classCallCheck(this, $t);
        this._transform = e.ae.identity([]), this.orientation = i, this.position = t;
      }
      _createClass($t, [{
        key: "mercatorPosition",
        get: function get() {
          var t = this.position;
          return new e._(t[0], t[1], t[2]);
        }
      }, {
        key: "position",
        get: function get() {
          var t = e.ax(this._transform, 3);
          return [t[0], t[1], t[2]];
        },
        set: function set(t) {
          var i;
          t && e.aA(this._transform, 3, [(i = t)[0], i[1], i[2], 1]);
        }
      }, {
        key: "orientation",
        get: function get() {
          return this._orientation;
        },
        set: function set(t) {
          this._orientation = t || e.aw.identity([]), t && Ut(this._transform, this._orientation);
        }
      }, {
        key: "getPitchBearing",
        value: function getPitchBearing() {
          var e = this.forward(),
            t = this.right();
          return {
            bearing: Math.atan2(-t[1], t[0]),
            pitch: Math.atan2(Math.sqrt(e[0] * e[0] + e[1] * e[1]), -e[2])
          };
        }
      }, {
        key: "setPitchBearing",
        value: function setPitchBearing(e, t) {
          this._orientation = Gt(e, t), Ut(this._transform, this._orientation);
        }
      }, {
        key: "forward",
        value: function forward() {
          var t = e.ax(this._transform, 2);
          return [-t[0], -t[1], -t[2]];
        }
      }, {
        key: "up",
        value: function up() {
          var t = e.ax(this._transform, 1);
          return [-t[0], -t[1], -t[2]];
        }
      }, {
        key: "right",
        value: function right() {
          var t = e.ax(this._transform, 0);
          return [t[0], t[1], t[2]];
        }
      }, {
        key: "getCameraToWorld",
        value: function getCameraToWorld(t, i) {
          var o = new Float64Array(16);
          return e.ae.invert(o, this.getWorldToCamera(t, i)), o;
        }
      }, {
        key: "getCameraToWorldMercator",
        value: function getCameraToWorldMercator() {
          return this._transform;
        }
      }, {
        key: "getWorldToCameraPosition",
        value: function getWorldToCameraPosition(t, i, o) {
          var r = this.position;
          e.$.scale(r, r, -t);
          var a = new Float64Array(16);
          return e.ae.fromScaling(a, [o, o, o]), e.ae.translate(a, a, r), a[10] *= i, a;
        }
      }, {
        key: "getWorldToCamera",
        value: function getWorldToCamera(t, i) {
          var o = new Float64Array(16),
            r = new Float64Array(4),
            a = this.position;
          return e.aw.conjugate(r, this._orientation), e.$.scale(a, a, -t), e.ae.fromQuat(o, r), e.ae.translate(o, o, a), o[1] *= -1, o[5] *= -1, o[9] *= -1, o[13] *= -1, o[8] *= i, o[9] *= i, o[10] *= i, o[11] *= i, o;
        }
      }, {
        key: "getCameraToClipPerspective",
        value: function getCameraToClipPerspective(t, i, o, r) {
          var a = new Float64Array(16);
          return e.ae.perspective(a, t, i, o, r), a;
        }
      }, {
        key: "getCameraToClipOrthographic",
        value: function getCameraToClipOrthographic(t, i, o, r, a, n) {
          var s = new Float64Array(16);
          return e.ae.ortho(s, t, i, o, r, a, n), s;
        }
      }, {
        key: "getDistanceToElevation",
        value: function getDistanceToElevation(t) {
          var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var o = 0 === t ? 0 : e.ay(t, i ? e.az(this.position[1]) : this.position[1]),
            r = this.forward();
          return (o - this.position[2]) / r[2];
        }
      }, {
        key: "clone",
        value: function clone() {
          return new $t(_toConsumableArray(this.position), _toConsumableArray(this.orientation));
        }
      }]);
      return $t;
    }();
    var Zt = {
        unknown: 0,
        flipRequired: 1,
        flipNotRequired: 2
      },
      Wt = Math.tan(85 * Math.PI / 180);
    function Ht(t, i, o, r, a, n, s) {
      var l = e.ae.create();
      if (o) {
        if ("globe" === n.name) {
          var _t477 = e.aC(a, i);
          e.ae.multiply(l, l, _t477);
        } else {
          var _t478 = e.aD.invert([], s);
          l[0] = _t478[0], l[1] = _t478[1], l[4] = _t478[2], l[5] = _t478[3], r || e.ae.rotateZ(l, l, a.angle);
        }
      } else e.ae.multiply(l, a.labelPlaneMatrix, t);
      return l;
    }
    function qt(e, t, i, o, r, a, n) {
      var s = Ht(e, t, i, o, r, a, n);
      return "globe" === a.name && i || (s[2] = s[6] = s[10] = s[14] = 0), s;
    }
    function Xt(t, i, o, r, a, n, s) {
      if (o) {
        if ("globe" === n.name) {
          var _l100 = Ht(t, i, o, r, a, n, s);
          return e.ae.invert(_l100, _l100), e.ae.multiply(_l100, t, _l100), _l100;
        }
        {
          var _i280 = e.ae.clone(t),
            _o157 = e.ae.identity([]);
          return _o157[0] = s[0], _o157[1] = s[1], _o157[4] = s[2], _o157[5] = s[3], e.ae.multiply(_i280, _i280, _o157), r || e.ae.rotateZ(_i280, _i280, -a.angle), _i280;
        }
      }
      return a.glCoordMatrix;
    }
    function Qt(t, i, o, r) {
      var a = [t, i, o, 1];
      o ? e.aB.transformMat4(a, a, r) : si(a, a, r);
      var n = a[3];
      return a[0] /= n, a[1] /= n, a[2] /= n, a;
    }
    function Yt(e, t) {
      return Math.min(.5 + e / t * .5, 1.5);
    }
    function Jt(e, t) {
      var i = e[0] / e[3],
        o = e[1] / e[3];
      return i >= -t[0] && i <= t[0] && o >= -t[1] && o <= t[1];
    }
    function Kt(t, i, o, r, a, n, s, l, c, h) {
      var _ = o.transform,
        u = r ? t.textSizeData : t.iconSizeData,
        d = e.aE(u, o.transform.zoom),
        p = "globe" === _.projection.name,
        f = [256 / o.width * 2 + 1, 256 / o.height * 2 + 1],
        m = r ? t.text.dynamicLayoutVertexArray : t.icon.dynamicLayoutVertexArray;
      m.clear();
      var g = null;
      p && (g = r ? t.text.globeExtVertexArray : t.icon.globeExtVertexArray);
      var v = t.lineVertexArray,
        x = r ? t.text.placedSymbolArray : t.icon.placedSymbolArray,
        y = o.transform.width / o.transform.height;
      var b,
        w = !1;
      for (var _r352 = 0; _r352 < x.length; _r352++) {
        var _p50 = x.get(_r352),
          _T6 = _p50.numGlyphs,
          _E3 = _p50.writingMode;
        if (_E3 !== e.aF.vertical || w || b === e.aF.horizontal || (w = !0), b = _E3, (_p50.hidden || _E3 === e.aF.vertical) && !w) {
          ni(_T6, m);
          continue;
        }
        w = !1;
        var _C = new e.P(_p50.tileAnchorX, _p50.tileAnchorY);
        var _$projection$projectT = _.projection.projectTilePoint(_C.x, _C.y, h.canonical),
          _S10 = _$projection$projectT.x,
          _I7 = _$projection$projectT.y,
          _L = _$projection$projectT.z;
        if (c) {
          var _c71 = c(_C),
            _c72 = _slicedToArray(_c71, 3),
            _e449 = _c72[0],
            _t479 = _c72[1],
            _i281 = _c72[2];
          _S10 += _e449, _I7 += _t479, _L += _i281;
        }
        var _P5 = [_S10, _I7, _L, 1];
        if (e.aB.transformMat4(_P5, _P5, i), !Jt(_P5, f)) {
          ni(_T6, m);
          continue;
        }
        var _R = _P5[3],
          _D = Yt(o.transform.getCameraToCenterDistance(_.projection), _R),
          _A11 = e.aG(u, d, _p50),
          _M12 = s ? _A11 / _D : _A11 * _D,
          _z4 = Qt(_S10, _I7, _L, a);
        if (_z4[3] <= 0) {
          ni(_T6, m);
          continue;
        }
        var _O = {};
        var _F = s ? null : c,
          _B2 = ii(_p50, _M12, !1, l, i, a, n, t.glyphOffsetArray, v, m, g, _z4, _C, _O, y, _F, _.projection, h, s);
        w = _B2.useVertical, _F && _B2.needsFlipping && (_O = {}), (_B2.notEnoughRoom || w || _B2.needsFlipping && ii(_p50, _M12, !0, l, i, a, n, t.glyphOffsetArray, v, m, g, _z4, _C, _O, y, _F, _.projection, h, s).notEnoughRoom) && ni(_T6, m);
      }
      r ? (t.text.dynamicLayoutVertexBuffer.updateData(m), g && t.text.globeExtVertexBuffer && t.text.globeExtVertexBuffer.updateData(g)) : (t.icon.dynamicLayoutVertexBuffer.updateData(m), g && t.icon.globeExtVertexBuffer && t.icon.globeExtVertexBuffer.updateData(g));
    }
    function ei(e, t, i, o, r, a, n, s, l, c, h, _, u, d, p, f) {
      var m = s.lineStartIndex,
        g = s.glyphStartIndex,
        v = s.segment,
        x = g + s.numGlyphs,
        y = m + s.lineLength,
        b = t.getoffsetX(g),
        w = t.getoffsetX(x - 1),
        T = ai(e * b, i, o, r, a, n, v, m, y, l, c, h, _, u, !0, d, p, f);
      if (!T) return null;
      var E = ai(e * w, i, o, r, a, n, v, m, y, l, c, h, _, u, !0, d, p, f);
      return E ? {
        first: T,
        last: E
      } : null;
    }
    function ti(t, i, o, r) {
      return t === e.aF.horizontal && Math.abs(r) > Math.abs(o) ? {
        useVertical: !0
      } : t === e.aF.vertical ? r > 0 ? {
        needsFlipping: !0
      } : null : i !== Zt.unknown && function (e, t) {
        return 0 === e || Math.abs(t / e) > Wt;
      }(o, r) ? i === Zt.flipRequired ? {
        needsFlipping: !0
      } : null : o < 0 ? {
        needsFlipping: !0
      } : null;
    }
    function ii(t, i, o, r, a, n, s, l, c, h, _, u, d, p, f, m, g, v, x) {
      var y = i / 24,
        b = t.lineOffsetX * y,
        w = t.lineOffsetY * y,
        T = t.lineStartIndex,
        E = t.glyphStartIndex,
        C = t.numGlyphs,
        S = t.segment,
        I = t.writingMode,
        L = t.flipState,
        P = T + t.lineLength,
        R = function R(t) {
          if (_) {
            var _t$up = _slicedToArray(t.up, 3),
              _i282 = _t$up[0],
              _o158 = _t$up[1],
              _r353 = _t$up[2],
              _a169 = h.length;
            e.aH(_, _a169 + 0, _i282, _o158, _r353), e.aH(_, _a169 + 1, _i282, _o158, _r353), e.aH(_, _a169 + 2, _i282, _o158, _r353), e.aH(_, _a169 + 3, _i282, _o158, _r353);
          }
          var _t$point2 = _slicedToArray(t.point, 3),
            i = _t$point2[0],
            o = _t$point2[1],
            r = _t$point2[2];
          e.aI(h, i, o, r, t.angle);
        };
      if (C > 1) {
        var _e450 = ei(y, l, b, w, o, u, d, t, c, n, p, m, !1, g, v, x);
        if (!_e450) return {
          notEnoughRoom: !0
        };
        if (r && !o) {
          var _Qt, _Qt2, _Qt3, _Qt4;
          var _e450$first$point = _slicedToArray(_e450.first.point, 3),
            _i283 = _e450$first$point[0],
            _o159 = _e450$first$point[1],
            _r354 = _e450$first$point[2],
            _e450$last$point = _slicedToArray(_e450.last.point, 3),
            _a170 = _e450$last$point[0],
            _n248 = _e450$last$point[1],
            _l101 = _e450$last$point[2];
          (_Qt = Qt(_i283, _o159, _r354, s), _Qt2 = _slicedToArray(_Qt, 2), _i283 = _Qt2[0], _o159 = _Qt2[1]), (_Qt3 = Qt(_a170, _n248, _l101, s), _Qt4 = _slicedToArray(_Qt3, 2), _a170 = _Qt4[0], _n248 = _Qt4[1]);
          var _c73 = ti(I, L, (_a170 - _i283) * f, _n248 - _o159);
          if (t.flipState = _c73 && _c73.needsFlipping ? Zt.flipRequired : Zt.flipNotRequired, _c73) return _c73;
        }
        R(_e450.first);
        for (var _e451 = E + 1; _e451 < E + C - 1; _e451++) {
          var _t480 = ai(y * l.getoffsetX(_e451), b, w, o, u, d, S, T, P, c, n, p, m, !1, !1, g, v, x);
          if (!_t480) return h.length -= 4 * (_e451 - E), {
            notEnoughRoom: !0
          };
          R(_t480);
        }
        R(_e450.last);
      } else {
        if (r && !o) {
          var _i284 = Qt(d.x, d.y, 0, a),
            _o160 = T + S + 1,
            _r355 = new e.P(c.getx(_o160), c.gety(_o160)),
            _n249 = Qt(_r355.x, _r355.y, 0, a),
            _s214 = _n249[3] > 0 ? _n249 : ri(d, _r355, _i284, 1, a, void 0, g, v.canonical),
            _l102 = ti(I, L, (_s214[0] - _i284[0]) * f, _s214[1] - _i284[1]);
          if (t.flipState = _l102 && _l102.needsFlipping ? Zt.flipRequired : Zt.flipNotRequired, _l102) return _l102;
        }
        var _i285 = ai(y * l.getoffsetX(E), b, w, o, u, d, S, T, P, c, n, p, m, !1, !1, g, v, x);
        if (!_i285) return {
          notEnoughRoom: !0
        };
        R(_i285);
      }
      return {};
    }
    function oi(e, t, i, o, r) {
      var _o$projectTilePoint = o.projectTilePoint(e.x, e.y, t),
        a = _o$projectTilePoint.x,
        n = _o$projectTilePoint.y,
        s = _o$projectTilePoint.z;
      if (!r) return Qt(a, n, s, i);
      var _r356 = r(e),
        _r357 = _slicedToArray(_r356, 3),
        l = _r357[0],
        c = _r357[1],
        h = _r357[2];
      return Qt(a + l, n + c, s + h, i);
    }
    function ri(t, i, o, r, a, n, s, l) {
      var c = oi(t.sub(i)._unit()._add(t), l, a, s, n);
      return e.$.sub(c, o, c), e.$.normalize(c, c), e.$.scaleAndAdd(c, o, c, r);
    }
    function ai(t, i, o, r, a, n, s, l, c, h, _, u, d, p, f, m, g, v) {
      var x = r ? t - i : t + i;
      var y = x > 0 ? 1 : -1,
        b = 0;
      r && (y *= -1, b = Math.PI), y < 0 && (b += Math.PI);
      var w = l + s + (y > 0 ? 0 : 1) | 0,
        T = a,
        E = a,
        C = 0,
        S = 0;
      var I = Math.abs(x),
        L = [],
        P = [];
      var R = n,
        D = R;
      var A = function A() {
        return ri(D, R, E, I - C + 1, _, d, m, g.canonical);
      };
      for (; C + S <= I;) {
        if (w += y, w < l || w >= c) return null;
        if (E = T, D = R, L.push(E), p && P.push(D), R = new e.P(h.getx(w), h.gety(w)), T = u[w], !T) {
          var _e452 = oi(R, g.canonical, _, m, d);
          T = _e452[3] > 0 ? u[w] = _e452 : A();
        }
        C += S, S = e.$.distance(E, T);
      }
      f && d && (u[w] && (T = A(), S = e.$.distance(E, T)), u[w] = T);
      var M = (I - C) / S,
        z = R.sub(D)._mult(M)._add(D),
        O = e.$.sub([], T, E),
        F = e.$.scaleAndAdd([], E, O, M);
      var B = [0, 0, 1],
        k = O[0],
        N = O[1];
      if (v && (B = m.upVector(g.canonical, z.x, z.y), 0 !== B[0] || 0 !== B[1] || 1 !== B[2])) {
        var _t481 = [B[2], 0, -B[0]],
          _i286 = e.$.cross([], B, _t481);
        e.$.normalize(_t481, _t481), e.$.normalize(_i286, _i286), k = e.$.dot(O, _t481), N = e.$.dot(O, _i286);
      }
      if (o) {
        var _t482 = e.$.cross([], B, O);
        e.$.normalize(_t482, _t482), e.$.scaleAndAdd(F, F, _t482, o * y);
      }
      var U = b + Math.atan2(N, k);
      return L.push(F), p && P.push(z), {
        point: F,
        angle: U,
        path: L,
        tilePath: P,
        up: B
      };
    }
    function ni(e, t) {
      var i = t.length,
        o = i + 4 * e;
      t.resize(o), t.float32.fill(-1 / 0, 4 * i, 4 * o);
    }
    function si(e, t, i) {
      var o = t[0],
        r = t[1];
      return e[0] = i[0] * o + i[4] * r + i[12], e[1] = i[1] * o + i[5] * r + i[13], e[3] = i[3] * o + i[7] * r + i[15], e;
    }
    var li = function li(e, t, i) {
        return (1 - i) * e + i * t;
      },
      ci = function ci(e) {
        return e * e * e * e * e;
      };
    var hi = /*#__PURE__*/function () {
      function hi(t, i, o, r, a, n, s) {
        _classCallCheck(this, hi);
        this.tileSize = 512, this._renderWorldCopies = void 0 === a || a, this._minZoom = t || 0, this._maxZoom = i || 22, this._minPitch = o !== null && o !== void 0 ? o : 0, this._maxPitch = r !== null && r !== void 0 ? r : 60, this.setProjection(n), this.setMaxBounds(s), this.width = 0, this.height = 0, this._center = new e.aJ(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = !0, this._edgeInsets = new Nt(), this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new $t(), this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [0, 0, 0], this._tileCoverLift = 0, this.freezeTileCoverage = !1, this._horizonShift = .1, this._orthographicProjectionAtLowPitch = !1;
      }
      _createClass(hi, [{
        key: "clone",
        value: function clone() {
          var e = new hi(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection());
          return e._elevation = this._elevation, e._centerAltitude = this._centerAltitude, e._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e.tileSize = this.tileSize, e.mercatorFromTransition = this.mercatorFromTransition, e.width = this.width, e.height = this.height, e.cameraElevationReference = this.cameraElevationReference, e._center = this._center, e._setZoom(this.zoom), e._seaLevelZoom = this._seaLevelZoom, e.angle = this.angle, e._fov = this._fov, e._pitch = this._pitch, e._nearZ = this._nearZ, e._farZ = this._farZ, e._averageElevation = this._averageElevation, e._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e._unmodified = this._unmodified, e._edgeInsets = this._edgeInsets.clone(), e._camera = this._camera.clone(), e._calcMatrices(), e.freezeTileCoverage = this.freezeTileCoverage, e.frustumCorners = this.frustumCorners, e;
        }
      }, {
        key: "isOrthographic",
        get: function get() {
          return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < 15;
        }
      }, {
        key: "elevation",
        get: function get() {
          return this._elevation;
        },
        set: function set(e) {
          this._elevation !== e && (this._elevation = e, this._updateCameraOnTerrain(), this._calcMatrices());
        }
      }, {
        key: "depthOcclusionForSymbolsAndCircles",
        get: function get() {
          return "globe" !== this.projection.name && !this.isOrthographic;
        }
      }, {
        key: "updateElevation",
        value: function updateElevation(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var i = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
          (null == this._seaLevelZoom || i) && this._updateCameraOnTerrain(), (e || i) && this._constrainCamera(t), this._calcMatrices();
        }
      }, {
        key: "getProjection",
        value: function getProjection() {
          return e.ai(this.projection, ["name", "center", "parallels"]);
        }
      }, {
        key: "setProjection",
        value: function setProjection(t) {
          this.projectionOptions = t || {
            name: "mercator"
          };
          var i = this.projection ? this.getProjection() : void 0;
          this.projection = e.aK(this.projectionOptions);
          var o = this.getProjection(),
            r = !e.d(i, o);
          return r && this._calcMatrices(), this.mercatorFromTransition = !1, r;
        }
      }, {
        key: "setOrthographicProjectionAtLowPitch",
        value: function setOrthographicProjectionAtLowPitch(e) {
          return this._orthographicProjectionAtLowPitch !== e && (this._orthographicProjectionAtLowPitch = e, this._calcMatrices(), !0);
        }
      }, {
        key: "setMercatorFromTransition",
        value: function setMercatorFromTransition() {
          var t = this.projection.name;
          this.mercatorFromTransition = !0, this.projectionOptions = {
            name: "mercator"
          }, this.projection = e.aK({
            name: "mercator"
          });
          var i = t !== this.projection.name;
          return i && this._calcMatrices(), i;
        }
      }, {
        key: "minZoom",
        get: function get() {
          return this._minZoom;
        },
        set: function set(e) {
          this._minZoom !== e && (this._minZoom = e, this.zoom = Math.max(this.zoom, e));
        }
      }, {
        key: "maxZoom",
        get: function get() {
          return this._maxZoom;
        },
        set: function set(e) {
          this._maxZoom !== e && (this._maxZoom = e, this.zoom = Math.min(this.zoom, e));
        }
      }, {
        key: "minPitch",
        get: function get() {
          return this._minPitch;
        },
        set: function set(e) {
          this._minPitch !== e && (this._minPitch = e, this.pitch = Math.max(this.pitch, e));
        }
      }, {
        key: "maxPitch",
        get: function get() {
          return this._maxPitch;
        },
        set: function set(e) {
          this._maxPitch !== e && (this._maxPitch = e, this.pitch = Math.min(this.pitch, e));
        }
      }, {
        key: "renderWorldCopies",
        get: function get() {
          return this._renderWorldCopies && !0 === this.projection.supportsWorldCopies;
        },
        set: function set(e) {
          void 0 === e ? e = !0 : null === e && (e = !1), this._renderWorldCopies = e;
        }
      }, {
        key: "worldSize",
        get: function get() {
          return this.tileSize * this.scale;
        }
      }, {
        key: "cameraWorldSizeForFog",
        get: function get() {
          var e = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
          return this._worldSizeFromZoom(this._zoomFromMercatorZ(e));
        }
      }, {
        key: "cameraWorldSize",
        get: function get() {
          var e = Math.max(this._camera.getDistanceToElevation(this._averageElevation, !0), Number.EPSILON);
          return this._worldSizeFromZoom(this._zoomFromMercatorZ(e));
        }
      }, {
        key: "pixelsPerMeter",
        get: function get() {
          return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
        }
      }, {
        key: "cameraPixelsPerMeter",
        get: function get() {
          return e.ay(1, this.center.lat) * this.cameraWorldSizeForFog;
        }
      }, {
        key: "centerOffset",
        get: function get() {
          return this.centerPoint._sub(this.size._div(2));
        }
      }, {
        key: "size",
        get: function get() {
          return new e.P(this.width, this.height);
        }
      }, {
        key: "bearing",
        get: function get() {
          return e.av(this.rotation, -180, 180);
        },
        set: function set(e) {
          this.rotation = e;
        }
      }, {
        key: "rotation",
        get: function get() {
          return -this.angle / Math.PI * 180;
        },
        set: function set(t) {
          var i = -t * Math.PI / 180;
          this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = e.aD.create(), e.aD.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
        }
      }, {
        key: "pitch",
        get: function get() {
          return this._pitch / Math.PI * 180;
        },
        set: function set(t) {
          var i = e.au(t, this.minPitch, this.maxPitch) / 180 * Math.PI;
          this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
        }
      }, {
        key: "aspect",
        get: function get() {
          return this.width / this.height;
        }
      }, {
        key: "fov",
        get: function get() {
          return this._fov / Math.PI * 180;
        },
        set: function set(t) {
          t = Math.max(.01, Math.min(60, t)), this._fov !== t && (this._unmodified = !1, this._fov = e.ac(t), this._calcMatrices());
        }
      }, {
        key: "fovX",
        get: function get() {
          return this._fov;
        }
      }, {
        key: "fovY",
        get: function get() {
          var e = 1 / Math.tan(.5 * this.fovX);
          return 2 * Math.atan(1 / this.aspect / e);
        }
      }, {
        key: "averageElevation",
        get: function get() {
          return this._averageElevation;
        },
        set: function set(e) {
          this._averageElevation = e, this._calcFogMatrices(), this._distanceTileDataCache = {};
        }
      }, {
        key: "zoom",
        get: function get() {
          return this._zoom;
        },
        set: function set(e) {
          var t = Math.min(Math.max(e, this.minZoom), this.maxZoom);
          this._zoom !== t && (this._unmodified = !1, this._setZoom(t), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
        }
      }, {
        key: "_setZoom",
        value: function _setZoom(e) {
          this._zoom = e, this.scale = this.zoomScale(e), this.tileZoom = Math.floor(e), this.zoomFraction = e - this.tileZoom;
        }
      }, {
        key: "tileCoverLift",
        get: function get() {
          return this._tileCoverLift;
        },
        set: function set(e) {
          this._tileCoverLift !== e && (this._tileCoverLift = e);
        }
      }, {
        key: "_updateCameraOnTerrain",
        value: function _updateCameraOnTerrain() {
          var e = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY,
            t = this.elevation && e === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
          if (!this._elevation || e === Number.NEGATIVE_INFINITY && (!t || !this._centerAltitude)) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
          var i = this._elevation;
          t || this._centerAltitude && this._centerAltitudeValidForExaggeration && i.exaggeration() && this._centerAltitudeValidForExaggeration !== i.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i.exaggeration(), this._centerAltitudeValidForExaggeration = i.exaggeration()) : (this._centerAltitude = e || 0, this._centerAltitudeValidForExaggeration = i.exaggeration()), this._updateSeaLevelZoom();
        }
      }, {
        key: "_updateSeaLevelZoom",
        value: function _updateSeaLevelZoom() {
          void 0 !== this._centerAltitudeValidForExaggeration && (this._seaLevelZoom = this._zoomFromMercatorZ((this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize));
        }
      }, {
        key: "sampleAverageElevation",
        value: function sampleAverageElevation() {
          if (!this._elevation) return 0;
          var t = this._elevation,
            i = [[.5, .2], [.3, .5], [.5, .5], [.7, .5], [.5, .8]],
            o = this.horizonLineFromTop();
          var r = 0,
            a = 0;
          for (var _n250 = 0; _n250 < i.length; _n250++) {
            var _s215 = new e.P(i[_n250][0] * this.width, o + i[_n250][1] * (this.height - o)),
              _l103 = t.pointCoordinate(_s215);
            if (!_l103) continue;
            var _c74 = 1 / Math.hypot(_l103[0] - this._camera.position[0], _l103[1] - this._camera.position[1]);
            r += _l103[3] * _c74, a += _c74;
          }
          return 0 === a ? NaN : r / a;
        }
      }, {
        key: "center",
        get: function get() {
          return this._center;
        },
        set: function set(e) {
          e.lat === this._center.lat && e.lng === this._center.lng || (this._unmodified = !1, this._center = e, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
        }
      }, {
        key: "_updateZoomFromElevation",
        value: function _updateZoomFromElevation() {
          if (null == this._seaLevelZoom || !this._elevation) return;
          var e = this._seaLevelZoom,
            t = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)),
            i = this.pixelsPerMeter / this.worldSize * t,
            o = this._mercatorZfromZoom(e),
            r = this._mercatorZfromZoom(this._maxZoom),
            a = Math.max(o - i, r);
          this._setZoom(this._zoomFromMercatorZ(a));
        }
      }, {
        key: "padding",
        get: function get() {
          return this._edgeInsets.toJSON();
        },
        set: function set(e) {
          this._edgeInsets.equals(e) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e, 1), this._calcMatrices());
        }
      }, {
        key: "computeZoomRelativeTo",
        value: function computeZoomRelativeTo(t) {
          var i = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, t.toAltitude()));
          var o;
          o = t.z < this._camera.position[2] ? [i.x, i.y, i.z] : [t.x, t.y, t.z];
          var r = e.$.length(e.$.sub([], this._camera.position, o));
          return e.au(this._zoomFromMercatorZ(r), this._minZoom, this._maxZoom);
        }
      }, {
        key: "setFreeCameraOptions",
        value: function setFreeCameraOptions(t) {
          if (!this.height) return;
          if (!t.position && !t.orientation) return;
          this._updateCameraState();
          var i = !1;
          if (t.orientation && !e.aw.exactEquals(t.orientation, this._camera.orientation) && (i = this._setCameraOrientation(t.orientation)), t.position) {
            var _o161 = [t.position.x, t.position.y, t.position.z];
            e.$.exactEquals(_o161, this._camera.position) || (this._setCameraPosition(_o161), i = !0);
          }
          i && (this._updateStateFromCamera(), this.recenterOnTerrain());
        }
      }, {
        key: "getFreeCameraOptions",
        value: function getFreeCameraOptions() {
          this._updateCameraState();
          var t = this._camera.position,
            i = new Vt();
          return i.position = new e._(t[0], t[1], t[2]), i.orientation = this._camera.orientation, i._elevation = this.elevation, i._renderWorldCopies = this.renderWorldCopies, i;
        }
      }, {
        key: "_setCameraOrientation",
        value: function _setCameraOrientation(t) {
          if (!e.aw.length(t)) return !1;
          e.aw.normalize(t, t);
          var i = e.$.transformQuat([], [0, 0, -1], t),
            o = e.$.transformQuat([], [0, -1, 0], t);
          if (o[2] < 0) return !1;
          var r = jt(i, o);
          return !!r && (this._camera.orientation = r, !0);
        }
      }, {
        key: "_setCameraPosition",
        value: function _setCameraPosition(t) {
          var i = this.zoomScale(this.minZoom) * this.tileSize,
            o = this.zoomScale(this.maxZoom) * this.tileSize,
            r = this.cameraToCenterDistance;
          t[2] = e.au(t[2], r / o, r / i), this._camera.position = t;
        }
      }, {
        key: "centerPoint",
        get: function get() {
          return this._edgeInsets.getCenter(this.width, this.height);
        }
      }, {
        key: "fovAboveCenter",
        get: function get() {
          return this._fov * (.5 + this.centerOffset.y / this.height);
        }
      }, {
        key: "isPaddingEqual",
        value: function isPaddingEqual(e) {
          return this._edgeInsets.equals(e);
        }
      }, {
        key: "interpolatePadding",
        value: function interpolatePadding(e, t, i) {
          this._unmodified = !1, this._edgeInsets.interpolate(e, t, i), this._constrain(), this._calcMatrices();
        }
      }, {
        key: "coveringZoomLevel",
        value: function coveringZoomLevel(e) {
          var t = (e.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e.tileSize));
          return Math.max(0, t);
        }
      }, {
        key: "getVisibleUnwrappedCoordinates",
        value: function getVisibleUnwrappedCoordinates(t) {
          var i = [new e.aL(0, t)];
          if (this.renderWorldCopies) {
            var _o162 = this.pointCoordinate(new e.P(0, 0)),
              _r358 = this.pointCoordinate(new e.P(this.width, 0)),
              _a171 = this.pointCoordinate(new e.P(this.width, this.height)),
              _n251 = this.pointCoordinate(new e.P(0, this.height)),
              _s216 = Math.floor(Math.min(_o162.x, _r358.x, _a171.x, _n251.x)),
              _l104 = Math.floor(Math.max(_o162.x, _r358.x, _a171.x, _n251.x)),
              _c75 = 1;
            for (var _o163 = _s216 - _c75; _o163 <= _l104 + _c75; _o163++) 0 !== _o163 && i.push(new e.aL(_o163, t));
          }
          return i;
        }
      }, {
        key: "isLODDisabled",
        value: function isLODDisabled(e) {
          return (!e || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
        }
      }, {
        key: "extendTileCover",
        value: function extendTileCover(t, i, o) {
          var r = [];
          var a = void 0 !== o,
            n = !a;
          if (n && this.zoom < i) return r;
          if (a && 0 === o[0] && 0 === o[1]) return r;
          var s = new Set(),
            l = function l(t, i, o, a, n) {
              var l = e.b2(i, t, o, a, n);
              s.has(l) || (r.push(new e.aQ(t, i, o, a, n)), s.add(l));
            };
          for (var _e453 = 0; _e453 < t.length; _e453++) {
            var _r359 = t[_e453];
            if (n && _r359.canonical.z !== i) continue;
            var _s217 = _r359.canonical,
              _c76 = _r359.overscaledZ,
              _h60 = _r359.wrap,
              _13 = 1 << _s217.z,
              _u83 = _s217.x + 1 < _13,
              _d33 = _s217.x > 0,
              _p51 = _s217.y + 1 < _13,
              _f44 = _s217.y > 0,
              _m24 = _r359.wrap - (_d33 ? 0 : 1),
              _g20 = _r359.wrap + (_u83 ? 0 : 1),
              _v14 = _d33 ? _s217.x - 1 : _13 - 1,
              _x18 = _u83 ? _s217.x + 1 : 0;
            if (a) o[0] < 0 ? (l(_c76, _g20, _s217.z, _x18, _s217.y), o[1] < 0 && _p51 && (l(_c76, _h60, _s217.z, _s217.x, _s217.y + 1), l(_c76, _g20, _s217.z, _x18, _s217.y + 1)), o[1] > 0 && _f44 && (l(_c76, _h60, _s217.z, _s217.x, _s217.y - 1), l(_c76, _g20, _s217.z, _x18, _s217.y - 1))) : o[0] > 0 ? (l(_c76, _m24, _s217.z, _v14, _s217.y), o[1] < 0 && _p51 && (l(_c76, _h60, _s217.z, _s217.x, _s217.y + 1), l(_c76, _m24, _s217.z, _v14, _s217.y + 1)), o[1] > 0 && _f44 && (l(_c76, _h60, _s217.z, _s217.x, _s217.y - 1), l(_c76, _m24, _s217.z, _v14, _s217.y - 1))) : o[1] < 0 && _p51 ? l(_c76, _h60, _s217.z, _s217.x, _s217.y + 1) : _f44 && l(_c76, _h60, _s217.z, _s217.x, _s217.y - 1);else {
              var _e454 = _r359.visibleQuadrants;
              1 & _e454 && (l(_c76, _m24, _s217.z, _v14, _s217.y), _f44 && (l(_c76, _h60, _s217.z, _s217.x, _s217.y - 1), l(_c76, _m24, _s217.z, _v14, _s217.y - 1))), 2 & _e454 && (l(_c76, _g20, _s217.z, _x18, _s217.y), _f44 && (l(_c76, _h60, _s217.z, _s217.x, _s217.y - 1), l(_c76, _g20, _s217.z, _x18, _s217.y - 1))), 4 & _e454 && (l(_c76, _m24, _s217.z, _v14, _s217.y), _p51 && (l(_c76, _h60, _s217.z, _s217.x, _s217.y + 1), l(_c76, _m24, _s217.z, _v14, _s217.y + 1))), 8 & _e454 && (l(_c76, _g20, _s217.z, _x18, _s217.y), _p51 && (l(_c76, _h60, _s217.z, _s217.x, _s217.y + 1), l(_c76, _g20, _s217.z, _x18, _s217.y + 1)));
            }
          }
          var c = [];
          var _iterator328 = _createForOfIteratorHelper(r),
            _step328;
          try {
            var _loop13 = function _loop13() {
              var e = _step328.value;
              r.some(function (t) {
                return e.isChildOf(t);
              }) || c.push(e);
            };
            for (_iterator328.s(); !(_step328 = _iterator328.n()).done;) {
              _loop13();
            }
          } catch (err) {
            _iterator328.e(err);
          } finally {
            _iterator328.f();
          }
          if (r = c.filter(function (e) {
            return !t.some(function (t) {
              return !!(e.overscaledZ < i && t.isChildOf(e)) || e.equals(t) || e.isChildOf(t);
            });
          }), n) {
            var _e455 = 1 << i,
              _t483 = "globe" === this.projection.name ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()),
              _o164 = [_e455 * _t483.x, _e455 * _t483.y],
              _a172 = 4,
              _n252 = _a172 * _a172;
            r = r.filter(function (e) {
              var t = e.canonical.x + .5 - _o164[0],
                i = e.canonical.y + .5 - _o164[1];
              return t * t + i * i < _n252;
            });
          }
          return r;
        }
      }, {
        key: "coveringTiles",
        value: function coveringTiles(t) {
          var _this106 = this;
          var i = this.coveringZoomLevel(t);
          var o = i,
            r = this.elevation && this.elevation.exaggeration(),
            a = r && !t.isTerrainDEM,
            n = "mercator" === this.projection.name;
          if (void 0 !== t.minzoom && i < t.minzoom) return [];
          void 0 !== t.maxzoom && i > t.maxzoom && (i = t.maxzoom);
          var s = this.locationCoordinate(this.center),
            l = this.center.lat,
            c = 1 << i,
            h = [c * s.x, c * s.y, 0],
            _ = "globe" === this.projection.name,
            u = !_,
            d = e.aM.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i, u),
            p = _ ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()),
            f = c * e.ay(1, this.center.lat),
            m = this._camera.position[2] / e.ay(1, this.center.lat),
            g = [c * p.x, c * p.y, m * (u ? 1 : f)],
            v = _ || r,
            x = this.cameraToCenterDistance / t.tileSize * (t.roundZoom ? 1 : .502),
            y = this.isLODDisabled(!0) ? i : 0;
          var b;
          if (this._elevation && t.isTerrainDEM) b = 1e4 * this._elevation.exaggeration();else if (this._elevation) {
            var _e456 = this._elevation.getMinMaxForVisibleTiles();
            b = _e456 ? _e456.max : this._centerAltitude;
          } else b = this._centerAltitude;
          var w = t.isTerrainDEM ? -b : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0,
            T = this.projection.isReprojectedInTileSpace ? e.aN(this) : 1,
            E = function E(t) {
              var i = 1 / 4e4,
                o = new e._(t.x + i, t.y, t.z),
                r = new e._(t.x, t.y + i, t.z),
                a = t.toLngLat(),
                n = o.toLngLat(),
                s = r.toLngLat(),
                l = _this106.locationCoordinate(a),
                c = _this106.locationCoordinate(n),
                h = _this106.locationCoordinate(s),
                _ = Math.hypot(c.x - l.x, c.y - l.y),
                u = Math.hypot(h.x - l.x, h.y - l.y);
              return Math.sqrt(_ * u) * T / i;
            },
            C = function C(t) {
              var i = b,
                o = w;
              return {
                aabb: e.aR(_this106, c, 0, 0, 0, t, o, i, _this106.projection),
                zoom: 0,
                x: 0,
                y: 0,
                minZ: o,
                maxZ: i,
                wrap: t,
                fullyVisible: !1
              };
            },
            S = [];
          var I = [];
          var L = i,
            P = t.reparseOverscaled ? o : i,
            R = (m - this._centerAltitude) * f,
            D = function D(e) {
              if (!_this106._elevation || !e.tileID || !n) return;
              var t = _this106._elevation.getMinMaxForTile(e.tileID),
                i = e.aabb;
              t ? (i.min[2] = t.min, i.max[2] = t.max, i.center[2] = (i.min[2] + i.max[2]) / 2) : (e.shouldSplit = M(e), e.shouldSplit || (i.min[2] = i.max[2] = i.center[2] = _this106._centerAltitude));
            },
            A = function A(e, t) {
              if (.707 * t < e) return 1;
              var i = t / e;
              return i / (1.4144271570014144 + (Math.pow(1.1, i - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
            },
            M = function M(t) {
              if (t.zoom < y) return !0;
              if (t.zoom === L) return !1;
              if (null != t.shouldSplit) return t.shouldSplit;
              var i = t.aabb.distanceX(g),
                r = t.aabb.distanceY(g);
              var s = R,
                c = 1;
              if (_) {
                s = t.aabb.distanceZ(g);
                var _i287 = Math.pow(2, t.zoom),
                  _o165 = e.az((t.y + 1) / _i287),
                  _r360 = e.az(t.y / _i287),
                  _a173 = Math.min(Math.max(l, _o165), _r360),
                  _n253 = e.b6(_a173) / e.b6(l);
                if (c = _a173 === l ? 1 / Math.max(1, _this106._mercatorScaleRatio - .3) : Math.min(1, _n253 / _this106._mercatorScaleRatio), _this106.zoom <= e.b3 && t.zoom === L - 1 && _n253 >= .9) return !0;
              } else if (a && (s = t.aabb.distanceZ(g) * f), _this106.projection.isReprojectedInTileSpace && o <= 5) {
                var _i288 = Math.pow(2, t.zoom),
                  _o166 = E(new e._((t.x + .5) / _i288, (t.y + .5) / _i288));
                c = _o166 > .85 ? 1 : _o166;
              }
              if (!n) {
                var _e457 = Math.sqrt(i * i + r * r + s * s);
                var _o167 = (1 << L - t.zoom) * x * c;
                return _o167 *= A(Math.max(s, R), _e457), _e457 < _o167;
              }
              var u = Number.MAX_VALUE,
                d = 0;
              var p = t.aabb.getCorners(),
                m = [];
              var _iterator329 = _createForOfIteratorHelper(p),
                _step329;
              try {
                for (_iterator329.s(); !(_step329 = _iterator329.n()).done;) {
                  var _t484 = _step329.value;
                  e.$.sub(m, _t484, g), _ || (a ? m[2] *= f : m[2] = R);
                  var _i289 = e.$.dot(m, _this106._camera.forward());
                  _i289 < u && (u = _i289, d = Math.abs(m[2]));
                }
              } catch (err) {
                _iterator329.e(err);
              } finally {
                _iterator329.f();
              }
              var v = (1 << L - t.zoom) * x * c;
              if (v *= A(Math.max(d, R), u), u < v) return !0;
              var b = t.aabb.closestPoint(h);
              return b[0] === h[0] && b[1] === h[1];
            };
          if (this.renderWorldCopies) for (var _e458 = 1; _e458 <= 3; _e458++) S.push(C(-_e458)), S.push(C(_e458));
          var _loop14 = function _loop14() {
              var o = S.pop(),
                r = o.x,
                s = o.y;
              var l = o.fullyVisible;
              var u = function u() {
                return "globe" === _this106.projection.name && (0 === o.y || o.y === (1 << o.zoom) - 1);
              };
              if (!l) {
                var _t485 = v ? o.aabb.intersects(d) : o.aabb.intersectsFlat(d);
                if (0 === _t485 && u()) {
                  var _i292 = new e.aO(o.zoom, r, s);
                  _t485 = e.aP(_this106, c, _i292, !0).intersects(d);
                }
                if (0 === _t485) return 0; // continue
                l = 2 === _t485;
              }
              if (o.zoom !== L && M(o)) for (var _t486 = 0; _t486 < 4; _t486++) {
                var _i293 = (r << 1) + _t486 % 2,
                  _h61 = (s << 1) + (_t486 >> 1),
                  _u84 = {
                    aabb: n ? o.aabb.quadrant(_t486) : e.aR(_this106, c, o.zoom + 1, _i293, _h61, o.wrap, o.minZ, o.maxZ, _this106.projection),
                    zoom: o.zoom + 1,
                    x: _i293,
                    y: _h61,
                    wrap: o.wrap,
                    fullyVisible: l,
                    tileID: void 0,
                    shouldSplit: void 0,
                    minZ: o.minZ,
                    maxZ: o.maxZ
                  };
                a && !_ && (_u84.tileID = new e.aQ(o.zoom + 1 === L ? P : o.zoom + 1, o.wrap, o.zoom + 1, _i293, _h61), D(_u84)), S.push(_u84);
              } else {
                var _a175 = o.zoom === L ? P : o.zoom;
                if (t.minzoom && t.minzoom > _a175) return 0; // continue
                var _n255 = 0;
                if (!l) {
                  var _i294 = v ? o.aabb.intersectsPrecise(d) : o.aabb.intersectsPreciseFlat(d);
                  if (0 === _i294 && u()) {
                    var _t487 = new e.aO(o.zoom, r, s);
                    _i294 = e.aP(_this106, c, _t487, !0).intersectsPrecise(d);
                  }
                  if (0 === _i294) return 0; // continue
                  if (t.calculateQuadrantVisibility) if (d.containsPoint(o.aabb.center)) _n255 = 15;else for (var _e459 = 0; _e459 < 4; _e459++) 0 !== o.aabb.quadrant(_e459).intersects(d) && (_n255 |= 1 << _e459);
                }
                var _14 = h[0] - (.5 + r + (o.wrap << o.zoom)) * (1 << i - o.zoom),
                  _p52 = h[1] - .5 - s,
                  _f45 = o.tileID ? o.tileID : new e.aQ(_a175, o.wrap, o.zoom, r, s);
                t.calculateQuadrantVisibility && (_f45.visibleQuadrants = _n255), I.push({
                  tileID: _f45,
                  distanceSq: _14 * _14 + _p52 * _p52
                });
              }
            },
            _ret4;
          for (S.push(C(0)); S.length > 0;) {
            _ret4 = _loop14();
            if (_ret4 === 0) continue;
          }
          if (this.fogCullDistSq) {
            var _i290 = this.fogCullDistSq,
              _o168 = this.horizonLineFromTop();
            I = I.filter(function (r) {
              var a = [0, 0, 0, 1],
                n = [e.a4, e.a4, 0, 1],
                s = _this106.calculateFogTileMatrix(r.tileID.toUnwrapped());
              e.aB.transformMat4(a, a, s), e.aB.transformMat4(n, n, s);
              var l = e.aB.min([], a, n),
                c = e.aB.max([], a, n),
                h = e.aS(l, c);
              if (0 === h) return !0;
              var _ = !1;
              var u = _this106._elevation;
              if (u && h > _i290 && 0 !== _o168) {
                var _i291 = _this106.calculateProjMatrix(r.tileID.toUnwrapped());
                var _a174;
                t.isTerrainDEM || (_a174 = u.getMinMaxForTile(r.tileID)), _a174 || (_a174 = {
                  min: w,
                  max: b
                });
                var _n254 = e.b4(_this106.rotation),
                  _s218 = [_n254[0] * e.a4, _n254[1] * e.a4, _a174.max];
                e.$.transformMat4(_s218, _s218, _i291), _ = (1 - _s218[1]) * _this106.height * .5 < _o168;
              }
              return h < _i290 || _;
            });
          }
          return I.sort(function (e, t) {
            return e.distanceSq - t.distanceSq;
          }).map(function (e) {
            return e.tileID;
          });
        }
      }, {
        key: "resize",
        value: function resize(e, t) {
          this.width = e, this.height = t, this.pixelsToGLUnits = [2 / e, -2 / t], this._constrain(), this._calcMatrices();
        }
      }, {
        key: "unmodified",
        get: function get() {
          return this._unmodified;
        }
      }, {
        key: "zoomScale",
        value: function zoomScale(e) {
          return Math.pow(2, e);
        }
      }, {
        key: "scaleZoom",
        value: function scaleZoom(e) {
          return Math.log(e) / Math.LN2;
        }
      }, {
        key: "project",
        value: function project(t) {
          var i = e.au(t.lat, -e.aT, e.aT),
            o = this.projection.project(t.lng, i);
          return new e.P(o.x * this.worldSize, o.y * this.worldSize);
        }
      }, {
        key: "unproject",
        value: function unproject(e) {
          return this.projection.unproject(e.x / this.worldSize, e.y / this.worldSize);
        }
      }, {
        key: "point",
        get: function get() {
          return this.project(this.center);
        }
      }, {
        key: "pointMerc",
        get: function get() {
          return this.point._div(this.worldSize);
        }
      }, {
        key: "pixelsPerMeterRatio",
        get: function get() {
          return this.pixelsPerMeter / e.ay(1, this.center.lat) / this.worldSize;
        }
      }, {
        key: "setLocationAtPoint",
        value: function setLocationAtPoint(t, i) {
          var o, r;
          var a = this.centerPoint;
          if ("globe" === this.projection.name) {
            var _e460 = this.worldSize;
            o = (i.x - a.x) / _e460, r = (i.y - a.y) / _e460;
          } else {
            var _e461 = this.pointCoordinate(i),
              _t488 = this.pointCoordinate(a);
            o = _e461.x - _t488.x, r = _e461.y - _t488.y;
          }
          var n = this.locationCoordinate(t);
          this.setLocation(new e._(n.x - o, n.y - r));
        }
      }, {
        key: "setLocation",
        value: function setLocation(e) {
          this.center = this.coordinateLocation(e), this.projection.wrap && (this.center = this.center.wrap());
        }
      }, {
        key: "locationPoint",
        value: function locationPoint(e) {
          return this.projection.locationPoint(this, e);
        }
      }, {
        key: "locationPoint3D",
        value: function locationPoint3D(e) {
          return this.projection.locationPoint(this, e, !0);
        }
      }, {
        key: "pointLocation",
        value: function pointLocation(e) {
          return this.coordinateLocation(this.pointCoordinate(e));
        }
      }, {
        key: "pointLocation3D",
        value: function pointLocation3D(e) {
          return this.coordinateLocation(this.pointCoordinate3D(e));
        }
      }, {
        key: "locationCoordinate",
        value: function locationCoordinate(t, i) {
          var o = i ? e.ay(i, t.lat) : void 0,
            r = this.projection.project(t.lng, t.lat);
          return new e._(r.x, r.y, o);
        }
      }, {
        key: "coordinateLocation",
        value: function coordinateLocation(e) {
          return this.projection.unproject(e.x, e.y);
        }
      }, {
        key: "pointRayIntersection",
        value: function pointRayIntersection(t, i) {
          var o = null != i ? i : this._centerAltitude,
            r = [t.x, t.y, 0, 1],
            a = [t.x, t.y, 1, 1];
          e.aB.transformMat4(r, r, this.pixelMatrixInverse), e.aB.transformMat4(a, a, this.pixelMatrixInverse);
          var n = a[3];
          e.aB.scale(r, r, 1 / r[3]), e.aB.scale(a, a, 1 / n);
          var s = r[2],
            l = a[2];
          return {
            p0: r,
            p1: a,
            t: s === l ? 0 : (o - s) / (l - s)
          };
        }
      }, {
        key: "screenPointToMercatorRay",
        value: function screenPointToMercatorRay(t) {
          var i = [t.x, t.y, 0, 1],
            o = [t.x, t.y, 1, 1];
          return e.aB.transformMat4(i, i, this.pixelMatrixInverse), e.aB.transformMat4(o, o, this.pixelMatrixInverse), e.aB.scale(i, i, 1 / i[3]), e.aB.scale(o, o, 1 / o[3]), i[2] = e.ay(i[2], this._center.lat) * this.worldSize, o[2] = e.ay(o[2], this._center.lat) * this.worldSize, e.aB.scale(i, i, 1 / this.worldSize), e.aB.scale(o, o, 1 / this.worldSize), new e.aU([i[0], i[1], i[2]], e.$.normalize([], e.$.sub([], o, i)));
        }
      }, {
        key: "rayIntersectionCoordinate",
        value: function rayIntersectionCoordinate(t) {
          var i = t.p0,
            o = t.p1,
            r = t.t,
            a = e.ay(i[2], this._center.lat),
            n = e.ay(o[2], this._center.lat);
          return new e._(e.a3(i[0], o[0], r) / this.worldSize, e.a3(i[1], o[1], r) / this.worldSize, e.a3(a, n, r));
        }
      }, {
        key: "pointCoordinate",
        value: function pointCoordinate(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._centerAltitude;
          return this.projection.pointCoordinate(this, e.x, e.y, t);
        }
      }, {
        key: "pointCoordinate3D",
        value: function pointCoordinate3D(t) {
          if (!this.elevation) return this.pointCoordinate(t);
          var i = this.projection.pointCoordinate3D(this, t.x, t.y);
          if (i) return new e._(i[0], i[1], i[2]);
          var o = 0,
            r = this.horizonLineFromTop();
          if (t.y > r) return this.pointCoordinate(t);
          var a = .02 * r,
            n = t.clone();
          for (var _t489 = 0; _t489 < 10 && r - o > a; _t489++) {
            n.y = e.a3(o, r, .66);
            var _t490 = this.projection.pointCoordinate3D(this, n.x, n.y);
            _t490 ? (r = n.y, i = _t490) : o = n.y;
          }
          return i ? new e._(i[0], i[1], i[2]) : this.pointCoordinate(t);
        }
      }, {
        key: "isPointAboveHorizon",
        value: function isPointAboveHorizon(e) {
          return this.projection.isPointAboveHorizon(this, e);
        }
      }, {
        key: "isPointOnSurface",
        value: function isPointOnSurface(t) {
          if (t.y < 0 || t.y > this.height || t.x < 0 || t.x > this.width) return !1;
          if (this.elevation || this.zoom >= e.aV) return !this.isPointAboveHorizon(t);
          var i = this.pointCoordinate(t);
          return i.y >= 0 && i.y <= 1;
        }
      }, {
        key: "_coordinatePoint",
        value: function _coordinatePoint(t, i) {
          var o = i && this.elevation ? this.elevation.getAtPointOrZero(t, this._centerAltitude) : this._centerAltitude,
            r = [t.x * this.worldSize, t.y * this.worldSize, o + t.toAltitude(), 1];
          return e.aB.transformMat4(r, r, this.pixelMatrix), r[3] > 0 ? new e.P(r[0] / r[3], r[1] / r[3]) : new e.P(Number.MAX_VALUE, Number.MAX_VALUE);
        }
      }, {
        key: "_getBoundsNonRectangular",
        value: function _getBoundsNonRectangular() {
          var _this107 = this;
          var _this$_edgeInsets = this._edgeInsets,
            t = _this$_edgeInsets.top,
            i = _this$_edgeInsets.left,
            o = this.height - this._edgeInsets.bottom,
            r = this.width - this._edgeInsets.right,
            a = this.pointLocation3D(new e.P(i, t)),
            n = this.pointLocation3D(new e.P(r, t)),
            s = this.pointLocation3D(new e.P(r, o)),
            l = this.pointLocation3D(new e.P(i, o));
          var c = Math.min(a.lng, n.lng, s.lng, l.lng),
            h = Math.max(a.lng, n.lng, s.lng, l.lng),
            _ = Math.min(a.lat, n.lat, s.lat, l.lat),
            u = Math.max(a.lat, n.lat, s.lat, l.lat);
          var d = Math.pow(2, -this.zoom) / 16 * 270,
            p = "globe" === this.projection.name ? 1 : 4,
            f = function f(t, i, o, r, a) {
              var n = (t + o) / 2,
                s = (i + r) / 2,
                l = new e.P(n, s),
                _this107$pointLocatio = _this107.pointLocation3D(l),
                m = _this107$pointLocatio.lng,
                g = _this107$pointLocatio.lat,
                v = Math.max(0, c - m, _ - g, m - h, g - u);
              c = Math.min(c, m), h = Math.max(h, m), _ = Math.min(_, g), u = Math.max(u, g), (a < p || v > d) && (f(t, i, n, s, a + 1), f(n, s, o, r, a + 1));
            };
          if (f(i, t, r, t, 1), f(r, t, r, o, 1), f(r, o, i, o, 1), f(i, o, i, t, 1), "globe" === this.projection.name) {
            var _e$aW = e.aW(this),
              _e$aW2 = _slicedToArray(_e$aW, 2),
              _t491 = _e$aW2[0],
              _i295 = _e$aW2[1];
            _t491 ? (u = 90, h = 180, c = -180) : _i295 && (_ = -90, h = 180, c = -180);
          }
          return new e.aj(new e.aJ(c, _), new e.aJ(h, u));
        }
      }, {
        key: "_getBoundsRectangular",
        value: function _getBoundsRectangular(t, i) {
          var _this$_edgeInsets2 = this._edgeInsets,
            o = _this$_edgeInsets2.top,
            r = _this$_edgeInsets2.left,
            a = this.height - this._edgeInsets.bottom,
            n = this.width - this._edgeInsets.right,
            s = new e.P(r, o),
            l = new e.P(n, o),
            c = new e.P(n, a),
            h = new e.P(r, a);
          var _ = this.pointCoordinate(s, t),
            u = this.pointCoordinate(l, t);
          var d = this.pointCoordinate(c, i),
            p = this.pointCoordinate(h, i),
            f = function f(e, t) {
              return (t.y - e.y) / (t.x - e.x);
            };
          return _.y > 1 && u.y >= 0 ? _ = new e._((1 - p.y) / f(p, _) + p.x, 1) : _.y < 0 && u.y <= 1 && (_ = new e._(-p.y / f(p, _) + p.x, 0)), u.y > 1 && _.y >= 0 ? u = new e._((1 - d.y) / f(d, u) + d.x, 1) : u.y < 0 && _.y <= 1 && (u = new e._(-d.y / f(d, u) + d.x, 0)), new e.aj().extend(this.coordinateLocation(_)).extend(this.coordinateLocation(u)).extend(this.coordinateLocation(p)).extend(this.coordinateLocation(d));
        }
      }, {
        key: "_getBoundsRectangularTerrain",
        value: function _getBoundsRectangularTerrain() {
          var e = this.elevation;
          if (!e.visibleDemTiles.length || e.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
          var t = e.visibleDemTiles.reduce(function (e, t) {
            if (t.dem) {
              var _i296 = t.dem.tree;
              e.min = Math.min(e.min, _i296.minimums[0]), e.max = Math.max(e.max, _i296.maximums[0]);
            }
            return e;
          }, {
            min: Number.MAX_VALUE,
            max: 0
          });
          return this._getBoundsRectangular(t.min * e.exaggeration(), t.max * e.exaggeration());
        }
      }, {
        key: "getBounds",
        value: function getBounds() {
          return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
        }
      }, {
        key: "horizonLineFromTop",
        value: function horizonLineFromTop() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
          var t = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, .1)) - this.centerOffset.y,
            i = this.height / 2 - t * (1 - this._horizonShift);
          return e ? Math.max(0, i) : i;
        }
      }, {
        key: "getMaxBounds",
        value: function getMaxBounds() {
          return this.maxBounds;
        }
      }, {
        key: "setMaxBounds",
        value: function setMaxBounds(t) {
          this.maxBounds = t, this.minLat = -e.aT, this.maxLat = e.aT, this.minLng = -180, this.maxLng = 180, t && (this.minLat = t.getSouth(), this.maxLat = t.getNorth(), this.minLng = t.getWest(), this.maxLng = t.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = e.ak(this.minLng) * this.tileSize, this.worldMaxX = e.ak(this.maxLng) * this.tileSize, this.worldMinY = e.al(this.maxLat) * this.tileSize, this.worldMaxY = e.al(this.minLat) * this.tileSize, this._constrain();
        }
      }, {
        key: "calculatePosMatrix",
        value: function calculatePosMatrix(e, t) {
          return this.projection.createTileMatrix(this, t, e);
        }
      }, {
        key: "calculateDistanceTileData",
        value: function calculateDistanceTileData(t) {
          var i = t.key,
            o = this._distanceTileDataCache;
          if (o[i]) return o[i];
          var r = t.canonical,
            a = 1 / this.height,
            n = this.cameraWorldSize,
            s = n / this.zoomScale(r.z),
            l = (r.x + Math.pow(2, r.z) * t.wrap) * s,
            c = r.y * s,
            h = this.point;
          h.x *= n / this.worldSize, h.y *= n / this.worldSize;
          var _ = this.angle,
            u = Math.sin(-_),
            d = -Math.cos(-_);
          return o[i] = {
            bearing: [u, d],
            center: [(h.x - l) * a, (h.y - c) * a],
            scale: s / e.a4 * a
          }, o[i];
        }
      }, {
        key: "calculateFogTileMatrix",
        value: function calculateFogTileMatrix(t) {
          var i = t.key,
            o = this._fogTileMatrixCache;
          if (o[i]) return o[i];
          var r = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, t);
          return e.ae.multiply(r, this.worldToFogMatrix, r), o[i] = new Float32Array(r), o[i];
        }
      }, {
        key: "calculateProjMatrix",
        value: function calculateProjMatrix(t) {
          var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          var r = t.key;
          var a;
          if (a = o ? this._expandedProjMatrixCache : i ? this._alignedProjMatrixCache : this._projMatrixCache, a[r]) return a[r];
          var n = this.calculatePosMatrix(t, this.worldSize);
          var s;
          return s = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : o ? this.expandedFarZProjMatrix : i ? this.alignedProjMatrix : this.projMatrix, e.ae.multiply(n, s, n), a[r] = new Float32Array(n), a[r];
        }
      }, {
        key: "calculatePixelsToTileUnitsMatrix",
        value: function calculatePixelsToTileUnitsMatrix(t) {
          var i = t.tileID.key,
            o = this._pixelsToTileUnitsCache;
          if (o[i]) return o[i];
          var r = e.aX(t, this);
          return o[i] = r, o[i];
        }
      }, {
        key: "customLayerMatrix",
        value: function customLayerMatrix() {
          return this.mercatorMatrix.slice();
        }
      }, {
        key: "globeToMercatorMatrix",
        value: function globeToMercatorMatrix() {
          if ("globe" === this.projection.name) {
            var _t492 = 1 / this.worldSize,
              _i297 = e.ae.fromScaling([], [_t492, _t492, _t492]);
            return e.ae.multiply(_i297, _i297, this.globeMatrix), _i297;
          }
        }
      }, {
        key: "recenterOnTerrain",
        value: function recenterOnTerrain() {
          if (!this._elevation || "globe" === this.projection.name) return;
          var t = this._elevation;
          this._updateCameraState();
          var i = e.ay(1, this._center.lat) * this.worldSize,
            o = this._computeCameraPosition(i),
            r = this._camera.forward(),
            a = e.ay(1, this._center.lat);
          o[2] /= a, r[2] /= a, e.$.normalize(r, r);
          var n = t.raycast(o, r, t.exaggeration());
          if (n) {
            var _t493 = e.$.scaleAndAdd([], o, r, n),
              _i298 = new e._(_t493[0], _t493[1], e.ay(_t493[2], e.az(_t493[1]))),
              _s219 = (_i298.z + e.$.length([_i298.x - o[0], _i298.y - o[1], _i298.z - o[2] * a])) * this._pixelsPerMercatorPixel;
            this._seaLevelZoom = this._zoomFromMercatorZ(_s219), this._centerAltitude = _i298.toAltitude(), this._center = this.coordinateLocation(_i298), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
          }
        }
      }, {
        key: "_constrainCamera",
        value: function _constrainCamera() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          if (!this._elevation) return;
          var i = this._elevation,
            o = e.ay(1, this._center.lat) * this.worldSize,
            r = this._computeCameraPosition(o),
            a = i.getAtPointOrZero(_construct2(e._, _toConsumableArray(r))),
            n = this.pixelsPerMeter / this.worldSize * a,
            s = this._minimumHeightOverTerrain(),
            l = r[2] - n;
          if (l <= s) if (l < 0 || t) {
            var _t494 = this.locationCoordinate(this._center, this._centerAltitude),
              _i299 = [r[0], r[1], _t494.z - r[2]],
              _o169 = e.$.length(_i299);
            _i299[2] -= (s - l) / this._pixelsPerMercatorPixel;
            var _a176 = e.$.length(_i299);
            if (0 === _a176) return;
            e.$.scale(_i299, _i299, _o169 / _a176 * this._pixelsPerMercatorPixel), this._camera.position = [r[0], r[1], _t494.z * this._pixelsPerMercatorPixel - _i299[2]], this._updateStateFromCamera();
          } else this._isCameraConstrained = !0;
        }
      }, {
        key: "_constrain",
        value: function _constrain() {
          if (!this.center || !this.width || !this.height || this._constraining) return;
          this._constraining = !0;
          var t = "globe" === this.projection.name || this.mercatorFromTransition;
          if (this.projection.isReprojectedInTileSpace || t) {
            var _i300 = this.center;
            return _i300.lat = e.au(_i300.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !t) && (_i300.lng = e.au(_i300.lng, this.minLng, this.maxLng)), this.center = _i300, void (this._constraining = !1);
          }
          var i = this._unmodified,
            _this$point = this.point,
            o = _this$point.x,
            r = _this$point.y;
          var a = 0,
            n = o,
            s = r;
          var l = this.width / 2,
            c = this.height / 2,
            h = this.worldMinY * this.scale,
            _ = this.worldMaxY * this.scale;
          if (r - c < h && (s = h + c), r + c > _ && (s = _ - c), _ - h < this.height && (a = Math.max(a, this.height / (_ - h)), s = (_ + h) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
            var _e462 = this.worldMinX * this.scale,
              _t495 = this.worldMaxX * this.scale,
              _i301 = this.worldSize / 2 - (_e462 + _t495) / 2;
            n = (o + _i301 + this.worldSize) % this.worldSize - _i301, n - l < _e462 && (n = _e462 + l), n + l > _t495 && (n = _t495 - l), _t495 - _e462 < this.width && (a = Math.max(a, this.width / (_t495 - _e462)), n = (_t495 + _e462) / 2);
          }
          n === o && s === r || (this.center = this.unproject(new e.P(n, s))), a && (this.zoom += this.scaleZoom(a)), this._constrainCamera(), this._unmodified = i, this._constraining = !1;
        }
      }, {
        key: "_minZoomForBounds",
        value: function _minZoomForBounds() {
          var e = Math.max(0, this.scaleZoom(this.height / (this.worldMaxY - this.worldMinY)));
          return this.maxBounds && (e = Math.max(e, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e;
        }
      }, {
        key: "_maxCameraBoundsDistance",
        value: function _maxCameraBoundsDistance() {
          return this._mercatorZfromZoom(this._minZoomForBounds());
        }
      }, {
        key: "_calcMatrices",
        value: function _calcMatrices() {
          if (!this.height) return;
          var t = this.centerOffset,
            i = "globe" === this.projection.name,
            o = this.pixelsPerMeter;
          "globe" === this.projection.name && (this._mercatorScaleRatio = e.ay(1, this.center.lat) / e.ay(1, e.b5));
          var r = e.aY(this.projection, this.zoom, this.width, this.height, 1024);
          this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, r), this.cameraToCenterDistance = .5 / Math.tan(.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
          var a = "meters" === this.projection.zAxisUnit ? o : 1,
            n = this._camera.getWorldToCamera(this.worldSize, a);
          var s;
          var l = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
          if (l[8] = 2 * -t.x / this.width, l[9] = 2 * t.y / this.height, this.isOrthographic) {
            var _e463 = .5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(.5 * this._fov),
              _i302 = _e463 * this.aspect,
              _o170 = -_i302,
              _r361 = -_e463;
            _i302 -= t.x, _o170 -= t.x, _e463 += t.y, _r361 += t.y, s = this._camera.getCameraToClipOrthographic(_o170, _i302, _r361, _e463, this._nearZ, this._farZ), function (e, t, i, o) {
              for (var _r362 = 0; _r362 < 16; _r362++) e[_r362] = li(t[_r362], i[_r362], o);
            }(s, s, l, ci(this.pitch >= 15 ? 1 : this.pitch / 15));
          } else s = l;
          var c = e.ae.mul([], l, n);
          var h = e.ae.mul([], s, n);
          if (this.projection.isReprojectedInTileSpace) {
            var _t496 = this.locationCoordinate(this.center),
              _i303 = e.ae.identity([]);
            e.ae.translate(_i303, _i303, [_t496.x * this.worldSize, _t496.y * this.worldSize, 0]), e.ae.multiply(_i303, _i303, e.aZ(this)), e.ae.translate(_i303, _i303, [-_t496.x * this.worldSize, -_t496.y * this.worldSize, 0]), e.ae.multiply(h, h, _i303), e.ae.multiply(c, c, _i303), this.inverseAdjustmentMatrix = e.a_(this);
          } else this.inverseAdjustmentMatrix = [1, 0, 0, 1];
          if (this.mercatorMatrix = e.ae.scale([], h, [this.worldSize, this.worldSize, this.worldSize / a, 1]), this.projMatrix = h, this.invProjMatrix = e.ae.invert(new Float64Array(16), this.projMatrix), i) {
            var _i304 = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
            _i304[8] = 2 * -t.x / this.width, _i304[9] = 2 * t.y / this.height, this.expandedFarZProjMatrix = e.ae.mul([], _i304, n);
          } else this.expandedFarZProjMatrix = this.projMatrix;
          var _ = e.ae.invert([], s);
          this.frustumCorners = e.a$.fromInvProjectionMatrix(_, this.horizonLineFromTop(), this.height), this.cameraFrustum = e.aM.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !i);
          var u = new Float32Array(16);
          e.ae.identity(u), e.ae.scale(u, u, [1, -1, 1]), e.ae.rotateX(u, u, this._pitch), e.ae.rotateZ(u, u, this.angle);
          var d = e.ae.perspective(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ);
          this.starsProjMatrix = e.ae.clone(d);
          var p = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
          d[8] = 2 * -t.x / this.width, d[9] = 2 * (t.y + p) / this.height, this.skyboxMatrix = e.ae.multiply(u, d, u);
          var f = this.point,
            m = f.x,
            g = f.y,
            v = this.width % 2 / 2,
            x = this.height % 2 / 2,
            y = Math.cos(this.angle),
            b = Math.sin(this.angle),
            w = m - Math.round(m) + y * v + b * x,
            T = g - Math.round(g) + y * x + b * v,
            E = new Float64Array(h);
          if (e.ae.translate(E, E, [w > .5 ? w - 1 : w, T > .5 ? T - 1 : T, 0]), this.alignedProjMatrix = E, h = e.ae.create(), e.ae.scale(h, h, [this.width / 2, -this.height / 2, 1]), e.ae.translate(h, h, [1, -1, 0]), this.labelPlaneMatrix = h, h = e.ae.create(), e.ae.scale(h, h, [1, -1, 1]), e.ae.translate(h, h, [-1, -1, 0]), e.ae.scale(h, h, [2 / this.width, 2 / this.height, 1]), this.glCoordMatrix = h, this.pixelMatrix = e.ae.multiply(new Float64Array(16), this.labelPlaneMatrix, c), this._calcFogMatrices(), this._distanceTileDataCache = {}, h = e.ae.invert(new Float64Array(16), this.pixelMatrix), !h) throw new Error("failed to invert matrix");
          if (this.pixelMatrixInverse = h, "globe" === this.projection.name || this.mercatorFromTransition) {
            this.globeMatrix = e.b0(this);
            var _t497 = [this.globeMatrix[12], this.globeMatrix[13], this.globeMatrix[14]];
            this.globeCenterInViewSpace = e.$.transformMat4(_t497, _t497, n), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
          } else this.globeMatrix = h;
          this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
        }
      }, {
        key: "_calcFogMatrices",
        value: function _calcFogMatrices() {
          this._fogTileMatrixCache = {};
          var t = this.cameraWorldSizeForFog,
            i = this.cameraPixelsPerMeter,
            o = this._camera.position,
            r = 1 / this.height / this._pixelsPerMercatorPixel,
            a = [t, t, i];
          e.$.scale(a, a, r), e.$.scale(o, o, -1), e.$.multiply(o, o, a);
          var n = e.ae.create();
          e.ae.translate(n, n, o), e.ae.scale(n, n, a), this.mercatorFogMatrix = n, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(t, i, r);
        }
      }, {
        key: "_computeCameraPosition",
        value: function _computeCameraPosition(e) {
          var t = (e = e || this.pixelsPerMeter) / this.pixelsPerMeter,
            i = this._camera.forward(),
            o = this.point,
            r = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t - e / this.worldSize * this._centerAltitude;
          return [o.x / this.worldSize - i[0] * r, o.y / this.worldSize - i[1] * r, e / this.worldSize * this._centerAltitude - i[2] * r];
        }
      }, {
        key: "_updateCameraState",
        value: function _updateCameraState() {
          this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
        }
      }, {
        key: "_translateCameraConstrained",
        value: function _translateCameraConstrained(t) {
          var i = this._maxCameraBoundsDistance() * Math.cos(this._pitch),
            o = this._camera.position[2],
            r = t[2];
          var a = 1;
          this.projection.wrap && (this.center = this.center.wrap()), r > 0 && (a = Math.min((i - o) / r, 1)), this._camera.position = e.$.scaleAndAdd([], this._camera.position, t, a), this._updateStateFromCamera();
        }
      }, {
        key: "_updateStateFromCamera",
        value: function _updateStateFromCamera() {
          var t = this._camera.position,
            i = this._camera.forward(),
            _this$_camera$getPitc = this._camera.getPitchBearing(),
            o = _this$_camera$getPitc.pitch,
            r = _this$_camera$getPitc.bearing,
            a = e.ay(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel,
            n = this._mercatorZfromZoom(this._maxZoom) * Math.cos(e.ac(this._maxPitch)),
            s = Math.max((t[2] - a) / Math.cos(o), n),
            l = this._zoomFromMercatorZ(s);
          e.$.scaleAndAdd(t, t, i, s), this._pitch = e.au(o, e.ac(this.minPitch), e.ac(this.maxPitch)), this.angle = e.av(r, -Math.PI, Math.PI), this._setZoom(e.au(l, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new e._(t[0], t[1], t[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
        }
      }, {
        key: "_worldSizeFromZoom",
        value: function _worldSizeFromZoom(e) {
          return Math.pow(2, e) * this.tileSize;
        }
      }, {
        key: "_mercatorZfromZoom",
        value: function _mercatorZfromZoom(e) {
          return this.cameraToCenterDistance / this._worldSizeFromZoom(e);
        }
      }, {
        key: "_minimumHeightOverTerrain",
        value: function _minimumHeightOverTerrain() {
          var e = Math.min(null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom, this._maxZoom) + 4;
          return this._mercatorZfromZoom(e);
        }
      }, {
        key: "_zoomFromMercatorZ",
        value: function _zoomFromMercatorZ(e) {
          return this.scaleZoom(this.cameraToCenterDistance / (e * this.tileSize));
        }
      }, {
        key: "zoomFromMercatorZAdjusted",
        value: function zoomFromMercatorZAdjusted(t) {
          var i = 0,
            o = e.aV,
            r = 0,
            a = 1 / 0;
          for (; o - i > 1e-6 && o > i;) {
            var _e464 = i + .5 * (o - i),
              _n256 = this.tileSize * Math.pow(2, _e464),
              _s220 = this.getCameraToCenterDistance(this.projection, _e464, _n256),
              _l105 = this.scaleZoom(_s220 / (t * this.tileSize)),
              _c77 = Math.abs(_e464 - _l105);
            _c77 < a && (a = _c77, r = _e464), _e464 < _l105 ? i = _e464 : o = _e464;
          }
          return r;
        }
      }, {
        key: "_terrainEnabled",
        value: function _terrainEnabled() {
          return !(!this._elevation || !this.projection.supportsTerrain && (e.w("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
        }
      }, {
        key: "anyCornerOffEdge",
        value: function anyCornerOffEdge(t, i) {
          var o = Math.min(t.x, i.x),
            r = Math.max(t.x, i.x),
            a = Math.min(t.y, i.y),
            n = Math.max(t.y, i.y);
          if (a < this.horizonLineFromTop(!1)) return !0;
          if ("mercator" !== this.projection.name) return !1;
          var s = [new e.P(o, a), new e.P(r, n), new e.P(o, n), new e.P(r, a)],
            l = this.renderWorldCopies ? -3 : 0,
            c = this.renderWorldCopies ? 4 : 1;
          for (var _i305 = 0, _s221 = s; _i305 < _s221.length; _i305++) {
            var _e465 = _s221[_i305];
            var _t498 = this.pointRayIntersection(_e465);
            if (_t498.t < 0) return !0;
            var _i306 = this.rayIntersectionCoordinate(_t498);
            if (_i306.x < l || _i306.y < 0 || _i306.x > c || _i306.y > 1) return !0;
          }
          return !1;
        }
      }, {
        key: "isHorizonVisible",
        value: function isHorizonVisible() {
          return this.pitch + e.b1(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new e.P(0, 0), new e.P(this.width, this.height));
        }
      }, {
        key: "zoomDeltaToMovement",
        value: function zoomDeltaToMovement(t, i) {
          var o = e.$.length(e.$.sub([], this._camera.position, t)),
            r = this._zoomFromMercatorZ(o) + i;
          return o - this._mercatorZfromZoom(r);
        }
      }, {
        key: "getCameraPoint",
        value: function getCameraPoint() {
          if ("globe" === this.projection.name) {
            var _t499 = function (_ref162, r) {
              var _ref163 = _slicedToArray(_ref162, 3),
                t = _ref163[0],
                i = _ref163[1],
                o = _ref163[2];
              var a = [t, i, o, 1];
              e.aB.transformMat4(a, a, r);
              var n = a[3] = Math.max(a[3], 1e-6);
              return a[0] /= n, a[1] /= n, a[2] /= n, a;
            }([this.globeMatrix[12], this.globeMatrix[13], this.globeMatrix[14]], this.pixelMatrix);
            return new e.P(_t499[0], _t499[1]);
          }
          {
            var _t500 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
            return this.centerPoint.add(new e.P(0, _t500));
          }
        }
      }, {
        key: "getCameraToCenterDistance",
        value: function getCameraToCenterDistance(t) {
          var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.zoom;
          var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.worldSize;
          var r = e.aY(t, i, this.width, this.height, 1024),
            a = t.pixelSpaceConversion(this.center.lat, o, r);
          var n = .5 / Math.tan(.5 * this._fov) * this.height * a;
          return this.isOrthographic && (n = li(1, n, ci(this.pitch >= 15 ? 1 : this.pitch / 15))), n;
        }
      }, {
        key: "getWorldToCameraMatrix",
        value: function getWorldToCameraMatrix() {
          var t = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
          return "globe" === this.projection.name && e.ae.multiply(t, t, this.globeMatrix), t;
        }
      }, {
        key: "getFrustum",
        value: function getFrustum(t) {
          return e.aM.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, t, "meters" === this.projection.zAxisUnit);
        }
      }]);
      return hi;
    }();
    var _i = {
        BaseColor: 5,
        MetallicRoughness: 6,
        Normal: 7,
        Occlusion: 8,
        Emission: 9,
        LUT: 10,
        ShadowMap0: 11
      },
      ui = function ui(t, i) {
        if (i > 0 && t.terrain && e.w("Cutoff is currently disabled on terrain"), i <= 0 || t.terrain) return {
          shouldRenderCutoff: !1,
          uniformValues: {
            u_cutoff_params: [0, 0, 0, 1]
          }
        };
        var o = t.transform,
          r = Math.max(Math.abs(o._zoom - (t.minCutoffZoom - 1)), 1),
          a = o.isLODDisabled(!1) ? e.a0(60, 45, o.pitch) : e.a0(30, 15, o.pitch),
          n = o._farZ - o._nearZ,
          s = i * o.height,
          l = ((1 - (c = a)) * o.cameraToCenterDistance + c * (o._farZ + s)) * r;
        var c;
        return {
          shouldRenderCutoff: a < 1,
          uniformValues: {
            u_cutoff_params: [o._nearZ, o._farZ, (l - o._nearZ) / n, (l - s - o._nearZ) / n]
          }
        };
      },
      di = {
        cascadeCount: 2,
        normalOffset: 3,
        shadowMapResolution: 2048
      };
    var pi = /*#__PURE__*/_createClass(function pi(e, t) {
      _classCallCheck(this, pi);
      this.aabb = e, this.lastCascade = t;
    });
    var fi = /*#__PURE__*/function () {
      function fi() {
        _classCallCheck(this, fi);
      }
      _createClass(fi, [{
        key: "add",
        value: function add(e, t) {
          var i = this.receivers[e.key];
          void 0 !== i ? (i.aabb.min[0] = Math.min(i.aabb.min[0], t.min[0]), i.aabb.min[1] = Math.min(i.aabb.min[1], t.min[1]), i.aabb.min[2] = Math.min(i.aabb.min[2], t.min[2]), i.aabb.max[0] = Math.max(i.aabb.max[0], t.max[0]), i.aabb.max[1] = Math.max(i.aabb.max[1], t.max[1]), i.aabb.max[2] = Math.max(i.aabb.max[2], t.max[2])) : this.receivers[e.key] = new pi(t, null);
        }
      }, {
        key: "clear",
        value: function clear() {
          this.receivers = {};
        }
      }, {
        key: "get",
        value: function get(e) {
          return this.receivers[e.key];
        }
      }, {
        key: "computeRequiredCascades",
        value: function computeRequiredCascades(t, i, o) {
          var r = e.b8.fromPoints(t.points);
          var a = 0;
          for (var _t501 in this.receivers) {
            var _n257 = this.receivers[_t501];
            if (!_n257) continue;
            if (!r.intersectsAabb(_n257.aabb)) continue;
            _n257.aabb.min = r.closestPoint(_n257.aabb.min), _n257.aabb.max = r.closestPoint(_n257.aabb.max);
            var _s222 = _n257.aabb.getCorners();
            for (var _t502 = 0; _t502 < o.length; _t502++) {
              var _r363 = !0;
              var _iterator330 = _createForOfIteratorHelper(_s222),
                _step330;
              try {
                for (_iterator330.s(); !(_step330 = _iterator330.n()).done;) {
                  var _a177 = _step330.value;
                  var _n258 = [_a177[0] * i, _a177[1] * i, _a177[2]];
                  if (e.$.transformMat4(_n258, _n258, o[_t502].matrix), _n258[0] < -1 || _n258[0] > 1 || _n258[1] < -1 || _n258[1] > 1) {
                    _r363 = !1;
                    break;
                  }
                }
              } catch (err) {
                _iterator330.e(err);
              } finally {
                _iterator330.f();
              }
              if (_n257.lastCascade = _t502, a = Math.max(a, _t502), _r363) break;
            }
          }
          return a + 1;
        }
      }]);
      return fi;
    }();
    var mi = /*#__PURE__*/function () {
      function mi(t) {
        var _this108 = this;
        _classCallCheck(this, mi);
        this.painter = t, this._enabled = !1, this._shadowLayerCount = 0, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new fi(), this._depthMode = new e.af(t.context.gl.LEQUAL, e.af.ReadWrite, [0, 1]), this._uniformValues = {
          u_light_matrix_0: new Float32Array(16),
          u_light_matrix_1: new Float32Array(16),
          u_shadow_intensity: 0,
          u_fade_range: [0, 0],
          u_shadow_normal_offset: [1, 1, 1],
          u_shadow_texel_size: 1,
          u_shadow_map_resolution: 1,
          u_shadow_direction: [0, 0, 1],
          u_shadow_bias: [36e-5, .0012, .012],
          u_shadowmap_0: 0,
          u_shadowmap_1: 0
        }, this._forceDisable = !1, this.useNormalOffset = !1, t.tp.registerParameter(this, ["Shadows"], "_forceDisable", {
          label: "forceDisable"
        }, function () {
          _this108.painter.style.map.triggerRepaint();
        }), t.tp.registerParameter(di, ["Shadows"], "cascadeCount", {
          min: 1,
          max: 2,
          step: 1
        }), t.tp.registerParameter(di, ["Shadows"], "normalOffset", {
          min: 0,
          max: 10,
          step: .05
        }), t.tp.registerParameter(di, ["Shadows"], "shadowMapResolution", {
          min: 32,
          max: 2048,
          step: 32
        }), t.tp.registerBinding(this, ["Shadows"], "_numCascadesToRender", {
          readonly: !0,
          label: "numCascadesToRender"
        });
      }
      _createClass(mi, [{
        key: "destroy",
        value: function destroy() {
          var _iterator331 = _createForOfIteratorHelper(this._cascades),
            _step331;
          try {
            for (_iterator331.s(); !(_step331 = _iterator331.n()).done;) {
              var _e466 = _step331.value;
              _e466.texture.destroy(), _e466.framebuffer.destroy();
            }
          } catch (err) {
            _iterator331.e(err);
          } finally {
            _iterator331.f();
          }
          this._cascades = [];
        }
      }, {
        key: "updateShadowParameters",
        value: function updateShadowParameters(t, i) {
          var o = this.painter;
          if (this._enabled = !1, this._shadowLayerCount = 0, this._receivers.clear(), !i || !i.properties) return;
          var r = i.properties.get("shadow-intensity");
          if (!i.shadowsEnabled() || r <= 0) return;
          if (this._shadowLayerCount = o.style.order.reduce(function (e, i) {
            var r = o.style._mergedLayers[i];
            return e + (r.hasShadowPass() && !r.isHidden(t.zoom) ? 1 : 0);
          }, 0), this._enabled = this._shadowLayerCount > 0, !this.enabled) return;
          var a = o.context,
            n = di.shadowMapResolution,
            s = di.shadowMapResolution;
          if (0 === this._cascades.length || di.shadowMapResolution !== this._cascades[0].texture.size[0]) {
            this._cascades = [];
            for (var _t503 = 0; _t503 < di.cascadeCount; ++_t503) {
              var _t504 = o._shadowMapDebug,
                _i307 = a.gl,
                _r364 = a.createFramebuffer(n, s, _t504, "texture"),
                _l106 = new e.T(a, {
                  width: n,
                  height: s,
                  data: null
                }, _i307.DEPTH_COMPONENT);
              if (_r364.depthAttachment.set(_l106.texture), _t504) {
                var _t505 = new e.T(a, {
                  width: n,
                  height: s,
                  data: null
                }, _i307.RGBA);
                _r364.colorAttachment.set(_t505.texture);
              }
              this._cascades.push({
                framebuffer: _r364,
                texture: _l106,
                matrix: [],
                far: 0,
                boundingSphereRadius: 0,
                frustum: new e.aM(),
                scale: 0
              });
            }
          }
          this.shadowDirection = vi(i);
          var l = 0;
          if (t.elevation) {
            var _e467 = t.elevation,
              _i308 = [1e4, -1e4];
            _e467.visibleDemTiles.filter(function (e) {
              return e.dem;
            }).forEach(function (e) {
              var t = e.dem.tree;
              _i308[0] = Math.min(_i308[0], t.minimums[0]), _i308[1] = Math.max(_i308[1], t.maximums[0]);
            }), 1e4 !== _i308[0] && (l = (_i308[1] - _i308[0]) * _e467.exaggeration());
          }
          var c = 1.5 * t.cameraToCenterDistance,
            h = 3 * c,
            _ = new Float64Array(16);
          for (var _i309 = 0; _i309 < this._cascades.length; ++_i309) {
            var _o171 = this._cascades[_i309];
            var _r365 = t.height / 50,
              _a178 = 1;
            1 === di.cascadeCount ? _a178 = h : 0 === _i309 ? _a178 = c : (_r365 = c, _a178 = h);
            var _yi = yi(t, this.shadowDirection, _r365, _a178, di.shadowMapResolution, l),
              _yi2 = _slicedToArray(_yi, 2),
              _n259 = _yi2[0],
              _s223 = _yi2[1];
            _o171.scale = t.scale, _o171.matrix = _n259, _o171.boundingSphereRadius = _s223, e.ae.invert(_, _o171.matrix), _o171.frustum = e.aM.fromInvProjectionMatrix(_, 1, 0, !0), _o171.far = _a178;
          }
          var u = this._cascades.length - 1;
          this._uniformValues.u_fade_range = [.75 * this._cascades[u].far, this._cascades[u].far], this._uniformValues.u_shadow_intensity = r, this._uniformValues.u_shadow_direction = [this.shadowDirection[0], this.shadowDirection[1], this.shadowDirection[2]], this._uniformValues.u_shadow_texel_size = 1 / di.shadowMapResolution, this._uniformValues.u_shadow_map_resolution = di.shadowMapResolution, this._uniformValues.u_shadowmap_0 = _i.ShadowMap0, this._uniformValues.u_shadowmap_1 = _i.ShadowMap0 + 1, this._groundShadowTiles = o.transform.coveringTiles({
            tileSize: 512,
            renderWorldCopies: !0
          });
          var d = o.transform.elevation;
          var _iterator332 = _createForOfIteratorHelper(this._groundShadowTiles),
            _step332;
          try {
            for (_iterator332.s(); !(_step332 = _iterator332.n()).done;) {
              var _e468 = _step332.value;
              var _t506 = {
                min: 0,
                max: 0
              };
              if (d) {
                var _i310 = d.getMinMaxForTile(_e468);
                _i310 && (_t506 = _i310);
              }
              this.addShadowReceiver(_e468.toUnwrapped(), _t506.min, _t506.max);
            }
          } catch (err) {
            _iterator332.e(err);
          } finally {
            _iterator332.f();
          }
        }
      }, {
        key: "enabled",
        get: function get() {
          return this._enabled && !this._forceDisable;
        },
        set: function set(e) {
          this._enabled = e;
        }
      }, {
        key: "drawShadowPass",
        value: function drawShadowPass(t, i) {
          if (!this.enabled) return;
          var o = this.painter,
            r = o.context;
          this._numCascadesToRender = this._receivers.computeRequiredCascades(o.transform.getFrustum(0), o.transform.worldSize, this._cascades), r.viewport.set([0, 0, di.shadowMapResolution, di.shadowMapResolution]);
          for (var _a179 = 0; _a179 < this._numCascadesToRender; ++_a179) {
            o.currentShadowCascade = _a179, r.bindFramebuffer.set(this._cascades[_a179].framebuffer.framebuffer), r.clear({
              color: e.C.white,
              depth: 1
            });
            var _iterator333 = _createForOfIteratorHelper(t.order),
              _step333;
            try {
              for (_iterator333.s(); !(_step333 = _iterator333.n()).done;) {
                var _e469 = _step333.value;
                var _r366 = t._mergedLayers[_e469];
                if (!_r366.hasShadowPass() || _r366.isHidden(o.transform.zoom)) continue;
                var _a180 = t.getLayerSourceCache(_r366),
                  _n260 = _a180 ? i[_a180.id] : void 0;
                ("model" === _r366.type || _n260 && _n260.length) && o.renderLayer(o, _a180, _r366, _n260);
              }
            } catch (err) {
              _iterator333.e(err);
            } finally {
              _iterator333.f();
            }
          }
          o.currentShadowCascade = 0;
        }
      }, {
        key: "drawGroundShadows",
        value: function drawGroundShadows() {
          if (!this.enabled) return;
          var t = this.painter,
            i = t.style,
            o = t.context,
            r = i.directionalLight,
            a = i.ambientLight;
          if (!r || !a) return;
          var n = [],
            s = ui(t, t.longestCutoffRange);
          s.shouldRenderCutoff && n.push("RENDER_CUTOFF");
          var l = xi(i, r, a),
            c = new e.af(o.gl.LEQUAL, e.af.ReadOnly, t.depthRangeFor3D);
          var _iterator334 = _createForOfIteratorHelper(this._groundShadowTiles),
            _step334;
          try {
            for (_iterator334.s(); !(_step334 = _iterator334.n()).done;) {
              var _i311 = _step334.value;
              var _r367 = _i311.toUnwrapped(),
                _a181 = t.isTileAffectedByFog(_i311),
                _h62 = t.getOrCreateProgram("groundShadow", {
                  defines: n,
                  overrideFog: _a181
                });
              this.setupShadows(_r367, _h62), t.uploadCommonUniforms(o, _h62, _r367, null, s);
              var _15 = {
                u_matrix: t.transform.calculateProjMatrix(_r367),
                u_ground_shadow_factor: l
              };
              _h62.draw(t, o.gl.TRIANGLES, c, e.ah.disabled, e.a.multiply, e.ag.disabled, _15, "ground_shadow", t.tileExtentBuffer, t.quadTriangleIndexBuffer, t.tileExtentSegments, {}, t.transform.zoom, null, null);
            }
          } catch (err) {
            _iterator334.e(err);
          } finally {
            _iterator334.f();
          }
        }
      }, {
        key: "getShadowPassColorMode",
        value: function getShadowPassColorMode() {
          return this.painter._shadowMapDebug ? e.a.unblended : e.a.disabled;
        }
      }, {
        key: "getShadowPassDepthMode",
        value: function getShadowPassDepthMode() {
          return this._depthMode;
        }
      }, {
        key: "getShadowCastingLayerCount",
        value: function getShadowCastingLayerCount() {
          return this._shadowLayerCount;
        }
      }, {
        key: "calculateShadowPassMatrixFromTile",
        value: function calculateShadowPassMatrixFromTile(t) {
          var i = this.painter.transform,
            o = i.calculatePosMatrix(t, i.worldSize);
          return e.ae.multiply(o, this._cascades[this.painter.currentShadowCascade].matrix, o), Float32Array.from(o);
        }
      }, {
        key: "calculateShadowPassMatrixFromMatrix",
        value: function calculateShadowPassMatrixFromMatrix(t) {
          return e.ae.multiply(t, this._cascades[this.painter.currentShadowCascade].matrix, t), Float32Array.from(t);
        }
      }, {
        key: "setupShadows",
        value: function setupShadows(t, i, o) {
          var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
          if (!this.enabled) return;
          var a = this.painter.transform,
            n = this.painter.context,
            s = n.gl,
            l = this._uniformValues,
            c = new Float64Array(16),
            h = a.calculatePosMatrix(t, a.worldSize);
          for (var _t507 = 0; _t507 < this._cascades.length; _t507++) e.ae.multiply(c, this._cascades[_t507].matrix, h), l[0 === _t507 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(c), n.activeTexture.set(s.TEXTURE0 + _i.ShadowMap0 + _t507), this._cascades[_t507].texture.bind(s.NEAREST, s.CLAMP_TO_EDGE);
          if (this.useNormalOffset = !!o, this.useNormalOffset) {
            var _i312 = e.b7(t.canonical),
              _n261 = 2 / a.tileSize * e.a4 / di.shadowMapResolution,
              _s224 = _n261 * this._cascades[0].boundingSphereRadius,
              _c78 = _n261 * this._cascades[this._cascades.length - 1].boundingSphereRadius,
              _h63 = ("vector-tile" === o ? 1 : 3) / Math.pow(2, r - t.canonical.z - (1 - a.zoom + Math.floor(a.zoom)));
            l.u_shadow_normal_offset = [_i312, _s224 * _h63, _c78 * _h63], l.u_shadow_bias = [6e-5, .0012, .012];
          } else l.u_shadow_bias = [36e-5, .0012, .012];
          i.setShadowUniformValues(n, l);
        }
      }, {
        key: "setupShadowsFromMatrix",
        value: function setupShadowsFromMatrix(t, i) {
          var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          if (!this.enabled) return;
          var r = this.painter.context,
            a = r.gl,
            n = this._uniformValues,
            s = new Float64Array(16);
          for (var _i313 = 0; _i313 < di.cascadeCount; _i313++) e.ae.multiply(s, this._cascades[_i313].matrix, t), n[0 === _i313 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(s), r.activeTexture.set(a.TEXTURE0 + _i.ShadowMap0 + _i313), this._cascades[_i313].texture.bind(a.NEAREST, a.CLAMP_TO_EDGE);
          if (this.useNormalOffset = o, o) {
            var _e470 = di.normalOffset;
            n.u_shadow_normal_offset = [1, _e470, _e470], n.u_shadow_bias = [6e-5, .0012, .012];
          } else n.u_shadow_bias = [36e-5, .0012, .012];
          i.setShadowUniformValues(r, n);
        }
      }, {
        key: "getShadowUniformValues",
        value: function getShadowUniformValues() {
          return this._uniformValues;
        }
      }, {
        key: "getCurrentCascadeFrustum",
        value: function getCurrentCascadeFrustum() {
          return this._cascades[this.painter.currentShadowCascade].frustum;
        }
      }, {
        key: "computeSimplifiedTileShadowVolume",
        value: function computeSimplifiedTileShadowVolume(t, i, o, r) {
          if (r[2] >= 0) return {};
          var a = function (t, i, o) {
              var r = o / (1 << t.canonical.z);
              return new e.b8([t.canonical.x * r + t.wrap * o, t.canonical.y * r + t.wrap * o, 0], [(t.canonical.x + 1) * r + t.wrap * o, (t.canonical.y + 1) * r + t.wrap * o, i]);
            }(t, i, o).getCorners(),
            n = i / -r[2];
          r[0] < 0 ? (e.$.add(a[0], a[0], [r[0] * n, 0, 0]), e.$.add(a[3], a[3], [r[0] * n, 0, 0])) : r[0] > 0 && (e.$.add(a[1], a[1], [r[0] * n, 0, 0]), e.$.add(a[2], a[2], [r[0] * n, 0, 0])), r[1] < 0 ? (e.$.add(a[0], a[0], [0, r[1] * n, 0]), e.$.add(a[1], a[1], [0, r[1] * n, 0])) : r[1] > 0 && (e.$.add(a[2], a[2], [0, r[1] * n, 0]), e.$.add(a[3], a[3], [0, r[1] * n, 0]));
          var s = {};
          return s.vertices = a, s.planes = [gi(a[1], a[0], a[4]), gi(a[2], a[1], a[5]), gi(a[3], a[2], a[6]), gi(a[0], a[3], a[7])], s;
        }
      }, {
        key: "addShadowReceiver",
        value: function addShadowReceiver(t, i, o) {
          this._receivers.add(t, e.b8.fromTileIdAndHeight(t, i, o));
        }
      }, {
        key: "getMaxCascadeForTile",
        value: function getMaxCascadeForTile(e) {
          var t = this._receivers.get(e);
          return t && t.lastCascade ? t.lastCascade : 0;
        }
      }]);
      return mi;
    }();
    function gi(t, i, o) {
      var r = e.$.sub([], o, i),
        a = e.$.sub([], t, i),
        n = e.$.cross([], r, a),
        s = e.$.length(n);
      return 0 === s ? [0, 0, 1, 0] : (e.$.scale(n, n, 1 / s), [n[0], n[1], n[2], -e.$.dot(n, i)]);
    }
    function vi(t) {
      var i = t.properties.get("direction"),
        o = e.ad(i.x, i.y, i.z);
      o[2] = e.au(o[2], 0, 75);
      var r = e.b9([o[0], o[1], o[2]]);
      return e.$.fromValues(r.x, r.y, r.z);
    }
    function xi(t, i, o) {
      var r = i.properties.get("color"),
        a = i.properties.get("intensity"),
        n = i.properties.get("direction"),
        s = [n.x, n.y, n.z],
        l = o.properties.get("color"),
        c = o.properties.get("intensity"),
        h = Math.max(e.$.dot([0, 0, 1], s), 0),
        _ = [0, 0, 0];
      e.$.scale(_, l.toRenderColor(t.getLut(i.scope)).toArray01Linear().slice(0, 3), c);
      var u = [0, 0, 0];
      return e.$.scale(u, r.toRenderColor(t.getLut(o.scope)).toArray01Linear().slice(0, 3), h * a), e.ba([_[0] > 0 ? _[0] / (_[0] + u[0]) : 0, _[1] > 0 ? _[1] / (_[1] + u[1]) : 0, _[2] > 0 ? _[2] / (_[2] + u[2]) : 0]);
    }
    function yi(t, i, o, r, a, n) {
      var s = t.zoom,
        l = t.scale,
        c = t.worldSize,
        h = 1 / c,
        _ = t.aspect,
        u = Math.sqrt(1 + _ * _) * Math.tan(.5 * t.fovX),
        d = u * u,
        p = r - o,
        f = r + o;
      var m, g;
      d > p / f ? (m = r, g = r * u) : (m = .5 * f * (1 + d), g = .5 * Math.sqrt(p * p + 2 * (r * r + o * o) * d + f * f * d * d));
      var v = t.projection.pixelsPerMeter(t.center.lat, c),
        x = t._camera.getCameraToWorldMercator(),
        y = [0, 0, -m * h];
      e.$.transformMat4(y, y, x);
      var b = g * h;
      var w = t._edgeInsets;
      if (!(0 === w.left && 0 === w.top && 0 === w.right && 0 === w.bottom || w.left === w.right && w.top === w.bottom)) {
        var _i314 = t._camera.getWorldToCamera(t.worldSize, "meters" === t.projection.zAxisUnit ? v : 1),
          _a182 = t._camera.getCameraToClipPerspective(t._fov, t.width / t.height, o, r);
        _a182[8] = 2 * -t.centerOffset.x / t.width, _a182[9] = 2 * t.centerOffset.y / t.height;
        var _n262 = new Float64Array(16);
        e.ae.mul(_n262, _a182, _i314);
        var _h64 = new Float64Array(16);
        e.ae.invert(_h64, _n262);
        var _16 = e.aM.fromInvProjectionMatrix(_h64, c, s, !0);
        var _iterator335 = _createForOfIteratorHelper(_16.points),
          _step335;
        try {
          for (_iterator335.s(); !(_step335 = _iterator335.n()).done;) {
            var _i315 = _step335.value;
            var _o172 = ((T = _i315)[0] /= l, T[1] /= l, T[2] = e.ay(T[2], t._center.lat), T);
            b = Math.max(b, e.$.len(e.$.subtract([], y, _o172)));
          }
        } catch (err) {
          _iterator335.e(err);
        } finally {
          _iterator335.f();
        }
      }
      var T;
      b *= a / (a - 1);
      var E = Math.acos(i[2]),
        C = Math.atan2(-i[0], -i[1]),
        S = new $t();
      S.position = y, S.setPitchBearing(E, C);
      var I = S.getWorldToCamera(c, v),
        L = b * c,
        P = Math.min(t._mercatorZfromZoom(17) * c * -2, -2 * L),
        R = S.getCameraToClipOrthographic(-L, L, -L, L, P, (L + n * v) / i[2]),
        D = new Float64Array(16);
      e.ae.multiply(D, R, I);
      var A = e.$.fromValues(Math.floor(1e6 * y[0]) / 1e6 * c, Math.floor(1e6 * y[1]) / 1e6 * c, 0),
        M = .5 * a,
        z = [0, 0, 0];
      e.$.transformMat4(z, A, D), e.$.scale(z, z, M);
      var O = [Math.floor(z[0]), Math.floor(z[1]), Math.floor(z[2])],
        F = [0, 0, 0];
      e.$.sub(F, z, O), e.$.scale(F, F, -1 / M);
      var B = new Float64Array(16);
      return e.ae.identity(B), e.ae.translate(B, B, F), e.ae.multiply(D, B, D), [D, L];
    }
    function bi(e, t) {
      return null != e && null != t && !(!e.hasData() || !t.hasData()) && null != e.demTexture && null != t.demTexture && e.tileID.key !== t.tileID.key;
    }
    var wi = new ( /*#__PURE__*/function () {
        function _class18() {
          _classCallCheck(this, _class18);
          this.operations = {};
        }
        _createClass(_class18, [{
          key: "newMorphing",
          value: function newMorphing(e, t, i, o, r) {
            if (e in this.operations) {
              var _t508 = this.operations[e];
              _t508.to.tileID.key !== i.tileID.key && (_t508.queued = i);
            } else this.operations[e] = {
              startTime: o,
              phase: 0,
              duration: r,
              from: t,
              to: i,
              queued: null
            };
          }
        }, {
          key: "getMorphValuesForProxy",
          value: function getMorphValuesForProxy(e) {
            if (!(e in this.operations)) return null;
            var t = this.operations[e];
            return {
              from: t.from,
              to: t.to,
              phase: t.phase
            };
          }
        }, {
          key: "update",
          value: function update(e) {
            for (var _t509 in this.operations) {
              var _i316 = this.operations[_t509];
              for (_i316.phase = (e - _i316.startTime) / _i316.duration; _i316.phase >= 1 || !this._validOp(_i316);) if (!this._nextOp(_i316, e)) {
                delete this.operations[_t509];
                break;
              }
            }
          }
        }, {
          key: "_nextOp",
          value: function _nextOp(e, t) {
            return !!e.queued && (e.from = e.to, e.to = e.queued, e.queued = null, e.phase = 0, e.startTime = t, !0);
          }
        }, {
          key: "_validOp",
          value: function _validOp(e) {
            return e.from.hasData() && e.to.hasData();
          }
        }]);
        return _class18;
      }())(),
      Ti = {
        0: null,
        1: "TERRAIN_VERTEX_MORPHING"
      };
    function Ei(e, t, i) {
      if (0 === t) return 0;
      var o = t < 1 && 514 === i ? .25 / t : 1;
      return 6 * Math.pow(1.5, 22 - e) * Math.max(t, 1) * o;
    }
    function Ci(e, t) {
      var i = 1 << e.z;
      return !t && (0 === e.x || e.x === i - 1) || 0 === e.y || e.y === i - 1;
    }
    var Si = function Si(e) {
      return {
        u_matrix: e
      };
    };
    function Ii(t, i, o, r, a) {
      if (a > 0) {
        var _n263 = e.e.now(),
          _s225 = (_n263 - t.timeAdded) / a,
          _l107 = i ? (_n263 - i.timeAdded) / a : -1,
          _c79 = o.getSource(),
          _h65 = r.coveringZoomLevel({
            tileSize: _c79.tileSize,
            roundZoom: _c79.roundZoom
          }),
          _17 = !i || Math.abs(i.tileID.overscaledZ - _h65) > Math.abs(t.tileID.overscaledZ - _h65),
          _u85 = _17 && t.refreshedUponExpiration ? 1 : e.au(_17 ? _s225 : 1 - _l107, 0, 1);
        return t.refreshedUponExpiration && _s225 >= 1 && (t.refreshedUponExpiration = !1), i ? {
          opacity: 1,
          mix: 1 - _u85
        } : {
          opacity: _u85,
          mix: 0
        };
      }
      return {
        opacity: 1,
        mix: 0
      };
    }
    var Li = /*#__PURE__*/function (_Ot) {
      _inherits(Li, _Ot);
      var _super143 = _createSuper(Li);
      function Li(t, i, o, r) {
        var _this109;
        _classCallCheck(this, Li);
        _this109 = _super143.call(this, t, i, o, r), _this109.type = "raster-array", _this109.maxzoom = 22, _this109._options = e.Q({
          type: "raster-array"
        }, i);
        return _this109;
      }
      _createClass(Li, [{
        key: "triggerRepaint",
        value: function triggerRepaint(e) {
          var t = this.map.painter._terrain,
            i = this.map.style.getSourceCache(this.id);
          t && t.enabled && i && t._clearRenderCacheForTile(i.id, e.tileID), this.map.triggerRepaint();
        }
      }, {
        key: "loadTile",
        value: function loadTile(t, i) {
          var _this110 = this;
          var o = this.map._requestManager.normalizeTileURL(t.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize),
            r = this.map._requestManager.transformRequest(o, e.R.Tile);
          t.requestParams = r, t.actor || (t.actor = this.dispatcher.getActor()), t.request = t.fetchHeader(void 0, function (e, o, r, a) {
            if (delete t.request, t.aborted) return t.state = "unloaded", i(null);
            if (e) {
              if (20 === e.code) return;
              return t.state = "errored", i(e);
            }
            _this110.map._refreshExpiredTiles && t.setExpiryData({
              cacheControl: r,
              expires: a
            }), t.state = "empty", i(null);
          });
        }
      }, {
        key: "unloadTile",
        value: function unloadTile(t, i) {
          var o = t.texture;
          o && o instanceof e.T ? (t.destroy(!0), this.map.painter.saveTileTexture(o)) : (t.destroy(), t.flushQueues(), t._isHeaderLoaded = !1, delete t._mrt, delete t.textureDescriptor), t.fbo && (t.fbo.destroy(), delete t.fbo), delete t.request, delete t.requestParams, delete t.neighboringTiles, t.state = "unloaded";
        }
      }, {
        key: "prepareTile",
        value: function prepareTile(t, i, o) {
          var _this111 = this;
          t._isHeaderLoaded && ("empty" !== t.state && (t.state = "reloading"), t.fetchBand(i, o, function (i, o) {
            if (i) return t.state = "errored", _this111.fire(new e.f(i)), void _this111.triggerRepaint(t);
            o && (t.setTexture(o, _this111.map.painter), t.state = "loaded", _this111.triggerRepaint(t));
          }));
        }
      }, {
        key: "getInitialBand",
        value: function getInitialBand(e) {
          if (!this.rasterLayers) return 0;
          var t = this.rasterLayers.find(function (_ref164) {
              var t = _ref164.id;
              return t === e;
            }),
            i = t && t.fields,
            o = i && i.bands && i.bands;
          return o ? o[0] : 0;
        }
      }, {
        key: "getTextureDescriptor",
        value: function getTextureDescriptor(t, i, o) {
          if (!t) return;
          var r = i.sourceLayer || this.rasterLayerIds && this.rasterLayerIds[0];
          if (!r) return;
          var a = null;
          i instanceof e.bm ? a = i.paint.get("raster-array-band") : i instanceof e.bn && (a = i.paint.get("raster-particle-array-band"));
          var n = a || this.getInitialBand(r);
          if (null != n) if (t.textureDescriptor) {
            if (!t.updateNeeded(r, n) || o) return Object.assign({}, t.textureDescriptor, {
              texture: t.texture
            });
          } else this.prepareTile(t, r, n);
        }
      }]);
      return Li;
    }(Ot);
    var Pi = {
        vector: Ft,
        raster: Ot,
        "raster-dem": /*#__PURE__*/function (_Ot2) {
          _inherits(rasterDem, _Ot2);
          var _super144 = _createSuper(rasterDem);
          function rasterDem(t, i, o, r) {
            var _this112;
            _classCallCheck(this, rasterDem);
            _this112 = _super144.call(this, t, i, o, r), _this112.type = "raster-dem", _this112.maxzoom = 22, _this112._options = e.Q({
              type: "raster-dem"
            }, i), _this112.encoding = i.encoding || "mapbox";
            return _this112;
          }
          _createClass(rasterDem, [{
            key: "loadTile",
            value: function loadTile(t, i) {
              var o = this.map._requestManager.normalizeTileURL(t.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
              function r(e, o) {
                e && (t.state = "errored", i(e)), o && (t.dem = o, t.dem.onDeserialize(), t.needsHillshadePrepare = !0, t.needsDEMTextureUpload = !0, t.state = "loaded", i(null));
              }
              t.request = e.i(this.map._requestManager.transformRequest(o, e.R.Tile), function (o, a, n, s) {
                if (delete t.request, t.aborted) t.state = "unloaded", i(null);else if (o) t.state = "errored", i(o);else if (a) {
                  this.map._refreshExpiredTiles && t.setExpiryData({
                    cacheControl: n,
                    expires: s
                  });
                  var _i317 = ImageBitmap && a instanceof ImageBitmap && e.bk(),
                    _o173 = 1 - (a.width - e.bl(a.width)) / 2;
                  _o173 < 1 || t.neighboringTiles || (t.neighboringTiles = this._getNeighboringTiles(t.tileID));
                  var _l108 = _i317 ? a : e.e.getImageData(a, _o173),
                    _c80 = {
                      uid: t.uid,
                      coord: t.tileID,
                      source: this.id,
                      scope: this.scope,
                      rawImageData: _l108,
                      encoding: this.encoding,
                      padding: _o173
                    };
                  t.actor && "expired" !== t.state || (t.actor = this.dispatcher.getActor(), t.actor.send("loadDEMTile", _c80, r.bind(this), void 0, !0));
                }
              }.bind(this));
            }
          }, {
            key: "_getNeighboringTiles",
            value: function _getNeighboringTiles(t) {
              var i = t.canonical,
                o = Math.pow(2, i.z),
                r = (i.x - 1 + o) % o,
                a = 0 === i.x ? t.wrap - 1 : t.wrap,
                n = (i.x + 1 + o) % o,
                s = i.x + 1 === o ? t.wrap + 1 : t.wrap,
                l = {};
              return l[new e.aQ(t.overscaledZ, a, i.z, r, i.y).key] = {
                backfilled: !1
              }, l[new e.aQ(t.overscaledZ, s, i.z, n, i.y).key] = {
                backfilled: !1
              }, i.y > 0 && (l[new e.aQ(t.overscaledZ, a, i.z, r, i.y - 1).key] = {
                backfilled: !1
              }, l[new e.aQ(t.overscaledZ, t.wrap, i.z, i.x, i.y - 1).key] = {
                backfilled: !1
              }, l[new e.aQ(t.overscaledZ, s, i.z, n, i.y - 1).key] = {
                backfilled: !1
              }), i.y + 1 < o && (l[new e.aQ(t.overscaledZ, a, i.z, r, i.y + 1).key] = {
                backfilled: !1
              }, l[new e.aQ(t.overscaledZ, t.wrap, i.z, i.x, i.y + 1).key] = {
                backfilled: !1
              }, l[new e.aQ(t.overscaledZ, s, i.z, n, i.y + 1).key] = {
                backfilled: !1
              }), l;
            }
          }]);
          return rasterDem;
        }(Ot),
        "raster-array": Li,
        geojson: /*#__PURE__*/function (_e$E10) {
          _inherits(geojson, _e$E10);
          var _super145 = _createSuper(geojson);
          function geojson(t, i, o, r) {
            var _this113;
            _classCallCheck(this, geojson);
            _this113 = _super145.call(this), _this113.id = t, _this113.type = "geojson", _this113.minzoom = 0, _this113.maxzoom = 18, _this113.tileSize = 512, _this113.isTileClipped = !0, _this113.reparseOverscaled = !0, _this113._loaded = !1, _this113.actor = o.getActor(), _this113.setEventedParent(r), _this113._data = i.data, _this113._options = e.Q({}, i), _this113._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (_this113.maxzoom = i.maxzoom), void 0 !== i.minzoom && (_this113.minzoom = i.minzoom), i.type && (_this113.type = i.type), i.attribution && (_this113.attribution = i.attribution), _this113.promoteId = i.promoteId;
            var a = e.a4 / _this113.tileSize;
            _this113.workerOptions = e.Q({
              source: _this113.id,
              scope: _this113.scope,
              cluster: i.cluster || !1,
              geojsonVtOptions: {
                buffer: (void 0 !== i.buffer ? i.buffer : 128) * a,
                tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * a,
                extent: e.a4,
                maxZoom: _this113.maxzoom,
                lineMetrics: i.lineMetrics || !1,
                generateId: i.generateId || !1
              },
              superclusterOptions: {
                maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : _this113.maxzoom - 1,
                minPoints: Math.max(2, i.clusterMinPoints || 2),
                extent: e.a4,
                radius: (void 0 !== i.clusterRadius ? i.clusterRadius : 50) * a,
                log: !1,
                generateId: i.generateId || !1
              },
              clusterProperties: i.clusterProperties,
              filter: i.filter,
              dynamic: i.dynamic
            }, i.workerOptions);
            return _this113;
          }
          _createClass(geojson, [{
            key: "onAdd",
            value: function onAdd(e) {
              this.map = e, this.setData(this._data);
            }
          }, {
            key: "setData",
            value: function setData(e) {
              return this._data = e, this._updateWorkerData(), this;
            }
          }, {
            key: "updateData",
            value: function updateData(t) {
              if (!this._options.dynamic) return this.fire(new e.f(new Error("Can't call updateData on a GeoJSON source with dynamic set to false.")));
              if ("string" != typeof t && ("Feature" === t.type && (t = {
                type: "FeatureCollection",
                features: [t]
              }), "FeatureCollection" !== t.type)) return this.fire(new e.f(new Error("Data to update should be a feature or a feature collection.")));
              if (this._coalesce && "string" != typeof t && "string" != typeof this._data && "FeatureCollection" === this._data.type) {
                var _e471 = new Map();
                var _iterator336 = _createForOfIteratorHelper(this._data.features),
                  _step336;
                try {
                  for (_iterator336.s(); !(_step336 = _iterator336.n()).done;) {
                    var _t510 = _step336.value;
                    _e471.set(_t510.id, _t510);
                  }
                } catch (err) {
                  _iterator336.e(err);
                } finally {
                  _iterator336.f();
                }
                var _iterator337 = _createForOfIteratorHelper(t.features),
                  _step337;
                try {
                  for (_iterator337.s(); !(_step337 = _iterator337.n()).done;) {
                    var _i318 = _step337.value;
                    _e471.set(_i318.id, _i318);
                  }
                } catch (err) {
                  _iterator337.e(err);
                } finally {
                  _iterator337.f();
                }
                this._data.features = _toConsumableArray(_e471.values());
              } else this._data = t;
              return this._updateWorkerData(!0), this;
            }
          }, {
            key: "getClusterExpansionZoom",
            value: function getClusterExpansionZoom(e, t) {
              return this.actor.send("geojson.getClusterExpansionZoom", {
                clusterId: e,
                source: this.id,
                scope: this.scope
              }, t), this;
            }
          }, {
            key: "getClusterChildren",
            value: function getClusterChildren(e, t) {
              return this.actor.send("geojson.getClusterChildren", {
                clusterId: e,
                source: this.id,
                scope: this.scope
              }, t), this;
            }
          }, {
            key: "getClusterLeaves",
            value: function getClusterLeaves(e, t, i, o) {
              return this.actor.send("geojson.getClusterLeaves", {
                source: this.id,
                scope: this.scope,
                clusterId: e,
                limit: t,
                offset: i
              }, o), this;
            }
          }, {
            key: "_updateWorkerData",
            value: function _updateWorkerData() {
              var _this114 = this;
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              if (this._pendingLoad) return void (this._coalesce = !0);
              this.fire(new e.g("dataloading", {
                dataType: "source"
              })), this._loaded = !1;
              var i = e.Q({
                append: t
              }, this.workerOptions);
              i.scope = this.scope;
              var o = this._data;
              "string" == typeof o ? (i.request = this.map._requestManager.transformRequest(e.e.resolveURL(o), e.R.Source), i.request.collectResourceTiming = this._collectResourceTiming) : i.data = JSON.stringify(o), this._pendingLoad = this.actor.send("".concat(this.type, ".loadData"), i, function (i, o) {
                if (_this114._loaded = !0, _this114._pendingLoad = null, i) _this114.fire(new e.f(i));else {
                  var _i319 = {
                    dataType: "source",
                    sourceDataType: _this114._metadataFired ? "content" : "metadata"
                  };
                  _this114._collectResourceTiming && o && o.resourceTiming && o.resourceTiming[_this114.id] && (_i319.resourceTiming = o.resourceTiming[_this114.id]), t && (_this114._partialReload = !0), _this114.fire(new e.g("data", _i319)), _this114._partialReload = !1, _this114._metadataFired = !0;
                }
                _this114._coalesce && (_this114._updateWorkerData(t), _this114._coalesce = !1);
              });
            }
          }, {
            key: "loaded",
            value: function loaded() {
              return this._loaded;
            }
          }, {
            key: "loadTile",
            value: function loadTile(t, i) {
              var _this115 = this;
              var o = t.actor ? "reloadTile" : "loadTile";
              t.actor = this.actor;
              var r = this.map.style ? this.map.style.getLut(this.scope) : null,
                a = this._partialReload,
                n = {
                  type: this.type,
                  uid: t.uid,
                  tileID: t.tileID,
                  tileZoom: t.tileZoom,
                  zoom: t.tileID.overscaledZ,
                  maxZoom: this.maxzoom,
                  tileSize: this.tileSize,
                  source: this.id,
                  lut: r ? {
                    image: r.image.clone()
                  } : null,
                  scope: this.scope,
                  pixelRatio: e.e.devicePixelRatio,
                  showCollisionBoxes: this.map.showCollisionBoxes,
                  promoteId: this.promoteId,
                  brightness: this.map.style && this.map.style.getBrightness() || 0,
                  partial: a
                };
              t.request = this.actor.send(o, n, function (e, r) {
                return a && !r ? (t.state = "loaded", i(null)) : (delete t.request, t.destroy(), t.aborted ? i(null) : e ? i(e) : (t.loadVectorData(r, _this115.map.painter, "reloadTile" === o), i(null)));
              }, void 0, "loadTile" === o);
            }
          }, {
            key: "abortTile",
            value: function abortTile(e) {
              e.request && (e.request.cancel(), delete e.request), e.aborted = !0;
            }
          }, {
            key: "unloadTile",
            value: function unloadTile(e, t) {
              this.actor.send("removeTile", {
                uid: e.uid,
                type: this.type,
                source: this.id,
                scope: this.scope
              }), e.destroy();
            }
          }, {
            key: "onRemove",
            value: function onRemove(e) {
              this._pendingLoad && this._pendingLoad.cancel();
            }
          }, {
            key: "serialize",
            value: function serialize() {
              return e.Q({}, this._options, {
                type: this.type,
                data: this._data
              });
            }
          }, {
            key: "hasTransition",
            value: function hasTransition() {
              return !1;
            }
          }]);
          return geojson;
        }(e.E),
        video: /*#__PURE__*/function (_e$bo) {
          _inherits(video, _e$bo);
          var _super146 = _createSuper(video);
          function video(e, t, i, o) {
            var _this116;
            _classCallCheck(this, video);
            _this116 = _super146.call(this, e, t, i, o), _this116.roundZoom = !0, _this116.type = "video", _this116.options = t;
            return _this116;
          }
          _createClass(video, [{
            key: "load",
            value: function load() {
              var _this117 = this;
              this._loaded = !1;
              var t = this.options;
              this.urls = [];
              var _iterator338 = _createForOfIteratorHelper(t.urls),
                _step338;
              try {
                for (_iterator338.s(); !(_step338 = _iterator338.n()).done;) {
                  var _i320 = _step338.value;
                  this.urls.push(this.map._requestManager.transformRequest(_i320, e.R.Source).url);
                }
              } catch (err) {
                _iterator338.e(err);
              } finally {
                _iterator338.f();
              }
              e.bp(this.urls, function (t, i) {
                _this117._loaded = !0, t ? _this117.fire(new e.f(t)) : i && (_this117.video = i, _this117.video.loop = !0, _this117.video.setAttribute("playsinline", ""), _this117.video.addEventListener("playing", function () {
                  _this117.map.triggerRepaint();
                }), _this117.map && _this117.video.play(), _this117._finishLoading());
              });
            }
          }, {
            key: "pause",
            value: function pause() {
              this.video && this.video.pause();
            }
          }, {
            key: "play",
            value: function play() {
              this.video && this.video.play();
            }
          }, {
            key: "seek",
            value: function seek(t) {
              if (this.video) {
                var _i321 = this.video.seekable;
                t < _i321.start(0) || t > _i321.end(0) ? this.fire(new e.f(new e.V("sources.".concat(this.id), null, "Playback for this video can be set only between the ".concat(_i321.start(0), " and ").concat(_i321.end(0), "-second mark.")))) : this.video.currentTime = t;
              }
            }
          }, {
            key: "getVideo",
            value: function getVideo() {
              return this.video;
            }
          }, {
            key: "onAdd",
            value: function onAdd(e) {
              this.map || (this.map = e, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }
          }, {
            key: "prepare",
            value: function prepare() {
              if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
              var t = this.map.painter.context,
                i = t.gl;
              this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new e.T(t, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t);
            }
          }, {
            key: "serialize",
            value: function serialize() {
              return {
                type: "video",
                urls: this.urls,
                coordinates: this.coordinates
              };
            }
          }, {
            key: "hasTransition",
            value: function hasTransition() {
              return this.video && !this.video.paused;
            }
          }]);
          return video;
        }(e.bo),
        image: e.bo,
        model: /*#__PURE__*/function (_e$E11) {
          _inherits(model, _e$E11);
          var _super147 = _createSuper(model);
          function model(e, t, i, o) {
            var _this118;
            _classCallCheck(this, model);
            _this118 = _super147.call(this), _this118.id = e, _this118.type = "model", _this118.models = [], _this118._loaded = !1, _this118._options = t;
            return _this118;
          }
          _createClass(model, [{
            key: "load",
            value: function load() {
              var _this119 = this;
              var t = [];
              var _loop15 = function _loop15(_i322) {
                var o = _this119._options.models[_i322],
                  r = e.l(_this119.map._requestManager.transformRequest(o.uri, e.R.Model).url).then(function (t) {
                    if (!t) return;
                    var r = e.c(t),
                      a = new e.M(_i322, o.position, o.orientation, r);
                    a.computeBoundsAndApplyParent(), _this119.models.push(a);
                  }).catch(function (t) {
                    _this119.fire(new e.f(new Error("Could not load model ".concat(_i322, " from ").concat(o.uri, ": ").concat(t.message))));
                  });
                t.push(r);
              };
              for (var _i322 in this._options.models) {
                _loop15(_i322);
              }
              return Promise.allSettled(t).then(function () {
                _this119._loaded = !0, _this119.fire(new e.g("data", {
                  dataType: "source",
                  sourceDataType: "metadata"
                }));
              }).catch(function (t) {
                _this119.fire(new e.f(new Error("Could not load models: ".concat(t.message))));
              });
            }
          }, {
            key: "onAdd",
            value: function onAdd(e) {
              this.map = e, this.load();
            }
          }, {
            key: "hasTransition",
            value: function hasTransition() {
              return !1;
            }
          }, {
            key: "loaded",
            value: function loaded() {
              return this._loaded;
            }
          }, {
            key: "getModels",
            value: function getModels() {
              return this.models;
            }
          }, {
            key: "loadTile",
            value: function loadTile(e, t) {}
          }, {
            key: "serialize",
            value: function serialize() {
              return {
                type: "model"
              };
            }
          }]);
          return model;
        }(e.E),
        "batched-model": /*#__PURE__*/function (_e$E12) {
          _inherits(batchedModel, _e$E12);
          var _super148 = _createSuper(batchedModel);
          function batchedModel(e, t, i, o) {
            var _this120;
            _classCallCheck(this, batchedModel);
            _this120 = _super148.call(this), _this120.type = "batched-model", _this120.id = e, _this120.tileSize = 512, _this120._options = t, _this120.tiles = _this120._options.tiles, _this120.maxzoom = t.maxzoom || 19, _this120.minzoom = t.minzoom || 0, _this120.roundZoom = !0, _this120.usedInConflation = !0, _this120.dispatcher = i, _this120.reparseOverscaled = !1, _this120.scheme = "xyz", _this120._loaded = !1, _this120.setEventedParent(o);
            return _this120;
          }
          _createClass(batchedModel, [{
            key: "onAdd",
            value: function onAdd(e) {
              this.map = e, this.load();
            }
          }, {
            key: "load",
            value: function load(t) {
              var _this121 = this;
              this._loaded = !1, this.fire(new e.g("dataloading", {
                dataType: "source"
              }));
              var i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language,
                o = this.map._worldview;
              this._tileJSONRequest = Mt(this._options, this.map._requestManager, i, o, function (r, a) {
                _this121._tileJSONRequest = null, _this121._loaded = !0, r ? (i && console.warn("Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ".concat(i)), o && 2 !== o.length && console.warn("Requested worldview strings must be a valid ISO alpha-2 code. Found: ".concat(o)), _this121.fire(new e.f(r))) : a && (e.Q(_this121, a), a.bounds && (_this121.tileBounds = new zt(a.bounds, _this121.minzoom, _this121.maxzoom)), e.ao(a.tiles, _this121.map._requestManager._customAccessToken), _this121.fire(new e.g("data", {
                  dataType: "source",
                  sourceDataType: "metadata"
                })), _this121.fire(new e.g("data", {
                  dataType: "source",
                  sourceDataType: "content"
                }))), t && t(r);
              });
            }
          }, {
            key: "hasTransition",
            value: function hasTransition() {
              return !1;
            }
          }, {
            key: "hasTile",
            value: function hasTile(e) {
              return !this.tileBounds || this.tileBounds.contains(e.canonical);
            }
          }, {
            key: "loaded",
            value: function loaded() {
              return this._loaded;
            }
          }, {
            key: "loadTile",
            value: function loadTile(t, i) {
              var o = this.map._requestManager.normalizeTileURL(t.tileID.canonical.url(this.tiles, this.scheme)),
                r = {
                  request: this.map._requestManager.transformRequest(o, e.R.Tile),
                  data: void 0,
                  uid: t.uid,
                  tileID: t.tileID,
                  tileZoom: t.tileZoom,
                  zoom: t.tileID.overscaledZ,
                  tileSize: this.tileSize * t.tileID.overscaleFactor(),
                  type: this.type,
                  source: this.id,
                  scope: this.scope,
                  showCollisionBoxes: this.map.showCollisionBoxes,
                  isSymbolTile: t.isSymbolTile,
                  brightness: this.map.style && this.map.style.getBrightness() || 0
                };
              if (t.actor && "expired" !== t.state) {
                if ("loading" === t.state) t.reloadCallback = i;else {
                  if (t.buckets) {
                    var _e472 = Object.values(t.buckets);
                    for (var _i323 = 0, _e473 = _e472; _i323 < _e473.length; _i323++) {
                      var _t511 = _e473[_i323];
                      _t511.dirty = !0;
                    }
                    return void (t.state = "loaded");
                  }
                  t.request = t.actor.send("reloadTile", r, a.bind(this));
                }
              } else t.actor = this.dispatcher.getActor(), t.request = t.actor.send("loadTile", r, a.bind(this), void 0, !0);
              function a(e, o) {
                return t.aborted ? i(null) : e && 404 !== e.status ? i(e) : (o && (o.resourceTiming && (t.resourceTiming = o.resourceTiming), this.map._refreshExpiredTiles && t.setExpiryData(o), t.buckets = _objectSpread(_objectSpread({}, t.buckets), o.buckets), o.featureIndex && (t.latestFeatureIndex = o.featureIndex)), t.state = "loaded", void i(null));
              }
            }
          }, {
            key: "serialize",
            value: function serialize() {
              return e.Q({}, this._options);
            }
          }]);
          return batchedModel;
        }(e.E),
        canvas: /*#__PURE__*/function (_e$bo2) {
          _inherits(canvas, _e$bo2);
          var _super149 = _createSuper(canvas);
          function canvas(t, i, o, r) {
            var _this122;
            _classCallCheck(this, canvas);
            _this122 = _super149.call(this, t, i, o, r), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some(function (e) {
              return !Array.isArray(e) || 2 !== e.length || e.some(function (e) {
                return "number" != typeof e;
              });
            }) || _this122.fire(new e.f(new e.V("sources.".concat(t), null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : _this122.fire(new e.f(new e.V("sources.".concat(t), null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && _this122.fire(new e.f(new e.V("sources.".concat(t), null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || _this122.fire(new e.f(new e.V("sources.".concat(t), null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : _this122.fire(new e.f(new e.V("sources.".concat(t), null, 'missing required property "canvas"'))), _this122.options = i, _this122.animate = void 0 === i.animate || i.animate;
            return _this122;
          }
          _createClass(canvas, [{
            key: "load",
            value: function load() {
              this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e.f(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function () {
                this._playing = !0, this.map.triggerRepaint();
              }, this.pause = function () {
                this._playing && (this.prepare(), this._playing = !1);
              }, this._finishLoading());
            }
          }, {
            key: "getCanvas",
            value: function getCanvas() {
              return this.canvas;
            }
          }, {
            key: "onAdd",
            value: function onAdd(e) {
              this.map = e, this.load(), this.canvas && this.animate && this.play();
            }
          }, {
            key: "onRemove",
            value: function onRemove(e) {
              this.pause();
            }
          }, {
            key: "prepare",
            value: function prepare() {
              var t = !1;
              if (this.canvas.width !== this.width && (this.width = this.canvas.width, t = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, t = !0), this._hasInvalidDimensions()) return;
              if (0 === Object.keys(this.tiles).length) return;
              var i = this.map.painter.context;
              this.texture ? !t && !this._playing || this.texture instanceof e.bq || this.texture.update(this.canvas, {
                premultiply: !0
              }) : this.texture = new e.T(i, this.canvas, i.gl.RGBA, {
                premultiply: !0
              }), this._prepareData(i);
            }
          }, {
            key: "serialize",
            value: function serialize() {
              return {
                type: "canvas",
                coordinates: this.coordinates
              };
            }
          }, {
            key: "hasTransition",
            value: function hasTransition() {
              return this._playing;
            }
          }, {
            key: "_hasInvalidDimensions",
            value: function _hasInvalidDimensions() {
              for (var _i324 = 0, _arr4 = [this.canvas.width, this.canvas.height]; _i324 < _arr4.length; _i324++) {
                var _e474 = _arr4[_i324];
                if (isNaN(_e474) || _e474 <= 0) return !0;
              }
              return !1;
            }
          }]);
          return canvas;
        }(e.bo),
        custom: /*#__PURE__*/function (_e$E13) {
          _inherits(custom, _e$E13);
          var _super150 = _createSuper(custom);
          function custom(t, i, o, r) {
            var _this123;
            _classCallCheck(this, custom);
            _this123 = _super150.call(this), _this123.id = t, _this123.type = "custom", _this123._dataType = "raster", _this123._dispatcher = o, _this123._implementation = i, _this123.setEventedParent(r), _this123.scheme = "xyz", _this123.minzoom = 0, _this123.maxzoom = 22, _this123.tileSize = 512, _this123._loaded = !1, _this123.roundZoom = !0, _this123._implementation || _this123.fire(new e.f(new Error("Missing implementation for ".concat(_this123.id, " custom source")))), _this123._implementation.loadTile || _this123.fire(new e.f(new Error("Missing loadTile implementation for ".concat(_this123.id, " custom source")))), _this123._implementation.bounds && (_this123.tileBounds = new zt(_this123._implementation.bounds, _this123.minzoom, _this123.maxzoom)), i.update = _this123._update.bind(_assertThisInitialized(_this123)), i.clearTiles = _this123._clearTiles.bind(_assertThisInitialized(_this123)), i.coveringTiles = _this123._coveringTiles.bind(_assertThisInitialized(_this123)), e.Q(_assertThisInitialized(_this123), e.ai(i, ["dataType", "scheme", "minzoom", "maxzoom", "tileSize", "attribution", "minTileCacheSize", "maxTileCacheSize"]));
            return _this123;
          }
          _createClass(custom, [{
            key: "serialize",
            value: function serialize() {
              return e.ai(this, ["type", "scheme", "minzoom", "maxzoom", "tileSize", "attribution"]);
            }
          }, {
            key: "load",
            value: function load() {
              this._loaded = !0, this.fire(new e.g("data", {
                dataType: "source",
                sourceDataType: "metadata"
              })), this.fire(new e.g("data", {
                dataType: "source",
                sourceDataType: "content"
              }));
            }
          }, {
            key: "loaded",
            value: function loaded() {
              return this._loaded;
            }
          }, {
            key: "onAdd",
            value: function onAdd(t) {
              this.map = t, this._loaded = !1, this.fire(new e.g("dataloading", {
                dataType: "source"
              })), this._implementation.onAdd && this._implementation.onAdd(t), this.load();
            }
          }, {
            key: "onRemove",
            value: function onRemove(e) {
              this._implementation.onRemove && this._implementation.onRemove(e);
            }
          }, {
            key: "hasTile",
            value: function hasTile(e) {
              if (this._implementation.hasTile) {
                var _e$canonical = e.canonical,
                  _t512 = _e$canonical.x,
                  _i325 = _e$canonical.y,
                  _o174 = _e$canonical.z;
                return this._implementation.hasTile({
                  x: _t512,
                  y: _i325,
                  z: _o174
                });
              }
              return !this.tileBounds || this.tileBounds.contains(e.canonical);
            }
          }, {
            key: "loadTile",
            value: function loadTile(e, t) {
              var _e$tileID$canonical = e.tileID.canonical,
                i = _e$tileID$canonical.x,
                o = _e$tileID$canonical.y,
                r = _e$tileID$canonical.z,
                a = new AbortController();
              e.request = Promise.resolve(this._implementation.loadTile({
                x: i,
                y: o,
                z: r
              }, {
                signal: a.signal
              })).then(function (i) {
                return delete e.request, e.aborted ? (e.state = "unloaded", t(null)) : void 0 === i ? (e.state = "errored", t(null)) : null === i ? (this.loadTileData(e, {
                  width: this.tileSize,
                  height: this.tileSize,
                  data: null
                }), e.state = "loaded", t(null)) : function (e) {
                  return e instanceof ImageData || e instanceof HTMLCanvasElement || e instanceof ImageBitmap || e instanceof HTMLImageElement;
                }(i) ? (this.loadTileData(e, i), e.state = "loaded", void t(null)) : (e.state = "errored", t(new Error("Can't infer data type for ".concat(this.id, ", only raster data supported at the moment"))));
              }.bind(this)).catch(function (i) {
                20 !== i.code && (e.state = "errored", t(i));
              }), e.request.cancel = function () {
                return a.abort();
              };
            }
          }, {
            key: "loadTileData",
            value: function loadTileData(e, t) {
              e.setTexture(t, this.map.painter);
            }
          }, {
            key: "unloadTile",
            value: function unloadTile(t, i) {
              if (t.texture && t.texture instanceof e.T ? (t.destroy(!0), t.texture && t.texture instanceof e.T && this.map.painter.saveTileTexture(t.texture)) : t.destroy(), this._implementation.unloadTile) {
                var _t$tileID$canonical = t.tileID.canonical,
                  _e475 = _t$tileID$canonical.x,
                  _i326 = _t$tileID$canonical.y,
                  _o175 = _t$tileID$canonical.z;
                this._implementation.unloadTile({
                  x: _e475,
                  y: _i326,
                  z: _o175
                });
              }
              i && i();
            }
          }, {
            key: "abortTile",
            value: function abortTile(e, t) {
              e.request && e.request.cancel && (e.request.cancel(), delete e.request), t && t();
            }
          }, {
            key: "hasTransition",
            value: function hasTransition() {
              return !1;
            }
          }, {
            key: "_coveringTiles",
            value: function _coveringTiles() {
              return this.map.transform.coveringTiles({
                tileSize: this.tileSize,
                minzoom: this.minzoom,
                maxzoom: this.maxzoom,
                roundZoom: this.roundZoom
              }).map(function (e) {
                return {
                  x: e.canonical.x,
                  y: e.canonical.y,
                  z: e.canonical.z
                };
              });
            }
          }, {
            key: "_clearTiles",
            value: function _clearTiles() {
              var t = e.am(this.id, this.scope);
              this.map.style.clearSource(t);
            }
          }, {
            key: "_update",
            value: function _update() {
              this.fire(new e.g("data", {
                dataType: "source",
                sourceDataType: "content"
              }));
            }
          }]);
          return custom;
        }(e.E)
      },
      Ri = function Ri(t, i, o, r) {
        var a = new Pi[i.type](t, i, o, r);
        if (a.id !== t) throw new Error("Expected Source id to be ".concat(t, " instead of ").concat(a.id));
        return e.br(["load", "abort", "unload", "serialize", "prepare"], a), a;
      };
    var Di = /*#__PURE__*/function (_e$bx) {
      _inherits(Di, _e$bx);
      var _super151 = _createSuper(Di);
      function Di(t) {
        var _this124;
        _classCallCheck(this, Di);
        var i = {
            type: "raster-dem",
            maxzoom: t.transform.maxZoom
          },
          o = new e.by(e.bz(), null),
          r = Ri("mock-dem", i, o, t.style);
        _this124 = _super151.call(this, "mock-dem", r, !1), r.setEventedParent(_assertThisInitialized(_this124)), _this124._sourceLoaded = !0;
        return _this124;
      }
      _createClass(Di, [{
        key: "_loadTile",
        value: function _loadTile(e, t) {
          e.state = "loaded", t(null);
        }
      }]);
      return Di;
    }(e.bx);
    var Ai = /*#__PURE__*/function (_e$bx2) {
      _inherits(Ai, _e$bx2);
      var _super152 = _createSuper(Ai);
      function Ai(t) {
        var _this125;
        _classCallCheck(this, Ai);
        var i = Ri("proxy", {
          type: "geojson",
          maxzoom: t.transform.maxZoom
        }, new e.by(e.bz(), null), t.style);
        _this125 = _super152.call(this, "proxy", i, !1), i.setEventedParent(_assertThisInitialized(_this125)), _this125.map = _this125.getSource().map = t, _this125.used = _this125._sourceLoaded = !0, _this125.renderCache = [], _this125.renderCachePool = [], _this125.proxyCachedFBO = {};
        return _this125;
      }
      _createClass(Ai, [{
        key: "update",
        value: function update(t, i, o) {
          var _this126 = this;
          if (t.freezeTileCoverage) return;
          this.transform = t;
          var r = t.coveringTiles({
            tileSize: this._source.tileSize,
            minzoom: this._source.minzoom,
            maxzoom: this._source.maxzoom,
            roundZoom: this._source.roundZoom,
            reparseOverscaled: this._source.reparseOverscaled
          }).reduce(function (i, o) {
            if (i[o.key] = "", !_this126._tiles[o.key]) {
              var _i327 = new e.bA(o, _this126._source.tileSize * o.overscaleFactor(), t.tileZoom);
              _i327.state = "loaded", _this126._tiles[o.key] = _i327;
            }
            return i;
          }, {});
          for (var _e476 in this._tiles) _e476 in r || (this.freeFBO(_e476), this._tiles[_e476].unloadVectorData(), delete this._tiles[_e476]);
        }
      }, {
        key: "freeFBO",
        value: function freeFBO(e) {
          var t = this.proxyCachedFBO[e];
          if (void 0 !== t) {
            var _this$renderCachePool;
            var _i328 = Object.values(t);
            (_this$renderCachePool = this.renderCachePool).push.apply(_this$renderCachePool, _i328), delete this.proxyCachedFBO[e];
          }
        }
      }, {
        key: "deallocRenderCache",
        value: function deallocRenderCache() {
          this.renderCache.forEach(function (e) {
            return e.fb.destroy();
          }), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
        }
      }]);
      return Ai;
    }(e.bx);
    var Mi = /*#__PURE__*/function (_e$aQ) {
      _inherits(Mi, _e$aQ);
      var _super153 = _createSuper(Mi);
      function Mi(e, t, i) {
        var _this127;
        _classCallCheck(this, Mi);
        _this127 = _super153.call(this, e.overscaledZ, e.wrap, e.canonical.z, e.canonical.x, e.canonical.y), _this127.proxyTileKey = t, _this127.projMatrix = i;
        return _this127;
      }
      return _createClass(Mi);
    }(e.aQ);
    var zi = /*#__PURE__*/function (_e$bs) {
      _inherits(zi, _e$bs);
      var _super154 = _createSuper(zi);
      function zi(t, i) {
        var _this128;
        _classCallCheck(this, zi);
        _this128 = _super154.call(this), _this128._debugParams = {
          sortTilesHiZFirst: !0,
          disableRenderCache: !1
        }, t.tp.registerParameter(_this128._debugParams, ["Terrain"], "sortTilesHiZFirst", {}, function () {
          _this128._style.map.triggerRepaint();
        }), t.tp.registerParameter(_this128._debugParams, ["Terrain"], "disableRenderCache", {}, function () {
          _this128._style.map.triggerRepaint();
        }), t.tp.registerButton(["Terrain"], "Invalidate Render Cache", function () {
          _this128.invalidateRenderCache = !0, _this128._style.map.triggerRepaint();
        }), _this128.painter = t, _this128.terrainTileForTile = {}, _this128.prevTerrainTileForTile = {};
        var _ref165 = function (t) {
            var i = new e.bv(),
              o = new e.bw(),
              r = 131;
            i.reserve(17161), o.reserve(33800);
            var a = e.a4 / 128,
              n = e.a4 + a / 2,
              s = n + a;
            for (var _t513 = -a; _t513 < s; _t513 += a) for (var _o176 = -a; _o176 < s; _o176 += a) {
              var _r368 = _o176 < 0 || _o176 > n || _t513 < 0 || _t513 > n ? 24575 : 0,
                _a183 = e.au(Math.round(_o176), 0, e.a4),
                _s226 = e.au(Math.round(_t513), 0, e.a4);
              i.emplaceBack(_a183 + _r368, _s226);
            }
            var l = function l(e, t) {
              var i = t * r + e;
              o.emplaceBack(i + 1, i, i + r), o.emplaceBack(i + r, i + r + 1, i + 1);
            };
            for (var _e477 = 1; _e477 < 129; _e477++) for (var _t514 = 1; _t514 < 129; _t514++) l(_t514, _e477);
            return [0, 129].forEach(function (e) {
              for (var _t515 = 0; _t515 < 130; _t515++) l(_t515, e), l(e, _t515);
            }), [i, o, 32768];
          }(),
          _ref166 = _slicedToArray(_ref165, 3),
          o = _ref166[0],
          r = _ref166[1],
          a = _ref166[2],
          n = t.context;
        _this128.gridBuffer = n.createVertexBuffer(o, e.bt.members), _this128.gridIndexBuffer = n.createIndexBuffer(r), _this128.gridSegments = e.b.simpleSegment(0, 0, o.length, r.length), _this128.gridNoSkirtSegments = e.b.simpleSegment(0, 0, o.length, a), _this128.proxyCoords = [], _this128.proxiedCoords = {}, _this128._visibleDemTiles = [], _this128._drapedRenderBatches = [], _this128._sourceTilesOverlap = {}, _this128.proxySourceCache = new Ai(i.map), _this128.orthoMatrix = e.ae.create(), e.ae.ortho(_this128.orthoMatrix, "globe" === _this128.painter.transform.projection.name ? .015 : 0, e.a4, 0, e.a4, 0, 1);
        var s = n.gl;
        _this128._overlapStencilMode = new e.ah({
          func: s.GEQUAL,
          mask: 255
        }, 0, 255, s.KEEP, s.KEEP, s.REPLACE), _this128._previousZoom = t.transform.zoom, _this128.pool = [], _this128._findCoveringTileCache = {}, _this128._tilesDirty = {}, _this128.style = i, _this128._useVertexMorphing = !0, _this128._exaggeration = 1, _this128._mockSourceCache = new Di(i.map), _this128._pendingGroundEffectLayers = [];
        return _this128;
      }
      _createClass(zi, [{
        key: "style",
        set: function set(e) {
          var _this129 = this;
          e.on("data", this._onStyleDataEvent.bind(this)), this._style = e, this._style.map.on("moveend", function () {
            _this129._clearLineLayersFromRenderCache();
          });
        }
      }, {
        key: "update",
        value: function update(t, i, o) {
          var _this130 = this;
          if (t && t.terrain) {
            this._style !== t && (this.style = t, this._evaluationZoom = void 0);
            var _r369 = t.terrain.properties,
              _a184 = 0 === t.terrain.drapeRenderMode,
              _n264 = t.terrain.isZoomDependent();
            this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = e.e.now();
            var _s227 = t.terrain && t.terrain.scope,
              _l109 = _r369.get("source"),
              _c81 = _a184 ? this._mockSourceCache : t.getSourceCache(_l109, _s227);
            if (!_c81) return void e.w("Couldn't find terrain source \"".concat(_l109, "\"."));
            if (this.sourceCache = _c81, this._exaggeration = _n264 ? this.calculateExaggeration(i) : _r369.get("exaggeration"), !i.projection.requiresDraping && _n264 && 0 === this._exaggeration) return void this._disable();
            this.enabled = !0;
            var _h66 = function _h66() {
              _this130.sourceCache.used && e.w("Raster DEM source '".concat(_this130.sourceCache.id, "' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source."));
              var t = _this130.getScaledDemTileSize();
              _this130.sourceCache.update(i, t, !0), _this130.resetTileLookupCache(_this130.sourceCache.id);
            };
            this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, _h66(), this._initializing = !0), _h66(), i.updateElevation(!0, o), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i), this._emptyDEMTextureDirty = !0, this._previousZoom = i.zoom;
          } else this._disable();
        }
      }, {
        key: "calculateExaggeration",
        value: function calculateExaggeration(t) {
          var i = this._previousCameraAltitude,
            o = t.getFreeCameraOptions().position.z / t.pixelsPerMeter * t.worldSize;
          this._previousCameraAltitude = o;
          var r = null != i ? o - i : Number.MAX_VALUE;
          if (Math.abs(r) < 2) return this._exaggeration;
          var a = t.zoom,
            n = this._style.terrain;
          if (!this._previousUpdateTimestamp) return n.getExaggeration(a);
          var s = a - this._previousZoom;
          var l = this._previousUpdateTimestamp;
          var c = a;
          null != this._evaluationZoom && (c = this._evaluationZoom, Math.abs(a - c) > .5 && (s = .5 * (a - c + s)), s * r < 0 && (c += s)), this._evaluationZoom = c;
          var h = n.getExaggeration(c),
            _ = h === n.getExaggeration(Math.max(0, c - .1));
          if (_ && Math.abs(h - this._exaggeration) < .01) return h;
          var u = Math.min(.1, .00375 * (this._updateTimestamp - l));
          return (_ || h < .1 || Math.abs(s) < 1e-4) && (u = Math.min(.2, 4 * u)), e.a3(this._exaggeration, h, u);
        }
      }, {
        key: "resetTileLookupCache",
        value: function resetTileLookupCache(e) {
          this._findCoveringTileCache[e] = {};
        }
      }, {
        key: "getScaledDemTileSize",
        value: function getScaledDemTileSize() {
          return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
        }
      }, {
        key: "_onStyleDataEvent",
        value: function _onStyleDataEvent(e) {
          e.coord && "source" === e.dataType ? this._clearRenderCacheForTile(e.sourceCacheId, e.coord) : "style" === e.dataType && (this.invalidateRenderCache = !0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
        }
      }, {
        key: "_disable",
        value: function _disable() {
          if (this.enabled && (this.enabled = !1, this._emptyDEMTextureDirty = !0, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for (var _e478 in this._style._mergedSourceCaches) this._style._mergedSourceCaches[_e478].usedForTerrain = !1;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this.pool.forEach(function (e) {
            return e.fb.destroy();
          }), this.pool = [], this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
        }
      }, {
        key: "_source",
        value: function _source() {
          return this.enabled ? this.sourceCache : null;
        }
      }, {
        key: "isUsingMockSource",
        value: function isUsingMockSource() {
          return this.sourceCache === this._mockSourceCache;
        }
      }, {
        key: "exaggeration",
        value: function exaggeration() {
          return this.enabled ? this._exaggeration : 0;
        }
      }, {
        key: "visibleDemTiles",
        get: function get() {
          return this._visibleDemTiles;
        }
      }, {
        key: "drapeBufferSize",
        get: function get() {
          var e = 2 * this.proxySourceCache.getSource().tileSize;
          return [e, e];
        }
      }, {
        key: "useVertexMorphing",
        set: function set(e) {
          this._useVertexMorphing = e;
        }
      }, {
        key: "updateTileBinding",
        value: function updateTileBinding(t) {
          var _this131 = this;
          if (!this.enabled) return;
          this.prevTerrainTileForTile = this.terrainTileForTile;
          var i = this.proxySourceCache,
            o = this.painter.transform;
          this._initializing && (this._initializing = 0 === o._centerAltitude && -1 === this.getAtPointOrZero(e._.fromLngLat(o.center), -1), this._emptyDEMTextureDirty = !this._initializing);
          var r = this.proxyCoords = i.getIds().map(function (e) {
            var t = i.getTileByID(e).tileID;
            return t.projMatrix = o.calculateProjMatrix(t.toUnwrapped()), t;
          });
          !function (t, i) {
            var o = i.transform.pointCoordinate(i.transform.getCameraPoint()),
              r = new e.P(o.x, o.y);
            t.sort(function (t, i) {
              if (i.overscaledZ - t.overscaledZ) return i.overscaledZ - t.overscaledZ;
              var o = new e.P(t.canonical.x + (1 << t.canonical.z) * t.wrap, t.canonical.y),
                a = new e.P(i.canonical.x + (1 << i.canonical.z) * i.wrap, i.canonical.y),
                n = r.mult(1 << t.canonical.z);
              return n.x -= .5, n.y -= .5, n.distSqr(o) - n.distSqr(a);
            });
          }(r, this.painter);
          var a = this.proxyToSource || {};
          this.proxyToSource = {}, r.forEach(function (e) {
            _this131.proxyToSource[e.key] = {};
          }), this.terrainTileForTile = {};
          var n = this._style._mergedSourceCaches;
          for (var _e479 in n) {
            var _i329 = n[_e479];
            if (!_i329.used) continue;
            if (_i329 !== this.sourceCache && this.resetTileLookupCache(_i329.id), this._setupProxiedCoordsForOrtho(_i329, t[_e479], a), _i329.usedForTerrain) continue;
            var _o177 = t[_e479];
            _i329.getSource().reparseOverscaled && this._assignTerrainTiles(_o177);
          }
          this.proxiedCoords[i.id] = r.map(function (e) {
            return new Mi(e, e.key, _this131.orthoMatrix);
          }), this._assignTerrainTiles(r), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(a), this.renderingToTexture = !1;
          var s = {};
          this._visibleDemTiles = [];
          var _iterator339 = _createForOfIteratorHelper(this.proxyCoords),
            _step339;
          try {
            for (_iterator339.s(); !(_step339 = _iterator339.n()).done;) {
              var _e480 = _step339.value;
              var _t516 = this.terrainTileForTile[_e480.key];
              if (!_t516) continue;
              var _i330 = _t516.tileID.key;
              _i330 in s || (this._visibleDemTiles.push(_t516), s[_i330] = _i330);
            }
          } catch (err) {
            _iterator339.e(err);
          } finally {
            _iterator339.f();
          }
        }
      }, {
        key: "_assignTerrainTiles",
        value: function _assignTerrainTiles(e) {
          var _this132 = this;
          this._initializing || e.forEach(function (e) {
            if (_this132.terrainTileForTile[e.key]) return;
            var t = _this132._findTileCoveringTileID(e, _this132.sourceCache);
            t && (_this132.terrainTileForTile[e.key] = t);
          });
        }
      }, {
        key: "_prepareDEMTextures",
        value: function _prepareDEMTextures() {
          var e = this.painter.context,
            t = e.gl;
          for (var _i331 in this.terrainTileForTile) {
            var _o178 = this.terrainTileForTile[_i331],
              _r370 = _o178.dem;
            !_r370 || _o178.demTexture && !_o178.needsDEMTextureUpload || (e.activeTexture.set(t.TEXTURE1), Dt(this.painter, _o178, _r370));
          }
        }
      }, {
        key: "_prepareDemTileUniforms",
        value: function _prepareDemTileUniforms(e, t, i, o) {
          if (!t || null == t.demTexture) return !1;
          var r = e.tileID.canonical,
            a = Math.pow(2, t.tileID.canonical.z - r.z),
            n = o || "";
          return i["u_dem_tl".concat(n)] = [r.x * a % 1, r.y * a % 1], i["u_dem_scale".concat(n)] = a, !0;
        }
      }, {
        key: "emptyDEMTexture",
        get: function get() {
          return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
        }
      }, {
        key: "_getLoadedAreaMinimum",
        value: function _getLoadedAreaMinimum() {
          if (!this.enabled) return 0;
          var e = 0;
          var t = this._visibleDemTiles.reduce(function (t, i) {
            if (!i.dem) return t;
            var o = i.dem.tree.minimums[0];
            return o > 0 && e++, t + o;
          }, 0);
          return e ? t / e : 0;
        }
      }, {
        key: "_updateEmptyDEMTexture",
        value: function _updateEmptyDEMTexture() {
          var t = this.painter.context,
            i = t.gl;
          t.activeTexture.set(i.TEXTURE2);
          var o = this._getLoadedAreaMinimum(),
            _ref167 = function () {
              var t = new e.bB({
                width: 1,
                height: 1
              }, new Float32Array([o]));
              return [i.R32F, t];
            }(),
            _ref168 = _slicedToArray(_ref167, 2),
            r = _ref168[0],
            a = _ref168[1];
          this._emptyDEMTextureDirty = !1;
          var n = this._emptyDEMTexture;
          return n ? n.update(a, {
            premultiply: !1
          }) : n = this._emptyDEMTexture = new e.T(t, a, r, {
            premultiply: !1
          }), n;
        }
      }, {
        key: "setupElevationDraw",
        value: function setupElevationDraw(t, i, o) {
          var _this133 = this;
          var r = this.painter.context,
            a = r.gl,
            n = {
              u_dem: 2,
              u_dem_prev: 4,
              u_dem_tl: [0, 0],
              u_dem_tl_prev: [0, 0],
              u_dem_scale: 0,
              u_dem_scale_prev: 0,
              u_dem_size: 0,
              u_dem_lerp: 1,
              u_depth: 3,
              u_depth_size_inv: [0, 0],
              u_depth_range_unpack: [0, 1],
              u_occluder_half_size: 16,
              u_occlusion_depth_offset: -1e-4,
              u_exaggeration: 0
            };
          n.u_exaggeration = this.exaggeration();
          var s = null,
            l = null,
            c = 1;
          if (o && o.morphing && this._useVertexMorphing) {
            var _e481 = o.morphing.srcDemTile,
              _i332 = o.morphing.dstDemTile;
            c = o.morphing.phase, _e481 && _i332 && (this._prepareDemTileUniforms(t, _e481, n, "_prev") && (l = _e481), this._prepareDemTileUniforms(t, _i332, n) && (s = _i332));
          }
          var h = function h(e) {
            return e && e.demTexture && _this133.painter.linearFloatFilteringSupported() ? a.LINEAR : a.NEAREST;
          };
          var _ = null;
          var u;
          if (this.enabled ? l && s ? (_ = s.demTexture, r.activeTexture.set(a.TEXTURE4), l.demTexture.bind(h(l), a.CLAMP_TO_EDGE), n.u_dem_lerp = c) : (s = this.terrainTileForTile[t.tileID.key], _ = this._prepareDemTileUniforms(t, s, n) ? s.demTexture : this.emptyDEMTexture) : _ = this.emptyDEMTexture, r.activeTexture.set(a.TEXTURE2), _ && (n.u_dem_size = 1 === (u = _).size[0] ? 1 : u.size[0] - 2, _.bind(h(s), a.CLAMP_TO_EDGE)), this.painter.setupDepthForOcclusion(o && o.useDepthForOcclusion, i, n), o && o.useMeterToDem && s) {
            var _t517 = (1 << s.tileID.canonical.z) * e.ay(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
            n.u_meter_to_dem = _t517;
          }
          if (o && o.labelPlaneMatrixInv && (n.u_label_plane_matrix_inv = o.labelPlaneMatrixInv), i.setTerrainUniformValues(r, n), "globe" === this.painter.transform.projection.name) {
            var _e482 = this.globeUniformValues(this.painter.transform, t.tileID.canonical, o && o.useDenormalizedUpVectorScale);
            i.setGlobeUniformValues(r, _e482);
          }
        }
      }, {
        key: "globeUniformValues",
        value: function globeUniformValues(t, i, o) {
          var r = t.projection;
          return {
            u_tile_tl_up: r.upVector(i, 0, 0),
            u_tile_tr_up: r.upVector(i, e.a4, 0),
            u_tile_br_up: r.upVector(i, e.a4, e.a4),
            u_tile_bl_up: r.upVector(i, 0, e.a4),
            u_tile_up_scale: o ? e.bu(1) : r.upVectorScale(i, t.center.lat, t.worldSize).metersToTile
          };
        }
      }, {
        key: "renderToBackBuffer",
        value: function renderToBackBuffer(t) {
          var i = this.painter,
            o = this.painter.context;
          0 !== t.length && (o.bindFramebuffer.set(null), o.viewport.set([0, 0, i.width, i.height]), i.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function (t, i, o, r, a) {
            if ("globe" === t.transform.projection.name) !function (t, i, o, r, a) {
              var n = t.context,
                s = n.gl;
              var l, c;
              var h = t.transform,
                _ = e.bc(t, n, h),
                u = function u(e, i) {
                  if (c === i) return;
                  var o = [Ti[i], "PROJECTION_GLOBE_VIEW"];
                  _ && o.push("CUSTOM_ANTIALIASING");
                  var r = t.isTileAffectedByFog(e);
                  l = t.getOrCreateProgram("globeRaster", {
                    defines: o,
                    overrideFog: r
                  }), c = i;
                },
                d = t.colorModeForRenderPass(),
                p = new e.af(s.LEQUAL, e.af.ReadWrite, t.depthRangeFor3D);
              wi.update(a);
              var f = e.bd(h),
                m = [e.ak(h.center.lng), e.al(h.center.lat)],
                g = t.globeSharedBuffers,
                v = [h.width * e.e.devicePixelRatio, h.height * e.e.devicePixelRatio],
                x = Float32Array.from(h.globeMatrix),
                y = {
                  useDenormalizedUpVectorScale: !0
                };
              {
                var _h67 = t.transform,
                  _18 = Ei(_h67.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                c = -1;
                var _b13 = s.TRIANGLES;
                var _iterator340 = _createForOfIteratorHelper(r),
                  _step340;
                try {
                  for (_iterator340.s(); !(_step340 = _iterator340.n()).done;) {
                    var _c82 = _step340.value;
                    var _r371 = o.getTile(_c82),
                      _w13 = e.ah.disabled,
                      _T7 = i.prevTerrainTileForTile[_c82.key],
                      _E4 = i.terrainTileForTile[_c82.key];
                    bi(_T7, _E4) && wi.newMorphing(_c82.key, _T7, _E4, a, 250), n.activeTexture.set(s.TEXTURE0), _r371.texture && _r371.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                    var _C2 = wi.getMorphValuesForProxy(_c82.key),
                      _S11 = _C2 ? 1 : 0;
                    _C2 && e.q(y, {
                      morphing: {
                        srcDemTile: _C2.from,
                        dstDemTile: _C2.to,
                        phase: e.bb(_C2.phase)
                      }
                    });
                    var _I8 = e.be(_c82.canonical),
                      _L2 = e.bf(_I8.getCenter().lat),
                      _P6 = e.bg(_c82.canonical, _I8, _L2, _h67.worldSize / _h67._pixelsPerMercatorPixel),
                      _R2 = e.bh(e.bi(_c82.canonical)),
                      _D2 = kt(_h67.expandedFarZProjMatrix, x, f, _R2, e.a2(_h67.zoom), m, _h67.frustumCorners.TL, _h67.frustumCorners.TR, _h67.frustumCorners.BR, _h67.frustumCorners.BL, _h67.globeCenterInViewSpace, _h67.globeRadius, v, _18, _h67._farZ, _P6);
                    if (u(_c82, _S11), l && (i.setupElevationDraw(_r371, l, y), t.uploadCommonUniforms(n, l, _c82.toUnwrapped()), g)) {
                      var _g$getGridBuffers = g.getGridBuffers(_L2, 0 !== _18),
                        _g$getGridBuffers2 = _slicedToArray(_g$getGridBuffers, 3),
                        _i333 = _g$getGridBuffers2[0],
                        _o179 = _g$getGridBuffers2[1],
                        _r372 = _g$getGridBuffers2[2];
                      l.draw(t, _b13, p, _w13, d, e.ag.backCCW, _D2, "globe_raster", _i333, _o179, _r372);
                    }
                  }
                } catch (err) {
                  _iterator340.e(err);
                } finally {
                  _iterator340.f();
                }
              }
              if (g && (t.renderDefaultNorthPole || t.renderDefaultSouthPole)) {
                var _a185 = ["GLOBE_POLES", "PROJECTION_GLOBE_VIEW"];
                _ && _a185.push("CUSTOM_ANTIALIASING"), l = t.getOrCreateProgram("globeRaster", {
                  defines: _a185
                });
                var _iterator341 = _createForOfIteratorHelper(r),
                  _step341;
                try {
                  var _loop16 = function _loop16() {
                    var a = _step341.value;
                    var _a$canonical = a.canonical,
                      r = _a$canonical.x,
                      c = _a$canonical.y,
                      _ = _a$canonical.z,
                      u = 0 === c,
                      f = c === (1 << _) - 1,
                      _g$getPoleBuffers = g.getPoleBuffers(_, !1),
                      _g$getPoleBuffers2 = _slicedToArray(_g$getPoleBuffers, 4),
                      x = _g$getPoleBuffers2[0],
                      b = _g$getPoleBuffers2[1],
                      w = _g$getPoleBuffers2[2],
                      T = _g$getPoleBuffers2[3];
                    if (T && (u || f)) {
                      var _c83 = o.getTile(a);
                      n.activeTexture.set(s.TEXTURE0), _c83.texture && _c83.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                      var _g21 = e.bj(_, r, h);
                      var _E5 = e.bh(e.bi(a.canonical)),
                        _C3 = function _C3(i, o) {
                          return i.draw(t, s.TRIANGLES, p, e.ah.disabled, d, e.ag.disabled, kt(h.expandedFarZProjMatrix, _g21, _g21, _E5, 0, m, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, v, 0, h._farZ), "globe_pole_raster", o, w, T);
                        };
                      i.setupElevationDraw(_c83, l, y), t.uploadCommonUniforms(n, l, a.toUnwrapped()), u && t.renderDefaultNorthPole && _C3(l, x), f && t.renderDefaultSouthPole && (_g21 = e.ae.scale(e.ae.create(), _g21, [1, -1, 1]), _C3(l, b));
                    }
                  };
                  for (_iterator341.s(); !(_step341 = _iterator341.n()).done;) {
                    _loop16();
                  }
                } catch (err) {
                  _iterator341.e(err);
                } finally {
                  _iterator341.f();
                }
              }
            }(t, i, o, r, a);else {
              var _n265 = t.context,
                _s228 = _n265.gl;
              var _l110, _c84;
              var _h68 = t.shadowRenderer,
                _19 = ui(t, t.longestCutoffRange),
                _u86 = function _u86(e) {
                  if (_c84 === e) return;
                  var i = [];
                  i.push(Ti[e]), _19.shouldRenderCutoff && i.push("RENDER_CUTOFF"), _l110 = t.getOrCreateProgram("terrainRaster", {
                    defines: i
                  }), _c84 = e;
                },
                _d34 = t.colorModeForRenderPass(),
                _p53 = new e.af(_s228.LEQUAL, e.af.ReadWrite, t.depthRangeFor3D);
              wi.update(a);
              var _f46 = t.transform,
                _m25 = Ei(_f46.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
              var _g22 = [0, 0, 0];
              if (_h68) {
                var _e483 = t.style.directionalLight,
                  _i334 = t.style.ambientLight;
                _e483 && _i334 && (_g22 = xi(t.style, _e483, _i334));
              }
              {
                _c84 = -1;
                var _v15 = _s228.TRIANGLES,
                  _ref169 = [i.gridIndexBuffer, i.gridSegments],
                  _x19 = _ref169[0],
                  _y53 = _ref169[1];
                var _iterator342 = _createForOfIteratorHelper(r),
                  _step342;
                try {
                  for (_iterator342.s(); !(_step342 = _iterator342.n()).done;) {
                    var _c85 = _step342.value;
                    var _r373 = o.getTile(_c85),
                      _b14 = e.ah.disabled,
                      _w14 = i.prevTerrainTileForTile[_c85.key],
                      _T8 = i.terrainTileForTile[_c85.key];
                    bi(_w14, _T8) && wi.newMorphing(_c85.key, _w14, _T8, a, 250), _n265.activeTexture.set(_s228.TEXTURE0), _r373.texture && _r373.texture.bind(_s228.LINEAR, _s228.CLAMP_TO_EDGE);
                    var _E6 = wi.getMorphValuesForProxy(_c85.key),
                      _C4 = _E6 ? 1 : 0;
                    var _S12 = void 0;
                    _E6 && (_S12 = {
                      morphing: {
                        srcDemTile: _E6.from,
                        dstDemTile: _E6.to,
                        phase: e.bb(_E6.phase)
                      }
                    });
                    var _I9 = Bt(_c85.projMatrix, Ci(_c85.canonical, _f46.renderWorldCopies) ? _m25 / 10 : _m25, _g22);
                    if (_u86(_C4), !_l110) continue;
                    i.setupElevationDraw(_r373, _l110, _S12);
                    var _L3 = _c85.toUnwrapped();
                    _h68 && _h68.setupShadows(_L3, _l110), t.uploadCommonUniforms(_n265, _l110, _L3, null, _19), _l110.draw(t, _v15, _p53, _b14, _d34, e.ag.backCCW, _I9, "terrain_raster", i.gridBuffer, _x19, _y53);
                  }
                } catch (err) {
                  _iterator342.e(err);
                } finally {
                  _iterator342.f();
                }
              }
            }
          }(i, this, this.proxySourceCache, t, this._updateTimestamp), this.renderingToTexture = !0, i.gpuTimingDeferredRenderEnd(), t.splice(0, t.length));
        }
      }, {
        key: "renderBatch",
        value: function renderBatch(t) {
          if (0 === this._drapedRenderBatches.length) return t + 1;
          this.renderingToTexture = !0;
          var i = this.painter,
            o = this.painter.context,
            r = this.proxySourceCache,
            a = this.proxiedCoords[r.id],
            n = this._drapedRenderBatches.shift(),
            s = i.style.order,
            l = [];
          var c = 0;
          var _iterator343 = _createForOfIteratorHelper(a),
            _step343;
          try {
            for (_iterator343.s(); !(_step343 = _iterator343.n()).done;) {
              var _h69 = _step343.value;
              var _a186 = r.getTileByID(_h69.proxyTileKey),
                _20 = r.proxyCachedFBO[_h69.key] ? r.proxyCachedFBO[_h69.key][t] : void 0,
                _u87 = void 0 !== _20 ? r.renderCache[_20] : this.pool[c++],
                _d35 = void 0 !== _20;
              if (_a186.texture = _u87.tex, _d35 && !_u87.dirty) {
                l.push(_a186.tileID);
                continue;
              }
              var _p54 = void 0;
              o.bindFramebuffer.set(_u87.fb.framebuffer), this.renderedToTile = !1, _u87.dirty && (o.clear({
                color: e.C.transparent,
                stencil: 0
              }), _u87.dirty = !1);
              for (var _e484 = n.start; _e484 <= n.end; ++_e484) {
                var _t518 = i.style._mergedLayers[s[_e484]];
                if (_t518.isHidden(i.transform.zoom)) continue;
                var _r374 = i.style.getLayerSourceCache(_t518),
                  _a187 = _r374 ? this.proxyToSource[_h69.key][_r374.id] : [_h69];
                if (!_a187) continue;
                var _n266 = _a187;
                o.viewport.set([0, 0, _u87.fb.width, _u87.fb.height]), _p54 !== (_r374 ? _r374.id : null) && (this._setupStencil(_u87, _a187, _t518, _r374), _p54 = _r374 ? _r374.id : null), i.renderLayer(i, _r374, _t518, _n266);
              }
              if (0 === this._drapedRenderBatches.length) {
                var _iterator344 = _createForOfIteratorHelper(this._pendingGroundEffectLayers),
                  _step344;
                try {
                  for (_iterator344.s(); !(_step344 = _iterator344.n()).done;) {
                    var _e485 = _step344.value;
                    var _t519 = i.style._mergedLayers[s[_e485]];
                    if (_t519.isHidden(i.transform.zoom)) continue;
                    var _r375 = i.style.getLayerSourceCache(_t519),
                      _a188 = _r375 ? this.proxyToSource[_h69.key][_r375.id] : [_h69];
                    if (!_a188) continue;
                    var _n267 = _a188;
                    o.viewport.set([0, 0, _u87.fb.width, _u87.fb.height]), _p54 !== (_r375 ? _r375.id : null) && (this._setupStencil(_u87, _a188, _t519, _r375), _p54 = _r375 ? _r375.id : null), i.renderLayer(i, _r375, _t519, _n267);
                  }
                } catch (err) {
                  _iterator344.e(err);
                } finally {
                  _iterator344.f();
                }
              }
              this.renderedToTile ? (_u87.dirty = !0, l.push(_a186.tileID)) : _d35 || --c, 5 === c && (c = 0, this.renderToBackBuffer(l));
            }
          } catch (err) {
            _iterator343.e(err);
          } finally {
            _iterator343.f();
          }
          return this.renderToBackBuffer(l), this.renderingToTexture = !1, o.bindFramebuffer.set(null), o.viewport.set([0, 0, i.width, i.height]), n.end + 1;
        }
      }, {
        key: "postRender",
        value: function postRender() {}
      }, {
        key: "isLayerOrderingCorrect",
        value: function isLayerOrderingCorrect(e) {
          var t = e.order.length;
          var i = -1,
            o = t;
          for (var _r376 = 0; _r376 < t; ++_r376) this._style.isLayerDraped(e._mergedLayers[e.order[_r376]]) ? i = Math.max(i, _r376) : o = Math.min(o, _r376);
          return o > i;
        }
      }, {
        key: "getMinElevationBelowMSL",
        value: function getMinElevationBelowMSL() {
          var e = 0;
          return this._visibleDemTiles.filter(function (e) {
            return e.dem;
          }).forEach(function (t) {
            e = Math.min(e, t.dem.tree.minimums[0]);
          }), 0 === e ? e : (e - 30) * this._exaggeration;
        }
      }, {
        key: "raycast",
        value: function raycast(e, t, i) {
          if (!this._visibleDemTiles) return null;
          var o = this._visibleDemTiles.filter(function (e) {
            return e.dem;
          }).map(function (o) {
            var r = o.tileID,
              a = 1 << r.overscaledZ,
              _r$canonical = r.canonical,
              n = _r$canonical.x,
              s = _r$canonical.y,
              l = n / a,
              c = (n + 1) / a,
              h = s / a,
              _ = (s + 1) / a;
            return {
              minx: l,
              miny: h,
              maxx: c,
              maxy: _,
              t: o.dem.tree.raycastRoot(l, h, c, _, e, t, i),
              tile: o
            };
          });
          o.sort(function (e, t) {
            return (null !== e.t ? e.t : Number.MAX_VALUE) - (null !== t.t ? t.t : Number.MAX_VALUE);
          });
          var _iterator345 = _createForOfIteratorHelper(o),
            _step345;
          try {
            for (_iterator345.s(); !(_step345 = _iterator345.n()).done;) {
              var _r377 = _step345.value;
              if (null == _r377.t) return null;
              var _o180 = _r377.tile.dem.tree.raycast(_r377.minx, _r377.miny, _r377.maxx, _r377.maxy, e, t, i);
              if (null != _o180) return _o180;
            }
          } catch (err) {
            _iterator345.e(err);
          } finally {
            _iterator345.f();
          }
          return null;
        }
      }, {
        key: "_createFBO",
        value: function _createFBO() {
          var t = this.painter.context,
            i = t.gl,
            o = this.drapeBufferSize;
          t.activeTexture.set(i.TEXTURE0);
          var r = new e.T(t, {
            width: o[0],
            height: o[1],
            data: null
          }, i.RGBA);
          r.bind(i.LINEAR, i.CLAMP_TO_EDGE);
          var a = t.createFramebuffer(o[0], o[1], !0, null);
          return a.colorAttachment.set(r.texture), a.depthAttachment = new ie(t, a.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t.createRenderbuffer(t.gl.DEPTH_STENCIL, o[0], o[1]), this._stencilRef = 0, a.depthAttachment.set(this._sharedDepthStencil), t.clear({
            stencil: 0
          })) : a.depthAttachment.set(this._sharedDepthStencil), t.extTextureFilterAnisotropic && i.texParameterf(i.TEXTURE_2D, t.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t.extTextureFilterAnisotropicMax), {
            fb: a,
            tex: r,
            dirty: !1
          };
        }
      }, {
        key: "_initFBOPool",
        value: function _initFBOPool() {
          for (; this.pool.length < Math.min(5, this.proxyCoords.length);) this.pool.push(this._createFBO());
        }
      }, {
        key: "_shouldDisableRenderCache",
        value: function _shouldDisableRenderCache() {
          var _this134 = this;
          if (this._debugParams.disableRenderCache) return !0;
          if (this._style.hasLightTransitions()) return !0;
          for (var _e486 in this._style._mergedSourceCaches) if (this._style._mergedSourceCaches[_e486].hasTransition()) return !0;
          return this._style.order.some(function (e) {
            var t = _this134._style._mergedLayers[e],
              i = t.isHidden(_this134.painter.transform.zoom);
            return "custom" === t.type ? !i && t.shouldRedrape() : !i && t.hasTransition();
          });
        }
      }, {
        key: "_clearLineLayersFromRenderCache",
        value: function _clearLineLayersFromRenderCache() {
          var t = !1;
          var _iterator346 = _createForOfIteratorHelper(this._style.getSources()),
            _step346;
          try {
            for (_iterator346.s(); !(_step346 = _iterator346.n()).done;) {
              var _e489 = _step346.value;
              if (_e489 instanceof Ft) {
                t = !0;
                break;
              }
            }
          } catch (err) {
            _iterator346.e(err);
          } finally {
            _iterator346.f();
          }
          if (!t) return;
          var i = {};
          for (var _t520 = 0; _t520 < this._style.order.length; ++_t520) {
            var _o181 = this._style._mergedLayers[this._style.order[_t520]],
              _r378 = this._style.getLayerSourceCache(_o181);
            if (_r378 && !i[_r378.id] && !_o181.isHidden(this.painter.transform.zoom) && "line" === _o181.type && _o181.widthExpression() instanceof e.Z) {
              i[_r378.id] = !0;
              var _iterator347 = _createForOfIteratorHelper(this.proxyCoords),
                _step347;
              try {
                for (_iterator347.s(); !(_step347 = _iterator347.n()).done;) {
                  var _e487 = _step347.value;
                  var _t521 = this.proxyToSource[_e487.key][_r378.id];
                  if (_t521) {
                    var _iterator348 = _createForOfIteratorHelper(_t521),
                      _step348;
                    try {
                      for (_iterator348.s(); !(_step348 = _iterator348.n()).done;) {
                        var _e488 = _step348.value;
                        this._clearRenderCacheForTile(_r378.id, _e488);
                      }
                    } catch (err) {
                      _iterator348.e(err);
                    } finally {
                      _iterator348.f();
                    }
                  }
                }
              } catch (err) {
                _iterator347.e(err);
              } finally {
                _iterator347.f();
              }
            }
          }
        }
      }, {
        key: "_clearRasterLayersFromRenderCache",
        value: function _clearRasterLayersFromRenderCache() {
          var e = !1;
          for (var _t522 in this._style._mergedSourceCaches) if (this._style._mergedSourceCaches[_t522]._source instanceof Ot) {
            e = !0;
            break;
          }
          if (!e) return;
          var t = {};
          for (var _e490 = 0; _e490 < this._style.order.length; ++_e490) {
            var _i335 = this._style._mergedLayers[this._style.order[_e490]],
              _o182 = this._style.getLayerSourceCache(_i335);
            if (!_o182 || t[_o182.id]) continue;
            if (_i335.isHidden(this.painter.transform.zoom) || "raster" !== _i335.type) continue;
            var _r379 = _i335.paint.get("raster-fade-duration");
            var _iterator349 = _createForOfIteratorHelper(this.proxyCoords),
              _step349;
            try {
              for (_iterator349.s(); !(_step349 = _iterator349.n()).done;) {
                var _e491 = _step349.value;
                var _t523 = this.proxyToSource[_e491.key][_o182.id];
                if (_t523) {
                  var _iterator350 = _createForOfIteratorHelper(_t523),
                    _step350;
                  try {
                    for (_iterator350.s(); !(_step350 = _iterator350.n()).done;) {
                      var _e492 = _step350.value;
                      var _t524 = Ii(_o182.getTile(_e492), _o182.findLoadedParent(_e492, 0), _o182, this.painter.transform, _r379);
                      (1 !== _t524.opacity || 0 !== _t524.mix) && this._clearRenderCacheForTile(_o182.id, _e492);
                    }
                  } catch (err) {
                    _iterator350.e(err);
                  } finally {
                    _iterator350.f();
                  }
                }
              }
            } catch (err) {
              _iterator349.e(err);
            } finally {
              _iterator349.f();
            }
          }
        }
      }, {
        key: "_setupDrapedRenderBatches",
        value: function _setupDrapedRenderBatches() {
          var t = this._style.order,
            i = t.length;
          if (0 === i) return;
          var o = [];
          this._pendingGroundEffectLayers = [];
          var r,
            a = 0,
            n = this._style._mergedLayers[t[a]];
          for (; !this._style.isLayerDraped(n) && n.isHidden(this.painter.transform.zoom) && ++a < i;) n = this._style._mergedLayers[t[a]];
          for (; a < i; ++a) {
            var _e493 = this._style._mergedLayers[t[a]];
            _e493.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(_e493) ? void 0 === r && (r = a) : ("fill-extrusion" === _e493.type && this._pendingGroundEffectLayers.push(a), void 0 !== r && (o.push({
              start: r,
              end: a - 1
            }), r = void 0)));
          }
          if (void 0 !== r && o.push({
            start: r,
            end: a - 1
          }), 0 !== o.length) {
            var _t525 = o[o.length - 1];
            this._pendingGroundEffectLayers.every(function (e) {
              return e > _t525.end;
            }) || e.w("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
          }
          this._drapedRenderBatches = o;
        }
      }, {
        key: "_setupRenderCache",
        value: function _setupRenderCache(e) {
          var t = this.proxySourceCache;
          if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
            if (this.invalidateRenderCache = !1, t.renderCache.length > t.renderCachePool.length) {
              var _e494 = Object.values(t.proxyCachedFBO);
              t.proxyCachedFBO = {};
              for (var _i336 = 0; _i336 < _e494.length; ++_i336) {
                var _t$renderCachePool;
                var _o183 = Object.values(_e494[_i336]);
                (_t$renderCachePool = t.renderCachePool).push.apply(_t$renderCachePool, _o183);
              }
            }
            return;
          }
          this._clearRasterLayersFromRenderCache();
          var i = this.proxyCoords,
            o = this._tilesDirty;
          for (var _r380 = i.length - 1; _r380 >= 0; _r380--) {
            var _a189 = i[_r380];
            if (t.getTileByID(_a189.key), void 0 !== t.proxyCachedFBO[_a189.key]) {
              var _i337 = e[_a189.key],
                _r381 = this.proxyToSource[_a189.key];
              var _n268 = 0;
              var _loop17 = function _loop17(_e495) {
                var t = _r381[_e495],
                  a = _i337[_e495];
                if (!a || a.length !== t.length || t.some(function (t, i) {
                  return t !== a[i] || o[_e495] && o[_e495].hasOwnProperty(t.key);
                })) {
                  _n268 = -1;
                  return 1; // break
                }
                ++_n268;
              };
              for (var _e495 in _r381) {
                if (_loop17(_e495)) break;
              }
              for (var _e496 in t.proxyCachedFBO[_a189.key]) t.renderCache[t.proxyCachedFBO[_a189.key][_e496]].dirty = _n268 < 0 || _n268 !== Object.values(_i337).length;
            }
          }
          var r = _toConsumableArray(this._drapedRenderBatches);
          r.sort(function (e, t) {
            return t.end - t.start - (e.end - e.start);
          });
          var _iterator351 = _createForOfIteratorHelper(r),
            _step351;
          try {
            for (_iterator351.s(); !(_step351 = _iterator351.n()).done;) {
              var _e497 = _step351.value;
              var _iterator352 = _createForOfIteratorHelper(i),
                _step352;
              try {
                for (_iterator352.s(); !(_step352 = _iterator352.n()).done;) {
                  var _o184 = _step352.value;
                  if (t.proxyCachedFBO[_o184.key]) continue;
                  var _i338 = t.renderCachePool.pop();
                  void 0 === _i338 && t.renderCache.length < 50 && (_i338 = t.renderCache.length, t.renderCache.push(this._createFBO())), void 0 !== _i338 && (t.proxyCachedFBO[_o184.key] = {}, t.proxyCachedFBO[_o184.key][_e497.start] = _i338, t.renderCache[_i338].dirty = !0);
                }
              } catch (err) {
                _iterator352.e(err);
              } finally {
                _iterator352.f();
              }
            }
          } catch (err) {
            _iterator351.e(err);
          } finally {
            _iterator351.f();
          }
          this._tilesDirty = {};
        }
      }, {
        key: "_setupStencil",
        value: function _setupStencil(e, t, i, o) {
          if (!o || !this._sourceTilesOverlap[o.id]) return void (this._overlapStencilType && (this._overlapStencilType = !1));
          var r = this.painter.context,
            a = r.gl;
          if (t.length <= 1) return void (this._overlapStencilType = !1);
          var n;
          if (i.isTileClipped()) n = t.length, this._overlapStencilMode.test = {
            func: a.EQUAL,
            mask: 255
          }, this._overlapStencilType = "Clip";else {
            if (!(t[0].overscaledZ > t[t.length - 1].overscaledZ)) return void (this._overlapStencilType = !1);
            n = 1, this._overlapStencilMode.test = {
              func: a.GREATER,
              mask: 255
            }, this._overlapStencilType = "Mask";
          }
          this._stencilRef + n > 255 && (r.clear({
            stencil: 0
          }), this._stencilRef = 0), this._stencilRef += n, this._overlapStencilMode.ref = this._stencilRef, i.isTileClipped() && this._renderTileClippingMasks(t, this._overlapStencilMode.ref);
        }
      }, {
        key: "clipOrMaskOverlapStencilType",
        value: function clipOrMaskOverlapStencilType() {
          return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
        }
      }, {
        key: "stencilModeForRTTOverlap",
        value: function stencilModeForRTTOverlap(t) {
          return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[t.key]), this._overlapStencilMode) : e.ah.disabled;
        }
      }, {
        key: "_renderTileClippingMasks",
        value: function _renderTileClippingMasks(t, i) {
          var o = this.painter,
            r = this.painter.context,
            a = r.gl;
          o._tileClippingMaskIDs = {}, r.setColorMode(e.a.disabled), r.setDepthMode(e.af.disabled);
          var n = o.getOrCreateProgram("clippingMask");
          var _iterator353 = _createForOfIteratorHelper(t),
            _step353;
          try {
            for (_iterator353.s(); !(_step353 = _iterator353.n()).done;) {
              var _r382 = _step353.value;
              var _t526 = o._tileClippingMaskIDs[_r382.key] = --i;
              n.draw(o, a.TRIANGLES, e.af.disabled, new e.ah({
                func: a.ALWAYS,
                mask: 0
              }, _t526, 255, a.KEEP, a.KEEP, a.REPLACE), e.a.disabled, e.ag.disabled, Si(_r382.projMatrix), "$clipping", o.tileExtentBuffer, o.quadTriangleIndexBuffer, o.tileExtentSegments);
            }
          } catch (err) {
            _iterator353.e(err);
          } finally {
            _iterator353.f();
          }
        }
      }, {
        key: "pointCoordinate",
        value: function pointCoordinate(t) {
          var i = this.painter.transform;
          if (t.x < 0 || t.x > i.width || t.y < 0 || t.y > i.height) return null;
          var o = [t.x, t.y, 1, 1];
          e.aB.transformMat4(o, o, i.pixelMatrixInverse), e.aB.scale(o, o, 1 / o[3]), o[0] /= i.worldSize, o[1] /= i.worldSize;
          var r = i._camera.position,
            a = e.ay(1, i.center.lat),
            n = [r[0], r[1], r[2] / a, 0],
            s = e.$.subtract([], o.slice(0, 3), n);
          e.$.normalize(s, s);
          var l = this.raycast(n, s, this._exaggeration);
          return null !== l && l ? (e.$.scaleAndAdd(n, n, s, l), n[3] = n[2], n[2] *= a, n) : null;
        }
      }, {
        key: "_setupProxiedCoordsForOrtho",
        value: function _setupProxiedCoordsForOrtho(t, i, o) {
          if (t.getSource() instanceof e.bo) return this._setupProxiedCoordsForImageSource(t, i, o);
          this._findCoveringTileCache[t.id] = this._findCoveringTileCache[t.id] || {};
          var r = this.proxiedCoords[t.id] = [],
            a = this.proxyCoords;
          for (var _e498 = 0; _e498 < a.length; _e498++) {
            var _i339 = a[_e498],
              _n269 = this._findTileCoveringTileID(_i339, t);
            if (_n269) {
              var _e499 = this._createProxiedId(_i339, _n269, o[_i339.key] && o[_i339.key][t.id]);
              r.push(_e499), this.proxyToSource[_i339.key][t.id] = [_e499];
            }
          }
          var n = !1;
          var s = new Set();
          for (var _e500 = 0; _e500 < i.length; _e500++) {
            var _a190 = t.getTile(i[_e500]);
            if (!_a190 || !_a190.hasData()) continue;
            var _l111 = this._findTileCoveringTileID(_a190.tileID, this.proxySourceCache);
            if (_l111 && _l111.tileID.canonical.z !== _a190.tileID.canonical.z) {
              var _e501 = this.proxyToSource[_l111.tileID.key][t.id],
                _i340 = this._createProxiedId(_l111.tileID, _a190, o[_l111.tileID.key] && o[_l111.tileID.key][t.id]);
              _e501 ? _e501.splice(_e501.length - 1, 0, _i340) : this.proxyToSource[_l111.tileID.key][t.id] = [_i340];
              var _c86 = this.proxyToSource[_l111.tileID.key][t.id];
              s.has(_c86) || s.add(_c86), r.push(_i340), n = !0;
            }
          }
          if (this._sourceTilesOverlap[t.id] = n, n && this._debugParams.sortTilesHiZFirst) {
            var _iterator354 = _createForOfIteratorHelper(s),
              _step354;
            try {
              for (_iterator354.s(); !(_step354 = _iterator354.n()).done;) {
                var _e502 = _step354.value;
                _e502.sort(function (e, t) {
                  return t.overscaledZ - e.overscaledZ;
                });
              }
            } catch (err) {
              _iterator354.e(err);
            } finally {
              _iterator354.f();
            }
          }
        }
      }, {
        key: "_setupProxiedCoordsForImageSource",
        value: function _setupProxiedCoordsForImageSource(t, i, o) {
          if (!t.getSource().loaded()) return;
          var r = this.proxiedCoords[t.id] = [],
            a = this.proxyCoords,
            n = t.getSource(),
            s = n.tileID;
          if (!s) return;
          var l = new e.P(s.x, s.y)._div(1 << s.z),
            c = n.coordinates.map(e._.fromLngLat).reduce(function (e, t) {
              return e.min.x = Math.min(e.min.x, t.x - l.x), e.min.y = Math.min(e.min.y, t.y - l.y), e.max.x = Math.max(e.max.x, t.x - l.x), e.max.y = Math.max(e.max.y, t.y - l.y), e;
            }, {
              min: new e.P(Number.MAX_VALUE, Number.MAX_VALUE),
              max: new e.P(-Number.MAX_VALUE, -Number.MAX_VALUE)
            }),
            h = function h(t, i) {
              var o = t.wrap + t.canonical.x / (1 << t.canonical.z),
                r = t.canonical.y / (1 << t.canonical.z),
                a = e.a4 / (1 << t.canonical.z),
                n = i.wrap + i.canonical.x / (1 << i.canonical.z),
                s = i.canonical.y / (1 << i.canonical.z);
              return o + a < n + c.min.x || o > n + c.max.x || r + a < s + c.min.y || r > s + c.max.y;
            };
          for (var _e503 = 0; _e503 < a.length; _e503++) {
            var _n270 = a[_e503];
            for (var _e504 = 0; _e504 < i.length; _e504++) {
              var _a191 = t.getTile(i[_e504]);
              if (!_a191 || !_a191.hasData()) continue;
              if (h(_n270, _a191.tileID)) continue;
              var _s229 = this._createProxiedId(_n270, _a191, o[_n270.key] && o[_n270.key][t.id]),
                _l112 = this.proxyToSource[_n270.key][t.id];
              _l112 ? _l112.push(_s229) : this.proxyToSource[_n270.key][t.id] = [_s229], r.push(_s229);
            }
          }
        }
      }, {
        key: "_createProxiedId",
        value: function _createProxiedId(t, i, o) {
          var r = this.orthoMatrix;
          if (o) {
            var _e505 = o.find(function (e) {
              return e.key === i.tileID.key;
            });
            if (_e505) return _e505;
          }
          if (i.tileID.key !== t.key) {
            var _o185 = t.canonical.z - i.tileID.canonical.z;
            var _a192, _n271, _s230;
            r = e.ae.create();
            var _l113 = i.tileID.wrap - t.wrap << t.overscaledZ;
            _o185 > 0 ? (_a192 = e.a4 >> _o185, _n271 = _a192 * ((i.tileID.canonical.x << _o185) - t.canonical.x + _l113), _s230 = _a192 * ((i.tileID.canonical.y << _o185) - t.canonical.y)) : (_a192 = e.a4 << -_o185, _n271 = e.a4 * (i.tileID.canonical.x - (t.canonical.x + _l113 << -_o185)), _s230 = e.a4 * (i.tileID.canonical.y - (t.canonical.y << -_o185))), e.ae.ortho(r, 0, _a192, 0, _a192, 0, 1), e.ae.translate(r, r, [_n271, _s230, 0]);
          }
          return new Mi(i.tileID, t.key, r);
        }
      }, {
        key: "_findTileCoveringTileID",
        value: function _findTileCoveringTileID(t, i) {
          var o = i.getTile(t);
          if (o && o.hasData()) return o;
          var r = this._findCoveringTileCache[i.id],
            a = r[t.key];
          if (o = a ? i.getTileByID(a) : null, o && o.hasData() || null === a) return o;
          var n = o ? o.tileID : t,
            s = n.overscaledZ;
          var l = i.getSource().minzoom,
            c = [];
          if (!a) {
            var _r383 = i.getSource().maxzoom;
            if (t.canonical.z >= _r383) {
              var _o186 = t.canonical.z - _r383;
              i.getSource().reparseOverscaled ? (s = Math.max(t.canonical.z + 2, i.transform.tileZoom), n = new e.aQ(s, t.wrap, _r383, t.canonical.x >> _o186, t.canonical.y >> _o186)) : 0 !== _o186 && (s = _r383, n = new e.aQ(s, t.wrap, _r383, t.canonical.x >> _o186, t.canonical.y >> _o186));
            }
            n.key !== t.key && (c.push(n.key), o = i.getTile(n));
          }
          var h = function h(e) {
            c.forEach(function (t) {
              r[t] = e;
            }), c.length = 0;
          };
          for (s -= 1; s >= l && (!o || !o.hasData()); s--) {
            o && h(o.tileID.key);
            var _e506 = n.calculateScaledKey(s);
            if (o = i.getTileByID(_e506), o && o.hasData()) break;
            var _t527 = r[_e506];
            if (null === _t527) break;
            void 0 === _t527 ? c.push(_e506) : o = i.getTileByID(_t527);
          }
          return h(o ? o.tileID.key : null), o && o.hasData() ? o : null;
        }
      }, {
        key: "findDEMTileFor",
        value: function findDEMTileFor(e) {
          return this.enabled ? this._findTileCoveringTileID(e, this.sourceCache) : null;
        }
      }, {
        key: "prepareDrawTile",
        value: function prepareDrawTile() {
          this.renderedToTile = !0;
        }
      }, {
        key: "_clearRenderCacheForTile",
        value: function _clearRenderCacheForTile(e, t) {
          var i = this._tilesDirty[e];
          i || (i = this._tilesDirty[e] = {}), i[t.key] = !0;
        }
      }]);
      return zi;
    }(e.bs);
    function Oi(t, i, o) {
      var r = function (t, i, o) {
          var r = e.$.dot(i, t),
            a = e.$.dot(o, [.2126, .7152, .0722]),
            n = function n(e, t, i) {
              return (1 - i) * e + i * t;
            },
            s = n(1 - .3 * Math.min(a, 1), 1, Math.min(r + 1, 1));
          return n(.92, 1, Math.asin(e.au(i[2], -1, 1)) / Math.PI + .5) * s;
        }(t, [0, 0, 1], i),
        a = [0, 0, 0];
      e.$.scale(a, o.slice(0, 3), r);
      var n = [0, 0, 0];
      e.$.scale(n, i.slice(0, 3), t[2]);
      var s = [0, 0, 0];
      return e.$.add(s, a, n), e.ba(s);
    }
    var Fi = ["fill", "fillOutline", "fillPattern", "line", "linePattern", "background", "backgroundPattern", "hillshade", "raster"],
      Bi = ["stars", "fillExtrusion", "fillExtrusionGroundEffect", "model", "symbolSDF", "symbolIcon", "symbolTextAndIcon"];
    var ki = /*#__PURE__*/function () {
      function ki(t, i, o, r, a, n) {
        _classCallCheck(this, ki);
        var s = t.gl;
        this.program = s.createProgram(), this.configuration = r, this.name = i, this.fixedDefines = _toConsumableArray(n);
        var l = r ? r.getBinderAttributes() : [],
          c = (o.staticAttributes || []).concat(l);
        var h = r ? r.defines() : [];
        h = h.concat(n.map(function (e) {
          return "#define ".concat(e);
        }));
        var _ = "#version 300 es\n";
        var u = _ + h.concat("precision mediump float;", Et, Tt.fragmentSource).join("\n");
        var _iterator355 = _createForOfIteratorHelper(o.fragmentIncludes),
          _step355;
        try {
          for (_iterator355.s(); !(_step355 = _iterator355.n()).done;) {
            var _e508 = _step355.value;
            u += "\n".concat(bt[_e508]);
          }
        } catch (err) {
          _iterator355.e(err);
        } finally {
          _iterator355.f();
        }
        u += "\n".concat(o.fragmentSource);
        var d = _ + h.concat("precision highp float;", Et, Tt.vertexSource).join("\n");
        var _iterator356 = _createForOfIteratorHelper(o.vertexIncludes),
          _step356;
        try {
          for (_iterator356.s(); !(_step356 = _iterator356.n()).done;) {
            var _e509 = _step356.value;
            d += "\n".concat(bt[_e509]);
          }
        } catch (err) {
          _iterator356.e(err);
        } finally {
          _iterator356.f();
        }
        d += "\n".concat(o.vertexSource);
        var p = s.createShader(s.FRAGMENT_SHADER);
        if (s.isContextLost()) return void (this.failedToCreate = !0);
        s.shaderSource(p, u), s.compileShader(p), s.attachShader(this.program, p);
        var f = s.createShader(s.VERTEX_SHADER);
        if (s.isContextLost()) this.failedToCreate = !0;else {
          s.shaderSource(f, d), s.compileShader(f), s.attachShader(this.program, f), this.attributes = {}, this.numAttributes = c.length;
          for (var _e507 = 0; _e507 < this.numAttributes; _e507++) if (c[_e507]) {
            var _t528 = c[_e507].startsWith("a_") ? c[_e507] : "a_".concat(c[_e507]);
            s.bindAttribLocation(this.program, _e507, _t528), this.attributes[_t528] = _e507;
          }
          s.linkProgram(this.program), s.deleteShader(f), s.deleteShader(p), this.fixedUniforms = a(t), this.binderUniforms = r ? r.getUniforms(t) : [], (n.includes("TERRAIN") || -1 !== i.indexOf("symbol") || -1 !== i.indexOf("circle")) && (this.terrainUniforms = function (t) {
            return {
              u_dem: new e.a8(t),
              u_dem_prev: new e.a8(t),
              u_dem_tl: new e.a9(t),
              u_dem_scale: new e.ab(t),
              u_dem_tl_prev: new e.a9(t),
              u_dem_scale_prev: new e.ab(t),
              u_dem_size: new e.ab(t),
              u_dem_lerp: new e.ab(t),
              u_exaggeration: new e.ab(t),
              u_depth: new e.a8(t),
              u_depth_size_inv: new e.a9(t),
              u_depth_range_unpack: new e.a9(t),
              u_occluder_half_size: new e.ab(t),
              u_occlusion_depth_offset: new e.ab(t),
              u_meter_to_dem: new e.ab(t),
              u_label_plane_matrix_inv: new e.a7(t)
            };
          }(t)), n.includes("GLOBE") && (this.globeUniforms = function (t) {
            return {
              u_tile_tl_up: new e.ar(t),
              u_tile_tr_up: new e.ar(t),
              u_tile_br_up: new e.ar(t),
              u_tile_bl_up: new e.ar(t),
              u_tile_up_scale: new e.ab(t)
            };
          }(t)), n.includes("FOG") && (this.fogUniforms = function (t) {
            return {
              u_fog_matrix: new e.a7(t),
              u_fog_range: new e.a9(t),
              u_fog_color: new e.at(t),
              u_fog_horizon_blend: new e.ab(t),
              u_fog_vertical_limit: new e.a9(t),
              u_fog_temporal_offset: new e.ab(t),
              u_frustum_tl: new e.ar(t),
              u_frustum_tr: new e.ar(t),
              u_frustum_br: new e.ar(t),
              u_frustum_bl: new e.ar(t),
              u_globe_pos: new e.ar(t),
              u_globe_radius: new e.ab(t),
              u_globe_transition: new e.ab(t),
              u_is_globe: new e.a8(t),
              u_viewport: new e.a9(t)
            };
          }(t)), n.includes("RENDER_CUTOFF") && (this.cutoffUniforms = function (t) {
            return {
              u_cutoff_params: new e.at(t)
            };
          }(t)), n.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = function (t) {
            return {
              u_lighting_ambient_color: new e.ar(t),
              u_lighting_directional_dir: new e.ar(t),
              u_lighting_directional_color: new e.ar(t),
              u_ground_radiance: new e.ar(t)
            };
          }(t)), n.includes("RENDER_SHADOWS") && (this.shadowUniforms = function (t) {
            return {
              u_light_matrix_0: new e.a7(t),
              u_light_matrix_1: new e.a7(t),
              u_fade_range: new e.a9(t),
              u_shadow_normal_offset: new e.ar(t),
              u_shadow_intensity: new e.ab(t),
              u_shadow_texel_size: new e.ab(t),
              u_shadow_map_resolution: new e.ab(t),
              u_shadow_direction: new e.ar(t),
              u_shadow_bias: new e.ar(t),
              u_shadowmap_0: new e.a8(t),
              u_shadowmap_1: new e.a8(t)
            };
          }(t));
        }
      }
      _createClass(ki, [{
        key: "setTerrainUniformValues",
        value: function setTerrainUniformValues(e, t) {
          if (!this.terrainUniforms) return;
          var i = this.terrainUniforms;
          if (!this.failedToCreate) {
            e.program.set(this.program);
            for (var _e510 in t) i[_e510] && i[_e510].set(this.program, _e510, t[_e510]);
          }
        }
      }, {
        key: "setGlobeUniformValues",
        value: function setGlobeUniformValues(e, t) {
          if (!this.globeUniforms) return;
          var i = this.globeUniforms;
          if (!this.failedToCreate) {
            e.program.set(this.program);
            for (var _e511 in t) i[_e511] && i[_e511].set(this.program, _e511, t[_e511]);
          }
        }
      }, {
        key: "setFogUniformValues",
        value: function setFogUniformValues(e, t) {
          if (!this.fogUniforms) return;
          var i = this.fogUniforms;
          if (!this.failedToCreate) {
            e.program.set(this.program);
            for (var _e512 in t) i[_e512].set(this.program, _e512, t[_e512]);
          }
        }
      }, {
        key: "setCutoffUniformValues",
        value: function setCutoffUniformValues(e, t) {
          if (!this.cutoffUniforms) return;
          var i = this.cutoffUniforms;
          if (!this.failedToCreate) {
            e.program.set(this.program);
            for (var _e513 in t) i[_e513].set(this.program, _e513, t[_e513]);
          }
        }
      }, {
        key: "setLightsUniformValues",
        value: function setLightsUniformValues(e, t) {
          if (!this.lightsUniforms) return;
          var i = this.lightsUniforms;
          if (!this.failedToCreate) {
            e.program.set(this.program);
            for (var _e514 in t) i[_e514].set(this.program, _e514, t[_e514]);
          }
        }
      }, {
        key: "setShadowUniformValues",
        value: function setShadowUniformValues(e, t) {
          if (this.failedToCreate || !this.shadowUniforms) return;
          var i = this.shadowUniforms;
          e.program.set(this.program);
          for (var _e515 in t) i[_e515].set(this.program, _e515, t[_e515]);
        }
      }, {
        key: "_drawDebugWireframe",
        value: function _drawDebugWireframe(t, i, o, r, a, n, s, l, c, h) {
          var _this135 = this;
          var _ = t.options.wireframe;
          if (!1 === _.terrain && !1 === _.layers2D && !1 === _.layers3D) return;
          var u = t.context;
          if (!function () {
            return !(!_.terrain || "terrainRaster" !== _this135.name && "globeRaster" !== _this135.name) || !(!_.layers2D || t._terrain && t._terrain.renderingToTexture || !Fi.includes(_this135.name)) || !(!_.layers3D || !Bi.includes(_this135.name));
          }()) return;
          var d = u.gl,
            p = t.wireframeDebugCache.getLinesFromTrianglesBuffer(t.frameCounter, a, u);
          if (!p) return;
          var f = _toConsumableArray(this.fixedDefines);
          f.push("DEBUG_WIREFRAME");
          var m = t.getOrCreateProgram(this.name, {
            config: this.configuration,
            defines: f
          });
          u.program.set(m.program);
          var g = function g(e, t, i) {
            if (t[e] && i[e]) for (var _o187 in t[e]) i[e][_o187] && i[e][_o187].set(i.program, _o187, t[e][_o187].current);
          };
          c && c.setUniforms(m.program, u, m.binderUniforms, s, {
            zoom: l
          }), g("fixedUniforms", this, m), g("terrainUniforms", this, m), g("globeUniforms", this, m), g("fogUniforms", this, m), g("lightsUniforms", this, m), g("shadowUniforms", this, m), p.bind(), u.setColorMode(new e.a([d.ONE, d.ONE_MINUS_SRC_ALPHA, d.ZERO, d.ONE], e.C.transparent, [!0, !0, !0, !1])), u.setDepthMode(new e.af(i.func === d.LESS ? d.LEQUAL : i.func, e.af.ReadOnly, i.range)), u.setStencilMode(e.ah.disabled);
          var v = 3 * n.primitiveLength * 2,
            x = 3 * n.primitiveOffset * 2 * 2;
          h && h > 1 ? d.drawElementsInstanced(d.LINES, v, d.UNSIGNED_SHORT, x, h) : d.drawElements(d.LINES, v, d.UNSIGNED_SHORT, x), a.bind(), u.program.set(this.program), u.setDepthMode(i), u.setStencilMode(o), u.setColorMode(r);
        }
      }, {
        key: "draw",
        value: function draw(e, t, i, o, r, a, n, s, l, c, h, _, u, d, p, f) {
          var m = e.context,
            g = m.gl;
          if (this.failedToCreate) return;
          m.program.set(this.program), m.setDepthMode(i), m.setStencilMode(o), m.setColorMode(r), m.setCullFace(a);
          for (var _i341 = 0, _Object$keys16 = Object.keys(this.fixedUniforms); _i341 < _Object$keys16.length; _i341++) {
            var _e516 = _Object$keys16[_i341];
            this.fixedUniforms[_e516].set(this.program, _e516, n[_e516]);
          }
          d && d.setUniforms(this.program, m, this.binderUniforms, _, {
            zoom: u
          });
          var v = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, g.POINTS, 1), g.LINES, 2), g.TRIANGLES, 3), g.LINE_STRIP, 1)[t],
            x = f && f > 0 ? 1 : void 0;
          var _iterator357 = _createForOfIteratorHelper(h.get()),
            _step357;
          try {
            for (_iterator357.s(); !(_step357 = _iterator357.n()).done;) {
              var _a193 = _step357.value;
              var _n272 = _a193.vaos || (_a193.vaos = {});
              (_n272[s] || (_n272[s] = new Lt())).bind(m, this, l, d ? d.getPaintVertexBuffers() : [], c, _a193.vertexOffset, p || [], x), f && f > 1 ? g.drawElementsInstanced(t, _a193.primitiveLength * v, g.UNSIGNED_SHORT, _a193.primitiveOffset * v * 2, f) : c ? g.drawElements(t, _a193.primitiveLength * v, g.UNSIGNED_SHORT, _a193.primitiveOffset * v * 2) : g.drawArrays(t, _a193.vertexOffset, _a193.vertexLength), t === g.TRIANGLES && c && this._drawDebugWireframe(e, i, o, r, c, _a193, _, u, d, f);
            }
          } catch (err) {
            _iterator357.e(err);
          } finally {
            _iterator357.f();
          }
        }
      }], [{
        key: "cacheKey",
        value: function cacheKey(e, t, i, o) {
          var r = "".concat(t).concat(o ? o.cacheKey : "");
          var _iterator358 = _createForOfIteratorHelper(i),
            _step358;
          try {
            for (_iterator358.s(); !(_step358 = _iterator358.n()).done;) {
              var _t529 = _step358.value;
              e.usedDefines.includes(_t529) && (r += "/".concat(_t529));
            }
          } catch (err) {
            _iterator358.e(err);
          } finally {
            _iterator358.f();
          }
          return r;
        }
      }]);
      return ki;
    }();
    function Ni(t, i) {
      var o = Math.pow(2, i.tileID.overscaledZ),
        r = i.tileSize * Math.pow(2, t.transform.tileZoom) / o,
        a = r * (i.tileID.canonical.x + i.tileID.wrap * o),
        n = r * i.tileID.canonical.y;
      return {
        u_image: 0,
        u_texsize: i.imageAtlasTexture ? i.imageAtlasTexture.size : [0, 0],
        u_tile_units_to_pixels: 1 / e.bD(i, 1, t.transform.tileZoom),
        u_pixel_coord_upper: [a >> 16, n >> 16],
        u_pixel_coord_lower: [65535 & a, 65535 & n]
      };
    }
    var Ui = e.ae.create(),
      Gi = function Gi(t, i, o, r, a, n, s, l, c, h, _, u, d, p, f, m, g, v) {
        var x = i.style.light,
          y = x.properties.get("position"),
          b = [y.x, y.y, y.z],
          w = e.bE.create();
        "viewport" === x.properties.get("anchor") && (e.bE.fromRotation(w, -i.transform.angle), e.$.transformMat3(b, b, w));
        var T = x.properties.get("color"),
          E = i.transform,
          C = {
            u_matrix: t,
            u_lightpos: b,
            u_lightintensity: x.properties.get("intensity"),
            u_lightcolor: [T.r, T.g, T.b],
            u_vertical_gradient: +o,
            u_opacity: r,
            u_tile_id: [0, 0, 0],
            u_zoom_transition: 0,
            u_inv_rot_matrix: Ui,
            u_merc_center: [0, 0],
            u_up_dir: [0, 0, 0],
            u_height_lift: 0,
            u_ao: a,
            u_edge_radius: n,
            u_alignment: s,
            u_width_scale: l,
            u_flood_light_color: p,
            u_vertical_scale: f,
            u_flood_light_intensity: m,
            u_ground_shadow_factor: g,
            u_emissive_strength: v
          };
        return "globe" === E.projection.name && (C.u_tile_id = [c.canonical.x, c.canonical.y, 1 << c.canonical.z], C.u_zoom_transition = _, C.u_inv_rot_matrix = d, C.u_merc_center = u, C.u_up_dir = E.projection.upVector(new e.aO(0, 0, 0), u[0] * e.a4, u[1] * e.a4), C.u_height_lift = h), C;
      },
      ji = function ji(e, t, i, o, r) {
        return {
          u_matrix: e,
          u_edge_radius: t,
          u_alignment: i,
          u_width_scale: o,
          u_vertical_scale: r
        };
      },
      Vi = function Vi(t, i, o, r, a, n, s, l, c, h, _, u, d, p, f, m) {
        var g = Gi(t, i, o, r, a, n, s, l, c, _, u, d, p, f, m, 1, [0, 0, 0], 0),
          v = {
            u_height_factor: -Math.pow(2, c.overscaledZ) / h.tileSize / 8
          };
        return e.Q(g, Ni(i, h), v);
      },
      $i = function $i(e, t) {
        return {
          u_matrix: e,
          u_emissive_strength: t
        };
      },
      Zi = function Zi(t, i, o, r) {
        return e.Q($i(t, i), Ni(o, r));
      },
      Wi = function Wi(e, t, i) {
        return {
          u_matrix: e,
          u_world: i,
          u_emissive_strength: t
        };
      },
      Hi = function Hi(t, i, o, r, a) {
        return e.Q(Zi(t, i, o, r), {
          u_world: a
        });
      },
      qi = function qi(t, i, o, r) {
        var a = e.a4 / o.tileSize;
        return {
          u_matrix: t,
          u_camera_to_center_distance: i.getCameraToCenterDistance(r),
          u_extrude_scale: [i.pixelsToGLUnits[0] / a, i.pixelsToGLUnits[1] / a]
        };
      },
      Xi = function Xi(e, t) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        return {
          u_matrix: e,
          u_color: t.toRenderColor(null),
          u_overlay: 0,
          u_overlay_scale: i
        };
      },
      Qi = e.ae.create(),
      Yi = function Yi(t, i, o, r, a, n, s) {
        var l = t.transform,
          c = "globe" === l.projection.name,
          h = c ? e.bF(l.zoom, i.canonical) * l._pixelsPerMercatorPixel : e.bD(o, 1, n),
          _ = {
            u_matrix: i.projMatrix,
            u_extrude_scale: h,
            u_intensity: s,
            u_inv_rot_matrix: Qi,
            u_merc_center: [0, 0],
            u_tile_id: [0, 0, 0],
            u_zoom_transition: 0,
            u_up_dir: [0, 0, 0]
          };
        if (c) {
          _.u_inv_rot_matrix = r, _.u_merc_center = a, _.u_tile_id = [i.canonical.x, i.canonical.y, 1 << i.canonical.z], _.u_zoom_transition = e.a2(l.zoom);
          var _t530 = a[0] * e.a4,
            _o188 = a[1] * e.a4;
          _.u_up_dir = l.projection.upVector(new e.aO(0, 0, 0), _t530, _o188);
        }
        return _;
      };
    function Ji(e, _ref170, _ref171) {
      var _ref172 = _slicedToArray(_ref170, 4),
        t = _ref172[0],
        i = _ref172[1],
        o = _ref172[2],
        r = _ref172[3];
      var _ref173 = _slicedToArray(_ref171, 2),
        a = _ref173[0],
        n = _ref173[1];
      if (a === n) return [0, 0, 0, 0];
      var s = 255 * (e - 1) / (e * (n - a));
      return [t * s, i * s, o * s, r * s];
    }
    function Ki(e, t, _ref174) {
      var _ref175 = _slicedToArray(_ref174, 2),
        i = _ref175[0],
        o = _ref175[1];
      return i === o ? 0 : .5 / e + (t - i) * (e - 1) / (e * (o - i));
    }
    var eo = function eo(t, i, o, r, a, n, s, l, c, h, _, u, d, p, f, m, g, v, x, y, b) {
      return {
        u_matrix: t,
        u_normalize_matrix: i,
        u_globe_matrix: o,
        u_merc_matrix: r,
        u_grid_matrix: a,
        u_tl_parent: n,
        u_scale_parent: h,
        u_fade_t: _.mix,
        u_opacity: _.opacity * u.paint.get("raster-opacity"),
        u_image0: 0,
        u_image1: 1,
        u_brightness_low: u.paint.get("raster-brightness-min"),
        u_brightness_high: u.paint.get("raster-brightness-max"),
        u_saturation_factor: e.bG(u.paint.get("raster-saturation")),
        u_contrast_factor: e.bH(u.paint.get("raster-contrast")),
        u_spin_weights: to(u.paint.get("raster-hue-rotate")),
        u_perspective_transform: d,
        u_raster_elevation: p,
        u_zoom_transition: s,
        u_merc_center: l,
        u_cutoff_params: c,
        u_colorization_mix: Ji(e.bI, m, v),
        u_colorization_offset: Ki(e.bI, g, v),
        u_color_ramp: f,
        u_texture_offset: [y / (x + 2 * y), x / (x + 2 * y)],
        u_texture_res: [x + 2 * y, x + 2 * y],
        u_emissive_strength: b
      };
    };
    function to(e) {
      e *= Math.PI / 180;
      var t = Math.sin(e),
        i = Math.cos(e);
      return [(2 * i + 1) / 3, (-Math.sqrt(3) * t - i + 1) / 3, (Math.sqrt(3) * t - i + 1) / 3];
    }
    var io = .05,
      oo = function oo(e, t, i, o, r, a, n, s, l, c, h, _) {
        return {
          u_matrix: e,
          u_normalize_matrix: t,
          u_globe_matrix: i,
          u_merc_matrix: o,
          u_grid_matrix: r,
          u_tl_parent: a,
          u_scale_parent: c,
          u_fade_t: h.mix,
          u_opacity: h.opacity,
          u_image0: 0,
          u_image1: 1,
          u_raster_elevation: _,
          u_zoom_transition: n,
          u_merc_center: s,
          u_cutoff_params: l
        };
      },
      ro = function ro(e, t, i, o, r, a, n, s, l, c) {
        return {
          u_particle_texture: e,
          u_particle_texture_side_len: t,
          u_tile_offset: i,
          u_velocity: o,
          u_color_ramp: a,
          u_velocity_res: r,
          u_max_speed: n,
          u_uv_offset: s,
          u_data_scale: [255 * l[0], 255 * l[1]],
          u_data_offset: c,
          u_particle_pos_scale: 1.1,
          u_particle_pos_offset: [io, io]
        };
      },
      ao = function ao(e, t, i, o, r, a, n, s, l, c) {
        return {
          u_particle_texture: e,
          u_particle_texture_side_len: t,
          u_velocity: i,
          u_velocity_res: o,
          u_max_speed: r,
          u_speed_factor: a,
          u_reset_rate: n,
          u_rand_seed: Math.random(),
          u_uv_offset: s,
          u_data_scale: [255 * l[0], 255 * l[1]],
          u_data_offset: c,
          u_particle_pos_scale: 1.1,
          u_particle_pos_offset: [io, io]
        };
      },
      no = e.ae.create(),
      so = function so(t, i, o, r, a, n, s, l, c, h, _, u, d, p, f, m, g, v) {
        var x = a.transform,
          y = {
            u_is_size_zoom_constant: +("constant" === t || "source" === t),
            u_is_size_feature_constant: +("constant" === t || "camera" === t),
            u_size_t: i ? i.uSizeT : 0,
            u_size: i ? i.uSize : 0,
            u_camera_to_center_distance: x.getCameraToCenterDistance(m),
            u_rotate_symbol: +o,
            u_aspect_ratio: x.width / x.height,
            u_fade_change: a.options.fadeDuration ? a.symbolFadeChange : 1,
            u_matrix: n,
            u_label_plane_matrix: s,
            u_coord_matrix: l,
            u_is_text: +c,
            u_pitch_with_map: +r,
            u_texsize: h,
            u_texture: 0,
            u_tile_id: [0, 0, 0],
            u_zoom_transition: 0,
            u_inv_rot_matrix: no,
            u_merc_center: [0, 0],
            u_camera_forward: [0, 0, 0],
            u_ecef_origin: [0, 0, 0],
            u_tile_matrix: no,
            u_up_vector: [0, -1, 0],
            u_color_adj_mat: g,
            u_icon_transition: v || 0
          };
        return "globe" === m.name && (y.u_tile_id = [_.canonical.x, _.canonical.y, 1 << _.canonical.z], y.u_zoom_transition = u, y.u_inv_rot_matrix = p, y.u_merc_center = d, y.u_camera_forward = x._camera.forward(), y.u_ecef_origin = e.bJ(x.globeMatrix, _.toUnwrapped()), y.u_tile_matrix = Float32Array.from(x.globeMatrix), y.u_up_vector = f), y;
      },
      lo = function lo(t, i, o, r, a, n, s, l, c, h, _, u, d, p, f, m, g) {
        return e.Q(so(t, i, o, r, a, n, s, l, c, h, u, d, p, f, m, g), {
          u_gamma_scale: r ? a.transform.getCameraToCenterDistance(g) * Math.cos(a.terrain ? 0 : a.transform._pitch) : 1,
          u_device_pixel_ratio: e.e.devicePixelRatio,
          u_is_halo: +_,
          undefined: void 0
        });
      },
      co = function co(t, i, o, r, a, n, s, l, c, h, _, u, d, p, f, m) {
        return e.Q(lo(t, i, o, r, a, n, s, l, !0, c, !0, _, u, d, p, f, m), {
          u_texsize_icon: h,
          u_texture_icon: 1
        });
      },
      ho = function ho(e, t, i, o) {
        return {
          u_matrix: e,
          u_emissive_strength: t,
          u_opacity: i,
          u_color: o
        };
      },
      _o = function _o(t, i, o, r, a, n, s, l) {
        return e.Q(function (t, i, o, r, a) {
          var _r$imageManager$getPi = r.imageManager.getPixelSize(i),
            n = _r$imageManager$getPi.width,
            s = _r$imageManager$getPi.height,
            l = Math.pow(2, a.tileID.overscaledZ),
            c = a.tileSize * Math.pow(2, r.transform.tileZoom) / l,
            h = c * (a.tileID.canonical.x + a.tileID.wrap * l),
            _ = c * a.tileID.canonical.y;
          return {
            u_image: 0,
            u_pattern_tl: o.tl,
            u_pattern_br: o.br,
            u_texsize: [n, s],
            u_pattern_size: o.displaySize,
            u_tile_units_to_pixels: 1 / e.bD(a, 1, r.transform.tileZoom),
            u_pixel_coord_upper: [h >> 16, _ >> 16],
            u_pixel_coord_lower: [65535 & h, 65535 & _]
          };
        }(0, n, s, r, l), {
          u_matrix: t,
          u_emissive_strength: i,
          u_opacity: o
        });
      },
      uo = new Float32Array(e.ae.identity([])),
      po = function po(t, i, o, r, a, n, s, l, c, h, _, u, d) {
        var p = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : [0, 0, 0];
        var f = arguments.length > 14 ? arguments[14] : undefined;
        var m = a.style.light,
          g = m.properties.get("position"),
          v = [-g.x, -g.y, g.z],
          x = e.bE.create();
        "viewport" === m.properties.get("anchor") && (e.bE.fromRotation(x, -a.transform.angle), e.$.transformMat3(v, v, x));
        var y = "MASK" === _.alphaMode,
          b = m.properties.get("color").toRenderColor(null),
          w = d.paint.get("model-ambient-occlusion-intensity"),
          T = d.paint.get("model-color").constantOr(e.C.white).toRenderColor(null),
          E = d.paint.get("model-color-mix-intensity").constantOr(0);
        return {
          u_matrix: t,
          u_lighting_matrix: i,
          u_normal_matrix: o,
          u_node_matrix: r || uo,
          u_lightpos: v,
          u_lightintensity: m.properties.get("intensity"),
          u_lightcolor: [b.r, b.g, b.b],
          u_camera_pos: p,
          u_opacity: n,
          u_baseTextureIsAlpha: 0,
          u_alphaMask: +y,
          u_alphaCutoff: _.alphaCutoff,
          u_baseColorFactor: [s.r, s.g, s.b, s.a],
          u_emissiveFactor: [l[0], l[1], l[2], 1],
          u_metallicFactor: c,
          u_roughnessFactor: h,
          u_baseColorTexture: _i.BaseColor,
          u_metallicRoughnessTexture: _i.MetallicRoughness,
          u_normalTexture: _i.Normal,
          u_occlusionTexture: _i.Occlusion,
          u_emissionTexture: _i.Emission,
          u_lutTexture: _i.LUT,
          u_color_mix: [T.r, T.g, T.b, E],
          u_aoIntensity: w,
          u_emissive_strength: u,
          u_occlusionTextureTransform: f || [0, 0, 0, 0]
        };
      },
      fo = function fo(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : uo;
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : uo;
        return {
          u_matrix: e,
          u_instance: t,
          u_node_matrix: i
        };
      },
      mo = {
        fillExtrusion: function fillExtrusion(t) {
          return {
            u_matrix: new e.a7(t),
            u_lightpos: new e.ar(t),
            u_lightintensity: new e.ab(t),
            u_lightcolor: new e.ar(t),
            u_vertical_gradient: new e.ab(t),
            u_opacity: new e.ab(t),
            u_edge_radius: new e.ab(t),
            u_alignment: new e.ab(t),
            u_width_scale: new e.ab(t),
            u_ao: new e.a9(t),
            u_tile_id: new e.ar(t),
            u_zoom_transition: new e.ab(t),
            u_inv_rot_matrix: new e.a7(t),
            u_merc_center: new e.a9(t),
            u_up_dir: new e.ar(t),
            u_height_lift: new e.ab(t),
            u_flood_light_color: new e.ar(t),
            u_vertical_scale: new e.ab(t),
            u_flood_light_intensity: new e.ab(t),
            u_ground_shadow_factor: new e.ar(t),
            u_emissive_strength: new e.ab(t)
          };
        },
        fillExtrusionDepth: function fillExtrusionDepth(t) {
          return {
            u_matrix: new e.a7(t),
            u_edge_radius: new e.ab(t),
            u_alignment: new e.ab(t),
            u_width_scale: new e.ab(t),
            u_vertical_scale: new e.ab(t)
          };
        },
        fillExtrusionPattern: function fillExtrusionPattern(t) {
          return {
            u_matrix: new e.a7(t),
            u_lightpos: new e.ar(t),
            u_lightintensity: new e.ab(t),
            u_lightcolor: new e.ar(t),
            u_vertical_gradient: new e.ab(t),
            u_height_factor: new e.ab(t),
            u_edge_radius: new e.ab(t),
            u_alignment: new e.ab(t),
            u_width_scale: new e.ab(t),
            u_ao: new e.a9(t),
            u_tile_id: new e.ar(t),
            u_zoom_transition: new e.ab(t),
            u_inv_rot_matrix: new e.a7(t),
            u_merc_center: new e.a9(t),
            u_up_dir: new e.ar(t),
            u_height_lift: new e.ab(t),
            u_image: new e.a8(t),
            u_texsize: new e.a9(t),
            u_pixel_coord_upper: new e.a9(t),
            u_pixel_coord_lower: new e.a9(t),
            u_tile_units_to_pixels: new e.ab(t),
            u_opacity: new e.ab(t)
          };
        },
        fillExtrusionGroundEffect: function fillExtrusionGroundEffect(t) {
          return {
            u_matrix: new e.a7(t),
            u_opacity: new e.ab(t),
            u_ao_pass: new e.ab(t),
            u_meter_to_tile: new e.ab(t),
            u_ao: new e.a9(t),
            u_flood_light_intensity: new e.ab(t),
            u_flood_light_color: new e.ar(t),
            u_attenuation: new e.ab(t),
            u_edge_radius: new e.ab(t),
            u_fb: new e.a8(t),
            u_fb_size: new e.ab(t)
          };
        },
        fill: function fill(t) {
          return {
            u_matrix: new e.a7(t),
            u_emissive_strength: new e.ab(t)
          };
        },
        fillPattern: function fillPattern(t) {
          return {
            u_matrix: new e.a7(t),
            u_emissive_strength: new e.ab(t),
            u_image: new e.a8(t),
            u_texsize: new e.a9(t),
            u_pixel_coord_upper: new e.a9(t),
            u_pixel_coord_lower: new e.a9(t),
            u_tile_units_to_pixels: new e.ab(t)
          };
        },
        fillOutline: function fillOutline(t) {
          return {
            u_matrix: new e.a7(t),
            u_emissive_strength: new e.ab(t),
            u_world: new e.a9(t)
          };
        },
        fillOutlinePattern: function fillOutlinePattern(t) {
          return {
            u_matrix: new e.a7(t),
            u_emissive_strength: new e.ab(t),
            u_world: new e.a9(t),
            u_image: new e.a8(t),
            u_texsize: new e.a9(t),
            u_pixel_coord_upper: new e.a9(t),
            u_pixel_coord_lower: new e.a9(t),
            u_tile_units_to_pixels: new e.ab(t)
          };
        },
        circle: e.bK,
        collisionBox: function collisionBox(t) {
          return {
            u_matrix: new e.a7(t),
            u_camera_to_center_distance: new e.ab(t),
            u_extrude_scale: new e.a9(t)
          };
        },
        collisionCircle: function collisionCircle(t) {
          return {
            u_matrix: new e.a7(t),
            u_inv_matrix: new e.a7(t),
            u_camera_to_center_distance: new e.ab(t),
            u_viewport_size: new e.a9(t)
          };
        },
        debug: function debug(t) {
          return {
            u_color: new e.aa(t),
            u_matrix: new e.a7(t),
            u_overlay: new e.a8(t),
            u_overlay_scale: new e.ab(t)
          };
        },
        clippingMask: function clippingMask(t) {
          return {
            u_matrix: new e.a7(t)
          };
        },
        heatmap: function heatmap(t) {
          return {
            u_extrude_scale: new e.ab(t),
            u_intensity: new e.ab(t),
            u_matrix: new e.a7(t),
            u_inv_rot_matrix: new e.a7(t),
            u_merc_center: new e.a9(t),
            u_tile_id: new e.ar(t),
            u_zoom_transition: new e.ab(t),
            u_up_dir: new e.ar(t)
          };
        },
        heatmapTexture: function heatmapTexture(t) {
          return {
            u_image: new e.a8(t),
            u_color_ramp: new e.a8(t),
            u_opacity: new e.ab(t)
          };
        },
        hillshade: function hillshade(t) {
          return {
            u_matrix: new e.a7(t),
            u_image: new e.a8(t),
            u_latrange: new e.a9(t),
            u_light: new e.a9(t),
            u_shadow: new e.aa(t),
            u_highlight: new e.aa(t),
            u_emissive_strength: new e.ab(t),
            u_accent: new e.aa(t)
          };
        },
        hillshadePrepare: function hillshadePrepare(t) {
          return {
            u_matrix: new e.a7(t),
            u_image: new e.a8(t),
            u_dimension: new e.a9(t),
            u_zoom: new e.ab(t)
          };
        },
        line: e.bL,
        linePattern: e.bM,
        raster: function raster(t) {
          return {
            u_matrix: new e.a7(t),
            u_normalize_matrix: new e.a7(t),
            u_globe_matrix: new e.a7(t),
            u_merc_matrix: new e.a7(t),
            u_grid_matrix: new e.as(t),
            u_tl_parent: new e.a9(t),
            u_scale_parent: new e.ab(t),
            u_fade_t: new e.ab(t),
            u_opacity: new e.ab(t),
            u_image0: new e.a8(t),
            u_image1: new e.a8(t),
            u_brightness_low: new e.ab(t),
            u_brightness_high: new e.ab(t),
            u_saturation_factor: new e.ab(t),
            u_contrast_factor: new e.ab(t),
            u_spin_weights: new e.ar(t),
            u_perspective_transform: new e.a9(t),
            u_raster_elevation: new e.ab(t),
            u_zoom_transition: new e.ab(t),
            u_merc_center: new e.a9(t),
            u_cutoff_params: new e.at(t),
            u_colorization_mix: new e.at(t),
            u_colorization_offset: new e.ab(t),
            u_color_ramp: new e.a8(t),
            u_texture_offset: new e.a9(t),
            u_texture_res: new e.a9(t),
            u_emissive_strength: new e.ab(t)
          };
        },
        rasterParticle: function rasterParticle(t) {
          return {
            u_matrix: new e.a7(t),
            u_normalize_matrix: new e.a7(t),
            u_globe_matrix: new e.a7(t),
            u_merc_matrix: new e.a7(t),
            u_grid_matrix: new e.as(t),
            u_tl_parent: new e.a9(t),
            u_scale_parent: new e.ab(t),
            u_fade_t: new e.ab(t),
            u_opacity: new e.ab(t),
            u_image0: new e.a8(t),
            u_image1: new e.a8(t),
            u_raster_elevation: new e.ab(t),
            u_zoom_transition: new e.ab(t),
            u_merc_center: new e.a9(t),
            u_cutoff_params: new e.at(t)
          };
        },
        rasterParticleTexture: function rasterParticleTexture(t) {
          return {
            u_texture: new e.a8(t),
            u_opacity: new e.ab(t)
          };
        },
        rasterParticleDraw: function rasterParticleDraw(t) {
          return {
            u_particle_texture: new e.a8(t),
            u_particle_texture_side_len: new e.ab(t),
            u_tile_offset: new e.a9(t),
            u_velocity: new e.a8(t),
            u_color_ramp: new e.a8(t),
            u_velocity_res: new e.a9(t),
            u_max_speed: new e.ab(t),
            u_uv_offset: new e.a9(t),
            u_data_scale: new e.a9(t),
            u_data_offset: new e.ab(t),
            u_particle_pos_scale: new e.ab(t),
            u_particle_pos_offset: new e.a9(t)
          };
        },
        rasterParticleUpdate: function rasterParticleUpdate(t) {
          return {
            u_particle_texture: new e.a8(t),
            u_particle_texture_side_len: new e.ab(t),
            u_velocity: new e.a8(t),
            u_velocity_res: new e.a9(t),
            u_max_speed: new e.ab(t),
            u_speed_factor: new e.ab(t),
            u_reset_rate: new e.ab(t),
            u_rand_seed: new e.ab(t),
            u_uv_offset: new e.a9(t),
            u_data_scale: new e.a9(t),
            u_data_offset: new e.ab(t),
            u_particle_pos_scale: new e.ab(t),
            u_particle_pos_offset: new e.a9(t)
          };
        },
        symbolIcon: function symbolIcon(t) {
          return {
            u_is_size_zoom_constant: new e.a8(t),
            u_is_size_feature_constant: new e.a8(t),
            u_size_t: new e.ab(t),
            u_size: new e.ab(t),
            u_camera_to_center_distance: new e.ab(t),
            u_rotate_symbol: new e.a8(t),
            u_aspect_ratio: new e.ab(t),
            u_fade_change: new e.ab(t),
            u_matrix: new e.a7(t),
            u_label_plane_matrix: new e.a7(t),
            u_coord_matrix: new e.a7(t),
            u_is_text: new e.a8(t),
            u_pitch_with_map: new e.a8(t),
            u_texsize: new e.a9(t),
            u_tile_id: new e.ar(t),
            u_zoom_transition: new e.ab(t),
            u_inv_rot_matrix: new e.a7(t),
            u_merc_center: new e.a9(t),
            u_camera_forward: new e.ar(t),
            u_tile_matrix: new e.a7(t),
            u_up_vector: new e.ar(t),
            u_ecef_origin: new e.ar(t),
            u_texture: new e.a8(t),
            u_icon_transition: new e.ab(t),
            u_color_adj_mat: new e.a7(t)
          };
        },
        symbolSDF: function symbolSDF(t) {
          return {
            u_is_size_zoom_constant: new e.a8(t),
            u_is_size_feature_constant: new e.a8(t),
            u_size_t: new e.ab(t),
            u_size: new e.ab(t),
            u_camera_to_center_distance: new e.ab(t),
            u_rotate_symbol: new e.a8(t),
            u_aspect_ratio: new e.ab(t),
            u_fade_change: new e.ab(t),
            u_matrix: new e.a7(t),
            u_label_plane_matrix: new e.a7(t),
            u_coord_matrix: new e.a7(t),
            u_is_text: new e.a8(t),
            u_pitch_with_map: new e.a8(t),
            u_texsize: new e.a9(t),
            u_texture: new e.a8(t),
            u_gamma_scale: new e.ab(t),
            u_device_pixel_ratio: new e.ab(t),
            u_tile_id: new e.ar(t),
            u_zoom_transition: new e.ab(t),
            u_inv_rot_matrix: new e.a7(t),
            u_merc_center: new e.a9(t),
            u_camera_forward: new e.ar(t),
            u_tile_matrix: new e.a7(t),
            u_up_vector: new e.ar(t),
            u_ecef_origin: new e.ar(t),
            u_is_halo: new e.a8(t)
          };
        },
        symbolTextAndIcon: function symbolTextAndIcon(t) {
          return {
            u_is_size_zoom_constant: new e.a8(t),
            u_is_size_feature_constant: new e.a8(t),
            u_size_t: new e.ab(t),
            u_size: new e.ab(t),
            u_camera_to_center_distance: new e.ab(t),
            u_rotate_symbol: new e.a8(t),
            u_aspect_ratio: new e.ab(t),
            u_fade_change: new e.ab(t),
            u_matrix: new e.a7(t),
            u_label_plane_matrix: new e.a7(t),
            u_coord_matrix: new e.a7(t),
            u_is_text: new e.a8(t),
            u_pitch_with_map: new e.a8(t),
            u_texsize: new e.a9(t),
            u_texsize_icon: new e.a9(t),
            u_texture: new e.a8(t),
            u_texture_icon: new e.a8(t),
            u_gamma_scale: new e.ab(t),
            u_device_pixel_ratio: new e.ab(t),
            u_is_halo: new e.a8(t)
          };
        },
        background: function background(t) {
          return {
            u_matrix: new e.a7(t),
            u_emissive_strength: new e.ab(t),
            u_opacity: new e.ab(t),
            u_color: new e.aa(t)
          };
        },
        backgroundPattern: function backgroundPattern(t) {
          return {
            u_matrix: new e.a7(t),
            u_emissive_strength: new e.ab(t),
            u_opacity: new e.ab(t),
            u_image: new e.a8(t),
            u_pattern_tl: new e.a9(t),
            u_pattern_br: new e.a9(t),
            u_texsize: new e.a9(t),
            u_pattern_size: new e.a9(t),
            u_pixel_coord_upper: new e.a9(t),
            u_pixel_coord_lower: new e.a9(t),
            u_tile_units_to_pixels: new e.ab(t)
          };
        },
        terrainRaster: function terrainRaster(t) {
          return {
            u_matrix: new e.a7(t),
            u_image0: new e.a8(t),
            u_skirt_height: new e.ab(t),
            u_ground_shadow_factor: new e.ar(t)
          };
        },
        skybox: function skybox(t) {
          return {
            u_matrix: new e.a7(t),
            u_sun_direction: new e.ar(t),
            u_cubemap: new e.a8(t),
            u_opacity: new e.ab(t),
            u_temporal_offset: new e.ab(t)
          };
        },
        skyboxGradient: function skyboxGradient(t) {
          return {
            u_matrix: new e.a7(t),
            u_color_ramp: new e.a8(t),
            u_center_direction: new e.ar(t),
            u_radius: new e.ab(t),
            u_opacity: new e.ab(t),
            u_temporal_offset: new e.ab(t)
          };
        },
        skyboxCapture: function skyboxCapture(t) {
          return {
            u_matrix_3f: new e.as(t),
            u_sun_direction: new e.ar(t),
            u_sun_intensity: new e.ab(t),
            u_color_tint_r: new e.at(t),
            u_color_tint_m: new e.at(t),
            u_luminance: new e.ab(t)
          };
        },
        globeRaster: function globeRaster(t) {
          return {
            u_proj_matrix: new e.a7(t),
            u_globe_matrix: new e.a7(t),
            u_normalize_matrix: new e.a7(t),
            u_merc_matrix: new e.a7(t),
            u_zoom_transition: new e.ab(t),
            u_merc_center: new e.a9(t),
            u_image0: new e.a8(t),
            u_grid_matrix: new e.as(t),
            u_skirt_height: new e.ab(t),
            u_far_z_cutoff: new e.ab(t),
            u_frustum_tl: new e.ar(t),
            u_frustum_tr: new e.ar(t),
            u_frustum_br: new e.ar(t),
            u_frustum_bl: new e.ar(t),
            u_globe_pos: new e.ar(t),
            u_globe_radius: new e.ab(t),
            u_viewport: new e.a9(t)
          };
        },
        globeAtmosphere: function globeAtmosphere(t) {
          return {
            u_frustum_tl: new e.ar(t),
            u_frustum_tr: new e.ar(t),
            u_frustum_br: new e.ar(t),
            u_frustum_bl: new e.ar(t),
            u_horizon: new e.ab(t),
            u_transition: new e.ab(t),
            u_fadeout_range: new e.ab(t),
            u_color: new e.at(t),
            u_high_color: new e.at(t),
            u_space_color: new e.at(t),
            u_temporal_offset: new e.ab(t),
            u_horizon_angle: new e.ab(t)
          };
        },
        model: function model(t) {
          return {
            u_matrix: new e.a7(t),
            u_lighting_matrix: new e.a7(t),
            u_normal_matrix: new e.a7(t),
            u_node_matrix: new e.a7(t),
            u_lightpos: new e.ar(t),
            u_lightintensity: new e.ab(t),
            u_lightcolor: new e.ar(t),
            u_camera_pos: new e.ar(t),
            u_opacity: new e.ab(t),
            u_baseColorFactor: new e.at(t),
            u_emissiveFactor: new e.at(t),
            u_metallicFactor: new e.ab(t),
            u_roughnessFactor: new e.ab(t),
            u_baseTextureIsAlpha: new e.a8(t),
            u_alphaMask: new e.a8(t),
            u_alphaCutoff: new e.ab(t),
            u_baseColorTexture: new e.a8(t),
            u_metallicRoughnessTexture: new e.a8(t),
            u_normalTexture: new e.a8(t),
            u_occlusionTexture: new e.a8(t),
            u_emissionTexture: new e.a8(t),
            u_lutTexture: new e.a8(t),
            u_color_mix: new e.at(t),
            u_aoIntensity: new e.ab(t),
            u_emissive_strength: new e.ab(t),
            u_occlusionTextureTransform: new e.at(t)
          };
        },
        modelDepth: function modelDepth(t) {
          return {
            u_matrix: new e.a7(t),
            u_instance: new e.a7(t),
            u_node_matrix: new e.a7(t)
          };
        },
        groundShadow: function groundShadow(t) {
          return {
            u_matrix: new e.a7(t),
            u_ground_shadow_factor: new e.ar(t)
          };
        },
        stars: function stars(t) {
          return {
            u_matrix: new e.a7(t),
            u_up: new e.ar(t),
            u_right: new e.ar(t),
            u_intensity_multiplier: new e.ab(t)
          };
        },
        occlusion: function occlusion(t) {
          return {
            u_matrix: new e.a7(t),
            u_anchorPos: new e.ar(t),
            u_screenSizePx: new e.a9(t),
            u_occluderSizePx: new e.a9(t),
            u_color: new e.at(t)
          };
        }
      };
    function go(t, i, o) {
      var r = i.createTileMatrix(t, t.worldSize, o.toUnwrapped());
      return e.ae.multiply(new Float32Array(16), t.projMatrix, r);
    }
    function vo(e, t, i) {
      if (t.projection.name === i.projection.name) return e.projMatrix;
      var o = i.clone();
      return o.setProjection(t.projection), go(o, t.getProjection(), e);
    }
    function xo(e, t, i) {
      return t.name === i.projection.name ? e.projMatrix : go(i, t, e);
    }
    var yo;
    function bo(t, i, o, r, a, n, s) {
      var l = t.context,
        c = l.gl,
        h = t.transform,
        _ = t.getOrCreateProgram("collisionBox"),
        u = [];
      var d = 0,
        p = 0;
      for (var _l114 = 0; _l114 < r.length; _l114++) {
        var _f47 = r[_l114],
          _m26 = i.getTile(_f47),
          _g23 = _m26.getBucket(o);
        if (!_g23) continue;
        var _v16 = vo(_f47, _g23, h);
        var _x20 = _v16;
        0 === a[0] && 0 === a[1] || (_x20 = t.translatePosMatrix(_v16, _m26, a, n));
        var _y54 = s ? _g23.textCollisionBox : _g23.iconCollisionBox,
          _b15 = _g23.collisionCircleArray;
        if (_b15.length > 0) {
          var _t531 = e.ae.create(),
            _i342 = _x20;
          e.ae.mul(_t531, _g23.placementInvProjMatrix, h.glCoordMatrix), e.ae.mul(_t531, _t531, _g23.placementViewportMatrix), u.push({
            circleArray: _b15,
            circleOffset: p,
            transform: _i342,
            invTransform: _t531,
            projection: _g23.getProjection()
          }), d += _b15.length / 4, p = d;
        }
        _y54 && (t.terrain && t.terrain.setupElevationDraw(_m26, _), _.draw(t, c.LINES, e.af.disabled, e.ah.disabled, t.colorModeForRenderPass(), e.ag.disabled, qi(_x20, h, _m26, _g23.getProjection()), o.id, _y54.layoutVertexBuffer, _y54.indexBuffer, _y54.segments, null, h.zoom, null, [_y54.collisionVertexBuffer, _y54.collisionVertexBufferExt]));
      }
      if (!s || !u.length) return;
      var f = t.getOrCreateProgram("collisionCircle"),
        m = new e.bN();
      m.resize(4 * d), m._trim();
      var g = 0;
      for (var _i343 = 0, _u88 = u; _i343 < _u88.length; _i343++) {
        var _e517 = _u88[_i343];
        for (var _t532 = 0; _t532 < _e517.circleArray.length / 4; _t532++) {
          var _i344 = 4 * _t532,
            _o189 = _e517.circleArray[_i344 + 0],
            _r384 = _e517.circleArray[_i344 + 1],
            _a194 = _e517.circleArray[_i344 + 2],
            _n273 = _e517.circleArray[_i344 + 3];
          m.emplace(g++, _o189, _r384, _a194, _n273, 0), m.emplace(g++, _o189, _r384, _a194, _n273, 1), m.emplace(g++, _o189, _r384, _a194, _n273, 2), m.emplace(g++, _o189, _r384, _a194, _n273, 3);
        }
      }
      (!yo || yo.length < 2 * d) && (yo = function (t) {
        var i = 2 * t,
          o = new e.bw();
        o.resize(i), o._trim();
        for (var _e518 = 0; _e518 < i; _e518++) {
          var _t533 = 6 * _e518;
          o.uint16[_t533 + 0] = 4 * _e518 + 0, o.uint16[_t533 + 1] = 4 * _e518 + 1, o.uint16[_t533 + 2] = 4 * _e518 + 2, o.uint16[_t533 + 3] = 4 * _e518 + 2, o.uint16[_t533 + 4] = 4 * _e518 + 3, o.uint16[_t533 + 5] = 4 * _e518 + 0;
        }
        return o;
      }(d));
      var v = l.createIndexBuffer(yo, !0),
        x = l.createVertexBuffer(m, e.bO.members, !0);
      for (var _i345 = 0, _u89 = u; _i345 < _u89.length; _i345++) {
        var _i346 = _u89[_i345];
        var _r385 = {
          u_matrix: _i346.transform,
          u_inv_matrix: _i346.invTransform,
          u_camera_to_center_distance: (y = h).getCameraToCenterDistance(_i346.projection),
          u_viewport_size: [y.width, y.height]
        };
        f.draw(t, c.TRIANGLES, e.af.disabled, e.ah.disabled, t.colorModeForRenderPass(), e.ag.disabled, _r385, o.id, x, v, e.b.simpleSegment(0, 2 * _i346.circleOffset, _i346.circleArray.length, _i346.circleArray.length / 2), null, h.zoom);
      }
      var y;
      x.destroy(), v.destroy();
    }
    var wo = e.ae.create();
    function To(t) {
      var i = t._camera.getWorldToCamera(t.worldSize, 1),
        o = e.ae.multiply([], i, t.globeMatrix);
      e.ae.invert(o, o);
      var r = [0, 0, 0],
        a = [0, 1, 0, 0];
      return e.aB.transformMat4(a, a, o), r[0] = a[0], r[1] = a[1], r[2] = a[2], e.$.normalize(r, r), r;
    }
    function Eo(_ref176, n) {
      var t = _ref176.width,
        i = _ref176.height,
        o = _ref176.anchor,
        r = _ref176.textOffset,
        a = _ref176.textScale;
      var _e$bS = e.bS(o),
        s = _e$bS.horizontalAlign,
        l = _e$bS.verticalAlign,
        c = -(s - .5) * t,
        h = -(l - .5) * i,
        _ = e.bR(o, r);
      return new e.P((c / a + _[0]) * n, (h / a + _[1]) * n);
    }
    function Co(t, i, o, r, a, n, s, l, c, h, _) {
      var u = t.text.placedSymbolArray,
        d = t.text.dynamicLayoutVertexArray,
        p = t.icon.dynamicLayoutVertexArray,
        f = {},
        m = t.getProjection(),
        g = xo(l, m, n),
        v = n.elevation,
        x = m.upVectorScale(l.canonical, n.center.lat, n.worldSize).metersToTile;
      d.clear();
      for (var _p55 = 0; _p55 < u.length; _p55++) {
        var _y55 = u.get(_p55),
          _b16 = _y55.tileAnchorX,
          _w15 = _y55.tileAnchorY,
          _T9 = _y55.numGlyphs,
          _E7 = _y55.hidden || !_y55.crossTileID || t.allowVerticalPlacement && !_y55.placedOrientation ? null : r[_y55.crossTileID];
        if (_E7) {
          var _m$projectTilePoint, _Qt7, _Qt8;
          var _r386 = 0,
            _u90 = 0,
            _p56 = 0;
          if (v) {
            var _e519 = v ? v.getAtTileOffset(l, _b16, _w15) : 0,
              _m$upVector = m.upVector(l.canonical, _b16, _w15),
              _m$upVector2 = _slicedToArray(_m$upVector, 3),
              _t534 = _m$upVector2[0],
              _i347 = _m$upVector2[1],
              _o190 = _m$upVector2[2];
            _r386 = _e519 * _t534 * x, _u90 = _e519 * _i347 * x, _p56 = _e519 * _o190 * x;
          }
          var _Qt5 = Qt(_y55.projectedAnchorX + _r386, _y55.projectedAnchorY + _u90, _y55.projectedAnchorZ + _p56, o ? g : s),
            _Qt6 = _slicedToArray(_Qt5, 4),
            _C5 = _Qt6[0],
            _S13 = _Qt6[1],
            _I10 = _Qt6[2],
            _L4 = _Qt6[3];
          var _P7 = Yt(n.getCameraToCenterDistance(m), _L4);
          var _R3 = a.evaluateSizeForFeature(t.textSizeData, h, _y55) * _P7 / e.bP;
          o && (_R3 *= t.tilePixelRatio / c);
          var _D3 = Eo(_E7, _R3);
          o ? ((_m$projectTilePoint = m.projectTilePoint(_b16 + _D3.x, _w15 + _D3.y, l.canonical), _C5 = _m$projectTilePoint.x, _S13 = _m$projectTilePoint.y, _I10 = _m$projectTilePoint.z), (_Qt7 = Qt(_C5 + _r386, _S13 + _u90, _I10 + _p56, s), _Qt8 = _slicedToArray(_Qt7, 3), _C5 = _Qt8[0], _S13 = _Qt8[1], _I10 = _Qt8[2])) : (i && _D3._rotate(-n.angle), _C5 += _D3.x, _S13 += _D3.y, _I10 = 0);
          var _A12 = t.allowVerticalPlacement && _y55.placedOrientation === e.aF.vertical ? Math.PI / 2 : 0;
          for (var _t535 = 0; _t535 < _T9; _t535++) e.aI(d, _C5, _S13, _I10, _A12);
          _ && _y55.associatedIconIndex >= 0 && (f[_y55.associatedIconIndex] = {
            x: _C5,
            y: _S13,
            z: _I10,
            angle: _A12
          });
        } else ni(_T9, d);
      }
      if (_) {
        p.clear();
        var _i348 = t.icon.placedSymbolArray;
        for (var _t536 = 0; _t536 < _i348.length; _t536++) {
          var _o191 = _i348.get(_t536),
            _r387 = _o191.numGlyphs,
            _a195 = f[_t536];
          if (_o191.hidden || !_a195) ni(_r387, p);else {
            var _t537 = _a195.x,
              _i349 = _a195.y,
              _o192 = _a195.z,
              _n274 = _a195.angle;
            for (var _a196 = 0; _a196 < _r387; _a196++) e.aI(p, _t537, _i349, _o192, _n274);
          }
        }
        t.icon.dynamicLayoutVertexBuffer.updateData(p);
      }
      t.text.dynamicLayoutVertexBuffer.updateData(d);
    }
    function So(t, i, o, r, a, n) {
      var s = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
      var l = o.paint.get("icon-translate"),
        c = o.paint.get("text-translate"),
        h = o.paint.get("icon-translate-anchor"),
        _ = o.paint.get("text-translate-anchor"),
        u = o.layout.get("icon-rotation-alignment"),
        d = o.layout.get("text-rotation-alignment"),
        p = o.layout.get("icon-pitch-alignment"),
        f = o.layout.get("text-pitch-alignment"),
        m = o.layout.get("icon-keep-upright"),
        g = o.layout.get("text-keep-upright"),
        v = o.paint.get("icon-color-saturation"),
        x = o.paint.get("icon-color-contrast"),
        y = o.paint.get("icon-color-brightness-min"),
        b = o.paint.get("icon-color-brightness-max");
      o.paint.get("icon-occlusion-opacity").constantOr(0), o.paint.get("text-occlusion-opacity").constantOr(0);
      var w = t.context,
        T = w.gl,
        E = t.transform,
        C = "map" === u,
        S = "map" === d,
        I = "map" === p,
        L = "map" === f,
        P = void 0 !== o.layout.get("symbol-sort-key").constantOr(1);
      var R = !1;
      var D = t.depthModeForSublayer(0, e.af.ReadOnly),
        A = [e.ak(E.center.lng), e.al(E.center.lat)],
        M = o.layout.get("text-variable-anchor"),
        z = "globe" === E.projection.name,
        O = [],
        F = [0, -1, 0];
      var _iterator359 = _createForOfIteratorHelper(r),
        _step359;
      try {
        var _loop18 = function _loop18() {
            var a = _step359.value;
            var r = i.getTile(a),
              n = r.getBucket(o);
            if (!n) return 0; // continue
            if ("mercator" === n.projection.name && z) return 0; // continue
            if (n.fullyClipped) return 0; // continue
            var u = "globe" === n.projection.name,
              d = u ? e.a2(E.zoom) : 0,
              p = xo(a, n.getProjection(), E),
              f = E.calculatePixelsToTileUnitsMatrix(r),
              w = M && n.hasTextData(),
              D = n.hasIconTextFit() && w && n.hasIconData(),
              B = n.getProjection().createInversionMatrix(E, a.canonical),
              k = function k(e) {
                E.depthOcclusionForSymbolsAndCircles && (o.hasInitialOcclusionOpacityProperties || t.terrain) && (e.push("DEPTH_D24"), e.push("DEPTH_OCCLUSION"));
              },
              N = function N() {
                var i = C && "point" !== o.layout.get("symbol-placement"),
                  s = [];
                k(s);
                var c = i || D,
                  _ = o.paint.get("icon-image-cross-fade").constantOr(0);
                t.terrainRenderModeElevated() && I && s.push("PITCH_WITH_MAP_TERRAIN"), u && (s.push("PROJECTION_GLOBE_VIEW"), c && s.push("PROJECTED_POS_ON_VIEWPORT")), _ > 0 && s.push("ICON_TRANSITION"), n.icon.zOffsetVertexBuffer && s.push("Z_OFFSET"), 0 === v && 0 === x && 0 === y && 1 === b || s.push("COLOR_ADJUSTMENT");
                var g = n.icon.programConfigurations.get(o.id),
                  w = t.getOrCreateProgram(n.sdfIcons ? "symbolSDF" : "symbolIcon", {
                    config: g,
                    defines: s
                  });
                var S;
                var L = r.imageAtlasTexture ? r.imageAtlasTexture.size : [0, 0],
                  P = n.iconSizeData,
                  R = e.aE(P, E.zoom),
                  M = I || 0 !== E.pitch,
                  O = Ht(p, r.tileID.canonical, I, C, E, n.getProjection(), f),
                  N = Xt(p, r.tileID.canonical, I, C, E, n.getProjection(), f),
                  U = t.translatePosMatrix(N, r, l, h, !0),
                  G = t.translatePosMatrix(p, r, l, h),
                  j = c ? wo : O,
                  V = C && !I && !i;
                var $ = F;
                !z && !E.mercatorFromTransition || C || ($ = To(E));
                var Z = u ? $ : F;
                if (n.sdfIcons && !n.iconsInText) S = lo(P.kind, R, V, I, t, G, j, U, !1, L, !0, a, d, A, B, Z, n.getProjection());else {
                  var _e521 = o.getColorAdjustmentMatrix(v, x, y, b);
                  S = so(P.kind, R, V, I, t, G, j, U, !1, L, a, d, A, B, Z, n.getProjection(), _e521, _);
                }
                var W = r.imageAtlasTexture ? r.imageAtlasTexture : null,
                  H = 1 !== o.layout.get("icon-size").constantOr(0) || n.iconsNeedLinear,
                  q = n.sdfIcons || t.options.rotating || t.options.zooming || H || M ? T.LINEAR : T.NEAREST,
                  X = n.sdfIcons && 0 !== o.paint.get("icon-halo-width").constantOr(1),
                  Q = t.terrain && I && i ? e.ae.invert(e.ae.create(), O) : wo;
                if (i && n.icon) {
                  var _e522 = E.elevation,
                    _i352 = _e522 ? _e522.getAtTileOffsetFunc(a, E.center.lat, E.worldSize, n.getProjection()) : null,
                    _o193 = qt(p, r.tileID.canonical, I, C, E, n.getProjection(), f);
                  Kt(n, p, t, !1, _o193, N, I, m, _i352, a);
                }
                return {
                  program: w,
                  buffers: n.icon,
                  uniformValues: S,
                  atlasTexture: W,
                  atlasTextureIcon: null,
                  atlasInterpolation: q,
                  atlasInterpolationIcon: null,
                  isSDF: n.sdfIcons,
                  hasHalo: X,
                  tile: r,
                  labelPlaneMatrixInv: Q
                };
              },
              U = function U() {
                var i = S && "point" !== o.layout.get("symbol-placement"),
                  s = [],
                  l = i || M || D;
                t.terrainRenderModeElevated() && L && s.push("PITCH_WITH_MAP_TERRAIN"), u && (s.push("PROJECTION_GLOBE_VIEW"), l && s.push("PROJECTED_POS_ON_VIEWPORT")), n.text.zOffsetVertexBuffer && s.push("Z_OFFSET"), k(s);
                var h = n.text.programConfigurations.get(o.id),
                  m = t.getOrCreateProgram(n.iconsInText ? "symbolTextAndIcon" : "symbolSDF", {
                    config: h,
                    defines: s
                  });
                var v,
                  x = [0, 0],
                  y = null;
                var b = n.textSizeData;
                n.iconsInText && (x = r.imageAtlasTexture ? r.imageAtlasTexture.size : [0, 0], y = r.imageAtlasTexture ? r.imageAtlasTexture : null, v = L || 0 !== E.pitch || t.options.rotating || t.options.zooming || "composite" === b.kind || "camera" === b.kind ? T.LINEAR : T.NEAREST);
                var w = r.glyphAtlasTexture ? r.glyphAtlasTexture.size : [0, 0],
                  C = e.aE(b, E.zoom),
                  I = Ht(p, r.tileID.canonical, L, S, E, n.getProjection(), f),
                  P = Xt(p, r.tileID.canonical, L, S, E, n.getProjection(), f),
                  R = t.translatePosMatrix(P, r, c, _, !0),
                  O = t.translatePosMatrix(p, r, c, _),
                  N = l ? wo : I,
                  U = S && !L && !i;
                var G = F;
                !z && !E.mercatorFromTransition || S || (G = To(E));
                var j = u ? G : F;
                var V;
                V = n.iconsInText ? co(b.kind, C, U, L, t, O, N, R, w, x, a, d, A, B, j, n.getProjection()) : lo(b.kind, C, U, L, t, O, N, R, !0, w, !0, a, d, A, B, j, n.getProjection());
                var $ = r.glyphAtlasTexture ? r.glyphAtlasTexture : null,
                  Z = T.LINEAR,
                  W = 0 !== o.paint.get("text-halo-width").constantOr(1),
                  H = t.terrain && L && i ? e.ae.invert(e.ae.create(), I) : wo;
                if (i && n.text) {
                  var _e523 = E.elevation,
                    _i353 = _e523 ? _e523.getAtTileOffsetFunc(a, E.center.lat, E.worldSize, n.getProjection()) : null,
                    _o194 = qt(p, r.tileID.canonical, L, S, E, n.getProjection(), f);
                  Kt(n, p, t, !0, _o194, P, L, g, _i353, a);
                }
                return {
                  program: m,
                  buffers: n.text,
                  uniformValues: V,
                  atlasTexture: $,
                  atlasTextureIcon: y,
                  atlasInterpolation: Z,
                  atlasInterpolationIcon: v,
                  isSDF: !0,
                  hasHalo: W,
                  tile: r,
                  labelPlaneMatrixInv: H
                };
              },
              G = n.icon.segments.get().length,
              j = n.text.segments.get().length,
              V = G && !s.onlyText ? N() : null,
              $ = j && !s.onlyIcons ? U() : null,
              Z = o.paint.get("icon-opacity").constantOr(1),
              W = o.paint.get("text-opacity").constantOr(1);
            if (P && n.canOverlap) {
              R = !0;
              var _t538 = Z && !s.onlyText ? n.icon.segments.get() : [],
                _i354 = W && !s.onlyIcons ? n.text.segments.get() : [];
              var _iterator360 = _createForOfIteratorHelper(_t538),
                _step360;
              try {
                for (_iterator360.s(); !(_step360 = _iterator360.n()).done;) {
                  var _i355 = _step360.value;
                  O.push({
                    segments: new e.b([_i355]),
                    sortKey: _i355.sortKey,
                    state: V
                  });
                }
              } catch (err) {
                _iterator360.e(err);
              } finally {
                _iterator360.f();
              }
              var _iterator361 = _createForOfIteratorHelper(_i354),
                _step361;
              try {
                for (_iterator361.s(); !(_step361 = _iterator361.n()).done;) {
                  var _t539 = _step361.value;
                  O.push({
                    segments: new e.b([_t539]),
                    sortKey: _t539.sortKey,
                    state: $
                  });
                }
              } catch (err) {
                _iterator361.e(err);
              } finally {
                _iterator361.f();
              }
            } else s.onlyText || O.push({
              segments: Z ? n.icon.segments : new e.b([]),
              sortKey: 0,
              state: V
            }), s.onlyIcons || O.push({
              segments: W ? n.text.segments : new e.b([]),
              sortKey: 0,
              state: $
            });
          },
          _ret5;
        for (_iterator359.s(); !(_step359 = _iterator359.n()).done;) {
          _ret5 = _loop18();
          if (_ret5 === 0) continue;
        }
      } catch (err) {
        _iterator359.e(err);
      } finally {
        _iterator359.f();
      }
      R && O.sort(function (e, t) {
        return e.sortKey - t.sortKey;
      });
      for (var _i350 = 0, _O2 = O; _i350 < _O2.length; _i350++) {
        var _e520 = _O2[_i350];
        var _i351 = _e520.state;
        if (_i351) if (t.terrain ? t.terrain.setupElevationDraw(_i351.tile, _i351.program, {
          useDepthForOcclusion: E.depthOcclusionForSymbolsAndCircles,
          labelPlaneMatrixInv: _i351.labelPlaneMatrixInv
        }) : t.setupDepthForOcclusion(E.depthOcclusionForSymbolsAndCircles, _i351.program), w.activeTexture.set(T.TEXTURE0), _i351.atlasTexture && _i351.atlasTexture.bind(_i351.atlasInterpolation, T.CLAMP_TO_EDGE, !0), _i351.atlasTextureIcon && (w.activeTexture.set(T.TEXTURE1), _i351.atlasTextureIcon && _i351.atlasTextureIcon.bind(_i351.atlasInterpolationIcon, T.CLAMP_TO_EDGE, !0)), t.uploadCommonLightUniforms(t.context, _i351.program), _i351.hasHalo) {
          var _r388 = _i351.uniformValues;
          _r388.u_is_halo = 1, Io(_i351.buffers, _e520.segments, o, t, _i351.program, D, a, n, _r388, 2), _r388.u_is_halo = 0;
        } else {
          if (_i351.isSDF) {
            var _r389 = _i351.uniformValues;
            _i351.hasHalo && (_r389.u_is_halo = 1, Io(_i351.buffers, _e520.segments, o, t, _i351.program, D, a, n, _r389, 1)), _r389.u_is_halo = 0;
          }
          Io(_i351.buffers, _e520.segments, o, t, _i351.program, D, a, n, _i351.uniformValues, 1);
        }
      }
    }
    function Io(t, i, o, r, a, n, s, l, c, h) {
      var _ = [t.dynamicLayoutVertexBuffer, t.opacityVertexBuffer, t.iconTransitioningVertexBuffer, t.globeExtVertexBuffer, t.zOffsetVertexBuffer];
      a.draw(r, r.context.gl.TRIANGLES, n, s, l, e.ag.disabled, c, o.id, t.layoutVertexBuffer, t.indexBuffer, i, o.paint, r.transform.zoom, t.programConfigurations.get(o.id), _, h);
    }
    function Lo(t, i, o, r, a, n, s) {
      var l = t.context.gl,
        c = o.paint.get("fill-pattern"),
        h = c && c.constantOr(1);
      var _, u, d, p, f;
      s ? (u = h && !o.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", _ = l.LINES) : (u = h ? "fillPattern" : "fill", _ = l.TRIANGLES);
      var _iterator362 = _createForOfIteratorHelper(r),
        _step362;
      try {
        for (_iterator362.s(); !(_step362 = _iterator362.n()).done;) {
          var _m27 = _step362.value;
          var _r390 = i.getTile(_m27);
          if (h && !_r390.patternsLoaded()) continue;
          var _g24 = _r390.getBucket(o);
          if (!_g24) continue;
          t.prepareDrawTile();
          var _v17 = _g24.programConfigurations.get(o.id),
            _x21 = t.isTileAffectedByFog(_m27),
            _y56 = t.getOrCreateProgram(u, {
              config: _v17,
              overrideFog: _x21
            });
          h && (t.context.activeTexture.set(l.TEXTURE0), _r390.imageAtlasTexture && _r390.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), _v17.updatePaintBuffers());
          var _b17 = c.constantOr(null);
          if (_b17 && _r390.imageAtlas) {
            var _e524 = _r390.imageAtlas.patternPositions[_b17.toString()];
            _e524 && _v17.setConstantPatternPositions(_e524);
          }
          var _w16 = t.translatePosMatrix(_m27.projMatrix, _r390, o.paint.get("fill-translate"), o.paint.get("fill-translate-anchor")),
            _T10 = o.paint.get("fill-emissive-strength");
          if (s) {
            p = _g24.indexBuffer2, f = _g24.segments2;
            var _e525 = t.terrain && t.terrain.renderingToTexture ? t.terrain.drapeBufferSize : [l.drawingBufferWidth, l.drawingBufferHeight];
            d = "fillOutlinePattern" === u && h ? Hi(_w16, _T10, t, _r390, _e525) : Wi(_w16, _T10, _e525);
          } else p = _g24.indexBuffer, f = _g24.segments, d = h ? Zi(_w16, _T10, t, _r390) : $i(_w16, _T10);
          t.uploadCommonUniforms(t.context, _y56, _m27.toUnwrapped()), _y56.draw(t, _, a, t.stencilModeForClipping(_m27), n, e.ag.disabled, d, o.id, _g24.layoutVertexBuffer, p, f, o.paint, t.transform.zoom, _v17, void 0);
        }
      } catch (err) {
        _iterator362.e(err);
      } finally {
        _iterator362.f();
      }
    }
    function Po(t, i, o, r, a, n, s, l) {
      o.resetLayerRenderingStats(t);
      var c = t.context,
        h = c.gl,
        _ = t.transform,
        u = o.paint.get("fill-extrusion-pattern"),
        d = u.constantOr(1),
        p = o.paint.get("fill-extrusion-opacity"),
        f = t.style.enable3dLights(),
        m = o.paint.get(f && !d ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"),
        g = [o.paint.get("fill-extrusion-ambient-occlusion-intensity"), m],
        v = o.layout.get("fill-extrusion-edge-radius"),
        x = v > 0 && !o.paint.get("fill-extrusion-rounded-roof"),
        y = x ? 0 : v,
        b = "globe" === _.projection.name ? e.b_() : 0,
        w = "globe" === _.projection.name,
        T = w ? e.a2(_.zoom) : 0,
        E = [e.ak(_.center.lng), e.al(_.center.lat)],
        C = o.paint.get("fill-extrusion-flood-light-color").toRenderColor(o.lut).toArray01().slice(0, 3),
        S = o.paint.get("fill-extrusion-flood-light-intensity"),
        I = o.paint.get("fill-extrusion-vertical-scale"),
        L = 0 !== o.paint.get("fill-extrusion-line-width").constantOr(1),
        P = ui(t, o.paint.get("fill-extrusion-cutoff-fade-range")),
        R = o.paint.get("fill-extrusion-emissive-strength"),
        D = [];
      w && D.push("PROJECTION_GLOBE_VIEW"), g[0] > 0 && D.push("FAUX_AO"), x && D.push("ZERO_ROOF_RADIUS"), l && D.push("HAS_CENTROID"), S > 0 && D.push("FLOOD_LIGHT"), P.shouldRenderCutoff && D.push("RENDER_CUTOFF"), L && D.push("RENDER_WALL_MODE");
      var A = function () {
        var t = o.paint.get("fill-extrusion-line-alignment");
        switch (t) {
          case "inside":
            return 1;
          case "outside":
            return -1;
          case "center":
            return 0;
          default:
            return e.w("Unsupported value for fill-extrusion-line-alignment: ".concat(t)), 0;
        }
      }();
      var M;
      var z = "shadow" === t.renderPass,
        O = t.shadowRenderer,
        F = z && !!O;
      t.shadowRenderer && (t.shadowRenderer.useNormalOffset = !0);
      var B = [0, 0, 0];
      if (O) {
        var _e526 = t.style.directionalLight,
          _i356 = t.style.ambientLight;
        _e526 && _i356 && (B = xi(t.style, _e526, _i356)), M = D.concat(["SHADOWS_SINGLE_CASCADE"]);
      }
      var k = F ? "fillExtrusionDepth" : d ? "fillExtrusionPattern" : "fillExtrusion",
        N = o.getLayerRenderingStats();
      var _iterator363 = _createForOfIteratorHelper(r),
        _step363;
      try {
        for (_iterator363.s(); !(_step363 = _iterator363.n()).done;) {
          var _f48 = _step363.value;
          var _r391 = i.getTile(_f48),
            _m28 = _r391.getBucket(o);
          if (!_m28 || _m28.projection.name !== _.projection.name) continue;
          var _v18 = !1;
          O && (_v18 = 0 === O.getMaxCascadeForTile(_f48.toUnwrapped()));
          var _x22 = t.isTileAffectedByFog(_f48),
            _F2 = _m28.programConfigurations.get(o.id),
            _U = t.getOrCreateProgram(k, {
              config: _F2,
              defines: _v18 ? M : D,
              overrideFog: _x22
            });
          if (t.terrain && t.terrain.setupElevationDraw(_r391, _U, {
            useMeterToDem: !0
          }), !_m28.centroidVertexBuffer) {
            var _e527 = _U.attributes.a_centroid_pos;
            void 0 !== _e527 && h.vertexAttrib2f(_e527, 0, 0);
          }
          !z && O && O.setupShadows(_r391.tileID.toUnwrapped(), _U, "vector-tile", _r391.tileID.overscaledZ), d && (t.context.activeTexture.set(h.TEXTURE0), _r391.imageAtlasTexture && _r391.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), _F2.updatePaintBuffers());
          var _G = u.constantOr(null);
          if (_G && _r391.imageAtlas) {
            var _e528 = _r391.imageAtlas.patternPositions[_G.toString()];
            _e528 && _F2.setConstantPatternPositions(_e528);
          }
          var _j = o.paint.get("fill-extrusion-vertical-gradient"),
            _V = 1 / _m28.tileToMeter;
          var _$ = void 0;
          if (z && O) {
            if (Oo(_r391.tileID, _m28, t)) continue;
            var _e529 = O.calculateShadowPassMatrixFromTile(_r391.tileID.toUnwrapped());
            _$ = ji(_e529, y, A, _V, I);
          } else {
            var _e530 = t.translatePosMatrix(_f48.expandedProjMatrix, _r391, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")),
              _i357 = _.projection.createInversionMatrix(_, _f48.canonical);
            _$ = d ? Vi(_e530, t, _j, p, g, y, A, _V, _f48, _r391, b, T, E, _i357, C, I) : Gi(_e530, t, _j, p, g, y, A, _V, _f48, b, T, E, _i357, C, I, S, B, R);
          }
          t.uploadCommonUniforms(c, _U, _f48.toUnwrapped(), null, P);
          var _Z = _m28.segments;
          if ("mercator" === _.projection.name && !z && (_Z = _m28.getVisibleSegments(_r391.tileID, t.terrain, t.transform.getFrustum(0)), !_Z.get().length)) continue;
          if (N) if (z) {
            var _iterator364 = _createForOfIteratorHelper(_Z.get()),
              _step364;
            try {
              for (_iterator364.s(); !(_step364 = _iterator364.n()).done;) {
                var _e531 = _step364.value;
                N.numRenderedVerticesInShadowPass += _e531.primitiveLength;
              }
            } catch (err) {
              _iterator364.e(err);
            } finally {
              _iterator364.f();
            }
          } else {
            var _iterator365 = _createForOfIteratorHelper(_Z.get()),
              _step365;
            try {
              for (_iterator365.s(); !(_step365 = _iterator365.n()).done;) {
                var _e532 = _step365.value;
                N.numRenderedVerticesInTransparentPass += _e532.primitiveLength;
              }
            } catch (err) {
              _iterator365.e(err);
            } finally {
              _iterator365.f();
            }
          }
          var _W = [];
          (t.terrain || l) && _W.push(_m28.centroidVertexBuffer), w && _W.push(_m28.layoutVertexExtBuffer), L && _W.push(_m28.wallVertexBuffer), _U.draw(t, c.gl.TRIANGLES, a, n, s, e.ag.backCCW, _$, o.id, _m28.layoutVertexBuffer, _m28.indexBuffer, _Z, o.paint, t.transform.zoom, _F2, _W);
        }
      } catch (err) {
        _iterator363.e(err);
      } finally {
        _iterator363.f();
      }
      t.shadowRenderer && (t.shadowRenderer.useNormalOffset = !1);
    }
    function Ro(t, i, o, r, a, n, s, l, c, h, _, u, d, p, f, m, g, v, x) {
      var y = t.context,
        b = y.gl,
        w = t.transform,
        T = t.transform.zoom,
        E = [],
        C = ui(t, o.paint.get("fill-extrusion-cutoff-fade-range"));
      "clear" === h ? (E.push("CLEAR_SUBPASS"), x && (E.push("CLEAR_FROM_TEXTURE"), y.activeTexture.set(b.TEXTURE0), x.bind(b.LINEAR, b.CLAMP_TO_EDGE))) : "sdf" === h && E.push("SDF_SUBPASS"), g && E.push("HAS_CENTROID"), C.shouldRenderCutoff && E.push("RENDER_CUTOFF");
      var S = o.layout.get("fill-extrusion-edge-radius"),
        I = function I(e, i, r, h, v) {
          var b = i.programConfigurations.get(o.id),
            w = t.isTileAffectedByFog(e),
            I = t.getOrCreateProgram("fillExtrusionGroundEffect", {
              config: b,
              defines: E,
              overrideFog: w
            }),
            L = function (e, t, i, o, r, a, n, s, l, c, h) {
              return {
                u_matrix: t,
                u_opacity: i,
                u_ao_pass: o ? 1 : 0,
                u_meter_to_tile: r,
                u_ao: a,
                u_flood_light_intensity: n,
                u_flood_light_color: s,
                u_attenuation: l,
                u_edge_radius: c,
                u_fb: 0,
                u_fb_size: h
              };
            }(0, h, _, c, v, [u, d * v], p, f, m, T >= 17 ? 0 : S * v, x ? x.size[0] : 0),
            P = [];
          g && P.push(i.hiddenByLandmarkVertexBuffer), t.uploadCommonUniforms(y, I, e.toUnwrapped(), null, C), I.draw(t, y.gl.TRIANGLES, a, n, s, l, L, o.id, i.vertexBuffer, i.indexBuffer, r, o.paint, T, b, P);
        };
      var _iterator366 = _createForOfIteratorHelper(r),
        _step366;
      try {
        for (_iterator366.s(); !(_step366 = _iterator366.n()).done;) {
          var _a197 = _step366.value;
          var _r392 = i.getTile(_a197),
            _n275 = _r392.getBucket(o);
          if (!_n275 || _n275.projection.name !== w.projection.name || !_n275.groundEffect || _n275.groundEffect && !_n275.groundEffect.hasData()) continue;
          var _s231 = _n275.groundEffect,
            _l115 = 1 / _n275.tileToMeter;
          {
            var _e533 = t.translatePosMatrix(_a197.projMatrix, _r392, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")),
              _i358 = _s231.getDefaultSegment();
            I(_a197, _s231, _i358, _e533, _l115);
          }
          if (v) for (var _n276 = 0; _n276 < 4; _n276++) {
            var _s232 = e.b$[_n276](_a197),
              _c87 = i.getTile(_s232);
            if (!_c87) continue;
            var _h70 = _c87.getBucket(o);
            if (!_h70 || _h70.projection.name !== w.projection.name || !_h70.groundEffect || _h70.groundEffect && !_h70.groundEffect.hasData()) continue;
            var _21 = _h70.groundEffect;
            var _u91 = void 0,
              _d36 = void 0;
            0 === _n276 ? (_u91 = [-e.a4, 0, 0], _d36 = 1) : 1 === _n276 ? (_u91 = [e.a4, 0, 0], _d36 = 0) : 2 === _n276 ? (_u91 = [0, -e.a4, 0], _d36 = 3) : (_u91 = [0, e.a4, 0], _d36 = 2);
            var _p57 = _21.regionSegments[_d36];
            if (!_p57) continue;
            var _f49 = new Float32Array(16);
            e.ae.translate(_f49, _a197.projMatrix, _u91), I(_a197, _21, _p57, t.translatePosMatrix(_f49, _r392, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), _l115);
          }
        }
      } catch (err) {
        _iterator366.e(err);
      } finally {
        _iterator366.f();
      }
    }
    function Do(t, i, o, r, a, n, s) {
      0 === r.centroidVertexArray.length && r.createCentroidsBuffer();
      var l = n ? n.findDEMTileFor(o) : null;
      if (!(l && l.dem || s)) return;
      var c = function c(t) {
          return new e.P(Math.ceil((t + e.c2) * e.c3), 0);
        },
        h = function h(e) {
          var t = i.getSource().minzoom,
            o = function o(e) {
              var t = i.getTileByID(e);
              if (t && t.hasData()) return t.getBucket(a);
            },
            r = [0, -1, 1];
          for (var _i359 = 0, _r393 = r; _i359 < _r393.length; _i359++) {
            var _i360 = _r393[_i359];
            if (e.overscaledZ + _i360 < t) continue;
            var _r394 = o(e.calculateScaledKey(e.overscaledZ + _i360));
            if (_r394) return _r394;
          }
        },
        _ = [0, 0, 0],
        u = function u(t, i) {
          return _[0] = Math.min(t.min.y, i.min.y), _[1] = Math.max(t.max.y, i.max.y), _[2] = e.a4 - i.min.x > t.max.x ? i.min.x - e.a4 : t.max.x, _;
        },
        d = function d(t, i) {
          return _[0] = Math.min(t.min.x, i.min.x), _[1] = Math.max(t.max.x, i.max.x), _[2] = e.a4 - i.min.y > t.max.y ? i.min.y - e.a4 : t.max.y, _;
        },
        p = [function (e, t) {
          return u(e, t);
        }, function (e, t) {
          return u(t, e);
        }, function (e, t) {
          return d(e, t);
        }, function (e, t) {
          return d(t, e);
        }],
        f = function f(t, i, r, a, s, c, h) {
          if (!n) return 0;
          var _ = [[c ? r : t, c ? t : r, 0], [c ? r : i, c ? i : r, 0]],
            u = h < 0 ? e.a4 + h : h,
            d = [c ? u : (t + i) / 2, c ? (t + i) / 2 : u, 0];
          return 0 === r && h < 0 || 0 !== r && h > 0 ? n.getForTilePoints(s, [d], !0, a) : _.push(d), n.getForTilePoints(o, _, !0, l), Math.max(_[0][2], _[1][2], d[2]) / n.exaggeration();
        };
      for (var _t540 = 0; _t540 < 4; _t540++) {
        var _i361 = r.borderFeatureIndices[_t540];
        if (0 === _i361.length) continue;
        var _a198 = e.b$[_t540](o),
          _l116 = h(_a198);
        if (!(_l116 && _l116 instanceof e.c0)) continue;
        if (r.borderDoneWithNeighborZ[_t540] === _l116.canonical.z) continue;
        0 === _l116.centroidVertexArray.length && _l116.createCentroidsBuffer();
        var _22 = n ? n.findDEMTileFor(_a198) : null;
        if (!(_22 && _22.dem || s)) continue;
        var _u92 = (_t540 < 2 ? 1 : 5) - _t540,
          _d37 = _l116.borderDoneWithNeighborZ[_u92] !== r.canonical.z,
          _v19 = _l116.borderFeatureIndices[_u92];
        var _x23 = 0;
        if (r.canonical.z !== _l116.canonical.z) {
          var _iterator367 = _createForOfIteratorHelper(_i361),
            _step367;
          try {
            for (_iterator367.s(); !(_step367 = _iterator367.n()).done;) {
              var _e535 = _step367.value;
              r.showCentroid(r.featuresOnBorder[_e535]);
            }
          } catch (err) {
            _iterator367.e(err);
          } finally {
            _iterator367.f();
          }
          if (_d37) {
            var _iterator368 = _createForOfIteratorHelper(_v19),
              _step368;
            try {
              for (_iterator368.s(); !(_step368 = _iterator368.n()).done;) {
                var _e534 = _step368.value;
                _l116.showCentroid(_l116.featuresOnBorder[_e534]);
              }
            } catch (err) {
              _iterator368.e(err);
            } finally {
              _iterator368.f();
            }
          }
          r.borderDoneWithNeighborZ[_t540] = _l116.canonical.z, _l116.borderDoneWithNeighborZ[_u92] = r.canonical.z;
        }
        var _iterator369 = _createForOfIteratorHelper(_i361),
          _step369;
        try {
          for (_iterator369.s(); !(_step369 = _iterator369.n()).done;) {
            var _o195 = _step369.value;
            var _i362 = r.featuresOnBorder[_o195],
              _n277 = r.centroidData[_i362.centroidDataIndex],
              _h71 = _i362.borders[_t540];
            var _d38 = void 0;
            for (; _x23 < _v19.length;) {
              _d38 = _l116.featuresOnBorder[_v19[_x23]];
              var _e536 = _d38.borders[_u92];
              if (_e536[1] > _h71[0] + 3 || _e536[0] > _h71[0] - 3) break;
              _l116.showCentroid(_d38), _x23++;
            }
            if (_d38 && _x23 < _v19.length) {
              var _o196 = _x23;
              var _y57 = 0;
              for (; !(_d38.borders[_u92][0] > _h71[1] - 3) && (_y57++, ++_x23 !== _v19.length);) _d38 = _l116.featuresOnBorder[_v19[_x23]];
              if (_d38 = _l116.featuresOnBorder[_v19[_o196]], _y57 > 1) {
                var _e537 = _d38.borders[_u92];
                Math.abs(_h71[0] - _e537[0]) < 3 && Math.abs(_h71[1] - _e537[1]) < 3 && (_y57 = 1, _x23 = _o196 + 1);
              } else if (0 === _y57) {
                r.showCentroid(_i362);
                continue;
              }
              var _b18 = _l116.centroidData[_d38.centroidDataIndex];
              s && 1 === _y57 && (((m = _n277).flags | (g = _b18).flags) & e.c1 ? (m.flags |= e.c1, g.flags |= e.c1) : (m.flags &= ~e.c1, g.flags &= ~e.c1));
              var _w17 = _i362.intersectsCount() > 1 || _d38.intersectsCount() > 1;
              if (_y57 > 1) _x23 = _o196, _n277.centroidXY = _b18.centroidXY = new e.P(0, 0);else if (_22 && _22.dem && !_w17) {
                var _i363 = p[_t540](_n277, _b18),
                  _o197 = _t540 % 2 ? e.a4 - 1 : 0,
                  _r395 = f(_i363[0], Math.min(e.a4 - 1, _i363[1]), _o197, _22, _a198, _t540 < 2, _i363[2]);
                _n277.centroidXY = _b18.centroidXY = c(_r395);
              } else _w17 ? _n277.centroidXY = _b18.centroidXY = new e.P(0, 0) : (_n277.centroidXY = r.encodeBorderCentroid(_i362), _b18.centroidXY = _l116.encodeBorderCentroid(_d38));
              r.writeCentroidToBuffer(_n277), _l116.writeCentroidToBuffer(_b18);
            } else r.showCentroid(_i362);
          }
        } catch (err) {
          _iterator369.e(err);
        } finally {
          _iterator369.f();
        }
        r.borderDoneWithNeighborZ[_t540] = _l116.canonical.z, _l116.borderDoneWithNeighborZ[_u92] = r.canonical.z;
      }
      var m, g;
      (r.needsCentroidUpdate || !r.centroidVertexBuffer && 0 !== r.centroidVertexArray.length) && r.uploadCentroid(t);
    }
    var Ao = [1, 0, 0],
      Mo = [0, 1, 0],
      zo = [0, 0, 1];
    function Oo(t, i, o) {
      var r = o.transform,
        a = o.shadowRenderer;
      if (!a) return !0;
      var n = t.toUnwrapped(),
        s = r.tileSize * a._cascades[o.currentShadowCascade].scale;
      var l = i.maxHeight;
      if (r.elevation) {
        var _e538 = r.elevation.getMinMaxForTile(t);
        _e538 && (l += _e538.max);
      }
      var c = _toConsumableArray(a.shadowDirection);
      c[2] = -c[2];
      var h = a.computeSimplifiedTileShadowVolume(n, l, s, c);
      if (!h) return !1;
      var _ = [Ao, Mo, zo, c, [c[0], 0, c[2]], [0, c[1], c[2]]],
        u = "globe" === r.projection.name,
        d = r.scaleZoom(s),
        p = e.aM.fromInvProjectionMatrix(r.invProjMatrix, r.worldSize, d, !u),
        f = a.getCurrentCascadeFrustum();
      return 0 === p.intersectsPrecise(h.vertices, h.planes, _) || 0 === f.intersectsPrecise(h.vertices, h.planes, _);
    }
    function Fo(t) {
      return [t[0] * e.c4, t[1] * e.c4, t[2] * e.c4, 0];
    }
    function Bo(t, i, o, r, a, n, s, l, c) {
      var h = r.getSource(),
        _ = o.globeSharedBuffers;
      if (!_) return;
      var u, d, p;
      if (i && (u = r.getTile(i)), h instanceof e.bo ? (d = h.texture, p = e.bj(0, 0, o.transform)) : u && i && (d = u.texture, p = e.bj(i.canonical.z, i.canonical.x, o.transform)), !d || !p) return;
      t || (p = e.ae.scale(e.ae.create(), p, [1, -1, 1]));
      var f = o.context,
        m = f.gl,
        g = "nearest" === a.paint.get("raster-resampling") ? m.NEAREST : m.LINEAR,
        v = o.colorModeForDrapableLayerRenderPass(n),
        x = s.defines;
      x.push("GLOBE_POLES");
      var y = new e.af(m.LEQUAL, e.af.ReadWrite, o.depthRangeFor3D),
        b = Float32Array.from(o.transform.expandedFarZProjMatrix),
        w = Float32Array.from(e.bh(e.bi(new e.aO(0, 0, 0))));
      o.terrain && o.terrain.prepareDrawTile(), f.activeTexture.set(m.TEXTURE0), d.bind(g, m.CLAMP_TO_EDGE), f.activeTexture.set(m.TEXTURE1), d.bind(g, m.CLAMP_TO_EDGE), d.useMipmap && f.extTextureFilterAnisotropic && o.transform.pitch > 20 && m.texParameterf(m.TEXTURE_2D, f.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, f.extTextureFilterAnisotropicMax);
      var _ref177 = i ? _.getPoleBuffers(i.canonical.z, !1) : _.getPoleBuffers(0, !0),
        _ref178 = _slicedToArray(_ref177, 4),
        T = _ref178[0],
        E = _ref178[1],
        C = _ref178[2],
        S = _ref178[3],
        I = a.paint.get("raster-elevation");
      var L;
      t ? (L = T, o.renderDefaultNorthPole = 0 !== I) : (L = E, o.renderDefaultSouthPole = 0 !== I);
      var P = Fo(s.mix),
        R = function (e, t, i, o, r, a, n, s, l, c, h, _, u) {
          return eo(e, t, i, new Float32Array(16), new Float32Array(9), [0, 0], o, [0, 0], [0, 0, 0, 0], 1, {
            opacity: 1,
            mix: 0
          }, a, [0, 0] || [0, 0], s, 2, c, h, _, 1, 0, u);
        }(b, w, p, e.a2(o.transform.zoom), 0, a, 0, I, 0, P, s.offset, s.range, n),
        D = o.getOrCreateProgram("raster", {
          defines: x
        });
      o.uploadCommonUniforms(f, D, null), D.draw(o, m.TRIANGLES, y, c, v, l, R, a.id, L, C, S);
    }
    function ko(e) {
      var t = e._nearZ,
        i = e.projection.farthestPixelDistance(e),
        o = i - t,
        r = .2 * e.height,
        a = t + r;
      return [t, i, (a - r - t) / o, (a - t) / o];
    }
    function No(t, i, o, r) {
      if (t) return i instanceof Li && t instanceof e.c5 ? i.getTextureDescriptor(t, o, !0) : {
        texture: t.texture,
        mix: Fo(r.mix),
        offset: r.offset,
        buffer: 0,
        tileSize: 1
      };
    }
    function Uo(t, i, o) {
      if (!t) return null;
      var r = i.getTextureDescriptor(t, o, !0);
      if (!r) return null;
      var a = r.texture,
        n = r.mix,
        s = r.offset,
        l = r.tileSize,
        c = r.buffer,
        h = r.format;
      if (!a || !h) return null;
      var _ = !1;
      return "uint32" === h && (_ = !0, n[3] = 0, n = Ji(e.c6, n, [0, o.paint.get("raster-particle-max-speed")]), s = Ki(e.c6, s, [0, o.paint.get("raster-particle-max-speed")])), {
        texture: a,
        textureOffset: [c / (l + 2 * c), l / (l + 2 * c)],
        tileSize: l,
        scalarData: _,
        scale: n,
        offset: s,
        defines: ["RASTER_ARRAY", {
          uint8: "DATA_FORMAT_UINT8",
          uint16: "DATA_FORMAT_UINT16",
          uint32: "DATA_FORMAT_UINT32"
        }[h]]
      };
    }
    function Go(e) {
      var t = e._nearZ,
        i = e.projection.farthestPixelDistance(e),
        o = i - t,
        r = .2 * e.height,
        a = t + r;
      return [t, i, (a - r - t) / o, (a - t) / o];
    }
    var jo = new e.C(1, 0, 0, 1),
      Vo = new e.C(0, 1, 0, 1),
      $o = new e.C(0, 0, 1, 1),
      Zo = new e.C(1, 0, 1, 1),
      Wo = new e.C(0, 1, 1, 1);
    function Ho(t, i, o, r, a, n, s) {
      var l = t.context,
        c = t.transform,
        h = l.gl,
        _ = "globe" === c.projection.name,
        u = _ ? ["PROJECTION_GLOBE_VIEW"] : [];
      var d = e.ae.clone(o.projMatrix);
      if (_ && e.a2(c.zoom) > 0) {
        var _t541 = e.c7(o.canonical, c),
          _i364 = e.c8(_t541);
        d = e.ae.multiply(new Float32Array(16), c.globeMatrix, _i364), e.ae.multiply(d, c.projMatrix, d);
      }
      var p = e.ae.create();
      p[12] += 2 * a / (e.e.devicePixelRatio * c.width), p[13] += 2 * n / (e.e.devicePixelRatio * c.height), e.ae.multiply(d, p, d);
      var f = t.getOrCreateProgram("debug", {
          defines: u
        }),
        m = i.getTileByID(o.key);
      t.terrain && t.terrain.setupElevationDraw(m, f);
      var g = e.af.disabled,
        v = e.ah.disabled,
        x = t.colorModeForRenderPass(),
        y = "$debug";
      l.activeTexture.set(h.TEXTURE0), t.emptyTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), _ ? m._makeGlobeTileDebugBuffers(t.context, c) : m._makeDebugTileBoundsBuffers(t.context, c.projection);
      var b = m._tileDebugBuffer || t.debugBuffer,
        w = m._tileDebugIndexBuffer || t.debugIndexBuffer,
        T = m._tileDebugSegments || t.debugSegments;
      if (f.draw(t, h.LINE_STRIP, g, v, x, e.ag.disabled, Xi(d, r), y, b, w, T, null, null, null, [m._globeTileDebugBorderBuffer]), s) {
        var _e539 = m.latestRawTileData,
          _i365 = Math.floor((_e539 && _e539.byteLength || 0) / 1024);
        var _r396 = o.canonical.toString();
        o.overscaledZ !== o.canonical.z && (_r396 += " => ".concat(o.overscaledZ)), _r396 += " ".concat(m.state), _r396 += " ".concat(_i365, "kb"), function (e, t) {
          e.initDebugOverlayCanvas();
          var i = e.debugOverlayCanvas,
            o = e.context.gl,
            r = e.debugOverlayCanvas.getContext("2d");
          r.clearRect(0, 0, i.width, i.height), r.shadowColor = "white", r.shadowBlur = 2, r.lineWidth = 1.5, r.strokeStyle = "white", r.textBaseline = "top", r.font = "bold 36px Open Sans, sans-serif", r.fillText(t, 5, 5), r.strokeText(t, 5, 5), e.debugOverlayTexture.update(i), e.debugOverlayTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
        }(t, _r396);
      }
      var E = i.getTile(o).tileSize,
        C = 512 / Math.min(E, 512) * (o.overscaledZ / c.zoom) * .5,
        S = m._tileDebugTextBuffer || t.debugBuffer,
        I = m._tileDebugTextIndexBuffer || t.quadTriangleIndexBuffer,
        L = m._tileDebugTextSegments || t.debugSegments;
      f.draw(t, h.TRIANGLES, g, v, e.a.alphaBlended, e.ag.disabled, Xi(d, e.C.transparent, C), y, S, I, L, null, null, null, [m._globeTileDebugTextBuffer]);
    }
    function qo(e, t, i, o) {
      Qo(e, 0, t + i / 2, e.transform.width, i, o);
    }
    function Xo(e, t, i, o) {
      Qo(e, t - i / 2, 0, i, e.transform.height, o);
    }
    function Qo(t, i, o, r, a, n) {
      var s = t.context,
        l = s.gl;
      l.enable(l.SCISSOR_TEST), l.scissor(i * e.e.devicePixelRatio, o * e.e.devicePixelRatio, r * e.e.devicePixelRatio, a * e.e.devicePixelRatio), s.clear({
        color: n
      }), l.disable(l.SCISSOR_TEST);
    }
    var Yo = e.c9([{
        name: "a_pos_3f",
        components: 3,
        type: "Float32"
      }]),
      Jo = Yo.members;
    function Ko(e, t, i, o) {
      e.emplaceBack(t, i, o);
    }
    var er = /*#__PURE__*/_createClass(function er(t) {
      _classCallCheck(this, er);
      this.vertexArray = new e.ca(), this.indices = new e.bw(), Ko(this.vertexArray, -1, -1, 1), Ko(this.vertexArray, 1, -1, 1), Ko(this.vertexArray, -1, 1, 1), Ko(this.vertexArray, 1, 1, 1), Ko(this.vertexArray, -1, -1, -1), Ko(this.vertexArray, 1, -1, -1), Ko(this.vertexArray, -1, 1, -1), Ko(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t.createVertexBuffer(this.vertexArray, Jo), this.indexBuffer = t.createIndexBuffer(this.indices), this.segment = e.b.simpleSegment(0, 0, 36, 12);
    });
    function tr(t, i, o, r, a, n) {
      var s = t.context.gl,
        l = i.paint.get("sky-atmosphere-color"),
        c = i.paint.get("sky-atmosphere-halo-color"),
        h = i.paint.get("sky-atmosphere-sun-intensity"),
        _ = function (e, t, i, o, r) {
          return {
            u_matrix_3f: e,
            u_sun_direction: t,
            u_sun_intensity: i,
            u_color_tint_r: [o.r, o.g, o.b, o.a],
            u_color_tint_m: [r.r, r.g, r.b, r.a],
            u_luminance: 5e-5
          };
        }(e.bE.fromMat4(e.bE.create(), r), a, h, l, c);
      s.framebufferTexture2D(s.FRAMEBUFFER, s.COLOR_ATTACHMENT0, s.TEXTURE_CUBE_MAP_POSITIVE_X + n, i.skyboxTexture, 0), o.draw(t, s.TRIANGLES, e.af.disabled, e.ah.disabled, e.a.unblended, e.ag.frontCW, _, "skyboxCapture", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
    }
    var ir = e.c9([{
      type: "Float32",
      name: "a_pos",
      components: 3
    }, {
      type: "Float32",
      name: "a_uv",
      components: 2
    }]);
    var or = /*#__PURE__*/function () {
      function or(t) {
        _classCallCheck(this, or);
        var i = new e.cb();
        i.emplaceBack(-1, 1, 1, 0, 0), i.emplaceBack(1, 1, 1, 1, 0), i.emplaceBack(1, -1, 1, 1, 1), i.emplaceBack(-1, -1, 1, 0, 1);
        var o = new e.bw();
        o.emplaceBack(0, 1, 2), o.emplaceBack(2, 3, 0), this.vertexBuffer = t.createVertexBuffer(i, ir.members), this.indexBuffer = t.createIndexBuffer(o), this.segments = e.b.simpleSegment(0, 0, 4, 2);
      }
      _createClass(or, [{
        key: "destroy",
        value: function destroy() {
          this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
        }
      }]);
      return or;
    }();
    var rr = e.c9([{
      type: "Float32",
      name: "a_pos_3f",
      components: 3
    }, {
      type: "Float32",
      name: "a_uv",
      components: 2
    }, {
      type: "Float32",
      name: "a_size_scale",
      components: 1
    }, {
      type: "Float32",
      name: "a_fade_opacity",
      components: 1
    }]);
    var ar = /*#__PURE__*/_createClass(function ar() {
      _classCallCheck(this, ar);
      this.starsCount = 16e3, this.sizeMultiplier = .15, this.sizeRange = 100, this.intensityRange = 200;
    });
    var nr = /*#__PURE__*/function () {
      function nr(t) {
        var _this136 = this;
        _classCallCheck(this, nr);
        this.colorModeAlphaBlendedWriteRGB = new e.a([e.cc, e.cd, e.cc, e.cd], e.C.transparent, [!0, !0, !0, !1]), this.colorModeWriteAlpha = new e.a([e.cc, e.ce, e.cc, e.ce], e.C.transparent, [!1, !1, !1, !0]), this.params = new ar(), this.updateNeeded = !0, t.tp.registerParameter(this.params, ["Stars"], "starsCount", {
          min: 100,
          max: 16e3,
          step: 1
        }, function () {
          _this136.updateNeeded = !0;
        }), t.tp.registerParameter(this.params, ["Stars"], "sizeMultiplier", {
          min: .01,
          max: 2,
          step: .01
        }), t.tp.registerParameter(this.params, ["Stars"], "sizeRange", {
          min: 0,
          max: 200,
          step: 1
        }, function () {
          _this136.updateNeeded = !0;
        }), t.tp.registerParameter(this.params, ["Stars"], "intensityRange", {
          min: 0,
          max: 200,
          step: 1
        }, function () {
          _this136.updateNeeded = !0;
        });
      }
      _createClass(nr, [{
        key: "update",
        value: function update(t) {
          var i = t.context;
          if (!this.atmosphereBuffer || this.updateNeeded) {
            this.updateNeeded = !1, this.atmosphereBuffer = new or(i);
            var _t542 = this.params.sizeRange,
              _o198 = this.params.intensityRange,
              _r397 = function (t) {
                var i = e.ch(30),
                  o = [];
                for (var _r398 = 0; _r398 < t; ++_r398) {
                  var _t543 = 2 * Math.PI * i(),
                    _r399 = Math.acos(1 - 2 * i()) - .5 * Math.PI;
                  o.push(e.$.fromValues(Math.cos(_r399) * Math.cos(_t543), Math.cos(_r399) * Math.sin(_t543), Math.sin(_r399)));
                }
                return o;
              }(this.params.starsCount),
              _a199 = e.ch(300),
              _n278 = new e.cf(),
              _s233 = new e.bw();
            var _l117 = 0;
            for (var _i366 = 0; _i366 < _r397.length; ++_i366) {
              var _c88 = e.$.scale([], _r397[_i366], 200),
                _h72 = Math.max(0, 1 + .01 * _t542 * (1 * _a199() - .5)),
                _23 = Math.max(0, 1 + .01 * _o198 * (1 * _a199() - .5));
              _n278.emplaceBack(_c88[0], _c88[1], _c88[2], -1, -1, _h72, _23), _n278.emplaceBack(_c88[0], _c88[1], _c88[2], 1, -1, _h72, _23), _n278.emplaceBack(_c88[0], _c88[1], _c88[2], 1, 1, _h72, _23), _n278.emplaceBack(_c88[0], _c88[1], _c88[2], -1, 1, _h72, _23), _s233.emplaceBack(_l117 + 0, _l117 + 1, _l117 + 2), _s233.emplaceBack(_l117 + 0, _l117 + 2, _l117 + 3), _l117 += 4;
            }
            this.starsVx = i.createVertexBuffer(_n278, rr.members), this.starsIdx = i.createIndexBuffer(_s233), this.starsSegments = e.b.simpleSegment(0, 0, _n278.length, _s233.length);
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy();
        }
      }, {
        key: "drawAtmosphereGlow",
        value: function drawAtmosphereGlow(t, i) {
          var _this137 = this;
          var o = t.context,
            r = o.gl,
            a = t.transform,
            n = new e.af(r.LEQUAL, e.af.ReadOnly, [0, 1]),
            s = e.a2(a.zoom),
            l = t.style.getLut(i.scope),
            c = i.properties.get("color").toRenderColor(l).toArray01(),
            h = i.properties.get("high-color").toRenderColor(l).toArray01(),
            _ = i.properties.get("space-color").toRenderColor(l).toArray01PremultipliedAlpha(),
            u = 5e-4,
            d = e.cg(i.properties.get("horizon-blend"), 0, 1, u, .25),
            p = e.bc(t, o, a) && d === u ? a.worldSize / (2 * Math.PI * 1.025) - 1 : a.globeRadius,
            f = t.frameCounter / 1e3 % 1,
            m = e.$.length(a.globeCenterInViewSpace),
            g = Math.sqrt(Math.pow(m, 2) - Math.pow(p, 2)),
            v = Math.acos(g / m),
            x = function x(i) {
              var l = "globe" === a.projection.name ? ["PROJECTION_GLOBE_VIEW", "FOG"] : ["FOG"];
              i && l.push("ALPHA_PASS");
              var u = t.getOrCreateProgram("globeAtmosphere", {
                  defines: l
                }),
                p = function (e, t, i, o, r, a, n, s, l, c, h, _) {
                  return {
                    u_frustum_tl: e,
                    u_frustum_tr: t,
                    u_frustum_br: i,
                    u_frustum_bl: o,
                    u_horizon: r,
                    u_transition: a,
                    u_fadeout_range: n,
                    u_color: s,
                    u_high_color: l,
                    u_space_color: c,
                    u_temporal_offset: h,
                    u_horizon_angle: _
                  };
                }(a.frustumCorners.TL, a.frustumCorners.TR, a.frustumCorners.BR, a.frustumCorners.BL, a.frustumCorners.horizon, s, d, c, h, _, f, v);
              t.uploadCommonUniforms(o, u);
              var m = _this137.atmosphereBuffer;
              m && u.draw(t, r.TRIANGLES, n, e.ah.disabled, i ? _this137.colorModeWriteAlpha : _this137.colorModeAlphaBlendedWriteRGB, e.ag.backCW, p, i ? "atmosphere_glow_alpha" : "atmosphere_glow", m.vertexBuffer, m.indexBuffer, m.segments);
            };
          x(!1), x(!0);
        }
      }, {
        key: "drawStars",
        value: function drawStars(t, i) {
          var o = e.au(i.properties.get("star-intensity"), 0, 1);
          if (0 === o) return;
          var r = t.context,
            a = r.gl,
            n = t.transform,
            s = t.getOrCreateProgram("stars"),
            l = e.aw.identity([]);
          e.aw.rotateX(l, l, -n._pitch), e.aw.rotateZ(l, l, -n.angle), e.aw.rotateX(l, l, e.ac(n._center.lat)), e.aw.rotateY(l, l, -e.ac(n._center.lng));
          var c = e.ae.fromQuat(new Float32Array(16), l),
            h = e.ae.multiply([], n.starsProjMatrix, c),
            _ = e.bE.fromMat4([], c),
            u = e.bE.invert([], _),
            d = [0, 1, 0];
          e.$.transformMat3(d, d, u), e.$.scale(d, d, this.params.sizeMultiplier);
          var p = [1, 0, 0];
          e.$.transformMat3(p, p, u), e.$.scale(p, p, this.params.sizeMultiplier);
          var f = (m = d, g = p, v = o, {
            u_matrix: Float32Array.from(h),
            u_up: m,
            u_right: g,
            u_intensity_multiplier: v
          });
          var m, g, v;
          t.uploadCommonUniforms(r, s), this.starsVx && this.starsIdx && s.draw(t, a.TRIANGLES, e.af.disabled, e.ah.disabled, this.colorModeAlphaBlendedWriteRGB, e.ag.disabled, f, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
        }
      }]);
      return nr;
    }();
    function sr(t, i) {
      var o = _toConsumableArray(t),
        r = i.cameraWorldSizeForFog / i.worldSize,
        a = e.ae.identity([]);
      return e.ae.scale(a, a, [r, r, 1]), e.ae.multiply(o, a, o), e.ae.multiply(o, i.worldToFogMatrix, o), o;
    }
    function lr(t, i, o, r, a) {
      var n = o.material,
        s = r.context,
        _n$pbrMetallicRoughne = n.pbrMetallicRoughness,
        l = _n$pbrMetallicRoughne.baseColorTexture,
        c = _n$pbrMetallicRoughne.metallicRoughnessTexture,
        h = n.normalTexture,
        _ = n.occlusionTexture,
        u = n.emissionTexture;
      function d(e, i, o) {
        if (e && (t.push(i), s.activeTexture.set(s.gl.TEXTURE0 + o), e.gfxTexture)) {
          var _e$sampler = e.sampler,
            _t544 = _e$sampler.minFilter,
            _i367 = _e$sampler.magFilter,
            _o199 = _e$sampler.wrapS,
            _r400 = _e$sampler.wrapT;
          e.gfxTexture.bindExtraParam(_t544, _i367, _o199, _r400);
        }
      }
      d(l, "HAS_TEXTURE_u_baseColorTexture", _i.BaseColor), d(c, "HAS_TEXTURE_u_metallicRoughnessTexture", _i.MetallicRoughness), d(h, "HAS_TEXTURE_u_normalTexture", _i.Normal), d(_, "HAS_TEXTURE_u_occlusionTexture", _i.Occlusion), d(u, "HAS_TEXTURE_u_emissionTexture", _i.Emission), a && (a.texture || (a.texture = new e.cj(r.context, a.image, [a.image.height, a.image.height, a.image.height], s.gl.RGBA)), s.activeTexture.set(s.gl.TEXTURE0 + _i.LUT), a.texture && a.texture.bind(s.gl.LINEAR, s.gl.CLAMP_TO_EDGE), t.push("APPLY_LUT_ON_GPU")), o.texcoordBuffer && (t.push("HAS_ATTRIBUTE_a_uv_2f"), i.push(o.texcoordBuffer)), o.colorBuffer && (t.push(12 === o.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), i.push(o.colorBuffer)), o.normalBuffer && (t.push("HAS_ATTRIBUTE_a_normal_3f"), i.push(o.normalBuffer)), o.pbrBuffer && (t.push("HAS_ATTRIBUTE_a_pbr"), t.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), i.push(o.pbrBuffer)), "OPAQUE" !== n.alphaMode && "MASK" !== n.alphaMode || t.push("UNPREMULT_TEXTURE_IN_SHADER"), n.defined || t.push("DIFFUSE_SHADED"), t.push("USE_STANDARD_DERIVATIVES");
    }
    function cr(t, i, o, r, a, n) {
      var s = o.paint.get("model-opacity"),
        l = i.context,
        c = new e.af(i.context.gl.LEQUAL, e.af.ReadWrite, i.depthRangeFor3D),
        h = i.transform,
        _ = t.mesh,
        u = _.material,
        d = u.pbrMetallicRoughness,
        p = i.style.fog;
      var f;
      f = "pixels" === i.transform.projection.zAxisUnit ? _toConsumableArray(t.nodeModelMatrix) : e.ae.multiply([], r.zScaleMatrix, t.nodeModelMatrix), e.ae.multiply(f, r.negCameraPosMatrix, f);
      var m = e.ae.invert([], f);
      e.ae.transpose(m, m);
      var g = o.paint.get("model-emissive-strength").constantOr(0),
        v = po(new Float32Array(t.worldViewProjection), new Float32Array(f), new Float32Array(m), null, i, s, d.baseColorFactor.toRenderColor(null), u.emissiveFactor, d.metallicFactor, d.roughnessFactor, u, g, o),
        x = {
          defines: []
        },
        y = [];
      lr(x.defines, y, _, i, o.lut);
      var b = i.shadowRenderer;
      b && (b.useNormalOffset = !1);
      var w = null;
      if (p) {
        var _e540 = sr(t.nodeModelMatrix, i.transform);
        if (w = new Float32Array(_e540), "globe" !== h.projection.name) {
          var _t545 = _.aabb.min,
            _i368 = _.aabb.max,
            _p$getOpacityForBound = p.getOpacityForBounds(_e540, _t545[0], _t545[1], _i368[0], _i368[1]),
            _p$getOpacityForBound2 = _slicedToArray(_p$getOpacityForBound, 2),
            _o200 = _p$getOpacityForBound2[0],
            _r401 = _p$getOpacityForBound2[1];
          x.overrideFog = _o200 >= Ke || _r401 >= Ke;
        }
      }
      var T = ui(i, o.paint.get("model-cutoff-fade-range"));
      T.shouldRenderCutoff && x.defines.push("RENDER_CUTOFF");
      var E = i.getOrCreateProgram("model", x);
      i.uploadCommonUniforms(l, E, null, w, T), "shadow" !== i.renderPass && b && b.setupShadowsFromMatrix(t.nodeModelMatrix, E), E.draw(i, l.gl.TRIANGLES, c, a, n, _.material.doubleSided ? e.ag.disabled : e.ag.backCCW, v, o.id, _.vertexBuffer, _.indexBuffer, _.segments, o.paint, i.transform.zoom, void 0, y);
    }
    function hr(t, i, o, r, a, n, s) {
      var l;
      l = "globe" === t.projection.name ? e.ck(o, t) : _toConsumableArray(o), e.ae.multiply(l, l, i.matrix);
      var c = e.ae.multiply([], r, l);
      if (i.meshes) {
        var _iterator370 = _createForOfIteratorHelper(i.meshes),
          _step370;
        try {
          for (_iterator370.s(); !(_step370 = _iterator370.n()).done;) {
            var _t546 = _step370.value;
            if ("BLEND" !== _t546.material.alphaMode) {
              s.push({
                mesh: _t546,
                depth: 0,
                modelIndex: a,
                worldViewProjection: c,
                nodeModelMatrix: l
              });
              continue;
            }
            var _i369 = e.$.transformMat4([], _t546.centroid, c);
            _i369[2] > 0 && n.push({
              mesh: _t546,
              depth: _i369[2],
              modelIndex: a,
              worldViewProjection: c,
              nodeModelMatrix: l
            });
          }
        } catch (err) {
          _iterator370.e(err);
        } finally {
          _iterator370.f();
        }
      }
      if (i.children) {
        var _iterator371 = _createForOfIteratorHelper(i.children),
          _step371;
        try {
          for (_iterator371.s(); !(_step371 = _iterator371.n()).done;) {
            var _e541 = _step371.value;
            hr(t, _e541, o, r, a, n, s);
          }
        } catch (err) {
          _iterator371.e(err);
        } finally {
          _iterator371.f();
        }
      }
    }
    function _r(t, i, o, r) {
      var a = o.shadowRenderer;
      if (!a) return;
      var n = a.getShadowPassDepthMode(),
        s = a.getShadowPassColorMode(),
        l = a.calculateShadowPassMatrixFromMatrix(i),
        c = fo(l);
      o.getOrCreateProgram("modelDepth", {
        defines: o._shadowMapDebug ? [] : ["DEPTH_TEXTURE"]
      }).draw(o, o.context.gl.TRIANGLES, n, e.ah.disabled, s, e.ag.backCCW, c, r.id, t.vertexBuffer, t.indexBuffer, t.segments, r.paint, o.transform.zoom, void 0, void 0);
    }
    function ur(t, i, o) {
      var r = i.updateZoomBasedPaintProperties(),
        a = function (t, i, o) {
          var r,
            a,
            n,
            s = t.terrain ? t.terrain.exaggeration() : 0;
          if (t.terrain && s > 0) {
            var _i370 = t.terrain,
              _a200 = _i370.findDEMTileFor(o);
            _a200 && _a200.dem ? r = e.cm.create(_i370, o, _a200) : s = 0;
          }
          if (0 === s && (i.terrainElevationMin = 0, i.terrainElevationMax = 0), s === i.validForExaggeration && (0 === s || r && r._demTile && r._demTile.tileID === i.validForDEMTile.id && r._dem._timestamp === i.validForDEMTile.timestamp)) return !1;
          for (var _e542 in i.instancesPerModel) {
            var _t547 = i.instancesPerModel[_e542];
            for (var _e543 = 0; _e543 < _t547.instancedDataArray.length; ++_e543) {
              var _o201 = (r ? s * r.getElevationAt(0 | _t547.instancedDataArray.float32[16 * _e543], 0 | _t547.instancedDataArray.float32[16 * _e543 + 1], !0, !0) : 0) + _t547.instancesEvaluatedElevation[_e543];
              _t547.instancedDataArray.float32[16 * _e543 + 6] = _o201, a = a ? Math.min(i.terrainElevationMin, _o201) : _o201, n = n ? Math.max(i.terrainElevationMax, _o201) : _o201;
            }
          }
          return i.terrainElevationMin = a || 0, i.terrainElevationMax = n || 0, i.validForExaggeration = s, i.validForDEMTile = r && r._demTile ? {
            id: r._demTile.tileID,
            timestamp: r._dem._timestamp
          } : {
            id: void 0,
            timestamp: 0
          }, !0;
        }(t, i, o);
      (r || a) && (i.uploaded = !1, i.upload(t.context));
    }
    var dr = {
      shadowUniformsInitialized: !1,
      useSingleShadowCascade: !1,
      tileMatrix: new Float64Array(16),
      shadowTileMatrix: new Float32Array(16),
      aabb: new e.b8([0, 0, 0], [e.a4, e.a4, 0])
    };
    function pr(t, i) {
      var o = 1 << t.canonical.z,
        r = i.getFreeCameraOptions().position,
        a = i.elevation,
        n = t.canonical.x / o,
        s = (t.canonical.x + 1) / o,
        l = t.canonical.y / o,
        c = (t.canonical.y + 1) / o;
      var h = i._centerAltitude;
      if (a) {
        var _e544 = a.getMinMaxForTile(t);
        _e544 && _e544.max > h && (h = _e544.max);
      }
      var _ = e.au(r.x, n, s) - r.x,
        u = e.au(r.y, l, c) - r.y,
        d = e.ay(h, i.center.lat) - r.z;
      return i._zoomFromMercatorZ(Math.sqrt(_ * _ + u * u + d * d));
    }
    function fr(t, i, o, r, a, n, s) {
      var l = t.context,
        c = "shadow" === t.renderPass,
        h = t.shadowRenderer,
        _ = c && h ? h.getShadowPassDepthMode() : new e.af(l.gl.LEQUAL, e.af.ReadWrite, t.depthRangeFor3D),
        u = t.isTileAffectedByFog(n);
      if (o.meshes) {
        var _iterator372 = _createForOfIteratorHelper(o.meshes),
          _step372;
        try {
          for (_iterator372.s(); !(_step372 = _iterator372.n()).done;) {
            var _d39 = _step372.value;
            var _p58 = ["MODEL_POSITION_ON_GPU"],
              _f50 = [];
            var _m29 = void 0,
              _g25 = void 0,
              _v20 = void 0;
            r.instancedDataArray.length > 20 && _p58.push("INSTANCED_ARRAYS");
            var _x24 = ui(t, i.paint.get("model-cutoff-fade-range"));
            if (_x24.shouldRenderCutoff && _p58.push("RENDER_CUTOFF"), c && h) _m29 = t.getOrCreateProgram("modelDepth", {
              defines: _p58
            }), _g25 = fo(s.shadowTileMatrix, s.shadowTileMatrix, Float32Array.from(o.matrix)), _v20 = h.getShadowPassColorMode();else {
              lr(_p58, _f50, _d39, t, i.lut), _m29 = t.getOrCreateProgram("model", {
                defines: _p58,
                overrideFog: u
              });
              var _r402 = _d39.material,
                _c89 = _r402.pbrMetallicRoughness,
                _24 = i.paint.get("model-opacity"),
                _y58 = i.paint.get("model-emissive-strength").constantOr(0);
              _g25 = po(n.expandedProjMatrix, Float32Array.from(o.matrix), new Float32Array(16), null, t, _24, _c89.baseColorFactor.toRenderColor(null), _r402.emissiveFactor, _c89.metallicFactor, _c89.roughnessFactor, _r402, _y58, i, a), h && (s.shadowUniformsInitialized ? _m29.setShadowUniformValues(l, h.getShadowUniformValues()) : (h.setupShadows(n.toUnwrapped(), _m29, "model-tile", n.overscaledZ), s.shadowUniformsInitialized = !0)), _v20 = _x24.shouldRenderCutoff || _24 < 1 || "OPAQUE" !== _r402.alphaMode ? e.a.alphaBlended : e.a.unblended;
            }
            t.uploadCommonUniforms(l, _m29, n.toUnwrapped(), null, _x24);
            var _y59 = _d39.material.doubleSided ? e.ag.disabled : e.ag.backCCW;
            if (r.instancedDataArray.length > 20) _f50.push(r.instancedDataBuffer), _m29.draw(t, l.gl.TRIANGLES, _, e.ah.disabled, _v20, _y59, _g25, i.id, _d39.vertexBuffer, _d39.indexBuffer, _d39.segments, i.paint, t.transform.zoom, void 0, _f50, r.instancedDataArray.length);else {
              var _o202 = c ? "u_instance" : "u_normal_matrix";
              for (var _a201 = 0; _a201 < r.instancedDataArray.length; ++_a201) _g25[_o202] = new Float32Array(r.instancedDataArray.arrayBuffer, 64 * _a201, 16), _m29.draw(t, l.gl.TRIANGLES, _, e.ah.disabled, _v20, _y59, _g25, i.id, _d39.vertexBuffer, _d39.indexBuffer, _d39.segments, i.paint, t.transform.zoom, void 0, _f50);
            }
          }
        } catch (err) {
          _iterator372.e(err);
        } finally {
          _iterator372.f();
        }
      }
      if (o.children) {
        var _iterator373 = _createForOfIteratorHelper(o.children),
          _step373;
        try {
          for (_iterator373.s(); !(_step373 = _iterator373.n()).done;) {
            var _e545 = _step373.value;
            fr(t, i, _e545, r, a, n, s);
          }
        } catch (err) {
          _iterator373.e(err);
        } finally {
          _iterator373.f();
        }
      }
    }
    var mr = [1, -1, 1];
    function gr(t, i, o, r) {
      if (!o.modelManager) return !0;
      var a = o.modelManager;
      if (!o.shadowRenderer) return !0;
      var n = o.shadowRenderer,
        s = i.aabb;
      var l = !0,
        c = t.maxHeight;
      if (0 === c) {
        var _e546 = 0;
        for (var _i371 in t.instancesPerModel) {
          var _t548 = a.getModel(_i371, r);
          _t548 ? _e546 = Math.max(_e546, Math.max(Math.max(_t548.aabb.max[0], _t548.aabb.max[1]), _t548.aabb.max[2])) : l = !1;
        }
        c = t.maxScale * _e546 * 1.41 + t.maxVerticalOffset, l && (t.maxHeight = c);
      }
      s.max[2] = c, s.min[2] += t.terrainElevationMin, s.max[2] += t.terrainElevationMax, e.$.transformMat4(s.min, s.min, i.tileMatrix), e.$.transformMat4(s.max, s.max, i.tileMatrix);
      var h = s.intersects(n.getCurrentCascadeFrustum());
      return 0 === o.currentShadowCascade && (t.isInsideFirstShadowMapFrustum = 2 === h), 0 === h;
    }
    function vr(t, i) {
      var o = t.uniformValues.u_cutoff_params[0],
        r = t.uniformValues.u_cutoff_params[1],
        a = t.uniformValues.u_cutoff_params[2],
        n = t.uniformValues.u_cutoff_params[3];
      return r === o || n === a ? 1 : e.au(((i - o) / (r - o) - a) / (n - a), 0, 1);
    }
    function xr(t, i, o, r) {
      if (i.pitch < 20) return 1;
      var a = i.getWorldToCameraMatrix(),
        n = e.ae.multiply([], a, t),
        s = [].concat(_toConsumableArray(o.min), [1]);
      var l = e.aB.transformMat4([], s, n),
        c = l,
        h = l;
      s[1] = o.max[1], l = e.aB.transformMat4([], s, n), c = l[1] < c[1] ? l : c, h = l[1] > h[1] ? l : h, s[0] = o.max[0], l = e.aB.transformMat4([], s, n), c = l[1] < c[1] ? l : c, h = l[1] > h[1] ? l : h, s[1] = o.min[1], l = e.aB.transformMat4([], s, n), c = l[1] < c[1] ? l : c, h = l[1] > h[1] ? l : h;
      var _ = e.au(r[0], 0, 1),
        u = 100 * i.pixelsPerMeter * e.au(r[1], 0, 1),
        d = e.au(r[2], 0, 1),
        p = e.$.lerp([], c, h, _),
        f = Math.tan(.5 * i.fovX),
        m = -p[2] * f;
      if (0 === u) return p[1] < -Math.abs(m) ? d : 1;
      var g = (-Math.abs(m) - p[1]) / u,
        v = function v(e, t, i) {
          return (1 - i) * e + i * t;
        },
        x = e.au(v(1, d, g), d, 1);
      return v(1, x, e.au((i.pitch - 20) / 20, 0, 1));
    }
    var yr = /*#__PURE__*/_createClass(function yr() {
      _classCallCheck(this, yr);
    });
    var br = /*#__PURE__*/function () {
      function br() {
        _classCallCheck(this, br);
        this._storage = new Map();
      }
      _createClass(br, [{
        key: "getLinesFromTrianglesBuffer",
        value: function getLinesFromTrianglesBuffer(t, i, o) {
          {
            var _e547 = this._storage.get(i.id);
            if (_e547) return _e547.lastUsedFrameIdx = t, _e547.buf;
          }
          var r = o.gl,
            a = r.getBufferParameter(r.ELEMENT_ARRAY_BUFFER, r.BUFFER_SIZE),
            n = new ArrayBuffer(a),
            s = new Int16Array(n);
          r.getBufferSubData(r.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(n));
          var l = new e.co();
          for (var _e548 = 0; _e548 < a / 2; _e548 += 3) {
            var _t549 = s[_e548],
              _i372 = s[_e548 + 1],
              _o203 = s[_e548 + 2];
            l.emplaceBack(_t549, _i372), l.emplaceBack(_i372, _o203), l.emplaceBack(_o203, _t549);
          }
          var c = o.bindVertexArrayOES.current,
            h = new yr();
          return h.buf = new e.I(o, l), h.lastUsedFrameIdx = t, this._storage.set(i.id, h), o.bindVertexArrayOES.set(c), h.buf;
        }
      }, {
        key: "update",
        value: function update(e) {
          var _iterator374 = _createForOfIteratorHelper(this._storage),
            _step374;
          try {
            for (_iterator374.s(); !(_step374 = _iterator374.n()).done;) {
              var _step374$value = _slicedToArray(_step374.value, 2),
                _t550 = _step374$value[0],
                _i373 = _step374$value[1];
              e - _i373.lastUsedFrameIdx > 30 && (_i373.buf.destroy(), this._storage.delete(_t550));
            }
          } catch (err) {
            _iterator374.e(err);
          } finally {
            _iterator374.f();
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iterator375 = _createForOfIteratorHelper(this._storage),
            _step375;
          try {
            for (_iterator375.s(); !(_step375 = _iterator375.n()).done;) {
              var _step375$value = _slicedToArray(_step375.value, 2),
                _e549 = _step375$value[0],
                _t551 = _step375$value[1];
              _t551.buf.destroy(), this._storage.delete(_e549);
            }
          } catch (err) {
            _iterator375.e(err);
          } finally {
            _iterator375.f();
          }
        }
      }]);
      return br;
    }();
    var wr = /*#__PURE__*/_createClass(function wr(e) {
      _classCallCheck(this, wr);
      this.occluderSize = 30, this.depthOffset = -1e-4, e.registerParameter(this, ["Occlusion"], "occluderSize", {
        min: 1,
        max: 100,
        step: 1
      }), e.registerParameter(this, ["Occlusion"], "depthOffset", {
        min: -.05,
        max: 0,
        step: 1e-5
      });
    });
    var Tr = {
        symbol: function symbol(t, i, o, r, a) {
          if ("translucent" !== t.renderPass) return;
          var n = e.ah.disabled,
            s = t.colorModeForRenderPass();
          o.layout.get("text-variable-anchor") && function (t, i, o, r, a, n, s) {
            var l = i.transform,
              c = "map" === a,
              h = "map" === n;
            var _iterator376 = _createForOfIteratorHelper(t),
              _step376;
            try {
              for (_iterator376.s(); !(_step376 = _iterator376.n()).done;) {
                var _i374 = _step376.value;
                var _t552 = r.getTile(_i374),
                  _a202 = _t552.getBucket(o);
                if (!_a202 || !_a202.text || !_a202.text.segments.get().length) continue;
                var _n279 = e.aE(_a202.textSizeData, l.zoom),
                  _25 = xo(_i374, _a202.getProjection(), l),
                  _u93 = l.calculatePixelsToTileUnitsMatrix(_t552),
                  _d40 = Ht(_25, _t552.tileID.canonical, h, c, l, _a202.getProjection(), _u93),
                  _p59 = _a202.hasIconTextFit() && _a202.hasIconData();
                if (_n279) {
                  var _o204 = Math.pow(2, l.zoom - _t552.tileID.overscaledZ);
                  Co(_a202, c, h, s, e.bQ, l, _d40, _i374, _o204, _n279, _p59);
                }
              }
            } catch (err) {
              _iterator376.e(err);
            } finally {
              _iterator376.f();
            }
          }(r, t, o, i, o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), a);
          var l = 0 !== o.paint.get("icon-opacity").constantOr(1),
            c = 0 !== o.paint.get("text-opacity").constantOr(1);
          void 0 !== o.layout.get("symbol-sort-key").constantOr(1) && (l || c) ? So(t, i, o, r, n, s) : (l && So(t, i, o, r, n, s, {
            onlyIcons: !0
          }), c && So(t, i, o, r, n, s, {
            onlyText: !0
          })), i.map.showCollisionBoxes && (bo(t, i, o, r, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), !0), bo(t, i, o, r, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), !1));
        },
        circle: function circle(t, i, o, r) {
          if ("translucent" !== t.renderPass) return;
          var a = o.paint.get("circle-opacity"),
            n = o.paint.get("circle-stroke-width"),
            s = o.paint.get("circle-stroke-opacity"),
            l = void 0 !== o.layout.get("circle-sort-key").constantOr(1),
            c = o.paint.get("circle-emissive-strength");
          if (0 === a.constantOr(1) && (0 === n.constantOr(1) || 0 === s.constantOr(1))) return;
          var h = t.context,
            _ = h.gl,
            u = t.transform,
            d = t.depthModeForSublayer(0, e.af.ReadOnly),
            p = e.ah.disabled,
            f = t.colorModeForDrapableLayerRenderPass(c),
            m = "globe" === u.projection.name,
            g = [e.ak(u.center.lng), e.al(u.center.lat)],
            v = [];
          for (var _a203 = 0; _a203 < r.length; _a203++) {
            var _n280 = r[_a203],
              _s234 = i.getTile(_n280),
              _c90 = _s234.getBucket(o);
            if (!_c90 || _c90.projection.name !== u.projection.name) continue;
            var _h73 = _c90.programConfigurations.get(o.id),
              _26 = e.bT(o),
              _d41 = t.isTileAffectedByFog(_n280);
            m && _26.push("PROJECTION_GLOBE_VIEW"), _26.push("DEPTH_D24"), t.terrain && u.depthOcclusionForSymbolsAndCircles && _26.push("DEPTH_OCCLUSION");
            var _p60 = t.getOrCreateProgram("circle", {
                config: _h73,
                defines: _26,
                overrideFog: _d41
              }),
              _f51 = _c90.layoutVertexBuffer,
              _x25 = _c90.globeExtVertexBuffer,
              _y60 = _c90.indexBuffer,
              _b19 = u.projection.createInversionMatrix(u, _n280.canonical),
              _w18 = {
                programConfiguration: _h73,
                program: _p60,
                layoutVertexBuffer: _f51,
                globeExtVertexBuffer: _x25,
                indexBuffer: _y60,
                uniformValues: e.bU(t, _n280, _s234, _b19, g, o),
                tile: _s234
              };
            if (l) {
              var _t553 = _c90.segments.get();
              var _iterator377 = _createForOfIteratorHelper(_t553),
                _step377;
              try {
                for (_iterator377.s(); !(_step377 = _iterator377.n()).done;) {
                  var _i375 = _step377.value;
                  v.push({
                    segments: new e.b([_i375]),
                    sortKey: _i375.sortKey,
                    state: _w18
                  });
                }
              } catch (err) {
                _iterator377.e(err);
              } finally {
                _iterator377.f();
              }
            } else v.push({
              segments: _c90.segments,
              sortKey: 0,
              state: _w18
            });
          }
          l && v.sort(function (e, t) {
            return e.sortKey - t.sortKey;
          });
          var x = {
            useDepthForOcclusion: u.depthOcclusionForSymbolsAndCircles
          };
          for (var _i376 = 0, _v21 = v; _i376 < _v21.length; _i376++) {
            var _i377 = _v21[_i376];
            var _i377$state = _i377.state,
              _r403 = _i377$state.programConfiguration,
              _a204 = _i377$state.program,
              _n281 = _i377$state.layoutVertexBuffer,
              _s235 = _i377$state.globeExtVertexBuffer,
              _l118 = _i377$state.indexBuffer,
              _c91 = _i377$state.uniformValues,
              _m30 = _i377$state.tile,
              _g26 = _i377.segments;
            t.terrain && t.terrain.setupElevationDraw(_m30, _a204, x), t.uploadCommonUniforms(h, _a204, _m30.tileID.toUnwrapped()), _a204.draw(t, _.TRIANGLES, d, p, f, e.ag.disabled, _c91, o.id, _n281, _l118, _g26, o.paint, u.zoom, _r403, [_s235]);
          }
        },
        heatmap: function heatmap(t, i, o, r) {
          if (0 !== o.paint.get("heatmap-opacity")) if ("offscreen" === t.renderPass) {
            var _a205 = t.context,
              _n282 = _a205.gl,
              _s236 = e.ah.disabled,
              _l119 = new e.a([_n282.ONE, _n282.ONE, _n282.ONE, _n282.ONE], e.C.transparent, [!0, !0, !0, !0]);
            !function (e, t, i, o) {
              var r = e.gl,
                a = t.width * o,
                n = t.height * o;
              e.activeTexture.set(r.TEXTURE1), e.viewport.set([0, 0, a, n]);
              var s = i.heatmapFbo;
              if (!s || s && (s.width !== a || s.height !== n)) {
                s && s.destroy();
                var _t554 = r.createTexture();
                r.bindTexture(r.TEXTURE_2D, _t554), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), s = i.heatmapFbo = e.createFramebuffer(a, n, !0, null), function (e, t, i, o, r, a) {
                  var n = e.gl;
                  n.texImage2D(n.TEXTURE_2D, 0, e.extRenderToTextureHalfFloat ? n.RGBA16F : n.RGBA, r, a, 0, n.RGBA, e.extRenderToTextureHalfFloat ? n.HALF_FLOAT : n.UNSIGNED_BYTE, null), o.colorAttachment.set(i);
                }(e, 0, _t554, s, a, n);
              } else r.bindTexture(r.TEXTURE_2D, s.colorAttachment.get()), e.bindFramebuffer.set(s.framebuffer);
            }(_a205, t, o, "globe" === t.transform.projection.name ? .5 : .25), _a205.clear({
              color: e.C.transparent
            });
            var _c92 = t.transform,
              _h74 = "globe" === _c92.projection.name,
              _27 = _h74 ? ["PROJECTION_GLOBE_VIEW"] : [],
              _u94 = _h74 ? e.ag.frontCCW : e.ag.disabled,
              _d42 = [e.ak(_c92.center.lng), e.al(_c92.center.lat)];
            for (var _p61 = 0; _p61 < r.length; _p61++) {
              var _f52 = r[_p61];
              if (i.hasRenderableParent(_f52)) continue;
              var _m31 = i.getTile(_f52),
                _g27 = _m31.getBucket(o);
              if (!_g27 || _g27.projection.name !== _c92.projection.name) continue;
              var _v22 = t.isTileAffectedByFog(_f52),
                _x26 = _g27.programConfigurations.get(o.id),
                _y61 = t.getOrCreateProgram("heatmap", {
                  config: _x26,
                  defines: _27,
                  overrideFog: _v22
                }),
                _b20 = t.transform.zoom;
              t.terrain && t.terrain.setupElevationDraw(_m31, _y61), t.uploadCommonUniforms(_a205, _y61, _f52.toUnwrapped());
              var _w19 = _c92.projection.createInversionMatrix(_c92, _f52.canonical);
              _y61.draw(t, _n282.TRIANGLES, e.af.disabled, _s236, _l119, _u94, Yi(t, _f52, _m31, _w19, _d42, _b20, o.paint.get("heatmap-intensity")), o.id, _g27.layoutVertexBuffer, _g27.indexBuffer, _g27.segments, o.paint, t.transform.zoom, _x26, _h74 ? [_g27.globeExtVertexBuffer] : null);
            }
            _a205.viewport.set([0, 0, t.width, t.height]);
          } else "translucent" === t.renderPass && (t.context.setColorMode(t.colorModeForRenderPass()), function (t, i) {
            var o = t.context,
              r = o.gl,
              a = i.heatmapFbo;
            if (!a) return;
            o.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, a.colorAttachment.get()), o.activeTexture.set(r.TEXTURE1);
            var n = i.colorRampTexture;
            n || (n = i.colorRampTexture = new e.T(o, i.colorRamp, r.RGBA)), n.bind(r.LINEAR, r.CLAMP_TO_EDGE), t.getOrCreateProgram("heatmapTexture").draw(t, r.TRIANGLES, e.af.disabled, e.ah.disabled, t.colorModeForRenderPass(), e.ag.disabled, function (e, t, i, o) {
              return {
                u_image: 0,
                u_color_ramp: 1,
                u_opacity: t.paint.get("heatmap-opacity")
              };
            }(0, i), i.id, t.viewportBuffer, t.quadTriangleIndexBuffer, t.viewportSegments, i.paint, t.transform.zoom);
          }(t, o));
        },
        line: function line(t, i, o, r) {
          if ("translucent" !== t.renderPass) return;
          var a = o.paint.get("line-opacity"),
            n = o.paint.get("line-width");
          if (0 === a.constantOr(1) || 0 === n.constantOr(1)) return;
          var s = o.paint.get("line-emissive-strength"),
            l = o.paint.get("line-occlusion-opacity"),
            c = t.context,
            h = c.gl,
            _ = o.layout.get("line-z-offset"),
            u = !_.isConstant() || !!_.constantOr(0),
            d = u ? new e.af(t.depthOcclusion ? h.GREATER : h.LEQUAL, e.af.ReadOnly, t.depthRangeFor3D) : t.depthModeForSublayer(0, e.af.ReadOnly),
            p = t.colorModeForDrapableLayerRenderPass(s),
            f = t.terrain && t.terrain.renderingToTexture,
            m = f ? 1 : e.e.devicePixelRatio,
            g = o.paint.get("line-dasharray"),
            v = g.constantOr(1),
            x = o.layout.get("line-cap"),
            y = g.constantOr(null),
            b = x.constantOr(null),
            w = o.paint.get("line-pattern"),
            T = w.constantOr(1),
            E = w.constantOr(null),
            C = o.paint.get("line-opacity").constantOr(1);
          var S = !T && 1 !== C || t.depthOcclusion && l > 0 && l < 1;
          var I = o.paint.get("line-gradient"),
            L = T ? "linePattern" : "line",
            P = e.bV(o);
          var R;
          if (f && t.terrain && t.terrain.clipOrMaskOverlapStencilType() && (S = !1), 0 !== l && t.depthOcclusion) {
            var _t555 = o.paint._values["line-opacity"];
            _t555 && _t555.value && "constant" === _t555.value.kind ? R = _t555.value : e.w("Occlusion opacity for layer ".concat(o.id, " is supported only when line-opacity isn't data-driven."));
          }
          if (u && (t.forceTerrainMode = !0), !u && 0 !== l && t.terrain && !f) return void e.w("Occlusion opacity for layer ".concat(o.id, " is supported on terrain only if the layer has non-zero line-z-offset."));
          var D = S && u ? t.stencilModeFor3D() : e.ah.disabled;
          var _iterator378 = _createForOfIteratorHelper(r),
            _step378;
          try {
            var _loop19 = function _loop19() {
                var a = _step378.value;
                var r = i.getTile(a);
                if (T && !r.patternsLoaded()) return 0; // continue
                var n = r.getBucket(o);
                if (!n) return 0; // continue
                t.prepareDrawTile();
                var s = n.programConfigurations.get(o.id),
                  _ = t.isTileAffectedByFog(a),
                  g = t.getOrCreateProgram(L, {
                    config: s,
                    defines: u ? [].concat(_toConsumableArray(P), ["ELEVATED"]) : P,
                    overrideFog: _
                  });
                if (E && r.imageAtlas) {
                  var _e550 = r.imageAtlas.patternPositions[E.toString()];
                  _e550 && s.setConstantPatternPositions(_e550);
                }
                if (!T && y && b && r.lineAtlas) {
                  var _e551 = r.lineAtlas.getDash(y, b);
                  _e551 && s.setConstantPatternPositions(_e551);
                }
                var _o$paint$get = o.paint.get("line-trim-offset"),
                  _o$paint$get2 = _slicedToArray(_o$paint$get, 2),
                  x = _o$paint$get2[0],
                  w = _o$paint$get2[1];
                if ("round" === b || "square" === b) {
                  var _e552 = 1;
                  x !== w && (0 === x && (x -= _e552), 1 === w && (w += _e552));
                }
                var A = f ? a.projMatrix : null,
                  M = T ? e.bW(t, r, o, A, m, [x, w]) : e.bX(t, r, o, A, n.lineClipsArray.length, m, [x, w]);
                if (I) {
                  var _r404 = n.gradients[o.id];
                  var _s237 = _r404.texture;
                  if (o.gradientVersion !== _r404.version) {
                    var _l120 = 256;
                    if (o.stepInterpolant) {
                      var _o205 = i.getSource().maxzoom,
                        _r405 = a.canonical.z === _o205 ? Math.ceil(1 << t.transform.maxZoom - a.canonical.z) : 1;
                      _l120 = e.au(e.bY(n.maxLineLength / e.a4 * 1024 * _r405), 256, c.maxTextureSize);
                    }
                    _r404.gradient = e.bZ({
                      expression: o.gradientExpression(),
                      evaluationKey: "lineProgress",
                      resolution: _l120,
                      image: _r404.gradient || void 0,
                      clips: n.lineClipsArray
                    }), _r404.texture ? _r404.texture.update(_r404.gradient) : _r404.texture = new e.T(c, _r404.gradient, h.RGBA), _r404.version = o.gradientVersion, _s237 = _r404.texture;
                  }
                  c.activeTexture.set(h.TEXTURE1), _s237.bind(o.stepInterpolant ? h.NEAREST : h.LINEAR, h.CLAMP_TO_EDGE);
                }
                v && (c.activeTexture.set(h.TEXTURE0), r.lineAtlasTexture && r.lineAtlasTexture.bind(h.LINEAR, h.REPEAT), s.updatePaintBuffers()), T && (c.activeTexture.set(h.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), s.updatePaintBuffers()), u && t.terrain.setupElevationDraw(r, g), t.uploadCommonUniforms(c, g, a.toUnwrapped());
                var z = function z(i) {
                  null != R && (R.value = C * l), g.draw(t, h.TRIANGLES, d, i, p, e.ag.disabled, M, o.id, n.layoutVertexBuffer, n.indexBuffer, n.segments, o.paint, t.transform.zoom, s, [n.layoutVertexBuffer2, n.patternVertexBuffer, n.zOffsetVertexBuffer]), null != R && (R.value = C);
                };
                if (S && !u) {
                  var _i378 = t.stencilModeForClipping(a).ref;
                  0 === _i378 && f && c.clear({
                    stencil: 0
                  });
                  var _o206 = {
                    func: h.EQUAL,
                    mask: 255
                  };
                  M.u_alpha_discard_threshold = .8, z(new e.ah(_o206, _i378, 255, h.KEEP, h.KEEP, h.INVERT)), M.u_alpha_discard_threshold = 0, z(new e.ah(_o206, _i378, 255, h.KEEP, h.KEEP, h.KEEP));
                } else S && u && (M.u_alpha_discard_threshold = .001), z(u ? D : t.stencilModeForClipping(a));
              },
              _ret6;
            for (_iterator378.s(); !(_step378 = _iterator378.n()).done;) {
              _ret6 = _loop19();
              if (_ret6 === 0) continue;
            }
          } catch (err) {
            _iterator378.e(err);
          } finally {
            _iterator378.f();
          }
          S && (t.resetStencilClippingMasks(), f && c.clear({
            stencil: 0
          })), 0 === l || t.depthOcclusion || f || t.layersWithOcclusionOpacity.push(t.currentLayer), u && (t.forceTerrainMode = !1);
        },
        fill: function fill(t, i, o, r) {
          var a = o.paint.get("fill-color"),
            n = o.paint.get("fill-opacity");
          if (0 === n.constantOr(1)) return;
          var s = o.paint.get("fill-emissive-strength"),
            l = t.colorModeForDrapableLayerRenderPass(s),
            c = o.paint.get("fill-pattern"),
            h = t.opaquePassEnabledForLayer() && !c.constantOr(1) && 1 === a.constantOr(e.C.transparent).a && 1 === n.constantOr(0) ? "opaque" : "translucent";
          if (t.renderPass === h) {
            var _a206 = t.depthModeForSublayer(1, "opaque" === t.renderPass ? e.af.ReadWrite : e.af.ReadOnly);
            Lo(t, i, o, r, _a206, l, !1);
          }
          if ("translucent" === t.renderPass && o.paint.get("fill-antialias")) {
            var _a207 = t.depthModeForSublayer(o.getPaintProperty("fill-outline-color") ? 2 : 0, e.af.ReadOnly);
            Lo(t, i, o, r, _a207, l, !0);
          }
        },
        "fill-extrusion": function fillExtrusion(t, i, o, r) {
          var a = o.paint.get("fill-extrusion-opacity"),
            n = t.context,
            s = n.gl,
            l = t.terrain,
            c = l && l.renderingToTexture;
          if (0 === a) return;
          var h = t.conflationActive && t.style.isLayerClipped(o, i.getSource()),
            _ = t.style.order.indexOf(o.fqid);
          if (h && function (e, t, i, o, r) {
            var _iterator379 = _createForOfIteratorHelper(o),
              _step379;
            try {
              for (_iterator379.s(); !(_step379 = _iterator379.n()).done;) {
                var _a208 = _step379.value;
                var _o207 = t.getTile(_a208).getBucket(i);
                _o207 && (_o207.updateReplacement(_a208, e.replacementSource, r), _o207.uploadCentroid(e.context));
              }
            } catch (err) {
              _iterator379.e(err);
            } finally {
              _iterator379.f();
            }
          }(t, i, o, r, _), l || h) {
            var _iterator380 = _createForOfIteratorHelper(r),
              _step380;
            try {
              for (_iterator380.s(); !(_step380 = _iterator380.n()).done;) {
                var _e553 = _step380.value;
                var _r406 = i.getTile(_e553).getBucket(o);
                _r406 && Do(t.context, i, _e553, _r406, o, l, h);
              }
            } catch (err) {
              _iterator380.e(err);
            } finally {
              _iterator380.f();
            }
          }
          if ("shadow" === t.renderPass && t.shadowRenderer) {
            var _n283 = t.shadowRenderer;
            if (l && a < .65 && o._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof e.Z) return;
            var _s238 = _n283.getShadowPassDepthMode(),
              _c93 = _n283.getShadowPassColorMode();
            Po(t, i, o, r, _s238, e.ah.disabled, _c93, h);
          } else if ("translucent" === t.renderPass) {
            var _28 = !o.paint.get("fill-extrusion-pattern").constantOr(1),
              _u95 = o.paint.get("fill-extrusion-color").constantOr(e.C.white);
            if (!c && 0 !== _u95.a) {
              var _n284 = new e.af(t.context.gl.LEQUAL, e.af.ReadWrite, t.depthRangeFor3D);
              1 === a && _28 ? Po(t, i, o, r, _n284, e.ah.disabled, e.a.unblended, h) : (Po(t, i, o, r, _n284, e.ah.disabled, e.a.disabled, h), Po(t, i, o, r, _n284, t.stencilModeFor3D(), t.colorModeForRenderPass(), h), t.resetStencilClippingMasks());
            }
            if (t.style.enable3dLights() && _28 && (!l && "globe" !== t.transform.projection.name || c)) {
              var _a209 = o.paint.get("fill-extrusion-opacity"),
                _29 = o.paint.get("fill-extrusion-ambient-occlusion-intensity"),
                _u96 = o.paint.get("fill-extrusion-ambient-occlusion-ground-radius"),
                _d43 = o.paint.get("fill-extrusion-flood-light-intensity"),
                _p62 = o.paint.get("fill-extrusion-flood-light-color").toRenderColor(o.lut).toArray01().slice(0, 3),
                _f53 = _29 > 0 && _u96 > 0,
                _m32 = _d43 > 0,
                _g28 = function _g28(e, t, i) {
                  return (1 - i) * e + i * t;
                },
                _v23 = function _v23(n) {
                  var l = t.depthModeForSublayer(1, e.af.ReadOnly, s.LEQUAL, !0),
                    c = o.paint.get(n ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"),
                    f = _g28(.1, 3, c),
                    m = t._showOverdrawInspector;
                  if (!m) {
                    var _c94 = new e.ah({
                        func: s.ALWAYS,
                        mask: 255
                      }, 255, 255, s.KEEP, s.KEEP, s.REPLACE),
                      _m33 = new e.a([s.ONE, s.ONE, s.ONE, s.ONE], e.C.transparent, [!1, !1, !1, !0], s.MIN);
                    Ro(t, i, o, r, l, _c94, _m33, e.ag.disabled, n, "sdf", _a209, _29, _u96, _d43, _p62, f, h, !1);
                  }
                  {
                    var _c95 = m ? e.ah.disabled : new e.ah({
                        func: s.EQUAL,
                        mask: 255
                      }, 255, 255, s.KEEP, s.DECR, s.DECR),
                      _g29 = m ? t.colorModeForRenderPass() : new e.a([s.ONE_MINUS_DST_ALPHA, s.DST_ALPHA, s.ONE, s.ONE], e.C.transparent, [!0, !0, !0, !0]);
                    Ro(t, i, o, r, l, _c95, _g29, e.ag.disabled, n, "color", _a209, _29, _u96, _d43, _p62, f, h, !1);
                  }
                };
              if (c) {
                var _c96 = function _c96(n, l, c) {
                  var f = t.depthModeForSublayer(1, e.af.ReadOnly, s.LEQUAL, !1),
                    m = o.paint.get(n ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"),
                    v = _g28(.1, 3, m);
                  {
                    var _c97 = new e.a([s.ONE, s.ONE, s.ONE, s.ONE], e.C.transparent, [!1, !1, !1, !0]);
                    Ro(t, i, o, r, f, e.ah.disabled, _c97, e.ag.disabled, n, "clear", _a209, _29, _u96, _d43, _p62, v, h, l);
                  }
                  {
                    var _c98 = new e.ah({
                        func: s.ALWAYS,
                        mask: 255
                      }, 255, 255, s.KEEP, s.KEEP, s.REPLACE),
                      _m34 = new e.a([s.ONE, s.ONE, s.ONE, s.ONE], e.C.transparent, [!1, !1, !1, !0], s.MIN);
                    Ro(t, i, o, r, f, _c98, _m34, e.ag.disabled, n, "sdf", _a209, _29, _u96, _d43, _p62, v, h, l);
                  }
                  {
                    var _c99 = n ? s.ZERO : s.ONE_MINUS_DST_ALPHA,
                      _m35 = new e.ah({
                        func: s.EQUAL,
                        mask: 255
                      }, 255, 255, s.KEEP, s.DECR, s.DECR),
                      _g30 = new e.a([_c99, s.DST_ALPHA, s.ONE_MINUS_DST_ALPHA, s.ZERO], e.C.transparent, [!0, !0, !0, !0]);
                    Ro(t, i, o, r, f, _m35, _g30, e.ag.disabled, n, "color", _a209, _29, _u96, _d43, _p62, v, h, l);
                  }
                  {
                    var _m36 = new e.a([s.ONE, s.ONE, s.ONE, n ? s.ZERO : s.ONE], e.C.transparent, [!1, !1, !1, !0], n ? s.FUNC_ADD : s.MAX);
                    Ro(t, i, o, r, f, e.ah.disabled, _m36, e.ag.disabled, n, "clear", _a209, _29, _u96, _d43, _p62, v, h, l, c);
                  }
                };
                if (_f53 || _m32) {
                  var _i379;
                  if (t.prepareDrawTile(), l) {
                    var _t556 = l.drapeBufferSize[0],
                      _o208 = l.drapeBufferSize[1];
                    _i379 = l.framebufferCopyTexture, _i379 && (!_i379 || _i379.size[0] === _t556 && _i379.size[1] === _o208) || (_i379 && _i379.destroy(), _i379 = l.framebufferCopyTexture = new e.T(n, new e.j({
                      width: _t556,
                      height: _o208
                    }), s.RGBA)), _i379.bind(s.LINEAR, s.CLAMP_TO_EDGE), s.copyTexImage2D(s.TEXTURE_2D, 0, s.RGBA, 0, 0, _t556, _o208, 0);
                  }
                  _f53 && _c96(!0, !1, _i379), _m32 && _c96(!1, !0, _i379);
                }
              } else _f53 && _v23(!0), _m32 && _v23(!1), (_f53 || _m32) && t.resetStencilClippingMasks();
            }
          }
        },
        hillshade: function hillshade(t, i, o, r) {
          if ("offscreen" !== t.renderPass && "translucent" !== t.renderPass) return;
          if (t.style.disableElevatedTerrain) return;
          var a = t.context,
            n = t.terrain && t.terrain.renderingToTexture,
            _ref179 = "translucent" !== t.renderPass || n ? [{}, r] : t.stencilConfigForOverlap(r),
            _ref180 = _slicedToArray(_ref179, 2),
            s = _ref180[0],
            l = _ref180[1];
          var _iterator381 = _createForOfIteratorHelper(l),
            _step381;
          try {
            for (_iterator381.s(); !(_step381 = _iterator381.n()).done;) {
              var _r407 = _step381.value;
              var _a210 = i.getTile(_r407);
              if (_a210.needsHillshadePrepare && "offscreen" === t.renderPass) At(t, _a210, o);else if ("translucent" === t.renderPass) {
                var _i380 = t.depthModeForSublayer(0, e.af.ReadOnly),
                  _l121 = o.paint.get("hillshade-emissive-strength"),
                  _c100 = t.colorModeForDrapableLayerRenderPass(_l121),
                  _h75 = n && t.terrain ? t.terrain.stencilModeForRTTOverlap(_r407) : s[_r407.overscaledZ];
                Rt(t, _r407, _a210, o, _i380, _h75, _c100);
              }
            }
          } catch (err) {
            _iterator381.e(err);
          } finally {
            _iterator381.f();
          }
          a.viewport.set([0, 0, t.width, t.height]), t.resetStencilClippingMasks();
        },
        raster: function raster(t, i, o, r, a, n) {
          if ("translucent" !== t.renderPass) return;
          if (0 === o.paint.get("raster-opacity")) return;
          var s = "globe" === t.transform.projection.name,
            l = 0 !== o.paint.get("raster-elevation"),
            c = l && s;
          if (t.renderElevatedRasterBackface && !c) return;
          var h = t.context,
            _ = h.gl,
            u = i.getSource(),
            d = function (t, i, o, r) {
              var a = i.paint.get("raster-color"),
                n = "raster-array" === t.type,
                s = [],
                l = i.paint.get("raster-resampling"),
                c = i.paint.get("raster-color-mix");
              var h = i.paint.get("raster-color-range");
              var _ = [c[0], c[1], c[2], 0],
                u = c[3];
              var d = "nearest" === l ? r.NEAREST : r.LINEAR;
              if (n && (s.push("RASTER_ARRAY"), a || s.push("RASTER_COLOR"), "linear" === l && s.push("RASTER_ARRAY_LINEAR"), d = r.NEAREST, !h && t.rasterLayers)) {
                var _e554 = t.rasterLayers.find(function (_ref181) {
                  var e = _ref181.id;
                  return e === i.sourceLayer;
                });
                _e554 && _e554.fields && _e554.fields.range && (h = _e554.fields.range);
              }
              if (h = h || [0, 1], a) {
                s.push("RASTER_COLOR"), o.activeTexture.set(r.TEXTURE2), i.updateColorRamp(h);
                var _t557 = i.colorRampTexture;
                _t557 || (_t557 = i.colorRampTexture = new e.T(o, i.colorRamp, r.RGBA)), _t557.bind(r.LINEAR, r.CLAMP_TO_EDGE);
              }
              return {
                mix: _,
                range: h,
                offset: u,
                defines: s,
                resampling: d
              };
            }(u, o, h, _);
          if (u instanceof e.bo && !r.length && !s) return;
          var p = o.paint.get("raster-emissive-strength"),
            f = t.colorModeForDrapableLayerRenderPass(p),
            m = t.terrain && t.terrain.renderingToTexture,
            g = !t.options.moving,
            v = "nearest" === o.paint.get("raster-resampling") ? _.NEAREST : _.LINEAR;
          if (u instanceof e.bo && !r.length && (u.onNorthPole || u.onSouthPole)) {
            var _r408 = l ? t.stencilModeFor3D() : e.ah.disabled;
            return void Bo(!!u.onNorthPole, null, t, i, o, p, d, e.ag.disabled, _r408);
          }
          if (!r.length) return;
          var _ref182 = u instanceof e.bo || m ? [{}, r] : t.stencilConfigForOverlap(r),
            _ref183 = _slicedToArray(_ref182, 2),
            x = _ref183[0],
            y = _ref183[1],
            b = y[y.length - 1].overscaledZ;
          c && d.defines.push("PROJECTION_GLOBE_VIEW"), l && d.defines.push("RENDER_CUTOFF");
          var w = function w(r, a, y) {
            var _iterator382 = _createForOfIteratorHelper(r),
              _step382;
            try {
              for (_iterator382.s(); !(_step382 = _iterator382.n()).done;) {
                var _w20 = _step382.value;
                var _r410 = _w20.toUnwrapped(),
                  _T11 = i.getTile(_w20);
                if (m && (!_T11 || !_T11.hasData())) continue;
                h.activeTexture.set(_.TEXTURE0);
                var _E8 = No(_T11, u, o, d);
                if (!_E8 || !_E8.texture) continue;
                var _C6 = _E8.texture,
                  _S14 = _E8.mix,
                  _I11 = _E8.offset,
                  _L5 = _E8.tileSize,
                  _P8 = _E8.buffer;
                var _R4 = void 0,
                  _D4 = void 0;
                m ? (_R4 = e.af.disabled, _D4 = _w20.projMatrix) : l ? (_R4 = new e.af(_.LEQUAL, e.af.ReadWrite, t.depthRangeFor3D), _D4 = s ? Float32Array.from(t.transform.expandedFarZProjMatrix) : t.transform.calculateProjMatrix(_r410, g)) : (_R4 = t.depthModeForSublayer(_w20.overscaledZ - b, 1 === o.paint.get("raster-opacity") ? e.af.ReadWrite : e.af.ReadOnly, _.LESS), _D4 = t.transform.calculateProjMatrix(_r410, g));
                var _A13 = t.terrain && m ? t.terrain.stencilModeForRTTOverlap(_w20) : x[_w20.overscaledZ],
                  _M13 = n ? 0 : o.paint.get("raster-fade-duration");
                _T11.registerFadeDuration(_M13);
                var _z5 = i.findLoadedParent(_w20, 0),
                  _O3 = Ii(_T11, _z5, i, t.transform, _M13);
                var _F3 = void 0,
                  _B3 = void 0;
                t.terrain && t.terrain.prepareDrawTile(), h.activeTexture.set(_.TEXTURE0), _C6.bind(v, _.CLAMP_TO_EDGE), h.activeTexture.set(_.TEXTURE1), _z5 ? (_z5.texture && _z5.texture.bind(v, _.CLAMP_TO_EDGE), _F3 = Math.pow(2, _z5.tileID.overscaledZ - _T11.tileID.overscaledZ), _B3 = [_T11.tileID.canonical.x * _F3 % 1, _T11.tileID.canonical.y * _F3 % 1]) : _C6.bind(v, _.CLAMP_TO_EDGE), _C6.useMipmap && h.extTextureFilterAnisotropic && t.transform.pitch > 20 && _.texParameterf(_.TEXTURE_2D, h.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, h.extTextureFilterAnisotropicMax);
                var _k6 = t.transform;
                var _N = void 0;
                var _U2 = l ? ko(_k6) : [0, 0, 0, 0];
                var _G2 = void 0,
                  _j2 = void 0,
                  _V2 = void 0,
                  _$2 = void 0,
                  _Z2 = void 0,
                  _W2 = 0;
                if (c && u instanceof e.bo && u.coordinates.length > 3) _G2 = Float32Array.from(e.bh(e.bi(new e.aO(0, 0, 0)))), _j2 = Float32Array.from(_k6.globeMatrix), _V2 = Float32Array.from(e.bd(_k6)), _$2 = [e.ak(_k6.center.lng), e.al(_k6.center.lat)], _N = u.elevatedGlobePerspectiveTransform, _Z2 = u.elevatedGlobeGridMatrix || new Float32Array(9);else if (c) {
                  var _t558 = e.be(_w20.canonical);
                  _W2 = e.bf(_t558.getCenter().lat), _G2 = Float32Array.from(e.bh(e.bi(_w20.canonical))), _j2 = Float32Array.from(_k6.globeMatrix), _V2 = Float32Array.from(e.bd(_k6)), _$2 = [e.ak(_k6.center.lng), e.al(_k6.center.lat)], _N = [0, 0], _Z2 = Float32Array.from(e.bg(_w20.canonical, _t558, _W2, _k6.worldSize / _k6._pixelsPerMercatorPixel));
                } else _N = u instanceof e.bo ? u.perspectiveTransform : [0, 0], _G2 = new Float32Array(16), _j2 = new Float32Array(9), _V2 = new Float32Array(16), _$2 = [0, 0], _Z2 = new Float32Array(9);
                var _H = eo(_D4, _G2, _j2, _V2, _Z2, _B3 || [0, 0], e.a2(t.transform.zoom), _$2, _U2, _F3 || 1, _O3, o, _N, l ? o.paint.get("raster-elevation") : 0, 2, _S14, _I11, d.range, _L5, _P8, p),
                  _q = t.isTileAffectedByFog(_w20),
                  _X = t.getOrCreateProgram("raster", {
                    defines: d.defines,
                    overrideFog: _q
                  });
                if (t.uploadCommonUniforms(h, _X, _r410), u instanceof e.bo) {
                  var _i381 = u.elevatedGlobeVertexBuffer,
                    _r411 = u.elevatedGlobeIndexBuffer;
                  if (m || !s) u.boundsBuffer && u.boundsSegments && _X.draw(t, _.TRIANGLES, _R4, e.ah.disabled, f, e.ag.disabled, _H, o.id, u.boundsBuffer, t.quadTriangleIndexBuffer, u.boundsSegments);else if (_i381 && _r411) {
                    var _n286 = _k6.zoom <= e.b3 ? u.elevatedGlobeSegments : u.getSegmentsForLongitude(_k6.center.lng);
                    _n286 && _X.draw(t, _.TRIANGLES, _R4, e.ah.disabled, f, a, _H, o.id, _i381, _r411, _n286);
                  }
                } else if (c) {
                  _R4 = new e.af(_.LEQUAL, e.af.ReadOnly, t.depthRangeFor3D);
                  var _i382 = t.globeSharedBuffers;
                  if (_i382) {
                    var _i382$getGridBuffers = _i382.getGridBuffers(_W2, !1),
                      _i382$getGridBuffers2 = _slicedToArray(_i382$getGridBuffers, 3),
                      _e555 = _i382$getGridBuffers2[0],
                      _r412 = _i382$getGridBuffers2[1],
                      _n287 = _i382$getGridBuffers2[2];
                    _X.draw(t, _.TRIANGLES, _R4, y || _A13, t.colorModeForRenderPass(), a, _H, o.id, _e555, _r412, _n287);
                  }
                } else {
                  var _t$getTileBoundsBuffe2 = t.getTileBoundsBuffers(_T11),
                    _i383 = _t$getTileBoundsBuffe2.tileBoundsBuffer,
                    _r413 = _t$getTileBoundsBuffe2.tileBoundsIndexBuffer,
                    _a211 = _t$getTileBoundsBuffe2.tileBoundsSegments;
                  _X.draw(t, _.TRIANGLES, _R4, _A13, f, e.ag.disabled, _H, o.id, _i383, _r413, _a211);
                }
              }
            } catch (err) {
              _iterator382.e(err);
            } finally {
              _iterator382.f();
            }
            if (!(u instanceof e.bo) && c) {
              var _iterator383 = _createForOfIteratorHelper(r),
                _step383;
              try {
                for (_iterator383.s(); !(_step383 = _iterator383.n()).done;) {
                  var _n285 = _step383.value;
                  var _r409 = _n285.canonical.y === (1 << _n285.canonical.z) - 1;
                  0 === _n285.canonical.y && Bo(!0, _n285, t, i, o, p, d, a, y || e.ah.disabled), _r409 && Bo(!1, _n285, t, i, o, p, d, a === e.ag.frontCW ? e.ag.backCW : e.ag.frontCW, y || e.ah.disabled);
                }
              } catch (err) {
                _iterator383.e(err);
              } finally {
                _iterator383.f();
              }
            }
          };
          c ? w(y, t.renderElevatedRasterBackface ? e.ag.backCW : e.ag.frontCW, t.stencilModeFor3D()) : w(y, e.ag.disabled, void 0), t.resetStencilClippingMasks();
        },
        "raster-particle": function rasterParticle(t, i, o, r, a, n) {
          "offscreen" === t.renderPass && function (t, i, o, r) {
            if (!r.length) return;
            var a = t.context,
              n = a.gl,
              s = i.getSource();
            if (!(s instanceof Li)) return;
            var l = Math.ceil(Math.sqrt(o.paint.get("raster-particle-count")));
            var c = o.particlePositionRGBAImage;
            if (!c || c.width !== l) {
              var _t559 = function (e) {
                var t = e * e,
                  i = new Uint8Array(4 * t),
                  o = function o(e) {
                    return e |= 0, e = Math.imul(2747636419 ^ e, 2654435769), e = Math.imul(e ^ e >>> 16, 2654435769), ((e = Math.imul(e ^ e >>> 16, 2654435769)) >>> 0) / 4294967296;
                  },
                  r = 1 / 1.1;
                for (var _e556 = 0; _e556 < t; _e556++) {
                  var _t560 = r * (o(2 * _e556 + 0) + io),
                    _a212 = r * (o(2 * _e556 + 1) + io),
                    _n288 = 255 * _t560 % 1,
                    _s239 = 255 * _a212 % 1,
                    _l122 = _n288,
                    _c101 = _a212 - _s239 / 255,
                    _h76 = _s239;
                  i[4 * _e556 + 0] = 255 * (_t560 - _n288 / 255), i[4 * _e556 + 1] = 255 * _l122, i[4 * _e556 + 2] = 255 * _c101, i[4 * _e556 + 3] = 255 * _h76;
                }
                return i;
              }(l);
              c = o.particlePositionRGBAImage = new e.j({
                width: l,
                height: l
              }, _t559);
            }
            var h = o.particleFramebuffer;
            h ? h.width !== l && (h.destroy(), h = o.particleFramebuffer = a.createFramebuffer(l, l, !0, null)) : h = o.particleFramebuffer = a.createFramebuffer(l, l, !0, null);
            var _ = [];
            var _iterator384 = _createForOfIteratorHelper(r),
              _step384;
            try {
              for (_iterator384.s(); !(_step384 = _iterator384.n()).done;) {
                var _t562 = _step384.value;
                var _r416 = i.getTile(_t562);
                if (!(_r416 instanceof e.c5)) continue;
                var _n289 = Uo(_r416, s, o);
                if (!_n289) continue;
                var _h80 = [_r416.tileSize, _r416.tileSize];
                var _u99 = o.tileFramebuffer;
                _u99 || (_u99 = o.tileFramebuffer = a.createFramebuffer(_h80[0], _h80[1], !0, null));
                var _d45 = _r416.rasterParticleState;
                _d45 || (_d45 = _r416.rasterParticleState = new ae(a, _t562, _h80, c));
                var _p64 = _d45.update(o.lastInvalidatedAt);
                _d45.particleTextureDimension !== l && _d45.updateParticleTexture(_t562, c);
                var _f54 = _d45.targetColorTexture;
                _d45.targetColorTexture = _d45.backgroundColorTexture, _d45.backgroundColorTexture = _f54;
                var _m37 = _d45.particleTexture0;
                _d45.particleTexture0 = _d45.particleTexture1, _d45.particleTexture1 = _m37, _.push([_t562, _n289, _d45, _p64]);
              }
            } catch (err) {
              _iterator384.e(err);
            } finally {
              _iterator384.f();
            }
            if (0 === _.length) return;
            var u = e.e.now(),
              d = o.previousDrawTimestamp ? .001 * (u - o.previousDrawTimestamp) : .0167;
            if (o.previousDrawTimestamp = u, o.hasColorMap()) {
              a.activeTexture.set(n.TEXTURE0 + 2);
              var _t561 = o.colorRampTexture;
              _t561 || (_t561 = o.colorRampTexture = new e.T(a, o.colorRamp, n.RGBA)), _t561.bind(n.LINEAR, n.CLAMP_TO_EDGE);
            }
            a.bindFramebuffer.set(o.tileFramebuffer.framebuffer), function (t, i, o) {
              var r = t.context,
                a = r.gl,
                n = i.tileFramebuffer;
              r.activeTexture.set(a.TEXTURE0);
              var s = {
                  u_texture: 0,
                  u_opacity: 1.05 * (c = i.paint.get("raster-particle-fade-opacity-factor")) / (c + .05)
                },
                l = t.getOrCreateProgram("rasterParticleTexture", {
                  defines: [],
                  overrideFog: !1
                });
              var c;
              var _iterator385 = _createForOfIteratorHelper(o),
                _step385;
              try {
                for (_iterator385.s(); !(_step385 = _iterator385.n()).done;) {
                  var _c102 = _step385.value;
                  var _c103 = _slicedToArray(_c102, 4),
                    _o209 = _c103[2],
                    _h77 = _c103[3];
                  n.colorAttachment.set(_o209.targetColorTexture.texture), r.viewport.set([0, 0, n.width, n.height]), r.clear({
                    color: e.C.transparent
                  }), _h77 && (_o209.backgroundColorTexture.bind(a.NEAREST, a.CLAMP_TO_EDGE), l.draw(t, a.TRIANGLES, e.af.disabled, e.ah.disabled, e.a.alphaBlended, e.ag.disabled, s, i.id, t.viewportBuffer, t.quadTriangleIndexBuffer, t.viewportSegments));
                }
              } catch (err) {
                _iterator385.e(err);
              } finally {
                _iterator385.f();
              }
            }(t, o, _), function (t, i, o, r) {
              var a = t.context,
                n = a.gl,
                s = o.tileFramebuffer,
                l = "globe" === t.transform.projection.name,
                c = o.paint.get("raster-particle-max-speed");
              var _iterator386 = _createForOfIteratorHelper(r),
                _step386;
              try {
                var _loop20 = function _loop20() {
                  var h = _step386.value;
                  var _h78 = _slicedToArray(h, 3),
                    r = _h78[0],
                    _ = _h78[1],
                    u = _h78[2];
                  a.activeTexture.set(n.TEXTURE0 + 0), _.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE), s.colorAttachment.set(u.targetColorTexture.texture);
                  var d = t.getOrCreateProgram("rasterParticleDraw", {
                    defines: _.defines,
                    overrideFog: !1
                  });
                  a.activeTexture.set(n.TEXTURE0 + 1);
                  var p = _.scalarData ? [] : [0, 1, 2, 3].map(function (t) {
                    return e.b$[t](r);
                  });
                  p.push(r);
                  var f = r.canonical.x,
                    m = r.canonical.y;
                  var _iterator387 = _createForOfIteratorHelper(p),
                    _step387;
                  try {
                    for (_iterator387.s(); !(_step387 = _iterator387.n()).done;) {
                      var _a213 = _step387.value;
                      var _s240 = i.getTile(l ? _a213.wrapped() : _a213);
                      if (!_s240) continue;
                      var _h79 = _s240.rasterParticleState;
                      if (!_h79) continue;
                      var _u97 = _a213.canonical.x + (1 << _a213.canonical.z) * (_a213.wrap - r.wrap),
                        _p63 = _a213.canonical.y;
                      _h79.particleTexture0.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                      var _g31 = ro(1, _h79.particleTexture0.size[0], [_u97 - f, _p63 - m], 0, _.texture.size, 2, c, _.textureOffset, _.scale, _.offset);
                      d.draw(t, n.POINTS, e.af.disabled, e.ah.disabled, e.a.alphaBlended, e.ag.disabled, _g31, o.id, _h79.particleIndexBuffer, void 0, _h79.particleSegment);
                    }
                  } catch (err) {
                    _iterator387.e(err);
                  } finally {
                    _iterator387.f();
                  }
                };
                for (_iterator386.s(); !(_step386 = _iterator386.n()).done;) {
                  _loop20();
                }
              } catch (err) {
                _iterator386.e(err);
              } finally {
                _iterator386.f();
              }
            }(t, i, o, _), a.bindFramebuffer.set(o.particleFramebuffer.framebuffer), function (t, i, o, r) {
              var a = t.context,
                n = a.gl,
                s = i.paint.get("raster-particle-max-speed"),
                l = r * i.paint.get("raster-particle-speed-factor") * .15,
                c = function (e) {
                  return Math.pow(e, 6);
                }(.01 + 1 * i.paint.get("raster-particle-reset-rate-factor")),
                h = i.particleFramebuffer;
              a.viewport.set([0, 0, h.width, h.height]);
              var _iterator388 = _createForOfIteratorHelper(o),
                _step388;
              try {
                for (_iterator388.s(); !(_step388 = _iterator388.n()).done;) {
                  var _r414 = _step388.value;
                  var _r415 = _slicedToArray(_r414, 3),
                    _o210 = _r415[1],
                    _30 = _r415[2];
                  a.activeTexture.set(n.TEXTURE0 + 0), _o210.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE), a.activeTexture.set(n.TEXTURE0 + 1);
                  var _u98 = _30.particleTexture0;
                  _u98.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                  var _d44 = ao(1, _u98.size[0], 0, _o210.texture.size, s, l, c, _o210.textureOffset, _o210.scale, _o210.offset);
                  h.colorAttachment.set(_30.particleTexture1.texture), a.clear({
                    color: e.C.transparent
                  }), t.getOrCreateProgram("rasterParticleUpdate", {
                    defines: _o210.defines
                  }).draw(t, n.TRIANGLES, e.af.disabled, e.ah.disabled, e.a.unblended, e.ag.disabled, _d44, i.id, t.viewportBuffer, t.quadTriangleIndexBuffer, t.viewportSegments);
                }
              } catch (err) {
                _iterator388.e(err);
              } finally {
                _iterator388.f();
              }
            }(t, o, _, d);
          }(t, i, o, r), "translucent" === t.renderPass && (function (t, i, o, r, a) {
            var n = t.context,
              s = n.gl,
              l = i.getSource().tileSize,
              c = 5 * (1 - e.a0(e.aV, e.aV + 1, t.transform.zoom)) * l + o.paint.get("raster-particle-elevation"),
              h = !t.options.moving,
              _ = "globe" === t.transform.projection.name;
            if (!r.length) return;
            var _t$stencilConfigForOv = t.stencilConfigForOverlap(r),
              _t$stencilConfigForOv2 = _slicedToArray(_t$stencilConfigForOv, 2),
              u = _t$stencilConfigForOv2[0],
              d = _t$stencilConfigForOv2[1],
              p = [];
            _ && p.push("PROJECTION_GLOBE_VIEW");
            var f = t.stencilModeFor3D();
            var _iterator389 = _createForOfIteratorHelper(d),
              _step389;
            try {
              for (_iterator389.s(); !(_step389 = _iterator389.n()).done;) {
                var _r417 = _step389.value;
                var _a214 = _r417.toUnwrapped(),
                  _l123 = i.getTile(_r417);
                if (!_l123.rasterParticleState) continue;
                var _d46 = _l123.rasterParticleState,
                  _m38 = 100;
                _l123.registerFadeDuration(_m38);
                var _g32 = i.findLoadedParent(_r417, 0),
                  _v24 = Ii(_l123, _g32, i, t.transform, _m38);
                var _x27 = void 0,
                  _y62 = void 0;
                t.terrain && t.terrain.prepareDrawTile(), n.activeTexture.set(s.TEXTURE0), _d46.targetColorTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE), n.activeTexture.set(s.TEXTURE1), _g32 && _g32.rasterParticleState ? (_g32.rasterParticleState.targetColorTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE), _x27 = Math.pow(2, _g32.tileID.overscaledZ - _l123.tileID.overscaledZ), _y62 = [_l123.tileID.canonical.x * _x27 % 1, _l123.tileID.canonical.y * _x27 % 1]) : _d46.targetColorTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                var _b21 = _ ? Float32Array.from(t.transform.expandedFarZProjMatrix) : t.transform.calculateProjMatrix(_a214, h),
                  _w21 = t.transform,
                  _T12 = Go(_w21),
                  _E9 = e.be(_r417.canonical),
                  _C7 = e.bf(_E9.getCenter().lat);
                var _S15 = void 0,
                  _I12 = void 0,
                  _L6 = void 0,
                  _P9 = void 0,
                  _R5 = void 0;
                _ ? (_S15 = Float32Array.from(e.bh(e.bi(_r417.canonical))), _I12 = Float32Array.from(_w21.globeMatrix), _L6 = Float32Array.from(e.bd(_w21)), _P9 = [e.ak(_w21.center.lng), e.al(_w21.center.lat)], _R5 = Float32Array.from(e.bg(_r417.canonical, _E9, _C7, _w21.worldSize / _w21._pixelsPerMercatorPixel))) : (_S15 = new Float32Array(16), _I12 = new Float32Array(9), _L6 = new Float32Array(16), _P9 = [0, 0], _R5 = new Float32Array(9));
                var _D5 = oo(_b21, _S15, _I12, _L6, _R5, _y62 || [0, 0], e.a2(t.transform.zoom), _P9, _T12, _x27 || 1, _v24, c),
                  _A14 = t.isTileAffectedByFog(_r417),
                  _M14 = t.getOrCreateProgram("rasterParticle", {
                    defines: p,
                    overrideFog: _A14
                  });
                if (t.uploadCommonUniforms(n, _M14, _a214), _) {
                  var _i384 = new e.af(s.LEQUAL, e.af.ReadOnly, t.depthRangeFor3D),
                    _r418 = 0,
                    _a215 = t.globeSharedBuffers;
                  if (_a215) {
                    var _a215$getGridBuffers = _a215.getGridBuffers(_C7, 0 !== _r418),
                      _a215$getGridBuffers2 = _slicedToArray(_a215$getGridBuffers, 3),
                      _n290 = _a215$getGridBuffers2[0],
                      _l124 = _a215$getGridBuffers2[1],
                      _c104 = _a215$getGridBuffers2[2];
                    _M14.draw(t, s.TRIANGLES, _i384, f, e.a.alphaBlended, t.renderElevatedRasterBackface ? e.ag.frontCCW : e.ag.backCCW, _D5, o.id, _n290, _l124, _c104);
                  }
                } else {
                  var _i385 = t.depthModeForSublayer(0, e.af.ReadOnly),
                    _a216 = u[_r417.overscaledZ],
                    _t$getTileBoundsBuffe3 = t.getTileBoundsBuffers(_l123),
                    _n291 = _t$getTileBoundsBuffe3.tileBoundsBuffer,
                    _c105 = _t$getTileBoundsBuffe3.tileBoundsIndexBuffer,
                    _h81 = _t$getTileBoundsBuffe3.tileBoundsSegments;
                  _M14.draw(t, s.TRIANGLES, _i385, _a216, e.a.alphaBlended, e.ag.disabled, _D5, o.id, _n291, _c105, _h81);
                }
              }
            } catch (err) {
              _iterator389.e(err);
            } finally {
              _iterator389.f();
            }
            t.resetStencilClippingMasks();
          }(t, i, o, r), t.style.map.triggerRepaint());
        },
        background: function background(t, i, o, r) {
          var a = o.paint.get("background-color"),
            n = o.paint.get("background-opacity"),
            s = o.paint.get("background-emissive-strength");
          if (0 === n) return;
          var l = t.context,
            c = l.gl,
            h = t.transform,
            _ = h.tileSize,
            u = o.paint.get("background-pattern");
          var d;
          if (void 0 !== u) {
            if (null === u) return;
            if (d = t.imageManager.getPattern(u.toString(), o.scope, t.style.getLut(o.scope)), !d) return;
          }
          var p = !u && 1 === a.a && 1 === n && t.opaquePassEnabledForLayer() ? "opaque" : "translucent";
          if (t.renderPass !== p) return;
          var f = e.ah.disabled,
            m = t.depthModeForSublayer(0, "opaque" === p ? e.af.ReadWrite : e.af.ReadOnly),
            g = t.colorModeForDrapableLayerRenderPass(s),
            v = u ? "backgroundPattern" : "background";
          var x,
            y = r;
          y || (x = t.getBackgroundTiles(), y = Object.values(x).map(function (e) {
            return e.tileID;
          })), u && (l.activeTexture.set(c.TEXTURE0), t.imageManager.bind(t.context, o.scope));
          var _iterator390 = _createForOfIteratorHelper(y),
            _step390;
          try {
            for (_iterator390.s(); !(_step390 = _iterator390.n()).done;) {
              var _p65 = _step390.value;
              var _y63 = t.isTileAffectedByFog(_p65),
                _b22 = t.getOrCreateProgram(v, {
                  overrideFog: _y63
                }),
                _w22 = _p65.toUnwrapped(),
                _T13 = r ? _p65.projMatrix : t.transform.calculateProjMatrix(_w22);
              t.prepareDrawTile();
              var _E10 = i ? i.getTile(_p65) : x ? x[_p65.key] : new e.bA(_p65, _, h.zoom, t),
                _C8 = u ? _o(_T13, s, n, t, 0, o.scope, d, {
                  tileID: _p65,
                  tileSize: _
                }) : ho(_T13, s, n, a.toRenderColor(o.lut));
              t.uploadCommonUniforms(l, _b22, _w22);
              var _t$getTileBoundsBuffe4 = t.getTileBoundsBuffers(_E10),
                _S16 = _t$getTileBoundsBuffe4.tileBoundsBuffer,
                _I13 = _t$getTileBoundsBuffe4.tileBoundsIndexBuffer,
                _L7 = _t$getTileBoundsBuffe4.tileBoundsSegments;
              _b22.draw(t, c.TRIANGLES, m, f, g, e.ag.disabled, _C8, o.id, _S16, _I13, _L7);
            }
          } catch (err) {
            _iterator390.e(err);
          } finally {
            _iterator390.f();
          }
        },
        sky: function sky(t, i, o) {
          var r = t._atmosphere ? e.a2(t.transform.zoom) : 1,
            a = o.paint.get("sky-opacity") * r;
          if (0 === a) return;
          var n = t.context,
            s = o.paint.get("sky-type"),
            l = new e.af(n.gl.LEQUAL, e.af.ReadOnly, [0, 1]),
            c = t.frameCounter / 1e3 % 1;
          "atmosphere" === s ? "offscreen" === t.renderPass ? o.needsSkyboxCapture(t) && (function (t, i, o, r) {
            var a = t.context,
              n = a.gl;
            var s = i.skyboxFbo;
            if (!s) {
              s = i.skyboxFbo = a.createFramebuffer(32, 32, !0, null), i.skyboxGeometry = new er(a), i.skyboxTexture = a.gl.createTexture(), n.bindTexture(n.TEXTURE_CUBE_MAP, i.skyboxTexture), n.texParameteri(n.TEXTURE_CUBE_MAP, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_CUBE_MAP, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_CUBE_MAP, n.TEXTURE_MIN_FILTER, n.LINEAR), n.texParameteri(n.TEXTURE_CUBE_MAP, n.TEXTURE_MAG_FILTER, n.LINEAR);
              for (var _e557 = 0; _e557 < 6; ++_e557) n.texImage2D(n.TEXTURE_CUBE_MAP_POSITIVE_X + _e557, 0, n.RGBA, 32, 32, 0, n.RGBA, n.UNSIGNED_BYTE, null);
            }
            a.bindFramebuffer.set(s.framebuffer), a.viewport.set([0, 0, 32, 32]);
            var l = i.getCenter(t, !0),
              c = t.getOrCreateProgram("skyboxCapture"),
              h = new Float64Array(16);
            e.ae.identity(h), e.ae.rotateY(h, h, .5 * -Math.PI), tr(t, i, c, h, l, 0), e.ae.identity(h), e.ae.rotateY(h, h, .5 * Math.PI), tr(t, i, c, h, l, 1), e.ae.identity(h), e.ae.rotateX(h, h, .5 * -Math.PI), tr(t, i, c, h, l, 2), e.ae.identity(h), e.ae.rotateX(h, h, .5 * Math.PI), tr(t, i, c, h, l, 3), e.ae.identity(h), tr(t, i, c, h, l, 4), e.ae.identity(h), e.ae.rotateY(h, h, Math.PI), tr(t, i, c, h, l, 5), a.viewport.set([0, 0, t.width, t.height]);
          }(t, o), o.markSkyboxValid(t)) : "sky" === t.renderPass && function (t, i, o, r, a) {
            var n = t.context,
              s = n.gl,
              l = t.transform,
              c = t.getOrCreateProgram("skybox");
            n.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_CUBE_MAP, i.skyboxTexture);
            var h = function (e, t, i, o, r) {
              return {
                u_matrix: e,
                u_sun_direction: t,
                u_cubemap: 0,
                u_opacity: o,
                u_temporal_offset: r
              };
            }(l.skyboxMatrix, i.getCenter(t, !1), 0, r, a);
            t.uploadCommonUniforms(n, c), c.draw(t, s.TRIANGLES, o, e.ah.disabled, t.colorModeForRenderPass(), e.ag.backCW, h, "skybox", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
          }(t, o, l, a, c) : "gradient" === s && "sky" === t.renderPass && function (t, i, o, r, a) {
            var n = t.context,
              s = n.gl,
              l = t.transform,
              c = t.getOrCreateProgram("skyboxGradient");
            i.skyboxGeometry || (i.skyboxGeometry = new er(n)), n.activeTexture.set(s.TEXTURE0);
            var h = i.colorRampTexture;
            h || (h = i.colorRampTexture = new e.T(n, i.colorRamp, s.RGBA)), h.bind(s.LINEAR, s.CLAMP_TO_EDGE);
            var _ = function (t, i, o, r, a) {
              return {
                u_matrix: t,
                u_color_ramp: 0,
                u_center_direction: i,
                u_radius: e.ac(o),
                u_opacity: r,
                u_temporal_offset: a
              };
            }(l.skyboxMatrix, i.getCenter(t, !1), i.paint.get("sky-gradient-radius"), r, a);
            t.uploadCommonUniforms(n, c), c.draw(t, s.TRIANGLES, o, e.ah.disabled, t.colorModeForRenderPass(), e.ag.backCW, _, "skyboxGradient", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
          }(t, o, l, a, c);
        },
        debug: function debug(t, i, o, r, a, n) {
          for (var _s241 = 0; _s241 < o.length; _s241++) if (a) {
            var _a217 = 1,
              _l125 = .8,
              _c106 = new e.C(r.r * _l125, r.g * _l125, r.b * _l125, 1);
            Ho(t, i, o[_s241], r, -_a217, -_a217, n), Ho(t, i, o[_s241], r, -_a217, _a217, n), Ho(t, i, o[_s241], r, _a217, _a217, n), Ho(t, i, o[_s241], r, _a217, -_a217, n), Ho(t, i, o[_s241], _c106, 0, 0, n);
          } else Ho(t, i, o[_s241], r, 0, 0, n);
        },
        custom: function custom(t, i, o, r) {
          var a = t.context,
            n = o.implementation;
          if (!t.transform.projection.unsupportedLayers || !t.transform.projection.unsupportedLayers.includes("custom") || t.terrain && (t.terrain.renderingToTexture || "offscreen" === t.renderPass) && o.isDraped(i)) {
            if ("offscreen" === t.renderPass) {
              var _i386 = n.prerender;
              if (_i386) {
                if (t.setCustomLayerDefaults(), a.setColorMode(t.colorModeForRenderPass()), "globe" === t.transform.projection.name) {
                  var _o211 = t.transform.pointMerc;
                  _i386.call(n, a.gl, t.transform.customLayerMatrix(), t.transform.getProjection(), t.transform.globeToMercatorMatrix(), e.a2(t.transform.zoom), [_o211.x, _o211.y], t.transform.pixelsPerMeterRatio);
                } else _i386.call(n, a.gl, t.transform.customLayerMatrix());
                a.setDirty(), t.setBaseState();
              }
            } else if ("translucent" === t.renderPass) {
              if (t.terrain && t.terrain.renderingToTexture) {
                var _i387 = n.renderToTile;
                if (_i387) {
                  var _o212 = r[0].canonical,
                    _s242 = new e._(_o212.x + r[0].wrap * (1 << _o212.z), _o212.y, _o212.z);
                  a.setDepthMode(e.af.disabled), a.setStencilMode(e.ah.disabled), a.setColorMode(t.colorModeForRenderPass()), t.setCustomLayerDefaults(), _i387.call(n, a.gl, _s242), a.setDirty(), t.setBaseState();
                }
                return;
              }
              t.setCustomLayerDefaults(), a.setColorMode(t.colorModeForRenderPass()), a.setStencilMode(e.ah.disabled);
              var _i388 = "3d" === n.renderingMode ? new e.af(t.context.gl.LEQUAL, e.af.ReadWrite, t.depthRangeFor3D) : t.depthModeForSublayer(0, e.af.ReadOnly);
              if (a.setDepthMode(_i388), "globe" === t.transform.projection.name) {
                var _i389 = t.transform.pointMerc;
                n.render(a.gl, t.transform.customLayerMatrix(), t.transform.getProjection(), t.transform.globeToMercatorMatrix(), e.a2(t.transform.zoom), [_i389.x, _i389.y], t.transform.pixelsPerMeterRatio);
              } else n.render(a.gl, t.transform.customLayerMatrix());
              a.setDirty(), t.setBaseState(), a.bindFramebuffer.set(null);
            }
          } else e.w("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
        },
        model: function model(t, i, o, r) {
          if ("opaque" === t.renderPass) return;
          var a = o.paint.get("model-opacity");
          if (0 === a) return;
          var n = o.paint.get("model-cast-shadows");
          if ("shadow" === t.renderPass) {
            if (!n) return;
            if (t.terrain && a < .65 && o._transitionablePaint._values["model-opacity"].value.expression instanceof e.Z) return;
          }
          var s = t.shadowRenderer,
            l = o.paint.get("model-receive-shadows");
          s && (s.useNormalOffset = !0, l || (s.enabled = !1));
          var c = function c() {
              s && (s.useNormalOffset = !0, l || (s.enabled = !0));
            },
            h = i.getSource();
          if ("light-beam" === t.renderPass && "batched-model" !== h.type) return;
          if ("vector" === h.type || "geojson" === h.type) return function (t, i, o, r, a) {
            var n = t.transform;
            if ("mercator" !== n.projection.name) return void e.w("Drawing 3D models for ".concat(n.projection.name, " projection is not yet implemented"));
            var s = n.getFreeCameraOptions().position;
            if (!t.modelManager) return;
            var l = t.modelManager;
            o.modelManager = l;
            var c = t.shadowRenderer;
            if (!o._unevaluatedLayout._values.hasOwnProperty("model-id")) return;
            var h = o._unevaluatedLayout._values["model-id"],
              _ = _objectSpread({}, o.layout.get("model-id").parameters),
              u = t.style.order.indexOf(o.fqid);
            var _iterator391 = _createForOfIteratorHelper(r),
              _step391;
            try {
              for (_iterator391.s(); !(_step391 = _iterator391.n()).done;) {
                var _d47 = _step391.value;
                var _r419 = i.getTile(_d47).getBucket(o);
                if (!_r419 || _r419.projection.name !== n.projection.name) continue;
                var _p66 = _r419.getModelUris();
                _p66 && !_r419.modelsRequested && (l.addModelsFromBucket(_p66, a), _r419.modelsRequested = !0);
                var _f55 = pr(_d47, n);
                _.zoom = _f55;
                var _m39 = h.possiblyEvaluate(_);
                if (ur(t, _r419, _d47), dr.shadowUniformsInitialized = !1, dr.useSingleShadowCascade = !!c && 0 === c.getMaxCascadeForTile(_d47.toUnwrapped()), "shadow" === t.renderPass && c) {
                  if (1 === t.currentShadowCascade && _r419.isInsideFirstShadowMapFrustum) continue;
                  var _i390 = n.calculatePosMatrix(_d47.toUnwrapped(), n.worldSize);
                  if (dr.tileMatrix.set(_i390), dr.shadowTileMatrix = Float32Array.from(c.calculateShadowPassMatrixFromMatrix(_i390)), dr.aabb.min.fill(0), dr.aabb.max[0] = dr.aabb.max[1] = e.a4, dr.aabb.max[2] = 0, gr(_r419, dr, t, o.scope)) continue;
                }
                var _g33 = 1 << _d47.canonical.z,
                  _v25 = [((s.x - _d47.wrap) * _g33 - _d47.canonical.x) * e.a4, (s.y * _g33 - _d47.canonical.y) * e.a4, s.z * _g33 * e.a4];
                t.conflationActive && Object.keys(_r419.instancesPerModel).length > 0 && t.style.isLayerClipped(o, i.getSource()) && _r419.updateReplacement(_d47, t.replacementSource, u, a) && (_r419.uploaded = !1, _r419.upload(t.context));
                for (var _e558 in _r419.instancesPerModel) {
                  var _i391 = _r419.instancesPerModel[_e558];
                  _i391.features.length > 0 && (_e558 = _m39.evaluate(_i391.features[0].feature, {}));
                  var _n292 = l.getModel(_e558, a);
                  if (_n292 && _n292.uploaded) {
                    var _iterator392 = _createForOfIteratorHelper(_n292.nodes),
                      _step392;
                    try {
                      for (_iterator392.s(); !(_step392 = _iterator392.n()).done;) {
                        var _e559 = _step392.value;
                        fr(t, o, _e559, _i391, _v25, _d47, dr);
                      }
                    } catch (err) {
                      _iterator392.e(err);
                    } finally {
                      _iterator392.f();
                    }
                  }
                }
              }
            } catch (err) {
              _iterator391.e(err);
            } finally {
              _iterator391.f();
            }
          }(t, i, o, r, "vector" === h.type ? o.scope : ""), void c();
          if (!h.loaded()) return;
          if ("batched-model" === h.type) return function (t, i, o, r) {
            o.resetLayerRenderingStats(t);
            var a = t.context,
              n = t.transform,
              s = t.style.fog,
              l = t.shadowRenderer;
            if ("mercator" !== n.projection.name) return void e.w("Drawing 3D landmark models for ".concat(n.projection.name, " projection is not yet implemented"));
            var c = t.transform.getFreeCameraOptions().position,
              h = e.$.scale([], [c.x, c.y, c.z], t.transform.worldSize);
            e.$.negate(h, h);
            var _ = e.ae.identity([]),
              u = e.ci(n.center.lat, n.zoom),
              d = e.ae.fromScaling([], [1, 1, 1 / u]);
            e.ae.translate(_, _, h);
            var p = o.paint.get("model-opacity"),
              f = new e.af(a.gl.LEQUAL, e.af.ReadWrite, t.depthRangeFor3D),
              m = new e.af(a.gl.LEQUAL, e.af.ReadOnly, t.depthRangeFor3D),
              g = new e.b8([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]),
              v = "shadow" === t.renderPass,
              x = v && l ? l.getCurrentCascadeFrustum() : n.getFrustum(n.scaleZoom(n.worldSize)),
              y = o.paint.get("model-front-cutoff"),
              b = y[2] < 1,
              w = ui(t, o.paint.get("model-cutoff-fade-range")),
              T = o.getLayerRenderingStats();
            (function (e, t, i, o) {
              var r = e.terrain ? e.terrain.exaggeration() : 0,
                a = e.transform.zoom;
              var _iterator393 = _createForOfIteratorHelper(o),
                _step393;
              try {
                for (_iterator393.s(); !(_step393 = _iterator393.n()).done;) {
                  var _n293 = _step393.value;
                  var _o213 = t.getTile(_n293).getBucket(i);
                  _o213 && (e.conflationActive && _o213.updateReplacement(_n293, e.replacementSource), _o213.evaluateScale(e, i), e.terrain && r > 0 && _o213.elevationUpdate(e.terrain, r, _n293, i.source), _o213.needsReEvaluation(e, a, i) && _o213.evaluate(i));
                }
              } catch (err) {
                _iterator393.e(err);
              } finally {
                _iterator393.f();
              }
            })(t, i, o, r), function () {
              var c, h, u;
              b ? (c = r.length - 1, h = -1, u = -1) : (c = 0, h = r.length, u = 1);
              var _loop21 = function _loop21() {
                var c = r[_E11],
                  h = i.getTile(c).getBucket(o);
                if (!h || !h.uploaded) return 1; // continue
                var u = !1;
                l && (u = 0 === l.getMaxCascadeForTile(c.toUnwrapped()));
                var C = n.calculatePosMatrix(c.toUnwrapped(), n.worldSize),
                  S = h.modelTraits,
                  I = [];
                var _iterator394 = _createForOfIteratorHelper(h.getNodesInfo()),
                  _step394;
                try {
                  var _loop22 = function _loop22() {
                      var i = _step394.value;
                      if (i.hiddenByReplacement) return 0; // continue
                      if (!i.node.meshes) return 0; // continue
                      var o = i.node;
                      var r = 0;
                      t.terrain && o.elevation && (r = o.elevation * t.terrain.exaggeration());
                      var a = i.evaluatedScale;
                      if (a[0] <= 1 && a[1] <= 1 && a[2] <= 1 && 0 === function () {
                        var t = i.aabb;
                        return g.min = _toConsumableArray(t.min), g.max = _toConsumableArray(t.max), g.min[2] += r, g.max[2] += r, e.$.transformMat4(g.min, g.min, C), e.$.transformMat4(g.max, g.max, C), g;
                      }().intersects(x)) return 0; // continue
                      var s = _toConsumableArray(C),
                        l = o.anchor ? o.anchor[0] : 0,
                        c = o.anchor ? o.anchor[1] : 0;
                      e.ae.translate(s, s, [l * (a[0] - 1), c * (a[1] - 1), r]), e.$.exactEquals(a, e.cl) || e.ae.scale(s, s, a);
                      var h = e.ae.multiply([], s, o.matrix),
                        _ = e.ae.multiply([], n.expandedFarZProjMatrix, h),
                        u = e.ae.multiply([], n.expandedFarZProjMatrix, s),
                        d = e.aB.transformMat4([], [l, c, r, 1], _)[2];
                      o.hidden = !1;
                      var f = p;
                      v || (b && (f *= xr(s, n, i.aabb, y)), f *= vr(w, d)), 0 !== f ? I.push({
                        nodeInfo: i,
                        depth: d,
                        opacity: f,
                        wvpForNode: _,
                        wvpForTile: u,
                        nodeModelMatrix: h,
                        tileModelMatrix: s
                      }) : o.hidden = !0;
                    },
                    _ret7;
                  for (_iterator394.s(); !(_step394 = _iterator394.n()).done;) {
                    _ret7 = _loop22();
                    if (_ret7 === 0) continue;
                  }
                } catch (err) {
                  _iterator394.e(err);
                } finally {
                  _iterator394.f();
                }
                v || I.sort(function (e, t) {
                  return !b || 1 === e.opacity && 1 === t.opacity ? e.depth < t.depth ? -1 : 1 : 1 === e.opacity ? -1 : 1 === t.opacity ? 1 : e.depth > t.depth ? -1 : 1;
                });
                for (var _i392 = 0, _I14 = I; _i392 < _I14.length; _i392++) {
                  var _i393 = _I14[_i392];
                  var _r420 = _i393.nodeInfo,
                    _c107 = _r420.node;
                  var _h82 = e.ae.multiply([], d, _i393.tileModelMatrix);
                  e.ae.multiply(_h82, _, _h82);
                  var _p67 = e.ae.invert([], _h82);
                  e.ae.transpose(_p67, _p67), e.ae.scale(_p67, _p67, mr), _h82 = e.ae.multiply(_h82, _h82, _c107.matrix);
                  var _g34 = "light-beam" === t.renderPass,
                    _x28 = S & e.cn.HasMapboxMeshFeatures,
                    _y64 = _x28 ? 0 : _r420.evaluatedRMEA[0][2];
                  for (var _31 = 0; _31 < _c107.meshes.length; ++_31) {
                    var _d48 = _c107.meshes[_31],
                      _b23 = _31 === _c107.lightMeshIndex;
                    var _w23 = _i393.wvpForNode;
                    if (_b23) {
                      if (!_g34 && !t.terrain && t.shadowRenderer) {
                        t.currentLayer < t.firstLightBeamLayer && (t.firstLightBeamLayer = t.currentLayer);
                        continue;
                      }
                      _w23 = _i393.wvpForTile;
                    } else if (_g34) continue;
                    var _E12 = {
                        defines: []
                      },
                      _C9 = [];
                    if (lr(_E12.defines, _C9, _d48, t, o.lut), _x28 || _E12.defines.push("DIFFUSE_SHADED"), u && _E12.defines.push("SHADOWS_SINGLE_CASCADE"), T && (v ? T.numRenderedVerticesInShadowPass += _d48.vertexArray.length : T.numRenderedVerticesInTransparentPass += _d48.vertexArray.length), v) {
                      _r(_d48, _i393.nodeModelMatrix, t, o);
                      continue;
                    }
                    var _S17 = null;
                    if (s) {
                      var _e560 = sr(_i393.nodeModelMatrix, t.transform);
                      if (_S17 = new Float32Array(_e560), "globe" !== n.projection.name) {
                        var _t563 = _d48.aabb.min,
                          _i394 = _d48.aabb.max,
                          _s$getOpacityForBound = s.getOpacityForBounds(_e560, _t563[0], _t563[1], _i394[0], _i394[1]),
                          _s$getOpacityForBound2 = _slicedToArray(_s$getOpacityForBound, 2),
                          _o214 = _s$getOpacityForBound2[0],
                          _r421 = _s$getOpacityForBound2[1];
                        _E12.overrideFog = _o214 >= Ke || _r421 >= Ke;
                      }
                    }
                    var _I15 = _d48.material;
                    var _L8 = void 0;
                    _I15.occlusionTexture && _I15.occlusionTexture.offsetScale && (_L8 = _I15.occlusionTexture.offsetScale, _E12.defines.push("OCCLUSION_TEXTURE_TRANSFORM")), !v && l && (l.useNormalOffset = !!_d48.normalBuffer);
                    var _P10 = t.getOrCreateProgram("model", _E12);
                    !v && l && l.setupShadowsFromMatrix(_i393.tileModelMatrix, _P10, l.useNormalOffset), t.uploadCommonUniforms(a, _P10, null, _S17);
                    var _R6 = _I15.pbrMetallicRoughness;
                    _R6.metallicFactor = .9, _R6.roughnessFactor = .5;
                    var _D6 = po(new Float32Array(_w23), new Float32Array(_h82), new Float32Array(_p67), new Float32Array(_c107.matrix), t, _i393.opacity, _R6.baseColorFactor.toRenderColor(null), _I15.emissiveFactor, _R6.metallicFactor, _R6.roughnessFactor, _I15, _y64, o, [0, 0, 0], _L8);
                    !_b23 && (_r420.hasTranslucentParts || _i393.opacity < 1) && _P10.draw(t, a.gl.TRIANGLES, f, e.ah.disabled, e.a.disabled, e.ag.backCCW, _D6, o.id, _d48.vertexBuffer, _d48.indexBuffer, _d48.segments, o.paint, t.transform.zoom, void 0, _C9), _P10.draw(t, a.gl.TRIANGLES, _b23 ? m : f, e.ah.disabled, _b23 || _i393.opacity < 1 || _r420.hasTranslucentParts ? e.a.alphaBlended : e.a.unblended, e.ag.backCCW, _D6, o.id, _d48.vertexBuffer, _d48.indexBuffer, _d48.segments, o.paint, t.transform.zoom, void 0, _C9);
                  }
                }
              };
              for (var _E11 = c; _E11 !== h; _E11 += u) {
                if (_loop21()) continue;
              }
            }();
          }(t, i, o, r), void c();
          if ("model" !== h.type) return;
          var _ = h.getModels(),
            u = [],
            d = t.transform.getFreeCameraOptions().position,
            p = e.$.scale([], [d.x, d.y, d.z], t.transform.worldSize);
          e.$.negate(p, p);
          var f = [],
            m = [];
          var g = 0;
          var _iterator395 = _createForOfIteratorHelper(_),
            _step395;
          try {
            for (_iterator395.s(); !(_step395 = _iterator395.n()).done;) {
              var _i398 = _step395.value;
              var _r422 = o.paint.get("model-rotation").constantOr(null),
                _a218 = o.paint.get("model-scale").constantOr(null),
                _n294 = o.paint.get("model-translation").constantOr(null);
              _i398.computeModelMatrix(t, _r422, _a218, _n294, !0, !0, !1);
              var _s243 = e.ae.identity([]),
                _l126 = e.ci(_i398.position.lat, t.transform.zoom),
                _c108 = e.ae.fromScaling([], [1, 1, 1 / _l126]);
              e.ae.translate(_s243, _s243, p), u.push({
                zScaleMatrix: _c108,
                negCameraPosMatrix: _s243
              });
              var _iterator402 = _createForOfIteratorHelper(_i398.nodes),
                _step402;
              try {
                for (_iterator402.s(); !(_step402 = _iterator402.n()).done;) {
                  var _e564 = _step402.value;
                  hr(t.transform, _e564, _i398.matrix, t.transform.expandedFarZProjMatrix, g, f, m);
                }
              } catch (err) {
                _iterator402.e(err);
              } finally {
                _iterator402.f();
              }
              g++;
            }
          } catch (err) {
            _iterator395.e(err);
          } finally {
            _iterator395.f();
          }
          if (f.sort(function (e, t) {
            return t.depth - e.depth;
          }), "shadow" !== t.renderPass) {
            if (1 === a) {
              var _iterator396 = _createForOfIteratorHelper(m),
                _step396;
              try {
                for (_iterator396.s(); !(_step396 = _iterator396.n()).done;) {
                  var _i395 = _step396.value;
                  cr(_i395, t, o, u[_i395.modelIndex], e.ah.disabled, t.colorModeForRenderPass());
                }
              } catch (err) {
                _iterator396.e(err);
              } finally {
                _iterator396.f();
              }
            } else {
              var _iterator397 = _createForOfIteratorHelper(m),
                _step397;
              try {
                for (_iterator397.s(); !(_step397 = _iterator397.n()).done;) {
                  var _i396 = _step397.value;
                  cr(_i396, t, o, u[_i396.modelIndex], e.ah.disabled, e.a.disabled);
                }
              } catch (err) {
                _iterator397.e(err);
              } finally {
                _iterator397.f();
              }
              var _iterator398 = _createForOfIteratorHelper(m),
                _step398;
              try {
                for (_iterator398.s(); !(_step398 = _iterator398.n()).done;) {
                  var _e561 = _step398.value;
                  cr(_e561, t, o, u[_e561.modelIndex], t.stencilModeFor3D(), t.colorModeForRenderPass());
                }
              } catch (err) {
                _iterator398.e(err);
              } finally {
                _iterator398.f();
              }
              t.resetStencilClippingMasks();
            }
            var _iterator399 = _createForOfIteratorHelper(f),
              _step399;
            try {
              for (_iterator399.s(); !(_step399 = _iterator399.n()).done;) {
                var _i397 = _step399.value;
                cr(_i397, t, o, u[_i397.modelIndex], e.ah.disabled, t.colorModeForRenderPass());
              }
            } catch (err) {
              _iterator399.e(err);
            } finally {
              _iterator399.f();
            }
            c();
          } else {
            var _iterator400 = _createForOfIteratorHelper(m),
              _step400;
            try {
              for (_iterator400.s(); !(_step400 = _iterator400.n()).done;) {
                var _e562 = _step400.value;
                _r(_e562.mesh, _e562.nodeModelMatrix, t, o);
              }
            } catch (err) {
              _iterator400.e(err);
            } finally {
              _iterator400.f();
            }
            var _iterator401 = _createForOfIteratorHelper(f),
              _step401;
            try {
              for (_iterator401.s(); !(_step401 = _iterator401.n()).done;) {
                var _e563 = _step401.value;
                _r(_e563.mesh, _e563.nodeModelMatrix, t, o);
              }
            } catch (err) {
              _iterator401.e(err);
            } finally {
              _iterator401.f();
            }
            c();
          }
        }
      },
      Er = {
        model: function model(e, t, i) {
          var o = t.getSource();
          if (!o.loaded()) return;
          if ("vector" === o.type || "geojson" === o.type) return void (i.modelManager && i.modelManager.upload(i, "vector" === o.type ? e.scope : ""));
          if ("batched-model" === o.type) return;
          if ("model" !== o.type) return;
          var r = o.getModels();
          var _iterator403 = _createForOfIteratorHelper(r),
            _step403;
          try {
            for (_iterator403.s(); !(_step403 = _iterator403.n()).done;) {
              var _e565 = _step403.value;
              _e565.upload(i.context);
            }
          } catch (err) {
            _iterator403.e(err);
          } finally {
            _iterator403.f();
          }
        },
        raster: function raster(e, t, i) {
          var o = t.getSource();
          if (!(o instanceof Li && o.loaded())) return;
          var r = e.sourceLayer || o.rasterLayerIds && o.rasterLayerIds[0];
          if (!r) return;
          var a = e.paint.get("raster-array-band") || o.getInitialBand(r);
          if (null == a) return;
          var n = t.getIds().map(function (e) {
            return t.getTileByID(e);
          });
          var _iterator404 = _createForOfIteratorHelper(n),
            _step404;
          try {
            for (_iterator404.s(); !(_step404 = _iterator404.n()).done;) {
              var _e566 = _step404.value;
              _e566.updateNeeded(r, a) && o.prepareTile(_e566, r, a);
            }
          } catch (err) {
            _iterator404.e(err);
          } finally {
            _iterator404.f();
          }
        },
        "raster-particle": function rasterParticle(e, t, i) {
          var o = t.getSource();
          if (!(o instanceof Li && o.loaded())) return;
          var r = e.sourceLayer || o.rasterLayerIds && o.rasterLayerIds[0];
          if (!r) return;
          var a = e.paint.get("raster-particle-array-band") || o.getInitialBand(r);
          if (null == a) return;
          var n = t.getIds().map(function (e) {
            return t.getTileByID(e);
          });
          var _iterator405 = _createForOfIteratorHelper(n),
            _step405;
          try {
            for (_iterator405.s(); !(_step405 = _iterator405.n()).done;) {
              var _e567 = _step405.value;
              _e567.updateNeeded(r, a) && o.prepareTile(_e567, r, a);
            }
          } catch (err) {
            _iterator405.e(err);
          } finally {
            _iterator405.f();
          }
        }
      };
    var Cr = /*#__PURE__*/function () {
      function Cr(t, i, o, r) {
        var _this138 = this;
        _classCallCheck(this, Cr);
        this.context = new re(t, i), this.transform = o, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.tp = r, this._timeStamp = e.e.now(), this._averageFPS = 0, this._fpsHistory = [], this._dt = 0, this._debugParams = {
          showTerrainProxyTiles: !1,
          fpsWindow: 30,
          continousRedraw: !1,
          enabledLayers: {}
        };
        var a = ["fill", "line", "symbol", "circle", "heatmap", "fill-extrusion", "raster", "raster-particle", "hillshade", "model", "background", "sky"];
        for (var _i399 = 0, _a219 = a; _i399 < _a219.length; _i399++) {
          var _e568 = _a219[_i399];
          this._debugParams.enabledLayers[_e568] = !0;
        }
        r.registerParameter(this._debugParams, ["Terrain"], "showTerrainProxyTiles", {}, function () {
          _this138.style.map.triggerRepaint();
        }), r.registerParameter(this._debugParams, ["FPS"], "fpsWindow", {
          min: 1,
          max: 100,
          step: 1
        }), r.registerBinding(this._debugParams, ["FPS"], "continousRedraw", {
          readonly: !0,
          label: "continuous redraw"
        }), r.registerBinding(this, ["FPS"], "_averageFPS", {
          readonly: !0,
          label: "value"
        }), r.registerBinding(this, ["FPS"], "_averageFPS", {
          readonly: !0,
          label: "graph",
          view: "graph",
          min: 0,
          max: 200
        });
        for (var _i400 = 0, _a220 = a; _i400 < _a220.length; _i400++) {
          var _e569 = _a220[_i400];
          r.registerParameter(this._debugParams.enabledLayers, ["Debug", "Layers"], _e569);
        }
        this.occlusionParams = new wr(r), this.setup(), this.numSublayers = e.bx.maxUnderzooming + e.bx.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {}, this.conflationActive = !1, this.replacementSource = new e.cp(), this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = !1, this._cachedTileFogOpacities = {}, this._shadowRenderer = new mi(this), this._wireframeDebugCache = new br(), this.renderDefaultNorthPole = !0, this.renderDefaultSouthPole = !0, this.layersWithOcclusionOpacity = [];
        var n = new e.j({
          width: 1,
          height: 1
        }, Uint8Array.of(0, 0, 0, 0));
        this.emptyDepthTexture = new e.T(this.context, n, t.RGBA);
      }
      _createClass(Cr, [{
        key: "updateTerrain",
        value: function updateTerrain(e, t) {
          var i = !!e && !!e.terrain && this.transform.projection.supportsTerrain;
          if (!(i || this._terrain && this._terrain.enabled)) return;
          this._terrain || (this._terrain = new zi(this, e));
          var o = this._terrain;
          this.transform.elevation = i ? o : null, o.update(e, this.transform, t), this.transform.elevation && !o.enabled && (this.transform.elevation = null);
        }
      }, {
        key: "_updateFog",
        value: function _updateFog(e) {
          var t = e.fog;
          if (!t || "globe" === this.transform.projection.name || t.getOpacity(this.transform.pitch) < 1 || t.properties.get("horizon-blend") < .03) return void (this.transform.fogCullDistSq = null);
          var _t$getFovAdjustedRang = t.getFovAdjustedRange(this.transform._fov),
            _t$getFovAdjustedRang2 = _slicedToArray(_t$getFovAdjustedRang, 2),
            i = _t$getFovAdjustedRang2[0],
            o = _t$getFovAdjustedRang2[1];
          if (i > o) return void (this.transform.fogCullDistSq = null);
          var r = i + .78 * (o - i);
          this.transform.fogCullDistSq = r * r;
        }
      }, {
        key: "terrain",
        get: function get() {
          return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled || this._forceTerrainMode ? this._terrain : null;
        }
      }, {
        key: "forceTerrainMode",
        get: function get() {
          return this._forceTerrainMode;
        },
        set: function set(e) {
          e && !this._terrain && (this._terrain = new zi(this, this.style)), this._forceTerrainMode = e;
        }
      }, {
        key: "shadowRenderer",
        get: function get() {
          return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
        }
      }, {
        key: "wireframeDebugCache",
        get: function get() {
          return this._wireframeDebugCache;
        }
      }, {
        key: "resize",
        value: function resize(t, i) {
          if (this.width = t * e.e.devicePixelRatio, this.height = i * e.e.devicePixelRatio, this.context.viewport.set([0, 0, this.width, this.height]), this.style) {
            var _iterator406 = _createForOfIteratorHelper(this.style.order),
              _step406;
            try {
              for (_iterator406.s(); !(_step406 = _iterator406.n()).done;) {
                var _e570 = _step406.value;
                this.style._mergedLayers[_e570].resize();
              }
            } catch (err) {
              _iterator406.e(err);
            } finally {
              _iterator406.f();
            }
          }
        }
      }, {
        key: "setup",
        value: function setup() {
          var t = this.context,
            i = new e.bv();
          i.emplaceBack(0, 0), i.emplaceBack(e.a4, 0), i.emplaceBack(0, e.a4), i.emplaceBack(e.a4, e.a4), this.tileExtentBuffer = t.createVertexBuffer(i, e.bt.members), this.tileExtentSegments = e.b.simpleSegment(0, 0, 4, 2);
          var o = new e.bv();
          o.emplaceBack(0, 0), o.emplaceBack(e.a4, 0), o.emplaceBack(0, e.a4), o.emplaceBack(e.a4, e.a4), this.debugBuffer = t.createVertexBuffer(o, e.bt.members), this.debugSegments = e.b.simpleSegment(0, 0, 4, 5);
          var r = new e.bv();
          r.emplaceBack(-1, -1), r.emplaceBack(1, -1), r.emplaceBack(-1, 1), r.emplaceBack(1, 1), this.viewportBuffer = t.createVertexBuffer(r, e.bt.members), this.viewportSegments = e.b.simpleSegment(0, 0, 4, 2);
          var a = new e.cq();
          a.emplaceBack(0, 0, 0, 0), a.emplaceBack(e.a4, 0, e.a4, 0), a.emplaceBack(0, e.a4, 0, e.a4), a.emplaceBack(e.a4, e.a4, e.a4, e.a4), this.mercatorBoundsBuffer = t.createVertexBuffer(a, e.cr.members), this.mercatorBoundsSegments = e.b.simpleSegment(0, 0, 4, 2);
          var n = new e.bw();
          n.emplaceBack(0, 1, 2), n.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t.createIndexBuffer(n);
          var s = new e.cs();
          for (var _i401 = 0, _arr5 = [0, 1, 3, 2, 0]; _i401 < _arr5.length; _i401++) {
            var _e571 = _arr5[_i401];
            s.emplaceBack(_e571);
          }
          this.debugIndexBuffer = t.createIndexBuffer(s), this.emptyTexture = new e.T(t, new e.j({
            width: 1,
            height: 1
          }, Uint8Array.of(0, 0, 0, 0)), t.gl.RGBA), this.identityMat = e.ae.create();
          var l = this.context.gl;
          this.stencilClearMode = new e.ah({
            func: l.ALWAYS,
            mask: 0
          }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.loadTimeStamps.push(performance.now());
        }
      }, {
        key: "getMercatorTileBoundsBuffers",
        value: function getMercatorTileBoundsBuffers() {
          return {
            tileBoundsBuffer: this.mercatorBoundsBuffer,
            tileBoundsIndexBuffer: this.quadTriangleIndexBuffer,
            tileBoundsSegments: this.mercatorBoundsSegments
          };
        }
      }, {
        key: "getTileBoundsBuffers",
        value: function getTileBoundsBuffers(e) {
          return e._makeTileBoundsBuffers(this.context, this.transform.projection), e._tileBoundsBuffer ? {
            tileBoundsBuffer: e._tileBoundsBuffer,
            tileBoundsIndexBuffer: e._tileBoundsIndexBuffer,
            tileBoundsSegments: e._tileBoundsSegments
          } : this.getMercatorTileBoundsBuffers();
        }
      }, {
        key: "clearStencil",
        value: function clearStencil() {
          var t = this.context.gl;
          this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, t.TRIANGLES, e.af.disabled, this.stencilClearMode, e.a.disabled, e.ag.disabled, Si(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
        }
      }, {
        key: "resetStencilClippingMasks",
        value: function resetStencilClippingMasks() {
          this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
        }
      }, {
        key: "_renderTileClippingMasks",
        value: function _renderTileClippingMasks(t, i, o) {
          if (!i || this.currentStencilSource === i.id || !t.isTileClipped() || !o || 0 === o.length) return;
          if (this._tileClippingMaskIDs && !this.terrain) {
            var _e572 = !1;
            var _iterator407 = _createForOfIteratorHelper(o),
              _step407;
            try {
              for (_iterator407.s(); !(_step407 = _iterator407.n()).done;) {
                var _t564 = _step407.value;
                if (void 0 === this._tileClippingMaskIDs[_t564.key]) {
                  _e572 = !0;
                  break;
                }
              }
            } catch (err) {
              _iterator407.e(err);
            } finally {
              _iterator407.f();
            }
            if (!_e572) return;
          }
          this.currentStencilSource = i.id;
          var r = this.context,
            a = r.gl;
          this.nextStencilID + o.length > 256 && this.clearStencil(), r.setColorMode(e.a.disabled), r.setDepthMode(e.af.disabled);
          var n = this.getOrCreateProgram("clippingMask");
          this._tileClippingMaskIDs = {};
          var _iterator408 = _createForOfIteratorHelper(o),
            _step408;
          try {
            for (_iterator408.s(); !(_step408 = _iterator408.n()).done;) {
              var _t565 = _step408.value;
              var _o215 = i.getTile(_t565),
                _r423 = this._tileClippingMaskIDs[_t565.key] = this.nextStencilID++,
                _this$getTileBoundsBu = this.getTileBoundsBuffers(_o215),
                _s244 = _this$getTileBoundsBu.tileBoundsBuffer,
                _l127 = _this$getTileBoundsBu.tileBoundsIndexBuffer,
                _c109 = _this$getTileBoundsBu.tileBoundsSegments;
              n.draw(this, a.TRIANGLES, e.af.disabled, new e.ah({
                func: a.ALWAYS,
                mask: 0
              }, _r423, 255, a.KEEP, a.KEEP, a.REPLACE), e.a.disabled, e.ag.disabled, Si(_t565.projMatrix), "$clipping", _s244, _l127, _c109);
            }
          } catch (err) {
            _iterator408.e(err);
          } finally {
            _iterator408.f();
          }
        }
      }, {
        key: "stencilModeFor3D",
        value: function stencilModeFor3D() {
          this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
          var t = this.nextStencilID++,
            i = this.context.gl;
          return new e.ah({
            func: i.NOTEQUAL,
            mask: 255
          }, t, 255, i.KEEP, i.KEEP, i.REPLACE);
        }
      }, {
        key: "stencilModeForClipping",
        value: function stencilModeForClipping(t) {
          if (this.terrain) return this.terrain.stencilModeForRTTOverlap(t);
          var i = this.context.gl;
          return new e.ah({
            func: i.EQUAL,
            mask: 255
          }, this._tileClippingMaskIDs[t.key], 0, i.KEEP, i.KEEP, i.REPLACE);
        }
      }, {
        key: "stencilConfigForOverlap",
        value: function stencilConfigForOverlap(t) {
          var i = this.context.gl,
            o = t.sort(function (e, t) {
              return t.overscaledZ - e.overscaledZ;
            }),
            r = o[o.length - 1].overscaledZ,
            a = o[0].overscaledZ - r + 1;
          if (a > 1) {
            this.currentStencilSource = void 0, this.nextStencilID + a > 256 && this.clearStencil();
            var _t566 = {};
            for (var _o216 = 0; _o216 < a; _o216++) _t566[_o216 + r] = new e.ah({
              func: i.GEQUAL,
              mask: 255
            }, _o216 + this.nextStencilID, 255, i.KEEP, i.KEEP, i.REPLACE);
            return this.nextStencilID += a, [_t566, o];
          }
          return [_defineProperty({}, r, e.ah.disabled), o];
        }
      }, {
        key: "colorModeForRenderPass",
        value: function colorModeForRenderPass() {
          var t = this.context.gl;
          if (this._showOverdrawInspector) {
            var _i402 = 1 / 8;
            return new e.a([t.CONSTANT_COLOR, t.ONE, t.CONSTANT_COLOR, t.ONE], new e.C(_i402, _i402, _i402, 0), [!0, !0, !0, !0]);
          }
          return "opaque" === this.renderPass ? e.a.unblended : e.a.alphaBlended;
        }
      }, {
        key: "colorModeForDrapableLayerRenderPass",
        value: function colorModeForDrapableLayerRenderPass(t) {
          var _this139 = this;
          var i = this.context.gl;
          return function () {
            return _this139.style && _this139.style.enable3dLights() && _this139.terrain && _this139.terrain.renderingToTexture;
          }() && "translucent" === this.renderPass ? new e.a([i.ONE, i.ONE_MINUS_SRC_ALPHA, i.CONSTANT_ALPHA, i.ONE_MINUS_SRC_ALPHA], new e.C(0, 0, 0, void 0 === t ? 0 : t), [!0, !0, !0, !0]) : this.colorModeForRenderPass();
        }
      }, {
        key: "depthModeForSublayer",
        value: function depthModeForSublayer(t, i, o) {
          var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          if (this.depthOcclusion) return new e.af(this.context.gl.GREATER, e.af.ReadOnly, this.depthRangeFor3D);
          if (!this.opaquePassEnabledForLayer() && !r) return e.af.disabled;
          var a = 1 - ((1 + this.currentLayer) * this.numSublayers + t) * this.depthEpsilon;
          return new e.af(o || this.context.gl.LEQUAL, i, [a, a]);
        }
      }, {
        key: "opaquePassEnabledForLayer",
        value: function opaquePassEnabledForLayer() {
          return this.currentLayer < this.opaquePassCutoff;
        }
      }, {
        key: "blitDepth",
        value: function blitDepth() {
          var t = this.context.gl,
            i = Math.ceil(this.width),
            o = Math.ceil(this.height),
            r = this.context.bindFramebuffer.get(),
            a = t.getParameter(t.TEXTURE_BINDING_2D);
          this.depthFBO && this.depthFBO.width === i && this.depthFBO.height === o || (this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), 0 !== i && 0 !== o && (this.depthFBO = new oe(this.context, i, o, !1, "texture"), this.depthTexture = new e.T(this.context, {
            width: i,
            height: o,
            data: null
          }, t.DEPTH_STENCIL), this.depthFBO.depthAttachment.set(this.depthTexture.texture))), this.context.bindFramebuffer.set(r), t.bindTexture(t.TEXTURE_2D, a), this.depthFBO && (t.bindFramebuffer(t.READ_FRAMEBUFFER, null), t.bindFramebuffer(t.DRAW_FRAMEBUFFER, this.depthFBO.framebuffer), t.blitFramebuffer(0, 0, i, o, 0, 0, i, o, t.DEPTH_BUFFER_BIT, t.NEAREST), t.bindFramebuffer(t.FRAMEBUFFER, this.context.bindFramebuffer.current));
        }
      }, {
        key: "updateAverageFPS",
        value: function updateAverageFPS() {
          var _this140 = this;
          this._fpsHistory.push(0 === this._dt ? 0 : 1e3 / this._dt), this._fpsHistory.length > this._debugParams.fpsWindow && this._fpsHistory.splice(0, this._fpsHistory.length - this._debugParams.fpsWindow), this._averageFPS = Math.round(this._fpsHistory.reduce(function (e, t) {
            return e + t / _this140._fpsHistory.length;
          }, 0));
        }
      }, {
        key: "render",
        value: function render(t, i) {
          var _this141 = this;
          var o = e.e.now();
          this._dt = o - this._timeStamp, this._timeStamp = o, this._wireframeDebugCache.update(this.frameCounter), this._debugParams.continousRedraw = t.map.repaint, this.style = t, this.options = i;
          var r = this.style._mergedLayers,
            a = this.style.order.filter(function (e) {
              var t = r[e];
              return !(t.type in _this141._debugParams.enabledLayers) || _this141._debugParams.enabledLayers[t.type];
            });
          var n = !1,
            s = !1;
          var _iterator409 = _createForOfIteratorHelper(a),
            _step409;
          try {
            for (_iterator409.s(); !(_step409 = _iterator409.n()).done;) {
              var _e590 = _step409.value;
              var _t574 = r[_e590];
              "circle" === _t574.type && (n = !0), "symbol" === _t574.type && (_t574.hasInitialOcclusionOpacityProperties ? s = !0 : n = !0);
            }
          } catch (err) {
            _iterator409.e(err);
          } finally {
            _iterator409.f();
          }
          var l = a.map(function (e) {
              return r[e];
            }),
            c = this.style._mergedSourceCaches;
          this.imageManager = t.imageManager, this.modelManager = t.modelManager, this.symbolFadeChange = t.placement.symbolFadeChange(e.e.now()), this.imageManager.beginFrame();
          var h = 0,
            _ = !1;
          for (var _e573 in c) {
            var _t567 = c[_e573];
            _t567.used && (_t567.prepare(this.context), _t567.getSource().usedInConflation && ++h);
          }
          var u = !1;
          var _iterator410 = _createForOfIteratorHelper(l),
            _step410;
          try {
            for (_iterator410.s(); !(_step410 = _iterator410.n()).done;) {
              var _e591 = _step410.value;
              _e591.isHidden(this.transform.zoom) || ("clip" === _e591.type && (u = !0), this.prepareLayer(_e591));
            }
          } catch (err) {
            _iterator410.e(err);
          } finally {
            _iterator410.f();
          }
          var d = {},
            p = {},
            f = {},
            m = {},
            g = {};
          for (var _e574 in c) {
            var _t568 = c[_e574];
            d[_e574] = _t568.getVisibleCoordinates(), p[_e574] = d[_e574].slice().reverse(), f[_e574] = _t568.getVisibleCoordinates(!0).reverse(), m[_e574] = _t568.getShadowCasterCoordinates(), g[_e574] = _t568.sortCoordinatesByDistance(d[_e574]);
          }
          var v = function v(e) {
            var t = _this141.style.getLayerSourceCache(e);
            return t && t.used ? t.getSource() : null;
          };
          if (h || u) {
            var _t569 = [],
              _i403 = [];
            var _o217 = 0;
            var _iterator411 = _createForOfIteratorHelper(l),
              _step411;
            try {
              for (_iterator411.s(); !(_step411 = _iterator411.n()).done;) {
                var _e576 = _step411.value;
                this.isSourceForClippingOrConflation(_e576, v(_e576)) && (_t569.push(_e576), _i403.push(_o217)), _o217++;
              }
            } catch (err) {
              _iterator411.e(err);
            } finally {
              _iterator411.f();
            }
            if (_t569 && (u || _t569.length > 1)) {
              var _o218 = [];
              for (var _r424 = 0; _r424 < _t569.length; _r424++) {
                var _a221 = _t569[_r424],
                  _n295 = _i403[_r424],
                  _s245 = this.style.getLayerSourceCache(_a221);
                if (!_s245 || !_s245.used || !_s245.getSource().usedInConflation && "clip" !== _a221.type) continue;
                var _l128 = e.cv,
                  _c110 = e.cw.None;
                var _h83 = [];
                if ("clip" === _a221.type) {
                  _l128 = _n295;
                  var _iterator412 = _createForOfIteratorHelper(_a221.layout.get("clip-layer-types")),
                    _step412;
                  try {
                    for (_iterator412.s(); !(_step412 = _iterator412.n()).done;) {
                      var _t570 = _step412.value;
                      _c110 |= "model" === _t570 ? e.cw.Model : "symbol" === _t570 ? e.cw.Symbol : e.cw.FillExtrusion;
                    }
                  } catch (err) {
                    _iterator412.e(err);
                  } finally {
                    _iterator412.f();
                  }
                  var _iterator413 = _createForOfIteratorHelper(_a221.layout.get("clip-layer-scope")),
                    _step413;
                  try {
                    for (_iterator413.s(); !(_step413 = _iterator413.n()).done;) {
                      var _e575 = _step413.value;
                      _h83.push(_e575);
                    }
                  } catch (err) {
                    _iterator413.e(err);
                  } finally {
                    _iterator413.f();
                  }
                }
                _o218.push({
                  layer: _a221.fqid,
                  cache: _s245,
                  order: _l128,
                  clipMask: _c110,
                  clipScope: _h83
                });
              }
              this.replacementSource.setSources(_o218), _ = !0;
            }
          }
          _ || this.replacementSource.clear(), this.conflationActive = _, this.minCutoffZoom = 0, this.longestCutoffRange = 0, this.opaquePassCutoff = 1 / 0, this._lastOcclusionLayer = -1, this.layersWithOcclusionOpacity = [];
          for (var _e577 = 0; _e577 < l.length; _e577++) {
            var _t571 = l[_e577],
              _i404 = _t571.cutoffRange();
            if (this.longestCutoffRange = Math.max(_i404, this.longestCutoffRange), _i404 > 0) {
              var _e578 = v(_t571);
              _e578 && (this.minCutoffZoom = Math.max(_e578.minzoom, this.minCutoffZoom)), _t571.minzoom && (this.minCutoffZoom = Math.max(_t571.minzoom, this.minCutoffZoom));
            }
            _t571.is3D() && (this.opaquePassCutoff === 1 / 0 && (this.opaquePassCutoff = _e577), this._lastOcclusionLayer = _e577);
          }
          var x = this.style && this.style.fog;
          x ? (this._fogVisible = 0 !== x.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = x.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = !1, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(f), this.opaquePassCutoff = 0);
          var y = this._shadowRenderer;
          if (y) {
            y.updateShadowParameters(this.transform, this.style.directionalLight);
            for (var _e579 in c) {
              var _iterator414 = _createForOfIteratorHelper(d[_e579]),
                _step414;
              try {
                for (_iterator414.s(); !(_step414 = _iterator414.n()).done;) {
                  var _t572 = _step414.value;
                  var _e580 = {
                    min: 0,
                    max: 0
                  };
                  this.terrain && (_e580 = this.terrain.getMinMaxForTile(_t572) || _e580), y.addShadowReceiver(_t572.toUnwrapped(), _e580.min, _e580.max);
                }
              } catch (err) {
                _iterator414.e(err);
              } finally {
                _iterator414.f();
              }
            }
          }
          if ("globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e.ct(this.context)), this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new nr(this)), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), !e.cu(this.context.gl)) return;
          this.renderPass = "offscreen";
          var _iterator415 = _createForOfIteratorHelper(l),
            _step415;
          try {
            for (_iterator415.s(); !(_step415 = _iterator415.n()).done;) {
              var _e592 = _step415.value;
              var _i413 = t.getLayerSourceCache(_e592);
              if (!_e592.hasOffscreenPass() || _e592.isHidden(this.transform.zoom)) continue;
              var _o223 = _i413 ? p[_i413.id] : void 0;
              ("custom" === _e592.type || "raster" === _e592.type || "raster-particle" === _e592.type || _e592.isSky() || _o223 && _o223.length) && this.renderLayer(this, _i413, _e592, _o223);
            }
          } catch (err) {
            _iterator415.e(err);
          } finally {
            _iterator415.f();
          }
          this.depthRangeFor3D = [0, 1 - (l.length + 2) * this.numSublayers * this.depthEpsilon], this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, m)), this.context.bindFramebuffer.set(null), this.context.viewport.set([0, 0, this.width, this.height]);
          var b = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(),
            w = function () {
              if (i.showOverdrawInspector) return e.C.black;
              var t = _this141.style.fog;
              if (t && _this141.transform.projection.supportsFog) {
                var _i405 = _this141.style.getLut(t.scope);
                if (!b) {
                  var _o219 = t.properties.get("color").toRenderColor(_i405).toArray01();
                  return _construct2(e.C, _toConsumableArray(_o219));
                }
                if (b) {
                  var _o220 = t.properties.get("space-color").toRenderColor(_i405).toArray01();
                  return _construct2(e.C, _toConsumableArray(_o220));
                }
              }
              return e.C.transparent;
            }();
          if (this.context.clear({
            color: w,
            depth: 1
          }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && b && this._atmosphere.drawStars(this, this.style.fog), !this.terrain) for (this.currentLayer = a.length - 1; this.currentLayer >= 0; this.currentLayer--) {
            var _e581 = l[this.currentLayer],
              _i406 = t.getLayerSourceCache(_e581);
            if (_e581.isSky()) continue;
            var _o221 = _i406 ? (_e581.is3D() ? g : p)[_i406.id] : void 0;
            this._renderTileClippingMasks(_e581, _i406, _o221), this.renderLayer(this, _i406, _e581, _o221);
          }
          if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && b && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || e.a2(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible())) for (this.currentLayer = 0; this.currentLayer < a.length; this.currentLayer++) {
            var _e582 = l[this.currentLayer],
              _i407 = t.getLayerSourceCache(_e582);
            _e582.isSky() && this.renderLayer(this, _i407, _e582, _i407 ? p[_i407.id] : void 0);
          }
          function T(e, t) {
            var i;
            return t && (i = ("symbol" === e.type ? f : e.is3D() ? g : p)[t.id]), i;
          }
          if (this.renderPass = "translucent", "globe" === this.transform.projection.name) {
            for (this.renderElevatedRasterBackface = !0, this.currentLayer = 0; this.currentLayer < a.length;) {
              var _e583 = l[this.currentLayer];
              if ("raster" === _e583.type || "raster-particle" === _e583.type) {
                var _i408 = t.getLayerSourceCache(_e583);
                this.renderLayer(this, _i408, _e583, T(_e583, _i408));
              }
              ++this.currentLayer;
            }
            this.renderElevatedRasterBackface = !1;
          }
          this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
          var E = 0;
          y && (E = y.getShadowCastingLayerCount());
          var C = !1,
            S = -1;
          for (var _e584 = 0; _e584 < a.length; ++_e584) {
            var _t573 = l[_e584];
            _t573.isHidden(this.transform.zoom) || _t573.is3D() && (S = _e584);
          }
          for (s && -1 === S && (n = !0); this.currentLayer < a.length;) {
            var _e585 = l[this.currentLayer],
              _i409 = t.getLayerSourceCache(_e585);
            if (_e585.isSky()) ++this.currentLayer;else if (this.terrain && this.style.isLayerDraped(_e585)) {
              if (_e585.isHidden(this.transform.zoom)) {
                ++this.currentLayer;
                continue;
              }
              this.currentLayer = this.terrain.renderBatch(this.currentLayer), this._lastOcclusionLayer = Math.max(this.currentLayer, this._lastOcclusionLayer);
            } else {
              if (n && !C && this.terrain && !this.transform.isOrthographic && (C = !0, this.blitDepth()), s && -1 !== S && this.currentLayer === S + 1 && !this.transform.isOrthographic && this.blitDepth(), _e585.is3D() || this.terrain || this._renderTileClippingMasks(_e585, _i409, _i409 ? d[_i409.id] : void 0), this.renderLayer(this, _i409, _e585, T(_e585, _i409)), !this.terrain && y && E > 0 && _e585.hasShadowPass() && 0 == --E && (y.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer)) {
                var _e586 = this.currentLayer;
                for (this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= _e586; this.currentLayer++) {
                  var _e587 = l[this.currentLayer];
                  if (!_e587.hasLightBeamPass()) continue;
                  var _i410 = t.getLayerSourceCache(_e587);
                  this.renderLayer(this, _i410, _e587, _i410 ? p[_i410.id] : void 0);
                }
                this.currentLayer = _e586, this.renderPass = "translucent";
              }
              if (this.currentLayer >= this._lastOcclusionLayer && this.layersWithOcclusionOpacity.length > 0) {
                var _e588 = this.currentLayer;
                this.depthOcclusion = !0;
                var _iterator416 = _createForOfIteratorHelper(this.layersWithOcclusionOpacity),
                  _step416;
                try {
                  for (_iterator416.s(); !(_step416 = _iterator416.n()).done;) {
                    var _e589 = _step416.value;
                    this.currentLayer = _e589;
                    var _i411 = l[this.currentLayer],
                      _o222 = t.getLayerSourceCache(_i411),
                      _r425 = _o222 ? p[_o222.id] : void 0;
                    _i411.is3D() || this.terrain || this._renderTileClippingMasks(_i411, _o222, _o222 ? d[_o222.id] : void 0), this.renderLayer(this, _o222, _i411, _r425);
                  }
                } catch (err) {
                  _iterator416.e(err);
                } finally {
                  _iterator416.f();
                }
                this.depthOcclusion = !1, this.currentLayer = _e588, this.renderPass = "translucent", this.layersWithOcclusionOpacity = [];
              }
              ++this.currentLayer;
            }
          }
          if (this.terrain && this.terrain.postRender(), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
            var _i412 = null;
            l.forEach(function (e) {
              var o = t.getLayerSourceCache(e);
              o && !e.isHidden(_this141.transform.zoom) && o.getVisibleCoordinates().length && (!_i412 || _i412.getSource().maxzoom < o.getSource().maxzoom) && (_i412 = o);
            }), _i412 && this.options.showTileBoundaries && Tr.debug(this, _i412, _i412.getVisibleCoordinates(), e.C.red, !1, this.options.showParseStatus);
          }
          this.terrain && this._debugParams.showTerrainProxyTiles && Tr.debug(this, this.terrain.proxySourceCache, this.terrain.proxyCoords, new e.C(1, .8, .1, 1), !0, this.options.showParseStatus), this.options.showPadding && function (e) {
            var t = e.transform.padding;
            qo(e, e.transform.height - (t.top || 0), 3, jo), qo(e, t.bottom || 0, 3, Vo), Xo(e, t.left || 0, 3, $o), Xo(e, e.transform.width - (t.right || 0), 3, Zo);
            var i = e.transform.centerPoint;
            !function (e, t, i, o) {
              Qo(e, t - 1, i - 10, 2, 20, o), Qo(e, t - 10, i - 1, 20, 2, o);
            }(e, i.x, e.transform.height - i.y, Wo);
          }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(performance.now()), this.saveCanvasCopy()), _ || (this.conflationActive = !1);
        }
      }, {
        key: "prepareLayer",
        value: function prepareLayer(e) {
          this.gpuTimingStart(e);
          var t = this.transform.projection.unsupportedLayers,
            i = !t || !t.includes(e.type);
          if (Er[e.type] && (i || this.terrain && "custom" === e.type)) {
            var _t575 = this.style.getLayerSourceCache(e);
            Er[e.type](e, _t575, this);
          }
          this.gpuTimingEnd();
        }
      }, {
        key: "renderLayer",
        value: function renderLayer(e, t, i, o) {
          i.isHidden(this.transform.zoom) || ("background" === i.type || "sky" === i.type || "custom" === i.type || "model" === i.type || "raster" === i.type || "raster-particle" === i.type || o && o.length) && (this.id = i.id, this.gpuTimingStart(i), e.transform.projection.unsupportedLayers && e.transform.projection.unsupportedLayers.includes(i.type) && (!e.terrain || "custom" !== i.type) || "clip" === i.type || Tr[i.type](e, t, i, o, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
        }
      }, {
        key: "gpuTimingStart",
        value: function gpuTimingStart(e) {
          if (!this.options.gpuTiming) return;
          var t = this.context.extTimerQuery,
            i = this.context.gl;
          var o = this.gpuTimers[e.id];
          o || (o = this.gpuTimers[e.id] = {
            calls: 0,
            cpuTime: 0,
            query: i.createQuery()
          }), o.calls++, i.beginQuery(t.TIME_ELAPSED_EXT, o.query);
        }
      }, {
        key: "gpuTimingDeferredRenderStart",
        value: function gpuTimingDeferredRenderStart() {
          if (this.options.gpuTimingDeferredRender) {
            var _e593 = this.context.extTimerQuery,
              _t576 = this.context.gl,
              _i414 = _t576.createQuery();
            this.deferredRenderGpuTimeQueries.push(_i414), _t576.beginQuery(_e593.TIME_ELAPSED_EXT, _i414);
          }
        }
      }, {
        key: "gpuTimingDeferredRenderEnd",
        value: function gpuTimingDeferredRenderEnd() {
          this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
        }
      }, {
        key: "gpuTimingEnd",
        value: function gpuTimingEnd() {
          this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
        }
      }, {
        key: "collectGpuTimers",
        value: function collectGpuTimers() {
          var e = this.gpuTimers;
          return this.gpuTimers = {}, e;
        }
      }, {
        key: "collectDeferredRenderGpuQueries",
        value: function collectDeferredRenderGpuQueries() {
          var e = this.deferredRenderGpuTimeQueries;
          return this.deferredRenderGpuTimeQueries = [], e;
        }
      }, {
        key: "queryGpuTimers",
        value: function queryGpuTimers(e) {
          var t = {};
          for (var _i415 in e) {
            var _o224 = e[_i415],
              _r426 = this.context.extTimerQuery,
              _a222 = _r426.getQueryParameter(_o224.query, this.context.gl.QUERY_RESULT) / 1e6;
            _r426.deleteQueryEXT(_o224.query), t[_i415] = _a222;
          }
          return t;
        }
      }, {
        key: "queryGpuTimeDeferredRender",
        value: function queryGpuTimeDeferredRender(e) {
          if (!this.options.gpuTimingDeferredRender) return 0;
          var t = this.context.extTimerQuery,
            i = this.context.gl;
          var o = 0;
          var _iterator417 = _createForOfIteratorHelper(e),
            _step417;
          try {
            for (_iterator417.s(); !(_step417 = _iterator417.n()).done;) {
              var _r427 = _step417.value;
              o += t.getQueryParameter(_r427, i.QUERY_RESULT) / 1e6, t.deleteQueryEXT(_r427);
            }
          } catch (err) {
            _iterator417.e(err);
          } finally {
            _iterator417.f();
          }
          return o;
        }
      }, {
        key: "translatePosMatrix",
        value: function translatePosMatrix(t, i, o, r, a) {
          if (!o[0] && !o[1]) return t;
          var n = a ? "map" === r ? this.transform.angle : 0 : "viewport" === r ? -this.transform.angle : 0;
          if (n) {
            var _e594 = Math.sin(n),
              _t577 = Math.cos(n);
            o = [o[0] * _t577 - o[1] * _e594, o[0] * _e594 + o[1] * _t577];
          }
          var s = [a ? o[0] : e.bD(i, o[0], this.transform.zoom), a ? o[1] : e.bD(i, o[1], this.transform.zoom), 0],
            l = new Float32Array(16);
          return e.ae.translate(l, t, s), l;
        }
      }, {
        key: "saveTileTexture",
        value: function saveTileTexture(e) {
          var t = e.size[0],
            i = this._tileTextures[t];
          i ? i.push(e) : this._tileTextures[t] = [e];
        }
      }, {
        key: "getTileTexture",
        value: function getTileTexture(e) {
          var t = this._tileTextures[e];
          return t && t.length > 0 ? t.pop() : null;
        }
      }, {
        key: "terrainRenderModeElevated",
        value: function terrainRenderModeElevated() {
          return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture || this.forceTerrainMode;
        }
      }, {
        key: "linearFloatFilteringSupported",
        value: function linearFloatFilteringSupported() {
          return null != this.context.extTextureFloatLinear;
        }
      }, {
        key: "currentGlobalDefines",
        value: function currentGlobalDefines(e, t, i) {
          var o = void 0 === i ? this.terrain && this.terrain.renderingToTexture : i,
            r = [];
          return this.style && this.style.enable3dLights() && ("globeRaster" === e || "terrainRaster" === e ? (r.push("LIGHTING_3D_MODE"), r.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : o || r.push("LIGHTING_3D_MODE")), "shadow" === this.renderPass ? this._shadowMapDebug || r.push("DEPTH_TEXTURE") : this.shadowRenderer && (this.shadowRenderer.useNormalOffset ? r.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET") : r.push("RENDER_SHADOWS", "DEPTH_TEXTURE")), this.terrainRenderModeElevated() && (r.push("TERRAIN"), this.linearFloatFilteringSupported() && r.push("TERRAIN_DEM_FLOAT_FORMAT")), "globe" === this.transform.projection.name && r.push("GLOBE"), !this._fogVisible || o || void 0 !== t && !t || r.push("FOG", "FOG_DITHERING"), o && r.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && r.push("OVERDRAW_INSPECTOR"), r;
        }
      }, {
        key: "getOrCreateProgram",
        value: function getOrCreateProgram(e, t) {
          this.cache = this.cache || {};
          var i = t && t.defines || [],
            o = t && t.config,
            r = this.currentGlobalDefines(e, t && t.overrideFog, t && t.overrideRtt).concat(i),
            a = ki.cacheKey(Ct[e], e, r, o);
          return this.cache[a] || (this.cache[a] = new ki(this.context, e, Ct[e], o, mo[e], r)), this.cache[a];
        }
      }, {
        key: "setCustomLayerDefaults",
        value: function setCustomLayerDefaults() {
          this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
        }
      }, {
        key: "setBaseState",
        value: function setBaseState() {
          var e = this.context.gl;
          this.context.cullFace.set(!1), this.context.viewport.set([0, 0, this.width, this.height]), this.context.blendEquation.set(e.FUNC_ADD);
        }
      }, {
        key: "initDebugOverlayCanvas",
        value: function initDebugOverlayCanvas() {
          null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy(), this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), this.emptyDepthTexture && this.emptyDepthTexture.destroy();
        }
      }, {
        key: "prepareDrawTile",
        value: function prepareDrawTile() {
          this.terrain && this.terrain.prepareDrawTile();
        }
      }, {
        key: "uploadCommonLightUniforms",
        value: function uploadCommonLightUniforms(t, i) {
          if (this.style.enable3dLights()) {
            var _o225 = this.style.directionalLight,
              _r428 = this.style.ambientLight;
            if (_o225 && _r428) {
              var _a223 = function (t, i, o) {
                var r = t.properties.get("direction"),
                  a = t.properties.get("color").toRenderColor(o.getLut(t.scope)).toArray01(),
                  n = t.properties.get("intensity"),
                  s = i.properties.get("color").toRenderColor(o.getLut(i.scope)).toArray01(),
                  l = i.properties.get("intensity"),
                  c = [r.x, r.y, r.z],
                  h = e.bC(s, l),
                  _ = e.bC(a, n);
                return {
                  u_lighting_ambient_color: h,
                  u_lighting_directional_dir: c,
                  u_lighting_directional_color: _,
                  u_ground_radiance: Oi(c, _, h)
                };
              }(_o225, _r428, this.style);
              i.setLightsUniformValues(t, _a223);
            }
          }
        }
      }, {
        key: "uploadCommonUniforms",
        value: function uploadCommonUniforms(t, i, o, r, a) {
          if (this.uploadCommonLightUniforms(t, i), this.terrain && this.terrain.renderingToTexture) return;
          var n = this.style.fog;
          if (n) {
            var _a224 = n.getOpacity(this.transform.pitch),
              _s246 = function (t, i, o, r, a, n, s, l, c, h, _, u) {
                var d = t.transform,
                  p = i.properties.get("color").toRenderColor(t.style.getLut(i.scope)).toArray01();
                p[3] = r;
                var f = t.frameCounter / 1e3 % 1,
                  _i$properties$get = i.properties.get("vertical-range"),
                  _i$properties$get2 = _slicedToArray(_i$properties$get, 2),
                  m = _i$properties$get2[0],
                  g = _i$properties$get2[1];
                return {
                  u_fog_matrix: o ? d.calculateFogTileMatrix(o) : u || t.identityMat,
                  u_fog_range: i.getFovAdjustedRange(d._fov),
                  u_fog_color: p,
                  u_fog_horizon_blend: i.properties.get("horizon-blend"),
                  u_fog_vertical_limit: [Math.min(m, g), g],
                  u_fog_temporal_offset: f,
                  u_frustum_tl: a,
                  u_frustum_tr: n,
                  u_frustum_br: s,
                  u_frustum_bl: l,
                  u_globe_pos: c,
                  u_globe_radius: h,
                  u_viewport: _,
                  u_globe_transition: e.a2(d.zoom),
                  u_is_globe: +("globe" === d.projection.name)
                };
              }(this, n, o, _a224, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [this.transform.width * e.e.devicePixelRatio, this.transform.height * e.e.devicePixelRatio], r);
            i.setFogUniformValues(t, _s246);
          }
          a && i.setCutoffUniformValues(t, a.uniformValues);
        }
      }, {
        key: "setTileLoadedFlag",
        value: function setTileLoadedFlag(e) {
          this.tileLoaded = e;
        }
      }, {
        key: "saveCanvasCopy",
        value: function saveCanvasCopy() {
          var e = this.canvasCopy();
          e && (this.frameCopies.push(e), this.tileLoaded = !1);
        }
      }, {
        key: "canvasCopy",
        value: function canvasCopy() {
          var e = this.context.gl,
            t = e.createTexture();
          return e.bindTexture(e.TEXTURE_2D, t), e.copyTexImage2D(e.TEXTURE_2D, 0, e.RGBA, 0, 0, e.drawingBufferWidth, e.drawingBufferHeight, 0), t;
        }
      }, {
        key: "getCanvasCopiesAndTimestamps",
        value: function getCanvasCopiesAndTimestamps() {
          return {
            canvasCopies: this.frameCopies,
            timeStamps: this.loadTimeStamps
          };
        }
      }, {
        key: "averageElevationNeedsEasing",
        value: function averageElevationNeedsEasing() {
          if (!this.transform._elevation) return !1;
          var e = this.style && this.style.fog;
          return !!e && 0 !== e.getOpacity(this.transform.pitch);
        }
      }, {
        key: "getBackgroundTiles",
        value: function getBackgroundTiles() {
          var t = this._backgroundTiles,
            i = this._backgroundTiles = {},
            o = this.transform.coveringTiles({
              tileSize: 512
            });
          var _iterator418 = _createForOfIteratorHelper(o),
            _step418;
          try {
            for (_iterator418.s(); !(_step418 = _iterator418.n()).done;) {
              var _r429 = _step418.value;
              i[_r429.key] = t[_r429.key] || new e.bA(_r429, 512, this.transform.tileZoom, this);
            }
          } catch (err) {
            _iterator418.e(err);
          } finally {
            _iterator418.f();
          }
          return i;
        }
      }, {
        key: "clearBackgroundTiles",
        value: function clearBackgroundTiles() {
          this._backgroundTiles = {};
        }
      }, {
        key: "isSourceForClippingOrConflation",
        value: function isSourceForClippingOrConflation(e, t) {
          return !(!e.is3D() || e.minzoom && e.minzoom > this.transform.zoom || (this.style._clipLayerIndices.length || "building" !== e.sourceLayer) && "clip" !== e.type && (!t || "batched-model" !== t.type));
        }
      }, {
        key: "isTileAffectedByFog",
        value: function isTileAffectedByFog(e) {
          if (!this.style || !this.style.fog) return !1;
          if ("globe" === this.transform.projection.name) return !0;
          var t = this._cachedTileFogOpacities[e.key];
          return t || (this._cachedTileFogOpacities[e.key] = t = this.style.fog.getOpacityForTile(e)), t[0] >= Ke || t[1] >= Ke;
        }
      }, {
        key: "setupDepthForOcclusion",
        value: function setupDepthForOcclusion(e, t, i) {
          var o = this.context,
            r = o.gl,
            a = !!i;
          var n;
          i || (i = {
            u_dem: 2,
            u_dem_prev: 4,
            u_dem_tl: [0, 0],
            u_dem_tl_prev: [0, 0],
            u_dem_scale: 0,
            u_dem_scale_prev: 0,
            u_dem_size: 0,
            u_dem_lerp: 1,
            u_depth: 3,
            u_depth_size_inv: [0, 0],
            u_depth_range_unpack: [0, 1],
            u_occluder_half_size: 16,
            u_occlusion_depth_offset: -1e-4,
            u_exaggeration: 0
          }), o.activeTexture.set(r.TEXTURE3), e && this.depthFBO && this.depthTexture ? (this.depthTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), i.u_depth_size_inv = [1 / this.depthFBO.width, 1 / this.depthFBO.height], i.u_depth_range_unpack = [2 / ((n = this.depthRangeFor3D)[1] - n[0]), -1 - 2 * n[0] / (n[1] - n[0])], i.u_occluder_half_size = .5 * this.occlusionParams.occluderSize, i.u_occlusion_depth_offset = this.occlusionParams.depthOffset) : this.emptyDepthTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), o.activeTexture.set(r.TEXTURE0), a || t.setTerrainUniformValues(o, i);
        }
      }]);
      return Cr;
    }();
    var Sr = /*#__PURE__*/function () {
      function Sr(e, t, i, o) {
        _classCallCheck(this, Sr);
        this.screenBounds = e, this.cameraPoint = t, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = i, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, o);
      }
      _createClass(Sr, [{
        key: "isPointQuery",
        value: function isPointQuery() {
          return 1 === this.screenBounds.length;
        }
      }, {
        key: "bufferedScreenGeometry",
        value: function bufferedScreenGeometry(t) {
          return e.cx(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t);
        }
      }, {
        key: "bufferedCameraGeometry",
        value: function bufferedCameraGeometry(t) {
          var i = this.screenBounds[0],
            o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1],
            r = e.cx(i, o, 0, !1);
          return this.cameraPoint.y > o.y && (this.cameraPoint.x > i.x && this.cameraPoint.x < o.x ? r.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= o.x ? r[2] = this.cameraPoint : this.cameraPoint.x <= i.x && (r[3] = this.cameraPoint)), e.cy(r, t);
        }
      }, {
        key: "bufferedCameraGeometryGlobe",
        value: function bufferedCameraGeometryGlobe(t) {
          var i = this.screenBounds[0],
            o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1],
            r = e.cx(i, o, t),
            a = this.cameraPoint.clone();
          switch (3 * ((a.y > i.y) + (a.y > o.y)) + ((a.x > i.x) + (a.x > o.x))) {
            case 0:
              r[0] = a, r[4] = a.clone();
              break;
            case 1:
              r.splice(1, 0, a);
              break;
            case 2:
              r[1] = a;
              break;
            case 3:
              r.splice(4, 0, a);
              break;
            case 5:
              r.splice(2, 0, a);
              break;
            case 6:
              r[3] = a;
              break;
            case 7:
              r.splice(3, 0, a);
              break;
            case 8:
              r[2] = a;
          }
          return r;
        }
      }, {
        key: "containsTile",
        value: function containsTile(t, i, o) {
          var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
          var a = t.queryPadding / i._pixelsPerMercatorPixel + 1,
            n = o ? this._bufferedCameraMercator(a, i) : this._bufferedScreenMercator(a, i);
          var s = t.tileID.wrap + (n.unwrapped ? r : 0);
          var l = n.polygon.map(function (i) {
            return e.cz(t.tileTransform, i, s);
          });
          if (!e.cA(l, 0, 0, e.a4, e.a4)) return;
          s = t.tileID.wrap + (this.screenGeometryMercator.unwrapped ? r : 0);
          var c = this.screenGeometryMercator.polygon.map(function (i) {
              return e.cB(t.tileTransform, i, s);
            }),
            h = c.map(function (t) {
              return new e.P(t[0], t[1]);
            }),
            _ = i.getFreeCameraOptions().position || new e._(0, 0, 0),
            u = e.cB(t.tileTransform, _, s),
            d = c.map(function (t) {
              var i = e.$.sub(t, t, u);
              return e.$.normalize(i, i), new e.aU(u, i);
            }),
            p = e.bD(t, 1, i.zoom) * i._pixelsPerMercatorPixel;
          return {
            queryGeometry: this,
            tilespaceGeometry: h,
            tilespaceRays: d,
            bufferedTilespaceGeometry: l,
            bufferedTilespaceBounds: (f = e.cC(l), f.min.x = e.au(f.min.x, 0, e.a4), f.min.y = e.au(f.min.y, 0, e.a4), f.max.x = e.au(f.max.x, 0, e.a4), f.max.y = e.au(f.max.y, 0, e.a4), f),
            tile: t,
            tileID: t.tileID,
            pixelToTileUnitsFactor: p
          };
          var f;
        }
      }, {
        key: "_bufferedScreenMercator",
        value: function _bufferedScreenMercator(e, t) {
          var i = Pr(e);
          if (this._screenRaycastCache[i]) return this._screenRaycastCache[i];
          {
            var _o226;
            return _o226 = "globe" === t.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e), t) : {
              polygon: this.bufferedScreenGeometry(e).map(function (e) {
                return t.pointCoordinate3D(e);
              }),
              unwrapped: !0
            }, this._screenRaycastCache[i] = _o226, _o226;
          }
        }
      }, {
        key: "_bufferedCameraMercator",
        value: function _bufferedCameraMercator(e, t) {
          var i = Pr(e);
          if (this._cameraRaycastCache[i]) return this._cameraRaycastCache[i];
          {
            var _o227;
            return _o227 = "globe" === t.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e), t) : {
              polygon: this.bufferedCameraGeometry(e).map(function (e) {
                return t.pointCoordinate3D(e);
              }),
              unwrapped: !0
            }, this._cameraRaycastCache[i] = _o227, _o227;
          }
        }
      }, {
        key: "_projectAndResample",
        value: function _projectAndResample(t, i) {
          var o = function (t, i) {
            var o = e.ae.multiply([], i.pixelMatrix, i.globeMatrix),
              r = [0, -e.cF, 0, 1],
              a = [0, e.cF, 0, 1],
              n = [0, 0, 0, 1];
            e.aB.transformMat4(r, r, o), e.aB.transformMat4(a, a, o), e.aB.transformMat4(n, n, o);
            var s = new e.P(r[0] / r[3], r[1] / r[3]),
              l = new e.P(a[0] / a[3], a[1] / a[3]),
              c = e.cD(t, s) && r[3] < n[3],
              h = e.cD(t, l) && a[3] < n[3];
            if (!c && !h) return null;
            var _ = function (e, t, i) {
              for (var _o228 = 1; _o228 < e.length; _o228++) {
                var _r430 = Lr(t.pointCoordinate3D(e[_o228 - 1]).x),
                  _a225 = Lr(t.pointCoordinate3D(e[_o228]).x);
                if (i < 0) {
                  if (_r430 < _a225) return {
                    idx: _o228,
                    t: -_r430 / (_a225 - 1 - _r430)
                  };
                } else if (_a225 < _r430) return {
                  idx: _o228,
                  t: (1 - _r430) / (_a225 + 1 - _r430)
                };
              }
              return null;
            }(t, i, c ? -1 : 1);
            if (!_) return null;
            var u = _.idx,
              d = _.t;
            var p = u > 1 ? Ir(t.slice(0, u), i) : [],
              f = u < t.length ? Ir(t.slice(u), i) : [];
            p = p.map(function (t) {
              return new e.P(Lr(t.x), t.y);
            }), f = f.map(function (t) {
              return new e.P(Lr(t.x), t.y);
            });
            var m = _toConsumableArray(p);
            0 === m.length && m.push(f[f.length - 1]);
            var g = e.a3(m[m.length - 1].y, (0 === f.length ? p[0] : f[0]).y, d);
            var v;
            return v = c ? [new e.P(0, g), new e.P(0, 0), new e.P(1, 0), new e.P(1, g)] : [new e.P(1, g), new e.P(1, 1), new e.P(0, 1), new e.P(0, g)], m.push.apply(m, _toConsumableArray(v)), 0 === f.length ? m.push(p[0]) : m.push.apply(m, _toConsumableArray(f)), {
              polygon: m.map(function (t) {
                return new e._(t.x, t.y);
              }),
              unwrapped: !1
            };
          }(t, i);
          if (o) return o;
          var r = function (t, i) {
            var o = !1,
              r = -1 / 0,
              a = 0;
            for (var _e595 = 0; _e595 < t.length - 1; _e595++) t[_e595].x > r && (r = t[_e595].x, a = _e595);
            for (var _e596 = 0; _e596 < t.length - 1; _e596++) {
              var _i416 = (a + _e596) % (t.length - 1),
                _r431 = t[_i416],
                _n296 = t[_i416 + 1];
              Math.abs(_r431.x - _n296.x) > .5 && (_r431.x < _n296.x ? (_r431.x += 1, 0 === _i416 && (t[t.length - 1].x += 1)) : (_n296.x += 1, _i416 + 1 === t.length - 1 && (t[0].x += 1)), o = !0);
            }
            var n = e.ak(i.center.lng);
            return o && n < Math.abs(n - 1) && t.forEach(function (e) {
              e.x -= 1;
            }), {
              polygon: t,
              unwrapped: o
            };
          }(Ir(t, i).map(function (t) {
            return new e.P(Lr(t.x), t.y);
          }), i);
          return {
            polygon: r.polygon.map(function (t) {
              return new e._(t.x, t.y);
            }),
            unwrapped: r.unwrapped
          };
        }
      }], [{
        key: "createFromScreenPoints",
        value: function createFromScreenPoints(t, i) {
          var o, r;
          if (t instanceof e.P || "number" == typeof t[0]) {
            var _a226 = e.P.convert(t);
            o = [_a226], r = i.isPointAboveHorizon(_a226);
          } else {
            var _a227 = e.P.convert(t[0]),
              _n297 = e.P.convert(t[1]);
            o = [_a227, _n297], r = e.cx(_a227, _n297).every(function (e) {
              return i.isPointAboveHorizon(e);
            });
          }
          return new Sr(o, i.getCameraPoint(), r, i);
        }
      }]);
      return Sr;
    }();
    function Ir(t, i) {
      return e.cE(t, function (e) {
        var t = i.pointCoordinate3D(e);
        e.x = t.x, e.y = t.y;
      }, 1 / 256);
    }
    function Lr(e) {
      return e < 0 ? 1 + e % 1 : e % 1;
    }
    function Pr(e) {
      return 100 * e | 0;
    }
    function Rr(t, i) {
      var o = e.ae.identity([]);
      return e.ae.scale(o, o, [.5 * t.width, .5 * -t.height, 1]), e.ae.translate(o, o, [1, -1, 0]), e.ae.multiply(o, o, t.calculateProjMatrix(i.toUnwrapped())), Float32Array.from(o);
    }
    function Dr(e, t, i, o, r, a, n) {
      var s = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : !1;
      var l = e.tilesIn(o, n, s);
      l.sort(Mr);
      var c = [];
      var _iterator419 = _createForOfIteratorHelper(l),
        _step419;
      try {
        for (_iterator419.s(); !(_step419 = _iterator419.n()).done;) {
          var _o231 = _step419.value;
          c.push({
            wrappedTileID: _o231.tile.tileID.wrapped().key,
            queryResults: _o231.tile.queryRenderedFeatures(t, i, e._state, _o231, r, a, Rr(e.transform, _o231.tile.tileID), s)
          });
        }
      } catch (err) {
        _iterator419.e(err);
      } finally {
        _iterator419.f();
      }
      var h = function (e) {
        var t = {},
          i = {};
        var _iterator420 = _createForOfIteratorHelper(e),
          _step420;
        try {
          for (_iterator420.s(); !(_step420 = _iterator420.n()).done;) {
            var _o229 = _step420.value;
            var _e597 = _o229.queryResults,
              _r432 = _o229.wrappedTileID,
              _a228 = i[_r432] = i[_r432] || {};
            for (var _i417 in _e597) {
              var _o230 = _e597[_i417],
                _r433 = _a228[_i417] = _a228[_i417] || {},
                _n298 = t[_i417] = t[_i417] || [];
              var _iterator421 = _createForOfIteratorHelper(_o230),
                _step421;
              try {
                for (_iterator421.s(); !(_step421 = _iterator421.n()).done;) {
                  var _e598 = _step421.value;
                  _r433[_e598.featureIndex] || (_r433[_e598.featureIndex] = !0, _n298.push(_e598));
                }
              } catch (err) {
                _iterator421.e(err);
              } finally {
                _iterator421.f();
              }
            }
          }
        } catch (err) {
          _iterator420.e(err);
        } finally {
          _iterator420.f();
        }
        return t;
      }(c);
      for (var _t578 in h) h[_t578].forEach(function (t) {
        var i = t.feature,
          o = i.layer;
        o && "background" !== o.type && "sky" !== o.type && "slot" !== o.type && (i.source = o.source, o["source-layer"] && (i.sourceLayer = o["source-layer"]), i.state = void 0 !== i.id ? e.getFeatureState(o["source-layer"], i.id) : {});
      });
      return h;
    }
    function Ar(e, t) {
      var i = e.getRenderableIds().map(function (t) {
          return e.getTileByID(t);
        }),
        o = [],
        r = {};
      for (var _e599 = 0; _e599 < i.length; _e599++) {
        var _a229 = i[_e599],
          _n299 = _a229.tileID.canonical.key;
        r[_n299] || (r[_n299] = !0, _a229.querySourceFeatures(o, t));
      }
      return o;
    }
    function Mr(e, t) {
      var i = e.tileID,
        o = t.tileID;
      return i.overscaledZ - o.overscaledZ || i.canonical.y - o.canonical.y || i.wrap - o.wrap || i.canonical.x - o.canonical.x;
    }
    var zr = /*#__PURE__*/function () {
      function zr(e) {
        _classCallCheck(this, zr);
        this.style = e, this.layersGotHidden = !1, this.layers = [];
      }
      _createClass(zr, [{
        key: "processLayersChanged",
        value: function processLayersChanged() {
          this.layers = [];
          var e = !1,
            t = !1;
          for (var _i418 in this.style._mergedLayers) {
            var _o232 = this.style._mergedLayers[_i418];
            if ("fill-extrusion" === _o232.type) this.layers.push({
              layer: _o232,
              visible: e,
              visibilityChanged: t
            });else if ("model" === _o232.type) {
              var _i419 = this.style.getLayerSource(_o232);
              _i419 && "batched-model" === _i419.type && this.layers.push({
                layer: _o232,
                visible: e,
                visibilityChanged: t
              });
            }
          }
        }
      }, {
        key: "onNewFrame",
        value: function onNewFrame(e) {
          this.layersGotHidden = !1;
          var _iterator422 = _createForOfIteratorHelper(this.layers),
            _step422;
          try {
            for (_iterator422.s(); !(_step422 = _iterator422.n()).done;) {
              var _t579 = _step422.value;
              var _i420 = _t579.layer;
              var _o233 = !1;
              "fill-extrusion" === _i420.type ? _o233 = !_i420.isHidden(e) && _i420.paint.get("fill-extrusion-opacity") > 0 : "model" === _i420.type && (_o233 = !_i420.isHidden(e) && _i420.paint.get("model-opacity") > 0), this.layersGotHidden = this.layersGotHidden || !_o233 && _t579.visible, _t579.visible = _o233;
            }
          } catch (err) {
            _iterator422.e(err);
          } finally {
            _iterator422.f();
          }
        }
      }, {
        key: "updateZOffset",
        value: function updateZOffset(e, t) {
          this.currentBuildingBuckets = [];
          var _iterator423 = _createForOfIteratorHelper(this.layers),
            _step423;
          try {
            for (_iterator423.s(); !(_step423 = _iterator423.n()).done;) {
              var _e600 = _step423.value;
              var _i421 = _e600.layer,
                _o235 = this.style.getLayerSourceCache(_i421);
              var _r435 = 1;
              "fill-extrusion" === _i421.type && (_r435 = _e600.visible ? _i421.paint.get("fill-extrusion-vertical-scale") : 0);
              var _a231 = _o235 ? _o235.getTile(t) : null;
              if (!_a231 && _o235 && t.canonical.z > _o235.getSource().minzoom) {
                var _e601 = t.scaledTo(Math.min(_o235.getSource().maxzoom, t.overscaledZ - 1));
                for (; _e601.overscaledZ >= _o235.getSource().minzoom && (_a231 = _o235.getTile(_e601), !_a231 && 0 !== _e601.overscaledZ);) _e601 = _e601.scaledTo(_e601.overscaledZ - 1);
              }
              this.currentBuildingBuckets.push({
                bucket: _a231 ? _a231.getBucket(_i421) : null,
                tileID: _a231 ? _a231.tileID : t,
                verticalScale: _r435
              });
            }
          } catch (err) {
            _iterator423.e(err);
          } finally {
            _iterator423.f();
          }
          e.hasAnyZOffset = !1;
          var i = !1;
          for (var _o234 = 0; _o234 < e.symbolInstances.length; _o234++) {
            var _r434 = e.symbolInstances.get(_o234),
              _a230 = _r434.zOffset,
              _n300 = this._getHeightAtTileOffset(t, _r434.tileAnchorX, _r434.tileAnchorY);
            _r434.zOffset = _n300 !== Number.NEGATIVE_INFINITY ? _n300 : _a230, i || _a230 === _r434.zOffset || (i = !0), e.hasAnyZOffset || 0 === _r434.zOffset || (e.hasAnyZOffset = !0);
          }
          i && (e.zOffsetBuffersNeedUpload = !0, e.zOffsetSortDirty = !0);
        }
      }, {
        key: "_mapCoordToOverlappingTile",
        value: function _mapCoordToOverlappingTile(t, i, o, r) {
          var a = i,
            n = o;
          if (t.canonical.z !== r.canonical.z) {
            var _s247 = r.canonical,
              _l129 = 1 / (1 << t.canonical.z - _s247.z);
            a = (i + t.canonical.x * e.a4) * _l129 - _s247.x * e.a4 | 0, n = (o + t.canonical.y * e.a4) * _l129 - _s247.y * e.a4 | 0;
          }
          return {
            tileX: a,
            tileY: n
          };
        }
      }, {
        key: "_getHeightAtTileOffset",
        value: function _getHeightAtTileOffset(e, t, i) {
          var o, r;
          for (var _a232 = 0; _a232 < this.layers.length; ++_a232) {
            if ("fill-extrusion" !== this.layers[_a232].layer.type) continue;
            var _this$currentBuilding = this.currentBuildingBuckets[_a232],
              _n301 = _this$currentBuilding.bucket,
              _s248 = _this$currentBuilding.tileID,
              _l130 = _this$currentBuilding.verticalScale;
            if (!_n301) continue;
            var _this$_mapCoordToOver = this._mapCoordToOverlappingTile(e, t, i, _s248),
              _c111 = _this$_mapCoordToOver.tileX,
              _h84 = _this$_mapCoordToOver.tileY,
              _32 = _n301.getHeightAtTileCoord(_c111, _h84);
            _32 && void 0 !== _32.height && (_32.hidden ? o = _32.height : r = Math.max(_32.height * _l130, r || 0));
          }
          if (void 0 !== r) return r;
          for (var _r436 = 0; _r436 < this.layers.length; ++_r436) {
            var _a233 = this.layers[_r436];
            if ("model" !== _a233.layer.type || !_a233.visible) continue;
            var _this$currentBuilding2 = this.currentBuildingBuckets[_r436],
              _n302 = _this$currentBuilding2.bucket,
              _s249 = _this$currentBuilding2.tileID;
            if (!_n302) continue;
            var _this$_mapCoordToOver2 = this._mapCoordToOverlappingTile(e, t, i, _s249),
              _l131 = _this$_mapCoordToOver2.tileX,
              _c112 = _this$_mapCoordToOver2.tileY,
              _h85 = _n302.getHeightAtTileCoord(_l131, _c112);
            if (_h85 && !_h85.hidden) return void 0 === _h85.height && void 0 !== o ? Math.min(_h85.maxHeight, o) * _h85.verticalScale : _h85.height ? _h85.height * _h85.verticalScale : Number.NEGATIVE_INFINITY;
          }
          return this.layersGotHidden ? 0 : Number.NEGATIVE_INFINITY;
        }
      }]);
      return zr;
    }();
    function Or(t, i) {
      var o = {};
      for (var _e602 in t) "ref" !== _e602 && (o[_e602] = t[_e602]);
      return e.cG.forEach(function (e) {
        e in i && (o[e] = i[e]);
      }), o;
    }
    function Fr(e) {
      e = e.slice();
      var t = Object.create(null);
      for (var _i422 = 0; _i422 < e.length; _i422++) t[e[_i422].id] = e[_i422];
      for (var _i423 = 0; _i423 < e.length; _i423++) "ref" in e[_i423] && (e[_i423] = Or(e[_i423], t[e[_i423].ref]));
      return e;
    }
    var Br = {
      setStyle: "setStyle",
      addLayer: "addLayer",
      removeLayer: "removeLayer",
      setPaintProperty: "setPaintProperty",
      setLayoutProperty: "setLayoutProperty",
      setSlot: "setSlot",
      setFilter: "setFilter",
      addSource: "addSource",
      removeSource: "removeSource",
      setGeoJSONSourceData: "setGeoJSONSourceData",
      setLayerZoomRange: "setLayerZoomRange",
      setLayerProperty: "setLayerProperty",
      setCenter: "setCenter",
      setZoom: "setZoom",
      setBearing: "setBearing",
      setPitch: "setPitch",
      setSprite: "setSprite",
      setGlyphs: "setGlyphs",
      setTransition: "setTransition",
      setLight: "setLight",
      setTerrain: "setTerrain",
      setFog: "setFog",
      setCamera: "setCamera",
      setLights: "setLights",
      setProjection: "setProjection",
      addImport: "addImport",
      removeImport: "removeImport",
      updateImport: "updateImport"
    };
    function kr(e, t, i) {
      i.push({
        command: Br.addSource,
        args: [e, t[e]]
      });
    }
    function Nr(e, t, i) {
      t.push({
        command: Br.removeSource,
        args: [e]
      }), i[e] = !0;
    }
    function Ur(e, t, i, o) {
      Nr(e, i, o), kr(e, t, i);
    }
    function Gr(t, i, o) {
      var r;
      for (r in t[o]) if (t[o].hasOwnProperty(r) && "data" !== r && !e.d(t[o][r], i[o][r])) return !1;
      for (r in i[o]) if (i[o].hasOwnProperty(r) && "data" !== r && !e.d(t[o][r], i[o][r])) return !1;
      return !0;
    }
    function jr(t, i, o, r, a, n) {
      var s;
      for (s in i = i || {}, t = t || {}) t.hasOwnProperty(s) && (e.d(t[s], i[s]) || o.push({
        command: n,
        args: [r, s, i[s], a]
      }));
      for (s in i) i.hasOwnProperty(s) && !t.hasOwnProperty(s) && (e.d(t[s], i[s]) || o.push({
        command: n,
        args: [r, s, i[s], a]
      }));
    }
    function Vr(e) {
      return e.id;
    }
    function $r(e, t) {
      return e[t.id] = t, e;
    }
    var Zr = /*#__PURE__*/function () {
      function Zr(e, t) {
        _classCallCheck(this, Zr);
        this.reset(e, t);
      }
      _createClass(Zr, [{
        key: "reset",
        value: function reset(e, t) {
          this.points = e || [], this._distances = [0];
          for (var _e603 = 1; _e603 < this.points.length; _e603++) this._distances[_e603] = this._distances[_e603 - 1] + this.points[_e603].dist(this.points[_e603 - 1]);
          this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
        }
      }, {
        key: "lerp",
        value: function lerp(t) {
          if (1 === this.points.length) return this.points[0];
          t = e.au(t, 0, 1);
          var i = 1,
            o = this._distances[i];
          var r = t * this.paddedLength + this.padding;
          for (; o < r && i < this._distances.length;) o = this._distances[++i];
          var a = i - 1,
            n = this._distances[a],
            s = o - n,
            l = s > 0 ? (r - n) / s : 0;
          return this.points[a].mult(1 - l).add(this.points[i].mult(l));
        }
      }]);
      return Zr;
    }();
    var Wr = /*#__PURE__*/function () {
      function Wr(e, t, i) {
        _classCallCheck(this, Wr);
        var o = this.boxCells = [],
          r = this.circleCells = [];
        this.xCellCount = Math.ceil(e / i), this.yCellCount = Math.ceil(t / i);
        for (var _e604 = 0; _e604 < this.xCellCount * this.yCellCount; _e604++) o.push([]), r.push([]);
        this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e, this.height = t, this.xScale = this.xCellCount / e, this.yScale = this.yCellCount / t, this.boxUid = 0, this.circleUid = 0;
      }
      _createClass(Wr, [{
        key: "keysLength",
        value: function keysLength() {
          return this.boxKeys.length + this.circleKeys.length;
        }
      }, {
        key: "insert",
        value: function insert(e, t, i, o, r) {
          this._forEachCell(t, i, o, r, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e), this.bboxes.push(t), this.bboxes.push(i), this.bboxes.push(o), this.bboxes.push(r);
        }
      }, {
        key: "insertCircle",
        value: function insertCircle(e, t, i, o) {
          this._forEachCell(t - o, i - o, t + o, i + o, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e), this.circles.push(t), this.circles.push(i), this.circles.push(o);
        }
      }, {
        key: "_insertBoxCell",
        value: function _insertBoxCell(e, t, i, o, r, a) {
          this.boxCells[r].push(a);
        }
      }, {
        key: "_insertCircleCell",
        value: function _insertCircleCell(e, t, i, o, r, a) {
          this.circleCells[r].push(a);
        }
      }, {
        key: "_query",
        value: function _query(e, t, i, o, r, a) {
          if (i < 0 || e > this.width || o < 0 || t > this.height) return !r && [];
          var n = [];
          if (e <= 0 && t <= 0 && this.width <= i && this.height <= o) {
            if (r) return !0;
            for (var _e605 = 0; _e605 < this.boxKeys.length; _e605++) n.push({
              key: this.boxKeys[_e605],
              x1: this.bboxes[4 * _e605],
              y1: this.bboxes[4 * _e605 + 1],
              x2: this.bboxes[4 * _e605 + 2],
              y2: this.bboxes[4 * _e605 + 3]
            });
            for (var _e606 = 0; _e606 < this.circleKeys.length; _e606++) {
              var _t580 = this.circles[3 * _e606],
                _i424 = this.circles[3 * _e606 + 1],
                _o236 = this.circles[3 * _e606 + 2];
              n.push({
                key: this.circleKeys[_e606],
                x1: _t580 - _o236,
                y1: _i424 - _o236,
                x2: _t580 + _o236,
                y2: _i424 + _o236
              });
            }
            return a ? n.filter(a) : n;
          }
          return this._forEachCell(e, t, i, o, this._queryCell, n, {
            hitTest: r,
            seenUids: {
              box: {},
              circle: {}
            }
          }, a), r ? n.length > 0 : n;
        }
      }, {
        key: "_queryCircle",
        value: function _queryCircle(e, t, i, o, r) {
          var a = e - i,
            n = e + i,
            s = t - i,
            l = t + i;
          if (n < 0 || a > this.width || l < 0 || s > this.height) return !o && [];
          var c = [];
          return this._forEachCell(a, s, n, l, this._queryCellCircle, c, {
            hitTest: o,
            circle: {
              x: e,
              y: t,
              radius: i
            },
            seenUids: {
              box: {},
              circle: {}
            }
          }, r), o ? c.length > 0 : c;
        }
      }, {
        key: "query",
        value: function query(e, t, i, o, r) {
          return this._query(e, t, i, o, !1, r);
        }
      }, {
        key: "hitTest",
        value: function hitTest(e, t, i, o, r) {
          return this._query(e, t, i, o, !0, r);
        }
      }, {
        key: "hitTestCircle",
        value: function hitTestCircle(e, t, i, o) {
          return this._queryCircle(e, t, i, !0, o);
        }
      }, {
        key: "_queryCell",
        value: function _queryCell(e, t, i, o, r, a, n, s) {
          var l = n.seenUids,
            c = this.boxCells[r];
          if (null !== c) {
            var _r437 = this.bboxes;
            var _iterator424 = _createForOfIteratorHelper(c),
              _step424;
            try {
              for (_iterator424.s(); !(_step424 = _iterator424.n()).done;) {
                var _h86 = _step424.value;
                if (!l.box[_h86]) {
                  l.box[_h86] = !0;
                  var _c113 = 4 * _h86;
                  if (e <= _r437[_c113 + 2] && t <= _r437[_c113 + 3] && i >= _r437[_c113 + 0] && o >= _r437[_c113 + 1] && (!s || s(this.boxKeys[_h86]))) {
                    if (n.hitTest) return a.push(!0), !0;
                    a.push({
                      key: this.boxKeys[_h86],
                      x1: _r437[_c113],
                      y1: _r437[_c113 + 1],
                      x2: _r437[_c113 + 2],
                      y2: _r437[_c113 + 3]
                    });
                  }
                }
              }
            } catch (err) {
              _iterator424.e(err);
            } finally {
              _iterator424.f();
            }
          }
          var h = this.circleCells[r];
          if (null !== h) {
            var _r438 = this.circles;
            var _iterator425 = _createForOfIteratorHelper(h),
              _step425;
            try {
              for (_iterator425.s(); !(_step425 = _iterator425.n()).done;) {
                var _c114 = _step425.value;
                if (!l.circle[_c114]) {
                  l.circle[_c114] = !0;
                  var _h87 = 3 * _c114;
                  if (this._circleAndRectCollide(_r438[_h87], _r438[_h87 + 1], _r438[_h87 + 2], e, t, i, o) && (!s || s(this.circleKeys[_c114]))) {
                    if (n.hitTest) return a.push(!0), !0;
                    {
                      var _e607 = _r438[_h87],
                        _t581 = _r438[_h87 + 1],
                        _i425 = _r438[_h87 + 2];
                      a.push({
                        key: this.circleKeys[_c114],
                        x1: _e607 - _i425,
                        y1: _t581 - _i425,
                        x2: _e607 + _i425,
                        y2: _t581 + _i425
                      });
                    }
                  }
                }
              }
            } catch (err) {
              _iterator425.e(err);
            } finally {
              _iterator425.f();
            }
          }
        }
      }, {
        key: "_queryCellCircle",
        value: function _queryCellCircle(e, t, i, o, r, a, n, s) {
          var l = n.circle,
            c = n.seenUids,
            h = this.boxCells[r];
          if (null !== h) {
            var _e608 = this.bboxes;
            var _iterator426 = _createForOfIteratorHelper(h),
              _step426;
            try {
              for (_iterator426.s(); !(_step426 = _iterator426.n()).done;) {
                var _t582 = _step426.value;
                if (!c.box[_t582]) {
                  c.box[_t582] = !0;
                  var _i426 = 4 * _t582;
                  if (this._circleAndRectCollide(l.x, l.y, l.radius, _e608[_i426 + 0], _e608[_i426 + 1], _e608[_i426 + 2], _e608[_i426 + 3]) && (!s || s(this.boxKeys[_t582]))) return a.push(!0), !0;
                }
              }
            } catch (err) {
              _iterator426.e(err);
            } finally {
              _iterator426.f();
            }
          }
          var _ = this.circleCells[r];
          if (null !== _) {
            var _e609 = this.circles;
            var _iterator427 = _createForOfIteratorHelper(_),
              _step427;
            try {
              for (_iterator427.s(); !(_step427 = _iterator427.n()).done;) {
                var _t583 = _step427.value;
                if (!c.circle[_t583]) {
                  c.circle[_t583] = !0;
                  var _i427 = 3 * _t583;
                  if (this._circlesCollide(_e609[_i427], _e609[_i427 + 1], _e609[_i427 + 2], l.x, l.y, l.radius) && (!s || s(this.circleKeys[_t583]))) return a.push(!0), !0;
                }
              }
            } catch (err) {
              _iterator427.e(err);
            } finally {
              _iterator427.f();
            }
          }
        }
      }, {
        key: "_forEachCell",
        value: function _forEachCell(e, t, i, o, r, a, n, s) {
          var l = this._convertToXCellCoord(e),
            c = this._convertToYCellCoord(t),
            h = this._convertToXCellCoord(i),
            _ = this._convertToYCellCoord(o);
          for (var _u100 = l; _u100 <= h; _u100++) for (var _l132 = c; _l132 <= _; _l132++) if (r.call(this, e, t, i, o, this.xCellCount * _l132 + _u100, a, n, s)) return;
        }
      }, {
        key: "_convertToXCellCoord",
        value: function _convertToXCellCoord(e) {
          return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e * this.xScale)));
        }
      }, {
        key: "_convertToYCellCoord",
        value: function _convertToYCellCoord(e) {
          return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e * this.yScale)));
        }
      }, {
        key: "_circlesCollide",
        value: function _circlesCollide(e, t, i, o, r, a) {
          var n = o - e,
            s = r - t,
            l = i + a;
          return l * l > n * n + s * s;
        }
      }, {
        key: "_circleAndRectCollide",
        value: function _circleAndRectCollide(e, t, i, o, r, a, n) {
          var s = (a - o) / 2,
            l = Math.abs(e - (o + s));
          if (l > s + i) return !1;
          var c = (n - r) / 2,
            h = Math.abs(t - (r + c));
          if (h > c + i) return !1;
          if (l <= s || h <= c) return !0;
          var _ = l - s,
            u = h - c;
          return _ * _ + u * u <= i * i;
        }
      }]);
      return Wr;
    }();
    var Hr = 100;
    var qr = /*#__PURE__*/function () {
      function qr(e, t) {
        var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Wr(e.width + 200, e.height + 200, 25);
        var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Wr(e.width + 200, e.height + 200, 25);
        _classCallCheck(this, qr);
        this.transform = e, this.grid = i, this.ignoredGrid = o, this.pitchfactor = Math.cos(e._pitch) * e.cameraToCenterDistance, this.screenRightBoundary = e.width + Hr, this.screenBottomBoundary = e.height + Hr, this.gridRightBoundary = e.width + 200, this.gridBottomBoundary = e.height + 200, this.fogState = t;
      }
      _createClass(qr, [{
        key: "placeCollisionBox",
        value: function placeCollisionBox(e, t, i, o, r, a, n, s) {
          var l = i.projectedAnchorX,
            c = i.projectedAnchorY,
            h = i.projectedAnchorZ;
          var _ = i.elevation,
            u = i.tileID,
            d = e.getProjection();
          if (_ && u) {
            var _d$upVector = d.upVector(u.canonical, i.tileAnchorX, i.tileAnchorY),
              _d$upVector2 = _slicedToArray(_d$upVector, 3),
              _e610 = _d$upVector2[0],
              _t584 = _d$upVector2[1],
              _o237 = _d$upVector2[2],
              _r439 = d.upVectorScale(u.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
            l += _e610 * _ * _r439, c += _t584 * _ * _r439, h += _o237 * _ * _r439;
          }
          var p = this.projectAndGetPerspectiveRatio(n, l, c, h, i.tileID, "globe" === d.name || !!_ || this.transform.pitch > 0, d),
            f = a * p.perspectiveRatio,
            m = (i.x1 * t + o.x - i.padding) * f + p.point.x,
            g = (i.y1 * t + o.y - i.padding) * f + p.point.y,
            v = (i.x2 * t + o.x + i.padding) * f + p.point.x,
            x = (i.y2 * t + o.y + i.padding) * f + p.point.y,
            y = p.perspectiveRatio <= .55 || p.occluded;
          return !this.isInsideGrid(m, g, v, x) || !r && this.grid.hitTest(m, g, v, x, s) || y ? {
            box: [],
            offscreen: !1,
            occluded: p.occluded
          } : {
            box: [m, g, v, x],
            offscreen: this.isOffscreen(m, g, v, x),
            occluded: !1
          };
        }
      }, {
        key: "placeCollisionCircles",
        value: function placeCollisionCircles(t, i, o, r, a, n, s, l, c, h, _, u, d, p, f) {
          var m = [],
            g = this.transform.elevation,
            v = t.getProjection(),
            x = g ? g.getAtTileOffsetFunc(f, this.transform.center.lat, this.transform.worldSize, v) : null,
            y = new e.P(o.tileAnchorX, o.tileAnchorY);
          var _v$projectTilePoint = v.projectTilePoint(y.x, y.y, f.canonical),
            b = _v$projectTilePoint.x,
            w = _v$projectTilePoint.y,
            T = _v$projectTilePoint.z;
          if (x) {
            var _x29 = x(y),
              _x30 = _slicedToArray(_x29, 3),
              _e611 = _x30[0],
              _t585 = _x30[1],
              _i428 = _x30[2];
            b += _e611, w += _t585, T += _i428;
          }
          var E = "globe" === v.name,
            C = this.projectAndGetPerspectiveRatio(s, b, w, T, f, E || !!g || this.transform.pitch > 0, v),
            S = C.perspectiveRatio,
            I = (_ ? n / S : n * S) / e.bP,
            L = Qt(b, w, T, l),
            P = C.signedDistanceFromCamera > 0 ? ei(I, a, o.lineOffsetX * I, o.lineOffsetY * I, !1, L, y, o, r, l, {}, g && !_ ? x : null, _ && !!g, v, f, _) : null;
          var R = !1,
            D = !1,
            A = !0;
          if (P && !C.occluded) {
            var _t586 = .5 * d * S + p,
              _o238 = new e.P(-100, -100),
              _r440 = new e.P(this.screenRightBoundary, this.screenBottomBoundary),
              _a234 = new Zr(),
              _n303 = P.first,
              _s250 = P.last,
              _l133 = _n303.path.length;
            var _33 = [];
            for (var _e612 = _l133 - 1; _e612 >= 1; _e612--) _33.push(_n303.path[_e612]);
            for (var _e613 = 1; _e613 < _s250.path.length; _e613++) _33.push(_s250.path[_e613]);
            var _f56 = 2.5 * _t586;
            c && (_33 = _33.map(function (_ref185, o) {
              var _ref186 = _slicedToArray(_ref185, 3),
                e = _ref186[0],
                t = _ref186[1],
                i = _ref186[2];
              return x && !E && (i = x(o < _l133 - 1 ? _n303.tilePath[_l133 - 1 - o] : _s250.tilePath[o - _l133 + 2])[2]), Qt(e, t, i, c);
            }), _33.some(function (e) {
              return e[3] <= 0;
            }) && (_33 = []));
            var _g35 = [];
            if (_33.length > 0) {
              var _t587 = 1 / 0,
                _i429 = -1 / 0,
                _a235 = 1 / 0,
                _n304 = -1 / 0;
              var _iterator428 = _createForOfIteratorHelper(_33),
                _step428;
              try {
                for (_iterator428.s(); !(_step428 = _iterator428.n()).done;) {
                  var _e614 = _step428.value;
                  _t587 = Math.min(_t587, _e614[0]), _a235 = Math.min(_a235, _e614[1]), _i429 = Math.max(_i429, _e614[0]), _n304 = Math.max(_n304, _e614[1]);
                }
              } catch (err) {
                _iterator428.e(err);
              } finally {
                _iterator428.f();
              }
              _i429 >= _o238.x && _t587 <= _r440.x && _n304 >= _o238.y && _a235 <= _r440.y && (_g35 = [_33.map(function (t) {
                return new e.P(t[0], t[1]);
              })], (_t587 < _o238.x || _i429 > _r440.x || _a235 < _o238.y || _n304 > _r440.y) && (_g35 = e.cH(_g35, _o238.x, _o238.y, _r440.x, _r440.y)));
            }
            var _iterator429 = _createForOfIteratorHelper(_g35),
              _step429;
            try {
              for (_iterator429.s(); !(_step429 = _iterator429.n()).done;) {
                var _e615 = _step429.value;
                _a234.reset(_e615, .25 * _t586);
                var _o239 = 0;
                _o239 = _a234.length <= .5 * _t586 ? 1 : Math.ceil(_a234.paddedLength / _f56) + 1;
                for (var _e616 = 0; _e616 < _o239; _e616++) {
                  var _r441 = _e616 / Math.max(_o239 - 1, 1),
                    _n305 = _a234.lerp(_r441),
                    _s251 = _n305.x + Hr,
                    _l134 = _n305.y + Hr;
                  m.push(_s251, _l134, _t586, 0);
                  var _c115 = _s251 - _t586,
                    _34 = _l134 - _t586,
                    _d49 = _s251 + _t586,
                    _p68 = _l134 + _t586;
                  if (A = A && this.isOffscreen(_c115, _34, _d49, _p68), D = D || this.isInsideGrid(_c115, _34, _d49, _p68), !i && this.grid.hitTestCircle(_s251, _l134, _t586, u) && (R = !0, !h)) return {
                    circles: [],
                    offscreen: !1,
                    collisionDetected: R,
                    occluded: !1
                  };
                }
              }
            } catch (err) {
              _iterator429.e(err);
            } finally {
              _iterator429.f();
            }
          }
          return {
            circles: !h && R || !D ? [] : m,
            offscreen: A,
            collisionDetected: R,
            occluded: C.occluded
          };
        }
      }, {
        key: "queryRenderedSymbols",
        value: function queryRenderedSymbols(t) {
          if (0 === t.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
          var i = [];
          var o = 1 / 0,
            r = 1 / 0,
            a = -1 / 0,
            n = -1 / 0;
          var _iterator430 = _createForOfIteratorHelper(t),
            _step430;
          try {
            for (_iterator430.s(); !(_step430 = _iterator430.n()).done;) {
              var _s252 = _step430.value;
              var _t588 = new e.P(_s252.x + Hr, _s252.y + Hr);
              o = Math.min(o, _t588.x), r = Math.min(r, _t588.y), a = Math.max(a, _t588.x), n = Math.max(n, _t588.y), i.push(_t588);
            }
          } catch (err) {
            _iterator430.e(err);
          } finally {
            _iterator430.f();
          }
          var s = this.grid.query(o, r, a, n).concat(this.ignoredGrid.query(o, r, a, n)),
            l = {},
            c = {};
          var _iterator431 = _createForOfIteratorHelper(s),
            _step431;
          try {
            for (_iterator431.s(); !(_step431 = _iterator431.n()).done;) {
              var _t589 = _step431.value;
              var _o240 = _t589.key;
              if (void 0 === l[_o240.bucketInstanceId] && (l[_o240.bucketInstanceId] = {}), l[_o240.bucketInstanceId][_o240.featureIndex]) continue;
              var _r442 = [new e.P(_t589.x1, _t589.y1), new e.P(_t589.x2, _t589.y1), new e.P(_t589.x2, _t589.y2), new e.P(_t589.x1, _t589.y2)];
              e.cI(i, _r442) && (l[_o240.bucketInstanceId][_o240.featureIndex] = !0, void 0 === c[_o240.bucketInstanceId] && (c[_o240.bucketInstanceId] = []), c[_o240.bucketInstanceId].push(_o240.featureIndex));
            }
          } catch (err) {
            _iterator431.e(err);
          } finally {
            _iterator431.f();
          }
          return c;
        }
      }, {
        key: "insertCollisionBox",
        value: function insertCollisionBox(e, t, i, o, r) {
          (t ? this.ignoredGrid : this.grid).insert({
            bucketInstanceId: i,
            featureIndex: o,
            collisionGroupID: r
          }, e[0], e[1], e[2], e[3]);
        }
      }, {
        key: "insertCollisionCircles",
        value: function insertCollisionCircles(e, t, i, o, r) {
          var a = t ? this.ignoredGrid : this.grid,
            n = {
              bucketInstanceId: i,
              featureIndex: o,
              collisionGroupID: r
            };
          for (var _t590 = 0; _t590 < e.length; _t590 += 4) a.insertCircle(n, e[_t590], e[_t590 + 1], e[_t590 + 2]);
        }
      }, {
        key: "projectAndGetPerspectiveRatio",
        value: function projectAndGetPerspectiveRatio(t, i, o, r, a, n, s) {
          var l = [i, o, r, 1];
          var c = !1;
          if (r || this.transform.pitch > 0) {
            if (e.aB.transformMat4(l, l, t), this.fogState && a && "globe" !== s.name) {
              var _t591 = function (t, i, o, r, a, n) {
                var s = n.calculateFogTileMatrix(a),
                  l = [i, o, r];
                return e.$.transformMat4(l, l, s), et(t, e.$.length(l), n.pitch, n._fov);
              }(this.fogState, i, o, r, a.toUnwrapped(), this.transform);
              c = _t591 > .9;
            }
          } else si(l, l, t);
          var h = l[3];
          return {
            point: new e.P((l[0] / h + 1) / 2 * this.transform.width + Hr, (-l[1] / h + 1) / 2 * this.transform.height + Hr),
            perspectiveRatio: Math.min(.5 + this.transform.getCameraToCenterDistance(s) / h * .5, 1.5),
            signedDistanceFromCamera: h,
            occluded: n && l[2] > h || c
          };
        }
      }, {
        key: "isOffscreen",
        value: function isOffscreen(e, t, i, o) {
          return i < Hr || e >= this.screenRightBoundary || o < Hr || t > this.screenBottomBoundary;
        }
      }, {
        key: "isInsideGrid",
        value: function isInsideGrid(e, t, i, o) {
          return i >= 0 && e < this.gridRightBoundary && o >= 0 && t < this.gridBottomBoundary;
        }
      }, {
        key: "getViewportMatrix",
        value: function getViewportMatrix() {
          var t = e.ae.identity([]);
          return e.ae.translate(t, t, [-100, -100, 0]), t;
        }
      }]);
      return qr;
    }();
    var Xr = /*#__PURE__*/function () {
      function Xr(e, t, i, o) {
        _classCallCheck(this, Xr);
        this.opacity = e ? Math.max(0, Math.min(1, e.opacity + (e.placed ? t : -t))) : o && i ? 1 : 0, this.placed = i;
      }
      _createClass(Xr, [{
        key: "isHidden",
        value: function isHidden() {
          return 0 === this.opacity && !this.placed;
        }
      }]);
      return Xr;
    }();
    var Qr = /*#__PURE__*/function () {
      function Qr(e, t, i, o, r) {
        var a = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
        _classCallCheck(this, Qr);
        this.text = new Xr(e ? e.text : null, t, i, r), this.icon = new Xr(e ? e.icon : null, t, o, r), this.clipped = a;
      }
      _createClass(Qr, [{
        key: "isHidden",
        value: function isHidden() {
          return this.text.isHidden() && this.icon.isHidden();
        }
      }]);
      return Qr;
    }();
    var Yr = /*#__PURE__*/_createClass(function Yr(e, t, i) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      _classCallCheck(this, Yr);
      this.text = e, this.icon = t, this.skipFade = i, this.clipped = o;
    });
    var Jr = /*#__PURE__*/_createClass(function Jr() {
      _classCallCheck(this, Jr);
      this.invProjMatrix = e.ae.create(), this.viewportMatrix = e.ae.create(), this.circles = [];
    });
    var Kr = /*#__PURE__*/_createClass(function Kr(e, t, i, o, r) {
      _classCallCheck(this, Kr);
      this.bucketInstanceId = e, this.featureIndex = t, this.sourceLayerIndex = i, this.bucketIndex = o, this.tileID = r;
    });
    var ea = /*#__PURE__*/function () {
      function ea(e) {
        _classCallCheck(this, ea);
        this.crossSourceCollisions = e, this.maxGroupID = 0, this.collisionGroups = {};
      }
      _createClass(ea, [{
        key: "get",
        value: function get(e) {
          if (this.crossSourceCollisions) return {
            ID: 0,
            predicate: null
          };
          if (!this.collisionGroups[e]) {
            var _t592 = ++this.maxGroupID;
            this.collisionGroups[e] = {
              ID: _t592,
              predicate: function predicate(e) {
                return e.collisionGroupID === _t592;
              }
            };
          }
          return this.collisionGroups[e];
        }
      }]);
      return ea;
    }();
    function ta(t, i, o, r, a) {
      var _e$bS2 = e.bS(t),
        n = _e$bS2.horizontalAlign,
        s = _e$bS2.verticalAlign,
        l = -(n - .5) * i,
        c = -(s - .5) * o,
        h = e.bR(t, r);
      return new e.P(l + h[0] * a, c + h[1] * a);
    }
    function ia(t, i, o, r, a) {
      var n = new e.P(t, i);
      return o && n._rotate(r ? a : -a), n;
    }
    var oa = /*#__PURE__*/function () {
      function oa(e, t, i, o, r, a) {
        _classCallCheck(this, oa);
        this.transform = e.clone(), this.projection = e.projection.name, this.collisionIndex = new qr(this.transform, r), this.buildingIndex = a, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = t, this.retainedQueryData = {}, this.collisionGroups = new ea(i), this.collisionCircleArrays = {}, this.prevPlacement = o, o && (o.prevPlacement = void 0), this.placedOrientations = {};
      }
      _createClass(oa, [{
        key: "getBucketParts",
        value: function getBucketParts(t, i, o, r) {
          var a = o.getBucket(i),
            n = o.latestFeatureIndex;
          if (!a || !n || i.fqid !== a.layerIds[0]) return;
          var s = a.layers[0].layout,
            l = o.collisionBoxArray,
            c = Math.pow(2, this.transform.zoom - o.tileID.overscaledZ),
            h = o.tileSize / e.a4,
            _ = o.tileID.toUnwrapped();
          this.transform.setProjection(a.projection);
          var u = (d = o.tileID, p = a.getProjection(), f = this.transform, p.name === this.projection ? f.calculateProjMatrix(d.toUnwrapped()) : go(f, p, d));
          var d, p, f;
          var m = "map" === s.get("text-pitch-alignment"),
            g = "map" === s.get("text-rotation-alignment");
          i.compileFilter();
          var v = i.dynamicFilter(),
            x = i.dynamicFilterNeedsFeature(),
            y = this.transform.calculatePixelsToTileUnitsMatrix(o),
            b = qt(u, o.tileID.canonical, m, g, this.transform, a.getProjection(), y);
          var w = null;
          if (m) {
            var _t593 = Xt(u, o.tileID.canonical, m, g, this.transform, a.getProjection(), y);
            w = e.ae.multiply([], this.transform.labelPlaneMatrix, _t593);
          }
          var T = null;
          v && o.latestFeatureIndex && (T = {
            unwrappedTileID: _,
            dynamicFilter: v,
            dynamicFilterNeedsFeature: x,
            featureIndex: o.latestFeatureIndex
          }), this.retainedQueryData[a.bucketInstanceId] = new Kr(a.bucketInstanceId, n, a.sourceLayerIndex, a.index, o.tileID);
          var E = {
            bucket: a,
            layout: s,
            posMatrix: u,
            textLabelPlaneMatrix: b,
            labelToScreenMatrix: w,
            clippingData: T,
            scale: c,
            textPixelRatio: h,
            holdingForFade: o.holdingForFade(),
            collisionBoxArray: l,
            partiallyEvaluatedTextSize: e.aE(a.textSizeData, this.transform.zoom),
            partiallyEvaluatedIconSize: e.aE(a.iconSizeData, this.transform.zoom),
            collisionGroup: this.collisionGroups.get(a.sourceID)
          };
          if (r) {
            var _iterator432 = _createForOfIteratorHelper(a.sortKeyRanges),
              _step432;
            try {
              for (_iterator432.s(); !(_step432 = _iterator432.n()).done;) {
                var _e617 = _step432.value;
                var _i430 = _e617.sortKey,
                  _o241 = _e617.symbolInstanceStart,
                  _r443 = _e617.symbolInstanceEnd;
                t.push({
                  sortKey: _i430,
                  symbolInstanceStart: _o241,
                  symbolInstanceEnd: _r443,
                  parameters: E
                });
              }
            } catch (err) {
              _iterator432.e(err);
            } finally {
              _iterator432.f();
            }
          } else t.push({
            symbolInstanceStart: 0,
            symbolInstanceEnd: a.symbolInstances.length,
            parameters: E
          });
        }
      }, {
        key: "attemptAnchorPlacement",
        value: function attemptAnchorPlacement(e, t, i, o, r, a, n, s, l, c, h, _, u, d, p, f, m, g) {
          var v = _.textOffset0,
            x = _.textOffset1,
            y = _.crossTileID,
            b = [v, x],
            w = ta(e, i, o, b, r),
            T = this.collisionIndex.placeCollisionBox(d, r, t, ia(w.x, w.y, a, n, this.transform.angle), h, s, l, c.predicate);
          if (f) {
            var _e618 = d.getSymbolInstanceIconSize(g, this.transform.zoom, _.placedIconSymbolIndex);
            if (0 === this.collisionIndex.placeCollisionBox(d, _e618, f, ia(w.x, w.y, a, n, this.transform.angle), h, s, l, c.predicate).box.length) return;
          }
          if (T.box.length > 0) {
            var _t594;
            return this.prevPlacement && this.prevPlacement.variableOffsets[y] && this.prevPlacement.placements[y] && this.prevPlacement.placements[y].text && (_t594 = this.prevPlacement.variableOffsets[y].anchor), this.variableOffsets[y] = {
              textOffset: b,
              width: i,
              height: o,
              anchor: e,
              textScale: r,
              prevAnchor: _t594
            }, this.markUsedJustification(d, e, _, p), d.allowVerticalPlacement && (this.markUsedOrientation(d, p, _), this.placedOrientations[y] = p), {
              shift: w,
              placedGlyphBoxes: T
            };
          }
        }
      }, {
        key: "placeLayerBucketPart",
        value: function placeLayerBucketPart(t, i, o, r) {
          var _this142 = this;
          var _t$parameters = t.parameters,
            a = _t$parameters.bucket,
            n = _t$parameters.layout,
            s = _t$parameters.posMatrix,
            l = _t$parameters.textLabelPlaneMatrix,
            c = _t$parameters.labelToScreenMatrix,
            h = _t$parameters.clippingData,
            _ = _t$parameters.textPixelRatio,
            u = _t$parameters.holdingForFade,
            d = _t$parameters.collisionBoxArray,
            p = _t$parameters.partiallyEvaluatedTextSize,
            f = _t$parameters.partiallyEvaluatedIconSize,
            m = _t$parameters.collisionGroup,
            g = n.get("text-optional"),
            v = n.get("icon-optional"),
            x = n.get("text-allow-overlap"),
            y = n.get("icon-allow-overlap"),
            b = "map" === n.get("text-rotation-alignment"),
            w = "map" === n.get("text-pitch-alignment"),
            T = "viewport-y" === n.get("symbol-z-order"),
            E = n.get("symbol-z-elevate");
          this.transform.setProjection(a.projection);
          var C = x && (y || !a.hasIconData() || v),
            S = y && (x || !a.hasTextData() || g);
          !a.collisionArrays && d && a.deserializeCollisionBoxes(d), o && r && a.updateCollisionDebugBuffers(this.transform.zoom, d);
          var I = function I(t, r, d) {
            var T = t.crossTileID,
              E = t.numVerticalGlyphVertices;
            if (h) {
              var _o242 = {
                zoom: _this142.transform.zoom,
                pitch: _this142.transform.pitch
              };
              var _r444 = null;
              if (h.dynamicFilterNeedsFeature) {
                var _e619 = _this142.retainedQueryData[a.bucketInstanceId];
                _r444 = h.featureIndex.loadFeature({
                  featureIndex: t.featureIndex,
                  bucketIndex: _e619.bucketIndex,
                  sourceLayerIndex: _e619.sourceLayerIndex,
                  layoutVertexArrayOffset: 0
                });
              }
              if (!(0, h.dynamicFilter)(_o242, _r444, _this142.retainedQueryData[a.bucketInstanceId].tileID.canonical, new e.P(t.tileAnchorX, t.tileAnchorY), _this142.transform.calculateDistanceTileData(h.unwrappedTileID))) return _this142.placements[T] = new Yr(!1, !1, !1, !0), void i.add(T);
            }
            if (i.has(T)) return;
            if (u) return void (_this142.placements[T] = new Yr(!1, !1, !1));
            var I = !1,
              L = !1,
              P = !0,
              R = !1,
              D = !1,
              A = null,
              M = {
                box: null,
                offscreen: null,
                occluded: null
              },
              z = {
                box: null,
                offscreen: null,
                occluded: null
              },
              O = null,
              F = null,
              B = null,
              k = 0,
              N = 0,
              U = 0;
            d.textFeatureIndex ? k = d.textFeatureIndex : t.useRuntimeCollisionCircles && (k = t.featureIndex), d.verticalTextFeatureIndex && (N = d.verticalTextFeatureIndex);
            var G = function G(e) {
                e.tileID = _this142.retainedQueryData[a.bucketInstanceId].tileID;
                var i = _this142.transform.elevation;
                e.elevation = t.zOffset + (i ? i.getAtTileOffset(e.tileID, e.tileAnchorX, e.tileAnchorY) : 0);
              },
              j = d.textBox;
            if (j) {
              G(j);
              var _i431 = function _i431(i) {
                  var o = e.aF.horizontal;
                  if (a.allowVerticalPlacement && !i && _this142.prevPlacement) {
                    var _e620 = _this142.prevPlacement.placedOrientations[T];
                    _e620 && (_this142.placedOrientations[T] = _e620, o = _e620, _this142.markUsedOrientation(a, o, t));
                  }
                  return o;
                },
                _o243 = function _o243(t, i) {
                  if (a.allowVerticalPlacement && E > 0 && d.verticalTextBox) {
                    var _iterator433 = _createForOfIteratorHelper(a.writingModes),
                      _step433;
                    try {
                      for (_iterator433.s(); !(_step433 = _iterator433.n()).done;) {
                        var _o244 = _step433.value;
                        if (_o244 === e.aF.vertical ? (M = i(), z = M) : M = t(), M && M.box && M.box.length) break;
                      }
                    } catch (err) {
                      _iterator433.e(err);
                    } finally {
                      _iterator433.f();
                    }
                  } else M = t();
                };
              if (n.get("text-variable-anchor")) {
                var _l135 = n.get("text-variable-anchor");
                if (_this142.prevPlacement && _this142.prevPlacement.variableOffsets[T]) {
                  var _e621 = _this142.prevPlacement.variableOffsets[T];
                  _l135.indexOf(_e621.anchor) > 0 && (_l135 = _l135.filter(function (t) {
                    return t !== _e621.anchor;
                  }), _l135.unshift(_e621.anchor));
                }
                var _c116 = function _c116(e, i, o) {
                  var n = a.getSymbolInstanceTextSize(p, t, _this142.transform.zoom, r),
                    c = (e.x2 - e.x1) * n + 2 * e.padding,
                    h = (e.y2 - e.y1) * n + 2 * e.padding,
                    u = t.hasIconTextFit && !y ? i : null;
                  u && G(u);
                  var d = {
                    box: [],
                    offscreen: !1,
                    occluded: !1
                  };
                  var g = x ? 2 * _l135.length : _l135.length;
                  for (var _i432 = 0; _i432 < g; ++_i432) {
                    var _g36 = _this142.attemptAnchorPlacement(_l135[_i432 % _l135.length], e, c, h, n, b, w, _, s, m, _i432 >= _l135.length, t, r, a, o, u, p, f);
                    if (_g36 && (d = _g36.placedGlyphBoxes, d && d.box && d.box.length)) {
                      I = !0, A = _g36.shift;
                      break;
                    }
                  }
                  return d;
                };
                _o243(function () {
                  return _c116(j, d.iconBox, e.aF.horizontal);
                }, function () {
                  var t = d.verticalTextBox;
                  return t && G(t), a.allowVerticalPlacement && !(M && M.box && M.box.length) && E > 0 && t ? _c116(t, d.verticalIconBox, e.aF.vertical) : {
                    box: null,
                    offscreen: null,
                    occluded: null
                  };
                }), M && (I = M.box, P = M.offscreen, R = M.occluded);
                var _h88 = _i431(!(!M || !M.box));
                if (!I && _this142.prevPlacement) {
                  var _e622 = _this142.prevPlacement.variableOffsets[T];
                  _e622 && (_this142.variableOffsets[T] = _e622, _this142.markUsedJustification(a, _e622.anchor, t, _h88));
                }
              } else {
                var _n306 = function _n306(i, o) {
                  var n = a.getSymbolInstanceTextSize(p, t, _this142.transform.zoom, r),
                    l = _this142.collisionIndex.placeCollisionBox(a, n, i, new e.P(0, 0), x, _, s, m.predicate);
                  return l && l.box && l.box.length && (_this142.markUsedOrientation(a, o, t), _this142.placedOrientations[T] = o), l;
                };
                _o243(function () {
                  return _n306(j, e.aF.horizontal);
                }, function () {
                  var t = d.verticalTextBox;
                  return a.allowVerticalPlacement && E > 0 && t ? (G(t), _n306(t, e.aF.vertical)) : {
                    box: null,
                    offscreen: null,
                    occluded: null
                  };
                }), _i431(!!(M && M.box && M.box.length));
              }
            }
            if (O = M, I = O && O.box && O.box.length > 0, P = O && O.offscreen, R = O && O.occluded, t.useRuntimeCollisionCircles) {
              var _i433 = a.text.placedSymbolArray.get(t.centerJustifiedTextSymbolIndex >= 0 ? t.centerJustifiedTextSymbolIndex : t.verticalPlacedTextSymbolIndex),
                _r445 = e.aG(a.textSizeData, p, _i433),
                _h89 = n.get("text-padding");
              F = _this142.collisionIndex.placeCollisionCircles(a, x, _i433, a.lineVertexArray, a.glyphOffsetArray, _r445, s, l, c, o, w, m.predicate, t.collisionCircleDiameter * _r445 / e.bP, _h89, _this142.retainedQueryData[a.bucketInstanceId].tileID), I = x || F.circles.length > 0 && !F.collisionDetected, P = P && F.offscreen, R = F.occluded;
            }
            if (d.iconFeatureIndex && (U = d.iconFeatureIndex), d.iconBox) {
              var _i434 = function _i434(i) {
                G(i);
                var o = t.hasIconTextFit && A ? ia(A.x, A.y, b, w, _this142.transform.angle) : new e.P(0, 0),
                  r = a.getSymbolInstanceIconSize(f, _this142.transform.zoom, t.placedIconSymbolIndex);
                return _this142.collisionIndex.placeCollisionBox(a, r, i, o, y, _, s, m.predicate);
              };
              z && z.box && z.box.length && d.verticalIconBox ? (B = _i434(d.verticalIconBox), L = B.box.length > 0) : (B = _i434(d.iconBox), L = B.box.length > 0), P = P && B.offscreen, D = B.occluded;
            }
            var V = g || 0 === t.numHorizontalGlyphVertices && 0 === E,
              $ = v || 0 === t.numIconVertices;
            if (V || $ ? $ ? V || (L = L && I) : I = L && I : L = I = L && I, I && O && O.box && _this142.collisionIndex.insertCollisionBox(O.box, n.get("text-ignore-placement"), a.bucketInstanceId, z && z.box && N ? N : k, m.ID), L && B && _this142.collisionIndex.insertCollisionBox(B.box, n.get("icon-ignore-placement"), a.bucketInstanceId, U, m.ID), F && (I && _this142.collisionIndex.insertCollisionCircles(F.circles, n.get("text-ignore-placement"), a.bucketInstanceId, k, m.ID), o)) {
              var _e623 = a.bucketInstanceId;
              var _t595 = _this142.collisionCircleArrays[_e623];
              void 0 === _t595 && (_t595 = _this142.collisionCircleArrays[_e623] = new Jr());
              for (var _e624 = 0; _e624 < F.circles.length; _e624 += 4) _t595.circles.push(F.circles[_e624 + 0]), _t595.circles.push(F.circles[_e624 + 1]), _t595.circles.push(F.circles[_e624 + 2]), _t595.circles.push(F.collisionDetected ? 1 : 0);
            }
            var Z = "globe" !== a.projection.name;
            C = C && (Z || !R), S = S && (Z || !D), _this142.placements[T] = new Yr(I || C, L || S, P || a.justReloaded), i.add(T);
          };
          if (E && this.buildingIndex && (this.buildingIndex.updateZOffset(a, this.retainedQueryData[a.bucketInstanceId].tileID), a.updateZOffset()), T) {
            var _t596 = a.getSortedSymbolIndexes(this.transform.angle);
            for (var _e625 = _t596.length - 1; _e625 >= 0; --_e625) {
              var _i435 = _t596[_e625];
              I(a.symbolInstances.get(_i435), _i435, a.collisionArrays[_i435]);
            }
            a.hasAnyZOffset && e.w("".concat(a.layerIds[0], " layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y"));
          } else if (a.hasAnyZOffset) {
            var _e626 = a.getSortedIndexesByZOffset();
            for (var _t597 = 0; _t597 < _e626.length; ++_t597) {
              var _i436 = _e626[_t597];
              I(a.symbolInstances.get(_i436), _i436, a.collisionArrays[_i436]);
            }
          } else for (var _e627 = t.symbolInstanceStart; _e627 < t.symbolInstanceEnd; _e627++) I(a.symbolInstances.get(_e627), _e627, a.collisionArrays[_e627]);
          if (o && a.bucketInstanceId in this.collisionCircleArrays) {
            var _t598 = this.collisionCircleArrays[a.bucketInstanceId];
            e.ae.invert(_t598.invProjMatrix, s), _t598.viewportMatrix = this.collisionIndex.getViewportMatrix();
          }
          a.justReloaded = !1;
        }
      }, {
        key: "markUsedJustification",
        value: function markUsedJustification(t, i, o, r) {
          var a = o.leftJustifiedTextSymbolIndex,
            n = o.centerJustifiedTextSymbolIndex,
            s = o.rightJustifiedTextSymbolIndex,
            l = o.verticalPlacedTextSymbolIndex,
            c = o.crossTileID,
            h = e.cM(i),
            _ = r === e.aF.vertical ? l : "left" === h ? a : "center" === h ? n : "right" === h ? s : -1;
          a >= 0 && (t.text.placedSymbolArray.get(a).crossTileID = _ >= 0 && a !== _ ? 0 : c), n >= 0 && (t.text.placedSymbolArray.get(n).crossTileID = _ >= 0 && n !== _ ? 0 : c), s >= 0 && (t.text.placedSymbolArray.get(s).crossTileID = _ >= 0 && s !== _ ? 0 : c), l >= 0 && (t.text.placedSymbolArray.get(l).crossTileID = _ >= 0 && l !== _ ? 0 : c);
        }
      }, {
        key: "markUsedOrientation",
        value: function markUsedOrientation(t, i, o) {
          var r = i === e.aF.horizontal || i === e.aF.horizontalOnly ? i : 0,
            a = i === e.aF.vertical ? i : 0,
            n = o.leftJustifiedTextSymbolIndex,
            s = o.centerJustifiedTextSymbolIndex,
            l = o.rightJustifiedTextSymbolIndex,
            c = o.verticalPlacedTextSymbolIndex,
            h = t.text.placedSymbolArray;
          n >= 0 && (h.get(n).placedOrientation = r), s >= 0 && (h.get(s).placedOrientation = r), l >= 0 && (h.get(l).placedOrientation = r), c >= 0 && (h.get(c).placedOrientation = a);
        }
      }, {
        key: "commit",
        value: function commit(e) {
          this.commitTime = e, this.zoomAtLastRecencyCheck = this.transform.zoom;
          var t = this.prevPlacement;
          var i = !1;
          this.prevZoomAdjustment = t ? t.zoomAdjustment(this.transform.zoom) : 0;
          var o = t ? t.symbolFadeChange(e) : 1,
            r = t ? t.opacities : {},
            a = t ? t.variableOffsets : {},
            n = t ? t.placedOrientations : {};
          for (var _e628 in this.placements) {
            var _t599 = this.placements[_e628],
              _a236 = r[_e628];
            _a236 ? (this.opacities[_e628] = new Qr(_a236, o, _t599.text, _t599.icon, null, _t599.clipped), i = i || _t599.text !== _a236.text.placed || _t599.icon !== _a236.icon.placed) : (this.opacities[_e628] = new Qr(null, o, _t599.text, _t599.icon, _t599.skipFade, _t599.clipped), i = i || _t599.text || _t599.icon);
          }
          for (var _e629 in r) {
            var _t600 = r[_e629];
            if (!this.opacities[_e629]) {
              var _r446 = new Qr(_t600, o, !1, !1);
              _r446.isHidden() || (this.opacities[_e629] = _r446, i = i || _t600.text.placed || _t600.icon.placed);
            }
          }
          for (var _e630 in a) this.variableOffsets[_e630] || !this.opacities[_e630] || this.opacities[_e630].isHidden() || (this.variableOffsets[_e630] = a[_e630]);
          for (var _e631 in n) this.placedOrientations[_e631] || !this.opacities[_e631] || this.opacities[_e631].isHidden() || (this.placedOrientations[_e631] = n[_e631]);
          i ? this.lastPlacementChangeTime = e : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t ? t.lastPlacementChangeTime : e);
        }
      }, {
        key: "updateLayerOpacities",
        value: function updateLayerOpacities(e, t, i, o) {
          var r = new Set();
          var _iterator434 = _createForOfIteratorHelper(t),
            _step434;
          try {
            for (_iterator434.s(); !(_step434 = _iterator434.n()).done;) {
              var _a237 = _step434.value;
              var _t601 = _a237.getBucket(e);
              _t601 && _a237.latestFeatureIndex && e.fqid === _t601.layerIds[0] && (this.updateBucketOpacities(_t601, r, _a237.collisionBoxArray, i, o, _a237.tileID, e.scope), _t601.layers[0].layout.get("symbol-z-elevate") && this.buildingIndex && (this.buildingIndex.updateZOffset(_t601, _a237.tileID), _t601.updateZOffset()));
            }
          } catch (err) {
            _iterator434.e(err);
          } finally {
            _iterator434.f();
          }
        }
      }, {
        key: "updateBucketOpacities",
        value: function updateBucketOpacities(t, i, o, r, a, n, s) {
          t.hasTextData() && t.text.opacityVertexArray.clear(), t.hasIconData() && t.icon.opacityVertexArray.clear(), t.hasIconCollisionBoxData() && t.iconCollisionBox.collisionVertexArray.clear(), t.hasTextCollisionBoxData() && t.textCollisionBox.collisionVertexArray.clear();
          var l = t.layers[0].layout,
            c = !!t.layers[0].dynamicFilter(),
            h = new Qr(null, 0, !1, !1, !0),
            _ = l.get("text-allow-overlap"),
            u = l.get("icon-allow-overlap"),
            d = l.get("text-variable-anchor"),
            p = "map" === l.get("text-rotation-alignment"),
            f = "map" === l.get("text-pitch-alignment"),
            m = new Qr(null, 0, _ && (u || !t.hasIconData() || l.get("icon-optional")), u && (_ || !t.hasTextData() || l.get("text-optional")), !0);
          !t.collisionArrays && o && (t.hasIconCollisionBoxData() || t.hasTextCollisionBoxData()) && t.deserializeCollisionBoxes(o);
          var g = function g(e, t, i) {
            for (var _o245 = 0; _o245 < t / 4; _o245++) e.opacityVertexArray.emplaceBack(i);
          };
          var v = 0;
          a && t.updateReplacement(n, a);
          for (var _o246 = 0; _o246 < t.symbolInstances.length; _o246++) {
            var _l136 = t.symbolInstances.get(_o246),
              _35 = _l136.numHorizontalGlyphVertices,
              _u101 = _l136.numVerticalGlyphVertices,
              _x31 = _l136.crossTileID,
              _y65 = _l136.numIconVertices,
              _b24 = _l136.tileAnchorX,
              _w24 = _l136.tileAnchorY,
              _T14 = i.has(_x31);
            var _E13 = this.opacities[_x31];
            _T14 ? _E13 = h : _E13 || (_E13 = m, this.opacities[_x31] = _E13), i.add(_x31);
            var _C10 = _35 > 0 || _u101 > 0,
              _S18 = _y65 > 0,
              _I16 = this.placedOrientations[_x31],
              _L9 = _I16 === e.aF.vertical,
              _P11 = _I16 === e.aF.horizontal || _I16 === e.aF.horizontalOnly;
            !_C10 && !_S18 || _E13.isHidden() || v++;
            var _R7 = !1;
            if ((_C10 || _S18) && a) {
              var _iterator435 = _createForOfIteratorHelper(t.activeReplacements),
                _step435;
              try {
                for (_iterator435.s(); !(_step435 = _iterator435.n()).done;) {
                  var _i437 = _step435.value;
                  if (e.cJ(_i437, r, e.cw.Symbol, s)) continue;
                  if (_i437.min.x > _b24 || _b24 > _i437.max.x || _i437.min.y > _w24 || _w24 > _i437.max.y) continue;
                  var _t602 = e.cK(_b24, _w24, n.canonical, _i437.footprintTileId.canonical);
                  if (_R7 = e.cL(_t602, _i437), _R7) break;
                }
              } catch (err) {
                _iterator435.e(err);
              } finally {
                _iterator435.f();
              }
            }
            if (_C10) {
              var _e632 = _R7 ? da : ua(_E13.text);
              g(t.text, _35, _L9 ? da : _e632), g(t.text, _u101, _P11 ? da : _e632);
              var _i438 = _E13.text.isHidden(),
                _o247 = _l136.leftJustifiedTextSymbolIndex,
                _r447 = _l136.centerJustifiedTextSymbolIndex,
                _a238 = _l136.rightJustifiedTextSymbolIndex,
                _n307 = _l136.verticalPlacedTextSymbolIndex,
                _s253 = t.text.placedSymbolArray,
                _c117 = _i438 || _L9 ? 1 : 0;
              _o247 >= 0 && (_s253.get(_o247).hidden = _c117), _r447 >= 0 && (_s253.get(_r447).hidden = _c117), _a238 >= 0 && (_s253.get(_a238).hidden = _c117), _n307 >= 0 && (_s253.get(_n307).hidden = _i438 || _P11 ? 1 : 0);
              var _h90 = this.variableOffsets[_x31];
              _h90 && this.markUsedJustification(t, _h90.anchor, _l136, _I16);
              var _d50 = this.placedOrientations[_x31];
              _d50 && (this.markUsedJustification(t, "left", _l136, _d50), this.markUsedOrientation(t, _d50, _l136));
            }
            if (_S18) {
              var _e633 = _R7 ? da : ua(_E13.icon),
                _i439 = _l136.placedIconSymbolIndex,
                _o248 = _l136.verticalPlacedIconSymbolIndex,
                _r448 = t.icon.placedSymbolArray,
                _a239 = _E13.icon.isHidden() ? 1 : 0;
              _i439 >= 0 && (g(t.icon, _y65, _L9 ? da : _e633), _r448.get(_i439).hidden = _a239), _o248 >= 0 && (g(t.icon, _l136.numVerticalIconVertices, _P11 ? da : _e633), _r448.get(_o248).hidden = _a239);
            }
            if (t.hasIconCollisionBoxData() || t.hasTextCollisionBoxData()) {
              var _i440 = t.collisionArrays[_o246];
              if (_i440) {
                var _o249 = new e.P(0, 0),
                  _r449 = !0;
                if (_i440.textBox || _i440.verticalTextBox) {
                  if (d) {
                    var _e634 = this.variableOffsets[_x31];
                    _e634 ? (_o249 = ta(_e634.anchor, _e634.width, _e634.height, _e634.textOffset, _e634.textScale), p && _o249._rotate(f ? this.transform.angle : -this.transform.angle)) : _r449 = !1;
                  }
                  c && (_r449 = !_E13.clipped), _i440.textBox && ra(t.textCollisionBox.collisionVertexArray, _E13.text.placed, !_r449 || _L9, _o249.x, _o249.y), _i440.verticalTextBox && ra(t.textCollisionBox.collisionVertexArray, _E13.text.placed, !_r449 || _P11, _o249.x, _o249.y);
                }
                var _a240 = _r449 && Boolean(!_P11 && _i440.verticalIconBox);
                _i440.iconBox && ra(t.iconCollisionBox.collisionVertexArray, _E13.icon.placed, _a240, _l136.hasIconTextFit ? _o249.x : 0, _l136.hasIconTextFit ? _o249.y : 0), _i440.verticalIconBox && ra(t.iconCollisionBox.collisionVertexArray, _E13.icon.placed, !_a240, _l136.hasIconTextFit ? _o249.x : 0, _l136.hasIconTextFit ? _o249.y : 0);
              }
            }
          }
          if (t.fullyClipped = 0 === v, t.sortFeatures(this.transform.angle), this.retainedQueryData[t.bucketInstanceId] && (this.retainedQueryData[t.bucketInstanceId].featureSortOrder = t.featureSortOrder), t.hasTextData() && t.text.opacityVertexBuffer && t.text.opacityVertexBuffer.updateData(t.text.opacityVertexArray), t.hasIconData() && t.icon.opacityVertexBuffer && t.icon.opacityVertexBuffer.updateData(t.icon.opacityVertexArray), t.hasIconCollisionBoxData() && t.iconCollisionBox.collisionVertexBuffer && t.iconCollisionBox.collisionVertexBuffer.updateData(t.iconCollisionBox.collisionVertexArray), t.hasTextCollisionBoxData() && t.textCollisionBox.collisionVertexBuffer && t.textCollisionBox.collisionVertexBuffer.updateData(t.textCollisionBox.collisionVertexArray), t.bucketInstanceId in this.collisionCircleArrays) {
            var _e635 = this.collisionCircleArrays[t.bucketInstanceId];
            t.placementInvProjMatrix = _e635.invProjMatrix, t.placementViewportMatrix = _e635.viewportMatrix, t.collisionCircleArray = _e635.circles, delete this.collisionCircleArrays[t.bucketInstanceId];
          }
        }
      }, {
        key: "symbolFadeChange",
        value: function symbolFadeChange(e) {
          return 0 === this.fadeDuration ? 1 : (e - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
        }
      }, {
        key: "zoomAdjustment",
        value: function zoomAdjustment(e) {
          return Math.max(0, (this.transform.zoom - e) / 1.5);
        }
      }, {
        key: "hasTransitions",
        value: function hasTransitions(e) {
          return this.stale || e - this.lastPlacementChangeTime < this.fadeDuration;
        }
      }, {
        key: "stillRecent",
        value: function stillRecent(e, t) {
          var i = this.zoomAtLastRecencyCheck === t ? 1 - this.zoomAdjustment(t) : 1;
          return this.zoomAtLastRecencyCheck = t, this.commitTime + this.fadeDuration * i > e;
        }
      }, {
        key: "setStale",
        value: function setStale() {
          this.stale = !0;
        }
      }]);
      return oa;
    }();
    function ra(e, t, i, o, r) {
      e.emplaceBack(t ? 1 : 0, i ? 1 : 0, o || 0, r || 0), e.emplaceBack(t ? 1 : 0, i ? 1 : 0, o || 0, r || 0), e.emplaceBack(t ? 1 : 0, i ? 1 : 0, o || 0, r || 0), e.emplaceBack(t ? 1 : 0, i ? 1 : 0, o || 0, r || 0);
    }
    var aa = Math.pow(2, 25),
      na = Math.pow(2, 24),
      sa = Math.pow(2, 17),
      la = Math.pow(2, 16),
      ca = Math.pow(2, 9),
      ha = Math.pow(2, 8),
      _a = Math.pow(2, 1);
    function ua(e) {
      if (0 === e.opacity && !e.placed) return 0;
      if (1 === e.opacity && e.placed) return 4294967295;
      var t = e.placed ? 1 : 0,
        i = Math.floor(127 * e.opacity);
      return i * aa + t * na + i * sa + t * la + i * ca + t * ha + i * _a + t;
    }
    var da = 0;
    var pa = /*#__PURE__*/function () {
      function pa(e) {
        _classCallCheck(this, pa);
        this._sortAcrossTiles = "viewport-y" !== e.layout.get("symbol-z-order") && void 0 !== e.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = new Set(), this._bucketParts = [];
      }
      _createClass(pa, [{
        key: "continuePlacement",
        value: function continuePlacement(e, t, i, o, r) {
          var a = this._bucketParts;
          for (; this._currentTileIndex < e.length;) if (t.getBucketParts(a, o, e[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, r()) return !0;
          for (this._sortAcrossTiles && (this._sortAcrossTiles = !1, a.sort(function (e, t) {
            return e.sortKey - t.sortKey;
          })); this._currentPartIndex < a.length;) {
            var _e636 = a[this._currentPartIndex];
            if (t.placeLayerBucketPart(_e636, this._seenCrossTileIDs, i, 0 === _e636.symbolInstanceStart), this._currentPartIndex++, r()) return !0;
          }
          return !1;
        }
      }]);
      return pa;
    }();
    var fa = /*#__PURE__*/function () {
      function fa(e, t, i, o, r, a, n, s, l) {
        _classCallCheck(this, fa);
        this.placement = new oa(e, r, a, n, s, l), this._currentPlacementIndex = t.length - 1, this._forceFullPlacement = i, this._showCollisionBoxes = o, this._done = !1;
      }
      _createClass(fa, [{
        key: "isDone",
        value: function isDone() {
          return this._done;
        }
      }, {
        key: "continuePlacement",
        value: function continuePlacement(t, i, o, r) {
          var _this143 = this;
          var a = e.e.now(),
            n = function n() {
              var t = e.e.now() - a;
              return !_this143._forceFullPlacement && t > 2;
            };
          for (; this._currentPlacementIndex >= 0;) {
            var _a241 = i[t[this._currentPlacementIndex]],
              _s254 = this.placement.collisionIndex.transform.zoom;
            if ("symbol" === _a241.type && (!_a241.minzoom || _a241.minzoom <= _s254) && (!_a241.maxzoom || _a241.maxzoom > _s254)) {
              var _t603 = _a241,
                _i441 = _t603.layout.get("symbol-z-elevate"),
                _s255 = this._inProgressLayer = this._inProgressLayer || new pa(_t603),
                _l137 = e.am(_a241.source, _a241.scope);
              if (_s255.continuePlacement(_i441 ? r[_l137] : o[_l137], this.placement, this._showCollisionBoxes, _a241, n)) return;
              delete this._inProgressLayer;
            }
            this._currentPlacementIndex--;
          }
          this._done = !0;
        }
      }, {
        key: "commit",
        value: function commit(e) {
          return this.placement.commit(e), this.placement;
        }
      }]);
      return fa;
    }();
    var ma = 512 / e.a4 / 2;
    var ga = /*#__PURE__*/function () {
      function ga(t, i, o) {
        _classCallCheck(this, ga);
        this.tileID = t, this.bucketInstanceId = o, this.index = new e.cN(i.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
        var r = t.canonical.x * e.a4,
          a = t.canonical.y * e.a4;
        for (var _e637 = 0; _e637 < i.length; _e637++) {
          var _i$get = i.get(_e637),
            _t604 = _i$get.key,
            _o250 = _i$get.crossTileID,
            _n308 = _i$get.tileAnchorX,
            _s256 = _i$get.tileAnchorY,
            _l138 = Math.floor((r + _n308) * ma),
            _c118 = Math.floor((a + _s256) * ma);
          this.index.add(_l138, _c118), this.keys.push(_t604), this.crossTileIDs.push(_o250);
        }
        this.index.finish();
      }
      _createClass(ga, [{
        key: "findMatches",
        value: function findMatches(t, i, o) {
          var r = this.tileID.canonical.z < i.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - i.canonical.z),
            a = ma / Math.pow(2, i.canonical.z - this.tileID.canonical.z),
            n = i.canonical.x * e.a4,
            s = i.canonical.y * e.a4;
          for (var _e638 = 0; _e638 < t.length; _e638++) {
            var _i442 = t.get(_e638);
            if (_i442.crossTileID) continue;
            var _l139 = _i442.key,
              _c119 = _i442.tileAnchorX,
              _h91 = _i442.tileAnchorY,
              _36 = Math.floor((n + _c119) * a),
              _u102 = Math.floor((s + _h91) * a),
              _d51 = this.index.range(_36 - r, _u102 - r, _36 + r, _u102 + r);
            var _iterator436 = _createForOfIteratorHelper(_d51),
              _step436;
            try {
              for (_iterator436.s(); !(_step436 = _iterator436.n()).done;) {
                var _e639 = _step436.value;
                var _t605 = this.crossTileIDs[_e639];
                if (this.keys[_e639] === _l139 && !o.has(_t605)) {
                  o.add(_t605), _i442.crossTileID = _t605;
                  break;
                }
              }
            } catch (err) {
              _iterator436.e(err);
            } finally {
              _iterator436.f();
            }
          }
        }
      }]);
      return ga;
    }();
    var va = /*#__PURE__*/function () {
      function va() {
        _classCallCheck(this, va);
        this.maxCrossTileID = 0;
      }
      _createClass(va, [{
        key: "generate",
        value: function generate() {
          return ++this.maxCrossTileID;
        }
      }]);
      return va;
    }();
    var xa = /*#__PURE__*/function () {
      function xa() {
        _classCallCheck(this, xa);
        this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
      }
      _createClass(xa, [{
        key: "handleWrapJump",
        value: function handleWrapJump(e) {
          var t = Math.round((e - this.lng) / 360);
          if (0 !== t) for (var _e640 in this.indexes) {
            var _i443 = this.indexes[_e640],
              _o251 = {};
            for (var _e641 in _i443) {
              var _r450 = _i443[_e641];
              _r450.tileID = _r450.tileID.unwrapTo(_r450.tileID.wrap + t), _o251[_r450.tileID.key] = _r450;
            }
            this.indexes[_e640] = _o251;
          }
          this.lng = e;
        }
      }, {
        key: "addBucket",
        value: function addBucket(e, t, i) {
          if (this.indexes[e.overscaledZ] && this.indexes[e.overscaledZ][e.key]) {
            if (this.indexes[e.overscaledZ][e.key].bucketInstanceId === t.bucketInstanceId) return !1;
            this.removeBucketCrossTileIDs(e.overscaledZ, this.indexes[e.overscaledZ][e.key]);
          }
          for (var _e642 = 0; _e642 < t.symbolInstances.length; _e642++) t.symbolInstances.get(_e642).crossTileID = 0;
          this.usedCrossTileIDs[e.overscaledZ] || (this.usedCrossTileIDs[e.overscaledZ] = new Set());
          var o = this.usedCrossTileIDs[e.overscaledZ];
          for (var _i444 in this.indexes) {
            var _r451 = this.indexes[_i444];
            if (Number(_i444) > e.overscaledZ) for (var _i445 in _r451) {
              var _a242 = _r451[_i445];
              _a242.tileID.isChildOf(e) && _a242.findMatches(t.symbolInstances, e, o);
            } else {
              var _a243 = _r451[e.scaledTo(Number(_i444)).key];
              _a243 && _a243.findMatches(t.symbolInstances, e, o);
            }
          }
          for (var _e643 = 0; _e643 < t.symbolInstances.length; _e643++) {
            var _r452 = t.symbolInstances.get(_e643);
            _r452.crossTileID || (_r452.crossTileID = i.generate(), o.add(_r452.crossTileID));
          }
          return void 0 === this.indexes[e.overscaledZ] && (this.indexes[e.overscaledZ] = {}), this.indexes[e.overscaledZ][e.key] = new ga(e, t.symbolInstances, t.bucketInstanceId), !0;
        }
      }, {
        key: "removeBucketCrossTileIDs",
        value: function removeBucketCrossTileIDs(e, t) {
          var _iterator437 = _createForOfIteratorHelper(t.crossTileIDs),
            _step437;
          try {
            for (_iterator437.s(); !(_step437 = _iterator437.n()).done;) {
              var _i446 = _step437.value;
              this.usedCrossTileIDs[e].delete(_i446);
            }
          } catch (err) {
            _iterator437.e(err);
          } finally {
            _iterator437.f();
          }
        }
      }, {
        key: "removeStaleBuckets",
        value: function removeStaleBuckets(e) {
          var t = !1;
          for (var _i447 in this.indexes) {
            var _o252 = this.indexes[_i447];
            for (var _r453 in _o252) e[_o252[_r453].bucketInstanceId] || (this.removeBucketCrossTileIDs(_i447, _o252[_r453]), delete _o252[_r453], t = !0);
          }
          return t;
        }
      }]);
      return xa;
    }();
    var ya = /*#__PURE__*/function () {
      function ya() {
        _classCallCheck(this, ya);
        this.layerIndexes = {}, this.crossTileIDs = new va(), this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
      }
      _createClass(ya, [{
        key: "addLayer",
        value: function addLayer(e, t, i, o) {
          var r = this.layerIndexes[e.fqid];
          void 0 === r && (r = this.layerIndexes[e.fqid] = new xa());
          var a = !1;
          var n = {};
          "globe" !== o.name && r.handleWrapJump(i);
          var _iterator438 = _createForOfIteratorHelper(t),
            _step438;
          try {
            for (_iterator438.s(); !(_step438 = _iterator438.n()).done;) {
              var _i448 = _step438.value;
              var _t606 = _i448.getBucket(e);
              _t606 && e.fqid === _t606.layerIds[0] && (_t606.bucketInstanceId || (_t606.bucketInstanceId = ++this.maxBucketInstanceId), r.addBucket(_i448.tileID, _t606, this.crossTileIDs) && (a = !0), n[_t606.bucketInstanceId] = !0);
            }
          } catch (err) {
            _iterator438.e(err);
          } finally {
            _iterator438.f();
          }
          return r.removeStaleBuckets(n) && (a = !0), a;
        }
      }, {
        key: "pruneUnusedLayers",
        value: function pruneUnusedLayers(e) {
          var t = {};
          e.forEach(function (e) {
            t[e] = !0;
          });
          for (var _e644 in this.layerIndexes) t[_e644] || delete this.layerIndexes[_e644];
        }
      }]);
      return ya;
    }();
    var ba = new e.U({
        data: new e.W(e.N.colorTheme.data)
      }),
      wa = function wa(e, t) {
        return We(e, t && t.filter(function (e) {
          return "source.canvas" !== e.identifier;
        }));
      },
      Ta = e.ai(Br, ["addLayer", "removeLayer", "setLights", "setPaintProperty", "setLayoutProperty", "setSlot", "setFilter", "addSource", "removeSource", "setLayerZoomRange", "setLight", "setTransition", "setGeoJSONSourceData", "setTerrain", "setFog", "setProjection", "setCamera", "addImport", "removeImport", "updateImport"]),
      Ea = e.ai(Br, ["setCenter", "setZoom", "setBearing", "setPitch"]),
      Ca = {
        version: 8,
        layers: [],
        sources: {}
      },
      Sa = {
        duration: 300,
        delay: 0
      };
    var Ia = /*#__PURE__*/function (_e$E14) {
      _inherits(Ia, _e$E14);
      var _super155 = _createSuper(Ia);
      function Ia(t) {
        var _this144;
        var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, Ia);
        _this144 = _super155.call(this), _this144.map = t, _this144.scope = i.scope || "", _this144.globalId = null, _this144.fragments = [], _this144.importDepth = i.importDepth || 0, _this144.importsCache = i.importsCache || new Map(), _this144.resolvedImports = i.resolvedImports || new Set(), _this144.transition = e.Q({}, Sa), _this144._buildingIndex = new zr(_assertThisInitialized(_this144)), _this144.crossTileSymbolIndex = new ya(), _this144._mergedOrder = [], _this144._drapedFirstOrder = [], _this144._mergedLayers = {}, _this144._mergedSourceCaches = {}, _this144._mergedOtherSourceCaches = {}, _this144._mergedSymbolSourceCaches = {}, _this144._clipLayerIndices = [], _this144._has3DLayers = !1, _this144._hasCircleLayers = !1, _this144._hasSymbolLayers = !1, _this144._changes = i.styleChanges || new g(), _this144.dispatcher = i.dispatcher ? i.dispatcher : new e.by(e.bz(), _assertThisInitialized(_this144)), i.imageManager ? _this144.imageManager = i.imageManager : (_this144.imageManager = new le(), _this144.imageManager.setEventedParent(_assertThisInitialized(_this144))), _this144.imageManager.createScope(_this144.scope), _this144.glyphManager = i.glyphManager ? i.glyphManager : new e.cP(t._requestManager, i.localFontFamily ? e.cQ.all : i.localIdeographFontFamily ? e.cQ.ideographs : e.cQ.none, i.localFontFamily || i.localIdeographFontFamily), i.modelManager ? _this144.modelManager = i.modelManager : (_this144.modelManager = new ne(t._requestManager), _this144.modelManager.setEventedParent(_assertThisInitialized(_this144))), _this144._layers = {}, _this144._serializedLayers = {}, _this144._sourceCaches = {}, _this144._otherSourceCaches = {}, _this144._symbolSourceCaches = {}, _this144._loaded = !1, _this144._precompileDone = !1, _this144._shouldPrecompile = !1, _this144._availableImages = [], _this144._order = [], _this144._markersNeedUpdate = !1, _this144._styleColorTheme = {
          lut: null,
          lutLoading: !1,
          lutLoadingCorrelationID: 0,
          colorTheme: null
        }, _this144._styleColorThemeForScope = {}, _this144.options = i.configOptions ? i.configOptions : new Map(), _this144._configDependentLayers = i.configDependentLayers ? i.configDependentLayers : new Set(), _this144._config = i.config, _this144._initialConfig = i.initialConfig, _this144.dispatcher.broadcast("setReferrer", e.cR());
        var o = _assertThisInitialized(_this144);
        _this144._rtlTextPluginCallback = Ia.registerForPluginStateChange(function (t) {
          o.dispatcher.broadcast("syncRTLPluginState", {
            pluginStatus: t.pluginStatus,
            pluginURL: t.pluginURL
          }, function (t, i) {
            if (e.cS(t), i && i.every(function (e) {
              return e;
            })) for (var _e645 in o._sourceCaches) {
              var _t607 = o._sourceCaches[_e645],
                _i449 = _t607.getSource().type;
              "vector" !== _i449 && "geojson" !== _i449 || _t607.reload();
            }
          });
        }), _this144.on("data", function (e) {
          if ("source" !== e.dataType || "metadata" !== e.sourceDataType) return;
          var t = _this144.getOwnSource(e.sourceId);
          if (t && t.vectorLayerIds) for (var _e646 in _this144._layers) {
            var _i450 = _this144._layers[_e646];
            _i450.source === t.id && _this144._validateLayer(_i450);
          }
        });
        return _this144;
      }
      _createClass(Ia, [{
        key: "load",
        value: function load(e) {
          return e ? ("string" == typeof e ? this.loadURL(e) : this.loadJSON(e), this) : this;
        }
      }, {
        key: "_getGlobalId",
        value: function _getGlobalId(t) {
          if (!t) return null;
          if ("string" == typeof t) {
            if (e.cT(t)) return t;
            var _i451 = e.cU(t);
            if (!_i451.startsWith("http")) try {
              return new URL(_i451, location.href).toString();
            } catch (e) {
              return _i451;
            }
            return _i451;
          }
          return "json://".concat(e.cV(JSON.stringify(t)));
        }
      }, {
        key: "_diffStyle",
        value: function _diffStyle(t, i, o) {
          var _this145 = this;
          this.globalId = this._getGlobalId(t);
          var r = function r(e, t) {
            try {
              t(null, _this145.setState(e, o));
            } catch (e) {
              t(e, !1);
            }
          };
          if ("string" == typeof t) {
            var _o253 = this.map._requestManager.normalizeStyleURL(t),
              _a244 = this.map._requestManager.transformRequest(_o253, e.R.Style);
            e.h(_a244, function (t, o) {
              t ? _this145.fire(new e.f(t)) : o && r(o, i);
            });
          } else "object" == typeof t && r(t, i);
        }
      }, {
        key: "loadURL",
        value: function loadURL(t) {
          var _this146 = this;
          var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          this.fire(new e.g("dataloading", {
            dataType: "style"
          }));
          var o = "boolean" == typeof i.validate ? i.validate : !e.cT(t);
          this.globalId = this._getGlobalId(t), t = this.map._requestManager.normalizeStyleURL(t, i.accessToken), this.resolvedImports.add(t);
          var r = this.importsCache.get(t);
          if (r) return this._load(r, o);
          var a = this.map._requestManager.transformRequest(t, e.R.Style);
          this._request = e.h(a, function (i, r) {
            if (_this146._request = null, i) _this146.fire(new e.f(i));else if (r) return _this146.importsCache.set(t, r), _this146._load(r, o);
          });
        }
      }, {
        key: "loadJSON",
        value: function loadJSON(t) {
          var _this147 = this;
          var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          this.fire(new e.g("dataloading", {
            dataType: "style"
          })), this.globalId = this._getGlobalId(t), this._request = e.e.frame(function () {
            _this147._request = null, _this147._load(t, !1 !== i.validate);
          });
        }
      }, {
        key: "loadEmpty",
        value: function loadEmpty() {
          this.fire(new e.g("dataloading", {
            dataType: "style"
          })), this._load(Ca, !1);
        }
      }, {
        key: "_loadImports",
        value: function _loadImports(t, i, o) {
          var _this148 = this;
          if (this.importDepth >= 4) return e.w("Style doesn't support nesting deeper than 5"), Promise.resolve();
          var r = [];
          var _iterator439 = _createForOfIteratorHelper(t),
            _step439;
          try {
            var _loop23 = function _loop23() {
              var e = _step439.value;
              var t = _this148._createFragmentStyle(e),
                a = new Promise(function (e) {
                  t.once("style.import.load", e), t.once("error", e);
                }).then(function () {
                  return _this148.mergeAll();
                });
              if (r.push(a), _this148.resolvedImports.has(e.url)) {
                t.loadEmpty();
                return 1; // continue
              }
              var n = e.data || _this148.importsCache.get(e.url);
              n ? (t.loadJSON(n, {
                validate: i
              }), _this148._isInternalStyle(n) && (t.globalId = null)) : e.url ? t.loadURL(e.url, {
                validate: i
              }) : t.loadEmpty();
              var s = {
                style: t,
                id: e.id,
                config: e.config
              };
              if (o) {
                var _e647 = _this148.fragments.findIndex(function (_ref187) {
                  var e = _ref187.id;
                  return e === o;
                });
                _this148.fragments = _this148.fragments.slice(0, _e647).concat(s).concat(_this148.fragments.slice(_e647));
              } else _this148.fragments.push(s);
            };
            for (_iterator439.s(); !(_step439 = _iterator439.n()).done;) {
              if (_loop23()) continue;
            }
          } catch (err) {
            _iterator439.e(err);
          } finally {
            _iterator439.f();
          }
          return Promise.allSettled(r);
        }
      }, {
        key: "getImportGlobalIds",
        value: function getImportGlobalIds() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
          var _iterator440 = _createForOfIteratorHelper(e.fragments),
            _step440;
          try {
            for (_iterator440.s(); !(_step440 = _iterator440.n()).done;) {
              var _i452 = _step440.value;
              _i452.style.globalId && t.add(_i452.style.globalId), this.getImportGlobalIds(_i452.style, t);
            }
          } catch (err) {
            _iterator440.e(err);
          } finally {
            _iterator440.f();
          }
          return _toConsumableArray(t.values());
        }
      }, {
        key: "_createFragmentStyle",
        value: function _createFragmentStyle(t) {
          var i = this.scope ? e.am(t.id, this.scope) : t.id;
          var o;
          var r = this._initialConfig && this._initialConfig[i];
          (t.config || r) && (o = e.Q({}, t.config, r));
          var a = new Ia(this.map, {
            scope: i,
            styleChanges: this._changes,
            importDepth: this.importDepth + 1,
            importsCache: this.importsCache,
            resolvedImports: new Set(this.resolvedImports),
            dispatcher: this.dispatcher,
            imageManager: this.imageManager,
            glyphManager: this.glyphManager,
            modelManager: this.modelManager,
            config: o,
            configOptions: this.options,
            configDependentLayers: this._configDependentLayers
          });
          return a.setEventedParent(this.map, {
            style: a
          }), a;
        }
      }, {
        key: "_reloadImports",
        value: function _reloadImports() {
          this.mergeAll(), this._updateMapProjection(), this.updateConfigDependencies(), this.map._triggerCameraUpdate(this.camera), this.dispatcher.broadcast("setLayers", {
            layers: this._serializeLayers(this._order),
            scope: this.scope,
            options: this.options
          }), this._shouldPrecompile = this.map._precompilePrograms && this.isRootStyle();
        }
      }, {
        key: "_isInternalStyle",
        value: function _isInternalStyle(e) {
          return this.isRootStyle() && (e.fragment || !!e.schema && !1 !== e.fragment);
        }
      }, {
        key: "_load",
        value: function _load(t, i) {
          var _this149 = this;
          var o = t.schema;
          if (this._isInternalStyle(t)) {
            var _o254 = e.Q({}, Ca, {
              imports: [{
                id: "basemap",
                data: t,
                url: ""
              }]
            });
            return void this._load(_o254, i);
          }
          if (this.updateConfig(this._config, o), i && wa(this, ze(t))) return;
          this._loaded = !0, this.stylesheet = e.cW(t);
          var r = function r() {
              for (var _e648 in t.sources) _this149.addSource(_e648, t.sources[_e648], {
                validate: !1,
                isInitialLoad: !0
              });
              t.sprite ? _this149._loadSprite(t.sprite) : (_this149.imageManager.setLoaded(!0, _this149.scope), _this149.dispatcher.broadcast("spriteLoaded", {
                scope: _this149.scope,
                isLoaded: !0
              })), _this149.glyphManager.setURL(t.glyphs, _this149.scope);
              var o = Fr(_this149.stylesheet.layers);
              if (_this149._order = o.map(function (e) {
                return e.id;
              }), _this149.stylesheet.light && e.w("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), _this149.stylesheet.lights) if (1 === _this149.stylesheet.lights.length && "flat" === _this149.stylesheet.lights[0].type) {
                var _e649 = _this149.stylesheet.lights[0];
                _this149.light = new qe(_e649.properties, _e649.id);
              } else _this149.setLights(_this149.stylesheet.lights);
              _this149.light || (_this149.light = new qe(_this149.stylesheet.light)), _this149._layers = {}, _this149._serializedLayers = {};
              var _iterator441 = _createForOfIteratorHelper(o),
                _step441;
              try {
                for (_iterator441.s(); !(_step441 = _iterator441.n()).done;) {
                  var _t608 = _step441.value;
                  var _i453 = e.c$(_t608, _this149.scope, _this149._styleColorTheme.lut, _this149.options);
                  0 !== _i453.configDependencies.size && _this149._configDependentLayers.add(_i453.fqid), _i453.setEventedParent(_this149, {
                    layer: {
                      id: _i453.id
                    }
                  }), _this149._layers[_i453.id] = _i453, _this149._serializedLayers[_i453.id] = _i453.serialize();
                  var _o255 = _this149.getOwnLayerSourceCache(_i453),
                    _r454 = !!_this149.directionalLight && _this149.directionalLight.shadowsEnabled();
                  _o255 && _i453.canCastShadows() && _r454 && (_o255.castsShadows = !0);
                }
              } catch (err) {
                _iterator441.e(err);
              } finally {
                _iterator441.f();
              }
              _this149.stylesheet.models && _this149.modelManager.addModels(_this149.stylesheet.models, _this149.scope);
              var r = _this149.stylesheet.terrain;
              r && (_this149.checkCanvasFingerprintNoise(), _this149.disableElevatedTerrain || _this149.terrainSetForDrapingOnly() || _this149._createTerrain(r, 1)), _this149.stylesheet.fog && _this149._createFog(_this149.stylesheet.fog), _this149.stylesheet.transition && _this149.setTransition(_this149.stylesheet.transition), _this149.fire(new e.g("data", {
                dataType: "style"
              }));
              var a = _this149.isRootStyle();
              t.imports ? _this149._loadImports(t.imports, i).then(function () {
                _this149._reloadImports(), _this149.fire(new e.g(a ? "style.load" : "style.import.load"));
              }) : (_this149._reloadImports(), _this149.fire(new e.g(a ? "style.load" : "style.import.load")));
            },
            a = this.stylesheet["color-theme"];
          if (this._styleColorTheme.colorTheme = a, a) {
            var _t609 = this._evaluateColorThemeData(a);
            this._loadColorTheme(_t609).then(function () {
              r();
            }).catch(function (t) {
              e.w("Couldn't load color theme from the stylesheet: ".concat(t)), r();
            });
          } else this._styleColorTheme.lut = null, r();
        }
      }, {
        key: "isRootStyle",
        value: function isRootStyle() {
          return 0 === this.importDepth;
        }
      }, {
        key: "mergeAll",
        value: function mergeAll() {
          var _this150 = this;
          var t, i, o, r, a, n, s, l;
          var c = {};
          this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle(function (e) {
            if (e.stylesheet) {
              if (null != e.light && (t = e.light), e.stylesheet.lights) {
                var _iterator442 = _createForOfIteratorHelper(e.stylesheet.lights),
                  _step442;
                try {
                  for (_iterator442.s(); !(_step442 = _iterator442.n()).done;) {
                    var _t610 = _step442.value;
                    "ambient" === _t610.type && null != e.ambientLight && (i = e.ambientLight), "directional" === _t610.type && null != e.directionalLight && (o = e.directionalLight);
                  }
                } catch (err) {
                  _iterator442.e(err);
                } finally {
                  _iterator442.f();
                }
              }
              r = _this150._prioritizeTerrain(r, e.terrain, e.stylesheet.terrain), e.stylesheet.fog && null != e.fog && (a = e.fog), null != e.stylesheet.camera && (l = e.stylesheet.camera), null != e.stylesheet.projection && (n = e.stylesheet.projection), null != e.stylesheet.transition && (s = e.stylesheet.transition), c[e.scope] = e._styleColorTheme;
            }
          }), this.light = t, this.ambientLight = i, this.directionalLight = o, this.fog = a, this._styleColorThemeForScope = c, null === r ? delete this.terrain : this.terrain = r, this.camera = l || {
            "camera-projection": "perspective"
          }, this.projection = n || {
            name: "mercator"
          }, this.transition = e.Q({}, Sa, s), this.mergeSources(), this.mergeLayers();
        }
      }, {
        key: "forEachFragmentStyle",
        value: function forEachFragmentStyle(e) {
          var t = function t(i) {
            var _iterator443 = _createForOfIteratorHelper(i.fragments),
              _step443;
            try {
              for (_iterator443.s(); !(_step443 = _iterator443.n()).done;) {
                var _e650 = _step443.value;
                t(_e650.style);
              }
            } catch (err) {
              _iterator443.e(err);
            } finally {
              _iterator443.f();
            }
            e(i);
          };
          t(this);
        }
      }, {
        key: "_prioritizeTerrain",
        value: function _prioritizeTerrain(e, t, i) {
          var o = e && 0 === e.drapeRenderMode;
          return null === i ? t && 0 === t.drapeRenderMode ? t : o ? e : null : null != t && (!e || o || t && 1 === t.drapeRenderMode) ? t : e;
        }
      }, {
        key: "mergeTerrain",
        value: function mergeTerrain() {
          var _this151 = this;
          var e;
          this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle(function (t) {
            e = _this151._prioritizeTerrain(e, t.terrain, t.stylesheet.terrain);
          }), null === e ? delete this.terrain : this.terrain = e;
        }
      }, {
        key: "mergeProjection",
        value: function mergeProjection() {
          var e;
          this.forEachFragmentStyle(function (t) {
            null != t.stylesheet.projection && (e = t.stylesheet.projection);
          }), this.projection = e || {
            name: "mercator"
          };
        }
      }, {
        key: "mergeSources",
        value: function mergeSources() {
          var t = {},
            i = {},
            o = {};
          this.forEachFragmentStyle(function (r) {
            for (var _i454 in r._sourceCaches) {
              var _o256 = e.am(_i454, r.scope);
              t[_o256] = r._sourceCaches[_i454];
            }
            for (var _t611 in r._otherSourceCaches) {
              var _o257 = e.am(_t611, r.scope);
              i[_o257] = r._otherSourceCaches[_t611];
            }
            for (var _t612 in r._symbolSourceCaches) {
              var _i455 = e.am(_t612, r.scope);
              o[_i455] = r._symbolSourceCaches[_t612];
            }
          }), this._mergedSourceCaches = t, this._mergedOtherSourceCaches = i, this._mergedSymbolSourceCaches = o;
        }
      }, {
        key: "mergeLayers",
        value: function mergeLayers() {
          var _this152 = this;
          var t = {},
            i = [],
            o = {};
          this._mergedSlots = [], this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this.forEachFragmentStyle(function (o) {
            var _iterator444 = _createForOfIteratorHelper(o._order),
              _step444;
            try {
              for (_iterator444.s(); !(_step444 = _iterator444.n()).done;) {
                var _r455 = _step444.value;
                var _a245 = o._layers[_r455];
                if ("slot" === _a245.type) {
                  var _i456 = e.cX(_r455);
                  if (t[_i456]) continue;
                  t[_i456] = [];
                }
                _a245.slot && t[_a245.slot] ? t[_a245.slot].push(_a245) : i.push(_a245);
              }
            } catch (err) {
              _iterator444.e(err);
            } finally {
              _iterator444.f();
            }
          }), this._mergedOrder = [], this._clipLayerIndices = [];
          var r = 0;
          var a = function a() {
            var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var _iterator445 = _createForOfIteratorHelper(i),
              _step445;
            try {
              for (_iterator445.s(); !(_step445 = _iterator445.n()).done;) {
                var _n309 = _step445.value;
                if ("slot" === _n309.type) {
                  var _i457 = e.cX(_n309.id);
                  t[_i457] && a(t[_i457]), _this152._mergedSlots.push(_i457);
                } else {
                  var _t613 = e.am(_n309.id, _n309.scope);
                  _this152._mergedOrder.push(_t613), o[_t613] = _n309, _n309.is3D() && (_this152._has3DLayers = !0), "circle" === _n309.type && (_this152._hasCircleLayers = !0), "symbol" === _n309.type && (_this152._hasSymbolLayers = !0), "clip" === _n309.type && _this152._clipLayerIndices.push(r), r++;
                }
              }
            } catch (err) {
              _iterator445.e(err);
            } finally {
              _iterator445.f();
            }
          };
          a(i), this._mergedOrder.sort(function (e, t) {
            var i = o[e],
              r = o[t];
            return i.hasInitialOcclusionOpacityProperties ? r.is3D() ? 1 : 0 : i.is3D() && r.hasInitialOcclusionOpacityProperties ? -1 : 0;
          }), this._mergedLayers = o, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged();
        }
      }, {
        key: "terrainSetForDrapingOnly",
        value: function terrainSetForDrapingOnly() {
          return !!this.terrain && 0 === this.terrain.drapeRenderMode;
        }
      }, {
        key: "getCamera",
        value: function getCamera() {
          return this.stylesheet.camera;
        }
      }, {
        key: "setCamera",
        value: function setCamera(t) {
          return this.stylesheet.camera = e.Q({}, this.stylesheet.camera, t), this.camera = this.stylesheet.camera, this;
        }
      }, {
        key: "_evaluateColorThemeData",
        value: function _evaluateColorThemeData(t) {
          return t.data ? function (t, i, o) {
            var r = e.Q({}, i);
            for (var _i458 = 0, _Object$keys17 = Object.keys(e.N.colorTheme); _i458 < _Object$keys17.length; _i458++) {
              var _t614 = _Object$keys17[_i458];
              void 0 === r[_t614] && (r[_t614] = e.N.colorTheme[_t614].default);
            }
            var a = new e.O(ba, t, new Map(o));
            return a.setTransitionOrValue(r, o), a.untransitioned().possiblyEvaluate(new e.Y(0));
          }(this.scope, t, this.options).get("data") : null;
        }
      }, {
        key: "_loadColorTheme",
        value: function _loadColorTheme(t) {
          var _this153 = this;
          this._styleColorTheme.lutLoading = !0, this._styleColorTheme.lutLoadingCorrelationID += 1;
          var i = this._styleColorTheme.lutLoadingCorrelationID;
          return new Promise(function (o, r) {
            var a = "data:image/png;base64,";
            if (!t || 0 === t.length) return _this153._styleColorTheme.lut = null, _this153._styleColorTheme.lutLoading = !1, void o();
            var n = t;
            n.startsWith(a) || (n = a + n);
            var s = "mapbox-reserved-lut",
              l = new Image();
            l.src = n, l.onerror = function () {
              _this153._styleColorTheme.lutLoading = !1, r(new Error("Failed to load image data"));
            }, l.onload = function () {
              if (_this153._styleColorTheme.lutLoadingCorrelationID !== i) return void o();
              _this153._styleColorTheme.lutLoading = !1;
              var _e$e$getImageData = e.e.getImageData(l),
                a = _e$e$getImageData.width,
                n = _e$e$getImageData.height,
                c = _e$e$getImageData.data;
              if (n > 32) return void r(new Error("The height of the image must be less than or equal to 32 pixels."));
              if (a !== n * n) return void r(new Error("The width of the image must be equal to the height squared."));
              _this153.getImage(s) && _this153.removeImage(s), _this153.addImage(s, {
                data: new e.j({
                  width: a,
                  height: n
                }, c),
                pixelRatio: 1,
                sdf: !1,
                version: 0
              });
              var h = _this153.imageManager.getImage(s, _this153.scope);
              h ? (_this153._styleColorTheme.lut = {
                image: h.data,
                data: t
              }, o()) : r(new Error("Missing LUT image."));
            };
          });
        }
      }, {
        key: "getLut",
        value: function getLut(e) {
          var t = this._styleColorThemeForScope[e];
          return t ? t.lut : null;
        }
      }, {
        key: "setProjection",
        value: function setProjection(e) {
          e ? this.stylesheet.projection = e : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
        }
      }, {
        key: "applyProjectionUpdate",
        value: function applyProjectionUpdate() {
          this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? (this.getTerrain() || this.stylesheet.terrain) && !this.disableElevatedTerrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null, 0));
        }
      }, {
        key: "_updateMapProjection",
        value: function _updateMapProjection() {
          this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
        }
      }, {
        key: "_loadSprite",
        value: function _loadSprite(t) {
          var _this154 = this;
          this._spriteRequest = function (t, i, o) {
            var r, a, n;
            var s = e.e.devicePixelRatio > 1 ? "@2x" : "";
            var l = e.h(i.transformRequest(i.normalizeSpriteURL(t, s, ".json"), e.R.SpriteJSON), function (e, t) {
                l = null, n || (n = e, r = t, h());
              }),
              c = e.i(i.transformRequest(i.normalizeSpriteURL(t, s, ".png"), e.R.SpriteImage), function (e, t) {
                c = null, n || (n = e, a = t, h());
              });
            function h() {
              if (n) o(n);else if (r && a) {
                var _t615 = e.e.getImageData(a),
                  _i459 = {};
                for (var _o258 in r) {
                  var _r$_o = r[_o258],
                    _a246 = _r$_o.width,
                    _n310 = _r$_o.height,
                    _s257 = _r$_o.x,
                    _l140 = _r$_o.y,
                    _c120 = _r$_o.sdf,
                    _h92 = _r$_o.pixelRatio,
                    _37 = _r$_o.stretchX,
                    _u103 = _r$_o.stretchY,
                    _d52 = _r$_o.content,
                    _p69 = new e.j({
                      width: _a246,
                      height: _n310
                    });
                  e.j.copy(_t615, _p69, {
                    x: _s257,
                    y: _l140
                  }, {
                    x: 0,
                    y: 0
                  }, {
                    width: _a246,
                    height: _n310
                  }, null), _i459[_o258] = {
                    data: _p69,
                    pixelRatio: _h92,
                    sdf: _c120,
                    stretchX: _37,
                    stretchY: _u103,
                    content: _d52
                  };
                }
                o(null, _i459);
              }
            }
            return {
              cancel: function cancel() {
                l && (l.cancel(), l = null), c && (c.cancel(), c = null);
              }
            };
          }(t, this.map._requestManager, function (t, i) {
            if (_this154._spriteRequest = null, t) _this154.fire(new e.f(t));else if (i) for (var _e651 in i) _this154.imageManager.addImage(_e651, _this154.scope, i[_e651]);
            _this154.imageManager.setLoaded(!0, _this154.scope), _this154._availableImages = _this154.imageManager.listImages(_this154.scope), _this154.dispatcher.broadcast("setImages", {
              scope: _this154.scope,
              images: _this154._availableImages
            }), _this154.dispatcher.broadcast("spriteLoaded", {
              scope: _this154.scope,
              isLoaded: !0
            }), _this154.fire(new e.g("data", {
              dataType: "style"
            }));
          });
        }
      }, {
        key: "_validateLayer",
        value: function _validateLayer(t) {
          var i = this.getOwnSource(t.source);
          if (!i) return;
          var o = t.sourceLayer;
          o && ("geojson" === i.type || i.vectorLayerIds && -1 === i.vectorLayerIds.indexOf(o)) && this.fire(new e.f(new Error("Source layer \"".concat(o, "\" does not exist on source \"").concat(i.id, "\" as specified by style layer \"").concat(t.id, "\""))));
        }
      }, {
        key: "loaded",
        value: function loaded() {
          if (!this._loaded) return !1;
          if (Object.keys(this._changes.getUpdatedSourceCaches()).length) return !1;
          for (var _e652 in this._sourceCaches) if (!this._sourceCaches[_e652].loaded()) return !1;
          if (!this.imageManager.isLoaded()) return !1;
          if (!this.modelManager.isLoaded()) return !1;
          if (this._styleColorTheme.lutLoading) return !1;
          var _iterator446 = _createForOfIteratorHelper(this.fragments),
            _step446;
          try {
            for (_iterator446.s(); !(_step446 = _iterator446.n()).done;) {
              var _e653 = _step446.value.style;
              if (!_e653.loaded()) return !1;
            }
          } catch (err) {
            _iterator446.e(err);
          } finally {
            _iterator446.f();
          }
          return !0;
        }
      }, {
        key: "_serializeImports",
        value: function _serializeImports() {
          var _this155 = this;
          if (this.stylesheet.imports) return this.stylesheet.imports.map(function (e, t) {
            var i = _this155.fragments[t];
            return i && i.style && (e.data = i.style.serialize()), e;
          });
        }
      }, {
        key: "_serializeSources",
        value: function _serializeSources() {
          var e = {};
          for (var _t616 in this._sourceCaches) {
            var _i460 = this._sourceCaches[_t616].getSource();
            e[_i460.id] || (e[_i460.id] = _i460.serialize());
          }
          return e;
        }
      }, {
        key: "_serializeLayers",
        value: function _serializeLayers(e) {
          var t = [];
          var _iterator447 = _createForOfIteratorHelper(e),
            _step447;
          try {
            for (_iterator447.s(); !(_step447 = _iterator447.n()).done;) {
              var _i461 = _step447.value;
              var _e654 = this._layers[_i461];
              _e654 && "custom" !== _e654.type && t.push(_e654.serialize());
            }
          } catch (err) {
            _iterator447.e(err);
          } finally {
            _iterator447.f();
          }
          return t;
        }
      }, {
        key: "hasLightTransitions",
        value: function hasLightTransitions() {
          return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
        }
      }, {
        key: "hasFogTransition",
        value: function hasFogTransition() {
          return !!this.fog && this.fog.hasTransition();
        }
      }, {
        key: "hasTransitions",
        value: function hasTransitions() {
          if (this.hasLightTransitions()) return !0;
          if (this.hasFogTransition()) return !0;
          for (var _e655 in this._sourceCaches) if (this._sourceCaches[_e655].hasTransition()) return !0;
          for (var _e656 in this._layers) if (this._layers[_e656].hasTransition()) return !0;
          return !1;
        }
      }, {
        key: "order",
        get: function get() {
          return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
        }
      }, {
        key: "isLayerDraped",
        value: function isLayerDraped(e) {
          return !!this.terrain && e.isDraped(this.getLayerSourceCache(e));
        }
      }, {
        key: "_checkLoaded",
        value: function _checkLoaded() {
          if (!this._loaded) throw new Error("Style is not done loading");
        }
      }, {
        key: "_checkLayer",
        value: function _checkLayer(t) {
          var i = this.getOwnLayer(t);
          if (i) return i;
          this.fire(new e.f(new Error("The layer '".concat(t, "' does not exist in the map's style."))));
        }
      }, {
        key: "_checkSource",
        value: function _checkSource(t) {
          var i = this.getOwnSource(t);
          if (i) return i;
          this.fire(new e.f(new Error("The source '".concat(t, "' does not exist in the map's style."))));
        }
      }, {
        key: "precompilePrograms",
        value: function precompilePrograms(e, t) {
          var i = this.map.painter;
          if (i) for (var _o259 = e.minzoom || 0; _o259 < (e.maxzoom || 25.5); _o259++) {
            var _o260 = e.getProgramIds();
            if (_o260) {
              var _iterator448 = _createForOfIteratorHelper(_o260),
                _step448;
              try {
                for (_iterator448.s(); !(_step448 = _iterator448.n()).done;) {
                  var _r456 = _step448.value;
                  var _o261 = e.getDefaultProgramParams(_r456, t.zoom, this._styleColorTheme.lut);
                  _o261 && (i.style = this, this.fog && (i._fogVisible = !0, _o261.overrideFog = !0, i.getOrCreateProgram(_r456, _o261)), i._fogVisible = !1, _o261.overrideFog = !1, i.getOrCreateProgram(_r456, _o261), (this.stylesheet.terrain || this.stylesheet.projection && "globe" === this.stylesheet.projection.name) && (_o261.overrideRtt = !0, i.getOrCreateProgram(_r456, _o261)));
                }
              } catch (err) {
                _iterator448.e(err);
              } finally {
                _iterator448.f();
              }
            }
          }
        }
      }, {
        key: "update",
        value: function update(t) {
          var _this156 = this;
          if (!this._loaded) return;
          this.ambientLight && this.ambientLight.recalculate(t), this.directionalLight && this.directionalLight.recalculate(t);
          var i = this.calculateLightsBrightness();
          t.brightness = i || 0, i !== this._brightness && (this._brightness = i, this.dispatcher.broadcast("setBrightness", i));
          var o = this._changes.isDirty();
          var r = !1;
          if (this._changes.isDirty()) {
            var _e657 = this._changes.getLayerUpdatesByScope();
            for (var _t617 in _e657) {
              var _e657$_t = _e657[_t617],
                _i462 = _e657$_t.updatedIds,
                _o262 = _e657$_t.removedIds;
              (_i462 || _o262) && (this._updateWorkerLayers(_t617, _i462, _o262), r = !0);
            }
            this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(t), this.light && this.light.updateTransitions(t), this.ambientLight && this.ambientLight.updateTransitions(t), this.directionalLight && this.directionalLight.updateTransitions(t), this.fog && this.fog.updateTransitions(t), this._changes.reset();
          }
          var a = {};
          for (var _e658 in this._mergedSourceCaches) {
            var _t618 = this._mergedSourceCaches[_e658];
            a[_e658] = _t618.used, _t618.used = !1, _t618.tileCoverLift = 0;
          }
          var _iterator449 = _createForOfIteratorHelper(this._mergedOrder),
            _step449;
          try {
            var _loop24 = function _loop24() {
              var e = _step449.value;
              var i = _this156._mergedLayers[e];
              if (i.recalculate(t, _this156._availableImages), !i.isHidden(t.zoom)) {
                var _e659 = _this156.getLayerSourceCache(i);
                _e659 && (_e659.used = !0, _e659.tileCoverLift = Math.max(_e659.tileCoverLift, i.tileCoverLift()));
              }
              !_this156._precompileDone && _this156._shouldPrecompile && ("requestIdleCallback" in window ? requestIdleCallback(function () {
                _this156.precompilePrograms(i, t);
              }) : _this156.precompilePrograms(i, t));
            };
            for (_iterator449.s(); !(_step449 = _iterator449.n()).done;) {
              _loop24();
            }
          } catch (err) {
            _iterator449.e(err);
          } finally {
            _iterator449.f();
          }
          this._shouldPrecompile && (this._precompileDone = !0), this.terrain && r && this.mergeLayers();
          for (var _t619 in a) {
            var _i463 = this._mergedSourceCaches[_t619];
            a[_t619] !== _i463.used && _i463.getSource().fire(new e.g("data", {
              sourceDataType: "visibility",
              dataType: "source",
              sourceId: _i463.getSource().id
            }));
          }
          this.light && this.light.recalculate(t), this.terrain && this.terrain.recalculate(t), this.fog && this.fog.recalculate(t), this.z = t.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), o && this.fire(new e.g("data", {
            dataType: "style"
          }));
        }
      }, {
        key: "_updateTilesForChangedImages",
        value: function _updateTilesForChangedImages() {
          var e = this._changes.getUpdatedImages();
          if (e.length) {
            for (var _t620 in this._sourceCaches) this._sourceCaches[_t620].reloadTilesForDependencies(["icons", "patterns"], e);
            this._changes.resetUpdatedImages();
          }
        }
      }, {
        key: "_updateWorkerLayers",
        value: function _updateWorkerLayers(e, t, i) {
          var o = this.getFragmentStyle(e);
          o && this.dispatcher.broadcast("updateLayers", {
            layers: t ? o._serializeLayers(t) : [],
            scope: e,
            removedIds: i || [],
            options: o.options
          });
        }
      }, {
        key: "setState",
        value: function setState(t, i) {
          var _this157 = this;
          if (this._checkLoaded(), wa(this, ze(t))) return !1;
          (t = e.cW(t)).layers = Fr(t.layers);
          var o = function (t, i) {
            if (!t) return [{
              command: Br.setStyle,
              args: [i]
            }];
            var o = [];
            try {
              if (!e.d(t.version, i.version)) return [{
                command: Br.setStyle,
                args: [i]
              }];
              if (e.d(t.center, i.center) || o.push({
                command: Br.setCenter,
                args: [i.center]
              }), e.d(t.zoom, i.zoom) || o.push({
                command: Br.setZoom,
                args: [i.zoom]
              }), e.d(t.bearing, i.bearing) || o.push({
                command: Br.setBearing,
                args: [i.bearing]
              }), e.d(t.pitch, i.pitch) || o.push({
                command: Br.setPitch,
                args: [i.pitch]
              }), e.d(t.sprite, i.sprite) || o.push({
                command: Br.setSprite,
                args: [i.sprite]
              }), e.d(t.glyphs, i.glyphs) || o.push({
                command: Br.setGlyphs,
                args: [i.glyphs]
              }), e.d(t.imports, i.imports) || function () {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var o = arguments.length > 2 ? arguments[2] : undefined;
                i = i || [];
                var r = (t = t || []).map(Vr),
                  a = i.map(Vr),
                  n = t.reduce($r, {}),
                  s = i.reduce($r, {}),
                  l = r.slice();
                var c, h, _, u;
                for (c = 0, h = 0; c < r.length; c++) _ = r[c], s.hasOwnProperty(_) ? h++ : (o.push({
                  command: Br.removeImport,
                  args: [_]
                }), l.splice(l.indexOf(_, h), 1));
                for (c = 0, h = 0; c < a.length; c++) _ = a[a.length - 1 - c], l[l.length - 1 - c] !== _ && (n.hasOwnProperty(_) ? (o.push({
                  command: Br.removeImport,
                  args: [_]
                }), l.splice(l.lastIndexOf(_, l.length - h), 1)) : h++, u = l[l.length - c], o.push({
                  command: Br.addImport,
                  args: [s[_], u]
                }), l.splice(l.length - c, 0, _));
                var _iterator450 = _createForOfIteratorHelper(i),
                  _step450;
                try {
                  for (_iterator450.s(); !(_step450 = _iterator450.n()).done;) {
                    var _t621 = _step450.value;
                    var _i464 = n[_t621.id];
                    _i464 && !e.d(_i464, _t621) && o.push({
                      command: Br.updateImport,
                      args: [_t621.id, _t621]
                    });
                  }
                } catch (err) {
                  _iterator450.e(err);
                } finally {
                  _iterator450.f();
                }
              }(t.imports, i.imports, o), e.d(t.transition, i.transition) || o.push({
                command: Br.setTransition,
                args: [i.transition]
              }), e.d(t.light, i.light) || o.push({
                command: Br.setLight,
                args: [i.light]
              }), e.d(t.fog, i.fog) || o.push({
                command: Br.setFog,
                args: [i.fog]
              }), e.d(t.projection, i.projection) || o.push({
                command: Br.setProjection,
                args: [i.projection]
              }), e.d(t.lights, i.lights) || o.push({
                command: Br.setLights,
                args: [i.lights]
              }), e.d(t.camera, i.camera) || o.push({
                command: Br.setCamera,
                args: [i.camera]
              }), !e.d(t["color-theme"], i["color-theme"])) return [{
                command: Br.setStyle,
                args: [i]
              }];
              var _r457 = {},
                _a247 = [];
              !function (t, i, o, r) {
                var a;
                for (a in i = i || {}, t = t || {}) t.hasOwnProperty(a) && (i.hasOwnProperty(a) || Nr(a, o, r));
                for (a in i) {
                  if (!i.hasOwnProperty(a)) continue;
                  var _n311 = i[a];
                  t.hasOwnProperty(a) ? e.d(t[a], _n311) || ("geojson" === t[a].type && "geojson" === _n311.type && Gr(t, i, a) ? o.push({
                    command: Br.setGeoJSONSourceData,
                    args: [a, _n311.data]
                  }) : Ur(a, i, o, r)) : kr(a, i, o);
                }
              }(t.sources, i.sources, _a247, _r457);
              var _n312 = [];
              t.layers && t.layers.forEach(function (e) {
                e.source && _r457[e.source] ? o.push({
                  command: Br.removeLayer,
                  args: [e.id]
                }) : _n312.push(e);
              });
              var _s258 = t.terrain;
              _s258 && _r457[_s258.source] && (o.push({
                command: Br.setTerrain,
                args: [void 0]
              }), _s258 = void 0), o = o.concat(_a247), e.d(_s258, i.terrain) || o.push({
                command: Br.setTerrain,
                args: [i.terrain]
              }), function (t, i, o) {
                i = i || [];
                var r = (t = t || []).map(Vr),
                  a = i.map(Vr),
                  n = t.reduce($r, {}),
                  s = i.reduce($r, {}),
                  l = r.slice(),
                  c = Object.create(null);
                var h, _, u, d, p, f, m;
                for (h = 0, _ = 0; h < r.length; h++) u = r[h], s.hasOwnProperty(u) ? _++ : (o.push({
                  command: Br.removeLayer,
                  args: [u]
                }), l.splice(l.indexOf(u, _), 1));
                for (h = 0, _ = 0; h < a.length; h++) u = a[a.length - 1 - h], l[l.length - 1 - h] !== u && (n.hasOwnProperty(u) ? (o.push({
                  command: Br.removeLayer,
                  args: [u]
                }), l.splice(l.lastIndexOf(u, l.length - _), 1)) : _++, f = l[l.length - h], o.push({
                  command: Br.addLayer,
                  args: [s[u], f]
                }), l.splice(l.length - h, 0, u), c[u] = !0);
                for (h = 0; h < a.length; h++) if (u = a[h], d = n[u], p = s[u], !c[u] && !e.d(d, p)) if (e.d(d.source, p.source) && e.d(d["source-layer"], p["source-layer"]) && e.d(d.type, p.type)) {
                  for (m in jr(d.layout, p.layout, o, u, null, Br.setLayoutProperty), jr(d.paint, p.paint, o, u, null, Br.setPaintProperty), e.d(d.slot, p.slot) || o.push({
                    command: Br.setSlot,
                    args: [u, p.slot]
                  }), e.d(d.filter, p.filter) || o.push({
                    command: Br.setFilter,
                    args: [u, p.filter]
                  }), e.d(d.minzoom, p.minzoom) && e.d(d.maxzoom, p.maxzoom) || o.push({
                    command: Br.setLayerZoomRange,
                    args: [u, p.minzoom, p.maxzoom]
                  }), d) d.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? jr(d[m], p[m], o, u, m.slice(6), Br.setPaintProperty) : e.d(d[m], p[m]) || o.push({
                    command: Br.setLayerProperty,
                    args: [u, m, p[m]]
                  }));
                  for (m in p) p.hasOwnProperty(m) && !d.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? jr(d[m], p[m], o, u, m.slice(6), Br.setPaintProperty) : e.d(d[m], p[m]) || o.push({
                    command: Br.setLayerProperty,
                    args: [u, m, p[m]]
                  }));
                } else o.push({
                  command: Br.removeLayer,
                  args: [u]
                }), f = l[l.lastIndexOf(u) + 1], o.push({
                  command: Br.addLayer,
                  args: [p, f]
                });
              }(_n312, i.layers, o);
            } catch (e) {
              console.warn("Unable to compute style diff:", e), o = [{
                command: Br.setStyle,
                args: [i]
              }];
            }
            return o;
          }(this.serialize(), t).filter(function (e) {
            return !(e.command in Ea);
          });
          if (0 === o.length) return !1;
          var r = o.filter(function (e) {
            return !(e.command in Ta);
          });
          if (r.length > 0) throw new Error("Unimplemented: ".concat(r.map(function (e) {
            return e.command;
          }).join(", "), "."));
          var a = [];
          return o.forEach(function (e) {
            a.push(_this157[e.command].apply(_this157, e.args));
          }), i && Promise.all(a).then(i), this.stylesheet = t, this.mergeAll(), this.dispatcher.broadcast("setLayers", {
            layers: this._serializeLayers(this._order),
            scope: this.scope,
            options: this.options
          }), !0;
        }
      }, {
        key: "addImage",
        value: function addImage(t, i) {
          return this.getImage(t) ? this.fire(new e.f(new Error("An image with this name already exists."))) : (this.imageManager.addImage(t, this.scope, i), this._afterImageUpdated(t), this);
        }
      }, {
        key: "updateImage",
        value: function updateImage(e, t) {
          this.imageManager.updateImage(e, this.scope, t);
        }
      }, {
        key: "getImage",
        value: function getImage(e) {
          return this.imageManager.getImage(e, this.scope);
        }
      }, {
        key: "removeImage",
        value: function removeImage(t) {
          return this.getImage(t) ? (this.imageManager.removeImage(t, this.scope), this._afterImageUpdated(t), this) : this.fire(new e.f(new Error("No image with this name exists.")));
        }
      }, {
        key: "_afterImageUpdated",
        value: function _afterImageUpdated(t) {
          this._availableImages = this.imageManager.listImages(this.scope), this._changes.updateImage(t), this.dispatcher.broadcast("setImages", {
            scope: this.scope,
            images: this._availableImages
          }), this.fire(new e.g("data", {
            dataType: "style"
          }));
        }
      }, {
        key: "listImages",
        value: function listImages() {
          return this._checkLoaded(), this._availableImages.slice();
        }
      }, {
        key: "addModel",
        value: function addModel(e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          return this._checkLoaded(), this._validate($e, "models.".concat(e), t, null, i) || (this.modelManager.addModel(e, t, this.scope), this._changes.setDirty()), this;
        }
      }, {
        key: "hasModel",
        value: function hasModel(e) {
          return this.modelManager.hasModel(e, this.scope);
        }
      }, {
        key: "removeModel",
        value: function removeModel(t) {
          return this.hasModel(t) ? (this.modelManager.removeModel(t, this.scope), this) : this.fire(new e.f(new Error("No model with this ID exists.")));
        }
      }, {
        key: "listModels",
        value: function listModels() {
          return this._checkLoaded(), this.modelManager.listModels(this.scope);
        }
      }, {
        key: "addSource",
        value: function addSource(t, i) {
          var _this158 = this;
          var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (this._checkLoaded(), void 0 !== this.getOwnSource(t)) throw new Error("There is already a source with ID \"".concat(t, "\"."));
          if (!i.type) throw new Error("The type property must be defined, but only the following properties were given: ".concat(Object.keys(i).join(", "), "."));
          if (["vector", "raster", "geojson", "video", "image"].indexOf(i.type) >= 0 && this._validate(Oe, "sources.".concat(t), i, null, o)) return;
          this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
          var r = Ri(t, i, this.dispatcher, this);
          r.scope = this.scope, r.setEventedParent(this, function () {
            return {
              isSourceLoaded: _this158._isSourceCacheLoaded(r.id),
              source: r.serialize(),
              sourceId: r.id
            };
          });
          var a = function a(t) {
            var i = (t ? "symbol:" : "other:") + r.id,
              o = e.am(i, _this158.scope),
              a = _this158._sourceCaches[i] = new e.bx(o, r, t);
            (t ? _this158._symbolSourceCaches : _this158._otherSourceCaches)[r.id] = a, a.onAdd(_this158.map);
          };
          a(!1), "vector" !== i.type && "geojson" !== i.type || a(!0), r.onAdd && r.onAdd(this.map), o.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
        }
      }, {
        key: "removeSource",
        value: function removeSource(t) {
          this._checkLoaded();
          var i = this.getOwnSource(t);
          if (!i) throw new Error("There is no source with this ID");
          for (var _i465 in this._layers) if (this._layers[_i465].source === t) return this.fire(new e.f(new Error("Source \"".concat(t, "\" cannot be removed while layer \"").concat(_i465, "\" is using it."))));
          if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === t) return this.fire(new e.f(new Error("Source \"".concat(t, "\" cannot be removed while terrain is using it."))));
          var o = this.getOwnSourceCaches(t);
          var _iterator451 = _createForOfIteratorHelper(o),
            _step451;
          try {
            for (_iterator451.s(); !(_step451 = _iterator451.n()).done;) {
              var _t622 = _step451.value;
              var _i466 = e.cX(_t622.id);
              delete this._sourceCaches[_i466], this._changes.discardSourceCacheUpdate(_t622.id), _t622.fire(new e.g("data", {
                sourceDataType: "metadata",
                dataType: "source",
                sourceId: _t622.getSource().id
              })), _t622.setEventedParent(null), _t622.clearTiles();
            }
          } catch (err) {
            _iterator451.e(err);
          } finally {
            _iterator451.f();
          }
          return delete this._otherSourceCaches[t], delete this._symbolSourceCaches[t], this.mergeSources(), i.setEventedParent(null), i.onRemove && i.onRemove(this.map), this._changes.setDirty(), this;
        }
      }, {
        key: "setGeoJSONSourceData",
        value: function setGeoJSONSourceData(e, t) {
          this._checkLoaded(), this.getOwnSource(e).setData(t), this._changes.setDirty();
        }
      }, {
        key: "getOwnSource",
        value: function getOwnSource(e) {
          var t = this.getOwnSourceCache(e);
          return t && t.getSource();
        }
      }, {
        key: "getOwnSources",
        value: function getOwnSources() {
          var e = [];
          for (var _t623 in this._otherSourceCaches) {
            var _i467 = this.getOwnSourceCache(_t623);
            _i467 && e.push(_i467.getSource());
          }
          return e;
        }
      }, {
        key: "areTilesLoaded",
        value: function areTilesLoaded() {
          var e = this._mergedSourceCaches;
          for (var _t624 in e) {
            var _i468 = e[_t624]._tiles;
            for (var _e660 in _i468) {
              var _t625 = _i468[_e660];
              if ("loaded" !== _t625.state && "errored" !== _t625.state) return !1;
            }
          }
          return !0;
        }
      }, {
        key: "setLights",
        value: function setLights(t) {
          if (this._checkLoaded(), !t) return delete this.ambientLight, void delete this.directionalLight;
          var i = this._getTransitionParameters();
          var _iterator452 = _createForOfIteratorHelper(t),
            _step452;
          try {
            for (_iterator452.s(); !(_step452 = _iterator452.n()).done;) {
              var _o263 = _step452.value;
              if (this._validate(Be, "lights", _o263)) return;
              switch (_o263.type) {
                case "ambient":
                  if (this.ambientLight) {
                    var _e661 = this.ambientLight;
                    _e661.set(_o263), _e661.updateTransitions(i);
                  } else this.ambientLight = new nt(_o263, st || (st = new e.U({
                    color: new e.W(e.N.properties_light_ambient.color),
                    intensity: new e.W(e.N.properties_light_ambient.intensity)
                  })), this.scope, this.options);
                  break;
                case "directional":
                  if (this.directionalLight) {
                    var _e662 = this.directionalLight;
                    _e662.set(_o263), _e662.updateTransitions(i);
                  } else this.directionalLight = new nt(_o263, lt || (lt = new e.U({
                    direction: new e.a6(e.N.properties_light_directional.direction),
                    color: new e.W(e.N.properties_light_directional.color),
                    intensity: new e.W(e.N.properties_light_directional.intensity),
                    "cast-shadows": new e.W(e.N.properties_light_directional["cast-shadows"]),
                    "shadow-intensity": new e.W(e.N.properties_light_directional["shadow-intensity"])
                  })), this.scope, this.options);
              }
            }
          } catch (err) {
            _iterator452.e(err);
          } finally {
            _iterator452.f();
          }
          var o = new e.Y(this.z || 0, i);
          this.ambientLight && this.ambientLight.recalculate(o), this.directionalLight && this.directionalLight.recalculate(o), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("setBrightness", this._brightness);
        }
      }, {
        key: "calculateLightsBrightness",
        value: function calculateLightsBrightness() {
          var t = this.directionalLight,
            i = this.ambientLight;
          if (!t || !i) return;
          var o = function o(e) {
              return .2126 * (e[0] <= .03928 ? e[0] / 12.92 : Math.pow((e[0] + .055) / 1.055, 2.4)) + .7152 * (e[1] <= .03928 ? e[1] / 12.92 : Math.pow((e[1] + .055) / 1.055, 2.4)) + .0722 * (e[2] <= .03928 ? e[2] / 12.92 : Math.pow((e[2] + .055) / 1.055, 2.4));
            },
            r = t.properties.get("color").toRenderColor(null).toArray01(),
            a = t.properties.get("intensity"),
            n = t.properties.get("direction"),
            s = 1 - e.ad(n.x, n.y, n.z)[2] / 90,
            l = o(r) * a * s,
            c = i.properties.get("color").toRenderColor(null).toArray01(),
            h = i.properties.get("intensity");
          return (l + o(c) * h) / 2;
        }
      }, {
        key: "getBrightness",
        value: function getBrightness() {
          return this._brightness;
        }
      }, {
        key: "getLights",
        value: function getLights() {
          if (!this.enable3dLights()) return null;
          var e = [];
          return this.directionalLight && e.push(this.directionalLight.get()), this.ambientLight && e.push(this.ambientLight.get()), e;
        }
      }, {
        key: "enable3dLights",
        value: function enable3dLights() {
          return !!this.ambientLight && !!this.directionalLight;
        }
      }, {
        key: "getFragmentStyle",
        value: function getFragmentStyle(t) {
          if (!t) return this;
          if (e.cY(t)) {
            var _i469 = e.cZ(t),
              _o264 = this.fragments.find(function (_ref188) {
                var e = _ref188.id;
                return e === _i469;
              });
            if (!_o264) throw new Error("Style import not found: ".concat(t));
            var _r458 = e.cX(t);
            return _o264.style.getFragmentStyle(_r458);
          }
          {
            var _e663 = this.fragments.find(function (_ref189) {
              var e = _ref189.id;
              return e === t;
            });
            if (!_e663) throw new Error("Style import not found: ".concat(t));
            return _e663.style;
          }
        }
      }, {
        key: "getConfigProperty",
        value: function getConfigProperty(t, i) {
          var o = this.getFragmentStyle(t);
          if (!o) return null;
          var r = e.am(i, o.scope),
            a = o.options.get(r),
            n = a ? a.value || a.default : null;
          return n ? n.serialize() : null;
        }
      }, {
        key: "setConfigProperty",
        value: function setConfigProperty(t, i, o) {
          var r = this.getFragmentStyle(t);
          if (!r) return;
          var a = r.stylesheet.schema;
          if (!a || !a[i]) return;
          var n = e.z(o);
          if ("success" !== n.result) return void wa(this, n.value);
          var s = n.value.expression,
            l = e.am(i, r.scope),
            c = r.options.get(l);
          if (!c) return;
          var h;
          var _a$i = a[i],
            _ = _a$i.minValue,
            u = _a$i.maxValue,
            d = _a$i.stepValue,
            p = _a$i.type,
            f = _a$i.values,
            m = e.z(a[i].default);
          "success" === m.result && (h = m.value.expression), h ? (this.options.set(l, _objectSpread(_objectSpread({}, c), {}, {
            value: s,
            default: h,
            minValue: _,
            maxValue: u,
            stepValue: d,
            type: p,
            values: f
          })), this.updateConfigDependencies(i)) : this.fire(new e.f(new Error("No schema defined for the config option \"".concat(i, "\" in the \"").concat(t, "\" fragment."))));
        }
      }, {
        key: "getConfig",
        value: function getConfig(t) {
          var i = this.getFragmentStyle(t);
          if (!i) return null;
          var o = i.stylesheet.schema;
          if (!o) return null;
          var r = {};
          for (var _t626 in o) {
            var _o265 = e.am(_t626, i.scope),
              _a248 = i.options.get(_o265),
              _n313 = _a248 ? _a248.value || _a248.default : null;
            r[_t626] = _n313 ? _n313.serialize() : null;
          }
          return r;
        }
      }, {
        key: "setConfig",
        value: function setConfig(e, t) {
          var i = this.getFragmentStyle(e);
          i && (i.updateConfig(t, i.stylesheet.schema), this.updateConfigDependencies());
        }
      }, {
        key: "getSchema",
        value: function getSchema(e) {
          var t = this.getFragmentStyle(e);
          return t ? t.stylesheet.schema : null;
        }
      }, {
        key: "setSchema",
        value: function setSchema(e, t) {
          var i = this.getFragmentStyle(e);
          i && (i.stylesheet.schema = t, i.updateConfig(i._config, t), this.updateConfigDependencies());
        }
      }, {
        key: "updateConfig",
        value: function updateConfig(t, i) {
          if (this._config = t, t || i) if (i) for (var _o266 in i) {
            var _r459 = void 0,
              _a249 = void 0;
            var _n314 = e.z(i[_o266].default);
            if ("success" === _n314.result && (_r459 = _n314.value.expression), t && void 0 !== t[_o266]) {
              var _i470 = e.z(t[_o266]);
              "success" === _i470.result && (_a249 = _i470.value.expression);
            }
            var _i$_o = i[_o266],
              _s259 = _i$_o.minValue,
              _l141 = _i$_o.maxValue,
              _c121 = _i$_o.stepValue,
              _h93 = _i$_o.type,
              _38 = _i$_o.values;
            if (_r459) {
              var _t627 = e.am(_o266, this.scope);
              this.options.set(_t627, {
                default: _r459,
                value: _a249,
                minValue: _s259,
                maxValue: _l141,
                stepValue: _c121,
                type: _h93,
                values: _38
              });
            } else this.fire(new e.f(new Error("No schema defined for config option \"".concat(_o266, "\"."))));
          } else this.fire(new e.f(new Error("Attempting to set config for a style without schema.")));
        }
      }, {
        key: "updateConfigDependencies",
        value: function updateConfigDependencies(e) {
          var _iterator453 = _createForOfIteratorHelper(this._configDependentLayers),
            _step453;
          try {
            for (_iterator453.s(); !(_step453 = _iterator453.n()).done;) {
              var _t629 = _step453.value;
              var _i471 = this.getLayer(_t629);
              if (_i471) {
                if (e && !_i471.configDependencies.has(e)) continue;
                _i471.possiblyEvaluateVisibility(), this._updateLayer(_i471);
              }
            }
          } catch (err) {
            _iterator453.e(err);
          } finally {
            _iterator453.f();
          }
          this.ambientLight && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.updateConfig(this.options), this.fog && this.fog.updateConfig(this.options), this.forEachFragmentStyle(function (e) {
            if (e._styleColorTheme.colorTheme) {
              var _t628 = e._evaluateColorThemeData(e._styleColorTheme.colorTheme);
              (!e._styleColorTheme.lut && "" !== _t628 || e._styleColorTheme.lut && _t628 !== e._styleColorTheme.lut.data) && e.setColorTheme(e._styleColorTheme.colorTheme);
            }
          }), this._changes.setDirty();
        }
      }, {
        key: "addLayer",
        value: function addLayer(t, i) {
          var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          this._checkLoaded();
          var r = t.id;
          if (this._layers[r]) return void this.fire(new e.f(new Error("Layer with id \"".concat(r, "\" already exists on this map"))));
          var a;
          if ("custom" === t.type) {
            if (wa(this, e.c_(t))) return;
            a = e.c$(t, this.scope, this._styleColorTheme.lut, this.options);
          } else {
            if ("object" == typeof t.source && (this.addSource(r, t.source), t = e.cW(t), t = e.Q(t, {
              source: r
            })), this._validate(Ue, "layers.".concat(r), t, {
              arrayIndex: -1
            }, o)) return;
            a = e.c$(t, this.scope, this._styleColorTheme.lut, this.options), this._validateLayer(a), a.setEventedParent(this, {
              layer: {
                id: r
              }
            }), this._serializedLayers[a.id] = a.serialize();
          }
          0 !== a.configDependencies.size && this._configDependentLayers.add(a.fqid);
          var n = this._order.length;
          if (i) {
            var _t630 = this._order.indexOf(i);
            if (-1 === _t630) return void this.fire(new e.f(new Error("Layer with id \"".concat(i, "\" does not exist on this map."))));
            a.slot === this._layers[i].slot ? n = _t630 : e.w("Layer with id \"".concat(i, "\" has a different slot. Layers can only be rearranged within the same slot."));
          }
          this._order.splice(n, 0, r), this._layerOrderChanged = !0, this._layers[r] = a;
          var s = this.getOwnLayerSourceCache(a),
            l = !!this.directionalLight && this.directionalLight.shadowsEnabled();
          s && a.canCastShadows() && l && (s.castsShadows = !0);
          var c = this._changes.getRemovedLayer(a);
          if (c && a.source && s && "custom" !== a.type) {
            this._changes.discardLayerRemoval(a);
            var _t631 = e.am(a.source, a.scope);
            c.type !== a.type ? this._changes.updateSourceCache(_t631, "clear") : (this._changes.updateSourceCache(_t631, "reload"), s.pause());
          }
          this._updateLayer(a), a.onAdd && a.onAdd(this.map), a.scope = this.scope, this.mergeLayers();
        }
      }, {
        key: "moveLayer",
        value: function moveLayer(t, i) {
          this._checkLoaded();
          var o = this._checkLayer(t);
          if (!o) return;
          if (t === i) return;
          var r = this._order.indexOf(t);
          this._order.splice(r, 1);
          var a = this._order.length;
          if (i) {
            var _t632 = this._order.indexOf(i);
            if (-1 === _t632) return void this.fire(new e.f(new Error("Layer with id \"".concat(i, "\" does not exist on this map."))));
            o.slot === this._layers[i].slot ? a = _t632 : e.w("Layer with id \"".concat(i, "\" has a different slot. Layers can only be rearranged within the same slot."));
          }
          this._order.splice(a, 0, t), this._changes.setDirty(), this._layerOrderChanged = !0, this.mergeLayers();
        }
      }, {
        key: "removeLayer",
        value: function removeLayer(e) {
          this._checkLoaded();
          var t = this._checkLayer(e);
          if (!t) return;
          t.setEventedParent(null);
          var i = this._order.indexOf(e);
          this._order.splice(i, 1), delete this._layers[e], delete this._serializedLayers[e], this._changes.setDirty(), this._layerOrderChanged = !0, this._configDependentLayers.delete(t.fqid), this._changes.removeLayer(t);
          var o = this.getOwnLayerSourceCache(t);
          if (o && o.castsShadows) {
            var _e664 = !1;
            for (var _i472 in this._layers) if (this._layers[_i472].source === t.source && this._layers[_i472].canCastShadows()) {
              _e664 = !0;
              break;
            }
            o.castsShadows = _e664;
          }
          t.onRemove && t.onRemove(this.map), this.mergeLayers();
        }
      }, {
        key: "getOwnLayer",
        value: function getOwnLayer(e) {
          return this._layers[e];
        }
      }, {
        key: "hasLayer",
        value: function hasLayer(e) {
          return e in this._mergedLayers;
        }
      }, {
        key: "hasLayerType",
        value: function hasLayerType(e) {
          for (var _t633 in this._layers) if (this._layers[_t633].type === e) return !0;
          return !1;
        }
      }, {
        key: "setLayerZoomRange",
        value: function setLayerZoomRange(e, t, i) {
          this._checkLoaded();
          var o = this._checkLayer(e);
          o && (o.minzoom === t && o.maxzoom === i || (null != t && (o.minzoom = t), null != i && (o.maxzoom = i), this._updateLayer(o)));
        }
      }, {
        key: "getSlots",
        value: function getSlots() {
          return this._checkLoaded(), this._mergedSlots;
        }
      }, {
        key: "setSlot",
        value: function setSlot(e, t) {
          this._checkLoaded();
          var i = this._checkLayer(e);
          i && i.slot !== t && (i.slot = t, this._updateLayer(i));
        }
      }, {
        key: "setFilter",
        value: function setFilter(t, i) {
          var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          this._checkLoaded();
          var r = this._checkLayer(t);
          if (r && !e.d(r.filter, i)) return null == i ? (r.filter = void 0, void this._updateLayer(r)) : void (this._validate(Ge, "layers.".concat(r.id, ".filter"), i, {
            layerType: r.type
          }, o) || (r.filter = e.cW(i), this._updateLayer(r)));
        }
      }, {
        key: "getFilter",
        value: function getFilter(t) {
          var i = this._checkLayer(t);
          if (i) return e.cW(i.filter);
        }
      }, {
        key: "setLayoutProperty",
        value: function setLayoutProperty(t, i, o) {
          var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          this._checkLoaded();
          var a = this._checkLayer(t);
          if (a && !e.d(a.getLayoutProperty(i), o)) {
            if (null != o && (!r || !1 !== r.validate) && wa(a, Ve.call(ze, {
              key: "layers.".concat(t, ".layout.").concat(i),
              layerType: a.type,
              objectKey: i,
              value: o,
              styleSpec: e.N,
              style: {
                glyphs: !0,
                sprite: !0
              }
            }))) return;
            a.setLayoutProperty(i, o), 0 !== a.configDependencies.size && this._configDependentLayers.add(a.fqid), this._updateLayer(a);
          }
        }
      }, {
        key: "getLayoutProperty",
        value: function getLayoutProperty(e, t) {
          var i = this._checkLayer(e);
          if (i) return i.getLayoutProperty(t);
        }
      }, {
        key: "setPaintProperty",
        value: function setPaintProperty(t, i, o) {
          var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          this._checkLoaded();
          var a = this._checkLayer(t);
          if (!a) return;
          if (e.d(a.getPaintProperty(i), o)) return;
          if (null != o && (!r || !1 !== r.validate) && wa(a, je.call(ze, {
            key: "layers.".concat(t, ".paint.").concat(i),
            layerType: a.type,
            objectKey: i,
            value: o,
            styleSpec: e.N
          }))) return;
          var n = a.setPaintProperty(i, o);
          0 !== a.configDependencies.size && this._configDependentLayers.add(a.fqid), n && this._updateLayer(a), this._changes.updatePaintProperties(a);
        }
      }, {
        key: "getPaintProperty",
        value: function getPaintProperty(e, t) {
          var i = this._checkLayer(e);
          if (i) return i.getPaintProperty(t);
        }
      }, {
        key: "setFeatureState",
        value: function setFeatureState(t, i) {
          this._checkLoaded();
          var o = t.source,
            r = t.sourceLayer,
            a = this._checkSource(o);
          if (!a) return;
          var n = a.type;
          if ("geojson" === n && r) return void this.fire(new e.f(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
          if ("vector" === n && !r) return void this.fire(new e.f(new Error("The sourceLayer parameter must be provided for vector source types.")));
          void 0 === t.id && this.fire(new e.f(new Error("The feature id parameter must be provided.")));
          var s = this.getOwnSourceCaches(o);
          var _iterator454 = _createForOfIteratorHelper(s),
            _step454;
          try {
            for (_iterator454.s(); !(_step454 = _iterator454.n()).done;) {
              var _e665 = _step454.value;
              _e665.setFeatureState(r, t.id, i);
            }
          } catch (err) {
            _iterator454.e(err);
          } finally {
            _iterator454.f();
          }
        }
      }, {
        key: "removeFeatureState",
        value: function removeFeatureState(t, i) {
          this._checkLoaded();
          var o = t.source,
            r = this._checkSource(o);
          if (!r) return;
          var a = r.type,
            n = "vector" === a ? t.sourceLayer : void 0;
          if ("vector" === a && !n) return void this.fire(new e.f(new Error("The sourceLayer parameter must be provided for vector source types.")));
          if (i && "string" != typeof t.id && "number" != typeof t.id) return void this.fire(new e.f(new Error("A feature id is required to remove its specific state property.")));
          var s = this.getOwnSourceCaches(o);
          var _iterator455 = _createForOfIteratorHelper(s),
            _step455;
          try {
            for (_iterator455.s(); !(_step455 = _iterator455.n()).done;) {
              var _e666 = _step455.value;
              _e666.removeFeatureState(n, t.id, i);
            }
          } catch (err) {
            _iterator455.e(err);
          } finally {
            _iterator455.f();
          }
        }
      }, {
        key: "getFeatureState",
        value: function getFeatureState(t) {
          this._checkLoaded();
          var i = t.source,
            o = t.sourceLayer,
            r = this._checkSource(i);
          if (r) {
            if ("vector" !== r.type || o) return void 0 === t.id && this.fire(new e.f(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(i)[0].getFeatureState(o, t.id);
            this.fire(new e.f(new Error("The sourceLayer parameter must be provided for vector source types.")));
          }
        }
      }, {
        key: "setTransition",
        value: function setTransition(t) {
          return this.stylesheet.transition = e.Q({}, this.stylesheet.transition, t), this.transition = this.stylesheet.transition, this;
        }
      }, {
        key: "getTransition",
        value: function getTransition() {
          return e.Q({}, this.stylesheet.transition);
        }
      }, {
        key: "serialize",
        value: function serialize() {
          this._checkLoaded();
          var t = this.getTerrain(),
            i = t && this.terrain && this.terrain.scope === this.scope ? t : this.stylesheet.terrain;
          return e.d0({
            version: this.stylesheet.version,
            name: this.stylesheet.name,
            metadata: this.stylesheet.metadata,
            fragment: this.stylesheet.fragment,
            imports: this._serializeImports(),
            schema: this.stylesheet.schema,
            camera: this.stylesheet.camera,
            light: this.stylesheet.light,
            lights: this.stylesheet.lights,
            terrain: i,
            fog: this.stylesheet.fog,
            center: this.stylesheet.center,
            "color-theme": this.stylesheet["color-theme"],
            zoom: this.stylesheet.zoom,
            bearing: this.stylesheet.bearing,
            pitch: this.stylesheet.pitch,
            sprite: this.stylesheet.sprite,
            glyphs: this.stylesheet.glyphs,
            transition: this.stylesheet.transition,
            projection: this.stylesheet.projection,
            sources: this._serializeSources(),
            layers: this._serializeLayers(this._order)
          }, function (e) {
            return void 0 !== e;
          });
        }
      }, {
        key: "_updateLayer",
        value: function _updateLayer(t) {
          this._changes.updateLayer(t);
          var i = this.getLayerSourceCache(t),
            o = e.am(t.source, t.scope),
            r = this._changes.getUpdatedSourceCaches();
          t.source && !r[o] && i && "raster" !== i.getSource().type && (this._changes.updateSourceCache(o, "reload"), i.pause()), t.invalidateCompiledFilter();
        }
      }, {
        key: "_flattenAndSortRenderedFeatures",
        value: function _flattenAndSortRenderedFeatures(e) {
          var _this159 = this;
          var t = function t(e) {
              return "fill-extrusion" === _this159._mergedLayers[e].type || "model" === _this159._mergedLayers[e].type;
            },
            i = this.order,
            o = {},
            r = [];
          for (var _a250 = i.length - 1; _a250 >= 0; _a250--) {
            var _n315 = i[_a250];
            if (t(_n315)) {
              o[_n315] = _a250;
              var _iterator456 = _createForOfIteratorHelper(e),
                _step456;
              try {
                for (_iterator456.s(); !(_step456 = _iterator456.n()).done;) {
                  var _t634 = _step456.value;
                  var _e667 = _t634[_n315];
                  if (_e667) {
                    var _iterator457 = _createForOfIteratorHelper(_e667),
                      _step457;
                    try {
                      for (_iterator457.s(); !(_step457 = _iterator457.n()).done;) {
                        var _t635 = _step457.value;
                        r.push(_t635);
                      }
                    } catch (err) {
                      _iterator457.e(err);
                    } finally {
                      _iterator457.f();
                    }
                  }
                }
              } catch (err) {
                _iterator456.e(err);
              } finally {
                _iterator456.f();
              }
            }
          }
          r.sort(function (e, t) {
            return t.intersectionZ - e.intersectionZ;
          });
          var a = [];
          for (var _n316 = i.length - 1; _n316 >= 0; _n316--) {
            var _s260 = i[_n316];
            if (t(_s260)) for (var _e668 = r.length - 1; _e668 >= 0; _e668--) {
              var _t636 = r[_e668].feature;
              if (_t636.layer && o[_t636.layer.id] < _n316) break;
              a.push(_t636), r.pop();
            } else {
              var _iterator458 = _createForOfIteratorHelper(e),
                _step458;
              try {
                for (_iterator458.s(); !(_step458 = _iterator458.n()).done;) {
                  var _t637 = _step458.value;
                  var _e669 = _t637[_s260];
                  if (_e669) {
                    var _iterator459 = _createForOfIteratorHelper(_e669),
                      _step459;
                    try {
                      for (_iterator459.s(); !(_step459 = _iterator459.n()).done;) {
                        var _t638 = _step459.value;
                        a.push(_t638.feature);
                      }
                    } catch (err) {
                      _iterator459.e(err);
                    } finally {
                      _iterator459.f();
                    }
                  }
                }
              } catch (err) {
                _iterator458.e(err);
              } finally {
                _iterator458.f();
              }
            }
          }
          return a;
        }
      }, {
        key: "queryRenderedFeatures",
        value: function queryRenderedFeatures(t, i, o) {
          var _this160 = this;
          i && i.filter && this._validate(Ge, "queryRenderedFeatures.filter", i.filter, null, i), i.scope = this.scope, i.availableImages = this._availableImages, i.serializedLayers = this._serializedLayers;
          var r = {};
          if (i && i.layers) {
            if (!Array.isArray(i.layers)) return this.fire(new e.f(new Error("parameters.layers must be an Array."))), [];
            var _iterator460 = _createForOfIteratorHelper(i.layers),
              _step460;
            try {
              for (_iterator460.s(); !(_step460 = _iterator460.n()).done;) {
                var _t639 = _step460.value;
                var _i473 = this._mergedLayers[_t639];
                if (!_i473) return this.fire(new e.f(new Error("The layer '".concat(_t639, "' does not exist in the map's style and cannot be queried for features.")))), [];
                r[_i473.source] = !0;
              }
            } catch (err) {
              _iterator460.e(err);
            } finally {
              _iterator460.f();
            }
          }
          var a = [],
            n = i.serializedLayers || {},
            s = i && i.layers ? i.layers.some(function (e) {
              var t = _this160.getLayer(e);
              return t && t.is3D();
            }) : this.has3DLayers(),
            l = Sr.createFromScreenPoints(t, o);
          for (var _e670 in this._mergedSourceCaches) {
            var _t640 = this._mergedSourceCaches[_e670].getSource();
            if (!_t640 || _t640.scope !== i.scope) continue;
            var _c122 = this._mergedSourceCaches[_e670].getSource().id;
            i.layers && !r[_c122] || a.push(Dr(this._mergedSourceCaches[_e670], this._mergedLayers, n, l, i, o, s, !!this.map._showQueryGeometry));
          }
          return this.placement && a.push(function (e, t, i, o, r, a, n) {
            var s = {},
              l = a.queryRenderedSymbols(o),
              c = [];
            var _iterator461 = _createForOfIteratorHelper(Object.keys(l).map(Number)),
              _step461;
            try {
              for (_iterator461.s(); !(_step461 = _iterator461.n()).done;) {
                var _e673 = _step461.value;
                c.push(n[_e673]);
              }
            } catch (err) {
              _iterator461.e(err);
            } finally {
              _iterator461.f();
            }
            c.sort(Mr);
            var _loop25 = function _loop25() {
              var i = _c123[_i474];
              var o = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], t, i.bucketIndex, i.sourceLayerIndex, r.filter, r.layers, r.availableImages, e);
              for (var _e671 in o) {
                var _t641 = s[_e671] = s[_e671] || [],
                  _r460 = o[_e671];
                _r460.sort(function (e, t) {
                  var o = i.featureSortOrder;
                  if (o) {
                    var _i475 = o.indexOf(e.featureIndex);
                    return o.indexOf(t.featureIndex) - _i475;
                  }
                  return t.featureIndex - e.featureIndex;
                });
                var _iterator462 = _createForOfIteratorHelper(_r460),
                  _step462;
                try {
                  for (_iterator462.s(); !(_step462 = _iterator462.n()).done;) {
                    var _e672 = _step462.value;
                    _t641.push(_e672);
                  }
                } catch (err) {
                  _iterator462.e(err);
                } finally {
                  _iterator462.f();
                }
              }
            };
            for (var _i474 = 0, _c123 = c; _i474 < _c123.length; _i474++) {
              _loop25();
            }
            var _loop26 = function _loop26(_t642) {
              s[_t642].forEach(function (o) {
                var r = o.feature,
                  a = i(e[_t642]);
                if (!a) return;
                var n = a.getFeatureState(r.layer["source-layer"], r.id);
                r.source = r.layer.source, r.layer["source-layer"] && (r.sourceLayer = r.layer["source-layer"]), r.state = n;
              });
            };
            for (var _t642 in s) {
              _loop26(_t642);
            }
            return s;
          }(this._mergedLayers, n, this.getLayerSourceCache.bind(this), l.screenGeometry, i, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(a);
        }
      }, {
        key: "querySourceFeatures",
        value: function querySourceFeatures(e, t) {
          t && t.filter && this._validate(Ge, "querySourceFeatures.filter", t.filter, null, t);
          var i = this.getOwnSourceCaches(e);
          var o = [];
          var _iterator463 = _createForOfIteratorHelper(i),
            _step463;
          try {
            for (_iterator463.s(); !(_step463 = _iterator463.n()).done;) {
              var _e674 = _step463.value;
              o = o.concat(Ar(_e674, t));
            }
          } catch (err) {
            _iterator463.e(err);
          } finally {
            _iterator463.f();
          }
          return o;
        }
      }, {
        key: "addSourceType",
        value: function addSourceType(e, t, i) {
          return Ia.getSourceType(e) ? i(new Error("A source type called \"".concat(e, "\" already exists."))) : (Ia.setSourceType(e, t), t.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
            name: e,
            url: t.workerSourceURL
          }, i) : i(null, null));
        }
      }, {
        key: "getFlatLight",
        value: function getFlatLight() {
          return this.light.getLight();
        }
      }, {
        key: "setFlatLight",
        value: function setFlatLight(t, i) {
          var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          this._checkLoaded();
          var r = this.light.getLight();
          var a = !1;
          for (var _i476 in t) if (!e.d(t[_i476], r[_i476])) {
            a = !0;
            break;
          }
          if (!a) return;
          var n = this._getTransitionParameters();
          this.light.setLight(t, i, o), this.light.updateTransitions(n);
        }
      }, {
        key: "getTerrain",
        value: function getTerrain() {
          return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
        }
      }, {
        key: "setTerrainForDraping",
        value: function setTerrainForDraping() {
          this.setTerrain({
            source: "",
            exaggeration: 0
          }, 0);
        }
      }, {
        key: "checkCanvasFingerprintNoise",
        value: function checkCanvasFingerprintNoise() {
          void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = e.e.hasCanvasFingerprintNoise(), this.disableElevatedTerrain && e.w("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode)."));
        }
      }, {
        key: "setTerrain",
        value: function setTerrain(t) {
          var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          if (this._checkLoaded(), !t) return this.terrainSetForDrapingOnly() || (delete this.terrain, this.map.transform.projection.requiresDraping && this.setTerrainForDraping()), 0 === i && delete this.terrain, null === t ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
          this.checkCanvasFingerprintNoise();
          var o = t;
          var r = null == t.source;
          if (1 === i) {
            if (this.disableElevatedTerrain) return;
            if ("object" == typeof o.source) {
              var _t643 = "terrain-dem-src";
              this.addSource(_t643, o.source), o = e.cW(o), o = e.Q(o, {
                source: _t643
              });
            }
            var _t644 = e.Q({}, o),
              _i477 = {};
            if (this.terrain && r) {
              _t644.source = this.terrain.get().source;
              var _e675 = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
              _e675 && (_i477.style = _e675.serialize());
            }
            if (this._validate(ke, "terrain", _t644, _i477)) return;
          }
          if (!this.terrain || this.terrain.scope !== this.scope && !r || this.terrain && i !== this.terrain.drapeRenderMode) {
            if (!o) return;
            this._createTerrain(o, i), this.fire(new e.g("data", {
              dataType: "style"
            }));
          } else {
            var _i478 = this.terrain,
              _r461 = _i478.get();
            for (var _i479 = 0, _Object$keys18 = Object.keys(e.N.terrain); _i479 < _Object$keys18.length; _i479++) {
              var _t645 = _Object$keys18[_i479];
              !o.hasOwnProperty(_t645) && e.N.terrain[_t645].default && (o[_t645] = e.N.terrain[_t645].default);
            }
            for (var _o267 in t) if (!e.d(t[_o267], _r461[_o267])) {
              _i478.set(t, this.options), this.stylesheet.terrain = t;
              var _o268 = this._getTransitionParameters({
                duration: 0
              });
              _i478.updateTransitions(_o268), this.fire(new e.g("data", {
                dataType: "style"
              }));
              break;
            }
          }
          this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
        }
      }, {
        key: "_createFog",
        value: function _createFog(e) {
          var t = this.fog = new at(e, this.map.transform, this.scope, this.options);
          this.stylesheet.fog = t.get();
          var i = this._getTransitionParameters({
            duration: 0
          });
          t.updateTransitions(i);
        }
      }, {
        key: "_updateMarkersOpacity",
        value: function _updateMarkersOpacity() {
          var _this161 = this;
          0 !== this.map._markers.length && this.map._requestDomTask(function () {
            var _iterator464 = _createForOfIteratorHelper(_this161.map._markers),
              _step464;
            try {
              for (_iterator464.s(); !(_step464 = _iterator464.n()).done;) {
                var _e676 = _step464.value;
                _e676._evaluateOpacity();
              }
            } catch (err) {
              _iterator464.e(err);
            } finally {
              _iterator464.f();
            }
          });
        }
      }, {
        key: "getFog",
        value: function getFog() {
          return this.fog ? this.fog.get() : null;
        }
      }, {
        key: "setFog",
        value: function setFog(t) {
          if (this._checkLoaded(), !t) return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = !0);
          if (this.fog) {
            var _i480 = this.fog;
            if (!e.d(_i480.get(), t)) {
              _i480.set(t, this.options), this.stylesheet.fog = _i480.get();
              var _e677 = this._getTransitionParameters({
                duration: 0
              });
              _i480.updateTransitions(_e677);
            }
          } else this._createFog(t);
          this._markersNeedUpdate = !0;
        }
      }, {
        key: "setColorTheme",
        value: function setColorTheme(t) {
          var _this162 = this;
          this._checkLoaded();
          var i = function i() {
            for (var _e678 in _this162._layers) _this162._layers[_e678].lut = _this162._styleColorTheme.lut;
            for (var _e679 in _this162._sourceCaches) _this162._sourceCaches[_e679].clearTiles();
          };
          if (this._styleColorTheme.colorTheme = t, !t) return this._styleColorTheme.lut = null, void i();
          var o = this._evaluateColorThemeData(t);
          this._loadColorTheme(o).then(function () {
            _this162.fire(new e.g("colorthemeset")), i();
          }).catch(function (t) {
            e.w("Couldn't set color theme: ".concat(t));
          });
        }
      }, {
        key: "_getTransitionParameters",
        value: function _getTransitionParameters(t) {
          return {
            now: e.e.now(),
            transition: e.Q(this.transition, t)
          };
        }
      }, {
        key: "updateDrapeFirstLayers",
        value: function updateDrapeFirstLayers() {
          var _this$_drapedFirstOrd, _this$_drapedFirstOrd2;
          if (!this.terrain) return;
          var e = [],
            t = [];
          var _iterator465 = _createForOfIteratorHelper(this._mergedOrder),
            _step465;
          try {
            for (_iterator465.s(); !(_step465 = _iterator465.n()).done;) {
              var _i481 = _step465.value;
              this.isLayerDraped(this._mergedLayers[_i481]) ? e.push(_i481) : t.push(_i481);
            }
          } catch (err) {
            _iterator465.e(err);
          } finally {
            _iterator465.f();
          }
          this._drapedFirstOrder = [], (_this$_drapedFirstOrd = this._drapedFirstOrder).push.apply(_this$_drapedFirstOrd, e), (_this$_drapedFirstOrd2 = this._drapedFirstOrder).push.apply(_this$_drapedFirstOrd2, t);
        }
      }, {
        key: "_createTerrain",
        value: function _createTerrain(e, t) {
          var i = this.terrain = new Qe(e, t, this.scope, this.options);
          1 === t && (this.stylesheet.terrain = e), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
          var o = this._getTransitionParameters({
            duration: 0
          });
          i.updateTransitions(o);
        }
      }, {
        key: "_force3DLayerUpdate",
        value: function _force3DLayerUpdate() {
          for (var _e680 in this._layers) {
            var _t646 = this._layers[_e680];
            "fill-extrusion" === _t646.type && this._updateLayer(_t646);
          }
        }
      }, {
        key: "_forceSymbolLayerUpdate",
        value: function _forceSymbolLayerUpdate() {
          for (var _e681 in this._layers) {
            var _t647 = this._layers[_e681];
            "symbol" === _t647.type && this._updateLayer(_t647);
          }
        }
      }, {
        key: "_validate",
        value: function _validate(t, i, o, r) {
          var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
          if (a && !1 === a.validate) return !1;
          var n = e.Q({}, this.serialize());
          return wa(this, t.call(ze, e.Q({
            key: i,
            style: n,
            value: o,
            styleSpec: e.N
          }, r)));
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), e.d1.off("pluginStateChange", this._rtlTextPluginCallback);
          for (var _e682 in this._mergedLayers) this._mergedLayers[_e682].setEventedParent(null);
          for (var _e683 in this._mergedSourceCaches) this._mergedSourceCaches[_e683].clearTiles(), this._mergedSourceCaches[_e683].setEventedParent(null);
          this.setEventedParent(null), delete this.fog, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.isRootStyle() && (this.imageManager.setEventedParent(null), this.modelManager.setEventedParent(null), this.dispatcher.remove());
        }
      }, {
        key: "clearSource",
        value: function clearSource(e) {
          var t = this.getSourceCaches(e);
          var _iterator466 = _createForOfIteratorHelper(t),
            _step466;
          try {
            for (_iterator466.s(); !(_step466 = _iterator466.n()).done;) {
              var _e684 = _step466.value;
              _e684.clearTiles();
            }
          } catch (err) {
            _iterator466.e(err);
          } finally {
            _iterator466.f();
          }
        }
      }, {
        key: "clearSources",
        value: function clearSources() {
          for (var _e685 in this._mergedSourceCaches) this._mergedSourceCaches[_e685].clearTiles();
        }
      }, {
        key: "reloadSource",
        value: function reloadSource(e) {
          var t = this.getSourceCaches(e);
          var _iterator467 = _createForOfIteratorHelper(t),
            _step467;
          try {
            for (_iterator467.s(); !(_step467 = _iterator467.n()).done;) {
              var _e686 = _step467.value;
              _e686.resume(), _e686.reload();
            }
          } catch (err) {
            _iterator467.e(err);
          } finally {
            _iterator467.f();
          }
        }
      }, {
        key: "reloadSources",
        value: function reloadSources() {
          var _iterator468 = _createForOfIteratorHelper(this.getSources()),
            _step468;
          try {
            for (_iterator468.s(); !(_step468 = _iterator468.n()).done;) {
              var _e687 = _step468.value;
              _e687.reload && _e687.reload();
            }
          } catch (err) {
            _iterator468.e(err);
          } finally {
            _iterator468.f();
          }
        }
      }, {
        key: "updateSources",
        value: function updateSources(e) {
          var t;
          this.directionalLight && (t = vi(this.directionalLight));
          for (var _i482 in this._mergedSourceCaches) this._mergedSourceCaches[_i482].update(e, void 0, void 0, t);
        }
      }, {
        key: "_generateCollisionBoxes",
        value: function _generateCollisionBoxes() {
          for (var _e688 in this._sourceCaches) {
            var _t648 = this._sourceCaches[_e688];
            _t648.resume(), _t648.reload();
          }
        }
      }, {
        key: "_updatePlacement",
        value: function _updatePlacement(t, i, o, r, a, n) {
          var _this163 = this;
          var s = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
          var l = !1,
            c = !1;
          var h = {},
            _ = {};
          var _iterator469 = _createForOfIteratorHelper(this._mergedOrder),
            _step469;
          try {
            var _loop28 = function _loop28() {
                var t = _step469.value;
                var o = _this163._mergedLayers[t];
                if ("symbol" !== o.type) return 0; // continue
                var r = e.am(o.source, o.scope);
                var a = h[r];
                if (!a) {
                  var _e689 = _this163.getLayerSourceCache(o);
                  if (!_e689) return 0; // continue
                  var _t650 = _e689.getRenderableIds(!0).map(function (t) {
                    return _e689.getTileByID(t);
                  });
                  _[r] = _t650.slice(), a = h[r] = _t650.sort(function (e, t) {
                    return t.tileID.overscaledZ - e.tileID.overscaledZ || (e.tileID.isLessThan(t.tileID) ? -1 : 1);
                  });
                }
                var n = _this163.crossTileSymbolIndex.addLayer(o, a, i.center.lng, i.projection);
                l = l || n;
              },
              _ret8;
            for (_iterator469.s(); !(_step469 = _iterator469.n()).done;) {
              _ret8 = _loop28();
              if (_ret8 === 0) continue;
            }
          } catch (err) {
            _iterator469.e(err);
          } finally {
            _iterator469.f();
          }
          if (this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder), s = s || this._layerOrderChanged || 0 === r, this._layerOrderChanged && this.fire(new e.g("neworder")), (s || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(e.e.now(), i.zoom)) && (this.pauseablePlacement = new fa(i, this._mergedOrder, s, o, r, a, this.placement, this.fog && i.projection.supportsFog ? this.fog.state : null, this._buildingIndex), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, h, _), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e.e.now()), c = !0), l && this.pauseablePlacement.placement.setStale()), c || l) {
            this._buildingIndex.onNewFrame(i.zoom);
            var _loop27 = function _loop27(_t649) {
              var i = _this163._mergedLayers[_this163._mergedOrder[_t649]];
              if ("symbol" !== i.type) return 1; // continue
              var o = _this163.isLayerClipped(i) && _this163._clipLayerIndices.some(function (e) {
                return _t649 < e;
              });
              _this163.placement.updateLayerOpacities(i, h[e.am(i.source, i.scope)], _t649, o ? n : null);
            };
            for (var _t649 = 0; _t649 < this._mergedOrder.length; _t649++) {
              if (_loop27(_t649)) continue;
            }
          }
          return {
            needsRerender: !this.pauseablePlacement.isDone() || this.placement.hasTransitions(e.e.now())
          };
        }
      }, {
        key: "_releaseSymbolFadeTiles",
        value: function _releaseSymbolFadeTiles() {
          for (var _e690 in this._sourceCaches) this._sourceCaches[_e690].releaseSymbolFadeTiles();
        }
      }, {
        key: "addImport",
        value: function addImport(t, i) {
          this._checkLoaded();
          var o = this.stylesheet.imports = this.stylesheet.imports || [];
          if (-1 !== o.findIndex(function (_ref190) {
            var e = _ref190.id;
            return e === t.id;
          })) return void this.fire(new e.f(new Error("Import with id '".concat(t.id, "' already exists in the map's style."))));
          if (!i) return o.push(t), this._loadImports([t], !0);
          var r = o.findIndex(function (_ref191) {
            var e = _ref191.id;
            return e === i;
          });
          return -1 === r && this.fire(new e.f(new Error("Import with id \"".concat(i, "\" does not exist on this map.")))), this.stylesheet.imports = o.slice(0, r).concat(t).concat(o.slice(r)), this._loadImports([t], !0, i);
        }
      }, {
        key: "updateImport",
        value: function updateImport(t, i) {
          this._checkLoaded();
          var o = this.stylesheet.imports || [],
            r = this.getImportIndex(t);
          return -1 === r ? this : "string" == typeof i ? (this.setImportUrl(t, i), this) : (i.url && i.url !== o[r].url && this.setImportUrl(t, i.url), e.d(i.config, o[r].config) || this.setImportConfig(t, i.config), e.d(i.data, o[r].data) || this.setImportData(t, i.data), this);
        }
      }, {
        key: "moveImport",
        value: function moveImport(e, t) {
          this._checkLoaded();
          var i = this.stylesheet.imports || [];
          var o = this.getImportIndex(e);
          if (-1 === o) return this;
          var r = this.getImportIndex(t);
          if (-1 === r) return this;
          var a = i[o],
            n = this.fragments[o];
          return i = i.filter(function (_ref192) {
            var t = _ref192.id;
            return t !== e;
          }), this.fragments = this.fragments.filter(function (_ref193) {
            var t = _ref193.id;
            return t !== e;
          }), this.stylesheet.imports = i.slice(0, r).concat(a).concat(i.slice(r)), this.fragments = this.fragments.slice(0, r).concat(n).concat(this.fragments.slice(r)), this.mergeLayers(), this;
        }
      }, {
        key: "setImportUrl",
        value: function setImportUrl(e, t) {
          var _this164 = this;
          this._checkLoaded();
          var i = this.stylesheet.imports || [],
            o = this.getImportIndex(e);
          if (-1 === o) return this;
          i[o].url = t;
          var r = this.fragments[o];
          return r.style = this._createFragmentStyle(i[o]), r.style.on("style.import.load", function () {
            return _this164.mergeAll();
          }), r.style.loadURL(t), this;
        }
      }, {
        key: "setImportData",
        value: function setImportData(e, t) {
          this._checkLoaded();
          var i = this.getImportIndex(e),
            o = this.stylesheet.imports || [];
          return -1 === i ? this : t ? (this.fragments[i].style.setState(t), this._reloadImports(), this) : (delete o[i].data, this.setImportUrl(e, o[i].url));
        }
      }, {
        key: "setImportConfig",
        value: function setImportConfig(e, t) {
          this._checkLoaded();
          var i = this.getImportIndex(e),
            o = this.stylesheet.imports || [];
          if (-1 === i) return this;
          t ? o[i].config = t : delete o[i].config;
          var r = this.fragments[i],
            a = r.style.stylesheet && r.style.stylesheet.schema;
          return r.config = t, r.style.updateConfig(t, a), this.updateConfigDependencies(), this;
        }
      }, {
        key: "removeImport",
        value: function removeImport(e) {
          this._checkLoaded();
          var t = this.stylesheet.imports || [],
            i = this.getImportIndex(e);
          -1 !== i && (t.splice(i, 1), this.fragments[i].style._remove(), this.fragments.splice(i, 1), this._reloadImports());
        }
      }, {
        key: "getImportIndex",
        value: function getImportIndex(t) {
          var i = (this.stylesheet.imports || []).findIndex(function (e) {
            return e.id === t;
          });
          return -1 === i && this.fire(new e.f(new Error("Import '".concat(t, "' does not exist in the map's style and cannot be updated.")))), i;
        }
      }, {
        key: "getLayer",
        value: function getLayer(e) {
          return this._mergedLayers[e];
        }
      }, {
        key: "getSources",
        value: function getSources() {
          var e = [];
          for (var _t651 in this._mergedOtherSourceCaches) {
            var _i483 = this._mergedOtherSourceCaches[_t651];
            _i483 && e.push(_i483.getSource());
          }
          return e;
        }
      }, {
        key: "getSource",
        value: function getSource(e, t) {
          var i = this.getSourceCache(e, t);
          return i && i.getSource();
        }
      }, {
        key: "getLayerSource",
        value: function getLayerSource(e) {
          var t = this.getLayerSourceCache(e);
          return t && t.getSource();
        }
      }, {
        key: "getSourceCache",
        value: function getSourceCache(t, i) {
          var o = e.am(t, i);
          return this._mergedOtherSourceCaches[o];
        }
      }, {
        key: "getLayerSourceCache",
        value: function getLayerSourceCache(t) {
          var i = e.am(t.source, t.scope);
          return "symbol" === t.type ? this._mergedSymbolSourceCaches[i] : this._mergedOtherSourceCaches[i];
        }
      }, {
        key: "getSourceCaches",
        value: function getSourceCaches(e) {
          if (null == e) return Object.values(this._mergedSourceCaches);
          var t = [];
          return this._mergedOtherSourceCaches[e] && t.push(this._mergedOtherSourceCaches[e]), this._mergedSymbolSourceCaches[e] && t.push(this._mergedSymbolSourceCaches[e]), t;
        }
      }, {
        key: "updateSourceCaches",
        value: function updateSourceCaches() {
          var e = this._changes.getUpdatedSourceCaches();
          for (var _t652 in e) {
            var _i484 = e[_t652];
            "reload" === _i484 ? this.reloadSource(_t652) : "clear" === _i484 && this.clearSource(_t652);
          }
        }
      }, {
        key: "updateLayers",
        value: function updateLayers(e) {
          var t = this._changes.getUpdatedPaintProperties();
          var _iterator470 = _createForOfIteratorHelper(t),
            _step470;
          try {
            for (_iterator470.s(); !(_step470 = _iterator470.n()).done;) {
              var _i485 = _step470.value;
              var _t653 = this.getLayer(_i485);
              _t653 && _t653.updateTransitions(e);
            }
          } catch (err) {
            _iterator470.e(err);
          } finally {
            _iterator470.f();
          }
        }
      }, {
        key: "getImages",
        value: function getImages(e, t, i) {
          this.imageManager.getImages(t.icons, t.scope, i), this._updateTilesForChangedImages();
          var o = function o(e) {
            e && e.setDependencies(t.tileID.key, t.type, t.icons);
          };
          o(this._otherSourceCaches[t.source]), o(this._symbolSourceCaches[t.source]);
        }
      }, {
        key: "getGlyphs",
        value: function getGlyphs(e, t, i) {
          this.glyphManager.getGlyphs(t.stacks, t.scope, i);
        }
      }, {
        key: "getResource",
        value: function getResource(t, i, o) {
          return e.d2(i, o);
        }
      }, {
        key: "getOwnSourceCache",
        value: function getOwnSourceCache(e) {
          return this._otherSourceCaches[e];
        }
      }, {
        key: "getOwnLayerSourceCache",
        value: function getOwnLayerSourceCache(e) {
          return "symbol" === e.type ? this._symbolSourceCaches[e.source] : this._otherSourceCaches[e.source];
        }
      }, {
        key: "getOwnSourceCaches",
        value: function getOwnSourceCaches(e) {
          var t = [];
          return this._otherSourceCaches[e] && t.push(this._otherSourceCaches[e]), this._symbolSourceCaches[e] && t.push(this._symbolSourceCaches[e]), t;
        }
      }, {
        key: "_isSourceCacheLoaded",
        value: function _isSourceCacheLoaded(t) {
          var i = this.getOwnSourceCaches(t);
          return 0 === i.length ? (this.fire(new e.f(new Error("There is no source with ID '".concat(t, "'")))), !1) : i.every(function (e) {
            return e.loaded();
          });
        }
      }, {
        key: "has3DLayers",
        value: function has3DLayers() {
          return this._has3DLayers;
        }
      }, {
        key: "hasSymbolLayers",
        value: function hasSymbolLayers() {
          return this._hasSymbolLayers;
        }
      }, {
        key: "hasCircleLayers",
        value: function hasCircleLayers() {
          return this._hasCircleLayers;
        }
      }, {
        key: "isLayerClipped",
        value: function isLayerClipped(t, i) {
          if (0 === this._clipLayerIndices.length && "fill-extrusion" !== t.type) return !1;
          var o = "fill-extrusion" === t.type && "building" === t.sourceLayer;
          var r = 0;
          if (t.is3D()) {
            if (o || i && "batched-model" === i.type) return !0;
            "model" === t.type && (r = e.cw.Model);
          } else "symbol" === t.type && (r = e.cw.Symbol);
          var _iterator471 = _createForOfIteratorHelper(this._clipLayerIndices),
            _step471;
          try {
            for (_iterator471.s(); !(_step471 = _iterator471.n()).done;) {
              var _t654 = _step471.value;
              var _i486 = this._mergedLayers[this._mergedOrder[_t654]];
              if (!_i486) continue;
              var _o269 = [];
              var _iterator472 = _createForOfIteratorHelper(_i486.layout.get("clip-layer-types")),
                _step472;
              try {
                for (_iterator472.s(); !(_step472 = _iterator472.n()).done;) {
                  var _t655 = _step472.value;
                  _o269.push("model" === _t655 ? e.cw.Model : "symbol" === _t655 ? e.cw.Symbol : e.cw.FillExtrusion);
                }
              } catch (err) {
                _iterator472.e(err);
              } finally {
                _iterator472.f();
              }
              for (var _i487 = 0, _o270 = _o269; _i487 < _o270.length; _i487++) {
                var _e691 = _o270[_i487];
                if (r & _e691) return !0;
              }
            }
          } catch (err) {
            _iterator471.e(err);
          } finally {
            _iterator471.f();
          }
          return !1;
        }
      }, {
        key: "_clearWorkerCaches",
        value: function _clearWorkerCaches() {
          this.dispatcher.broadcast("clearCaches");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._clearWorkerCaches(), this.fragments.forEach(function (e) {
            e.style._remove();
          }), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
        }
      }]);
      return Ia;
    }(e.E);
    function La(e, t) {
      var i = !1,
        o = null;
      var r = function r() {
        o = null, i && (e(), o = setTimeout(r, t), i = !1);
      };
      return function () {
        return i = !0, o || r(), o;
      };
    }
    Ia.getSourceType = function (e) {
      return Pi[e];
    }, Ia.setSourceType = function (e, t) {
      Pi[e] = t;
    }, Ia.registerForPluginStateChange = e.cO;
    var Pa = /*#__PURE__*/function () {
      function Pa(t) {
        _classCallCheck(this, Pa);
        this._hashName = t && encodeURIComponent(t), e.br(["_getCurrentHash", "_onHashChange", "_updateHash"], this), this._updateHash = La(this._updateHashUnthrottled.bind(this), 300);
      }
      _createClass(Pa, [{
        key: "addTo",
        value: function addTo(e) {
          return this._map = e, window.addEventListener("hashchange", this._onHashChange, !1), e.on("moveend", this._updateHash), this;
        }
      }, {
        key: "remove",
        value: function remove() {
          return this._map ? (this._map.off("moveend", this._updateHash), window.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
        }
      }, {
        key: "getHashString",
        value: function getHashString() {
          var e = this._map;
          if (!e) return "";
          var t = Ra(e);
          if (this._hashName) {
            var _e692 = this._hashName;
            var _i488 = !1;
            var _o271 = location.hash.slice(1).split("&").map(function (o) {
              var r = o.split("=")[0];
              return r === _e692 ? (_i488 = !0, "".concat(r, "=").concat(t)) : o;
            }).filter(function (e) {
              return e;
            });
            return _i488 || _o271.push("".concat(_e692, "=").concat(t)), "#".concat(_o271.join("&"));
          }
          return "#".concat(t);
        }
      }, {
        key: "_getCurrentHash",
        value: function _getCurrentHash() {
          var _this165 = this;
          var e = location.hash.replace("#", "");
          if (this._hashName) {
            var _t656;
            return e.split("&").map(function (e) {
              return e.split("=");
            }).forEach(function (e) {
              e[0] === _this165._hashName && (_t656 = e);
            }), (_t656 && _t656[1] || "").split("/");
          }
          return e.split("/");
        }
      }, {
        key: "_onHashChange",
        value: function _onHashChange() {
          var e = this._map;
          if (!e) return !1;
          var t = this._getCurrentHash();
          if (t.length >= 3 && !t.some(function (e) {
            return isNaN(e);
          })) {
            var _i489 = e.dragRotate.isEnabled() && e.touchZoomRotate.isEnabled() ? +(t[3] || 0) : e.getBearing();
            return e.jumpTo({
              center: [+t[2], +t[1]],
              zoom: +t[0],
              bearing: _i489,
              pitch: +(t[4] || 0)
            }), !0;
          }
          return !1;
        }
      }, {
        key: "_updateHashUnthrottled",
        value: function _updateHashUnthrottled() {
          history.replaceState(history.state, "", location.href.replace(/(#.+)?$/, this.getHashString()));
        }
      }]);
      return Pa;
    }();
    function Ra(e, t) {
      var i = e.getCenter(),
        o = Math.round(100 * e.getZoom()) / 100,
        r = Math.ceil((o * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10),
        a = Math.pow(10, r),
        n = Math.round(i.lng * a) / a,
        s = Math.round(i.lat * a) / a,
        l = e.getBearing(),
        c = e.getPitch();
      var h = t ? "/".concat(n, "/").concat(s, "/").concat(o) : "".concat(o, "/").concat(s, "/").concat(n);
      return (l || c) && (h += "/" + Math.round(10 * l) / 10), c && (h += "/".concat(Math.round(c))), h;
    }
    var Da = {
        linearity: .3,
        easing: e.d3(0, 0, .3, 1)
      },
      Aa = e.Q({
        deceleration: 2500,
        maxSpeed: 1400
      }, Da),
      Ma = e.Q({
        deceleration: 20,
        maxSpeed: 1400
      }, Da),
      za = e.Q({
        deceleration: 1e3,
        maxSpeed: 360
      }, Da),
      Oa = e.Q({
        deceleration: 1e3,
        maxSpeed: 90
      }, Da);
    var Fa = /*#__PURE__*/function () {
      function Fa(e) {
        _classCallCheck(this, Fa);
        this._map = e, this.clear();
      }
      _createClass(Fa, [{
        key: "clear",
        value: function clear() {
          this._inertiaBuffer = [];
        }
      }, {
        key: "record",
        value: function record(t) {
          this._drainInertiaBuffer(), this._inertiaBuffer.push({
            time: e.e.now(),
            settings: t
          });
        }
      }, {
        key: "_drainInertiaBuffer",
        value: function _drainInertiaBuffer() {
          var t = this._inertiaBuffer,
            i = e.e.now();
          for (; t.length > 0 && i - t[0].time > 160;) t.shift();
        }
      }, {
        key: "_onMoveEnd",
        value: function _onMoveEnd(t) {
          if (this._map._prefersReducedMotion()) return;
          if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
          var i = {
            zoom: 0,
            bearing: 0,
            pitch: 0,
            pan: new e.P(0, 0),
            pinchAround: void 0,
            around: void 0
          };
          var _iterator473 = _createForOfIteratorHelper(this._inertiaBuffer),
            _step473;
          try {
            for (_iterator473.s(); !(_step473 = _iterator473.n()).done;) {
              var _e696 = _step473.value.settings;
              i.zoom += _e696.zoomDelta || 0, i.bearing += _e696.bearingDelta || 0, i.pitch += _e696.pitchDelta || 0, _e696.panDelta && i.pan._add(_e696.panDelta), _e696.around && (i.around = _e696.around), _e696.pinchAround && (i.pinchAround = _e696.pinchAround);
            }
          } catch (err) {
            _iterator473.e(err);
          } finally {
            _iterator473.f();
          }
          var o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time,
            r = {};
          if (i.pan.mag()) {
            var _a251 = ka(i.pan.mag(), o, e.Q({}, Aa, t || {}));
            r.offset = i.pan.mult(_a251.amount / i.pan.mag()), r.center = this._map.transform.center, Ba(r, _a251);
          }
          if (i.zoom) {
            var _e693 = ka(i.zoom, o, Ma);
            r.zoom = this._map.transform.zoom + _e693.amount, Ba(r, _e693);
          }
          if (i.bearing) {
            var _t657 = ka(i.bearing, o, za);
            r.bearing = this._map.transform.bearing + e.au(_t657.amount, -179, 179), Ba(r, _t657);
          }
          if (i.pitch) {
            var _e694 = ka(i.pitch, o, Oa);
            r.pitch = this._map.transform.pitch + _e694.amount, Ba(r, _e694);
          }
          if (r.zoom || r.bearing) {
            var _e695 = void 0 === i.pinchAround ? i.around : i.pinchAround;
            r.around = _e695 ? this._map.unproject(_e695) : this._map.getCenter();
          }
          return this.clear(), r.noMoveStart = !0, r;
        }
      }]);
      return Fa;
    }();
    function Ba(e, t) {
      (!e.duration || e.duration < t.duration) && (e.duration = t.duration, e.easing = t.easing);
    }
    function ka(t, i, o) {
      var r = o.maxSpeed,
        a = o.linearity,
        n = o.deceleration,
        s = e.au(t * a / (i / 1e3), -r, r),
        l = Math.abs(s) / (n * a);
      return {
        easing: o.easing,
        duration: 1e3 * l,
        amount: s * (l / 2)
      };
    }
    var Na = /*#__PURE__*/function (_e$g) {
      _inherits(Na, _e$g);
      var _super156 = _createSuper(Na);
      function Na(t, i, o) {
        var _this166;
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        _classCallCheck(this, Na);
        var a = d(i.getCanvasContainer(), o),
          n = i.unproject(a);
        _this166 = _super156.call(this, t, e.Q({
          point: a,
          lngLat: n,
          originalEvent: o
        }, r)), _this166._defaultPrevented = !1, _this166.target = i;
        return _this166;
      }
      _createClass(Na, [{
        key: "preventDefault",
        value: function preventDefault() {
          this._defaultPrevented = !0;
        }
      }, {
        key: "defaultPrevented",
        get: function get() {
          return this._defaultPrevented;
        }
      }]);
      return Na;
    }(e.g);
    var Ua = /*#__PURE__*/function (_e$g2) {
      _inherits(Ua, _e$g2);
      var _super157 = _createSuper(Ua);
      function Ua(t, i, o) {
        var _this167;
        _classCallCheck(this, Ua);
        var r = "touchend" === t ? o.changedTouches : o.touches,
          a = p(i.getCanvasContainer(), r),
          n = a.map(function (e) {
            return i.unproject(e);
          }),
          s = a.reduce(function (e, t, i, o) {
            return e.add(t.div(o.length));
          }, new e.P(0, 0));
        _this167 = _super157.call(this, t, {
          points: a,
          point: s,
          lngLats: n,
          lngLat: i.unproject(s),
          originalEvent: o
        }), _this167._defaultPrevented = !1;
        return _this167;
      }
      _createClass(Ua, [{
        key: "preventDefault",
        value: function preventDefault() {
          this._defaultPrevented = !0;
        }
      }, {
        key: "defaultPrevented",
        get: function get() {
          return this._defaultPrevented;
        }
      }]);
      return Ua;
    }(e.g);
    var Ga = /*#__PURE__*/function (_e$g3) {
      _inherits(Ga, _e$g3);
      var _super158 = _createSuper(Ga);
      function Ga(e, t) {
        var _this168;
        _classCallCheck(this, Ga);
        _this168 = _super158.call(this, "wheel", {
          originalEvent: t
        }), _this168._defaultPrevented = !1;
        return _this168;
      }
      _createClass(Ga, [{
        key: "preventDefault",
        value: function preventDefault() {
          this._defaultPrevented = !0;
        }
      }, {
        key: "defaultPrevented",
        get: function get() {
          return this._defaultPrevented;
        }
      }]);
      return Ga;
    }(e.g);
    var ja = /*#__PURE__*/function () {
      function ja(e, t) {
        _classCallCheck(this, ja);
        this._map = e, this._clickTolerance = t.clickTolerance;
      }
      _createClass(ja, [{
        key: "reset",
        value: function reset() {
          this._mousedownPos = void 0;
        }
      }, {
        key: "wheel",
        value: function wheel(e) {
          return this._firePreventable(new Ga(this._map, e));
        }
      }, {
        key: "mousedown",
        value: function mousedown(e, t) {
          return this._mousedownPos = t, this._firePreventable(new Na(e.type, this._map, e));
        }
      }, {
        key: "mouseup",
        value: function mouseup(e) {
          this._map.fire(new Na(e.type, this._map, e));
        }
      }, {
        key: "preclick",
        value: function preclick(t) {
          var i = e.Q({}, t);
          i.type = "preclick", this._map.fire(new Na(i.type, this._map, i));
        }
      }, {
        key: "click",
        value: function click(e, t) {
          this._mousedownPos && this._mousedownPos.dist(t) >= this._clickTolerance || (this.preclick(e), this._map.fire(new Na(e.type, this._map, e)));
        }
      }, {
        key: "dblclick",
        value: function dblclick(e) {
          return this._firePreventable(new Na(e.type, this._map, e));
        }
      }, {
        key: "mouseover",
        value: function mouseover(e) {
          this._map.fire(new Na(e.type, this._map, e));
        }
      }, {
        key: "mouseout",
        value: function mouseout(e) {
          this._map.fire(new Na(e.type, this._map, e));
        }
      }, {
        key: "touchstart",
        value: function touchstart(e) {
          return this._firePreventable(new Ua(e.type, this._map, e));
        }
      }, {
        key: "touchmove",
        value: function touchmove(e) {
          this._map.fire(new Ua(e.type, this._map, e));
        }
      }, {
        key: "touchend",
        value: function touchend(e) {
          this._map.fire(new Ua(e.type, this._map, e));
        }
      }, {
        key: "touchcancel",
        value: function touchcancel(e) {
          this._map.fire(new Ua(e.type, this._map, e));
        }
      }, {
        key: "_firePreventable",
        value: function _firePreventable(e) {
          if (this._map.fire(e), e.defaultPrevented) return {};
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return !0;
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return !1;
        }
      }, {
        key: "enable",
        value: function enable() {}
      }, {
        key: "disable",
        value: function disable() {}
      }]);
      return ja;
    }();
    var Va = /*#__PURE__*/function () {
      function Va(e) {
        _classCallCheck(this, Va);
        this._map = e;
      }
      _createClass(Va, [{
        key: "reset",
        value: function reset() {
          this._delayContextMenu = !1, this._contextMenuEvent = void 0;
        }
      }, {
        key: "mousemove",
        value: function mousemove(e) {
          this._map.fire(new Na(e.type, this._map, e));
        }
      }, {
        key: "mousedown",
        value: function mousedown() {
          this._delayContextMenu = !0;
        }
      }, {
        key: "mouseup",
        value: function mouseup() {
          this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new Na("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
        }
      }, {
        key: "contextmenu",
        value: function contextmenu(e) {
          this._delayContextMenu ? this._contextMenuEvent = e : this._map.fire(new Na(e.type, this._map, e)), this._map.listens("contextmenu") && e.preventDefault();
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return !0;
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return !1;
        }
      }, {
        key: "enable",
        value: function enable() {}
      }, {
        key: "disable",
        value: function disable() {}
      }]);
      return Va;
    }();
    var $a = /*#__PURE__*/function () {
      function $a(e, t) {
        _classCallCheck(this, $a);
        this._map = e, this._el = e.getCanvasContainer(), this._container = e.getContainer(), this._clickTolerance = t.clickTolerance || 1;
      }
      _createClass($a, [{
        key: "isEnabled",
        value: function isEnabled() {
          return !!this._enabled;
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return !!this._active;
        }
      }, {
        key: "enable",
        value: function enable() {
          this.isEnabled() || (this._enabled = !0);
        }
      }, {
        key: "disable",
        value: function disable() {
          this.isEnabled() && (this._enabled = !1);
        }
      }, {
        key: "mousedown",
        value: function mousedown(e, t) {
          this.isEnabled() && e.shiftKey && 0 === e.button && (c(), this._startPos = this._lastPos = t, this._active = !0);
        }
      }, {
        key: "mousemoveWindow",
        value: function mousemoveWindow(e, t) {
          var _this169 = this;
          if (!this._active) return;
          var i = t,
            o = this._startPos,
            a = this._lastPos;
          if (!o || !a || a.equals(i) || !this._box && i.dist(o) < this._clickTolerance) return;
          this._lastPos = i, this._box || (this._box = r("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e));
          var n = Math.min(o.x, i.x),
            s = Math.max(o.x, i.x),
            l = Math.min(o.y, i.y),
            c = Math.max(o.y, i.y);
          this._map._requestDomTask(function () {
            _this169._box && (_this169._box.style.transform = "translate(".concat(n, "px,").concat(l, "px)"), _this169._box.style.width = s - n + "px", _this169._box.style.height = c - l + "px");
          });
        }
      }, {
        key: "mouseupWindow",
        value: function mouseupWindow(t, i) {
          var _this170 = this;
          if (!this._active) return;
          var o = this._startPos,
            r = i;
          if (o && 0 === t.button) {
            if (this.reset(), u(), o.x !== r.x || o.y !== r.y) return this._map.fire(new e.g("boxzoomend", {
              originalEvent: t
            })), {
              cameraAnimation: function cameraAnimation(e) {
                return e.fitScreenCoordinates(o, r, _this170._map.getBearing(), {
                  linear: !1
                });
              }
            };
            this._fireEvent("boxzoomcancel", t);
          }
        }
      }, {
        key: "keydown",
        value: function keydown(e) {
          this._active && 27 === e.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e));
        }
      }, {
        key: "blur",
        value: function blur() {
          this.reset();
        }
      }, {
        key: "reset",
        value: function reset() {
          this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), h(), delete this._startPos, delete this._lastPos;
        }
      }, {
        key: "_fireEvent",
        value: function _fireEvent(t, i) {
          return this._map.fire(new e.g(t, {
            originalEvent: i
          }));
        }
      }]);
      return $a;
    }();
    function Za(e, t) {
      var i = {};
      for (var _o272 = 0; _o272 < e.length; _o272++) i[e[_o272].identifier] = t[_o272];
      return i;
    }
    var Wa = /*#__PURE__*/function () {
      function Wa(e) {
        _classCallCheck(this, Wa);
        this.reset(), this.numTouches = e.numTouches;
      }
      _createClass(Wa, [{
        key: "reset",
        value: function reset() {
          this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
        }
      }, {
        key: "touchstart",
        value: function touchstart(t, i, o) {
          (this.centroid || o.length > this.numTouches) && (this.aborted = !0), this.aborted || (0 === this.startTime && (this.startTime = t.timeStamp), o.length === this.numTouches && (this.centroid = function (t) {
            var i = new e.P(0, 0);
            var _iterator474 = _createForOfIteratorHelper(t),
              _step474;
            try {
              for (_iterator474.s(); !(_step474 = _iterator474.n()).done;) {
                var _e697 = _step474.value;
                i._add(_e697);
              }
            } catch (err) {
              _iterator474.e(err);
            } finally {
              _iterator474.f();
            }
            return i.div(t.length);
          }(i), this.touches = Za(o, i)));
        }
      }, {
        key: "touchmove",
        value: function touchmove(e, t, i) {
          if (this.aborted || !this.centroid) return;
          var o = Za(i, t);
          for (var _e698 in this.touches) {
            var _t658 = o[_e698];
            (!_t658 || _t658.dist(this.touches[_e698]) > 30) && (this.aborted = !0);
          }
        }
      }, {
        key: "touchend",
        value: function touchend(e, t, i) {
          if ((!this.centroid || e.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
            var _e699 = !this.aborted && this.centroid;
            if (this.reset(), _e699) return _e699;
          }
        }
      }]);
      return Wa;
    }();
    var Ha = /*#__PURE__*/function () {
      function Ha(e) {
        _classCallCheck(this, Ha);
        this.singleTap = new Wa(e), this.numTaps = e.numTaps, this.reset();
      }
      _createClass(Ha, [{
        key: "reset",
        value: function reset() {
          this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
        }
      }, {
        key: "touchstart",
        value: function touchstart(e, t, i) {
          this.singleTap.touchstart(e, t, i);
        }
      }, {
        key: "touchmove",
        value: function touchmove(e, t, i) {
          this.singleTap.touchmove(e, t, i);
        }
      }, {
        key: "touchend",
        value: function touchend(e, t, i) {
          var o = this.singleTap.touchend(e, t, i);
          if (o) {
            var _t659 = e.timeStamp - this.lastTime < 500,
              _i490 = !this.lastTap || this.lastTap.dist(o) < 30;
            if (_t659 && _i490 || this.reset(), this.count++, this.lastTime = e.timeStamp, this.lastTap = o, this.count === this.numTaps) return this.reset(), o;
          }
        }
      }]);
      return Ha;
    }();
    var qa = /*#__PURE__*/function () {
      function qa() {
        _classCallCheck(this, qa);
        this._zoomIn = new Ha({
          numTouches: 1,
          numTaps: 2
        }), this._zoomOut = new Ha({
          numTouches: 2,
          numTaps: 1
        }), this.reset();
      }
      _createClass(qa, [{
        key: "reset",
        value: function reset() {
          this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
        }
      }, {
        key: "touchstart",
        value: function touchstart(e, t, i) {
          this._zoomIn.touchstart(e, t, i), this._zoomOut.touchstart(e, t, i);
        }
      }, {
        key: "touchmove",
        value: function touchmove(e, t, i) {
          this._zoomIn.touchmove(e, t, i), this._zoomOut.touchmove(e, t, i);
        }
      }, {
        key: "touchend",
        value: function touchend(e, t, i) {
          var _this171 = this;
          var o = this._zoomIn.touchend(e, t, i),
            r = this._zoomOut.touchend(e, t, i);
          return o ? (this._active = !0, e.preventDefault(), setTimeout(function () {
            return _this171.reset();
          }, 0), {
            cameraAnimation: function cameraAnimation(t) {
              return t.easeTo({
                duration: 300,
                zoom: t.getZoom() + 1,
                around: t.unproject(o)
              }, {
                originalEvent: e
              });
            }
          }) : r ? (this._active = !0, e.preventDefault(), setTimeout(function () {
            return _this171.reset();
          }, 0), {
            cameraAnimation: function cameraAnimation(t) {
              return t.easeTo({
                duration: 300,
                zoom: t.getZoom() - 1,
                around: t.unproject(r)
              }, {
                originalEvent: e
              });
            }
          }) : void 0;
        }
      }, {
        key: "touchcancel",
        value: function touchcancel() {
          this.reset();
        }
      }, {
        key: "enable",
        value: function enable() {
          this._enabled = !0;
        }
      }, {
        key: "disable",
        value: function disable() {
          this._enabled = !1, this.reset();
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return this._enabled;
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return this._active;
        }
      }]);
      return qa;
    }();
    var Xa = {
      0: 1,
      2: 2
    };
    var Qa = /*#__PURE__*/function () {
      function Qa(e) {
        _classCallCheck(this, Qa);
        this.reset(), this._clickTolerance = e.clickTolerance || 1;
      }
      _createClass(Qa, [{
        key: "blur",
        value: function blur() {
          this.reset();
        }
      }, {
        key: "reset",
        value: function reset() {
          this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
        }
      }, {
        key: "_correctButton",
        value: function _correctButton(e, t) {
          return !1;
        }
      }, {
        key: "_move",
        value: function _move(e, t) {
          return {};
        }
      }, {
        key: "mousedown",
        value: function mousedown(e, t) {
          if (this._lastPoint) return;
          var i = f(e);
          this._correctButton(e, i) && (this._lastPoint = t, this._eventButton = i);
        }
      }, {
        key: "mousemoveWindow",
        value: function mousemoveWindow(e, t) {
          var i = this._lastPoint;
          if (i) if (e.preventDefault(), null != this._eventButton && function (e, t) {
            var i = Xa[t];
            return void 0 === e.buttons || (e.buttons & i) !== i;
          }(e, this._eventButton)) this.reset();else if (this._moved || !(t.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = t, this._move(i, t);
        }
      }, {
        key: "mouseupWindow",
        value: function mouseupWindow(e) {
          this._lastPoint && f(e) === this._eventButton && (this._moved && u(), this.reset());
        }
      }, {
        key: "enable",
        value: function enable() {
          this._enabled = !0;
        }
      }, {
        key: "disable",
        value: function disable() {
          this._enabled = !1, this.reset();
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return this._enabled;
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return this._active;
        }
      }]);
      return Qa;
    }();
    var Ya = /*#__PURE__*/function (_Qa) {
      _inherits(Ya, _Qa);
      var _super159 = _createSuper(Ya);
      function Ya() {
        _classCallCheck(this, Ya);
        return _super159.apply(this, arguments);
      }
      _createClass(Ya, [{
        key: "mousedown",
        value: function mousedown(e, t) {
          _get(_getPrototypeOf(Ya.prototype), "mousedown", this).call(this, e, t), this._lastPoint && (this._active = !0);
        }
      }, {
        key: "_correctButton",
        value: function _correctButton(e, t) {
          return 0 === t && !e.ctrlKey;
        }
      }, {
        key: "_move",
        value: function _move(e, t) {
          return {
            around: t,
            panDelta: t.sub(e)
          };
        }
      }]);
      return Ya;
    }(Qa);
    var Ja = /*#__PURE__*/function (_Qa2) {
      _inherits(Ja, _Qa2);
      var _super160 = _createSuper(Ja);
      function Ja() {
        _classCallCheck(this, Ja);
        return _super160.apply(this, arguments);
      }
      _createClass(Ja, [{
        key: "_correctButton",
        value: function _correctButton(e, t) {
          return 0 === t && e.ctrlKey || 2 === t;
        }
      }, {
        key: "_move",
        value: function _move(e, t) {
          var i = .8 * (t.x - e.x);
          if (i) return this._active = !0, {
            bearingDelta: i
          };
        }
      }, {
        key: "contextmenu",
        value: function contextmenu(e) {
          e.preventDefault();
        }
      }]);
      return Ja;
    }(Qa);
    var Ka = /*#__PURE__*/function (_Qa3) {
      _inherits(Ka, _Qa3);
      var _super161 = _createSuper(Ka);
      function Ka() {
        _classCallCheck(this, Ka);
        return _super161.apply(this, arguments);
      }
      _createClass(Ka, [{
        key: "_correctButton",
        value: function _correctButton(e, t) {
          return 0 === t && e.ctrlKey || 2 === t;
        }
      }, {
        key: "_move",
        value: function _move(e, t) {
          var i = -.5 * (t.y - e.y);
          if (i) return this._active = !0, {
            pitchDelta: i
          };
        }
      }, {
        key: "contextmenu",
        value: function contextmenu(e) {
          e.preventDefault();
        }
      }]);
      return Ka;
    }(Qa);
    var en = /*#__PURE__*/function () {
      function en(t, i) {
        _classCallCheck(this, en);
        this._map = t, this._el = t.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i.clickTolerance || 1, this.reset(), e.br(["_addTouchPanBlocker", "_showTouchPanBlockerAlert"], this);
      }
      _createClass(en, [{
        key: "reset",
        value: function reset() {
          this._active = !1, this._touches = {}, this._sum = new e.P(0, 0);
        }
      }, {
        key: "touchstart",
        value: function touchstart(e, t, i) {
          return this._calculateTransform(e, t, i);
        }
      }, {
        key: "touchmove",
        value: function touchmove(t, i, o) {
          if (this._active && !(o.length < this._minTouches)) {
            if (this._map._cooperativeGestures && !this._map.isMoving()) {
              if (1 === o.length && !e.d4()) return void this._showTouchPanBlockerAlert();
              "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
            }
            return t.cancelable && t.preventDefault(), this._calculateTransform(t, i, o);
          }
        }
      }, {
        key: "touchend",
        value: function touchend(e, t, i) {
          this._calculateTransform(e, t, i), this._active && i.length < this._minTouches && this.reset();
        }
      }, {
        key: "touchcancel",
        value: function touchcancel() {
          this.reset();
        }
      }, {
        key: "_calculateTransform",
        value: function _calculateTransform(t, i, o) {
          o.length > 0 && (this._active = !0);
          var r = Za(o, i),
            a = new e.P(0, 0),
            n = new e.P(0, 0);
          var s = 0;
          for (var _e700 in r) {
            var _t660 = r[_e700],
              _i491 = this._touches[_e700];
            _i491 && (a._add(_t660), n._add(_t660.sub(_i491)), s++, r[_e700] = _t660);
          }
          if (this._touches = r, s < this._minTouches || !n.mag()) return;
          var l = n.div(s);
          return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
            around: a.div(s),
            panDelta: l
          };
        }
      }, {
        key: "enable",
        value: function enable() {
          this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
        }
      }, {
        key: "disable",
        value: function disable() {
          this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return !!this._enabled;
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return !!this._active;
        }
      }, {
        key: "_addTouchPanBlocker",
        value: function _addTouchPanBlocker() {
          this._map && !this._alertContainer && (this._alertContainer = r("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = "".concat(Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth))), "px"));
        }
      }, {
        key: "_showTouchPanBlockerAlert",
        value: function _showTouchPanBlockerAlert() {
          var _this172 = this;
          this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(function () {
            _this172._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), _this172._alertContainer.removeAttribute("role");
          }, 500);
        }
      }]);
      return en;
    }();
    var tn = /*#__PURE__*/function () {
      function tn() {
        _classCallCheck(this, tn);
        this.reset();
      }
      _createClass(tn, [{
        key: "reset",
        value: function reset() {
          this._active = !1, this._firstTwoTouches = void 0;
        }
      }, {
        key: "_start",
        value: function _start(e) {}
      }, {
        key: "_move",
        value: function _move(e, t, i) {
          return {};
        }
      }, {
        key: "touchstart",
        value: function touchstart(e, t, i) {
          this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [i[0].identifier, i[1].identifier], this._start([t[0], t[1]]));
        }
      }, {
        key: "touchmove",
        value: function touchmove(e, t, i) {
          var o = this._firstTwoTouches;
          if (!o) return;
          e.preventDefault();
          var _o273 = _slicedToArray(o, 2),
            r = _o273[0],
            a = _o273[1],
            n = on(i, t, r),
            s = on(i, t, a);
          if (!n || !s) return;
          var l = this._aroundCenter ? null : n.add(s).div(2);
          return this._move([n, s], l, e);
        }
      }, {
        key: "touchend",
        value: function touchend(e, t, i) {
          if (!this._firstTwoTouches) return;
          var _this$_firstTwoTouche = _slicedToArray(this._firstTwoTouches, 2),
            o = _this$_firstTwoTouche[0],
            r = _this$_firstTwoTouche[1],
            a = on(i, t, o),
            n = on(i, t, r);
          a && n || (this._active && u(), this.reset());
        }
      }, {
        key: "touchcancel",
        value: function touchcancel() {
          this.reset();
        }
      }, {
        key: "enable",
        value: function enable(e) {
          this._enabled = !0, this._aroundCenter = !!e && "center" === e.around;
        }
      }, {
        key: "disable",
        value: function disable() {
          this._enabled = !1, this.reset();
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return this._enabled;
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return this._active;
        }
      }]);
      return tn;
    }();
    function on(e, t, i) {
      for (var _o274 = 0; _o274 < e.length; _o274++) if (e[_o274].identifier === i) return t[_o274];
    }
    function rn(e, t) {
      return Math.log(e / t) / Math.LN2;
    }
    var an = /*#__PURE__*/function (_tn) {
      _inherits(an, _tn);
      var _super162 = _createSuper(an);
      function an() {
        _classCallCheck(this, an);
        return _super162.apply(this, arguments);
      }
      _createClass(an, [{
        key: "reset",
        value: function reset() {
          _get(_getPrototypeOf(an.prototype), "reset", this).call(this), this._distance = 0, this._startDistance = 0;
        }
      }, {
        key: "_start",
        value: function _start(e) {
          this._startDistance = this._distance = e[0].dist(e[1]);
        }
      }, {
        key: "_move",
        value: function _move(e, t) {
          var i = this._distance;
          if (this._distance = e[0].dist(e[1]), this._active || !(Math.abs(rn(this._distance, this._startDistance)) < .1)) return this._active = !0, {
            zoomDelta: rn(this._distance, i),
            pinchAround: t
          };
        }
      }]);
      return an;
    }(tn);
    function nn(e, t) {
      return 180 * e.angleWith(t) / Math.PI;
    }
    var sn = /*#__PURE__*/function (_tn2) {
      _inherits(sn, _tn2);
      var _super163 = _createSuper(sn);
      function sn() {
        _classCallCheck(this, sn);
        return _super163.apply(this, arguments);
      }
      _createClass(sn, [{
        key: "reset",
        value: function reset() {
          _get(_getPrototypeOf(sn.prototype), "reset", this).call(this), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
        }
      }, {
        key: "_start",
        value: function _start(e) {
          this._startVector = this._vector = e[0].sub(e[1]), this._minDiameter = e[0].dist(e[1]);
        }
      }, {
        key: "_move",
        value: function _move(e, t) {
          var i = this._vector;
          if (this._vector = e[0].sub(e[1]), i && (this._active || !this._isBelowThreshold(this._vector))) return this._active = !0, {
            bearingDelta: nn(this._vector, i),
            pinchAround: t
          };
        }
      }, {
        key: "_isBelowThreshold",
        value: function _isBelowThreshold(e) {
          this._minDiameter = Math.min(this._minDiameter, e.mag());
          var t = 25 / (Math.PI * this._minDiameter) * 360,
            i = this._startVector;
          if (!i) return !1;
          var o = nn(e, i);
          return Math.abs(o) < t;
        }
      }]);
      return sn;
    }(tn);
    function ln(e) {
      return Math.abs(e.y) > Math.abs(e.x);
    }
    var cn = /*#__PURE__*/function (_tn3) {
      _inherits(cn, _tn3);
      var _super164 = _createSuper(cn);
      function cn(e) {
        var _this173;
        _classCallCheck(this, cn);
        _this173 = _super164.call(this), _this173._map = e;
        return _this173;
      }
      _createClass(cn, [{
        key: "reset",
        value: function reset() {
          _get(_getPrototypeOf(cn.prototype), "reset", this).call(this), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
        }
      }, {
        key: "_start",
        value: function _start(e) {
          this._lastPoints = e, ln(e[0].sub(e[1])) && (this._valid = !1);
        }
      }, {
        key: "_move",
        value: function _move(t, i, o) {
          var r = this._lastPoints;
          if (!r) return;
          var a = t[0].sub(r[0]),
            n = t[1].sub(r[1]);
          return this._map._cooperativeGestures && !e.d4() && o.touches.length < 3 || (this._valid = this.gestureBeginsVertically(a, n, o.timeStamp), !this._valid) ? void 0 : (this._lastPoints = t, this._active = !0, {
            pitchDelta: (a.y + n.y) / 2 * -.5
          });
        }
      }, {
        key: "gestureBeginsVertically",
        value: function gestureBeginsVertically(e, t, i) {
          if (void 0 !== this._valid) return this._valid;
          var o = e.mag() >= 2,
            r = t.mag() >= 2;
          if (!o && !r) return;
          if (!o || !r) return null == this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
          var a = e.y > 0 == t.y > 0;
          return ln(e) && ln(t) && a;
        }
      }]);
      return cn;
    }(tn);
    var hn = {
      panStep: 100,
      bearingStep: 15,
      pitchStep: 10
    };
    var _n = /*#__PURE__*/function () {
      function _n() {
        _classCallCheck(this, _n);
        var e = hn;
        this._panStep = e.panStep, this._bearingStep = e.bearingStep, this._pitchStep = e.pitchStep, this._rotationDisabled = !1;
      }
      _createClass(_n, [{
        key: "blur",
        value: function blur() {
          this.reset();
        }
      }, {
        key: "reset",
        value: function reset() {
          this._active = !1;
        }
      }, {
        key: "keydown",
        value: function keydown(e) {
          var _this174 = this;
          if (e.altKey || e.ctrlKey || e.metaKey) return;
          var t = 0,
            i = 0,
            o = 0,
            r = 0,
            a = 0;
          switch (e.keyCode) {
            case 61:
            case 107:
            case 171:
            case 187:
              t = 1;
              break;
            case 189:
            case 109:
            case 173:
              t = -1;
              break;
            case 37:
              e.shiftKey ? i = -1 : (e.preventDefault(), r = -1);
              break;
            case 39:
              e.shiftKey ? i = 1 : (e.preventDefault(), r = 1);
              break;
            case 38:
              e.shiftKey ? o = 1 : (e.preventDefault(), a = -1);
              break;
            case 40:
              e.shiftKey ? o = -1 : (e.preventDefault(), a = 1);
              break;
            default:
              return;
          }
          return this._rotationDisabled && (i = 0, o = 0), {
            cameraAnimation: function cameraAnimation(n) {
              var s = n.getZoom();
              n.easeTo({
                duration: 300,
                easeId: "keyboardHandler",
                easing: un,
                zoom: t ? Math.round(s) + t * (e.shiftKey ? 2 : 1) : s,
                bearing: n.getBearing() + i * _this174._bearingStep,
                pitch: n.getPitch() + o * _this174._pitchStep,
                offset: [-r * _this174._panStep, -a * _this174._panStep],
                center: n.getCenter()
              }, {
                originalEvent: e
              });
            }
          };
        }
      }, {
        key: "enable",
        value: function enable() {
          this._enabled = !0;
        }
      }, {
        key: "disable",
        value: function disable() {
          this._enabled = !1, this.reset();
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return this._enabled;
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return this._active;
        }
      }, {
        key: "disableRotation",
        value: function disableRotation() {
          this._rotationDisabled = !0;
        }
      }, {
        key: "enableRotation",
        value: function enableRotation() {
          this._rotationDisabled = !1;
        }
      }]);
      return _n;
    }();
    function un(e) {
      return e * (2 - e);
    }
    var dn = 4.000244140625,
      pn = 1 / 450;
    var fn = /*#__PURE__*/function () {
      function fn(t, i) {
        _classCallCheck(this, fn);
        this._map = t, this._el = t.getCanvasContainer(), this._handler = i, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = pn, e.br(["_onTimeout", "_addScrollZoomBlocker", "_showBlockerAlert"], this);
      }
      _createClass(fn, [{
        key: "setZoomRate",
        value: function setZoomRate(e) {
          this._defaultZoomRate = e;
        }
      }, {
        key: "setWheelZoomRate",
        value: function setWheelZoomRate(e) {
          this._wheelZoomRate = e;
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return !!this._enabled;
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return this._active || void 0 !== this._finishTimeout;
        }
      }, {
        key: "isZooming",
        value: function isZooming() {
          return !!this._zooming;
        }
      }, {
        key: "enable",
        value: function enable(e) {
          this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e && "center" === e.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
        }
      }, {
        key: "disable",
        value: function disable() {
          this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
        }
      }, {
        key: "wheel",
        value: function wheel(t) {
          if (!this.isEnabled()) return;
          if (this._map._cooperativeGestures) {
            if (!(t.ctrlKey || t.metaKey || this.isZooming() || e.d4())) return void this._showBlockerAlert();
            "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
          }
          var i = t.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t.deltaY : t.deltaY;
          var o = e.e.now(),
            r = o - (this._lastWheelEventTime || 0);
          this._lastWheelEventTime = o, 0 !== i && i % dn == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : r > 400 ? (this._type = null, this._lastValue = i, this._timeout = window.setTimeout(this._onTimeout, 40, t)) : this._type || (this._type = Math.abs(r * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), t.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = t, this._delta -= i, this._active || this._start(t)), t.preventDefault();
        }
      }, {
        key: "_onTimeout",
        value: function _onTimeout(e) {
          this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e);
        }
      }, {
        key: "_start",
        value: function _start(e) {
          if (!this._delta) return;
          this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
          var t = d(this._el, e);
          this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
        }
      }, {
        key: "renderFrame",
        value: function renderFrame() {
          var _this175 = this;
          if (!this._frameId) return;
          if (this._frameId = null, !this.isActive()) return;
          var t = this._map.transform;
          "wheel" === this._type && t.projection.wrap && (t._center.lng >= 180 || t._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
          var i = function i() {
            return t._terrainEnabled() && _this175._aroundCoord ? t.computeZoomRelativeTo(_this175._aroundCoord) : t.zoom;
          };
          if (0 !== this._delta) {
            var _e701 = "wheel" === this._type && Math.abs(this._delta) > dn ? this._wheelZoomRate : this._defaultZoomRate;
            var _o275 = 2 / (1 + Math.exp(-Math.abs(this._delta * _e701)));
            this._delta < 0 && 0 !== _o275 && (_o275 = 1 / _o275);
            var _r462 = i(),
              _a252 = Math.pow(2, _r462),
              _n317 = "number" == typeof this._targetZoom ? t.zoomScale(this._targetZoom) : _a252;
            this._targetZoom = Math.min(t.maxZoom, Math.max(t.minZoom, t.scaleZoom(_n317 * _o275))), "wheel" === this._type && (this._startZoom = _r462, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
          }
          var o = "number" == typeof this._targetZoom ? this._targetZoom : i(),
            r = this._startZoom,
            a = this._easing;
          var n,
            s = !1;
          if ("wheel" === this._type && r && a) {
            var _t661 = Math.min((e.e.now() - this._lastWheelEventTime) / 200, 1),
              _i492 = a(_t661);
            n = e.a3(r, o, _i492), _t661 < 1 ? this._frameId || (this._frameId = !0) : s = !0;
          } else n = o, s = !0;
          this._active = !0, s && (this._active = !1, this._finishTimeout = window.setTimeout(function () {
            _this175._zooming = !1, _this175._handler._triggerRenderFrame(), delete _this175._targetZoom, delete _this175._finishTimeout;
          }, 200));
          var l = n - i();
          return l * this._lastDelta < 0 && (l = 0), {
            noInertia: !0,
            needsRenderFrame: !s,
            zoomDelta: l,
            around: this._aroundPoint,
            aroundCoord: this._aroundCoord,
            originalEvent: this._lastWheelEvent
          };
        }
      }, {
        key: "_smoothOutEasing",
        value: function _smoothOutEasing(t) {
          var i = e.d5;
          if (this._prevEase) {
            var _t662 = this._prevEase,
              _o276 = (e.e.now() - _t662.start) / _t662.duration,
              _r463 = _t662.easing(_o276 + .01) - _t662.easing(_o276),
              _a253 = .27 / Math.sqrt(_r463 * _r463 + 1e-4) * .01,
              _n318 = Math.sqrt(.0729 - _a253 * _a253);
            i = e.d3(_a253, _n318, .25, 1);
          }
          return this._prevEase = {
            start: e.e.now(),
            duration: t,
            easing: i
          }, i;
        }
      }, {
        key: "blur",
        value: function blur() {
          this.reset();
        }
      }, {
        key: "reset",
        value: function reset() {
          this._active = !1;
        }
      }, {
        key: "_addScrollZoomBlocker",
        value: function _addScrollZoomBlocker() {
          this._map && !this._alertContainer && (this._alertContainer = r("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = "".concat(Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth))), "px"));
        }
      }, {
        key: "_showBlockerAlert",
        value: function _showBlockerAlert() {
          var _this176 = this;
          this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(function () {
            _this176._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), _this176._alertContainer.removeAttribute("role");
          }, 200);
        }
      }]);
      return fn;
    }();
    var mn = /*#__PURE__*/function () {
      function mn(e, t) {
        _classCallCheck(this, mn);
        this._clickZoom = e, this._tapZoom = t;
      }
      _createClass(mn, [{
        key: "enable",
        value: function enable() {
          this._clickZoom.enable(), this._tapZoom.enable();
        }
      }, {
        key: "disable",
        value: function disable() {
          this._clickZoom.disable(), this._tapZoom.disable();
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return this._clickZoom.isActive() || this._tapZoom.isActive();
        }
      }]);
      return mn;
    }();
    var gn = /*#__PURE__*/function () {
      function gn() {
        _classCallCheck(this, gn);
        this.reset();
      }
      _createClass(gn, [{
        key: "reset",
        value: function reset() {
          this._active = !1;
        }
      }, {
        key: "blur",
        value: function blur() {
          this.reset();
        }
      }, {
        key: "dblclick",
        value: function dblclick(e, t) {
          return e.preventDefault(), {
            cameraAnimation: function cameraAnimation(i) {
              i.easeTo({
                duration: 300,
                zoom: i.getZoom() + (e.shiftKey ? -1 : 1),
                around: i.unproject(t)
              }, {
                originalEvent: e
              });
            }
          };
        }
      }, {
        key: "enable",
        value: function enable() {
          this._enabled = !0;
        }
      }, {
        key: "disable",
        value: function disable() {
          this._enabled = !1, this.reset();
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return this._enabled;
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return this._active;
        }
      }]);
      return gn;
    }();
    var vn = /*#__PURE__*/function () {
      function vn() {
        _classCallCheck(this, vn);
        this._tap = new Ha({
          numTouches: 1,
          numTaps: 1
        }), this.reset();
      }
      _createClass(vn, [{
        key: "reset",
        value: function reset() {
          this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
        }
      }, {
        key: "touchstart",
        value: function touchstart(e, t, i) {
          this._swipePoint || (this._tapTime && e.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = t[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(e, t, i));
        }
      }, {
        key: "touchmove",
        value: function touchmove(e, t, i) {
          if (this._tapTime) {
            if (this._swipePoint) {
              if (i[0].identifier !== this._swipeTouch) return;
              var _o277 = t[0],
                _r464 = _o277.y - this._swipePoint.y;
              return this._swipePoint = _o277, e.preventDefault(), this._active = !0, {
                zoomDelta: _r464 / 128
              };
            }
          } else this._tap.touchmove(e, t, i);
        }
      }, {
        key: "touchend",
        value: function touchend(e, t, i) {
          this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(e, t, i) && (this._tapTime = e.timeStamp);
        }
      }, {
        key: "touchcancel",
        value: function touchcancel() {
          this.reset();
        }
      }, {
        key: "enable",
        value: function enable() {
          this._enabled = !0;
        }
      }, {
        key: "disable",
        value: function disable() {
          this._enabled = !1, this.reset();
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return this._enabled;
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return this._active;
        }
      }]);
      return vn;
    }();
    var xn = /*#__PURE__*/function () {
      function xn(e, t, i) {
        _classCallCheck(this, xn);
        this._el = e, this._mousePan = t, this._touchPan = i;
      }
      _createClass(xn, [{
        key: "enable",
        value: function enable(e) {
          this._inertiaOptions = e || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
        }
      }, {
        key: "disable",
        value: function disable() {
          this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return this._mousePan.isEnabled() && this._touchPan.isEnabled();
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return this._mousePan.isActive() || this._touchPan.isActive();
        }
      }]);
      return xn;
    }();
    var yn = /*#__PURE__*/function () {
      function yn(e, t, i) {
        _classCallCheck(this, yn);
        this._pitchWithRotate = e.pitchWithRotate, this._mouseRotate = t, this._mousePitch = i;
      }
      _createClass(yn, [{
        key: "enable",
        value: function enable() {
          this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
        }
      }, {
        key: "disable",
        value: function disable() {
          this._mouseRotate.disable(), this._mousePitch.disable();
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return this._mouseRotate.isActive() || this._mousePitch.isActive();
        }
      }]);
      return yn;
    }();
    var bn = /*#__PURE__*/function () {
      function bn(e, t, i, o) {
        _classCallCheck(this, bn);
        this._el = e, this._touchZoom = t, this._touchRotate = i, this._tapDragZoom = o, this._rotationDisabled = !1, this._enabled = !0;
      }
      _createClass(bn, [{
        key: "enable",
        value: function enable(e) {
          this._touchZoom.enable(e), this._rotationDisabled || this._touchRotate.enable(e), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
        }
      }, {
        key: "disable",
        value: function disable() {
          this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
        }
      }, {
        key: "isEnabled",
        value: function isEnabled() {
          return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
        }
      }, {
        key: "disableRotation",
        value: function disableRotation() {
          this._rotationDisabled = !0, this._touchRotate.disable();
        }
      }, {
        key: "enableRotation",
        value: function enableRotation() {
          this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
        }
      }]);
      return bn;
    }();
    var wn = function wn(e) {
      return e.zoom || e.drag || e.pitch || e.rotate;
    };
    var Tn = /*#__PURE__*/function (_e$g4) {
      _inherits(Tn, _e$g4);
      var _super165 = _createSuper(Tn);
      function Tn() {
        _classCallCheck(this, Tn);
        return _super165.apply(this, arguments);
      }
      return _createClass(Tn);
    }(e.g);
    var En = /*#__PURE__*/function () {
      function En() {
        _classCallCheck(this, En);
        this.constants = [1, 1, .01], this.radius = 0;
      }
      _createClass(En, [{
        key: "setup",
        value: function setup(t, i) {
          var o = e.$.sub([], i, t);
          this.radius = e.$.length(o[2] < 0 ? e.$.div([], o, this.constants) : [o[0], o[1], 0]);
        }
      }, {
        key: "projectRay",
        value: function projectRay(t) {
          e.$.div(t, t, this.constants), e.$.normalize(t, t), e.$.mul(t, t, this.constants);
          var i = e.$.scale([], t, this.radius);
          if (i[2] > 0) {
            var _t663 = e.$.scale([], [0, 0, 1], e.$.dot(i, [0, 0, 1])),
              _o278 = e.$.scale([], e.$.normalize([], [i[0], i[1], 0]), this.radius),
              _r465 = e.$.add([], i, e.$.scale([], e.$.sub([], e.$.add([], _o278, _t663), i), 2));
            i[0] = _r465[0], i[1] = _r465[1];
          }
          return i;
        }
      }]);
      return En;
    }();
    function Cn(e) {
      return e.panDelta && e.panDelta.mag() || e.zoomDelta || e.bearingDelta || e.pitchDelta;
    }
    var Sn = /*#__PURE__*/function () {
      function Sn(t, i) {
        _classCallCheck(this, Sn);
        this._map = t, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Fa(t), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new En(), this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i), e.br(["handleEvent", "handleWindowEvent"], this);
        var o = this._el;
        this._listeners = [[o, "touchstart", {
          passive: !0
        }], [o, "touchmove", {
          passive: !1
        }], [o, "touchend", void 0], [o, "touchcancel", void 0], [o, "mousedown", void 0], [o, "mousemove", void 0], [o, "mouseup", void 0], [document, "mousemove", {
          capture: !0
        }], [document, "mouseup", void 0], [o, "mouseover", void 0], [o, "mouseout", void 0], [o, "dblclick", void 0], [o, "click", void 0], [o, "keydown", {
          capture: !1
        }], [o, "keyup", void 0], [o, "wheel", {
          passive: !1
        }], [o, "contextmenu", void 0], [window, "blur", void 0]];
        var _iterator475 = _createForOfIteratorHelper(this._listeners),
          _step475;
        try {
          for (_iterator475.s(); !(_step475 = _iterator475.n()).done;) {
            var _step475$value = _slicedToArray(_step475.value, 3),
              _e702 = _step475$value[0],
              _t664 = _step475$value[1],
              _i493 = _step475$value[2];
            var _o279 = _e702 === document ? this.handleWindowEvent : this.handleEvent;
            _e702.addEventListener(_t664, _o279, _i493);
          }
        } catch (err) {
          _iterator475.e(err);
        } finally {
          _iterator475.f();
        }
      }
      _createClass(Sn, [{
        key: "destroy",
        value: function destroy() {
          var _iterator476 = _createForOfIteratorHelper(this._listeners),
            _step476;
          try {
            for (_iterator476.s(); !(_step476 = _iterator476.n()).done;) {
              var _step476$value = _slicedToArray(_step476.value, 3),
                _e703 = _step476$value[0],
                _t665 = _step476$value[1],
                _i494 = _step476$value[2];
              var _o280 = _e703 === document ? this.handleWindowEvent : this.handleEvent;
              _e703.removeEventListener(_t665, _o280, _i494);
            }
          } catch (err) {
            _iterator476.e(err);
          } finally {
            _iterator476.f();
          }
        }
      }, {
        key: "_addDefaultHandlers",
        value: function _addDefaultHandlers(e) {
          var t = this._map,
            i = t.getCanvasContainer();
          this._add("mapEvent", new ja(t, e));
          var o = t.boxZoom = new $a(t, e);
          this._add("boxZoom", o);
          var r = new qa(),
            a = new gn();
          t.doubleClickZoom = new mn(a, r), this._add("tapZoom", r), this._add("clickZoom", a);
          var n = new vn();
          this._add("tapDragZoom", n);
          var s = t.touchPitch = new cn(t);
          this._add("touchPitch", s);
          var l = new Ja(e),
            c = new Ka(e);
          t.dragRotate = new yn(e, l, c), this._add("mouseRotate", l, ["mousePitch"]), this._add("mousePitch", c, ["mouseRotate"]);
          var h = new Ya(e),
            _ = new en(t, e);
          t.dragPan = new xn(i, h, _), this._add("mousePan", h), this._add("touchPan", _, ["touchZoom", "touchRotate"]);
          var u = new sn(),
            d = new an();
          t.touchZoomRotate = new bn(i, d, u, n), this._add("touchRotate", u, ["touchPan", "touchZoom"]), this._add("touchZoom", d, ["touchPan", "touchRotate"]), this._add("blockableMapEvent", new Va(t));
          var p = t.scrollZoom = new fn(t, this);
          this._add("scrollZoom", p, ["mousePan"]);
          var f = t.keyboard = new _n();
          this._add("keyboard", f);
          for (var _i495 = 0, _arr6 = ["boxZoom", "doubleClickZoom", "tapDragZoom", "touchPitch", "dragRotate", "dragPan", "touchZoomRotate", "scrollZoom", "keyboard"]; _i495 < _arr6.length; _i495++) {
            var _i496 = _arr6[_i495];
            e.interactive && e[_i496] && t[_i496].enable(e[_i496]);
          }
        }
      }, {
        key: "_add",
        value: function _add(e, t, i) {
          this._handlers.push({
            handlerName: e,
            handler: t,
            allowed: i
          }), this._handlersById[e] = t;
        }
      }, {
        key: "stop",
        value: function stop(e) {
          if (!this._updatingCamera) {
            var _iterator477 = _createForOfIteratorHelper(this._handlers),
              _step477;
            try {
              for (_iterator477.s(); !(_step477 = _iterator477.n()).done;) {
                var _e704 = _step477.value.handler;
                _e704.reset();
              }
            } catch (err) {
              _iterator477.e(err);
            } finally {
              _iterator477.f();
            }
            this._inertia.clear(), this._fireEvents({}, {}, e), this._changes = [], this._originalZoom = void 0;
          }
        }
      }, {
        key: "isActive",
        value: function isActive() {
          var _iterator478 = _createForOfIteratorHelper(this._handlers),
            _step478;
          try {
            for (_iterator478.s(); !(_step478 = _iterator478.n()).done;) {
              var _e705 = _step478.value.handler;
              if (_e705.isActive()) return !0;
            }
          } catch (err) {
            _iterator478.e(err);
          } finally {
            _iterator478.f();
          }
          return !1;
        }
      }, {
        key: "isZooming",
        value: function isZooming() {
          return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
        }
      }, {
        key: "isRotating",
        value: function isRotating() {
          return !!this._eventsInProgress.rotate;
        }
      }, {
        key: "isMoving",
        value: function isMoving() {
          return !!wn(this._eventsInProgress) || this.isZooming();
        }
      }, {
        key: "_isDragging",
        value: function _isDragging() {
          return !!this._eventsInProgress.drag;
        }
      }, {
        key: "_blockedByActive",
        value: function _blockedByActive(e, t, i) {
          for (var _o281 in e) if (_o281 !== i && (!t || t.indexOf(_o281) < 0)) return !0;
          return !1;
        }
      }, {
        key: "handleWindowEvent",
        value: function handleWindowEvent(e) {
          this.handleEvent(e, "".concat(e.type, "Window"));
        }
      }, {
        key: "_getMapTouches",
        value: function _getMapTouches(e) {
          var t = [];
          var _iterator479 = _createForOfIteratorHelper(e),
            _step479;
          try {
            for (_iterator479.s(); !(_step479 = _iterator479.n()).done;) {
              var _i497 = _step479.value;
              this._el.contains(_i497.target) && t.push(_i497);
            }
          } catch (err) {
            _iterator479.e(err);
          } finally {
            _iterator479.f();
          }
          return t;
        }
      }, {
        key: "handleEvent",
        value: function handleEvent(e, t) {
          this._updatingCamera = !0;
          var i = "renderFrame" === e.type,
            o = i ? void 0 : e,
            r = {
              needsRenderFrame: !1
            },
            a = {},
            n = {},
            s = e.touches ? this._getMapTouches(e.touches) : void 0,
            l = s ? p(this._el, s) : i ? void 0 : d(this._el, e);
          var _iterator480 = _createForOfIteratorHelper(this._handlers),
            _step480;
          try {
            for (_iterator480.s(); !(_step480 = _iterator480.n()).done;) {
              var _step480$value = _step480.value,
                _i498 = _step480$value.handlerName,
                _c124 = _step480$value.handler,
                _h94 = _step480$value.allowed;
              if (!_c124.isEnabled()) continue;
              var _39 = void 0;
              this._blockedByActive(n, _h94, _i498) ? _c124.reset() : _c124[t || e.type] && (_39 = _c124[t || e.type](e, l, s), this.mergeHandlerResult(r, a, _39, _i498, o), _39 && _39.needsRenderFrame && this._triggerRenderFrame()), (_39 || _c124.isActive()) && (n[_i498] = _c124);
            }
          } catch (err) {
            _iterator480.e(err);
          } finally {
            _iterator480.f();
          }
          var c = {};
          for (var _e706 in this._previousActiveHandlers) n[_e706] || (c[_e706] = o);
          this._previousActiveHandlers = n, (Object.keys(c).length || Cn(r)) && (this._changes.push([r, a, c]), this._triggerRenderFrame()), (Object.keys(n).length || Cn(r)) && this._map._stop(!0), this._updatingCamera = !1;
          var h = r.cameraAnimation;
          h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
        }
      }, {
        key: "mergeHandlerResult",
        value: function mergeHandlerResult(t, i, o, r, a) {
          if (!o) return;
          e.Q(t, o);
          var n = {
            handlerName: r,
            originalEvent: o.originalEvent || a
          };
          void 0 !== o.zoomDelta && (i.zoom = n), void 0 !== o.panDelta && (i.drag = n), void 0 !== o.pitchDelta && (i.pitch = n), void 0 !== o.bearingDelta && (i.rotate = n);
        }
      }, {
        key: "_applyChanges",
        value: function _applyChanges() {
          var t = {},
            i = {},
            o = {};
          var _iterator481 = _createForOfIteratorHelper(this._changes),
            _step481;
          try {
            for (_iterator481.s(); !(_step481 = _iterator481.n()).done;) {
              var _step481$value = _slicedToArray(_step481.value, 3),
                _r466 = _step481$value[0],
                _a254 = _step481$value[1],
                _n319 = _step481$value[2];
              _r466.panDelta && (t.panDelta = (t.panDelta || new e.P(0, 0))._add(_r466.panDelta)), _r466.zoomDelta && (t.zoomDelta = (t.zoomDelta || 0) + _r466.zoomDelta), _r466.bearingDelta && (t.bearingDelta = (t.bearingDelta || 0) + _r466.bearingDelta), _r466.pitchDelta && (t.pitchDelta = (t.pitchDelta || 0) + _r466.pitchDelta), void 0 !== _r466.around && (t.around = _r466.around), void 0 !== _r466.aroundCoord && (t.aroundCoord = _r466.aroundCoord), void 0 !== _r466.pinchAround && (t.pinchAround = _r466.pinchAround), _r466.noInertia && (t.noInertia = _r466.noInertia), e.Q(i, _a254), e.Q(o, _n319);
            }
          } catch (err) {
            _iterator481.e(err);
          } finally {
            _iterator481.f();
          }
          this._updateMapTransform(t, i, o), this._changes = [];
        }
      }, {
        key: "_updateMapTransform",
        value: function _updateMapTransform(t, i, o) {
          var _this177 = this;
          var r = this._map,
            a = r.transform,
            n = function n(e) {
              return [e.x, e.y, e.z];
            };
          if (function (e) {
            var t = _this177._eventsInProgress.drag;
            return t && !_this177._handlersById[t.handlerName].isActive();
          }() && !Cn(t)) {
            var _e707 = a.zoom;
            a.cameraElevationReference = "sea", null != this._originalZoom && a._orthographicProjectionAtLowPitch && "globe" !== a.projection.name && 0 === a.pitch ? (a.cameraElevationReference = "ground", a.zoom = this._originalZoom) : (a.recenterOnTerrain(), a.cameraElevationReference = "ground"), _e707 !== a.zoom && this._map._update(!0);
          }
          if (a._isCameraConstrained && r._stop(!0), !Cn(t)) return void this._fireEvents(i, o, !0);
          var s = t.panDelta,
            l = t.zoomDelta,
            c = t.bearingDelta,
            h = t.pitchDelta,
            _ = t.around,
            u = t.aroundCoord,
            d = t.pinchAround;
          a._isCameraConstrained && (l > 0 && (l = 0), a._isCameraConstrained = !1), void 0 !== d && (_ = d), (l || function (e) {
            return i[e] && !_this177._eventsInProgress[e];
          }("drag")) && _ && (this._dragOrigin = n(a.pointCoordinate3D(_)), this._originalZoom = a.zoom, this._trackingEllipsoid.setup(a._camera.position, this._dragOrigin)), a.cameraElevationReference = "sea", r._stop(!0), _ = _ || r.transform.centerPoint, c && (a.bearing += c), h && (a.pitch += h), a._updateCameraState();
          var p = [0, 0, 0];
          if (s) if ("mercator" === a.projection.name) {
            var _e708 = this._trackingEllipsoid.projectRay(a.screenPointToMercatorRay(_).dir),
              _t666 = this._trackingEllipsoid.projectRay(a.screenPointToMercatorRay(_.sub(s)).dir);
            p[0] = _t666[0] - _e708[0], p[1] = _t666[1] - _e708[1];
          } else {
            var _t667 = a.pointCoordinate(_);
            if ("globe" === a.projection.name) {
              s = s.rotate(-a.angle);
              var _i499 = a._pixelsPerMercatorPixel / a.worldSize;
              p[0] = -s.x * e.d6(e.az(_t667.y)) * _i499, p[1] = -s.y * e.d6(a.center.lat) * _i499;
            } else {
              var _e709 = a.pointCoordinate(_.sub(s));
              _t667 && _e709 && (p[0] = _e709.x - _t667.x, p[1] = _e709.y - _t667.y);
            }
          }
          var f = a.zoom,
            m = [0, 0, 0];
          if (l) {
            var _t668 = n(u || a.pointCoordinate3D(_)),
              _i500 = {
                dir: e.$.normalize([], e.$.sub([], _t668, a._camera.position))
              };
            if (_i500.dir[2] < 0) {
              var _o282 = a.zoomDeltaToMovement(_t668, l);
              e.$.scale(m, _i500.dir, _o282);
            }
          }
          var g = e.$.add(p, p, m);
          a._translateCameraConstrained(g), l && Math.abs(a.zoom - f) > 1e-4 && a.recenterOnTerrain(), a.cameraElevationReference = "ground", this._map._update(), t.noInertia || this._inertia.record(t), this._fireEvents(i, o, !0);
        }
      }, {
        key: "_fireEvents",
        value: function _fireEvents(t, i, o) {
          var _this178 = this;
          var r = wn(this._eventsInProgress),
            a = wn(t),
            n = {};
          for (var _e710 in t) {
            var _i501 = t[_e710].originalEvent;
            this._eventsInProgress[_e710] || (n["".concat(_e710, "start")] = _i501), this._eventsInProgress[_e710] = t[_e710];
          }
          !r && a && this._fireEvent("movestart", a.originalEvent);
          for (var _e711 in n) this._fireEvent(_e711, n[_e711]);
          a && this._fireEvent("move", a.originalEvent);
          for (var _e712 in t) {
            var _i502 = t[_e712].originalEvent;
            this._fireEvent(_e712, _i502);
          }
          var s = {};
          var l;
          for (var _e713 in this._eventsInProgress) {
            var _this$_eventsInProgre = this._eventsInProgress[_e713],
              _t669 = _this$_eventsInProgre.handlerName,
              _o283 = _this$_eventsInProgre.originalEvent;
            this._handlersById[_t669].isActive() || (delete this._eventsInProgress[_e713], l = i[_t669] || _o283, s["".concat(_e713, "end")] = l);
          }
          for (var _e714 in s) this._fireEvent(_e714, s[_e714]);
          var c = wn(this._eventsInProgress);
          if (o && (r || a) && !c) {
            this._updatingCamera = !0;
            var _t670 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions),
              _i503 = function _i503(e) {
                return 0 !== e && -_this178._bearingSnap < e && e < _this178._bearingSnap;
              };
            _t670 ? (_i503(_t670.bearing || this._map.getBearing()) && (_t670.bearing = 0), this._map.easeTo(_t670, {
              originalEvent: l
            })) : (this._map.fire(new e.g("moveend", {
              originalEvent: l
            })), _i503(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
          }
        }
      }, {
        key: "_fireEvent",
        value: function _fireEvent(t, i) {
          this._map.fire(new e.g(t, i ? {
            originalEvent: i
          } : {}));
        }
      }, {
        key: "_requestFrame",
        value: function _requestFrame() {
          var _this179 = this;
          return this._map.triggerRepaint(), this._map._renderTaskQueue.add(function (e) {
            _this179._frameId = void 0, _this179.handleEvent(new Tn("renderFrame", {
              timeStamp: e
            })), _this179._applyChanges();
          });
        }
      }, {
        key: "_triggerRenderFrame",
        value: function _triggerRenderFrame() {
          void 0 === this._frameId && (this._frameId = this._requestFrame());
        }
      }]);
      return Sn;
    }();
    var In = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
    var Ln = /*#__PURE__*/function (_e$E15) {
      _inherits(Ln, _e$E15);
      var _super166 = _createSuper(Ln);
      function Ln(t, i) {
        var _this180;
        _classCallCheck(this, Ln);
        _this180 = _super166.call(this), _this180._moving = !1, _this180._zooming = !1, _this180.transform = t, _this180._bearingSnap = i.bearingSnap, _this180._respectPrefersReducedMotion = !1 !== i.respectPrefersReducedMotion, e.br(["_renderFrameCallback"], _assertThisInitialized(_this180));
        return _this180;
      }
      _createClass(Ln, [{
        key: "getCenter",
        value: function getCenter() {
          return new e.aJ(this.transform.center.lng, this.transform.center.lat);
        }
      }, {
        key: "setCenter",
        value: function setCenter(e, t) {
          return this.jumpTo({
            center: e
          }, t);
        }
      }, {
        key: "panBy",
        value: function panBy(t, i, o) {
          return t = e.P.convert(t).mult(-1), this.panTo(this.transform.center, e.Q({
            offset: t
          }, i), o);
        }
      }, {
        key: "panTo",
        value: function panTo(t, i, o) {
          return this.easeTo(e.Q({
            center: t
          }, i), o);
        }
      }, {
        key: "getZoom",
        value: function getZoom() {
          return this.transform.zoom;
        }
      }, {
        key: "setZoom",
        value: function setZoom(e, t) {
          return this.jumpTo({
            zoom: e
          }, t), this;
        }
      }, {
        key: "zoomTo",
        value: function zoomTo(t, i, o) {
          return this.easeTo(e.Q({
            zoom: t
          }, i), o);
        }
      }, {
        key: "zoomIn",
        value: function zoomIn(e, t) {
          return this.zoomTo(this.getZoom() + 1, e, t), this;
        }
      }, {
        key: "zoomOut",
        value: function zoomOut(e, t) {
          return this.zoomTo(this.getZoom() - 1, e, t), this;
        }
      }, {
        key: "getBearing",
        value: function getBearing() {
          return this.transform.bearing;
        }
      }, {
        key: "setBearing",
        value: function setBearing(e, t) {
          return this.jumpTo({
            bearing: e
          }, t), this;
        }
      }, {
        key: "getPadding",
        value: function getPadding() {
          return this.transform.padding;
        }
      }, {
        key: "setPadding",
        value: function setPadding(e, t) {
          return this.jumpTo({
            padding: e
          }, t), this;
        }
      }, {
        key: "rotateTo",
        value: function rotateTo(t, i, o) {
          return this.easeTo(e.Q({
            bearing: t
          }, i), o);
        }
      }, {
        key: "resetNorth",
        value: function resetNorth(t, i) {
          return this.rotateTo(0, e.Q({
            duration: 1e3
          }, t), i), this;
        }
      }, {
        key: "resetNorthPitch",
        value: function resetNorthPitch(t, i) {
          return this.easeTo(e.Q({
            bearing: 0,
            pitch: 0,
            duration: 1e3
          }, t), i), this;
        }
      }, {
        key: "snapToNorth",
        value: function snapToNorth(e, t) {
          return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e, t) : this;
        }
      }, {
        key: "getPitch",
        value: function getPitch() {
          return this.transform.pitch;
        }
      }, {
        key: "setPitch",
        value: function setPitch(e, t) {
          return this.jumpTo({
            pitch: e
          }, t), this;
        }
      }, {
        key: "cameraForBounds",
        value: function cameraForBounds(t, i) {
          t = e.aj.convert(t);
          var o = i && i.bearing || 0,
            r = i && i.pitch || 0,
            a = t.getNorthWest(),
            n = t.getSouthEast();
          return this._cameraForBounds(this.transform, a, n, o, r, i);
        }
      }, {
        key: "_extendPadding",
        value: function _extendPadding(t) {
          var i = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          };
          return null == t ? e.Q({}, i, this.transform.padding) : "number" == typeof t ? {
            top: t,
            bottom: t,
            right: t,
            left: t
          } : e.Q({}, i, t);
        }
      }, {
        key: "_extendCameraOptions",
        value: function _extendCameraOptions(t) {
          return (t = e.Q({
            offset: [0, 0],
            maxZoom: this.transform.maxZoom
          }, t)).padding = this._extendPadding(t.padding), t;
        }
      }, {
        key: "_minimumAABBFrustumDistance",
        value: function _minimumAABBFrustumDistance(e, t) {
          var i = t.max[0] - t.min[0],
            o = t.max[1] - t.min[1];
          return i / o > e.aspect ? i / (2 * Math.tan(.5 * e.fovX) * e.aspect) : o / (2 * Math.tan(.5 * e.fovY) * e.aspect);
        }
      }, {
        key: "_cameraForBoundsOnGlobe",
        value: function _cameraForBoundsOnGlobe(t, i, o, r, a, n) {
          var s = t.clone(),
            l = this._extendCameraOptions(n);
          s.bearing = r, s.pitch = a;
          var c = e.aJ.convert(i),
            h = e.aJ.convert(o),
            _ = .5 * (c.lat + h.lat),
            u = .5 * (c.lng + h.lng),
            d = e.d7(_, u),
            p = e.$.normalize([], d),
            f = e.$.normalize([], e.$.cross([], p, [0, 1, 0])),
            m = e.$.cross([], f, p),
            g = [f[0], f[1], f[2], 0, m[0], m[1], m[2], 0, p[0], p[1], p[2], 0, 0, 0, 0, 1],
            v = [d, e.d7(c.lat, c.lng), e.d7(h.lat, c.lng), e.d7(h.lat, h.lng), e.d7(c.lat, h.lng), e.d7(_, c.lng), e.d7(_, h.lng), e.d7(c.lat, u), e.d7(h.lat, u)];
          var x = e.b8.fromPoints(v.map(function (t) {
            return [e.$.dot(f, t), e.$.dot(m, t), e.$.dot(p, t)];
          }));
          var y = e.$.transformMat4([], x.center, g);
          0 === e.$.squaredLength(y) && e.$.set(y, 0, 0, 1), e.$.normalize(y, y), e.$.scale(y, y, e.cF), s.center = e.d8(y);
          var b = s.getWorldToCameraMatrix(),
            w = e.ae.invert(new Float64Array(16), b);
          x = e.b8.applyTransform(x, e.ae.multiply([], b, g));
          var T = this._extendAABB(x, s, l, r);
          if (!T) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
          x = T, e.$.transformMat4(y, y, b);
          var E = .5 * (x.max[2] - x.min[2]),
            C = this._minimumAABBFrustumDistance(s, x),
            S = e.$.scale([], [0, 0, 1], E),
            I = e.$.add(S, y, S),
            L = C + (0 === s.pitch ? 0 : e.$.distance(y, I)),
            P = s.globeCenterInViewSpace,
            R = e.$.sub([], y, [P[0], P[1], P[2]]);
          e.$.normalize(R, R), e.$.scale(R, R, L);
          var D = e.$.add([], y, R);
          e.$.transformMat4(D, D, w);
          var A = e.da / e.cF,
            M = e.$.length(D),
            z = e.ay(Math.max(M * A - e.da, Number.EPSILON), 0),
            O = Math.min(s.zoomFromMercatorZAdjusted(z), l.maxZoom);
          return O > .5 * (e.b3 + e.aV) ? (s.setProjection({
            name: "mercator"
          }), s.zoom = O, this._cameraForBounds(s, i, o, r, a, n)) : {
            center: s.center,
            zoom: O,
            bearing: r,
            pitch: a
          };
        }
      }, {
        key: "_extendAABB",
        value: function _extendAABB(t, i, o, r) {
          var a = .5 * ((o.padding.left || 0) + (o.padding.right || 0)),
            n = .5 * ((o.padding.top || 0) + (o.padding.bottom || 0)),
            s = n,
            l = a,
            c = a,
            h = n,
            _ = i.width - (l + c),
            u = i.height - (s + h),
            d = e.$.sub([], t.max, t.min),
            p = Math.min(_ / d[0], u / d[1]),
            f = Math.min(i.scaleZoom(i.scale * p), o.maxZoom);
          if (isNaN(f)) return null;
          var m = i.scale / i.zoomScale(f),
            g = new e.b8([t.min[0] - l * m, t.min[1] - h * m, t.min[2]], [t.max[0] + c * m, t.max[1] + s * m, t.max[2]]),
            v = ("number" == typeof o.offset.x && "number" == typeof o.offset.y ? new e.P(o.offset.x, o.offset.y) : e.P.convert(o.offset)).rotate(-e.ac(r));
          return g.center[0] -= v.x * m, g.center[1] += v.y * m, g;
        }
      }, {
        key: "queryTerrainElevation",
        value: function queryTerrainElevation(t, i) {
          var o = this.transform.elevation;
          return o ? (i = e.Q({}, {
            exaggerated: !0
          }, i), o.getAtPoint(e._.fromLngLat(t), null, i.exaggerated)) : null;
        }
      }, {
        key: "_cameraForBounds",
        value: function _cameraForBounds(t, i, o, r, a, n) {
          if ("globe" === t.projection.name) return this._cameraForBoundsOnGlobe(t, i, o, r, a, n);
          var s = t.clone(),
            l = this._extendCameraOptions(n);
          s.bearing = r, s.pitch = a;
          var c = e.aJ.convert(i),
            h = e.aJ.convert(o),
            _ = new e.aJ(c.lng, h.lat),
            u = new e.aJ(h.lng, c.lat),
            d = s.project(c),
            p = s.project(h),
            f = this.queryTerrainElevation(c),
            m = this.queryTerrainElevation(h),
            g = this.queryTerrainElevation(_),
            v = this.queryTerrainElevation(u),
            x = [[d.x, d.y, Math.min(f || 0, m || 0, g || 0, v || 0)], [p.x, p.y, Math.max(f || 0, m || 0, g || 0, v || 0)]];
          var y = e.b8.fromPoints(x);
          var b = s.getWorldToCameraMatrix(),
            w = e.ae.invert(new Float64Array(16), b);
          y = e.b8.applyTransform(y, b);
          var T = this._extendAABB(y, s, l, r);
          if (!T) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
          y = T;
          var E = .5 * e.$.sub([], y.max, y.min)[2],
            C = this._minimumAABBFrustumDistance(s, y),
            S = [0, 0, 1, 0];
          e.aB.transformMat4(S, S, b), e.aB.normalize(S, S);
          var I = e.$.scale([], S, C + E),
            L = e.$.add([], y.center, I);
          e.$.transformMat4(y.center, y.center, w), e.$.transformMat4(L, L, w);
          var P = [y.center[0], y.center[1], L[2] * s.pixelsPerMeter];
          e.$.scale(P, P, 1 / s.worldSize);
          var R = e.d9(P[0]),
            D = e.az(P[1]),
            A = Math.min(s._zoomFromMercatorZ(P[2]), l.maxZoom),
            M = new e.aJ(R, D);
          return s.mercatorFromTransition && A < .5 * (e.b3 + e.aV) ? (s.setProjection({
            name: "globe"
          }), s.zoom = A, this._cameraForBounds(s, i, o, r, a, n)) : {
            center: M,
            zoom: A,
            bearing: r,
            pitch: a
          };
        }
      }, {
        key: "fitBounds",
        value: function fitBounds(e, t, i) {
          var o = this.cameraForBounds(e, t);
          return this._fitInternal(o, t, i);
        }
      }, {
        key: "fitScreenCoordinates",
        value: function fitScreenCoordinates(t, i, o, r, a) {
          var n = e.P.convert(t),
            s = e.P.convert(i),
            l = new e.P(Math.min(n.x, s.x), Math.min(n.y, s.y)),
            c = new e.P(Math.max(n.x, s.x), Math.max(n.y, s.y));
          if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(n, s)) return this;
          var h = this.transform.pointLocation3D(l),
            _ = this.transform.pointLocation3D(c),
            u = this.transform.pointLocation3D(new e.P(l.x, c.y)),
            d = this.transform.pointLocation3D(new e.P(c.x, l.y)),
            p = [Math.min(h.lng, _.lng, u.lng, d.lng), Math.min(h.lat, _.lat, u.lat, d.lat)],
            f = [Math.max(h.lng, _.lng, u.lng, d.lng), Math.max(h.lat, _.lat, u.lat, d.lat)],
            m = r && r.pitch ? r.pitch : this.getPitch(),
            g = this._cameraForBounds(this.transform, p, f, o, m, r);
          return this._fitInternal(g, r, a);
        }
      }, {
        key: "_fitInternal",
        value: function _fitInternal(t, i, o) {
          return t ? (i = e.Q(t, i)).linear ? this.easeTo(i, o) : this.flyTo(i, o) : this;
        }
      }, {
        key: "jumpTo",
        value: function jumpTo(t, i) {
          this.stop();
          var o = t.preloadOnly ? this.transform.clone() : this.transform;
          var r = !1,
            a = !1,
            n = !1;
          if ("zoom" in t && o.zoom !== +t.zoom && (r = !0, o.zoom = +t.zoom), void 0 !== t.center && (o.center = e.aJ.convert(t.center)), "bearing" in t && o.bearing !== +t.bearing && (a = !0, o.bearing = +t.bearing), "pitch" in t && o.pitch !== +t.pitch && (n = !0, o.pitch = +t.pitch), null != t.padding) {
            var _e715 = "number" == typeof t.padding ? this._extendPadding(t.padding) : t.padding;
            o.isPaddingEqual(_e715) || (o.padding = _e715);
          }
          return t.preloadOnly ? (this._preloadTiles(o), this) : (this.fire(new e.g("movestart", i)).fire(new e.g("move", i)), r && this.fire(new e.g("zoomstart", i)).fire(new e.g("zoom", i)).fire(new e.g("zoomend", i)), a && this.fire(new e.g("rotatestart", i)).fire(new e.g("rotate", i)).fire(new e.g("rotateend", i)), n && this.fire(new e.g("pitchstart", i)).fire(new e.g("pitch", i)).fire(new e.g("pitchend", i)), this.fire(new e.g("moveend", i)));
        }
      }, {
        key: "getFreeCameraOptions",
        value: function getFreeCameraOptions() {
          return this.transform.projection.supportsFreeCamera || e.w(In), this.transform.getFreeCameraOptions();
        }
      }, {
        key: "setFreeCameraOptions",
        value: function setFreeCameraOptions(t, i) {
          var o = this.transform;
          if (!o.projection.supportsFreeCamera) return e.w(In), this;
          this.stop();
          var r = o.zoom,
            a = o.pitch,
            n = o.bearing;
          o.setFreeCameraOptions(t);
          var s = r !== o.zoom,
            l = a !== o.pitch,
            c = n !== o.bearing;
          return this.fire(new e.g("movestart", i)).fire(new e.g("move", i)), s && this.fire(new e.g("zoomstart", i)).fire(new e.g("zoom", i)).fire(new e.g("zoomend", i)), c && this.fire(new e.g("rotatestart", i)).fire(new e.g("rotate", i)).fire(new e.g("rotateend", i)), l && this.fire(new e.g("pitchstart", i)).fire(new e.g("pitch", i)).fire(new e.g("pitchend", i)), this.fire(new e.g("moveend", i)), this;
        }
      }, {
        key: "easeTo",
        value: function easeTo(t, i) {
          var _this181 = this;
          this._stop(!1, t.easeId), (!1 === (t = e.Q({
            offset: [0, 0],
            duration: 500,
            easing: e.d5
          }, t)).animate || this._prefersReducedMotion(t)) && (t.duration = 0);
          var o = this.transform,
            r = this.getZoom(),
            a = this.getBearing(),
            n = this.getPitch(),
            s = this.getPadding(),
            l = "zoom" in t ? +t.zoom : r,
            c = "bearing" in t ? this._normalizeBearing(t.bearing, a) : a,
            h = "pitch" in t ? +t.pitch : n,
            _ = this._extendPadding(t.padding),
            u = e.P.convert(t.offset);
          var d, p, f;
          if ("globe" === o.projection.name) {
            var _i504 = e._.fromLngLat(o.center),
              _r467 = u.rotate(-o.angle);
            _i504.x += _r467.x / o.worldSize, _i504.y += _r467.y / o.worldSize;
            var _a255 = _i504.toLngLat(),
              _n320 = e.aJ.convert(t.center || _a255);
            this._normalizeCenter(_n320), d = o.centerPoint.add(_r467), p = new e.P(_i504.x, _i504.y).mult(o.worldSize), f = new e.P(e.ak(_n320.lng), e.al(_n320.lat)).mult(o.worldSize).sub(p);
          } else {
            d = o.centerPoint.add(u);
            var _i505 = o.pointLocation(d),
              _r468 = e.aJ.convert(t.center || _i505);
            this._normalizeCenter(_r468), p = o.project(_i505), f = o.project(_r468).sub(p);
          }
          var m = o.zoomScale(l - r);
          var g, v;
          t.around && (g = e.aJ.convert(t.around), v = o.locationPoint(g));
          var x = this._zooming || l !== r,
            y = this._rotating || a !== c,
            b = this._pitching || h !== n,
            w = !o.isPaddingEqual(_),
            T = function T(o) {
              return function (T) {
                if (x && (o.zoom = e.a3(r, l, T)), y && (o.bearing = e.a3(a, c, T)), b && (o.pitch = e.a3(n, h, T)), w && (o.interpolatePadding(s, _, T), d = o.centerPoint.add(u)), g) o.setLocationAtPoint(g, v);else {
                  var _e716 = o.zoomScale(o.zoom - r),
                    _t671 = l > r ? Math.min(2, m) : Math.max(.5, m),
                    _i506 = Math.pow(_t671, 1 - T),
                    _a256 = o.unproject(p.add(f.mult(T * _i506)).mult(_e716));
                  o.setLocationAtPoint(o.renderWorldCopies ? _a256.wrap() : _a256, d);
                }
                return t.preloadOnly || _this181._fireMoveEvents(i), o;
              };
            };
          if (t.preloadOnly) {
            var _e717 = this._emulate(T, t.duration, o);
            return this._preloadTiles(_e717), this;
          }
          var E = {
            moving: this._moving,
            zooming: this._zooming,
            rotating: this._rotating,
            pitching: this._pitching
          };
          return this._zooming = x, this._rotating = y, this._pitching = b, this._padding = w, this._easeId = t.easeId, this._prepareEase(i, t.noMoveStart, E), this._ease(T(o), function (e) {
            "sea" === o.cameraElevationReference && o.recenterOnTerrain(), _this181._afterEase(i, e);
          }, t), this;
        }
      }, {
        key: "_prepareEase",
        value: function _prepareEase(t, i) {
          var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          this._moving = !0, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), i || o.moving || this.fire(new e.g("movestart", t)), this._zooming && !o.zooming && this.fire(new e.g("zoomstart", t)), this._rotating && !o.rotating && this.fire(new e.g("rotatestart", t)), this._pitching && !o.pitching && this.fire(new e.g("pitchstart", t));
        }
      }, {
        key: "_fireMoveEvents",
        value: function _fireMoveEvents(t) {
          this.fire(new e.g("move", t)), this._zooming && this.fire(new e.g("zoom", t)), this._rotating && this.fire(new e.g("rotate", t)), this._pitching && this.fire(new e.g("pitch", t));
        }
      }, {
        key: "_afterEase",
        value: function _afterEase(t, i) {
          if (this._easeId && i && this._easeId === i) return;
          this._easeId = void 0, this.transform.cameraElevationReference = "ground";
          var o = this._zooming,
            r = this._rotating,
            a = this._pitching;
          this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, o && this.fire(new e.g("zoomend", t)), r && this.fire(new e.g("rotateend", t)), a && this.fire(new e.g("pitchend", t)), this.fire(new e.g("moveend", t));
        }
      }, {
        key: "flyTo",
        value: function flyTo(t, i) {
          var _this182 = this;
          if (this._prefersReducedMotion(t)) {
            var _o284 = e.ai(t, ["center", "zoom", "bearing", "pitch", "around", "padding"]);
            return this.jumpTo(_o284, i);
          }
          this.stop(), t = e.Q({
            offset: [0, 0],
            speed: 1.2,
            curve: 1.42,
            easing: e.d5
          }, t);
          var o = this.transform,
            r = this.getZoom(),
            a = this.getBearing(),
            n = this.getPitch(),
            s = this.getPadding(),
            l = "zoom" in t ? e.au(+t.zoom, o.minZoom, o.maxZoom) : r,
            c = "bearing" in t ? this._normalizeBearing(t.bearing, a) : a,
            h = "pitch" in t ? +t.pitch : n,
            _ = this._extendPadding(t.padding),
            u = o.zoomScale(l - r),
            d = e.P.convert(t.offset);
          var p = o.centerPoint.add(d);
          var f = o.pointLocation(p),
            m = e.aJ.convert(t.center || f);
          this._normalizeCenter(m);
          var g = o.project(f),
            v = o.project(m).sub(g);
          var x = t.curve;
          var y = Math.max(o.width, o.height),
            b = y / u,
            w = v.mag();
          if ("minZoom" in t) {
            var _i507 = e.au(Math.min(t.minZoom, r, l), o.minZoom, o.maxZoom),
              _a257 = y / o.zoomScale(_i507 - r);
            x = Math.sqrt(_a257 / w * 2);
          }
          var T = x * x;
          function E(e) {
            var t = (b * b - y * y + (e ? -1 : 1) * T * T * w * w) / (2 * (e ? b : y) * T * w);
            return Math.log(Math.sqrt(t * t + 1) - t);
          }
          function C(e) {
            return (Math.exp(e) - Math.exp(-e)) / 2;
          }
          function S(e) {
            return (Math.exp(e) + Math.exp(-e)) / 2;
          }
          var I = E(0);
          var L = function L(e) {
              return S(I) / S(I + x * e);
            },
            P = function P(e) {
              return y * ((S(I) * (C(t = I + x * e) / S(t)) - C(I)) / T) / w;
              var t;
            },
            R = (E(1) - I) / x;
          if (Math.abs(w) < 1e-6 || !isFinite(R)) {
            if (Math.abs(y - b) < 1e-6) return this.easeTo(t, i);
            var _e718 = b < y ? -1 : 1;
            R = Math.abs(Math.log(b / y)) / x, P = function P() {
              return 0;
            }, L = function L(t) {
              return Math.exp(_e718 * x * t);
            };
          }
          t.duration = "duration" in t ? +t.duration : 1e3 * R / ("screenSpeed" in t ? +t.screenSpeed / x : +t.speed), t.maxDuration && t.duration > t.maxDuration && (t.duration = 0);
          var D = a !== c,
            A = h !== n,
            M = !o.isPaddingEqual(_),
            z = function z(o) {
              return function (u) {
                var f = u * R,
                  x = 1 / L(f);
                o.zoom = 1 === u ? l : r + o.scaleZoom(x), D && (o.bearing = e.a3(a, c, u)), A && (o.pitch = e.a3(n, h, u)), M && (o.interpolatePadding(s, _, u), p = o.centerPoint.add(d));
                var y = 1 === u ? m : o.unproject(g.add(v.mult(P(f))).mult(x));
                return o.setLocationAtPoint(o.renderWorldCopies ? y.wrap() : y, p), o._updateCameraOnTerrain(), t.preloadOnly || _this182._fireMoveEvents(i), o;
              };
            };
          if (t.preloadOnly) {
            var _e719 = this._emulate(z, t.duration, o);
            return this._preloadTiles(_e719), this;
          }
          return this._zooming = !0, this._rotating = D, this._pitching = A, this._padding = M, this._prepareEase(i, !1), this._ease(z(o), function () {
            return _this182._afterEase(i);
          }, t), this;
        }
      }, {
        key: "isEasing",
        value: function isEasing() {
          return !!this._easeFrameId;
        }
      }, {
        key: "stop",
        value: function stop() {
          return this._stop();
        }
      }, {
        key: "_requestRenderFrame",
        value: function _requestRenderFrame(e) {}
      }, {
        key: "_cancelRenderFrame",
        value: function _cancelRenderFrame(e) {}
      }, {
        key: "_stop",
        value: function _stop(e, t) {
          if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
            var _e720 = this._onEaseEnd;
            this._onEaseEnd = void 0, _e720.call(this, t);
          }
          if (!e) {
            var _e721 = this.handlers;
            _e721 && _e721.stop(!1);
          }
          return this;
        }
      }, {
        key: "_ease",
        value: function _ease(t, i, o) {
          !1 === o.animate || 0 === o.duration ? (t(1), i()) : (this._easeStart = e.e.now(), this._easeOptions = o, this._onEaseFrame = t, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
        }
      }, {
        key: "_renderFrameCallback",
        value: function _renderFrameCallback() {
          var t = Math.min((e.e.now() - this._easeStart) / this._easeOptions.duration, 1),
            i = this._onEaseFrame;
          i && i(this._easeOptions.easing(t)), t < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
        }
      }, {
        key: "_normalizeBearing",
        value: function _normalizeBearing(t, i) {
          t = e.av(t, -180, 180);
          var o = Math.abs(t - i);
          return Math.abs(t - 360 - i) < o && (t -= 360), Math.abs(t + 360 - i) < o && (t += 360), t;
        }
      }, {
        key: "_normalizeCenter",
        value: function _normalizeCenter(e) {
          var t = this.transform;
          if (t.maxBounds) return;
          if ("globe" !== t.projection.name && !t.renderWorldCopies) return;
          var i = e.lng - t.center.lng;
          e.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
        }
      }, {
        key: "_prefersReducedMotion",
        value: function _prefersReducedMotion(t) {
          return this._respectPrefersReducedMotion && e.e.prefersReducedMotion && !(t && t.essential);
        }
      }, {
        key: "_emulate",
        value: function _emulate(e, t, i) {
          var o = Math.ceil(15 * t / 1e3),
            r = [],
            a = e(i.clone());
          for (var _e722 = 0; _e722 <= o; _e722++) {
            var _t672 = a(_e722 / o);
            r.push(_t672.clone());
          }
          return r;
        }
      }, {
        key: "_preloadTiles",
        value: function _preloadTiles(e, t) {}
      }]);
      return Ln;
    }(e.E);
    var Pn = /*#__PURE__*/function () {
      function Pn() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, Pn);
        this.options = t, e.br(["_toggleAttribution", "_updateEditLink", "_updateData", "_updateCompact"], this);
      }
      _createClass(Pn, [{
        key: "getDefaultPosition",
        value: function getDefaultPosition() {
          return "bottom-right";
        }
      }, {
        key: "onAdd",
        value: function onAdd(e) {
          var t = this.options && this.options.compact,
            i = e._getUIString("AttributionControl.ToggleAttribution");
          this._map = e, this._container = r("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = r("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._compactButton.setAttribute("aria-label", i);
          var o = r("span", "mapboxgl-ctrl-icon", this._compactButton);
          return o.setAttribute("aria-hidden", "true"), o.setAttribute("title", i), this._innerContainer = r("div", "mapboxgl-ctrl-attrib-inner", this._container), t && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
        }
      }, {
        key: "onRemove",
        value: function onRemove() {
          this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
        }
      }, {
        key: "_toggleAttribution",
        value: function _toggleAttribution() {
          this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
        }
      }, {
        key: "_updateEditLink",
        value: function _updateEditLink() {
          var t = this._editLink;
          t || (t = this._editLink = this._container.querySelector(".mapbox-improve-map"));
          var i = [{
            key: "owner",
            value: this.styleOwner
          }, {
            key: "id",
            value: this.styleId
          }, {
            key: "access_token",
            value: this._map._requestManager._customAccessToken || e.db.ACCESS_TOKEN
          }];
          if (t) {
            var _o285 = i.reduce(function (e, t, o) {
              return t.value && (e += "".concat(t.key, "=").concat(t.value).concat(o < i.length - 1 ? "&" : "")), e;
            }, "?");
            t.href = "".concat(e.db.FEEDBACK_URL, "/").concat(_o285, "#").concat(Ra(this._map, !0)), t.rel = "noopener nofollow";
          }
        }
      }, {
        key: "_updateData",
        value: function _updateData(e) {
          !e || "metadata" !== e.sourceDataType && "visibility" !== e.sourceDataType && "style" !== e.dataType || (this._updateAttributions(), this._updateEditLink());
        }
      }, {
        key: "_updateAttributions",
        value: function _updateAttributions() {
          if (!this._map.style) return;
          var e = [];
          if (this._map.style.stylesheet) {
            var _e723 = this._map.style.stylesheet;
            this.styleOwner = _e723.owner, this.styleId = _e723.id;
          }
          var t = this._map.style._mergedSourceCaches;
          for (var _i508 in t) {
            var _o286 = t[_i508];
            if (_o286.used) {
              var _t673 = _o286.getSource();
              _t673.attribution && e.indexOf(_t673.attribution) < 0 && e.push(_t673.attribution);
            }
          }
          e.sort(function (e, t) {
            return e.length - t.length;
          }), e = e.filter(function (t, i) {
            for (var _o287 = i + 1; _o287 < e.length; _o287++) if (e[_o287].indexOf(t) >= 0) return !1;
            return !0;
          }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e = [].concat(_toConsumableArray(this.options.customAttribution), _toConsumableArray(e)) : e.unshift(this.options.customAttribution));
          var i = e.join(" | ");
          i !== this._attribHTML && (this._attribHTML = i, e.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
        }
      }, {
        key: "_updateCompact",
        value: function _updateCompact() {
          this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
        }
      }]);
      return Pn;
    }();
    var Rn = /*#__PURE__*/function () {
      function Rn() {
        _classCallCheck(this, Rn);
        e.br(["_updateLogo", "_updateCompact"], this);
      }
      _createClass(Rn, [{
        key: "onAdd",
        value: function onAdd(e) {
          this._map = e, this._container = r("div", "mapboxgl-ctrl");
          var t = r("a", "mapboxgl-ctrl-logo");
          return t.target = "_blank", t.rel = "noopener nofollow", t.href = "https://www.mapbox.com/", t.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
        }
      }, {
        key: "onRemove",
        value: function onRemove() {
          this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
        }
      }, {
        key: "getDefaultPosition",
        value: function getDefaultPosition() {
          return "bottom-left";
        }
      }, {
        key: "_updateLogo",
        value: function _updateLogo(e) {
          e && "metadata" !== e.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
        }
      }, {
        key: "_logoRequired",
        value: function _logoRequired() {
          if (!this._map.style) return !0;
          var e = this._map.style._sourceCaches;
          if (0 === Object.entries(e).length) return !0;
          for (var _t674 in e) {
            var _i509 = e[_t674].getSource();
            if (_i509.hasOwnProperty("mapbox_logo") && !_i509.mapbox_logo) return !1;
          }
          return !0;
        }
      }, {
        key: "_updateCompact",
        value: function _updateCompact() {
          var e = this._container.children;
          if (e.length) {
            var _t675 = e[0];
            this._map.getCanvasContainer().offsetWidth < 250 ? _t675.classList.add("mapboxgl-compact") : _t675.classList.remove("mapboxgl-compact");
          }
        }
      }]);
      return Rn;
    }();
    var Dn = /*#__PURE__*/function () {
      function Dn() {
        _classCallCheck(this, Dn);
        this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
      }
      _createClass(Dn, [{
        key: "add",
        value: function add(e) {
          var t = ++this._id;
          return this._queue.push({
            callback: e,
            id: t,
            cancelled: !1
          }), t;
        }
      }, {
        key: "remove",
        value: function remove(e) {
          var t = this._currentlyRunning,
            i = t ? this._queue.concat(t) : this._queue;
          var _iterator482 = _createForOfIteratorHelper(i),
            _step482;
          try {
            for (_iterator482.s(); !(_step482 = _iterator482.n()).done;) {
              var _t676 = _step482.value;
              if (_t676.id === e) return void (_t676.cancelled = !0);
            }
          } catch (err) {
            _iterator482.e(err);
          } finally {
            _iterator482.f();
          }
        }
      }, {
        key: "run",
        value: function run() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          var t = this._currentlyRunning = this._queue;
          this._queue = [];
          var _iterator483 = _createForOfIteratorHelper(t),
            _step483;
          try {
            for (_iterator483.s(); !(_step483 = _iterator483.n()).done;) {
              var _i510 = _step483.value;
              if (!_i510.cancelled && (_i510.callback(e), this._cleared)) break;
            }
          } catch (err) {
            _iterator483.e(err);
          } finally {
            _iterator483.f();
          }
          this._cleared = !1, this._currentlyRunning = !1;
        }
      }, {
        key: "clear",
        value: function clear() {
          this._currentlyRunning && (this._cleared = !0), this._queue = [];
        }
      }]);
      return Dn;
    }();
    function An(t, i, o) {
      if (t = new e.aJ(t.lng, t.lat), i) {
        var _r469 = new e.aJ(t.lng - 360, t.lat),
          _a258 = new e.aJ(t.lng + 360, t.lat),
          _n321 = 360 * Math.ceil(Math.abs(t.lng - o.center.lng) / 360),
          _s261 = o.locationPoint(t).distSqr(i),
          _l142 = i.x < 0 || i.y < 0 || i.x > o.width || i.y > o.height;
        o.locationPoint(_r469).distSqr(i) < _s261 && (_l142 || Math.abs(_r469.lng - o.center.lng) < _n321) ? t = _r469 : o.locationPoint(_a258).distSqr(i) < _s261 && (_l142 || Math.abs(_a258.lng - o.center.lng) < _n321) && (t = _a258);
      }
      for (; Math.abs(t.lng - o.center.lng) > 180;) {
        var _e724 = o.locationPoint(t);
        if (_e724.x >= 0 && _e724.y >= 0 && _e724.x <= o.width && _e724.y <= o.height) break;
        t.lng > o.center.lng ? t.lng -= 360 : t.lng += 360;
      }
      return t;
    }
    var Mn = {
      center: "translate(-50%,-50%)",
      top: "translate(-50%,0)",
      "top-left": "translate(0,0)",
      "top-right": "translate(-100%,0)",
      bottom: "translate(-50%,-100%)",
      "bottom-left": "translate(0,-100%)",
      "bottom-right": "translate(-100%,-100%)",
      left: "translate(0,-50%)",
      right: "translate(-100%,-50%)"
    };
    var zn = /*#__PURE__*/function (_e$E16) {
      _inherits(zn, _e$E16);
      var _super167 = _createSuper(zn);
      function zn(t, i) {
        var _this183;
        _classCallCheck(this, zn);
        if (_this183 = _super167.call(this), (t instanceof HTMLElement || i) && (t = e.Q({
          element: t
        }, i)), e.br(["_update", "_onMove", "_onUp", "_addDragHandler", "_onMapClick", "_onKeyPress", "_clearFadeTimer"], _assertThisInitialized(_this183)), _this183._anchor = t && t.anchor || "center", _this183._color = t && t.color || "#3FB1CE", _this183._scale = t && t.scale || 1, _this183._draggable = t && t.draggable || !1, _this183._clickTolerance = t && t.clickTolerance || 0, _this183._isDragging = !1, _this183._state = "inactive", _this183._rotation = t && t.rotation || 0, _this183._rotationAlignment = t && t.rotationAlignment || "auto", _this183._pitchAlignment = t && t.pitchAlignment && t.pitchAlignment || "auto", _this183._updateMoving = function () {
          return _this183._update(!0);
        }, _this183._occludedOpacity = t && t.occludedOpacity || .2, t && t.element) _this183._element = t.element, _this183._offset = e.P.convert(t && t.offset || [0, 0]);else {
          _this183._defaultMarker = !0, _this183._element = r("div");
          var _i511 = 41,
            _o288 = 27,
            _n322 = a("svg", {
              display: "block",
              height: _i511 * _this183._scale + "px",
              width: _o288 * _this183._scale + "px",
              viewBox: "0 0 ".concat(_o288, " ").concat(_i511)
            }, _this183._element),
            _s262 = a("radialGradient", {
              id: "shadowGradient"
            }, a("defs", {}, _n322));
          a("stop", {
            offset: "10%",
            "stop-opacity": .4
          }, _s262), a("stop", {
            offset: "100%",
            "stop-opacity": .05
          }, _s262), a("ellipse", {
            cx: 13.5,
            cy: 34.8,
            rx: 10.5,
            ry: 5.25,
            fill: "url(#shadowGradient)"
          }, _n322), a("path", {
            fill: _this183._color,
            d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"
          }, _n322), a("path", {
            opacity: .25,
            d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"
          }, _n322), a("circle", {
            fill: "white",
            cx: 13.5,
            cy: 13.5,
            r: 5.5
          }, _n322), _this183._offset = e.P.convert(t && t.offset || [0, -14]);
        }
        _this183._element.hasAttribute("aria-label") || _this183._element.setAttribute("aria-label", "Map marker"), _this183._element.hasAttribute("role") || _this183._element.setAttribute("role", "img"), _this183._element.classList.add("mapboxgl-marker"), _this183._element.addEventListener("dragstart", function (e) {
          e.preventDefault();
        }), _this183._element.addEventListener("mousedown", function (e) {
          e.preventDefault();
        });
        var o = _this183._element.classList;
        for (var _e725 in Mn) o.remove("mapboxgl-marker-anchor-".concat(_e725));
        o.add("mapboxgl-marker-anchor-".concat(_this183._anchor));
        var n = t && t.className ? t.className.trim().split(/\s+/) : [];
        o.add.apply(o, _toConsumableArray(n)), _this183._popup = null;
        return _possibleConstructorReturn(_this183);
      }
      _createClass(zn, [{
        key: "addTo",
        value: function addTo(e) {
          return e === this._map || (this.remove(), this._map = e, e.getCanvasContainer().appendChild(this._element), e.on("move", this._updateMoving), e.on("moveend", this._update), e.on("remove", this._clearFadeTimer), e._addMarker(this), this.setDraggable(this._draggable), this._update(), e.on("click", this._onMapClick)), this;
        }
      }, {
        key: "remove",
        value: function remove() {
          var e = this._map;
          return e && (e.off("click", this._onMapClick), e.off("move", this._updateMoving), e.off("moveend", this._update), e.off("mousedown", this._addDragHandler), e.off("touchstart", this._addDragHandler), e.off("mouseup", this._onUp), e.off("touchend", this._onUp), e.off("mousemove", this._onMove), e.off("touchmove", this._onMove), e.off("remove", this._clearFadeTimer), e._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
        }
      }, {
        key: "getLngLat",
        value: function getLngLat() {
          return this._lngLat;
        }
      }, {
        key: "setLngLat",
        value: function setLngLat(t) {
          return this._lngLat = e.aJ.convert(t), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
        }
      }, {
        key: "getElement",
        value: function getElement() {
          return this._element;
        }
      }, {
        key: "setPopup",
        value: function setPopup(e) {
          if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e) {
            if (!("offset" in e.options)) {
              var _t677 = 38.1,
                _i512 = 13.5,
                _o289 = Math.sqrt(Math.pow(_i512, 2) / 2);
              e.options.offset = this._defaultMarker ? {
                top: [0, 0],
                "top-left": [0, 0],
                "top-right": [0, 0],
                bottom: [0, -_t677],
                "bottom-left": [_o289, -1 * (_t677 - _i512 + _o289)],
                "bottom-right": [-_o289, -1 * (_t677 - _i512 + _o289)],
                left: [_i512, -1 * (_t677 - _i512)],
                right: [-_i512, -1 * (_t677 - _i512)]
              } : this._offset;
            }
            this._popup = e, e._marker = this, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
          }
          return this;
        }
      }, {
        key: "_onKeyPress",
        value: function _onKeyPress(e) {
          var t = e.code,
            i = e.charCode || e.keyCode;
          "Space" !== t && "Enter" !== t && 32 !== i && 13 !== i || this.togglePopup();
        }
      }, {
        key: "_onMapClick",
        value: function _onMapClick(e) {
          var t = e.originalEvent.target,
            i = this._element;
          this._popup && (t === i || i.contains(t)) && this.togglePopup();
        }
      }, {
        key: "getPopup",
        value: function getPopup() {
          return this._popup;
        }
      }, {
        key: "togglePopup",
        value: function togglePopup() {
          var e = this._popup;
          return e ? (e.isOpen() ? (e.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
        }
      }, {
        key: "_behindTerrain",
        value: function _behindTerrain() {
          var e = this._map,
            t = this._pos;
          if (!e || !t) return !1;
          var i = e.unproject(t),
            o = e.getFreeCameraOptions();
          if (!o.position) return !1;
          var r = o.position.toLngLat();
          return r.distanceTo(i) < .9 * r.distanceTo(this._lngLat);
        }
      }, {
        key: "_evaluateOpacity",
        value: function _evaluateOpacity() {
          var t = this._map;
          if (!t) return;
          var i = this._pos;
          if (!i || i.x < 0 || i.x > t.transform.width || i.y < 0 || i.y > t.transform.height) return void this._clearFadeTimer();
          var o = t.unproject(i);
          var r;
          t._showingGlobe() && e.dc(t.transform, this._lngLat) ? r = 0 : (r = 1 - t._queryFogOpacity(o), t.transform._terrainEnabled() && t.getTerrain() && this._behindTerrain() && (r *= this._occludedOpacity)), this._element.style.opacity = "".concat(r), this._element.style.pointerEvents = r > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(r), this._fadeTimer = null;
        }
      }, {
        key: "_clearFadeTimer",
        value: function _clearFadeTimer() {
          this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
        }
      }, {
        key: "_updateDOM",
        value: function _updateDOM() {
          var e = this._pos;
          if (!e || !this._map) return;
          var t = this._offset.mult(this._scale);
          this._element.style.transform = "\n            translate(".concat(e.x, "px,").concat(e.y, "px)\n            ").concat(Mn[this._anchor], "\n            ").concat(this._calculateXYTransform(), " ").concat(this._calculateZTransform(), "\n            translate(").concat(t.x, "px,").concat(t.y, "px)\n        ");
        }
      }, {
        key: "_calculateXYTransform",
        value: function _calculateXYTransform() {
          var t = this._pos,
            i = this._map,
            o = this.getPitchAlignment();
          if (!i || !t || "map" !== o) return "";
          if (!i._showingGlobe()) {
            var _e726 = i.getPitch();
            return _e726 ? "rotateX(".concat(_e726, "deg)") : "";
          }
          var r = e.b1(e.dd(i.transform, this._lngLat)),
            a = t.sub(e.de(i.transform)),
            n = Math.abs(a.x) + Math.abs(a.y);
          if (0 === n) return "";
          var s = r / n;
          return "rotateX(".concat(-a.y * s, "deg) rotateY(").concat(a.x * s, "deg)");
        }
      }, {
        key: "_calculateZTransform",
        value: function _calculateZTransform() {
          var t = this._pos,
            i = this._map;
          if (!i || !t) return "";
          var o = 0;
          var r = this.getRotationAlignment();
          if ("map" === r) {
            if (i._showingGlobe()) {
              var _t678 = i.project(new e.aJ(this._lngLat.lng, this._lngLat.lat + .001)),
                _r470 = i.project(new e.aJ(this._lngLat.lng, this._lngLat.lat - .001)).sub(_t678);
              o = e.b1(Math.atan2(_r470.y, _r470.x)) - 90;
            } else o = -i.getBearing();
          } else if ("horizon" === r) {
            var _r471 = e.a0(4, 6, i.getZoom()),
              _a259 = e.de(i.transform);
            _a259.y += _r471 * i.transform.height;
            var _n323 = t.sub(_a259),
              _s263 = e.b1(Math.atan2(_n323.y, _n323.x));
            o = (_s263 > 90 ? _s263 - 270 : _s263 + 90) * (1 - _r471);
          }
          return o += this._rotation, o ? "rotateZ(".concat(o, "deg)") : "";
        }
      }, {
        key: "_update",
        value: function _update(e) {
          var _this184 = this;
          cancelAnimationFrame(this._updateFrameId);
          var t = this._map;
          t && (t.transform.renderWorldCopies && (this._lngLat = An(this._lngLat, this._pos, t.transform)), this._pos = t.project(this._lngLat), !0 === e ? this._updateFrameId = requestAnimationFrame(function () {
            _this184._element && _this184._pos && _this184._anchor && (_this184._pos = _this184._pos.round(), _this184._updateDOM());
          }) : this._pos = this._pos.round(), t._requestDomTask(function () {
            _this184._map && (_this184._element && _this184._pos && _this184._anchor && _this184._updateDOM(), (t._showingGlobe() || t.getTerrain() || t.getFog()) && !_this184._fadeTimer && (_this184._fadeTimer = window.setTimeout(_this184._evaluateOpacity.bind(_this184), 60)));
          }));
        }
      }, {
        key: "getOffset",
        value: function getOffset() {
          return this._offset;
        }
      }, {
        key: "setOffset",
        value: function setOffset(t) {
          return this._offset = e.P.convert(t), this._update(), this;
        }
      }, {
        key: "addClassName",
        value: function addClassName(e) {
          return this._element.classList.add(e), this;
        }
      }, {
        key: "removeClassName",
        value: function removeClassName(e) {
          return this._element.classList.remove(e), this;
        }
      }, {
        key: "toggleClassName",
        value: function toggleClassName(e) {
          return this._element.classList.toggle(e);
        }
      }, {
        key: "_onMove",
        value: function _onMove(t) {
          var i = this._map;
          if (!i) return;
          var o = this._pointerdownPos,
            r = this._positionDelta;
          if (o && r) {
            if (!this._isDragging) {
              var _e727 = this._clickTolerance || i._clickTolerance;
              if (t.point.dist(o) < _e727) return;
              this._isDragging = !0;
            }
            this._pos = t.point.sub(r), this._lngLat = i.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e.g("dragstart"))), this.fire(new e.g("drag"));
          }
        }
      }, {
        key: "_onUp",
        value: function _onUp() {
          this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
          var t = this._map;
          t && (t.off("mousemove", this._onMove), t.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e.g("dragend")), this._state = "inactive";
        }
      }, {
        key: "_addDragHandler",
        value: function _addDragHandler(e) {
          var t = this._map,
            i = this._pos;
          t && i && this._element.contains(e.originalEvent.target) && (e.preventDefault(), this._positionDelta = e.point.sub(i), this._pointerdownPos = e.point, this._state = "pending", t.on("mousemove", this._onMove), t.on("touchmove", this._onMove), t.once("mouseup", this._onUp), t.once("touchend", this._onUp));
        }
      }, {
        key: "setDraggable",
        value: function setDraggable(e) {
          this._draggable = !!e;
          var t = this._map;
          return t && (e ? (t.on("mousedown", this._addDragHandler), t.on("touchstart", this._addDragHandler)) : (t.off("mousedown", this._addDragHandler), t.off("touchstart", this._addDragHandler))), this;
        }
      }, {
        key: "isDraggable",
        value: function isDraggable() {
          return this._draggable;
        }
      }, {
        key: "setRotation",
        value: function setRotation(e) {
          return this._rotation = e || 0, this._update(), this;
        }
      }, {
        key: "getRotation",
        value: function getRotation() {
          return this._rotation;
        }
      }, {
        key: "setRotationAlignment",
        value: function setRotationAlignment(e) {
          return this._rotationAlignment = e || "auto", this._update(), this;
        }
      }, {
        key: "getRotationAlignment",
        value: function getRotationAlignment() {
          return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
        }
      }, {
        key: "setPitchAlignment",
        value: function setPitchAlignment(e) {
          return this._pitchAlignment = e || "auto", this._update(), this;
        }
      }, {
        key: "getPitchAlignment",
        value: function getPitchAlignment() {
          return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
        }
      }, {
        key: "setOccludedOpacity",
        value: function setOccludedOpacity(e) {
          return this._occludedOpacity = e || .2, this._update(), this;
        }
      }, {
        key: "getOccludedOpacity",
        value: function getOccludedOpacity() {
          return this._occludedOpacity;
        }
      }]);
      return zn;
    }(e.E);
    var On = {
        closeButton: !0,
        closeOnClick: !0,
        focusAfterOpen: !0,
        className: "",
        maxWidth: "240px"
      },
      Fn = ["a[href]", "[tabindex]:not([tabindex='-1'])", "[contenteditable]:not([contenteditable='false'])", "button:not([disabled])", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].join(", ");
    function Bn() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new e.P(0, 0);
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "bottom";
      if ("number" == typeof t) {
        var _o290 = Math.round(Math.sqrt(.5 * Math.pow(t, 2)));
        switch (i) {
          case "top":
            return new e.P(0, t);
          case "top-left":
            return new e.P(_o290, _o290);
          case "top-right":
            return new e.P(-_o290, _o290);
          case "bottom":
            return new e.P(0, -t);
          case "bottom-left":
            return new e.P(_o290, -_o290);
          case "bottom-right":
            return new e.P(-_o290, -_o290);
          case "left":
            return new e.P(t, 0);
          case "right":
            return new e.P(-t, 0);
        }
        return new e.P(0, 0);
      }
      return t instanceof e.P || Array.isArray(t) ? e.P.convert(t) : e.P.convert(t[i] || [0, 0]);
    }
    var kn = /*#__PURE__*/function () {
      function kn(e) {
        _classCallCheck(this, kn);
        this.jumpTo(e);
      }
      _createClass(kn, [{
        key: "getValue",
        value: function getValue(t) {
          if (t <= this._startTime) return this._start;
          if (t >= this._endTime) return this._end;
          var i = e.bb((t - this._startTime) / (this._endTime - this._startTime));
          return this._start * (1 - i) + this._end * i;
        }
      }, {
        key: "isEasing",
        value: function isEasing(e) {
          return e >= this._startTime && e <= this._endTime;
        }
      }, {
        key: "jumpTo",
        value: function jumpTo(e) {
          this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e, this._end = e;
        }
      }, {
        key: "easeTo",
        value: function easeTo(e, t, i) {
          this._start = this.getValue(t), this._end = e, this._startTime = t, this._endTime = t + i;
        }
      }]);
      return kn;
    }();
    var Nn = {
      "AttributionControl.ToggleAttribution": "Toggle attribution",
      "FullscreenControl.Enter": "Enter fullscreen",
      "FullscreenControl.Exit": "Exit fullscreen",
      "GeolocateControl.FindMyLocation": "Find my location",
      "GeolocateControl.LocationNotAvailable": "Location not available",
      "LogoControl.Title": "Mapbox homepage",
      "Map.Title": "Map",
      "NavigationControl.ResetBearing": "Reset bearing to north",
      "NavigationControl.ZoomIn": "Zoom in",
      "NavigationControl.ZoomOut": "Zoom out",
      "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map",
      "ScrollZoomBlocker.CmdMessage": "Use ⌘ + scroll to zoom the map",
      "TouchPanBlocker.Message": "Use two fingers to move the map"
    };
    var Un = /*#__PURE__*/function () {
      function Un() {
        _classCallCheck(this, Un);
      }
      _createClass(Un, [{
        key: "registerParameter",
        value: function registerParameter() {}
      }, {
        key: "registerButton",
        value: function registerButton() {}
      }, {
        key: "registerBinding",
        value: function registerBinding() {}
      }, {
        key: "refreshUI",
        value: function refreshUI() {}
      }]);
      return Un;
    }();
    var Gn = {
        center: [0, 0],
        zoom: 0,
        bearing: 0,
        pitch: 0,
        minZoom: -2,
        maxZoom: 22,
        minPitch: 0,
        maxPitch: 85,
        interactive: !0,
        scrollZoom: !0,
        boxZoom: !0,
        dragRotate: !0,
        dragPan: !0,
        keyboard: !0,
        doubleClickZoom: !0,
        touchZoomRotate: !0,
        touchPitch: !0,
        cooperativeGestures: !1,
        performanceMetricsCollection: !0,
        bearingSnap: 7,
        clickTolerance: 3,
        pitchWithRotate: !0,
        hash: !1,
        attributionControl: !0,
        antialias: !1,
        failIfMajorPerformanceCaveat: !1,
        preserveDrawingBuffer: !1,
        trackResize: !0,
        renderWorldCopies: !0,
        refreshExpiredTiles: !0,
        minTileCacheSize: null,
        maxTileCacheSize: null,
        localIdeographFontFamily: "sans-serif",
        localFontFamily: null,
        transformRequest: null,
        accessToken: null,
        fadeDuration: 300,
        respectPrefersReducedMotion: !0,
        crossSourceCollisions: !0,
        collectResourceTiming: !1,
        testMode: !1,
        precompilePrograms: !0
      },
      jn = {
        showCompass: !0,
        showZoom: !0,
        visualizePitch: !1
      };
    var Vn = /*#__PURE__*/function () {
      function Vn(t, i) {
        var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        _classCallCheck(this, Vn);
        this._clickTolerance = 10, this.element = i, this.mouseRotate = new Ja({
          clickTolerance: t.dragRotate._mouseRotate._clickTolerance
        }), this.map = t, o && (this.mousePitch = new Ka({
          clickTolerance: t.dragRotate._mousePitch._clickTolerance
        })), e.br(["mousedown", "mousemove", "mouseup", "touchstart", "touchmove", "touchend", "reset"], this), i.addEventListener("mousedown", this.mousedown), i.addEventListener("touchstart", this.touchstart, {
          passive: !1
        }), i.addEventListener("touchmove", this.touchmove), i.addEventListener("touchend", this.touchend), i.addEventListener("touchcancel", this.reset);
      }
      _createClass(Vn, [{
        key: "down",
        value: function down(e, t) {
          this.mouseRotate.mousedown(e, t), this.mousePitch && this.mousePitch.mousedown(e, t), c();
        }
      }, {
        key: "move",
        value: function move(e, t) {
          var i = this.map,
            o = this.mouseRotate.mousemoveWindow(e, t),
            r = o && o.bearingDelta;
          if (r && i.setBearing(i.getBearing() + r), this.mousePitch) {
            var _o291 = this.mousePitch.mousemoveWindow(e, t),
              _r472 = _o291 && _o291.pitchDelta;
            _r472 && i.setPitch(i.getPitch() + _r472);
          }
        }
      }, {
        key: "off",
        value: function off() {
          var e = this.element;
          e.removeEventListener("mousedown", this.mousedown), e.removeEventListener("touchstart", this.touchstart, {
            passive: !1
          }), e.removeEventListener("touchmove", this.touchmove), e.removeEventListener("touchend", this.touchend), e.removeEventListener("touchcancel", this.reset), this.offTemp();
        }
      }, {
        key: "offTemp",
        value: function offTemp() {
          h(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup);
        }
      }, {
        key: "mousedown",
        value: function mousedown(t) {
          this.down(e.Q({}, t, {
            ctrlKey: !0,
            preventDefault: function preventDefault() {
              return t.preventDefault();
            }
          }), d(this.element, t)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
        }
      }, {
        key: "mousemove",
        value: function mousemove(e) {
          this.move(e, d(this.element, e));
        }
      }, {
        key: "mouseup",
        value: function mouseup(e) {
          this.mouseRotate.mouseupWindow(e), this.mousePitch && this.mousePitch.mouseupWindow(e), this.offTemp();
        }
      }, {
        key: "touchstart",
        value: function touchstart(e) {
          1 !== e.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = p(this.element, e.targetTouches)[0], this.down({
            type: "mousedown",
            button: 0,
            ctrlKey: !0,
            preventDefault: function preventDefault() {
              return e.preventDefault();
            }
          }, this._startPos));
        }
      }, {
        key: "touchmove",
        value: function touchmove(e) {
          1 !== e.targetTouches.length ? this.reset() : (this._lastPos = p(this.element, e.targetTouches)[0], this.move({
            preventDefault: function preventDefault() {
              return e.preventDefault();
            }
          }, this._lastPos));
        }
      }, {
        key: "touchend",
        value: function touchend(e) {
          0 === e.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
        }
      }, {
        key: "reset",
        value: function reset() {
          this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
        }
      }]);
      return Vn;
    }();
    var $n = {
        positionOptions: {
          enableHighAccuracy: !1,
          maximumAge: 0,
          timeout: 6e3
        },
        fitBoundsOptions: {
          maxZoom: 15
        },
        trackUserLocation: !1,
        showAccuracyCircle: !0,
        showUserLocation: !0,
        showUserHeading: !1
      },
      Zn = {
        maxWidth: 100,
        unit: "metric"
      },
      Wn = {
        kilometer: "km",
        meter: "m",
        mile: "mi",
        foot: "ft",
        "nautical-mile": "nm"
      },
      Hn = {
        version: e.dw,
        supported: t,
        setRTLTextPlugin: e.dy,
        getRTLTextPluginStatus: e.dz,
        Map: /*#__PURE__*/function (_Ln) {
          _inherits(Map, _Ln);
          var _super168 = _createSuper(Map);
          function Map(t) {
            var _this185;
            _classCallCheck(this, Map);
            e.df.mark(e.dg.create);
            var i = t;
            if (null != (t = e.Q({}, Gn, t)).minZoom && null != t.maxZoom && t.minZoom > t.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
            if (null != t.minPitch && null != t.maxPitch && t.minPitch > t.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
            if (null != t.minPitch && t.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
            if (null != t.maxPitch && t.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
            if (t.antialias && e.dh(window) && (t.antialias = !1, e.w("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), _this185 = _super168.call(this, new hi(t.minZoom, t.maxZoom, t.minPitch, t.maxPitch, t.renderWorldCopies), t), _this185._repaint = !!t.repaint, _this185._interactive = t.interactive, _this185._minTileCacheSize = t.minTileCacheSize, _this185._maxTileCacheSize = t.maxTileCacheSize, _this185._failIfMajorPerformanceCaveat = t.failIfMajorPerformanceCaveat, _this185._preserveDrawingBuffer = t.preserveDrawingBuffer, _this185._antialias = t.antialias, _this185._trackResize = t.trackResize, _this185._bearingSnap = t.bearingSnap, _this185._refreshExpiredTiles = t.refreshExpiredTiles, _this185._fadeDuration = t.fadeDuration, _this185._isInitialLoad = !0, _this185._crossSourceCollisions = t.crossSourceCollisions, _this185._collectResourceTiming = t.collectResourceTiming, _this185._language = _this185._parseLanguage(t.language), _this185._worldview = t.worldview, _this185._renderTaskQueue = new Dn(), _this185._domRenderTaskQueue = new Dn(), _this185._controls = [], _this185._markers = [], _this185._popups = [], _this185._mapId = e.di(), _this185._locale = e.Q({}, Nn, t.locale), _this185._clickTolerance = t.clickTolerance, _this185._cooperativeGestures = t.cooperativeGestures, _this185._performanceMetricsCollection = t.performanceMetricsCollection, _this185._tessellationStep = t.tessellationStep, _this185._containerWidth = 0, _this185._containerHeight = 0, _this185._showParseStatus = !0, _this185._precompilePrograms = t.precompilePrograms, _this185._averageElevationLastSampledAt = -1 / 0, _this185._averageElevationExaggeration = 0, _this185._averageElevation = new kn(0), _this185._interactionRange = [1 / 0, -1 / 0], _this185._visibilityHidden = 0, _this185._useExplicitProjection = !1, _this185._frameId = 0, _this185._requestManager = new e.dj(t.transformRequest, t.accessToken, t.testMode), _this185._silenceAuthErrors = !!t.testMode, _this185._contextCreateOptions = t.contextCreateOptions ? _objectSpread({}, t.contextCreateOptions) : {}, "string" == typeof t.container) {
              var _e728 = document.getElementById(t.container);
              if (!_e728) throw new Error("Container '".concat(t.container.toString(), "' not found."));
              _this185._container = _e728;
            } else {
              if (!(t.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
              _this185._container = t.container;
            }
            if (_this185._container.childNodes.length > 0 && e.w("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t.maxBounds && _this185.setMaxBounds(t.maxBounds), e.br(["_onWindowOnline", "_onWindowResize", "_onVisibilityChange", "_onMapScroll", "_contextLost", "_contextRestored"], _assertThisInitialized(_this185)), _this185._setupContainer(), _this185._tp || (_this185._tp = new Un()), _this185._tp.registerParameter(_assertThisInitialized(_this185), ["Debug"], "showOverdrawInspector"), _this185._tp.registerParameter(_assertThisInitialized(_this185), ["Debug"], "showTileBoundaries"), _this185._tp.registerParameter(_assertThisInitialized(_this185), ["Debug"], "showParseStatus"), _this185._tp.registerParameter(_assertThisInitialized(_this185), ["Debug"], "repaint"), _this185._tp.registerParameter(_assertThisInitialized(_this185), ["Debug"], "showTileAABBs"), _this185._tp.registerParameter(_assertThisInitialized(_this185), ["Debug"], "showPadding"), _this185._tp.registerParameter(_assertThisInitialized(_this185), ["Debug"], "showCollisionBoxes", {
              noSave: !0
            }), _this185._tp.registerParameter(_this185.transform, ["Debug"], "freezeTileCoverage", {
              noSave: !0
            }, function () {
              _this185._update();
            }), _this185._tp.registerParameter(_assertThisInitialized(_this185), ["Debug", "Wireframe"], "showTerrainWireframe"), _this185._tp.registerParameter(_assertThisInitialized(_this185), ["Debug", "Wireframe"], "showLayers2DWireframe"), _this185._tp.registerParameter(_assertThisInitialized(_this185), ["Debug", "Wireframe"], "showLayers3DWireframe"), _this185._setupPainter(), void 0 === _this185.painter) throw new Error("Failed to initialize WebGL.");
            if (_this185.on("move", function () {
              return _this185._update(!1);
            }), _this185.on("moveend", function () {
              return _this185._update(!1);
            }), _this185.on("zoom", function () {
              return _this185._update(!0);
            }), _this185._fullscreenchangeEvent = "onfullscreenchange" in document ? "fullscreenchange" : "webkitfullscreenchange", window.addEventListener("online", _this185._onWindowOnline, !1), window.addEventListener("resize", _this185._onWindowResize, !1), window.addEventListener("orientationchange", _this185._onWindowResize, !1), window.addEventListener(_this185._fullscreenchangeEvent, _this185._onWindowResize, !1), window.addEventListener("visibilitychange", _this185._onVisibilityChange, !1), _this185.handlers = new Sn(_assertThisInitialized(_this185), t), _this185._localFontFamily = t.localFontFamily, _this185._localIdeographFontFamily = t.localIdeographFontFamily, (t.style || !t.testMode) && _this185.setStyle(t.style || e.db.DEFAULT_STYLE, {
              config: t.config,
              localFontFamily: _this185._localFontFamily,
              localIdeographFontFamily: _this185._localIdeographFontFamily
            }), t.projection && _this185.setProjection(t.projection), t.hash && (_this185._hash = new Pa("string" == typeof t.hash && t.hash || void 0).addTo(_assertThisInitialized(_this185))), !_this185._hash || !_this185._hash._onHashChange()) {
              null == i.center && null == i.zoom || (_this185.transform._unmodified = !1), _this185.jumpTo({
                center: t.center,
                zoom: t.zoom,
                bearing: t.bearing,
                pitch: t.pitch
              });
              var _o292 = t.bounds;
              _o292 && (_this185.resize(), _this185.fitBounds(_o292, e.Q({}, t.fitBoundsOptions, {
                duration: 0
              })));
            }
            _this185.resize(), t.attributionControl && _this185.addControl(new Pn({
              customAttribution: t.customAttribution
            })), _this185._logoControl = new Rn(), _this185.addControl(_this185._logoControl, t.logoPosition), _this185.on("style.load", function () {
              _this185.transform.unmodified && _this185.jumpTo(_this185.style.stylesheet), _this185._postStyleLoadEvent();
            }), _this185.on("data", function (t) {
              _this185._update("style" === t.dataType), _this185.fire(new e.g("".concat(t.dataType, "data"), t));
            }), _this185.on("dataloading", function (t) {
              _this185.fire(new e.g("".concat(t.dataType, "dataloading"), t));
            });
            return _possibleConstructorReturn(_this185);
          }
          _createClass(Map, [{
            key: "_getMapId",
            value: function _getMapId() {
              return this._mapId;
            }
          }, {
            key: "addControl",
            value: function addControl(t, i) {
              if (void 0 === i && (i = t.getDefaultPosition ? t.getDefaultPosition() : "top-right"), !t || !t.onAdd) return this.fire(new e.f(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
              var o = t.onAdd(this);
              this._controls.push(t);
              var r = this._controlPositions[i];
              return -1 !== i.indexOf("bottom") ? r.insertBefore(o, r.firstChild) : r.appendChild(o), this;
            }
          }, {
            key: "removeControl",
            value: function removeControl(t) {
              if (!t || !t.onRemove) return this.fire(new e.f(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
              var i = this._controls.indexOf(t);
              return i > -1 && this._controls.splice(i, 1), t.onRemove(this), this;
            }
          }, {
            key: "hasControl",
            value: function hasControl(e) {
              return this._controls.indexOf(e) > -1;
            }
          }, {
            key: "getContainer",
            value: function getContainer() {
              return this._container;
            }
          }, {
            key: "getCanvasContainer",
            value: function getCanvasContainer() {
              return this._canvasContainer;
            }
          }, {
            key: "getCanvas",
            value: function getCanvas() {
              return this._canvas;
            }
          }, {
            key: "resize",
            value: function resize(t) {
              if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
              this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
              var i = !this._moving;
              return i && this.fire(new e.g("movestart", t)).fire(new e.g("move", t)), this.fire(new e.g("resize", t)), i && this.fire(new e.g("moveend", t)), this;
            }
          }, {
            key: "getBounds",
            value: function getBounds() {
              return this.transform.getBounds();
            }
          }, {
            key: "getMaxBounds",
            value: function getMaxBounds() {
              return this.transform.getMaxBounds() || null;
            }
          }, {
            key: "setMaxBounds",
            value: function setMaxBounds(t) {
              return this.transform.setMaxBounds(e.aj.convert(t)), this._update();
            }
          }, {
            key: "setMinZoom",
            value: function setMinZoom(t) {
              var _t679;
              if ((t = (_t679 = t) !== null && _t679 !== void 0 ? _t679 : -2) >= -2 && t <= this.transform.maxZoom) return this.transform.minZoom = t, this._update(), this.getZoom() < t ? this.setZoom(t) : this.fire(new e.g("zoomstart")).fire(new e.g("zoom")).fire(new e.g("zoomend")), this;
              throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
            }
          }, {
            key: "getMinZoom",
            value: function getMinZoom() {
              return this.transform.minZoom;
            }
          }, {
            key: "setMaxZoom",
            value: function setMaxZoom(t) {
              var _t680;
              if ((t = (_t680 = t) !== null && _t680 !== void 0 ? _t680 : 22) >= this.transform.minZoom) return this.transform.maxZoom = t, this._update(), this.getZoom() > t ? this.setZoom(t) : this.fire(new e.g("zoomstart")).fire(new e.g("zoom")).fire(new e.g("zoomend")), this;
              throw new Error("maxZoom must be greater than the current minZoom");
            }
          }, {
            key: "getMaxZoom",
            value: function getMaxZoom() {
              return this.transform.maxZoom;
            }
          }, {
            key: "setMinPitch",
            value: function setMinPitch(t) {
              var _t681;
              if ((t = (_t681 = t) !== null && _t681 !== void 0 ? _t681 : 0) < 0) throw new Error("minPitch must be greater than or equal to 0");
              if (t >= 0 && t <= this.transform.maxPitch) return this.transform.minPitch = t, this._update(), this.getPitch() < t ? this.setPitch(t) : this.fire(new e.g("pitchstart")).fire(new e.g("pitch")).fire(new e.g("pitchend")), this;
              throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
            }
          }, {
            key: "getMinPitch",
            value: function getMinPitch() {
              return this.transform.minPitch;
            }
          }, {
            key: "setMaxPitch",
            value: function setMaxPitch(t) {
              var _t682;
              if ((t = (_t682 = t) !== null && _t682 !== void 0 ? _t682 : 85) > 85) throw new Error("maxPitch must be less than or equal to 85");
              if (t >= this.transform.minPitch) return this.transform.maxPitch = t, this._update(), this.getPitch() > t ? this.setPitch(t) : this.fire(new e.g("pitchstart")).fire(new e.g("pitch")).fire(new e.g("pitchend")), this;
              throw new Error("maxPitch must be greater than or equal to minPitch");
            }
          }, {
            key: "getMaxPitch",
            value: function getMaxPitch() {
              return this.transform.maxPitch;
            }
          }, {
            key: "getRenderWorldCopies",
            value: function getRenderWorldCopies() {
              return this.transform.renderWorldCopies;
            }
          }, {
            key: "setRenderWorldCopies",
            value: function setRenderWorldCopies(e) {
              return this.transform.renderWorldCopies = e, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(!0), this._update();
            }
          }, {
            key: "getLanguage",
            value: function getLanguage() {
              return this._language;
            }
          }, {
            key: "_parseLanguage",
            value: function _parseLanguage(e) {
              return "auto" === e ? navigator.language : Array.isArray(e) ? 0 === e.length ? void 0 : e.map(function (e) {
                return "auto" === e ? navigator.language : e;
              }) : e;
            }
          }, {
            key: "setLanguage",
            value: function setLanguage(e) {
              var t = this._parseLanguage(e);
              if (!this.style || t === this._language) return this;
              this._language = t, this.style.reloadSources();
              var _iterator484 = _createForOfIteratorHelper(this._controls),
                _step484;
              try {
                for (_iterator484.s(); !(_step484 = _iterator484.n()).done;) {
                  var _e729 = _step484.value;
                  _e729._setLanguage && _e729._setLanguage(this._language);
                }
              } catch (err) {
                _iterator484.e(err);
              } finally {
                _iterator484.f();
              }
              return this;
            }
          }, {
            key: "getWorldview",
            value: function getWorldview() {
              return this._worldview;
            }
          }, {
            key: "setWorldview",
            value: function setWorldview(e) {
              return this.style && e !== this._worldview ? (this._worldview = e, this.style.reloadSources(), this) : this;
            }
          }, {
            key: "getProjection",
            value: function getProjection() {
              return this.transform.mercatorFromTransition ? {
                name: "globe",
                center: [0, 0]
              } : this.transform.getProjection();
            }
          }, {
            key: "_showingGlobe",
            value: function _showingGlobe() {
              return "globe" === this.transform.projection.name;
            }
          }, {
            key: "setProjection",
            value: function setProjection(e) {
              return this._lazyInitEmptyStyle(), e ? "string" == typeof e && (e = {
                name: e
              }) : e = null, this._useExplicitProjection = !!e, this._prioritizeAndUpdateProjection(e, this.style.projection);
            }
          }, {
            key: "_updateProjectionTransition",
            value: function _updateProjectionTransition() {
              if ("globe" !== this.getProjection().name) return;
              var t = this.transform,
                i = t.projection.name;
              var o;
              "globe" === i && t.zoom >= e.aV ? (t.setMercatorFromTransition(), o = !0) : "mercator" === i && t.zoom < e.aV && (t.setProjection({
                name: "globe"
              }), o = !0), o && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate());
            }
          }, {
            key: "_prioritizeAndUpdateProjection",
            value: function _prioritizeAndUpdateProjection(e, t) {
              return this._updateProjection(e || t || {
                name: "mercator"
              });
            }
          }, {
            key: "_updateProjection",
            value: function _updateProjection(t) {
              var i;
              return i = "globe" === t.name && this.transform.zoom >= e.aV ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t), this.style.applyProjectionUpdate(), i && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(!0), this._forceMarkerAndPopupUpdate(!0)), this;
            }
          }, {
            key: "project",
            value: function project(t) {
              return this.transform.locationPoint3D(e.aJ.convert(t));
            }
          }, {
            key: "unproject",
            value: function unproject(t) {
              return this.transform.pointLocation3D(e.P.convert(t));
            }
          }, {
            key: "isMoving",
            value: function isMoving() {
              return this._moving || this.handlers && this.handlers.isMoving() || !1;
            }
          }, {
            key: "isZooming",
            value: function isZooming() {
              return this._zooming || this.handlers && this.handlers.isZooming() || !1;
            }
          }, {
            key: "isRotating",
            value: function isRotating() {
              return this._rotating || this.handlers && this.handlers.isRotating() || !1;
            }
          }, {
            key: "_isDragging",
            value: function _isDragging() {
              return this.handlers && this.handlers._isDragging() || !1;
            }
          }, {
            key: "_createDelegatedListener",
            value: function _createDelegatedListener(e, t, i) {
              var _this186 = this;
              if ("mouseenter" === e || "mouseover" === e) {
                var _o293 = !1;
                var _r473 = function _r473(r) {
                    var a = t.filter(function (e) {
                        return _this186.getLayer(e);
                      }),
                      n = a.length ? _this186.queryRenderedFeatures(r.point, {
                        layers: a
                      }) : [];
                    n.length ? _o293 || (_o293 = !0, i.call(_this186, new Na(e, _this186, r.originalEvent, {
                      features: n
                    }))) : _o293 = !1;
                  },
                  _a260 = function _a260() {
                    _o293 = !1;
                  };
                return {
                  layers: new Set(t),
                  listener: i,
                  delegates: {
                    mousemove: _r473,
                    mouseout: _a260
                  }
                };
              }
              if ("mouseleave" === e || "mouseout" === e) {
                var _o294 = !1;
                var _r474 = function _r474(r) {
                    var a = t.filter(function (e) {
                      return _this186.getLayer(e);
                    });
                    (a.length ? _this186.queryRenderedFeatures(r.point, {
                      layers: a
                    }) : []).length ? _o294 = !0 : _o294 && (_o294 = !1, i.call(_this186, new Na(e, _this186, r.originalEvent)));
                  },
                  _a261 = function _a261(t) {
                    _o294 && (_o294 = !1, i.call(_this186, new Na(e, _this186, t.originalEvent)));
                  };
                return {
                  layers: new Set(t),
                  listener: i,
                  delegates: {
                    mousemove: _r474,
                    mouseout: _a261
                  }
                };
              }
              {
                var _o295 = function _o295(e) {
                  var o = t.filter(function (e) {
                      return _this186.getLayer(e);
                    }),
                    r = o.length ? _this186.queryRenderedFeatures(e.point, {
                      layers: o
                    }) : [];
                  r.length && (e.features = r, i.call(_this186, e), delete e.features);
                };
                return {
                  layers: new Set(t),
                  listener: i,
                  delegates: _defineProperty({}, e, _o295)
                };
              }
            }
          }, {
            key: "on",
            value: function on(e, t, i) {
              if ("function" == typeof t || void 0 === i) return _get(_getPrototypeOf(Map.prototype), "on", this).call(this, e, t);
              if (Array.isArray(t) || (t = [t]), t) {
                var _iterator485 = _createForOfIteratorHelper(t),
                  _step485;
                try {
                  for (_iterator485.s(); !(_step485 = _iterator485.n()).done;) {
                    var _e730 = _step485.value;
                    if (!this._isValidId(_e730)) return this;
                  }
                } catch (err) {
                  _iterator485.e(err);
                } finally {
                  _iterator485.f();
                }
              }
              var o = this._createDelegatedListener(e, t, i);
              this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e] = this._delegatedListeners[e] || [], this._delegatedListeners[e].push(o);
              for (var _e731 in o.delegates) this.on(_e731, o.delegates[_e731]);
              return this;
            }
          }, {
            key: "once",
            value: function once(e, t, i) {
              if ("function" == typeof t || void 0 === i) return _get(_getPrototypeOf(Map.prototype), "once", this).call(this, e, t);
              if (Array.isArray(t) || (t = [t]), t) {
                var _iterator486 = _createForOfIteratorHelper(t),
                  _step486;
                try {
                  for (_iterator486.s(); !(_step486 = _iterator486.n()).done;) {
                    var _e732 = _step486.value;
                    if (!this._isValidId(_e732)) return this;
                  }
                } catch (err) {
                  _iterator486.e(err);
                } finally {
                  _iterator486.f();
                }
              }
              var o = this._createDelegatedListener(e, t, i);
              for (var _e733 in o.delegates) this.once(_e733, o.delegates[_e733]);
              return this;
            }
          }, {
            key: "off",
            value: function off(e, t, i) {
              var _this187 = this;
              if ("function" == typeof t || void 0 === i) return _get(_getPrototypeOf(Map.prototype), "off", this).call(this, e, t);
              var o = new Set(Array.isArray(t) ? t : [t]);
              var _iterator487 = _createForOfIteratorHelper(o),
                _step487;
              try {
                for (_iterator487.s(); !(_step487 = _iterator487.n()).done;) {
                  var _e735 = _step487.value;
                  if (!this._isValidId(_e735)) return this;
                }
              } catch (err) {
                _iterator487.e(err);
              } finally {
                _iterator487.f();
              }
              var r = function r(e, t) {
                  if (e.size !== t.size) return !1;
                  var _iterator488 = _createForOfIteratorHelper(e),
                    _step488;
                  try {
                    for (_iterator488.s(); !(_step488 = _iterator488.n()).done;) {
                      var _i513 = _step488.value;
                      if (!t.has(_i513)) return !1;
                    }
                  } catch (err) {
                    _iterator488.e(err);
                  } finally {
                    _iterator488.f();
                  }
                  return !0;
                },
                a = this._delegatedListeners ? this._delegatedListeners[e] : void 0;
              return a && function (e) {
                for (var _t683 = 0; _t683 < e.length; _t683++) {
                  var _a262 = e[_t683];
                  if (_a262.listener === i && r(_a262.layers, o)) {
                    for (var _e734 in _a262.delegates) _this187.off(_e734, _a262.delegates[_e734]);
                    return e.splice(_t683, 1), _this187;
                  }
                }
              }(a), this;
            }
          }, {
            key: "queryRenderedFeatures",
            value: function queryRenderedFeatures(t, i) {
              if (!this.style) return [];
              if (void 0 !== i || void 0 === t || t instanceof e.P || Array.isArray(t) || (i = t, t = void 0), t = t || [[0, 0], [this.transform.width, this.transform.height]], (i = i || {}).layers && Array.isArray(i.layers)) {
                var _iterator489 = _createForOfIteratorHelper(i.layers),
                  _step489;
                try {
                  for (_iterator489.s(); !(_step489 = _iterator489.n()).done;) {
                    var _e736 = _step489.value;
                    if (!this._isValidId(_e736)) return [];
                  }
                } catch (err) {
                  _iterator489.e(err);
                } finally {
                  _iterator489.f();
                }
              }
              return this.style.queryRenderedFeatures(t, i, this.transform);
            }
          }, {
            key: "querySourceFeatures",
            value: function querySourceFeatures(e, t) {
              return this._isValidId(e) ? this.style.querySourceFeatures(e, t) : [];
            }
          }, {
            key: "isPointOnSurface",
            value: function isPointOnSurface(t) {
              var i = this.transform.projection.name;
              return "globe" !== i && "mercator" !== i && e.w("".concat(i, " projection does not support isPointOnSurface, this API may behave unexpectedly.")), this.transform.isPointOnSurface(e.P.convert(t));
            }
          }, {
            key: "setStyle",
            value: function setStyle(t, i) {
              var _this188 = this;
              return i = e.Q({}, {
                localIdeographFontFamily: this._localIdeographFontFamily,
                localFontFamily: this._localFontFamily
              }, i), this.style && t && !1 !== i.diff && i.localFontFamily === this._localFontFamily && i.localIdeographFontFamily === this._localIdeographFontFamily && !i.config ? (this.style._diffStyle(t, function (o, r) {
                o ? (e.w("Unable to perform style diff: ".concat(String(o.message || o.error || o), ". Rebuilding the style from scratch.")), _this188._updateStyle(t, i)) : r && _this188._update(!0);
              }, function () {
                _this188._postStyleLoadEvent();
              }), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._localFontFamily = i.localFontFamily, this._updateStyle(t, i));
            }
          }, {
            key: "_getUIString",
            value: function _getUIString(e) {
              var t = this._locale[e];
              if (null == t) throw new Error("Missing UI string '".concat(e, "'"));
              return t;
            }
          }, {
            key: "_updateStyle",
            value: function _updateStyle(t, i) {
              if (this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), t) {
                var _o296 = e.Q({}, i);
                i && i.config && (_o296.initialConfig = i.config, delete _o296.config), this.style = new Ia(this, _o296).load(t), this.style.setEventedParent(this, {
                  style: this.style
                });
              }
              return this._updateTerrain(), this;
            }
          }, {
            key: "_lazyInitEmptyStyle",
            value: function _lazyInitEmptyStyle() {
              this.style || (this.style = new Ia(this, {}), this.style.setEventedParent(this, {
                style: this.style
              }), this.style.loadEmpty());
            }
          }, {
            key: "getStyle",
            value: function getStyle() {
              if (this.style) return this.style.serialize();
            }
          }, {
            key: "isStyleLoaded",
            value: function isStyleLoaded() {
              return this.style ? this.style.loaded() : (e.w("There is no style added to the map."), !1);
            }
          }, {
            key: "_isValidId",
            value: function _isValidId(t) {
              return null == t ? (this.fire(new e.f(new Error("IDs can't be empty."))), !1) : !e.cY(t) || (this.fire(new e.f(new Error("IDs can't contain special symbols: \"".concat(t, "\".")))), !1);
            }
          }, {
            key: "addSource",
            value: function addSource(e, t) {
              return this._isValidId(e) ? (this._lazyInitEmptyStyle(), this.style.addSource(e, t), this._update(!0)) : this;
            }
          }, {
            key: "isSourceLoaded",
            value: function isSourceLoaded(e) {
              return !!this._isValidId(e) && !!this.style && this.style._isSourceCacheLoaded(e);
            }
          }, {
            key: "areTilesLoaded",
            value: function areTilesLoaded() {
              return this.style.areTilesLoaded();
            }
          }, {
            key: "addSourceType",
            value: function addSourceType(e, t, i) {
              this._lazyInitEmptyStyle(), this.style.addSourceType(e, t, i);
            }
          }, {
            key: "removeSource",
            value: function removeSource(e) {
              return this._isValidId(e) ? (this.style.removeSource(e), this._updateTerrain(), this._update(!0)) : this;
            }
          }, {
            key: "getSource",
            value: function getSource(e) {
              return this._isValidId(e) ? this.style.getOwnSource(e) : null;
            }
          }, {
            key: "addImage",
            value: function addImage(t, i) {
              var _ref194 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
                _ref194$pixelRatio = _ref194.pixelRatio,
                o = _ref194$pixelRatio === void 0 ? 1 : _ref194$pixelRatio,
                _ref194$sdf = _ref194.sdf,
                r = _ref194$sdf === void 0 ? !1 : _ref194$sdf,
                a = _ref194.stretchX,
                n = _ref194.stretchY,
                s = _ref194.content;
              if (this._lazyInitEmptyStyle(), i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap) {
                var _e$e$getImageData2 = e.e.getImageData(i),
                  _l143 = _e$e$getImageData2.width,
                  _c125 = _e$e$getImageData2.height,
                  _h95 = _e$e$getImageData2.data;
                this.style.addImage(t, {
                  data: new e.j({
                    width: _l143,
                    height: _c125
                  }, _h95),
                  pixelRatio: o,
                  stretchX: a,
                  stretchY: n,
                  content: s,
                  sdf: r,
                  version: 0
                });
              } else if (void 0 === i.width || void 0 === i.height) this.fire(new e.f(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));else {
                var _l144 = i.width,
                  _c126 = i.height,
                  _h96 = i;
                this.style.addImage(t, {
                  data: new e.j({
                    width: _l144,
                    height: _c126
                  }, new Uint8Array(_h96.data)),
                  pixelRatio: o,
                  stretchX: a,
                  stretchY: n,
                  content: s,
                  sdf: r,
                  version: 0,
                  userImage: _h96
                }), _h96.onAdd && _h96.onAdd(this, t);
              }
            }
          }, {
            key: "updateImage",
            value: function updateImage(t, i) {
              this._lazyInitEmptyStyle();
              var o = this.style.getImage(t);
              if (!o) return void this.fire(new e.f(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
              var r = i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap ? e.e.getImageData(i) : i,
                a = r.width,
                n = r.height,
                s = r.data;
              if (void 0 === a || void 0 === n) return void this.fire(new e.f(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
              if (a !== o.data.width || n !== o.data.height) return void this.fire(new e.f(new Error("The width and height of the updated image (".concat(a, ", ").concat(n, ")\n                must be that same as the previous version of the image\n                (").concat(o.data.width, ", ").concat(o.data.height, ")"))));
              var l = !(i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap);
              o.data.replace(s, l), this.style.updateImage(t, o);
            }
          }, {
            key: "hasImage",
            value: function hasImage(t) {
              return t ? !!this.style && !!this.style.getImage(t) : (this.fire(new e.f(new Error("Missing required image id"))), !1);
            }
          }, {
            key: "removeImage",
            value: function removeImage(e) {
              this.style.removeImage(e);
            }
          }, {
            key: "loadImage",
            value: function loadImage(t, i) {
              e.i(this._requestManager.transformRequest(t, e.R.Image), function (t, o) {
                i(t, o instanceof HTMLImageElement ? e.e.getImageData(o) : o);
              });
            }
          }, {
            key: "listImages",
            value: function listImages() {
              return this.style.listImages();
            }
          }, {
            key: "addModel",
            value: function addModel(e, t) {
              this._lazyInitEmptyStyle(), this.style.addModel(e, t);
            }
          }, {
            key: "hasModel",
            value: function hasModel(t) {
              return t ? this.style.hasModel(t) : (this.fire(new e.f(new Error("Missing required model id"))), !1);
            }
          }, {
            key: "removeModel",
            value: function removeModel(e) {
              this.style.removeModel(e);
            }
          }, {
            key: "listModels",
            value: function listModels() {
              return this.style.listModels();
            }
          }, {
            key: "addLayer",
            value: function addLayer(e, t) {
              return this._isValidId(e.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e, t), this._update(!0)) : this;
            }
          }, {
            key: "getSlot",
            value: function getSlot(e) {
              var t = this.getLayer(e);
              return t && t.slot || null;
            }
          }, {
            key: "setSlot",
            value: function setSlot(e, t) {
              return this.style.setSlot(e, t), this.style.mergeLayers(), this._update(!0);
            }
          }, {
            key: "addImport",
            value: function addImport(e, t) {
              return this.style.addImport(e, t), this;
            }
          }, {
            key: "updateImport",
            value: function updateImport(e, t) {
              return "string" != typeof t && t.id !== e ? (this.removeImport(e), this.addImport(t)) : (this.style.updateImport(e, t), this._update(!0));
            }
          }, {
            key: "removeImport",
            value: function removeImport(e) {
              return this.style.removeImport(e), this;
            }
          }, {
            key: "moveImport",
            value: function moveImport(e, t) {
              return this.style.moveImport(e, t), this._update(!0);
            }
          }, {
            key: "moveLayer",
            value: function moveLayer(e, t) {
              return this._isValidId(e) ? (this.style.moveLayer(e, t), this._update(!0)) : this;
            }
          }, {
            key: "removeLayer",
            value: function removeLayer(e) {
              return this._isValidId(e) ? (this.style.removeLayer(e), this._update(!0)) : this;
            }
          }, {
            key: "getLayer",
            value: function getLayer(e) {
              if (!this._isValidId(e)) return null;
              var t = this.style.getOwnLayer(e);
              return t ? "custom" === t.type ? t.implementation : t.serialize() : void 0;
            }
          }, {
            key: "getSlots",
            value: function getSlots() {
              return this.style.getSlots();
            }
          }, {
            key: "setLayerZoomRange",
            value: function setLayerZoomRange(e, t, i) {
              return this._isValidId(e) ? (this.style.setLayerZoomRange(e, t, i), this._update(!0)) : this;
            }
          }, {
            key: "setFilter",
            value: function setFilter(e, t) {
              var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              return this._isValidId(e) ? (this.style.setFilter(e, t, i), this._update(!0)) : this;
            }
          }, {
            key: "getFilter",
            value: function getFilter(e) {
              return this._isValidId(e) ? this.style.getFilter(e) : null;
            }
          }, {
            key: "setPaintProperty",
            value: function setPaintProperty(e, t, i) {
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
              return this._isValidId(e) ? (this.style.setPaintProperty(e, t, i, o), this._update(!0)) : this;
            }
          }, {
            key: "getPaintProperty",
            value: function getPaintProperty(e, t) {
              return this._isValidId(e) ? this.style.getPaintProperty(e, t) : null;
            }
          }, {
            key: "setLayoutProperty",
            value: function setLayoutProperty(e, t, i) {
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
              return this._isValidId(e) ? (this.style.setLayoutProperty(e, t, i, o), this._update(!0)) : this;
            }
          }, {
            key: "getLayoutProperty",
            value: function getLayoutProperty(e, t) {
              return this._isValidId(e) ? this.style.getLayoutProperty(e, t) : null;
            }
          }, {
            key: "getSchema",
            value: function getSchema(e) {
              return this.style.getSchema(e);
            }
          }, {
            key: "setSchema",
            value: function setSchema(e, t) {
              return this.style.setSchema(e, t), this._update(!0);
            }
          }, {
            key: "getConfig",
            value: function getConfig(e) {
              return this.style.getConfig(e);
            }
          }, {
            key: "setConfig",
            value: function setConfig(e, t) {
              return this.style.setConfig(e, t), this._update(!0);
            }
          }, {
            key: "getConfigProperty",
            value: function getConfigProperty(e, t) {
              return this.style.getConfigProperty(e, t);
            }
          }, {
            key: "setConfigProperty",
            value: function setConfigProperty(e, t, i) {
              return this.style.setConfigProperty(e, t, i), this._update(!0);
            }
          }, {
            key: "setLights",
            value: function setLights(e) {
              if (this._lazyInitEmptyStyle(), e && 1 === e.length && "flat" === e[0].type) {
                var _t684 = e[0];
                _t684.properties ? this.style.setFlatLight(_t684.properties, _t684.id, {}) : this.style.setFlatLight({}, "flat");
              } else this.style.setLights(e), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = !0);
              return this._update(!0);
            }
          }, {
            key: "getLights",
            value: function getLights() {
              var e = this.style.getLights() || [];
              return 0 === e.length && e.push({
                id: this.style.light.id,
                type: "flat",
                properties: this.style.getFlatLight()
              }), e;
            }
          }, {
            key: "setLight",
            value: function setLight(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([{
                id: "flat",
                type: "flat",
                properties: e
              }]);
            }
          }, {
            key: "getLight",
            value: function getLight() {
              return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
            }
          }, {
            key: "setTerrain",
            value: function setTerrain(e) {
              return this._lazyInitEmptyStyle(), !e && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
            }
          }, {
            key: "getTerrain",
            value: function getTerrain() {
              return this.style ? this.style.getTerrain() : null;
            }
          }, {
            key: "setFog",
            value: function setFog(e) {
              return this._lazyInitEmptyStyle(), this.style.setFog(e), this._update(!0);
            }
          }, {
            key: "getFog",
            value: function getFog() {
              return this.style ? this.style.getFog() : null;
            }
          }, {
            key: "setColorTheme",
            value: function setColorTheme(e) {
              return this._lazyInitEmptyStyle(), this.style.setColorTheme(e), this._update(!0);
            }
          }, {
            key: "setCamera",
            value: function setCamera(e) {
              return this.style.setCamera(e), this._triggerCameraUpdate(e);
            }
          }, {
            key: "_triggerCameraUpdate",
            value: function _triggerCameraUpdate(e) {
              return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e["camera-projection"]));
            }
          }, {
            key: "getCamera",
            value: function getCamera() {
              return this.style.camera;
            }
          }, {
            key: "_queryFogOpacity",
            value: function _queryFogOpacity(t) {
              return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e.aJ.convert(t), this.transform) : 0;
            }
          }, {
            key: "setFeatureState",
            value: function setFeatureState(e, t) {
              return this._isValidId(e.source) ? (this.style.setFeatureState(e, t), this._update()) : this;
            }
          }, {
            key: "removeFeatureState",
            value: function removeFeatureState(e, t) {
              return this._isValidId(e.source) ? (this.style.removeFeatureState(e, t), this._update()) : this;
            }
          }, {
            key: "getFeatureState",
            value: function getFeatureState(e) {
              return this._isValidId(e.source) ? this.style.getFeatureState(e) : null;
            }
          }, {
            key: "_updateContainerDimensions",
            value: function _updateContainerDimensions() {
              if (!this._container) return;
              var e = this._container.getBoundingClientRect().width || 400,
                t = this._container.getBoundingClientRect().height || 300;
              var i,
                o,
                r,
                a = this._container;
              for (; a && (!o || !r);) {
                var _e737 = window.getComputedStyle(a).transform;
                _e737 && "none" !== _e737 && (i = _e737.match(/matrix.*\((.+)\)/)[1].split(", "), i[0] && "0" !== i[0] && "1" !== i[0] && (o = i[0]), i[3] && "0" !== i[3] && "1" !== i[3] && (r = i[3])), a = a.parentElement;
              }
              this._containerWidth = o ? Math.abs(e / o) : e, this._containerHeight = r ? Math.abs(t / r) : t;
            }
          }, {
            key: "_detectMissingCSS",
            value: function _detectMissingCSS() {
              "rgb(250, 128, 114)" !== window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e.w("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
            }
          }, {
            key: "_setupContainer",
            value: function _setupContainer() {
              var e = this._container;
              e.classList.add("mapboxgl-map"), (this._missingCSSCanary = r("div", "mapboxgl-canary", e)).style.visibility = "hidden", this._detectMissingCSS();
              var t = this._canvasContainer = r("div", "mapboxgl-canvas-container", e);
              this._canvas = r("canvas", "mapboxgl-canvas", t), this._interactive && (t.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
              var i = this._controlContainer = r("div", "mapboxgl-control-container", e),
                o = this._controlPositions = {};
              ["top-left", "top-right", "bottom-left", "bottom-right"].forEach(function (e) {
                o[e] = r("div", "mapboxgl-ctrl-".concat(e), i);
              }), this._container.addEventListener("scroll", this._onMapScroll, !1);
            }
          }, {
            key: "_resizeCanvas",
            value: function _resizeCanvas(t, i) {
              var o = e.e.devicePixelRatio || 1;
              this._canvas.width = o * Math.ceil(t), this._canvas.height = o * Math.ceil(i), this._canvas.style.width = "".concat(t, "px"), this._canvas.style.height = "".concat(i, "px");
            }
          }, {
            key: "_addMarker",
            value: function _addMarker(e) {
              this._markers.push(e);
            }
          }, {
            key: "_removeMarker",
            value: function _removeMarker(e) {
              var t = this._markers.indexOf(e);
              -1 !== t && this._markers.splice(t, 1);
            }
          }, {
            key: "_addPopup",
            value: function _addPopup(e) {
              this._popups.push(e);
            }
          }, {
            key: "_removePopup",
            value: function _removePopup(e) {
              var t = this._popups.indexOf(e);
              -1 !== t && this._popups.splice(t, 1);
            }
          }, {
            key: "_setupPainter",
            value: function _setupPainter() {
              var _this189 = this;
              var i = e.Q({}, t.webGLContextAttributes, {
                  failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                  preserveDrawingBuffer: this._preserveDrawingBuffer,
                  antialias: this._antialias || !1
                }),
                o = this._canvas.getContext("webgl2", i);
              o ? (e.dk(o, !0), this.painter = new Cr(o, this._contextCreateOptions, this.transform, this._tp), this.on("data", function (e) {
                "source" === e.dataType && _this189.painter.setTileLoadedFlag(!0);
              }), e.dl.testSupport(o)) : this.fire(new e.f(new Error("Failed to initialize WebGL")));
            }
          }, {
            key: "_contextLost",
            value: function _contextLost(t) {
              t.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new e.g("webglcontextlost", {
                originalEvent: t
              }));
            }
          }, {
            key: "_contextRestored",
            value: function _contextRestored(t) {
              this._setupPainter(), this.resize(), this._update(), this.fire(new e.g("webglcontextrestored", {
                originalEvent: t
              }));
            }
          }, {
            key: "_onMapScroll",
            value: function _onMapScroll(e) {
              if (e.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
            }
          }, {
            key: "idle",
            value: function idle() {
              return !this.isMoving() && this.loaded();
            }
          }, {
            key: "loaded",
            value: function loaded() {
              return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
            }
          }, {
            key: "frameReady",
            value: function frameReady() {
              return this.loaded() && !this._placementDirty;
            }
          }, {
            key: "_update",
            value: function _update(e) {
              return this.style ? (this._styleDirty = this._styleDirty || e, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
            }
          }, {
            key: "_requestRenderFrame",
            value: function _requestRenderFrame(e) {
              return this._update(), this._renderTaskQueue.add(e);
            }
          }, {
            key: "_cancelRenderFrame",
            value: function _cancelRenderFrame(e) {
              this._renderTaskQueue.remove(e);
            }
          }, {
            key: "_requestDomTask",
            value: function _requestDomTask(e) {
              !this.loaded() || this.loaded() && !this.isMoving() ? e() : this._domRenderTaskQueue.add(e);
            }
          }, {
            key: "_render",
            value: function _render(t) {
              var _this190 = this;
              var i;
              this.fire(new e.g("renderstart")), ++this._frameId;
              var o = this.painter.context.extTimerQuery,
                r = e.e.now(),
                a = this.painter.context.gl;
              if (this.listens("gpu-timing-frame") && (i = a.createQuery(), a.beginQuery(o.TIME_ELAPSED_EXT, i)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], performance.now())), this._renderTaskQueue.run(t), this._domRenderTaskQueue.run(t), this._removed) return;
              this._updateProjectionTransition();
              var n = this._isInitialLoad ? 0 : this._fadeDuration;
              if (this.style && this._styleDirty) {
                this._styleDirty = !1;
                var _t685 = this.transform.zoom,
                  _i514 = this.transform.pitch,
                  _o297 = e.e.now(),
                  _r475 = new e.Y(_t685, {
                    now: _o297,
                    fadeDuration: n,
                    pitch: _i514,
                    transition: this.style.transition
                  });
                this.style.update(_r475);
              }
              this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
              var s = !1;
              this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), s = this._updateAverageElevation(r), this.style.updateSources(this.transform), this._forceMarkerAndPopupUpdate()) : s = this._updateAverageElevation(r);
              var l = this.style && this.style._updatePlacement(this.painter, this.painter.transform, this.showCollisionBoxes, n, this._crossSourceCollisions, this.painter.replacementSource);
              if (l && (this._placementDirty = l.needsRerender), this.style && this.painter.render(this.style, {
                showTileBoundaries: this.showTileBoundaries,
                showParseStatus: this.showParseStatus,
                wireframe: {
                  terrain: this.showTerrainWireframe,
                  layers2D: this.showLayers2DWireframe,
                  layers3D: this.showLayers3DWireframe
                },
                showOverdrawInspector: this._showOverdrawInspector,
                showQueryGeometry: !!this._showQueryGeometry,
                showTileAABBs: this.showTileAABBs,
                rotating: this.isRotating(),
                zooming: this.isZooming(),
                moving: this.isMoving(),
                fadeDuration: n,
                isInitialLoad: this._isInitialLoad,
                showPadding: this.showPadding,
                gpuTiming: !!this.listens("gpu-timing-layer"),
                gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"),
                speedIndexTiming: this.speedIndexTiming
              }), this.fire(new e.g("render")), this.loaded() && !this._loaded && (this._loaded = !0, e.df.mark(e.dg.load), this.fire(new e.g("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), i) {
                var _t686 = e.e.now() - r;
                a.endQuery(o.TIME_ELAPSED_EXT), setTimeout(function () {
                  var o = a.getQueryParameter(i, a.QUERY_RESULT) / 1e6;
                  a.deleteQuery(i), _this190.fire(new e.g("gpu-timing-frame", {
                    cpuTime: _t686,
                    gpuTime: o
                  }));
                }, 50);
              }
              if (this.listens("gpu-timing-layer")) {
                var _t687 = this.painter.collectGpuTimers();
                setTimeout(function () {
                  var i = _this190.painter.queryGpuTimers(_t687);
                  _this190.fire(new e.g("gpu-timing-layer", {
                    layerTimes: i
                  }));
                }, 50);
              }
              if (this.listens("gpu-timing-deferred-render")) {
                var _t688 = this.painter.collectDeferredRenderGpuQueries();
                setTimeout(function () {
                  var i = _this190.painter.queryGpuTimeDeferredRender(_t688);
                  _this190.fire(new e.g("gpu-timing-deferred-render", {
                    gpuTime: i
                  }));
                }, 50);
              }
              var c = this._sourcesDirty || this._styleDirty || this._placementDirty || s;
              if (c || this._repaint) this.triggerRepaint();else {
                var _t689 = this.idle();
                if (_t689 && (s = this._updateAverageElevation(r, !0)), s) this.triggerRepaint();else if (this._triggerFrame(!1), _t689 && (this.fire(new e.g("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
                  var _t690 = this._calculateSpeedIndex();
                  this.fire(new e.g("speedindexcompleted", {
                    speedIndex: _t690
                  })), this.speedIndexTiming = !1;
                }
              }
              !this._loaded || this._fullyLoaded || c || (this._fullyLoaded = !0, e.df.mark(e.dg.fullLoad), this._performanceMetricsCollection && e.dm(this._requestManager._customAccessToken, {
                width: this.painter.width,
                height: this.painter.height,
                interactionRange: this._interactionRange,
                visibilityHidden: this._visibilityHidden,
                terrainEnabled: !!this.painter.style.getTerrain(),
                fogEnabled: !!this.painter.style.getFog(),
                projection: this.getProjection().name,
                zoom: this.transform.zoom,
                renderer: this.painter.context.renderer,
                vendor: this.painter.context.vendor
              }), this._authenticate());
            }
          }, {
            key: "_forceMarkerAndPopupUpdate",
            value: function _forceMarkerAndPopupUpdate(e) {
              var _iterator490 = _createForOfIteratorHelper(this._markers),
                _step490;
              try {
                for (_iterator490.s(); !(_step490 = _iterator490.n()).done;) {
                  var _t691 = _step490.value;
                  e && !this.getRenderWorldCopies() && (_t691._lngLat = _t691._lngLat.wrap()), _t691._update();
                }
              } catch (err) {
                _iterator490.e(err);
              } finally {
                _iterator490.f();
              }
              var _iterator491 = _createForOfIteratorHelper(this._popups),
                _step491;
              try {
                for (_iterator491.s(); !(_step491 = _iterator491.n()).done;) {
                  var _t692 = _step491.value;
                  !e || this.getRenderWorldCopies() || _t692._trackPointer || (_t692._lngLat = _t692._lngLat.wrap()), _t692._update();
                }
              } catch (err) {
                _iterator491.e(err);
              } finally {
                _iterator491.f();
              }
            }
          }, {
            key: "_updateAverageElevation",
            value: function _updateAverageElevation(e) {
              var _this191 = this;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              var i = function i(e) {
                return _this191.transform.averageElevation = e, _this191._update(!1), !0;
              };
              if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i(0);
              var o = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
              if (o || (t || e - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e)) {
                var _t693 = this.transform.averageElevation;
                var _r476 = this.transform.sampleAverageElevation();
                null != this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(_r476) ? _r476 = 0 : this._averageElevationLastSampledAt = e;
                var _a263 = Math.abs(_t693 - _r476);
                if (_a263 > 1) {
                  if (this._isInitialLoad || o) return this._averageElevation.jumpTo(_r476), i(_r476);
                  this._averageElevation.easeTo(_r476, e, 300);
                } else if (_a263 > 1e-4) return this._averageElevation.jumpTo(_r476), i(_r476);
              }
              return !!this._averageElevation.isEasing(e) && i(this._averageElevation.getValue(e));
            }
          }, {
            key: "_authenticate",
            value: function _authenticate() {
              var _this192 = this;
              e.dn(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, function (t) {
                if (t && (t.message === e.dp || 401 === t.status)) {
                  var _t694 = _this192.painter.context.gl;
                  e.dk(_t694, !1), _this192._logoControl instanceof Rn && _this192._logoControl._updateLogo(), _t694 && _t694.clear(_t694.DEPTH_BUFFER_BIT | _t694.COLOR_BUFFER_BIT | _t694.STENCIL_BUFFER_BIT), _this192._silenceAuthErrors || _this192.fire(new e.f(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                }
              }), e.dq(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, function () {});
            }
          }, {
            key: "_postStyleLoadEvent",
            value: function _postStyleLoadEvent() {
              this.style.globalId && e.dr(this._requestManager._customAccessToken, {
                map: this,
                skuToken: this._requestManager._skuToken,
                style: this.style.globalId,
                importedStyles: this.style.getImportGlobalIds()
              });
            }
          }, {
            key: "_updateTerrain",
            value: function _updateTerrain() {
              var e = this._isDragging();
              this.painter.updateTerrain(this.style, e);
            }
          }, {
            key: "_calculateSpeedIndex",
            value: function _calculateSpeedIndex() {
              var e = this.painter.canvasCopy(),
                t = this.painter.getCanvasCopiesAndTimestamps();
              t.timeStamps.push(performance.now());
              var i = this.painter.context.gl,
                o = i.createFramebuffer();
              function r(e) {
                i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e, 0);
                var t = new Uint8Array(i.drawingBufferWidth * i.drawingBufferHeight * 4);
                return i.readPixels(0, 0, i.drawingBufferWidth, i.drawingBufferHeight, i.RGBA, i.UNSIGNED_BYTE, t), t;
              }
              return i.bindFramebuffer(i.FRAMEBUFFER, o), this._canvasPixelComparison(r(e), t.canvasCopies.map(r), t.timeStamps);
            }
          }, {
            key: "_canvasPixelComparison",
            value: function _canvasPixelComparison(e, t, i) {
              var o = i[1] - i[0];
              var r = e.length / 4;
              for (var _a264 = 0; _a264 < t.length; _a264++) {
                var _n324 = t[_a264];
                var _s264 = 0;
                for (var _t695 = 0; _t695 < _n324.length; _t695 += 4) _n324[_t695] === e[_t695] && _n324[_t695 + 1] === e[_t695 + 1] && _n324[_t695 + 2] === e[_t695 + 2] && _n324[_t695 + 3] === e[_t695 + 3] && (_s264 += 1);
                o += (i[_a264 + 2] - i[_a264 + 1]) * (1 - _s264 / r);
              }
              return o;
            }
          }, {
            key: "remove",
            value: function remove() {
              this._hash && this._hash.remove();
              var _iterator492 = _createForOfIteratorHelper(this._controls),
                _step492;
              try {
                for (_iterator492.s(); !(_step492 = _iterator492.n()).done;) {
                  var _e738 = _step492.value;
                  _e738.onRemove(this);
                }
              } catch (err) {
                _iterator492.e(err);
              } finally {
                _iterator492.f();
              }
              this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), window.removeEventListener("resize", this._onWindowResize, !1), window.removeEventListener("orientationchange", this._onWindowResize, !1), window.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.removeEventListener("online", this._onWindowOnline, !1), window.removeEventListener("visibilitychange", this._onVisibilityChange, !1);
              var t = this.painter.context.gl.getExtension("WEBGL_lose_context");
              t && t.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, !1), e.ds(this.painter.context.gl), e.dt.remove(), e.du.remove(), this._removed = !0, this.fire(new e.g("remove"));
            }
          }, {
            key: "triggerRepaint",
            value: function triggerRepaint() {
              this._triggerFrame(!0);
            }
          }, {
            key: "_triggerFrame",
            value: function _triggerFrame(t) {
              var _this193 = this;
              this._renderNextFrame = this._renderNextFrame || t, this.style && !this._frame && (this._frame = e.e.frame(function (e) {
                var t = !!_this193._renderNextFrame;
                _this193._frame = null, _this193._renderNextFrame = null, t && _this193._render(e);
              }));
            }
          }, {
            key: "_preloadTiles",
            value: function _preloadTiles(t) {
              var _this194 = this;
              var i = this.style ? this.style.getSourceCaches() : [];
              return e.dv(i, function (e, i) {
                return e._preloadTiles(t, i);
              }, function () {
                _this194.triggerRepaint();
              }), this;
            }
          }, {
            key: "_onWindowOnline",
            value: function _onWindowOnline() {
              this._update();
            }
          }, {
            key: "_onWindowResize",
            value: function _onWindowResize(e) {
              this._trackResize && this.resize({
                originalEvent: e
              })._update();
            }
          }, {
            key: "_onVisibilityChange",
            value: function _onVisibilityChange() {
              "hidden" === document.visibilityState && this._visibilityHidden++;
            }
          }, {
            key: "showTileBoundaries",
            get: function get() {
              return !!this._showTileBoundaries;
            },
            set: function set(e) {
              this._showTileBoundaries !== e && (this._showTileBoundaries = e, this._tp.refreshUI(), this._update());
            }
          }, {
            key: "showParseStatus",
            get: function get() {
              return !!this._showParseStatus;
            },
            set: function set(e) {
              this._showParseStatus !== e && (this._showParseStatus = e, this._tp.refreshUI(), this._update());
            }
          }, {
            key: "showTerrainWireframe",
            get: function get() {
              return !!this._showTerrainWireframe;
            },
            set: function set(e) {
              this._showTerrainWireframe !== e && (this._showTerrainWireframe = e, this._tp.refreshUI(), this._update());
            }
          }, {
            key: "showLayers2DWireframe",
            get: function get() {
              return !!this._showLayers2DWireframe;
            },
            set: function set(e) {
              this._showLayers2DWireframe !== e && (this._showLayers2DWireframe = e, this._tp.refreshUI(), this._update());
            }
          }, {
            key: "showLayers3DWireframe",
            get: function get() {
              return !!this._showLayers3DWireframe;
            },
            set: function set(e) {
              this._showLayers3DWireframe !== e && (this._showLayers3DWireframe = e, this._tp.refreshUI(), this._update());
            }
          }, {
            key: "speedIndexTiming",
            get: function get() {
              return !!this._speedIndexTiming;
            },
            set: function set(e) {
              this._speedIndexTiming !== e && (this._speedIndexTiming = e, this._update());
            }
          }, {
            key: "showPadding",
            get: function get() {
              return !!this._showPadding;
            },
            set: function set(e) {
              this._showPadding !== e && (this._showPadding = e, this._tp.refreshUI(), this._update());
            }
          }, {
            key: "showCollisionBoxes",
            get: function get() {
              return !!this._showCollisionBoxes;
            },
            set: function set(e) {
              this._showCollisionBoxes !== e && (this._showCollisionBoxes = e, this._tp.refreshUI(), e ? this.style._generateCollisionBoxes() : this._update());
            }
          }, {
            key: "showOverdrawInspector",
            get: function get() {
              return !!this._showOverdrawInspector;
            },
            set: function set(e) {
              this._showOverdrawInspector !== e && (this._showOverdrawInspector = e, this._tp.refreshUI(), this._update());
            }
          }, {
            key: "repaint",
            get: function get() {
              return !!this._repaint;
            },
            set: function set(e) {
              this._repaint !== e && (this._repaint = e, this._tp.refreshUI(), this.triggerRepaint());
            }
          }, {
            key: "vertices",
            get: function get() {
              return !!this._vertices;
            },
            set: function set(e) {
              this._vertices = e, this._update();
            }
          }, {
            key: "showTileAABBs",
            get: function get() {
              return !!this._showTileAABBs;
            },
            set: function set(e) {
              this._showTileAABBs !== e && (this._showTileAABBs = e, this._tp.refreshUI(), e && this._update());
            }
          }, {
            key: "_setCacheLimits",
            value: function _setCacheLimits(t, i) {
              e.dx(t, i);
            }
          }, {
            key: "version",
            get: function get() {
              return e.dw;
            }
          }]);
          return Map;
        }(Ln),
        NavigationControl: /*#__PURE__*/function () {
          function NavigationControl() {
            var _this195 = this;
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, NavigationControl);
            this.options = e.Q({}, jn, t), this._container = r("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", function (e) {
              return e.preventDefault();
            }), this.options.showZoom && (e.br(["_setButtonTitle", "_updateZoomButtons"], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", function (e) {
              _this195._map && _this195._map.zoomIn({}, {
                originalEvent: e
              });
            }), r("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", function (e) {
              _this195._map && _this195._map.zoomOut({}, {
                originalEvent: e
              });
            }), r("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e.br(["_rotateCompassArrow"], this), this._compass = this._createButton("mapboxgl-ctrl-compass", function (e) {
              var t = _this195._map;
              t && (_this195.options.visualizePitch ? t.resetNorthPitch({}, {
                originalEvent: e
              }) : t.resetNorth({}, {
                originalEvent: e
              }));
            }), this._compassIcon = r("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
          }
          _createClass(NavigationControl, [{
            key: "_updateZoomButtons",
            value: function _updateZoomButtons() {
              var e = this._map;
              if (!e) return;
              var t = e.getZoom(),
                i = t === e.getMaxZoom(),
                o = t === e.getMinZoom();
              this._zoomInButton.disabled = i, this._zoomOutButton.disabled = o, this._zoomInButton.setAttribute("aria-disabled", i.toString()), this._zoomOutButton.setAttribute("aria-disabled", o.toString());
            }
          }, {
            key: "_rotateCompassArrow",
            value: function _rotateCompassArrow() {
              var _this196 = this;
              var e = this._map;
              if (!e) return;
              var t = this.options.visualizePitch ? "scale(".concat(1 / Math.pow(Math.cos(e.transform.pitch * (Math.PI / 180)), .5), ") rotateX(").concat(e.transform.pitch, "deg) rotateZ(").concat(e.transform.angle * (180 / Math.PI), "deg)") : "rotate(".concat(e.transform.angle * (180 / Math.PI), "deg)");
              e._requestDomTask(function () {
                _this196._compassIcon && (_this196._compassIcon.style.transform = t);
              });
            }
          }, {
            key: "onAdd",
            value: function onAdd(e) {
              return this._map = e, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e.on("pitch", this._rotateCompassArrow), e.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Vn(e, this._compass, this.options.visualizePitch)), this._container;
            }
          }, {
            key: "onRemove",
            value: function onRemove() {
              var e = this._map;
              e && (this._container.remove(), this.options.showZoom && e.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e.off("pitch", this._rotateCompassArrow), e.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
            }
          }, {
            key: "_createButton",
            value: function _createButton(e, t) {
              var i = r("button", e, this._container);
              return i.type = "button", i.addEventListener("click", t), i;
            }
          }, {
            key: "_setButtonTitle",
            value: function _setButtonTitle(e, t) {
              if (!this._map) return;
              var i = this._map._getUIString("NavigationControl.".concat(t));
              e.setAttribute("aria-label", i), e.firstElementChild && e.firstElementChild.setAttribute("title", i);
            }
          }]);
          return NavigationControl;
        }(),
        GeolocateControl: /*#__PURE__*/function (_e$E17) {
          _inherits(GeolocateControl, _e$E17);
          var _super169 = _createSuper(GeolocateControl);
          function GeolocateControl() {
            var _this197;
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, GeolocateControl);
            _this197 = _super169.call(this);
            var i = navigator.geolocation;
            _this197.options = e.Q({
              geolocation: i
            }, $n, t), e.br(["_onSuccess", "_onError", "_onZoom", "_finish", "_setupUI", "_updateCamera", "_updateMarker", "_updateMarkerRotation", "_onDeviceOrientation"], _assertThisInitialized(_this197)), _this197._updateMarkerRotationThrottled = La(_this197._updateMarkerRotation, 20), _this197._numberOfWatches = 0;
            return _this197;
          }
          _createClass(GeolocateControl, [{
            key: "onAdd",
            value: function onAdd(e) {
              return this._map = e, this._container = r("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
            }
          }, {
            key: "onRemove",
            value: function onRemove() {
              void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
            }
          }, {
            key: "_checkGeolocationSupport",
            value: function _checkGeolocationSupport(e) {
              var _this198 = this;
              var t = function t() {
                var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !!_this198.options.geolocation;
                _this198._supportsGeolocation = t, e(t);
              };
              void 0 !== this._supportsGeolocation ? e(this._supportsGeolocation) : void 0 !== navigator.permissions ? navigator.permissions.query({
                name: "geolocation"
              }).then(function (e) {
                return t("denied" !== e.state);
              }).catch(function () {
                return t();
              }) : t();
            }
          }, {
            key: "_isOutOfMapMaxBounds",
            value: function _isOutOfMapMaxBounds(e) {
              var t = this._map.getMaxBounds(),
                i = e.coords;
              return !!t && (i.longitude < t.getWest() || i.longitude > t.getEast() || i.latitude < t.getSouth() || i.latitude > t.getNorth());
            }
          }, {
            key: "_setErrorState",
            value: function _setErrorState() {
              switch (this._watchState) {
                case "WAITING_ACTIVE":
                  this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                  break;
                case "ACTIVE_LOCK":
                  this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                  break;
                case "BACKGROUND":
                  this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
              }
            }
          }, {
            key: "_onSuccess",
            value: function _onSuccess(t) {
              if (this._map) {
                if (this._isOutOfMapMaxBounds(t)) return this._setErrorState(), this.fire(new e.g("outofmaxbounds", t)), this._updateMarker(), void this._finish();
                if (this.options.trackUserLocation) switch (this._lastKnownPosition = t, this._watchState) {
                  case "WAITING_ACTIVE":
                  case "ACTIVE_LOCK":
                  case "ACTIVE_ERROR":
                    this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                    break;
                  case "BACKGROUND":
                  case "BACKGROUND_ERROR":
                    this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                }
                this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(t), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.g("geolocate", t)), this._finish();
              }
            }
          }, {
            key: "_updateCamera",
            value: function _updateCamera(t) {
              var i = new e.aJ(t.coords.longitude, t.coords.latitude),
                o = t.coords.accuracy,
                r = this._map.getBearing(),
                a = e.Q({
                  bearing: r
                }, this.options.fitBoundsOptions);
              this._map.fitBounds(i.toBounds(o), a, {
                geolocateSource: !0
              });
            }
          }, {
            key: "_updateMarker",
            value: function _updateMarker(t) {
              if (t) {
                var _i515 = new e.aJ(t.coords.longitude, t.coords.latitude);
                this._accuracyCircleMarker.setLngLat(_i515).addTo(this._map), this._userLocationDotMarker.setLngLat(_i515).addTo(this._map), this._accuracy = t.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
              } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
            }
          }, {
            key: "_updateCircleRadius",
            value: function _updateCircleRadius() {
              var t = this._map.transform,
                i = e.ay(1, t._center.lat) * t.worldSize,
                o = Math.ceil(2 * this._accuracy * i);
              this._circleElement.style.width = "".concat(o, "px"), this._circleElement.style.height = "".concat(o, "px");
            }
          }, {
            key: "_onZoom",
            value: function _onZoom() {
              this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
            }
          }, {
            key: "_updateMarkerRotation",
            value: function _updateMarkerRotation() {
              this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
            }
          }, {
            key: "_onError",
            value: function _onError(t) {
              if (this._map) {
                if (this.options.trackUserLocation) if (1 === t.code) {
                  this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                  var _e739 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                  this._geolocateButton.setAttribute("aria-label", _e739), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", _e739), void 0 !== this._geolocationWatchID && this._clearWatch();
                } else {
                  if (3 === t.code && this._noTimeout) return;
                  this._setErrorState();
                }
                "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.g("error", t)), this._finish();
              }
            }
          }, {
            key: "_finish",
            value: function _finish() {
              this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
            }
          }, {
            key: "_setupUI",
            value: function _setupUI(t) {
              var _this199 = this;
              if (void 0 !== this._map) {
                if (this._container.addEventListener("contextmenu", function (e) {
                  return e.preventDefault();
                }), this._geolocateButton = r("button", "mapboxgl-ctrl-geolocate", this._container), r("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === t) {
                  e.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                  var _t696 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                  this._geolocateButton.disabled = !0, this._geolocateButton.setAttribute("aria-label", _t696), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", _t696);
                } else {
                  var _e740 = this._map._getUIString("GeolocateControl.FindMyLocation");
                  this._geolocateButton.setAttribute("aria-label", _e740), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", _e740);
                }
                this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = r("div", "mapboxgl-user-location"), this._dotElement.appendChild(r("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(r("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new zn({
                  element: this._dotElement,
                  rotationAlignment: "map",
                  pitchAlignment: "map"
                }), this._circleElement = r("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new zn({
                  element: this._circleElement,
                  pitchAlignment: "map"
                }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", function (t) {
                  t.geolocateSource || "ACTIVE_LOCK" !== _this199._watchState || t.originalEvent && "resize" === t.originalEvent.type || (_this199._watchState = "BACKGROUND", _this199._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), _this199._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), _this199.fire(new e.g("trackuserlocationend")));
                });
              }
            }
          }, {
            key: "_onDeviceOrientation",
            value: function _onDeviceOrientation(e) {
              this._userLocationDotMarker && (e.webkitCompassHeading ? this._heading = e.webkitCompassHeading : !0 === e.absolute && (this._heading = -1 * e.alpha), this._updateMarkerRotationThrottled());
            }
          }, {
            key: "trigger",
            value: function trigger() {
              if (!this._setup) return e.w("Geolocate control triggered before added to a map"), !1;
              if (this.options.trackUserLocation) {
                switch (this._watchState) {
                  case "OFF":
                    this._watchState = "WAITING_ACTIVE", this.fire(new e.g("trackuserlocationstart"));
                    break;
                  case "WAITING_ACTIVE":
                  case "ACTIVE_LOCK":
                  case "ACTIVE_ERROR":
                  case "BACKGROUND_ERROR":
                    this._numberOfWatches--, this._noTimeout = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new e.g("trackuserlocationend"));
                    break;
                  case "BACKGROUND":
                    this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e.g("trackuserlocationstart"));
                }
                switch (this._watchState) {
                  case "WAITING_ACTIVE":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                    break;
                  case "ACTIVE_LOCK":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                    break;
                  case "ACTIVE_ERROR":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                    break;
                  case "BACKGROUND":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                    break;
                  case "BACKGROUND_ERROR":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                }
                if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();else if (void 0 === this._geolocationWatchID) {
                  var _e741;
                  this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (_e741 = {
                    maximumAge: 6e5,
                    timeout: 0
                  }, this._noTimeout = !0) : (_e741 = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, _e741), this.options.showUserHeading && this._addDeviceOrientationListener();
                }
              } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = window.setTimeout(this._finish, 1e4);
              return !0;
            }
          }, {
            key: "_addDeviceOrientationListener",
            value: function _addDeviceOrientationListener() {
              var _this200 = this;
              var e = function e() {
                "ondeviceorientationabsolute" in window ? window.addEventListener("deviceorientationabsolute", _this200._onDeviceOrientation) : window.addEventListener("deviceorientation", _this200._onDeviceOrientation);
              };
              "undefined" != typeof DeviceMotionEvent && "function" == typeof DeviceMotionEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then(function (t) {
                "granted" === t && e();
              }).catch(console.error) : e();
            }
          }, {
            key: "_clearWatch",
            value: function _clearWatch() {
              this.options.geolocation.clearWatch(this._geolocationWatchID), window.removeEventListener("deviceorientation", this._onDeviceOrientation), window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
            }
          }]);
          return GeolocateControl;
        }(e.E),
        AttributionControl: Pn,
        ScaleControl: /*#__PURE__*/function () {
          function ScaleControl() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, ScaleControl);
            this.options = e.Q({}, Zn, t), this._isNumberFormatSupported = function () {
              try {
                return new Intl.NumberFormat("en", {
                  style: "unit",
                  unitDisplay: "short",
                  unit: "meter"
                }), !0;
              } catch (e) {
                return !1;
              }
            }(), e.br(["_update", "_setScale", "setUnit"], this);
          }
          _createClass(ScaleControl, [{
            key: "getDefaultPosition",
            value: function getDefaultPosition() {
              return "bottom-left";
            }
          }, {
            key: "_update",
            value: function _update() {
              var e = this.options.maxWidth || 100,
                t = this._map,
                i = t._containerHeight / 2,
                o = t._containerWidth / 2 - e / 2,
                r = t.unproject([o, i]),
                a = t.unproject([o + e, i]),
                n = r.distanceTo(a);
              if ("imperial" === this.options.unit) {
                var _t697 = 3.2808 * n;
                _t697 > 5280 ? this._setScale(e, _t697 / 5280, "mile") : this._setScale(e, _t697, "foot");
              } else "nautical" === this.options.unit ? this._setScale(e, n / 1852, "nautical-mile") : n >= 1e3 ? this._setScale(e, n / 1e3, "kilometer") : this._setScale(e, n, "meter");
            }
          }, {
            key: "_setScale",
            value: function _setScale(e, t, i) {
              var _this201 = this;
              this._map._requestDomTask(function () {
                var o = function (e) {
                    var t = Math.pow(10, "".concat(Math.floor(e)).length - 1);
                    var i = e / t;
                    return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function (e) {
                      var t = Math.pow(10, Math.ceil(-Math.log(e) / Math.LN10));
                      return Math.round(e * t) / t;
                    }(i), t * i;
                  }(t),
                  r = o / t;
                _this201._container.innerHTML = _this201._isNumberFormatSupported && "nautical-mile" !== i ? new Intl.NumberFormat(_this201._language, {
                  style: "unit",
                  unitDisplay: "short",
                  unit: i
                }).format(o) : "".concat(o, "&nbsp;").concat(Wn[i]), _this201._container.style.width = e * r + "px";
              });
            }
          }, {
            key: "onAdd",
            value: function onAdd(e) {
              return this._map = e, this._language = e.getLanguage(), this._container = r("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
            }
          }, {
            key: "onRemove",
            value: function onRemove() {
              this._container.remove(), this._map.off("move", this._update), this._map = void 0;
            }
          }, {
            key: "_setLanguage",
            value: function _setLanguage(e) {
              this._language = e, this._update();
            }
          }, {
            key: "setUnit",
            value: function setUnit(e) {
              this.options.unit = e, this._update();
            }
          }]);
          return ScaleControl;
        }(),
        FullscreenControl: /*#__PURE__*/function () {
          function FullscreenControl() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, FullscreenControl);
            this._fullscreen = !1, t && t.container && (t.container instanceof HTMLElement ? this._container = t.container : e.w("Full screen control 'container' must be a DOM element.")), e.br(["_onClickFullscreen", "_changeIcon"], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in document && (this._fullscreenchange = "webkitfullscreenchange");
          }
          _createClass(FullscreenControl, [{
            key: "onAdd",
            value: function onAdd(t) {
              return this._map = t, this._container || (this._container = this._map.getContainer()), this._controlContainer = r("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e.w("This device does not support fullscreen mode.")), this._controlContainer;
            }
          }, {
            key: "onRemove",
            value: function onRemove() {
              this._controlContainer.remove(), this._map = null, document.removeEventListener(this._fullscreenchange, this._changeIcon);
            }
          }, {
            key: "_checkFullscreenSupport",
            value: function _checkFullscreenSupport() {
              return !(!document.fullscreenEnabled && !document.webkitFullscreenEnabled);
            }
          }, {
            key: "_setupUI",
            value: function _setupUI() {
              var e = this._fullscreenButton = r("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
              r("span", "mapboxgl-ctrl-icon", e).setAttribute("aria-hidden", "true"), e.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), document.addEventListener(this._fullscreenchange, this._changeIcon);
            }
          }, {
            key: "_updateTitle",
            value: function _updateTitle() {
              var e = this._getTitle();
              this._fullscreenButton.setAttribute("aria-label", e), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e);
            }
          }, {
            key: "_getTitle",
            value: function _getTitle() {
              return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
            }
          }, {
            key: "_isFullscreen",
            value: function _isFullscreen() {
              return this._fullscreen;
            }
          }, {
            key: "_changeIcon",
            value: function _changeIcon() {
              (document.fullscreenElement || document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
            }
          }, {
            key: "_onClickFullscreen",
            value: function _onClickFullscreen() {
              this._isFullscreen() ? document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
            }
          }]);
          return FullscreenControl;
        }(),
        Popup: /*#__PURE__*/function (_e$E18) {
          _inherits(Popup, _e$E18);
          var _super170 = _createSuper(Popup);
          function Popup(t) {
            var _this202;
            _classCallCheck(this, Popup);
            _this202 = _super170.call(this), _this202.options = e.Q(Object.create(On), t), e.br(["_update", "_onClose", "remove", "_onMouseEvent"], _assertThisInitialized(_this202)), _this202._classList = new Set(t && t.className ? t.className.trim().split(/\s+/) : []);
            return _this202;
          }
          _createClass(Popup, [{
            key: "addTo",
            value: function addTo(t) {
              return this._map && this.remove(), this._map = t, this.options.closeOnClick && t.on("preclick", this._onClose), this.options.closeOnMove && t.on("move", this._onClose), t.on("remove", this.remove), this._update(), t._addPopup(this), this._focusFirstElement(), this._trackPointer ? (t.on("mousemove", this._onMouseEvent), t.on("mouseup", this._onMouseEvent), t._canvasContainer.classList.add("mapboxgl-track-pointer")) : t.on("move", this._update), this.fire(new e.g("open")), this;
            }
          }, {
            key: "isOpen",
            value: function isOpen() {
              return !!this._map;
            }
          }, {
            key: "remove",
            value: function remove() {
              this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
              var t = this._map;
              return t && (t.off("move", this._update), t.off("move", this._onClose), t.off("preclick", this._onClose), t.off("click", this._onClose), t.off("remove", this.remove), t.off("mousemove", this._onMouseEvent), t.off("mouseup", this._onMouseEvent), t.off("drag", this._onMouseEvent), t._canvasContainer && t._canvasContainer.classList.remove("mapboxgl-track-pointer"), t._removePopup(this), this._map = void 0), this.fire(new e.g("close")), this;
            }
          }, {
            key: "getLngLat",
            value: function getLngLat() {
              return this._lngLat;
            }
          }, {
            key: "setLngLat",
            value: function setLngLat(t) {
              this._lngLat = e.aJ.convert(t), this._pos = null, this._trackPointer = !1, this._update();
              var i = this._map;
              return i && (i.on("move", this._update), i.off("mousemove", this._onMouseEvent), i._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
            }
          }, {
            key: "trackPointer",
            value: function trackPointer() {
              this._trackPointer = !0, this._pos = null, this._update();
              var e = this._map;
              return e && (e.off("move", this._update), e.on("mousemove", this._onMouseEvent), e.on("drag", this._onMouseEvent), e._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
            }
          }, {
            key: "getElement",
            value: function getElement() {
              return this._container;
            }
          }, {
            key: "setText",
            value: function setText(e) {
              return this.setDOMContent(document.createTextNode(e));
            }
          }, {
            key: "setHTML",
            value: function setHTML(e) {
              var t = document.createDocumentFragment(),
                i = document.createElement("body");
              var o;
              for (i.innerHTML = e; o = i.firstChild, o;) t.appendChild(o);
              return this.setDOMContent(t);
            }
          }, {
            key: "getMaxWidth",
            value: function getMaxWidth() {
              return this._container && this._container.style.maxWidth;
            }
          }, {
            key: "setMaxWidth",
            value: function setMaxWidth(e) {
              return this.options.maxWidth = e, this._update(), this;
            }
          }, {
            key: "setDOMContent",
            value: function setDOMContent(e) {
              var t = this._content;
              if (t) for (; t.hasChildNodes();) t.firstChild && t.removeChild(t.firstChild);else t = this._content = r("div", "mapboxgl-popup-content", this._container || void 0);
              if (t.appendChild(e), this.options.closeButton) {
                var _e742 = this._closeButton = r("button", "mapboxgl-popup-close-button", t);
                _e742.type = "button", _e742.setAttribute("aria-label", "Close popup"), _e742.setAttribute("aria-hidden", "true"), _e742.innerHTML = "&#215;", _e742.addEventListener("click", this._onClose);
              }
              return this._update(), this._focusFirstElement(), this;
            }
          }, {
            key: "addClassName",
            value: function addClassName(e) {
              return this._classList.add(e), this._updateClassList(), this;
            }
          }, {
            key: "removeClassName",
            value: function removeClassName(e) {
              return this._classList.delete(e), this._updateClassList(), this;
            }
          }, {
            key: "setOffset",
            value: function setOffset(e) {
              return this.options.offset = e, this._update(), this;
            }
          }, {
            key: "toggleClassName",
            value: function toggleClassName(e) {
              var t;
              return this._classList.delete(e) ? t = !1 : (this._classList.add(e), t = !0), this._updateClassList(), t;
            }
          }, {
            key: "_onMouseEvent",
            value: function _onMouseEvent(e) {
              this._update(e.point);
            }
          }, {
            key: "_getAnchor",
            value: function _getAnchor(e) {
              if (this.options.anchor) return this.options.anchor;
              var t = this._map,
                i = this._container,
                o = this._pos;
              if (!t || !i || !o) return "bottom";
              var r = i.offsetWidth,
                a = i.offsetHeight,
                n = o.x < r / 2,
                s = o.x > t.transform.width - r / 2;
              if (o.y + e < a) return n ? "top-left" : s ? "top-right" : "top";
              if (o.y > t.transform.height - a) {
                if (n) return "bottom-left";
                if (s) return "bottom-right";
              }
              return n ? "left" : s ? "right" : "bottom";
            }
          }, {
            key: "_updateClassList",
            value: function _updateClassList() {
              var e = this._container;
              if (!e) return;
              var t = _toConsumableArray(this._classList);
              t.push("mapboxgl-popup"), this._anchor && t.push("mapboxgl-popup-anchor-".concat(this._anchor)), this._trackPointer && t.push("mapboxgl-popup-track-pointer"), e.className = t.join(" ");
            }
          }, {
            key: "_update",
            value: function _update(t) {
              var _this203 = this;
              var i = this._map,
                o = this._content;
              if (!i || !this._lngLat && !this._trackPointer || !o) return;
              var a = this._container;
              if (a || (a = this._container = r("div", "mapboxgl-popup", i.getContainer()), this._tip = r("div", "mapboxgl-popup-tip", a), a.appendChild(o)), this.options.maxWidth && a.style.maxWidth !== this.options.maxWidth && (a.style.maxWidth = this.options.maxWidth), i.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = An(this._lngLat, this._pos, i.transform)), !this._trackPointer || t) {
                var _o298 = this._pos = this._trackPointer && t instanceof e.P ? t : i.project(this._lngLat),
                  _r477 = Bn(this.options.offset),
                  _a265 = this._anchor = this._getAnchor(_r477.y),
                  _n325 = Bn(this.options.offset, _a265),
                  _s265 = _o298.add(_n325).round();
                i._requestDomTask(function () {
                  _this203._container && _a265 && (_this203._container.style.transform = "".concat(Mn[_a265], " translate(").concat(_s265.x, "px,").concat(_s265.y, "px)"));
                });
              }
              if (!this._marker && i._showingGlobe()) {
                var _t698 = e.dc(i.transform, this._lngLat) ? 0 : 1;
                this._setOpacity(_t698);
              }
              this._updateClassList();
            }
          }, {
            key: "_focusFirstElement",
            value: function _focusFirstElement() {
              if (!this.options.focusAfterOpen || !this._container) return;
              var e = this._container.querySelector(Fn);
              e && e.focus();
            }
          }, {
            key: "_onClose",
            value: function _onClose() {
              this.remove();
            }
          }, {
            key: "_setOpacity",
            value: function _setOpacity(e) {
              this._container && (this._container.style.opacity = "".concat(e)), this._content && (this._content.style.pointerEvents = e ? "auto" : "none");
            }
          }]);
          return Popup;
        }(e.E),
        Marker: zn,
        Style: Ia,
        LngLat: e.aJ,
        LngLatBounds: e.aj,
        Point: e.P,
        MercatorCoordinate: e._,
        FreeCameraOptions: Vt,
        Evented: e.E,
        config: e.db,
        prewarm: e.dA,
        clearPrewarmedResources: e.dB,
        get accessToken() {
          return e.db.ACCESS_TOKEN;
        },
        set accessToken(t) {
          e.db.ACCESS_TOKEN = t;
        },
        get baseApiUrl() {
          return e.db.API_URL;
        },
        set baseApiUrl(t) {
          e.db.API_URL = t;
        },
        get workerCount() {
          return e.dC.workerCount;
        },
        set workerCount(t) {
          e.dC.workerCount = t;
        },
        get maxParallelImageRequests() {
          return e.db.MAX_PARALLEL_IMAGE_REQUESTS;
        },
        set maxParallelImageRequests(t) {
          e.db.MAX_PARALLEL_IMAGE_REQUESTS = t;
        },
        clearStorage: function clearStorage(t) {
          e.dD(t);
        },
        get workerUrl() {
          return e.dE.workerUrl;
        },
        set workerUrl(t) {
          e.dE.workerUrl = t;
        },
        get workerClass() {
          return e.dE.workerClass;
        },
        set workerClass(t) {
          e.dE.workerClass = t;
        },
        get workerParams() {
          return e.dE.workerParams;
        },
        set workerParams(t) {
          e.dE.workerParams = t;
        },
        get dracoUrl() {
          return e.dF();
        },
        set dracoUrl(t) {
          e.dG(t);
        },
        get meshoptUrl() {
          return e.dH();
        },
        set meshoptUrl(t) {
          e.dI(t);
        },
        setNow: e.e.setNow,
        restoreNow: e.e.restoreNow
      };
    return Hn;
  });

  //
  // Our custom intro provides a specialized "define()" function, called by the
  // AMD modules below, that sets up the worker blob URL and then executes the
  // main module, storing its exported value as 'mapboxgl'

  var mapboxgl$1 = mapboxgl;
  return mapboxgl$1;
});